
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3efa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3efa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aS1Zy", function(module, exports) {
"use strict";
function $7ea07e0ec393a151$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7ea07e0ec393a151$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7ea07e0ec393a151$var$checkDCE();

module.exports = (parcelRequire("cIf3S"));

});
parcelRegister("cIf3S", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $94154706315aabfd$export$ae55be85d98224ed, (v) => $94154706315aabfd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $94154706315aabfd$export$d39a5bbd09211389, (v) => $94154706315aabfd$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $94154706315aabfd$export$882461b6382ed46c, (v) => $94154706315aabfd$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $94154706315aabfd$export$466bfc07425424d5, (v) => $94154706315aabfd$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $94154706315aabfd$export$cd75ccfd720a3cd4, (v) => $94154706315aabfd$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $94154706315aabfd$export$fa8d919ba61d84db, (v) => $94154706315aabfd$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $94154706315aabfd$export$757ceba2d55c277e, (v) => $94154706315aabfd$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $94154706315aabfd$export$b3890eb0ae9dca99, (v) => $94154706315aabfd$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $94154706315aabfd$export$502457920280e6be, (v) => $94154706315aabfd$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $94154706315aabfd$export$c78a37762a8d58e1, (v) => $94154706315aabfd$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $94154706315aabfd$export$dc54d992c10e8a18, (v) => $94154706315aabfd$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $94154706315aabfd$export$83d89fbfd8236492, (v) => $94154706315aabfd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $94154706315aabfd$export$ae55be85d98224ed;
var $94154706315aabfd$export$d39a5bbd09211389;
var $94154706315aabfd$export$882461b6382ed46c;
var $94154706315aabfd$export$466bfc07425424d5;
var $94154706315aabfd$export$cd75ccfd720a3cd4;
var $94154706315aabfd$export$fa8d919ba61d84db;
var $94154706315aabfd$export$757ceba2d55c277e;
var $94154706315aabfd$export$b3890eb0ae9dca99;
var $94154706315aabfd$export$502457920280e6be;
var $94154706315aabfd$export$c78a37762a8d58e1;
var $94154706315aabfd$export$dc54d992c10e8a18;
var $94154706315aabfd$export$83d89fbfd8236492;
"use strict";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $94154706315aabfd$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $94154706315aabfd$var$da = new Set, $94154706315aabfd$var$ea = {};
function $94154706315aabfd$var$fa(a, b) {
    $94154706315aabfd$var$ha(a, b);
    $94154706315aabfd$var$ha(a + "Capture", b);
}
function $94154706315aabfd$var$ha(a, b) {
    $94154706315aabfd$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$94154706315aabfd$var$da.add(b[a]);
}
var $94154706315aabfd$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $94154706315aabfd$var$ja = Object.prototype.hasOwnProperty, $94154706315aabfd$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $94154706315aabfd$var$la = {}, $94154706315aabfd$var$ma = {};
function $94154706315aabfd$var$na(a) {
    if ($94154706315aabfd$var$ja.call($94154706315aabfd$var$ma, a)) return !0;
    if ($94154706315aabfd$var$ja.call($94154706315aabfd$var$la, a)) return !1;
    if ($94154706315aabfd$var$ka.test(a)) return $94154706315aabfd$var$ma[a] = !0;
    $94154706315aabfd$var$la[a] = !0;
    return !1;
}
function $94154706315aabfd$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $94154706315aabfd$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $94154706315aabfd$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $94154706315aabfd$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $94154706315aabfd$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $94154706315aabfd$var$t[b] = new $94154706315aabfd$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $94154706315aabfd$var$ra = /[\-:]([a-z])/g;
function $94154706315aabfd$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($94154706315aabfd$var$ra, $94154706315aabfd$var$ta);
    $94154706315aabfd$var$t[b] = new $94154706315aabfd$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($94154706315aabfd$var$ra, $94154706315aabfd$var$ta);
    $94154706315aabfd$var$t[b] = new $94154706315aabfd$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($94154706315aabfd$var$ra, $94154706315aabfd$var$ta);
    $94154706315aabfd$var$t[b] = new $94154706315aabfd$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$94154706315aabfd$var$t.xlinkHref = new $94154706315aabfd$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $94154706315aabfd$var$t[a] = new $94154706315aabfd$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $94154706315aabfd$var$ua(a, b, c, d) {
    var e = $94154706315aabfd$var$t.hasOwnProperty(b) ? $94154706315aabfd$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $94154706315aabfd$var$pa(b, c, e, d) && (c = null), d || null === e ? $94154706315aabfd$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $94154706315aabfd$var$va = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $94154706315aabfd$var$wa = Symbol.for("react.element"), $94154706315aabfd$var$xa = Symbol.for("react.portal"), $94154706315aabfd$var$ya = Symbol.for("react.fragment"), $94154706315aabfd$var$za = Symbol.for("react.strict_mode"), $94154706315aabfd$var$Aa = Symbol.for("react.profiler"), $94154706315aabfd$var$Ba = Symbol.for("react.provider"), $94154706315aabfd$var$Ca = Symbol.for("react.context"), $94154706315aabfd$var$Da = Symbol.for("react.forward_ref"), $94154706315aabfd$var$Ea = Symbol.for("react.suspense"), $94154706315aabfd$var$Fa = Symbol.for("react.suspense_list"), $94154706315aabfd$var$Ga = Symbol.for("react.memo"), $94154706315aabfd$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $94154706315aabfd$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $94154706315aabfd$var$Ja = Symbol.iterator;
function $94154706315aabfd$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $94154706315aabfd$var$Ja && a[$94154706315aabfd$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $94154706315aabfd$var$u = Object.assign, $94154706315aabfd$var$La;
function $94154706315aabfd$var$Ma(a) {
    if (void 0 === $94154706315aabfd$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $94154706315aabfd$var$La = b && b[1] || "";
    }
    return "\n" + $94154706315aabfd$var$La + a;
}
var $94154706315aabfd$var$Na = !1;
function $94154706315aabfd$var$Oa(a, b) {
    if (!a || $94154706315aabfd$var$Na) return "";
    $94154706315aabfd$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $94154706315aabfd$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $94154706315aabfd$var$Ma(a) : "";
}
function $94154706315aabfd$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $94154706315aabfd$var$Ma(a.type);
        case 16:
            return $94154706315aabfd$var$Ma("Lazy");
        case 13:
            return $94154706315aabfd$var$Ma("Suspense");
        case 19:
            return $94154706315aabfd$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $94154706315aabfd$var$Oa(a.type, !1), a;
        case 11:
            return a = $94154706315aabfd$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $94154706315aabfd$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $94154706315aabfd$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $94154706315aabfd$var$ya:
            return "Fragment";
        case $94154706315aabfd$var$xa:
            return "Portal";
        case $94154706315aabfd$var$Aa:
            return "Profiler";
        case $94154706315aabfd$var$za:
            return "StrictMode";
        case $94154706315aabfd$var$Ea:
            return "Suspense";
        case $94154706315aabfd$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $94154706315aabfd$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $94154706315aabfd$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $94154706315aabfd$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $94154706315aabfd$var$Ga:
            return b = a.displayName || null, null !== b ? b : $94154706315aabfd$var$Qa(a.type) || "Memo";
        case $94154706315aabfd$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $94154706315aabfd$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $94154706315aabfd$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $94154706315aabfd$var$Qa(b);
        case 8:
            return b === $94154706315aabfd$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $94154706315aabfd$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $94154706315aabfd$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $94154706315aabfd$var$Ua(a) {
    var b = $94154706315aabfd$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $94154706315aabfd$var$Va(a) {
    a._valueTracker || (a._valueTracker = $94154706315aabfd$var$Ua(a));
}
function $94154706315aabfd$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $94154706315aabfd$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $94154706315aabfd$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $94154706315aabfd$var$Ya(a, b) {
    var c = b.checked;
    return $94154706315aabfd$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $94154706315aabfd$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $94154706315aabfd$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $94154706315aabfd$var$$a(a, b) {
    b = b.checked;
    null != b && $94154706315aabfd$var$ua(a, "checked", b, !1);
}
function $94154706315aabfd$var$ab(a, b) {
    $94154706315aabfd$var$$a(a, b);
    var c = $94154706315aabfd$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $94154706315aabfd$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $94154706315aabfd$var$bb(a, b.type, $94154706315aabfd$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $94154706315aabfd$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $94154706315aabfd$var$bb(a, b, c) {
    if ("number" !== b || $94154706315aabfd$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $94154706315aabfd$var$db = Array.isArray;
function $94154706315aabfd$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $94154706315aabfd$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $94154706315aabfd$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($94154706315aabfd$var$p(91));
    return $94154706315aabfd$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $94154706315aabfd$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($94154706315aabfd$var$p(92));
            if ($94154706315aabfd$var$db(c)) {
                if (1 < c.length) throw Error($94154706315aabfd$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $94154706315aabfd$var$Sa(c)
    };
}
function $94154706315aabfd$var$hb(a, b) {
    var c = $94154706315aabfd$var$Sa(b.value), d = $94154706315aabfd$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $94154706315aabfd$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $94154706315aabfd$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $94154706315aabfd$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $94154706315aabfd$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $94154706315aabfd$var$mb, $94154706315aabfd$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $94154706315aabfd$var$mb = $94154706315aabfd$var$mb || document.createElement("div");
        $94154706315aabfd$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $94154706315aabfd$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $94154706315aabfd$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $94154706315aabfd$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $94154706315aabfd$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($94154706315aabfd$var$pb).forEach(function(a) {
    $94154706315aabfd$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $94154706315aabfd$var$pb[b] = $94154706315aabfd$var$pb[a];
    });
});
function $94154706315aabfd$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $94154706315aabfd$var$pb.hasOwnProperty(a) && $94154706315aabfd$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $94154706315aabfd$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $94154706315aabfd$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $94154706315aabfd$var$tb = $94154706315aabfd$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $94154706315aabfd$var$ub(a, b) {
    if (b) {
        if ($94154706315aabfd$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($94154706315aabfd$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($94154706315aabfd$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($94154706315aabfd$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($94154706315aabfd$var$p(62));
    }
}
function $94154706315aabfd$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $94154706315aabfd$var$wb = null;
function $94154706315aabfd$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $94154706315aabfd$var$yb = null, $94154706315aabfd$var$zb = null, $94154706315aabfd$var$Ab = null;
function $94154706315aabfd$var$Bb(a) {
    if (a = $94154706315aabfd$var$Cb(a)) {
        if ("function" !== typeof $94154706315aabfd$var$yb) throw Error($94154706315aabfd$var$p(280));
        var b = a.stateNode;
        b && (b = $94154706315aabfd$var$Db(b), $94154706315aabfd$var$yb(a.stateNode, a.type, b));
    }
}
function $94154706315aabfd$var$Eb(a) {
    $94154706315aabfd$var$zb ? $94154706315aabfd$var$Ab ? $94154706315aabfd$var$Ab.push(a) : $94154706315aabfd$var$Ab = [
        a
    ] : $94154706315aabfd$var$zb = a;
}
function $94154706315aabfd$var$Fb() {
    if ($94154706315aabfd$var$zb) {
        var a = $94154706315aabfd$var$zb, b = $94154706315aabfd$var$Ab;
        $94154706315aabfd$var$Ab = $94154706315aabfd$var$zb = null;
        $94154706315aabfd$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$94154706315aabfd$var$Bb(b[a]);
    }
}
function $94154706315aabfd$var$Gb(a, b) {
    return a(b);
}
function $94154706315aabfd$var$Hb() {}
var $94154706315aabfd$var$Ib = !1;
function $94154706315aabfd$var$Jb(a, b, c) {
    if ($94154706315aabfd$var$Ib) return a(b, c);
    $94154706315aabfd$var$Ib = !0;
    try {
        return $94154706315aabfd$var$Gb(a, b, c);
    } finally{
        if ($94154706315aabfd$var$Ib = !1, null !== $94154706315aabfd$var$zb || null !== $94154706315aabfd$var$Ab) $94154706315aabfd$var$Hb(), $94154706315aabfd$var$Fb();
    }
}
function $94154706315aabfd$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $94154706315aabfd$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($94154706315aabfd$var$p(231, b, typeof c));
    return c;
}
var $94154706315aabfd$var$Lb = !1;
if ($94154706315aabfd$var$ia) try {
    var $94154706315aabfd$var$Mb = {};
    Object.defineProperty($94154706315aabfd$var$Mb, "passive", {
        get: function() {
            $94154706315aabfd$var$Lb = !0;
        }
    });
    window.addEventListener("test", $94154706315aabfd$var$Mb, $94154706315aabfd$var$Mb);
    window.removeEventListener("test", $94154706315aabfd$var$Mb, $94154706315aabfd$var$Mb);
} catch (a) {
    $94154706315aabfd$var$Lb = !1;
}
function $94154706315aabfd$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $94154706315aabfd$var$Ob = !1, $94154706315aabfd$var$Pb = null, $94154706315aabfd$var$Qb = !1, $94154706315aabfd$var$Rb = null, $94154706315aabfd$var$Sb = {
    onError: function(a) {
        $94154706315aabfd$var$Ob = !0;
        $94154706315aabfd$var$Pb = a;
    }
};
function $94154706315aabfd$var$Tb(a, b, c, d, e, f, g, h, k) {
    $94154706315aabfd$var$Ob = !1;
    $94154706315aabfd$var$Pb = null;
    $94154706315aabfd$var$Nb.apply($94154706315aabfd$var$Sb, arguments);
}
function $94154706315aabfd$var$Ub(a, b, c, d, e, f, g, h, k) {
    $94154706315aabfd$var$Tb.apply(this, arguments);
    if ($94154706315aabfd$var$Ob) {
        if ($94154706315aabfd$var$Ob) {
            var l = $94154706315aabfd$var$Pb;
            $94154706315aabfd$var$Ob = !1;
            $94154706315aabfd$var$Pb = null;
        } else throw Error($94154706315aabfd$var$p(198));
        $94154706315aabfd$var$Qb || ($94154706315aabfd$var$Qb = !0, $94154706315aabfd$var$Rb = l);
    }
}
function $94154706315aabfd$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $94154706315aabfd$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $94154706315aabfd$var$Xb(a) {
    if ($94154706315aabfd$var$Vb(a) !== a) throw Error($94154706315aabfd$var$p(188));
}
function $94154706315aabfd$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $94154706315aabfd$var$Vb(a);
        if (null === b) throw Error($94154706315aabfd$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $94154706315aabfd$var$Xb(e), a;
                if (f === d) return $94154706315aabfd$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($94154706315aabfd$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($94154706315aabfd$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($94154706315aabfd$var$p(190));
    }
    if (3 !== c.tag) throw Error($94154706315aabfd$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $94154706315aabfd$var$Zb(a) {
    a = $94154706315aabfd$var$Yb(a);
    return null !== a ? $94154706315aabfd$var$$b(a) : null;
}
function $94154706315aabfd$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $94154706315aabfd$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $94154706315aabfd$var$ac = $fO90s.unstable_scheduleCallback, $94154706315aabfd$var$bc = $fO90s.unstable_cancelCallback, $94154706315aabfd$var$cc = $fO90s.unstable_shouldYield, $94154706315aabfd$var$dc = $fO90s.unstable_requestPaint, $94154706315aabfd$var$A = $fO90s.unstable_now, $94154706315aabfd$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $94154706315aabfd$var$fc = $fO90s.unstable_ImmediatePriority, $94154706315aabfd$var$gc = $fO90s.unstable_UserBlockingPriority, $94154706315aabfd$var$hc = $fO90s.unstable_NormalPriority, $94154706315aabfd$var$ic = $fO90s.unstable_LowPriority, $94154706315aabfd$var$jc = $fO90s.unstable_IdlePriority, $94154706315aabfd$var$kc = null, $94154706315aabfd$var$lc = null, $94154706315aabfd$var$B = null, $94154706315aabfd$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $94154706315aabfd$var$nc(a, b) {
    if ($94154706315aabfd$var$lc && "function" === typeof $94154706315aabfd$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $94154706315aabfd$var$fc;
                break;
            case 4:
                d = $94154706315aabfd$var$gc;
                break;
            case 16:
                d = $94154706315aabfd$var$hc;
                break;
            case 536870912:
                d = $94154706315aabfd$var$jc;
                break;
            default:
                d = $94154706315aabfd$var$hc;
        }
        $94154706315aabfd$var$lc.onCommitFiberRoot($94154706315aabfd$var$kc, a, d, c);
    } catch (e) {}
}
function $94154706315aabfd$var$oc(a) {
    $94154706315aabfd$var$B = a;
}
function $94154706315aabfd$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $94154706315aabfd$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $94154706315aabfd$var$rc() {
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markCommitStopped && $94154706315aabfd$var$B.markCommitStopped();
}
function $94154706315aabfd$var$sc(a) {
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentRenderStarted && $94154706315aabfd$var$B.markComponentRenderStarted(a);
}
function $94154706315aabfd$var$tc() {
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentRenderStopped && $94154706315aabfd$var$B.markComponentRenderStopped();
}
function $94154706315aabfd$var$uc(a) {
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentLayoutEffectUnmountStarted && $94154706315aabfd$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $94154706315aabfd$var$vc() {
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentLayoutEffectUnmountStopped && $94154706315aabfd$var$B.markComponentLayoutEffectUnmountStopped();
}
function $94154706315aabfd$var$wc(a) {
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markRenderStarted && $94154706315aabfd$var$B.markRenderStarted(a);
}
function $94154706315aabfd$var$xc() {
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markRenderStopped && $94154706315aabfd$var$B.markRenderStopped();
}
function $94154706315aabfd$var$yc(a, b) {
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markStateUpdateScheduled && $94154706315aabfd$var$B.markStateUpdateScheduled(a, b);
}
var $94154706315aabfd$var$Ac = Math.clz32 ? Math.clz32 : $94154706315aabfd$var$zc, $94154706315aabfd$var$Bc = Math.log, $94154706315aabfd$var$Cc = Math.LN2;
function $94154706315aabfd$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($94154706315aabfd$var$Bc(a) / $94154706315aabfd$var$Cc | 0) | 0;
}
function $94154706315aabfd$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $94154706315aabfd$var$Dc = 64, $94154706315aabfd$var$Ec = 4194304;
function $94154706315aabfd$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $94154706315aabfd$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $94154706315aabfd$var$Fc(h) : (f &= g, 0 !== f && (d = $94154706315aabfd$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $94154706315aabfd$var$Fc(g) : 0 !== f && (d = $94154706315aabfd$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $94154706315aabfd$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $94154706315aabfd$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $94154706315aabfd$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $94154706315aabfd$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $94154706315aabfd$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $94154706315aabfd$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $94154706315aabfd$var$Kc() {
    var a = $94154706315aabfd$var$Dc;
    $94154706315aabfd$var$Dc <<= 1;
    0 === ($94154706315aabfd$var$Dc & 4194240) && ($94154706315aabfd$var$Dc = 64);
    return a;
}
function $94154706315aabfd$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $94154706315aabfd$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $94154706315aabfd$var$Ac(b);
    a[b] = c;
}
function $94154706315aabfd$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $94154706315aabfd$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $94154706315aabfd$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $94154706315aabfd$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $94154706315aabfd$var$Pc(a, b, c) {
    if ($94154706315aabfd$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $94154706315aabfd$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $94154706315aabfd$var$Qc(a, b) {
    if ($94154706315aabfd$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $94154706315aabfd$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $94154706315aabfd$var$E = 0;
function $94154706315aabfd$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $94154706315aabfd$var$Sc, $94154706315aabfd$var$Tc, $94154706315aabfd$var$Uc, $94154706315aabfd$var$Vc, $94154706315aabfd$var$Wc, $94154706315aabfd$var$Xc = !1, $94154706315aabfd$var$Yc = [], $94154706315aabfd$var$Zc = null, $94154706315aabfd$var$$c = null, $94154706315aabfd$var$ad = null, $94154706315aabfd$var$bd = new Map, $94154706315aabfd$var$cd = new Map, $94154706315aabfd$var$dd = [], $94154706315aabfd$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $94154706315aabfd$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $94154706315aabfd$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $94154706315aabfd$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $94154706315aabfd$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $94154706315aabfd$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $94154706315aabfd$var$cd.delete(b.pointerId);
    }
}
function $94154706315aabfd$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $94154706315aabfd$var$Cb(b), null !== b && $94154706315aabfd$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $94154706315aabfd$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $94154706315aabfd$var$Zc = $94154706315aabfd$var$gd($94154706315aabfd$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $94154706315aabfd$var$$c = $94154706315aabfd$var$gd($94154706315aabfd$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $94154706315aabfd$var$ad = $94154706315aabfd$var$gd($94154706315aabfd$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $94154706315aabfd$var$bd.set(f, $94154706315aabfd$var$gd($94154706315aabfd$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $94154706315aabfd$var$cd.set(f, $94154706315aabfd$var$gd($94154706315aabfd$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $94154706315aabfd$var$id(a) {
    var b = $94154706315aabfd$var$jd(a.target);
    if (null !== b) {
        var c = $94154706315aabfd$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $94154706315aabfd$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $94154706315aabfd$var$Wc(a.priority, function() {
                        $94154706315aabfd$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $94154706315aabfd$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $94154706315aabfd$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $94154706315aabfd$var$wb = d;
            c.target.dispatchEvent(d);
            $94154706315aabfd$var$wb = null;
        } else return b = $94154706315aabfd$var$Cb(c), null !== b && $94154706315aabfd$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $94154706315aabfd$var$md(a, b, c) {
    $94154706315aabfd$var$kd(a) && c.delete(b);
}
function $94154706315aabfd$var$nd() {
    $94154706315aabfd$var$Xc = !1;
    null !== $94154706315aabfd$var$Zc && $94154706315aabfd$var$kd($94154706315aabfd$var$Zc) && ($94154706315aabfd$var$Zc = null);
    null !== $94154706315aabfd$var$$c && $94154706315aabfd$var$kd($94154706315aabfd$var$$c) && ($94154706315aabfd$var$$c = null);
    null !== $94154706315aabfd$var$ad && $94154706315aabfd$var$kd($94154706315aabfd$var$ad) && ($94154706315aabfd$var$ad = null);
    $94154706315aabfd$var$bd.forEach($94154706315aabfd$var$md);
    $94154706315aabfd$var$cd.forEach($94154706315aabfd$var$md);
}
function $94154706315aabfd$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $94154706315aabfd$var$Xc || ($94154706315aabfd$var$Xc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $94154706315aabfd$var$nd)));
}
function $94154706315aabfd$var$pd(a) {
    function b(b) {
        return $94154706315aabfd$var$od(b, a);
    }
    if (0 < $94154706315aabfd$var$Yc.length) {
        $94154706315aabfd$var$od($94154706315aabfd$var$Yc[0], a);
        for(var c = 1; c < $94154706315aabfd$var$Yc.length; c++){
            var d = $94154706315aabfd$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $94154706315aabfd$var$Zc && $94154706315aabfd$var$od($94154706315aabfd$var$Zc, a);
    null !== $94154706315aabfd$var$$c && $94154706315aabfd$var$od($94154706315aabfd$var$$c, a);
    null !== $94154706315aabfd$var$ad && $94154706315aabfd$var$od($94154706315aabfd$var$ad, a);
    $94154706315aabfd$var$bd.forEach(b);
    $94154706315aabfd$var$cd.forEach(b);
    for(c = 0; c < $94154706315aabfd$var$dd.length; c++)d = $94154706315aabfd$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $94154706315aabfd$var$dd.length && (c = $94154706315aabfd$var$dd[0], null === c.blockedOn);)$94154706315aabfd$var$id(c), null === c.blockedOn && $94154706315aabfd$var$dd.shift();
}
var $94154706315aabfd$var$qd = $94154706315aabfd$var$va.ReactCurrentBatchConfig, $94154706315aabfd$var$rd = !0;
function $94154706315aabfd$var$sd(a, b, c, d) {
    var e = $94154706315aabfd$var$E, f = $94154706315aabfd$var$qd.transition;
    $94154706315aabfd$var$qd.transition = null;
    try {
        $94154706315aabfd$var$E = 1, $94154706315aabfd$var$td(a, b, c, d);
    } finally{
        $94154706315aabfd$var$E = e, $94154706315aabfd$var$qd.transition = f;
    }
}
function $94154706315aabfd$var$ud(a, b, c, d) {
    var e = $94154706315aabfd$var$E, f = $94154706315aabfd$var$qd.transition;
    $94154706315aabfd$var$qd.transition = null;
    try {
        $94154706315aabfd$var$E = 4, $94154706315aabfd$var$td(a, b, c, d);
    } finally{
        $94154706315aabfd$var$E = e, $94154706315aabfd$var$qd.transition = f;
    }
}
function $94154706315aabfd$var$td(a, b, c, d) {
    if ($94154706315aabfd$var$rd) {
        var e = $94154706315aabfd$var$ld(a, b, c, d);
        if (null === e) $94154706315aabfd$var$vd(a, b, d, $94154706315aabfd$var$wd, c), $94154706315aabfd$var$fd(a, d);
        else if ($94154706315aabfd$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($94154706315aabfd$var$fd(a, d), b & 4 && -1 < $94154706315aabfd$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $94154706315aabfd$var$Cb(e);
                null !== f && $94154706315aabfd$var$Sc(f);
                f = $94154706315aabfd$var$ld(a, b, c, d);
                null === f && $94154706315aabfd$var$vd(a, b, d, $94154706315aabfd$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $94154706315aabfd$var$vd(a, b, d, null, c);
    }
}
var $94154706315aabfd$var$wd = null;
function $94154706315aabfd$var$ld(a, b, c, d) {
    $94154706315aabfd$var$wd = null;
    a = $94154706315aabfd$var$xb(d);
    a = $94154706315aabfd$var$jd(a);
    if (null !== a) {
        if (b = $94154706315aabfd$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $94154706315aabfd$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $94154706315aabfd$var$wd = a;
    return null;
}
function $94154706315aabfd$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($94154706315aabfd$var$ec()){
                case $94154706315aabfd$var$fc:
                    return 1;
                case $94154706315aabfd$var$gc:
                    return 4;
                case $94154706315aabfd$var$hc:
                case $94154706315aabfd$var$ic:
                    return 16;
                case $94154706315aabfd$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $94154706315aabfd$var$yd = null, $94154706315aabfd$var$zd = null, $94154706315aabfd$var$Ad = null;
function $94154706315aabfd$var$Bd() {
    if ($94154706315aabfd$var$Ad) return $94154706315aabfd$var$Ad;
    var a, b = $94154706315aabfd$var$zd, c = b.length, d, e = "value" in $94154706315aabfd$var$yd ? $94154706315aabfd$var$yd.value : $94154706315aabfd$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $94154706315aabfd$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $94154706315aabfd$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $94154706315aabfd$var$Dd() {
    return !0;
}
function $94154706315aabfd$var$Ed() {
    return !1;
}
function $94154706315aabfd$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $94154706315aabfd$var$Dd : $94154706315aabfd$var$Ed;
        this.isPropagationStopped = $94154706315aabfd$var$Ed;
        return this;
    }
    $94154706315aabfd$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $94154706315aabfd$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $94154706315aabfd$var$Dd);
        },
        persist: function() {},
        isPersistent: $94154706315aabfd$var$Dd
    });
    return b;
}
var $94154706315aabfd$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $94154706315aabfd$var$Hd = $94154706315aabfd$var$Fd($94154706315aabfd$var$Gd), $94154706315aabfd$var$Id = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Gd, {
    view: 0,
    detail: 0
}), $94154706315aabfd$var$Jd = $94154706315aabfd$var$Fd($94154706315aabfd$var$Id), $94154706315aabfd$var$Kd, $94154706315aabfd$var$Ld, $94154706315aabfd$var$Md, $94154706315aabfd$var$Od = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $94154706315aabfd$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $94154706315aabfd$var$Md && ($94154706315aabfd$var$Md && "mousemove" === a.type ? ($94154706315aabfd$var$Kd = a.screenX - $94154706315aabfd$var$Md.screenX, $94154706315aabfd$var$Ld = a.screenY - $94154706315aabfd$var$Md.screenY) : $94154706315aabfd$var$Ld = $94154706315aabfd$var$Kd = 0, $94154706315aabfd$var$Md = a);
        return $94154706315aabfd$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $94154706315aabfd$var$Ld;
    }
}), $94154706315aabfd$var$Pd = $94154706315aabfd$var$Fd($94154706315aabfd$var$Od), $94154706315aabfd$var$Qd = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Od, {
    dataTransfer: 0
}), $94154706315aabfd$var$Rd = $94154706315aabfd$var$Fd($94154706315aabfd$var$Qd), $94154706315aabfd$var$Sd = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Id, {
    relatedTarget: 0
}), $94154706315aabfd$var$Td = $94154706315aabfd$var$Fd($94154706315aabfd$var$Sd), $94154706315aabfd$var$Ud = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $94154706315aabfd$var$Vd = $94154706315aabfd$var$Fd($94154706315aabfd$var$Ud), $94154706315aabfd$var$Wd = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $94154706315aabfd$var$Xd = $94154706315aabfd$var$Fd($94154706315aabfd$var$Wd), $94154706315aabfd$var$Yd = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Gd, {
    data: 0
}), $94154706315aabfd$var$Zd = $94154706315aabfd$var$Fd($94154706315aabfd$var$Yd), $94154706315aabfd$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $94154706315aabfd$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $94154706315aabfd$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $94154706315aabfd$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $94154706315aabfd$var$be[a]) ? !!b[a] : !1;
}
function $94154706315aabfd$var$Nd() {
    return $94154706315aabfd$var$ce;
}
var $94154706315aabfd$var$de = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $94154706315aabfd$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $94154706315aabfd$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $94154706315aabfd$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $94154706315aabfd$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $94154706315aabfd$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $94154706315aabfd$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $94154706315aabfd$var$ee = $94154706315aabfd$var$Fd($94154706315aabfd$var$de), $94154706315aabfd$var$fe = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $94154706315aabfd$var$ge = $94154706315aabfd$var$Fd($94154706315aabfd$var$fe), $94154706315aabfd$var$he = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $94154706315aabfd$var$Nd
}), $94154706315aabfd$var$ie = $94154706315aabfd$var$Fd($94154706315aabfd$var$he), $94154706315aabfd$var$je = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $94154706315aabfd$var$ke = $94154706315aabfd$var$Fd($94154706315aabfd$var$je), $94154706315aabfd$var$le = $94154706315aabfd$var$u({}, $94154706315aabfd$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $94154706315aabfd$var$me = $94154706315aabfd$var$Fd($94154706315aabfd$var$le), $94154706315aabfd$var$ne = [
    9,
    13,
    27,
    32
], $94154706315aabfd$var$oe = $94154706315aabfd$var$ia && "CompositionEvent" in window, $94154706315aabfd$var$pe = null;
$94154706315aabfd$var$ia && "documentMode" in document && ($94154706315aabfd$var$pe = document.documentMode);
var $94154706315aabfd$var$qe = $94154706315aabfd$var$ia && "TextEvent" in window && !$94154706315aabfd$var$pe, $94154706315aabfd$var$re = $94154706315aabfd$var$ia && (!$94154706315aabfd$var$oe || $94154706315aabfd$var$pe && 8 < $94154706315aabfd$var$pe && 11 >= $94154706315aabfd$var$pe), $94154706315aabfd$var$se = String.fromCharCode(32), $94154706315aabfd$var$te = !1;
function $94154706315aabfd$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $94154706315aabfd$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $94154706315aabfd$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $94154706315aabfd$var$we = !1;
function $94154706315aabfd$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $94154706315aabfd$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $94154706315aabfd$var$te = !0;
            return $94154706315aabfd$var$se;
        case "textInput":
            return a = b.data, a === $94154706315aabfd$var$se && $94154706315aabfd$var$te ? null : a;
        default:
            return null;
    }
}
function $94154706315aabfd$var$ye(a, b) {
    if ($94154706315aabfd$var$we) return "compositionend" === a || !$94154706315aabfd$var$oe && $94154706315aabfd$var$ue(a, b) ? (a = $94154706315aabfd$var$Bd(), $94154706315aabfd$var$Ad = $94154706315aabfd$var$zd = $94154706315aabfd$var$yd = null, $94154706315aabfd$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $94154706315aabfd$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $94154706315aabfd$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $94154706315aabfd$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$94154706315aabfd$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $94154706315aabfd$var$Be(a, b, c, d) {
    $94154706315aabfd$var$Eb(d);
    b = $94154706315aabfd$var$Ce(b, "onChange");
    0 < b.length && (c = new $94154706315aabfd$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $94154706315aabfd$var$De = null, $94154706315aabfd$var$Ee = null;
function $94154706315aabfd$var$Fe(a) {
    $94154706315aabfd$var$Ge(a, 0);
}
function $94154706315aabfd$var$He(a) {
    var b = $94154706315aabfd$var$Ie(a);
    if ($94154706315aabfd$var$Wa(b)) return a;
}
function $94154706315aabfd$var$Je(a, b) {
    if ("change" === a) return b;
}
var $94154706315aabfd$var$Ke = !1;
if ($94154706315aabfd$var$ia) {
    var $94154706315aabfd$var$Le;
    if ($94154706315aabfd$var$ia) {
        var $94154706315aabfd$var$Me = "oninput" in document;
        if (!$94154706315aabfd$var$Me) {
            var $94154706315aabfd$var$Ne = document.createElement("div");
            $94154706315aabfd$var$Ne.setAttribute("oninput", "return;");
            $94154706315aabfd$var$Me = "function" === typeof $94154706315aabfd$var$Ne.oninput;
        }
        $94154706315aabfd$var$Le = $94154706315aabfd$var$Me;
    } else $94154706315aabfd$var$Le = !1;
    $94154706315aabfd$var$Ke = $94154706315aabfd$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $94154706315aabfd$var$Oe() {
    $94154706315aabfd$var$De && ($94154706315aabfd$var$De.detachEvent("onpropertychange", $94154706315aabfd$var$Pe), $94154706315aabfd$var$Ee = $94154706315aabfd$var$De = null);
}
function $94154706315aabfd$var$Pe(a) {
    if ("value" === a.propertyName && $94154706315aabfd$var$He($94154706315aabfd$var$Ee)) {
        var b = [];
        $94154706315aabfd$var$Be(b, $94154706315aabfd$var$Ee, a, $94154706315aabfd$var$xb(a));
        $94154706315aabfd$var$Jb($94154706315aabfd$var$Fe, b);
    }
}
function $94154706315aabfd$var$Qe(a, b, c) {
    "focusin" === a ? ($94154706315aabfd$var$Oe(), $94154706315aabfd$var$De = b, $94154706315aabfd$var$Ee = c, $94154706315aabfd$var$De.attachEvent("onpropertychange", $94154706315aabfd$var$Pe)) : "focusout" === a && $94154706315aabfd$var$Oe();
}
function $94154706315aabfd$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $94154706315aabfd$var$He($94154706315aabfd$var$Ee);
}
function $94154706315aabfd$var$Se(a, b) {
    if ("click" === a) return $94154706315aabfd$var$He(b);
}
function $94154706315aabfd$var$Te(a, b) {
    if ("input" === a || "change" === a) return $94154706315aabfd$var$He(b);
}
function $94154706315aabfd$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $94154706315aabfd$var$Ve = "function" === typeof Object.is ? Object.is : $94154706315aabfd$var$Ue;
function $94154706315aabfd$var$We(a, b) {
    if ($94154706315aabfd$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$94154706315aabfd$var$ja.call(b, e) || !$94154706315aabfd$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $94154706315aabfd$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $94154706315aabfd$var$Ye(a, b) {
    var c = $94154706315aabfd$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $94154706315aabfd$var$Xe(c);
    }
}
function $94154706315aabfd$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $94154706315aabfd$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $94154706315aabfd$var$$e() {
    for(var a = window, b = $94154706315aabfd$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $94154706315aabfd$var$Xa(a.document);
    }
    return b;
}
function $94154706315aabfd$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $94154706315aabfd$var$bf(a) {
    var b = $94154706315aabfd$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $94154706315aabfd$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $94154706315aabfd$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $94154706315aabfd$var$Ye(c, f);
                var g = $94154706315aabfd$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $94154706315aabfd$var$cf = $94154706315aabfd$var$ia && "documentMode" in document && 11 >= document.documentMode, $94154706315aabfd$var$df = null, $94154706315aabfd$var$ef = null, $94154706315aabfd$var$ff = null, $94154706315aabfd$var$gf = !1;
function $94154706315aabfd$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $94154706315aabfd$var$gf || null == $94154706315aabfd$var$df || $94154706315aabfd$var$df !== $94154706315aabfd$var$Xa(d) || (d = $94154706315aabfd$var$df, "selectionStart" in d && $94154706315aabfd$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $94154706315aabfd$var$ff && $94154706315aabfd$var$We($94154706315aabfd$var$ff, d) || ($94154706315aabfd$var$ff = d, d = $94154706315aabfd$var$Ce($94154706315aabfd$var$ef, "onSelect"), 0 < d.length && (b = new $94154706315aabfd$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $94154706315aabfd$var$df)));
}
function $94154706315aabfd$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $94154706315aabfd$var$kf = {
    animationend: $94154706315aabfd$var$jf("Animation", "AnimationEnd"),
    animationiteration: $94154706315aabfd$var$jf("Animation", "AnimationIteration"),
    animationstart: $94154706315aabfd$var$jf("Animation", "AnimationStart"),
    transitionend: $94154706315aabfd$var$jf("Transition", "TransitionEnd")
}, $94154706315aabfd$var$lf = {}, $94154706315aabfd$var$mf = {};
$94154706315aabfd$var$ia && ($94154706315aabfd$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $94154706315aabfd$var$kf.animationend.animation, delete $94154706315aabfd$var$kf.animationiteration.animation, delete $94154706315aabfd$var$kf.animationstart.animation), "TransitionEvent" in window || delete $94154706315aabfd$var$kf.transitionend.transition);
function $94154706315aabfd$var$nf(a) {
    if ($94154706315aabfd$var$lf[a]) return $94154706315aabfd$var$lf[a];
    if (!$94154706315aabfd$var$kf[a]) return a;
    var b = $94154706315aabfd$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $94154706315aabfd$var$mf) return $94154706315aabfd$var$lf[a] = b[c];
    return a;
}
var $94154706315aabfd$var$of = $94154706315aabfd$var$nf("animationend"), $94154706315aabfd$var$pf = $94154706315aabfd$var$nf("animationiteration"), $94154706315aabfd$var$qf = $94154706315aabfd$var$nf("animationstart"), $94154706315aabfd$var$rf = $94154706315aabfd$var$nf("transitionend"), $94154706315aabfd$var$sf = new Map, $94154706315aabfd$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $94154706315aabfd$var$uf(a, b) {
    $94154706315aabfd$var$sf.set(a, b);
    $94154706315aabfd$var$fa(b, [
        a
    ]);
}
for(var $94154706315aabfd$var$vf = 0; $94154706315aabfd$var$vf < $94154706315aabfd$var$tf.length; $94154706315aabfd$var$vf++){
    var $94154706315aabfd$var$wf = $94154706315aabfd$var$tf[$94154706315aabfd$var$vf], $94154706315aabfd$var$xf = $94154706315aabfd$var$wf.toLowerCase(), $94154706315aabfd$var$yf = $94154706315aabfd$var$wf[0].toUpperCase() + $94154706315aabfd$var$wf.slice(1);
    $94154706315aabfd$var$uf($94154706315aabfd$var$xf, "on" + $94154706315aabfd$var$yf);
}
$94154706315aabfd$var$uf($94154706315aabfd$var$of, "onAnimationEnd");
$94154706315aabfd$var$uf($94154706315aabfd$var$pf, "onAnimationIteration");
$94154706315aabfd$var$uf($94154706315aabfd$var$qf, "onAnimationStart");
$94154706315aabfd$var$uf("dblclick", "onDoubleClick");
$94154706315aabfd$var$uf("focusin", "onFocus");
$94154706315aabfd$var$uf("focusout", "onBlur");
$94154706315aabfd$var$uf($94154706315aabfd$var$rf, "onTransitionEnd");
$94154706315aabfd$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$94154706315aabfd$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$94154706315aabfd$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$94154706315aabfd$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$94154706315aabfd$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$94154706315aabfd$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$94154706315aabfd$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$94154706315aabfd$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$94154706315aabfd$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$94154706315aabfd$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $94154706315aabfd$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $94154706315aabfd$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($94154706315aabfd$var$zf));
function $94154706315aabfd$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $94154706315aabfd$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $94154706315aabfd$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $94154706315aabfd$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $94154706315aabfd$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($94154706315aabfd$var$Qb) throw a = $94154706315aabfd$var$Rb, $94154706315aabfd$var$Qb = !1, $94154706315aabfd$var$Rb = null, a;
}
function $94154706315aabfd$var$F(a, b) {
    var c = b[$94154706315aabfd$var$Cf];
    void 0 === c && (c = b[$94154706315aabfd$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($94154706315aabfd$var$Df(b, a, 2, !1), c.add(d));
}
function $94154706315aabfd$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $94154706315aabfd$var$Df(c, a, d, b);
}
var $94154706315aabfd$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $94154706315aabfd$var$Gf(a) {
    if (!a[$94154706315aabfd$var$Ff]) {
        a[$94154706315aabfd$var$Ff] = !0;
        $94154706315aabfd$var$da.forEach(function(b) {
            "selectionchange" !== b && ($94154706315aabfd$var$Af.has(b) || $94154706315aabfd$var$Ef(b, !1, a), $94154706315aabfd$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$94154706315aabfd$var$Ff] || (b[$94154706315aabfd$var$Ff] = !0, $94154706315aabfd$var$Ef("selectionchange", !1, b));
    }
}
function $94154706315aabfd$var$Df(a, b, c, d) {
    switch($94154706315aabfd$var$xd(b)){
        case 1:
            var e = $94154706315aabfd$var$sd;
            break;
        case 4:
            e = $94154706315aabfd$var$ud;
            break;
        default:
            e = $94154706315aabfd$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$94154706315aabfd$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $94154706315aabfd$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $94154706315aabfd$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $94154706315aabfd$var$Jb(function() {
        var d = f, e = $94154706315aabfd$var$xb(c), g = [];
        a: {
            var h = $94154706315aabfd$var$sf.get(a);
            if (void 0 !== h) {
                var k = $94154706315aabfd$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $94154706315aabfd$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $94154706315aabfd$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $94154706315aabfd$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $94154706315aabfd$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $94154706315aabfd$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $94154706315aabfd$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $94154706315aabfd$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $94154706315aabfd$var$ie;
                        break;
                    case $94154706315aabfd$var$of:
                    case $94154706315aabfd$var$pf:
                    case $94154706315aabfd$var$qf:
                        k = $94154706315aabfd$var$Vd;
                        break;
                    case $94154706315aabfd$var$rf:
                        k = $94154706315aabfd$var$ke;
                        break;
                    case "scroll":
                        k = $94154706315aabfd$var$Jd;
                        break;
                    case "wheel":
                        k = $94154706315aabfd$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $94154706315aabfd$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $94154706315aabfd$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $94154706315aabfd$var$Kb(y, x), null != D && w.push($94154706315aabfd$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $94154706315aabfd$var$wb && (m = c.relatedTarget || c.fromElement) && ($94154706315aabfd$var$jd(m) || m[$94154706315aabfd$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $94154706315aabfd$var$jd(m) : null, null !== m && (C = $94154706315aabfd$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $94154706315aabfd$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $94154706315aabfd$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $94154706315aabfd$var$Ie(k);
                        v = null == m ? h : $94154706315aabfd$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $94154706315aabfd$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $94154706315aabfd$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $94154706315aabfd$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $94154706315aabfd$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $94154706315aabfd$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $94154706315aabfd$var$Jf(w);
                                x = $94154706315aabfd$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $94154706315aabfd$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $94154706315aabfd$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $94154706315aabfd$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $94154706315aabfd$var$Je;
                else if ($94154706315aabfd$var$Ae(h)) {
                    if ($94154706315aabfd$var$Ke) ca = $94154706315aabfd$var$Te;
                    else {
                        ca = $94154706315aabfd$var$Re;
                        var R = $94154706315aabfd$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $94154706315aabfd$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $94154706315aabfd$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $94154706315aabfd$var$bb(h, "number", h.value);
            }
            R = d ? $94154706315aabfd$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($94154706315aabfd$var$Ae(R) || "true" === R.contentEditable) $94154706315aabfd$var$df = R, $94154706315aabfd$var$ef = d, $94154706315aabfd$var$ff = null;
                    break;
                case "focusout":
                    $94154706315aabfd$var$ff = $94154706315aabfd$var$ef = $94154706315aabfd$var$df = null;
                    break;
                case "mousedown":
                    $94154706315aabfd$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $94154706315aabfd$var$gf = !1;
                    $94154706315aabfd$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($94154706315aabfd$var$cf) break;
                case "keydown":
                case "keyup":
                    $94154706315aabfd$var$hf(g, c, e);
            }
            var sa;
            if ($94154706315aabfd$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $94154706315aabfd$var$we ? $94154706315aabfd$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($94154706315aabfd$var$re && "ko" !== c.locale && ($94154706315aabfd$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $94154706315aabfd$var$we && (sa = $94154706315aabfd$var$Bd()) : ($94154706315aabfd$var$yd = e, $94154706315aabfd$var$zd = "value" in $94154706315aabfd$var$yd ? $94154706315aabfd$var$yd.value : $94154706315aabfd$var$yd.textContent, $94154706315aabfd$var$we = !0)), R = $94154706315aabfd$var$Ce(d, V), 0 < R.length && (V = new $94154706315aabfd$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $94154706315aabfd$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $94154706315aabfd$var$qe ? $94154706315aabfd$var$xe(a, c) : $94154706315aabfd$var$ye(a, c)) d = $94154706315aabfd$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $94154706315aabfd$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $94154706315aabfd$var$Ge(g, b);
    });
}
function $94154706315aabfd$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $94154706315aabfd$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $94154706315aabfd$var$Kb(a, c), null != f && d.unshift($94154706315aabfd$var$Hf(a, f, e)), f = $94154706315aabfd$var$Kb(a, b), null != f && d.push($94154706315aabfd$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $94154706315aabfd$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $94154706315aabfd$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $94154706315aabfd$var$Kb(c, f), null != k && g.unshift($94154706315aabfd$var$Hf(c, k, h))) : e || (k = $94154706315aabfd$var$Kb(c, f), null != k && g.push($94154706315aabfd$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $94154706315aabfd$var$Lf = /\r\n?/g, $94154706315aabfd$var$Mf = /\u0000|\uFFFD/g;
function $94154706315aabfd$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($94154706315aabfd$var$Lf, "\n").replace($94154706315aabfd$var$Mf, "");
}
function $94154706315aabfd$var$Of(a, b, c) {
    b = $94154706315aabfd$var$Nf(b);
    if ($94154706315aabfd$var$Nf(a) !== b && c) throw Error($94154706315aabfd$var$p(425));
}
function $94154706315aabfd$var$Pf() {}
var $94154706315aabfd$var$Qf = null, $94154706315aabfd$var$Rf = null;
function $94154706315aabfd$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $94154706315aabfd$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $94154706315aabfd$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $94154706315aabfd$var$Vf = "function" === typeof Promise ? Promise : void 0, $94154706315aabfd$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $94154706315aabfd$var$Vf ? function(a) {
    return $94154706315aabfd$var$Vf.resolve(null).then(a).catch($94154706315aabfd$var$Wf);
} : $94154706315aabfd$var$Tf;
function $94154706315aabfd$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $94154706315aabfd$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $94154706315aabfd$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $94154706315aabfd$var$pd(b);
}
function $94154706315aabfd$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $94154706315aabfd$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $94154706315aabfd$var$ag = Math.random().toString(36).slice(2), $94154706315aabfd$var$bg = "__reactFiber$" + $94154706315aabfd$var$ag, $94154706315aabfd$var$cg = "__reactProps$" + $94154706315aabfd$var$ag, $94154706315aabfd$var$If = "__reactContainer$" + $94154706315aabfd$var$ag, $94154706315aabfd$var$Cf = "__reactEvents$" + $94154706315aabfd$var$ag, $94154706315aabfd$var$dg = "__reactListeners$" + $94154706315aabfd$var$ag, $94154706315aabfd$var$eg = "__reactHandles$" + $94154706315aabfd$var$ag;
function $94154706315aabfd$var$jd(a) {
    var b = a[$94154706315aabfd$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$94154706315aabfd$var$If] || c[$94154706315aabfd$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $94154706315aabfd$var$$f(a); null !== a;){
                if (c = a[$94154706315aabfd$var$bg]) return c;
                a = $94154706315aabfd$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $94154706315aabfd$var$Cb(a) {
    a = a[$94154706315aabfd$var$bg] || a[$94154706315aabfd$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $94154706315aabfd$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($94154706315aabfd$var$p(33));
}
function $94154706315aabfd$var$Db(a) {
    return a[$94154706315aabfd$var$cg] || null;
}
var $94154706315aabfd$var$fg = [], $94154706315aabfd$var$gg = -1;
function $94154706315aabfd$var$hg(a) {
    return {
        current: a
    };
}
function $94154706315aabfd$var$G(a) {
    0 > $94154706315aabfd$var$gg || (a.current = $94154706315aabfd$var$fg[$94154706315aabfd$var$gg], $94154706315aabfd$var$fg[$94154706315aabfd$var$gg] = null, $94154706315aabfd$var$gg--);
}
function $94154706315aabfd$var$H(a, b) {
    $94154706315aabfd$var$gg++;
    $94154706315aabfd$var$fg[$94154706315aabfd$var$gg] = a.current;
    a.current = b;
}
var $94154706315aabfd$var$ig = {}, $94154706315aabfd$var$I = $94154706315aabfd$var$hg($94154706315aabfd$var$ig), $94154706315aabfd$var$jg = $94154706315aabfd$var$hg(!1), $94154706315aabfd$var$kg = $94154706315aabfd$var$ig;
function $94154706315aabfd$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $94154706315aabfd$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $94154706315aabfd$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $94154706315aabfd$var$ng() {
    $94154706315aabfd$var$G($94154706315aabfd$var$jg);
    $94154706315aabfd$var$G($94154706315aabfd$var$I);
}
function $94154706315aabfd$var$og(a, b, c) {
    if ($94154706315aabfd$var$I.current !== $94154706315aabfd$var$ig) throw Error($94154706315aabfd$var$p(168));
    $94154706315aabfd$var$H($94154706315aabfd$var$I, b);
    $94154706315aabfd$var$H($94154706315aabfd$var$jg, c);
}
function $94154706315aabfd$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($94154706315aabfd$var$p(108, $94154706315aabfd$var$Ra(a) || "Unknown", e));
    return $94154706315aabfd$var$u({}, c, d);
}
function $94154706315aabfd$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $94154706315aabfd$var$ig;
    $94154706315aabfd$var$kg = $94154706315aabfd$var$I.current;
    $94154706315aabfd$var$H($94154706315aabfd$var$I, a);
    $94154706315aabfd$var$H($94154706315aabfd$var$jg, $94154706315aabfd$var$jg.current);
    return !0;
}
function $94154706315aabfd$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($94154706315aabfd$var$p(169));
    c ? (a = $94154706315aabfd$var$pg(a, b, $94154706315aabfd$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $94154706315aabfd$var$G($94154706315aabfd$var$jg), $94154706315aabfd$var$G($94154706315aabfd$var$I), $94154706315aabfd$var$H($94154706315aabfd$var$I, a)) : $94154706315aabfd$var$G($94154706315aabfd$var$jg);
    $94154706315aabfd$var$H($94154706315aabfd$var$jg, c);
}
var $94154706315aabfd$var$sg = null, $94154706315aabfd$var$tg = !1, $94154706315aabfd$var$ug = !1;
function $94154706315aabfd$var$vg(a) {
    null === $94154706315aabfd$var$sg ? $94154706315aabfd$var$sg = [
        a
    ] : $94154706315aabfd$var$sg.push(a);
}
function $94154706315aabfd$var$wg(a) {
    $94154706315aabfd$var$tg = !0;
    $94154706315aabfd$var$vg(a);
}
function $94154706315aabfd$var$xg() {
    if (!$94154706315aabfd$var$ug && null !== $94154706315aabfd$var$sg) {
        $94154706315aabfd$var$ug = !0;
        var a = 0, b = $94154706315aabfd$var$E;
        try {
            var c = $94154706315aabfd$var$sg;
            for($94154706315aabfd$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $94154706315aabfd$var$sg = null;
            $94154706315aabfd$var$tg = !1;
        } catch (e) {
            throw null !== $94154706315aabfd$var$sg && ($94154706315aabfd$var$sg = $94154706315aabfd$var$sg.slice(a + 1)), $94154706315aabfd$var$ac($94154706315aabfd$var$fc, $94154706315aabfd$var$xg), e;
        } finally{
            $94154706315aabfd$var$E = b, $94154706315aabfd$var$ug = !1;
        }
    }
    return null;
}
var $94154706315aabfd$var$yg = [], $94154706315aabfd$var$zg = 0, $94154706315aabfd$var$Ag = null, $94154706315aabfd$var$Bg = 0, $94154706315aabfd$var$Cg = [], $94154706315aabfd$var$Dg = 0, $94154706315aabfd$var$Eg = null, $94154706315aabfd$var$Fg = 1, $94154706315aabfd$var$Gg = "";
function $94154706315aabfd$var$Hg(a, b) {
    $94154706315aabfd$var$yg[$94154706315aabfd$var$zg++] = $94154706315aabfd$var$Bg;
    $94154706315aabfd$var$yg[$94154706315aabfd$var$zg++] = $94154706315aabfd$var$Ag;
    $94154706315aabfd$var$Ag = a;
    $94154706315aabfd$var$Bg = b;
}
function $94154706315aabfd$var$Ig(a, b, c) {
    $94154706315aabfd$var$Cg[$94154706315aabfd$var$Dg++] = $94154706315aabfd$var$Fg;
    $94154706315aabfd$var$Cg[$94154706315aabfd$var$Dg++] = $94154706315aabfd$var$Gg;
    $94154706315aabfd$var$Cg[$94154706315aabfd$var$Dg++] = $94154706315aabfd$var$Eg;
    $94154706315aabfd$var$Eg = a;
    var d = $94154706315aabfd$var$Fg;
    a = $94154706315aabfd$var$Gg;
    var e = 32 - $94154706315aabfd$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $94154706315aabfd$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $94154706315aabfd$var$Fg = 1 << 32 - $94154706315aabfd$var$Ac(b) + e | c << e | d;
        $94154706315aabfd$var$Gg = f + a;
    } else $94154706315aabfd$var$Fg = 1 << f | c << e | d, $94154706315aabfd$var$Gg = a;
}
function $94154706315aabfd$var$Jg(a) {
    null !== a.return && ($94154706315aabfd$var$Hg(a, 1), $94154706315aabfd$var$Ig(a, 1, 0));
}
function $94154706315aabfd$var$Kg(a) {
    for(; a === $94154706315aabfd$var$Ag;)$94154706315aabfd$var$Ag = $94154706315aabfd$var$yg[--$94154706315aabfd$var$zg], $94154706315aabfd$var$yg[$94154706315aabfd$var$zg] = null, $94154706315aabfd$var$Bg = $94154706315aabfd$var$yg[--$94154706315aabfd$var$zg], $94154706315aabfd$var$yg[$94154706315aabfd$var$zg] = null;
    for(; a === $94154706315aabfd$var$Eg;)$94154706315aabfd$var$Eg = $94154706315aabfd$var$Cg[--$94154706315aabfd$var$Dg], $94154706315aabfd$var$Cg[$94154706315aabfd$var$Dg] = null, $94154706315aabfd$var$Gg = $94154706315aabfd$var$Cg[--$94154706315aabfd$var$Dg], $94154706315aabfd$var$Cg[$94154706315aabfd$var$Dg] = null, $94154706315aabfd$var$Fg = $94154706315aabfd$var$Cg[--$94154706315aabfd$var$Dg], $94154706315aabfd$var$Cg[$94154706315aabfd$var$Dg] = null;
}
var $94154706315aabfd$var$Lg = null, $94154706315aabfd$var$Mg = null, $94154706315aabfd$var$J = !1, $94154706315aabfd$var$Ng = null;
function $94154706315aabfd$var$Og(a, b) {
    var c = $94154706315aabfd$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $94154706315aabfd$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $94154706315aabfd$var$Lg = a, $94154706315aabfd$var$Mg = $94154706315aabfd$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $94154706315aabfd$var$Lg = a, $94154706315aabfd$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $94154706315aabfd$var$Eg ? {
                id: $94154706315aabfd$var$Fg,
                overflow: $94154706315aabfd$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $94154706315aabfd$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $94154706315aabfd$var$Lg = a, $94154706315aabfd$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $94154706315aabfd$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $94154706315aabfd$var$Sg(a) {
    if ($94154706315aabfd$var$J) {
        var b = $94154706315aabfd$var$Mg;
        if (b) {
            var c = b;
            if (!$94154706315aabfd$var$Qg(a, b)) {
                if ($94154706315aabfd$var$Rg(a)) throw Error($94154706315aabfd$var$p(418));
                b = $94154706315aabfd$var$Zf(c.nextSibling);
                var d = $94154706315aabfd$var$Lg;
                b && $94154706315aabfd$var$Qg(a, b) ? $94154706315aabfd$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $94154706315aabfd$var$J = !1, $94154706315aabfd$var$Lg = a);
            }
        } else {
            if ($94154706315aabfd$var$Rg(a)) throw Error($94154706315aabfd$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $94154706315aabfd$var$J = !1;
            $94154706315aabfd$var$Lg = a;
        }
    }
}
function $94154706315aabfd$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $94154706315aabfd$var$Lg = a;
}
function $94154706315aabfd$var$Ug(a) {
    if (a !== $94154706315aabfd$var$Lg) return !1;
    if (!$94154706315aabfd$var$J) return $94154706315aabfd$var$Tg(a), $94154706315aabfd$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$94154706315aabfd$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $94154706315aabfd$var$Mg)) {
        if ($94154706315aabfd$var$Rg(a)) throw $94154706315aabfd$var$Vg(), Error($94154706315aabfd$var$p(418));
        for(; b;)$94154706315aabfd$var$Og(a, b), b = $94154706315aabfd$var$Zf(b.nextSibling);
    }
    $94154706315aabfd$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($94154706315aabfd$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $94154706315aabfd$var$Mg = $94154706315aabfd$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $94154706315aabfd$var$Mg = null;
        }
    } else $94154706315aabfd$var$Mg = $94154706315aabfd$var$Lg ? $94154706315aabfd$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $94154706315aabfd$var$Vg() {
    for(var a = $94154706315aabfd$var$Mg; a;)a = $94154706315aabfd$var$Zf(a.nextSibling);
}
function $94154706315aabfd$var$Wg() {
    $94154706315aabfd$var$Mg = $94154706315aabfd$var$Lg = null;
    $94154706315aabfd$var$J = !1;
}
function $94154706315aabfd$var$Xg(a) {
    null === $94154706315aabfd$var$Ng ? $94154706315aabfd$var$Ng = [
        a
    ] : $94154706315aabfd$var$Ng.push(a);
}
var $94154706315aabfd$var$Yg = $94154706315aabfd$var$va.ReactCurrentBatchConfig;
function $94154706315aabfd$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($94154706315aabfd$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($94154706315aabfd$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($94154706315aabfd$var$p(284));
        if (!c._owner) throw Error($94154706315aabfd$var$p(290, a));
    }
    return a;
}
function $94154706315aabfd$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($94154706315aabfd$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $94154706315aabfd$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $94154706315aabfd$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $94154706315aabfd$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $94154706315aabfd$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $94154706315aabfd$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $94154706315aabfd$var$Ha && $94154706315aabfd$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $94154706315aabfd$var$Zg(a, b, c), d.return = a, d;
        d = $94154706315aabfd$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $94154706315aabfd$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $94154706315aabfd$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $94154706315aabfd$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $94154706315aabfd$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $94154706315aabfd$var$wa:
                    return c = $94154706315aabfd$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $94154706315aabfd$var$Zg(a, null, b), c.return = a, c;
                case $94154706315aabfd$var$xa:
                    return b = $94154706315aabfd$var$fh(b, a.mode, c), b.return = a, b;
                case $94154706315aabfd$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($94154706315aabfd$var$db(b) || $94154706315aabfd$var$Ka(b)) return b = $94154706315aabfd$var$gh(b, a.mode, c, null), b.return = a, b;
            $94154706315aabfd$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $94154706315aabfd$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $94154706315aabfd$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $94154706315aabfd$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($94154706315aabfd$var$db(c) || $94154706315aabfd$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $94154706315aabfd$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $94154706315aabfd$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $94154706315aabfd$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $94154706315aabfd$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($94154706315aabfd$var$db(d) || $94154706315aabfd$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $94154706315aabfd$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $94154706315aabfd$var$J && $94154706315aabfd$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $94154706315aabfd$var$J && $94154706315aabfd$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $94154706315aabfd$var$J && $94154706315aabfd$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $94154706315aabfd$var$Ka(h);
        if ("function" !== typeof l) throw Error($94154706315aabfd$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($94154706315aabfd$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $94154706315aabfd$var$J && $94154706315aabfd$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $94154706315aabfd$var$J && $94154706315aabfd$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $94154706315aabfd$var$J && $94154706315aabfd$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $94154706315aabfd$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $94154706315aabfd$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $94154706315aabfd$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $94154706315aabfd$var$Ha && $94154706315aabfd$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $94154706315aabfd$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $94154706315aabfd$var$ya ? (d = $94154706315aabfd$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $94154706315aabfd$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $94154706315aabfd$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $94154706315aabfd$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $94154706315aabfd$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $94154706315aabfd$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($94154706315aabfd$var$db(f)) return m(a, d, f, h);
            if ($94154706315aabfd$var$Ka(f)) return w(a, d, f, h);
            $94154706315aabfd$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $94154706315aabfd$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $94154706315aabfd$var$hh = $94154706315aabfd$var$bh(!0), $94154706315aabfd$var$ih = $94154706315aabfd$var$bh(!1), $94154706315aabfd$var$jh = $94154706315aabfd$var$hg(null), $94154706315aabfd$var$kh = null, $94154706315aabfd$var$lh = null, $94154706315aabfd$var$mh = null;
function $94154706315aabfd$var$nh() {
    $94154706315aabfd$var$mh = $94154706315aabfd$var$lh = $94154706315aabfd$var$kh = null;
}
function $94154706315aabfd$var$oh(a) {
    var b = $94154706315aabfd$var$jh.current;
    $94154706315aabfd$var$G($94154706315aabfd$var$jh);
    a._currentValue = b;
}
function $94154706315aabfd$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $94154706315aabfd$var$qh(a, b) {
    $94154706315aabfd$var$kh = a;
    $94154706315aabfd$var$mh = $94154706315aabfd$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($94154706315aabfd$var$rh = !0), a.firstContext = null);
}
function $94154706315aabfd$var$sh(a) {
    var b = a._currentValue;
    if ($94154706315aabfd$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $94154706315aabfd$var$lh) {
            if (null === $94154706315aabfd$var$kh) throw Error($94154706315aabfd$var$p(308));
            $94154706315aabfd$var$lh = a;
            $94154706315aabfd$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $94154706315aabfd$var$lh = $94154706315aabfd$var$lh.next = a;
    }
    return b;
}
var $94154706315aabfd$var$th = null;
function $94154706315aabfd$var$uh(a) {
    null === $94154706315aabfd$var$th ? $94154706315aabfd$var$th = [
        a
    ] : $94154706315aabfd$var$th.push(a);
}
function $94154706315aabfd$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $94154706315aabfd$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $94154706315aabfd$var$wh(a, d);
}
function $94154706315aabfd$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $94154706315aabfd$var$xh = !1;
function $94154706315aabfd$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $94154706315aabfd$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $94154706315aabfd$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $94154706315aabfd$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($94154706315aabfd$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $94154706315aabfd$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $94154706315aabfd$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $94154706315aabfd$var$wh(a, c);
}
function $94154706315aabfd$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $94154706315aabfd$var$Oc(a, c);
    }
}
function $94154706315aabfd$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $94154706315aabfd$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $94154706315aabfd$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $94154706315aabfd$var$u({}, q, r);
                            break a;
                        case 2:
                            $94154706315aabfd$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $94154706315aabfd$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $94154706315aabfd$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($94154706315aabfd$var$p(191, e));
            e.call(d);
        }
    }
}
var $94154706315aabfd$var$Hh = {}, $94154706315aabfd$var$Ih = $94154706315aabfd$var$hg($94154706315aabfd$var$Hh), $94154706315aabfd$var$Jh = $94154706315aabfd$var$hg($94154706315aabfd$var$Hh), $94154706315aabfd$var$Kh = $94154706315aabfd$var$hg($94154706315aabfd$var$Hh);
function $94154706315aabfd$var$Lh(a) {
    if (a === $94154706315aabfd$var$Hh) throw Error($94154706315aabfd$var$p(174));
    return a;
}
function $94154706315aabfd$var$Mh(a, b) {
    $94154706315aabfd$var$H($94154706315aabfd$var$Kh, b);
    $94154706315aabfd$var$H($94154706315aabfd$var$Jh, a);
    $94154706315aabfd$var$H($94154706315aabfd$var$Ih, $94154706315aabfd$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $94154706315aabfd$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $94154706315aabfd$var$kb(b, a);
    }
    $94154706315aabfd$var$G($94154706315aabfd$var$Ih);
    $94154706315aabfd$var$H($94154706315aabfd$var$Ih, b);
}
function $94154706315aabfd$var$Nh() {
    $94154706315aabfd$var$G($94154706315aabfd$var$Ih);
    $94154706315aabfd$var$G($94154706315aabfd$var$Jh);
    $94154706315aabfd$var$G($94154706315aabfd$var$Kh);
}
function $94154706315aabfd$var$Oh(a) {
    $94154706315aabfd$var$Lh($94154706315aabfd$var$Kh.current);
    var b = $94154706315aabfd$var$Lh($94154706315aabfd$var$Ih.current);
    var c = $94154706315aabfd$var$kb(b, a.type);
    b !== c && ($94154706315aabfd$var$H($94154706315aabfd$var$Jh, a), $94154706315aabfd$var$H($94154706315aabfd$var$Ih, c));
}
function $94154706315aabfd$var$Ph(a) {
    $94154706315aabfd$var$Jh.current === a && ($94154706315aabfd$var$G($94154706315aabfd$var$Ih), $94154706315aabfd$var$G($94154706315aabfd$var$Jh));
}
var $94154706315aabfd$var$L = $94154706315aabfd$var$hg(0);
function $94154706315aabfd$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $94154706315aabfd$var$Rh = [];
function $94154706315aabfd$var$Sh() {
    for(var a = 0; a < $94154706315aabfd$var$Rh.length; a++)$94154706315aabfd$var$Rh[a]._workInProgressVersionPrimary = null;
    $94154706315aabfd$var$Rh.length = 0;
}
var $94154706315aabfd$var$Th = $94154706315aabfd$var$va.ReactCurrentDispatcher, $94154706315aabfd$var$Uh = $94154706315aabfd$var$va.ReactCurrentBatchConfig, $94154706315aabfd$var$Vh = 0, $94154706315aabfd$var$M = null, $94154706315aabfd$var$N = null, $94154706315aabfd$var$O = null, $94154706315aabfd$var$Wh = !1, $94154706315aabfd$var$Xh = !1, $94154706315aabfd$var$Yh = 0, $94154706315aabfd$var$Zh = 0;
function $94154706315aabfd$var$P() {
    throw Error($94154706315aabfd$var$p(321));
}
function $94154706315aabfd$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$94154706315aabfd$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $94154706315aabfd$var$ai(a, b, c, d, e, f) {
    $94154706315aabfd$var$Vh = f;
    $94154706315aabfd$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $94154706315aabfd$var$Th.current = null === a || null === a.memoizedState ? $94154706315aabfd$var$bi : $94154706315aabfd$var$ci;
    a = c(d, e);
    if ($94154706315aabfd$var$Xh) {
        f = 0;
        do {
            $94154706315aabfd$var$Xh = !1;
            $94154706315aabfd$var$Yh = 0;
            if (25 <= f) throw Error($94154706315aabfd$var$p(301));
            f += 1;
            $94154706315aabfd$var$O = $94154706315aabfd$var$N = null;
            b.updateQueue = null;
            $94154706315aabfd$var$Th.current = $94154706315aabfd$var$di;
            a = c(d, e);
        }while ($94154706315aabfd$var$Xh);
    }
    $94154706315aabfd$var$Th.current = $94154706315aabfd$var$ei;
    b = null !== $94154706315aabfd$var$N && null !== $94154706315aabfd$var$N.next;
    $94154706315aabfd$var$Vh = 0;
    $94154706315aabfd$var$O = $94154706315aabfd$var$N = $94154706315aabfd$var$M = null;
    $94154706315aabfd$var$Wh = !1;
    if (b) throw Error($94154706315aabfd$var$p(300));
    return a;
}
function $94154706315aabfd$var$fi() {
    var a = 0 !== $94154706315aabfd$var$Yh;
    $94154706315aabfd$var$Yh = 0;
    return a;
}
function $94154706315aabfd$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $94154706315aabfd$var$O ? $94154706315aabfd$var$M.memoizedState = $94154706315aabfd$var$O = a : $94154706315aabfd$var$O = $94154706315aabfd$var$O.next = a;
    return $94154706315aabfd$var$O;
}
function $94154706315aabfd$var$hi() {
    if (null === $94154706315aabfd$var$N) {
        var a = $94154706315aabfd$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $94154706315aabfd$var$N.next;
    var b = null === $94154706315aabfd$var$O ? $94154706315aabfd$var$M.memoizedState : $94154706315aabfd$var$O.next;
    if (null !== b) $94154706315aabfd$var$O = b, $94154706315aabfd$var$N = a;
    else {
        if (null === a) throw Error($94154706315aabfd$var$p(310));
        $94154706315aabfd$var$N = a;
        a = {
            memoizedState: $94154706315aabfd$var$N.memoizedState,
            baseState: $94154706315aabfd$var$N.baseState,
            baseQueue: $94154706315aabfd$var$N.baseQueue,
            queue: $94154706315aabfd$var$N.queue,
            next: null
        };
        null === $94154706315aabfd$var$O ? $94154706315aabfd$var$M.memoizedState = $94154706315aabfd$var$O = a : $94154706315aabfd$var$O = $94154706315aabfd$var$O.next = a;
    }
    return $94154706315aabfd$var$O;
}
function $94154706315aabfd$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $94154706315aabfd$var$ji(a) {
    var b = $94154706315aabfd$var$hi(), c = b.queue;
    if (null === c) throw Error($94154706315aabfd$var$p(311));
    c.lastRenderedReducer = a;
    var d = $94154706315aabfd$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($94154706315aabfd$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $94154706315aabfd$var$M.lanes |= n;
                $94154706315aabfd$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $94154706315aabfd$var$Ve(d, b.memoizedState) || ($94154706315aabfd$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $94154706315aabfd$var$M.lanes |= f, $94154706315aabfd$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $94154706315aabfd$var$ki(a) {
    var b = $94154706315aabfd$var$hi(), c = b.queue;
    if (null === c) throw Error($94154706315aabfd$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $94154706315aabfd$var$Ve(f, b.memoizedState) || ($94154706315aabfd$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $94154706315aabfd$var$li() {}
function $94154706315aabfd$var$mi(a, b) {
    var c = $94154706315aabfd$var$M, d = $94154706315aabfd$var$hi(), e = b(), f = !$94154706315aabfd$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $94154706315aabfd$var$rh = !0);
    d = d.queue;
    $94154706315aabfd$var$ni($94154706315aabfd$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $94154706315aabfd$var$O && $94154706315aabfd$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $94154706315aabfd$var$pi(9, $94154706315aabfd$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $94154706315aabfd$var$Q) throw Error($94154706315aabfd$var$p(349));
        0 !== ($94154706315aabfd$var$Vh & 30) || $94154706315aabfd$var$ri(c, b, e);
    }
    return e;
}
function $94154706315aabfd$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $94154706315aabfd$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $94154706315aabfd$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $94154706315aabfd$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $94154706315aabfd$var$si(b) && $94154706315aabfd$var$ti(a);
}
function $94154706315aabfd$var$oi(a, b, c) {
    return c(function() {
        $94154706315aabfd$var$si(b) && $94154706315aabfd$var$ti(a);
    });
}
function $94154706315aabfd$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$94154706315aabfd$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $94154706315aabfd$var$ti(a) {
    var b = $94154706315aabfd$var$wh(a, 1);
    null !== b && $94154706315aabfd$var$ui(b, a, 1, -1);
}
function $94154706315aabfd$var$vi(a) {
    var b = $94154706315aabfd$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $94154706315aabfd$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $94154706315aabfd$var$wi.bind(null, $94154706315aabfd$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $94154706315aabfd$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $94154706315aabfd$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $94154706315aabfd$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $94154706315aabfd$var$xi() {
    return $94154706315aabfd$var$hi().memoizedState;
}
function $94154706315aabfd$var$Ai(a, b, c, d) {
    var e = $94154706315aabfd$var$gi();
    $94154706315aabfd$var$M.flags |= a;
    e.memoizedState = $94154706315aabfd$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $94154706315aabfd$var$Bi(a, b, c, d) {
    var e = $94154706315aabfd$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $94154706315aabfd$var$N) {
        var g = $94154706315aabfd$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $94154706315aabfd$var$$h(d, g.deps)) {
            e.memoizedState = $94154706315aabfd$var$pi(b, c, f, d);
            return;
        }
    }
    $94154706315aabfd$var$M.flags |= a;
    e.memoizedState = $94154706315aabfd$var$pi(1 | b, c, f, d);
}
function $94154706315aabfd$var$Ci(a, b) {
    return $94154706315aabfd$var$Ai(8390656, 8, a, b);
}
function $94154706315aabfd$var$ni(a, b) {
    return $94154706315aabfd$var$Bi(2048, 8, a, b);
}
function $94154706315aabfd$var$Di(a, b) {
    return $94154706315aabfd$var$Bi(4, 2, a, b);
}
function $94154706315aabfd$var$Ei(a, b) {
    return $94154706315aabfd$var$Bi(4, 4, a, b);
}
function $94154706315aabfd$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $94154706315aabfd$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $94154706315aabfd$var$Bi(4, 4, $94154706315aabfd$var$Fi.bind(null, b, a), c);
}
function $94154706315aabfd$var$Hi() {}
function $94154706315aabfd$var$Ii(a, b) {
    var c = $94154706315aabfd$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $94154706315aabfd$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $94154706315aabfd$var$Ji(a, b) {
    var c = $94154706315aabfd$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $94154706315aabfd$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $94154706315aabfd$var$Ki(a, b, c) {
    if (0 === ($94154706315aabfd$var$Vh & 21)) return a.baseState && (a.baseState = !1, $94154706315aabfd$var$rh = !0), a.memoizedState = c;
    $94154706315aabfd$var$Ve(c, b) || (c = $94154706315aabfd$var$Kc(), $94154706315aabfd$var$M.lanes |= c, $94154706315aabfd$var$Fh |= c, a.baseState = !0);
    return b;
}
function $94154706315aabfd$var$Li(a, b) {
    var c = $94154706315aabfd$var$E;
    $94154706315aabfd$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $94154706315aabfd$var$Uh.transition;
    $94154706315aabfd$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $94154706315aabfd$var$E = c, $94154706315aabfd$var$Uh.transition = d;
    }
}
function $94154706315aabfd$var$Mi() {
    return $94154706315aabfd$var$hi().memoizedState;
}
function $94154706315aabfd$var$Ni(a, b, c) {
    var d = $94154706315aabfd$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($94154706315aabfd$var$Pi(a)) $94154706315aabfd$var$Qi(b, c);
    else if (c = $94154706315aabfd$var$vh(a, b, c, d), null !== c) {
        var e = $94154706315aabfd$var$Ri();
        $94154706315aabfd$var$ui(c, a, d, e);
        $94154706315aabfd$var$Si(c, b, d);
    }
    $94154706315aabfd$var$yc(a, d);
}
function $94154706315aabfd$var$wi(a, b, c) {
    var d = $94154706315aabfd$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($94154706315aabfd$var$Pi(a)) $94154706315aabfd$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($94154706315aabfd$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $94154706315aabfd$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $94154706315aabfd$var$vh(a, b, e, d);
        null !== c && (e = $94154706315aabfd$var$Ri(), $94154706315aabfd$var$ui(c, a, d, e), $94154706315aabfd$var$Si(c, b, d));
    }
    $94154706315aabfd$var$yc(a, d);
}
function $94154706315aabfd$var$Pi(a) {
    var b = a.alternate;
    return a === $94154706315aabfd$var$M || null !== b && b === $94154706315aabfd$var$M;
}
function $94154706315aabfd$var$Qi(a, b) {
    $94154706315aabfd$var$Xh = $94154706315aabfd$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $94154706315aabfd$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $94154706315aabfd$var$Oc(a, c);
    }
}
var $94154706315aabfd$var$ei = {
    readContext: $94154706315aabfd$var$sh,
    useCallback: $94154706315aabfd$var$P,
    useContext: $94154706315aabfd$var$P,
    useEffect: $94154706315aabfd$var$P,
    useImperativeHandle: $94154706315aabfd$var$P,
    useInsertionEffect: $94154706315aabfd$var$P,
    useLayoutEffect: $94154706315aabfd$var$P,
    useMemo: $94154706315aabfd$var$P,
    useReducer: $94154706315aabfd$var$P,
    useRef: $94154706315aabfd$var$P,
    useState: $94154706315aabfd$var$P,
    useDebugValue: $94154706315aabfd$var$P,
    useDeferredValue: $94154706315aabfd$var$P,
    useTransition: $94154706315aabfd$var$P,
    useMutableSource: $94154706315aabfd$var$P,
    useSyncExternalStore: $94154706315aabfd$var$P,
    useId: $94154706315aabfd$var$P,
    unstable_isNewReconciler: !1
}, $94154706315aabfd$var$bi = {
    readContext: $94154706315aabfd$var$sh,
    useCallback: function(a, b) {
        $94154706315aabfd$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $94154706315aabfd$var$sh,
    useEffect: $94154706315aabfd$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $94154706315aabfd$var$Ai(4194308, 4, $94154706315aabfd$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $94154706315aabfd$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $94154706315aabfd$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $94154706315aabfd$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $94154706315aabfd$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $94154706315aabfd$var$Ni.bind(null, $94154706315aabfd$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $94154706315aabfd$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $94154706315aabfd$var$vi,
    useDebugValue: $94154706315aabfd$var$Hi,
    useDeferredValue: function(a) {
        return $94154706315aabfd$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $94154706315aabfd$var$vi(!1), b = a[0];
        a = $94154706315aabfd$var$Li.bind(null, a[1]);
        $94154706315aabfd$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $94154706315aabfd$var$M, e = $94154706315aabfd$var$gi();
        if ($94154706315aabfd$var$J) {
            if (void 0 === c) throw Error($94154706315aabfd$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $94154706315aabfd$var$Q) throw Error($94154706315aabfd$var$p(349));
            0 !== ($94154706315aabfd$var$Vh & 30) || $94154706315aabfd$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $94154706315aabfd$var$Ci($94154706315aabfd$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $94154706315aabfd$var$pi(9, $94154706315aabfd$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $94154706315aabfd$var$gi(), b = $94154706315aabfd$var$Q.identifierPrefix;
        if ($94154706315aabfd$var$J) {
            var c = $94154706315aabfd$var$Gg;
            var d = $94154706315aabfd$var$Fg;
            c = (d & ~(1 << 32 - $94154706315aabfd$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $94154706315aabfd$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $94154706315aabfd$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $94154706315aabfd$var$ci = {
    readContext: $94154706315aabfd$var$sh,
    useCallback: $94154706315aabfd$var$Ii,
    useContext: $94154706315aabfd$var$sh,
    useEffect: $94154706315aabfd$var$ni,
    useImperativeHandle: $94154706315aabfd$var$Gi,
    useInsertionEffect: $94154706315aabfd$var$Di,
    useLayoutEffect: $94154706315aabfd$var$Ei,
    useMemo: $94154706315aabfd$var$Ji,
    useReducer: $94154706315aabfd$var$ji,
    useRef: $94154706315aabfd$var$xi,
    useState: function() {
        return $94154706315aabfd$var$ji($94154706315aabfd$var$ii);
    },
    useDebugValue: $94154706315aabfd$var$Hi,
    useDeferredValue: function(a) {
        var b = $94154706315aabfd$var$hi();
        return $94154706315aabfd$var$Ki(b, $94154706315aabfd$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $94154706315aabfd$var$ji($94154706315aabfd$var$ii)[0], b = $94154706315aabfd$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $94154706315aabfd$var$li,
    useSyncExternalStore: $94154706315aabfd$var$mi,
    useId: $94154706315aabfd$var$Mi,
    unstable_isNewReconciler: !1
}, $94154706315aabfd$var$di = {
    readContext: $94154706315aabfd$var$sh,
    useCallback: $94154706315aabfd$var$Ii,
    useContext: $94154706315aabfd$var$sh,
    useEffect: $94154706315aabfd$var$ni,
    useImperativeHandle: $94154706315aabfd$var$Gi,
    useInsertionEffect: $94154706315aabfd$var$Di,
    useLayoutEffect: $94154706315aabfd$var$Ei,
    useMemo: $94154706315aabfd$var$Ji,
    useReducer: $94154706315aabfd$var$ki,
    useRef: $94154706315aabfd$var$xi,
    useState: function() {
        return $94154706315aabfd$var$ki($94154706315aabfd$var$ii);
    },
    useDebugValue: $94154706315aabfd$var$Hi,
    useDeferredValue: function(a) {
        var b = $94154706315aabfd$var$hi();
        return null === $94154706315aabfd$var$N ? b.memoizedState = a : $94154706315aabfd$var$Ki(b, $94154706315aabfd$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $94154706315aabfd$var$ki($94154706315aabfd$var$ii)[0], b = $94154706315aabfd$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $94154706315aabfd$var$li,
    useSyncExternalStore: $94154706315aabfd$var$mi,
    useId: $94154706315aabfd$var$Mi,
    unstable_isNewReconciler: !1
}, $94154706315aabfd$var$Ti = $fO90s.unstable_now, $94154706315aabfd$var$Ui = 0, $94154706315aabfd$var$Vi = -1, $94154706315aabfd$var$Wi = -1, $94154706315aabfd$var$Xi = -1, $94154706315aabfd$var$Yi = !1, $94154706315aabfd$var$Zi = !1;
function $94154706315aabfd$var$$i(a, b) {
    if (0 <= $94154706315aabfd$var$Wi) {
        var c = $94154706315aabfd$var$Ti() - $94154706315aabfd$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $94154706315aabfd$var$Wi = -1;
    }
}
function $94154706315aabfd$var$aj(a) {
    if (0 <= $94154706315aabfd$var$Vi) {
        var b = $94154706315aabfd$var$Ti() - $94154706315aabfd$var$Vi;
        $94154706315aabfd$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $94154706315aabfd$var$bj(a) {
    if (0 <= $94154706315aabfd$var$Xi) {
        var b = $94154706315aabfd$var$Ti() - $94154706315aabfd$var$Xi;
        $94154706315aabfd$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $94154706315aabfd$var$cj() {
    $94154706315aabfd$var$Vi = $94154706315aabfd$var$Ti();
}
function $94154706315aabfd$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $94154706315aabfd$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $94154706315aabfd$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $94154706315aabfd$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $94154706315aabfd$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $94154706315aabfd$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $94154706315aabfd$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $94154706315aabfd$var$Ri(), e = $94154706315aabfd$var$Oi(a), f = $94154706315aabfd$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $94154706315aabfd$var$Bh(a, f, e);
        null !== b && ($94154706315aabfd$var$ui(b, a, e, d), $94154706315aabfd$var$Ch(b, a, e));
        $94154706315aabfd$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $94154706315aabfd$var$Ri(), e = $94154706315aabfd$var$Oi(a), f = $94154706315aabfd$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $94154706315aabfd$var$Bh(a, f, e);
        null !== b && ($94154706315aabfd$var$ui(b, a, e, d), $94154706315aabfd$var$Ch(b, a, e));
        $94154706315aabfd$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $94154706315aabfd$var$Ri(), d = $94154706315aabfd$var$Oi(a), e = $94154706315aabfd$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $94154706315aabfd$var$Bh(a, e, d);
        null !== b && ($94154706315aabfd$var$ui(b, a, d, c), $94154706315aabfd$var$Ch(b, a, d));
        null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markForceUpdateScheduled && $94154706315aabfd$var$B.markForceUpdateScheduled(a, d);
    }
};
function $94154706315aabfd$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$94154706315aabfd$var$We(c, d) || !$94154706315aabfd$var$We(e, f) : !0;
}
function $94154706315aabfd$var$ij(a, b, c) {
    var d = !1, e = $94154706315aabfd$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $94154706315aabfd$var$sh(f) : (e = $94154706315aabfd$var$mg(b) ? $94154706315aabfd$var$kg : $94154706315aabfd$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $94154706315aabfd$var$lg(a, e) : $94154706315aabfd$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $94154706315aabfd$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $94154706315aabfd$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $94154706315aabfd$var$gj.enqueueReplaceState(b, b.state, null);
}
function $94154706315aabfd$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $94154706315aabfd$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $94154706315aabfd$var$sh(f) : (f = $94154706315aabfd$var$mg(b) ? $94154706315aabfd$var$kg : $94154706315aabfd$var$I.current, e.context = $94154706315aabfd$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($94154706315aabfd$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $94154706315aabfd$var$gj.enqueueReplaceState(e, e.state, null), $94154706315aabfd$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $94154706315aabfd$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $94154706315aabfd$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $94154706315aabfd$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $94154706315aabfd$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $94154706315aabfd$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $94154706315aabfd$var$pj(a, b, c) {
    c = $94154706315aabfd$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $94154706315aabfd$var$qj || ($94154706315aabfd$var$qj = !0, $94154706315aabfd$var$rj = d);
        $94154706315aabfd$var$nj(a, b);
    };
    return c;
}
function $94154706315aabfd$var$sj(a, b, c) {
    c = $94154706315aabfd$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $94154706315aabfd$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $94154706315aabfd$var$nj(a, b);
        "function" !== typeof d && (null === $94154706315aabfd$var$tj ? $94154706315aabfd$var$tj = new Set([
            this
        ]) : $94154706315aabfd$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $94154706315aabfd$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $94154706315aabfd$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $94154706315aabfd$var$vj.bind(null, a, b, c), $94154706315aabfd$var$mc && $94154706315aabfd$var$wj(a, c), b.then(d, d));
}
function $94154706315aabfd$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $94154706315aabfd$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $94154706315aabfd$var$Ah(-1, 1), b.tag = 2, $94154706315aabfd$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $94154706315aabfd$var$zj = $94154706315aabfd$var$va.ReactCurrentOwner, $94154706315aabfd$var$rh = !1;
function $94154706315aabfd$var$Aj(a, b, c, d) {
    b.child = null === a ? $94154706315aabfd$var$ih(b, null, c, d) : $94154706315aabfd$var$hh(b, a.child, c, d);
}
function $94154706315aabfd$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $94154706315aabfd$var$qh(b, e);
    $94154706315aabfd$var$sc(b);
    d = $94154706315aabfd$var$ai(a, b, c, d, f, e);
    c = $94154706315aabfd$var$fi();
    $94154706315aabfd$var$tc();
    if (null !== a && !$94154706315aabfd$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $94154706315aabfd$var$Cj(a, b, e);
    $94154706315aabfd$var$J && c && $94154706315aabfd$var$Jg(b);
    b.flags |= 1;
    $94154706315aabfd$var$Aj(a, b, d, e);
    return b.child;
}
function $94154706315aabfd$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$94154706315aabfd$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $94154706315aabfd$var$Fj(a, b, f, d, e);
        a = $94154706315aabfd$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $94154706315aabfd$var$We;
        if (c(g, d) && a.ref === b.ref) return $94154706315aabfd$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $94154706315aabfd$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $94154706315aabfd$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($94154706315aabfd$var$We(f, d) && a.ref === b.ref) {
            if ($94154706315aabfd$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($94154706315aabfd$var$rh = !0);
            else return b.lanes = a.lanes, $94154706315aabfd$var$Cj(a, b, e);
        }
    }
    return $94154706315aabfd$var$Gj(a, b, c, d, e);
}
function $94154706315aabfd$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $94154706315aabfd$var$H($94154706315aabfd$var$Ij, $94154706315aabfd$var$Jj), $94154706315aabfd$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $94154706315aabfd$var$H($94154706315aabfd$var$Ij, $94154706315aabfd$var$Jj), $94154706315aabfd$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $94154706315aabfd$var$H($94154706315aabfd$var$Ij, $94154706315aabfd$var$Jj);
            $94154706315aabfd$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $94154706315aabfd$var$H($94154706315aabfd$var$Ij, $94154706315aabfd$var$Jj), $94154706315aabfd$var$Jj |= d;
    $94154706315aabfd$var$Aj(a, b, e, c);
    return b.child;
}
function $94154706315aabfd$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $94154706315aabfd$var$Gj(a, b, c, d, e) {
    var f = $94154706315aabfd$var$mg(c) ? $94154706315aabfd$var$kg : $94154706315aabfd$var$I.current;
    f = $94154706315aabfd$var$lg(b, f);
    $94154706315aabfd$var$qh(b, e);
    $94154706315aabfd$var$sc(b);
    c = $94154706315aabfd$var$ai(a, b, c, d, f, e);
    d = $94154706315aabfd$var$fi();
    $94154706315aabfd$var$tc();
    if (null !== a && !$94154706315aabfd$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $94154706315aabfd$var$Cj(a, b, e);
    $94154706315aabfd$var$J && d && $94154706315aabfd$var$Jg(b);
    b.flags |= 1;
    $94154706315aabfd$var$Aj(a, b, c, e);
    return b.child;
}
function $94154706315aabfd$var$Lj(a, b, c, d, e) {
    if ($94154706315aabfd$var$mg(c)) {
        var f = !0;
        $94154706315aabfd$var$qg(b);
    } else f = !1;
    $94154706315aabfd$var$qh(b, e);
    if (null === b.stateNode) $94154706315aabfd$var$Mj(a, b), $94154706315aabfd$var$ij(b, c, d), $94154706315aabfd$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $94154706315aabfd$var$sh(l) : (l = $94154706315aabfd$var$mg(c) ? $94154706315aabfd$var$kg : $94154706315aabfd$var$I.current, l = $94154706315aabfd$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $94154706315aabfd$var$jj(b, g, d, l);
        $94154706315aabfd$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $94154706315aabfd$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $94154706315aabfd$var$jg.current || $94154706315aabfd$var$xh ? ("function" === typeof n && ($94154706315aabfd$var$fj(b, c, n, d), k = b.memoizedState), (h = $94154706315aabfd$var$xh || $94154706315aabfd$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $94154706315aabfd$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $94154706315aabfd$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $94154706315aabfd$var$sh(k) : (k = $94154706315aabfd$var$mg(c) ? $94154706315aabfd$var$kg : $94154706315aabfd$var$I.current, k = $94154706315aabfd$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $94154706315aabfd$var$jj(b, g, d, k);
        $94154706315aabfd$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $94154706315aabfd$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $94154706315aabfd$var$jg.current || $94154706315aabfd$var$xh ? ("function" === typeof z && ($94154706315aabfd$var$fj(b, c, z, d), m = b.memoizedState), (l = $94154706315aabfd$var$xh || $94154706315aabfd$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $94154706315aabfd$var$Nj(a, b, c, d, f, e);
}
function $94154706315aabfd$var$Nj(a, b, c, d, e, f) {
    $94154706315aabfd$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $94154706315aabfd$var$rg(b, c, !1), $94154706315aabfd$var$Cj(a, b, f);
    d = b.stateNode;
    $94154706315aabfd$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $94154706315aabfd$var$Wi = -1;
    } else $94154706315aabfd$var$sc(b), h = d.render(), $94154706315aabfd$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $94154706315aabfd$var$hh(b, a.child, null, f), b.child = $94154706315aabfd$var$hh(b, null, g, f)) : $94154706315aabfd$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $94154706315aabfd$var$rg(b, c, !0);
    return b.child;
}
function $94154706315aabfd$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $94154706315aabfd$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $94154706315aabfd$var$og(a, b.context, !1);
    $94154706315aabfd$var$Mh(a, b.containerInfo);
}
function $94154706315aabfd$var$Rj(a, b, c, d, e) {
    $94154706315aabfd$var$Wg();
    $94154706315aabfd$var$Xg(e);
    b.flags |= 256;
    $94154706315aabfd$var$Aj(a, b, c, d);
    return b.child;
}
var $94154706315aabfd$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $94154706315aabfd$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $94154706315aabfd$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $94154706315aabfd$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $94154706315aabfd$var$H($94154706315aabfd$var$L, e & 1);
    if (null === a) {
        $94154706315aabfd$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $94154706315aabfd$var$Vj(g, d, 0, null), a = $94154706315aabfd$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $94154706315aabfd$var$Tj(c), b.memoizedState = $94154706315aabfd$var$Sj, a) : $94154706315aabfd$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $94154706315aabfd$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $94154706315aabfd$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $94154706315aabfd$var$ch(h, f) : (f = $94154706315aabfd$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $94154706315aabfd$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $94154706315aabfd$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $94154706315aabfd$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $94154706315aabfd$var$Wj(a, b) {
    b = $94154706315aabfd$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $94154706315aabfd$var$Yj(a, b, c, d) {
    null !== d && $94154706315aabfd$var$Xg(d);
    $94154706315aabfd$var$hh(b, a.child, null, c);
    a = $94154706315aabfd$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $94154706315aabfd$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $94154706315aabfd$var$mj(Error($94154706315aabfd$var$p(422))), $94154706315aabfd$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $94154706315aabfd$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $94154706315aabfd$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $94154706315aabfd$var$hh(b, a.child, null, g);
        b.child.memoizedState = $94154706315aabfd$var$Tj(g);
        b.memoizedState = $94154706315aabfd$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $94154706315aabfd$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($94154706315aabfd$var$p(419));
        d = $94154706315aabfd$var$mj(f, d, void 0);
        return $94154706315aabfd$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($94154706315aabfd$var$rh || h) {
        d = $94154706315aabfd$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $94154706315aabfd$var$wh(a, e), $94154706315aabfd$var$ui(d, a, e, -1));
        }
        $94154706315aabfd$var$Zj();
        d = $94154706315aabfd$var$mj(Error($94154706315aabfd$var$p(421)));
        return $94154706315aabfd$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $94154706315aabfd$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $94154706315aabfd$var$Mg = $94154706315aabfd$var$Zf(e.nextSibling);
    $94154706315aabfd$var$Lg = b;
    $94154706315aabfd$var$J = !0;
    $94154706315aabfd$var$Ng = null;
    null !== a && ($94154706315aabfd$var$Cg[$94154706315aabfd$var$Dg++] = $94154706315aabfd$var$Fg, $94154706315aabfd$var$Cg[$94154706315aabfd$var$Dg++] = $94154706315aabfd$var$Gg, $94154706315aabfd$var$Cg[$94154706315aabfd$var$Dg++] = $94154706315aabfd$var$Eg, $94154706315aabfd$var$Fg = a.id, $94154706315aabfd$var$Gg = a.overflow, $94154706315aabfd$var$Eg = b);
    b = $94154706315aabfd$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $94154706315aabfd$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $94154706315aabfd$var$ph(a.return, b, c);
}
function $94154706315aabfd$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $94154706315aabfd$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $94154706315aabfd$var$Aj(a, b, d.children, c);
    d = $94154706315aabfd$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $94154706315aabfd$var$bk(a, c, b);
            else if (19 === a.tag) $94154706315aabfd$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $94154706315aabfd$var$H($94154706315aabfd$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $94154706315aabfd$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $94154706315aabfd$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $94154706315aabfd$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $94154706315aabfd$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $94154706315aabfd$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $94154706315aabfd$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $94154706315aabfd$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $94154706315aabfd$var$Wi = -1;
    $94154706315aabfd$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($94154706315aabfd$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $94154706315aabfd$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $94154706315aabfd$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $94154706315aabfd$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $94154706315aabfd$var$Oj(b);
            $94154706315aabfd$var$Wg();
            break;
        case 5:
            $94154706315aabfd$var$Oh(b);
            break;
        case 1:
            $94154706315aabfd$var$mg(b.type) && $94154706315aabfd$var$qg(b);
            break;
        case 4:
            $94154706315aabfd$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $94154706315aabfd$var$H($94154706315aabfd$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $94154706315aabfd$var$H($94154706315aabfd$var$L, $94154706315aabfd$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $94154706315aabfd$var$Uj(a, b, c);
                $94154706315aabfd$var$H($94154706315aabfd$var$L, $94154706315aabfd$var$L.current & 1);
                a = $94154706315aabfd$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $94154706315aabfd$var$H($94154706315aabfd$var$L, $94154706315aabfd$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $94154706315aabfd$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $94154706315aabfd$var$H($94154706315aabfd$var$L, $94154706315aabfd$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $94154706315aabfd$var$Hj(a, b, c);
    }
    return $94154706315aabfd$var$Cj(a, b, c);
}
var $94154706315aabfd$var$fk, $94154706315aabfd$var$gk, $94154706315aabfd$var$hk, $94154706315aabfd$var$ik;
$94154706315aabfd$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$94154706315aabfd$var$gk = function() {};
$94154706315aabfd$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $94154706315aabfd$var$Lh($94154706315aabfd$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $94154706315aabfd$var$Ya(a, e);
                d = $94154706315aabfd$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $94154706315aabfd$var$u({}, e, {
                    value: void 0
                });
                d = $94154706315aabfd$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $94154706315aabfd$var$fb(a, e);
                d = $94154706315aabfd$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $94154706315aabfd$var$Pf);
        }
        $94154706315aabfd$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($94154706315aabfd$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($94154706315aabfd$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $94154706315aabfd$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$94154706315aabfd$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $94154706315aabfd$var$jk(a, b) {
    if (!$94154706315aabfd$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $94154706315aabfd$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $94154706315aabfd$var$kk(a, b, c) {
    var d = b.pendingProps;
    $94154706315aabfd$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $94154706315aabfd$var$S(b), null;
        case 1:
            return $94154706315aabfd$var$mg(b.type) && $94154706315aabfd$var$ng(), $94154706315aabfd$var$S(b), null;
        case 3:
            d = b.stateNode;
            $94154706315aabfd$var$Nh();
            $94154706315aabfd$var$G($94154706315aabfd$var$jg);
            $94154706315aabfd$var$G($94154706315aabfd$var$I);
            $94154706315aabfd$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $94154706315aabfd$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $94154706315aabfd$var$Ng && ($94154706315aabfd$var$lk($94154706315aabfd$var$Ng), $94154706315aabfd$var$Ng = null));
            $94154706315aabfd$var$gk(a, b);
            $94154706315aabfd$var$S(b);
            return null;
        case 5:
            $94154706315aabfd$var$Ph(b);
            var e = $94154706315aabfd$var$Lh($94154706315aabfd$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $94154706315aabfd$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($94154706315aabfd$var$p(166));
                    $94154706315aabfd$var$S(b);
                    return null;
                }
                a = $94154706315aabfd$var$Lh($94154706315aabfd$var$Ih.current);
                if ($94154706315aabfd$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$94154706315aabfd$var$bg] = b;
                    d[$94154706315aabfd$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $94154706315aabfd$var$F("cancel", d);
                            $94154706315aabfd$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $94154706315aabfd$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $94154706315aabfd$var$zf.length; e++)$94154706315aabfd$var$F($94154706315aabfd$var$zf[e], d);
                            break;
                        case "source":
                            $94154706315aabfd$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $94154706315aabfd$var$F("error", d);
                            $94154706315aabfd$var$F("load", d);
                            break;
                        case "details":
                            $94154706315aabfd$var$F("toggle", d);
                            break;
                        case "input":
                            $94154706315aabfd$var$Za(d, c);
                            $94154706315aabfd$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $94154706315aabfd$var$F("invalid", d);
                            break;
                        case "textarea":
                            $94154706315aabfd$var$gb(d, c), $94154706315aabfd$var$F("invalid", d);
                    }
                    $94154706315aabfd$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $94154706315aabfd$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $94154706315aabfd$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $94154706315aabfd$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $94154706315aabfd$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $94154706315aabfd$var$Va(d);
                            $94154706315aabfd$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $94154706315aabfd$var$Va(d);
                            $94154706315aabfd$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $94154706315aabfd$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $94154706315aabfd$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$94154706315aabfd$var$bg] = b;
                    a[$94154706315aabfd$var$cg] = d;
                    $94154706315aabfd$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $94154706315aabfd$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $94154706315aabfd$var$F("cancel", a);
                                $94154706315aabfd$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $94154706315aabfd$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $94154706315aabfd$var$zf.length; e++)$94154706315aabfd$var$F($94154706315aabfd$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $94154706315aabfd$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $94154706315aabfd$var$F("error", a);
                                $94154706315aabfd$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $94154706315aabfd$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $94154706315aabfd$var$Za(a, d);
                                e = $94154706315aabfd$var$Ya(a, d);
                                $94154706315aabfd$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $94154706315aabfd$var$u({}, d, {
                                    value: void 0
                                });
                                $94154706315aabfd$var$F("invalid", a);
                                break;
                            case "textarea":
                                $94154706315aabfd$var$gb(a, d);
                                e = $94154706315aabfd$var$fb(a, d);
                                $94154706315aabfd$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $94154706315aabfd$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $94154706315aabfd$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $94154706315aabfd$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $94154706315aabfd$var$ob(a, k) : "number" === typeof k && $94154706315aabfd$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($94154706315aabfd$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $94154706315aabfd$var$F("scroll", a) : null != k && $94154706315aabfd$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $94154706315aabfd$var$Va(a);
                                $94154706315aabfd$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $94154706315aabfd$var$Va(a);
                                $94154706315aabfd$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $94154706315aabfd$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $94154706315aabfd$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $94154706315aabfd$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $94154706315aabfd$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $94154706315aabfd$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $94154706315aabfd$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($94154706315aabfd$var$p(166));
                a = $94154706315aabfd$var$Lh($94154706315aabfd$var$Kh.current);
                $94154706315aabfd$var$Lh($94154706315aabfd$var$Ih.current);
                if ($94154706315aabfd$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$94154706315aabfd$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $94154706315aabfd$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $94154706315aabfd$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $94154706315aabfd$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$94154706315aabfd$var$bg] = b, b.stateNode = d;
            }
            $94154706315aabfd$var$S(b);
            return null;
        case 13:
            $94154706315aabfd$var$G($94154706315aabfd$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($94154706315aabfd$var$J && null !== $94154706315aabfd$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $94154706315aabfd$var$Vg(), $94154706315aabfd$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $94154706315aabfd$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($94154706315aabfd$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($94154706315aabfd$var$p(317));
                        f[$94154706315aabfd$var$bg] = b;
                        $94154706315aabfd$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $94154706315aabfd$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $94154706315aabfd$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $94154706315aabfd$var$Ng && ($94154706315aabfd$var$lk($94154706315aabfd$var$Ng), $94154706315aabfd$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $94154706315aabfd$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($94154706315aabfd$var$L.current & 1) ? 0 === $94154706315aabfd$var$T && ($94154706315aabfd$var$T = 3) : $94154706315aabfd$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $94154706315aabfd$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $94154706315aabfd$var$Nh(), $94154706315aabfd$var$gk(a, b), null === a && $94154706315aabfd$var$Gf(b.stateNode.containerInfo), $94154706315aabfd$var$S(b), null;
        case 10:
            return $94154706315aabfd$var$oh(b.type._context), $94154706315aabfd$var$S(b), null;
        case 17:
            return $94154706315aabfd$var$mg(b.type) && $94154706315aabfd$var$ng(), $94154706315aabfd$var$S(b), null;
        case 19:
            $94154706315aabfd$var$G($94154706315aabfd$var$L);
            f = b.memoizedState;
            if (null === f) return $94154706315aabfd$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $94154706315aabfd$var$jk(f, !1);
                else {
                    if (0 !== $94154706315aabfd$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $94154706315aabfd$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $94154706315aabfd$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $94154706315aabfd$var$H($94154706315aabfd$var$L, $94154706315aabfd$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $94154706315aabfd$var$A() > $94154706315aabfd$var$mk && (b.flags |= 128, d = !0, $94154706315aabfd$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $94154706315aabfd$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $94154706315aabfd$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$94154706315aabfd$var$J) return $94154706315aabfd$var$S(b), null;
                    } else 2 * $94154706315aabfd$var$A() - f.renderingStartTime > $94154706315aabfd$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $94154706315aabfd$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $94154706315aabfd$var$A(), b.sibling = null, a = $94154706315aabfd$var$L.current, $94154706315aabfd$var$H($94154706315aabfd$var$L, d ? a & 1 | 2 : a & 1), b;
            $94154706315aabfd$var$S(b);
            return null;
        case 22:
        case 23:
            return $94154706315aabfd$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($94154706315aabfd$var$Jj & 1073741824) && ($94154706315aabfd$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $94154706315aabfd$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($94154706315aabfd$var$p(156, b.tag));
}
function $94154706315aabfd$var$ok(a, b) {
    $94154706315aabfd$var$Kg(b);
    switch(b.tag){
        case 1:
            return $94154706315aabfd$var$mg(b.type) && $94154706315aabfd$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $94154706315aabfd$var$dj(b), b) : null;
        case 3:
            return $94154706315aabfd$var$Nh(), $94154706315aabfd$var$G($94154706315aabfd$var$jg), $94154706315aabfd$var$G($94154706315aabfd$var$I), $94154706315aabfd$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $94154706315aabfd$var$Ph(b), null;
        case 13:
            $94154706315aabfd$var$G($94154706315aabfd$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($94154706315aabfd$var$p(340));
                $94154706315aabfd$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $94154706315aabfd$var$dj(b), b) : null;
        case 19:
            return $94154706315aabfd$var$G($94154706315aabfd$var$L), null;
        case 4:
            return $94154706315aabfd$var$Nh(), null;
        case 10:
            return $94154706315aabfd$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $94154706315aabfd$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $94154706315aabfd$var$pk = !1, $94154706315aabfd$var$qk = !1, $94154706315aabfd$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $94154706315aabfd$var$U = null, $94154706315aabfd$var$sk = null, $94154706315aabfd$var$tk = null;
function $94154706315aabfd$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $94154706315aabfd$var$cj(), b.componentWillUnmount();
    } finally{
        $94154706315aabfd$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $94154706315aabfd$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $94154706315aabfd$var$cj(), c(null);
            } finally{
                $94154706315aabfd$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $94154706315aabfd$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $94154706315aabfd$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $94154706315aabfd$var$W(a, b, d);
    }
}
var $94154706315aabfd$var$xk = !1;
function $94154706315aabfd$var$yk(a, b) {
    $94154706315aabfd$var$Qf = $94154706315aabfd$var$rd;
    a = $94154706315aabfd$var$$e();
    if ($94154706315aabfd$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $94154706315aabfd$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $94154706315aabfd$var$rd = !1;
    for($94154706315aabfd$var$U = b; null !== $94154706315aabfd$var$U;)if (b = $94154706315aabfd$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $94154706315aabfd$var$U = a;
    else for(; null !== $94154706315aabfd$var$U;){
        b = $94154706315aabfd$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $94154706315aabfd$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($94154706315aabfd$var$p(163));
            }
        } catch (D) {
            $94154706315aabfd$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $94154706315aabfd$var$U = a;
            break;
        }
        $94154706315aabfd$var$U = b.return;
    }
    m = $94154706315aabfd$var$xk;
    $94154706315aabfd$var$xk = !1;
    return m;
}
function $94154706315aabfd$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentPassiveEffectUnmountStarted && $94154706315aabfd$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $94154706315aabfd$var$uc(b), $94154706315aabfd$var$wk(b, c, f), 0 !== (a & 8) ? null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentPassiveEffectUnmountStopped && $94154706315aabfd$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $94154706315aabfd$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $94154706315aabfd$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentPassiveEffectMountStarted && $94154706315aabfd$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentLayoutEffectMountStarted && $94154706315aabfd$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentPassiveEffectMountStopped && $94154706315aabfd$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentLayoutEffectMountStopped && $94154706315aabfd$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $94154706315aabfd$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $94154706315aabfd$var$cj(), b(c);
            } finally{
                $94154706315aabfd$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $94154706315aabfd$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $94154706315aabfd$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$94154706315aabfd$var$bg], delete b[$94154706315aabfd$var$cg], delete b[$94154706315aabfd$var$Cf], delete b[$94154706315aabfd$var$dg], delete b[$94154706315aabfd$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $94154706315aabfd$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $94154706315aabfd$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $94154706315aabfd$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $94154706315aabfd$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $94154706315aabfd$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($94154706315aabfd$var$Fk(a, b, c), a = a.sibling; null !== a;)$94154706315aabfd$var$Fk(a, b, c), a = a.sibling;
}
function $94154706315aabfd$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($94154706315aabfd$var$Gk(a, b, c), a = a.sibling; null !== a;)$94154706315aabfd$var$Gk(a, b, c), a = a.sibling;
}
var $94154706315aabfd$var$X = null, $94154706315aabfd$var$Hk = !1;
function $94154706315aabfd$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$94154706315aabfd$var$Jk(a, b, c), c = c.sibling;
}
function $94154706315aabfd$var$Jk(a, b, c) {
    if ($94154706315aabfd$var$lc && "function" === typeof $94154706315aabfd$var$lc.onCommitFiberUnmount) try {
        $94154706315aabfd$var$lc.onCommitFiberUnmount($94154706315aabfd$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $94154706315aabfd$var$qk || $94154706315aabfd$var$vk(c, b);
        case 6:
            var d = $94154706315aabfd$var$X, e = $94154706315aabfd$var$Hk;
            $94154706315aabfd$var$X = null;
            $94154706315aabfd$var$Ik(a, b, c);
            $94154706315aabfd$var$X = d;
            $94154706315aabfd$var$Hk = e;
            null !== $94154706315aabfd$var$X && ($94154706315aabfd$var$Hk ? (a = $94154706315aabfd$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $94154706315aabfd$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $94154706315aabfd$var$X && ($94154706315aabfd$var$Hk ? (a = $94154706315aabfd$var$X, c = c.stateNode, 8 === a.nodeType ? $94154706315aabfd$var$Yf(a.parentNode, c) : 1 === a.nodeType && $94154706315aabfd$var$Yf(a, c), $94154706315aabfd$var$pd(a)) : $94154706315aabfd$var$Yf($94154706315aabfd$var$X, c.stateNode));
            break;
        case 4:
            d = $94154706315aabfd$var$X;
            e = $94154706315aabfd$var$Hk;
            $94154706315aabfd$var$X = c.stateNode.containerInfo;
            $94154706315aabfd$var$Hk = !0;
            $94154706315aabfd$var$Ik(a, b, c);
            $94154706315aabfd$var$X = d;
            $94154706315aabfd$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$94154706315aabfd$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $94154706315aabfd$var$wk(c, b, g) : 0 !== (f & 4) && ($94154706315aabfd$var$uc(c), c.mode & 2 ? ($94154706315aabfd$var$cj(), $94154706315aabfd$var$wk(c, b, g), $94154706315aabfd$var$aj(c)) : $94154706315aabfd$var$wk(c, b, g), $94154706315aabfd$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $94154706315aabfd$var$Ik(a, b, c);
            break;
        case 1:
            if (!$94154706315aabfd$var$qk && ($94154706315aabfd$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $94154706315aabfd$var$uk(c, d);
            } catch (h) {
                $94154706315aabfd$var$W(c, b, h);
            }
            $94154706315aabfd$var$Ik(a, b, c);
            break;
        case 21:
            $94154706315aabfd$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($94154706315aabfd$var$qk = (d = $94154706315aabfd$var$qk) || null !== c.memoizedState, $94154706315aabfd$var$Ik(a, b, c), $94154706315aabfd$var$qk = d) : $94154706315aabfd$var$Ik(a, b, c);
            break;
        default:
            $94154706315aabfd$var$Ik(a, b, c);
    }
}
function $94154706315aabfd$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $94154706315aabfd$var$rk);
        b.forEach(function(b) {
            var d = $94154706315aabfd$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($94154706315aabfd$var$mc) {
                    if (null !== $94154706315aabfd$var$sk && null !== $94154706315aabfd$var$tk) $94154706315aabfd$var$wj($94154706315aabfd$var$tk, $94154706315aabfd$var$sk);
                    else throw Error($94154706315aabfd$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $94154706315aabfd$var$Mk(a, b, c) {
    $94154706315aabfd$var$sk = c;
    $94154706315aabfd$var$tk = a;
    $94154706315aabfd$var$Nk(b, a);
    $94154706315aabfd$var$tk = $94154706315aabfd$var$sk = null;
}
function $94154706315aabfd$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $94154706315aabfd$var$X = h.stateNode;
                        $94154706315aabfd$var$Hk = !1;
                        break a;
                    case 3:
                        $94154706315aabfd$var$X = h.stateNode.containerInfo;
                        $94154706315aabfd$var$Hk = !0;
                        break a;
                    case 4:
                        $94154706315aabfd$var$X = h.stateNode.containerInfo;
                        $94154706315aabfd$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $94154706315aabfd$var$X) throw Error($94154706315aabfd$var$p(160));
            $94154706315aabfd$var$Jk(f, g, e);
            $94154706315aabfd$var$X = null;
            $94154706315aabfd$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $94154706315aabfd$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$94154706315aabfd$var$Nk(b, a), b = b.sibling;
}
function $94154706315aabfd$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $94154706315aabfd$var$Ok(b, a);
            $94154706315aabfd$var$Pk(a);
            if (d & 4) {
                try {
                    $94154706315aabfd$var$zk(3, a, a.return), $94154706315aabfd$var$Ak(3, a);
                } catch (m) {
                    $94154706315aabfd$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $94154706315aabfd$var$cj(), $94154706315aabfd$var$zk(5, a, a.return);
                    } catch (m) {
                        $94154706315aabfd$var$W(a, a.return, m);
                    }
                    $94154706315aabfd$var$aj(a);
                } else try {
                    $94154706315aabfd$var$zk(5, a, a.return);
                } catch (m) {
                    $94154706315aabfd$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $94154706315aabfd$var$Ok(b, a);
            $94154706315aabfd$var$Pk(a);
            d & 512 && null !== c && $94154706315aabfd$var$vk(c, c.return);
            break;
        case 5:
            $94154706315aabfd$var$Ok(b, a);
            $94154706315aabfd$var$Pk(a);
            d & 512 && null !== c && $94154706315aabfd$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $94154706315aabfd$var$ob(e, "");
                } catch (m) {
                    $94154706315aabfd$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $94154706315aabfd$var$$a(e, f);
                    $94154706315aabfd$var$vb(h, g);
                    var l = $94154706315aabfd$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $94154706315aabfd$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $94154706315aabfd$var$nb(e, q) : "children" === n ? $94154706315aabfd$var$ob(e, q) : $94154706315aabfd$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $94154706315aabfd$var$ab(e, f);
                            break;
                        case "textarea":
                            $94154706315aabfd$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $94154706315aabfd$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $94154706315aabfd$var$eb(e, !!f.multiple, f.defaultValue, !0) : $94154706315aabfd$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$94154706315aabfd$var$cg] = f;
                } catch (m) {
                    $94154706315aabfd$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $94154706315aabfd$var$Ok(b, a);
            $94154706315aabfd$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($94154706315aabfd$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $94154706315aabfd$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $94154706315aabfd$var$Ok(b, a);
            $94154706315aabfd$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $94154706315aabfd$var$pd(b.containerInfo);
            } catch (m) {
                $94154706315aabfd$var$W(a, a.return, m);
            }
            break;
        case 4:
            $94154706315aabfd$var$Ok(b, a);
            $94154706315aabfd$var$Pk(a);
            break;
        case 13:
            $94154706315aabfd$var$Ok(b, a);
            $94154706315aabfd$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($94154706315aabfd$var$Qk = $94154706315aabfd$var$A()));
            d & 4 && $94154706315aabfd$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($94154706315aabfd$var$qk = (l = $94154706315aabfd$var$qk) || n, $94154706315aabfd$var$Ok(b, a), $94154706315aabfd$var$qk = l) : $94154706315aabfd$var$Ok(b, a);
            $94154706315aabfd$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($94154706315aabfd$var$U = a, n = a.child; null !== n;){
                    for(q = $94154706315aabfd$var$U = n; null !== $94154706315aabfd$var$U;){
                        r = $94154706315aabfd$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $94154706315aabfd$var$cj(), $94154706315aabfd$var$zk(4, r, r.return);
                                } finally{
                                    $94154706315aabfd$var$aj(r);
                                }
                                else $94154706315aabfd$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $94154706315aabfd$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $94154706315aabfd$var$uk(c, d);
                                    } catch (m) {
                                        $94154706315aabfd$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $94154706315aabfd$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $94154706315aabfd$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $94154706315aabfd$var$U = z) : $94154706315aabfd$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $94154706315aabfd$var$rb("display", g));
                            } catch (m) {
                                $94154706315aabfd$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $94154706315aabfd$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $94154706315aabfd$var$Ok(b, a);
            $94154706315aabfd$var$Pk(a);
            d & 4 && $94154706315aabfd$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $94154706315aabfd$var$Ok(b, a), $94154706315aabfd$var$Pk(a);
    }
}
function $94154706315aabfd$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($94154706315aabfd$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($94154706315aabfd$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($94154706315aabfd$var$ob(e, ""), d.flags &= -33);
                    var f = $94154706315aabfd$var$Ek(a);
                    $94154706315aabfd$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $94154706315aabfd$var$Ek(a);
                    $94154706315aabfd$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($94154706315aabfd$var$p(161));
            }
        } catch (k) {
            $94154706315aabfd$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $94154706315aabfd$var$Sk(a, b, c) {
    $94154706315aabfd$var$sk = c;
    $94154706315aabfd$var$tk = b;
    $94154706315aabfd$var$U = a;
    $94154706315aabfd$var$Tk(a, b, c);
    $94154706315aabfd$var$tk = $94154706315aabfd$var$sk = null;
}
function $94154706315aabfd$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $94154706315aabfd$var$U;){
        var e = $94154706315aabfd$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $94154706315aabfd$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $94154706315aabfd$var$qk;
                h = $94154706315aabfd$var$pk;
                var l = $94154706315aabfd$var$qk;
                $94154706315aabfd$var$pk = g;
                if (($94154706315aabfd$var$qk = k) && !l) for($94154706315aabfd$var$U = e; null !== $94154706315aabfd$var$U;)g = $94154706315aabfd$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $94154706315aabfd$var$Uk(e) : null !== k ? (k.return = g, $94154706315aabfd$var$U = k) : $94154706315aabfd$var$Uk(e);
                for(; null !== f;)$94154706315aabfd$var$U = f, $94154706315aabfd$var$Tk(f, b, c), f = f.sibling;
                $94154706315aabfd$var$U = e;
                $94154706315aabfd$var$pk = h;
                $94154706315aabfd$var$qk = l;
            }
            $94154706315aabfd$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $94154706315aabfd$var$U = f) : $94154706315aabfd$var$Vk(a, b, c);
    }
}
function $94154706315aabfd$var$Vk(a) {
    for(; null !== $94154706315aabfd$var$U;){
        var b = $94154706315aabfd$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$94154706315aabfd$var$qk) {
                            if (b.mode & 2) try {
                                $94154706315aabfd$var$cj(), $94154706315aabfd$var$Ak(5, b);
                            } finally{
                                $94154706315aabfd$var$aj(b);
                            }
                            else $94154706315aabfd$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$94154706315aabfd$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $94154706315aabfd$var$cj(), d.componentDidMount();
                                } finally{
                                    $94154706315aabfd$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $94154706315aabfd$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $94154706315aabfd$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $94154706315aabfd$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $94154706315aabfd$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $94154706315aabfd$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $94154706315aabfd$var$Ui;
                        c = null === c ? "mount" : "update";
                        $94154706315aabfd$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $94154706315aabfd$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $94154706315aabfd$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($94154706315aabfd$var$p(163));
                }
                $94154706315aabfd$var$qk || b.flags & 512 && $94154706315aabfd$var$Bk(b);
            } catch (v) {
                $94154706315aabfd$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $94154706315aabfd$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $94154706315aabfd$var$U = k;
            break;
        }
        $94154706315aabfd$var$U = b.return;
    }
}
function $94154706315aabfd$var$Rk(a) {
    for(; null !== $94154706315aabfd$var$U;){
        var b = $94154706315aabfd$var$U;
        if (b === a) {
            $94154706315aabfd$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $94154706315aabfd$var$U = c;
            break;
        }
        $94154706315aabfd$var$U = b.return;
    }
}
function $94154706315aabfd$var$Uk(a) {
    for(; null !== $94154706315aabfd$var$U;){
        var b = $94154706315aabfd$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $94154706315aabfd$var$cj();
                        var c = b.return;
                        try {
                            $94154706315aabfd$var$Ak(4, b);
                        } catch (l) {
                            $94154706315aabfd$var$W(b, c, l);
                        }
                    } finally{
                        $94154706315aabfd$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $94154706315aabfd$var$Ak(4, b);
                        } catch (l) {
                            $94154706315aabfd$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $94154706315aabfd$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $94154706315aabfd$var$Bk(b);
                    } catch (l) {
                        $94154706315aabfd$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $94154706315aabfd$var$Bk(b);
                    } catch (l) {
                        $94154706315aabfd$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $94154706315aabfd$var$W(b, b.return, l);
        }
        if (b === a) {
            $94154706315aabfd$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $94154706315aabfd$var$U = k;
            break;
        }
        $94154706315aabfd$var$U = b.return;
    }
}
var $94154706315aabfd$var$Xk = Math.ceil, $94154706315aabfd$var$Yk = $94154706315aabfd$var$va.ReactCurrentDispatcher, $94154706315aabfd$var$Zk = $94154706315aabfd$var$va.ReactCurrentOwner, $94154706315aabfd$var$$k = $94154706315aabfd$var$va.ReactCurrentBatchConfig, $94154706315aabfd$var$K = 0, $94154706315aabfd$var$Q = null, $94154706315aabfd$var$Y = null, $94154706315aabfd$var$Z = 0, $94154706315aabfd$var$Jj = 0, $94154706315aabfd$var$Ij = $94154706315aabfd$var$hg(0), $94154706315aabfd$var$T = 0, $94154706315aabfd$var$al = null, $94154706315aabfd$var$Fh = 0, $94154706315aabfd$var$bl = 0, $94154706315aabfd$var$cl = 0, $94154706315aabfd$var$dl = null, $94154706315aabfd$var$el = null, $94154706315aabfd$var$Qk = 0, $94154706315aabfd$var$mk = Infinity, $94154706315aabfd$var$fl = null, $94154706315aabfd$var$qj = !1, $94154706315aabfd$var$rj = null, $94154706315aabfd$var$tj = null, $94154706315aabfd$var$gl = !1, $94154706315aabfd$var$hl = null, $94154706315aabfd$var$il = 0, $94154706315aabfd$var$jl = [], $94154706315aabfd$var$kl = 0, $94154706315aabfd$var$ll = null, $94154706315aabfd$var$ml = -1, $94154706315aabfd$var$nl = 0;
function $94154706315aabfd$var$Ri() {
    return 0 !== ($94154706315aabfd$var$K & 6) ? $94154706315aabfd$var$A() : -1 !== $94154706315aabfd$var$ml ? $94154706315aabfd$var$ml : $94154706315aabfd$var$ml = $94154706315aabfd$var$A();
}
function $94154706315aabfd$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($94154706315aabfd$var$K & 2) && 0 !== $94154706315aabfd$var$Z) return $94154706315aabfd$var$Z & -$94154706315aabfd$var$Z;
    if (null !== $94154706315aabfd$var$Yg.transition) return 0 === $94154706315aabfd$var$nl && ($94154706315aabfd$var$nl = $94154706315aabfd$var$Kc()), $94154706315aabfd$var$nl;
    a = $94154706315aabfd$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $94154706315aabfd$var$xd(a.type);
    return a;
}
function $94154706315aabfd$var$ui(a, b, c, d) {
    if (50 < $94154706315aabfd$var$kl) throw $94154706315aabfd$var$kl = 0, $94154706315aabfd$var$ll = null, Error($94154706315aabfd$var$p(185));
    $94154706315aabfd$var$Mc(a, c, d);
    if (0 === ($94154706315aabfd$var$K & 2) || a !== $94154706315aabfd$var$Q) $94154706315aabfd$var$mc && $94154706315aabfd$var$Pc(a, b, c), a === $94154706315aabfd$var$Q && (0 === ($94154706315aabfd$var$K & 2) && ($94154706315aabfd$var$bl |= c), 4 === $94154706315aabfd$var$T && $94154706315aabfd$var$ol(a, $94154706315aabfd$var$Z)), $94154706315aabfd$var$pl(a, d), 1 === c && 0 === $94154706315aabfd$var$K && 0 === (b.mode & 1) && ($94154706315aabfd$var$mk = $94154706315aabfd$var$A() + 500, $94154706315aabfd$var$tg && $94154706315aabfd$var$xg());
}
function $94154706315aabfd$var$pl(a, b) {
    var c = a.callbackNode;
    $94154706315aabfd$var$Ic(a, b);
    var d = $94154706315aabfd$var$Gc(a, a === $94154706315aabfd$var$Q ? $94154706315aabfd$var$Z : 0);
    if (0 === d) null !== c && $94154706315aabfd$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $94154706315aabfd$var$bc(c);
        if (1 === b) 0 === a.tag ? $94154706315aabfd$var$wg($94154706315aabfd$var$ql.bind(null, a)) : $94154706315aabfd$var$vg($94154706315aabfd$var$ql.bind(null, a)), $94154706315aabfd$var$Xf(function() {
            0 === ($94154706315aabfd$var$K & 6) && $94154706315aabfd$var$xg();
        }), c = null;
        else {
            switch($94154706315aabfd$var$Rc(d)){
                case 1:
                    c = $94154706315aabfd$var$fc;
                    break;
                case 4:
                    c = $94154706315aabfd$var$gc;
                    break;
                case 16:
                    c = $94154706315aabfd$var$hc;
                    break;
                case 536870912:
                    c = $94154706315aabfd$var$jc;
                    break;
                default:
                    c = $94154706315aabfd$var$hc;
            }
            c = $94154706315aabfd$var$rl(c, $94154706315aabfd$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $94154706315aabfd$var$sl(a, b) {
    $94154706315aabfd$var$Zi = $94154706315aabfd$var$Yi = !1;
    $94154706315aabfd$var$ml = -1;
    $94154706315aabfd$var$nl = 0;
    if (0 !== ($94154706315aabfd$var$K & 6)) throw Error($94154706315aabfd$var$p(327));
    var c = a.callbackNode;
    if ($94154706315aabfd$var$tl() && a.callbackNode !== c) return null;
    var d = $94154706315aabfd$var$Gc(a, a === $94154706315aabfd$var$Q ? $94154706315aabfd$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $94154706315aabfd$var$ul(a, d);
    else {
        b = d;
        var e = $94154706315aabfd$var$K;
        $94154706315aabfd$var$K |= 2;
        var f = $94154706315aabfd$var$vl();
        if ($94154706315aabfd$var$Q !== a || $94154706315aabfd$var$Z !== b) {
            if ($94154706315aabfd$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($94154706315aabfd$var$wj(a, $94154706315aabfd$var$Z), g.clear());
                $94154706315aabfd$var$Qc(a, b);
            }
            $94154706315aabfd$var$fl = null;
            $94154706315aabfd$var$mk = $94154706315aabfd$var$A() + 500;
            $94154706315aabfd$var$wl(a, b);
        }
        $94154706315aabfd$var$wc(b);
        for(;;)try {
            $94154706315aabfd$var$xl();
            break;
        } catch (h) {
            $94154706315aabfd$var$yl(a, h);
        }
        $94154706315aabfd$var$nh();
        $94154706315aabfd$var$Yk.current = f;
        $94154706315aabfd$var$K = e;
        null !== $94154706315aabfd$var$Y ? (null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markRenderYielded && $94154706315aabfd$var$B.markRenderYielded(), b = 0) : ($94154706315aabfd$var$xc(), $94154706315aabfd$var$Q = null, $94154706315aabfd$var$Z = 0, b = $94154706315aabfd$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $94154706315aabfd$var$Jc(a), 0 !== e && (d = e, b = $94154706315aabfd$var$zl(a, e)));
        if (1 === b) throw c = $94154706315aabfd$var$al, $94154706315aabfd$var$wl(a, 0), $94154706315aabfd$var$ol(a, d), $94154706315aabfd$var$pl(a, $94154706315aabfd$var$A()), c;
        if (6 === b) $94154706315aabfd$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$94154706315aabfd$var$Al(e) && (b = $94154706315aabfd$var$ul(a, d), 2 === b && (f = $94154706315aabfd$var$Jc(a), 0 !== f && (d = f, b = $94154706315aabfd$var$zl(a, f))), 1 === b)) throw c = $94154706315aabfd$var$al, $94154706315aabfd$var$wl(a, 0), $94154706315aabfd$var$ol(a, d), $94154706315aabfd$var$pl(a, $94154706315aabfd$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($94154706315aabfd$var$p(345));
                case 2:
                    $94154706315aabfd$var$Cl(a, $94154706315aabfd$var$el, $94154706315aabfd$var$fl);
                    break;
                case 3:
                    $94154706315aabfd$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $94154706315aabfd$var$Qk + 500 - $94154706315aabfd$var$A(), 10 < b)) {
                        if (0 !== $94154706315aabfd$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $94154706315aabfd$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $94154706315aabfd$var$Tf($94154706315aabfd$var$Cl.bind(null, a, $94154706315aabfd$var$el, $94154706315aabfd$var$fl), b);
                        break;
                    }
                    $94154706315aabfd$var$Cl(a, $94154706315aabfd$var$el, $94154706315aabfd$var$fl);
                    break;
                case 4:
                    $94154706315aabfd$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $94154706315aabfd$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $94154706315aabfd$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $94154706315aabfd$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $94154706315aabfd$var$Tf($94154706315aabfd$var$Cl.bind(null, a, $94154706315aabfd$var$el, $94154706315aabfd$var$fl), d);
                        break;
                    }
                    $94154706315aabfd$var$Cl(a, $94154706315aabfd$var$el, $94154706315aabfd$var$fl);
                    break;
                case 5:
                    $94154706315aabfd$var$Cl(a, $94154706315aabfd$var$el, $94154706315aabfd$var$fl);
                    break;
                default:
                    throw Error($94154706315aabfd$var$p(329));
            }
        }
    }
    $94154706315aabfd$var$pl(a, $94154706315aabfd$var$A());
    return a.callbackNode === c ? $94154706315aabfd$var$sl.bind(null, a) : null;
}
function $94154706315aabfd$var$zl(a, b) {
    var c = $94154706315aabfd$var$dl;
    a.current.memoizedState.isDehydrated && ($94154706315aabfd$var$wl(a, b).flags |= 256);
    a = $94154706315aabfd$var$ul(a, b);
    2 !== a && (b = $94154706315aabfd$var$el, $94154706315aabfd$var$el = c, null !== b && $94154706315aabfd$var$lk(b));
    return a;
}
function $94154706315aabfd$var$lk(a) {
    null === $94154706315aabfd$var$el ? $94154706315aabfd$var$el = a : $94154706315aabfd$var$el.push.apply($94154706315aabfd$var$el, a);
}
function $94154706315aabfd$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$94154706315aabfd$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $94154706315aabfd$var$ol(a, b) {
    b &= ~$94154706315aabfd$var$cl;
    b &= ~$94154706315aabfd$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $94154706315aabfd$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $94154706315aabfd$var$ql(a) {
    $94154706315aabfd$var$Yi = $94154706315aabfd$var$Zi;
    $94154706315aabfd$var$Zi = !1;
    if (0 !== ($94154706315aabfd$var$K & 6)) throw Error($94154706315aabfd$var$p(327));
    $94154706315aabfd$var$tl();
    var b = $94154706315aabfd$var$Gc(a, 0);
    if (0 === (b & 1)) return $94154706315aabfd$var$pl(a, $94154706315aabfd$var$A()), null;
    var c = $94154706315aabfd$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $94154706315aabfd$var$Jc(a);
        0 !== d && (b = d, c = $94154706315aabfd$var$zl(a, d));
    }
    if (1 === c) throw c = $94154706315aabfd$var$al, $94154706315aabfd$var$wl(a, 0), $94154706315aabfd$var$ol(a, b), $94154706315aabfd$var$pl(a, $94154706315aabfd$var$A()), c;
    if (6 === c) throw Error($94154706315aabfd$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $94154706315aabfd$var$Cl(a, $94154706315aabfd$var$el, $94154706315aabfd$var$fl);
    $94154706315aabfd$var$pl(a, $94154706315aabfd$var$A());
    return null;
}
function $94154706315aabfd$var$Dl(a, b) {
    var c = $94154706315aabfd$var$K;
    $94154706315aabfd$var$K |= 1;
    try {
        return a(b);
    } finally{
        $94154706315aabfd$var$K = c, 0 === $94154706315aabfd$var$K && ($94154706315aabfd$var$mk = $94154706315aabfd$var$A() + 500, $94154706315aabfd$var$tg && $94154706315aabfd$var$xg());
    }
}
function $94154706315aabfd$var$El(a) {
    null !== $94154706315aabfd$var$hl && 0 === $94154706315aabfd$var$hl.tag && 0 === ($94154706315aabfd$var$K & 6) && $94154706315aabfd$var$tl();
    var b = $94154706315aabfd$var$K;
    $94154706315aabfd$var$K |= 1;
    var c = $94154706315aabfd$var$$k.transition, d = $94154706315aabfd$var$E;
    try {
        if ($94154706315aabfd$var$$k.transition = null, $94154706315aabfd$var$E = 1, a) return a();
    } finally{
        $94154706315aabfd$var$E = d, $94154706315aabfd$var$$k.transition = c, $94154706315aabfd$var$K = b, 0 === ($94154706315aabfd$var$K & 6) && $94154706315aabfd$var$xg();
    }
}
function $94154706315aabfd$var$nk() {
    $94154706315aabfd$var$Jj = $94154706315aabfd$var$Ij.current;
    $94154706315aabfd$var$G($94154706315aabfd$var$Ij);
}
function $94154706315aabfd$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $94154706315aabfd$var$Uf(c));
    if (null !== $94154706315aabfd$var$Y) for(c = $94154706315aabfd$var$Y.return; null !== c;){
        var d = c;
        $94154706315aabfd$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $94154706315aabfd$var$ng();
                break;
            case 3:
                $94154706315aabfd$var$Nh();
                $94154706315aabfd$var$G($94154706315aabfd$var$jg);
                $94154706315aabfd$var$G($94154706315aabfd$var$I);
                $94154706315aabfd$var$Sh();
                break;
            case 5:
                $94154706315aabfd$var$Ph(d);
                break;
            case 4:
                $94154706315aabfd$var$Nh();
                break;
            case 13:
                $94154706315aabfd$var$G($94154706315aabfd$var$L);
                break;
            case 19:
                $94154706315aabfd$var$G($94154706315aabfd$var$L);
                break;
            case 10:
                $94154706315aabfd$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $94154706315aabfd$var$nk();
        }
        c = c.return;
    }
    $94154706315aabfd$var$Q = a;
    $94154706315aabfd$var$Y = a = $94154706315aabfd$var$ch(a.current, null);
    $94154706315aabfd$var$Z = $94154706315aabfd$var$Jj = b;
    $94154706315aabfd$var$T = 0;
    $94154706315aabfd$var$al = null;
    $94154706315aabfd$var$cl = $94154706315aabfd$var$bl = $94154706315aabfd$var$Fh = 0;
    $94154706315aabfd$var$el = $94154706315aabfd$var$dl = null;
    if (null !== $94154706315aabfd$var$th) {
        for(b = 0; b < $94154706315aabfd$var$th.length; b++)if (c = $94154706315aabfd$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $94154706315aabfd$var$th = null;
    }
    return a;
}
function $94154706315aabfd$var$yl(a, b) {
    do {
        var c = $94154706315aabfd$var$Y;
        try {
            $94154706315aabfd$var$nh();
            $94154706315aabfd$var$Th.current = $94154706315aabfd$var$ei;
            if ($94154706315aabfd$var$Wh) {
                for(var d = $94154706315aabfd$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $94154706315aabfd$var$Wh = !1;
            }
            $94154706315aabfd$var$Vh = 0;
            $94154706315aabfd$var$O = $94154706315aabfd$var$N = $94154706315aabfd$var$M = null;
            $94154706315aabfd$var$Xh = !1;
            $94154706315aabfd$var$Yh = 0;
            $94154706315aabfd$var$Zk.current = null;
            if (null === c || null === c.return) {
                $94154706315aabfd$var$T = 1;
                $94154706315aabfd$var$al = b;
                $94154706315aabfd$var$Y = null;
                break;
            }
            c.mode & 2 && $94154706315aabfd$var$$i(c, !0);
            $94154706315aabfd$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentSuspended && $94154706315aabfd$var$B.markComponentSuspended(c, f, $94154706315aabfd$var$Z);
            } else null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markComponentErrored && $94154706315aabfd$var$B.markComponentErrored(c, b, $94154706315aabfd$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $94154706315aabfd$var$Z;
                k.flags |= 32768;
                $94154706315aabfd$var$mc && $94154706315aabfd$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $94154706315aabfd$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $94154706315aabfd$var$yj(z, h, k, g, b);
                        z.mode & 1 && $94154706315aabfd$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $94154706315aabfd$var$uj(g, l, b);
                            $94154706315aabfd$var$Zj();
                            break a;
                        }
                        f = Error($94154706315aabfd$var$p(426));
                    }
                } else if ($94154706315aabfd$var$J && k.mode & 1) {
                    var C = $94154706315aabfd$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $94154706315aabfd$var$yj(C, h, k, g, b);
                        $94154706315aabfd$var$Xg($94154706315aabfd$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $94154706315aabfd$var$lj(f, k);
                4 !== $94154706315aabfd$var$T && ($94154706315aabfd$var$T = 2);
                null === $94154706315aabfd$var$dl ? $94154706315aabfd$var$dl = [
                    g
                ] : $94154706315aabfd$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $94154706315aabfd$var$pj(g, f, b);
                            $94154706315aabfd$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $94154706315aabfd$var$tj || !$94154706315aabfd$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $94154706315aabfd$var$sj(g, k, b);
                                $94154706315aabfd$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $94154706315aabfd$var$Fl(c);
        } catch (ca) {
            b = ca;
            $94154706315aabfd$var$Y === c && null !== c && ($94154706315aabfd$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $94154706315aabfd$var$vl() {
    var a = $94154706315aabfd$var$Yk.current;
    $94154706315aabfd$var$Yk.current = $94154706315aabfd$var$ei;
    return null === a ? $94154706315aabfd$var$ei : a;
}
function $94154706315aabfd$var$Zj() {
    if (0 === $94154706315aabfd$var$T || 3 === $94154706315aabfd$var$T || 2 === $94154706315aabfd$var$T) $94154706315aabfd$var$T = 4;
    null === $94154706315aabfd$var$Q || 0 === ($94154706315aabfd$var$Fh & 268435455) && 0 === ($94154706315aabfd$var$bl & 268435455) || $94154706315aabfd$var$ol($94154706315aabfd$var$Q, $94154706315aabfd$var$Z);
}
function $94154706315aabfd$var$ul(a, b) {
    var c = $94154706315aabfd$var$K;
    $94154706315aabfd$var$K |= 2;
    var d = $94154706315aabfd$var$vl();
    if ($94154706315aabfd$var$Q !== a || $94154706315aabfd$var$Z !== b) {
        if ($94154706315aabfd$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($94154706315aabfd$var$wj(a, $94154706315aabfd$var$Z), e.clear());
            $94154706315aabfd$var$Qc(a, b);
        }
        $94154706315aabfd$var$fl = null;
        $94154706315aabfd$var$wl(a, b);
    }
    $94154706315aabfd$var$wc(b);
    for(;;)try {
        $94154706315aabfd$var$Gl();
        break;
    } catch (f) {
        $94154706315aabfd$var$yl(a, f);
    }
    $94154706315aabfd$var$nh();
    $94154706315aabfd$var$K = c;
    $94154706315aabfd$var$Yk.current = d;
    if (null !== $94154706315aabfd$var$Y) throw Error($94154706315aabfd$var$p(261));
    $94154706315aabfd$var$xc();
    $94154706315aabfd$var$Q = null;
    $94154706315aabfd$var$Z = 0;
    return $94154706315aabfd$var$T;
}
function $94154706315aabfd$var$Gl() {
    for(; null !== $94154706315aabfd$var$Y;)$94154706315aabfd$var$Hl($94154706315aabfd$var$Y);
}
function $94154706315aabfd$var$xl() {
    for(; null !== $94154706315aabfd$var$Y && !$94154706315aabfd$var$cc();)$94154706315aabfd$var$Hl($94154706315aabfd$var$Y);
}
function $94154706315aabfd$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($94154706315aabfd$var$Wi = $94154706315aabfd$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $94154706315aabfd$var$Ti()), b = $94154706315aabfd$var$Il(b, a, $94154706315aabfd$var$Jj), $94154706315aabfd$var$$i(a, !0)) : b = $94154706315aabfd$var$Il(b, a, $94154706315aabfd$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $94154706315aabfd$var$Fl(a) : $94154706315aabfd$var$Y = b;
    $94154706315aabfd$var$Zk.current = null;
}
function $94154706315aabfd$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $94154706315aabfd$var$kk(c, b, $94154706315aabfd$var$Jj);
            else {
                var d = b;
                $94154706315aabfd$var$Wi = $94154706315aabfd$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $94154706315aabfd$var$Ti());
                c = $94154706315aabfd$var$kk(c, b, $94154706315aabfd$var$Jj);
                $94154706315aabfd$var$$i(b, !1);
            }
            if (null !== c) {
                $94154706315aabfd$var$Y = c;
                return;
            }
        } else {
            c = $94154706315aabfd$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $94154706315aabfd$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $94154706315aabfd$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $94154706315aabfd$var$T = 6;
                $94154706315aabfd$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $94154706315aabfd$var$Y = b;
            return;
        }
        $94154706315aabfd$var$Y = b = a;
    }while (null !== b);
    0 === $94154706315aabfd$var$T && ($94154706315aabfd$var$T = 5);
}
function $94154706315aabfd$var$Cl(a, b, c) {
    var d = $94154706315aabfd$var$E, e = $94154706315aabfd$var$$k.transition;
    try {
        $94154706315aabfd$var$$k.transition = null, $94154706315aabfd$var$E = 1, $94154706315aabfd$var$Jl(a, b, c, d);
    } finally{
        $94154706315aabfd$var$$k.transition = e, $94154706315aabfd$var$E = d;
    }
    return null;
}
function $94154706315aabfd$var$Jl(a, b, c, d) {
    do $94154706315aabfd$var$tl();
    while (null !== $94154706315aabfd$var$hl);
    if (0 !== ($94154706315aabfd$var$K & 6)) throw Error($94154706315aabfd$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markCommitStarted && $94154706315aabfd$var$B.markCommitStarted(e);
    if (null === c) return $94154706315aabfd$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($94154706315aabfd$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $94154706315aabfd$var$Nc(a, f);
    a === $94154706315aabfd$var$Q && ($94154706315aabfd$var$Y = $94154706315aabfd$var$Q = null, $94154706315aabfd$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $94154706315aabfd$var$gl || ($94154706315aabfd$var$gl = !0, $94154706315aabfd$var$rl($94154706315aabfd$var$hc, function() {
        $94154706315aabfd$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $94154706315aabfd$var$$k.transition;
        $94154706315aabfd$var$$k.transition = null;
        var g = $94154706315aabfd$var$E;
        $94154706315aabfd$var$E = 1;
        var h = $94154706315aabfd$var$K;
        $94154706315aabfd$var$K |= 4;
        $94154706315aabfd$var$Zk.current = null;
        $94154706315aabfd$var$yk(a, c);
        $94154706315aabfd$var$Ui = $94154706315aabfd$var$Ti();
        $94154706315aabfd$var$Mk(a, c, e);
        $94154706315aabfd$var$bf($94154706315aabfd$var$Rf);
        $94154706315aabfd$var$rd = !!$94154706315aabfd$var$Qf;
        $94154706315aabfd$var$Rf = $94154706315aabfd$var$Qf = null;
        a.current = c;
        null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markLayoutEffectsStarted && $94154706315aabfd$var$B.markLayoutEffectsStarted(e);
        $94154706315aabfd$var$Sk(c, a, e);
        null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markLayoutEffectsStopped && $94154706315aabfd$var$B.markLayoutEffectsStopped();
        $94154706315aabfd$var$dc();
        $94154706315aabfd$var$K = h;
        $94154706315aabfd$var$E = g;
        $94154706315aabfd$var$$k.transition = f;
    } else a.current = c, $94154706315aabfd$var$Ui = $94154706315aabfd$var$Ti();
    $94154706315aabfd$var$gl && ($94154706315aabfd$var$gl = !1, $94154706315aabfd$var$hl = a, $94154706315aabfd$var$il = e);
    f = a.pendingLanes;
    0 === f && ($94154706315aabfd$var$tj = null);
    $94154706315aabfd$var$nc(c.stateNode, d);
    $94154706315aabfd$var$mc && a.memoizedUpdaters.clear();
    $94154706315aabfd$var$pl(a, $94154706315aabfd$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($94154706315aabfd$var$qj) throw $94154706315aabfd$var$qj = !1, a = $94154706315aabfd$var$rj, $94154706315aabfd$var$rj = null, a;
    0 !== ($94154706315aabfd$var$il & 1) && 0 !== a.tag && $94154706315aabfd$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($94154706315aabfd$var$Zi = !0, a === $94154706315aabfd$var$ll ? $94154706315aabfd$var$kl++ : ($94154706315aabfd$var$kl = 0, $94154706315aabfd$var$ll = a)) : $94154706315aabfd$var$kl = 0;
    $94154706315aabfd$var$xg();
    $94154706315aabfd$var$rc();
    return null;
}
function $94154706315aabfd$var$tl() {
    if (null !== $94154706315aabfd$var$hl) {
        var a = $94154706315aabfd$var$Rc($94154706315aabfd$var$il), b = $94154706315aabfd$var$$k.transition, c = $94154706315aabfd$var$E;
        try {
            $94154706315aabfd$var$$k.transition = null;
            $94154706315aabfd$var$E = 16 > a ? 16 : a;
            if (null === $94154706315aabfd$var$hl) var d = !1;
            else {
                a = $94154706315aabfd$var$hl;
                var e = $94154706315aabfd$var$il;
                $94154706315aabfd$var$hl = null;
                $94154706315aabfd$var$il = 0;
                if (0 !== ($94154706315aabfd$var$K & 6)) throw Error($94154706315aabfd$var$p(331));
                null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markPassiveEffectsStarted && $94154706315aabfd$var$B.markPassiveEffectsStarted(e);
                e = $94154706315aabfd$var$K;
                $94154706315aabfd$var$K |= 4;
                for($94154706315aabfd$var$U = a.current; null !== $94154706315aabfd$var$U;){
                    var f = $94154706315aabfd$var$U, g = f.child;
                    if (0 !== ($94154706315aabfd$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($94154706315aabfd$var$U = l; null !== $94154706315aabfd$var$U;){
                                    var n = $94154706315aabfd$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($94154706315aabfd$var$Xi = $94154706315aabfd$var$Ti(), $94154706315aabfd$var$zk(8, q, f), $94154706315aabfd$var$bj(q)) : $94154706315aabfd$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $94154706315aabfd$var$U = r;
                                    else for(; null !== $94154706315aabfd$var$U;){
                                        n = $94154706315aabfd$var$U;
                                        var z = n.sibling, m = n.return;
                                        $94154706315aabfd$var$Ck(n);
                                        if (n === l) {
                                            $94154706315aabfd$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $94154706315aabfd$var$U = z;
                                            break;
                                        }
                                        $94154706315aabfd$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $94154706315aabfd$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $94154706315aabfd$var$U = g;
                    else b: for(; null !== $94154706315aabfd$var$U;){
                        f = $94154706315aabfd$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($94154706315aabfd$var$Xi = $94154706315aabfd$var$Ti(), $94154706315aabfd$var$zk(9, k, k.return), $94154706315aabfd$var$bj(k)) : $94154706315aabfd$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $94154706315aabfd$var$U = y;
                            break b;
                        }
                        $94154706315aabfd$var$U = f.return;
                    }
                }
                var v = a.current;
                for($94154706315aabfd$var$U = v; null !== $94154706315aabfd$var$U;){
                    g = $94154706315aabfd$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $94154706315aabfd$var$U = D;
                    else b: for(g = v; null !== $94154706315aabfd$var$U;){
                        h = $94154706315aabfd$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $94154706315aabfd$var$Xi = $94154706315aabfd$var$Ti();
                                        try {
                                            $94154706315aabfd$var$Ak(9, l);
                                        } finally{
                                            $94154706315aabfd$var$bj(l);
                                        }
                                    } else $94154706315aabfd$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $94154706315aabfd$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $94154706315aabfd$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $94154706315aabfd$var$U = ca;
                            break b;
                        }
                        $94154706315aabfd$var$U = h.return;
                    }
                }
                v = $94154706315aabfd$var$jl;
                $94154706315aabfd$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $94154706315aabfd$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $94154706315aabfd$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markPassiveEffectsStopped && $94154706315aabfd$var$B.markPassiveEffectsStopped();
                $94154706315aabfd$var$K = e;
                $94154706315aabfd$var$xg();
                if ($94154706315aabfd$var$lc && "function" === typeof $94154706315aabfd$var$lc.onPostCommitFiberRoot) try {
                    $94154706315aabfd$var$lc.onPostCommitFiberRoot($94154706315aabfd$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $94154706315aabfd$var$E = c, $94154706315aabfd$var$$k.transition = b;
        }
    }
    return !1;
}
function $94154706315aabfd$var$Wk(a) {
    $94154706315aabfd$var$jl.push(a);
    $94154706315aabfd$var$gl || ($94154706315aabfd$var$gl = !0, $94154706315aabfd$var$rl($94154706315aabfd$var$hc, function() {
        $94154706315aabfd$var$tl();
        return null;
    }));
}
function $94154706315aabfd$var$Kl(a, b, c) {
    b = $94154706315aabfd$var$lj(c, b);
    b = $94154706315aabfd$var$pj(a, b, 1);
    a = $94154706315aabfd$var$Bh(a, b, 1);
    b = $94154706315aabfd$var$Ri();
    null !== a && ($94154706315aabfd$var$Mc(a, 1, b), $94154706315aabfd$var$pl(a, b));
}
function $94154706315aabfd$var$W(a, b, c) {
    if (3 === a.tag) $94154706315aabfd$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $94154706315aabfd$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $94154706315aabfd$var$tj || !$94154706315aabfd$var$tj.has(d))) {
                a = $94154706315aabfd$var$lj(c, a);
                a = $94154706315aabfd$var$sj(b, a, 1);
                b = $94154706315aabfd$var$Bh(b, a, 1);
                a = $94154706315aabfd$var$Ri();
                null !== b && ($94154706315aabfd$var$Mc(b, 1, a), $94154706315aabfd$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $94154706315aabfd$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $94154706315aabfd$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $94154706315aabfd$var$Q === a && ($94154706315aabfd$var$Z & c) === c && (4 === $94154706315aabfd$var$T || 3 === $94154706315aabfd$var$T && ($94154706315aabfd$var$Z & 130023424) === $94154706315aabfd$var$Z && 500 > $94154706315aabfd$var$A() - $94154706315aabfd$var$Qk ? $94154706315aabfd$var$wl(a, 0) : $94154706315aabfd$var$cl |= c);
    $94154706315aabfd$var$pl(a, b);
}
function $94154706315aabfd$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $94154706315aabfd$var$Ec, $94154706315aabfd$var$Ec <<= 1, 0 === ($94154706315aabfd$var$Ec & 130023424) && ($94154706315aabfd$var$Ec = 4194304)));
    var c = $94154706315aabfd$var$Ri();
    a = $94154706315aabfd$var$wh(a, b);
    null !== a && ($94154706315aabfd$var$Mc(a, b, c), $94154706315aabfd$var$pl(a, c));
}
function $94154706315aabfd$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $94154706315aabfd$var$Ll(a, c);
}
function $94154706315aabfd$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($94154706315aabfd$var$p(314));
    }
    null !== d && d.delete(b);
    $94154706315aabfd$var$Ll(a, c);
}
var $94154706315aabfd$var$Il;
$94154706315aabfd$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $94154706315aabfd$var$jg.current) $94154706315aabfd$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $94154706315aabfd$var$rh = !1, $94154706315aabfd$var$ek(a, b, c);
            $94154706315aabfd$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $94154706315aabfd$var$rh = !1, $94154706315aabfd$var$J && 0 !== (b.flags & 1048576) && $94154706315aabfd$var$Ig(b, $94154706315aabfd$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $94154706315aabfd$var$Mj(a, b);
            a = b.pendingProps;
            var e = $94154706315aabfd$var$lg(b, $94154706315aabfd$var$I.current);
            $94154706315aabfd$var$qh(b, c);
            $94154706315aabfd$var$sc(b);
            e = $94154706315aabfd$var$ai(null, b, d, a, e, c);
            var f = $94154706315aabfd$var$fi();
            $94154706315aabfd$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $94154706315aabfd$var$mg(d) ? (f = !0, $94154706315aabfd$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $94154706315aabfd$var$yh(b), e.updater = $94154706315aabfd$var$gj, b.stateNode = e, e._reactInternals = b, $94154706315aabfd$var$kj(b, d, a, c), b = $94154706315aabfd$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $94154706315aabfd$var$J && f && $94154706315aabfd$var$Jg(b), $94154706315aabfd$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $94154706315aabfd$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $94154706315aabfd$var$Ml(d);
                a = $94154706315aabfd$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $94154706315aabfd$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $94154706315aabfd$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $94154706315aabfd$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $94154706315aabfd$var$Dj(null, b, d, $94154706315aabfd$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($94154706315aabfd$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $94154706315aabfd$var$ej(d, e), $94154706315aabfd$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $94154706315aabfd$var$ej(d, e), $94154706315aabfd$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $94154706315aabfd$var$Oj(b);
                if (null === a) throw Error($94154706315aabfd$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $94154706315aabfd$var$zh(a, b);
                $94154706315aabfd$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $94154706315aabfd$var$lj(Error($94154706315aabfd$var$p(423)), b);
                        b = $94154706315aabfd$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $94154706315aabfd$var$lj(Error($94154706315aabfd$var$p(424)), b);
                        b = $94154706315aabfd$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($94154706315aabfd$var$Mg = $94154706315aabfd$var$Zf(b.stateNode.containerInfo.firstChild), $94154706315aabfd$var$Lg = b, $94154706315aabfd$var$J = !0, $94154706315aabfd$var$Ng = null, c = $94154706315aabfd$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $94154706315aabfd$var$Wg();
                    if (d === e) {
                        b = $94154706315aabfd$var$Cj(a, b, c);
                        break a;
                    }
                    $94154706315aabfd$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $94154706315aabfd$var$Oh(b), null === a && $94154706315aabfd$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $94154706315aabfd$var$Sf(d, e) ? g = null : null !== f && $94154706315aabfd$var$Sf(d, f) && (b.flags |= 32), $94154706315aabfd$var$Kj(a, b), $94154706315aabfd$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $94154706315aabfd$var$Sg(b), null;
        case 13:
            return $94154706315aabfd$var$Uj(a, b, c);
        case 4:
            return $94154706315aabfd$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $94154706315aabfd$var$hh(b, null, d, c) : $94154706315aabfd$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $94154706315aabfd$var$ej(d, e), $94154706315aabfd$var$Bj(a, b, d, e, c);
        case 7:
            return $94154706315aabfd$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $94154706315aabfd$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $94154706315aabfd$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $94154706315aabfd$var$H($94154706315aabfd$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($94154706315aabfd$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$94154706315aabfd$var$jg.current) {
                            b = $94154706315aabfd$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $94154706315aabfd$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $94154706315aabfd$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($94154706315aabfd$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $94154706315aabfd$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $94154706315aabfd$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $94154706315aabfd$var$qh(b, c), e = $94154706315aabfd$var$sh(e), $94154706315aabfd$var$sc(b), d = d(e), $94154706315aabfd$var$tc(), b.flags |= 1, $94154706315aabfd$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $94154706315aabfd$var$ej(d, b.pendingProps), e = $94154706315aabfd$var$ej(d.type, e), $94154706315aabfd$var$Dj(a, b, d, e, c);
        case 15:
            return $94154706315aabfd$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $94154706315aabfd$var$ej(d, e), $94154706315aabfd$var$Mj(a, b), b.tag = 1, $94154706315aabfd$var$mg(d) ? (a = !0, $94154706315aabfd$var$qg(b)) : a = !1, $94154706315aabfd$var$qh(b, c), $94154706315aabfd$var$ij(b, d, e), $94154706315aabfd$var$kj(b, d, e, c), $94154706315aabfd$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $94154706315aabfd$var$dk(a, b, c);
        case 22:
            return $94154706315aabfd$var$Hj(a, b, c);
    }
    throw Error($94154706315aabfd$var$p(156, b.tag));
};
function $94154706315aabfd$var$wj(a, b) {
    $94154706315aabfd$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $94154706315aabfd$var$Pc(a, c, b);
    });
}
function $94154706315aabfd$var$rl(a, b) {
    return $94154706315aabfd$var$ac(a, b);
}
function $94154706315aabfd$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $94154706315aabfd$var$Pg(a, b, c, d) {
    return new $94154706315aabfd$var$Nl(a, b, c, d);
}
function $94154706315aabfd$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $94154706315aabfd$var$Ml(a) {
    if ("function" === typeof a) return $94154706315aabfd$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $94154706315aabfd$var$Da) return 11;
        if (a === $94154706315aabfd$var$Ga) return 14;
    }
    return 2;
}
function $94154706315aabfd$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $94154706315aabfd$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $94154706315aabfd$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $94154706315aabfd$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $94154706315aabfd$var$ya:
            return $94154706315aabfd$var$gh(c.children, e, f, b);
        case $94154706315aabfd$var$za:
            g = 8;
            e |= 8;
            break;
        case $94154706315aabfd$var$Aa:
            return a = $94154706315aabfd$var$Pg(12, c, b, e | 2), a.elementType = $94154706315aabfd$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $94154706315aabfd$var$Ea:
            return a = $94154706315aabfd$var$Pg(13, c, b, e), a.elementType = $94154706315aabfd$var$Ea, a.lanes = f, a;
        case $94154706315aabfd$var$Fa:
            return a = $94154706315aabfd$var$Pg(19, c, b, e), a.elementType = $94154706315aabfd$var$Fa, a.lanes = f, a;
        case $94154706315aabfd$var$Ia:
            return $94154706315aabfd$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $94154706315aabfd$var$Ba:
                    g = 10;
                    break a;
                case $94154706315aabfd$var$Ca:
                    g = 9;
                    break a;
                case $94154706315aabfd$var$Da:
                    g = 11;
                    break a;
                case $94154706315aabfd$var$Ga:
                    g = 14;
                    break a;
                case $94154706315aabfd$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($94154706315aabfd$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $94154706315aabfd$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $94154706315aabfd$var$gh(a, b, c, d) {
    a = $94154706315aabfd$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $94154706315aabfd$var$Vj(a, b, c, d) {
    a = $94154706315aabfd$var$Pg(22, a, d, b);
    a.elementType = $94154706315aabfd$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $94154706315aabfd$var$dh(a, b, c) {
    a = $94154706315aabfd$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $94154706315aabfd$var$fh(a, b, c) {
    b = $94154706315aabfd$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $94154706315aabfd$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $94154706315aabfd$var$Lc(0);
    this.expirationTimes = $94154706315aabfd$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $94154706315aabfd$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $94154706315aabfd$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $94154706315aabfd$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $94154706315aabfd$var$mc && (b |= 2);
    f = $94154706315aabfd$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $94154706315aabfd$var$yh(f);
    return a;
}
function $94154706315aabfd$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $94154706315aabfd$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $94154706315aabfd$var$Rl(a) {
    if (!a) return $94154706315aabfd$var$ig;
    a = a._reactInternals;
    a: {
        if ($94154706315aabfd$var$Vb(a) !== a || 1 !== a.tag) throw Error($94154706315aabfd$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($94154706315aabfd$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($94154706315aabfd$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($94154706315aabfd$var$mg(c)) return $94154706315aabfd$var$pg(a, c, b);
    }
    return b;
}
function $94154706315aabfd$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $94154706315aabfd$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $94154706315aabfd$var$Rl(null);
    c = a.current;
    d = $94154706315aabfd$var$Ri();
    e = $94154706315aabfd$var$Oi(c);
    f = $94154706315aabfd$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $94154706315aabfd$var$Bh(c, f, e);
    a.current.lanes = e;
    $94154706315aabfd$var$Mc(a, e, d);
    $94154706315aabfd$var$pl(a, d);
    return a;
}
function $94154706315aabfd$var$Tl(a, b, c, d) {
    var e = b.current, f = $94154706315aabfd$var$Ri(), g = $94154706315aabfd$var$Oi(e);
    null !== $94154706315aabfd$var$B && "function" === typeof $94154706315aabfd$var$B.markRenderScheduled && $94154706315aabfd$var$B.markRenderScheduled(g);
    c = $94154706315aabfd$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $94154706315aabfd$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $94154706315aabfd$var$Bh(e, b, g);
    null !== a && ($94154706315aabfd$var$ui(a, e, g, f), $94154706315aabfd$var$Ch(a, e, g));
    return g;
}
function $94154706315aabfd$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $94154706315aabfd$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $94154706315aabfd$var$Wl(a, b) {
    $94154706315aabfd$var$Vl(a, b);
    (a = a.alternate) && $94154706315aabfd$var$Vl(a, b);
}
function $94154706315aabfd$var$Xl() {
    return null;
}
var $94154706315aabfd$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $94154706315aabfd$var$Zl(a) {
    this._internalRoot = a;
}
$94154706315aabfd$var$$l.prototype.render = $94154706315aabfd$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($94154706315aabfd$var$p(409));
    $94154706315aabfd$var$Tl(a, b, null, null);
};
$94154706315aabfd$var$$l.prototype.unmount = $94154706315aabfd$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $94154706315aabfd$var$El(function() {
            $94154706315aabfd$var$Tl(null, a, null, null);
        });
        b[$94154706315aabfd$var$If] = null;
    }
};
function $94154706315aabfd$var$$l(a) {
    this._internalRoot = a;
}
$94154706315aabfd$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $94154706315aabfd$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $94154706315aabfd$var$dd.length && 0 !== b && b < $94154706315aabfd$var$dd[c].priority; c++);
        $94154706315aabfd$var$dd.splice(c, 0, a);
        0 === c && $94154706315aabfd$var$id(a);
    }
};
function $94154706315aabfd$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $94154706315aabfd$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $94154706315aabfd$var$cm() {}
function $94154706315aabfd$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $94154706315aabfd$var$Ul(g);
                f.call(a);
            };
        }
        var g = $94154706315aabfd$var$Sl(b, d, a, 0, null, !1, !1, "", $94154706315aabfd$var$cm);
        a._reactRootContainer = g;
        a[$94154706315aabfd$var$If] = g.current;
        $94154706315aabfd$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $94154706315aabfd$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $94154706315aabfd$var$Ul(k);
            h.call(a);
        };
    }
    var k = $94154706315aabfd$var$Pl(a, 0, !1, null, null, !1, !1, "", $94154706315aabfd$var$cm);
    a._reactRootContainer = k;
    a[$94154706315aabfd$var$If] = k.current;
    $94154706315aabfd$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $94154706315aabfd$var$El(function() {
        $94154706315aabfd$var$Tl(b, k, c, d);
    });
    return k;
}
function $94154706315aabfd$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $94154706315aabfd$var$Ul(g);
                h.call(a);
            };
        }
        $94154706315aabfd$var$Tl(b, g, a, e);
    } else g = $94154706315aabfd$var$dm(c, b, a, e, d);
    return $94154706315aabfd$var$Ul(g);
}
$94154706315aabfd$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $94154706315aabfd$var$Fc(b.pendingLanes);
                0 !== c && ($94154706315aabfd$var$Oc(b, c | 1), $94154706315aabfd$var$pl(b, $94154706315aabfd$var$A()), 0 === ($94154706315aabfd$var$K & 6) && ($94154706315aabfd$var$mk = $94154706315aabfd$var$A() + 500, $94154706315aabfd$var$xg()));
            }
            break;
        case 13:
            $94154706315aabfd$var$El(function() {
                var b = $94154706315aabfd$var$wh(a, 1);
                if (null !== b) {
                    var c = $94154706315aabfd$var$Ri();
                    $94154706315aabfd$var$ui(b, a, 1, c);
                }
            }), $94154706315aabfd$var$Wl(a, 1);
    }
};
$94154706315aabfd$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $94154706315aabfd$var$wh(a, 134217728);
        if (null !== b) {
            var c = $94154706315aabfd$var$Ri();
            $94154706315aabfd$var$ui(b, a, 134217728, c);
        }
        $94154706315aabfd$var$Wl(a, 134217728);
    }
};
$94154706315aabfd$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $94154706315aabfd$var$Oi(a), c = $94154706315aabfd$var$wh(a, b);
        if (null !== c) {
            var d = $94154706315aabfd$var$Ri();
            $94154706315aabfd$var$ui(c, a, b, d);
        }
        $94154706315aabfd$var$Wl(a, b);
    }
};
$94154706315aabfd$var$Vc = function() {
    return $94154706315aabfd$var$E;
};
$94154706315aabfd$var$Wc = function(a, b) {
    var c = $94154706315aabfd$var$E;
    try {
        return $94154706315aabfd$var$E = a, b();
    } finally{
        $94154706315aabfd$var$E = c;
    }
};
$94154706315aabfd$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $94154706315aabfd$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $94154706315aabfd$var$Db(d);
                        if (!e) throw Error($94154706315aabfd$var$p(90));
                        $94154706315aabfd$var$Wa(d);
                        $94154706315aabfd$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $94154706315aabfd$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $94154706315aabfd$var$eb(a, !!c.multiple, b, !1);
    }
};
$94154706315aabfd$var$Gb = $94154706315aabfd$var$Dl;
$94154706315aabfd$var$Hb = $94154706315aabfd$var$El;
var $94154706315aabfd$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $94154706315aabfd$var$Cb,
        $94154706315aabfd$var$Ie,
        $94154706315aabfd$var$Db,
        $94154706315aabfd$var$Eb,
        $94154706315aabfd$var$Fb,
        $94154706315aabfd$var$Dl
    ]
}, $94154706315aabfd$var$gm = {
    findFiberByHostInstance: $94154706315aabfd$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $94154706315aabfd$var$u({}, a, {
            getLaneLabelMap: $94154706315aabfd$var$pc,
            injectProfilingHooks: $94154706315aabfd$var$oc
        }), $94154706315aabfd$var$kc = b.inject(a), $94154706315aabfd$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $94154706315aabfd$var$gm.bundleType,
    version: $94154706315aabfd$var$gm.version,
    rendererPackageName: $94154706315aabfd$var$gm.rendererPackageName,
    rendererConfig: $94154706315aabfd$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $94154706315aabfd$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $94154706315aabfd$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $94154706315aabfd$var$gm.findFiberByHostInstance || $94154706315aabfd$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$94154706315aabfd$export$ae55be85d98224ed = $94154706315aabfd$var$fm;
$94154706315aabfd$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$94154706315aabfd$var$am(b)) throw Error($94154706315aabfd$var$p(200));
    return $94154706315aabfd$var$Ql(a, b, null, c);
};
$94154706315aabfd$export$882461b6382ed46c = function(a, b) {
    if (!$94154706315aabfd$var$am(a)) throw Error($94154706315aabfd$var$p(299));
    var c = !1, d = "", e = $94154706315aabfd$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $94154706315aabfd$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$94154706315aabfd$var$If] = b.current;
    $94154706315aabfd$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $94154706315aabfd$var$Zl(b);
};
$94154706315aabfd$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($94154706315aabfd$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($94154706315aabfd$var$p(268, a));
    }
    a = $94154706315aabfd$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$94154706315aabfd$export$cd75ccfd720a3cd4 = function(a) {
    return $94154706315aabfd$var$El(a);
};
$94154706315aabfd$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$94154706315aabfd$var$bm(b)) throw Error($94154706315aabfd$var$p(200));
    return $94154706315aabfd$var$em(null, a, b, !0, c);
};
$94154706315aabfd$export$757ceba2d55c277e = function(a, b, c) {
    if (!$94154706315aabfd$var$am(a)) throw Error($94154706315aabfd$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $94154706315aabfd$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $94154706315aabfd$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$94154706315aabfd$var$If] = b.current;
    $94154706315aabfd$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $94154706315aabfd$var$$l(b);
};
$94154706315aabfd$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$94154706315aabfd$var$bm(b)) throw Error($94154706315aabfd$var$p(200));
    return $94154706315aabfd$var$em(null, a, b, !1, c);
};
$94154706315aabfd$export$502457920280e6be = function(a) {
    if (!$94154706315aabfd$var$bm(a)) throw Error($94154706315aabfd$var$p(40));
    return a._reactRootContainer ? ($94154706315aabfd$var$El(function() {
        $94154706315aabfd$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$94154706315aabfd$var$If] = null;
        });
    }), !0) : !1;
};
$94154706315aabfd$export$c78a37762a8d58e1 = $94154706315aabfd$var$Dl;
$94154706315aabfd$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$94154706315aabfd$var$bm(c)) throw Error($94154706315aabfd$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($94154706315aabfd$var$p(38));
    return $94154706315aabfd$var$em(a, b, c, !1, d);
};
$94154706315aabfd$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("bNos8", function(module, exports) {
"use strict";

var $j5wbN = parcelRequire("j5wbN");

var $dtE14 = parcelRequire("dtE14");

var $d4mGr = parcelRequire("d4mGr");

var $4X6M3 = parcelRequire("4X6M3");

var $lThBY = parcelRequire("lThBY");

var $2oD7l = parcelRequire("2oD7l");

var $hAaqX = parcelRequire("hAaqX");

var $5A24j = parcelRequire("5A24j");

var $1c3ii = parcelRequire("1c3ii");
var $89673d226db80b47$var$loadQuery = $1c3ii.loadQuery;

var $9pgH3 = parcelRequire("9pgH3");

var $eLBQT = parcelRequire("eLBQT");

var $jwpXG = parcelRequire("jwpXG");

var $9KXWY = parcelRequire("9KXWY");

var $3QqxT = parcelRequire("3QqxT");

var $6RH4A = parcelRequire("6RH4A");

var $2rQPf = parcelRequire("2rQPf");

var $dAN4o = parcelRequire("dAN4o");

var $johsa = parcelRequire("johsa");

var $fH4DL = parcelRequire("fH4DL");

var $hASCV = parcelRequire("hASCV");

var $1tdq5 = parcelRequire("1tdq5");

var $4fG2B = parcelRequire("4fG2B");

var $jc1m1 = parcelRequire("jc1m1");

var $5v24M = parcelRequire("5v24M");

var $lcVKE = parcelRequire("lcVKE");
module.exports = {
    ConnectionHandler: $lcVKE.ConnectionHandler,
    QueryRenderer: $lThBY,
    LocalQueryRenderer: $d4mGr,
    MutationTypes: $lcVKE.MutationTypes,
    RangeOperations: $lcVKE.RangeOperations,
    ReactRelayContext: $j5wbN,
    applyOptimisticMutation: $lcVKE.applyOptimisticMutation,
    commitLocalUpdate: $lcVKE.commitLocalUpdate,
    commitMutation: $lcVKE.commitMutation,
    createFragmentContainer: $dtE14.createContainer,
    createPaginationContainer: $4X6M3.createContainer,
    createRefetchContainer: $2oD7l.createContainer,
    fetchQuery_DEPRECATED: $lcVKE.fetchQuery_DEPRECATED,
    graphql: $lcVKE.graphql,
    readInlineData: $lcVKE.readInlineData,
    requestSubscription: $lcVKE.requestSubscription,
    EntryPointContainer: $hAaqX,
    RelayEnvironmentProvider: $eLBQT,
    ProfilerContext: $9pgH3,
    fetchQuery: $lcVKE.fetchQuery,
    loadQuery: $89673d226db80b47$var$loadQuery,
    loadEntryPoint: $5A24j,
    useClientQuery: $jwpXG,
    useFragment: $3QqxT,
    useLazyLoadQuery: $6RH4A,
    useEntryPointLoader: $9KXWY,
    useQueryLoader: $hASCV,
    useMutation: $2rQPf,
    usePaginationFragment: $dAN4o,
    usePreloadedQuery: $fH4DL,
    useRefetchableFragment: $1tdq5,
    usePrefetchableForwardPaginationFragment_EXPERIMENTAL: $johsa,
    useRelayEnvironment: $4fG2B,
    useSubscribeToInvalidationState: $jc1m1,
    useSubscription: $5v24M
};

});
parcelRegister("j5wbN", function(module, exports) {
"use strict";

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $de577414e5b4a9da$var$createRelayContext = $lcVKE.__internal.createRelayContext;
module.exports = $de577414e5b4a9da$var$createRelayContext($acw62);

});
parcelRegister("lcVKE", function(module, exports) {
/**
 * Relay v18.2.0
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("lCUey"));

});
parcelRegister("lCUey", function(module, exports) {
"use strict";

var $8m1pd = parcelRequire("8m1pd");
var $fbe8c469291c9f9e$var$isErrorResult = $8m1pd.isErrorResult, $fbe8c469291c9f9e$var$isValueResult = $8m1pd.isValueResult;

var $aGNBD = parcelRequire("aGNBD");

var $gURLS = parcelRequire("gURLS");

var $dlzXy = parcelRequire("dlzXy");

var $301e4 = parcelRequire("301e4");

var $5C6Ki = parcelRequire("5C6Ki");

var $M010p = parcelRequire("M010p");

var $lRc4h = parcelRequire("lRc4h");

var $ioH3s = parcelRequire("ioH3s");

var $hrzAF = parcelRequire("hrzAF");

var $jJlPe = parcelRequire("jJlPe");

var $jDJ8J = parcelRequire("jDJ8J");

var $b5DFS = parcelRequire("b5DFS");

var $9VGFV = parcelRequire("9VGFV");

var $1v92Z = parcelRequire("1v92Z");

var $kx3Ii = parcelRequire("kx3Ii");

var $6iwIs = parcelRequire("6iwIs");

var $2Zm5L = parcelRequire("2Zm5L");
var $fbe8c469291c9f9e$var$generateClientID = $2Zm5L.generateClientID, $fbe8c469291c9f9e$var$generateUniqueClientID = $2Zm5L.generateUniqueClientID, $fbe8c469291c9f9e$var$isClientID = $2Zm5L.isClientID;

var $kL5wL = parcelRequire("kL5wL");

var $gzFws = parcelRequire("gzFws");

var $8V1FJ = parcelRequire("8V1FJ");

var $4T3eA = parcelRequire("4T3eA");
var $fbe8c469291c9f9e$var$isSuspenseSentinel = $4T3eA.isSuspenseSentinel, $fbe8c469291c9f9e$var$suspenseSentinel = $4T3eA.suspenseSentinel;

var $94SdE = parcelRequire("94SdE");

var $6UUWp = parcelRequire("6UUWp");

var $6zf6P = parcelRequire("6zf6P");

var $gwzA3 = parcelRequire("gwzA3");

var $j6kQy = parcelRequire("j6kQy");

var $gPxAs = parcelRequire("gPxAs");

var $cTAdw = parcelRequire("cTAdw");

var $6SV6U = parcelRequire("6SV6U");

var $gH9zW = parcelRequire("gH9zW");

var $iUWBj = parcelRequire("iUWBj");

var $boOnJ = parcelRequire("boOnJ");

var $jVaPD = parcelRequire("jVaPD");

var $8Dxz4 = parcelRequire("8Dxz4");

var $4i4EY = parcelRequire("4i4EY");

var $2hcuI = parcelRequire("2hcuI");

var $4ERpj = parcelRequire("4ERpj");

var $eahk4 = parcelRequire("eahk4");

var $iPEiW = parcelRequire("iPEiW");

var $4w68P = parcelRequire("4w68P");

var $8R95j = parcelRequire("8R95j");

var $jtDJm = parcelRequire("jtDJm");

var $lK1yG = parcelRequire("lK1yG");

var $h8beS = parcelRequire("h8beS");

var $6Aftc = parcelRequire("6Aftc");

var $haJc5 = parcelRequire("haJc5");
var $fbe8c469291c9f9e$var$handlePotentialSnapshotErrors = $haJc5.handlePotentialSnapshotErrors;

var $1DbUp = parcelRequire("1DbUp");

var $asMlo = parcelRequire("asMlo");

var $2qPt3 = parcelRequire("2qPt3");

var $dgrHZ = parcelRequire("dgrHZ");

var $lUb19 = parcelRequire("lUb19");

var $jcJkf = parcelRequire("jcJkf");

var $9nfN5 = parcelRequire("9nfN5");

var $gjUUf = parcelRequire("gjUUf");

var $3leo0 = parcelRequire("3leo0");

var $a9M0M = parcelRequire("a9M0M");
var $fbe8c469291c9f9e$var$hasCycle = $a9M0M.hasCycle, $fbe8c469291c9f9e$var$stableCopy = $a9M0M.stableCopy;

var $kDIPG = parcelRequire("kDIPG");
var $fbe8c469291c9f9e$var$mapStr, $fbe8c469291c9f9e$var$setStr, $fbe8c469291c9f9e$var$promiseStr, $fbe8c469291c9f9e$var$objStr;
module.exports = {
    Environment: $gwzA3,
    Network: $hrzAF,
    Observable: $jJlPe,
    QueryResponseCache: $jDJ8J,
    RecordSource: $iUWBj,
    Record: $gPxAs,
    ReplaySubject: $3leo0,
    Store: $6SV6U,
    areEqualSelectors: $cTAdw.areEqualSelectors,
    createFragmentSpecResolver: $kL5wL,
    createNormalizationSelector: $cTAdw.createNormalizationSelector,
    createOperationDescriptor: $j6kQy.createOperationDescriptor,
    createReaderSelector: $cTAdw.createReaderSelector,
    createRequestDescriptor: $j6kQy.createRequestDescriptor,
    getArgumentValues: $boOnJ.getArgumentValues,
    getDataIDsFromFragment: $cTAdw.getDataIDsFromFragment,
    getDataIDsFromObject: $cTAdw.getDataIDsFromObject,
    getNode: $kx3Ii.getNode,
    getFragment: $kx3Ii.getFragment,
    getInlineDataFragment: $kx3Ii.getInlineDataFragment,
    getModuleComponentKey: $boOnJ.getModuleComponentKey,
    getModuleOperationKey: $boOnJ.getModuleOperationKey,
    getPaginationFragment: $kx3Ii.getPaginationFragment,
    getPluralSelector: $cTAdw.getPluralSelector,
    getRefetchableFragment: $kx3Ii.getRefetchableFragment,
    getRequest: $kx3Ii.getRequest,
    getRequestIdentifier: $h8beS,
    getSelector: $cTAdw.getSelector,
    getSelectorsFromObject: $cTAdw.getSelectorsFromObject,
    getSingularSelector: $cTAdw.getSingularSelector,
    getStorageKey: $boOnJ.getStorageKey,
    getVariablesFromFragment: $cTAdw.getVariablesFromFragment,
    getVariablesFromObject: $cTAdw.getVariablesFromObject,
    getVariablesFromPluralFragment: $cTAdw.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $cTAdw.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $fbe8c469291c9f9e$var$handlePotentialSnapshotErrors,
    graphql: $kx3Ii.graphql,
    isErrorResult: $fbe8c469291c9f9e$var$isErrorResult,
    isValueResult: $fbe8c469291c9f9e$var$isValueResult,
    isFragment: $kx3Ii.isFragment,
    isInlineDataFragment: $kx3Ii.isInlineDataFragment,
    isSuspenseSentinel: $fbe8c469291c9f9e$var$isSuspenseSentinel,
    suspenseSentinel: $fbe8c469291c9f9e$var$suspenseSentinel,
    isRequest: $kx3Ii.isRequest,
    readInlineData: $6UUWp,
    MutationTypes: $ioH3s.MutationTypes,
    RangeOperations: $ioH3s.RangeOperations,
    DefaultHandlerProvider: $301e4,
    ConnectionHandler: $aGNBD,
    MutationHandlers: $dlzXy,
    VIEWER_ID: $8Dxz4.VIEWER_ID,
    VIEWER_TYPE: $8Dxz4.VIEWER_TYPE,
    applyOptimisticMutation: $5C6Ki,
    commitLocalUpdate: $M010p,
    commitMutation: $lRc4h,
    fetchQuery: $b5DFS,
    fetchQuery_DEPRECATED: $9VGFV,
    isRelayModernEnvironment: $8V1FJ,
    requestSubscription: $4i4EY,
    ConnectionInterface: $gURLS,
    PreloadableQueryRegistry: $6iwIs,
    RelayProfiler: $gjUUf,
    createPayloadFor3DField: $2hcuI,
    RelayConcreteNode: $dgrHZ,
    RelayError: $jcJkf,
    RelayFeatureFlags: $9nfN5,
    DEFAULT_HANDLE_KEY: $lUb19.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $boOnJ.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $boOnJ.FRAGMENT_OWNER_KEY,
    ID_KEY: $boOnJ.ID_KEY,
    REF_KEY: $boOnJ.REF_KEY,
    REFS_KEY: $boOnJ.REFS_KEY,
    ROOT_ID: $boOnJ.ROOT_ID,
    ROOT_TYPE: $boOnJ.ROOT_TYPE,
    TYPENAME_KEY: $boOnJ.TYPENAME_KEY,
    deepFreeze: $4ERpj,
    generateClientID: $fbe8c469291c9f9e$var$generateClientID,
    generateUniqueClientID: $fbe8c469291c9f9e$var$generateUniqueClientID,
    getRelayHandleKey: $lK1yG,
    isClientID: $fbe8c469291c9f9e$var$isClientID,
    isPromise: $1DbUp,
    isScalarAndEqual: $asMlo,
    recycleNodesInto: $2qPt3,
    stableCopy: $fbe8c469291c9f9e$var$stableCopy,
    hasCycle: $fbe8c469291c9f9e$var$hasCycle,
    getFragmentIdentifier: $eahk4,
    getRefetchMetadata: $jtDJm,
    getPaginationMetadata: $iPEiW,
    getPaginationVariables: $4w68P,
    getPendingOperationsForFragment: $8R95j,
    getValueAtPath: $6Aftc,
    __internal: {
        ResolverFragments: $jVaPD,
        OperationTracker: $gH9zW,
        createRelayContext: $gzFws,
        getOperationVariables: $6zf6P.getOperationVariables,
        getLocalVariables: $6zf6P.getLocalVariables,
        fetchQuery: $1v92Z.fetchQuery,
        fetchQueryDeduped: $1v92Z.fetchQueryDeduped,
        getPromiseForActiveRequest: $1v92Z.getPromiseForActiveRequest,
        getObservableForActiveRequest: $1v92Z.getObservableForActiveRequest,
        normalizeResponse: $94SdE,
        withProvidedVariables: $kDIPG
    }
};

});
parcelRegister("8m1pd", function(module, exports) {
"use strict";

var $9USHc = parcelRequire("9USHc");

var $7xiTF = parcelRequire("7xiTF");
var $615177ec91ed4816$var$observeFragment = $7xiTF.observeFragment;

var $aNyad = parcelRequire("aNyad");
var $615177ec91ed4816$var$waitForFragmentData = $aNyad.waitForFragmentData;
function $615177ec91ed4816$var$isValueResult(input) {
    return input.ok === true;
}
function $615177ec91ed4816$var$isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    resolverDataInjector: $9USHc,
    isValueResult: $615177ec91ed4816$var$isValueResult,
    isErrorResult: $615177ec91ed4816$var$isErrorResult,
    observeFragment: $615177ec91ed4816$var$observeFragment,
    waitForFragmentData: $615177ec91ed4816$var$waitForFragmentData
};

});
parcelRegister("9USHc", function(module, exports) {
"use strict";

var $jVaPD = parcelRequire("jVaPD");
var $7383c57359295091$var$readFragment = $jVaPD.readFragment;

var $aaXwj = parcelRequire("aaXwj");
function $7383c57359295091$var$resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args) {
        var data = $7383c57359295091$var$readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) $aaXwj(false);
                else return resolverFn(null, args);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && $aaXwj(false);
                return resolverFn(data[fieldName], args);
            } else $aaXwj(false);
        } else return resolverFn(data, args);
    };
}
module.exports = $7383c57359295091$var$resolverDataInjector;

});
parcelRegister("jVaPD", function(module, exports) {
"use strict";

var $kx3Ii = parcelRequire("kx3Ii");
var $e80bbe277c954dfc$var$getFragment = $kx3Ii.getFragment;

var $haJc5 = parcelRequire("haJc5");
var $e80bbe277c954dfc$var$eventShouldThrow = $haJc5.eventShouldThrow;

var $cTAdw = parcelRequire("cTAdw");
var $e80bbe277c954dfc$var$getSelector = $cTAdw.getSelector;

var $aaXwj = parcelRequire("aaXwj");
var $e80bbe277c954dfc$var$contextStack = [];
function $e80bbe277c954dfc$var$withResolverContext(context, cb) {
    $e80bbe277c954dfc$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $e80bbe277c954dfc$var$contextStack.pop();
    }
}
function $e80bbe277c954dfc$var$readFragment(fragmentInput, fragmentKey) {
    if (!$e80bbe277c954dfc$var$contextStack.length) throw new Error("readFragment should be called only from within a Relay Resolver function.");
    var context = $e80bbe277c954dfc$var$contextStack[$e80bbe277c954dfc$var$contextStack.length - 1];
    var fragmentNode = $e80bbe277c954dfc$var$getFragment(fragmentInput);
    var fragmentSelector = $e80bbe277c954dfc$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $aaXwj(false);
    !(fragmentSelector.kind === "SingularReaderSelector") && $aaXwj(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, errorResponseFields = _context$getDataForRe.errorResponseFields;
    if (isMissingData || errorResponseFields != null && errorResponseFields.some($e80bbe277c954dfc$var$eventShouldThrow)) throw $e80bbe277c954dfc$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var $e80bbe277c954dfc$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    readFragment: $e80bbe277c954dfc$var$readFragment,
    withResolverContext: $e80bbe277c954dfc$var$withResolverContext,
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: $e80bbe277c954dfc$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL
};

});
parcelRegister("kx3Ii", function(module, exports) {
"use strict";

var $dgrHZ = parcelRequire("dgrHZ");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $ef29c52094055a99$var$graphql(strings) {
    $aaXwj(false);
}
function $ef29c52094055a99$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === "function") node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $ef29c52094055a99$var$isFragment(node) {
    var fragment = $ef29c52094055a99$var$getNode(node);
    return typeof fragment === "object" && fragment !== null && fragment.kind === $dgrHZ.FRAGMENT;
}
function $ef29c52094055a99$var$isRequest(node) {
    var request = $ef29c52094055a99$var$getNode(node);
    return typeof request === "object" && request !== null && request.kind === $dgrHZ.REQUEST;
}
function $ef29c52094055a99$var$isUpdatableQuery(node) {
    var updatableQuery = $ef29c52094055a99$var$getNode(node);
    return typeof updatableQuery === "object" && updatableQuery !== null && updatableQuery.kind === $dgrHZ.UPDATABLE_QUERY;
}
function $ef29c52094055a99$var$isInlineDataFragment(node) {
    var fragment = $ef29c52094055a99$var$getNode(node);
    return typeof fragment === "object" && fragment !== null && fragment.kind === $dgrHZ.INLINE_DATA_FRAGMENT;
}
function $ef29c52094055a99$var$getFragment(taggedNode) {
    var fragment = $ef29c52094055a99$var$getNode(taggedNode);
    !$ef29c52094055a99$var$isFragment(fragment) && $aaXwj(false);
    return fragment;
}
function $ef29c52094055a99$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $ef29c52094055a99$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== "object" || connection === null || typeof connection !== "object") return null;
    return fragment;
}
function $ef29c52094055a99$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $ef29c52094055a99$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== "object") return null;
    return fragment;
}
function $ef29c52094055a99$var$getRequest(taggedNode) {
    var request = $ef29c52094055a99$var$getNode(taggedNode);
    !$ef29c52094055a99$var$isRequest(request) && $aaXwj(false);
    return request;
}
function $ef29c52094055a99$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $ef29c52094055a99$var$getNode(taggedNode);
    !$ef29c52094055a99$var$isUpdatableQuery(updatableQuery) && $aaXwj(false);
    return updatableQuery;
}
function $ef29c52094055a99$var$getInlineDataFragment(taggedNode) {
    var fragment = $ef29c52094055a99$var$getNode(taggedNode);
    !$ef29c52094055a99$var$isInlineDataFragment(fragment) && $aaXwj(false);
    return fragment;
}
module.exports = {
    getFragment: $ef29c52094055a99$var$getFragment,
    getNode: $ef29c52094055a99$var$getNode,
    getPaginationFragment: $ef29c52094055a99$var$getPaginationFragment,
    getRefetchableFragment: $ef29c52094055a99$var$getRefetchableFragment,
    getRequest: $ef29c52094055a99$var$getRequest,
    getUpdatableQuery: $ef29c52094055a99$var$getUpdatableQuery,
    getInlineDataFragment: $ef29c52094055a99$var$getInlineDataFragment,
    graphql: $ef29c52094055a99$var$graphql,
    isFragment: $ef29c52094055a99$var$isFragment,
    isRequest: $ef29c52094055a99$var$isRequest,
    isUpdatableQuery: $ef29c52094055a99$var$isUpdatableQuery,
    isInlineDataFragment: $ef29c52094055a99$var$isInlineDataFragment
};

});
parcelRegister("dgrHZ", function(module, exports) {
"use strict";
var $9a824356cae1ee6d$var$RelayConcreteNode = {
    ACTOR_CHANGE: "ActorChange",
    CATCH_FIELD: "CatchField",
    CONDITION: "Condition",
    CLIENT_COMPONENT: "ClientComponent",
    CLIENT_EDGE_TO_SERVER_OBJECT: "ClientEdgeToServerObject",
    CLIENT_EDGE_TO_CLIENT_OBJECT: "ClientEdgeToClientObject",
    CLIENT_EXTENSION: "ClientExtension",
    DEFER: "Defer",
    CONNECTION: "Connection",
    FRAGMENT: "Fragment",
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_DATA_FRAGMENT_SPREAD: "InlineDataFragmentSpread",
    INLINE_DATA_FRAGMENT: "InlineDataFragment",
    INLINE_FRAGMENT: "InlineFragment",
    LINKED_FIELD: "LinkedField",
    LINKED_HANDLE: "LinkedHandle",
    LITERAL: "Literal",
    LIST_VALUE: "ListValue",
    LOCAL_ARGUMENT: "LocalArgument",
    MODULE_IMPORT: "ModuleImport",
    ALIASED_FRAGMENT_SPREAD: "AliasedFragmentSpread",
    ALIASED_INLINE_FRAGMENT_SPREAD: "AliasedInlineFragmentSpread",
    RELAY_RESOLVER: "RelayResolver",
    RELAY_LIVE_RESOLVER: "RelayLiveResolver",
    REQUIRED_FIELD: "RequiredField",
    OBJECT_VALUE: "ObjectValue",
    OPERATION: "Operation",
    REQUEST: "Request",
    ROOT_ARGUMENT: "RootArgument",
    SCALAR_FIELD: "ScalarField",
    SCALAR_HANDLE: "ScalarHandle",
    SPLIT_OPERATION: "SplitOperation",
    STREAM: "Stream",
    TYPE_DISCRIMINATOR: "TypeDiscriminator",
    UPDATABLE_QUERY: "UpdatableQuery",
    VARIABLE: "Variable"
};
module.exports = $9a824356cae1ee6d$var$RelayConcreteNode;

});

parcelRegister("aaXwj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $768901fea8dbe440$var$invariant;

});

parcelRegister("8Fbfi", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $9Nafg = parcelRequire("9Nafg");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $64eae03bc3a3aaf1$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = "Warning: " + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $64eae03bc3a3aaf1$var$warning = $9Nafg;
module.exports = $64eae03bc3a3aaf1$var$warning;

});
parcelRegister("9Nafg", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $7210a323e2a92597$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $7210a323e2a92597$var$emptyFunction = function emptyFunction() {};
$7210a323e2a92597$var$emptyFunction.thatReturns = $7210a323e2a92597$var$makeEmptyFunction;
$7210a323e2a92597$var$emptyFunction.thatReturnsFalse = $7210a323e2a92597$var$makeEmptyFunction(false);
$7210a323e2a92597$var$emptyFunction.thatReturnsTrue = $7210a323e2a92597$var$makeEmptyFunction(true);
$7210a323e2a92597$var$emptyFunction.thatReturnsNull = $7210a323e2a92597$var$makeEmptyFunction(null);
$7210a323e2a92597$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$7210a323e2a92597$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $7210a323e2a92597$var$emptyFunction;

});



parcelRegister("haJc5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c8066d6c5e3ae4a4$var$_interopRequireDefault = $1jnue.default;

var $c8066d6c5e3ae4a4$var$_createForOfIteratorHelper2 = $c8066d6c5e3ae4a4$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $aaXwj = parcelRequire("aaXwj");
function $c8066d6c5e3ae4a4$var$handleFieldErrors(environment, errorResponseFields) {
    var _iterator = (0, $c8066d6c5e3ae4a4$var$_createForOfIteratorHelper2["default"])(errorResponseFields), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger(fieldError);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, $c8066d6c5e3ae4a4$var$_createForOfIteratorHelper2["default"])(errorResponseFields), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if ($c8066d6c5e3ae4a4$var$eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case "relay_resolver.error":
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case "relay_field_payload.error":
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case "missing_expected_data.throw":
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case "missing_required_field.throw":
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case "missing_required_field.log":
                case "missing_expected_data.log":
                    break;
                default:
                    _fieldError.kind;
                    $aaXwj(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $c8066d6c5e3ae4a4$var$eventShouldThrow(event) {
    switch(event.kind){
        case "relay_resolver.error":
        case "relay_field_payload.error":
            return event.shouldThrow && !event.handled;
        case "missing_expected_data.throw":
        case "missing_required_field.throw":
            return !event.handled;
        case "missing_required_field.log":
        case "missing_expected_data.log":
            return false;
        default:
            event.kind;
            throw new Error("Relay: Unexpected event kind");
    }
}
function $c8066d6c5e3ae4a4$var$handlePotentialSnapshotErrors(environment, errorResponseFields) {
    if (errorResponseFields != null) $c8066d6c5e3ae4a4$var$handleFieldErrors(environment, errorResponseFields);
}
module.exports = {
    handlePotentialSnapshotErrors: $c8066d6c5e3ae4a4$var$handlePotentialSnapshotErrors,
    eventShouldThrow: $c8066d6c5e3ae4a4$var$eventShouldThrow
};

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8QL5z", function(module, exports) {

var $72a6v = parcelRequire("72a6v");
function $6717b4f17c8c4903$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $72a6v(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $6717b4f17c8c4903$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("cTAdw", function(module, exports) {
"use strict";

var $6zf6P = parcelRequire("6zf6P");
var $9636b70b03b82afc$var$getFragmentVariables = $6zf6P.getFragmentVariables;

var $boOnJ = parcelRequire("boOnJ");
var $9636b70b03b82afc$var$CLIENT_EDGE_TRAVERSAL_PATH = $boOnJ.CLIENT_EDGE_TRAVERSAL_PATH, $9636b70b03b82afc$var$FRAGMENT_OWNER_KEY = $boOnJ.FRAGMENT_OWNER_KEY, $9636b70b03b82afc$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $boOnJ.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $9636b70b03b82afc$var$FRAGMENTS_KEY = $boOnJ.FRAGMENTS_KEY, $9636b70b03b82afc$var$ID_KEY = $boOnJ.ID_KEY;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $9636b70b03b82afc$var$getSingularSelector(fragment, item) {
    !(typeof item === "object" && item !== null && !Array.isArray(item)) && $aaXwj(false);
    var dataID = item[$9636b70b03b82afc$var$ID_KEY];
    var fragments = item[$9636b70b03b82afc$var$FRAGMENTS_KEY];
    var mixedOwner = item[$9636b70b03b82afc$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$9636b70b03b82afc$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === "string" && typeof fragments === "object" && fragments !== null && typeof fragments[fragment.name] === "object" && fragments[fragment.name] !== null && typeof mixedOwner === "object" && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $9636b70b03b82afc$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$9636b70b03b82afc$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $9636b70b03b82afc$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $9636b70b03b82afc$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $9636b70b03b82afc$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: "PluralReaderSelector",
        selectors: selectors
    };
}
function $9636b70b03b82afc$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $aaXwj(false);
        return $9636b70b03b82afc$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $aaXwj(false);
        return $9636b70b03b82afc$var$getSingularSelector(fragment, item);
    }
}
function $9636b70b03b82afc$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $9636b70b03b82afc$var$getSelector(fragment, item);
    }
    return selectors;
}
function $9636b70b03b82afc$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $9636b70b03b82afc$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $9636b70b03b82afc$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $aaXwj(false);
        return $9636b70b03b82afc$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $aaXwj(false);
        return $9636b70b03b82afc$var$getDataID(fragment, item);
    }
}
function $9636b70b03b82afc$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $9636b70b03b82afc$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $9636b70b03b82afc$var$getDataID(fragment, item) {
    !(typeof item === "object" && item !== null && !Array.isArray(item)) && $aaXwj(false);
    var dataID = item[$9636b70b03b82afc$var$ID_KEY];
    if (typeof dataID === "string") return dataID;
    return null;
}
function $9636b70b03b82afc$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $9636b70b03b82afc$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $9636b70b03b82afc$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $aaXwj(false);
        return $9636b70b03b82afc$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $aaXwj(false);
        return $9636b70b03b82afc$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $9636b70b03b82afc$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $9636b70b03b82afc$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $9636b70b03b82afc$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $9636b70b03b82afc$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $9636b70b03b82afc$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $ewhZB(thisSelector.variables, thatSelector.variables) && $9636b70b03b82afc$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $9636b70b03b82afc$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $9636b70b03b82afc$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $ewhZB(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $9636b70b03b82afc$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $9636b70b03b82afc$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === "SingularReaderSelector" && b.kind === "SingularReaderSelector") return $9636b70b03b82afc$var$areEqualSingularSelectors(a, b);
    else if (a.kind === "PluralReaderSelector" && b.kind === "PluralReaderSelector") return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $9636b70b03b82afc$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $9636b70b03b82afc$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: "SingularReaderSelector",
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $9636b70b03b82afc$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $9636b70b03b82afc$var$areEqualSelectors,
    createReaderSelector: $9636b70b03b82afc$var$createReaderSelector,
    createNormalizationSelector: $9636b70b03b82afc$var$createNormalizationSelector,
    getDataIDsFromFragment: $9636b70b03b82afc$var$getDataIDsFromFragment,
    getDataIDsFromObject: $9636b70b03b82afc$var$getDataIDsFromObject,
    getSingularSelector: $9636b70b03b82afc$var$getSingularSelector,
    getPluralSelector: $9636b70b03b82afc$var$getPluralSelector,
    getSelector: $9636b70b03b82afc$var$getSelector,
    getSelectorsFromObject: $9636b70b03b82afc$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $9636b70b03b82afc$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $9636b70b03b82afc$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $9636b70b03b82afc$var$getVariablesFromFragment,
    getVariablesFromObject: $9636b70b03b82afc$var$getVariablesFromObject
};

});
parcelRegister("6zf6P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4c81bb5242c8fa9f$var$_interopRequireDefault = $1jnue.default;

var $4c81bb5242c8fa9f$var$_objectSpread2 = $4c81bb5242c8fa9f$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $boOnJ = parcelRequire("boOnJ");
var $4c81bb5242c8fa9f$var$getArgumentValues = $boOnJ.getArgumentValues;

var $aaXwj = parcelRequire("aaXwj");
function $4c81bb5242c8fa9f$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $4c81bb5242c8fa9f$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case "LocalArgument":
                variables[definition.name] = definition.defaultValue;
                break;
            case "RootArgument":
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $aaXwj(false);
        }
    });
    return variables || argumentVariables;
}
function $4c81bb5242c8fa9f$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $4c81bb5242c8fa9f$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $4c81bb5242c8fa9f$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $4c81bb5242c8fa9f$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $4c81bb5242c8fa9f$var$getLocalVariables,
    getFragmentVariables: $4c81bb5242c8fa9f$var$getFragmentVariables,
    getOperationVariables: $4c81bb5242c8fa9f$var$getOperationVariables
};

});
parcelRegister("cbdLd", function(module, exports) {

var $g5Zhu = parcelRequire("g5Zhu");
function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $g5Zhu(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $8de12fa6a893dcd1$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("boOnJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $84c9045945c93bb8$var$_interopRequireDefault = $1jnue.default;

var $84c9045945c93bb8$var$_toConsumableArray2 = $84c9045945c93bb8$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $lK1yG = parcelRequire("lK1yG");

var $dgrHZ = parcelRequire("dgrHZ");

var $a9M0M = parcelRequire("a9M0M");
var $84c9045945c93bb8$var$stableCopy = $a9M0M.stableCopy;

var $aaXwj = parcelRequire("aaXwj");
var $84c9045945c93bb8$var$VARIABLE = $dgrHZ.VARIABLE, $84c9045945c93bb8$var$LITERAL = $dgrHZ.LITERAL, $84c9045945c93bb8$var$OBJECT_VALUE = $dgrHZ.OBJECT_VALUE, $84c9045945c93bb8$var$LIST_VALUE = $dgrHZ.LIST_VALUE;
var $84c9045945c93bb8$var$ERRORS_KEY = "__errors";
var $84c9045945c93bb8$var$MODULE_COMPONENT_KEY_PREFIX = "__module_component_";
var $84c9045945c93bb8$var$MODULE_OPERATION_KEY_PREFIX = "__module_operation_";
function $84c9045945c93bb8$var$getArgumentValue(arg, variables) {
    if (arg.kind === $84c9045945c93bb8$var$VARIABLE) return $84c9045945c93bb8$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $84c9045945c93bb8$var$LITERAL) return arg.value;
    else if (arg.kind === $84c9045945c93bb8$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $84c9045945c93bb8$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $84c9045945c93bb8$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($84c9045945c93bb8$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $84c9045945c93bb8$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$84c9045945c93bb8$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $84c9045945c93bb8$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $84c9045945c93bb8$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $lK1yG(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $84c9045945c93bb8$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $84c9045945c93bb8$var$formatStorageKey(handleName, $84c9045945c93bb8$var$getArgumentValues(filterArgs, variables));
}
function $84c9045945c93bb8$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $84c9045945c93bb8$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $84c9045945c93bb8$var$formatStorageKey(name, $84c9045945c93bb8$var$getArgumentValues(args, variables)) : name;
}
function $84c9045945c93bb8$var$getArguments(field) {
    if (field.kind === "RelayResolver" || field.kind === "RelayLiveResolver") {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === "undefined" ? undefined : field.args;
    return args;
}
function $84c9045945c93bb8$var$getStableStorageKey(name, args) {
    return $84c9045945c93bb8$var$formatStorageKey(name, $84c9045945c93bb8$var$stableCopy(args));
}
function $84c9045945c93bb8$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ":" + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "undefined"));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(","), ")");
}
function $84c9045945c93bb8$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $aaXwj(false);
    return $84c9045945c93bb8$var$stableCopy(variables[name]);
}
function $84c9045945c93bb8$var$getModuleComponentKey(documentName) {
    return "".concat($84c9045945c93bb8$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $84c9045945c93bb8$var$getModuleOperationKey(documentName) {
    return "".concat($84c9045945c93bb8$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $84c9045945c93bb8$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: "__actorIdentifier",
    CLIENT_EDGE_TRAVERSAL_PATH: "__clientEdgeTraversalPath",
    FRAGMENTS_KEY: "__fragments",
    FRAGMENT_OWNER_KEY: "__fragmentOwner",
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: "$isWithinUnmatchedTypeRefinement",
    FRAGMENT_PROP_NAME_KEY: "__fragmentPropName",
    MODULE_COMPONENT_KEY: "__module_component",
    ERRORS_KEY: $84c9045945c93bb8$var$ERRORS_KEY,
    ID_KEY: "__id",
    REF_KEY: "__ref",
    REFS_KEY: "__refs",
    ROOT_ID: "client:root",
    ROOT_TYPE: "__Root",
    TYPENAME_KEY: "__typename",
    INVALIDATED_AT_KEY: "__invalidated_at",
    RELAY_RESOLVER_VALUE_KEY: "__resolverValue",
    RELAY_RESOLVER_INVALIDATION_KEY: "__resolverValueMayBeInvalid",
    RELAY_RESOLVER_SNAPSHOT_KEY: "__resolverSnapshot",
    RELAY_RESOLVER_ERROR_KEY: "__resolverError",
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: "__resolverOutputTypeRecordIDs",
    formatStorageKey: $84c9045945c93bb8$var$formatStorageKey,
    getArgumentValue: $84c9045945c93bb8$var$getArgumentValue,
    getArgumentValues: $84c9045945c93bb8$var$getArgumentValues,
    getHandleStorageKey: $84c9045945c93bb8$var$getHandleStorageKey,
    getStorageKey: $84c9045945c93bb8$var$getStorageKey,
    getStableStorageKey: $84c9045945c93bb8$var$getStableStorageKey,
    getModuleComponentKey: $84c9045945c93bb8$var$getModuleComponentKey,
    getModuleOperationKey: $84c9045945c93bb8$var$getModuleOperationKey
};
module.exports = $84c9045945c93bb8$var$RelayStoreUtils;

});
parcelRegister("fUHKi", function(module, exports) {

var $5F6pO = parcelRequire("5F6pO");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $8UrHA = parcelRequire("8UrHA");
function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $5F6pO(r) || $hAHB6(r) || $72a6v(r) || $8UrHA();
}
module.exports = $b95e04f2d4c66124$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5F6pO", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2zZPz(r);
}
module.exports = $41f5c206613f56c9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hAHB6", function(module, exports) {
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cce79e023a3a67e7$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8UrHA", function(module, exports) {
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $67c90abe6042aecd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lK1yG", function(module, exports) {
"use strict";

var $lUb19 = parcelRequire("lUb19");
var $fd3f1a567926258f$var$DEFAULT_HANDLE_KEY = $lUb19.DEFAULT_HANDLE_KEY;

var $aaXwj = parcelRequire("aaXwj");
function $fd3f1a567926258f$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $fd3f1a567926258f$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $aaXwj(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $fd3f1a567926258f$var$getRelayHandleKey;

});
parcelRegister("lUb19", function(module, exports) {
"use strict";
module.exports = {
    DEFAULT_HANDLE_KEY: ""
};

});


parcelRegister("a9M0M", function(module, exports) {
"use strict";
function $764ffcc38fcab5b8$var$stableCopy(value) {
    if (!value || typeof value !== "object") return value;
    if (Array.isArray(value)) return value.map($764ffcc38fcab5b8$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $764ffcc38fcab5b8$var$stableCopy(value[keys[i]]);
    return stable;
}
function $764ffcc38fcab5b8$var$hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== "object") return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return $764ffcc38fcab5b8$var$hasCycle(v, newParents);
    });
}
module.exports = {
    stableCopy: $764ffcc38fcab5b8$var$stableCopy,
    hasCycle: $764ffcc38fcab5b8$var$hasCycle
};

});



parcelRegister("ewhZB", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $a92202c86788587e$var$aStackPool = [];
var $a92202c86788587e$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $a92202c86788587e$var$areEqual(a, b) {
    var aStack = $a92202c86788587e$var$aStackPool.length ? $a92202c86788587e$var$aStackPool.pop() : [];
    var bStack = $a92202c86788587e$var$bStackPool.length ? $a92202c86788587e$var$bStackPool.pop() : [];
    var result = $a92202c86788587e$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $a92202c86788587e$var$aStackPool.push(aStack);
    $a92202c86788587e$var$bStackPool.push(bStack);
    return result;
}
function $a92202c86788587e$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != "object" || typeof b != "object") return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case "[object String]":
            return a == String(b);
        case "[object Number]":
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case "[object Date]":
        case "[object Boolean]":
            return +a == +b;
        case "[object RegExp]":
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === "[object Array]") {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$a92202c86788587e$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty("valueOf") && b.hasOwnProperty("valueOf")) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$a92202c86788587e$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $a92202c86788587e$var$areEqual;

});




parcelRegister("7xiTF", function(module, exports) {
"use strict";

var $fOd0O = parcelRequire("fOd0O");
var $57ca45f97a43f14b$require$_asyncToGenerator = $fOd0O.default;

var $jJlPe = parcelRequire("jJlPe");

var $kx3Ii = parcelRequire("kx3Ii");
var $57ca45f97a43f14b$var$getFragment = $kx3Ii.getFragment;

var $8R95j = parcelRequire("8R95j");

var $haJc5 = parcelRequire("haJc5");
var $57ca45f97a43f14b$var$handlePotentialSnapshotErrors = $haJc5.handlePotentialSnapshotErrors;

var $cTAdw = parcelRequire("cTAdw");
var $57ca45f97a43f14b$var$getSelector = $cTAdw.getSelector;

var $aaXwj = parcelRequire("aaXwj");
function $57ca45f97a43f14b$var$waitForFragmentData(_x, _x2, _x3) {
    return $57ca45f97a43f14b$var$_waitForFragmentData.apply(this, arguments);
}
function $57ca45f97a43f14b$var$_waitForFragmentData() {
    $57ca45f97a43f14b$var$_waitForFragmentData = $57ca45f97a43f14b$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $57ca45f97a43f14b$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === "ok") resolve(val.value);
                        else if (val.state === "error") reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $57ca45f97a43f14b$var$_waitForFragmentData.apply(this, arguments);
}
function $57ca45f97a43f14b$var$observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = $57ca45f97a43f14b$var$getFragment(fragment);
    var fragmentSelector = $57ca45f97a43f14b$var$getSelector(fragmentNode, fragmentRef);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null) && $aaXwj(false);
    !(fragmentSelector != null) && $aaXwj(false);
    switch(fragmentSelector.kind){
        case "SingularReaderSelector":
            return $57ca45f97a43f14b$var$observeSelector(environment, fragment, fragmentSelector);
        case "PluralReaderSelector":
            $aaXwj(false);
    }
    $aaXwj(false);
}
function $57ca45f97a43f14b$var$observeSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return $jJlPe.create(function(sink) {
        sink.next($57ca45f97a43f14b$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next($57ca45f97a43f14b$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function $57ca45f97a43f14b$var$snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: "loading"
    };
    if (snapshot.isMissingData) {
        var pendingOperations = $8R95j(environment, fragmentNode, owner);
        if (pendingOperations != null) return {
            state: "loading"
        };
    }
    try {
        $57ca45f97a43f14b$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
    } catch (error) {
        return {
            error: error,
            state: "error"
        };
    }
    !(snapshot.data != null) && $aaXwj(false);
    return {
        state: "ok",
        value: snapshot.data
    };
}
module.exports = {
    observeFragment: $57ca45f97a43f14b$var$observeFragment,
    waitForFragmentData: $57ca45f97a43f14b$var$waitForFragmentData
};

});
parcelRegister("fOd0O", function(module, exports) {
function $b8259e79f5c77a6f$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b8259e79f5c77a6f$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $b8259e79f5c77a6f$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jJlPe", function(module, exports) {
"use strict";

var $1DbUp = parcelRequire("1DbUp");
var $e5d32657c8f95eb7$var$hostReportError = $e5d32657c8f95eb7$var$swallowError;
var $e5d32657c8f95eb7$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $e5d32657c8f95eb7$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $e5d32657c8f95eb7$var$isObservable(obj) ? $e5d32657c8f95eb7$var$fromObservable(obj) : $1DbUp(obj) ? $e5d32657c8f95eb7$var$fromPromise(obj) : $e5d32657c8f95eb7$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $e5d32657c8f95eb7$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both("start"),
                next: both("next"),
                error: both("error"),
                complete: both("complete"),
                unsubscribe: both("unsubscribe")
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $e5d32657c8f95eb7$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $e5d32657c8f95eb7$var$isObservable(obj) {
    return typeof obj === "object" && obj !== null && typeof obj.subscribe === "function";
}
function $e5d32657c8f95eb7$var$fromObservable(obj) {
    return obj instanceof $e5d32657c8f95eb7$var$RelayObservable ? obj : $e5d32657c8f95eb7$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $e5d32657c8f95eb7$var$fromPromise(promise) {
    return $e5d32657c8f95eb7$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $e5d32657c8f95eb7$var$fromValue(value) {
    return $e5d32657c8f95eb7$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $e5d32657c8f95eb7$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, "closed", {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $e5d32657c8f95eb7$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $e5d32657c8f95eb7$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $e5d32657c8f95eb7$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $e5d32657c8f95eb7$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $e5d32657c8f95eb7$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $e5d32657c8f95eb7$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $e5d32657c8f95eb7$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $e5d32657c8f95eb7$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $e5d32657c8f95eb7$var$RelayObservable;

});
parcelRegister("1DbUp", function(module, exports) {
"use strict";
function $1302abd4177f7282$var$isPromise(p) {
    return p != null && typeof p === "object" && typeof p.then === "function";
}
module.exports = $1302abd4177f7282$var$isPromise;

});


parcelRegister("8R95j", function(module, exports) {
"use strict";

var $1v92Z = parcelRequire("1v92Z");
var $672a51ffb741191a$var$getPromiseForActiveRequest = $1v92Z.getPromiseForActiveRequest;
function $672a51ffb741191a$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $672a51ffb741191a$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(",")) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = "Unknown pending operation";
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: "pendingoperation.found",
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $672a51ffb741191a$var$getPendingOperationsForFragment;

});
parcelRegister("1v92Z", function(module, exports) {
"use strict";

var $jJlPe = parcelRequire("jJlPe");

var $3leo0 = parcelRequire("3leo0");

var $aaXwj = parcelRequire("aaXwj");
var $117fb44d34063416$var$WEAKMAP_SUPPORTED = typeof WeakMap === "function";
var $117fb44d34063416$var$requestCachesByEnvironment = $117fb44d34063416$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $117fb44d34063416$var$fetchQuery(environment, operation) {
    return $117fb44d34063416$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $117fb44d34063416$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $jJlPe.create(function(sink) {
        var requestCache = $117fb44d34063416$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $3leo0(),
                    subjectForInFlightStatus: new $3leo0(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $117fb44d34063416$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $117fb44d34063416$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $117fb44d34063416$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $117fb44d34063416$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $aaXwj(false);
        return $117fb44d34063416$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $117fb44d34063416$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $jJlPe.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $117fb44d34063416$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $jJlPe.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $117fb44d34063416$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $117fb44d34063416$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $117fb44d34063416$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $117fb44d34063416$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $117fb44d34063416$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $117fb44d34063416$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $117fb44d34063416$var$getRequestCache(environment) {
    var cached = $117fb44d34063416$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $117fb44d34063416$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $117fb44d34063416$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $aaXwj(false);
    return cached;
}
module.exports = {
    fetchQuery: $117fb44d34063416$var$fetchQuery,
    fetchQueryDeduped: $117fb44d34063416$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $117fb44d34063416$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $117fb44d34063416$var$getObservableForActiveRequest
};

});
parcelRegister("3leo0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $26ee7e14e4588005$var$_interopRequireDefault = $1jnue.default;

var $26ee7e14e4588005$var$_createForOfIteratorHelper2 = $26ee7e14e4588005$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $26ee7e14e4588005$var$_defineProperty2 = $26ee7e14e4588005$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $jJlPe = parcelRequire("jJlPe");

var $aaXwj = parcelRequire("aaXwj");
var $26ee7e14e4588005$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $26ee7e14e4588005$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $26ee7e14e4588005$var$_defineProperty2["default"])(this, "_events", []);
        (0, $26ee7e14e4588005$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $26ee7e14e4588005$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $jJlPe.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case "complete":
                        sink.complete();
                        break;
                    case "error":
                        sink.error(event.error);
                        break;
                    case "next":
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $aaXwj(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: "complete"
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: "error",
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: "next",
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $26ee7e14e4588005$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $26ee7e14e4588005$var$RelayReplaySubject;

});




parcelRegister("aNyad", function(module, exports) {
"use strict";

var $fOd0O = parcelRequire("fOd0O");
var $7dc8fb39113317cd$require$_asyncToGenerator = $fOd0O.default;

var $7xiTF = parcelRequire("7xiTF");
var $7dc8fb39113317cd$var$observeFragment = $7xiTF.observeFragment;
function $7dc8fb39113317cd$var$waitForFragmentData(_x, _x2, _x3) {
    return $7dc8fb39113317cd$var$_waitForFragmentData.apply(this, arguments);
}
function $7dc8fb39113317cd$var$_waitForFragmentData() {
    $7dc8fb39113317cd$var$_waitForFragmentData = $7dc8fb39113317cd$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $7dc8fb39113317cd$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === "ok") resolve(val.value);
                        else if (val.state === "error") reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $7dc8fb39113317cd$var$_waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: $7dc8fb39113317cd$var$waitForFragmentData
};

});


parcelRegister("aGNBD", function(module, exports) {
"use strict";

var $2Zm5L = parcelRequire("2Zm5L");
var $7c844e52b9c2a187$var$generateClientID = $2Zm5L.generateClientID;

var $boOnJ = parcelRequire("boOnJ");
var $7c844e52b9c2a187$var$getStableStorageKey = $boOnJ.getStableStorageKey;

var $lK1yG = parcelRequire("lK1yG");

var $gURLS = parcelRequire("gURLS");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $7c844e52b9c2a187$var$CONNECTION = "connection";
var $7c844e52b9c2a187$var$NEXT_EDGE_INDEX = "__connection_next_edge_index";
function $7c844e52b9c2a187$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $gURLS.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = $7c844e52b9c2a187$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $7c844e52b9c2a187$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $7c844e52b9c2a187$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($7c844e52b9c2a187$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $7c844e52b9c2a187$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $7c844e52b9c2a187$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $7c844e52b9c2a187$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $7c844e52b9c2a187$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $7c844e52b9c2a187$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === "string") clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === "string") clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $7c844e52b9c2a187$var$getConnection(record, key, filters) {
    var handleKey = $lK1yG($7c844e52b9c2a187$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $7c844e52b9c2a187$var$getConnectionID(recordID, key, filters) {
    var handleKey = $lK1yG($7c844e52b9c2a187$var$CONNECTION, key, null);
    var storageKey = $7c844e52b9c2a187$var$getStableStorageKey(handleKey, filters);
    return $7c844e52b9c2a187$var$generateClientID(recordID, storageKey);
}
function $7c844e52b9c2a187$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $gURLS.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $7c844e52b9c2a187$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $gURLS.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $7c844e52b9c2a187$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue("cursor") == null) edge.setValue(null, "cursor");
    return edge;
}
function $7c844e52b9c2a187$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $gURLS.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $7c844e52b9c2a187$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $gURLS.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $7c844e52b9c2a187$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $gURLS.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($7c844e52b9c2a187$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === "number") && $aaXwj(false);
    var edgeID = $7c844e52b9c2a187$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue("cursor") == null) connectionEdge.setValue(null, "cursor");
    connection.setValue(edgeIndex + 1, $7c844e52b9c2a187$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $7c844e52b9c2a187$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $gURLS.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $7c844e52b9c2a187$var$buildConnectionEdge,
    createEdge: $7c844e52b9c2a187$var$createEdge,
    deleteNode: $7c844e52b9c2a187$var$deleteNode,
    getConnection: $7c844e52b9c2a187$var$getConnection,
    getConnectionID: $7c844e52b9c2a187$var$getConnectionID,
    insertEdgeAfter: $7c844e52b9c2a187$var$insertEdgeAfter,
    insertEdgeBefore: $7c844e52b9c2a187$var$insertEdgeBefore,
    update: $7c844e52b9c2a187$var$update
};

});
parcelRegister("2Zm5L", function(module, exports) {
"use strict";

var $9nfN5 = parcelRequire("9nfN5");

var $ib6Cf = parcelRequire("ib6Cf");
var $22d26a489e9aa6ac$var$intern = $ib6Cf.intern;
var $22d26a489e9aa6ac$var$PREFIX = "client:";
function $22d26a489e9aa6ac$var$generateClientID(id, storageKey, index) {
    var internedId = $9nfN5.STRING_INTERN_LEVEL <= 0 ? id : $22d26a489e9aa6ac$var$intern(id, $9nfN5.MAX_DATA_ID_LENGTH);
    var key = internedId + ":" + storageKey;
    if (index != null) key += ":" + index;
    if (key.indexOf($22d26a489e9aa6ac$var$PREFIX) !== 0) key = $22d26a489e9aa6ac$var$PREFIX + key;
    return key;
}
function $22d26a489e9aa6ac$var$isClientID(id) {
    return id.indexOf($22d26a489e9aa6ac$var$PREFIX) === 0;
}
var $22d26a489e9aa6ac$var$localID = 0;
function $22d26a489e9aa6ac$var$generateUniqueClientID() {
    return "".concat($22d26a489e9aa6ac$var$PREFIX, "local:").concat($22d26a489e9aa6ac$var$localID++);
}
function $22d26a489e9aa6ac$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($22d26a489e9aa6ac$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ":" + index;
    return key;
}
module.exports = {
    generateClientID: $22d26a489e9aa6ac$var$generateClientID,
    generateClientObjectClientID: $22d26a489e9aa6ac$var$generateClientObjectClientID,
    generateUniqueClientID: $22d26a489e9aa6ac$var$generateUniqueClientID,
    isClientID: $22d26a489e9aa6ac$var$isClientID
};

});
parcelRegister("9nfN5", function(module, exports) {
"use strict";
var $6d3282c16ab9bd89$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: false,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true
};
module.exports = $6d3282c16ab9bd89$var$RelayFeatureFlags;

});

parcelRegister("ib6Cf", function(module, exports) {
"use strict";
var $d3be62da2bbe19be$var$internTable = new Map();
var $d3be62da2bbe19be$var$nextIndex = 1;
var $d3be62da2bbe19be$var$digits = $d3be62da2bbe19be$var$initDigitTable();
var $d3be62da2bbe19be$var$INTERN_PREFIX = "	";
var $d3be62da2bbe19be$var$ESCAPE_PREFIX = "\v";
function $d3be62da2bbe19be$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $d3be62da2bbe19be$var$escape(str) {
    if (str[0] === $d3be62da2bbe19be$var$INTERN_PREFIX && $d3be62da2bbe19be$var$digits.has(str[1]) || str[0] === $d3be62da2bbe19be$var$ESCAPE_PREFIX) return $d3be62da2bbe19be$var$ESCAPE_PREFIX + str;
    return str;
}
function $d3be62da2bbe19be$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $d3be62da2bbe19be$var$escape(str);
    var internedString = $d3be62da2bbe19be$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $d3be62da2bbe19be$var$INTERN_PREFIX + $d3be62da2bbe19be$var$nextIndex++;
    $d3be62da2bbe19be$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $d3be62da2bbe19be$var$intern
};

});


parcelRegister("gURLS", function(module, exports) {
"use strict";
var $c50b9628b5012d1a$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $c50b9628b5012d1a$var$config = {
    CURSOR: "cursor",
    EDGES: "edges",
    END_CURSOR: "endCursor",
    HAS_NEXT_PAGE: "hasNextPage",
    HAS_PREV_PAGE: "hasPreviousPage",
    NODE: "node",
    PAGE_INFO_TYPE: "PageInfo",
    PAGE_INFO: "pageInfo",
    START_CURSOR: "startCursor"
};
var $c50b9628b5012d1a$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $c50b9628b5012d1a$var$config = newConfig;
    },
    get: function get() {
        return $c50b9628b5012d1a$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $c50b9628b5012d1a$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $c50b9628b5012d1a$var$ConnectionInterface;

});


parcelRegister("dlzXy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9b79215ae8b95c1d$var$_interopRequireDefault = $1jnue.default;

var $9b79215ae8b95c1d$var$_createForOfIteratorHelper2 = $9b79215ae8b95c1d$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $aGNBD = parcelRequire("aGNBD");

var $gURLS = parcelRequire("gURLS");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $9b79215ae8b95c1d$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === "string") store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === "string") store["delete"](id);
            });
        }
    }
};
var $9b79215ae8b95c1d$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $aaXwj(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === "string") {
                var _iterator = (0, $9b79215ae8b95c1d$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $aGNBD.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $9b79215ae8b95c1d$var$AppendEdgeHandler = {
    update: $9b79215ae8b95c1d$var$edgeUpdater($aGNBD.insertEdgeAfter)
};
var $9b79215ae8b95c1d$var$PrependEdgeHandler = {
    update: $9b79215ae8b95c1d$var$edgeUpdater($aGNBD.insertEdgeBefore)
};
var $9b79215ae8b95c1d$var$AppendNodeHandler = {
    update: $9b79215ae8b95c1d$var$nodeUpdater($aGNBD.insertEdgeAfter)
};
var $9b79215ae8b95c1d$var$PrependNodeHandler = {
    update: $9b79215ae8b95c1d$var$nodeUpdater($aGNBD.insertEdgeBefore)
};
function $9b79215ae8b95c1d$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $aaXwj(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $gURLS.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $9b79215ae8b95c1d$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord("node");
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $9b79215ae8b95c1d$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $aGNBD.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $aaXwj(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $9b79215ae8b95c1d$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $aaXwj(false);
        !(edgeTypeName != null) && $aaXwj(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $gURLS.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $9b79215ae8b95c1d$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $9b79215ae8b95c1d$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $aGNBD.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $aaXwj(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $9b79215ae8b95c1d$var$AppendEdgeHandler,
    DeleteRecordHandler: $9b79215ae8b95c1d$var$DeleteRecordHandler,
    PrependEdgeHandler: $9b79215ae8b95c1d$var$PrependEdgeHandler,
    AppendNodeHandler: $9b79215ae8b95c1d$var$AppendNodeHandler,
    PrependNodeHandler: $9b79215ae8b95c1d$var$PrependNodeHandler,
    DeleteEdgeHandler: $9b79215ae8b95c1d$var$DeleteEdgeHandler
};

});

parcelRegister("301e4", function(module, exports) {
"use strict";

var $aGNBD = parcelRequire("aGNBD");

var $dlzXy = parcelRequire("dlzXy");

var $aaXwj = parcelRequire("aaXwj");
function $22f252a390ac995c$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case "connection":
            return $aGNBD;
        case "deleteRecord":
            return $dlzXy.DeleteRecordHandler;
        case "deleteEdge":
            return $dlzXy.DeleteEdgeHandler;
        case "appendEdge":
            return $dlzXy.AppendEdgeHandler;
        case "prependEdge":
            return $dlzXy.PrependEdgeHandler;
        case "appendNode":
            return $dlzXy.AppendNodeHandler;
        case "prependNode":
            return $dlzXy.PrependNodeHandler;
    }
    $aaXwj(false);
}
module.exports = $22f252a390ac995c$var$RelayDefaultHandlerProvider;

});

parcelRegister("5C6Ki", function(module, exports) {
"use strict";

var $kx3Ii = parcelRequire("kx3Ii");
var $4165bbf018fb2fcf$var$getRequest = $kx3Ii.getRequest;

var $8V1FJ = parcelRequire("8V1FJ");

var $j6kQy = parcelRequire("j6kQy");
var $4165bbf018fb2fcf$var$createOperationDescriptor = $j6kQy.createOperationDescriptor;

var $ioH3s = parcelRequire("ioH3s");

var $aaXwj = parcelRequire("aaXwj");
function $4165bbf018fb2fcf$var$applyOptimisticMutation(environment, config) {
    !$8V1FJ(environment) && $aaXwj(false);
    var mutation = $4165bbf018fb2fcf$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== "mutation") throw new Error("commitMutation: Expected mutation operation");
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $4165bbf018fb2fcf$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $ioH3s.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $4165bbf018fb2fcf$var$applyOptimisticMutation;

});
parcelRegister("8V1FJ", function(module, exports) {
"use strict";
function $67e4f19f39079f0a$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment["@@RelayModernEnvironment"]);
}
module.exports = $67e4f19f39079f0a$var$isRelayModernEnvironment;

});

parcelRegister("j6kQy", function(module, exports) {
"use strict";
parcelRequire("4ERpj");

var $h8beS = parcelRequire("h8beS");

var $9nfN5 = parcelRequire("9nfN5");

var $a9M0M = parcelRequire("a9M0M");
var $de7ebf8bd4eb66d9$var$hasCycle = $a9M0M.hasCycle;

var $6zf6P = parcelRequire("6zf6P");
var $de7ebf8bd4eb66d9$var$getOperationVariables = $6zf6P.getOperationVariables;

var $cTAdw = parcelRequire("cTAdw");
var $de7ebf8bd4eb66d9$var$createNormalizationSelector = $cTAdw.createNormalizationSelector, $de7ebf8bd4eb66d9$var$createReaderSelector = $cTAdw.createReaderSelector;

var $boOnJ = parcelRequire("boOnJ");
var $de7ebf8bd4eb66d9$var$ROOT_ID = $boOnJ.ROOT_ID;

var $aaXwj = parcelRequire("aaXwj");
function $de7ebf8bd4eb66d9$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $de7ebf8bd4eb66d9$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $de7ebf8bd4eb66d9$var$getOperationVariables(operation, request.params.providedVariables, variables);
    if ($9nfN5.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!$de7ebf8bd4eb66d9$var$hasCycle(operationVariables) && $aaXwj(false);
    var requestDescriptor = $de7ebf8bd4eb66d9$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $de7ebf8bd4eb66d9$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $de7ebf8bd4eb66d9$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $de7ebf8bd4eb66d9$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $h8beS(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $de7ebf8bd4eb66d9$var$createOperationDescriptor,
    createRequestDescriptor: $de7ebf8bd4eb66d9$var$createRequestDescriptor
};

});
parcelRegister("4ERpj", function(module, exports) {
"use strict";
function $36445368d7b251ad$var$deepFreeze(object) {
    if (!$36445368d7b251ad$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === "object" && !Object.isFrozen(property)) $36445368d7b251ad$var$deepFreeze(property);
    });
    return object;
}
function $36445368d7b251ad$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === "object" && value.constructor === Object);
}
module.exports = $36445368d7b251ad$var$deepFreeze;

});

parcelRegister("h8beS", function(module, exports) {
"use strict";

var $a9M0M = parcelRequire("a9M0M");
var $c78be6dac9fc9f45$var$stableCopy = $a9M0M.stableCopy;

var $aaXwj = parcelRequire("aaXwj");
function $c78be6dac9fc9f45$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $aaXwj(false);
    return requestID + JSON.stringify($c78be6dac9fc9f45$var$stableCopy(variables));
}
module.exports = $c78be6dac9fc9f45$var$getRequestIdentifier;

});


parcelRegister("ioH3s", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d64bddab5328fcec$var$_interopRequireDefault = $1jnue.default;

var $d64bddab5328fcec$var$_createForOfIteratorHelper2 = $d64bddab5328fcec$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $aGNBD = parcelRequire("aGNBD");
parcelRequire("8Fbfi");
var $d64bddab5328fcec$var$MutationTypes = Object.freeze({
    RANGE_ADD: "RANGE_ADD",
    RANGE_DELETE: "RANGE_DELETE",
    NODE_DELETE: "NODE_DELETE"
});
var $d64bddab5328fcec$var$RangeOperations = Object.freeze({
    APPEND: "append",
    PREPEND: "prepend"
});
function $d64bddab5328fcec$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case "NODE_DELETE":
                var nodeDeleteResult = $d64bddab5328fcec$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case "RANGE_ADD":
                var rangeAddResult = $d64bddab5328fcec$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case "RANGE_DELETE":
                var rangeDeleteResult = $d64bddab5328fcec$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $d64bddab5328fcec$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $d64bddab5328fcec$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === "string") store["delete"](id);
        });
    };
}
function $d64bddab5328fcec$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $d64bddab5328fcec$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $d64bddab5328fcec$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $aGNBD.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $aGNBD.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case "append":
                        $aGNBD.insertEdgeAfter(connection, clientEdge);
                        break;
                    case "prepend":
                        $aGNBD.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $d64bddab5328fcec$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $d64bddab5328fcec$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $d64bddab5328fcec$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === "object") deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === "object" && typeof idObject.id === "string") deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === "string") deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === "string" && typeof deletedIDField === "object") {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === "string") deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === "string") deleteIDs.push(id);
            });
        }
        $d64bddab5328fcec$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $d64bddab5328fcec$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $d64bddab5328fcec$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $aGNBD.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $aGNBD.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $d64bddab5328fcec$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === "LinkedField") return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $d64bddab5328fcec$var$MutationTypes,
    RangeOperations: $d64bddab5328fcec$var$RangeOperations,
    convert: $d64bddab5328fcec$var$convert
};

});


parcelRegister("M010p", function(module, exports) {
"use strict";
function $09047ed4f8cc5315$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $09047ed4f8cc5315$var$commitLocalUpdate;

});

parcelRegister("lRc4h", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fe97e8a8719c5194$var$_interopRequireDefault = $1jnue.default;

var $fe97e8a8719c5194$var$_toConsumableArray2 = $fe97e8a8719c5194$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $kx3Ii = parcelRequire("kx3Ii");
var $fe97e8a8719c5194$var$getRequest = $kx3Ii.getRequest;

var $2Zm5L = parcelRequire("2Zm5L");
var $fe97e8a8719c5194$var$generateUniqueClientID = $2Zm5L.generateUniqueClientID;

var $8V1FJ = parcelRequire("8V1FJ");

var $j6kQy = parcelRequire("j6kQy");
var $fe97e8a8719c5194$var$createOperationDescriptor = $j6kQy.createOperationDescriptor;

var $ioH3s = parcelRequire("ioH3s");
parcelRequire("jyT8R");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $fe97e8a8719c5194$var$commitMutation(environment, config) {
    !$8V1FJ(environment) && $aaXwj(false);
    var mutation = $fe97e8a8719c5194$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== "mutation") throw new Error("commitMutation: Expected mutation operation");
    if (mutation.kind !== "Request") throw new Error("commitMutation: Expected mutation to be of type request");
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $fe97e8a8719c5194$var$createOperationDescriptor(mutation, variables, cacheConfig, $fe97e8a8719c5194$var$generateUniqueClientID());
    if (typeof optimisticResponse === "function") optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $ioH3s.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $fe97e8a8719c5194$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $fe97e8a8719c5194$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $fe97e8a8719c5194$var$commitMutation;

});
parcelRegister("jyT8R", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e3dbf756f8202857$var$_interopRequireDefault = $1jnue.default;

var $e3dbf756f8202857$var$_objectSpread2 = $e3dbf756f8202857$var$_interopRequireDefault((parcelRequire("cbdLd")));
parcelRequire("8Fbfi");
var $e3dbf756f8202857$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $e3dbf756f8202857$var$validateMutation = function validateMutation() {};
var $e3dbf756f8202857$var$addFieldToDiff, $e3dbf756f8202857$var$validateSelections, $e3dbf756f8202857$var$validateSelection, $e3dbf756f8202857$var$validateModuleImport, $e3dbf756f8202857$var$validateAbstractKey, $e3dbf756f8202857$var$validateField, $e3dbf756f8202857$var$validateOptimisticResponse;
module.exports = $e3dbf756f8202857$var$validateMutation;

});


parcelRegister("hrzAF", function(module, exports) {
"use strict";

var $kDIPG = parcelRequire("kDIPG");

var $02scZ = parcelRequire("02scZ");
var $cb3090cecc670ab7$var$convertFetch = $02scZ.convertFetch;

var $aaXwj = parcelRequire("aaXwj");
function $cb3090cecc670ab7$var$create(fetchFn, subscribe) {
    var observeFetch = $cb3090cecc670ab7$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $kDIPG(variables, request.providedVariables);
        if (request.operationKind === "subscription") {
            !subscribe && $aaXwj(false);
            !!uploadables && $aaXwj(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $aaXwj(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $cb3090cecc670ab7$var$create
};

});
parcelRegister("kDIPG", function(module, exports) {
"use strict";
parcelRequire("ewhZB");
parcelRequire("8Fbfi");
var $f06a39ff88ffc1fe$var$WEAKMAP_SUPPORTED = typeof WeakMap === "function";
var $f06a39ff88ffc1fe$var$debugCache = $f06a39ff88ffc1fe$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $f06a39ff88ffc1fe$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$f06a39ff88ffc1fe$var$debugCache.has(providerFunction)) {
                $f06a39ff88ffc1fe$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $f06a39ff88ffc1fe$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$f06a39ff88ffc1fe$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $f06a39ff88ffc1fe$var$withProvidedVariables;

});

parcelRegister("02scZ", function(module, exports) {
"use strict";

var $jJlPe = parcelRequire("jJlPe");
function $007611a8cb44d47f$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $jJlPe.create(function(sink) {
            return sink.error(result);
        });
        return $jJlPe.from(result);
    };
}
module.exports = {
    convertFetch: $007611a8cb44d47f$var$convertFetch
};

});


parcelRegister("jDJ8J", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e4c4aca6159b25c2$var$_interopRequireDefault = $1jnue.default;

var $e4c4aca6159b25c2$var$_objectSpread2 = $e4c4aca6159b25c2$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $a9M0M = parcelRequire("a9M0M");
var $e4c4aca6159b25c2$var$stableCopy = $a9M0M.stableCopy;

var $aaXwj = parcelRequire("aaXwj");
var $e4c4aca6159b25c2$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $aaXwj(false);
        !(ttl > 0) && $aaXwj(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $e4c4aca6159b25c2$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$e4c4aca6159b25c2$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $e4c4aca6159b25c2$var$_objectSpread2["default"])((0, $e4c4aca6159b25c2$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $e4c4aca6159b25c2$var$_objectSpread2["default"])((0, $e4c4aca6159b25c2$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $e4c4aca6159b25c2$var$_objectSpread2["default"])((0, $e4c4aca6159b25c2$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $e4c4aca6159b25c2$var$_objectSpread2["default"])((0, $e4c4aca6159b25c2$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $e4c4aca6159b25c2$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $e4c4aca6159b25c2$var$getCacheKey(queryID, variables) {
    return JSON.stringify($e4c4aca6159b25c2$var$stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function $e4c4aca6159b25c2$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $e4c4aca6159b25c2$var$RelayQueryResponseCache;

});

parcelRegister("b5DFS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $812eefe156ab9f16$var$_interopRequireDefault = $1jnue.default;

var $812eefe156ab9f16$var$_objectSpread2 = $812eefe156ab9f16$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $jJlPe = parcelRequire("jJlPe");

var $j6kQy = parcelRequire("j6kQy");
var $812eefe156ab9f16$var$createOperationDescriptor = $j6kQy.createOperationDescriptor;

var $haJc5 = parcelRequire("haJc5");
var $812eefe156ab9f16$var$handlePotentialSnapshotErrors = $haJc5.handlePotentialSnapshotErrors;

var $1v92Z = parcelRequire("1v92Z");

var $kx3Ii = parcelRequire("kx3Ii");
var $812eefe156ab9f16$var$getRequest = $kx3Ii.getRequest;

var $aaXwj = parcelRequire("aaXwj");
function $812eefe156ab9f16$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $812eefe156ab9f16$var$getRequest(query);
    !(queryNode.params.operationKind === "query") && $aaXwj(false);
    var networkCacheConfig = (0, $812eefe156ab9f16$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $812eefe156ab9f16$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : "network-only";
    function readData(snapshot) {
        $812eefe156ab9f16$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case "network-only":
            return $812eefe156ab9f16$var$getNetworkObservable(environment, operation).map(readData);
        case "store-or-network":
            if (environment.check(operation).status === "available") return $jJlPe.from(environment.lookup(operation.fragment)).map(readData);
            return $812eefe156ab9f16$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error("fetchQuery: Invalid fetchPolicy " + fetchPolicy);
    }
}
function $812eefe156ab9f16$var$getNetworkObservable(environment, operation) {
    return $1v92Z.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $812eefe156ab9f16$var$fetchQuery;

});

parcelRegister("9VGFV", function(module, exports) {
"use strict";

var $j6kQy = parcelRequire("j6kQy");
var $73aa8a5735f9372e$var$createOperationDescriptor = $j6kQy.createOperationDescriptor;

var $kx3Ii = parcelRequire("kx3Ii");
var $73aa8a5735f9372e$var$getRequest = $kx3Ii.getRequest;
function $73aa8a5735f9372e$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $73aa8a5735f9372e$var$getRequest(taggedNode);
    if (query.params.operationKind !== "query") throw new Error("fetchQuery: Expected query operation");
    var operation = $73aa8a5735f9372e$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $73aa8a5735f9372e$var$fetchQuery_DEPRECATED;

});

parcelRegister("6iwIs", function(module, exports) {
"use strict";
var $495dcd3cb4042812$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $495dcd3cb4042812$var$preloadableQueryRegistry = new $495dcd3cb4042812$var$PreloadableQueryRegistry();
module.exports = $495dcd3cb4042812$var$preloadableQueryRegistry;

});

parcelRegister("kL5wL", function(module, exports) {
"use strict";

var $8yy3m = parcelRequire("8yy3m");
parcelRequire("8Fbfi");
function $f1cc7c0ff3883805$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $8yy3m(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $f1cc7c0ff3883805$var$createFragmentSpecResolver;

});
parcelRegister("8yy3m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $63abe9fafa079168$var$_interopRequireDefault = $1jnue.default;

var $63abe9fafa079168$var$_objectSpread2 = $63abe9fafa079168$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $63abe9fafa079168$var$_defineProperty2 = $63abe9fafa079168$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $8R95j = parcelRequire("8R95j");

var $haJc5 = parcelRequire("haJc5");
var $63abe9fafa079168$var$handlePotentialSnapshotErrors = $haJc5.handlePotentialSnapshotErrors;

var $asMlo = parcelRequire("asMlo");

var $2qPt3 = parcelRequire("2qPt3");

var $9nfN5 = parcelRequire("9nfN5");

var $j6kQy = parcelRequire("j6kQy");
var $63abe9fafa079168$var$createRequestDescriptor = $j6kQy.createRequestDescriptor;

var $cTAdw = parcelRequire("cTAdw");
var $63abe9fafa079168$var$areEqualSelectors = $cTAdw.areEqualSelectors, $63abe9fafa079168$var$createReaderSelector = $cTAdw.createReaderSelector, $63abe9fafa079168$var$getSelectorsFromObject = $cTAdw.getSelectorsFromObject;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $63abe9fafa079168$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $63abe9fafa079168$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === "function") _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $63abe9fafa079168$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $63abe9fafa079168$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$asMlo(_nextItem, prevItem)) {
                        nextData = nextData || (0, $63abe9fafa079168$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($9nfN5.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $63abe9fafa079168$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === "PluralReaderSelector") {
                if (resolver == null) resolver = new $63abe9fafa079168$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $63abe9fafa079168$var$SelectorListResolver) && $aaXwj(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $63abe9fafa079168$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $63abe9fafa079168$var$SelectorResolver) && $aaXwj(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $63abe9fafa079168$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $63abe9fafa079168$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._errorResponseFields = snapshot.errorResponseFields;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._errorResponseFields = _snapshot.errorResponseFields;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($9nfN5.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = $8R95j(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: "suspense.fragment",
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $63abe9fafa079168$var$handlePotentialSnapshotErrors(this._environment, this._errorResponseFields);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $63abe9fafa079168$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $2qPt3(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._errorResponseFields = snapshot.errorResponseFields;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($ewhZB(variables, this._selector.variables)) return;
        var requestDescriptor = $63abe9fafa079168$var$createRequestDescriptor(request, variables);
        var selector = $63abe9fafa079168$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $63abe9fafa079168$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $63abe9fafa079168$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($63abe9fafa079168$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $63abe9fafa079168$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $63abe9fafa079168$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $63abe9fafa079168$var$RelayModernFragmentSpecResolver;

});
parcelRegister("asMlo", function(module, exports) {
"use strict";
function $79e205061caaa191$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== "object");
}
module.exports = $79e205061caaa191$var$isScalarAndEqual;

});

parcelRegister("2qPt3", function(module, exports) {
"use strict";
function $1c55eee6d2287b0d$var$recycleNodesInto(prevData, nextData) {
    return $1c55eee6d2287b0d$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $1c55eee6d2287b0d$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== "object" || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== "object" || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $1c55eee6d2287b0d$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $1c55eee6d2287b0d$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $1c55eee6d2287b0d$var$recycleNodesInto;

});



parcelRegister("gzFws", function(module, exports) {
"use strict";

var $aaXwj = parcelRequire("aaXwj");
var $c1101fc11092a2d5$var$relayContext;
var $c1101fc11092a2d5$var$firstReact;
function $c1101fc11092a2d5$var$createRelayContext(react) {
    if (!$c1101fc11092a2d5$var$relayContext) {
        $c1101fc11092a2d5$var$relayContext = react.createContext(null);
        $c1101fc11092a2d5$var$firstReact = react;
    }
    !(react === $c1101fc11092a2d5$var$firstReact) && $aaXwj(false);
    return $c1101fc11092a2d5$var$relayContext;
}
module.exports = $c1101fc11092a2d5$var$createRelayContext;

});

parcelRegister("4T3eA", function(module, exports) {
"use strict";
var $38eecec12b274742$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $38eecec12b274742$var$suspenseSentinel() {
    return $38eecec12b274742$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $38eecec12b274742$var$isSuspenseSentinel(value) {
    return value === $38eecec12b274742$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $38eecec12b274742$var$isSuspenseSentinel,
    suspenseSentinel: $38eecec12b274742$var$suspenseSentinel
};

});

parcelRegister("94SdE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $69be8b9266aef6dd$var$_interopRequireDefault = $1jnue.default;

var $69be8b9266aef6dd$var$_objectSpread2 = $69be8b9266aef6dd$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $69be8b9266aef6dd$var$_RelayModernRecord = $69be8b9266aef6dd$var$_interopRequireDefault((parcelRequire("gPxAs")));

var $69be8b9266aef6dd$var$_RelayRecordSource = $69be8b9266aef6dd$var$_interopRequireDefault((parcelRequire("iUWBj")));

var $69be8b9266aef6dd$var$_RelayResponseNormalizer = $69be8b9266aef6dd$var$_interopRequireDefault((parcelRequire("k8Yke")));
function $69be8b9266aef6dd$var$normalizeResponse(response, selector, typeName, options) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $69be8b9266aef6dd$var$_RelayRecordSource["default"].create();
    var record = $69be8b9266aef6dd$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $69be8b9266aef6dd$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors);
    return (0, $69be8b9266aef6dd$var$_objectSpread2["default"])((0, $69be8b9266aef6dd$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $69be8b9266aef6dd$var$normalizeResponse;

});
parcelRegister("gPxAs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c40b766fe7bc1eb3$var$_interopRequireDefault = $1jnue.default;

var $c40b766fe7bc1eb3$var$_defineProperty2 = $c40b766fe7bc1eb3$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $c40b766fe7bc1eb3$var$_objectWithoutPropertiesLoose2 = $c40b766fe7bc1eb3$var$_interopRequireDefault((parcelRequire("c05no")));

var $c40b766fe7bc1eb3$var$_toPropertyKey2 = $c40b766fe7bc1eb3$var$_interopRequireDefault((parcelRequire("5DKOa")));

var $c40b766fe7bc1eb3$var$_objectSpread2 = $c40b766fe7bc1eb3$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $4ERpj = parcelRequire("4ERpj");

var $2Zm5L = parcelRequire("2Zm5L");
var $c40b766fe7bc1eb3$var$generateClientObjectClientID = $2Zm5L.generateClientObjectClientID, $c40b766fe7bc1eb3$var$isClientID = $2Zm5L.isClientID;

var $4T3eA = parcelRequire("4T3eA");
var $c40b766fe7bc1eb3$var$isSuspenseSentinel = $4T3eA.isSuspenseSentinel;

var $boOnJ = parcelRequire("boOnJ");
var $c40b766fe7bc1eb3$var$ACTOR_IDENTIFIER_KEY = $boOnJ.ACTOR_IDENTIFIER_KEY, $c40b766fe7bc1eb3$var$ERRORS_KEY = $boOnJ.ERRORS_KEY, $c40b766fe7bc1eb3$var$ID_KEY = $boOnJ.ID_KEY, $c40b766fe7bc1eb3$var$INVALIDATED_AT_KEY = $boOnJ.INVALIDATED_AT_KEY, $c40b766fe7bc1eb3$var$REF_KEY = $boOnJ.REF_KEY, $c40b766fe7bc1eb3$var$REFS_KEY = $boOnJ.REFS_KEY, $c40b766fe7bc1eb3$var$RELAY_RESOLVER_VALUE_KEY = $boOnJ.RELAY_RESOLVER_VALUE_KEY, $c40b766fe7bc1eb3$var$ROOT_ID = $boOnJ.ROOT_ID, $c40b766fe7bc1eb3$var$TYPENAME_KEY = $boOnJ.TYPENAME_KEY;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $c40b766fe7bc1eb3$var$clone(record) {
    return (0, $c40b766fe7bc1eb3$var$_objectSpread2["default"])({}, record);
}
function $c40b766fe7bc1eb3$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $c40b766fe7bc1eb3$var$ID_KEY && key !== $c40b766fe7bc1eb3$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $c40b766fe7bc1eb3$var$create(dataID, typeName) {
    var record = {};
    record[$c40b766fe7bc1eb3$var$ID_KEY] = dataID;
    record[$c40b766fe7bc1eb3$var$TYPENAME_KEY] = typeName;
    return record;
}
function $c40b766fe7bc1eb3$var$fromObject(json) {
    return json;
}
function $c40b766fe7bc1eb3$var$getDataID(record) {
    return record[$c40b766fe7bc1eb3$var$ID_KEY];
}
function $c40b766fe7bc1eb3$var$getFields(record) {
    if ($c40b766fe7bc1eb3$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $c40b766fe7bc1eb3$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $c40b766fe7bc1eb3$var$getType(record) {
    return record[$c40b766fe7bc1eb3$var$TYPENAME_KEY];
}
function $c40b766fe7bc1eb3$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$c40b766fe7bc1eb3$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $c40b766fe7bc1eb3$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === "object") !(!value.hasOwnProperty($c40b766fe7bc1eb3$var$REF_KEY) && !value.hasOwnProperty($c40b766fe7bc1eb3$var$REFS_KEY)) && $aaXwj(false);
    return value;
}
function $c40b766fe7bc1eb3$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $c40b766fe7bc1eb3$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === "object" && link && typeof link[$c40b766fe7bc1eb3$var$REF_KEY] === "string") && $aaXwj(false);
    return link[$c40b766fe7bc1eb3$var$REF_KEY];
}
function $c40b766fe7bc1eb3$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === "object" && link && typeof link[$c40b766fe7bc1eb3$var$REF_KEY] === "string";
}
function $c40b766fe7bc1eb3$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === "object" && Array.isArray(links[$c40b766fe7bc1eb3$var$REFS_KEY])) && $aaXwj(false);
    return links[$c40b766fe7bc1eb3$var$REFS_KEY];
}
function $c40b766fe7bc1eb3$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === "object" && Array.isArray(links[$c40b766fe7bc1eb3$var$REFS_KEY]) && links[$c40b766fe7bc1eb3$var$REFS_KEY].every(function(link) {
        return typeof link === "string";
    });
}
function $c40b766fe7bc1eb3$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$c40b766fe7bc1eb3$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== "number") return null;
    return invalidatedAt;
}
function $c40b766fe7bc1eb3$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$c40b766fe7bc1eb3$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$c40b766fe7bc1eb3$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$ewhZB(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $c40b766fe7bc1eb3$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $c40b766fe7bc1eb3$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($ewhZB(prevValue, nextValue) && $ewhZB(prevErrors, nextErrors)) continue;
            updated = (0, $c40b766fe7bc1eb3$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$c40b766fe7bc1eb3$var$ERRORS_KEY] = (0, $c40b766fe7bc1eb3$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $c40b766fe7bc1eb3$var$setValue(updated, _storageKey2, nextValue);
        $c40b766fe7bc1eb3$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $c40b766fe7bc1eb3$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($c40b766fe7bc1eb3$var$ERRORS_KEY in record1 || $c40b766fe7bc1eb3$var$ERRORS_KEY in record2) {
        var errors1 = record1[$c40b766fe7bc1eb3$var$ERRORS_KEY], fields1 = (0, $c40b766fe7bc1eb3$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $c40b766fe7bc1eb3$var$ERRORS_KEY
        ].map($c40b766fe7bc1eb3$var$_toPropertyKey2["default"]));
        var errors2 = record2[$c40b766fe7bc1eb3$var$ERRORS_KEY], fields2 = (0, $c40b766fe7bc1eb3$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $c40b766fe7bc1eb3$var$ERRORS_KEY
        ].map($c40b766fe7bc1eb3$var$_toPropertyKey2["default"]));
        var updated = (0, $c40b766fe7bc1eb3$var$_objectSpread2["default"])((0, $c40b766fe7bc1eb3$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$c40b766fe7bc1eb3$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $c40b766fe7bc1eb3$var$_objectSpread2["default"])((0, $c40b766fe7bc1eb3$var$_objectSpread2["default"])({}, record1), record2);
}
function $c40b766fe7bc1eb3$var$freeze(record) {
    $4ERpj(record);
}
function $c40b766fe7bc1eb3$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$c40b766fe7bc1eb3$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$c40b766fe7bc1eb3$var$ERRORS_KEY] = (0, $c40b766fe7bc1eb3$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$c40b766fe7bc1eb3$var$ERRORS_KEY];
        }
    }
}
function $c40b766fe7bc1eb3$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $c40b766fe7bc1eb3$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$c40b766fe7bc1eb3$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $c40b766fe7bc1eb3$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$c40b766fe7bc1eb3$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $c40b766fe7bc1eb3$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$c40b766fe7bc1eb3$var$REF_KEY] = linkedID;
    link[$c40b766fe7bc1eb3$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $c40b766fe7bc1eb3$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === "object" && typeof link[$c40b766fe7bc1eb3$var$REF_KEY] === "string" && link[$c40b766fe7bc1eb3$var$ACTOR_IDENTIFIER_KEY] != null) && $aaXwj(false);
    return [
        link[$c40b766fe7bc1eb3$var$ACTOR_IDENTIFIER_KEY],
        link[$c40b766fe7bc1eb3$var$REF_KEY]
    ];
}
function $c40b766fe7bc1eb3$var$getResolverLinkedRecordID(record, typeName) {
    var id = $c40b766fe7bc1eb3$var$getValue(record, $c40b766fe7bc1eb3$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $c40b766fe7bc1eb3$var$isSuspenseSentinel(id)) return null;
    if (typeof id === "object") id = id.id;
    !(typeof id === "string") && $aaXwj(false);
    return $c40b766fe7bc1eb3$var$generateClientObjectClientID(typeName, id);
}
function $c40b766fe7bc1eb3$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $c40b766fe7bc1eb3$var$getValue(record, $c40b766fe7bc1eb3$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $c40b766fe7bc1eb3$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $aaXwj(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === "object") id = id.id;
        !(typeof id === "string") && $aaXwj(false);
        return $c40b766fe7bc1eb3$var$generateClientObjectClientID(typeName, id);
    });
}
function $c40b766fe7bc1eb3$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $c40b766fe7bc1eb3$var$clone,
    copyFields: $c40b766fe7bc1eb3$var$copyFields,
    create: $c40b766fe7bc1eb3$var$create,
    freeze: $c40b766fe7bc1eb3$var$freeze,
    fromObject: $c40b766fe7bc1eb3$var$fromObject,
    getDataID: $c40b766fe7bc1eb3$var$getDataID,
    getErrors: $c40b766fe7bc1eb3$var$getErrors,
    getFields: $c40b766fe7bc1eb3$var$getFields,
    getInvalidationEpoch: $c40b766fe7bc1eb3$var$getInvalidationEpoch,
    getLinkedRecordID: $c40b766fe7bc1eb3$var$getLinkedRecordID,
    getLinkedRecordIDs: $c40b766fe7bc1eb3$var$getLinkedRecordIDs,
    getType: $c40b766fe7bc1eb3$var$getType,
    getValue: $c40b766fe7bc1eb3$var$getValue,
    hasValue: $c40b766fe7bc1eb3$var$hasValue,
    hasLinkedRecordID: $c40b766fe7bc1eb3$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $c40b766fe7bc1eb3$var$hasLinkedRecordIDs,
    merge: $c40b766fe7bc1eb3$var$merge,
    setErrors: $c40b766fe7bc1eb3$var$setErrors,
    setValue: $c40b766fe7bc1eb3$var$setValue,
    setLinkedRecordID: $c40b766fe7bc1eb3$var$setLinkedRecordID,
    setLinkedRecordIDs: $c40b766fe7bc1eb3$var$setLinkedRecordIDs,
    update: $c40b766fe7bc1eb3$var$update,
    getActorLinkedRecordID: $c40b766fe7bc1eb3$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $c40b766fe7bc1eb3$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $c40b766fe7bc1eb3$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $c40b766fe7bc1eb3$var$getResolverLinkedRecordIDs,
    toJSON: $c40b766fe7bc1eb3$var$toJSON
};

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iUWBj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $dc5ae9e1db17e94c$var$_interopRequireDefault = $1jnue.default;

var $dc5ae9e1db17e94c$var$_createForOfIteratorHelper2 = $dc5ae9e1db17e94c$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $gPxAs = parcelRequire("gPxAs");

var $41YHA = parcelRequire("41YHA");
var $dc5ae9e1db17e94c$var$EXISTENT = $41YHA.EXISTENT, $dc5ae9e1db17e94c$var$NONEXISTENT = $41YHA.NONEXISTENT, $dc5ae9e1db17e94c$var$UNKNOWN = $41YHA.UNKNOWN;
var $dc5ae9e1db17e94c$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $gPxAs.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $dc5ae9e1db17e94c$var$UNKNOWN;
        return this._records.get(dataID) == null ? $dc5ae9e1db17e94c$var$NONEXISTENT : $dc5ae9e1db17e94c$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $dc5ae9e1db17e94c$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $gPxAs.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $dc5ae9e1db17e94c$var$RelayRecordSource;

});
parcelRegister("41YHA", function(module, exports) {
"use strict";
var $2ef65790f745eaba$var$RelayRecordState = {
    EXISTENT: "EXISTENT",
    NONEXISTENT: "NONEXISTENT",
    UNKNOWN: "UNKNOWN"
};
module.exports = $2ef65790f745eaba$var$RelayRecordState;

});


parcelRegister("k8Yke", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $eaa359551a6a83a1$var$_interopRequireDefault = $1jnue.default;

var $eaa359551a6a83a1$var$_createForOfIteratorHelper2 = $eaa359551a6a83a1$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $eaa359551a6a83a1$var$_toConsumableArray2 = $eaa359551a6a83a1$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $8V0ZN = parcelRequire("8V0ZN");
var $eaa359551a6a83a1$var$ACTOR_IDENTIFIER_FIELD_NAME = $8V0ZN.ACTOR_IDENTIFIER_FIELD_NAME, $eaa359551a6a83a1$var$getActorIdentifierFromPayload = $8V0ZN.getActorIdentifierFromPayload;

var $9nfN5 = parcelRequire("9nfN5");

var $2Zm5L = parcelRequire("2Zm5L");
var $eaa359551a6a83a1$var$generateClientID = $2Zm5L.generateClientID, $eaa359551a6a83a1$var$isClientID = $2Zm5L.isClientID;

var $6zf6P = parcelRequire("6zf6P");
var $eaa359551a6a83a1$var$getLocalVariables = $6zf6P.getLocalVariables;

var $d58cJ = parcelRequire("d58cJ");
var $eaa359551a6a83a1$var$buildErrorTrie = $d58cJ.buildErrorTrie, $eaa359551a6a83a1$var$getErrorsByKey = $d58cJ.getErrorsByKey, $eaa359551a6a83a1$var$getNestedErrorTrieByKey = $d58cJ.getNestedErrorTrieByKey;

var $gPxAs = parcelRequire("gPxAs");

var $cTAdw = parcelRequire("cTAdw");
var $eaa359551a6a83a1$var$createNormalizationSelector = $cTAdw.createNormalizationSelector;

var $boOnJ = parcelRequire("boOnJ");
var $eaa359551a6a83a1$var$ROOT_ID = $boOnJ.ROOT_ID, $eaa359551a6a83a1$var$TYPENAME_KEY = $boOnJ.TYPENAME_KEY, $eaa359551a6a83a1$var$getArgumentValues = $boOnJ.getArgumentValues, $eaa359551a6a83a1$var$getHandleStorageKey = $boOnJ.getHandleStorageKey, $eaa359551a6a83a1$var$getModuleComponentKey = $boOnJ.getModuleComponentKey, $eaa359551a6a83a1$var$getModuleOperationKey = $boOnJ.getModuleOperationKey, $eaa359551a6a83a1$var$getStorageKey = $boOnJ.getStorageKey;

var $49Jzj = parcelRequire("49Jzj");
var $eaa359551a6a83a1$var$TYPE_SCHEMA_TYPE = $49Jzj.TYPE_SCHEMA_TYPE, $eaa359551a6a83a1$var$generateTypeID = $49Jzj.generateTypeID;
parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $eaa359551a6a83a1$var$normalize(recordSource, selector, response, options, errors) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $eaa359551a6a83a1$var$RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $eaa359551a6a83a1$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, $eaa359551a6a83a1$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $aaXwj(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $eaa359551a6a83a1$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $eaa359551a6a83a1$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $eaa359551a6a83a1$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $gPxAs.create(typeID, $eaa359551a6a83a1$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $gPxAs.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$eaa359551a6a83a1$var$TYPENAME_KEY];
        !(typeName != null) && $aaXwj(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case "ScalarField":
                case "LinkedField":
                    this._normalizeField(selection, record, data);
                    break;
                case "Condition":
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case "FragmentSpread":
                    var prevVariables = this._variables;
                    this._variables = $eaa359551a6a83a1$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case "InlineFragment":
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $gPxAs.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = $gPxAs.getType(record);
                        var typeID = $eaa359551a6a83a1$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $gPxAs.create(typeID, $eaa359551a6a83a1$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $gPxAs.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case "TypeDiscriminator":
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = $gPxAs.getType(record);
                    var _typeID = $eaa359551a6a83a1$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $gPxAs.create(_typeID, $eaa359551a6a83a1$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $gPxAs.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case "LinkedHandle":
                case "ScalarHandle":
                    var args = selection.args ? $eaa359551a6a83a1$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $eaa359551a6a83a1$var$getStorageKey(selection, this._variables);
                    var handleKey = $eaa359551a6a83a1$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $gPxAs.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $eaa359551a6a83a1$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case "ModuleImport":
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case "Defer":
                    this._normalizeDefer(selection, record, data);
                    break;
                case "Stream":
                    this._normalizeStream(selection, record, data);
                    break;
                case "ClientExtension":
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case "ClientComponent":
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case "ActorChange":
                    this._normalizeActorChange(selection, record, data);
                    break;
                case "RelayResolver":
                    this._normalizeResolver(selection, record, data);
                    break;
                case "RelayLiveResolver":
                    this._normalizeResolver(selection, record, data);
                    break;
                case "ClientEdgeToClientObject":
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: "defer",
            data: data,
            label: defer.label,
            path: (0, $eaa359551a6a83a1$var$_toConsumableArray2["default"])(this._path),
            selector: $eaa359551a6a83a1$var$createNormalizationSelector(defer, $gPxAs.getDataID(record), this._variables),
            typeName: $gPxAs.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: "stream",
            label: stream.label,
            path: (0, $eaa359551a6a83a1$var$_toConsumableArray2["default"])(this._path),
            parentID: $gPxAs.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === "object" && data) && $aaXwj(false);
        var typeName = $gPxAs.getType(record);
        var componentKey = $eaa359551a6a83a1$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $gPxAs.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $eaa359551a6a83a1$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $gPxAs.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: "ModuleImportPayload",
            args: moduleImport.args,
            data: data,
            dataID: $gPxAs.getDataID(record),
            operationReference: operationReference,
            path: (0, $eaa359551a6a83a1$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === "object" && data) && $aaXwj(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $eaa359551a6a83a1$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null || $9nfN5.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $gPxAs.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $eaa359551a6a83a1$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $gPxAs.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === "ScalarField") $gPxAs.setValue(record, storageKey, fieldValue);
        else if (selection.kind === "LinkedField") {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $eaa359551a6a83a1$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $aaXwj(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === "object" && data) && $aaXwj(false);
        var responseKey = field.alias || field.name;
        var storageKey = $eaa359551a6a83a1$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $gPxAs.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $eaa359551a6a83a1$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $gPxAs.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $gPxAs.getLinkedRecordID(record, storageKey) || $eaa359551a6a83a1$var$generateClientID($gPxAs.getDataID(record), storageKey);
        !(typeof nextID === "string") && $aaXwj(false);
        $gPxAs.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: "ActorPayload",
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $eaa359551a6a83a1$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === "object" && fieldValue) && $aaXwj(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $gPxAs.getLinkedRecordID(record, storageKey) || $eaa359551a6a83a1$var$generateClientID($gPxAs.getDataID(record), storageKey);
        !(typeof nextID === "string") && $aaXwj(false);
        $gPxAs.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $gPxAs.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $aaXwj(false);
        var prevIDs = $gPxAs.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $eaa359551a6a83a1$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === "object") && $aaXwj(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $eaa359551a6a83a1$var$generateClientID($gPxAs.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === "string") && $aaXwj(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $gPxAs.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $gPxAs.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = $gPxAs.getDataID(record);
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $eaa359551a6a83a1$var$normalize
};

});
parcelRegister("8V0ZN", function(module, exports) {
"use strict";
var $67e46b5185c5bfef$var$ACTOR_IDENTIFIER_FIELD_NAME = "actor_key";

var $5Tok1 = parcelRequire("5Tok1");
var $67e46b5185c5bfef$var$getActorIdentifier = $5Tok1.getActorIdentifier;
function $67e46b5185c5bfef$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === "object" && typeof payload[$67e46b5185c5bfef$var$ACTOR_IDENTIFIER_FIELD_NAME] === "string") return $67e46b5185c5bfef$var$getActorIdentifier(payload[$67e46b5185c5bfef$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $67e46b5185c5bfef$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $67e46b5185c5bfef$var$getActorIdentifierFromPayload
};

});
parcelRegister("5Tok1", function(module, exports) {
"use strict";

var $aaXwj = parcelRequire("aaXwj");
var $44a4f4a5c92177d0$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = "INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE";
function $44a4f4a5c92177d0$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $44a4f4a5c92177d0$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $aaXwj(false);
}
module.exports = {
    assertInternalActorIdentifier: $44a4f4a5c92177d0$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error("Not Implemented");
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $44a4f4a5c92177d0$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("d58cJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $98621b3499886b1b$var$_interopRequireDefault = $1jnue.default;

var $98621b3499886b1b$var$_objectSpread2 = $98621b3499886b1b$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $98621b3499886b1b$var$_objectWithoutPropertiesLoose2 = $98621b3499886b1b$var$_interopRequireDefault((parcelRequire("c05no")));

var $98621b3499886b1b$var$_createForOfIteratorHelper2 = $98621b3499886b1b$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $98621b3499886b1b$var$_toConsumableArray2 = $98621b3499886b1b$var$_interopRequireDefault((parcelRequire("fUHKi")));
var $98621b3499886b1b$var$_excluded = [
    "path",
    "locations"
];
var $98621b3499886b1b$var$SELF = Symbol("$SELF");
function $98621b3499886b1b$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, $98621b3499886b1b$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $98621b3499886b1b$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $98621b3499886b1b$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($98621b3499886b1b$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $98621b3499886b1b$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $98621b3499886b1b$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $98621b3499886b1b$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $98621b3499886b1b$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $98621b3499886b1b$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $98621b3499886b1b$var$_toConsumableArray2["default"])(value));
            else $98621b3499886b1b$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $98621b3499886b1b$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $98621b3499886b1b$var$_objectSpread2["default"])((0, $98621b3499886b1b$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $98621b3499886b1b$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $98621b3499886b1b$var$SELF,
    buildErrorTrie: $98621b3499886b1b$var$buildErrorTrie,
    getNestedErrorTrieByKey: $98621b3499886b1b$var$getNestedErrorTrieByKey,
    getErrorsByKey: $98621b3499886b1b$var$getErrorsByKey
};

});

parcelRegister("49Jzj", function(module, exports) {
"use strict";
var $306b59a8f5e0508a$var$PREFIX = "client:__type:";
var $306b59a8f5e0508a$var$TYPE_SCHEMA_TYPE = "__TypeSchema";
function $306b59a8f5e0508a$var$generateTypeID(typeName) {
    return $306b59a8f5e0508a$var$PREFIX + typeName;
}
function $306b59a8f5e0508a$var$isTypeID(id) {
    return id.indexOf($306b59a8f5e0508a$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $306b59a8f5e0508a$var$generateTypeID,
    isTypeID: $306b59a8f5e0508a$var$isTypeID,
    TYPE_SCHEMA_TYPE: $306b59a8f5e0508a$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("6UUWp", function(module, exports) {
"use strict";

var $kx3Ii = parcelRequire("kx3Ii");
var $5094245c5d825347$var$getInlineDataFragment = $kx3Ii.getInlineDataFragment;

var $boOnJ = parcelRequire("boOnJ");
var $5094245c5d825347$var$FRAGMENTS_KEY = $boOnJ.FRAGMENTS_KEY;

var $aaXwj = parcelRequire("aaXwj");
function $5094245c5d825347$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $5094245c5d825347$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === "object") && $aaXwj(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$5094245c5d825347$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $aaXwj(false);
    return inlineData;
}
module.exports = $5094245c5d825347$var$readInlineData;

});

parcelRegister("gwzA3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c07b3c07e60440a5$var$_interopRequireDefault = $1jnue.default;

var $c07b3c07e60440a5$var$_objectSpread2 = $c07b3c07e60440a5$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $301e4 = parcelRequire("301e4");

var $5Tok1 = parcelRequire("5Tok1");
var $c07b3c07e60440a5$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $5Tok1.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $c07b3c07e60440a5$var$assertInternalActorIdentifier = $5Tok1.assertInternalActorIdentifier;

var $jJlPe = parcelRequire("jJlPe");

var $jdHnU = parcelRequire("jdHnU");

var $gH9zW = parcelRequire("gH9zW");

var $fvhF8 = parcelRequire("fvhF8");

var $ciRhT = parcelRequire("ciRhT");

var $yPK5j = parcelRequire("yPK5j");

var $94SdE = parcelRequire("94SdE");

var $gouRE = parcelRequire("gouRE");

var $9i4l8 = parcelRequire("9i4l8");

var $iUWBj = parcelRequire("iUWBj");
parcelRequire("aaXwj");
var $c07b3c07e60440a5$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $c07b3c07e60440a5$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $yPK5j;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : "partial";
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $jdHnU(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $ciRhT;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $9i4l8(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $301e4, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $94SdE;
        this.__setNet = function(newNet) {
            return _this._network = $jdHnU(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $gH9zW();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $fvhF8(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === "active";
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $jJlPe.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$c07b3c07e60440a5$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $jJlPe.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $iUWBj.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $c07b3c07e60440a5$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $c07b3c07e60440a5$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $c07b3c07e60440a5$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $c07b3c07e60440a5$var$_objectSpread2["default"])((0, $c07b3c07e60440a5$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : "", ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $jJlPe.create(function(sink) {
            var executor = $gouRE.execute({
                actorIdentifier: $c07b3c07e60440a5$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $c07b3c07e60440a5$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $c07b3c07e60440a5$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $c07b3c07e60440a5$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === "Operation" && operation.root.node.clientAbstractTypes != null;
}
$c07b3c07e60440a5$var$RelayModernEnvironment.prototype["@@RelayModernEnvironment"] = true;
function $c07b3c07e60440a5$var$emptyFunction() {}
module.exports = $c07b3c07e60440a5$var$RelayModernEnvironment;

});
parcelRegister("jdHnU", function(module, exports) {
"use strict";

var $gFvrV = parcelRequire("gFvrV");
function $dfe0e27d5e1f0d6d$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = $gFvrV();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: "network.start",
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: "network.next",
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: "network.error",
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: "network.complete",
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: "network.unsubscribe",
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: "network.info",
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
module.exports = $dfe0e27d5e1f0d6d$var$wrapNetworkWithLogObserver;

});
parcelRegister("gFvrV", function(module, exports) {
"use strict";
var $c228dede950cbfb0$var$id = 100000;
function $c228dede950cbfb0$var$generateID() {
    return $c228dede950cbfb0$var$id++;
}
module.exports = $c228dede950cbfb0$var$generateID;

});


parcelRegister("gH9zW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c278179abe02c2aa$var$_interopRequireDefault = $1jnue.default;

var $c278179abe02c2aa$var$_createForOfIteratorHelper2 = $c278179abe02c2aa$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $aaXwj = parcelRequire("aaXwj");
var $c278179abe02c2aa$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $c278179abe02c2aa$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $c278179abe02c2aa$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $c278179abe02c2aa$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $c278179abe02c2aa$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $c278179abe02c2aa$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $aaXwj(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $c278179abe02c2aa$var$RelayOperationTracker;

});

parcelRegister("fvhF8", function(module, exports) {
"use strict";
function $b49773a6ca7ec9b3$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $b49773a6ca7ec9b3$var$registerEnvironmentWithDevTools;

});

parcelRegister("ciRhT", function(module, exports) {
"use strict";

var $8Dxz4 = parcelRequire("8Dxz4");
var $8f50804aad94cee0$var$VIEWER_ID = $8Dxz4.VIEWER_ID, $8f50804aad94cee0$var$VIEWER_TYPE = $8Dxz4.VIEWER_TYPE;
function $8f50804aad94cee0$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $8f50804aad94cee0$var$VIEWER_TYPE) return fieldValue.id == null ? $8f50804aad94cee0$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $8f50804aad94cee0$var$defaultGetDataID;

});
parcelRegister("8Dxz4", function(module, exports) {
"use strict";

var $2Zm5L = parcelRequire("2Zm5L");
var $649c0082f38fc462$var$generateClientID = $2Zm5L.generateClientID;

var $boOnJ = parcelRequire("boOnJ");
var $649c0082f38fc462$var$ROOT_ID = $boOnJ.ROOT_ID;
var $649c0082f38fc462$var$VIEWER_ID = $649c0082f38fc462$var$generateClientID($649c0082f38fc462$var$ROOT_ID, "viewer");
var $649c0082f38fc462$var$VIEWER_TYPE = "Viewer";
module.exports = {
    VIEWER_ID: $649c0082f38fc462$var$VIEWER_ID,
    VIEWER_TYPE: $649c0082f38fc462$var$VIEWER_TYPE
};

});


parcelRegister("yPK5j", function(module, exports) {
"use strict";
var $068b5008a6c9d10a$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $068b5008a6c9d10a$var$defaultRelayFieldLogger;

});

parcelRegister("gouRE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bef6d43f35851459$var$_interopRequireDefault = $1jnue.default;

var $bef6d43f35851459$var$_createForOfIteratorHelper2 = $bef6d43f35851459$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $bef6d43f35851459$var$_toConsumableArray2 = $bef6d43f35851459$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $jJlPe = parcelRequire("jJlPe");

var $gFvrV = parcelRequire("gFvrV");

var $1Qbuk = parcelRequire("1Qbuk");

var $jcJkf = parcelRequire("jcJkf");

var $9nfN5 = parcelRequire("9nfN5");

var $a9M0M = parcelRequire("a9M0M");
var $bef6d43f35851459$var$stableCopy = $a9M0M.stableCopy;

var $l9vQI = parcelRequire("l9vQI");

var $2Zm5L = parcelRequire("2Zm5L");
var $bef6d43f35851459$var$generateClientID = $2Zm5L.generateClientID, $bef6d43f35851459$var$generateUniqueClientID = $2Zm5L.generateUniqueClientID;

var $6zf6P = parcelRequire("6zf6P");
var $bef6d43f35851459$var$getLocalVariables = $6zf6P.getLocalVariables;

var $gPxAs = parcelRequire("gPxAs");

var $cTAdw = parcelRequire("cTAdw");
var $bef6d43f35851459$var$createNormalizationSelector = $cTAdw.createNormalizationSelector, $bef6d43f35851459$var$createReaderSelector = $cTAdw.createReaderSelector;

var $iUWBj = parcelRequire("iUWBj");

var $boOnJ = parcelRequire("boOnJ");
var $bef6d43f35851459$var$ROOT_TYPE = $boOnJ.ROOT_TYPE, $bef6d43f35851459$var$TYPENAME_KEY = $boOnJ.TYPENAME_KEY, $bef6d43f35851459$var$getStorageKey = $boOnJ.getStorageKey;

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $bef6d43f35851459$var$execute(config) {
    return new $bef6d43f35851459$var$Executor(config);
}
var $bef6d43f35851459$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log, normalizeResponse = _ref2.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $gFvrV();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = "started";
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === "subscription";
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($9nfN5.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: "execute.start",
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (!$9nfN5.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === "completed") return;
        this._state = "completed";
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case "started":
                activeState = "active";
                break;
            case "loading_incremental":
                activeState = "active";
                break;
            case "completed":
                activeState = "inactive";
                break;
            case "loading_final":
                activeState = this._pendingModulePayloadsCount > 0 ? "active" : "inactive";
                break;
            default:
                this._state;
                $aaXwj(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $jJlPe.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: "execute.complete",
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: "execute.error",
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === "loading_incremental" ? "low" : "default";
        this._schedule(function() {
            _this4._log({
                name: "execute.next.start",
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
            _this4._handleNext(response);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                name: "execute.next.end",
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty("errors")) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty("errors") && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join("\n") : "(No errors)";
                var error = $jcJkf.create("RelayNetwork", "No data returned for operation `" + _this5._operation.request.node.params.name + "`, got error(s):\n" + messages + "\n\nSee the error `source` property for more information.");
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $aaXwj(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== "started") $aaXwj(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === "completed") return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = "loading_final";
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $bef6d43f35851459$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $bef6d43f35851459$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $bef6d43f35851459$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $bef6d43f35851459$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $aaXwj(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $bef6d43f35851459$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            $bef6d43f35851459$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $iUWBj.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($9nfN5.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $bef6d43f35851459$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case "ModuleImportPayload":
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $bef6d43f35851459$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case "ActorPayload":
                            break;
                        default:
                            followupPayload;
                            $aaXwj(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === "SplitOperation" && followupPayload.kind === "ModuleImportPayload") variables = $bef6d43f35851459$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $bef6d43f35851459$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return this._normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $1Qbuk(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $bef6d43f35851459$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== "started") return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $bef6d43f35851459$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        this._log({
            name: "execute.normalize.start",
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $bef6d43f35851459$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            _this8._log({
                name: "execute.normalize.end",
                operation: _this8._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === "completed") return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? "loading_final" : "loading_incremental";
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== "loading_final";
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === "loading_final") {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === "defer") relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case "ModuleImportPayload":
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $1Qbuk(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $jJlPe.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $jJlPe.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $1Qbuk(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $9nfN5.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = $l9vQI(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this10._log({
                                                name: "execute.async.module",
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case "ActorPayload":
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $aaXwj(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join(".");
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === "response" ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: "placeholder",
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === "stream") parentID = placeholder.parentID;
        else if (placeholder.kind === "defer") parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $aaXwj(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $bef6d43f35851459$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $aaXwj(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $gPxAs.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $bef6d43f35851459$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf("$defer$") !== -1) {
                var pathKey = path.map(String).join(".");
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: "response",
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === "response") {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === "defer") && $aaXwj(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join(".");
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: "response",
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === "response") {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === "stream") && $aaXwj(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $aaXwj(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $iUWBj.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === "LinkedField" && field.plural === true) && $aaXwj(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $bef6d43f35851459$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $iUWBj.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !(typeof data === "object") && $aaXwj(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $bef6d43f35851459$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $aaXwj(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $gPxAs.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $aaXwj(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $aaXwj(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$bef6d43f35851459$var$TYPENAME_KEY];
        !(typeof typeName === "string") && $aaXwj(false);
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : $bef6d43f35851459$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === "string") && $aaXwj(false);
        var selector = $bef6d43f35851459$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $gPxAs.clone(parentRecord);
        var nextIDs = (0, $bef6d43f35851459$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $gPxAs.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, $bef6d43f35851459$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $bef6d43f35851459$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $bef6d43f35851459$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $bef6d43f35851459$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $bef6d43f35851459$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $aaXwj(false);
        return operationLoader;
    };
    return Executor;
}();
function $bef6d43f35851459$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $aaXwj(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function $bef6d43f35851459$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($bef6d43f35851459$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "";
}
function $bef6d43f35851459$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $aaXwj(false);
}
module.exports = {
    execute: $bef6d43f35851459$var$execute
};

});
parcelRegister("1Qbuk", function(module, exports) {
"use strict";

var $dgrHZ = parcelRequire("dgrHZ");
var $15738f1368e5e9eb$var$REQUEST = $dgrHZ.REQUEST, $15738f1368e5e9eb$var$SPLIT_OPERATION = $dgrHZ.SPLIT_OPERATION;
function $15738f1368e5e9eb$var$getOperation(node) {
    switch(node.kind){
        case $15738f1368e5e9eb$var$REQUEST:
            return node.operation;
        case $15738f1368e5e9eb$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $15738f1368e5e9eb$var$getOperation;

});

parcelRegister("jcJkf", function(module, exports) {
"use strict";
function $dfb24c02da9ecc2e$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $dfb24c02da9ecc2e$var$createError.apply(void 0, [
            "error",
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $dfb24c02da9ecc2e$var$createError.apply(void 0, [
            "warn",
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("l9vQI", function(module, exports) {
"use strict";
var $f66324d1600b5927$var$_window, $f66324d1600b5927$var$_window$performance;
var $f66324d1600b5927$var$isPerformanceNowAvailable = typeof window !== "undefined" && typeof (($f66324d1600b5927$var$_window = window) === null || $f66324d1600b5927$var$_window === void 0 ? void 0 : ($f66324d1600b5927$var$_window$performance = $f66324d1600b5927$var$_window.performance) === null || $f66324d1600b5927$var$_window$performance === void 0 ? void 0 : $f66324d1600b5927$var$_window$performance.now) === "function";
function $f66324d1600b5927$var$currentTimestamp() {
    if ($f66324d1600b5927$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $f66324d1600b5927$var$withStartAndDuration(cb) {
    var startTime = $f66324d1600b5927$var$currentTimestamp();
    var result = cb();
    return [
        startTime,
        $f66324d1600b5927$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $f66324d1600b5927$var$withStartAndDuration;

});


parcelRegister("9i4l8", function(module, exports) {
"use strict";
var $6c39295294f35327$var$_global$ErrorUtils$ap, $6c39295294f35327$var$_global$ErrorUtils;

var $kKRsY = parcelRequire("kKRsY");

var $PfUON = parcelRequire("PfUON");

var $f12l4 = parcelRequire("f12l4");

var $kjcqj = parcelRequire("kjcqj");

var $iUWBj = parcelRequire("iUWBj");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $6c39295294f35327$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : undefined;
var $6c39295294f35327$var$applyWithGuard = ($6c39295294f35327$var$_global$ErrorUtils$ap = $6c39295294f35327$var$_global === null || $6c39295294f35327$var$_global === void 0 ? void 0 : ($6c39295294f35327$var$_global$ErrorUtils = $6c39295294f35327$var$_global.ErrorUtils) === null || $6c39295294f35327$var$_global$ErrorUtils === void 0 ? void 0 : $6c39295294f35327$var$_global$ErrorUtils.applyWithGuard) !== null && $6c39295294f35327$var$_global$ErrorUtils$ap !== void 0 ? $6c39295294f35327$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $6c39295294f35327$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $aaXwj(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: "payload",
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: "updater",
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: "source",
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $kKRsY(this._store.getSource(), source);
        var recordSourceProxy = new $PfUON(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $aaXwj(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $aaXwj(false);
            var recordSourceSelectorProxy = new $f12l4(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $6c39295294f35327$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === "payload") {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === "source") {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $iUWBj.create();
                var mutator = new $kKRsY(_this2._store.getSource(), sink);
                var recordSourceProxy = new $PfUON(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                $6c39295294f35327$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, "RelayPublishQueue:commitData");
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $iUWBj.create();
        var mutator = new $kKRsY(this._store.getSource(), sink);
        var recordSourceProxy = new $PfUON(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $6c39295294f35327$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, "RelayPublishQueue:applyUpdates");
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $6c39295294f35327$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $f12l4(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $6c39295294f35327$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, "RelayPublishQueue:applyUpdates");
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $6c39295294f35327$var$lookupSelector(source, selector) {
    var selectorData = $kjcqj.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $6c39295294f35327$var$RelayPublishQueue;

});
parcelRegister("kKRsY", function(module, exports) {
"use strict";

var $gPxAs = parcelRequire("gPxAs");

var $41YHA = parcelRequire("41YHA");
var $f1c193cdb06a2d74$var$EXISTENT = $41YHA.EXISTENT;

var $aaXwj = parcelRequire("aaXwj");
var $f1c193cdb06a2d74$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $gPxAs.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $gPxAs.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $gPxAs.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $aaXwj(false);
            sinkRecord = $gPxAs.create(dataID, $gPxAs.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $aaXwj(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $gPxAs.copyFields(baseSource, sink);
        if (sinkSource) $gPxAs.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $gPxAs.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $f1c193cdb06a2d74$var$EXISTENT && this._sink.getStatus(dataID) !== $f1c193cdb06a2d74$var$EXISTENT) && $aaXwj(false);
        var record = $gPxAs.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $gPxAs.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $gPxAs.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $gPxAs.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $gPxAs.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        $gPxAs.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $gPxAs.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $gPxAs.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $gPxAs.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $gPxAs.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $f1c193cdb06a2d74$var$RelayRecordSourceMutator;

});

parcelRegister("PfUON", function(module, exports) {
"use strict";

var $gPxAs = parcelRequire("gPxAs");

var $41YHA = parcelRequire("41YHA");
var $09a11c01c11ac418$var$EXISTENT = $41YHA.EXISTENT, $09a11c01c11ac418$var$NONEXISTENT = $41YHA.NONEXISTENT;

var $boOnJ = parcelRequire("boOnJ");
var $09a11c01c11ac418$var$ROOT_ID = $boOnJ.ROOT_ID, $09a11c01c11ac418$var$ROOT_TYPE = $boOnJ.ROOT_TYPE;

var $1ywdA = parcelRequire("1ywdA");
var $09a11c01c11ac418$var$_readUpdatableFragment = $1ywdA.readUpdatableFragment;

var $hkOfJ = parcelRequire("hkOfJ");
var $09a11c01c11ac418$var$_readUpdatableQuery = $hkOfJ.readUpdatableQuery;

var $ct1aR = parcelRequire("ct1aR");

var $aaXwj = parcelRequire("aaXwj");
var $09a11c01c11ac418$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $09a11c01c11ac418$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $09a11c01c11ac418$var$EXISTENT) _this.create(dataID, $gPxAs.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $09a11c01c11ac418$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $aaXwj(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $aaXwj(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $09a11c01c11ac418$var$ROOT_ID) && $aaXwj(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $09a11c01c11ac418$var$EXISTENT) this._proxies[dataID] = new $ct1aR(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $09a11c01c11ac418$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($09a11c01c11ac418$var$ROOT_ID);
        if (!root) root = this.create($09a11c01c11ac418$var$ROOT_ID, $09a11c01c11ac418$var$ROOT_TYPE);
        !(root && root.getType() === $09a11c01c11ac418$var$ROOT_TYPE) && $aaXwj(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $09a11c01c11ac418$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $09a11c01c11ac418$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $09a11c01c11ac418$var$RelayRecordSourceProxy;

});
parcelRegister("1ywdA", function(module, exports) {
"use strict";

var $kx3Ii = parcelRequire("kx3Ii");
var $1221f54bd23d5dc1$var$getFragment = $kx3Ii.getFragment;

var $cTAdw = parcelRequire("cTAdw");
var $1221f54bd23d5dc1$var$getVariablesFromFragment = $cTAdw.getVariablesFromFragment;

var $boOnJ = parcelRequire("boOnJ");
var $1221f54bd23d5dc1$var$ID_KEY = $boOnJ.ID_KEY;

var $1ZaIC = parcelRequire("1ZaIC");
var $1221f54bd23d5dc1$var$createUpdatableProxy = $1ZaIC.createUpdatableProxy;

var $aaXwj = parcelRequire("aaXwj");
function $1221f54bd23d5dc1$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $1221f54bd23d5dc1$var$getFragment(fragment);
    var fragmentVariables = $1221f54bd23d5dc1$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$1221f54bd23d5dc1$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $aaXwj(false);
    return {
        updatableData: $1221f54bd23d5dc1$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $1221f54bd23d5dc1$var$readUpdatableFragment
};

});
parcelRegister("1ZaIC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1723cd72486f045a$var$_interopRequireDefault = $1jnue.default;

var $1723cd72486f045a$var$_createForOfIteratorHelper2 = $1723cd72486f045a$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $boOnJ = parcelRequire("boOnJ");
var $1723cd72486f045a$var$getArgumentValues = $boOnJ.getArgumentValues;
var $1723cd72486f045a$var$nonUpdatableKeys = [
    "id",
    "__id",
    "__typename",
    "js"
];
function $1723cd72486f045a$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $1723cd72486f045a$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $1723cd72486f045a$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $1723cd72486f045a$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case "LinkedField":
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $1723cd72486f045a$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $1723cd72486f045a$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $1723cd72486f045a$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $1723cd72486f045a$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case "ScalarField":
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $1723cd72486f045a$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $1723cd72486f045a$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $1723cd72486f045a$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $1723cd72486f045a$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case "InlineFragment":
                    if (updatableProxyRootRecord.getType() === selection.type) $1723cd72486f045a$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case "ClientExtension":
                    $1723cd72486f045a$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case "FragmentSpread":
                    break;
                case "Condition":
                case "ActorChange":
                case "InlineDataFragmentSpread":
                case "AliasedInlineFragmentSpread":
                case "ClientEdgeToClientObject":
                case "ClientEdgeToServerObject":
                case "Defer":
                case "ModuleImport":
                case "RelayLiveResolver":
                case "RequiredField":
                case "CatchField":
                case "Stream":
                case "RelayResolver":
                    throw new Error("Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.");
                default:
                    selection.kind;
                    throw new Error("Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.");
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $1723cd72486f045a$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $1723cd72486f045a$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error("Do not assign null to plural linked fields; assign an empty array instead.");
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error("When assigning an array of items, none of the items should be null or undefined.");
                var __id = item.__id;
                if (__id == null) throw new Error("The __id field must be present on each item passed to the setter. This indicates a bug in Relay.");
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $1723cd72486f045a$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $1723cd72486f045a$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error("The __id field must be present on the argument. This indicates a bug in Relay.");
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $1723cd72486f045a$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $1723cd72486f045a$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $1723cd72486f045a$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $1723cd72486f045a$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $1723cd72486f045a$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $1723cd72486f045a$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $1723cd72486f045a$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $1723cd72486f045a$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $1723cd72486f045a$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $1723cd72486f045a$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === "linked") {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $1723cd72486f045a$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $1723cd72486f045a$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === "pluralLinked") {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $1723cd72486f045a$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $1723cd72486f045a$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === "scalar") {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $1723cd72486f045a$var$createUpdatableProxy
};

});


parcelRegister("hkOfJ", function(module, exports) {
"use strict";

var $kx3Ii = parcelRequire("kx3Ii");
var $c9eb49136e900d08$var$getUpdatableQuery = $kx3Ii.getUpdatableQuery;

var $1ZaIC = parcelRequire("1ZaIC");
var $c9eb49136e900d08$var$createUpdatableProxy = $1ZaIC.createUpdatableProxy;
function $c9eb49136e900d08$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $c9eb49136e900d08$var$getUpdatableQuery(query);
    return {
        updatableData: $c9eb49136e900d08$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $c9eb49136e900d08$var$readUpdatableQuery
};

});

parcelRegister("ct1aR", function(module, exports) {
"use strict";

var $2Zm5L = parcelRequire("2Zm5L");
var $91391a9d4507e63d$var$generateClientID = $2Zm5L.generateClientID;

var $boOnJ = parcelRequire("boOnJ");
var $91391a9d4507e63d$var$getStableStorageKey = $boOnJ.getStableStorageKey;

var $aaXwj = parcelRequire("aaXwj");
var $91391a9d4507e63d$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $aaXwj(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $91391a9d4507e63d$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !$91391a9d4507e63d$var$isValidLeafValue(value) && $aaXwj(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = $91391a9d4507e63d$var$getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = $91391a9d4507e63d$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $91391a9d4507e63d$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $aaXwj(false);
        var storageKey = $91391a9d4507e63d$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $91391a9d4507e63d$var$getStableStorageKey(name, args);
            var clientID = $91391a9d4507e63d$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $91391a9d4507e63d$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $aaXwj(false);
        var storageKey = $91391a9d4507e63d$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $91391a9d4507e63d$var$isValidLeafValue(value) {
    return value == null || typeof value !== "object" || Array.isArray(value) && value.every($91391a9d4507e63d$var$isValidLeafValue);
}
module.exports = $91391a9d4507e63d$var$RelayRecordProxy;

});


parcelRegister("f12l4", function(module, exports) {
"use strict";

var $boOnJ = parcelRequire("boOnJ");
var $aee8c36f5a1960bb$var$ROOT_TYPE = $boOnJ.ROOT_TYPE, $aee8c36f5a1960bb$var$getStorageKey = $boOnJ.getStorageKey;

var $1ywdA = parcelRequire("1ywdA");
var $aee8c36f5a1960bb$var$_readUpdatableFragment = $1ywdA.readUpdatableFragment;

var $hkOfJ = parcelRequire("hkOfJ");
var $aee8c36f5a1960bb$var$_readUpdatableQuery = $hkOfJ.readUpdatableQuery;

var $aaXwj = parcelRequire("aaXwj");
var $aee8c36f5a1960bb$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $aee8c36f5a1960bb$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === "LinkedField" && selection.name === fieldName || selection.kind === "RequiredField" && selection.field.name === fieldName;
        });
        if (field && field.kind === "RequiredField") field = field.field;
        !(field && field.kind === "LinkedField") && $aaXwj(false);
        !(field.plural === plural) && $aaXwj(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $aee8c36f5a1960bb$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $aee8c36f5a1960bb$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $aee8c36f5a1960bb$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $aee8c36f5a1960bb$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $aee8c36f5a1960bb$var$RelayRecordSourceSelectorProxy;

});

parcelRegister("kjcqj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ec8f3803098a36b1$var$_interopRequireDefault = $1jnue.default;

var $ec8f3803098a36b1$var$_objectSpread2 = $ec8f3803098a36b1$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $ec8f3803098a36b1$var$_defineProperty2 = $ec8f3803098a36b1$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $ec8f3803098a36b1$var$_objectWithoutPropertiesLoose2 = $ec8f3803098a36b1$var$_interopRequireDefault((parcelRequire("c05no")));

var $ec8f3803098a36b1$var$_createForOfIteratorHelper2 = $ec8f3803098a36b1$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $ec8f3803098a36b1$var$_toConsumableArray2 = $ec8f3803098a36b1$var$_interopRequireDefault((parcelRequire("fUHKi")));
var $ec8f3803098a36b1$var$_excluded = [
    "message"
];

var $4T3eA = parcelRequire("4T3eA");
var $ec8f3803098a36b1$var$isSuspenseSentinel = $4T3eA.isSuspenseSentinel;

var $6zf6P = parcelRequire("6zf6P");

var $gPxAs = parcelRequire("gPxAs");

var $boOnJ = parcelRequire("boOnJ");
var $ec8f3803098a36b1$var$CLIENT_EDGE_TRAVERSAL_PATH = $boOnJ.CLIENT_EDGE_TRAVERSAL_PATH, $ec8f3803098a36b1$var$FRAGMENT_OWNER_KEY = $boOnJ.FRAGMENT_OWNER_KEY, $ec8f3803098a36b1$var$FRAGMENT_PROP_NAME_KEY = $boOnJ.FRAGMENT_PROP_NAME_KEY, $ec8f3803098a36b1$var$FRAGMENTS_KEY = $boOnJ.FRAGMENTS_KEY, $ec8f3803098a36b1$var$ID_KEY = $boOnJ.ID_KEY, $ec8f3803098a36b1$var$MODULE_COMPONENT_KEY = $boOnJ.MODULE_COMPONENT_KEY, $ec8f3803098a36b1$var$ROOT_ID = $boOnJ.ROOT_ID, $ec8f3803098a36b1$var$getArgumentValues = $boOnJ.getArgumentValues, $ec8f3803098a36b1$var$getModuleComponentKey = $boOnJ.getModuleComponentKey, $ec8f3803098a36b1$var$getStorageKey = $boOnJ.getStorageKey;

var $d6Nxo = parcelRequire("d6Nxo");
var $ec8f3803098a36b1$var$NoopResolverCache = $d6Nxo.NoopResolverCache;

var $jVaPD = parcelRequire("jVaPD");
var $ec8f3803098a36b1$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = $jVaPD.RESOLVER_FRAGMENT_ERRORED_SENTINEL, $ec8f3803098a36b1$var$withResolverContext = $jVaPD.withResolverContext;

var $49Jzj = parcelRequire("49Jzj");
var $ec8f3803098a36b1$var$generateTypeID = $49Jzj.generateTypeID;

var $aaXwj = parcelRequire("aaXwj");
function $ec8f3803098a36b1$var$read(recordSource, selector, resolverCache, resolverContext) {
    var reader = new $ec8f3803098a36b1$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $ec8f3803098a36b1$var$NoopResolverCache(), resolverContext);
    return reader.read();
}
var $ec8f3803098a36b1$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _this$_owner$node$ope;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $ec8f3803098a36b1$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._errorResponseFields = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            errorResponseFields: this._errorResponseFields
        };
    };
    _proto._maybeAddErrorResponseFields = function _maybeAddErrorResponseFields(record, storageKey) {
        var errors = $gPxAs.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var _iterator = (0, $ec8f3803098a36b1$var$_createForOfIteratorHelper2["default"])(errors), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _error$path, _this$_selector$node$2, _this$_selector$node$3;
                var error = _step.value;
                this._errorResponseFields.push({
                    kind: "relay_field_payload.error",
                    owner: owner,
                    fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join("."),
                    error: error,
                    shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                    handled: false
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var owner = this._fragmentName;
        this._errorResponseFields.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            kind: "missing_expected_data.throw",
            owner: owner,
            fieldPath: fieldName,
            handled: false
        } : {
            kind: "missing_expected_data.log",
            owner: owner,
            fieldPath: fieldName
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing("<record>");
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === "NONE") return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case "THROW":
                this._errorResponseFields.push({
                    kind: "missing_required_field.throw",
                    fieldPath: fieldName,
                    owner: owner,
                    handled: false
                });
                return;
            case "LOG":
                this._errorResponseFields.push({
                    kind: "missing_required_field.log",
                    fieldPath: fieldName,
                    owner: owner
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case "RESULT":
                value = this._asResult(_value);
                break;
            case "NULL":
                if (this._errorResponseFields != null && this._errorResponseFields.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenErrorResponseFields = this._errorResponseFields;
        this._errorResponseFields = previousResponseFields;
        if (childrenErrorResponseFields != null) {
            if (this._errorResponseFields == null) this._errorResponseFields = [];
            for(var i = 0; i < childrenErrorResponseFields.length; i++)this._errorResponseFields.push($ec8f3803098a36b1$var$markFieldErrorHasHandled(childrenErrorResponseFields[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._errorResponseFields == null || this._errorResponseFields.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._errorResponseFields.map(function(error) {
            switch(error.kind){
                case "relay_field_payload.error":
                    var _error$error = error.error, message = _error$error.message, displayError = (0, $ec8f3803098a36b1$var$_objectWithoutPropertiesLoose2["default"])(_error$error, $ec8f3803098a36b1$var$_excluded);
                    return displayError;
                case "missing_expected_data.throw":
                case "missing_expected_data.log":
                    return {
                        path: error.fieldPath.split(".")
                    };
                case "relay_resolver.error":
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case "missing_required_field.throw":
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case "missing_required_field.log":
                    return null;
                default:
                    error.kind;
                    $aaXwj(false);
            }
        }).filter(Boolean);
        return {
            ok: false,
            errors: errors
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case "RequiredField":
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case "CatchField":
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._errorResponseFields;
                    this._errorResponseFields = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && $aaXwj(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case "ScalarField":
                    this._readScalar(selection, record, data);
                    break;
                case "LinkedField":
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case "Condition":
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case "InlineFragment":
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case "RelayLiveResolver":
                case "RelayResolver":
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case "FragmentSpread":
                    this._createFragmentPointer(selection, record, data);
                    break;
                case "AliasedInlineFragmentSpread":
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case "ModuleImport":
                    this._readModuleImport(selection, record, data);
                    break;
                case "InlineDataFragmentSpread":
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case "Defer":
                case "ClientExtension":
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case "Stream":
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case "ActorChange":
                    this._readActorChange(selection, record, data);
                    break;
                case "ClientEdgeToClientObject":
                case "ClientEdgeToServerObject":
                    if (this._useExecTimeResolvers && (selection.backingField.kind === "RelayResolver" || selection.backingField.kind === "RelayLiveResolver")) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case "ScalarField":
                return this._readScalar(selection.field, record, data);
            case "LinkedField":
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case "RelayResolver":
                return this._readResolverField(selection.field, record, data);
            case "RelayLiveResolver":
                return this._readResolverField(selection.field, record, data);
            case "ClientEdgeToClientObject":
            case "ClientEdgeToServerObject":
                return this._readClientEdge(selection.field, record, data);
            case "AliasedInlineFragmentSpread":
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                $aaXwj(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $gPxAs.getDataID(record);
        var prevErrors = this._errorResponseFields;
        this._errorResponseFields = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                errorResponseFields: snapshot.errorResponseFields
            };
            snapshot = $ec8f3803098a36b1$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                errorResponseFields: snapshot.errorResponseFields
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $ec8f3803098a36b1$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $ec8f3803098a36b1$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $ec8f3803098a36b1$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $ec8f3803098a36b1$var$getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $ec8f3803098a36b1$var$getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator2 = (0, $ec8f3803098a36b1$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missing = _step2.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator3 = (0, $ec8f3803098a36b1$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var missingResolverField = _step3.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
            if (cachedSnapshot.errorResponseFields != null) {
                if (this._errorResponseFields == null) this._errorResponseFields = [];
                var _iterator4 = (0, $ec8f3803098a36b1$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.errorResponseFields), _step4;
                try {
                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                        var _this$_selector$node$6;
                        var error = _step4.value;
                        if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._errorResponseFields.push(error);
                        else this._errorResponseFields.push($ec8f3803098a36b1$var$markFieldErrorHasHandled(error));
                    }
                } catch (err) {
                    _iterator4.e(err);
                } finally{
                    _iterator4.f();
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                kind: "relay_resolver.error",
                fieldPath: fieldPath,
                owner: this._fragmentName,
                error: resolverError,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                handled: false
            };
            if (this._errorResponseFields == null) this._errorResponseFields = [
                errorEvent
            ];
            else this._errorResponseFields.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) {
            var _iterator5 = (0, $ec8f3803098a36b1$var$_createForOfIteratorHelper2["default"])(updatedDataIDs), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var recordID = _step5.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this2 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== "ClientExtension") && $aaXwj(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $ec8f3803098a36b1$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $aaXwj(false);
            var storeIDs;
            !(field.kind === "ClientEdgeToClientObject") && $aaXwj(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === "string") && $aaXwj(false);
                var localId = $ec8f3803098a36b1$var$extractIdFromResponse(itemResponse, backingField.path, _this2._owner.identifier);
                var id = _this2._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $aaXwj(false);
                    var model = _this2._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return $ec8f3803098a36b1$var$extractIdFromResponse(obj, backingField.path, _this2._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $ec8f3803098a36b1$var$extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === "ClientEdgeToClientObject") {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === "string") && $aaXwj(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === "string") && $aaXwj(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $aaXwj(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === "object") && $aaXwj(false);
            var prevErrors = this._errorResponseFields;
            this._errorResponseFields = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $ec8f3803098a36b1$var$getStorageKey(field, this._variables);
        var value = $gPxAs.getValue(record, storageKey);
        if (value === null) this._maybeAddErrorResponseFields(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $ec8f3803098a36b1$var$getStorageKey(field, this._variables);
        var linkedID = $gPxAs.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddErrorResponseFields(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === "object") && $aaXwj(false);
        var prevErrors = this._errorResponseFields;
        this._errorResponseFields = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._errorResponseFields != null) {
            for(var i = 0; i < this._errorResponseFields.length; i++){
                var event = this._errorResponseFields[i];
                if (event.owner === this._fragmentName && (event.kind === "missing_expected_data.throw" || event.kind === "missing_expected_data.log" || event.kind === "missing_required_field.throw" || event.kind === "missing_required_field.log")) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i = this._errorResponseFields.length - 1; _i >= 0; _i--)prevErrors.push(this._errorResponseFields[_i]);
                this._errorResponseFields = prevErrors;
            }
        } else this._errorResponseFields = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $ec8f3803098a36b1$var$getStorageKey(field, this._variables);
        var externalRef = $gPxAs.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddErrorResponseFields(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $gPxAs.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $ec8f3803098a36b1$var$getStorageKey(field, this._variables);
        var linkedIDs = $gPxAs.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null) this._maybeAddErrorResponseFields(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this3 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $aaXwj(false);
        var prevErrors = this._errorResponseFields;
        this._errorResponseFields = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this3._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === "object") && $aaXwj(false);
            var prevErrors = _this3._errorResponseFields;
            _this3._errorResponseFields = null;
            linkedArray[nextIndex] = _this3._traverse(field, linkedID, prevItem);
            _this3._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var _moduleImport$compone;
        var componentKey = $ec8f3803098a36b1$var$getModuleComponentKey(moduleImport.documentName);
        var component = (_moduleImport$compone = moduleImport.componentModuleProvider) !== null && _moduleImport$compone !== void 0 ? _moduleImport$compone : $gPxAs.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing("<module-import>");
            return;
        }
        this._createFragmentPointer({
            kind: "FragmentSpread",
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$ec8f3803098a36b1$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$ec8f3803098a36b1$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._errorResponseFields;
        this._errorResponseFields = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = $gPxAs.getType(record);
        return typeName != null && typeName === type || $gPxAs.getDataID(record) === $ec8f3803098a36b1$var$ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$ec8f3803098a36b1$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$ec8f3803098a36b1$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === "object" && fragmentPointers != null) && $aaXwj(false);
        if (data[$ec8f3803098a36b1$var$ID_KEY] == null) data[$ec8f3803098a36b1$var$ID_KEY] = $gPxAs.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $ec8f3803098a36b1$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$ec8f3803098a36b1$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$ec8f3803098a36b1$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $ec8f3803098a36b1$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$ec8f3803098a36b1$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$ec8f3803098a36b1$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === "object" && fragmentPointers != null) && $aaXwj(false);
        if (data[$ec8f3803098a36b1$var$ID_KEY] == null) data[$ec8f3803098a36b1$var$ID_KEY] = $gPxAs.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $ec8f3803098a36b1$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $6zf6P.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $gPxAs.getType(record);
        var typeRecord = this._recordSource.get($ec8f3803098a36b1$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $gPxAs.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing("<abstract-type-hint>");
        return implementsInterface;
    };
    return RelayReader;
}();
function $ec8f3803098a36b1$var$markFieldErrorHasHandled(event) {
    switch(event.kind){
        case "missing_expected_data.throw":
        case "missing_required_field.throw":
        case "relay_field_payload.error":
        case "relay_resolver.error":
            return (0, $ec8f3803098a36b1$var$_objectSpread2["default"])((0, $ec8f3803098a36b1$var$_objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case "missing_expected_data.log":
        case "missing_required_field.log":
            return event;
        default:
            event.kind;
            $aaXwj(false);
    }
}
function $ec8f3803098a36b1$var$getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === "function" ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $ec8f3803098a36b1$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== $ec8f3803098a36b1$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $ec8f3803098a36b1$var$extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === "string") return individualResponse;
    else if (typeof individualResponse === "object" && individualResponse != null && typeof individualResponse.id === "string") return individualResponse.id;
    $aaXwj(false);
}
module.exports = {
    read: $ec8f3803098a36b1$var$read
};

});
parcelRegister("d6Nxo", function(module, exports) {
"use strict";

var $dgrHZ = parcelRequire("dgrHZ");
var $98b24302df005c2b$var$RELAY_LIVE_RESOLVER = $dgrHZ.RELAY_LIVE_RESOLVER;

var $aaXwj = parcelRequire("aaXwj");
var $98b24302df005c2b$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $98b24302df005c2b$var$RELAY_LIVE_RESOLVER) && $aaXwj(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $aaXwj(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: $98b24302df005c2b$var$NoopResolverCache
};

});




parcelRegister("6SV6U", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5034162d5cdbb553$var$_interopRequireDefault = $1jnue.default;

var $5034162d5cdbb553$var$_createForOfIteratorHelper2 = $5034162d5cdbb553$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $5034162d5cdbb553$var$_defineProperty2 = $5034162d5cdbb553$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $5Tok1 = parcelRequire("5Tok1");
var $5034162d5cdbb553$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $5Tok1.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $5034162d5cdbb553$var$assertInternalActorIdentifier = $5Tok1.assertInternalActorIdentifier;
parcelRequire("4ERpj");

var $9EkOZ = parcelRequire("9EkOZ");

var $eYuFa = parcelRequire("eYuFa");

var $ciRhT = parcelRequire("ciRhT");

var $jvwgv = parcelRequire("jvwgv");
var $5034162d5cdbb553$var$LiveResolverCache = $jvwgv.LiveResolverCache, $5034162d5cdbb553$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $jvwgv.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $5034162d5cdbb553$var$getUpdatedDataIDs = $jvwgv.getUpdatedDataIDs;

var $gPxAs = parcelRequire("gPxAs");

var $bbeIO = parcelRequire("bbeIO");

var $kjcqj = parcelRequire("kjcqj");

var $doi4H = parcelRequire("doi4H");

var $cWmsa = parcelRequire("cWmsa");

var $boOnJ = parcelRequire("boOnJ");

var $boOnJ = parcelRequire("boOnJ");
var $5034162d5cdbb553$var$ROOT_ID = $boOnJ.ROOT_ID, $5034162d5cdbb553$var$ROOT_TYPE = $boOnJ.ROOT_TYPE;

var $aaXwj = parcelRequire("aaXwj");
var $5034162d5cdbb553$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $5034162d5cdbb553$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing;
        (0, $5034162d5cdbb553$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $5034162d5cdbb553$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $9EkOZ;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $ciRhT;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $5034162d5cdbb553$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $cWmsa(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        $5034162d5cdbb553$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: "liveresolver.batch.start"
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: "liveresolver.batch.end"
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: "stale"
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $5034162d5cdbb553$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $5034162d5cdbb553$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $eYuFa.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $5034162d5cdbb553$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log);
        return $5034162d5cdbb553$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: "store.lookup.start",
            selector: selector
        });
        var source = this.getSource();
        var snapshot = $kjcqj.read(source, selector, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: "store.lookup.end",
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: "store.notify.start",
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === "query" && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        if (log != null) log({
            name: "store.notify.complete",
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $5034162d5cdbb553$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: "store.publish",
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return "RelayModernStore()";
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $gPxAs.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set("global", this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get("global") !== prevInvalidations.get("global")) return true;
        var _iterator = (0, $5034162d5cdbb553$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $aaXwj(false);
        var log = this.__log;
        if (log != null) log({
            name: "store.snapshot"
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $bbeIO.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $aaXwj(false);
        var log = this.__log;
        if (log != null) log({
            name: "store.restore"
        });
        var optimisticIDs = $bbeIO.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: "store.gc.start"
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $5034162d5cdbb553$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $doi4H.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: "store.gc.interrupted"
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $gPxAs.getValue(record, $5034162d5cdbb553$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            if (log != null) log({
                name: "store.gc.end",
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $5034162d5cdbb553$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function $5034162d5cdbb553$var$initializeRecordSource(target) {
    if (!target.has($5034162d5cdbb553$var$ROOT_ID)) {
        var rootRecord = $gPxAs.create($5034162d5cdbb553$var$ROOT_ID, $5034162d5cdbb553$var$ROOT_TYPE);
        target.set($5034162d5cdbb553$var$ROOT_ID, rootRecord);
    }
}
function $5034162d5cdbb553$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $gPxAs.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $gPxAs.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $gPxAs.setValue(nextRecord, $boOnJ.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $gPxAs.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $5034162d5cdbb553$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === "number") {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: "stale"
        };
    }
    if (status === "missing") return {
        status: "missing"
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: "stale"
        };
    }
    return {
        status: "available",
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $5034162d5cdbb553$var$RelayModernStore;

});
parcelRegister("9EkOZ", function(module, exports) {
"use strict";
var $7068002cbb0021d0$var$resolvedPromise = Promise.resolve();
function $7068002cbb0021d0$var$resolveImmediate(callback) {
    $7068002cbb0021d0$var$resolvedPromise.then(callback)["catch"]($7068002cbb0021d0$var$throwNext);
}
function $7068002cbb0021d0$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $7068002cbb0021d0$var$resolveImmediate;

});

parcelRegister("eYuFa", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ae6e745031c91362$var$_interopRequireDefault = $1jnue.default;

var $ae6e745031c91362$var$_createForOfIteratorHelper2 = $ae6e745031c91362$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $kKRsY = parcelRequire("kKRsY");

var $PfUON = parcelRequire("PfUON");

var $1Qbuk = parcelRequire("1Qbuk");

var $2Zm5L = parcelRequire("2Zm5L");
var $ae6e745031c91362$var$isClientID = $2Zm5L.isClientID;

var $dAzQU = parcelRequire("dAzQU");

var $5E9XW = parcelRequire("5E9XW");

var $6zf6P = parcelRequire("6zf6P");
var $ae6e745031c91362$var$getLocalVariables = $6zf6P.getLocalVariables;

var $gPxAs = parcelRequire("gPxAs");

var $41YHA = parcelRequire("41YHA");
var $ae6e745031c91362$var$EXISTENT = $41YHA.EXISTENT, $ae6e745031c91362$var$UNKNOWN = $41YHA.UNKNOWN;

var $boOnJ = parcelRequire("boOnJ");

var $49Jzj = parcelRequire("49Jzj");
var $ae6e745031c91362$var$TYPE_SCHEMA_TYPE = $49Jzj.TYPE_SCHEMA_TYPE, $ae6e745031c91362$var$generateTypeID = $49Jzj.generateTypeID;

var $aaXwj = parcelRequire("aaXwj");
var $ae6e745031c91362$var$getModuleOperationKey = $boOnJ.getModuleOperationKey, $ae6e745031c91362$var$getStorageKey = $boOnJ.getStorageKey, $ae6e745031c91362$var$getArgumentValues = $boOnJ.getArgumentValues;
function $ae6e745031c91362$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log) {
    if (log != null) log({
        name: "store.datachecker.start",
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $ae6e745031c91362$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: "store.datachecker.end",
        selector: selector
    });
    return result;
}
var $ae6e745031c91362$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $kKRsY(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $PfUON(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: "missing",
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: "available",
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === "id" && field.alias == null && $ae6e745031c91362$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $ae6e745031c91362$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $ae6e745031c91362$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === "scalar") {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $ae6e745031c91362$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $ae6e745031c91362$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === "linked") {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $ae6e745031c91362$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $ae6e745031c91362$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $ae6e745031c91362$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === "pluralLinked") {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $ae6e745031c91362$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $ae6e745031c91362$var$UNKNOWN) this._handleMissing();
        if (status === $ae6e745031c91362$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $gPxAs.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case "ScalarField":
                    _this2._checkScalar(selection, dataID);
                    break;
                case "LinkedField":
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case "ActorChange":
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case "Condition":
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case "InlineFragment":
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $aaXwj(false);
                        var _typeID = $ae6e745031c91362$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case "LinkedHandle":
                    var handleField = $dAzQU(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case "ScalarHandle":
                    var _handleField = $5E9XW(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case "ModuleImport":
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case "Defer":
                case "Stream":
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case "FragmentSpread":
                    var prevVariables = _this2._variables;
                    _this2._variables = $ae6e745031c91362$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case "ClientExtension":
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case "TypeDiscriminator":
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $aaXwj(false);
                    var typeID = $ae6e745031c91362$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case "ClientComponent":
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case "RelayResolver":
                    _this2._checkResolver(selection, dataID);
                    break;
                case "RelayLiveResolver":
                    _this2._checkResolver(selection, dataID);
                    break;
                case "ClientEdgeToClientObject":
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        var operationKey = $ae6e745031c91362$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $1Qbuk(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $ae6e745031c91362$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $ae6e745031c91362$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $ae6e745031c91362$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $ae6e745031c91362$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $ae6e745031c91362$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $gPxAs.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $ae6e745031c91362$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $ae6e745031c91362$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $ae6e745031c91362$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $ae6e745031c91362$var$check
};

});
parcelRegister("dAzQU", function(module, exports) {
"use strict";

var $dgrHZ = parcelRequire("dgrHZ");
var $9e4a72b55bd5f84c$var$LINKED_FIELD = $dgrHZ.LINKED_FIELD;

var $boOnJ = parcelRequire("boOnJ");
var $9e4a72b55bd5f84c$var$getHandleStorageKey = $boOnJ.getHandleStorageKey;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
function $9e4a72b55bd5f84c$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $9e4a72b55bd5f84c$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $ewhZB(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $9e4a72b55bd5f84c$var$LINKED_FIELD) && $aaXwj(false);
    var handleKey = $9e4a72b55bd5f84c$var$getHandleStorageKey(handleField, variables);
    return {
        kind: "LinkedField",
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $9e4a72b55bd5f84c$var$cloneRelayHandleSourceField;

});

parcelRegister("5E9XW", function(module, exports) {
"use strict";

var $dgrHZ = parcelRequire("dgrHZ");
var $41c86b26ea54a1a7$var$SCALAR_FIELD = $dgrHZ.SCALAR_FIELD;

var $boOnJ = parcelRequire("boOnJ");
var $41c86b26ea54a1a7$var$getHandleStorageKey = $boOnJ.getHandleStorageKey;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
function $41c86b26ea54a1a7$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $41c86b26ea54a1a7$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $ewhZB(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $41c86b26ea54a1a7$var$SCALAR_FIELD) && $aaXwj(false);
    var handleKey = $41c86b26ea54a1a7$var$getHandleStorageKey(handleField, variables);
    return {
        kind: "ScalarField",
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $41c86b26ea54a1a7$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("jvwgv", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e339f0c28ac7abf9$var$_interopRequireDefault = $1jnue.default;

var $e339f0c28ac7abf9$var$_createForOfIteratorHelper2 = $e339f0c28ac7abf9$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $2qPt3 = parcelRequire("2qPt3");

var $dgrHZ = parcelRequire("dgrHZ");
var $e339f0c28ac7abf9$var$RELAY_LIVE_RESOLVER = $dgrHZ.RELAY_LIVE_RESOLVER;

var $9nfN5 = parcelRequire("9nfN5");

var $gu3tP = parcelRequire("gu3tP");

var $2Zm5L = parcelRequire("2Zm5L");
var $e339f0c28ac7abf9$var$generateClientID = $2Zm5L.generateClientID, $e339f0c28ac7abf9$var$generateClientObjectClientID = $2Zm5L.generateClientObjectClientID;

var $gPxAs = parcelRequire("gPxAs");

var $cTAdw = parcelRequire("cTAdw");
var $e339f0c28ac7abf9$var$createNormalizationSelector = $cTAdw.createNormalizationSelector;

var $iUWBj = parcelRequire("iUWBj");

var $k8Yke = parcelRequire("k8Yke");
var $e339f0c28ac7abf9$var$normalize = $k8Yke.normalize;

var $boOnJ = parcelRequire("boOnJ");
var $e339f0c28ac7abf9$var$RELAY_RESOLVER_ERROR_KEY = $boOnJ.RELAY_RESOLVER_ERROR_KEY, $e339f0c28ac7abf9$var$RELAY_RESOLVER_INVALIDATION_KEY = $boOnJ.RELAY_RESOLVER_INVALIDATION_KEY, $e339f0c28ac7abf9$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $boOnJ.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $e339f0c28ac7abf9$var$RELAY_RESOLVER_SNAPSHOT_KEY = $boOnJ.RELAY_RESOLVER_SNAPSHOT_KEY, $e339f0c28ac7abf9$var$RELAY_RESOLVER_VALUE_KEY = $boOnJ.RELAY_RESOLVER_VALUE_KEY, $e339f0c28ac7abf9$var$getStorageKey = $boOnJ.getStorageKey;

var $2bjN9 = parcelRequire("2bjN9");

var $cBaPl = parcelRequire("cBaPl");

var $4T3eA = parcelRequire("4T3eA");
var $e339f0c28ac7abf9$var$isSuspenseSentinel = $4T3eA.isSuspenseSentinel;

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = "__resolverLiveStateSubscription";
var $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_VALUE = "__resolverLiveStateValue";
var $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = "__resolverLiveStateDirty";
var $e339f0c28ac7abf9$var$RELAY_RESOLVER_RECORD_TYPENAME = "__RELAY_RESOLVER__";
var $e339f0c28ac7abf9$var$MODEL_PROPERTY_NAME = "__relay_model_instance";
function $e339f0c28ac7abf9$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $e339f0c28ac7abf9$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $e339f0c28ac7abf9$var$expectRecord(recordSource, recordID);
        var storageKey = $e339f0c28ac7abf9$var$getStorageKey(field, variables);
        var linkedID = $gPxAs.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $e339f0c28ac7abf9$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $e339f0c28ac7abf9$var$generateClientID(recordID, storageKey);
            linkedRecord = $gPxAs.create(linkedID, $e339f0c28ac7abf9$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $gPxAs.setValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $gPxAs.setValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $e339f0c28ac7abf9$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $aaXwj(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $e339f0c28ac7abf9$var$expectRecord(recordSource, recordID);
            var nextRecord = $gPxAs.clone(currentRecord);
            $gPxAs.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $e339f0c28ac7abf9$var$getStorageKey(field.fragment, variables);
                var resolverID = $e339f0c28ac7abf9$var$generateClientID(recordID, fragmentStorageKey);
                $e339f0c28ac7abf9$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $e339f0c28ac7abf9$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $e339f0c28ac7abf9$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $e339f0c28ac7abf9$var$RELAY_LIVE_RESOLVER && $gPxAs.getValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $e339f0c28ac7abf9$var$generateClientID(recordID, storageKey);
            linkedRecord = $gPxAs.clone(linkedRecord);
            var _liveState = $gPxAs.getValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$cBaPl(_liveState)) $aaXwj(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $gPxAs.setValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $gPxAs.getValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $gPxAs.getValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($e339f0c28ac7abf9$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $e339f0c28ac7abf9$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $aaXwj(false);
        var liveState = $gPxAs.getValue(liveStateRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $gPxAs.setValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $gPxAs.setValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $gPxAs.setValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$gPxAs.hasValue(currentRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $gPxAs.clone(currentRecord);
            $gPxAs.setValue(nextRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $iUWBj.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $iUWBj.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $aaXwj(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $gPxAs.setValue(resolverRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$e339f0c28ac7abf9$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $2bjN9(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $aaXwj(false);
                resolverValue = [];
                var nextSource = $iUWBj.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === "object") && $aaXwj(false);
                    var typename = $e339f0c28ac7abf9$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $e339f0c28ac7abf9$var$generateClientObjectClientID(typename, $gPxAs.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $e339f0c28ac7abf9$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $e339f0c28ac7abf9$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === "object") && $aaXwj(false);
                var _typename = $e339f0c28ac7abf9$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $e339f0c28ac7abf9$var$generateClientObjectClientID(_typename, $gPxAs.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $e339f0c28ac7abf9$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $gPxAs.setValue(resolverRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $gu3tP(resolverValue);
            $gPxAs.setValue(resolverRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $gu3tP(value);
            $gPxAs.setValue(resolverRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $gPxAs.getValue(resolverRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $e339f0c28ac7abf9$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$gPxAs.getValue(record, $e339f0c28ac7abf9$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $gPxAs.getValue(record, $e339f0c28ac7abf9$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $2qPt3(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($9nfN5.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $gPxAs.clone(record);
            $gPxAs.setValue(nextRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($gPxAs.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $iUWBj.create();
        switch(normalizationInfo.kind){
            case "OutputType":
                var record = $gPxAs.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $e339f0c28ac7abf9$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $e339f0c28ac7abf9$var$normalize(source, selector, value, normalizationOptions).source;
            case "WeakModel":
                var _record = $gPxAs.create(outputTypeDataID, typename);
                $gPxAs.setValue(_record, $e339f0c28ac7abf9$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $aaXwj(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $e339f0c28ac7abf9$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $gPxAs.create(key, typeName);
            $gPxAs.setValue(newRecord, "id", id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $e339f0c28ac7abf9$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $e339f0c28ac7abf9$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $e339f0c28ac7abf9$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $e339f0c28ac7abf9$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $e339f0c28ac7abf9$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $gPxAs.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $e339f0c28ac7abf9$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $e339f0c28ac7abf9$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $gPxAs.getFields(record).forEach(function(field) {
        if ($gPxAs.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $gPxAs.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($gPxAs.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $gPxAs.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $e339f0c28ac7abf9$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $gPxAs.clone(record);
    $gPxAs.setValue(nextRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $e339f0c28ac7abf9$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $e339f0c28ac7abf9$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $e339f0c28ac7abf9$var$isResolverRecord(_record2)) $e339f0c28ac7abf9$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $e339f0c28ac7abf9$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $e339f0c28ac7abf9$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $e339f0c28ac7abf9$var$isResolverRecord(record)) $e339f0c28ac7abf9$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $e339f0c28ac7abf9$var$isResolverRecord(record) {
    return $gPxAs.getType(record) === $e339f0c28ac7abf9$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $e339f0c28ac7abf9$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $gPxAs.getValue(linkedRecord, $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $e339f0c28ac7abf9$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $aaXwj(false);
    return record;
}
function $e339f0c28ac7abf9$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $e339f0c28ac7abf9$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $aaXwj(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $e339f0c28ac7abf9$var$LiveResolverCache,
    getUpdatedDataIDs: $e339f0c28ac7abf9$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $e339f0c28ac7abf9$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("gu3tP", function(module, exports) {
"use strict";
module.exports = function shallowFreeze(value) {
    if (typeof value === "object" && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("2bjN9", function(module, exports) {
"use strict";

var $gPxAs = parcelRequire("gPxAs");

var $boOnJ = parcelRequire("boOnJ");
var $196bf614879e2035$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $boOnJ.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $aaXwj = parcelRequire("aaXwj");
function $196bf614879e2035$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $gPxAs.getValue(record, $196bf614879e2035$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $aaXwj(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $196bf614879e2035$var$getOutputTypeRecordIDs;

});

parcelRegister("cBaPl", function(module, exports) {
"use strict";
function $92c156cbff7221e7$var$isLiveStateValue(v) {
    return v != null && typeof v === "object" && typeof v.read === "function" && typeof v.subscribe === "function";
}
module.exports = $92c156cbff7221e7$var$isLiveStateValue;

});


parcelRegister("bbeIO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $823c243c35614bc1$var$_interopRequireDefault = $1jnue.default;

var $823c243c35614bc1$var$_objectSpread2 = $823c243c35614bc1$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $gPxAs = parcelRequire("gPxAs");

var $iUWBj = parcelRequire("iUWBj");

var $aaXwj = parcelRequire("aaXwj");
var $823c243c35614bc1$var$UNPUBLISH_RECORD_SENTINEL = $gPxAs.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $823c243c35614bc1$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $iUWBj.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $823c243c35614bc1$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $823c243c35614bc1$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return "UNKNOWN";
        else if (record === null) return "NONEXISTENT";
        else return "EXISTENT";
    };
    _proto.clear = function clear() {
        this._base = $iUWBj.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $823c243c35614bc1$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $823c243c35614bc1$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $gPxAs.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $823c243c35614bc1$var$create(base) {
    return new $823c243c35614bc1$var$RelayOptimisticRecordSource(base);
}
function $823c243c35614bc1$var$getOptimisticRecordIDs(source) {
    !(source instanceof $823c243c35614bc1$var$RelayOptimisticRecordSource) && $aaXwj(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $823c243c35614bc1$var$create,
    getOptimisticRecordIDs: $823c243c35614bc1$var$getOptimisticRecordIDs
};

});

parcelRegister("doi4H", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9bfb898dd89af9aa$var$_interopRequireDefault = $1jnue.default;

var $9bfb898dd89af9aa$var$_createForOfIteratorHelper2 = $9bfb898dd89af9aa$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $1Qbuk = parcelRequire("1Qbuk");

var $dAzQU = parcelRequire("dAzQU");

var $2bjN9 = parcelRequire("2bjN9");

var $6zf6P = parcelRequire("6zf6P");
var $9bfb898dd89af9aa$var$getLocalVariables = $6zf6P.getLocalVariables;

var $gPxAs = parcelRequire("gPxAs");

var $boOnJ = parcelRequire("boOnJ");

var $49Jzj = parcelRequire("49Jzj");
var $9bfb898dd89af9aa$var$generateTypeID = $49Jzj.generateTypeID;

var $aaXwj = parcelRequire("aaXwj");
var $9bfb898dd89af9aa$var$getStorageKey = $boOnJ.getStorageKey, $9bfb898dd89af9aa$var$getModuleOperationKey = $boOnJ.getModuleOperationKey;
function $9bfb898dd89af9aa$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $9bfb898dd89af9aa$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
var $9bfb898dd89af9aa$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === "Operation" || node.kind === "SplitOperation") this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case "ActorChange":
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case "LinkedField":
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case "Condition":
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case "InlineFragment":
                    if (selection.abstractKey == null) {
                        var typeName = $gPxAs.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $boOnJ.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $gPxAs.getType(record);
                        var typeID = $9bfb898dd89af9aa$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case "FragmentSpread":
                    var prevVariables = _this._variables;
                    _this._variables = $9bfb898dd89af9aa$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case "LinkedHandle":
                    var handleField = $dAzQU(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case "Defer":
                case "Stream":
                    _this._traverseSelections(selection.selections, record);
                    break;
                case "ScalarField":
                case "ScalarHandle":
                    break;
                case "TypeDiscriminator":
                    var _typeName2 = $gPxAs.getType(record);
                    var _typeID = $9bfb898dd89af9aa$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case "ModuleImport":
                    _this._traverseModuleImport(selection, record);
                    break;
                case "ClientExtension":
                    _this._traverseSelections(selection.selections, record);
                    break;
                case "ClientComponent":
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case "RelayResolver":
                    _this._traverseResolverField(selection, record);
                    break;
                case "RelayLiveResolver":
                    _this._traverseResolverField(selection, record);
                    break;
                case "ClientEdgeToClientObject":
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $2bjN9(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $9bfb898dd89af9aa$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $gPxAs.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $9bfb898dd89af9aa$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $gPxAs.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = $9bfb898dd89af9aa$var$getStorageKey(field, this._variables);
        var dataID = $gPxAs.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        var operationKey = $9bfb898dd89af9aa$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $gPxAs.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $1Qbuk(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $9bfb898dd89af9aa$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $9bfb898dd89af9aa$var$getStorageKey(field, this._variables);
        var linkedID = $gPxAs.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $9bfb898dd89af9aa$var$getStorageKey(field, this._variables);
        var linkedIDs = $gPxAs.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $9bfb898dd89af9aa$var$mark
};

});

parcelRegister("cWmsa", function(module, exports) {
"use strict";
parcelRequire("4ERpj");

var $2qPt3 = parcelRequire("2qPt3");

var $9nfN5 = parcelRequire("9nfN5");

var $5u0Ki = parcelRequire("5u0Ki");

var $h2itc = parcelRequire("h2itc");

var $kjcqj = parcelRequire("kjcqj");
var $96bc5194ef3a9004$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $kjcqj.read(source, snapshot.selector, _this2._resolverCache, _this2._resolverContext);
            var nextData = $2qPt3(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    errorResponseFields: backup.errorResponseFields
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $5u0Ki(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $kjcqj.read(source, snapshot.selector, this._resolverCache, this._resolverContext) : backup;
        var nextData = $2qPt3(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            errorResponseFields: nextSnapshot.errorResponseFields
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $9nfN5.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: "store.notify.subscription",
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($9nfN5.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $h2itc(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $96bc5194ef3a9004$var$RelayStoreSubscriptions;

});
parcelRegister("5u0Ki", function(module, exports) {
"use strict";
var $3fe0552ae668f65b$var$ITERATOR_KEY = Symbol.iterator;
function $3fe0552ae668f65b$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$3fe0552ae668f65b$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $3fe0552ae668f65b$var$hasOverlappingIDs;

});

parcelRegister("h2itc", function(module, exports) {
"use strict";

var $boOnJ = parcelRequire("boOnJ");
var $c670f34f31bb7bf0$var$ROOT_ID = $boOnJ.ROOT_ID;

var $8Dxz4 = parcelRequire("8Dxz4");
var $c670f34f31bb7bf0$var$VIEWER_ID = $8Dxz4.VIEWER_ID;
var $c670f34f31bb7bf0$var$ITERATOR_KEY = Symbol.iterator;
function $c670f34f31bb7bf0$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$c670f34f31bb7bf0$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $c670f34f31bb7bf0$var$ROOT_ID && key !== $c670f34f31bb7bf0$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $c670f34f31bb7bf0$var$hasSignificantOverlappingIDs;

});



parcelRegister("4i4EY", function(module, exports) {
"use strict";

var $ioH3s = parcelRequire("ioH3s");

var $kx3Ii = parcelRequire("kx3Ii");
var $31fc753501530181$var$getRequest = $kx3Ii.getRequest;

var $j6kQy = parcelRequire("j6kQy");
var $31fc753501530181$var$createOperationDescriptor = $j6kQy.createOperationDescriptor;

var $cTAdw = parcelRequire("cTAdw");
var $31fc753501530181$var$createReaderSelector = $cTAdw.createReaderSelector;
parcelRequire("8Fbfi");
function $31fc753501530181$var$requestSubscription(environment, config) {
    var subscription = $31fc753501530181$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== "subscription") throw new Error("requestSubscription: Must use Subscription operation");
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $31fc753501530181$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $ioH3s.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === "string") selector = $31fc753501530181$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $31fc753501530181$var$requestSubscription;

});

parcelRegister("2hcuI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1a86dc6942bb2c9d$var$_interopRequireDefault = $1jnue.default;

var $1a86dc6942bb2c9d$var$_objectSpread2 = $1a86dc6942bb2c9d$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $boOnJ = parcelRequire("boOnJ");
var $1a86dc6942bb2c9d$var$getModuleComponentKey = $boOnJ.getModuleComponentKey, $1a86dc6942bb2c9d$var$getModuleOperationKey = $boOnJ.getModuleOperationKey;
function $1a86dc6942bb2c9d$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $1a86dc6942bb2c9d$var$_objectSpread2["default"])({}, response);
    data[$1a86dc6942bb2c9d$var$getModuleComponentKey(name)] = component;
    data[$1a86dc6942bb2c9d$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $1a86dc6942bb2c9d$var$createPayloadFor3DField;

});

parcelRegister("eahk4", function(module, exports) {
"use strict";

var $cTAdw = parcelRequire("cTAdw");
var $a4ff6fc41c587b99$var$getDataIDsFromFragment = $cTAdw.getDataIDsFromFragment, $a4ff6fc41c587b99$var$getSelector = $cTAdw.getSelector, $a4ff6fc41c587b99$var$getVariablesFromFragment = $cTAdw.getVariablesFromFragment;

var $kxJli = parcelRequire("kxJli");

var $9nfN5 = parcelRequire("9nfN5");

var $a9M0M = parcelRequire("a9M0M");
var $a4ff6fc41c587b99$var$stableCopy = $a9M0M.stableCopy;

var $ib6Cf = parcelRequire("ib6Cf");
var $a4ff6fc41c587b99$var$intern = $ib6Cf.intern;
function $a4ff6fc41c587b99$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $a4ff6fc41c587b99$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? "null" : selector.kind === "SingularReaderSelector" ? selector.owner.identifier : "[" + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(",") + "]";
    var fragmentVariables = $a4ff6fc41c587b99$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $a4ff6fc41c587b99$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($9nfN5.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === "undefined" ? "missing" : dataIDs == null ? "null" : Array.isArray(dataIDs) ? "[" + dataIDs.join(",") + "]" : dataIDs;
        ids = $9nfN5.STRING_INTERN_LEVEL <= 1 ? ids : $a4ff6fc41c587b99$var$intern(ids, $9nfN5.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + "/" + fragmentNode.name + "/" + (fragmentVariables == null || $kxJli(fragmentVariables) ? "{}" : JSON.stringify($a4ff6fc41c587b99$var$stableCopy(fragmentVariables))) + "/" + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "missing";
        _ids = $9nfN5.STRING_INTERN_LEVEL <= 1 ? _ids : $a4ff6fc41c587b99$var$intern(_ids, $9nfN5.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + "/" + fragmentNode.name + "/" + JSON.stringify($a4ff6fc41c587b99$var$stableCopy(fragmentVariables)) + "/" + _ids;
    }
}
module.exports = $a4ff6fc41c587b99$var$getFragmentIdentifier;

});
parcelRegister("kxJli", function(module, exports) {
"use strict";
var $ef4a0fc53df39e17$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $ef4a0fc53df39e17$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($ef4a0fc53df39e17$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $ef4a0fc53df39e17$var$isEmptyObject;

});


parcelRegister("iPEiW", function(module, exports) {
"use strict";

var $jtDJm = parcelRequire("jtDJm");

var $aaXwj = parcelRequire("aaXwj");
function $db5c411124f3d754$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $jtDJm(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $aaXwj(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $aaXwj(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === "string") && $aaXwj(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $db5c411124f3d754$var$getPaginationMetadata;

});
parcelRegister("jtDJm", function(module, exports) {
"use strict";

var $aaXwj = parcelRequire("aaXwj");
function $e2df8b728854104b$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $aaXwj(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $aaXwj(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== "string") && $aaXwj(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === "string") && $aaXwj(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === "string") && $aaXwj(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $e2df8b728854104b$var$getRefetchMetadata;

});


parcelRegister("4w68P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $349eea278e29c274$var$_interopRequireDefault = $1jnue.default;

var $349eea278e29c274$var$_defineProperty2 = $349eea278e29c274$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $349eea278e29c274$var$_objectSpread4 = $349eea278e29c274$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $349eea278e29c274$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === "backward") {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $aaXwj(false);
        var _paginationVariables = (0, $349eea278e29c274$var$_objectSpread4["default"])((0, $349eea278e29c274$var$_objectSpread4["default"])((0, $349eea278e29c274$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $349eea278e29c274$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $349eea278e29c274$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $aaXwj(false);
    var paginationVariables = (0, $349eea278e29c274$var$_objectSpread4["default"])((0, $349eea278e29c274$var$_objectSpread4["default"])((0, $349eea278e29c274$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $349eea278e29c274$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $349eea278e29c274$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $349eea278e29c274$var$getPaginationVariables;

});

parcelRegister("6Aftc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4cb21ae621e44fd1$var$_interopRequireDefault = $1jnue.default;

var $4cb21ae621e44fd1$var$_createForOfIteratorHelper2 = $4cb21ae621e44fd1$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $aaXwj = parcelRequire("aaXwj");
function $4cb21ae621e44fd1$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $4cb21ae621e44fd1$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === "number") {
                !Array.isArray(result) && $aaXwj(false);
                result = result[key];
            } else {
                !(typeof result === "object" && !Array.isArray(result)) && $aaXwj(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $4cb21ae621e44fd1$var$getValueAtPath;

});

parcelRegister("gjUUf", function(module, exports) {
"use strict";
var $be1a901218462152$var$profileHandlersByName = {};
var $be1a901218462152$var$defaultProfiler = {
    stop: function stop() {}
};
var $be1a901218462152$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $be1a901218462152$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $be1a901218462152$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$be1a901218462152$var$profileHandlersByName.hasOwnProperty(name)) $be1a901218462152$var$profileHandlersByName[name] = [];
        $be1a901218462152$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($be1a901218462152$var$profileHandlersByName.hasOwnProperty(name)) $be1a901218462152$var$removeFromArray($be1a901218462152$var$profileHandlersByName[name], handler);
    }
};
function $be1a901218462152$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $be1a901218462152$var$RelayProfiler;

});




parcelRegister("dtE14", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9cfd0632bd918039$var$_interopRequireDefault = $1jnue.default;

var $9cfd0632bd918039$var$_extends2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $9cfd0632bd918039$var$_objectWithoutPropertiesLoose2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("c05no")));

var $9cfd0632bd918039$var$_assertThisInitialized2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("6zC7B")));

var $9cfd0632bd918039$var$_inheritsLoose2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("6r4zt")));

var $9cfd0632bd918039$var$_defineProperty2 = $9cfd0632bd918039$var$_interopRequireDefault((parcelRequire("g5Zhu")));
var $9cfd0632bd918039$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $lSLpg = parcelRequire("lSLpg");

var $3ixBO = parcelRequire("3ixBO");
var $9cfd0632bd918039$var$getContainerName = $3ixBO.getContainerName;

var $6IwOm = parcelRequire("6IwOm");
var $9cfd0632bd918039$var$assertRelayContext = $6IwOm.assertRelayContext;

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $9cfd0632bd918039$var$createFragmentSpecResolver = $lcVKE.createFragmentSpecResolver, $9cfd0632bd918039$var$getDataIDsFromObject = $lcVKE.getDataIDsFromObject, $9cfd0632bd918039$var$isScalarAndEqual = $lcVKE.isScalarAndEqual;
function $9cfd0632bd918039$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $9cfd0632bd918039$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $9cfd0632bd918039$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $9cfd0632bd918039$var$_defineProperty2["default"])((0, $9cfd0632bd918039$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $9cfd0632bd918039$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $9cfd0632bd918039$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $9cfd0632bd918039$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $9cfd0632bd918039$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $9cfd0632bd918039$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $9cfd0632bd918039$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $9cfd0632bd918039$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$ewhZB(prevIDs, nextIDs)) {
                resolver = $9cfd0632bd918039$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $9cfd0632bd918039$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $9cfd0632bd918039$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === "__relayContext") {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$9cfd0632bd918039$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $9cfd0632bd918039$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $9cfd0632bd918039$var$_excluded);
            return /*#__PURE__*/ $acw62.createElement(Component, (0, $9cfd0632bd918039$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($acw62.Component), (0, $9cfd0632bd918039$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $9cfd0632bd918039$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $9cfd0632bd918039$var$createContainer(Component, fragmentSpec) {
    return $lSLpg(Component, fragmentSpec, $9cfd0632bd918039$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $9cfd0632bd918039$var$createContainer
};

});
parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6r4zt", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $4af8cf748148995c$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $aAhot(t, o);
}
module.exports = $4af8cf748148995c$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lSLpg", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fee36a111fa579ba$var$_interopRequireDefault = $1jnue.default;

var $fee36a111fa579ba$var$_extends2 = $fee36a111fa579ba$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $9RnpX = parcelRequire("9RnpX");

var $3ixBO = parcelRequire("3ixBO");
var $fee36a111fa579ba$var$getComponentName = $3ixBO.getComponentName, $fee36a111fa579ba$var$getContainerName = $3ixBO.getContainerName;

var $j5wbN = parcelRequire("j5wbN");

var $7WvV7 = parcelRequire("7WvV7");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $fee36a111fa579ba$var$getFragment = $lcVKE.getFragment;
var $fee36a111fa579ba$var$useContext = $acw62.useContext;
function $fee36a111fa579ba$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $fee36a111fa579ba$var$getContainerName(ComponentClass);
    $9RnpX($fee36a111fa579ba$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $fee36a111fa579ba$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $fee36a111fa579ba$var$useContext($j5wbN);
        !(context != null) && $aaXwj(false);
        var queryRendererContext = $fee36a111fa579ba$var$useContext($7WvV7);
        return /*#__PURE__*/ $acw62.createElement(Container, (0, $fee36a111fa579ba$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $acw62.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $fee36a111fa579ba$var$buildReactRelayContainer;

});
parcelRegister("9RnpX", function(module, exports) {
"use strict";

var $aaXwj = parcelRequire("aaXwj");
function $72db3a93f5da1b8a$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === "object") && $aaXwj(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === "object" || typeof fragment === "function")) && $aaXwj(false);
    }
}
module.exports = $72db3a93f5da1b8a$var$assertFragmentMap;

});

parcelRegister("3ixBO", function(module, exports) {
"use strict";
function $266d1f901031532e$var$getComponentName(component) {
    return component.displayName || component.name || "Component";
}
function $266d1f901031532e$var$getContainerName(Component) {
    return "Relay(" + $266d1f901031532e$var$getComponentName(Component) + ")";
}
module.exports = {
    getComponentName: $266d1f901031532e$var$getComponentName,
    getContainerName: $266d1f901031532e$var$getContainerName
};

});

parcelRegister("7WvV7", function(module, exports) {
"use strict";

var $acw62 = parcelRequire("acw62");
module.exports = $acw62.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("6IwOm", function(module, exports) {
"use strict";

var $9oOwi = parcelRequire("9oOwi");

var $aaXwj = parcelRequire("aaXwj");
function $4e404dc609e87032$var$assertRelayContext(relay) {
    !$4e404dc609e87032$var$isRelayContext(relay) && $aaXwj(false);
    return relay;
}
function $4e404dc609e87032$var$isRelayContext(context) {
    return typeof context === "object" && context !== null && !Array.isArray(context) && $9oOwi(context.environment);
}
module.exports = {
    assertRelayContext: $4e404dc609e87032$var$assertRelayContext,
    isRelayContext: $4e404dc609e87032$var$isRelayContext
};

});
parcelRegister("9oOwi", function(module, exports) {
"use strict";
function $6d7d8b201d442cc1$var$isRelayEnvironment(environment) {
    return typeof environment === "object" && environment !== null && typeof environment.check === "function" && typeof environment.lookup === "function" && typeof environment.retain === "function" && typeof environment.execute === "function" && typeof environment.subscribe === "function";
}
module.exports = $6d7d8b201d442cc1$var$isRelayEnvironment;

});



parcelRegister("d4mGr", function(module, exports) {
"use strict";

var $j5wbN = parcelRequire("j5wbN");

var $7WvV7 = parcelRequire("7WvV7");

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $983d3e946124bafe$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $983d3e946124bafe$var$deepFreeze = $lcVKE.deepFreeze, $983d3e946124bafe$var$getRequest = $lcVKE.getRequest;
var $983d3e946124bafe$var$useLayoutEffect = $acw62.useLayoutEffect, $983d3e946124bafe$var$useState = $acw62.useState, $983d3e946124bafe$var$useRef = $acw62.useRef, $983d3e946124bafe$var$useMemo = $acw62.useMemo;
var $983d3e946124bafe$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $983d3e946124bafe$var$useDeepCompare(value) {
    var latestValue = $acw62.useRef(value);
    if (!$ewhZB(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $983d3e946124bafe$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $983d3e946124bafe$var$useDeepCompare(variables);
    var operation = $983d3e946124bafe$var$useMemo(function() {
        var request = $983d3e946124bafe$var$getRequest(query);
        return $983d3e946124bafe$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $983d3e946124bafe$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $983d3e946124bafe$var$useRef(null);
    var _useState = $983d3e946124bafe$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $983d3e946124bafe$var$useRef(null);
    var snapshot = $983d3e946124bafe$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $983d3e946124bafe$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $acw62.createElement($7WvV7.Provider, {
        value: $983d3e946124bafe$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $983d3e946124bafe$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("4X6M3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $39b1ed4e037781da$var$_interopRequireDefault = $1jnue.default;

var $39b1ed4e037781da$var$_extends2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $39b1ed4e037781da$var$_objectWithoutPropertiesLoose2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("c05no")));

var $39b1ed4e037781da$var$_assertThisInitialized2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("6zC7B")));

var $39b1ed4e037781da$var$_inheritsLoose2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("6r4zt")));

var $39b1ed4e037781da$var$_defineProperty2 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $39b1ed4e037781da$var$_objectSpread3 = $39b1ed4e037781da$var$_interopRequireDefault((parcelRequire("cbdLd")));
var $39b1ed4e037781da$var$_excluded = [
    "componentRef"
], $39b1ed4e037781da$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $39b1ed4e037781da$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $lSLpg = parcelRequire("lSLpg");

var $lFfnI = parcelRequire("lFfnI");

var $3ixBO = parcelRequire("3ixBO");
var $39b1ed4e037781da$var$getComponentName = $3ixBO.getComponentName, $39b1ed4e037781da$var$getContainerName = $3ixBO.getContainerName;

var $j5wbN = parcelRequire("j5wbN");

var $twtDt = parcelRequire("twtDt");

var $6IwOm = parcelRequire("6IwOm");
var $39b1ed4e037781da$var$assertRelayContext = $6IwOm.assertRelayContext;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $39b1ed4e037781da$var$ConnectionInterface = $lcVKE.ConnectionInterface, $39b1ed4e037781da$var$Observable = $lcVKE.Observable, $39b1ed4e037781da$var$RelayFeatureFlags = $lcVKE.RelayFeatureFlags, $39b1ed4e037781da$var$createFragmentSpecResolver = $lcVKE.createFragmentSpecResolver, $39b1ed4e037781da$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $39b1ed4e037781da$var$getDataIDsFromObject = $lcVKE.getDataIDsFromObject, $39b1ed4e037781da$var$getRequest = $lcVKE.getRequest, $39b1ed4e037781da$var$getVariablesFromObject = $lcVKE.getVariablesFromObject, $39b1ed4e037781da$var$isScalarAndEqual = $lcVKE.isScalarAndEqual;
parcelRequire("8Fbfi");
var $39b1ed4e037781da$var$FORWARD = "forward";
function $39b1ed4e037781da$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $aaXwj(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== "object") return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $39b1ed4e037781da$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $aaXwj(false);
    return function(prevVars, totalCount) {
        return (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, prevVars), {}, (0, $39b1ed4e037781da$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $39b1ed4e037781da$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $aaXwj(false);
            !!foundConnectionMetadata && $aaXwj(false);
            foundConnectionMetadata = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $aaXwj(false);
    return foundConnectionMetadata || {};
}
function $39b1ed4e037781da$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === "function" ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === "function" && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $39b1ed4e037781da$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $39b1ed4e037781da$var$getComponentName(Component);
    var containerName = $39b1ed4e037781da$var$getContainerName(Component);
    var metadata = $39b1ed4e037781da$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $39b1ed4e037781da$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $aaXwj(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $39b1ed4e037781da$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $39b1ed4e037781da$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage("refetchConnection")) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $39b1ed4e037781da$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $39b1ed4e037781da$var$_defineProperty2["default"])((0, $39b1ed4e037781da$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage("loadMore")) return {
                    dispose: function dispose() {}
                };
                var observer = $39b1ed4e037781da$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $39b1ed4e037781da$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $39b1ed4e037781da$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $39b1ed4e037781da$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($39b1ed4e037781da$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $39b1ed4e037781da$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $39b1ed4e037781da$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($39b1ed4e037781da$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($39b1ed4e037781da$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $39b1ed4e037781da$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $39b1ed4e037781da$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $39b1ed4e037781da$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $lFfnI(fragments, this.props);
            var nextRootVariables = $lFfnI(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$ewhZB(prevRootVariables, nextRootVariables) || !$ewhZB(prevIDs, nextIDs)) {
                this._cleanup();
                if ($39b1ed4e037781da$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $39b1ed4e037781da$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $39b1ed4e037781da$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === "__relayContext") {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$39b1ed4e037781da$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $39b1ed4e037781da$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $39b1ed4e037781da$var$_excluded);
            var props = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $39b1ed4e037781da$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === "object") && $aaXwj(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $aaXwj(false);
            !(typeof pageInfo === "object") && $aaXwj(false);
            var hasMore = direction === $39b1ed4e037781da$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $39b1ed4e037781da$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== "boolean" || edges.length !== 0 && typeof cursor === "undefined") return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $twtDt();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $39b1ed4e037781da$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $39b1ed4e037781da$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $39b1ed4e037781da$var$_excluded2);
            var props = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $lFfnI(fragments, restProps);
            fragmentVariables = $39b1ed4e037781da$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === "object" && fetchVariables !== null) && $aaXwj(false);
            fetchVariables = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $39b1ed4e037781da$var$_objectSpread3["default"])((0, $39b1ed4e037781da$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $39b1ed4e037781da$var$getRequest(connectionConfig.query);
            var operation = $39b1ed4e037781da$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$ewhZB(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $39b1ed4e037781da$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $39b1ed4e037781da$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $39b1ed4e037781da$var$_excluded3);
            return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $acw62.createElement(Component, (0, $39b1ed4e037781da$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($acw62.Component), (0, $39b1ed4e037781da$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $39b1ed4e037781da$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $lSLpg(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $39b1ed4e037781da$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $39b1ed4e037781da$var$createContainer
};

});
parcelRegister("lFfnI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fc595bc5ba55864e$var$_interopRequireDefault = $1jnue.default;

var $fc595bc5ba55864e$var$_objectSpread2 = $fc595bc5ba55864e$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $lcVKE = parcelRequire("lcVKE");
var $fc595bc5ba55864e$var$getSelector = $lcVKE.getSelector;
function $fc595bc5ba55864e$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $fc595bc5ba55864e$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === "PluralReaderSelector" ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $fc595bc5ba55864e$var$_objectSpread2["default"])((0, $fc595bc5ba55864e$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $fc595bc5ba55864e$var$getRootVariablesForFragments;

});

parcelRegister("twtDt", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $058be6cd9ce208dc$var$_interopRequireDefault = $1jnue.default;

var $058be6cd9ce208dc$var$_defineProperty2 = $058be6cd9ce208dc$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $aaXwj = parcelRequire("aaXwj");

var $lcVKE = parcelRequire("lcVKE");
var $058be6cd9ce208dc$var$fetchQuery = $lcVKE.__internal.fetchQuery, $058be6cd9ce208dc$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $058be6cd9ce208dc$var$isRelayModernEnvironment = $lcVKE.isRelayModernEnvironment;
var $058be6cd9ce208dc$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $058be6cd9ce208dc$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $058be6cd9ce208dc$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === "store-and-network" || fetchPolicy === "store-or-network") {
            if (environment.check(operation).status === "available") {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$058be6cd9ce208dc$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $058be6cd9ce208dc$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $aaXwj(false);
        if (typeof onDataChange === "function") {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $058be6cd9ce208dc$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $aaXwj(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $aaXwj(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $058be6cd9ce208dc$var$ReactRelayQueryFetcher;

});


parcelRegister("lThBY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fefc654fde92ad78$var$_interopRequireDefault = $1jnue.default;

var $fefc654fde92ad78$var$_objectSpread2 = $fefc654fde92ad78$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $fefc654fde92ad78$var$_assertThisInitialized2 = $fefc654fde92ad78$var$_interopRequireDefault((parcelRequire("6zC7B")));

var $fefc654fde92ad78$var$_inheritsLoose2 = $fefc654fde92ad78$var$_interopRequireDefault((parcelRequire("6r4zt")));

var $fefc654fde92ad78$var$_defineProperty2 = $fefc654fde92ad78$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $j5wbN = parcelRequire("j5wbN");

var $twtDt = parcelRequire("twtDt");

var $7WvV7 = parcelRequire("7WvV7");

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $fefc654fde92ad78$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $fefc654fde92ad78$var$deepFreeze = $lcVKE.deepFreeze, $fefc654fde92ad78$var$getRequest = $lcVKE.getRequest;
var $fefc654fde92ad78$var$requestCache = {};
var $fefc654fde92ad78$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $fefc654fde92ad78$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $fefc654fde92ad78$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $fefc654fde92ad78$var$_defineProperty2["default"])((0, $fefc654fde92ad78$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $fefc654fde92ad78$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $fefc654fde92ad78$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $fefc654fde92ad78$var$getRequest(query);
            requestCacheKey = $fefc654fde92ad78$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $fefc654fde92ad78$var$requestCache[requestCacheKey] ? $fefc654fde92ad78$var$requestCache[requestCacheKey].queryFetcher : new $twtDt();
        } else queryFetcher = new $twtDt();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $fefc654fde92ad78$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $fefc654fde92ad78$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$ewhZB(prevState.prevPropsVariables, nextProps.variables)) return $fefc654fde92ad78$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $fefc654fde92ad78$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $fefc654fde92ad78$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $fefc654fde92ad78$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $fefc654fde92ad78$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $fefc654fde92ad78$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $fefc654fde92ad78$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $acw62.createElement($7WvV7.Provider, {
            value: $fefc654fde92ad78$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($acw62.Component);
function $fefc654fde92ad78$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $fefc654fde92ad78$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $fefc654fde92ad78$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === "function") retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === "function") retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $fefc654fde92ad78$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $fefc654fde92ad78$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $fefc654fde92ad78$var$getRequest(query);
        var requestCacheKey = $fefc654fde92ad78$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $fefc654fde92ad78$var$requestCache[requestCacheKey] ? $fefc654fde92ad78$var$requestCache[requestCacheKey].queryFetcher : new $twtDt(prevSelectionReferences);
    } else queryFetcher = new $twtDt(prevSelectionReferences);
    return (0, $fefc654fde92ad78$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $fefc654fde92ad78$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $fefc654fde92ad78$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $fefc654fde92ad78$var$getRequest(query);
        var operation = $fefc654fde92ad78$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === "string" && $fefc654fde92ad78$var$requestCache[requestCacheKey]) {
            var snapshot = $fefc654fde92ad78$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $fefc654fde92ad78$var$getRequestCacheKey(request.params, props.variables);
            $fefc654fde92ad78$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $fefc654fde92ad78$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $fefc654fde92ad78$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $fefc654fde92ad78$var$ReactRelayQueryRenderer;

});

parcelRegister("2oD7l", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1bec2a90a13db051$var$_interopRequireDefault = $1jnue.default;

var $1bec2a90a13db051$var$_extends2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("3p9rK")));

var $1bec2a90a13db051$var$_objectWithoutPropertiesLoose2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("c05no")));

var $1bec2a90a13db051$var$_objectSpread2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $1bec2a90a13db051$var$_assertThisInitialized2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("6zC7B")));

var $1bec2a90a13db051$var$_inheritsLoose2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("6r4zt")));

var $1bec2a90a13db051$var$_defineProperty2 = $1bec2a90a13db051$var$_interopRequireDefault((parcelRequire("g5Zhu")));
var $1bec2a90a13db051$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $lSLpg = parcelRequire("lSLpg");

var $lFfnI = parcelRequire("lFfnI");

var $3ixBO = parcelRequire("3ixBO");
var $1bec2a90a13db051$var$getContainerName = $3ixBO.getContainerName;

var $j5wbN = parcelRequire("j5wbN");

var $twtDt = parcelRequire("twtDt");

var $6IwOm = parcelRequire("6IwOm");
var $1bec2a90a13db051$var$assertRelayContext = $6IwOm.assertRelayContext;

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $1bec2a90a13db051$var$Observable = $lcVKE.Observable, $1bec2a90a13db051$var$createFragmentSpecResolver = $lcVKE.createFragmentSpecResolver, $1bec2a90a13db051$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $1bec2a90a13db051$var$getDataIDsFromObject = $lcVKE.getDataIDsFromObject, $1bec2a90a13db051$var$getRequest = $lcVKE.getRequest, $1bec2a90a13db051$var$getVariablesFromObject = $lcVKE.getVariablesFromObject, $1bec2a90a13db051$var$isScalarAndEqual = $lcVKE.isScalarAndEqual;
parcelRequire("8Fbfi");
function $1bec2a90a13db051$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $1bec2a90a13db051$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $1bec2a90a13db051$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $1bec2a90a13db051$var$_defineProperty2["default"])((0, $1bec2a90a13db051$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $1bec2a90a13db051$var$_defineProperty2["default"])((0, $1bec2a90a13db051$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $1bec2a90a13db051$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $lFfnI(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === "function" ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $1bec2a90a13db051$var$_objectSpread2["default"])((0, $1bec2a90a13db051$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $1bec2a90a13db051$var$_objectSpread2["default"])((0, $1bec2a90a13db051$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === "function" ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $1bec2a90a13db051$var$getRequest(taggedNode);
                var operation = $1bec2a90a13db051$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $1bec2a90a13db051$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $1bec2a90a13db051$var$_objectSpread2["default"])((0, $1bec2a90a13db051$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $1bec2a90a13db051$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $1bec2a90a13db051$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $1bec2a90a13db051$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $1bec2a90a13db051$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $1bec2a90a13db051$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $1bec2a90a13db051$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $lFfnI(fragments, prevProps);
            var nextRootVariables = $lFfnI(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$ewhZB(prevRootVariables, nextRootVariables) || !$ewhZB(prevIDs, nextIDs)) {
                resolver = $1bec2a90a13db051$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $1bec2a90a13db051$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === "__relayContext") {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$1bec2a90a13db051$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $1bec2a90a13db051$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $twtDt();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $1bec2a90a13db051$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $1bec2a90a13db051$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $acw62.createElement(Component, (0, $1bec2a90a13db051$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($acw62.Component), (0, $1bec2a90a13db051$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $1bec2a90a13db051$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $1bec2a90a13db051$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $lSLpg(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $1bec2a90a13db051$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $1bec2a90a13db051$var$createContainer
};

});

parcelRegister("hAaqX", function(module, exports) {
"use strict";

var $9pgH3 = parcelRequire("9pgH3");

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $cccde464a8681a62$var$useContext = $acw62.useContext, $cccde464a8681a62$var$useEffect = $acw62.useEffect;
parcelRequire("8Fbfi");
function $cccde464a8681a62$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $cccde464a8681a62$var$useContext($9pgH3);
    var environment = $4fG2B();
    $cccde464a8681a62$var$useEffect(function() {
        environment.__log({
            name: "entrypoint.root.consume",
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $cccde464a8681a62$var$EntryPointContainer;

});
parcelRegister("9pgH3", function(module, exports) {
"use strict";

var $acw62 = parcelRequire("acw62");
var $6d9365d86eab27b6$var$ProfilerContext = $acw62.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $6d9365d86eab27b6$var$ProfilerContext;

});

parcelRegister("4fG2B", function(module, exports) {
"use strict";

var $j5wbN = parcelRequire("j5wbN");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $31892c9d9c950969$var$useContext = $acw62.useContext;
function $31892c9d9c950969$var$useRelayEnvironment() {
    var context = $31892c9d9c950969$var$useContext($j5wbN);
    !(context != null) && $aaXwj(false);
    return context.environment;
}
module.exports = $31892c9d9c950969$var$useRelayEnvironment;

});


parcelRegister("5A24j", function(module, exports) {
"use strict";

var $1c3ii = parcelRequire("1c3ii");
var $4101eb50f14405be$var$loadQuery = $1c3ii.loadQuery;
function $4101eb50f14405be$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $4101eb50f14405be$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: "loadEntryPoint"
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $4101eb50f14405be$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $4101eb50f14405be$var$loadEntryPoint;

});
parcelRegister("1c3ii", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0de97792fcab6c65$var$_interopRequireDefault = $1jnue.default;

var $0de97792fcab6c65$var$_objectSpread2 = $0de97792fcab6c65$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $aaXwj = parcelRequire("aaXwj");

var $lcVKE = parcelRequire("lcVKE");
var $0de97792fcab6c65$var$fetchQueryDeduped = $lcVKE.__internal.fetchQueryDeduped, $0de97792fcab6c65$var$Observable = $lcVKE.Observable, $0de97792fcab6c65$var$PreloadableQueryRegistry = $lcVKE.PreloadableQueryRegistry, $0de97792fcab6c65$var$ReplaySubject = $lcVKE.ReplaySubject, $0de97792fcab6c65$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $0de97792fcab6c65$var$getRequest = $lcVKE.getRequest, $0de97792fcab6c65$var$getRequestIdentifier = $lcVKE.getRequestIdentifier;
var $0de97792fcab6c65$var$fetchKey = 100001;
function $0de97792fcab6c65$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    $0de97792fcab6c65$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : "store-or-network";
    var networkCacheConfig = (0, $0de97792fcab6c65$var$_objectSpread2["default"])((0, $0de97792fcab6c65$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $0de97792fcab6c65$var$ReplaySubject();
    var returnedObservable = $0de97792fcab6c65$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params) {
        didMakeNetworkRequest = true;
        var subject = new $0de97792fcab6c65$var$ReplaySubject();
        var identifier = "raw-network-request-" + $0de97792fcab6c65$var$getRequestIdentifier(params, variables);
        var observable = $0de97792fcab6c65$var$fetchQueryDeduped(environment, identifier, function() {
            var network = environment.getNetwork();
            return network.execute(params, variables, networkCacheConfig);
        });
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $0de97792fcab6c65$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $0de97792fcab6c65$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $0de97792fcab6c65$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === "store-only") return;
        var shouldFetch = fetchPolicy !== "store-or-network" || environment.check(operation).status !== "available";
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params);
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === "PreloadableConcreteRequest") {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $aaXwj(false);
        var _module = $0de97792fcab6c65$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === "store-only" ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $0de97792fcab6c65$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $0de97792fcab6c65$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $0de97792fcab6c65$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: "PreloadedQuery",
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $0de97792fcab6c65$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $0de97792fcab6c65$var$loadQuery
};

});


parcelRegister("eLBQT", function(module, exports) {
"use strict";

var $j5wbN = parcelRequire("j5wbN");

var $acw62 = parcelRequire("acw62");
var $ac02d11be19a6f4b$var$useMemo = $acw62.useMemo;
function $ac02d11be19a6f4b$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $ac02d11be19a6f4b$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $acw62.createElement($j5wbN.Provider, {
        value: context
    }, children);
}
module.exports = $ac02d11be19a6f4b$var$RelayEnvironmentProvider;

});

parcelRegister("jwpXG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e36524ec094ac92e$var$_interopRequireDefault = $1jnue.default;

var $e36524ec094ac92e$var$_objectSpread2 = $e36524ec094ac92e$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $6RH4A = parcelRequire("6RH4A");
function $e36524ec094ac92e$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $6RH4A(query, variables, (0, $e36524ec094ac92e$var$_objectSpread2["default"])((0, $e36524ec094ac92e$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: "store-only"
    }));
}
module.exports = $e36524ec094ac92e$var$useClientQuery;

});
parcelRegister("6RH4A", function(module, exports) {
"use strict";

var $03QWz = parcelRequire("03QWz");

var $lbcmO = parcelRequire("lbcmO");

var $4fG2B = parcelRequire("4fG2B");

var $lcVKE = parcelRequire("lcVKE");
var $4ff91ab98f673877$var$fetchQuery = $lcVKE.__internal.fetchQuery;
function $4ff91ab98f673877$var$useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = $4fG2B();
    var query = $lbcmO(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $03QWz({
        componentDisplayName: "useLazyLoadQuery()",
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $4ff91ab98f673877$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $4ff91ab98f673877$var$useLazyLoadQuery;

});
parcelRegister("03QWz", function(module, exports) {
"use strict";

var $9pgH3 = parcelRequire("9pgH3");

var $i2nMq = parcelRequire("i2nMq");
var $00b95970b654f37e$var$getQueryCacheIdentifier = $i2nMq.getQueryCacheIdentifier, $00b95970b654f37e$var$getQueryResourceForEnvironment = $i2nMq.getQueryResourceForEnvironment;

var $fzOCt = parcelRequire("fzOCt");

var $3DuL7 = parcelRequire("3DuL7");

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");
var $00b95970b654f37e$var$useContext = $acw62.useContext, $00b95970b654f37e$var$useEffect = $acw62.useEffect, $00b95970b654f37e$var$useState = $acw62.useState, $00b95970b654f37e$var$useRef = $acw62.useRef;
function $00b95970b654f37e$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $4fG2B();
    var profilerContext = $00b95970b654f37e$var$useContext($9pgH3);
    var QueryResource = $00b95970b654f37e$var$getQueryResourceForEnvironment(environment);
    var _useState = $00b95970b654f37e$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $fzOCt(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : "");
    var cacheIdentifier = $00b95970b654f37e$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $00b95970b654f37e$var$useRef(false);
    $00b95970b654f37e$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $00b95970b654f37e$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $00b95970b654f37e$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $3DuL7(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $00b95970b654f37e$var$useLazyLoadQueryNode;

});
parcelRegister("i2nMq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d21adc1d9490b1db$var$_interopRequireDefault = $1jnue.default;

var $d21adc1d9490b1db$var$_objectSpread2 = $d21adc1d9490b1db$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $d21adc1d9490b1db$var$_defineProperty2 = $d21adc1d9490b1db$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $i3k6C = parcelRequire("i3k6C");

var $fTQd2 = parcelRequire("fTQd2");

var $aaXwj = parcelRequire("aaXwj");

var $lcVKE = parcelRequire("lcVKE");
var $d21adc1d9490b1db$var$isPromise = $lcVKE.isPromise;
parcelRequire("8Fbfi");
var $d21adc1d9490b1db$var$CACHE_CAPACITY = 1000;
var $d21adc1d9490b1db$var$DEFAULT_FETCH_POLICY = "store-or-network";
var $d21adc1d9490b1db$var$DEFAULT_LIVE_FETCH_POLICY = "store-and-network";
var $d21adc1d9490b1db$var$WEAKMAP_SUPPORTED = typeof WeakMap === "function";
function $d21adc1d9490b1db$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $d21adc1d9490b1db$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $d21adc1d9490b1db$var$operationIsLiveQuery(operation) ? $d21adc1d9490b1db$var$DEFAULT_LIVE_FETCH_POLICY : $d21adc1d9490b1db$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $d21adc1d9490b1db$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $d21adc1d9490b1db$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $d21adc1d9490b1db$var$nextID = 200000;
function $d21adc1d9490b1db$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $d21adc1d9490b1db$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $fTQd2(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $d21adc1d9490b1db$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $d21adc1d9490b1db$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $d21adc1d9490b1db$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $i3k6C.create($d21adc1d9490b1db$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $d21adc1d9490b1db$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $d21adc1d9490b1db$var$operationIsLiveQuery(operation) ? $d21adc1d9490b1db$var$DEFAULT_LIVE_FETCH_POLICY : $d21adc1d9490b1db$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $d21adc1d9490b1db$var$_objectSpread2["default"])((0, $d21adc1d9490b1db$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($d21adc1d9490b1db$var$isPromise(cachedValue)) {
            environment.__log({
                name: "suspense.query",
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: "queryresource.retain",
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $d21adc1d9490b1db$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $d21adc1d9490b1db$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === "available";
        var canPartialRender = hasFullQuery || renderPolicy === "partial" && queryStatus !== "stale";
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case "store-only":
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case "store-or-network":
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case "store-and-network":
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case "network-only":
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $d21adc1d9490b1db$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $d21adc1d9490b1db$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $d21adc1d9490b1db$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $d21adc1d9490b1db$var$_objectSpread2["default"])((0, $d21adc1d9490b1db$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($d21adc1d9490b1db$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = "Relay(" + operation.fragment.node.name + ")";
                _cacheEntry2 = $d21adc1d9490b1db$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $aaXwj(false);
        environment.__log({
            name: "queryresource.fetch",
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $d21adc1d9490b1db$var$createQueryResource(environment) {
    return new $d21adc1d9490b1db$var$QueryResourceImpl(environment);
}
var $d21adc1d9490b1db$var$dataResources = $d21adc1d9490b1db$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $d21adc1d9490b1db$var$getQueryResourceForEnvironment(environment) {
    var cached = $d21adc1d9490b1db$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $d21adc1d9490b1db$var$createQueryResource(environment);
    $d21adc1d9490b1db$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $d21adc1d9490b1db$var$createQueryResource,
    getQueryResourceForEnvironment: $d21adc1d9490b1db$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $d21adc1d9490b1db$var$getQueryCacheIdentifier
};

});
parcelRegister("i3k6C", function(module, exports) {
"use strict";

var $aaXwj = parcelRequire("aaXwj");
var $d2481a674cf40986$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $aaXwj(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $d2481a674cf40986$var$create(capacity) {
    return new $d2481a674cf40986$var$LRUCache(capacity);
}
module.exports = {
    create: $d2481a674cf40986$var$create
};

});

parcelRegister("fTQd2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b9347dbf28b75b10$var$_interopRequireDefault = $1jnue.default;

var $b9347dbf28b75b10$var$_defineProperty2 = $b9347dbf28b75b10$var$_interopRequireDefault((parcelRequire("g5Zhu")));
parcelRequire("8Fbfi");
var $b9347dbf28b75b10$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $b9347dbf28b75b10$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $b9347dbf28b75b10$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $b9347dbf28b75b10$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $b9347dbf28b75b10$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $b9347dbf28b75b10$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $b9347dbf28b75b10$var$SuspenseResource;

});


parcelRegister("fzOCt", function(module, exports) {
"use strict";

var $fciVy = parcelRequire("fciVy");

var $acw62 = parcelRequire("acw62");
var $b57163e50945b80f$var$useCallback = $acw62.useCallback, $b57163e50945b80f$var$useEffect = $acw62.useEffect;
function $b57163e50945b80f$var$useFetchTrackingRef() {
    var subscriptionRef = $fciVy(null);
    var isFetchingRef = $fciVy(false);
    var disposeFetch = $b57163e50945b80f$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $b57163e50945b80f$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $b57163e50945b80f$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $b57163e50945b80f$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $b57163e50945b80f$var$useFetchTrackingRef;

});
parcelRegister("fciVy", function(module, exports) {
"use strict";

var $acw62 = parcelRequire("acw62");
var $b106a88b9e17ad00$var$useMemo = $acw62.useMemo;
function $b106a88b9e17ad00$var$useUnsafeRef_DEPRECATED(init) {
    return $b106a88b9e17ad00$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $b106a88b9e17ad00$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("3DuL7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2a5cdfb9fc57713a$var$_interopRequireDefault = $1jnue.default;

var $2a5cdfb9fc57713a$var$_useFragmentInternal_CURRENT = $2a5cdfb9fc57713a$var$_interopRequireDefault((parcelRequire("4k2Yk")));

var $2a5cdfb9fc57713a$var$_useFragmentInternal_EXPERIMENTAL = $2a5cdfb9fc57713a$var$_interopRequireDefault((parcelRequire("8gLOS")));

var $lcVKE = parcelRequire("lcVKE");
function $2a5cdfb9fc57713a$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if ($lcVKE.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, $2a5cdfb9fc57713a$var$_useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, $2a5cdfb9fc57713a$var$_useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = $2a5cdfb9fc57713a$var$useFragmentInternal;

});
parcelRegister("4k2Yk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $325b55da769d0bcb$var$_interopRequireDefault = $1jnue.default;

var $325b55da769d0bcb$var$_objectSpread2 = $325b55da769d0bcb$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $325b55da769d0bcb$var$_createForOfIteratorHelper2 = $325b55da769d0bcb$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $325b55da769d0bcb$var$_toConsumableArray2 = $325b55da769d0bcb$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $i2nMq = parcelRequire("i2nMq");
var $325b55da769d0bcb$var$getQueryResourceForEnvironment = $i2nMq.getQueryResourceForEnvironment;

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $325b55da769d0bcb$var$useDebugValue = $acw62.useDebugValue, $325b55da769d0bcb$var$useEffect = $acw62.useEffect, $325b55da769d0bcb$var$useMemo = $acw62.useMemo, $325b55da769d0bcb$var$useRef = $acw62.useRef, $325b55da769d0bcb$var$useState = $acw62.useState;

var $lcVKE = parcelRequire("lcVKE");
var $325b55da769d0bcb$var$_require3$__internal = $lcVKE.__internal, $325b55da769d0bcb$var$fetchQueryInternal = $325b55da769d0bcb$var$_require3$__internal.fetchQuery, $325b55da769d0bcb$var$getPromiseForActiveRequest = $325b55da769d0bcb$var$_require3$__internal.getPromiseForActiveRequest, $325b55da769d0bcb$var$RelayFeatureFlags = $lcVKE.RelayFeatureFlags, $325b55da769d0bcb$var$areEqualSelectors = $lcVKE.areEqualSelectors, $325b55da769d0bcb$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $325b55da769d0bcb$var$getPendingOperationsForFragment = $lcVKE.getPendingOperationsForFragment, $325b55da769d0bcb$var$getSelector = $lcVKE.getSelector, $325b55da769d0bcb$var$getVariablesFromFragment = $lcVKE.getVariablesFromFragment, $325b55da769d0bcb$var$handlePotentialSnapshotErrors = $lcVKE.handlePotentialSnapshotErrors, $325b55da769d0bcb$var$recycleNodesInto = $lcVKE.recycleNodesInto;
parcelRequire("8Fbfi");
function $325b55da769d0bcb$var$isMissingData(state) {
    if (state.kind === "bailout") return false;
    else if (state.kind === "singular") return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $325b55da769d0bcb$var$getMissingClientEdges(state) {
    if (state.kind === "bailout") return null;
    else if (state.kind === "singular") {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $325b55da769d0bcb$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $325b55da769d0bcb$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $325b55da769d0bcb$var$getSuspendingLiveResolver(state) {
    if (state.kind === "bailout") return null;
    else if (state.kind === "singular") {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $325b55da769d0bcb$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $325b55da769d0bcb$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $325b55da769d0bcb$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === "singular") $325b55da769d0bcb$var$handlePotentialSnapshotErrors(environment, state.snapshot.errorResponseFields);
    else if (state.kind === "plural") {
        var _iterator5 = (0, $325b55da769d0bcb$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $325b55da769d0bcb$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $325b55da769d0bcb$var$handleMissedUpdates(environment, state) {
    if (state.kind === "bailout") return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === "singular") {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $325b55da769d0bcb$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: "singular",
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $325b55da769d0bcb$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $aaXwj(false);
        return [
            didMissUpdates,
            {
                kind: "plural",
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $325b55da769d0bcb$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $325b55da769d0bcb$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $325b55da769d0bcb$var$_objectSpread2["default"])((0, $325b55da769d0bcb$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $325b55da769d0bcb$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $325b55da769d0bcb$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $325b55da769d0bcb$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $325b55da769d0bcb$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $325b55da769d0bcb$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === "bailout") return function() {};
    else if (state.kind === "singular") {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== "singular" || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $325b55da769d0bcb$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: "useFragment.subscription.missedUpdates",
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: "singular",
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== "plural" || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $325b55da769d0bcb$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: "useFragment.subscription.missedUpdates",
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $325b55da769d0bcb$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: "plural",
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $325b55da769d0bcb$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $325b55da769d0bcb$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: "bailout"
    };
    else if (fragmentSelector.kind === "PluralReaderSelector") return {
        kind: "plural",
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: "singular",
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $325b55da769d0bcb$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $325b55da769d0bcb$var$useMemo(function() {
        return $325b55da769d0bcb$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $aaXwj(false);
    else !!Array.isArray(fragmentRef) && $aaXwj(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $aaXwj(false);
    var environment = $4fG2B();
    var _useState = $325b55da769d0bcb$var$useState(function() {
        return $325b55da769d0bcb$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $325b55da769d0bcb$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $325b55da769d0bcb$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $325b55da769d0bcb$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$325b55da769d0bcb$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $325b55da769d0bcb$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $325b55da769d0bcb$var$useRef(false);
    $325b55da769d0bcb$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = $325b55da769d0bcb$var$useMemo(function() {
            var missingClientEdges = $325b55da769d0bcb$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $325b55da769d0bcb$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $325b55da769d0bcb$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $325b55da769d0bcb$var$useEffect(function() {
            var QueryResource = $325b55da769d0bcb$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $325b55da769d0bcb$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($325b55da769d0bcb$var$isMissingData(state)) {
        var suspendingLiveResolvers = $325b55da769d0bcb$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($325b55da769d0bcb$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$325b55da769d0bcb$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $aaXwj(false);
            var fragmentOwner = fragmentSelector.kind === "PluralReaderSelector" ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $325b55da769d0bcb$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $325b55da769d0bcb$var$handlePotentialSnapshotErrorsForState(environment, state);
    var hasPendingStateChanges = $325b55da769d0bcb$var$useRef(false);
    $325b55da769d0bcb$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $325b55da769d0bcb$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $325b55da769d0bcb$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $325b55da769d0bcb$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $325b55da769d0bcb$var$useMemo(function() {
            if (state.kind === "bailout") return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === "plural") && $aaXwj(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === "bailout") data = null;
    else {
        !(state.kind === "singular") && $aaXwj(false);
        data = state.snapshot.data;
    }
    if ($325b55da769d0bcb$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $325b55da769d0bcb$var$useFragmentInternal;

});

parcelRegister("8gLOS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6054e95123c3db7f$var$_interopRequireDefault = $1jnue.default;

var $6054e95123c3db7f$var$_objectSpread2 = $6054e95123c3db7f$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $6054e95123c3db7f$var$_createForOfIteratorHelper2 = $6054e95123c3db7f$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $6054e95123c3db7f$var$_toConsumableArray2 = $6054e95123c3db7f$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $i2nMq = parcelRequire("i2nMq");
var $6054e95123c3db7f$var$getQueryResourceForEnvironment = $i2nMq.getQueryResourceForEnvironment;

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $6054e95123c3db7f$var$useDebugValue = $acw62.useDebugValue, $6054e95123c3db7f$var$useEffect = $acw62.useEffect, $6054e95123c3db7f$var$useMemo = $acw62.useMemo, $6054e95123c3db7f$var$useRef = $acw62.useRef, $6054e95123c3db7f$var$useState = $acw62.useState;

var $lcVKE = parcelRequire("lcVKE");
var $6054e95123c3db7f$var$_require3$__internal = $lcVKE.__internal, $6054e95123c3db7f$var$fetchQueryInternal = $6054e95123c3db7f$var$_require3$__internal.fetchQuery, $6054e95123c3db7f$var$getPromiseForActiveRequest = $6054e95123c3db7f$var$_require3$__internal.getPromiseForActiveRequest, $6054e95123c3db7f$var$RelayFeatureFlags = $lcVKE.RelayFeatureFlags, $6054e95123c3db7f$var$areEqualSelectors = $lcVKE.areEqualSelectors, $6054e95123c3db7f$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $6054e95123c3db7f$var$getPendingOperationsForFragment = $lcVKE.getPendingOperationsForFragment, $6054e95123c3db7f$var$getSelector = $lcVKE.getSelector, $6054e95123c3db7f$var$getVariablesFromFragment = $lcVKE.getVariablesFromFragment, $6054e95123c3db7f$var$handlePotentialSnapshotErrors = $lcVKE.handlePotentialSnapshotErrors, $6054e95123c3db7f$var$recycleNodesInto = $lcVKE.recycleNodesInto;
parcelRequire("8Fbfi");
function $6054e95123c3db7f$var$isMissingData(state) {
    if (state.kind === "bailout") return false;
    else if (state.kind === "singular") return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $6054e95123c3db7f$var$getMissingClientEdges(state) {
    if (state.kind === "bailout") return null;
    else if (state.kind === "singular") {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $6054e95123c3db7f$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $6054e95123c3db7f$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $6054e95123c3db7f$var$getSuspendingLiveResolver(state) {
    if (state.kind === "bailout") return null;
    else if (state.kind === "singular") {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $6054e95123c3db7f$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $6054e95123c3db7f$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $6054e95123c3db7f$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === "singular") $6054e95123c3db7f$var$handlePotentialSnapshotErrors(environment, state.snapshot.errorResponseFields);
    else if (state.kind === "plural") {
        var _iterator5 = (0, $6054e95123c3db7f$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $6054e95123c3db7f$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $6054e95123c3db7f$var$handleMissedUpdates(environment, state) {
    if (state.kind === "bailout") return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === "singular") {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $6054e95123c3db7f$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: "singular",
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $6054e95123c3db7f$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $aaXwj(false);
        return [
            didMissUpdates,
            {
                kind: "plural",
                snapshots: currentSnapshots,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    }
}
function $6054e95123c3db7f$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $6054e95123c3db7f$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $6054e95123c3db7f$var$_objectSpread2["default"])((0, $6054e95123c3db7f$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $6054e95123c3db7f$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $6054e95123c3db7f$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $6054e95123c3db7f$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $6054e95123c3db7f$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $6054e95123c3db7f$var$subscribeToSnapshot(environment, state, setState) {
    if (state.kind === "bailout") return function() {};
    else if (state.kind === "singular") {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== "singular" || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = $6054e95123c3db7f$var$handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            name: "useFragment.subscription.missedUpdates",
                            hasDataChanges: dataChanged
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    kind: "singular",
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch(),
                    selector: state.selector,
                    environment: state.environment
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== "plural" || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = $6054e95123c3db7f$var$handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                name: "useFragment.subscription.missedUpdates",
                                hasDataChanges: dataChanged
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, $6054e95123c3db7f$var$_toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            kind: "plural",
                            snapshots: updated,
                            epoch: environment.getStore().getEpoch(),
                            selector: state.selector,
                            environment: state.environment
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, $6054e95123c3db7f$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $6054e95123c3db7f$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: "bailout",
        environment: environment
    };
    else if (fragmentSelector.kind === "PluralReaderSelector") return {
        kind: "plural",
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
    else return {
        kind: "singular",
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
}
function $6054e95123c3db7f$var$useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $6054e95123c3db7f$var$useMemo(function() {
        return $6054e95123c3db7f$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $aaXwj(false);
    else !!Array.isArray(fragmentRef) && $aaXwj(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $aaXwj(false);
    var environment = $4fG2B();
    var _useState = $6054e95123c3db7f$var$useState(function() {
        return $6054e95123c3db7f$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!$6054e95123c3db7f$var$areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = $6054e95123c3db7f$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = $6054e95123c3db7f$var$useRef(false);
    $6054e95123c3db7f$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = $6054e95123c3db7f$var$useMemo(function() {
            var missingClientEdges = $6054e95123c3db7f$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $6054e95123c3db7f$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $6054e95123c3db7f$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $6054e95123c3db7f$var$useEffect(function() {
            var QueryResource = $6054e95123c3db7f$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $6054e95123c3db7f$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($6054e95123c3db7f$var$isMissingData(state)) {
        var suspendingLiveResolvers = $6054e95123c3db7f$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($6054e95123c3db7f$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$6054e95123c3db7f$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $aaXwj(false);
            var fragmentOwner = fragmentSelector.kind === "PluralReaderSelector" ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $6054e95123c3db7f$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $6054e95123c3db7f$var$handlePotentialSnapshotErrorsForState(environment, state);
    var storeSubscriptionRef = $6054e95123c3db7f$var$useRef(null);
    $6054e95123c3db7f$var$useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription != null) {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else storeSubscription.dispose();
        }
        if (state.kind === "bailout") return;
        var stateForSubscription = state;
        var updates = $6054e95123c3db7f$var$handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = $6054e95123c3db7f$var$subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            selector: state.selector,
            environment: state.environment
        };
    }, [
        state
    ]);
    $6054e95123c3db7f$var$useEffect(function() {
        if (storeSubscriptionRef.current == null && state.kind !== "bailout") {
            var dispose = $6054e95123c3db7f$var$subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                selector: state.selector,
                environment: state.environment
            };
        }
        return function() {
            var _storeSubscriptionRef;
            (_storeSubscriptionRef = storeSubscriptionRef.current) === null || _storeSubscriptionRef === void 0 || _storeSubscriptionRef.dispose();
            storeSubscriptionRef.current = null;
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $6054e95123c3db7f$var$useMemo(function() {
            if (state.kind === "bailout") return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === "plural") && $aaXwj(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === "bailout") data = null;
    else {
        !(state.kind === "singular") && $aaXwj(false);
        data = state.snapshot.data;
    }
    if ($6054e95123c3db7f$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $6054e95123c3db7f$var$useFragmentInternal_EXPERIMENTAL;

});



parcelRegister("lbcmO", function(module, exports) {
"use strict";

var $lt6Hp = parcelRequire("lt6Hp");

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $f6b437df3eecd49f$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $f6b437df3eecd49f$var$getRequest = $lcVKE.getRequest;
var $f6b437df3eecd49f$var$useMemo = $acw62.useMemo;
function $f6b437df3eecd49f$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $lt6Hp(variables);
    var memoCacheConfig = $lt6Hp(cacheConfig || {});
    return $f6b437df3eecd49f$var$useMemo(function() {
        return $f6b437df3eecd49f$var$createOperationDescriptor($f6b437df3eecd49f$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $f6b437df3eecd49f$var$useMemoOperationDescriptor;

});
parcelRegister("lt6Hp", function(module, exports) {
"use strict";

var $ewhZB = parcelRequire("ewhZB");

var $acw62 = parcelRequire("acw62");
var $fa1180b51395b55c$var$useState = $acw62.useState;
function $fa1180b51395b55c$var$useMemoVariables(variables) {
    var _useState = $fa1180b51395b55c$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($ewhZB(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $fa1180b51395b55c$var$useMemoVariables;

});




parcelRegister("9KXWY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $71a6e9ce88b1800c$var$_interopRequireDefault = $1jnue.default;

var $71a6e9ce88b1800c$var$_createForOfIteratorHelper2 = $71a6e9ce88b1800c$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $5A24j = parcelRequire("5A24j");

var $epnQn = parcelRequire("epnQn");

var $acw62 = parcelRequire("acw62");
var $71a6e9ce88b1800c$var$useCallback = $acw62.useCallback, $71a6e9ce88b1800c$var$useEffect = $acw62.useEffect, $71a6e9ce88b1800c$var$useRef = $acw62.useRef, $71a6e9ce88b1800c$var$useState = $acw62.useState;
var $71a6e9ce88b1800c$var$initialNullEntryPointReferenceState = {
    kind: "NullEntryPointReference"
};
function $71a6e9ce88b1800c$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $71a6e9ce88b1800c$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $epnQn();
    var undisposedEntryPointReferencesRef = $71a6e9ce88b1800c$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $71a6e9ce88b1800c$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $71a6e9ce88b1800c$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $71a6e9ce88b1800c$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: "NullEntryPointReference"
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $71a6e9ce88b1800c$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $5A24j(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $71a6e9ce88b1800c$var$useRef(false);
    $71a6e9ce88b1800c$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $71a6e9ce88b1800c$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== "NullEntryPointReference" && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $71a6e9ce88b1800c$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== "NullEntryPointReference") undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $71a6e9ce88b1800c$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $71a6e9ce88b1800c$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== "NullEntryPointReference") unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === "NullEntryPointReference" ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $71a6e9ce88b1800c$var$useLoadEntryPoint;

});
parcelRegister("epnQn", function(module, exports) {
"use strict";

var $acw62 = parcelRequire("acw62");
var $a7d5e55a6ec2b789$var$useEffect = $acw62.useEffect, $a7d5e55a6ec2b789$var$useRef = $acw62.useRef;
function $a7d5e55a6ec2b789$var$useIsMountedRef() {
    var isMountedRef = $a7d5e55a6ec2b789$var$useRef(true);
    $a7d5e55a6ec2b789$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $a7d5e55a6ec2b789$var$useIsMountedRef;

});


parcelRegister("3QqxT", function(module, exports) {
"use strict";

var $3DuL7 = parcelRequire("3DuL7");

var $eYEgc = parcelRequire("eYEgc");

var $acw62 = parcelRequire("acw62");
var $2ccad1d442117d14$var$useDebugValue = $acw62.useDebugValue;

var $lcVKE = parcelRequire("lcVKE");
var $2ccad1d442117d14$var$getFragment = $lcVKE.getFragment;
function $2ccad1d442117d14$var$useFragment(fragment, key) {
    var fragmentNode = $2ccad1d442117d14$var$getFragment(fragment);
    $eYEgc(fragmentNode, "first argument of useFragment()");
    var data = $3DuL7(fragmentNode, key, "useFragment()");
    return data;
}
module.exports = $2ccad1d442117d14$var$useFragment;

});
parcelRegister("eYEgc", function(module, exports) {
"use strict";
parcelRequire("fciVy");
parcelRequire("8Fbfi");
function $02d05a6bd98090d2$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $02d05a6bd98090d2$var$useStaticFragmentNodeWarning;

});


parcelRegister("2rQPf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1c87146c0f3b6dc9$var$_interopRequireDefault = $1jnue.default;

var $1c87146c0f3b6dc9$var$_objectSpread2 = $1c87146c0f3b6dc9$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $epnQn = parcelRequire("epnQn");

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $1c87146c0f3b6dc9$var$defaultCommitMutation = $lcVKE.commitMutation;
var $1c87146c0f3b6dc9$var$useState = $acw62.useState, $1c87146c0f3b6dc9$var$useEffect = $acw62.useEffect, $1c87146c0f3b6dc9$var$useRef = $acw62.useRef, $1c87146c0f3b6dc9$var$useCallback = $acw62.useCallback;
function $1c87146c0f3b6dc9$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1c87146c0f3b6dc9$var$defaultCommitMutation;
    var environment = $4fG2B();
    var isMountedRef = $epnQn();
    var environmentRef = $1c87146c0f3b6dc9$var$useRef(environment);
    var mutationRef = $1c87146c0f3b6dc9$var$useRef(mutation);
    var inFlightMutationsRef = $1c87146c0f3b6dc9$var$useRef(new Set());
    var _useState = $1c87146c0f3b6dc9$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $1c87146c0f3b6dc9$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $1c87146c0f3b6dc9$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $1c87146c0f3b6dc9$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $1c87146c0f3b6dc9$var$_objectSpread2["default"])((0, $1c87146c0f3b6dc9$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $1c87146c0f3b6dc9$var$useMutation;

});

parcelRegister("dAN4o", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9e54b364225a7706$var$_interopRequireDefault = $1jnue.default;

var $9e54b364225a7706$var$_objectSpread2 = $9e54b364225a7706$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $7OZAN = parcelRequire("7OZAN");

var $3JX1g = parcelRequire("3JX1g");

var $4fG2B = parcelRequire("4fG2B");

var $eYEgc = parcelRequire("eYEgc");

var $acw62 = parcelRequire("acw62");
var $9e54b364225a7706$var$useCallback = $acw62.useCallback, $9e54b364225a7706$var$useDebugValue = $acw62.useDebugValue, $9e54b364225a7706$var$useState = $acw62.useState;

var $lcVKE = parcelRequire("lcVKE");
var $9e54b364225a7706$var$getFragment = $lcVKE.getFragment, $9e54b364225a7706$var$getFragmentIdentifier = $lcVKE.getFragmentIdentifier, $9e54b364225a7706$var$getPaginationMetadata = $lcVKE.getPaginationMetadata;
function $9e54b364225a7706$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $9e54b364225a7706$var$getFragment(fragmentInput);
    $eYEgc(fragmentNode, "first argument of usePaginationFragment()");
    var componentDisplayName = "usePaginationFragment()";
    var _getPaginationMetadat = $9e54b364225a7706$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $3JX1g(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $9e54b364225a7706$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $9e54b364225a7706$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: "backward",
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $9e54b364225a7706$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: "forward",
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $9e54b364225a7706$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $9e54b364225a7706$var$_objectSpread2["default"])((0, $9e54b364225a7706$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $9e54b364225a7706$var$useLoadMore(args) {
    var environment = $4fG2B();
    var _useState = $9e54b364225a7706$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        }
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $7OZAN((0, $9e54b364225a7706$var$_objectSpread2["default"])((0, $9e54b364225a7706$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $9e54b364225a7706$var$usePaginationFragment;

});
parcelRegister("7OZAN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5b1cfaea4824f818$var$_interopRequireDefault = $1jnue.default;

var $5b1cfaea4824f818$var$_objectSpread2 = $5b1cfaea4824f818$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $aeS5o = parcelRequire("aeS5o");

var $fzOCt = parcelRequire("fzOCt");

var $epnQn = parcelRequire("epnQn");

var $jCnVf = parcelRequire("jCnVf");

var $6NOcZ = parcelRequire("6NOcZ");

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $5b1cfaea4824f818$var$useCallback = $acw62.useCallback, $5b1cfaea4824f818$var$useEffect = $acw62.useEffect, $5b1cfaea4824f818$var$useState = $acw62.useState;

var $lcVKE = parcelRequire("lcVKE");
var $5b1cfaea4824f818$var$fetchQuery = $lcVKE.__internal.fetchQuery, $5b1cfaea4824f818$var$RelayFeatureFlags = $lcVKE.RelayFeatureFlags, $5b1cfaea4824f818$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $5b1cfaea4824f818$var$getPaginationVariables = $lcVKE.getPaginationVariables, $5b1cfaea4824f818$var$getRefetchMetadata = $lcVKE.getRefetchMetadata, $5b1cfaea4824f818$var$getSelector = $lcVKE.getSelector;
parcelRequire("8Fbfi");
function $5b1cfaea4824f818$var$useLoadMoreFunction(args) {
    if ($5b1cfaea4824f818$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $6NOcZ(args);
    return $5b1cfaea4824f818$var$useLoadMoreFunction_CURRENT(args);
}
function $5b1cfaea4824f818$var$useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $4fG2B();
    var _useFetchTrackingRef = $fzOCt(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $5b1cfaea4824f818$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === "object" ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $epnQn();
    var _useState = $5b1cfaea4824f818$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $5b1cfaea4824f818$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $jCnVf(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $aeS5o(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $5b1cfaea4824f818$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var loadMore = $5b1cfaea4824f818$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $5b1cfaea4824f818$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== "PluralReaderSelector") && $aaXwj(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $5b1cfaea4824f818$var$_objectSpread2["default"])((0, $5b1cfaea4824f818$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $5b1cfaea4824f818$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $5b1cfaea4824f818$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $5b1cfaea4824f818$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $5b1cfaea4824f818$var$fetchQuery(environment, paginationQuery).subscribe((0, $5b1cfaea4824f818$var$_objectSpread2["default"])((0, $5b1cfaea4824f818$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = $5b1cfaea4824f818$var$useLoadMoreFunction;

});
parcelRegister("aeS5o", function(module, exports) {
"use strict";

var $aaXwj = parcelRequire("aaXwj");

var $lcVKE = parcelRequire("lcVKE");
var $77452a8f168be140$var$ConnectionInterface = $lcVKE.ConnectionInterface, $77452a8f168be140$var$getValueAtPath = $lcVKE.getValueAtPath;
function $77452a8f168be140$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $77452a8f168be140$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $77452a8f168be140$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === "object") && $aaXwj(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $aaXwj(false);
    !(typeof pageInfo === "object") && $aaXwj(false);
    var cursor = direction === "forward" ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === "string") && $aaXwj(false);
    var hasMore;
    if (direction === "forward") hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $77452a8f168be140$var$getConnectionState;

});

parcelRegister("jCnVf", function(module, exports) {
"use strict";

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");

var $lcVKE = parcelRequire("lcVKE");
var $e4841f682ea31b56$var$getObservableForActiveRequest = $lcVKE.__internal.getObservableForActiveRequest, $e4841f682ea31b56$var$getSelector = $lcVKE.getSelector;
var $e4841f682ea31b56$var$useEffect = $acw62.useEffect, $e4841f682ea31b56$var$useState = $acw62.useState, $e4841f682ea31b56$var$useMemo = $acw62.useMemo;
function $e4841f682ea31b56$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $4fG2B();
    var observable = $e4841f682ea31b56$var$useMemo(function() {
        var selector = $e4841f682ea31b56$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === "SingularReaderSelector") && $aaXwj(false);
        return $e4841f682ea31b56$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $e4841f682ea31b56$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $e4841f682ea31b56$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $e4841f682ea31b56$var$useIsOperationNodeActive;

});

parcelRegister("6NOcZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4f3e4409c7322760$var$_interopRequireDefault = $1jnue.default;

var $4f3e4409c7322760$var$_objectSpread2 = $4f3e4409c7322760$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $aeS5o = parcelRequire("aeS5o");

var $epnQn = parcelRequire("epnQn");

var $jCnVf = parcelRequire("jCnVf");

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $4f3e4409c7322760$var$useCallback = $acw62.useCallback, $4f3e4409c7322760$var$useRef = $acw62.useRef, $4f3e4409c7322760$var$useState = $acw62.useState;

var $lcVKE = parcelRequire("lcVKE");
var $4f3e4409c7322760$var$fetchQuery = $lcVKE.__internal.fetchQuery, $4f3e4409c7322760$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $4f3e4409c7322760$var$getPaginationVariables = $lcVKE.getPaginationVariables, $4f3e4409c7322760$var$getRefetchMetadata = $lcVKE.getRefetchMetadata, $4f3e4409c7322760$var$getSelector = $lcVKE.getSelector;
parcelRequire("8Fbfi");
function $4f3e4409c7322760$var$useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $4fG2B();
    var _getRefetchMetadata = $4f3e4409c7322760$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === "object" ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = $4f3e4409c7322760$var$useRef({
        kind: "none"
    });
    var _useState = $4f3e4409c7322760$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $4f3e4409c7322760$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $jCnVf(fragmentNode, fragmentRef);
    var forceDisposeFn = $4f3e4409c7322760$var$useCallback(function() {
        if (fetchStatusRef.current.kind === "fetching") fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: "none"
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $aeS5o(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isMountedRef = $epnQn();
    var loadMore = $4f3e4409c7322760$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $4f3e4409c7322760$var$getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === "fetching" || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== "PluralReaderSelector") && $aaXwj(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $4f3e4409c7322760$var$_objectSpread2["default"])((0, $4f3e4409c7322760$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $4f3e4409c7322760$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $4f3e4409c7322760$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $4f3e4409c7322760$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $4f3e4409c7322760$var$fetchQuery(environment, paginationQuery).subscribe((0, $4f3e4409c7322760$var$_objectSpread2["default"])((0, $4f3e4409c7322760$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: "fetching",
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: "none"
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: "none"
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = $4f3e4409c7322760$var$useLoadMoreFunction_EXPERIMENTAL;

});


parcelRegister("3JX1g", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2b935b17de48aad2$var$_interopRequireDefault = $1jnue.default;

var $2b935b17de48aad2$var$_objectSpread2 = $2b935b17de48aad2$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $9pgH3 = parcelRequire("9pgH3");

var $i2nMq = parcelRequire("i2nMq");
var $2b935b17de48aad2$var$getQueryResourceForEnvironment = $i2nMq.getQueryResourceForEnvironment;

var $7bk3G = parcelRequire("7bk3G");

var $3DuL7 = parcelRequire("3DuL7");

var $epnQn = parcelRequire("epnQn");

var $hASCV = parcelRequire("hASCV");

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $2b935b17de48aad2$var$useCallback = $acw62.useCallback, $2b935b17de48aad2$var$useContext = $acw62.useContext, $2b935b17de48aad2$var$useReducer = $acw62.useReducer;

var $lcVKE = parcelRequire("lcVKE");
var $2b935b17de48aad2$var$fetchQuery = $lcVKE.__internal.fetchQuery, $2b935b17de48aad2$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $2b935b17de48aad2$var$getFragmentIdentifier = $lcVKE.getFragmentIdentifier, $2b935b17de48aad2$var$getRefetchMetadata = $lcVKE.getRefetchMetadata, $2b935b17de48aad2$var$getSelector = $lcVKE.getSelector, $2b935b17de48aad2$var$getValueAtPath = $lcVKE.getValueAtPath;
parcelRequire("8Fbfi");
function $2b935b17de48aad2$var$reducer(state, action) {
    switch(action.type){
        case "refetch":
            var _action$refetchEnviro;
            return (0, $2b935b17de48aad2$var$_objectSpread2["default"])((0, $2b935b17de48aad2$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case "reset":
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error("useRefetchableFragmentNode: Unexpected action type");
    }
}
function $2b935b17de48aad2$var$useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $4fG2B();
    var _getRefetchMetadata = $2b935b17de48aad2$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $2b935b17de48aad2$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $2b935b17de48aad2$var$useReducer($2b935b17de48aad2$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $2b935b17de48aad2$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $2b935b17de48aad2$var$useContext($9pgH3);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $hASCV(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: "reset",
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $2b935b17de48aad2$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $7bk3G(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $aaXwj(false);
        var refetchedFragmentRef = $2b935b17de48aad2$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $3DuL7(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $2b935b17de48aad2$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $2b935b17de48aad2$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $epnQn();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === "object" ? fragmentData[identifierInfo.identifierField] : null;
    return $2b935b17de48aad2$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $2b935b17de48aad2$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === "PluralReaderSelector") {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $2b935b17de48aad2$var$_objectSpread2["default"])((0, $2b935b17de48aad2$var$_objectSpread2["default"])((0, $2b935b17de48aad2$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $2b935b17de48aad2$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: "refetch"
        });
        dispatch({
            type: "refetch",
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $2b935b17de48aad2$var$debugFunctions;
module.exports = $2b935b17de48aad2$var$useRefetchableFragmentNode;

});
parcelRegister("7bk3G", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $53a91ea40a67562a$var$_interopRequireDefault = $1jnue.default;

var $53a91ea40a67562a$var$_objectSpread2 = $53a91ea40a67562a$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $53a91ea40a67562a$var$_createForOfIteratorHelper2 = $53a91ea40a67562a$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $i2nMq = parcelRequire("i2nMq");
var $53a91ea40a67562a$var$getQueryResourceForEnvironment = $i2nMq.getQueryResourceForEnvironment;

var $aaXwj = parcelRequire("aaXwj");

var $lcVKE = parcelRequire("lcVKE");
var $53a91ea40a67562a$var$fetchQueryInternal = $lcVKE.__internal.fetchQuery, $53a91ea40a67562a$var$RelayFeatureFlags = $lcVKE.RelayFeatureFlags, $53a91ea40a67562a$var$createOperationDescriptor = $lcVKE.createOperationDescriptor, $53a91ea40a67562a$var$getPendingOperationsForFragment = $lcVKE.getPendingOperationsForFragment, $53a91ea40a67562a$var$getSelector = $lcVKE.getSelector, $53a91ea40a67562a$var$getVariablesFromFragment = $lcVKE.getVariablesFromFragment, $53a91ea40a67562a$var$handlePotentialSnapshotErrors = $lcVKE.handlePotentialSnapshotErrors;
parcelRequire("8Fbfi");
function $53a91ea40a67562a$var$isMissingData(state) {
    if (state.kind === "bailout") return false;
    else if (state.kind === "singular") return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $53a91ea40a67562a$var$getMissingClientEdges(state) {
    if (state.kind === "bailout") return null;
    else if (state.kind === "singular") {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $53a91ea40a67562a$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $53a91ea40a67562a$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $53a91ea40a67562a$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === "singular") $53a91ea40a67562a$var$handlePotentialSnapshotErrors(environment, state.snapshot.errorResponseFields);
    else if (state.kind === "plural") {
        var _iterator3 = (0, $53a91ea40a67562a$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                $53a91ea40a67562a$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $53a91ea40a67562a$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $53a91ea40a67562a$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $53a91ea40a67562a$var$_objectSpread2["default"])((0, $53a91ea40a67562a$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $53a91ea40a67562a$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $53a91ea40a67562a$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $53a91ea40a67562a$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $53a91ea40a67562a$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: "bailout"
    };
    else if (fragmentSelector.kind === "PluralReaderSelector") {
        if (fragmentSelector.selectors.length === 0) return {
            kind: "bailout"
        };
        else return {
            kind: "plural",
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: "singular",
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $53a91ea40a67562a$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $53a91ea40a67562a$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $aaXwj(false);
    else !!Array.isArray(fragmentRef) && $aaXwj(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $aaXwj(false);
    var state = $53a91ea40a67562a$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var missingClientEdges = $53a91ea40a67562a$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $53a91ea40a67562a$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($53a91ea40a67562a$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($53a91ea40a67562a$var$isMissingData(state)) {
        !(fragmentSelector != null) && $aaXwj(false);
        var fragmentOwner = fragmentSelector.kind === "PluralReaderSelector" ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $53a91ea40a67562a$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $53a91ea40a67562a$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === "bailout") data = isPlural ? [] : null;
    else if (state.kind === "singular") data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($53a91ea40a67562a$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $53a91ea40a67562a$var$readFragmentInternal;

});

parcelRegister("hASCV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ccf02c33d689ea63$var$_interopRequireDefault = $1jnue.default;

var $ccf02c33d689ea63$var$_createForOfIteratorHelper2 = $ccf02c33d689ea63$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $1c3ii = parcelRequire("1c3ii");
var $ccf02c33d689ea63$var$loadQuery = $1c3ii.loadQuery;

var $epnQn = parcelRequire("epnQn");

var $10ZTl = parcelRequire("10ZTl");

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");
var $ccf02c33d689ea63$var$useCallback = $acw62.useCallback, $ccf02c33d689ea63$var$useEffect = $acw62.useEffect, $ccf02c33d689ea63$var$useRef = $acw62.useRef, $ccf02c33d689ea63$var$useState = $acw62.useState;

var $lcVKE = parcelRequire("lcVKE");
var $ccf02c33d689ea63$var$RelayFeatureFlags = $lcVKE.RelayFeatureFlags, $ccf02c33d689ea63$var$getRequest = $lcVKE.getRequest;
var $ccf02c33d689ea63$var$initialNullQueryReferenceState = {
    kind: "NullQueryReference"
};
function $ccf02c33d689ea63$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === "PreloadableConcreteRequest") return preloadableRequest.params.metadata.live !== undefined;
    var request = $ccf02c33d689ea63$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $ccf02c33d689ea63$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    if ($ccf02c33d689ea63$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $10ZTl(preloadableRequest, initialQueryReference);
    return $ccf02c33d689ea63$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function $ccf02c33d689ea63$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $ccf02c33d689ea63$var$initialNullQueryReferenceState;
    var environment = $4fG2B();
    var isMountedRef = $epnQn();
    var undisposedQueryReferencesRef = $ccf02c33d689ea63$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $ccf02c33d689ea63$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $ccf02c33d689ea63$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $ccf02c33d689ea63$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($ccf02c33d689ea63$var$initialNullQueryReferenceState);
            setQueryReference($ccf02c33d689ea63$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $ccf02c33d689ea63$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty("__environment") ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $ccf02c33d689ea63$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $ccf02c33d689ea63$var$useRef(false);
    $ccf02c33d689ea63$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $ccf02c33d689ea63$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== "NullQueryReference") queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $ccf02c33d689ea63$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== "NullQueryReference") {
                        if ($ccf02c33d689ea63$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $ccf02c33d689ea63$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $ccf02c33d689ea63$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== "NullQueryReference") {
                        if ($ccf02c33d689ea63$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === "NullQueryReference" ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $ccf02c33d689ea63$var$useQueryLoader;

});
parcelRegister("10ZTl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0bd5cce7a539319f$var$_interopRequireDefault = $1jnue.default;

var $0bd5cce7a539319f$var$_createForOfIteratorHelper2 = $0bd5cce7a539319f$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $1c3ii = parcelRequire("1c3ii");
var $0bd5cce7a539319f$var$loadQuery = $1c3ii.loadQuery;

var $epnQn = parcelRequire("epnQn");

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");
var $0bd5cce7a539319f$var$useCallback = $acw62.useCallback, $0bd5cce7a539319f$var$useEffect = $acw62.useEffect, $0bd5cce7a539319f$var$useInsertionEffect = $acw62.useInsertionEffect, $0bd5cce7a539319f$var$useRef = $acw62.useRef, $0bd5cce7a539319f$var$useState = $acw62.useState;

var $lcVKE = parcelRequire("lcVKE");
var $0bd5cce7a539319f$var$getRequest = $lcVKE.getRequest;
var $0bd5cce7a539319f$var$initialNullQueryReferenceState = {
    kind: "NullQueryReference"
};
function $0bd5cce7a539319f$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === "PreloadableConcreteRequest") return preloadableRequest.params.metadata.live !== undefined;
    var request = $0bd5cce7a539319f$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var $0bd5cce7a539319f$var$CLEANUP_TIMEOUT = 300000;
function $0bd5cce7a539319f$var$useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $0bd5cce7a539319f$var$initialNullQueryReferenceState;
    var environment = $4fG2B();
    var isMountedRef = $epnQn();
    var undisposedQueryReferencesRef = $0bd5cce7a539319f$var$useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = $0bd5cce7a539319f$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $0bd5cce7a539319f$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $0bd5cce7a539319f$var$useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add($0bd5cce7a539319f$var$initialNullQueryReferenceState);
            setQueryReference($0bd5cce7a539319f$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $0bd5cce7a539319f$var$useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty("__environment") ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        var updatedQueryReference = $0bd5cce7a539319f$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = $0bd5cce7a539319f$var$useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, $0bd5cce7a539319f$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== "NullQueryReference") {
                    if ($0bd5cce7a539319f$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = $0bd5cce7a539319f$var$useRef(null);
    $0bd5cce7a539319f$var$useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, $0bd5cce7a539319f$var$CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    $0bd5cce7a539319f$var$useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === "NullQueryReference" ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $0bd5cce7a539319f$var$useQueryLoader_EXPERIMENTAL;

});




parcelRegister("johsa", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e1ddcc17f0710c4b$var$_interopRequireDefault = $1jnue.default;

var $e1ddcc17f0710c4b$var$_objectSpread2 = $e1ddcc17f0710c4b$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $3QqxT = parcelRequire("3QqxT");

var $7OZAN = parcelRequire("7OZAN");

var $3JX1g = parcelRequire("3JX1g");

var $4fG2B = parcelRequire("4fG2B");

var $eYEgc = parcelRequire("eYEgc");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $e1ddcc17f0710c4b$var$useCallback = $acw62.useCallback, $e1ddcc17f0710c4b$var$useDebugValue = $acw62.useDebugValue, $e1ddcc17f0710c4b$var$useEffect = $acw62.useEffect, $e1ddcc17f0710c4b$var$useLayoutEffect = $acw62.useLayoutEffect, $e1ddcc17f0710c4b$var$useMemo = $acw62.useMemo, $e1ddcc17f0710c4b$var$useRef = $acw62.useRef, $e1ddcc17f0710c4b$var$useState = $acw62.useState;

var $lcVKE = parcelRequire("lcVKE");
var $e1ddcc17f0710c4b$var$getFragment = $lcVKE.getFragment, $e1ddcc17f0710c4b$var$getFragmentIdentifier = $lcVKE.getFragmentIdentifier, $e1ddcc17f0710c4b$var$getPaginationMetadata = $lcVKE.getPaginationMetadata;

var $lcVKE = parcelRequire("lcVKE");
var $e1ddcc17f0710c4b$var$ConnectionInterface = $lcVKE.ConnectionInterface, $e1ddcc17f0710c4b$var$getSelector = $lcVKE.getSelector, $e1ddcc17f0710c4b$var$getValueAtPath = $lcVKE.getValueAtPath;
function $e1ddcc17f0710c4b$var$usePrefetchableForwardPaginationFragment_EXPERIMENTAL(fragmentInput, parentFragmentRef, bufferSize, initialSize, prefetchingLoadMoreOptions) {
    var _fragmentInput$metada, _fragmentInput$metada2;
    var minimalFetchSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var fragmentNode = $e1ddcc17f0710c4b$var$getFragment(fragmentInput);
    $eYEgc(fragmentNode, "first argument of usePrefetchableForwardPaginationFragment_EXPERIMENTAL()");
    var componentDisplayName = "usePrefetchableForwardPaginationFragment_EXPERIMENTAL()";
    var _getPaginationMetadat = $e1ddcc17f0710c4b$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $3JX1g(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $e1ddcc17f0710c4b$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var edgeKeys = $e1ddcc17f0710c4b$var$useMemo(function() {
        var connection = $e1ddcc17f0710c4b$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
        if (connection == null) return null;
        var _ConnectionInterface$ = $e1ddcc17f0710c4b$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES;
        return connection[EDGES];
    }, [
        connectionPathInFragmentData,
        fragmentData
    ]);
    var sourceSize = edgeKeys == null ? -1 : edgeKeys.length;
    var _useState = $e1ddcc17f0710c4b$var$useState(initialSize != null ? initialSize : sourceSize), _numInUse = _useState[0], setNumInUse = _useState[1];
    var numInUse = _numInUse;
    if (_numInUse === -1 && sourceSize !== -1) {
        numInUse = initialSize != null ? initialSize : sourceSize;
        setNumInUse(numInUse);
    }
    var environment = $4fG2B();
    var _useState2 = $e1ddcc17f0710c4b$var$useState(false), isLoadingMore = _useState2[0], reallySetIsLoadingMore = _useState2[1];
    var _useState3 = $e1ddcc17f0710c4b$var$useState(false), isRefetching = _useState3[0], setIsRefetching = _useState3[1];
    var availableSizeRef = $e1ddcc17f0710c4b$var$useRef(0);
    var setIsLoadingMore = $e1ddcc17f0710c4b$var$useCallback(function(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    }, [
        environment
    ]);
    var isLoadingMoreRef = $e1ddcc17f0710c4b$var$useRef(false);
    var observer = $e1ddcc17f0710c4b$var$useMemo(function() {
        return {
            start: function start() {
                isLoadingMoreRef.current = true;
                reallySetIsLoadingMore(true);
            },
            complete: function complete() {
                isLoadingMoreRef.current = false;
                setIsLoadingMore(false);
            },
            error: function error() {
                isLoadingMoreRef.current = false;
                setIsLoadingMore(false);
            }
        };
    }, [
        setIsLoadingMore
    ]);
    var handleReset = $e1ddcc17f0710c4b$var$useCallback(function() {
        if (!isRefetching) {
            var _environment$getSched2;
            var schedule = (_environment$getSched2 = environment.getScheduler()) === null || _environment$getSched2 === void 0 ? void 0 : _environment$getSched2.schedule;
            if (schedule) schedule(function() {
                setNumInUse(-1);
            });
            else setNumInUse(-1);
        }
        isLoadingMoreRef.current = false;
        setIsLoadingMore(false);
    }, [
        environment,
        isRefetching,
        setIsLoadingMore
    ]);
    var _useLoadMoreFunction = $7OZAN({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: "forward",
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest,
        observer: observer,
        onReset: handleReset
    }), loadMore = _useLoadMoreFunction[0], hasNext = _useLoadMoreFunction[1], disposeFetchNext = _useLoadMoreFunction[2];
    $e1ddcc17f0710c4b$var$useLayoutEffect(function() {
        availableSizeRef.current = sourceSize - numInUse;
    }, [
        numInUse,
        sourceSize
    ]);
    var prefetchingUNSTABLE_extraVariables = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.UNSTABLE_extraVariables;
    var prefetchingOnComplete = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.onComplete;
    var showMore = $e1ddcc17f0710c4b$var$useCallback(function(numToAdd, options) {
        if (!isLoadingMoreRef.current || availableSizeRef.current >= 0) {
            availableSizeRef.current -= numToAdd;
            setNumInUse(function(lastNumInUse) {
                return lastNumInUse + numToAdd;
            });
            if (!isLoadingMoreRef.current && availableSizeRef.current < 0) loadMore(Math.max(minimalFetchSize, Math.min(numToAdd, bufferSize - availableSizeRef.current)), options !== null && options !== void 0 ? options : {
                onComplete: prefetchingOnComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === "function" ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $e1ddcc17f0710c4b$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === "PluralReaderSelector") && $aaXwj(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        bufferSize,
        loadMore,
        minimalFetchSize,
        edgeKeys,
        fragmentData,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete
    ]);
    var edgesFragment = (_fragmentInput$metada = fragmentInput.metadata) === null || _fragmentInput$metada === void 0 ? void 0 : (_fragmentInput$metada2 = _fragmentInput$metada.refetch) === null || _fragmentInput$metada2 === void 0 ? void 0 : _fragmentInput$metada2.edgesFragment;
    !(edgesFragment != null) && $aaXwj(false);
    $e1ddcc17f0710c4b$var$useEffect(function() {
        if (!isLoadingMoreRef.current && !isLoadingMore && !isRefetching && hasNext && (sourceSize - numInUse < bufferSize || numInUse > sourceSize)) {
            var onComplete = prefetchingOnComplete;
            loadMore(Math.max(bufferSize - Math.max(sourceSize - numInUse, 0), numInUse - sourceSize, minimalFetchSize), {
                onComplete: onComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === "function" ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $e1ddcc17f0710c4b$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === "PluralReaderSelector") && $aaXwj(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        hasNext,
        bufferSize,
        isRefetching,
        loadMore,
        numInUse,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete,
        sourceSize,
        edgeKeys,
        isLoadingMore,
        minimalFetchSize,
        environment,
        edgesFragment
    ]);
    var realNumInUse = Math.min(numInUse, sourceSize);
    var derivedEdgeKeys = $e1ddcc17f0710c4b$var$useMemo(function() {
        var _edgeKeys$slice;
        return (_edgeKeys$slice = edgeKeys === null || edgeKeys === void 0 ? void 0 : edgeKeys.slice(0, realNumInUse)) !== null && _edgeKeys$slice !== void 0 ? _edgeKeys$slice : [];
    }, [
        edgeKeys,
        realNumInUse
    ]);
    var edges = $3QqxT(edgesFragment, derivedEdgeKeys);
    var refetchPagination = $e1ddcc17f0710c4b$var$useCallback(function(variables, options) {
        disposeFetchNext();
        setIsRefetching(true);
        return refetch(variables, (0, $e1ddcc17f0710c4b$var$_objectSpread2["default"])((0, $e1ddcc17f0710c4b$var$_objectSpread2["default"])({}, options), {}, {
            onComplete: function onComplete(maybeError) {
                var _environment$getSched3, _options$onComplete;
                var schedule = (_environment$getSched3 = environment.getScheduler()) === null || _environment$getSched3 === void 0 ? void 0 : _environment$getSched3.schedule;
                if (schedule) schedule(function() {
                    setIsRefetching(false);
                    setNumInUse(-1);
                });
                else {
                    setIsRefetching(false);
                    setNumInUse(-1);
                }
                options === null || options === void 0 || (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 || _options$onComplete.call(options, maybeError);
            },
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        environment,
        refetch
    ]);
    return {
        edges: edges,
        data: fragmentData,
        loadNext: showMore,
        hasNext: hasNext || sourceSize > numInUse,
        isLoadingNext: isLoadingMore && numInUse > sourceSize,
        refetch: refetchPagination
    };
}
module.exports = $e1ddcc17f0710c4b$var$usePrefetchableForwardPaginationFragment_EXPERIMENTAL;

});

parcelRegister("fH4DL", function(module, exports) {
"use strict";

var $03QWz = parcelRequire("03QWz");

var $lbcmO = parcelRequire("lbcmO");

var $4fG2B = parcelRequire("4fG2B");

var $aaXwj = parcelRequire("aaXwj");

var $acw62 = parcelRequire("acw62");
var $b6ce78a9352dcf1e$var$useDebugValue = $acw62.useDebugValue;

var $lcVKE = parcelRequire("lcVKE");
var $b6ce78a9352dcf1e$var$_require2$__internal = $lcVKE.__internal, $b6ce78a9352dcf1e$var$fetchQueryDeduped = $b6ce78a9352dcf1e$var$_require2$__internal.fetchQueryDeduped, $b6ce78a9352dcf1e$var$fetchQuery = $b6ce78a9352dcf1e$var$_require2$__internal.fetchQuery;
parcelRequire("8Fbfi");
function $b6ce78a9352dcf1e$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = $4fG2B();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $lbcmO(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === "PreloadedQuery_DEPRECATED") {
        !(operation.request.node.params.name === preloadedQuery.name) && $aaXwj(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: "usePreloadedQuery()",
            fetchKey: fetchKey,
            fetchObservable: $b6ce78a9352dcf1e$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $b6ce78a9352dcf1e$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: "usePreloadedQuery()",
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $03QWz(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $b6ce78a9352dcf1e$var$usePreloadedQuery;

});

parcelRegister("1tdq5", function(module, exports) {
"use strict";

var $3JX1g = parcelRequire("3JX1g");

var $eYEgc = parcelRequire("eYEgc");

var $acw62 = parcelRequire("acw62");
var $1122e8be893ed8ab$var$useDebugValue = $acw62.useDebugValue;

var $lcVKE = parcelRequire("lcVKE");
var $1122e8be893ed8ab$var$getFragment = $lcVKE.getFragment;
function $1122e8be893ed8ab$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $1122e8be893ed8ab$var$getFragment(fragmentInput);
    $eYEgc(fragmentNode, "first argument of useRefetchableFragment()");
    var _useRefetchableFragme = $3JX1g(fragmentNode, fragmentRef, "useRefetchableFragment()"), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $1122e8be893ed8ab$var$useRefetchableFragment;

});

parcelRegister("jc1m1", function(module, exports) {
"use strict";

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");
var $df90303d28a83b73$var$useEffect = $acw62.useEffect, $df90303d28a83b73$var$useRef = $acw62.useRef;
function $df90303d28a83b73$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $4fG2B();
    var disposableRef = $df90303d28a83b73$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join("");
    $df90303d28a83b73$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $df90303d28a83b73$var$useSubscribeToInvalidationState;

});

parcelRegister("5v24M", function(module, exports) {
"use strict";

var $4fG2B = parcelRequire("4fG2B");

var $acw62 = parcelRequire("acw62");
var $401175455cbde4cc$var$useEffect = $acw62.useEffect;

var $lcVKE = parcelRequire("lcVKE");
var $401175455cbde4cc$var$requestSubscription = $lcVKE.requestSubscription;
function $401175455cbde4cc$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $401175455cbde4cc$var$requestSubscription;
    var environment = $4fG2B();
    $401175455cbde4cc$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $401175455cbde4cc$var$useSubscription;

});


parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "ClassNames", () => $e0f035ab0866fe47$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $e0f035ab0866fe47$export$c8a8987d4410bf2d);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, "css")) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== "undefined";
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: "css"
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== "css" && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== "undefined";
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + "box-$1$2" + (0, $fm8kz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-item-" + (0, $fm8kz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-line-pack" + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + "box-" + (0, $fm8kz.replace)(value, "-grow", "") + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, "$1" + (0, $fm8kz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + "$1"), /(image-set)/, (0, $fm8kz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + "box-pack:$3" + (0, $fm8kz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fm8kz.WEBKIT) + "$2-$3" + "$1" + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, "stretch") ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ":", ":" + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fm8kz.WEBKIT) + "$2$3" + "$1" + (0, $fm8kz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, "@", "@" + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
"use strict";
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});




parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== "undefined";
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, "-$&").toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== "undefined";
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});



parcelRegister("cfuBi", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $8eae9f6324a7c469$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $8eae9f6324a7c469$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $8eae9f6324a7c469$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $8eae9f6324a7c469$export$352e418ed5b6193a);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $8eae9f6324a7c469$export$9d7b58831ae93caa);
var $8eae9f6324a7c469$export$4ef52930e33717cd = "data-theme";
var $8eae9f6324a7c469$export$a00eac3f8684bcd0 = "data-color-mode";
var $8eae9f6324a7c469$export$2112803007239c61 = "data-contrast-mode";
var $8eae9f6324a7c469$export$352e418ed5b6193a = "data-custom-theme";
var $8eae9f6324a7c469$export$6f0c6fb8c80fcc92 = "ds";
var $8eae9f6324a7c469$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $8eae9f6324a7c469$export$dddac1532e822863 = "--".concat($8eae9f6324a7c469$export$6f0c6fb8c80fcc92, "-token-not-found");
var $8eae9f6324a7c469$export$9d7b58831ae93caa = "--".concat($8eae9f6324a7c469$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5zphJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $40e3d5b564ddd8a9$export$2e2bcd8739ae039);
const $40e3d5b564ddd8a9$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $40e3d5b564ddd8a9$var$ATOMIC_GROUP_LENGTH = 5;
function $40e3d5b564ddd8a9$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $40e3d5b564ddd8a9$var$UNDERSCORE_UNICODE ? $40e3d5b564ddd8a9$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("cZGu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $975c22efe0f749c9$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $975c22efe0f749c9$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});

parcelRegister("5l6ld", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $97f8824bdeb85413$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<862724469d14ac56cfd68b24336e2d39>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $97f8824bdeb85413$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
    }, v1 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
            }
        ],
        "type": "AtlassianAccountUser",
        "abstractKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "authContextProviderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthenticationContext",
                        "kind": "LinkedField",
                        "name": "me",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v0 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "me.user.accountId"
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "storageKey": null
                                },
                                "action": "THROW",
                                "path": "me.user"
                            }
                        ],
                        "storageKey": null
                    },
                    "action": "THROW",
                    "path": "me"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "authContextProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                },
                                v0 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "42519adda6853705e4520d7241c5146a",
            "id": null,
            "metadata": {},
            "name": "authContextProviderQuery",
            "operationKind": "query",
            "text": "query authContextProviderQuery {\n  me {\n    user {\n      __typename\n      accountId\n      ... on AtlassianAccountUser {\n        picture\n        name\n        email\n      }\n      id\n    }\n  }\n}\n"
        }
    };
}();
$97f8824bdeb85413$var$node.hash = "1ed67efe85bfa38abdfa7d5180272f1b";
var $97f8824bdeb85413$export$2e2bcd8739ae039 = $97f8824bdeb85413$var$node;

});

parcelRegister("2pciS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $aa6544268c694196$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25cd0727e877bd297a034b02a868b5c0>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa6544268c694196$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hostNames"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "hostNames",
            "variableName": "hostNames"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cloudId",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "orgId",
        "storageKey": null
    }, v4 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "devai.ondemand"
        }
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entitlementId",
        "storageKey": null
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
            }
        ],
        "type": "CcpEntitlement",
        "abstractKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "tenantContextProviderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": null,
                        "args": v1 /*: any*/ ,
                        "concreteType": "TenantContext",
                        "kind": "LinkedField",
                        "name": "tenantContexts",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v2 /*: any*/ ,
                                "action": "THROW",
                                "path": "tenantContexts.cloudId"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v3 /*: any*/ ,
                                "action": "THROW",
                                "path": "tenantContexts.orgId"
                            },
                            {
                                "alias": null,
                                "args": v4 /*: any*/ ,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "entitlementInfo",
                                "plural": false,
                                "selections": [
                                    v5 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "entitlement",
                                        "plural": false,
                                        "selections": [
                                            v6 /*: any*/ 
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": 'entitlementInfo(hamsProductKey:"devai.ondemand")'
                            }
                        ],
                        "storageKey": null
                    },
                    "action": "THROW",
                    "path": "tenantContexts"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "tenantContextProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "alias": null,
                            "args": v4 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": 'entitlementInfo(hamsProductKey:"devai.ondemand")'
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "f22e22f3982f8d26e0a23898b5f9bbbc",
            "id": null,
            "metadata": {},
            "name": "tenantContextProviderQuery",
            "operationKind": "query",
            "text": 'query tenantContextProviderQuery(\n  $hostNames: [String!]\n) {\n  tenantContexts(hostNames: $hostNames) {\n    cloudId\n    orgId\n    entitlementInfo(hamsProductKey: "devai.ondemand") {\n      __typename\n      entitlementId\n      entitlement {\n        __typename\n        ... on CcpEntitlement {\n          status\n        }\n        id\n      }\n    }\n  }\n}\n'
        }
    };
}();
$aa6544268c694196$var$node.hash = "2b15fe3d52428f9cb93757fbfeb7bd5d";
var $aa6544268c694196$export$2e2bcd8739ae039 = $aa6544268c694196$var$node;

});

parcelRegister("ltooA", function(module, exports) {

$parcel$export(module.exports, "fg", () => $fa1f3adb8706799e$export$b40ec24ac8275656);

var $LXQUz = parcelRequire("LXQUz");
function $fa1f3adb8706799e$export$ba05d765b8392e5e(flagResolver) {
    (0, $LXQUz.setBooleanResolver)(flagResolver);
}
function $fa1f3adb8706799e$export$470e5c2be1411c89(name) {
    return (0, $LXQUz.resolveBooleanFlag)(name);
}
function $fa1f3adb8706799e$export$b40ec24ac8275656(name) {
    return (0, $LXQUz.resolveBooleanFlag)(name);
}

});
parcelRegister("LXQUz", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $0902d157d71d2032$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $0902d157d71d2032$export$6333b6aff9fc6275);

var $k5qh3 = parcelRequire("k5qh3");

var $cHzEV = parcelRequire("cHzEV");

var $hPtJY = parcelRequire("hPtJY");
var $0902d157d71d2032$var$pkgName = "@atlaskit/platform-feature-flags";
var $0902d157d71d2032$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $0902d157d71d2032$var$hasProcessEnv = typeof $hPtJY !== "undefined" && typeof $hPtJY.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $0902d157d71d2032$var$ENV_ENABLE_PLATFORM_FF = $0902d157d71d2032$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $0902d157d71d2032$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $0902d157d71d2032$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $0902d157d71d2032$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $0902d157d71d2032$var$ENV_ENABLE_PLATFORM_FF || $0902d157d71d2032$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $0902d157d71d2032$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $0902d157d71d2032$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98] = $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98] || $0902d157d71d2032$var$DEFAULT_PFF_GLOBAL;
function $0902d157d71d2032$export$f2b591175b3e424c(resolver) {
    $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $0902d157d71d2032$export$6333b6aff9fc6275(flagKey) {
    if ($0902d157d71d2032$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $cHzEV.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $0902d157d71d2032$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $k5qh3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $0902d157d71d2032$var$globalVar[$0902d157d71d2032$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("k5qh3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9f8a7c42435822f$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $ihYhP = parcelRequire("ihYhP");

var $95dDe = parcelRequire("95dDe");



var $e9f8a7c42435822f$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $e9f8a7c42435822f$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$e9f8a7c42435822f$var$_FeatureGates = $e9f8a7c42435822f$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "client", new (0, $ihYhP.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e9f8a7c42435822f$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $e9f8a7c42435822f$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e9f8a7c42435822f$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e9f8a7c42435822f$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e9f8a7c42435822f$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e9f8a7c42435822f$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initializeCalled", $e9f8a7c42435822f$var$_FeatureGates.client.initializeCalled.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initializeCompleted", $e9f8a7c42435822f$var$_FeatureGates.client.initializeCompleted.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initialize", $e9f8a7c42435822f$var$_FeatureGates.client.initialize.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initializeWithProvider", $e9f8a7c42435822f$var$_FeatureGates.client.initializeWithProvider.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "initializeFromValues", $e9f8a7c42435822f$var$_FeatureGates.client.initializeFromValues.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "manuallyLogGateExposure", $e9f8a7c42435822f$var$_FeatureGates.client.manuallyLogGateExposure.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getExperiment", $e9f8a7c42435822f$var$_FeatureGates.client.getExperiment.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "manuallyLogExperimentExposure", $e9f8a7c42435822f$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "manuallyLogLayerExposure", $e9f8a7c42435822f$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "shutdownStatsig", $e9f8a7c42435822f$var$_FeatureGates.client.shutdownStatsig.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "overrideGate", $e9f8a7c42435822f$var$_FeatureGates.client.overrideGate.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "clearGateOverride", $e9f8a7c42435822f$var$_FeatureGates.client.clearGateOverride.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "overrideConfig", $e9f8a7c42435822f$var$_FeatureGates.client.overrideConfig.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "clearConfigOverride", $e9f8a7c42435822f$var$_FeatureGates.client.clearConfigOverride.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "setOverrides", $e9f8a7c42435822f$var$_FeatureGates.client.setOverrides.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getOverrides", $e9f8a7c42435822f$var$_FeatureGates.client.getOverrides.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "clearAllOverrides", $e9f8a7c42435822f$var$_FeatureGates.client.clearAllOverrides.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "isCurrentUser", $e9f8a7c42435822f$var$_FeatureGates.client.isCurrentUser.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "onGateUpdated", $e9f8a7c42435822f$var$_FeatureGates.client.onGateUpdated.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "onExperimentValueUpdated", $e9f8a7c42435822f$var$_FeatureGates.client.onExperimentValueUpdated.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "onAnyUpdated", $e9f8a7c42435822f$var$_FeatureGates.client.onAnyUpdated.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "updateUser", $e9f8a7c42435822f$var$_FeatureGates.client.updateUser.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "updateUserWithProvider", $e9f8a7c42435822f$var$_FeatureGates.client.updateUserWithProvider.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "updateUserWithValues", $e9f8a7c42435822f$var$_FeatureGates.client.updateUserWithValues.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getPackageVersion", $e9f8a7c42435822f$var$_FeatureGates.client.getPackageVersion.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getLayer", $e9f8a7c42435822f$var$_FeatureGates.client.getLayer.bind($e9f8a7c42435822f$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($e9f8a7c42435822f$var$FeatureGates, "getLayerValue", $e9f8a7c42435822f$var$_FeatureGates.client.getLayerValue.bind($e9f8a7c42435822f$var$_FeatureGates.client));
var $e9f8a7c42435822f$var$boundFGJS = $e9f8a7c42435822f$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e9f8a7c42435822f$var$FeatureGates;
    else {
        var $e9f8a7c42435822f$var$_boundFGJS, $e9f8a7c42435822f$var$_boundFGJS$getPackage;
        $e9f8a7c42435822f$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $e9f8a7c42435822f$var$boundVersion = (($e9f8a7c42435822f$var$_boundFGJS = $e9f8a7c42435822f$var$boundFGJS) === null || $e9f8a7c42435822f$var$_boundFGJS === void 0 || ($e9f8a7c42435822f$var$_boundFGJS$getPackage = $e9f8a7c42435822f$var$_boundFGJS.getPackageVersion) === null || $e9f8a7c42435822f$var$_boundFGJS$getPackage === void 0 ? void 0 : $e9f8a7c42435822f$var$_boundFGJS$getPackage.call($e9f8a7c42435822f$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($e9f8a7c42435822f$var$boundVersion !== (0, $95dDe.CLIENT_VERSION)) {
            var $e9f8a7c42435822f$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($e9f8a7c42435822f$var$boundVersion, " when module version ").concat((0, $95dDe.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($e9f8a7c42435822f$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e9f8a7c42435822f$export$2e2bcd8739ae039 = $e9f8a7c42435822f$var$boundFGJS;

});
parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ihYhP", function(module, exports) {

$parcel$export(module.exports, "Client", () => $d5089430a0b807cf$export$1f2bb630327ac4b6);

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $49JF1 = parcelRequire("49JF1");

var $cu1O2 = parcelRequire("cu1O2");

var $1FlXM = parcelRequire("1FlXM");

var $cgoqa = parcelRequire("cgoqa");

var $3G7ch = parcelRequire("3G7ch");

var $wC5uA = parcelRequire("wC5uA");

var $e7j5k = parcelRequire("e7j5k");

var $9UzjC = parcelRequire("9UzjC");

var $fUDja = parcelRequire("fUDja");

var $4if7L = parcelRequire("4if7L");

var $95dDe = parcelRequire("95dDe");
var $d5089430a0b807cf$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $d5089430a0b807cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5089430a0b807cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5089430a0b807cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5089430a0b807cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d5089430a0b807cf$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $d5089430a0b807cf$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $d5089430a0b807cf$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $9UzjC.LOCAL_STORAGE_KEY) : _ref$localStorageKey;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "subscriptions", new (0, $cu1O2.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "dataAdapter", new (0, $e7j5k.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = new (0, $9UzjC.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4if7L.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $4if7L.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4if7L.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $4if7L.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $95dDe.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $d5089430a0b807cf$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $95dDe.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $fUDja.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $4if7L.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $4if7L.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $4if7L.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $wC5uA.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $1FlXM.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $1FlXM.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $3G7ch.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $4if7L.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $4if7L.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $d5089430a0b807cf$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $wC5uA.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $wC5uA.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $d5089430a0b807cf$var$_objectSpread($d5089430a0b807cf$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $4if7L.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $d5089430a0b807cf$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $d5089430a0b807cf$var$_objectSpread($d5089430a0b807cf$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $d5089430a0b807cf$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $fUDja.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(newClientOptions, $d5089430a0b807cf$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $4if7L.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $d5089430a0b807cf$var$_objectSpread($d5089430a0b807cf$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $49JF1.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $49JF1.StatsigClient)($d5089430a0b807cf$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $4if7L.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $95dDe.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $cgoqa.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $cgoqa.Layer).fromLayer((0, $49JF1._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("h1Oiy", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $c6598bdb60f83fe0$var$runtime = (parcelRequire("8HV7i"))();
module.exports = $c6598bdb60f83fe0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c6598bdb60f83fe0$var$runtime);
}

});
parcelRegister("8HV7i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $656ea513998a70a9$var$_typeof = $41YNz.default;
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $656ea513998a70a9$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($656ea513998a70a9$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("49JF1", function(module, exports) {
"use strict";
var $306b6bf2e1481351$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $306b6bf2e1481351$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $306b6bf2e1481351$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;

var $eW9f7 = parcelRequire("eW9f7");
module.exports.StatsigClient = $eW9f7.default;

$306b6bf2e1481351$var$__exportStar((parcelRequire("jS1H0")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    StatsigClient: $eW9f7.default
});
module.exports.default = __STATSIG__;

});
parcelRegister("eW9f7", function(module, exports) {
"use strict";
var $adfda6e7b7bfaec8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jS1H0 = parcelRequire("jS1H0");

var $lOMkS = parcelRequire("lOMkS");

var $57TdV = parcelRequire("57TdV");

var $3XUKG = parcelRequire("3XUKG");

var $lm8vs = parcelRequire("lm8vs");
class $adfda6e7b7bfaec8$var$StatsigClient extends $jS1H0.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient|undefined} Returns the StatsigClient instance associated with the given SDK key, or undefined if no instance is associated with the key or if no key is provided and no instances exist.
     */ static instance(sdkKey) {
        const instance = (0, $jS1H0._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $adfda6e7b7bfaec8$var$StatsigClient) return instance;
        $jS1H0.Log.warn((0, $jS1H0._isServerEnv)() ? "StatsigClient.instance is not supported in server environments" : "Unable to find StatsigClient instance");
        return new $adfda6e7b7bfaec8$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "", {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $jS1H0.SDKType._setClientType(sdkKey, "javascript-client");
        const network = new $57TdV.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $lm8vs.StatsigEvaluationsDataAdapter(), network, options);
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($jS1H0.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($jS1H0.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($jS1H0.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($jS1H0.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($jS1H0.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $lOMkS.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== "Uninitialized") return (0, $jS1H0.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            "MultipleInitializations",
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $adfda6e7b7bfaec8$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        var _a;
        const startTime = performance.now();
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push("NoCachedValues");
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === "Bootstrap") return (0, $jS1H0.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $jS1H0.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $adfda6e7b7bfaec8$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $jS1H0.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus("Loading", result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $jS1H0.createUpdateDetails)(false, this._store.getSource(), -1, new Error("User changed during update"), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $jS1H0.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $jS1H0.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($jS1H0.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: "initialization_failure"
                });
            }
            $jS1H0.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $jS1H0.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $jS1H0.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $jS1H0.StatsigSession.get(this._sdkKey),
            stableID: $jS1H0.StableID.get(this._sdkKey)
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === "string" ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    _primeReadyRipcord() {
        this.$on("error", ()=>{
            this.loadingStatus === "Loading" && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $adfda6e7b7bfaec8$var$__awaiter(this, void 0, void 0, function*() {
            if (!$jS1H0.Storage.isReady()) yield $jS1H0.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus("Ready", values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: "low"
        }).catch((err)=>{
            $jS1H0.Log.error("An error occurred after update.", err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $jS1H0._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $jS1H0.StableID.setOverride(stableIdOverride, this._sdkKey);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $jS1H0._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $jS1H0._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "gate_evaluation",
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $jS1H0._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $jS1H0._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "dynamic_config_evaluation",
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $jS1H0._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $jS1H0._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $jS1H0._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "experiment_evaluation",
            experiment: result
        });
        return result;
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $jS1H0._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $jS1H0._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $jS1H0._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: "layer_evaluation",
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $3XUKG._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $3XUKG._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $adfda6e7b7bfaec8$var$StatsigClient;

});
parcelRegister("jS1H0", function(module, exports) {
"use strict";
var $e7745f9a4dcdc92a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7745f9a4dcdc92a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e7745f9a4dcdc92a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;


Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9vgpJ")).Diagnostics;
    }
});

var $1x5ek = parcelRequire("1x5ek");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $1x5ek.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("aJqAw")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1Y0sQ")).Storage;
    }
});

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("1TJvm")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("hgBBj")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("ig6km")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("fFRwz")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("9vgpJ")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("1uA6T")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("90xfN")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("3izdo")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("iS0Os")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("c7j2m")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("gXsA7")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("aJqAw")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("bMivU")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("7JCXg")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("2juun")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("eHhOb")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("ibDZT")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("f87Bk")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("eSDjJ")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("df3hs")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("cyM0i")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("kAAfI")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("20vLv")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("9HWUG")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("3XJjC")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("72E2N")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("6A2Ba")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("cYkgq")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("fVgBI")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("1Q38X")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("i0Ijk")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("1Y0sQ")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("hpdMt")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("jif12")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("sNl0d")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("elNQX")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("gjSL0")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("9D94r")), module.exports);

$e7745f9a4dcdc92a$var$__exportStar((parcelRequire("cJJ9J")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    Log: (parcelRequire("aJqAw")).Log,
    SDK_VERSION: (parcelRequire("72E2N")).SDK_VERSION
});

});
parcelRegister("1TJvm", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $161e39cde079670c$var$_a, $161e39cde079670c$var$_b, $161e39cde079670c$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $aJqAw = parcelRequire("aJqAw");
const $161e39cde079670c$var$_getStatsigGlobal = ()=>{
    return __STATSIG__ ? __STATSIG__ : $161e39cde079670c$var$statsigGlobal;
};
module.exports._getStatsigGlobal = $161e39cde079670c$var$_getStatsigGlobal;
const $161e39cde079670c$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $161e39cde079670c$var$_getStatsigGlobalFlag;
const $161e39cde079670c$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $aJqAw.Log.warn("Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.");
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $161e39cde079670c$var$_getInstance;
const $161e39cde079670c$var$GLOBAL_KEY = "__STATSIG__";
const $161e39cde079670c$var$_window = typeof window !== "undefined" ? window : {};
const $161e39cde079670c$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $161e39cde079670c$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : {};
const $161e39cde079670c$var$statsigGlobal = ($161e39cde079670c$var$_c = ($161e39cde079670c$var$_b = ($161e39cde079670c$var$_a = $161e39cde079670c$var$_window[$161e39cde079670c$var$GLOBAL_KEY]) !== null && $161e39cde079670c$var$_a !== void 0 ? $161e39cde079670c$var$_a : $161e39cde079670c$var$_global[$161e39cde079670c$var$GLOBAL_KEY]) !== null && $161e39cde079670c$var$_b !== void 0 ? $161e39cde079670c$var$_b : $161e39cde079670c$var$_globalThis[$161e39cde079670c$var$GLOBAL_KEY]) !== null && $161e39cde079670c$var$_c !== void 0 ? $161e39cde079670c$var$_c : {
    instance: module.exports._getInstance
};
$161e39cde079670c$var$_window[$161e39cde079670c$var$GLOBAL_KEY] = $161e39cde079670c$var$statsigGlobal;
$161e39cde079670c$var$_global[$161e39cde079670c$var$GLOBAL_KEY] = $161e39cde079670c$var$statsigGlobal;
$161e39cde079670c$var$_globalThis[$161e39cde079670c$var$GLOBAL_KEY] = $161e39cde079670c$var$statsigGlobal;

});
parcelRegister("aJqAw", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $7d02bb34903f983d$var$DEBUG = " DEBUG ";
const $7d02bb34903f983d$var$_INFO = "  INFO ";
const $7d02bb34903f983d$var$_WARN = "  WARN ";
const $7d02bb34903f983d$var$ERROR = " ERROR ";
function $7d02bb34903f983d$var$addTag(args) {
    args.unshift("[Statsig]");
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $7d02bb34903f983d$var$Log {
    static info(...args) {
        if ($7d02bb34903f983d$var$Log.level >= module.exports.LogLevel.Info) console.info($7d02bb34903f983d$var$_INFO, ...$7d02bb34903f983d$var$addTag(args));
    }
    static debug(...args) {
        if ($7d02bb34903f983d$var$Log.level >= module.exports.LogLevel.Debug) console.debug($7d02bb34903f983d$var$DEBUG, ...$7d02bb34903f983d$var$addTag(args));
    }
    static warn(...args) {
        if ($7d02bb34903f983d$var$Log.level >= module.exports.LogLevel.Warn) console.warn($7d02bb34903f983d$var$_WARN, ...$7d02bb34903f983d$var$addTag(args));
    }
    static error(...args) {
        if ($7d02bb34903f983d$var$Log.level >= module.exports.LogLevel.Error) console.error($7d02bb34903f983d$var$ERROR, ...$7d02bb34903f983d$var$addTag(args));
    }
}
module.exports.Log = $7d02bb34903f983d$var$Log;
$7d02bb34903f983d$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("9vgpJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $6eb3bdc3e880d863$var$MARKER_MAP = new Map();
const $6eb3bdc3e880d863$var$ACT_START = "start";
const $6eb3bdc3e880d863$var$ACT_END = "end";
const $6eb3bdc3e880d863$var$DIAGNOSTICS_EVENT = "statsig::diagnostics";
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $6eb3bdc3e880d863$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker({}, $6eb3bdc3e880d863$var$ACT_START, "overall"));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: "InitializeError",
                message: "Failed to initialize"
            },
            evaluationDetails: evaluationDetails
        }, $6eb3bdc3e880d863$var$ACT_END, "overall"));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker(data, $6eb3bdc3e880d863$var$ACT_START, "initialize", "network_request"));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker(data, $6eb3bdc3e880d863$var$ACT_END, "initialize", "network_request"));
    },
    _markInitProcessStart: (sdkKey)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker({}, $6eb3bdc3e880d863$var$ACT_START, "initialize", "process"));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $6eb3bdc3e880d863$var$_addMarker(sdkKey, $6eb3bdc3e880d863$var$_createMarker(data, $6eb3bdc3e880d863$var$ACT_END, "initialize", "process"));
    },
    _clearMarkers: (sdkKey)=>{
        $6eb3bdc3e880d863$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === "object")) return;
        return {
            code: $6eb3bdc3e880d863$var$_safeGetField(e, "code"),
            name: $6eb3bdc3e880d863$var$_safeGetField(e, "name"),
            message: $6eb3bdc3e880d863$var$_safeGetField(e, "message")
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get("x-statsig-region"),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $6eb3bdc3e880d863$var$_makeDiagnosticsEvent(user, {
            context: "initialize",
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $6eb3bdc3e880d863$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $6eb3bdc3e880d863$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $6eb3bdc3e880d863$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $6eb3bdc3e880d863$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $6eb3bdc3e880d863$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $6eb3bdc3e880d863$var$MARKER_MAP.set(sdkKey, markers);
}
function $6eb3bdc3e880d863$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("1x5ek", function(module, exports) {
"use strict";
var $11dcee1bd8902280$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $hgBBj = parcelRequire("hgBBj");

var $c7j2m = parcelRequire("c7j2m");

var $aJqAw = parcelRequire("aJqAw");

var $7JCXg = parcelRequire("7JCXg");

var $f87Bk = parcelRequire("f87Bk");

var $3XJjC = parcelRequire("3XJjC");

var $1Y0sQ = parcelRequire("1Y0sQ");

var $sNl0d = parcelRequire("sNl0d");

var $gjSL0 = parcelRequire("gjSL0");
const $11dcee1bd8902280$var$DEFAULT_QUEUE_SIZE = 100;
const $11dcee1bd8902280$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $11dcee1bd8902280$var$MAX_DEDUPER_KEYS = 1000;
const $11dcee1bd8902280$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $11dcee1bd8902280$var$MAX_FAILED_LOGS = 500;
const $11dcee1bd8902280$var$QUICK_FLUSH_WINDOW_MS = 200;
const $11dcee1bd8902280$var$EVENT_LOGGER_MAP = {};
const $11dcee1bd8902280$var$RetryFailedLogsTrigger = {
    Startup: "startup",
    GainedFocus: "gained_focus"
};
class $11dcee1bd8902280$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $11dcee1bd8902280$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $11dcee1bd8902280$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($11dcee1bd8902280$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._isLoggingDisabled = (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true;
        this._maxQueueSize = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _a !== void 0 ? _a : $11dcee1bd8902280$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $sNl0d.UrlConfiguration($7JCXg.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLoggingDisabled(isDisabled) {
        this._isLoggingDisabled = isDisabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $11dcee1bd8902280$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        this._lastExposureTimeMap = {};
    }
    start() {
        if ((0, $f87Bk._isServerEnv)()) return; // do not run in server environments
        $11dcee1bd8902280$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        (0, $gjSL0._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === "background") $11dcee1bd8902280$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === "foreground") $11dcee1bd8902280$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($11dcee1bd8902280$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $11dcee1bd8902280$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $11dcee1bd8902280$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$11dcee1bd8902280$var$EventLogger._safeFlushAndForget(this._sdkKey), $11dcee1bd8902280$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        if ((0, $f87Bk._isServerEnv)()) return false; // do not run in server environments
        if (!(0, $3XJjC._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $hgBBj._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata["gate"],
            metadata["config"],
            metadata["ruleID"],
            metadata["allocatedExperiment"],
            metadata["parameterName"],
            String(metadata["isExplicitParameter"]),
            metadata["reason"]
        ].join("|");
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $11dcee1bd8902280$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $11dcee1bd8902280$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        var _a, _b;
        return $11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
            if (this._isLoggingDisabled) {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $gjSL0._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: "pre_logs_flushed",
                    events: events
                });
                const response = shouldUseBeacon ? yield this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: "logs_flushed",
                        events: events
                    });
                    return true;
                } else {
                    $aJqAw.Log.warn("Failed to flush events.");
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $aJqAw.Log.warn("Failed to flush events.");
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        var _a;
        return $11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return $11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
            return {
                success: yield this._network.beacon(this._getRequestData(events))
            };
        });
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$7JCXg.NetworkParam.EventCount]: String(events.length)
            },
            credentials: "same-origin"
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $11dcee1bd8902280$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $1Y0sQ._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $aJqAw.Log.warn("Unable to save failed logs to storage");
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$11dcee1bd8902280$var$__awaiter(this, void 0, void 0, function*() {
                if (!$1Y0sQ.Storage.isReady()) yield $1Y0sQ.Storage.isReadyResolver();
                const events = (0, $1Y0sQ._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $11dcee1bd8902280$var$RetryFailedLogsTrigger.Startup) $1Y0sQ.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $11dcee1bd8902280$var$RetryFailedLogsTrigger.GainedFocus) $1Y0sQ.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $aJqAw.Log.warn("Failed to flush stored logs");
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $c7j2m._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $aJqAw.Log.debug("Enqueued Event:", final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: "statsig::non_exposed_checks",
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $f87Bk._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $11dcee1bd8902280$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $11dcee1bd8902280$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $11dcee1bd8902280$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $11dcee1bd8902280$var$EventLogger;

});
parcelRegister("hgBBj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $c7j2m = parcelRequire("c7j2m");
function $c921190cb6191442$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(",")}`,
        `k:${sdkKey}`
    ];
    return (0, $c7j2m._DJB2)(parts.join("|"));
}
module.exports._getUserStorageKey = $c921190cb6191442$var$_getUserStorageKey;
function $c921190cb6191442$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $c921190cb6191442$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $c7j2m._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $c921190cb6191442$var$_getStorageKey;

});
parcelRegister("c7j2m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $jif12 = parcelRequire("jif12");
const $8d24e7d3a4faa2d1$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $8d24e7d3a4faa2d1$var$_DJB2;
const $8d24e7d3a4faa2d1$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $8d24e7d3a4faa2d1$var$_DJB2Object;
const $8d24e7d3a4faa2d1$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $jif12._typeOf)(value) !== "object") {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $8d24e7d3a4faa2d1$var$_getSortedObject;

});
parcelRegister("jif12", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $e0bb5896df65cfcc$var$_typeOf(input) {
    return Array.isArray(input) ? "array" : typeof input;
}
module.exports._typeOf = $e0bb5896df65cfcc$var$_typeOf;
function $e0bb5896df65cfcc$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? "array" : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $e0bb5896df65cfcc$var$_isTypeMatch;

});



parcelRegister("7JCXg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: "initialize",
    _rgstr: "rgstr",
    _download_config_specs: "download_config_specs"
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: "https://prodregistryv2.org/v1",
    [module.exports.Endpoint._initialize]: "https://featureassets.org/v1",
    [module.exports.Endpoint._download_config_specs]: "https://api.statsigcdn.com/v1"
};
module.exports.NetworkParam = {
    EventCount: "ec",
    SdkKey: "k",
    SdkType: "st",
    SdkVersion: "sv",
    Time: "t",
    SessionID: "sid",
    StatsigEncoded: "se",
    IsGzipped: "gz"
};

});

parcelRegister("f87Bk", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $b03d7fc4181c0b52$var$_getWindowSafe = ()=>{
    return typeof window !== "undefined" ? window : null;
};
module.exports._getWindowSafe = $b03d7fc4181c0b52$var$_getWindowSafe;
const $b03d7fc4181c0b52$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $b03d7fc4181c0b52$var$_getDocumentSafe;
const $b03d7fc4181c0b52$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $hPtJY !== "undefined" && $hPtJY.versions != null && $hPtJY.versions.node != null;
    const isVercel = typeof EdgeRuntime === "string";
    return isVercel || isNode;
};
module.exports._isServerEnv = $b03d7fc4181c0b52$var$_isServerEnv;
const $b03d7fc4181c0b52$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === "function") win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $b03d7fc4181c0b52$var$_addWindowEventListenerSafe;
const $b03d7fc4181c0b52$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === "function") doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $b03d7fc4181c0b52$var$_addDocumentEventListenerSafe;
const $b03d7fc4181c0b52$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $b03d7fc4181c0b52$var$_getCurrentPageUrlSafe;
const $b03d7fc4181c0b52$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return "beforeunload";
    const eventType = "onpagehide" in win ? "pagehide" : "beforeunload";
    return eventType;
};
module.exports._getUnloadEvent = $b03d7fc4181c0b52$var$_getUnloadEvent;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("3XJjC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $2e2a087b59135670$var$CONFIG_EXPOSURE_NAME = "statsig::config_exposure";
const $2e2a087b59135670$var$GATE_EXPOSURE_NAME = "statsig::gate_exposure";
const $2e2a087b59135670$var$LAYER_EXPOSURE_NAME = "statsig::layer_exposure";
const $2e2a087b59135670$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata["bootstrapMetadata"] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $2e2a087b59135670$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $2e2a087b59135670$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $2e2a087b59135670$var$GATE_EXPOSURE_NAME || eventName === $2e2a087b59135670$var$CONFIG_EXPOSURE_NAME || eventName === $2e2a087b59135670$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $2e2a087b59135670$var$_isExposureEvent;
const $2e2a087b59135670$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = gate.__evaluation.version;
    return $2e2a087b59135670$var$_createExposure($2e2a087b59135670$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $2e2a087b59135670$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $2e2a087b59135670$var$_createGateExposure;
function $2e2a087b59135670$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === "string") return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $2e2a087b59135670$var$_mapExposures;
const $2e2a087b59135670$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata["rulePassed"] = String(config.__evaluation.passed);
    return $2e2a087b59135670$var$_createExposure($2e2a087b59135670$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $2e2a087b59135670$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $2e2a087b59135670$var$_createConfigExposure;
const $2e2a087b59135670$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = "";
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : "";
        secondaryExposures = evaluation.secondary_exposures;
    }
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_d = layer.__evaluation) === null || _d === void 0 ? void 0 : _d.version) != null) metadata["configVersion"] = layer.__evaluation.version;
    return $2e2a087b59135670$var$_createExposure($2e2a087b59135670$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $2e2a087b59135670$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $2e2a087b59135670$var$_createLayerParameterExposure;
const $2e2a087b59135670$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata["reason"] = details.reason;
    if (details.lcut) metadata["lcut"] = String(details.lcut);
    if (details.receivedAt) metadata["receivedAt"] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("1Y0sQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $aJqAw = parcelRequire("aJqAw");

var $f87Bk = parcelRequire("f87Bk");
const $16ebc13608dd52ec$var$inMemoryStore = {};
const $16ebc13608dd52ec$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>"InMemory",
    getItem: (key)=>$16ebc13608dd52ec$var$inMemoryStore[key] ? $16ebc13608dd52ec$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $16ebc13608dd52ec$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $16ebc13608dd52ec$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($16ebc13608dd52ec$var$inMemoryStore)
};
let $16ebc13608dd52ec$var$_localStorageProvider = null;
try {
    const win = (0, $f87Bk._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === "function") $16ebc13608dd52ec$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>"LocalStorage",
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $aJqAw.Log.warn("Failed to setup localStorageProvider.");
}
let $16ebc13608dd52ec$var$_main = $16ebc13608dd52ec$var$_localStorageProvider !== null && $16ebc13608dd52ec$var$_localStorageProvider !== void 0 ? $16ebc13608dd52ec$var$_localStorageProvider : $16ebc13608dd52ec$var$_inMemoryProvider;
let $16ebc13608dd52ec$var$_current = $16ebc13608dd52ec$var$_main;
function $16ebc13608dd52ec$var$_inMemoryBreaker(get) {
    try {
        return get();
    } catch (error) {
        if (error instanceof Error && error.name === "SecurityError") {
            module.exports.Storage._setProvider($16ebc13608dd52ec$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$16ebc13608dd52ec$var$_current.isReady(),
    isReadyResolver: ()=>$16ebc13608dd52ec$var$_current.isReadyResolver(),
    getProviderName: ()=>$16ebc13608dd52ec$var$_current.getProviderName(),
    getItem: (key)=>$16ebc13608dd52ec$var$_inMemoryBreaker(()=>$16ebc13608dd52ec$var$_current.getItem(key)),
    setItem: (key, value)=>$16ebc13608dd52ec$var$_current.setItem(key, value),
    removeItem: (key)=>$16ebc13608dd52ec$var$_current.removeItem(key),
    getAllKeys: ()=>$16ebc13608dd52ec$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $16ebc13608dd52ec$var$_main = newProvider;
        $16ebc13608dd52ec$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $16ebc13608dd52ec$var$_current = $16ebc13608dd52ec$var$_inMemoryProvider;
        else $16ebc13608dd52ec$var$_current = $16ebc13608dd52ec$var$_main;
    }
};
function $16ebc13608dd52ec$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : "null");
}
module.exports._getObjectFromStorage = $16ebc13608dd52ec$var$_getObjectFromStorage;
function $16ebc13608dd52ec$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $16ebc13608dd52ec$var$_setObjectInStorage;

});

parcelRegister("sNl0d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $c7j2m = parcelRequire("c7j2m");

var $7JCXg = parcelRequire("7JCXg");
const $0568e316ac889a5f$var$ENDPOINT_DNS_KEY_MAP = {
    [$7JCXg.Endpoint._initialize]: "i",
    [$7JCXg.Endpoint._rgstr]: "e",
    [$7JCXg.Endpoint._download_config_specs]: "d"
};
class $0568e316ac889a5f$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $0568e316ac889a5f$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith("/") ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $7JCXg.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(",");
        return (0, $c7j2m._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $0568e316ac889a5f$var$UrlConfiguration;

});

parcelRegister("gjSL0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $f87Bk = parcelRequire("f87Bk");
const $be18e54c302a5617$var$FOREGROUND = "foreground";
const $be18e54c302a5617$var$BACKGROUND = "background";
const $be18e54c302a5617$var$LISTENERS = [];
let $be18e54c302a5617$var$current = $be18e54c302a5617$var$FOREGROUND;
let $be18e54c302a5617$var$isUnloading = false;
const $be18e54c302a5617$var$_isCurrentlyVisible = ()=>{
    return $be18e54c302a5617$var$current === $be18e54c302a5617$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $be18e54c302a5617$var$_isCurrentlyVisible;
const $be18e54c302a5617$var$_isUnloading = ()=>$be18e54c302a5617$var$isUnloading;
module.exports._isUnloading = $be18e54c302a5617$var$_isUnloading;
const $be18e54c302a5617$var$_subscribeToVisiblityChanged = (listener)=>{
    $be18e54c302a5617$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $be18e54c302a5617$var$_subscribeToVisiblityChanged;
const $be18e54c302a5617$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $be18e54c302a5617$var$current) return;
    $be18e54c302a5617$var$current = visibility;
    $be18e54c302a5617$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $be18e54c302a5617$var$_notifyVisibilityChanged;
(0, $f87Bk._addWindowEventListenerSafe)("focus", ()=>{
    $be18e54c302a5617$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($be18e54c302a5617$var$FOREGROUND);
});
(0, $f87Bk._addWindowEventListenerSafe)("blur", ()=>(0, module.exports._notifyVisibilityChanged)($be18e54c302a5617$var$BACKGROUND));
(0, $f87Bk._addDocumentEventListenerSafe)("visibilitychange", ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === "visible" ? $be18e54c302a5617$var$FOREGROUND : $be18e54c302a5617$var$BACKGROUND);
});
(0, $f87Bk._addWindowEventListenerSafe)((0, $f87Bk._getUnloadEvent)(), ()=>{
    $be18e54c302a5617$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($be18e54c302a5617$var$BACKGROUND);
});

});


parcelRegister("72E2N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = "3.15.0";
let $0152b4c71326a69f$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: "js-mono"
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$0152b4c71326a69f$var$metadata,
    add: (additions)=>{
        $0152b4c71326a69f$var$metadata = Object.assign(Object.assign({}, $0152b4c71326a69f$var$metadata), additions);
    }
};

});

parcelRegister("ig6km", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fFRwz", function(module, exports) {
"use strict";
var $b694342f590c9e15$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $aJqAw = parcelRequire("aJqAw");

var $cyM0i = parcelRequire("cyM0i");

var $i0Ijk = parcelRequire("i0Ijk");

var $1Y0sQ = parcelRequire("1Y0sQ");

var $hpdMt = parcelRequire("hpdMt");
const $b694342f590c9e15$var$CACHE_LIMIT = 10;
class $b694342f590c9e15$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $b694342f590c9e15$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $i0Ijk._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $i0Ijk._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $b694342f590c9e15$var$_makeDataAdapterResult("Bootstrap", data, null, normalized));
    }
    _getDataAsyncImpl(current, user, options) {
        return $b694342f590c9e15$var$__awaiter(this, void 0, void 0, function*() {
            if (!$1Y0sQ.Storage.isReady()) yield $1Y0sQ.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $aJqAw.Log.debug("Fetching latest value timed out");
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $b694342f590c9e15$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $i0Ijk._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: "Prefetch"
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        var _a;
        return $b694342f590c9e15$var$__awaiter(this, void 0, void 0, function*() {
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $aJqAw.Log.debug("No response returned for latest value");
                return null;
            }
            const response = (0, $hpdMt._typedJsonParse)(latest, "has_updates", "Response");
            const sdkKey = this._getSdkKey();
            const stableID = $cyM0i.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $b694342f590c9e15$var$_makeDataAdapterResult("Network", latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $b694342f590c9e15$var$_makeDataAdapterResult("NetworkNotModified", cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $aJqAw.Log.error(`${this._adapterName} is not attached to a Client`);
        return "";
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $1Y0sQ.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($1Y0sQ.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $hpdMt._typedJsonParse)(cache, "source", "Cached Result");
        return result ? Object.assign(Object.assign({}, result), {
            source: "Cache"
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $1Y0sQ.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $1Y0sQ._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $b694342f590c9e15$var$_getEvictableKey(lastModifiedTimeMap, $b694342f590c9e15$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $1Y0sQ.Storage.removeItem(evictable);
        }
        (0, $1Y0sQ._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $b694342f590c9e15$var$DataAdapterCore;
function $b694342f590c9e15$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $i0Ijk._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $b694342f590c9e15$var$_makeDataAdapterResult;
class $b694342f590c9e15$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $aJqAw.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $b694342f590c9e15$var$_getEvictableKey(this._data, $b694342f590c9e15$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $b694342f590c9e15$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === "object" && typeof current === "object") return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("cyM0i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $hgBBj = parcelRequire("hgBBj");

var $aJqAw = parcelRequire("aJqAw");

var $f87Bk = parcelRequire("f87Bk");

var $1Y0sQ = parcelRequire("1Y0sQ");

var $elNQX = parcelRequire("elNQX");
const $025c18590c6ad1c0$var$PROMISE_MAP = {};
const $025c18590c6ad1c0$var$COOKIE_ENABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($025c18590c6ad1c0$var$PROMISE_MAP[sdkKey] != null) return $025c18590c6ad1c0$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $025c18590c6ad1c0$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $025c18590c6ad1c0$var$PROMISE_MAP[sdkKey] = stableID;
            $025c18590c6ad1c0$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $025c18590c6ad1c0$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $elNQX.getUUID)();
        $025c18590c6ad1c0$var$_persistToStorage(stableID, sdkKey);
        $025c18590c6ad1c0$var$_persistToCookie(stableID, sdkKey);
        $025c18590c6ad1c0$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $025c18590c6ad1c0$var$PROMISE_MAP[sdkKey] = override;
        $025c18590c6ad1c0$var$_persistToStorage(override, sdkKey);
        $025c18590c6ad1c0$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $025c18590c6ad1c0$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    }
};
function $025c18590c6ad1c0$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $hgBBj._getStorageKey)(sdkKey)}`;
}
function $025c18590c6ad1c0$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $025c18590c6ad1c0$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $1Y0sQ._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $aJqAw.Log.warn("Failed to save StableID to storage");
    }
}
function $025c18590c6ad1c0$var$_loadFromStorage(sdkKey) {
    const storageKey = $025c18590c6ad1c0$var$_getStableIDStorageKey(sdkKey);
    return (0, $1Y0sQ._getObjectFromStorage)(storageKey);
}
function $025c18590c6ad1c0$var$_loadFromCookie(sdkKey) {
    if (!$025c18590c6ad1c0$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $f87Bk._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(";");
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split("=");
        if (key === $025c18590c6ad1c0$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $025c18590c6ad1c0$var$_persistToCookie(stableID, sdkKey) {
    if (!$025c18590c6ad1c0$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$025c18590c6ad1c0$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $025c18590c6ad1c0$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $hgBBj._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("elNQX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $a729b2a1ca571392$var$getUUID() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
    const y = "89ab"[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $a729b2a1ca571392$var$getUUID;

});


parcelRegister("i0Ijk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $c7j2m = parcelRequire("c7j2m");

var $aJqAw = parcelRequire("aJqAw");
function $d1ca9940db31dd85$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $aJqAw.Log.error("Failed to JSON.stringify user");
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $d1ca9940db31dd85$var$_normalizeUser;
function $d1ca9940db31dd85$var$_getFullUserHash(user) {
    return user ? (0, $c7j2m._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $d1ca9940db31dd85$var$_getFullUserHash;

});

parcelRegister("hpdMt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $aJqAw = parcelRequire("aJqAw");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $cabf7614283886ac$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === "object" && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $aJqAw.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $cabf7614283886ac$var$_typedJsonParse;

});


parcelRegister("1uA6T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("90xfN", function(module, exports) {
"use strict";
var $68ede8a43d4e9f9a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $aJqAw = parcelRequire("aJqAw");

var $eSDjJ = parcelRequire("eSDjJ");

var $72E2N = parcelRequire("72E2N");
module.exports.EXCEPTION_ENDPOINT = "https://statsigapi.net/v1/sdk_exception";
const $68ede8a43d4e9f9a$var$UNKNOWN_ERROR = "[Statsig] UnknownError";
class $68ede8a43d4e9f9a$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $68ede8a43d4e9f9a$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ("$EB" in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError("eb:wrap", err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $68ede8a43d4e9f9a$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $aJqAw.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$68ede8a43d4e9f9a$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($68ede8a43d4e9f9a$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : "No Name";
                    const resolvedError = $68ede8a43d4e9f9a$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: "error",
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $eSDjJ.SDKType._get(this._sdkKey);
                    const statsigMetadata = $72E2N.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $68ede8a43d4e9f9a$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $68ede8a43d4e9f9a$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: "POST",
                        headers: {
                            "STATSIG-API-KEY": this._sdkKey,
                            "STATSIG-SDK-TYPE": String(sdkType),
                            "STATSIG-SDK-VERSION": String(statsigMetadata.sdkVersion),
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: "error",
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $68ede8a43d4e9f9a$var$ErrorBoundary;
function $68ede8a43d4e9f9a$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === "string") return new Error(error);
    else return new Error("An unknown error occurred.");
}
function $68ede8a43d4e9f9a$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $68ede8a43d4e9f9a$var$UNKNOWN_ERROR;
    }
}
function $68ede8a43d4e9f9a$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === "function").forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $68ede8a43d4e9f9a$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case "number":
            case "bigint":
            case "boolean":
                loggingCopy[String(option)] = value;
                break;
            case "string":
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = "set";
                break;
            case "object":
                if (option === "environment") loggingCopy["environment"] = value;
                else if (option === "networkConfig") loggingCopy["networkConfig"] = value;
                else loggingCopy[String(option)] = value != null ? "set" : "unset";
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("eSDjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $ad549b702f98e4fb$var$SDK_CLIENT = {};
let $ad549b702f98e4fb$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $ad549b702f98e4fb$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : "js-mono") + ($ad549b702f98e4fb$var$suffix !== null && $ad549b702f98e4fb$var$suffix !== void 0 ? $ad549b702f98e4fb$var$suffix : "");
    },
    _setClientType (sdkKey, client) {
        $ad549b702f98e4fb$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$ad549b702f98e4fb$var$suffix || $ad549b702f98e4fb$var$suffix === "-react") $ad549b702f98e4fb$var$suffix = "-" + binding;
    }
};

});


parcelRegister("3izdo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iS0Os", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gXsA7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bMivU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: "g",
    _dynamicConfig: "c",
    _experiment: "e",
    _layer: "l",
    _paramStore: "p"
};
const $893289d933952143$var$EXIST_KEYS = new Set([]);
const $893289d933952143$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    "userPersistedValues"
]);
function $893289d933952143$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($893289d933952143$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($893289d933952143$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $893289d933952143$var$createMemoKey;

});

parcelRegister("2juun", function(module, exports) {
"use strict";
var $1af5019a825c5b76$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $1TJvm = parcelRequire("1TJvm");

var $1TJvm = parcelRequire("1TJvm");

var $9vgpJ = parcelRequire("9vgpJ");

var $aJqAw = parcelRequire("aJqAw");

var $7JCXg = parcelRequire("7JCXg");

var $ekhnC = parcelRequire("ekhnC");

var $cJJ9J = parcelRequire("cJJ9J");

var $eSDjJ = parcelRequire("eSDjJ");

var $f87Bk = parcelRequire("f87Bk");

var $df3hs = parcelRequire("df3hs");

var $cyM0i = parcelRequire("cyM0i");

var $20vLv = parcelRequire("20vLv");

var $72E2N = parcelRequire("72E2N");

var $gjSL0 = parcelRequire("gjSL0");
const $1af5019a825c5b76$var$DEFAULT_TIMEOUT_MS = 10000;
const $1af5019a825c5b76$var$BACKOFF_BASE_MS = 500;
const $1af5019a825c5b76$var$BACKOFF_MAX_MS = 30000;
const $1af5019a825c5b76$var$RATE_LIMIT_WINDOW_MS = 1000;
const $1af5019a825c5b76$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $1af5019a825c5b76$var$LEAK_RATE = $1af5019a825c5b76$var$RATE_LIMIT_MAX_REQ_COUNT / $1af5019a825c5b76$var$RATE_LIMIT_WINDOW_MS;
const $1af5019a825c5b76$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $1af5019a825c5b76$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $1af5019a825c5b76$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $ekhnC.NetworkFallbackResolver(this._options);
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function";
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
            if (!$1af5019a825c5b76$var$_ensureValidSdkKey(args)) return false;
            const argsInternal = this._getInternalRequestArgs("POST", args);
            yield this._tryToCompressBody(argsInternal);
            const url = yield this._getPopulatedURL(argsInternal);
            const nav = navigator;
            return nav.sendBeacon.bind(nav)(url, argsInternal.body);
        });
    }
    post(args) {
        return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs("POST", args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs("GET", args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        var _a, _b, _c, _d;
        return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
            if (!$1af5019a825c5b76$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $aJqAw.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== "undefined" ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = yield this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $gjSL0._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $1af5019a825c5b76$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>"No Text");
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = "NetworkError";
                    throw err;
                }
                const text = yield response.text();
                $1af5019a825c5b76$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $1af5019a825c5b76$var$_getErrorMessage(abortController, error);
                const timedOut = $1af5019a825c5b76$var$_didTimeout(abortController);
                $1af5019a825c5b76$var$_tryMarkInitEnd(args, response, currentAttempt, "", error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$1af5019a825c5b76$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: "error",
                        error: error,
                        tag: $20vLv.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $aJqAw.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $1af5019a825c5b76$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $1af5019a825c5b76$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $1af5019a825c5b76$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
            const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
            if (args.urlConfig.endpoint === $7JCXg.Endpoint._initialize || args.urlConfig.endpoint === $7JCXg.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
            const params = Object.assign({
                [$7JCXg.NetworkParam.SdkKey]: args.sdkKey,
                [$7JCXg.NetworkParam.SdkType]: $eSDjJ.SDKType._get(args.sdkKey),
                [$7JCXg.NetworkParam.SdkVersion]: $72E2N.SDK_VERSION,
                [$7JCXg.NetworkParam.Time]: String(Date.now()),
                [$7JCXg.NetworkParam.SessionID]: $df3hs.SessionID.get(args.sdkKey)
            }, args.params);
            const query = Object.keys(params).map((key)=>{
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            }).join("&");
            return `${url}${query ? `?${query}` : ""}`;
        });
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $f87Bk._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== "string" || (0, $1TJvm._getStatsigGlobalFlag)("no-encode") != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split("").reverse().join("");
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$7JCXg.NetworkParam.StatsigEncoded]: "1"
            });
        } catch (e) {
            $aJqAw.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        var _a;
        return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
            const body = args.body;
            if (typeof body !== "string" || !$1af5019a825c5b76$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream("gzip");
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($aJqAw.Log.error);
                writer.close().catch($aJqAw.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$7JCXg.NetworkParam.IsGzipped]: "1"
                });
            } catch (e) {
                $aJqAw.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ("data" in args) $1af5019a825c5b76$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $1af5019a825c5b76$var$NetworkCore;
const $1af5019a825c5b76$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $aJqAw.Log.warn("Unable to make request without an SDK key");
        return false;
    }
    return true;
};
const $1af5019a825c5b76$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $cyM0i.StableID.get(sdkKey);
    const sessionID = $df3hs.SessionID.get(sdkKey);
    const sdkType = $eSDjJ.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $72E2N.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $1af5019a825c5b76$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    if (options.disableCompression) return false;
    if ((args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null) && $cJJ9J.SDKFlags.get(args.sdkKey, "enable_log_event_compression") !== true) return false;
    if ((0, $1TJvm._getStatsigGlobalFlag)("no-compress") != null || typeof CompressionStream === "undefined" || typeof TextEncoder === "undefined") return false;
    return true;
}
function $1af5019a825c5b76$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string") return controller.signal.reason;
    if (typeof error === "string") return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return "Unknown Error";
}
function $1af5019a825c5b76$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string" && controller.signal.reason.includes("Timeout");
    return timeout || false;
}
function $1af5019a825c5b76$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $7JCXg.Endpoint._initialize) return;
    $9vgpJ.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $1af5019a825c5b76$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $7JCXg.Endpoint._initialize) return;
    $9vgpJ.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $9vgpJ.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $1af5019a825c5b76$var$_exponentialBackoff(attempt) {
    return $1af5019a825c5b76$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($1af5019a825c5b76$var$BACKOFF_BASE_MS * (attempt * attempt), $1af5019a825c5b76$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("ekhnC", function(module, exports) {
"use strict";
var $a6e06a37714d50a7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $lGf2U = parcelRequire("lGf2U");

var $c7j2m = parcelRequire("c7j2m");

var $aJqAw = parcelRequire("aJqAw");

var $1Y0sQ = parcelRequire("1Y0sQ");
const $a6e06a37714d50a7$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $a6e06a37714d50a7$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $a6e06a37714d50a7$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $a6e06a37714d50a7$var$DEFAULT_TTL_MS;
        $a6e06a37714d50a7$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $a6e06a37714d50a7$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $a6e06a37714d50a7$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        var _a, _b;
        return $a6e06a37714d50a7$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (!$a6e06a37714d50a7$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError("tryFetchUpdatedFallbackInfo", error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $a6e06a37714d50a7$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $a6e06a37714d50a7$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        var _a;
        return $a6e06a37714d50a7$var$__awaiter(this, void 0, void 0, function*() {
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $a6e06a37714d50a7$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $lGf2U._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $a6e06a37714d50a7$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + "=")) continue;
                const parts = record.split("=");
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith("/") ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $a6e06a37714d50a7$var$NetworkFallbackResolver;
function $a6e06a37714d50a7$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    return timedOut || lowerErrorMsg.includes("uncaught exception") || lowerErrorMsg.includes("failed to fetch") || lowerErrorMsg.includes("networkerror when attempting to fetch resource");
}
module.exports._isDomainFailure = $a6e06a37714d50a7$var$_isDomainFailure;
function $a6e06a37714d50a7$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $c7j2m._DJB2)(sdkKey)}`;
}
function $a6e06a37714d50a7$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $a6e06a37714d50a7$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $1Y0sQ.Storage.removeItem(hashKey);
        return;
    }
    $1Y0sQ.Storage.setItem(hashKey, JSON.stringify(info));
}
function $a6e06a37714d50a7$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $a6e06a37714d50a7$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $1Y0sQ.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $aJqAw.Log.error("Failed to parse FallbackInfo");
        return null;
    }
}
function $a6e06a37714d50a7$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("lGf2U", function(module, exports) {
"use strict";
var $fc8931065cea88e7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $fc8931065cea88e7$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $fc8931065cea88e7$var$DNS_QUERY_ENDPOINT = "https://cloudflare-dns.com/dns-query";
const $fc8931065cea88e7$var$DOMAIN_CHARS = [
    "i",
    "e",
    "d"
];
const $fc8931065cea88e7$var$MAX_START_LOOKUP = 200;
function $fc8931065cea88e7$var$_fetchTxtRecords(networkFunc) {
    return $fc8931065cea88e7$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($fc8931065cea88e7$var$DNS_QUERY_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/dns-message",
                Accept: "application/dns-message"
            },
            body: $fc8931065cea88e7$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error("Failed to fetch TXT records from DNS");
            err.name = "DnsTxtFetchError";
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $fc8931065cea88e7$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $fc8931065cea88e7$var$_fetchTxtRecords;
function $fc8931065cea88e7$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $fc8931065cea88e7$var$MAX_START_LOOKUP && String.fromCharCode(byte) === "=" && $fc8931065cea88e7$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error("Failed to parse TXT records from DNS");
        err.name = "DnsTxtParseError";
        throw err;
    }
    // decode the remaining bytes as a string
    let result = "";
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(",");
}

});


parcelRegister("cJJ9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $945cb70a7fdffe7f$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $945cb70a7fdffe7f$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $945cb70a7fdffe7f$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("df3hs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $hgBBj = parcelRequire("hgBBj");

var $aJqAw = parcelRequire("aJqAw");

var $1Y0sQ = parcelRequire("1Y0sQ");

var $elNQX = parcelRequire("elNQX");
const $9a3f388b2b7cd749$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $9a3f388b2b7cd749$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $9a3f388b2b7cd749$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($9a3f388b2b7cd749$var$PROMISE_MAP[sdkKey] == null) $9a3f388b2b7cd749$var$PROMISE_MAP[sdkKey] = $9a3f388b2b7cd749$var$_loadSession(sdkKey);
        const session = $9a3f388b2b7cd749$var$PROMISE_MAP[sdkKey];
        return $9a3f388b2b7cd749$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $9a3f388b2b7cd749$var$PROMISE_MAP[sdkKey] = $9a3f388b2b7cd749$var$_overrideSessionId(override, sdkKey);
    }
};
function $9a3f388b2b7cd749$var$_loadSession(sdkKey) {
    let data = $9a3f388b2b7cd749$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $elNQX.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $9a3f388b2b7cd749$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $9a3f388b2b7cd749$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    if ($9a3f388b2b7cd749$var$_isIdle(data) || $9a3f388b2b7cd749$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $elNQX.getUUID)();
        data.startTime = now;
    }
    data.lastUpdate = now;
    $9a3f388b2b7cd749$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    const sdkKey = session.sdkKey;
    session.idleTimeoutID = $9a3f388b2b7cd749$var$_createSessionTimeout(sdkKey, $9a3f388b2b7cd749$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $9a3f388b2b7cd749$var$_createSessionTimeout(sdkKey, $9a3f388b2b7cd749$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $9a3f388b2b7cd749$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }, duration);
}
function $9a3f388b2b7cd749$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $9a3f388b2b7cd749$var$MAX_SESSION_IDLE_TIME;
}
function $9a3f388b2b7cd749$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $9a3f388b2b7cd749$var$MAX_SESSION_AGE;
}
function $9a3f388b2b7cd749$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $hgBBj._getStorageKey)(sdkKey)}`;
}
function $9a3f388b2b7cd749$var$_persistToStorage(session, sdkKey) {
    const storageKey = $9a3f388b2b7cd749$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $1Y0sQ._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $aJqAw.Log.warn("Failed to save SessionID");
    }
}
function $9a3f388b2b7cd749$var$_loadFromStorage(sdkKey) {
    const storageKey = $9a3f388b2b7cd749$var$_getSessionIDStorageKey(sdkKey);
    return (0, $1Y0sQ._getObjectFromStorage)(storageKey);
}

});

parcelRegister("20vLv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: "NetworkError"
};

});


parcelRegister("eHhOb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ibDZT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kAAfI", function(module, exports) {
"use strict";
var $efd34a7219933b37$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $1TJvm = parcelRequire("1TJvm");

var $1TJvm = parcelRequire("1TJvm");

var $90xfN = parcelRequire("90xfN");

var $1x5ek = parcelRequire("1x5ek");

var $aJqAw = parcelRequire("aJqAw");

var $bMivU = parcelRequire("bMivU");

var $f87Bk = parcelRequire("f87Bk");

var $df3hs = parcelRequire("df3hs");

var $cyM0i = parcelRequire("cyM0i");

var $1Y0sQ = parcelRequire("1Y0sQ");
const $efd34a7219933b37$var$MAX_MEMO_CACHE_SIZE = 3000;
class $efd34a7219933b37$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a;
        this.loadingStatus = "Uninitialized";
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($aJqAw.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $1Y0sQ.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $df3hs.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $1Y0sQ.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && this.updateRuntimeOptions({
            enableCookies: options.enableCookies
        });
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $1x5ek.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $90xfN.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $1Y0sQ.Storage;
        this._primeReadyRipcord();
        $efd34a7219933b37$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingDisabled(options.disableLogging);
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $1Y0sQ.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $cyM0i.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $efd34a7219933b37$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: "pre_shutdown"
            });
            this._setStatus("Uninitialized", null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $aJqAw.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners["*"]) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: "values_updated",
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $bMivU.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $efd34a7219933b37$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $efd34a7219933b37$var$StatsigClientBase;
function $efd34a7219933b37$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $f87Bk._isServerEnv)()) return;
    const statsigGlobal = (0, $1TJvm._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $aJqAw.Log.warn("Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.");
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("9HWUG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = "statsig.cached";

});

parcelRegister("6A2Ba", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cYkgq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fVgBI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $aJqAw = parcelRequire("aJqAw");

var $jif12 = parcelRequire("jif12");
const $b9790fc30884dec5$var$DEFAULT_RULE = "default";
function $b9790fc30884dec5$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : $b9790fc30884dec5$var$DEFAULT_RULE,
        __evaluation: evaluation,
        value: value
    };
}
function $b9790fc30884dec5$var$_makeFeatureGate(name, details, evaluation) {
    return $b9790fc30884dec5$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true);
}
module.exports._makeFeatureGate = $b9790fc30884dec5$var$_makeFeatureGate;
function $b9790fc30884dec5$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $b9790fc30884dec5$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $b9790fc30884dec5$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $b9790fc30884dec5$var$_makeDynamicConfig;
function $b9790fc30884dec5$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $b9790fc30884dec5$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $b9790fc30884dec5$var$_makeExperiment;
function $b9790fc30884dec5$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $b9790fc30884dec5$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $b9790fc30884dec5$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $b9790fc30884dec5$var$_makeLayer;
function $b9790fc30884dec5$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $b9790fc30884dec5$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $b9790fc30884dec5$var$_mergeOverride;
function $b9790fc30884dec5$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $jif12._isTypeMatch)(found, fallback)) {
            $aJqAw.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $b9790fc30884dec5$var$_makeTypedGet;

});

parcelRegister("1Q38X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9D94r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $702ecacc1b02df37$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $702ecacc1b02df37$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: "No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error."
};

});


parcelRegister("lOMkS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jS1H0 = parcelRequire("jS1H0");
class $fe23c2f7fbd126a5$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = "Uninitialized";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = "Loading";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
    }
    finalize() {
        if (this._values) return;
        this._source = "NoValues";
    }
    getValues() {
        return this._rawValues ? (0, $jS1H0._typedJsonParse)(this._rawValues, "has_updates", "EvaluationStoreValues") : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $jS1H0._typedJsonParse)(result.data, "has_updates", "EvaluationResponse");
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $jS1H0.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== "Bootstrap") return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $jS1H0._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a;
        const stableID = $jS1H0.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID) {
            this._warnings.add("StableIDMismatch");
            return;
        }
        if ("user" in values) {
            const bootstrapUser = values["user"];
            if ((0, $jS1H0._getFullUserHash)(user) !== (0, $jS1H0._getFullUserHash)(bootstrapUser)) this._warnings.add("PartialUserMatch");
        }
    }
    getCurrentSourceDetails() {
        if (this._source === "Uninitialized" || this._source === "NoValues") return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === "Bootstrap" && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== "Uninitialized" && reason !== "NoValues") {
            const subreason = isUnrecognized ? "Unrecognized" : "Recognized";
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === "Bootstrap" ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $fe23c2f7fbd126a5$var$EvaluationStore;

});

parcelRegister("57TdV", function(module, exports) {
"use strict";
var $3bb8716e35f9d378$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jS1H0 = parcelRequire("jS1H0");

var $1QLj7 = parcelRequire("1QLj7");
class $3bb8716e35f9d378$var$StatsigNetwork extends $jS1H0.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $jS1H0.UrlConfiguration($jS1H0.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        var _a, _b, _c, _d, _e, _f;
        return $3bb8716e35f9d378$var$__awaiter(this, void 0, void 0, function*() {
            const cache = current ? (0, $jS1H0._typedJsonParse)(current, "has_updates", "InitializeResponse") : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : "djb2",
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : "djb2");
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: "derived_fields" in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        var _a, _b;
        return $3bb8716e35f9d378$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $1QLj7._resolveDeltasResponse)(cache, response.body);
            if (typeof result === "string") return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $3bb8716e35f9d378$var$StatsigNetwork;

});
parcelRegister("1QLj7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $jS1H0 = parcelRequire("jS1H0");
const $158f580e41d6770b$var$MAX_DELTAS_SORT_DEPTH = 2;
function $158f580e41d6770b$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $jS1H0._typedJsonParse)(deltasString, "checksum", "DeltasEvaluationResponse");
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $158f580e41d6770b$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $158f580e41d6770b$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $jS1H0._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $158f580e41d6770b$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $158f580e41d6770b$var$_resolveDeltasResponse;
function $158f580e41d6770b$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $158f580e41d6770b$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $158f580e41d6770b$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $158f580e41d6770b$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $158f580e41d6770b$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $158f580e41d6770b$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("3XUKG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $jS1H0 = parcelRequire("jS1H0");
const $2e32e78462c75b4d$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $2e32e78462c75b4d$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $2e32e78462c75b4d$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $jS1H0._isTypeMatch)(value, fallback);
}
function $2e32e78462c75b4d$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $2e32e78462c75b4d$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $2e32e78462c75b4d$var$_shouldLogExposure(options) ? undefined : $2e32e78462c75b4d$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $2e32e78462c75b4d$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $2e32e78462c75b4d$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($2e32e78462c75b4d$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($2e32e78462c75b4d$var$_shouldLogExposure(options)) client.getDynamicConfig(param.config_name);
    return value;
}
function $2e32e78462c75b4d$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $2e32e78462c75b4d$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($2e32e78462c75b4d$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($2e32e78462c75b4d$var$_shouldLogExposure(options)) client.getExperiment(param.experiment_name);
    return value;
}
function $2e32e78462c75b4d$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $2e32e78462c75b4d$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($2e32e78462c75b4d$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($2e32e78462c75b4d$var$_shouldLogExposure(options)) client.getLayer(param.layer_name).get(param.param_name);
    return value;
}
function $2e32e78462c75b4d$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $jS1H0._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case "static":
                return $2e32e78462c75b4d$var$_getMappedStaticValue(param, options);
            case "gate":
                return $2e32e78462c75b4d$var$_getMappedGateValue(client, param, options);
            case "dynamic_config":
                return $2e32e78462c75b4d$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case "experiment":
                return $2e32e78462c75b4d$var$_getMappedExperimentValue(client, param, fallback, options);
            case "layer":
                return $2e32e78462c75b4d$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $2e32e78462c75b4d$var$_makeParamStoreGetter;

});

parcelRegister("lm8vs", function(module, exports) {
"use strict";
var $f8c2403f327db5d2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $jS1H0 = parcelRequire("jS1H0");

var $57TdV = parcelRequire("57TdV");
class $f8c2403f327db5d2$var$StatsigEvaluationsDataAdapter extends $jS1H0.DataAdapterCore {
    constructor(){
        super("EvaluationsDataAdapter", "evaluations");
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $57TdV.default) this._network = network;
        else this._network = new $57TdV.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $jS1H0._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $jS1H0._typedJsonParse)(data, "has_updates", "data");
        if (values && "user" in values) super.setData(data, values.user);
        else $jS1H0.Log.error("StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.");
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        var _a;
        return $f8c2403f327db5d2$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $jS1H0._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$jS1H0.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $jS1H0._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $f8c2403f327db5d2$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("cu1O2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9169b004f895749f$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $5SA4b = parcelRequire("5SA4b");
function $9169b004f895749f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9169b004f895749f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9169b004f895749f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9169b004f895749f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9169b004f895749f$export$a66cbd9b2289cd78 = "@all-features";
var $9169b004f895749f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "eventToValue", new Map());
        this.emitter = new (0, $5SA4b.EventEmitter2)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $9169b004f895749f$var$_objectSpread($9169b004f895749f$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $9169b004f895749f$var$_objectSpread($9169b004f895749f$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $9169b004f895749f$var$_objectSpread($9169b004f895749f$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $9169b004f895749f$var$_objectSpread($9169b004f895749f$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($9169b004f895749f$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($9169b004f895749f$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($9169b004f895749f$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $9169b004f895749f$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("5SA4b", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + " listeners added. " + "Use emitter.setMaxListeners() to increase limit.";
        if (this.verboseMemoryLeak) errorMsg += " Event name: " + eventName + ".";
        if (typeof $hPtJY !== "undefined" && $hPtJY.emitWarning) {
            var e = new Error(errorMsg);
            e.name = "MaxListenersExceededWarning";
            e.emitter = this;
            e.count = count;
            $hPtJY.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === "function") {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === "*" || currentType === "**" || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === "*") {
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === "**") {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === "*";
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) {
                    if (branch === "*" || branch === "**") {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree["*"];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree["**"];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== "_listeners" && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            "**": isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree["*"] && xxTree["*"]._listeners) searchListenerTree(handlers, type, xxTree["*"], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === "string" ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === "**" && type[i + 1] === "**") return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === "function") tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = ".";
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = "";
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== "function") throw new Error("many only accepts instances of Function");
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === "function") {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === "function") {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== "function") throw new Error("onAny only accepts instances of Function");
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === "function") {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== "function") throw new Error("on only accepts instances of Function");
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit("newListener", type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === "function") // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== "function") throw new Error("removeListener only takes instances of Function");
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("1FlXM", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", () => $136aa836460b1c7b$export$6dc24881a3d96325);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $4if7L = parcelRequire("4if7L");
var $136aa836460b1c7b$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $4if7L.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("4if7L", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", () => $32049334f4adf9e6$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $32049334f4adf9e6$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $32049334f4adf9e6$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $32049334f4adf9e6$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $32049334f4adf9e6$export$18ad168d3dbac899);

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $49JF1 = parcelRequire("49JF1");

var $70zaY = parcelRequire("70zaY");

var $3G7ch = parcelRequire("3G7ch");

var $fUDja = parcelRequire("fUDja");
var $32049334f4adf9e6$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $32049334f4adf9e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32049334f4adf9e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32049334f4adf9e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32049334f4adf9e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32049334f4adf9e6$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $32049334f4adf9e6$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $70zaY.isFedRamp)() ? (0, $fUDja.PerimeterType).FEDRAMP_MODERATE : (0, $fUDja.PerimeterType).COMMERCIAL
    }, options);
};
var $32049334f4adf9e6$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $32049334f4adf9e6$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $32049334f4adf9e6$var$_objectSpread({
            stableID: (0, $49JF1.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $32049334f4adf9e6$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(options, $32049334f4adf9e6$var$_excluded);
    return $32049334f4adf9e6$var$_objectSpread($32049334f4adf9e6$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $32049334f4adf9e6$var$evaluationReasonMappings = Object.entries((0, $3G7ch.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $32049334f4adf9e6$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $32049334f4adf9e6$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $3G7ch.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("70zaY", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $51a3d1b9225c53e3$export$64d6499adf9b2e51);

var $69ShP = parcelRequire("69ShP");
function $51a3d1b9225c53e3$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $69ShP.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("69ShP", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $47bdb182392bd059$export$ce553301d55c2fd8);
var $47bdb182392bd059$export$ce553301d55c2fd8 = "fedramp-moderate";
var $47bdb182392bd059$export$f005e2e9f707cb5f = "commercial";
var $47bdb182392bd059$export$bd6b5a7802d76127 = "fedramp-fedex";
var $47bdb182392bd059$export$a739cd5aac835909 = "stg";
var $47bdb182392bd059$export$42dd0cdd351a4a9 = "prod";
var $47bdb182392bd059$export$404582bc18fe4d9e = "dev";

});


parcelRegister("3G7ch", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", () => $2adae0817e9e9054$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $2adae0817e9e9054$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("fUDja", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $b95a93c0274070b4$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $b95a93c0274070b4$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $b95a93c0274070b4$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $b95a93c0274070b4$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $b95a93c0274070b4$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("cgoqa", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $8ed9ec3005bc0ac3$export$936d0764594b6eb3);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $4if7L = parcelRequire("4if7L");
var $8ed9ec3005bc0ac3$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $4if7L.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("wC5uA", function(module, exports) {

$parcel$export(module.exports, "default", () => $062088acc5b471e6$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $fUDja = parcelRequire("fUDja");

var $95dDe = parcelRequire("95dDe");

var $i8K72 = parcelRequire("i8K72");
function $062088acc5b471e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $062088acc5b471e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $062088acc5b471e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $062088acc5b471e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $062088acc5b471e6$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $062088acc5b471e6$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $062088acc5b471e6$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $062088acc5b471e6$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $062088acc5b471e6$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $062088acc5b471e6$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $062088acc5b471e6$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $062088acc5b471e6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $i8K72.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $i8K72.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $062088acc5b471e6$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $fUDja.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $fUDja.FeatureGateEnvironment).Production:
                        return $062088acc5b471e6$export$18c93900db9358a4;
                    case (0, $fUDja.FeatureGateEnvironment).Staging:
                        return $062088acc5b471e6$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $fUDja.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $fUDja.FeatureGateEnvironment).Development:
                        return $062088acc5b471e6$export$f058dbf75c3bc647;
                    case (0, $fUDja.FeatureGateEnvironment).Staging:
                        return $062088acc5b471e6$export$942ba04389b0d5a2;
                    default:
                        return $062088acc5b471e6$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $062088acc5b471e6$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $062088acc5b471e6$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $95dDe.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("95dDe", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $69cf27a9f3c583a9$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $69cf27a9f3c583a9$export$a59f8d67326bd1cb = "5.0.0";

});

parcelRegister("i8K72", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $d34cbe5bd7e463d8$export$286baf652d0b1206);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $in7St = parcelRequire("in7St");
function $d34cbe5bd7e463d8$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $d34cbe5bd7e463d8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $d34cbe5bd7e463d8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d34cbe5bd7e463d8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d34cbe5bd7e463d8$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ResponseError);
        return $d34cbe5bd7e463d8$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($in7St)))(Error));

});
parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(t);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aAhot(t, e);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("in7St", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");

var $aAhot = parcelRequire("aAhot");

var $8NOJo = parcelRequire("8NOJo");

var $ieMd9 = parcelRequire("ieMd9");
function $d6007c48accfcb1b$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $d6007c48accfcb1b$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$8NOJo(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $ieMd9(t, arguments, $cGTaw(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $aAhot(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d6007c48accfcb1b$var$_wrapNativeSuper(t);
}
module.exports = $d6007c48accfcb1b$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8NOJo", function(module, exports) {
function $668a4079c2bb95d6$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $668a4079c2bb95d6$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ieMd9", function(module, exports) {

var $5HCVq = parcelRequire("5HCVq");

var $aAhot = parcelRequire("aAhot");
function $d46eee8acbe6979e$var$_construct(t, e, r) {
    if ($5HCVq()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $aAhot(p, r.prototype), p;
}
module.exports = $d46eee8acbe6979e$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5HCVq", function(module, exports) {
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("e7j5k", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", () => $a47086014aff2308$export$55fffef3474104af);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $49JF1 = parcelRequire("49JF1");
function $a47086014aff2308$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a47086014aff2308$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a47086014aff2308$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a47086014aff2308$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a47086014aff2308$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $a47086014aff2308$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $a47086014aff2308$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a47086014aff2308$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a47086014aff2308$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a47086014aff2308$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, NoFetchDataAdapter);
        _this = $a47086014aff2308$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $49JF1.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $a47086014aff2308$var$_objectSpread($a47086014aff2308$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $49JF1._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $a47086014aff2308$var$_objectSpread($a47086014aff2308$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $49JF1._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $49JF1._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $49JF1.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $a47086014aff2308$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $a47086014aff2308$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $49JF1.DataAdapterCore));

});
parcelRegister("dpL0o", function(module, exports) {

var $fkEbL = parcelRequire("fkEbL");
function $9c4212772a6002f0$var$_get() {
    return module.exports = $9c4212772a6002f0$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $fkEbL(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9c4212772a6002f0$var$_get.apply(null, arguments);
}
module.exports = $9c4212772a6002f0$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fkEbL", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");
function $b297e5ebd9b2c4c7$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $cGTaw(t)););
    return t;
}
module.exports = $b297e5ebd9b2c4c7$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("9UzjC", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $7374bcf3464a7aea$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $7374bcf3464a7aea$export$bcb28fbac1def494);

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $jS1H0 = parcelRequire("jS1H0");
function $7374bcf3464a7aea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7374bcf3464a7aea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7374bcf3464a7aea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7374bcf3464a7aea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7374bcf3464a7aea$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7374bcf3464a7aea$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7374bcf3464a7aea$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7374bcf3464a7aea$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7374bcf3464a7aea$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7374bcf3464a7aea$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7374bcf3464a7aea$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $7374bcf3464a7aea$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $7374bcf3464a7aea$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $7374bcf3464a7aea$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $7374bcf3464a7aea$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ":" + hash;
};
var $7374bcf3464a7aea$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, PersistentOverrideAdapter);
        this._overrides = $7374bcf3464a7aea$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $7374bcf3464a7aea$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $7374bcf3464a7aea$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $7374bcf3464a7aea$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($7374bcf3464a7aea$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($7374bcf3464a7aea$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $7374bcf3464a7aea$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $jS1H0._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, $7374bcf3464a7aea$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "gates"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "gates"));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($7374bcf3464a7aea$var$djb2MapKey(current.name, "gates"));
                if (overridden == null) return null;
                return $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current.details), {}, {
                        reason: $7374bcf3464a7aea$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "layers"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($7374bcf3464a7aea$var$djb2MapKey((0, $jS1H0._DJB2)(name), "layers"));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $7374bcf3464a7aea$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($7374bcf3464a7aea$var$djb2MapKey(current.name, "layers"));
                if (overridden == null) return null;
                return $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $jS1H0._makeTypedGet)(current.name, overridden),
                    details: $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current.details), {}, {
                        reason: $7374bcf3464a7aea$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($7374bcf3464a7aea$var$djb2MapKey(current.name, "configs"));
                if (overridden == null) return null;
                return $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $jS1H0._makeTypedGet)(current.name, overridden),
                    details: $7374bcf3464a7aea$var$_objectSpread($7374bcf3464a7aea$var$_objectSpread({}, current.details), {}, {
                        reason: $7374bcf3464a7aea$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("cHzEV", function(module, exports) {

$parcel$export(module.exports, "debug", () => $93f52950e219c08b$export$1c9f709888824e05);
var $93f52950e219c08b$var$_process, $93f52950e219c08b$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $93f52950e219c08b$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($93f52950e219c08b$var$_process = globalThis.process) === null || $93f52950e219c08b$var$_process === void 0 || ($93f52950e219c08b$var$_process = $93f52950e219c08b$var$_process.env) === null || $93f52950e219c08b$var$_process === void 0 ? void 0 : $93f52950e219c08b$var$_process.JEST_WORKER_ID) !== undefined;
var $93f52950e219c08b$var$DEBUG_MODE = !$93f52950e219c08b$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($93f52950e219c08b$var$_process2 = globalThis.process) === null || $93f52950e219c08b$var$_process2 === void 0 || ($93f52950e219c08b$var$_process2 = $93f52950e219c08b$var$_process2.env) === null || $93f52950e219c08b$var$_process2 === void 0 ? void 0 : $93f52950e219c08b$var$_process2.NODE_ENV) !== "production";
var $93f52950e219c08b$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$93f52950e219c08b$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("hxCZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc53c4b4b7ecdfb4$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $cc53c4b4b7ecdfb4$export$2e2bcd8739ae039(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}

});

parcelRegister("b4vGv", function(module, exports) {

$parcel$export(module.exports, "setUFOConfig", () => $80f8a558faaf992f$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $80f8a558faaf992f$export$44487a86467333c3);
$parcel$export(module.exports, "getInteractionRate", () => $80f8a558faaf992f$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getExperimentalInteractionRate", () => $80f8a558faaf992f$export$563f73272328c0d);
$parcel$export(module.exports, "getPostInteractionRate", () => $80f8a558faaf992f$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $80f8a558faaf992f$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $80f8a558faaf992f$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $80f8a558faaf992f$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "shouldHandleEditorLnv", () => $80f8a558faaf992f$export$808cd22f6b703d66);
var $80f8a558faaf992f$var$config;
function $80f8a558faaf992f$export$10d6139a8fb42158(newConfig) {
    $80f8a558faaf992f$var$config = newConfig;
}
function $80f8a558faaf992f$export$44487a86467333c3() {
    return $80f8a558faaf992f$var$config;
}
function $80f8a558faaf992f$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$80f8a558faaf992f$var$config) return 0;
        var _config = $80f8a558faaf992f$var$config, killswitch = _config.killswitch, rates = _config.rates, rules = _config.rules, kind = _config.kind, autoGeneratedRate = _config.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, "ig");
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith("auto-generated");
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $80f8a558faaf992f$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$80f8a558faaf992f$var$config) return 0;
        var _config2 = $80f8a558faaf992f$var$config, experimentalInteractionMetrics = _config2.experimentalInteractionMetrics;
        if (!(experimentalInteractionMetrics !== null && experimentalInteractionMetrics !== void 0 && experimentalInteractionMetrics.enabled)) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === "number") return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === "number") return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $80f8a558faaf992f$export$1d459f020c06ae34(name, interactionType) {
    try {
        if (!$80f8a558faaf992f$var$config) return 0;
        var _config3 = $80f8a558faaf992f$var$config, postInteractionLog = _config3.postInteractionLog;
        if (!(postInteractionLog !== null && postInteractionLog !== void 0 && postInteractionLog.enabled)) return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === "number") return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === "number") return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $80f8a558faaf992f$export$29b9ffb14861a1d(capability) {
    try {
        if (!$80f8a558faaf992f$var$config) return 0;
        var _config4 = $80f8a558faaf992f$var$config, capabilityRate = _config4.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused) {
        return 0;
    }
}
var $80f8a558faaf992f$var$validTypingMethods = [
    "timeout",
    "timeoutNoAlloc",
    "mutationObserver"
];
function $80f8a558faaf992f$export$7e32aae12bf9b50f() {
    var defaultMethod = "timeout";
    try {
        if (!$80f8a558faaf992f$var$config) return defaultMethod;
        var _config5 = $80f8a558faaf992f$var$config, typingMethod = _config5.typingMethod;
        if (typingMethod != null && $80f8a558faaf992f$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $80f8a558faaf992f$export$2d311b3fd18dcab1() {
    try {
        if (!$80f8a558faaf992f$var$config) return [];
        var _config6 = $80f8a558faaf992f$var$config, awaitBM3TTI = _config6.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $80f8a558faaf992f$export$e2ea675800536898() {
    try {
        if (!$80f8a558faaf992f$var$config) return false;
        var _config7 = $80f8a558faaf992f$var$config, removePageSegmentsUFOPrefixes = _config7.removePageSegmentsUFOPrefixes;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $80f8a558faaf992f$export$525ba53ca98e9db() {
    try {
        if (!$80f8a558faaf992f$var$config) return false;
        var _config8 = $80f8a558faaf992f$var$config, removeInteractionsUFOPrefixes = _config8.removeInteractionsUFOPrefixes;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $80f8a558faaf992f$export$4f4649ef27b6f5d6() {
    try {
        if (!$80f8a558faaf992f$var$config) return undefined;
        var _config9 = $80f8a558faaf992f$var$config, ufoNameOverrides = _config9.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $80f8a558faaf992f$export$3c170167645a0eff() {
    try {
        if (!$80f8a558faaf992f$var$config) return undefined;
        var _config10 = $80f8a558faaf992f$var$config, doNotAbortActivePressInteraction = _config10.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $80f8a558faaf992f$export$d6dc9444bd15f70f() {
    try {
        if (!$80f8a558faaf992f$var$config) return undefined;
        var _config11 = $80f8a558faaf992f$var$config, doNotAbortActivePressInteractionOnTransition = _config11.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
function $80f8a558faaf992f$export$808cd22f6b703d66() {
    try {
        var _config$enableEditorL, _config12;
        return (_config$enableEditorL = (_config12 = $80f8a558faaf992f$var$config) === null || _config12 === void 0 ? void 0 : _config12.enableEditorLnvHandler) !== null && _config$enableEditorL !== void 0 ? _config$enableEditorL : false;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("ayrpn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7af25711ca8768f3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $12HqF = parcelRequire("12HqF");
var $7af25711ca8768f3$export$2e2bcd8739ae039 = (0, $12HqF.default);
function $7af25711ca8768f3$export$11bcb6e9af2aca35() {
    return (0, $acw62.useContext)((0, $12HqF.default));
}

});
parcelRegister("12HqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c27aa7a20d367fb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $0c27aa7a20d367fb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);

});


parcelRegister("9Gm6H", function(module, exports) {

$parcel$export(module.exports, "DefaultInteractionID", () => $70c92f524e3dcebd$export$3109542b68df9ba1);
$parcel$export(module.exports, "default", () => $70c92f524e3dcebd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $70c92f524e3dcebd$export$37bca3107733ac1e);

var $acw62 = parcelRequire("acw62");
var $70c92f524e3dcebd$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$70c92f524e3dcebd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)($70c92f524e3dcebd$export$3109542b68df9ba1);
var $70c92f524e3dcebd$export$37bca3107733ac1e = function getInteractionId() {
    return $70c92f524e3dcebd$export$3109542b68df9ba1;
};
var $70c92f524e3dcebd$export$9f6000531b78127e = function useInteractionId() {
    return $70c92f524e3dcebd$export$3109542b68df9ba1;
};

});

parcelRegister("7QErp", function(module, exports) {

$parcel$export(module.exports, "postInteractionLog", () => $5b6cc2812d110d94$export$d8f52e8f804021e8);
$parcel$export(module.exports, "getActiveInteraction", () => $5b6cc2812d110d94$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $5b6cc2812d110d94$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $5b6cc2812d110d94$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCustomTiming", () => $5b6cc2812d110d94$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $5b6cc2812d110d94$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $5b6cc2812d110d94$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addHold", () => $5b6cc2812d110d94$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $5b6cc2812d110d94$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $5b6cc2812d110d94$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $5b6cc2812d110d94$export$2df109852219d16e);
$parcel$export(module.exports, "addProfilerTimings", () => $5b6cc2812d110d94$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $5b6cc2812d110d94$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $5b6cc2812d110d94$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $5b6cc2812d110d94$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $5b6cc2812d110d94$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $5b6cc2812d110d94$export$c4a545284f55edf2);
$parcel$export(module.exports, "addNewInteraction", () => $5b6cc2812d110d94$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addApdex", () => $5b6cc2812d110d94$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $5b6cc2812d110d94$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $5b6cc2812d110d94$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $5b6cc2812d110d94$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $5b6cc2812d110d94$export$6ce04c7ca6810a7e);

var $fOd0O = parcelRequire("fOd0O");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $fUHKi = parcelRequire("fUHKi");

var $h1Oiy = parcelRequire("h1Oiy");

var $8MSmw = parcelRequire("8MSmw");

var $hxCZS = parcelRequire("hxCZS");

var $b4vGv = parcelRequire("b4vGv");

var $9NQTG = parcelRequire("9NQTG");

var $9z7qU = parcelRequire("9z7qU");

var $7ht9N = parcelRequire("7ht9N");

var $9Gm6H = parcelRequire("9Gm6H");

var $lllYc = parcelRequire("lllYc");

var $5nWMQ = parcelRequire("5nWMQ");

var $a91DW = parcelRequire("a91DW");
function $5b6cc2812d110d94$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5b6cc2812d110d94$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5b6cc2812d110d94$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5b6cc2812d110d94$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5b6cc2812d110d94$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5b6cc2812d110d94$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5b6cc2812d110d94$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5b6cc2812d110d94$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5b6cc2812d110d94$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5b6cc2812d110d94$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $5b6cc2812d110d94$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
var $5b6cc2812d110d94$export$d8f52e8f804021e8 = new (0, $a91DW.default)();
var $5b6cc2812d110d94$var$interactionQueue = [];
var $5b6cc2812d110d94$var$segmentCache = new Map();
var $5b6cc2812d110d94$var$CLEANUP_TIMEOUT = 60000;
var $5b6cc2812d110d94$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
var $5b6cc2812d110d94$var$segmentObservers = [];
function $5b6cc2812d110d94$export$2b3954d2e8509985() {
    var interactionId = (0, $9Gm6H.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $5nWMQ.interactions).get(interactionId.current);
}
function $5b6cc2812d110d94$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $b4vGv.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
function $5b6cc2812d110d94$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join("/");
}
function $5b6cc2812d110d94$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return "segmentId" in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join("/");
}
function $5b6cc2812d110d94$var$addSegmentObserver(observer) {
    $5b6cc2812d110d94$var$segmentObservers.push(observer);
    var _iterator = $5b6cc2812d110d94$var$_createForOfIteratorHelper($5b6cc2812d110d94$var$segmentCache.values()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var segmentInfo = _step.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $5b6cc2812d110d94$var$removeSegmentObserver(observer) {
    var index = $5b6cc2812d110d94$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $5b6cc2812d110d94$var$segmentObservers.splice(index, 1);
}
function $5b6cc2812d110d94$export$cd7f480d6b8286c3(interactionId) {
    (0, $5nWMQ.interactions).delete(interactionId);
}
function $5b6cc2812d110d94$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $5b6cc2812d110d94$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== "page_load" && interaction.type !== "transition") return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $5b6cc2812d110d94$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $5b6cc2812d110d94$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, i, data[i])
        });
    });
}
function $5b6cc2812d110d94$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($5b6cc2812d110d94$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($5b6cc2812d110d94$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $5b6cc2812d110d94$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($5b6cc2812d110d94$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($5b6cc2812d110d94$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $5b6cc2812d110d94$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $5nWMQ.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($5b6cc2812d110d94$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($5b6cc2812d110d94$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $5b6cc2812d110d94$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($5b6cc2812d110d94$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($5b6cc2812d110d94$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $5b6cc2812d110d94$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $5nWMQ.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($5b6cc2812d110d94$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($5b6cc2812d110d94$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
}
function $5b6cc2812d110d94$export$9e04fe1a58571ec(moduleId, timestamp) {
    $5b6cc2812d110d94$export$c4b23cc624bd2fb("bundle_preload", moduleId, null, timestamp);
}
function $5b6cc2812d110d94$export$6f228d1fdc911d7(identifier, start, end) {
    $5b6cc2812d110d94$export$943a8b2b5d6b1809("bundle_load", identifier, null, start, end - start);
}
var $5b6cc2812d110d94$var$moduleLoadingRequests = {};
function $5b6cc2812d110d94$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : "";
    result = result.replace(/^\.\/src\/packages\//, "");
    result = result.replace(/^\.\/node_modules\//, "");
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, "");
    return result;
}
function $5b6cc2812d110d94$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $5b6cc2812d110d94$var$labelStackToString(labelStack), name, startTime);
}
function $5b6cc2812d110d94$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $5b6cc2812d110d94$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    var id = (0, $8MSmw.v4)();
    if (interaction != null) {
        var _getConfig2;
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((_getConfig2 = (0, $b4vGv.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.experimentalInteractionMetrics) !== null && _getConfig2 !== void 0 && _getConfig2.enabled && experimental) interaction.holdExpActive.set(id, $5b6cc2812d110d94$var$_objectSpread($5b6cc2812d110d94$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        if (!experimental) interaction.holdActive.set(id, $5b6cc2812d110d94$var$_objectSpread($5b6cc2812d110d94$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        $5b6cc2812d110d94$var$addHoldCriterion(id, labelStack, name, start);
        return function() {
            var end = performance.now();
            if ($5b6cc2812d110d94$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($5b6cc2812d110d94$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $5b6cc2812d110d94$var$removeHoldCriterion(id);
            var currentInteraction = (0, $5nWMQ.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            var expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push($5b6cc2812d110d94$var$_objectSpread($5b6cc2812d110d94$var$_objectSpread({}, currentHold), {}, {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push($5b6cc2812d110d94$var$_objectSpread($5b6cc2812d110d94$var$_objectSpread({}, expHold), {}, {
                        end: end
                    }));
                    interaction.holdExpActive.delete(id);
                }
            }
        };
    }
    return function() {};
}
function $5b6cc2812d110d94$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $5b6cc2812d110d94$var$addHoldCriterion(id, labelStack, name, start);
    }
    return function() {};
}
function $5b6cc2812d110d94$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $5nWMQ.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($5b6cc2812d110d94$var$_objectSpread($5b6cc2812d110d94$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $5b6cc2812d110d94$var$removeHoldCriterion(id);
        }
    }
}
function $5b6cc2812d110d94$export$2df109852219d16e(interactionId) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $5b6cc2812d110d94$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $5b6cc2812d110d94$export$9e04fe1a58571ec($5b6cc2812d110d94$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $5b6cc2812d110d94$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $5b6cc2812d110d94$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $5b6cc2812d110d94$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $5b6cc2812d110d94$var$moduleLoadingRequests[info.identifier];
            $5b6cc2812d110d94$export$6f228d1fdc911d7($5b6cc2812d110d94$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $9Gm6H.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $5b6cc2812d110d94$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $9Gm6H.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $5b6cc2812d110d94$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $5b6cc2812d110d94$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $5b6cc2812d110d94$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $5nWMQ.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
var $5b6cc2812d110d94$export$53d6f611de951a13 = function addProfilerTimings(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig3;
    if ($5b6cc2812d110d94$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($5b6cc2812d110d94$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig3 = (0, $b4vGv.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $5b6cc2812d110d94$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
};
var $5b6cc2812d110d94$var$pushToQueue = function pushToQueue(id, data) {
    $5b6cc2812d110d94$var$interactionQueue.push({
        id: id,
        data: data
    });
};
var $5b6cc2812d110d94$var$handleInteraction = $5b6cc2812d110d94$var$pushToQueue;
function $5b6cc2812d110d94$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
var $5b6cc2812d110d94$var$finishInteraction = function finishInteraction(id, data) {
    var _getConfig4, _getConfig5;
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $7ht9N.currentFeatureFlagsAccessed));
    (0, $9z7qU.clearActiveTrace)();
    $5b6cc2812d110d94$var$callCleanUpCallbacks(data);
    if ((_getConfig4 = (0, $b4vGv.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.vc) !== null && _getConfig4 !== void 0 && _getConfig4.stopVCAtInteractionFinish) data.vc = (0, $lllYc.getVCObserver)().getVCRawData();
    if (!((_getConfig5 = (0, $b4vGv.getConfig)()) !== null && _getConfig5 !== void 0 && (_getConfig5 = _getConfig5.experimentalInteractionMetrics) !== null && _getConfig5 !== void 0 && _getConfig5.enabled)) $5b6cc2812d110d94$export$cd7f480d6b8286c3(id);
    $5b6cc2812d110d94$var$PreviousInteractionLog.name = data.ufoName || "unknown";
    $5b6cc2812d110d94$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $5b6cc2812d110d94$var$handleInteraction(id, data);
    if ($5b6cc2812d110d94$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $5b6cc2812d110d94$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator2 = $5b6cc2812d110d94$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_step2.value, 2), _step2$value$ = _step2$value[1], labelStack = _step2$value$.labelStack, start = _step2$value$.start, end = _step2$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($5b6cc2812d110d94$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent("UFO_FINISH_INTERACTION", {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
};
var $5b6cc2812d110d94$export$9e614a29a1ac213e = function sinkInteractionHandler(sinkFn) {
    if ($5b6cc2812d110d94$var$handleInteraction === $5b6cc2812d110d94$var$pushToQueue) {
        $5b6cc2812d110d94$var$handleInteraction = sinkFn;
        $5b6cc2812d110d94$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $5b6cc2812d110d94$var$interactionQueue.length = 0;
    }
};
var $5b6cc2812d110d94$export$8a1ba7bef607358a = function sinkPostInteractionLogHandler(sinkFn) {
    $5b6cc2812d110d94$export$d8f52e8f804021e8.sinkHandler(sinkFn);
};
// a flag to prevent multiple submitting
var $5b6cc2812d110d94$var$activeSubmitted = false;
function $5b6cc2812d110d94$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) {
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var noMoreExpHolds = interaction.holdExpActive.size === 0;
        var postInteraction = /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee() {
                var _getConfig6, _getConfig8;
                var _getConfig7, experimentalVC90, experimentalTTAI, _yield$getExperimenta, start, end;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!((_getConfig6 = (0, $b4vGv.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.postInteractionLog) !== null && _getConfig6 !== void 0 && _getConfig6.enabled)) {
                                _context.next = 17;
                                break;
                            }
                            if (!((_getConfig7 = (0, $b4vGv.getConfig)()) !== null && _getConfig7 !== void 0 && (_getConfig7 = _getConfig7.experimentalInteractionMetrics) !== null && _getConfig7 !== void 0 && _getConfig7.enabled)) {
                                _context.next = 16;
                                break;
                            }
                            _context.next = 4;
                            return (0, $9NQTG.getExperimentalVCMetrics)(interaction);
                        case 4:
                            _context.t1 = _yield$getExperimenta = _context.sent;
                            _context.t0 = _context.t1 === null;
                            if (_context.t0) {
                                _context.next = 8;
                                break;
                            }
                            _context.t0 = _yield$getExperimenta === void 0;
                        case 8:
                            if (!_context.t0) {
                                _context.next = 12;
                                break;
                            }
                            _context.t2 = void 0;
                            _context.next = 13;
                            break;
                        case 12:
                            _context.t2 = _yield$getExperimenta["metric:experimental:vc90"];
                        case 13:
                            experimentalVC90 = _context.t2;
                            start = interaction.start, end = interaction.end;
                            experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                        case 16:
                            $5b6cc2812d110d94$export$d8f52e8f804021e8.onInteractionComplete($5b6cc2812d110d94$var$_objectSpread($5b6cc2812d110d94$var$_objectSpread({}, interaction), {}, {
                                experimentalTTAI: experimentalTTAI,
                                experimentalVC90: experimentalVC90
                            }));
                        case 17:
                            if ((_getConfig8 = (0, $b4vGv.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.experimentalInteractionMetrics) !== null && _getConfig8 !== void 0 && _getConfig8.enabled) $5b6cc2812d110d94$export$cd7f480d6b8286c3(interactionId);
                            $5b6cc2812d110d94$var$activeSubmitted = false;
                        case 19:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function postInteraction() {
                return _ref.apply(this, arguments);
            };
        }();
        if (noMoreActiveHolds) {
            if (!$5b6cc2812d110d94$var$activeSubmitted) {
                $5b6cc2812d110d94$var$finishInteraction(interactionId, interaction, endTime);
                $5b6cc2812d110d94$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                var _getConfig9;
                if ((_getConfig9 = (0, $b4vGv.getConfig)()) !== null && _getConfig9 !== void 0 && (_getConfig9 = _getConfig9.experimentalInteractionMetrics) !== null && _getConfig9 !== void 0 && _getConfig9.enabled) (0, $9NQTG.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $5b6cc2812d110d94$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $5b6cc2812d110d94$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) {
        var _getConfig10;
        $5b6cc2812d110d94$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $5b6cc2812d110d94$var$finishInteraction(interactionId, interaction);
        if ((_getConfig10 = (0, $b4vGv.getConfig)()) !== null && _getConfig10 !== void 0 && (_getConfig10 = _getConfig10.experimentalInteractionMetrics) !== null && _getConfig10 !== void 0 && _getConfig10.enabled) {
            (0, $9NQTG.onExperimentalInteractionComplete)(interactionId, interaction);
            $5b6cc2812d110d94$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $5b6cc2812d110d94$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) {
        var _getConfig11;
        $5b6cc2812d110d94$var$callCancelCallbacks(interaction);
        interaction.abortReason = "new_interaction";
        interaction.abortedByInteractionName = interactionName;
        $5b6cc2812d110d94$var$finishInteraction(interactionId, interaction);
        if ((_getConfig11 = (0, $b4vGv.getConfig)()) !== null && _getConfig11 !== void 0 && (_getConfig11 = _getConfig11.experimentalInteractionMetrics) !== null && _getConfig11 !== void 0 && _getConfig11.enabled) {
            (0, $9NQTG.onExperimentalInteractionComplete)(interactionId, interaction);
            $5b6cc2812d110d94$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $5b6cc2812d110d94$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $5nWMQ.interactions).forEach(function(interaction, interactionId) {
        var _getConfig12;
        var noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $5b6cc2812d110d94$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $5b6cc2812d110d94$var$finishInteraction(interactionId, interaction);
        if ((_getConfig12 = (0, $b4vGv.getConfig)()) !== null && _getConfig12 !== void 0 && (_getConfig12 = _getConfig12.experimentalInteractionMetrics) !== null && _getConfig12 !== void 0 && _getConfig12.enabled) {
            (0, $9NQTG.onExperimentalInteractionComplete)(interactionId, interaction);
            $5b6cc2812d110d94$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $5b6cc2812d110d94$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $5nWMQ.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $5b6cc2812d110d94$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _getConfig13;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    if ((_getConfig13 = (0, $b4vGv.getConfig)()) !== null && _getConfig13 !== void 0 && (_getConfig13 = _getConfig13.postInteractionLog) !== null && _getConfig13 !== void 0 && _getConfig13.enabled) $5b6cc2812d110d94$export$d8f52e8f804021e8.reset();
    var previousTime = startTime;
    var timeoutTime = $5b6cc2812d110d94$var$CLEANUP_TIMEOUT;
    var timerID = setTimeout(function() {
        $5b6cc2812d110d94$export$5def58af4fd46132(interactionId, "timeout");
    }, $5b6cc2812d110d94$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $5b6cc2812d110d94$export$5def58af4fd46132(interactionId, "timeout");
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $hxCZS.default)((0, $b4vGv.getCapabilityRate)("feature_flag_access"));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $5b6cc2812d110d94$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $5b6cc2812d110d94$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $7ht9N.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $7ht9N.currentFeatureFlagsAccessed).clear();
    (0, $5nWMQ.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $5b6cc2812d110d94$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $5b6cc2812d110d94$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    var awaitBM3TTIList = (0, $b4vGv.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $5b6cc2812d110d94$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === "transition") {
        var _getConfig14;
        (0, $lllYc.getVCObserver)().start({
            startTime: startTime
        });
        $5b6cc2812d110d94$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((_getConfig14 = (0, $b4vGv.getConfig)()) !== null && _getConfig14 !== void 0 && (_getConfig14 = _getConfig14.experimentalInteractionMetrics) !== null && _getConfig14 !== void 0 && _getConfig14.enabled) (0, $9NQTG.experimentalVC).start({
            startTime: startTime
        });
    }
}
function $5b6cc2812d110d94$export$4a759336b50e86e3(event) {
    var interaction = $5b6cc2812d110d94$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === "page_load" || interaction.type === "transition") && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === "PAGE_LOAD") {
            interaction.changeTimeout($5b6cc2812d110d94$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $5b6cc2812d110d94$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $5b6cc2812d110d94$export$ad216cc25852d44b(apdex) {
    (0, $5nWMQ.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($5b6cc2812d110d94$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $5b6cc2812d110d94$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $5b6cc2812d110d94$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($5b6cc2812d110d94$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $5b6cc2812d110d94$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $5b6cc2812d110d94$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($5b6cc2812d110d94$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $5b6cc2812d110d94$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === "string" && typeof obj.segmentId === "string";
}
function $5b6cc2812d110d94$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($5b6cc2812d110d94$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join("|");
}
function $5b6cc2812d110d94$export$1c43f9ac826b6462(labelStack) {
    var key = $5b6cc2812d110d94$var$getSegmentCacheKey(labelStack);
    var existingSegment = $5b6cc2812d110d94$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $5b6cc2812d110d94$var$segmentCache.set(key, segmentInfo);
        $5b6cc2812d110d94$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $5b6cc2812d110d94$export$d0365e48b58231c3(labelStack) {
    var key = $5b6cc2812d110d94$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $5b6cc2812d110d94$var$segmentCache.get(key);
    if (segmentInfo) {
        $5b6cc2812d110d94$var$segmentCache.delete(JSON.stringify(labelStack));
        $5b6cc2812d110d94$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $5b6cc2812d110d94$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $5nWMQ.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($5b6cc2812d110d94$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
var $5b6cc2812d110d94$export$6ce04c7ca6810a7e = [];
var $5b6cc2812d110d94$var$defaultLabelStack = [
    {
        name: "custom"
    }
];
function $5b6cc2812d110d94$export$5342dcad19138a1c(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $5b6cc2812d110d94$var$defaultLabelStack;
    var customSpan = {
        type: "custom",
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $5b6cc2812d110d94$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("8MSmw", function(module, exports) {

var $8Mu9Q = parcelRequire("8Mu9Q");

var $GtgEQ = parcelRequire("GtgEQ");
var $665cf99d053a9587$var$uuid = $GtgEQ;
$665cf99d053a9587$var$uuid.v1 = $8Mu9Q;
$665cf99d053a9587$var$uuid.v4 = $GtgEQ;
module.exports = $665cf99d053a9587$var$uuid;

});
parcelRegister("8Mu9Q", function(module, exports) {

var $fHCN2 = parcelRequire("fHCN2");

var $bWPL5 = parcelRequire("bWPL5");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $664a331dabbb8233$var$_nodeId;
var $664a331dabbb8233$var$_clockseq;
// Previous uuid creation time
var $664a331dabbb8233$var$_lastMSecs = 0;
var $664a331dabbb8233$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $664a331dabbb8233$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $664a331dabbb8233$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $664a331dabbb8233$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $fHCN2();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $664a331dabbb8233$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $664a331dabbb8233$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $664a331dabbb8233$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $664a331dabbb8233$var$_lastMSecs + (nsecs - $664a331dabbb8233$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $664a331dabbb8233$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $664a331dabbb8233$var$_lastMSecs = msecs;
    $664a331dabbb8233$var$_lastNSecs = nsecs;
    $664a331dabbb8233$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $bWPL5(b);
}
module.exports = $664a331dabbb8233$var$v1;

});
parcelRegister("fHCN2", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $b6e8f60da77e75b0$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($b6e8f60da77e75b0$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $b6e8f60da77e75b0$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $b6e8f60da77e75b0$var$getRandomValues($b6e8f60da77e75b0$var$rnds8);
        return $b6e8f60da77e75b0$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $b6e8f60da77e75b0$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $b6e8f60da77e75b0$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $b6e8f60da77e75b0$var$rnds;
    };
}

});

parcelRegister("bWPL5", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $8b2d42a4f7f8c657$var$byteToHex = [];
for(var $8b2d42a4f7f8c657$var$i = 0; $8b2d42a4f7f8c657$var$i < 256; ++$8b2d42a4f7f8c657$var$i)$8b2d42a4f7f8c657$var$byteToHex[$8b2d42a4f7f8c657$var$i] = ($8b2d42a4f7f8c657$var$i + 0x100).toString(16).substr(1);
function $8b2d42a4f7f8c657$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $8b2d42a4f7f8c657$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $8b2d42a4f7f8c657$var$bytesToUuid;

});


parcelRegister("GtgEQ", function(module, exports) {

var $fHCN2 = parcelRequire("fHCN2");

var $bWPL5 = parcelRequire("bWPL5");
function $07faa04f0d7b670f$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $fHCN2)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $bWPL5(rnds);
}
module.exports = $07faa04f0d7b670f$var$v4;

});


parcelRegister("9NQTG", function(module, exports) {

$parcel$export(module.exports, "sinkExperimentalHandler", () => $7231b8f2da9654b3$export$7aa99c40634ac65f);
$parcel$export(module.exports, "onExperimentalInteractionComplete", () => $7231b8f2da9654b3$export$1aed449484dedf63);
$parcel$export(module.exports, "experimentalVC", () => $7231b8f2da9654b3$export$81b28dca2587ec47);
$parcel$export(module.exports, "getExperimentalVCMetrics", () => $7231b8f2da9654b3$export$d17d2b5c5e8d732e);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $197ST = parcelRequire("197ST");

var $gXXlM = parcelRequire("gXXlM");
function $7231b8f2da9654b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7231b8f2da9654b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7231b8f2da9654b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7231b8f2da9654b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7231b8f2da9654b3$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7231b8f2da9654b3$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7231b8f2da9654b3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7231b8f2da9654b3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7231b8f2da9654b3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7231b8f2da9654b3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7231b8f2da9654b3$var$interactionBuffer = [];
var $7231b8f2da9654b3$var$bufferInteractionData = function bufferInteractionData(interactionId, data) {
    $7231b8f2da9654b3$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $7231b8f2da9654b3$var$clearInteractionBuffer() {
    $7231b8f2da9654b3$var$interactionBuffer.length = 0;
}
function $7231b8f2da9654b3$var$appendInteractionData(interactionId, data) {
    $7231b8f2da9654b3$var$bufferInteractionData(interactionId, data);
}
function $7231b8f2da9654b3$export$c8a9e17ae62a073d(handler) {
    var _iterator = $7231b8f2da9654b3$var$_createForOfIteratorHelper($7231b8f2da9654b3$var$interactionBuffer), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, _interactionId = _step$value.interactionId, data = _step$value.data;
            handler(_interactionId, data);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    $7231b8f2da9654b3$var$clearInteractionBuffer();
    $7231b8f2da9654b3$var$bufferInteractionData = handler;
}
function $7231b8f2da9654b3$export$7aa99c40634ac65f(sinkFn) {
    $7231b8f2da9654b3$export$c8a9e17ae62a073d(sinkFn);
}
function $7231b8f2da9654b3$export$1aed449484dedf63(interactionId, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (data.ufoName) {
        data.end = endTime;
        $7231b8f2da9654b3$var$appendInteractionData(interactionId, data);
        $7231b8f2da9654b3$var$clearInteractionBuffer();
    }
}
var $7231b8f2da9654b3$export$f9a59f57e0282541 = /*#__PURE__*/ function() {
    function ExperimentalVCMetrics() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ExperimentalVCMetrics);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "vcObserver", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ExperimentalVCMetrics, [
        {
            key: "initialize",
            value: function initialize(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $gXXlM.VCObserver)($7231b8f2da9654b3$var$_objectSpread($7231b8f2da9654b3$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
                return this;
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        }
    ]);
}();
var $7231b8f2da9654b3$export$81b28dca2587ec47 = new $7231b8f2da9654b3$export$f9a59f57e0282541();
var $7231b8f2da9654b3$export$d17d2b5c5e8d732e = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(interaction) {
        var _interaction$apdex, prefix, result, VC, pageVisibilityUpToTTAI;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!$7231b8f2da9654b3$export$81b28dca2587ec47.vcObserver) {
                        _context.next = 12;
                        break;
                    }
                    prefix = "ufo-experimental";
                    _context.next = 4;
                    return $7231b8f2da9654b3$export$81b28dca2587ec47.vcObserver.getVCResult({
                        start: interaction.start,
                        stop: interaction.end,
                        tti: (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime,
                        isEventAborted: !!interaction.abortReason,
                        prefix: prefix,
                        vc: interaction.vc
                    });
                case 4:
                    result = _context.sent;
                    VC = result === null || result === void 0 ? void 0 : result["metrics:vc"];
                    if (!(!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")]))) {
                        _context.next = 8;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 8:
                    pageVisibilityUpToTTAI = (0, $197ST.getPageVisibilityState)(interaction.start, interaction.end);
                    if (!(interaction.abortReason || pageVisibilityUpToTTAI !== "visible")) {
                        _context.next = 11;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 11:
                    return _context.abrupt("return", $7231b8f2da9654b3$var$_objectSpread($7231b8f2da9654b3$var$_objectSpread({}, result), {}, {
                        "metric:experimental:vc90": VC["90"]
                    }));
                case 12:
                    return _context.abrupt("return", null);
                case 13:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getExperimentalVCMetrics(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("197ST", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", () => $0d5cbf62069f5aa5$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $0d5cbf62069f5aa5$export$768b2008623433e1);

var $8fY35 = parcelRequire("8fY35");
var $0d5cbf62069f5aa5$var$timings = [];
var $0d5cbf62069f5aa5$var$wasHiddenFlag;
var $0d5cbf62069f5aa5$var$setupFlag = false;
function $0d5cbf62069f5aa5$var$isPageHidden() {
    if ("visibilityState" in document) return document.visibilityState === "hidden";
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $0d5cbf62069f5aa5$var$SIZE = 50;
var $0d5cbf62069f5aa5$var$insertIndex = 0;
function $0d5cbf62069f5aa5$var$pushHidden(isPageHiddenFlag, time) {
    $0d5cbf62069f5aa5$var$timings[$0d5cbf62069f5aa5$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $0d5cbf62069f5aa5$var$insertIndex = ($0d5cbf62069f5aa5$var$insertIndex + 1) % $0d5cbf62069f5aa5$var$SIZE;
    $0d5cbf62069f5aa5$var$wasHiddenFlag = isPageHiddenFlag;
}
function $0d5cbf62069f5aa5$var$handleChange() {
    var isPageHiddenFlag = $0d5cbf62069f5aa5$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$0d5cbf62069f5aa5$var$wasHiddenFlag) $0d5cbf62069f5aa5$var$pushHidden(isPageHiddenFlag);
        $0d5cbf62069f5aa5$var$wasHiddenFlag = true;
    } else {
        if ($0d5cbf62069f5aa5$var$wasHiddenFlag) $0d5cbf62069f5aa5$var$pushHidden(isPageHiddenFlag);
        $0d5cbf62069f5aa5$var$wasHiddenFlag = false;
    }
}
function $0d5cbf62069f5aa5$var$setup() {
    (0, $8fY35.bind)(window, {
        type: "pageshow",
        listener: $0d5cbf62069f5aa5$var$handleChange
    });
    (0, $8fY35.bind)(window, {
        type: "pagehide",
        listener: $0d5cbf62069f5aa5$var$handleChange
    });
    (0, $8fY35.bind)(document, {
        type: "visibilitychange",
        listener: $0d5cbf62069f5aa5$var$handleChange
    });
}
function $0d5cbf62069f5aa5$export$554cefe0f0373da4() {
    if (!$0d5cbf62069f5aa5$var$setupFlag) {
        var isPageHiddenFlag = $0d5cbf62069f5aa5$var$isPageHidden();
        $0d5cbf62069f5aa5$var$pushHidden(isPageHiddenFlag, 0);
        $0d5cbf62069f5aa5$var$setup();
        $0d5cbf62069f5aa5$var$setupFlag = true;
    }
}
function $0d5cbf62069f5aa5$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($0d5cbf62069f5aa5$var$timings.length === 0) return "visible";
    var currentSize = $0d5cbf62069f5aa5$var$timings.length;
    var hiddenState = "mixed";
    var startIdx = $0d5cbf62069f5aa5$var$insertIndex;
    var endIdx = $0d5cbf62069f5aa5$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($0d5cbf62069f5aa5$var$insertIndex + i) % currentSize;
        if ($0d5cbf62069f5aa5$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($0d5cbf62069f5aa5$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($0d5cbf62069f5aa5$var$timings[startIdx].hidden) hiddenState = "hidden";
        else hiddenState = "visible";
    }
    return hiddenState;
}

});
parcelRegister("8fY35", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $gYwVX = parcelRequire("gYwVX");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $gYwVX.bind;
    }
});

var $h6VkO = parcelRequire("h6VkO");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $h6VkO.bindAll;
    }
});

});
parcelRegister("gYwVX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $c5bbcbe38ba49ef4$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $c5bbcbe38ba49ef4$var$bind;

});

parcelRegister("h6VkO", function(module, exports) {
"use strict";
var $c74f78a9926000a3$var$__assign = module.exports && module.exports.__assign || function() {
    $c74f78a9926000a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c74f78a9926000a3$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $gYwVX = parcelRequire("gYwVX");
function $c74f78a9926000a3$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $c74f78a9926000a3$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $c74f78a9926000a3$var$__assign($c74f78a9926000a3$var$__assign({}, original), {
        options: $c74f78a9926000a3$var$__assign($c74f78a9926000a3$var$__assign({}, $c74f78a9926000a3$var$toOptions(sharedOptions)), $c74f78a9926000a3$var$toOptions(original.options))
    });
    return binding;
}
function $c74f78a9926000a3$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $c74f78a9926000a3$var$getBinding(original, sharedOptions);
        return (0, $gYwVX.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $c74f78a9926000a3$var$bindAll;

});



parcelRegister("gXXlM", function(module, exports) {

$parcel$export(module.exports, "VCObserver", () => $c5a031c1796af8e5$export$1f70d263701b1d01);

var $fUHKi = parcelRequire("fUHKi");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $h1Oiy = parcelRequire("h1Oiy");

var $ltooA = parcelRequire("ltooA");

var $197ST = parcelRequire("197ST");

var $8SB8n = parcelRequire("8SB8n");

var $cVvO2 = parcelRequire("cVvO2");

var $8Tf0K = parcelRequire("8Tf0K");

var $7KavK = parcelRequire("7KavK");

var $4iKsn = parcelRequire("4iKsn");
var $c5a031c1796af8e5$var$_excluded = [
    "__debug__element"
];
function $c5a031c1796af8e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5a031c1796af8e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5a031c1796af8e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5a031c1796af8e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c5a031c1796af8e5$var$abortReason = {
    scroll: "scroll",
    keypress: "keypress",
    resize: "resize",
    error: "error"
};
var $c5a031c1796af8e5$var$UNUSED_SECTOR = 0;
function $c5a031c1796af8e5$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(entry, $c5a031c1796af8e5$var$_excluded);
                return rest;
            })
        ];
    }));
}
var $c5a031c1796af8e5$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "abortReason", {
            reason: null,
            info: "",
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "outOfBoundaryInfo", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "multiHeatmap", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "vcRatios", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbind", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== "" ? " ".concat(_this.abortReason.info) : "";
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $c5a031c1796af8e5$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                multiHeatmap: _this.multiHeatmap,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $c5a031c1796af8e5$var$_objectSpread({}, _this.componentsLog),
                viewport: $c5a031c1796af8e5$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getVCResult", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(_ref3) {
                var start, stop, tti, prefix, ssr, vc, isEventAborted, startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, multiHeatmap, _VCObserver$calculate, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, isVCClean, isMultiHeatmapEnabled, pageVisibilityUpToTTAI, isVisiblePageVisibleUpToTTAI, shouldHaveVCmetric, revisionsData, isCalcSpeedIndexEnabled, speedIndex;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc, isEventAborted = _ref3.isEventAborted;
                            startTime = performance.now(); // add local measurement
                            fullPrefix = prefix !== undefined && prefix !== "" ? "".concat(prefix, ":") : "";
                            rawData = vc !== undefined ? vc : _this.getVCRawData();
                            if (!(rawData === null)) {
                                _context.next = 6;
                                break;
                            }
                            return _context.abrupt("return", {});
                        case 6:
                            abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios, multiHeatmap = rawData.multiHeatmap;
                            if (!(abortReasonInfo !== null && abortReason.blocking)) {
                                _context.next = 10;
                                break;
                            }
                            // exposing data to devtools
                            try {
                                if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                            } catch (e) {}
                            return _context.abrupt("return", (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, "".concat(fullPrefix, "vc:state"), false), "".concat(fullPrefix, "vc:abort:reason"), abortReasonInfo), "".concat(fullPrefix, "vc:abort:timestamp"), abortReason.timestamp));
                        case 10:
                            _VCObserver$calculate = VCObserver.calculateVC({
                                heatmap: heatmap,
                                ssr: ssr,
                                componentsLog: $c5a031c1796af8e5$var$_objectSpread({}, componentsLog),
                                viewport: viewport
                            }), VC = _VCObserver$calculate.VC, VCBox = _VCObserver$calculate.VCBox, VCEntries = _VCObserver$calculate.VCEntries, totalPainted = _VCObserver$calculate.totalPainted;
                            try {
                                if (!_this.isPostInteraction) VCObserver.VCParts.forEach(function(key) {
                                    var duration = VC[key];
                                    if (duration !== null && duration !== undefined) performance.measure("VC".concat(key), {
                                        start: start,
                                        duration: duration
                                    });
                                });
                            } catch (e) {
                            /* empty */ }
                            _componentsLog = {}; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                            if ((0, $ltooA.fg)("ufo-remove-vc-component-observations-after-ttai")) Object.entries(_this.componentsLog).forEach(function(_ref6) {
                                var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref6, 2), _timestamp = _ref7[0], value = _ref7[1];
                                var timestamp = Number(_timestamp);
                                if (stop > timestamp) _componentsLog[timestamp] = value;
                            });
                            else _componentsLog = $c5a031c1796af8e5$var$_objectSpread({}, componentsLog);
                            vcNext = VCObserver.calculateVC({
                                heatmap: heatmapNext,
                                ssr: ssr,
                                componentsLog: _componentsLog,
                                viewport: viewport
                            });
                            try {
                                if (!_this.isPostInteraction) VCObserver.VCParts.forEach(function(key) {
                                    var duration = vcNext.VC[key];
                                    if (duration !== null && duration !== undefined) performance.measure("VC_Next".concat(key), {
                                        start: start,
                                        duration: duration
                                    });
                                });
                            } catch (e) {
                            /* empty */ }
                            outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {}; //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                            stopTime = performance.now(); // exposing data to devtools
                            try {
                                if (!_this.isPostInteraction && devToolsEnabled) {
                                    window.__vc = {
                                        entries: VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            "75": VC["75"],
                                            "80": VC["80"],
                                            "85": VC["85"],
                                            "90": VC["90"],
                                            "95": VC["95"],
                                            "98": VC["98"],
                                            "99": VC["99"],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmap,
                                        ratios: ratios
                                    };
                                    window.__vcNext = {
                                        entries: vcNext.VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            "75": vcNext.VC["75"],
                                            "80": vcNext.VC["80"],
                                            "85": vcNext.VC["85"],
                                            "90": vcNext.VC["90"],
                                            "95": vcNext.VC["95"],
                                            "98": vcNext.VC["98"],
                                            "99": vcNext.VC["99"],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmapNext,
                                        ratios: ratios
                                    };
                                    // Emitting a custom event to make it available in the Chrome extension
                                    window.dispatchEvent(new CustomEvent("vcReady", {
                                        detail: {
                                            log: $c5a031c1796af8e5$var$filterComponentsLog(componentsLog),
                                            entries: VCEntries.rel
                                        }
                                    }));
                                }
                            } catch (e) {
                            /*  do nothing */ }
                            isVCClean = !abortReasonInfo;
                            isMultiHeatmapEnabled = !(0, $ltooA.fg)("platform_ufo_multiheatmap_killswitch");
                            pageVisibilityUpToTTAI = (0, $197ST.getPageVisibilityState)(start, stop);
                            isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === "visible";
                            shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
                            revisionsData = isMultiHeatmapEnabled ? (0, $ltooA.fg)("platform_ufo_vc_observer_new") ? (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, "".concat(fullPrefix, "vc:rev"), [
                                {
                                    revision: "fy25.01",
                                    clean: isVCClean,
                                    "metric:vc90": shouldHaveVCmetric ? VC["90"] : null,
                                    vcDetails: shouldHaveVCmetric ? Object.fromEntries(VCObserver.VCParts.map(function(key) {
                                        var _VCBox$key;
                                        return [
                                            key,
                                            {
                                                t: VC[key],
                                                e: (_VCBox$key = VCBox[key]) !== null && _VCBox$key !== void 0 ? _VCBox$key : []
                                            }
                                        ];
                                    })) : []
                                },
                                {
                                    revision: "fy25.02",
                                    clean: isVCClean,
                                    "metric:vc90": shouldHaveVCmetric ? VC["90"] : null,
                                    vcDetails: shouldHaveVCmetric ? Object.fromEntries(VCObserver.VCParts.map(function(key) {
                                        var _vcNext$VCBox$key;
                                        return [
                                            key,
                                            {
                                                t: vcNext.VC[key],
                                                e: (_vcNext$VCBox$key = vcNext.VCBox[key]) !== null && _vcNext$VCBox$key !== void 0 ? _vcNext$VCBox$key : []
                                            }
                                        ];
                                    })) : []
                                }
                            ]) : multiHeatmap !== null ? (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, "".concat(fullPrefix, "vc:rev"), multiHeatmap === null || multiHeatmap === void 0 ? void 0 : multiHeatmap.getPayloadShapedData({
                                VCParts: VCObserver.VCParts.map(function(v) {
                                    return parseInt(v);
                                }),
                                VCCalculationMethods: (0, $4iKsn.getRevisions)().map(function(_ref10) {
                                    var classifier = _ref10.classifier;
                                    return classifier.VCCalculationMethod;
                                }),
                                filterComponentsLog: (0, $4iKsn.getRevisions)().map(function(_ref11) {
                                    var classifier = _ref11.classifier;
                                    return classifier.filterComponentsLog;
                                }),
                                isEventAborted: isEventAborted,
                                interactionStart: start,
                                ttai: stop,
                                ssr: ssr,
                                clean: isVCClean
                            })) : null : null; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                            isCalcSpeedIndexEnabled = (0, $ltooA.fg)("ufo-calc-speed-index");
                            speedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, "ufo:speedIndex", VCEntries.speedIndex), "ufo:next:speedIndex", vcNext.VCEntries.speedIndex);
                            return _context.abrupt("return", $c5a031c1796af8e5$var$_objectSpread($c5a031c1796af8e5$var$_objectSpread($c5a031c1796af8e5$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
                                "metrics:vc": VC
                            }, "".concat(fullPrefix, "vc:state"), true), "".concat(fullPrefix, "vc:clean"), isVCClean), "".concat(fullPrefix, "vc:dom"), VCBox), "".concat(fullPrefix, "vc:updates"), VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:total"), totalPainted), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, "".concat(fullPrefix, "vc:next"), vcNext.VC), "".concat(fullPrefix, "vc:next:updates"), vcNext.VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), isCalcSpeedIndexEnabled ? speedIndex : {}));
                        case 28:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason) {
            _this.measureStart();
            _this.legacyHandleUpdate(rawTime, intersectionRect, targetName, element, type, ignoreReason);
            if (!(0, $ltooA.fg)("platform_ufo_vc_observer_new")) _this.onViewportChangeDetected({
                timestamp: rawTime,
                intersectionRect: intersectionRect,
                targetName: targetName,
                element: element,
                type: type,
                ignoreReason: ignoreReason
            });
            _this.measureStop();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "legacyHandleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                if ((!ignoreReason || ignoreReason === "not-visible") && type !== "attr") _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "onViewportChangeDetected", function(_ref13) {
            var element = _ref13.element, type = _ref13.type, ignoreReason = _ref13.ignoreReason, timestamp = _ref13.timestamp, targetName = _ref13.targetName, intersectionRect = _ref13.intersectionRect;
            if (_this.multiHeatmap === null) return;
            // @todo add abort reason handling
            var time = Math.round(timestamp - _this.startTime);
            var revisions = (0, $4iKsn.getRevisions)();
            var revisionsClassification = revisions.map(function(revision) {
                return revision.classifier.classifyUpdate({
                    element: element,
                    type: type,
                    ignoreReason: ignoreReason
                });
            }, []);
            _this.multiHeatmap.handleUpdate({
                time: time,
                targetName: targetName,
                intersectionRect: intersectionRect,
                type: type,
                element: element,
                classification: revisionsClassification,
                onError: function onError(error) {
                    _this.setAbortReason($c5a031c1796af8e5$var$abortReason.error, error.time, error.error);
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === "") {
                var outOfBoundaryInfo = "";
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case "wheel":
                    _this.setAbortReason($c5a031c1796af8e5$var$abortReason.scroll, time);
                    break;
                case "keydown":
                    _this.setAbortReason($c5a031c1796af8e5$var$abortReason.keypress, time);
                    break;
                case "resize":
                    _this.setAbortReason($c5a031c1796af8e5$var$abortReason.resize, time);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "attachAbortListeners", function() {
            var _window;
            _this.detachAbortListeners();
            var unbinds = (0, $8SB8n.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                var _window2;
                Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref14) {
                    var _ref15 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref14, 2), key = _ref15[0], time = _ref15[1];
                    if (time) _this.abortReasonCallback(key, time);
                });
                unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                (_window2 = window) === null || _window2 === void 0 || delete _window2.__SSR_ABORT_LISTENERS__;
            }
            _this.unbind = unbinds;
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $7KavK.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.multiHeatmap = new (0, $8Tf0K.MultiRevisionHeatmap)({
            viewport: this.viewport,
            revisions: (0, $4iKsn.getRevisions)(),
            devToolsEnabled: this.devToolsEnabled
        });
        this.isPostInteraction = options.isPostInteraction || false;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref16) {
                var startTime = _ref16.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason("not-supported", startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref17) {
                    var ignoreReason = _ref17.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref18) {
                    var targetName = _ref18.targetName, ignoreReason = _ref18.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $c5a031c1796af8e5$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: "",
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.multiHeatmap = new (0, $8Tf0K.MultiRevisionHeatmap)({
                    viewport: this.viewport,
                    revisions: (0, $4iKsn.getRevisions)(),
                    devToolsEnabled: this.devToolsEnabled
                });
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill("").map(function() {
                    return Array(_this2.arraySize).fill($c5a031c1796af8e5$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $cVvO2.getViewportWidth)();
                this.viewport.h = (0, $cVvO2.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($c5a031c1796af8e5$var$abortReason.error, time, "index - ".concat(row));
                        } catch (e) {
                            this.setAbortReason($c5a031c1796af8e5$var$abortReason.error, time, "row error");
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                this.unbind.forEach(function(fn) {
                    return fn();
                });
                this.unbind = [];
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "calculateVC",
            value: function calculateVC(_ref19) {
                var heatmap = _ref19.heatmap, _ref19$ssr = _ref19.ssr, ssr = _ref19$ssr === void 0 ? $c5a031c1796af8e5$var$UNUSED_SECTOR : _ref19$ssr, componentsLog = _ref19.componentsLog, viewport = _ref19.viewport;
                var lastUpdate = {};
                var totalPainted = 0;
                if (ssr !== $c5a031c1796af8e5$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: "SSR"
                    };
                    if (!componentsLog[ssr]) componentsLog[ssr] = [];
                    componentsLog[ssr].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $c5a031c1796af8e5$var$UNUSED_SECTOR && ssr !== $c5a031c1796af8e5$var$UNUSED_SECTOR ? ssr : entry);
                        totalPainted += rounded !== $c5a031c1796af8e5$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $c5a031c1796af8e5$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                var isCalcSpeedIndexEnabled = (0, $ltooA.fg)("ufo-calc-speed-index");
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var currRatio = v[1] / totalPainted;
                    var VCRatio = currRatio + acc;
                    if ((0, $ltooA.fg)("platform_ufo_fix_vc_observer_rounding_error")) {
                        var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                        var preciseAccRatio = Math.round(acc * 100);
                        VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    }
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.map(function(v) {
                                return v.targetName;
                            })));
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, _ref20, i) {
                    var _acc$abs, _componentsLog$timest, _acc$rel$vc, _acc$rel;
                    var _ref21 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref20, 2), timestamp = _ref21[0], entryPainted = _ref21[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.map(function(v) {
                        return v.targetName;
                    })));
                    var ratioDelta = (currentlyPaintedRatio - ((_acc$rel$vc = (_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) !== null && _acc$rel$vc !== void 0 ? _acc$rel$vc : 0)) / 100;
                    if (isCalcSpeedIndexEnabled) {
                        var speedIndex = timestamp * ratioDelta;
                        acc.speedIndex += speedIndex;
                    }
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: [],
                    speedIndex: 0
                });
                VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
}();
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($c5a031c1796af8e5$export$1f70d263701b1d01, "VCParts", [
    "25",
    "50",
    "75",
    "80",
    "85",
    "90",
    "95",
    "98",
    "99"
]);

});
parcelRegister("8SB8n", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", () => $67702befe98bb572$export$9010aa71841a6887);

var $8fY35 = parcelRequire("8fY35");

var $33W3L = parcelRequire("33W3L");

var $cVvO2 = parcelRequire("cVvO2");
var $67702befe98bb572$export$9010aa71841a6887 = function attachAbortListeners(window, initialViewPort, callback) {
    var unbindWheel = (0, $8fY35.bind)(window, {
        type: (0, $33W3L.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $33W3L.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $8fY35.bind)(window, {
        type: (0, $33W3L.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $33W3L.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $8fY35.bind)(window, {
        type: (0, $33W3L.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $cVvO2.getViewportWidth)() !== initialViewPort.w || (0, $cVvO2.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $33W3L.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
};

});
parcelRegister("33W3L", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", () => $23aeb061cd6d7022$export$199edc0307b5587f);
var $23aeb061cd6d7022$export$199edc0307b5587f = {
    wheel: "wheel",
    keydown: "keydown",
    resize: "resize"
};

});

parcelRegister("cVvO2", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", () => $96937aea77051446$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $96937aea77051446$export$4f01c15d21ef9cc6);
function $96937aea77051446$export$a497a1dcb4408212() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $96937aea77051446$export$4f01c15d21ef9cc6() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("8Tf0K", function(module, exports) {

$parcel$export(module.exports, "MultiRevisionHeatmap", () => $678f1aae2f2e6dd6$export$40923620784ea2c1);

var $02Ztr = parcelRequire("02Ztr");

var $j1hp1 = parcelRequire("j1hp1");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $197ST = parcelRequire("197ST");
var $678f1aae2f2e6dd6$var$UNUSED_SECTOR = 0;
var $678f1aae2f2e6dd6$export$40923620784ea2c1 = /*#__PURE__*/ function() {
    function MultiRevisionHeatmap(_ref) {
        var _this = this;
        var viewport = _ref.viewport, revisions = _ref.revisions, arraySize = _ref.arraySize, devToolsEnabled = _ref.devToolsEnabled;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, MultiRevisionHeatmap);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "arraySize", {
            w: 200,
            h: 200
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize.w);
            var t = Math.floor(top / h * _this.arraySize.h);
            var r = Math.ceil((left + width) / w * _this.arraySize.w);
            var b = Math.ceil((top + height) / h * _this.arraySize.h);
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize.w, r),
                b: Math.min(_this.arraySize.h, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize.w * _this.arraySize.h);
        });
        this.viewport = viewport;
        this.revisions = revisions;
        if (arraySize) this.arraySize = arraySize;
        this.heatmaps = new Array(revisions.length);
        this.componentsLogs = new Array(revisions.length);
        this.vcRatios = new Array(revisions.length);
        this.devToolsEnabled = devToolsEnabled || false;
        revisions.forEach(function(_ref2, i) {
            (0, (/*@__PURE__*/$parcel$interopDefault($j1hp1)))(_ref2);
            _this.heatmaps[i] = _this.getCleanHeatmap();
            _this.componentsLogs[i] = {};
            _this.vcRatios[i] = {};
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(MultiRevisionHeatmap, [
        {
            key: "handleUpdate",
            value: function handleUpdate(_ref3) {
                var _this2 = this;
                var time = _ref3.time, type = _ref3.type, classification = _ref3.classification, intersectionRect = _ref3.intersectionRect, element = _ref3.element, targetName = _ref3.targetName, ignoreReason = _ref3.ignoreReason, onError = _ref3.onError;
                var mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                var result = this.applyChangesToHeatMap(mappedValues, time, classification);
                if (result !== true) onError(result);
                var componentRatio = this.getElementRatio(mappedValues);
                this.revisions.forEach(function(_, i) {
                    if (classification[i]) _this2.vcRatios[i][targetName] = componentRatio;
                    if (!_this2.componentsLogs[i][time]) _this2.componentsLogs[i][time] = [];
                    _this2.componentsLogs[i][time].push({
                        __debug__element: _this2.devToolsEnabled ? new WeakRef(element) : null,
                        intersectionRect: intersectionRect,
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    });
                });
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    heatmaps: this.heatmaps
                };
            }
        },
        {
            key: "getPayloadShapedData",
            value: function getPayloadShapedData(args) {
                var pageVisibilityUpToTTAI = (0, $197ST.getPageVisibilityState)(args.interactionStart, args.ttai);
                var result = this.processData(args);
                var payload = this.revisions.map(function(rev, i) {
                    var _vcDetails$;
                    var vcDetails = {};
                    args.VCParts.forEach(function(VCPart) {
                        vcDetails[VCPart] = {
                            t: result[i].VC[VCPart] || 0,
                            e: Array.from(result[i].VCBox[VCPart] || [])
                        };
                    });
                    return {
                        revision: rev.name,
                        vcDetails: vcDetails,
                        clean: args.clean,
                        "metric:vc90": args.clean && !args.isEventAborted && pageVisibilityUpToTTAI === "visible" ? vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails["90"]) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t : null
                    };
                });
                return payload;
            }
        },
        {
            key: "processData",
            value: function processData(_ref4) {
                var _this3 = this;
                var VCParts = _ref4.VCParts, VCCalculationMethods = _ref4.VCCalculationMethods, filterComponentsLog = _ref4.filterComponentsLog, ttai = _ref4.ttai, _ref4$ssr = _ref4.ssr, ssr = _ref4$ssr === void 0 ? $678f1aae2f2e6dd6$var$UNUSED_SECTOR : _ref4$ssr;
                return this.heatmaps.map(function(heatmap, i) {
                    var lastUpdate = {};
                    var totalPainted = 0;
                    var componentsLog = _this3.componentsLogs[i];
                    if (ssr !== $678f1aae2f2e6dd6$var$UNUSED_SECTOR) {
                        var _window$document;
                        var element = {
                            __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                            intersectionRect: {
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                x: 0,
                                y: 0,
                                width: _this3.viewport.w,
                                height: _this3.viewport.h,
                                toJSON: function toJSON() {
                                    return {};
                                }
                            },
                            targetName: "SSR"
                        };
                        if (!componentsLog[ssr]) componentsLog[ssr] = [];
                        componentsLog[ssr].push(element);
                    }
                    for(var _i = 0; _i < heatmap.length; _i++){
                        var rounded = Math.floor(heatmap[_i] === $678f1aae2f2e6dd6$var$UNUSED_SECTOR && ssr !== $678f1aae2f2e6dd6$var$UNUSED_SECTOR ? ssr : heatmap[_i]);
                        totalPainted += rounded !== $678f1aae2f2e6dd6$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $678f1aae2f2e6dd6$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    }
                    var entries = Object.entries(lastUpdate).map(function(a) {
                        return [
                            parseInt(a[0], 10),
                            a[1]
                        ];
                    }).sort(function(a, b) {
                        return a[0] > b[0] ? 1 : -1;
                    });
                    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
                    componentsLog = filterComponentsLog[i]({
                        componentsLog: componentsLog,
                        ttai: ttai
                    });
                    var _VCCalculationMethods = VCCalculationMethods[i]({
                        VCParts: VCParts,
                        componentsLog: componentsLog,
                        entries: entries,
                        totalPainted: totalPainted
                    }), VC = _VCCalculationMethods.VC, VCBox = _VCCalculationMethods.VCBox;
                    var VCEntries = entries.reduce(function(acc, _ref5, i) {
                        var _acc$abs, _componentsLog$timest;
                        var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref5, 2), timestamp = _ref6[0], entryPainted = _ref6[1];
                        var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                        var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                        var logEntry = (_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.map(function(v) {
                            return v.targetName;
                        });
                        acc.abs.push([
                            timestamp,
                            currentlyPainted
                        ]);
                        acc.rel.push({
                            time: timestamp,
                            vc: currentlyPaintedRatio,
                            elements: logEntry
                        });
                        return acc;
                    }, {
                        abs: [],
                        rel: []
                    });
                    return {
                        VC: VC,
                        VCBox: VCBox,
                        VCEntries: VCEntries,
                        totalPainted: totalPainted
                    };
                });
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, classification) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var size = classification.length;
                for(var row = t; row < b; row++){
                    if (this.heatmaps[0][row] === undefined) try {
                        return {
                            error: "index - ".concat(row),
                            time: time
                        };
                    } catch (e) {
                        return {
                            error: "row error",
                            time: time
                        };
                    }
                    else {
                        for(var heatmapIndex = 0; heatmapIndex < size; heatmapIndex++)if (classification[heatmapIndex]) this.heatmaps[heatmapIndex].fill(time, this.getIndex(l, row), this.getIndex(r, row));
                    }
                }
                return true;
            }
        },
        {
            key: "getIndex",
            value: function getIndex(x, y) {
                return x + this.arraySize.w * y;
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                return new Int32Array(this.arraySize.w * this.arraySize.h);
            }
        }
    ], [
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj(VCParts) {
                var vc = {};
                VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
}();

});
parcelRegister("j1hp1", function(module, exports) {
function $dd8b9c1e17bbac03$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
module.exports = $dd8b9c1e17bbac03$var$_objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7KavK", function(module, exports) {

$parcel$export(module.exports, "Observers", () => $5a34fb95669b7633$export$b65d046240060e78);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $ltooA = parcelRequire("ltooA");

var $b4vGv = parcelRequire("b4vGv");

var $dBXFJ = parcelRequire("dBXFJ");

var $7Cs6Z = parcelRequire("7Cs6Z");

var $7RvMD = parcelRequire("7RvMD");
function $5a34fb95669b7633$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5a34fb95669b7633$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5a34fb95669b7633$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5a34fb95669b7633$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5a34fb95669b7633$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $5a34fb95669b7633$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== "function") return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
function $5a34fb95669b7633$var$isInsideEditorContainer(target) {
    if (!target || typeof target.closest !== "function") return false;
    return Boolean(target.closest(".ProseMirror"));
}
var $5a34fb95669b7633$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "observedMutations", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "ssr", {
            state: $5a34fb95669b7633$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "observeElement", function(node, mutation, type, ignoreReason) {
            var _this$intersectionObs;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type
            });
        });
        this.selectorConfig = $5a34fb95669b7633$var$_objectSpread($5a34fb95669b7633$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $7RvMD.SSRPlaceholderHandlers)();
        this.editorLnvHandler = new (0, $7Cs6Z.EditorLnvHandler)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === "function" && typeof window.MutationObserver === "function";
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $5a34fb95669b7633$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: (0, $ltooA.fg)("platform-ufo-vc-observe-attributes") ? [
                        "hidden",
                        "style",
                        "src",
                        "class"
                    ] : [
                        "hidden",
                        "style",
                        "src"
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView = new Set();
                this.callbacks = new Set();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
                this.editorLnvHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $5a34fb95669b7633$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                var shouldHandleEditorLnvLocal = (0, $b4vGv.shouldHandleEditorLnv)();
                return this.isBrowserSupported() ? new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = "";
                        if (_this2.ssr.state === $5a34fb95669b7633$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $5a34fb95669b7633$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = "ssr-hydration";
                        }
                        if (_this2.ssr.state === $5a34fb95669b7633$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = "ssr-hydration";
                            else _this2.ssr.state = $5a34fb95669b7633$var$state.normal;
                        }
                        if (mutation.type === "childList") {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $dBXFJ.isContainedWithinMediaWrapper)(node)) ignoreReason = "image";
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignoreReason);
                                        });
                                        return;
                                    }
                                    if (shouldHandleEditorLnvLocal) {
                                        if (_this2.editorLnvHandler.shouldHandleAddedNode(node)) {
                                            _this2.editorLnvHandler.handleAddedNode(node).then(function(_ref) {
                                                var shouldIgnore = _ref.shouldIgnore;
                                                _this2.observeElement(node, mutation, "html", shouldIgnore ? "editor-lazy-node-view" : ignoreReason);
                                            });
                                            return;
                                        }
                                    }
                                    _this2.observeElement(node, mutation, "html", ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, "text", ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === "attributes") {
                            if (mutation.target instanceof HTMLElement) {
                                if ((0, $ltooA.fg)("platform-ufo-vc-observe-attributes")) _this2.observeElement(mutation.target, mutation, "attr", ignoreReason);
                            }
                        }
                    });
                    _this2.measureStop();
                }) : null;
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute("data-vc");
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? '[data-vc="'.concat(dataVCAttr, '"]') : "";
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : "";
                    var testId = this.selectorConfig.testId ? element.getAttribute("data-testid") || element.getAttribute("data-test-id") : "";
                    testId = testId ? "[testid=".concat(testId, "]") : "";
                    var role = this.selectorConfig.role ? element.getAttribute("role") : "";
                    role = role ? "[role=".concat(role, "]") : "";
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join(".") : "";
                    classList = classList === "" ? "" : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join("");
                    var idString = "";
                    if (attrs === "" && classList === "") {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : "unknown";
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join("");
                    return idString;
                } catch (e) {
                    return "error";
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                return this.isBrowserSupported() ? new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref2) {
                        var isIntersecting = _ref2.isIntersecting, ir = _ref2.intersectionRect, target = _ref2.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if ((0, $ltooA.fg)("platform-ufo-invisible-element-vc-calculations")) {
                                if (!$5a34fb95669b7633$var$isElementVisible(target)) data.ignoreReason = "not-visible";
                            }
                            if ((0, $ltooA.fg)("platform_editor_ed-25937_ignore_mutations_for_ttvc")) {
                                if ($5a34fb95669b7633$var$isInsideEditorContainer(target)) data.ignoreReason = "editor-container-mutation";
                            }
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (e) {
                                    elementName = "error";
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                }) : null;
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();

});
parcelRegister("dBXFJ", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $9e8d04b59d35101c$export$f61fbc3b9c4a9019);

var $j9amX = parcelRequire("j9amX");
var $9e8d04b59d35101c$export$f61fbc3b9c4a9019 = function isContainedWithinMediaWrapper(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $j9amX.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
};

});
parcelRegister("j9amX", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $df06e6b2a947ebef$export$7674290405cc25b0);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
var $df06e6b2a947ebef$export$7674290405cc25b0 = "data-media-vc-wrapper";
var $df06e6b2a947ebef$export$7028e9efe569888c = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $df06e6b2a947ebef$export$7674290405cc25b0, true);
function $df06e6b2a947ebef$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $df06e6b2a947ebef$export$7028e9efe569888c, children);
}

});


parcelRegister("7Cs6Z", function(module, exports) {

$parcel$export(module.exports, "EditorLnvHandler", () => $58c1e368b1b7b57d$export$569bcb41b9a84ec8);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
var $58c1e368b1b7b57d$var$placeholderDataKey = "editorLnvPlaceholder"; // data-editor-lnv-placeholder
var $58c1e368b1b7b57d$var$replaceDataKey = "editorLnvPlaceholderReplace"; // data-editor-lnv-placeholder-replace
var $58c1e368b1b7b57d$export$569bcb41b9a84ec8 = /*#__PURE__*/ function() {
    function EditorLnvHandler() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, EditorLnvHandler);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "placeholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "isAddedPlaceholderMatchingSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "isAddedReplaceMatchingSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "intersectionObserverCallback", function(_ref) {
            var _target$dataset, _target$dataset2;
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            _this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) return;
            var placeholderId = (_target$dataset = target.dataset) === null || _target$dataset === void 0 ? void 0 : _target$dataset[$58c1e368b1b7b57d$var$placeholderDataKey];
            if (placeholderId && _this.getSizeCallbacks.has(placeholderId)) {
                var _resolve = _this.getSizeCallbacks.get(placeholderId);
                _this.getSizeCallbacks.delete(placeholderId);
                if (!_resolve) return;
                _resolve({
                    x: boundingClientRect.x,
                    y: boundingClientRect.y,
                    width: boundingClientRect.width,
                    height: boundingClientRect.height
                });
                return;
            }
            if (placeholderId && _this.isAddedPlaceholderMatchingSizeCallbacks.has(placeholderId)) {
                var _resolve2 = _this.isAddedPlaceholderMatchingSizeCallbacks.get(placeholderId);
                _this.isAddedPlaceholderMatchingSizeCallbacks.delete(placeholderId);
                if (!_resolve2) return;
                var placeholder = _this.placeholders.get(placeholderId);
                if (!placeholder) {
                    _resolve2(false);
                    return;
                }
                _resolve2(_this.areRectsSameSize(placeholder, boundingClientRect));
                return;
            }
            var replaceId = (_target$dataset2 = target.dataset) === null || _target$dataset2 === void 0 ? void 0 : _target$dataset2[$58c1e368b1b7b57d$var$replaceDataKey];
            if (replaceId && _this.isAddedReplaceMatchingSizeCallbacks.has(replaceId)) {
                var _resolve3 = _this.isAddedReplaceMatchingSizeCallbacks.get(replaceId);
                _this.isAddedReplaceMatchingSizeCallbacks.delete(replaceId);
                if (!_resolve3) return;
                var _placeholder = _this.placeholders.get(replaceId);
                if (!_placeholder) {
                    _resolve3(false);
                    return;
                }
                _this.placeholders.delete(replaceId);
                _resolve3(_this.areRectsSameSize(_placeholder, boundingClientRect));
                return;
            }
        });
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(EditorLnvHandler, [
        {
            key: "shouldHandleAddedNode",
            value: function shouldHandleAddedNode(el) {
                var _el$dataset, _el$dataset2;
                return ((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset[$58c1e368b1b7b57d$var$placeholderDataKey]) || ((_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2[$58c1e368b1b7b57d$var$replaceDataKey]);
            }
        },
        {
            key: "handleAddedNode",
            value: function handleAddedNode(el) {
                var _el$dataset3, _el$dataset4;
                // If it placeholder does not already exist, add it to the map
                var placeholderId = (_el$dataset3 = el.dataset) === null || _el$dataset3 === void 0 ? void 0 : _el$dataset3[$58c1e368b1b7b57d$var$placeholderDataKey];
                if (placeholderId) return this.handleAddedPlaceholderNode(el, placeholderId);
                var replaceId = (_el$dataset4 = el.dataset) === null || _el$dataset4 === void 0 ? void 0 : _el$dataset4[$58c1e368b1b7b57d$var$replaceDataKey];
                if (replaceId) return this.handleAddedReplaceNode(el, replaceId);
                return Promise.resolve({
                    shouldIgnore: false
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.placeholders.clear();
                this.intersectionObserver.disconnect();
            }
        },
        {
            key: "handleAddedPlaceholderNode",
            value: function handleAddedPlaceholderNode(el, placeholderId) {
                if (this.isExistingPlaceholder(placeholderId)) return this.isAddedPlaceholderMatchingSize(el, placeholderId).then(function(isMatching) {
                    return {
                        shouldIgnore: isMatching
                    };
                });
                return this.registerPlaceholder(el, placeholderId).then(function() {
                    return {
                        shouldIgnore: false
                    };
                });
            }
        },
        {
            key: "handleAddedReplaceNode",
            value: function handleAddedReplaceNode(el, placeholderId) {
                if (this.isExistingPlaceholder(placeholderId)) return this.isAddedReplaceMatchingSize(el, placeholderId).then(function(isMatching) {
                    return {
                        shouldIgnore: isMatching
                    };
                });
                return Promise.resolve({
                    shouldIgnore: false
                });
            }
        },
        {
            key: "isExistingPlaceholder",
            value: function isExistingPlaceholder(placeholderId) {
                return this.placeholders.has(placeholderId);
            }
        },
        {
            key: "registerPlaceholder",
            value: function registerPlaceholder(el, placeholderId) {
                var _this2 = this;
                return this.getSize(el, placeholderId).then(function(size) {
                    _this2.placeholders.set(placeholderId, size);
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el, placeholderId) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    _this3.getSizeCallbacks.set(placeholderId, resolve);
                    _this3.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "isAddedPlaceholderMatchingSize",
            value: function isAddedPlaceholderMatchingSize(el, placeholderId) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    _this4.isAddedPlaceholderMatchingSizeCallbacks.set(placeholderId, resolve);
                    _this4.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "isAddedReplaceMatchingSize",
            value: function isAddedReplaceMatchingSize(el, placeholderId) {
                var _this5 = this;
                return new Promise(function(resolve) {
                    _this5.isAddedReplaceMatchingSizeCallbacks.set(placeholderId, resolve);
                    _this5.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "areRectsSameSize",
            value: function areRectsSameSize(a, b) {
                return Math.abs(a.width - b.width) < 1 && Math.abs(a.height - b.height) < 1;
            }
        }
    ]);
}();

});

parcelRegister("7RvMD", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $5b96232f16ab43aa$export$c0102f1a1198d10f);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
var $5b96232f16ab43aa$var$EQUALITY_THRESHOLD = 0.1;
var $5b96232f16ab43aa$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $5b96232f16ab43aa$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "intersectionObserverCallback", function(_ref) {
            var _this$intersectionObs;
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = target.dataset.ssrPlaceholder || "";
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) _resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = target.getBoundingClientRect();
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        _resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = target.dataset.ssrPlaceholderReplace || "";
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                if (_hasSameSizePosition || _this.isDummyRect(_rect)) _resolve2(_hasSameSizePosition);
                else requestAnimationFrame(function() {
                    var targetRect = target.getBoundingClientRect();
                    var hasSameSizePosition = _this.hasSameSizePosition(_rect, targetRect);
                    _resolve2(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        if (typeof IntersectionObserver === "function") // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        if (window.document) try {
            var existingElements = document.querySelectorAll("[data-ssr-placeholder]");
            existingElements.forEach(function(el) {
                var _el$dataset;
                if (el instanceof HTMLElement && el !== null && el !== void 0 && (_el$dataset = el.dataset) !== null && _el$dataset !== void 0 && _el$dataset.ssrPlaceholder) {
                    var _window$__SSR_PLACEHO, _this$intersectionObs2;
                    var width = -1;
                    var height = -1;
                    var x = -1;
                    var y = -1;
                    var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[el.dataset.ssrPlaceholder];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    _this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(element.dataset.ssrPlaceholder);
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(element.dataset.ssrPlaceholderReplace);
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return "ssrPlaceholderIgnored" in element.dataset;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $5b96232f16ab43aa$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this2 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholder || "";
                return new Promise(function(resolve) {
                    if (!_this2.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this2$intersectionOb;
                        _this2.callbacks.set(id, resolve);
                        (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    var _this3$intersectionOb;
                    _this3.getSizeCallbacks.set(el.dataset.ssrPlaceholder || "", resolve);
                    (_this3$intersectionOb = _this3.intersectionObserver) === null || _this3$intersectionOb === void 0 || _this3$intersectionOb.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this4 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholderReplace || "";
                return new Promise(function(resolve) {
                    if (!_this4.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this4$intersectionOb;
                        _this4.reactValidateCallbacks.set(id, resolve);
                        (_this4$intersectionOb = _this4.intersectionObserver) === null || _this4$intersectionOb === void 0 || _this4$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                return rect && Math.abs(rect.x - boundingClientRect.x) < $5b96232f16ab43aa$var$EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < $5b96232f16ab43aa$var$EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < $5b96232f16ab43aa$var$EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < $5b96232f16ab43aa$var$EQUALITY_THRESHOLD || false;
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
}();

});


parcelRegister("4iKsn", function(module, exports) {

$parcel$export(module.exports, "getRevisions", () => $321ce135910873d3$export$3a6bcaa2795a58f8);

var $hER75 = parcelRequire("hER75");

var $kDYLz = parcelRequire("kDYLz");
var $321ce135910873d3$var$Revisions = [
    {
        name: "fy25.01",
        classifier: (0, $hER75.revFY25_01Classifier)
    },
    {
        name: "fy25.02",
        classifier: (0, $kDYLz.revFY25_02Classifier)
    }
];
var $321ce135910873d3$var$revisionResultCache = null;
var $321ce135910873d3$export$3a6bcaa2795a58f8 = function getRevisions() {
    if ($321ce135910873d3$var$revisionResultCache !== null) return $321ce135910873d3$var$revisionResultCache;
    $321ce135910873d3$var$revisionResultCache = [].concat($321ce135910873d3$var$Revisions);
    return $321ce135910873d3$var$revisionResultCache;
};

});
parcelRegister("hER75", function(module, exports) {

$parcel$export(module.exports, "FY25_01Classifier", () => $cdaf5f48d5e78e95$export$1287fed0f253eee5);
$parcel$export(module.exports, "revFY25_01Classifier", () => $cdaf5f48d5e78e95$export$d822caadc9ee5453);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $ltooA = parcelRequire("ltooA");

var $f81h0 = parcelRequire("f81h0");
function $cdaf5f48d5e78e95$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $cdaf5f48d5e78e95$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $cdaf5f48d5e78e95$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cdaf5f48d5e78e95$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $cdaf5f48d5e78e95$var$legacyIgnoreReasons = [
    "image",
    "ssr-hydration",
    "editor-lazy-node-view",
    "editor-container-mutation"
];
var $cdaf5f48d5e78e95$export$1287fed0f253eee5 = /*#__PURE__*/ function(_ViewportUpdateClassi) {
    function FY25_01Classifier() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FY25_01Classifier);
        _this = $cdaf5f48d5e78e95$var$_callSuper(this, FY25_01Classifier);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "revision", "fy25.01");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "types", [
            "html",
            "text"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "filters", [
            {
                name: "default-ignore-reasons",
                filter: function filter(_ref) {
                    var type = _ref.type, ignoreReason = _ref.ignoreReason;
                    return !ignoreReason || !$cdaf5f48d5e78e95$var$legacyIgnoreReasons.includes(ignoreReason);
                }
            }
        ]);
        _this.mergeConfig();
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(FY25_01Classifier, _ViewportUpdateClassi);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FY25_01Classifier, [
        {
            key: "VCCalculationMethod",
            value: function VCCalculationMethod(_ref2) {
                var VCParts = _ref2.VCParts, entries = _ref2.entries, totalPainted = _ref2.totalPainted, componentsLog = _ref2.componentsLog;
                var VC = {};
                var VCBox = {};
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var VCRatio = v[1] / totalPainted + acc;
                    var time = v[0];
                    if ((0, $ltooA.fg)("platform_ufo_fix_vc_observer_rounding_error")) {
                        // @todo apply fix to include small changes into accumulator
                        var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                        var preciseAccRatio = Math.round(acc * 100);
                        VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    }
                    VCParts.forEach(function(value) {
                        if ((VC[value] === null || VC[value] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[value] = time;
                            VCBox[value] = new Set();
                            (_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 || _componentsLog$time.forEach(function(v) {
                                var _VCBox$value;
                                return (_VCBox$value = VCBox[value]) === null || _VCBox$value === void 0 ? void 0 : _VCBox$value.add(v.targetName);
                            });
                        }
                    });
                    return VCRatio;
                }, 0);
                return {
                    VC: VC,
                    VCBox: VCBox
                };
            }
        }
    ]);
}((0, $f81h0.ViewportUpdateClassifier));
var $cdaf5f48d5e78e95$export$d822caadc9ee5453 = new $cdaf5f48d5e78e95$export$1287fed0f253eee5();

});
parcelRegister("f81h0", function(module, exports) {

$parcel$export(module.exports, "ViewportUpdateClassifier", () => $b038973da6e006df$export$66a5f74f04eab7df);

var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
var $b038973da6e006df$export$66a5f74f04eab7df = /*#__PURE__*/ function() {
    function ViewportUpdateClassifier() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ViewportUpdateClassifier);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "types", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "filters", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "removedFilters", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "__combinedTypes", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "__combinedFilters", []);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ViewportUpdateClassifier, [
        {
            key: "VCCalculationMethod",
            value: function VCCalculationMethod(_) {
                return {
                    VC: {},
                    VCBox: {}
                };
            }
        },
        {
            key: "filterComponentsLog",
            value: function filterComponentsLog(_ref) {
                var componentsLog = _ref.componentsLog;
                return componentsLog;
            }
        },
        {
            key: "mergeConfig",
            value: function mergeConfig() {
                var _this = this;
                this.__combinedTypes = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(this.types), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((this === null || this === void 0 ? void 0 : this.__combinedTypes) || []));
                var previousFilters = this.removedFilters.length === 0 ? this.__combinedFilters : this.__combinedFilters.filter(function(filter) {
                    return !_this.removedFilters.includes(filter.name);
                });
                this.__combinedFilters = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(this.filters), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(previousFilters));
            }
        },
        {
            key: "classifyUpdate",
            value: function classifyUpdate(_ref2) {
                var element = _ref2.element, type = _ref2.type, tags = _ref2.tags, ignoreReason = _ref2.ignoreReason;
                if (!this.__combinedTypes.includes(type)) return false;
                return this.__combinedFilters.every(function(_ref3) {
                    var filter = _ref3.filter, name = _ref3.name;
                    return filter({
                        type: type,
                        tags: tags,
                        ignoreReason: ignoreReason
                    });
                });
            }
        }
    ]);
}();

});


parcelRegister("kDYLz", function(module, exports) {

$parcel$export(module.exports, "revFY25_02Classifier", () => $f0769614c436dbe9$export$624b2c3760a5ab41);

var $02Ztr = parcelRequire("02Ztr");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $ltooA = parcelRequire("ltooA");

var $hER75 = parcelRequire("hER75");
function $f0769614c436dbe9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f0769614c436dbe9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f0769614c436dbe9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f0769614c436dbe9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f0769614c436dbe9$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $f0769614c436dbe9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $f0769614c436dbe9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f0769614c436dbe9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f0769614c436dbe9$export$d8e8ccb82df07b7c = /*#__PURE__*/ function(_FY25_01Classifier) {
    function FY25_02Classifier() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FY25_02Classifier);
        _this = $f0769614c436dbe9$var$_callSuper(this, FY25_02Classifier);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "revision", "fy25.02");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "types", [
            "attr"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "filters", [
            {
                name: "not-visible",
                filter: function filter(_ref) {
                    var type = _ref.type, ignoreReason = _ref.ignoreReason;
                    return !(ignoreReason !== null && ignoreReason !== void 0 && ignoreReason.includes("not-visible"));
                }
            }
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "removedFilters", []);
        _this.mergeConfig();
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(FY25_02Classifier, _FY25_01Classifier);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FY25_02Classifier, [
        {
            key: "filterComponentsLog",
            value: // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
            function filterComponentsLog(_ref2) {
                var componentsLog = _ref2.componentsLog, ttai = _ref2.ttai;
                var _componentsLog = {};
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                if ((0, $ltooA.fg)("ufo-remove-vc-component-observations-after-ttai")) Object.entries(componentsLog).forEach(function(_ref3) {
                    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), _timestamp = _ref4[0], value = _ref4[1];
                    var timestamp = Number(_timestamp);
                    if (ttai > timestamp) _componentsLog[timestamp] = value;
                });
                else _componentsLog = $f0769614c436dbe9$var$_objectSpread({}, componentsLog);
                return _componentsLog;
            }
        }
    ]);
}((0, $hER75.FY25_01Classifier));
var $f0769614c436dbe9$export$624b2c3760a5ab41 = new $f0769614c436dbe9$export$d8e8ccb82df07b7c();

});




parcelRegister("9z7qU", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $6f6d25f826435c3f$export$f2e521e495a88544);
$parcel$export(module.exports, "getActiveTrace", () => $6f6d25f826435c3f$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $6f6d25f826435c3f$export$17ab21d7be720b);

var $jJOp5 = parcelRequire("jJOp5");
var $6f6d25f826435c3f$var$state = {
    context: null
};
var $6f6d25f826435c3f$export$295213bc4d0c54ad = function generateSpanId() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join("");
};
var $6f6d25f826435c3f$export$f2e521e495a88544 = function setInteractionActiveTrace(interactionId, experienceType) {
    $6f6d25f826435c3f$export$a1002be327997103(interactionId.replace(/-/g, ""), $6f6d25f826435c3f$export$295213bc4d0c54ad(), experienceType);
};
var $6f6d25f826435c3f$export$a1002be327997103 = function setActiveTrace(traceId, spanId, type) {
    $6f6d25f826435c3f$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
};
var $6f6d25f826435c3f$export$b6ac780db3a3cc77 = function getActiveTrace() {
    return $6f6d25f826435c3f$var$state.context || undefined;
};
var $6f6d25f826435c3f$export$17ab21d7be720b = function clearActiveTrace() {
    $6f6d25f826435c3f$var$state.context = null;
};
var $6f6d25f826435c3f$export$6e17cce6446848f9 = function getActiveTraceHttpRequestHeaders(_url) {
    if ($6f6d25f826435c3f$var$state.context === null) return null;
    var _state$context = $6f6d25f826435c3f$var$state.context, traceId = _state$context.traceId, spanId = _state$context.spanId;
    return (0, $jJOp5.makeTraceHttpRequestHeaders)(traceId, spanId);
};
var $6f6d25f826435c3f$export$a1e7396778592551 = function getActiveTraceAsQueryParams(_url) {
    var traceHeaders = $6f6d25f826435c3f$export$6e17cce6446848f9(_url);
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
};

});
parcelRegister("jJOp5", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $e5e951683b36ac5b$export$1115c5277eb10d5e);
var $e5e951683b36ac5b$export$1115c5277eb10d5e = function makeTraceHttpRequestHeaders(traceId, spanId) {
    return {
        "X-B3-TraceId": traceId,
        "X-B3-SpanId": spanId
    };
};

});


parcelRegister("7ht9N", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $54d0bceaf304b151$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $54d0bceaf304b151$export$2a5c8df26bb89760);

var $94RZt = parcelRequire("94RZt");
var $54d0bceaf304b151$export$5b78c989c8db2561 = new Map();
var $54d0bceaf304b151$export$2a5c8df26bb89760 = new Map();
var $54d0bceaf304b151$export$47fade9662f71000 = function addFeatureFlagAccessed(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === "function") globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $94RZt.redactValue)(featureFlagValue);
    $54d0bceaf304b151$export$5b78c989c8db2561.set(featureFlagName, value);
    $54d0bceaf304b151$export$2a5c8df26bb89760.set(featureFlagName, value);
};

});
parcelRegister("94RZt", function(module, exports) {

$parcel$export(module.exports, "redactValue", () => $69be5e26fcbc210b$export$fcc03ee4c944962f);

var $41YNz = parcelRequire("41YNz");

var $9TOpA = parcelRequire("9TOpA");
var $69be5e26fcbc210b$var$startsAsObject = function startsAsObject(value) {
    try {
        if (value.charAt(0) === "{") return true;
    } catch (e) {
        return false;
    }
    return false;
};
var $69be5e26fcbc210b$var$isObject = function isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && value.constructor === Object;
};
var $69be5e26fcbc210b$var$isString = function isString(input) {
    var result;
    try {
        result = typeof input === "string" || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
var $69be5e26fcbc210b$export$7b4abba432e57989 = function shouldRedactValue(value) {
    return $69be5e26fcbc210b$var$isString(value) && $69be5e26fcbc210b$var$startsAsObject(value) || $69be5e26fcbc210b$var$isObject(value);
};
var $69be5e26fcbc210b$export$fcc03ee4c944962f = function redactValue(featureFlagValue) {
    return $69be5e26fcbc210b$export$7b4abba432e57989(featureFlagValue) ? (0, $9TOpA.NON_BOOLEAN_VALUE) : featureFlagValue;
};

});
parcelRegister("9TOpA", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $73505ad169617557$export$42f4885608027d0c);
var $73505ad169617557$export$42f4885608027d0c = "non_boolean";

});



parcelRegister("lllYc", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", () => $f89c99ef15751916$export$b3bc47985717b49e);

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $ltooA = parcelRequire("ltooA");

var $b4vGv = parcelRequire("b4vGv");

var $eq0cS = parcelRequire("eq0cS");

var $gXXlM = parcelRequire("gXXlM");

var $h7JHd = parcelRequire("h7JHd");

var $hPtJY = parcelRequire("hPtJY");
var $f89c99ef15751916$var$_process;
function $f89c99ef15751916$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f89c99ef15751916$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f89c99ef15751916$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f89c99ef15751916$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f89c99ef15751916$var$VCObserverWrapper = /*#__PURE__*/ function() {
    function VCObserverWrapper() {
        var _getConfig;
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, VCObserverWrapper);
        this.newVCObserver = null;
        var isNewVCObserverEnabled = (0, $ltooA.fg)("platform_ufo_vc_observer_new") || ((_getConfig = (0, $b4vGv.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.vc) === null || _getConfig === void 0 ? void 0 : _getConfig.enableVCObserverNew);
        if (isNewVCObserverEnabled) this.newVCObserver = new (0, $h7JHd.default)({
            selectorConfig: opts.selectorConfig
        });
        this.oldVCObserver = new (0, $gXXlM.VCObserver)(opts);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(VCObserverWrapper, [
        {
            key: "start",
            value: function start(startArg) {
                var _this$oldVCObserver, _this$newVCObserver;
                (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start(startArg);
                (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                    startTime: startArg.startTime
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$oldVCObserver2, _this$newVCObserver2;
                (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
                (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this$oldVCObserver$g, _this$oldVCObserver3;
                return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(param) {
                    var _this$oldVCObserver4, _this$newVCObserver3, _ref;
                    var oldResult, newResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
                            case 2:
                                oldResult = _context.sent;
                                _context.next = 5;
                                return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                                    start: param.start,
                                    stop: (0, $ltooA.fg)("platform_ufo_vc_ttai_on_paint") ? param.stop : performance.now()
                                });
                            case 5:
                                newResult = _context.sent;
                                if (!(oldResult && !newResult)) {
                                    _context.next = 8;
                                    break;
                                }
                                return _context.abrupt("return", oldResult);
                            case 8:
                                return _context.abrupt("return", $f89c99ef15751916$var$_objectSpread($f89c99ef15751916$var$_objectSpread({}, oldResult !== null && oldResult !== void 0 ? oldResult : {}), {}, {
                                    "ufo:vc:rev": [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((_ref = oldResult === null || oldResult === void 0 ? void 0 : oldResult["ufo:vc:rev"]) !== null && _ref !== void 0 ? _ref : []), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(newResult !== null && newResult !== void 0 ? newResult : []))
                                }));
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this$oldVCObserver5;
                (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this$oldVCObserver6;
                (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this$oldVCObserver7;
                (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
            }
        }
    ]);
}(); // Some products set this variable to indicate it is running in SSR
var $f89c99ef15751916$var$isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var $f89c99ef15751916$var$isReactSSR = typeof $hPtJY !== "undefined" && Boolean((($f89c99ef15751916$var$_process = $hPtJY) === null || $f89c99ef15751916$var$_process === void 0 || ($f89c99ef15751916$var$_process = $f89c99ef15751916$var$_process.env) === null || $f89c99ef15751916$var$_process === void 0 ? void 0 : $f89c99ef15751916$var$_process.REACT_SSR) || false);
function $f89c99ef15751916$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($f89c99ef15751916$var$isReactSSR || $f89c99ef15751916$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== "function") return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== "function" || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== "function" || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== "function") return false;
    return true;
}
var $f89c99ef15751916$export$b3bc47985717b49e = function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!globalThis.__vcObserver) {
        var shouldMockVCObserver = !$f89c99ef15751916$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $eq0cS.VCObserverNOOP)() : new $f89c99ef15751916$var$VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
};

});
parcelRegister("eq0cS", function(module, exports) {

$parcel$export(module.exports, "VCObserverNOOP", () => $a7f3a77471748a75$export$24d07287b49da906);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");
var $a7f3a77471748a75$export$24d07287b49da906 = /*#__PURE__*/ function() {
    function VCObserverNOOP() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, VCObserverNOOP);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(VCObserverNOOP, [
        {
            key: "start",
            value: function start(startArg) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(param) {
                return Promise.resolve({
                    "ufo:vc:noop": true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {}
        }
    ]);
}();

});

parcelRegister("h7JHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7768963c8d2470d$export$2e2bcd8739ae039);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $6BUbt = parcelRequire("6BUbt");

var $7RKEY = parcelRequire("7RKEY");

var $cGIB1 = parcelRequire("cGIB1");

var $9TRzl = parcelRequire("9TRzl");

var $e04yf = parcelRequire("e04yf");
var $c7768963c8d2470d$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
var $c7768963c8d2470d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function VCObserverNew(config) {
        var _config$selectorConfi, _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, VCObserverNew);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "viewportObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "windowEventObserver", null);
        this.entriesTimeline = new (0, $6BUbt.default)();
        this.selectorConfig = (_config$selectorConfi = config.selectorConfig) !== null && _config$selectorConfi !== void 0 ? _config$selectorConfi : $c7768963c8d2470d$var$DEFAULT_SELECTOR_CONFIG;
        this.viewportObserver = new (0, $9TRzl.default)({
            onChange: function onChange(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = "unknown";
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                _this.entriesTimeline.push({
                    time: time,
                    type: type,
                    data: {
                        elementName: elementName,
                        rect: rect,
                        previousRect: previousRect,
                        visible: visible,
                        attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName
                    }
                });
            }
        });
        this.windowEventObserver = new (0, $e04yf.default)({
            onEvent: function onEvent(_ref) {
                var time = _ref.time, type = _ref.type;
                _this.entriesTimeline.push({
                    time: time,
                    type: "window:event",
                    data: {
                        eventType: type
                    }
                });
            }
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(VCObserverNew, [
        {
            key: "start",
            value: function start(_ref2) {
                var _this$viewportObserve, _this$windowEventObse;
                var startTime = _ref2.startTime;
                (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
                (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
                this.entriesTimeline.clear();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$viewportObserve2, _this$windowEventObse2;
                (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
                (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(param) {
                    var start, stop, results, calculator_fy25_03, orderedEntries, fy25_03;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                start = param.start, stop = param.stop;
                                results = [];
                                calculator_fy25_03 = new (0, $cGIB1.default)();
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                _context.next = 6;
                                return calculator_fy25_03.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop
                                });
                            case 6:
                                fy25_03 = _context.sent;
                                if (fy25_03) results.push(fy25_03);
                                return _context.abrupt("return", results);
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, $7RKEY.default)(this.selectorConfig, element);
            }
        }
    ]);
}();

});
parcelRegister("6BUbt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d01c7c78571c058$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
var $4d01c7c78571c058$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EntriesTimeline() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, EntriesTimeline);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unorderedEntries", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sortedEntriesCache", new Map());
        this.unorderedEntries = [];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : "null", "_").concat(stop !== null && stop !== void 0 ? stop : "null");
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(_ref) {
                var _this$sortedEntriesCa;
                var start = _ref.start, stop = _ref.stop;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
}();

});

parcelRegister("7RKEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ba1ad4ff825d928$export$2e2bcd8739ae039);
var $5ba1ad4ff825d928$var$nameCache = new WeakMap();
function $5ba1ad4ff825d928$export$2e2bcd8739ae039(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return "error";
    var cachedName = $5ba1ad4ff825d928$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function encodeValue(s) {
        if (typeof encodeURIComponent !== "function") return "";
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return "malformed_value";
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function getAttributeSelector(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        if (element && typeof element.getAttribute !== "function") return "";
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return "";
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, '="').concat(encondedAttrValue, '"]');
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector("data-vc") : "";
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : "";
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector("data-testid") || getAttributeSelector("data-test-id") : "";
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector("role") : "";
    var classNames = Array.from(element.classList).map(encodeValue).join(".");
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : "";
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join("");
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? $5ba1ad4ff825d928$export$2e2bcd8739ae039(selectorConfig, element.parentElement) : "unknown";
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    $5ba1ad4ff825d928$var$nameCache.set(element, name);
    return name;
}

});

parcelRegister("cGIB1", function(module, exports) {

$parcel$export(module.exports, "default", () => $93cc00247d63da61$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $jGNyD = parcelRequire("jGNyD");

var $20p1C = parcelRequire("20p1C");
function $93cc00247d63da61$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $93cc00247d63da61$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $93cc00247d63da61$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($93cc00247d63da61$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $93cc00247d63da61$var$ABORTING_WINDOW_EVENT = [
    "wheel",
    "scroll",
    "keydown",
    "resize"
];
var $93cc00247d63da61$var$REVISION_NO = "fy25.03";
var $93cc00247d63da61$var$CONSIDERED_ENTRY_TYPE = [
    "mutation:child-element",
    "mutation:element",
    "mutation:attribute",
    "layout-shift",
    "window:event"
];
var $93cc00247d63da61$export$98812f4e79596e2b = [
    "data-drop-target-for-element",
    "draggable"
];
var $93cc00247d63da61$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractVCCalculator) {
    function VCCalculator_FY25_03() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, VCCalculator_FY25_03);
        return $93cc00247d63da61$var$_callSuper(this, VCCalculator_FY25_03, [
            $93cc00247d63da61$var$REVISION_NO
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(VCCalculator_FY25_03, _AbstractVCCalculator);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry) {
                if (!$93cc00247d63da61$var$CONSIDERED_ENTRY_TYPE.includes(entry.type)) return false;
                if (entry.type === "mutation:attribute") {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (!attributeName || $93cc00247d63da61$export$98812f4e79596e2b.includes(attributeName)) return false;
                    return true;
                }
                if ((0, $20p1C.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "isVCClean",
            value: function isVCClean(filteredEntries) {
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.type === "window:event") {
                        var data = entry.data;
                        if ($93cc00247d63da61$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) return true;
                    }
                    return false;
                });
                return !hasAbortEvent;
            }
        }
    ]);
}((0, $jGNyD.default));

});
parcelRegister("jGNyD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e55861a97bec4b4a$export$2e2bcd8739ae039);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $jRJIh = parcelRequire("jRJIh");

var $9sV5v = parcelRequire("9sV5v");

var $eJHlM = parcelRequire("eJHlM");
var $e55861a97bec4b4a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AbstractVCCalculatorBase(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AbstractVCCalculatorBase, [
        {
            key: "calculate",
            value: function() {
                var _calculate = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(_ref) {
                    var _this = this, _vcDetails$90$t, _vcDetails$;
                    var startTime, stopTime, orderedEntries, filteredEntries, isVCClean, vcDetails;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry);
                                });
                                isVCClean = this.isVCClean(filteredEntries);
                                if (isVCClean) {
                                    _context.next = 5;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    "metric:vc90": null,
                                    clean: false
                                });
                            case 5:
                                _context.next = 7;
                                return (0, $jRJIh.default)({
                                    viewport: {
                                        width: (0, $eJHlM.default)(),
                                        height: (0, $9sV5v.default)()
                                    },
                                    startTime: startTime,
                                    stopTime: stopTime,
                                    orderedEntries: filteredEntries,
                                    percentiles: [
                                        25,
                                        50,
                                        75,
                                        80,
                                        85,
                                        90,
                                        95,
                                        98,
                                        99
                                    ]
                                });
                            case 7:
                                vcDetails = _context.sent;
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined,
                                    clean: isVCClean,
                                    "metric:vc90": (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails["90"]) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null
                                });
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function calculate(_x) {
                    return _calculate.apply(this, arguments);
                }
                return calculate;
            }()
        }
    ]);
}();

});
parcelRegister("jRJIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7666d44c0da3442$export$2e2bcd8739ae039);

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");

var $8pZwx = parcelRequire("8pZwx");

var $lQBz0 = parcelRequire("lQBz0");

var $lNVa9 = parcelRequire("lNVa9");
function $e7666d44c0da3442$export$2e2bcd8739ae039(_x) {
    return $e7666d44c0da3442$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $e7666d44c0da3442$var$_calculateTTVCPercentiles() {
    $e7666d44c0da3442$var$_calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(arg) {
        var algo, vcDetails, _vcDetails, _vcDetails2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    algo = "canvas_heatmap";
                    if (!(algo === "canvas_heatmap")) {
                        _context.next = 6;
                        break;
                    }
                    _context.next = 4;
                    return (0, $8pZwx.default)(arg);
                case 4:
                    vcDetails = _context.sent;
                    return _context.abrupt("return", vcDetails);
                case 6:
                    if (!(algo === "rect_sweeping")) {
                        _context.next = 11;
                        break;
                    }
                    _context.next = 9;
                    return (0, $lNVa9.default)(arg);
                case 9:
                    _vcDetails = _context.sent;
                    return _context.abrupt("return", _vcDetails);
                case 11:
                    if (!(algo === "old_heatmap")) {
                        _context.next = 16;
                        break;
                    }
                    _context.next = 14;
                    return (0, $lQBz0.default)(arg);
                case 14:
                    _vcDetails2 = _context.sent;
                    return _context.abrupt("return", _vcDetails2);
                case 16:
                    throw new Error("unexpected Error algo not chosen correctly");
                case 17:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $e7666d44c0da3442$var$_calculateTTVCPercentiles.apply(this, arguments);
}

});
parcelRegister("8pZwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $621061de7a61d3a5$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");

var $ltooA = parcelRequire("ltooA");

var $lDRMu = parcelRequire("lDRMu");
function $621061de7a61d3a5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $621061de7a61d3a5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $621061de7a61d3a5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $621061de7a61d3a5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $621061de7a61d3a5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $621061de7a61d3a5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $621061de7a61d3a5$export$2e2bcd8739ae039(_x) {
    return $621061de7a61d3a5$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $621061de7a61d3a5$var$_calculateTTVCPercentiles() {
    $621061de7a61d3a5$var$_calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(_ref) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iterator2, _step2, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    viewport = _ref.viewport, orderedEntries = _ref.orderedEntries, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    canvas = new (0, $lDRMu.ViewportCanvas)(viewport, (0, $ltooA.fg)("platform_ufo_canvas_heatmap_full_precision") ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator2 = $621061de7a61d3a5$var$_createForOfIteratorHelper(orderedEntries);
                    _context.prev = 4;
                    _iterator2.s();
                case 6:
                    if ((_step2 = _iterator2.n()).done) {
                        _context.next = 17;
                        break;
                    }
                    entry = _step2.value;
                    if ("rect" in entry.data) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("continue", 15);
                case 10:
                    rect = entry.data.rect;
                    elementName = entry.data.elementName;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                    elementMap.get(entry.time).add(elementName);
                case 15:
                    _context.next = 6;
                    break;
                case 17:
                    _context.next = 22;
                    break;
                case 19:
                    _context.prev = 19;
                    _context.t0 = _context["catch"](4);
                    _iterator2.e(_context.t0);
                case 22:
                    _context.prev = 22;
                    _iterator2.f();
                    return _context.finish(22);
                case 25:
                    _context.next = 27;
                    return canvas.getPixelCounts();
                case 27:
                    timePixelCounts = _context.sent;
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return _context.abrupt("return", $621061de7a61d3a5$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime));
                case 31:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                19,
                22,
                25
            ]
        ]);
    }));
    return $621061de7a61d3a5$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $621061de7a61d3a5$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref2, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref2, 1), timeA = _ref4[0];
        var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 1), timeB = _ref5[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iterator = $621061de7a61d3a5$var$_createForOfIteratorHelper(sortedEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_step.value, 2), time = _step$value[0], pixelCount = _step$value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}

});
parcelRegister("lDRMu", function(module, exports) {

$parcel$export(module.exports, "ViewportCanvas", () => $fc16f547d140836d$export$3e59ac9de7402fb1);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $fGnsQ = parcelRequire("fGnsQ");
var $fc16f547d140836d$export$3e59ac9de7402fb1 = /*#__PURE__*/ function() {
    /** The underlying OffscreenCanvas instance */ /** The 2D rendering context of the canvas */ /** Scale factor applied to the canvas (affects final pixel counts) */ /** Maps unique colors to their corresponding timestamps */ /** Counter used to generate unique colors */ /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ViewportCanvas);
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize OffscreenCanvas with scaled dimensions
        this.canvas = document.createElement("canvas");
        this.canvas.width = this.scaledWidth;
        this.canvas.height = this.scaledHeight;
        var ctx = this.canvas.getContext("2d", {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: "srgb" // Use standard RGB color space
        });
        if (!ctx) throw new Error("Could not get canvas context");
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = "source-over";
        this.clear();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ViewportCanvas, [
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return $fc16f547d140836d$export$54591583ed0b20ce(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: function() {
                var _getPixelCounts = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                _context.next = 4;
                                return $fc16f547d140836d$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
                            case 4:
                                pixelCounts = _context.sent;
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                i = 0;
                            case 7:
                                if (!(i < pixelCounts.length)) {
                                    _context.next = 18;
                                    break;
                                }
                                count = pixelCounts[i];
                                if (!(typeof count !== "number")) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("continue", 15);
                            case 11:
                                color = i + 1;
                                rgbColor = $fc16f547d140836d$export$54591583ed0b20ce(color);
                                timestamp = this.colorTimeMap.get(rgbColor);
                                if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                            case 15:
                                i++;
                                _context.next = 7;
                                break;
                            case 18:
                                return _context.abrupt("return", timePixelCounts);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getPixelCounts() {
                    return _getPixelCounts.apply(this, arguments);
                }
                return getPixelCounts;
            }()
        }
    ]);
}();
function $fc16f547d140836d$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error("Input number must be between 0 and 16777215 (inclusive).");
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}
function $fc16f547d140836d$export$fafc9be44839f9c8(_x, _x2, _x3) {
    return $fc16f547d140836d$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}
function $fc16f547d140836d$var$_calculateDrawnPixelsRaw() {
    $fc16f547d140836d$var$_calculateDrawnPixelsRaw = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(imageData, scaleFactor, arraySize) {
        var data, arr, i, color, colorIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                case 3:
                    if (!(i < data.length)) {
                        _context2.next = 11;
                        break;
                    }
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) {
                        _context2.next = 8;
                        break;
                    }
                    _context2.next = 8;
                    return (0, $fGnsQ.default)();
                case 8:
                    i += 4;
                    _context2.next = 3;
                    break;
                case 11:
                    return _context2.abrupt("return", arr);
                case 12:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $fc16f547d140836d$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}

});
parcelRegister("fGnsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6acfac6cd28f32e$export$2e2bcd8739ae039);

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");
function $b6acfac6cd28f32e$export$2e2bcd8739ae039() {
    return $b6acfac6cd28f32e$var$_taskYield.apply(this, arguments);
}
function $b6acfac6cd28f32e$var$_taskYield() {
    $b6acfac6cd28f32e$var$_taskYield = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee() {
        var resolve, p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!("scheduler" in globalThis && // @ts-ignore
                    "yield" in globalThis.scheduler)) {
                        _context.next = 4;
                        break;
                    }
                    _context.next = 3;
                    return scheduler.yield();
                case 3:
                    return _context.abrupt("return");
                case 4:
                    resolve = function resolve() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    _context.next = 9;
                    return p;
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $b6acfac6cd28f32e$var$_taskYield.apply(this, arguments);
}

});



parcelRegister("lQBz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7b97a105149302$export$2e2bcd8739ae039);

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $20p1C = parcelRequire("20p1C");

var $fGnsQ = parcelRequire("fGnsQ");
function $fe7b97a105149302$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe7b97a105149302$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe7b97a105149302$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe7b97a105149302$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fe7b97a105149302$var$MAX_HEATMAP_SIZE = 1000;
function $fe7b97a105149302$var$createEmptyHeatmapEntry() {
    return {
        head: null,
        previousEntries: []
    };
}
function $fe7b97a105149302$var$createEmptyMap(heatmapWidth, heatmapHeight) {
    return Array.from({
        length: heatmapHeight
    }).map(function() {
        return Array.from({
            length: heatmapWidth
        }).map($fe7b97a105149302$var$createEmptyHeatmapEntry);
    });
}
function $fe7b97a105149302$var$isRectInside(a, b) {
    if (!a || !b) return false;
    // Check if all corners of rectangle a are within the bounds of rectangle b
    return a.left >= b.left && a.right <= b.right && a.top >= b.top && a.bottom <= b.bottom;
}
var $fe7b97a105149302$var$Heatmap = /*#__PURE__*/ function() {
    /**
   * Heatmap Width
   */ /**
   * Heatmap Height
   */ /**
   * Heatmap Area (width * height)
   */ function Heatmap(_ref) {
        var viewport = _ref.viewport, heatmapSize = _ref.heatmapSize;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Heatmap);
        // TODO timeOrigin? do we need? for SSR??
        this.viewport = viewport;
        var safeSize = Math.min(heatmapSize, $fe7b97a105149302$var$MAX_HEATMAP_SIZE);
        if (viewport.width === 0 || viewport.height === 0) {
            this.width = safeSize;
            this.height = safeSize;
            this.scaleX = 1;
            this.scaleY = 1;
            this.heatmapAreaSize = 0;
            this.map = $fe7b97a105149302$var$createEmptyMap(safeSize, safeSize);
            return;
        }
        var aspectRatio = viewport.width / viewport.height;
        if (aspectRatio > 1) {
            // Landscape orientation
            this.width = safeSize;
            this.height = Math.round(safeSize / aspectRatio);
        } else {
            // Portrait orientation
            this.width = safeSize;
            this.height = Math.round(safeSize * aspectRatio);
        }
        this.scaleX = this.width / viewport.width;
        this.scaleY = this.height / viewport.height;
        this.heatmapAreaSize = this.width * this.height;
        this.map = $fe7b97a105149302$var$createEmptyMap(this.width, this.height);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Heatmap, [
        {
            key: "getHeatmap",
            value: function getHeatmap() {
                return this.map;
            }
        },
        {
            key: "getCell",
            value: function getCell(row, col) {
                var _this$map$row;
                return (_this$map$row = this.map[row]) === null || _this$map$row === void 0 ? void 0 : _this$map$row[col];
            }
        },
        {
            key: "mapDOMRectToHeatmap",
            value: function mapDOMRectToHeatmap(rect) {
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                return {
                    left: Math.floor(scaledX),
                    right: Math.ceil(scaledX + scaledWidth),
                    top: Math.floor(scaledY),
                    bottom: Math.ceil(scaledY + scaledHeight)
                };
            }
        },
        {
            key: "getRatio",
            value: function getRatio(rect) {
                if (this.viewport.width === 0 || this.viewport.height === 0) return 0;
                var right = rect.right, left = rect.left, bottom = rect.bottom, top = rect.top;
                var rectWidth = right - left;
                var rectHeight = bottom - top;
                var rectArea = rectWidth * rectHeight;
                var ratio = rectArea / this.heatmapAreaSize;
                if (ratio > 1) return 1;
                return ratio;
            }
        },
        {
            key: "applyEntriesToHeatmap",
            value: function() {
                var _applyEntriesToHeatmap = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(entries) {
                    var i, entry, time, type, data, rect, ratio, heatmapEntryData, roundedTop, roundedBottom, roundedLeft, roundedRight, row, col, cell, previousEntry;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                i = 0;
                            case 1:
                                if (!(i < entries.length)) {
                                    _context.next = 37;
                                    break;
                                }
                                entry = entries[i];
                                time = entry.time, type = entry.type, data = entry.data;
                                if (!(0, $20p1C.default)(data)) {
                                    _context.next = 31;
                                    break;
                                }
                                rect = this.mapDOMRectToHeatmap(data.rect);
                                ratio = this.getRatio(rect);
                                heatmapEntryData = {
                                    time: time,
                                    elementName: data.elementName,
                                    ratio: ratio !== null && ratio !== void 0 ? ratio : null,
                                    rect: rect,
                                    source: type
                                };
                                roundedTop = Math.floor(rect.top);
                                roundedBottom = Math.min(rect.bottom, this.height);
                                roundedLeft = Math.floor(rect.left);
                                roundedRight = Math.min(rect.right, this.width);
                                row = roundedTop;
                            case 13:
                                if (!(row < roundedBottom)) {
                                    _context.next = 31;
                                    break;
                                }
                                col = roundedLeft;
                            case 15:
                                if (!(col < roundedRight)) {
                                    _context.next = 28;
                                    break;
                                }
                                cell = this.getCell(row, col);
                                if (cell) {
                                    _context.next = 19;
                                    break;
                                }
                                return _context.abrupt("continue", 25);
                            case 19:
                                previousEntry = cell.head; // When elements are added at the same time
                                // we try to keep the inner element changes as the head
                                if (!((previousEntry === null || previousEntry === void 0 ? void 0 : previousEntry.time) === entry.time && $fe7b97a105149302$var$isRectInside(previousEntry.rect, heatmapEntryData.rect))) {
                                    _context.next = 23;
                                    break;
                                }
                                cell.previousEntries.push($fe7b97a105149302$var$_objectSpread($fe7b97a105149302$var$_objectSpread({}, heatmapEntryData), {}, {
                                    source: "mutation:parent-mounted"
                                }));
                                return _context.abrupt("continue", 25);
                            case 23:
                                cell.head = $fe7b97a105149302$var$_objectSpread($fe7b97a105149302$var$_objectSpread({}, heatmapEntryData), {}, {
                                    source: heatmapEntryData.source || null
                                });
                                if (previousEntry !== null) cell.previousEntries.push(previousEntry);
                            case 25:
                                col++;
                                _context.next = 15;
                                break;
                            case 28:
                                row++;
                                _context.next = 13;
                                break;
                            case 31:
                                if (!(i % 100 === 0)) {
                                    _context.next = 34;
                                    break;
                                }
                                _context.next = 34;
                                return (0, $fGnsQ.default)();
                            case 34:
                                i++;
                                _context.next = 1;
                                break;
                            case 37:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function applyEntriesToHeatmap(_x) {
                    return _applyEntriesToHeatmap.apply(this, arguments);
                }
                return applyEntriesToHeatmap;
            }()
        },
        {
            key: "getVCPercentMetrics",
            value: function() {
                var _getVCPercentMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(vcPercentCheckpoint, startTime) {
                    var sortedCheckpoints, flattenHeatmap, totalCells, timestampMap, i, _cellHead$time, _timestampMap$get, cell, cellHead, timestamp, elementName, curr, sortedTimings, totalCellPainted, result, domElementsBuffer, _i, _timestamp, timestampInfo, cellCount, domElements, currVCRatio, currVCPercent, matchesAnyCheckpoints, checkpoint, _domElements;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                sortedCheckpoints = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(vcPercentCheckpoint).sort(function(a, b) {
                                    return a - b;
                                });
                                flattenHeatmap = this.map.flat();
                                totalCells = flattenHeatmap.length;
                                timestampMap = new Map();
                                i = 0;
                            case 5:
                                if (!(i < flattenHeatmap.length)) {
                                    _context2.next = 20;
                                    break;
                                }
                                cell = flattenHeatmap[i];
                                cellHead = cell.head;
                                timestamp = Math.trunc((_cellHead$time = cellHead === null || cellHead === void 0 ? void 0 : cellHead.time) !== null && _cellHead$time !== void 0 ? _cellHead$time : 0);
                                elementName = cellHead === null || cellHead === void 0 ? void 0 : cellHead.elementName;
                                curr = (_timestampMap$get = timestampMap.get(timestamp)) !== null && _timestampMap$get !== void 0 ? _timestampMap$get : {
                                    cellCount: 0,
                                    domElements: new Set()
                                };
                                curr.cellCount += 1;
                                if (elementName) curr.domElements.add(elementName);
                                timestampMap.set(timestamp, curr);
                                // Every 10000 heatmap entries processed
                                // we give the browser the power
                                // to process any other high priority task
                                if (!(i > 10000 && i % 10000 === 0)) {
                                    _context2.next = 17;
                                    break;
                                }
                                _context2.next = 17;
                                return (0, $fGnsQ.default)();
                            case 17:
                                i++;
                                _context2.next = 5;
                                break;
                            case 20:
                                sortedTimings = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(timestampMap.keys()).sort(function(a, b) {
                                    return a - b;
                                });
                                totalCellPainted = 0;
                                result = {};
                                domElementsBuffer = new Set();
                                _i = 0;
                            case 25:
                                if (!(_i < sortedTimings.length)) {
                                    _context2.next = 52;
                                    break;
                                }
                                _timestamp = sortedTimings[_i];
                                timestampInfo = timestampMap.get(_timestamp);
                                if (timestampInfo) {
                                    _context2.next = 30;
                                    break;
                                }
                                throw new Error("unexpected timestampInfo not found");
                            case 30:
                                cellCount = timestampInfo.cellCount, domElements = timestampInfo.domElements;
                                totalCellPainted += cellCount;
                                currVCRatio = totalCellPainted / totalCells;
                                currVCPercent = Math.round(currVCRatio * 100);
                                domElements.forEach(function(domElement) {
                                    domElementsBuffer.add(domElement);
                                });
                                matchesAnyCheckpoints = false;
                            case 36:
                                if (!(sortedCheckpoints.length > 0 && currVCPercent >= sortedCheckpoints[0])) {
                                    _context2.next = 45;
                                    break;
                                }
                                checkpoint = sortedCheckpoints.shift();
                                _domElements = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(domElementsBuffer);
                                if (checkpoint) {
                                    _context2.next = 41;
                                    break;
                                }
                                return _context2.abrupt("break", 45);
                            case 41:
                                matchesAnyCheckpoints = true;
                                result[checkpoint.toString()] = {
                                    t: Math.round(_timestamp - startTime),
                                    e: _domElements
                                };
                                _context2.next = 36;
                                break;
                            case 45:
                                if (matchesAnyCheckpoints) domElementsBuffer.clear();
                                if (!(_i % 500 === 0)) {
                                    _context2.next = 49;
                                    break;
                                }
                                _context2.next = 49;
                                return (0, $fGnsQ.default)();
                            case 49:
                                _i++;
                                _context2.next = 25;
                                break;
                            case 52:
                                return _context2.abrupt("return", result);
                            case 53:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getVCPercentMetrics(_x2, _x3) {
                    return _getVCPercentMetrics.apply(this, arguments);
                }
                return getVCPercentMetrics;
            }()
        }
    ]);
}();
function $fe7b97a105149302$export$2e2bcd8739ae039(_x4) {
    return $fe7b97a105149302$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $fe7b97a105149302$var$_calculateTTVCPercentiles() {
    $fe7b97a105149302$var$_calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(_ref2) {
        var orderedEntries, viewport, percentiles, startTime, heatmap, vcDetails;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    orderedEntries = _ref2.orderedEntries, viewport = _ref2.viewport, percentiles = _ref2.percentiles, startTime = _ref2.startTime;
                    heatmap = new $fe7b97a105149302$var$Heatmap({
                        viewport: viewport,
                        heatmapSize: 200
                    });
                    _context3.next = 4;
                    return heatmap.applyEntriesToHeatmap(orderedEntries);
                case 4:
                    _context3.next = 6;
                    return heatmap.getVCPercentMetrics(percentiles, startTime);
                case 6:
                    vcDetails = _context3.sent;
                    return _context3.abrupt("return", vcDetails);
                case 8:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $fe7b97a105149302$var$_calculateTTVCPercentiles.apply(this, arguments);
}

});
parcelRegister("20p1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $175efe4d72156a4c$export$2e2bcd8739ae039);
function $175efe4d72156a4c$export$2e2bcd8739ae039(data) {
    if (data) {
        var hasElementName = typeof data.elementName === "string";
        var hasRect = typeof data.rect !== "undefined";
        if (hasRect && hasElementName) return true;
    }
    return false;
}

});


parcelRegister("lNVa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdfa83e1ae0de27c$export$2e2bcd8739ae039);

var $fUHKi = parcelRequire("fUHKi");

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");

var $20p1C = parcelRequire("20p1C");

var $fGnsQ = parcelRequire("fGnsQ");

var $1HaBO = parcelRequire("1HaBO");
function $fdfa83e1ae0de27c$export$2e2bcd8739ae039(_x) {
    return $fdfa83e1ae0de27c$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $fdfa83e1ae0de27c$var$_calculateTTVCPercentiles() {
    $fdfa83e1ae0de27c$var$_calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(_ref) {
        var orderedEntries, viewport, percentiles, startTime, sortedPercentiles, viewportArea, checkpoints, activeRects, removeActiveRect, domElementsBuffer, i, iEntry, iEntryData, rect, elementName, exclusionArea, currentArea, currVCPercent, matchesAnyCheckpoints, _checkpoint, domElements;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    orderedEntries = _ref.orderedEntries, viewport = _ref.viewport, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    sortedPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(percentiles).sort(function(a, b) {
                        return a - b;
                    });
                    viewportArea = viewport.width * viewport.height;
                    checkpoints = {};
                    activeRects = orderedEntries.filter(function(e) {
                        return (0, $20p1C.default)(e.data);
                    }).map(function(e) {
                        return e.data.rect;
                    });
                    removeActiveRect = function removeActiveRect(rectToRemove) {
                        var index = activeRects.indexOf(rectToRemove);
                        // Check if the element exists in the array
                        if (index !== -1) // Remove the element at the found index
                        activeRects.splice(index, 1);
                    };
                    domElementsBuffer = new Set();
                    i = 0;
                case 8:
                    if (!(i < orderedEntries.length)) {
                        _context.next = 36;
                        break;
                    }
                    iEntry = orderedEntries[i];
                    iEntryData = iEntry.data;
                    if ((0, $20p1C.default)(iEntryData)) {
                        _context.next = 13;
                        break;
                    }
                    return _context.abrupt("continue", 33);
                case 13:
                    rect = iEntryData.rect, elementName = iEntryData.elementName;
                    domElementsBuffer.add(elementName);
                    removeActiveRect(rect);
                    exclusionArea = (0, $1HaBO.default)(activeRects);
                    currentArea = viewportArea - exclusionArea;
                    currVCPercent = Math.round(currentArea / viewportArea * 100);
                    matchesAnyCheckpoints = false;
                case 20:
                    if (!(sortedPercentiles.length > 0 && currVCPercent >= sortedPercentiles[0])) {
                        _context.next = 29;
                        break;
                    }
                    _checkpoint = sortedPercentiles.shift();
                    domElements = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(domElementsBuffer);
                    if (_checkpoint) {
                        _context.next = 25;
                        break;
                    }
                    return _context.abrupt("break", 29);
                case 25:
                    matchesAnyCheckpoints = true;
                    checkpoints[_checkpoint.toString()] = {
                        t: Math.round(iEntry.time - startTime),
                        e: domElements
                    };
                    _context.next = 20;
                    break;
                case 29:
                    if (matchesAnyCheckpoints) domElementsBuffer.clear();
                    if (!(i % 500 === 0)) {
                        _context.next = 33;
                        break;
                    }
                    _context.next = 33;
                    return (0, $fGnsQ.default)();
                case 33:
                    i++;
                    _context.next = 8;
                    break;
                case 36:
                    return _context.abrupt("return", checkpoints);
                case 37:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $fdfa83e1ae0de27c$var$_calculateTTVCPercentiles.apply(this, arguments);
}

});
parcelRegister("1HaBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $13c2094de8387826$export$2e2bcd8739ae039);

var $02Ztr = parcelRequire("02Ztr");

var $fUHKi = parcelRequire("fUHKi");
function $13c2094de8387826$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $13c2094de8387826$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $13c2094de8387826$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $13c2094de8387826$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $13c2094de8387826$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $13c2094de8387826$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $13c2094de8387826$export$2e2bcd8739ae039(rectangles) {
    // Step 1: Create sweep line events
    var events = $13c2094de8387826$var$createSweepLineEvents(rectangles);
    // Step 2: Process events to calculate total area
    var activeIntervals = new Map();
    var totalArea = 0;
    var previousX = 0;
    for(var _i = 0, _events = events; _i < _events.length; _i++){
        var event = _events[_i];
        // Calculate height at current x-position
        var currentHeight = $13c2094de8387826$var$calculateActiveHeight(activeIntervals);
        // Add area since last x-position
        totalArea += currentHeight * (event.x - previousX);
        // Update x-position
        previousX = event.x;
        // Update active intervals
        $13c2094de8387826$var$updateActiveIntervals(activeIntervals, event);
    }
    return totalArea;
}
function $13c2094de8387826$var$createSweepLineEvents(rectangles) {
    var events = [];
    var _iterator = $13c2094de8387826$var$_createForOfIteratorHelper(rectangles), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var rect = _step.value;
            // Create start and end events for each rectangle
            events.push({
                x: rect.left,
                type: "start",
                top: rect.top,
                bottom: rect.bottom
            });
            events.push({
                x: rect.right,
                type: "end",
                top: rect.top,
                bottom: rect.bottom
            });
        }
    // Sort events by x-coordinate (and type as tiebreaker)
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return events.sort(function(a, b) {
        return a.x === b.x ? a.type === "end" ? 1 : -1 : a.x - b.x;
    });
}
function $13c2094de8387826$var$calculateActiveHeight(intervals) {
    if (intervals.size === 0) return 0;
    // Get all unique y-coordinates
    var coordinates = [];
    var _iterator2 = $13c2094de8387826$var$_createForOfIteratorHelper(intervals), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_step2.value, 1), _key = _step2$value[0];
            var _key$split$map3 = _key.split(",").map(Number), _key$split$map4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_key$split$map3, 2), _start = _key$split$map4[0], _end = _key$split$map4[1];
            coordinates.push(_start, _end);
        }
    // Sort coordinates
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var sortedCoords = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set(coordinates)).sort(function(a, b) {
        return a - b;
    });
    var totalHeight = 0;
    // Check each segment between consecutive coordinates
    for(var i = 0; i < sortedCoords.length; i++){
        var y1 = sortedCoords[i];
        var y2 = sortedCoords[i + 1];
        // Check if this segment is covered by any active interval
        var covered = false;
        var _iterator3 = $13c2094de8387826$var$_createForOfIteratorHelper(intervals), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var _step3$value = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_step3.value, 2), key = _step3$value[0], count = _step3$value[1];
                if (count <= 0) continue;
                var _key$split$map = key.split(",").map(Number), _key$split$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_key$split$map, 2), start = _key$split$map2[0], end = _key$split$map2[1];
                if (start <= y1 && end >= y2) {
                    covered = true;
                    break;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        if (covered) totalHeight += y2 - y1;
    }
    return totalHeight;
}
function $13c2094de8387826$var$updateActiveIntervals(intervals, event) {
    var key = "".concat(event.top, ",").concat(event.bottom);
    if (event.type === "start") intervals.set(key, (intervals.get(key) || 0) + 1);
    else {
        var count = intervals.get(key) || 0;
        if (count > 1) intervals.set(key, count - 1);
        else intervals.delete(key);
    }
}

});



parcelRegister("9sV5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e430301f5475e24$export$2e2bcd8739ae039);
function $6e430301f5475e24$export$2e2bcd8739ae039() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});

parcelRegister("eJHlM", function(module, exports) {

$parcel$export(module.exports, "default", () => $aba6e5229fc843c9$export$2e2bcd8739ae039);
function $aba6e5229fc843c9$export$2e2bcd8739ae039() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}

});



parcelRegister("9TRzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7352cdd194079632$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $dBXFJ = parcelRequire("dBXFJ");

var $1Uq64 = parcelRequire("1Uq64");

var $9E5ux = parcelRequire("9E5ux");

var $bGYmR = parcelRequire("bGYmR");
function $7352cdd194079632$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7352cdd194079632$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7352cdd194079632$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7352cdd194079632$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7352cdd194079632$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7352cdd194079632$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7352cdd194079632$var$isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            // @ts-expect-error
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}
function $7352cdd194079632$var$sameRectSize(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height;
}
function $7352cdd194079632$var$sameRectDimensions(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height && a.x === b.x && a.y === b.y;
}
var $7352cdd194079632$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ViewportObserver(_ref) {
        var _this = this;
        var onChange = _ref.onChange;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ViewportObserver);
        this.mapVisibleNodeRects = new WeakMap();
        this.intersectionObserver = (0, $1Uq64.createIntersectionObserver)({
            onEntry: function onEntry(_ref2) {
                var target = _ref2.target, rect = _ref2.rect, time = _ref2.time, type = _ref2.type, mutationData = _ref2.mutationData;
                if (!target) return;
                var visible = $7352cdd194079632$var$isElementVisible(target);
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                _this.mapVisibleNodeRects.set(target, rect);
                onChange({
                    time: time,
                    type: type,
                    elementRef: new WeakRef(target),
                    visible: visible,
                    rect: rect,
                    previousRect: lastElementRect,
                    mutationData: mutationData
                });
            }
        });
        this.mutationObserver = (0, $9E5ux.default)({
            onChildListMutation: function onChildListMutation(_ref3) {
                var _removedNodes$map;
                var addedNodes = _ref3.addedNodes, removedNodes = _ref3.removedNodes;
                var removedNodeRects = (_removedNodes$map = removedNodes === null || removedNodes === void 0 ? void 0 : removedNodes.map(function(n) {
                    return _this.mapVisibleNodeRects.get(n);
                })) !== null && _removedNodes$map !== void 0 ? _removedNodes$map : [];
                addedNodes.forEach(function(addedNode) {
                    var _this$intersectionObs3;
                    // for (const elem of addedNode.querySelectorAll('*')) {
                    // 	this.intersectionObserver?.watchAndTag(elem, 'mutation:child-element');
                    // }
                    var sameDeletedNode = removedNodes.find(function(n) {
                        return n.isEqualNode(addedNode);
                    });
                    if (sameDeletedNode) {
                        var _this$intersectionObs;
                        (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, "mutation:remount");
                        return;
                    }
                    if ((0, $dBXFJ.isContainedWithinMediaWrapper)(addedNode)) {
                        var _this$intersectionObs2;
                        (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(addedNode, "mutation:media");
                        return;
                    }
                    (_this$intersectionObs3 = _this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.watchAndTag(addedNode, function(_ref4) {
                        var rect = _ref4.rect;
                        var wasDeleted = removedNodeRects.some(function(nr) {
                            return $7352cdd194079632$var$sameRectDimensions(nr, rect);
                        });
                        if (wasDeleted) return "mutation:element-replacement";
                        return "mutation:element";
                    });
                });
            },
            onAttributeMutation: function onAttributeMutation(_ref5) {
                var _this$intersectionObs4;
                var target = _ref5.target, attributeName = _ref5.attributeName;
                (_this$intersectionObs4 = _this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.watchAndTag(target, function(_ref6) {
                    var target = _ref6.target, rect = _ref6.rect;
                    if ((0, $dBXFJ.isContainedWithinMediaWrapper)(target)) return {
                        type: "mutation:media",
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    var lastElementRect = _this.mapVisibleNodeRects.get(target);
                    if (lastElementRect && $7352cdd194079632$var$sameRectSize(rect, lastElementRect)) return {
                        type: "mutation:attribute:no-layout-shift",
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    return {
                        type: "mutation:attribute",
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                });
            }
        });
        this.performanceObserver = (0, $bGYmR.default)({
            onLayoutShift: function onLayoutShift(_ref7) {
                var time = _ref7.time, changedRects = _ref7.changedRects;
                var _iterator = $7352cdd194079632$var$_createForOfIteratorHelper(changedRects), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var changedRect = _step.value;
                        var target = changedRect.node;
                        if (target) onChange({
                            time: time,
                            elementRef: new WeakRef(target),
                            visible: true,
                            rect: changedRect.rect,
                            previousRect: changedRect.previousRect,
                            type: "layout-shift"
                        });
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ViewportObserver, [
        {
            key: "start",
            value: function start() {
                var _this$mutationObserve, _this$performanceObse;
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
                    type: "layout-shift",
                    buffered: true,
                    // @ts-ignore-error
                    durationThreshold: 30
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$mutationObserve2, _this$intersectionObs5, _this$performanceObse2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs5 = this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.disconnect();
                (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
            }
        }
    ]);
}();

});
parcelRegister("1Uq64", function(module, exports) {

$parcel$export(module.exports, "createIntersectionObserver", () => $163f43b4e07ea714$export$c3799d33e0ae80a5);
function $163f43b4e07ea714$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $163f43b4e07ea714$export$c3799d33e0ae80a5(args) {
    if (!window || typeof window.IntersectionObserver !== "function") return null;
    var callbacksPerElement = new WeakMap();
    var observer = new IntersectionObserver(function(entries) {
        var _args$onObserved;
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(entry.target instanceof HTMLElement) || !$163f43b4e07ea714$var$isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === "function") {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = "unknown";
                else if (typeof tagOrCallbackResult === "string") mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === "string") mutationTag = tagOrCallback;
            args.onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : "unknown",
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        (_args$onObserved = args.onObserved) === null || _args$onObserved === void 0 || _args$onObserved.call(args, {
            time: startTime,
            elements: validEntries
        });
    });
    return {
        disconnect: function disconnect() {
            observer.disconnect();
        },
        unobserve: function unobserve(target) {
            observer.unobserve(target);
        },
        watchAndTag: function watchAndTag(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});

parcelRegister("9E5ux", function(module, exports) {

$parcel$export(module.exports, "default", () => $705c1bf7bec04c3d$export$2e2bcd8739ae039);
function $705c1bf7bec04c3d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $705c1bf7bec04c3d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $705c1bf7bec04c3d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $705c1bf7bec04c3d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $705c1bf7bec04c3d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $705c1bf7bec04c3d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $705c1bf7bec04c3d$export$2e2bcd8739ae039(_ref) {
    var onAttributeMutation = _ref.onAttributeMutation, onChildListMutation = _ref.onChildListMutation, onMutationFinished = _ref.onMutationFinished;
    if (!window || typeof window.IntersectionObserver !== "function") return null;
    var observer = new MutationObserver(function(mutations) {
        var addedNodes = [];
        var removedNodes = [];
        var targets = [];
        var _iterator = $705c1bf7bec04c3d$var$_createForOfIteratorHelper(mutations), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var mut = _step.value;
                if (!(mut.target instanceof HTMLElement)) continue;
                if (mut.type === "attributes") {
                    var _mut$attributeName;
                    onAttributeMutation({
                        target: mut.target,
                        attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : "unknown"
                    });
                    continue;
                } else if (mut.type === "childList") {
                    var _mut$addedNodes, _mut$removedNodes;
                    ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) addedNodes.push(node);
                    });
                    ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) removedNodes.push(node);
                    });
                }
                targets.push(mut.target);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        onChildListMutation({
            addedNodes: addedNodes,
            removedNodes: removedNodes
        });
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    });
    return observer;
}

});

parcelRegister("bGYmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $883271b7c4771e6a$export$2e2bcd8739ae039);
function $883271b7c4771e6a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $883271b7c4771e6a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $883271b7c4771e6a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $883271b7c4771e6a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $883271b7c4771e6a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $883271b7c4771e6a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $883271b7c4771e6a$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== "number") return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $883271b7c4771e6a$export$2e2bcd8739ae039(args) {
    if (!window || typeof window.PerformanceObserver !== "function") return null;
    var onLayoutShift = args.onLayoutShift;
    var observer = new PerformanceObserver(function(entries) {
        var _iterator = $883271b7c4771e6a$var$_createForOfIteratorHelper(entries.getEntries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.entryType === "layout-shift") {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: $883271b7c4771e6a$export$5e3f54cad8cb65e2(attr.currentRect),
                            previousRect: $883271b7c4771e6a$export$5e3f54cad8cb65e2(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return observer;
}

});


parcelRegister("e04yf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3149895fc683fd9$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");
var $a3149895fc683fd9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WindowEventObserver(opts) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, WindowEventObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbindFns", []);
        this.onEvent = opts.onEvent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, $8fY35.bind)(window, {
                    type: type,
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent("wheel");
                this.bindEvent("scroll");
                this.bindEvent("keydown");
                this.bindEvent("resize");
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
}();

});



parcelRegister("5nWMQ", function(module, exports) {

$parcel$export(module.exports, "interactions", () => $3ebcb397dda2ede3$export$cc97b17ef9aeb088);
var $3ebcb397dda2ede3$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("a91DW", function(module, exports) {

$parcel$export(module.exports, "default", () => $762c04f84f99b90c$export$2e2bcd8739ae039);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $b4vGv = parcelRequire("b4vGv");

var $gXXlM = parcelRequire("gXXlM");
function $762c04f84f99b90c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $762c04f84f99b90c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $762c04f84f99b90c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $762c04f84f99b90c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $762c04f84f99b90c$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $762c04f84f99b90c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sinkTimeoutId", null);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sinkHandlerFn", function() {});
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $gXXlM.VCObserver)($762c04f84f99b90c$var$_objectSpread($762c04f84f99b90c$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function() {
                var _sendPostInteractionLog = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee() {
                    var _this$vcObserver3, _getConfig2;
                    var _getConfig, _this$vcObserver2, postInteractionFinishVCResult, _this$vcObserver4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn)) {
                                    _context.next = 4;
                                    break;
                                }
                                this.reset();
                                if ((_getConfig = (0, $b4vGv.getConfig)()) !== null && _getConfig !== void 0 && (_getConfig = _getConfig.experimentalInteractionMetrics) !== null && _getConfig !== void 0 && _getConfig.enabled) (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
                                return _context.abrupt("return");
                            case 4:
                                _context.next = 6;
                                return (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 ? void 0 : _this$vcObserver3.getVCResult($762c04f84f99b90c$var$_objectSpread({
                                    start: this.lastInteractionFinish.start,
                                    stop: performance.now(),
                                    tti: -1,
                                    // no need for TTI value here
                                    isEventAborted: !!this.lastInteractionFinish.abortReason,
                                    prefix: "ufo"
                                }, this.vcObserverSSRConfig));
                            case 6:
                                postInteractionFinishVCResult = _context.sent;
                                if ((_getConfig2 = (0, $b4vGv.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.experimentalInteractionMetrics) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) (_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 || _this$vcObserver4.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
                                });
                                this.reset();
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function sendPostInteractionLog() {
                    return _sendPostInteractionLog.apply(this, arguments);
                }
                return sendPostInteractionLog;
            }()
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig3, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type, experimentalTTAI = _ref2.experimentalTTAI, experimentalVC90 = _ref2.experimentalVC90;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                };
                var timeout = ((_getConfig3 = (0, $b4vGv.getConfig)()) === null || _getConfig3 === void 0 ? void 0 : _getConfig3.timeWindowForLateMutationsInMilliseconds) || $762c04f84f99b90c$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return _this.sendPostInteractionLog();
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                })), timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        }
    ]);
}();

});


parcelRegister("dVxap", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kYYea").then(()=>parcelRequire("cdcn8"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("5NceL", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $437b056ac5350794$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $437b056ac5350794$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $437b056ac5350794$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $437b056ac5350794$export$2e2bcd8739ae039);

var $ltooA = parcelRequire("ltooA");
var $437b056ac5350794$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
/**
 * Contrast preferences: The system contrast preference
 */ var $437b056ac5350794$var$themeContrastModes = [
    "more",
    "no-preference",
    "auto"
];
var $437b056ac5350794$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $437b056ac5350794$var$themeOverrideIds = [];
var $437b056ac5350794$export$92ba366331403db2 = [].concat($437b056ac5350794$export$7d43e72a58e3283f, $437b056ac5350794$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $437b056ac5350794$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $437b056ac5350794$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: function typography() {
        if ((0, $ltooA.fg)("platform-default-typography-modernized")) return "typography-modernized";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $437b056ac5350794$export$2e2bcd8739ae039 = $437b056ac5350794$var$themeConfig;

});

parcelRegister("hM7vC", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $cf0cbe79b9488419$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $cf0cbe79b9488419$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $cf0cbe79b9488419$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $cf0cbe79b9488419$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $cf0cbe79b9488419$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $cf0cbe79b9488419$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $cf0cbe79b9488419$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $cf0cbe79b9488419$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $cf0cbe79b9488419$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $cf0cbe79b9488419$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $cf0cbe79b9488419$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $cf0cbe79b9488419$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $cf0cbe79b9488419$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $cf0cbe79b9488419$export$b36dbdb4f463f05c(hex) {
    if (!$cf0cbe79b9488419$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $cf0cbe79b9488419$export$1212645cf40ebf71(hex)
    ];
}
function $cf0cbe79b9488419$export$5a544e13ad4e1fa5(hex) {
    if (!$cf0cbe79b9488419$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $cf0cbe79b9488419$export$47ea145a83f50dc0(hex) {
    if (!$cf0cbe79b9488419$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $cf0cbe79b9488419$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $cf0cbe79b9488419$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $cf0cbe79b9488419$export$d061e26956a60b0a(foreground, background) {
    if (!$cf0cbe79b9488419$var$isValidHex(foreground) || !$cf0cbe79b9488419$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $cf0cbe79b9488419$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $cf0cbe79b9488419$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $cf0cbe79b9488419$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $cf0cbe79b9488419$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $cf0cbe79b9488419$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $cf0cbe79b9488419$var$rgbToLab(rgbA);
    var labB = $cf0cbe79b9488419$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $cf0cbe79b9488419$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("klQHf", function(module, exports) {

$parcel$export(module.exports, "hash", () => $ed0ea53e8a1fecc7$export$d6af199866bfb566);
var $ed0ea53e8a1fecc7$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("8Ex6V", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("rEW7g").then(()=>parcelRequire("cusNu"));

});

parcelRegister("lH96A", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8866c").then(()=>parcelRequire("4cp9X"));

});

parcelRegister("1Lc0l", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gBdVF").then(()=>parcelRequire("1gEOj"));

});

parcelRegister("9Bi5g", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("952Nd").then(()=>parcelRequire("1u3hM"));

});

parcelRegister("3J0Ly", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7ZaF9").then(()=>parcelRequire("kI1gl"));

});

parcelRegister("b7Xwx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bs3J9").then(()=>parcelRequire("dN7zS"));

});

parcelRegister("hR0TH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6xqMO").then(()=>parcelRequire("8Qtve"));

});

parcelRegister("n9MS2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5EV3L").then(()=>parcelRequire("658iW"));

});

parcelRegister("k92Of", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aVmNA").then(()=>parcelRequire("flZwp"));

});

parcelRegister("kBQNP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("53UTJ").then(()=>parcelRequire("6IVyQ"));

});

parcelRegister("g5OPz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("EIWVS").then(()=>parcelRequire("71NW9"));

});

parcelRegister("8Rge0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kf8JK").then(()=>parcelRequire("8r5wM"));

});

parcelRegister("lDv3h", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eAzhj").then(()=>parcelRequire("3RDzf"));

});

parcelRegister("iO3vf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ireJI").then(()=>parcelRequire("92KhO"));

});

parcelRegister("73N7s", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("g4gq9").then(()=>parcelRequire("5VEYa"));

});

parcelRegister("lXhZa", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $ffbd0f3b346011dd$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $ffbd0f3b346011dd$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $ffbd0f3b346011dd$export$e673f367da2ff23e);

var $02Ztr = parcelRequire("02Ztr");

var $fUHKi = parcelRequire("fUHKi");

var $1deXG = parcelRequire("1deXG");

var $cfuBi = parcelRequire("cfuBi");

var $klQHf = parcelRequire("klQHf");
function $ffbd0f3b346011dd$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $klQHf.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $cfuBi.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $cfuBi.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $ffbd0f3b346011dd$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.from(document.head.querySelectorAll("style[".concat((0, $cfuBi.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $cfuBi.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $ffbd0f3b346011dd$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $1deXG.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});
parcelRegister("1deXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e229c6308825451$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02412877f3dbfda4dbaee7a917f24b6c>>
 * @codegenCommand yarn build tokens
 */ var $0e229c6308825451$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body"
};
var $0e229c6308825451$export$2e2bcd8739ae039 = $0e229c6308825451$var$tokens;

});


parcelRegister("ifbJw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4r2dB").then(()=>parcelRequire("lTRum"));

});

parcelRegister("dnCk4", function(module, exports) {

$parcel$export(module.exports, "R50", () => $9bdb266b04d49690$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R300", () => $9bdb266b04d49690$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $9bdb266b04d49690$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $9bdb266b04d49690$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $9bdb266b04d49690$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $9bdb266b04d49690$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $9bdb266b04d49690$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y300", () => $9bdb266b04d49690$export$c6930421db9fa514);
$parcel$export(module.exports, "Y400", () => $9bdb266b04d49690$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $9bdb266b04d49690$export$874739ea9e379ab6);
$parcel$export(module.exports, "G50", () => $9bdb266b04d49690$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G300", () => $9bdb266b04d49690$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $9bdb266b04d49690$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $9bdb266b04d49690$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $9bdb266b04d49690$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $9bdb266b04d49690$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $9bdb266b04d49690$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $9bdb266b04d49690$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $9bdb266b04d49690$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $9bdb266b04d49690$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $9bdb266b04d49690$export$a6ee3d71bc067634);
$parcel$export(module.exports, "P50", () => $9bdb266b04d49690$export$363e4475840015bb);
$parcel$export(module.exports, "P300", () => $9bdb266b04d49690$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $9bdb266b04d49690$export$147899de772240ec);
$parcel$export(module.exports, "N0", () => $9bdb266b04d49690$export$29a4f05edc054374);
$parcel$export(module.exports, "N10", () => $9bdb266b04d49690$export$e655ef011c4aa1a2);
$parcel$export(module.exports, "N20", () => $9bdb266b04d49690$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $9bdb266b04d49690$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $9bdb266b04d49690$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N70", () => $9bdb266b04d49690$export$5f71e19f3a7ad9de);
$parcel$export(module.exports, "N90", () => $9bdb266b04d49690$export$7c87d337fb91a97d);
$parcel$export(module.exports, "N100", () => $9bdb266b04d49690$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $9bdb266b04d49690$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $9bdb266b04d49690$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $9bdb266b04d49690$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $9bdb266b04d49690$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $9bdb266b04d49690$export$7090862dc3038a9f);
$parcel$export(module.exports, "N700", () => $9bdb266b04d49690$export$ad0bacf983b7ddaa);
$parcel$export(module.exports, "N800", () => $9bdb266b04d49690$export$7d61b15e0da132af);
$parcel$export(module.exports, "N900", () => $9bdb266b04d49690$export$fbda843f0a27fe96);
$parcel$export(module.exports, "N20A", () => $9bdb266b04d49690$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $9bdb266b04d49690$export$920c0d5c49070351);
$parcel$export(module.exports, "N50A", () => $9bdb266b04d49690$export$7d3359664e8bb0e5);
$parcel$export(module.exports, "N60A", () => $9bdb266b04d49690$export$d2d3bedfb276cac0);
$parcel$export(module.exports, "N100A", () => $9bdb266b04d49690$export$486ab785e4bac3c6);
$parcel$export(module.exports, "DN400", () => $9bdb266b04d49690$export$abcf8c38338b4aa5);
$parcel$export(module.exports, "DN300", () => $9bdb266b04d49690$export$97e81faa16a182c7);
$parcel$export(module.exports, "DN100", () => $9bdb266b04d49690$export$ee82aa2ea6a1558);
$parcel$export(module.exports, "DN70", () => $9bdb266b04d49690$export$d281fbfe3cff2df6);
$parcel$export(module.exports, "DN60", () => $9bdb266b04d49690$export$3902c91d8b98a753);
$parcel$export(module.exports, "DN30", () => $9bdb266b04d49690$export$633847cf062b69e0);
$parcel$export(module.exports, "DN0", () => $9bdb266b04d49690$export$3d4f271a500072a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $9bdb266b04d49690$export$4b84fd0e2c617bd = "#FFEBE6";
var $9bdb266b04d49690$export$b34b069eff244586 = "#FFBDAD";
var $9bdb266b04d49690$export$be802dd0d8b57f35 = "#FF8F73";
var $9bdb266b04d49690$export$60847d42f9da92a6 = "#FF7452";
var $9bdb266b04d49690$export$4a7404f376229999 = "#FF5630";
var $9bdb266b04d49690$export$2010d0fb4295b346 = "#DE350B";
var $9bdb266b04d49690$export$2837b5a1a71d5c02 = "#BF2600";
var $9bdb266b04d49690$export$8d9596b529bbb9cf = "#FFFAE6";
var $9bdb266b04d49690$export$41060a744ab0b7ae = "#FFF0B3";
var $9bdb266b04d49690$export$1cc05bbbf340e559 = "#FFE380";
var $9bdb266b04d49690$export$5aae31392d72caaa = "#FFC400";
var $9bdb266b04d49690$export$c6930421db9fa514 = "#FFAB00";
var $9bdb266b04d49690$export$59619663aa6500fb = "#FF991F";
var $9bdb266b04d49690$export$874739ea9e379ab6 = "#FF8B00";
var $9bdb266b04d49690$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $9bdb266b04d49690$export$69a3bf21b9686c2b = "#ABF5D1";
var $9bdb266b04d49690$export$afbce1382ec95f73 = "#79F2C0";
var $9bdb266b04d49690$export$747d86715d4175de = "#57D9A3";
var $9bdb266b04d49690$export$940e1f69e873f202 = "#36B37E";
var $9bdb266b04d49690$export$a49394138f7b8e85 = "#00875A";
var $9bdb266b04d49690$export$6fa04827ac68a4fb = "#006644";
var $9bdb266b04d49690$export$226de0355ed012f8 = "#DEEBFF";
var $9bdb266b04d49690$export$8c13c2ee36917869 = "#B3D4FF";
var $9bdb266b04d49690$export$ecfc1dff386a3e7a = "#4C9AFF";
var $9bdb266b04d49690$export$215b7063051591f1 = "#2684FF";
var $9bdb266b04d49690$export$e62e8919cca44969 = "#0065FF";
var $9bdb266b04d49690$export$b3de0ae08da2ce64 = "#0052CC";
var $9bdb266b04d49690$export$a6ee3d71bc067634 = "#0747A6";
var $9bdb266b04d49690$export$67f15409e87642a1 = "#669DF1";
var $9bdb266b04d49690$export$f0539dbc42dbb067 = "#8FB8F6";
var $9bdb266b04d49690$export$363e4475840015bb = "#EAE6FF";
var $9bdb266b04d49690$export$4b0a4417ed59760f = "#C0B6F2";
var $9bdb266b04d49690$export$6011520a64d9a187 = "#998DD9";
var $9bdb266b04d49690$export$a7175d4e9206bc80 = "#8777D9";
var $9bdb266b04d49690$export$b48405b95304b5a1 = "#6554C0";
var $9bdb266b04d49690$export$c71e4279dd54a18d = "#5243AA";
var $9bdb266b04d49690$export$147899de772240ec = "#403294";
var $9bdb266b04d49690$export$2cf711fe14c66f06 = "#E6FCFF";
var $9bdb266b04d49690$export$7a8f4d33f6f9772c = "#B3F5FF";
var $9bdb266b04d49690$export$776c9c497ef08533 = "#79E2F2";
var $9bdb266b04d49690$export$69cb3ca10c1e330e = "#00C7E6";
var $9bdb266b04d49690$export$9dc1ef0f3f48059b = "#00B8D9";
var $9bdb266b04d49690$export$7c835c78b6fcdef8 = "#00A3BF";
var $9bdb266b04d49690$export$6036577f95c3877e = "#008DA6";
var $9bdb266b04d49690$export$29a4f05edc054374 = "#FFFFFF";
var $9bdb266b04d49690$export$e655ef011c4aa1a2 = "#FAFBFC";
var $9bdb266b04d49690$export$9fdfb749e33cdf97 = "#F4F5F7";
var $9bdb266b04d49690$export$3e51e8f1440314ba = "#EBECF0";
var $9bdb266b04d49690$export$1ce2d1575d444ceb = "#DFE1E6";
var $9bdb266b04d49690$export$8754fc7e6d8b3000 = "#C1C7D0";
var $9bdb266b04d49690$export$c2e91cbeada39b8b = "#B3BAC5";
var $9bdb266b04d49690$export$5f71e19f3a7ad9de = "#A5ADBA";
var $9bdb266b04d49690$export$eaa8c8a70ac22806 = "#97A0AF";
var $9bdb266b04d49690$export$7c87d337fb91a97d = "#8993A4";
var $9bdb266b04d49690$export$d6447c357493214f = "#7A869A";
var $9bdb266b04d49690$export$f563ee71e9ee74cd = "#6B778C";
var $9bdb266b04d49690$export$e2ef2124cf4024b1 = "#5E6C84";
var $9bdb266b04d49690$export$eece5f492e429f08 = "#505F79";
var $9bdb266b04d49690$export$c39c0fe0f26207ae = "#42526E";
var $9bdb266b04d49690$export$7090862dc3038a9f = "#344563";
var $9bdb266b04d49690$export$ad0bacf983b7ddaa = "#253858";
var $9bdb266b04d49690$export$7d61b15e0da132af = "#172B4D";
var $9bdb266b04d49690$export$fbda843f0a27fe96 = "#091E42";
var $9bdb266b04d49690$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $9bdb266b04d49690$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $9bdb266b04d49690$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $9bdb266b04d49690$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $9bdb266b04d49690$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $9bdb266b04d49690$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $9bdb266b04d49690$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $9bdb266b04d49690$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $9bdb266b04d49690$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $9bdb266b04d49690$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $9bdb266b04d49690$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $9bdb266b04d49690$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $9bdb266b04d49690$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $9bdb266b04d49690$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $9bdb266b04d49690$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $9bdb266b04d49690$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $9bdb266b04d49690$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $9bdb266b04d49690$export$2f6319cf7d736c2a = "#E6EDFA";
var $9bdb266b04d49690$export$95126bc8884d6634 = "#DCE5F5";
var $9bdb266b04d49690$export$8338d8c35d44ff1 = "#CED9EB";
var $9bdb266b04d49690$export$5368d76ae4fbbda7 = "#B8C7E0";
var $9bdb266b04d49690$export$9f0a771d16ec8d36 = "#ABBBD6";
var $9bdb266b04d49690$export$abcf8c38338b4aa5 = "#9FB0CC";
var $9bdb266b04d49690$export$97e81faa16a182c7 = "#8C9CB8";
var $9bdb266b04d49690$export$bfe21c59123ecf33 = "#7988A3";
var $9bdb266b04d49690$export$ee82aa2ea6a1558 = "#67758F";
var $9bdb266b04d49690$export$682927c6ed76be02 = "#56637A";
var $9bdb266b04d49690$export$91fd9994c5be9757 = "#455166";
var $9bdb266b04d49690$export$d281fbfe3cff2df6 = "#3B475C";
var $9bdb266b04d49690$export$3902c91d8b98a753 = "#313D52";
var $9bdb266b04d49690$export$8e8133c1ba5845b5 = "#283447";
var $9bdb266b04d49690$export$33ff357f6620b39 = "#202B3D";
var $9bdb266b04d49690$export$633847cf062b69e0 = "#1B2638";
var $9bdb266b04d49690$export$9776a6e503bdbf76 = "#121A29";
var $9bdb266b04d49690$export$6c813d5160dff5db = "#0E1624";
var $9bdb266b04d49690$export$3d4f271a500072a = "#0D1424";
var $9bdb266b04d49690$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $9bdb266b04d49690$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $9bdb266b04d49690$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $9bdb266b04d49690$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $9bdb266b04d49690$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $9bdb266b04d49690$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $9bdb266b04d49690$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $9bdb266b04d49690$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $9bdb266b04d49690$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $9bdb266b04d49690$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $9bdb266b04d49690$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $9bdb266b04d49690$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $9bdb266b04d49690$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $9bdb266b04d49690$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $9bdb266b04d49690$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $9bdb266b04d49690$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $9bdb266b04d49690$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $9bdb266b04d49690$export$d2adc5dedf09fced = "#292A2E";
var $9bdb266b04d49690$export$f51762073d2bb381 = "#94C748";
var $9bdb266b04d49690$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("ib4Hv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::257fef37d04db299e24e95484ff9b12f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3bce6894f1cfeb1$var$_react = $d3bce6894f1cfeb1$var$_interopRequireDefault((parcelRequire("acw62")));

var $d3bce6894f1cfeb1$var$_baseNew = $d3bce6894f1cfeb1$var$_interopRequireDefault((parcelRequire("feA4o")));
function $d3bce6894f1cfeb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3bce6894f1cfeb1$var$ErrorIcon = (props)=>/*#__PURE__*/ $d3bce6894f1cfeb1$var$_react.default.createElement($d3bce6894f1cfeb1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$d3bce6894f1cfeb1$var$ErrorIcon.displayName = "ErrorIcon";
var $d3bce6894f1cfeb1$var$_default = module.exports.default = $d3bce6894f1cfeb1$var$ErrorIcon;

});
parcelRegister("feA4o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("lvCqS")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("lvCqS")).Icon);

var $lvCqS = parcelRequire("lvCqS");

});
parcelRegister("lvCqS", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $fa8a4e1ca8c56cff$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $fa8a4e1ca8c56cff$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $ltooA = parcelRequire("ltooA");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $fa8a4e1ca8c56cff$var$commonSVGStyles = (0, $jjlaj.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $fa8a4e1ca8c56cff$var$svgStyles = (0, $jjlaj.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $fa8a4e1ca8c56cff$var$iconStyles = (0, $jjlaj.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $fa8a4e1ca8c56cff$var$utilityIconStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $fa8a4e1ca8c56cff$var$scaleStyles = (0, $jjlaj.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $fa8a4e1ca8c56cff$var$baseHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $fa8a4e1ca8c56cff$var$scaleSize = (0, $jjlaj.css)({
    width: "inherit",
    height: "inherit"
});
var $fa8a4e1ca8c56cff$var$sizeMap = {
    core: {
        none: (0, $jjlaj.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jjlaj.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $jjlaj.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $jjlaj.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jjlaj.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $fa8a4e1ca8c56cff$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $fa8a4e1ca8c56cff$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $fa8a4e1ca8c56cff$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $ltooA.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $jjlaj.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $fa8a4e1ca8c56cff$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $fa8a4e1ca8c56cff$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $fa8a4e1ca8c56cff$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return (0, $jjlaj.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        css: [
            $fa8a4e1ca8c56cff$var$iconStyles,
            $fa8a4e1ca8c56cff$var$baseHcmStyles,
            shouldScale && $fa8a4e1ca8c56cff$var$scaleStyles,
            props.type === "utility" && $fa8a4e1ca8c56cff$var$utilityIconStyles
        ]
    }, (0, $jjlaj.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $fa8a4e1ca8c56cff$var$commonSVGStyles,
            $fa8a4e1ca8c56cff$var$svgStyles,
            shouldScale ? $fa8a4e1ca8c56cff$var$scaleSize : props.type === "utility" ? $fa8a4e1ca8c56cff$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $fa8a4e1ca8c56cff$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $fa8a4e1ca8c56cff$export$2e2bcd8739ae039 = $fa8a4e1ca8c56cff$export$f04a61298a47a40f;

});



parcelRegister("eh3Ll", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a645926750c7bca5$var$_react = $a645926750c7bca5$var$_interopRequireDefault((parcelRequire("acw62")));

var $58rIq = parcelRequire("58rIq");

var $a645926750c7bca5$var$_error = $a645926750c7bca5$var$_interopRequireDefault((parcelRequire("ib4Hv")));
function $a645926750c7bca5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a645926750c7bca5$var$ErrorIcon = (props)=>/*#__PURE__*/ $a645926750c7bca5$var$_react.default.createElement($58rIq.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $a645926750c7bca5$var$_error.default
    }));
$a645926750c7bca5$var$ErrorIcon.displayName = "ErrorIcon";
var $a645926750c7bca5$var$_default = module.exports.default = $a645926750c7bca5$var$ErrorIcon;

});
parcelRegister("58rIq", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $3bd332d0d860848f$export$3cfb73f70dfca966);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $7Thnq = parcelRequire("7Thnq");
var $3bd332d0d860848f$var$_excluded = [
    "dangerouslySetGlyph"
];
var $3bd332d0d860848f$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $3bd332d0d860848f$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $3bd332d0d860848f$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $ltooA.fg)("platform-visual-refresh-icons-facade-button-fix") ? $3bd332d0d860848f$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $3bd332d0d860848f$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7Thnq.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("7Thnq", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $5beb262371f1cc5e$export$f04a61298a47a40f);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $e0vem = parcelRequire("e0vem");

var $iMFv3 = parcelRequire("iMFv3");
function $5beb262371f1cc5e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5beb262371f1cc5e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5beb262371f1cc5e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5beb262371f1cc5e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $5beb262371f1cc5e$var$iconStyles = (0, $jjlaj.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $5beb262371f1cc5e$var$_objectSpread($5beb262371f1cc5e$var$_objectSpread({}, (0, $e0vem.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $5beb262371f1cc5e$var$baseHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $5beb262371f1cc5e$var$primaryEqualsSecondaryHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $5beb262371f1cc5e$var$secondaryTransparentHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $5beb262371f1cc5e$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jjlaj.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $e0vem.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jjlaj.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $iMFv3.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $5beb262371f1cc5e$var$iconStyles,
            $5beb262371f1cc5e$var$baseHcmStyles,
            primaryColor === secondaryColor && $5beb262371f1cc5e$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $5beb262371f1cc5e$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jjlaj.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $5beb262371f1cc5e$export$2e2bcd8739ae039 = $5beb262371f1cc5e$export$f04a61298a47a40f;

});
parcelRegister("e0vem", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $a3294a82b6521b72$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $a3294a82b6521b72$export$3eb7d6130acfda37);

var $ge57l = parcelRequire("ge57l");

var $jjlaj = parcelRequire("jjlaj");
var $a3294a82b6521b72$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a3294a82b6521b72$var$smallStyles = (0, $jjlaj.css)((0, $ge57l.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a3294a82b6521b72$var$mediumStyles = (0, $jjlaj.css)((0, $ge57l.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a3294a82b6521b72$var$largeStyles = (0, $jjlaj.css)((0, $ge57l.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a3294a82b6521b72$var$xlargeStyles = (0, $jjlaj.css)((0, $ge57l.dimensions).xlarge);
var $a3294a82b6521b72$export$ef0ad74202575b64 = {
    small: $a3294a82b6521b72$var$smallStyles,
    medium: $a3294a82b6521b72$var$mediumStyles,
    large: $a3294a82b6521b72$var$largeStyles,
    xlarge: $a3294a82b6521b72$var$xlargeStyles
};
var $a3294a82b6521b72$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $ge57l.dimensions)[size];
    return undefined;
};

});
parcelRegister("ge57l", function(module, exports) {

$parcel$export(module.exports, "dimensions", () => $bd01ec5af3136cb1$export$62ad7b0c781000e9);
var $bd01ec5af3136cb1$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $bd01ec5af3136cb1$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $bd01ec5af3136cb1$export$62ad7b0c781000e9 = {
    small: {
        width: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.small,
        height: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.medium,
        height: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.large,
        height: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.xlarge,
        height: $bd01ec5af3136cb1$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("iMFv3", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $dacce6ae6934d567$export$18cb9425622d4e06);
var $dacce6ae6934d567$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("kztcQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11503d00887c85dd37060e980bd5f02d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef9dbb4abd6a4cbf$var$_react = $ef9dbb4abd6a4cbf$var$_interopRequireDefault((parcelRequire("acw62")));

var $ef9dbb4abd6a4cbf$var$_baseNew = $ef9dbb4abd6a4cbf$var$_interopRequireDefault((parcelRequire("feA4o")));
function $ef9dbb4abd6a4cbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef9dbb4abd6a4cbf$var$InformationIcon = (props)=>/*#__PURE__*/ $ef9dbb4abd6a4cbf$var$_react.default.createElement($ef9dbb4abd6a4cbf$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$ef9dbb4abd6a4cbf$var$InformationIcon.displayName = "InformationIcon";
var $ef9dbb4abd6a4cbf$var$_default = module.exports.default = $ef9dbb4abd6a4cbf$var$InformationIcon;

});

parcelRegister("jqqD2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e24519ef75c4d64e$var$_react = $e24519ef75c4d64e$var$_interopRequireDefault((parcelRequire("acw62")));

var $58rIq = parcelRequire("58rIq");

var $e24519ef75c4d64e$var$_information = $e24519ef75c4d64e$var$_interopRequireDefault((parcelRequire("kztcQ")));
function $e24519ef75c4d64e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e24519ef75c4d64e$var$InfoIcon = (props)=>/*#__PURE__*/ $e24519ef75c4d64e$var$_react.default.createElement($58rIq.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $e24519ef75c4d64e$var$_information.default
    }));
$e24519ef75c4d64e$var$InfoIcon.displayName = "InfoIcon";
var $e24519ef75c4d64e$var$_default = module.exports.default = $e24519ef75c4d64e$var$InfoIcon;

});

parcelRegister("9hXFR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8a54e77ebc6c63c295a0cd7c7e0eeda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c33fd9db01faa07$var$_react = $6c33fd9db01faa07$var$_interopRequireDefault((parcelRequire("acw62")));

var $6c33fd9db01faa07$var$_baseNew = $6c33fd9db01faa07$var$_interopRequireDefault((parcelRequire("feA4o")));
function $6c33fd9db01faa07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c33fd9db01faa07$var$SuccessIcon = (props)=>/*#__PURE__*/ $6c33fd9db01faa07$var$_react.default.createElement($6c33fd9db01faa07$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$6c33fd9db01faa07$var$SuccessIcon.displayName = "SuccessIcon";
var $6c33fd9db01faa07$var$_default = module.exports.default = $6c33fd9db01faa07$var$SuccessIcon;

});

parcelRegister("9yvRw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f50013474b9e33a$var$_react = $6f50013474b9e33a$var$_interopRequireDefault((parcelRequire("acw62")));

var $58rIq = parcelRequire("58rIq");

var $6f50013474b9e33a$var$_success = $6f50013474b9e33a$var$_interopRequireDefault((parcelRequire("9hXFR")));
function $6f50013474b9e33a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6f50013474b9e33a$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $6f50013474b9e33a$var$_react.default.createElement($58rIq.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $6f50013474b9e33a$var$_success.default
    }));
$6f50013474b9e33a$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $6f50013474b9e33a$var$_default = module.exports.default = $6f50013474b9e33a$var$CheckCircleIcon;

});

parcelRegister("6nmbG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1447c2d9394cec1fac504fd0d225fa23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a461a0060b3ee22$var$_react = $4a461a0060b3ee22$var$_interopRequireDefault((parcelRequire("acw62")));

var $4a461a0060b3ee22$var$_baseNew = $4a461a0060b3ee22$var$_interopRequireDefault((parcelRequire("feA4o")));
function $4a461a0060b3ee22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a461a0060b3ee22$var$WarningIcon = (props)=>/*#__PURE__*/ $4a461a0060b3ee22$var$_react.default.createElement($4a461a0060b3ee22$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$4a461a0060b3ee22$var$WarningIcon.displayName = "WarningIcon";
var $4a461a0060b3ee22$var$_default = module.exports.default = $4a461a0060b3ee22$var$WarningIcon;

});

parcelRegister("1I0Gl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13ea6ded91267d3c$var$_react = $13ea6ded91267d3c$var$_interopRequireDefault((parcelRequire("acw62")));

var $58rIq = parcelRequire("58rIq");

var $13ea6ded91267d3c$var$_warning = $13ea6ded91267d3c$var$_interopRequireDefault((parcelRequire("6nmbG")));
function $13ea6ded91267d3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $13ea6ded91267d3c$var$WarningIcon = (props)=>/*#__PURE__*/ $13ea6ded91267d3c$var$_react.default.createElement($58rIq.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $13ea6ded91267d3c$var$_warning.default
    }));
$13ea6ded91267d3c$var$WarningIcon.displayName = "WarningIcon";
var $13ea6ded91267d3c$var$_default = module.exports.default = $13ea6ded91267d3c$var$WarningIcon;

});

parcelRegister("eVxRg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ade0a712ce131adc$var$_react = $ade0a712ce131adc$var$_interopRequireDefault((parcelRequire("acw62")));

var $ade0a712ce131adc$var$_baseNew = $ade0a712ce131adc$var$_interopRequireDefault((parcelRequire("feA4o")));
function $ade0a712ce131adc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ade0a712ce131adc$var$CloseIcon = (props)=>/*#__PURE__*/ $ade0a712ce131adc$var$_react.default.createElement($ade0a712ce131adc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$ade0a712ce131adc$var$CloseIcon.displayName = "CloseIcon";
var $ade0a712ce131adc$var$_default = module.exports.default = $ade0a712ce131adc$var$CloseIcon;

});

parcelRegister("bsgYL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $856f7aedef48a228$var$_react = $856f7aedef48a228$var$_interopRequireDefault((parcelRequire("acw62")));

var $58rIq = parcelRequire("58rIq");

var $856f7aedef48a228$var$_close = $856f7aedef48a228$var$_interopRequireDefault((parcelRequire("eVxRg")));
function $856f7aedef48a228$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $856f7aedef48a228$var$CrossIcon = (props)=>/*#__PURE__*/ $856f7aedef48a228$var$_react.default.createElement($58rIq.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $856f7aedef48a228$var$_close.default
    }));
$856f7aedef48a228$var$CrossIcon.displayName = "CrossIcon";
var $856f7aedef48a228$var$_default = module.exports.default = $856f7aedef48a228$var$CrossIcon;

});

parcelRegister("sg1HA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a026656028c05157ac730015f665601>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $054f0c28a42c9a22$var$_react = $054f0c28a42c9a22$var$_interopRequireDefault((parcelRequire("acw62")));

var $054f0c28a42c9a22$var$_baseNew = $054f0c28a42c9a22$var$_interopRequireDefault((parcelRequire("feA4o")));
function $054f0c28a42c9a22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $054f0c28a42c9a22$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $054f0c28a42c9a22$var$_react.default.createElement($054f0c28a42c9a22$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.03 3.97 6 7.94l3.97-3.97 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$054f0c28a42c9a22$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $054f0c28a42c9a22$var$_default = module.exports.default = $054f0c28a42c9a22$var$ChevronDownIcon;

});

parcelRegister("hUoEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d09ac97c4d5c96c6$var$_react = $d09ac97c4d5c96c6$var$_interopRequireDefault((parcelRequire("acw62")));

var $58rIq = parcelRequire("58rIq");

var $d09ac97c4d5c96c6$var$_chevronDown = $d09ac97c4d5c96c6$var$_interopRequireDefault((parcelRequire("sg1HA")));
function $d09ac97c4d5c96c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d09ac97c4d5c96c6$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $d09ac97c4d5c96c6$var$_react.default.createElement($58rIq.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $d09ac97c4d5c96c6$var$_chevronDown.default,
        iconType: "utility"
    }));
$d09ac97c4d5c96c6$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $d09ac97c4d5c96c6$var$_default = module.exports.default = $d09ac97c4d5c96c6$var$HipchatChevronDownIcon;

});

parcelRegister("fqvUX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afcaa915720f5b4d9e69ee6ef0943c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3b20ae295cad039$var$_react = $b3b20ae295cad039$var$_interopRequireDefault((parcelRequire("acw62")));

var $b3b20ae295cad039$var$_baseNew = $b3b20ae295cad039$var$_interopRequireDefault((parcelRequire("feA4o")));
function $b3b20ae295cad039$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b3b20ae295cad039$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $b3b20ae295cad039$var$_react.default.createElement($b3b20ae295cad039$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 4.06 2.03 8.03.97 6.97l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5-1.06 1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$b3b20ae295cad039$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $b3b20ae295cad039$var$_default = module.exports.default = $b3b20ae295cad039$var$ChevronUpIcon;

});

parcelRegister("ihoUn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4ed22ceb5c8d966$var$_react = $d4ed22ceb5c8d966$var$_interopRequireDefault((parcelRequire("acw62")));

var $58rIq = parcelRequire("58rIq");

var $d4ed22ceb5c8d966$var$_chevronUp = $d4ed22ceb5c8d966$var$_interopRequireDefault((parcelRequire("fqvUX")));
function $d4ed22ceb5c8d966$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d4ed22ceb5c8d966$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $d4ed22ceb5c8d966$var$_react.default.createElement($58rIq.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $d4ed22ceb5c8d966$var$_chevronUp.default,
        iconType: "utility"
    }));
$d4ed22ceb5c8d966$var$HipchatChevronUpIcon.displayName = "HipchatChevronUpIcon";
var $d4ed22ceb5c8d966$var$_default = module.exports.default = $d4ed22ceb5c8d966$var$HipchatChevronUpIcon;

});

parcelRegister("bv4qN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f606e562c81b96$export$2e2bcd8739ae039);
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}

});

parcelRegister("lLUpG", function(module, exports) {

$parcel$export(module.exports, "draggable", () => (parcelRequire("9eYWs")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("9eYWs")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("9eYWs")).monitorForElements);

var $9eYWs = parcelRequire("9eYWs");
 // Payload for the draggable being dragged

});
parcelRegister("9eYWs", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", () => $6ba4b1aafdc6c74e$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $6ba4b1aafdc6c74e$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $6ba4b1aafdc6c74e$export$c746a5152d4ba26c);

var $02Ztr = parcelRequire("02Ztr");

var $8fY35 = parcelRequire("8fY35");

var $kk6Dv = parcelRequire("kk6Dv");

var $6QCyH = parcelRequire("6QCyH");

var $6WHuD = parcelRequire("6WHuD");

var $iedos = parcelRequire("iedos");

var $axaCz = parcelRequire("axaCz");

var $6AMEG = parcelRequire("6AMEG");

var $5ZupI = parcelRequire("5ZupI");

var $sJ9rD = parcelRequire("sJ9rD");

var $hZyk4 = parcelRequire("hZyk4");

var $kBeST = parcelRequire("kBeST");
var $6ba4b1aafdc6c74e$var$draggableRegistry = new WeakMap();
function $6ba4b1aafdc6c74e$var$addToRegistry(args) {
    $6ba4b1aafdc6c74e$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $6ba4b1aafdc6c74e$var$draggableRegistry.delete(args.element);
    };
}
var $6ba4b1aafdc6c74e$var$honeyPotFix = (0, $6QCyH.makeHoneyPotFix)();
var $6ba4b1aafdc6c74e$var$adapter = (0, $6WHuD.makeAdapter)({
    typeKey: "element",
    defaultDropEffect: "move",
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $iedos.combine)($6ba4b1aafdc6c74e$var$honeyPotFix.bindEvents(), (0, $8fY35.bind)(document, {
            type: "dragstart",
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $6ba4b1aafdc6c74e$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $5ZupI.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $kk6Dv.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : "");
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $6AMEG.isAndroid)() && !event.dataTransfer.types.includes((0, $sJ9rD.textMediaType)) && !event.dataTransfer.types.includes((0, $hZyk4.URLMediaType))) event.dataTransfer.setData((0, $sJ9rD.textMediaType), (0, $6AMEG.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $kBeST.elementAdapterNativeDataKey), "");
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: "element",
                    payload: payload,
                    startedFrom: "internal"
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $6ba4b1aafdc6c74e$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $6ba4b1aafdc6c74e$var$honeyPotFix.getOnPostDispatch()
});
var $6ba4b1aafdc6c74e$export$e7140b68045b5036 = $6ba4b1aafdc6c74e$var$adapter.dropTarget;
var $6ba4b1aafdc6c74e$export$59a074bac4c54f54 = $6ba4b1aafdc6c74e$var$adapter.monitor;
function $6ba4b1aafdc6c74e$export$c746a5152d4ba26c(args) {
    var existing;
    return (0, $iedos.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $6ba4b1aafdc6c74e$var$adapter.registerUsage(), $6ba4b1aafdc6c74e$var$addToRegistry(args), (0, $axaCz.addAttribute)(args.element, {
        attribute: "draggable",
        value: "true"
    }));
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("kk6Dv", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $ecbad2b94d3ba5d7$export$81d0353f25f5dd);

var $02Ztr = parcelRequire("02Ztr");

var $3s8a4 = parcelRequire("3s8a4");
function $ecbad2b94d3ba5d7$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $3s8a4.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("3s8a4", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", () => $283a5152aff51e26$export$821bdcd739a2706b);

var $7Oabr = parcelRequire("7Oabr");
function $283a5152aff51e26$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $7Oabr.honeyPotDataAttribute));
}

});
parcelRegister("7Oabr", function(module, exports) {

$parcel$export(module.exports, "honeyPotDataAttribute", () => $5af51a2135a003ac$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $5af51a2135a003ac$export$6eafea55f7947469 = "data-pdnd-honey-pot";

});



parcelRegister("6QCyH", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", () => $4fc58260d57fd988$export$8ecad27c959e89e0);

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $d2wQL = parcelRequire("d2wQL");

var $7Oabr = parcelRequire("7Oabr");
function $4fc58260d57fd988$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4fc58260d57fd988$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4fc58260d57fd988$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4fc58260d57fd988$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4fc58260d57fd988$var$honeyPotSize = 2;
var $4fc58260d57fd988$var$halfHoneyPotSize = $4fc58260d57fd988$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $4fc58260d57fd988$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $4fc58260d57fd988$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $4fc58260d57fd988$var$halfHoneyPotSize,
        y: point.y - $4fc58260d57fd988$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4fc58260d57fd988$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4fc58260d57fd988$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $4fc58260d57fd988$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $4fc58260d57fd988$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $4fc58260d57fd988$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $4fc58260d57fd988$var$preventGoingForwardsOffScreen($4fc58260d57fd988$var$preventGoingBackwardsOffScreen($4fc58260d57fd988$var$pullBackByHalfHoneyPotSize($4fc58260d57fd988$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $4fc58260d57fd988$var$honeyPotSize,
        height: $4fc58260d57fd988$var$honeyPotSize
    });
}
function $4fc58260d57fd988$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $4fc58260d57fd988$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $4fc58260d57fd988$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement("div");
    element.setAttribute((0, $7Oabr.honeyPotDataAttribute), "true");
    // can shift during the drag thanks to Firefox
    var clientRect = $4fc58260d57fd988$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $4fc58260d57fd988$var$_objectSpread($4fc58260d57fd988$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: "transparent",
        position: "fixed",
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: "border-box"
    }, $4fc58260d57fd988$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: "auto",
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $d2wQL.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $8fY35.bind)(window, {
        type: "pointermove",
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $4fc58260d57fd988$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $4fc58260d57fd988$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($4fc58260d57fd988$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $8fY35.bindAll)(window, [
            {
                type: "pointerdown",
                listener: cleanup
            },
            {
                type: "pointermove",
                listener: cleanup
            },
            {
                type: "focusin",
                listener: cleanup
            },
            {
                type: "focusout",
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: "dragstart",
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: "dragenter",
                listener: cleanup
            },
            {
                type: "dragover",
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $4fc58260d57fd988$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $8fY35.bind)(window, {
            type: "pointermove",
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === "onDragStart") {
                var _latestPointerMove;
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = (_latestPointerMove = latestPointerMove) !== null && _latestPointerMove !== void 0 ? _latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $4fc58260d57fd988$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === "onDrop") {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("d2wQL", function(module, exports) {

$parcel$export(module.exports, "maxZIndex", () => $97e4f199c1b7193b$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $97e4f199c1b7193b$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("6WHuD", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $50e9e5adc7c613fd$export$2aa3a33160990d96);

var $bWDmX = parcelRequire("bWDmX");

var $jfTID = parcelRequire("jfTID");

var $2mqZv = parcelRequire("2mqZv");

var $i1b4Y = parcelRequire("i1b4Y");
function $50e9e5adc7c613fd$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $i1b4Y.makeMonitor)();
    var dropTargetAPI = (0, $2mqZv.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $bWDmX.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $bWDmX.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $jfTID.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("bWDmX", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $8b23a668efba0488$export$3efdceeb8ca25c51);

var $fUHKi = parcelRequire("fUHKi");

var $8fY35 = parcelRequire("8fY35");

var $kk6Dv = parcelRequire("kk6Dv");

var $3s8a4 = parcelRequire("3s8a4");

var $ac4A8 = parcelRequire("ac4A8");

var $guUqI = parcelRequire("guUqI");

var $5ZupI = parcelRequire("5ZupI");

var $dY2vp = parcelRequire("dY2vp");
var $8b23a668efba0488$var$globalState = {
    isActive: false
};
function $8b23a668efba0488$var$canStart() {
    return !$8b23a668efba0488$var$globalState.isActive;
}
function $8b23a668efba0488$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $8b23a668efba0488$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $8b23a668efba0488$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$8b23a668efba0488$var$canStart()) return;
    var initial = $8b23a668efba0488$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $8b23a668efba0488$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $8b23a668efba0488$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $dY2vp.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $8b23a668efba0488$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $5ZupI.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $3s8a4.isHoneyPotElement)(event.target) ? (0, $kk6Dv.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $8b23a668efba0488$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $8b23a668efba0488$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: "dragover",
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: "dragenter",
            listener: onUpdateEvent
        },
        {
            type: "dragleave",
            listener: function listener(event) {
                if (!(0, $ac4A8.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === "external") cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: "drop",
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $5ZupI.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $8b23a668efba0488$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === "external" ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: "dragend",
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $5ZupI.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((0, $guUqI.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $8b23a668efba0488$var$getNativeSetDragImage(event)
    });
}
function $8b23a668efba0488$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $8b23a668efba0488$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $5ZupI.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === "external") return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $8b23a668efba0488$export$3efdceeb8ca25c51 = {
    canStart: $8b23a668efba0488$var$canStart,
    start: $8b23a668efba0488$var$start
};

});
parcelRegister("ac4A8", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $76be943fd292ee18$export$57d220c74e84a273);

var $6enBj = parcelRequire("6enBj");

var $iXb9E = parcelRequire("iXb9E");

var $fCUWk = parcelRequire("fCUWk");

var $kVTd4 = parcelRequire("kVTd4");
function $76be943fd292ee18$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== "dragleave") return false;
    if ((0, $iXb9E.isSafari)()) return (0, $fCUWk.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $6enBj.isFirefox)()) return (0, $kVTd4.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("6enBj", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $48965b868d61cb9c$export$b7d78993b74f766d);

var $deJG5 = parcelRequire("deJG5");
var $48965b868d61cb9c$export$b7d78993b74f766d = (0, $deJG5.once)(function isFirefox() {
    return navigator.userAgent.includes("Firefox");
});

});
parcelRegister("deJG5", function(module, exports) {

$parcel$export(module.exports, "once", () => $9a3003d7f2341560$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $9a3003d7f2341560$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("iXb9E", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $dcc663c8d046b643$export$95df08bae54cb4df);

var $deJG5 = parcelRequire("deJG5");
var $dcc663c8d046b643$export$95df08bae54cb4df = (0, $deJG5.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes("AppleWebKit") && !userAgent.includes("Chrome");
});

});

parcelRegister("fCUWk", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", () => $b60692aace78371d$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $b60692aace78371d$export$f21837c338005454);

var $8fY35 = parcelRequire("8fY35");

var $iXb9E = parcelRequire("iXb9E");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $b60692aace78371d$var$symbols = {
    isLeavingWindow: Symbol("leaving"),
    isEnteringWindow: Symbol("entering")
};
function $b60692aace78371d$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $iXb9E.isSafari)()) return false;
    return dragEnter.hasOwnProperty($b60692aace78371d$var$symbols.isEnteringWindow);
}
function $b60692aace78371d$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $iXb9E.isSafari)()) return false;
    return dragLeave.hasOwnProperty($b60692aace78371d$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === "undefined") return;
    if (!(0, $iXb9E.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $8fY35.bindAll)(window, [
        {
            type: "dragstart",
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: "drop",
            listener: resetState
        },
        {
            type: "dragend",
            listener: resetState
        },
        {
            type: "dragenter",
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$b60692aace78371d$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: "dragleave",
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$b60692aace78371d$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("kVTd4", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $f3d3f50eeb4a63d6$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $f3d3f50eeb4a63d6$var$isNodeLike(target) {
    return "nodeName" in target;
}
function $f3d3f50eeb4a63d6$export$e46810fef53b5b0e(eventTarget) {
    return $f3d3f50eeb4a63d6$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("guUqI", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $c02b3882c40dbd96$export$ac5e5b0daf997b2);
function $c02b3882c40dbd96$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: "pointerdown",
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("5ZupI", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $45ca3dcf5eb7145b$export$7c112ceec8941e67);
function $45ca3dcf5eb7145b$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("dY2vp", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $a2b2d2813eb5c722$export$9f13ecc44e83d682);

var $ciU3d = parcelRequire("ciU3d");
var $a2b2d2813eb5c722$var$scheduleOnDrag = (0, $ciU3d.default)(function(fn) {
    return fn();
});
var $a2b2d2813eb5c722$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $a2b2d2813eb5c722$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: "onGenerateDragPreview",
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $a2b2d2813eb5c722$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: "onDragStart",
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $a2b2d2813eb5c722$var$dragStart.flush();
            $a2b2d2813eb5c722$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: "onDropTargetChange",
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $a2b2d2813eb5c722$var$scheduleOnDrag(function() {
                $a2b2d2813eb5c722$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: "onDrag",
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $a2b2d2813eb5c722$var$dragStart.flush();
            $a2b2d2813eb5c722$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: "onDrop",
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("ciU3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f52a5054f09a665$export$2e2bcd8739ae039);
var $8f52a5054f09a665$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $8f52a5054f09a665$export$2e2bcd8739ae039 = $8f52a5054f09a665$var$rafSchd;

});



parcelRegister("jfTID", function(module, exports) {

$parcel$export(module.exports, "register", () => $e04aa3a457000d64$export$6503ec6e8aabbaf);
// Extending `Map` to allow us to link Key and Values together
var $e04aa3a457000d64$var$ledger = new Map();
function $e04aa3a457000d64$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $e04aa3a457000d64$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $e04aa3a457000d64$var$ledger.set(typeKey, initial);
    return initial;
}
function $e04aa3a457000d64$export$6503ec6e8aabbaf(args) {
    var entry = $e04aa3a457000d64$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $e04aa3a457000d64$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("2mqZv", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $1b8292b88c4a57a8$export$47d10e7bd9c81890);

var $g5Zhu = parcelRequire("g5Zhu");

var $fUHKi = parcelRequire("fUHKi");

var $iedos = parcelRequire("iedos");

var $axaCz = parcelRequire("axaCz");
function $1b8292b88c4a57a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b8292b88c4a57a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b8292b88c4a57a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b8292b88c4a57a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b8292b88c4a57a8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1b8292b88c4a57a8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1b8292b88c4a57a8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1b8292b88c4a57a8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1b8292b88c4a57a8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1b8292b88c4a57a8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1b8292b88c4a57a8$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $1b8292b88c4a57a8$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        return (0, $iedos.combine)((0, $axaCz.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: "true"
        }), addToRegistry(args));
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $1b8292b88c4a57a8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $1b8292b88c4a57a8$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $1b8292b88c4a57a8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $1b8292b88c4a57a8$var$copyReverse(current);
        var actualCaptureOrdered = $1b8292b88c4a57a8$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $1b8292b88c4a57a8$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("iedos", function(module, exports) {

$parcel$export(module.exports, "combine", () => $d453ec773833617e$export$1be1fc439b849fdf);
/** Create a new combined function that will call all the provided functions */ function $d453ec773833617e$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});

parcelRegister("axaCz", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $7ab53996d2b59441$export$5dcb5c23b6ba980a);
function $7ab53996d2b59441$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("i1b4Y", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $d1e0ea191414d51e$export$5dd4ed888d5b12ca);

var $g5Zhu = parcelRequire("g5Zhu");
function $d1e0ea191414d51e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d1e0ea191414d51e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d1e0ea191414d51e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d1e0ea191414d51e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d1e0ea191414d51e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d1e0ea191414d51e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d1e0ea191414d51e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1e0ea191414d51e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1e0ea191414d51e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1e0ea191414d51e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d1e0ea191414d51e$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $d1e0ea191414d51e$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === "onGenerateDragPreview") {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $d1e0ea191414d51e$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === "onDrop") {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("6AMEG", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $4ccbd8c1d4cf98a2$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $4ccbd8c1d4cf98a2$export$aceb3ed8b7f7bd2c);

var $deJG5 = parcelRequire("deJG5");
var $4ccbd8c1d4cf98a2$export$a11b0059900ceec8 = (0, $deJG5.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes("android");
});
var $4ccbd8c1d4cf98a2$export$aceb3ed8b7f7bd2c = "pdnd:android-fallback";

});

parcelRegister("sJ9rD", function(module, exports) {

$parcel$export(module.exports, "textMediaType", () => $0565a3c110eeed03$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $0565a3c110eeed03$export$fd3d00026297c0ad = "text/plain";

});

parcelRegister("hZyk4", function(module, exports) {

$parcel$export(module.exports, "URLMediaType", () => $d192c1f59100e50e$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $d192c1f59100e50e$export$4c44a460f123106 = "text/uri-list";

});

parcelRegister("kBeST", function(module, exports) {

$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $eff2cf0ca066f9dd$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $eff2cf0ca066f9dd$export$c9c4cc54e73b125d = "application/vnd.pdnd";

});



parcelRegister("fqFky", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("dAi0Y")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("dAi0Y")).Icon);

var $dAi0Y = parcelRequire("dAi0Y");

});
parcelRegister("dAi0Y", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $9e3c9c7e8d15a6db$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $9e3c9c7e8d15a6db$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $ltooA = parcelRequire("ltooA");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $9e3c9c7e8d15a6db$var$commonSVGStyles = (0, $jjlaj.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $9e3c9c7e8d15a6db$var$svgStyles = (0, $jjlaj.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $9e3c9c7e8d15a6db$var$iconStyles = (0, $jjlaj.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $9e3c9c7e8d15a6db$var$utilityIconStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $9e3c9c7e8d15a6db$var$scaleStyles = (0, $jjlaj.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $9e3c9c7e8d15a6db$var$baseHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $9e3c9c7e8d15a6db$var$scaleSize = (0, $jjlaj.css)({
    width: "inherit",
    height: "inherit"
});
var $9e3c9c7e8d15a6db$var$sizeMap = {
    core: {
        none: (0, $jjlaj.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jjlaj.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $jjlaj.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $jjlaj.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jjlaj.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $9e3c9c7e8d15a6db$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $9e3c9c7e8d15a6db$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $9e3c9c7e8d15a6db$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $ltooA.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $jjlaj.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $9e3c9c7e8d15a6db$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $9e3c9c7e8d15a6db$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $9e3c9c7e8d15a6db$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jjlaj.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $9e3c9c7e8d15a6db$var$iconStyles,
            $9e3c9c7e8d15a6db$var$baseHcmStyles,
            shouldScale && $9e3c9c7e8d15a6db$var$scaleStyles,
            props.type === "utility" && $9e3c9c7e8d15a6db$var$utilityIconStyles
        ]
    }, (0, $jjlaj.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $9e3c9c7e8d15a6db$var$commonSVGStyles,
            $9e3c9c7e8d15a6db$var$svgStyles,
            shouldScale ? $9e3c9c7e8d15a6db$var$scaleSize : props.type === "utility" ? $9e3c9c7e8d15a6db$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $9e3c9c7e8d15a6db$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $9e3c9c7e8d15a6db$export$2e2bcd8739ae039 = $9e3c9c7e8d15a6db$export$f04a61298a47a40f;

});


parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("kYoXd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $588818851db77b42$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<888ba502967936cecc13445d40e05c91>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $588818851db77b42$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudID"
    }, v2 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "atlassianAccountId",
                    "variableName": "atlassianAccountId"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudID"
                }
            ],
            "concreteType": "DevAiUser",
            "kind": "LinkedField",
            "name": "devai_rovoDevAgentsUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasProductAccess",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAdmin",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "userPermContextProviderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "userPermContextProviderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0be938ea1c92244159dfe62218139544",
            "id": null,
            "metadata": {},
            "name": "userPermContextProviderQuery",
            "operationKind": "query",
            "text": 'query userPermContextProviderQuery(\n  $cloudID: ID!\n  $atlassianAccountId: ID!\n) {\n  devai_rovoDevAgentsUser(cloudId: $cloudID, atlassianAccountId: $atlassianAccountId) @optIn(to: "DevAiUsers") {\n    hasProductAccess\n    isAdmin\n  }\n}\n'
        }
    };
}();
$588818851db77b42$var$node.hash = "484f74b7aaa804926094af900b594a4e";
var $588818851db77b42$export$2e2bcd8739ae039 = $588818851db77b42$var$node;

});

parcelRegister("2yjMv", function(module, exports) {
"use strict";
var $1dbe19e648c2a53a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $acw62 = parcelRequire("acw62");

const $1dbe19e648c2a53a$var$feature_gate_js_client_1 = $1dbe19e648c2a53a$var$__importDefault((parcelRequire("26IN9")));
const $1dbe19e648c2a53a$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $acw62.useState)(()=>$1dbe19e648c2a53a$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $acw62.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $1dbe19e648c2a53a$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $1dbe19e648c2a53a$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $1dbe19e648c2a53a$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $acw62.useState)(()=>$1dbe19e648c2a53a$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $acw62.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $1dbe19e648c2a53a$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $1dbe19e648c2a53a$var$useExperimentValue;

});
parcelRegister("26IN9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("5Lqbi")).default);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("a9hho")).FeatureGateEnvironment);
$parcel$export(module.exports, "PerimeterType", () => (parcelRequire("a9hho")).PerimeterType);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("a8TeI")).CLIENT_VERSION);
$parcel$export(module.exports, "DynamicConfig", () => (parcelRequire("6KuMn")).DynamicConfig);
$parcel$export(module.exports, "Layer", () => (parcelRequire("b9B8v")).Layer);
$parcel$export(module.exports, "EvaluationReason", () => (parcelRequire("fBTBL")).EvaluationReason);
parcelRequire("5Lqbi");
var $a8TeI = parcelRequire("a8TeI");
var $5Lqbi = parcelRequire("5Lqbi");
var $a9hho = parcelRequire("a9hho");

var $6KuMn = parcelRequire("6KuMn");

var $b9B8v = parcelRequire("b9B8v");

var $fBTBL = parcelRequire("fBTBL");

});
parcelRegister("5Lqbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4325a69894930da9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("a8TeI")).CLIENT_VERSION);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $9P1Ta = parcelRequire("9P1Ta");

var $a8TeI = parcelRequire("a8TeI");



var $a9hho = parcelRequire("a9hho");
var $4325a69894930da9$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $4325a69894930da9$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$4325a69894930da9$var$_FeatureGates = $4325a69894930da9$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "client", new (0, $9P1Ta.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$4325a69894930da9$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $4325a69894930da9$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $4325a69894930da9$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$4325a69894930da9$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $4325a69894930da9$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $4325a69894930da9$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "initializeCalled", $4325a69894930da9$var$_FeatureGates.client.initializeCalled.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "initializeCompleted", $4325a69894930da9$var$_FeatureGates.client.initializeCompleted.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "initialize", $4325a69894930da9$var$_FeatureGates.client.initialize.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "initializeWithProvider", $4325a69894930da9$var$_FeatureGates.client.initializeWithProvider.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "initializeFromValues", $4325a69894930da9$var$_FeatureGates.client.initializeFromValues.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "manuallyLogGateExposure", $4325a69894930da9$var$_FeatureGates.client.manuallyLogGateExposure.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "getExperiment", $4325a69894930da9$var$_FeatureGates.client.getExperiment.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "manuallyLogExperimentExposure", $4325a69894930da9$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "manuallyLogLayerExposure", $4325a69894930da9$var$_FeatureGates.client.manuallyLogLayerExposure.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "shutdownStatsig", $4325a69894930da9$var$_FeatureGates.client.shutdownStatsig.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "overrideGate", $4325a69894930da9$var$_FeatureGates.client.overrideGate.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "clearGateOverride", $4325a69894930da9$var$_FeatureGates.client.clearGateOverride.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "overrideConfig", $4325a69894930da9$var$_FeatureGates.client.overrideConfig.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "clearConfigOverride", $4325a69894930da9$var$_FeatureGates.client.clearConfigOverride.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "setOverrides", $4325a69894930da9$var$_FeatureGates.client.setOverrides.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "getOverrides", $4325a69894930da9$var$_FeatureGates.client.getOverrides.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "clearAllOverrides", $4325a69894930da9$var$_FeatureGates.client.clearAllOverrides.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "isCurrentUser", $4325a69894930da9$var$_FeatureGates.client.isCurrentUser.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "onGateUpdated", $4325a69894930da9$var$_FeatureGates.client.onGateUpdated.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "onExperimentValueUpdated", $4325a69894930da9$var$_FeatureGates.client.onExperimentValueUpdated.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "onAnyUpdated", $4325a69894930da9$var$_FeatureGates.client.onAnyUpdated.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "updateUser", $4325a69894930da9$var$_FeatureGates.client.updateUser.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "updateUserWithProvider", $4325a69894930da9$var$_FeatureGates.client.updateUserWithProvider.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "updateUserWithValues", $4325a69894930da9$var$_FeatureGates.client.updateUserWithValues.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "getPackageVersion", $4325a69894930da9$var$_FeatureGates.client.getPackageVersion.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "getLayer", $4325a69894930da9$var$_FeatureGates.client.getLayer.bind($4325a69894930da9$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4325a69894930da9$var$FeatureGates, "getLayerValue", $4325a69894930da9$var$_FeatureGates.client.getLayerValue.bind($4325a69894930da9$var$_FeatureGates.client));
var $4325a69894930da9$var$boundFGJS = $4325a69894930da9$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $4325a69894930da9$var$FeatureGates;
    else {
        var $4325a69894930da9$var$_boundFGJS, $4325a69894930da9$var$_boundFGJS$getPackage;
        $4325a69894930da9$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $4325a69894930da9$var$boundVersion = (($4325a69894930da9$var$_boundFGJS = $4325a69894930da9$var$boundFGJS) === null || $4325a69894930da9$var$_boundFGJS === void 0 || ($4325a69894930da9$var$_boundFGJS$getPackage = $4325a69894930da9$var$_boundFGJS.getPackageVersion) === null || $4325a69894930da9$var$_boundFGJS$getPackage === void 0 ? void 0 : $4325a69894930da9$var$_boundFGJS$getPackage.call($4325a69894930da9$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($4325a69894930da9$var$boundVersion !== (0, $a8TeI.CLIENT_VERSION)) {
            var $4325a69894930da9$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($4325a69894930da9$var$boundVersion, " when module version ").concat((0, $a8TeI.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($4325a69894930da9$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $4325a69894930da9$export$2e2bcd8739ae039 = $4325a69894930da9$var$boundFGJS;

});
parcelRegister("9P1Ta", function(module, exports) {

$parcel$export(module.exports, "Client", () => $726a578a20aa1146$export$1f2bb630327ac4b6);

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $49JF1 = parcelRequire("49JF1");

var $ftXtW = parcelRequire("ftXtW");

var $6KuMn = parcelRequire("6KuMn");

var $b9B8v = parcelRequire("b9B8v");

var $fBTBL = parcelRequire("fBTBL");

var $2zHX9 = parcelRequire("2zHX9");

var $etPJl = parcelRequire("etPJl");

var $jeR0E = parcelRequire("jeR0E");

var $a9hho = parcelRequire("a9hho");

var $2jrvh = parcelRequire("2jrvh");

var $a8TeI = parcelRequire("a8TeI");
var $726a578a20aa1146$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $726a578a20aa1146$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $726a578a20aa1146$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $726a578a20aa1146$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $726a578a20aa1146$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $726a578a20aa1146$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $726a578a20aa1146$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $726a578a20aa1146$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $jeR0E.LOCAL_STORAGE_KEY) : _ref$localStorageKey;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "subscriptions", new (0, $ftXtW.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "dataAdapter", new (0, $etPJl.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = new (0, $jeR0E.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $2jrvh.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $2jrvh.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $2jrvh.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $2jrvh.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $a8TeI.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $726a578a20aa1146$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $a8TeI.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $a9hho.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $2jrvh.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $2jrvh.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $2jrvh.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $2zHX9.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $6KuMn.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $6KuMn.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $fBTBL.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $2jrvh.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $2jrvh.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $726a578a20aa1146$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $2zHX9.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $2zHX9.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $726a578a20aa1146$var$_objectSpread($726a578a20aa1146$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $2jrvh.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $726a578a20aa1146$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $726a578a20aa1146$var$_objectSpread($726a578a20aa1146$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $726a578a20aa1146$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $a9hho.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(newClientOptions, $726a578a20aa1146$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $2jrvh.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $726a578a20aa1146$var$_objectSpread($726a578a20aa1146$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $49JF1.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $49JF1.StatsigClient)($726a578a20aa1146$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $2jrvh.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $a8TeI.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $b9B8v.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $b9B8v.Layer).fromLayer((0, $49JF1._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("ftXtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b457b45528bd068d$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $5SA4b = parcelRequire("5SA4b");
function $b457b45528bd068d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b457b45528bd068d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b457b45528bd068d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b457b45528bd068d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b457b45528bd068d$export$a66cbd9b2289cd78 = "@all-features";
var $b457b45528bd068d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "eventToValue", new Map());
        this.emitter = new (0, $5SA4b.EventEmitter2)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $b457b45528bd068d$var$_objectSpread($b457b45528bd068d$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $b457b45528bd068d$var$_objectSpread($b457b45528bd068d$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $b457b45528bd068d$var$_objectSpread($b457b45528bd068d$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $b457b45528bd068d$var$_objectSpread($b457b45528bd068d$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($b457b45528bd068d$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($b457b45528bd068d$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($b457b45528bd068d$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $b457b45528bd068d$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("6KuMn", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", () => $4e9eea0df64d1803$export$6dc24881a3d96325);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $2jrvh = parcelRequire("2jrvh");
var $4e9eea0df64d1803$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $2jrvh.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("2jrvh", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", () => $1af2b0bc0cce40a8$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $1af2b0bc0cce40a8$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $1af2b0bc0cce40a8$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $1af2b0bc0cce40a8$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $1af2b0bc0cce40a8$export$18ad168d3dbac899);

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $49JF1 = parcelRequire("49JF1");

var $70zaY = parcelRequire("70zaY");

var $fBTBL = parcelRequire("fBTBL");

var $a9hho = parcelRequire("a9hho");
var $1af2b0bc0cce40a8$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $1af2b0bc0cce40a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1af2b0bc0cce40a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1af2b0bc0cce40a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1af2b0bc0cce40a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1af2b0bc0cce40a8$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $1af2b0bc0cce40a8$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $70zaY.isFedRamp)() ? (0, $a9hho.PerimeterType).FEDRAMP_MODERATE : (0, $a9hho.PerimeterType).COMMERCIAL
    }, options);
};
var $1af2b0bc0cce40a8$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $1af2b0bc0cce40a8$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $1af2b0bc0cce40a8$var$_objectSpread({
            stableID: (0, $49JF1.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $1af2b0bc0cce40a8$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(options, $1af2b0bc0cce40a8$var$_excluded);
    return $1af2b0bc0cce40a8$var$_objectSpread($1af2b0bc0cce40a8$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $1af2b0bc0cce40a8$var$evaluationReasonMappings = Object.entries((0, $fBTBL.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $1af2b0bc0cce40a8$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $1af2b0bc0cce40a8$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $fBTBL.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("fBTBL", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", () => $b5d5725873ca4432$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $b5d5725873ca4432$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("a9hho", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $763825fd64a781e5$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $763825fd64a781e5$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $763825fd64a781e5$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $763825fd64a781e5$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $763825fd64a781e5$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("b9B8v", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $81ed576e137f9ac1$export$936d0764594b6eb3);

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $2jrvh = parcelRequire("2jrvh");
var $81ed576e137f9ac1$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $2jrvh.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("2zHX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e00f1cf7fe7e9cc$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");

var $a9hho = parcelRequire("a9hho");

var $a8TeI = parcelRequire("a8TeI");

var $cM9dC = parcelRequire("cM9dC");
function $1e00f1cf7fe7e9cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e00f1cf7fe7e9cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e00f1cf7fe7e9cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e00f1cf7fe7e9cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1e00f1cf7fe7e9cc$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $1e00f1cf7fe7e9cc$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $1e00f1cf7fe7e9cc$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $1e00f1cf7fe7e9cc$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $1e00f1cf7fe7e9cc$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $1e00f1cf7fe7e9cc$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $1e00f1cf7fe7e9cc$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $1e00f1cf7fe7e9cc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $cM9dC.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $cM9dC.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $1e00f1cf7fe7e9cc$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $a9hho.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $a9hho.FeatureGateEnvironment).Production:
                        return $1e00f1cf7fe7e9cc$export$18c93900db9358a4;
                    case (0, $a9hho.FeatureGateEnvironment).Staging:
                        return $1e00f1cf7fe7e9cc$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $a9hho.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $a9hho.FeatureGateEnvironment).Development:
                        return $1e00f1cf7fe7e9cc$export$f058dbf75c3bc647;
                    case (0, $a9hho.FeatureGateEnvironment).Staging:
                        return $1e00f1cf7fe7e9cc$export$942ba04389b0d5a2;
                    default:
                        return $1e00f1cf7fe7e9cc$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $1e00f1cf7fe7e9cc$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $1e00f1cf7fe7e9cc$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $a8TeI.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("a8TeI", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $76257f836d2fbbb7$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $76257f836d2fbbb7$export$a59f8d67326bd1cb = "4.26.5";

});

parcelRegister("cM9dC", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $94d11e5cdd4fff24$export$286baf652d0b1206);

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $in7St = parcelRequire("in7St");
function $94d11e5cdd4fff24$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $94d11e5cdd4fff24$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $94d11e5cdd4fff24$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($94d11e5cdd4fff24$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $94d11e5cdd4fff24$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ResponseError);
        return $94d11e5cdd4fff24$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($in7St)))(Error));

});


parcelRegister("etPJl", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", () => $a8abe6b5c203ed26$export$55fffef3474104af);

var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $h1Oiy = parcelRequire("h1Oiy");

var $49JF1 = parcelRequire("49JF1");
function $a8abe6b5c203ed26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a8abe6b5c203ed26$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a8abe6b5c203ed26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a8abe6b5c203ed26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a8abe6b5c203ed26$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $a8abe6b5c203ed26$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $a8abe6b5c203ed26$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a8abe6b5c203ed26$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a8abe6b5c203ed26$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a8abe6b5c203ed26$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, NoFetchDataAdapter);
        _this = $a8abe6b5c203ed26$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $49JF1.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $a8abe6b5c203ed26$var$_objectSpread($a8abe6b5c203ed26$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $49JF1._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $a8abe6b5c203ed26$var$_objectSpread($a8abe6b5c203ed26$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $49JF1._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $49JF1._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $49JF1.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $a8abe6b5c203ed26$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $a8abe6b5c203ed26$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $49JF1.DataAdapterCore));

});

parcelRegister("jeR0E", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $e01871bb165fe53b$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $e01871bb165fe53b$export$bcb28fbac1def494);

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $jS1H0 = parcelRequire("jS1H0");
function $e01871bb165fe53b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e01871bb165fe53b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e01871bb165fe53b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e01871bb165fe53b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e01871bb165fe53b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e01871bb165fe53b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e01871bb165fe53b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e01871bb165fe53b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e01871bb165fe53b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e01871bb165fe53b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e01871bb165fe53b$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $e01871bb165fe53b$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $e01871bb165fe53b$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $e01871bb165fe53b$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $e01871bb165fe53b$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ":" + hash;
};
var $e01871bb165fe53b$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, PersistentOverrideAdapter);
        this._overrides = $e01871bb165fe53b$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $e01871bb165fe53b$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $e01871bb165fe53b$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $e01871bb165fe53b$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($e01871bb165fe53b$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($e01871bb165fe53b$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $e01871bb165fe53b$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $jS1H0._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $e01871bb165fe53b$var$_objectSpread($e01871bb165fe53b$var$_objectSpread({}, $e01871bb165fe53b$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($e01871bb165fe53b$var$djb2MapKey((0, $jS1H0._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($e01871bb165fe53b$var$djb2MapKey((0, $jS1H0._DJB2)(name), "gates"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($e01871bb165fe53b$var$djb2MapKey((0, $jS1H0._DJB2)(name), "gates"));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($e01871bb165fe53b$var$djb2MapKey(current.name, "gates"));
                if (overridden == null) return null;
                return $e01871bb165fe53b$var$_objectSpread($e01871bb165fe53b$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $e01871bb165fe53b$var$_objectSpread($e01871bb165fe53b$var$_objectSpread({}, current.details), {}, {
                        reason: $e01871bb165fe53b$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($e01871bb165fe53b$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($e01871bb165fe53b$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($e01871bb165fe53b$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($e01871bb165fe53b$var$djb2MapKey((0, $jS1H0._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($e01871bb165fe53b$var$djb2MapKey((0, $jS1H0._DJB2)(name), "layers"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($e01871bb165fe53b$var$djb2MapKey((0, $jS1H0._DJB2)(name), "layers"));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $e01871bb165fe53b$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($e01871bb165fe53b$var$djb2MapKey(current.name, "layers"));
                if (overridden == null) return null;
                return $e01871bb165fe53b$var$_objectSpread($e01871bb165fe53b$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $jS1H0._makeTypedGet)(current.name, overridden),
                    details: $e01871bb165fe53b$var$_objectSpread($e01871bb165fe53b$var$_objectSpread({}, current.details), {}, {
                        reason: $e01871bb165fe53b$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($e01871bb165fe53b$var$djb2MapKey(current.name, "configs"));
                if (overridden == null) return null;
                return $e01871bb165fe53b$var$_objectSpread($e01871bb165fe53b$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $jS1H0._makeTypedGet)(current.name, overridden),
                    details: $e01871bb165fe53b$var$_objectSpread($e01871bb165fe53b$var$_objectSpread({}, current.details), {}, {
                        reason: $e01871bb165fe53b$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});





parcelRegister("5vuWi", function(module, exports) {
"use strict";
var $4027d8e9cf82c0d9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $acw62 = parcelRequire("acw62");

const $4027d8e9cf82c0d9$var$feature_gate_js_client_1 = $4027d8e9cf82c0d9$var$__importDefault((parcelRequire("26IN9")));

var $jVVXk = parcelRequire("jVVXk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $4027d8e9cf82c0d9$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $acw62.useState)(!overrides && (0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $acw62.useRef)(options);
    (0, $acw62.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        if (enabled) {
            if ((0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jVVXk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $4027d8e9cf82c0d9$var$feature_gate_js_client_1.default.initializeCalled() ? $4027d8e9cf82c0d9$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $4027d8e9cf82c0d9$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.then(()=>(0, $jVVXk.applyOverrides)(overrides)).catch((err)=>(0, $jVVXk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jVVXk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $jVVXk.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $4027d8e9cf82c0d9$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("jVVXk", function(module, exports) {
"use strict";
var $e8304c0254f188db$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearOverrides = module.exports.applyOverrides = module.exports.toError = module.exports.pickChildToRender = module.exports.isClientAlreadyInCorrectState = void 0;

const $e8304c0254f188db$var$react_1 = $e8304c0254f188db$var$__importDefault((parcelRequire("acw62")));

const $e8304c0254f188db$var$feature_gate_js_client_1 = $e8304c0254f188db$var$__importDefault((parcelRequire("26IN9")));
let $e8304c0254f188db$var$hasWarnedAboutMissingOverrideSupport = false;
function $e8304c0254f188db$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default)) && ((_b = $e8304c0254f188db$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($e8304c0254f188db$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
module.exports.isClientAlreadyInCorrectState = $e8304c0254f188db$var$isClientAlreadyInCorrectState;
function $e8304c0254f188db$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $e8304c0254f188db$var$react_1.default.createElement($e8304c0254f188db$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $e8304c0254f188db$var$react_1.default.createElement($e8304c0254f188db$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
module.exports.pickChildToRender = $e8304c0254f188db$var$pickChildToRender;
function $e8304c0254f188db$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
module.exports.toError = $e8304c0254f188db$var$toError;
function $e8304c0254f188db$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$e8304c0254f188db$var$feature_gate_js_client_1.default.overrideGate || !$e8304c0254f188db$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$e8304c0254f188db$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn("Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+");
            $e8304c0254f188db$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default, configName, values);
    });
}
module.exports.applyOverrides = $e8304c0254f188db$var$applyOverrides;
function $e8304c0254f188db$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $e8304c0254f188db$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($e8304c0254f188db$var$feature_gate_js_client_1.default, configName);
    });
}
module.exports.clearOverrides = $e8304c0254f188db$var$clearOverrides;

});


parcelRegister("6AwzT", function(module, exports) {
"use strict";
var $4cbf602cf77f8f02$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $acw62 = parcelRequire("acw62");

const $4cbf602cf77f8f02$var$feature_gate_js_client_1 = $4cbf602cf77f8f02$var$__importDefault((parcelRequire("26IN9")));

var $jVVXk = parcelRequire("jVVXk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $4cbf602cf77f8f02$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $acw62.useState)(!overrides && (0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $acw62.useRef)(options);
    const providerRef = (0, $acw62.useRef)(provider);
    (0, $acw62.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $acw62.useEffect)(()=>{
        if (enabled) {
            if ((0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jVVXk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $4cbf602cf77f8f02$var$feature_gate_js_client_1.default.initializeCalled() ? $4cbf602cf77f8f02$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $4cbf602cf77f8f02$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.then(()=>(0, $jVVXk.applyOverrides)(overrides)).catch((err)=>(0, $jVVXk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jVVXk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $jVVXk.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $4cbf602cf77f8f02$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("1FExB", function(module, exports) {
"use strict";
var $1379116260a67eca$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $acw62 = parcelRequire("acw62");

const $1379116260a67eca$var$feature_gate_js_client_1 = $1379116260a67eca$var$__importDefault((parcelRequire("26IN9")));

var $jVVXk = parcelRequire("jVVXk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $1379116260a67eca$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $acw62.useState)(!overrides && (0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $acw62.useRef)(options);
    (0, $acw62.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        if (enabled) {
            if ((0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jVVXk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $1379116260a67eca$var$feature_gate_js_client_1.default.initializeCalled() ? $1379116260a67eca$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $1379116260a67eca$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: "client-default-key"
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.then(()=>(0, $jVVXk.applyOverrides)(overrides)).catch((err)=>(0, $jVVXk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jVVXk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $jVVXk.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $1379116260a67eca$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("eWJCq", function(module, exports) {
"use strict";
var $ae19de6a123fa76a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $acw62 = parcelRequire("acw62");

const $ae19de6a123fa76a$var$feature_gate_js_client_1 = $ae19de6a123fa76a$var$__importDefault((parcelRequire("26IN9")));

var $jVVXk = parcelRequire("jVVXk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $ae19de6a123fa76a$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $acw62.useState)(!overrides && (0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $acw62.useRef)(options);
    (0, $acw62.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        if (enabled) {
            if ((0, $jVVXk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jVVXk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $ae19de6a123fa76a$var$feature_gate_js_client_1.default.initializeCalled() ? $ae19de6a123fa76a$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $ae19de6a123fa76a$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.then(()=>(0, $jVVXk.applyOverrides)(overrides)).catch((err)=>(0, $jVVXk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jVVXk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $jVVXk.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $ae19de6a123fa76a$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});

parcelRegister("4q3AQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d772cd2cc0c3e3d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d36421192180d527d2fe6d00b0552008>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d772cd2cc0c3e3d2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "creator"
    }, v2 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "creator",
                    "variableName": "creator"
                }
            ],
            "concreteType": "DevAiFlowSession",
            "kind": "LinkedField",
            "name": "devai_flowSessionsByCreatorAndCloudId",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sessionARI",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "additionalInfoJSON",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "flowsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "flowsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7a5e65fb89307461c737ecf012f199cd",
            "id": null,
            "metadata": {},
            "name": "flowsQuery",
            "operationKind": "query",
            "text": 'query flowsQuery(\n  $creator: String!\n  $cloudId: ID!\n) {\n  devai_flowSessionsByCreatorAndCloudId(creator: $creator, cloudId: $cloudId) @optIn(to: "DevAiFlowSessionsByCreatorAndCloudId") {\n    id\n    sessionARI\n    status\n    additionalInfoJSON\n  }\n}\n'
        }
    };
}();
$d772cd2cc0c3e3d2$var$node.hash = "5a338790b3796f41b3009f0dcc3c934f";
var $d772cd2cc0c3e3d2$export$2e2bcd8739ae039 = $d772cd2cc0c3e3d2$var$node;

});

parcelRegister("aFWKD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c5b4e754fca68ba$var$_react = $7c5b4e754fca68ba$var$_interopRequireDefault((parcelRequire("acw62")));

var $7c5b4e754fca68ba$var$_baseNew = $7c5b4e754fca68ba$var$_interopRequireDefault((parcelRequire("fqFky")));
function $7c5b4e754fca68ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c5b4e754fca68ba$var$FileIcon = (props)=>/*#__PURE__*/ $7c5b4e754fca68ba$var$_react.default.createElement($7c5b4e754fca68ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$7c5b4e754fca68ba$var$FileIcon.displayName = "FileIcon";
var $7c5b4e754fca68ba$var$_default = module.exports.default = $7c5b4e754fca68ba$var$FileIcon;

});

parcelRegister("kHyiL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1226e5edd56988a$var$_react = $f1226e5edd56988a$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $f1226e5edd56988a$var$_warning = $f1226e5edd56988a$var$_interopRequireDefault((parcelRequire("keOiG")));
function $f1226e5edd56988a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1226e5edd56988a$var$WarningIcon = (props)=>/*#__PURE__*/ $f1226e5edd56988a$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $f1226e5edd56988a$var$_warning.default
    }));
$f1226e5edd56988a$var$WarningIcon.displayName = "WarningIcon";
var $f1226e5edd56988a$var$_default = module.exports.default = $f1226e5edd56988a$var$WarningIcon;

});
parcelRegister("kaGTc", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $eaf602bbcc1ed686$export$3cfb73f70dfca966);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $cpJkH = parcelRequire("cpJkH");
var $eaf602bbcc1ed686$var$_excluded = [
    "dangerouslySetGlyph"
];
var $eaf602bbcc1ed686$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $eaf602bbcc1ed686$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $acw62.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $eaf602bbcc1ed686$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $ltooA.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: (0, $ltooA.fg)("platform-visual-refresh-icons-facade-button-fix") ? $eaf602bbcc1ed686$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                spacing: $eaf602bbcc1ed686$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cpJkH.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("cpJkH", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $909afc01458e2b41$export$f04a61298a47a40f);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $jPhJ6 = parcelRequire("jPhJ6");

var $5L99G = parcelRequire("5L99G");
function $909afc01458e2b41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $909afc01458e2b41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $909afc01458e2b41$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $909afc01458e2b41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $909afc01458e2b41$var$iconStyles = (0, $jjlaj.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $909afc01458e2b41$var$_objectSpread($909afc01458e2b41$var$_objectSpread({}, (0, $jPhJ6.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $909afc01458e2b41$var$baseHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $909afc01458e2b41$var$primaryEqualsSecondaryHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $909afc01458e2b41$var$secondaryTransparentHcmStyles = (0, $jjlaj.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $909afc01458e2b41$export$f04a61298a47a40f = /*#__PURE__*/ (0, $acw62.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jjlaj.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $jPhJ6.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jjlaj.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $5L99G.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $909afc01458e2b41$var$iconStyles,
            $909afc01458e2b41$var$baseHcmStyles,
            primaryColor === secondaryColor && $909afc01458e2b41$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $909afc01458e2b41$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jjlaj.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $909afc01458e2b41$export$2e2bcd8739ae039 = $909afc01458e2b41$export$f04a61298a47a40f;

});
parcelRegister("jPhJ6", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $e6f087d674393b6c$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $e6f087d674393b6c$export$3eb7d6130acfda37);

var $bbKA3 = parcelRequire("bbKA3");

var $jjlaj = parcelRequire("jjlaj");
var $e6f087d674393b6c$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e6f087d674393b6c$var$smallStyles = (0, $jjlaj.css)((0, $bbKA3.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e6f087d674393b6c$var$mediumStyles = (0, $jjlaj.css)((0, $bbKA3.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e6f087d674393b6c$var$largeStyles = (0, $jjlaj.css)((0, $bbKA3.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $e6f087d674393b6c$var$xlargeStyles = (0, $jjlaj.css)((0, $bbKA3.dimensions).xlarge);
var $e6f087d674393b6c$export$ef0ad74202575b64 = {
    small: $e6f087d674393b6c$var$smallStyles,
    medium: $e6f087d674393b6c$var$mediumStyles,
    large: $e6f087d674393b6c$var$largeStyles,
    xlarge: $e6f087d674393b6c$var$xlargeStyles
};
var $e6f087d674393b6c$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $bbKA3.dimensions)[size];
    return undefined;
};

});
parcelRegister("bbKA3", function(module, exports) {

$parcel$export(module.exports, "dimensions", () => $8254dab3a92bb0ab$export$62ad7b0c781000e9);
var $8254dab3a92bb0ab$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $8254dab3a92bb0ab$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $8254dab3a92bb0ab$export$62ad7b0c781000e9 = {
    small: {
        width: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.small,
        height: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.medium,
        height: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.large,
        height: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.xlarge,
        height: $8254dab3a92bb0ab$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("5L99G", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $4318718ecf5d405f$export$18cb9425622d4e06);
var $4318718ecf5d405f$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("keOiG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1447c2d9394cec1fac504fd0d225fa23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebbc2214663f1482$var$_react = $ebbc2214663f1482$var$_interopRequireDefault((parcelRequire("acw62")));

var $ebbc2214663f1482$var$_baseNew = $ebbc2214663f1482$var$_interopRequireDefault((parcelRequire("fqFky")));
function $ebbc2214663f1482$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ebbc2214663f1482$var$WarningIcon = (props)=>/*#__PURE__*/ $ebbc2214663f1482$var$_react.default.createElement($ebbc2214663f1482$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$ebbc2214663f1482$var$WarningIcon.displayName = "WarningIcon";
var $ebbc2214663f1482$var$_default = module.exports.default = $ebbc2214663f1482$var$WarningIcon;

});


parcelRegister("i4oav", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $436293b6dca6d061$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3cdd5ac86959eb7f249b030bd78c964c>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $436293b6dca6d061$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "additionalInfoJSON"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "createdBy"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueARI"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraHost"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraIssueJSON"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "repoUrl"
    }, v7 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "additionalInfoJSON",
                    "variableName": "additionalInfoJSON"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "createdBy",
                    "variableName": "createdBy"
                },
                {
                    "kind": "Variable",
                    "name": "issueARI",
                    "variableName": "issueARI"
                },
                {
                    "kind": "Variable",
                    "name": "jiraHost",
                    "variableName": "jiraHost"
                },
                {
                    "kind": "Variable",
                    "name": "jiraIssueJSON",
                    "variableName": "jiraIssueJSON"
                },
                {
                    "kind": "Variable",
                    "name": "repoUrl",
                    "variableName": "repoUrl"
                }
            ],
            "concreteType": "DevAiFlowSession",
            "kind": "LinkedField",
            "name": "devai_flowCreate",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "useCreateFlowMutation",
            "selections": v7 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateFlowMutation",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "283d1d691458d0b4c1687291c95e658b",
            "id": null,
            "metadata": {},
            "name": "useCreateFlowMutation",
            "operationKind": "mutation",
            "text": 'mutation useCreateFlowMutation(\n  $cloudId: String!\n  $issueARI: ID\n  $repoUrl: URL!\n  $createdBy: String!\n  $jiraHost: String!\n  $jiraIssueJSON: String\n  $additionalInfoJSON: String!\n) {\n  devai_flowCreate(issueARI: $issueARI, cloudId: $cloudId, repoUrl: $repoUrl, createdBy: $createdBy, jiraHost: $jiraHost, jiraIssueJSON: $jiraIssueJSON, additionalInfoJSON: $additionalInfoJSON) @optIn(to: "DevAiFlowCreate") {\n    id\n  }\n}\n'
        }
    };
}();
$436293b6dca6d061$var$node.hash = "baf2202dfb2f79b9e1fe5f5751c42ef7";
var $436293b6dca6d061$export$2e2bcd8739ae039 = $436293b6dca6d061$var$node;

});

parcelRegister("cXz1d", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("iedos")).combine);

var $iedos = parcelRequire("iedos");

});

parcelRegister("3BIVW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a07aea35ac2dbf9$var$_react = $2a07aea35ac2dbf9$var$_interopRequireDefault((parcelRequire("acw62")));

var $2a07aea35ac2dbf9$var$_baseNew = $2a07aea35ac2dbf9$var$_interopRequireDefault((parcelRequire("fqFky")));
function $2a07aea35ac2dbf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a07aea35ac2dbf9$var$CloseIcon = (props)=>/*#__PURE__*/ $2a07aea35ac2dbf9$var$_react.default.createElement($2a07aea35ac2dbf9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$2a07aea35ac2dbf9$var$CloseIcon.displayName = "CloseIcon";
var $2a07aea35ac2dbf9$var$_default = module.exports.default = $2a07aea35ac2dbf9$var$CloseIcon;

});

parcelRegister("at3iV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79ef2cf25005c825$var$_react = $79ef2cf25005c825$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $79ef2cf25005c825$var$_close = $79ef2cf25005c825$var$_interopRequireDefault((parcelRequire("3BIVW")));
function $79ef2cf25005c825$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79ef2cf25005c825$var$CrossIcon = (props)=>/*#__PURE__*/ $79ef2cf25005c825$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $79ef2cf25005c825$var$_close.default
    }));
$79ef2cf25005c825$var$CrossIcon.displayName = "CrossIcon";
var $79ef2cf25005c825$var$_default = module.exports.default = $79ef2cf25005c825$var$CrossIcon;

});

parcelRegister("71Yyg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::257fef37d04db299e24e95484ff9b12f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51e798b2827f0117$var$_react = $51e798b2827f0117$var$_interopRequireDefault((parcelRequire("acw62")));

var $51e798b2827f0117$var$_baseNew = $51e798b2827f0117$var$_interopRequireDefault((parcelRequire("fqFky")));
function $51e798b2827f0117$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $51e798b2827f0117$var$ErrorIcon = (props)=>/*#__PURE__*/ $51e798b2827f0117$var$_react.default.createElement($51e798b2827f0117$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$51e798b2827f0117$var$ErrorIcon.displayName = "ErrorIcon";
var $51e798b2827f0117$var$_default = module.exports.default = $51e798b2827f0117$var$ErrorIcon;

});

parcelRegister("29iCp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $190add46bd1af531$var$_react = $190add46bd1af531$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $190add46bd1af531$var$_error = $190add46bd1af531$var$_interopRequireDefault((parcelRequire("71Yyg")));
function $190add46bd1af531$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $190add46bd1af531$var$ErrorIcon = (props)=>/*#__PURE__*/ $190add46bd1af531$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $190add46bd1af531$var$_error.default
    }));
$190add46bd1af531$var$ErrorIcon.displayName = "ErrorIcon";
var $190add46bd1af531$var$_default = module.exports.default = $190add46bd1af531$var$ErrorIcon;

});

parcelRegister("1yyV4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d97879d6b889ef4621929c7dd705b0ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12240db9e342d710$var$_react = $12240db9e342d710$var$_interopRequireDefault((parcelRequire("acw62")));

var $12240db9e342d710$var$_baseNew = $12240db9e342d710$var$_interopRequireDefault((parcelRequire("fqFky")));
function $12240db9e342d710$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12240db9e342d710$var$ErrorIcon = (props)=>/*#__PURE__*/ $12240db9e342d710$var$_react.default.createElement($12240db9e342d710$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$12240db9e342d710$var$ErrorIcon.displayName = "ErrorIcon";
var $12240db9e342d710$var$_default = module.exports.default = $12240db9e342d710$var$ErrorIcon;

});

parcelRegister("kOdz9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b91b2ac4848db507d9eb71a2b738b7fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f263001393e3eacf$var$_react = $f263001393e3eacf$var$_interopRequireDefault((parcelRequire("acw62")));

var $f263001393e3eacf$var$_baseNew = $f263001393e3eacf$var$_interopRequireDefault((parcelRequire("fqFky")));
function $f263001393e3eacf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f263001393e3eacf$var$SuccessIcon = (props)=>/*#__PURE__*/ $f263001393e3eacf$var$_react.default.createElement($f263001393e3eacf$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$f263001393e3eacf$var$SuccessIcon.displayName = "SuccessIcon";
var $f263001393e3eacf$var$_default = module.exports.default = $f263001393e3eacf$var$SuccessIcon;

});

parcelRegister("7GNzJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5992e946768e2bb1$var$_react = $5992e946768e2bb1$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $5992e946768e2bb1$var$_success = $5992e946768e2bb1$var$_interopRequireDefault((parcelRequire("jTmfM")));
function $5992e946768e2bb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5992e946768e2bb1$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $5992e946768e2bb1$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $5992e946768e2bb1$var$_success.default
    }));
$5992e946768e2bb1$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $5992e946768e2bb1$var$_default = module.exports.default = $5992e946768e2bb1$var$EditorSuccessIcon;

});
parcelRegister("jTmfM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8a54e77ebc6c63c295a0cd7c7e0eeda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7b46a7978487e07$var$_react = $e7b46a7978487e07$var$_interopRequireDefault((parcelRequire("acw62")));

var $e7b46a7978487e07$var$_baseNew = $e7b46a7978487e07$var$_interopRequireDefault((parcelRequire("fqFky")));
function $e7b46a7978487e07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7b46a7978487e07$var$SuccessIcon = (props)=>/*#__PURE__*/ $e7b46a7978487e07$var$_react.default.createElement($e7b46a7978487e07$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$e7b46a7978487e07$var$SuccessIcon.displayName = "SuccessIcon";
var $e7b46a7978487e07$var$_default = module.exports.default = $e7b46a7978487e07$var$SuccessIcon;

});


parcelRegister("127MC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c0c03e9a478e3fc$var$_react = $0c0c03e9a478e3fc$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $0c0c03e9a478e3fc$var$_close = $0c0c03e9a478e3fc$var$_interopRequireDefault((parcelRequire("3BIVW")));
function $0c0c03e9a478e3fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0c0c03e9a478e3fc$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $0c0c03e9a478e3fc$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $0c0c03e9a478e3fc$var$_close.default
    }));
$0c0c03e9a478e3fc$var$EditorCloseIcon.displayName = "EditorCloseIcon";
var $0c0c03e9a478e3fc$var$_default = module.exports.default = $0c0c03e9a478e3fc$var$EditorCloseIcon;

});

parcelRegister("9qHPW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $351e57f1b3af3055$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44525442e19df36f0b375d8cc3e61a43>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $351e57f1b3af3055$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "DevAiFlowSession",
            "kind": "LinkedField",
            "name": "devai_flowSessionComplete",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sessionARI",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "useCompleteFlowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCompleteFlowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "cc140d5e728fc3dcb4ddeb2c539a132d",
            "id": null,
            "metadata": {},
            "name": "useCompleteFlowMutation",
            "operationKind": "mutation",
            "text": 'mutation useCompleteFlowMutation(\n  $id: ID!\n) {\n  devai_flowSessionComplete(id: $id) @optIn(to: "DevAiFlowSessionComplete") {\n    id\n    sessionARI\n    status\n  }\n}\n'
        }
    };
}();
$351e57f1b3af3055$var$node.hash = "fd278c01fdd08d6ca6228a142f57d4e2";
var $351e57f1b3af3055$export$2e2bcd8739ae039 = $351e57f1b3af3055$var$node;

});

parcelRegister("6Yjvt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $50467a6f162d98ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cba19563d9141dbc669411c4460f16e2>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $50467a6f162d98ac$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "sessionId",
            "variableName": "sessionId"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "issueARI",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "codeFrame_loadFlowQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "DevAiFlowSession",
                    "kind": "LinkedField",
                    "name": "devai_flowSessionGetByIDAndCloudID",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DevAiFlowPipeline",
                            "kind": "LinkedField",
                            "name": "pipelines",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "codeFrame_loadFlowQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "DevAiFlowSession",
                    "kind": "LinkedField",
                    "name": "devai_flowSessionGetByIDAndCloudID",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DevAiFlowPipeline",
                            "kind": "LinkedField",
                            "name": "pipelines",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v3 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "6df7814c1c18a0e3bfbe3b0e7a4724ad",
            "id": null,
            "metadata": {},
            "name": "codeFrame_loadFlowQuery",
            "operationKind": "query",
            "text": 'query codeFrame_loadFlowQuery(\n  $sessionId: ID!\n  $cloudId: ID!\n) {\n  devai_flowSessionGetByIDAndCloudID(sessionId: $sessionId, cloudId: $cloudId) @optIn(to: "DevAiFlowSessionGetByIDAndCloudID") {\n    id\n    createdAt\n    issueARI\n    pipelines {\n      status\n      url\n      id\n    }\n  }\n}\n'
        }
    };
}();
$50467a6f162d98ac$var$node.hash = "2bc96ac28bcd7ae80590b68d7d72c94d";
var $50467a6f162d98ac$export$2e2bcd8739ae039 = $50467a6f162d98ac$var$node;

});

parcelRegister("2SfCO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ff82dc6ed61724a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf51b0ef2ef63bbae2a35217d5605f39>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7ff82dc6ed61724a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "sessionId",
            "variableName": "sessionId"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalInfoJSON",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "flowScreen_loadFlowQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "DevAiFlowSession",
                    "kind": "LinkedField",
                    "name": "devai_flowSessionGetByIDAndCloudID",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DevAiFlowPipeline",
                            "kind": "LinkedField",
                            "name": "pipelines",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "flowScreen_loadFlowQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "DevAiFlowSession",
                    "kind": "LinkedField",
                    "name": "devai_flowSessionGetByIDAndCloudID",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DevAiFlowPipeline",
                            "kind": "LinkedField",
                            "name": "pipelines",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v3 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "d7a709eb7db4e83e4e978cade7866cac",
            "id": null,
            "metadata": {},
            "name": "flowScreen_loadFlowQuery",
            "operationKind": "query",
            "text": 'query flowScreen_loadFlowQuery(\n  $sessionId: ID!\n  $cloudId: ID!\n) {\n  devai_flowSessionGetByIDAndCloudID(sessionId: $sessionId, cloudId: $cloudId) @optIn(to: "DevAiFlowSessionGetByIDAndCloudID") {\n    id\n    createdAt\n    status\n    additionalInfoJSON\n    pipelines {\n      status\n      url\n      id\n    }\n  }\n}\n'
        }
    };
}();
$7ff82dc6ed61724a$var$node.hash = "8f0e1d26b6a07a82e822647006422c30";
var $7ff82dc6ed61724a$export$2e2bcd8739ae039 = $7ff82dc6ed61724a$var$node;

});

parcelRegister("7rmpO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11503d00887c85dd37060e980bd5f02d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56ac713e38842c57$var$_react = $56ac713e38842c57$var$_interopRequireDefault((parcelRequire("acw62")));

var $56ac713e38842c57$var$_baseNew = $56ac713e38842c57$var$_interopRequireDefault((parcelRequire("fqFky")));
function $56ac713e38842c57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56ac713e38842c57$var$InformationIcon = (props)=>/*#__PURE__*/ $56ac713e38842c57$var$_react.default.createElement($56ac713e38842c57$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$56ac713e38842c57$var$InformationIcon.displayName = "InformationIcon";
var $56ac713e38842c57$var$_default = module.exports.default = $56ac713e38842c57$var$InformationIcon;

});

parcelRegister("kyY1Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef858c181cbf85a8$var$_react = $ef858c181cbf85a8$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $ef858c181cbf85a8$var$_information = $ef858c181cbf85a8$var$_interopRequireDefault((parcelRequire("7rmpO")));
function $ef858c181cbf85a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ef858c181cbf85a8$var$InfoIcon = (props)=>/*#__PURE__*/ $ef858c181cbf85a8$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $ef858c181cbf85a8$var$_information.default
    }));
$ef858c181cbf85a8$var$InfoIcon.displayName = "InfoIcon";
var $ef858c181cbf85a8$var$_default = module.exports.default = $ef858c181cbf85a8$var$InfoIcon;

});

parcelRegister("ftOEy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b450db1e4afceb73$var$_react = $b450db1e4afceb73$var$_interopRequireDefault((parcelRequire("acw62")));

var $b450db1e4afceb73$var$_baseNew = $b450db1e4afceb73$var$_interopRequireDefault((parcelRequire("fqFky")));
function $b450db1e4afceb73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b450db1e4afceb73$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $b450db1e4afceb73$var$_react.default.createElement($b450db1e4afceb73$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$b450db1e4afceb73$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $b450db1e4afceb73$var$_default = module.exports.default = $b450db1e4afceb73$var$QuestionCircleIcon;

});

parcelRegister("c8PsL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d6e26d8f0ca3492$var$_react = $8d6e26d8f0ca3492$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $8d6e26d8f0ca3492$var$_questionCircle = $8d6e26d8f0ca3492$var$_interopRequireDefault((parcelRequire("ftOEy")));
function $8d6e26d8f0ca3492$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d6e26d8f0ca3492$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $8d6e26d8f0ca3492$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $8d6e26d8f0ca3492$var$_questionCircle.default
    }));
$8d6e26d8f0ca3492$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $8d6e26d8f0ca3492$var$_default = module.exports.default = $8d6e26d8f0ca3492$var$QuestionCircleIcon;

});

parcelRegister("4rk35", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33b93c4ae7cd1380$var$_react = $33b93c4ae7cd1380$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $33b93c4ae7cd1380$var$_success = $33b93c4ae7cd1380$var$_interopRequireDefault((parcelRequire("jTmfM")));
function $33b93c4ae7cd1380$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $33b93c4ae7cd1380$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $33b93c4ae7cd1380$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $33b93c4ae7cd1380$var$_success.default
    }));
$33b93c4ae7cd1380$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $33b93c4ae7cd1380$var$_default = module.exports.default = $33b93c4ae7cd1380$var$CheckCircleIcon;

});

parcelRegister("31QgG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e9a839f245cce70$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c41db37033f24db3201bc81fae81fec>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5e9a839f245cce70$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jql"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "assignedToMeQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "card_fragment"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "assignedToMeQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "summary",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "issuetype",
                                                                "status",
                                                                "description"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId",
                                                                            "storageKey": null
                                                                        },
                                                                        v2 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v4 /*: any*/ ,
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "small",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        v2 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "JiraStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v4 /*: any*/ ,
                                                                                        v2 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusField",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "JiraRichText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "richText",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "JiraADF",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "adfValue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "convertedPlainText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "plainText",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "JiraRichTextField",
                                                                            "abstractKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": 'fieldsById(ids:["issuetype","status","description"])'
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "4eff0b0991a42782209751dff48b473e",
            "id": null,
            "metadata": {},
            "name": "assignedToMeQuery",
            "operationKind": "query",
            "text": 'query assignedToMeQuery(\n  $cloudId: ID!\n  $jql: String\n) {\n  jira {\n    issueSearch(cloudId: $cloudId, issueSearchInput: {jql: $jql}) @optIn(to: "JiraSpreadsheetComponent-M1") {\n      edges {\n        node {\n          id\n          key\n          ...card_fragment\n        }\n      }\n    }\n  }\n}\n\nfragment card_fragment on JiraIssue {\n  id\n  key\n  summary\n  fieldsById(ids: ["issuetype", "status", "description"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ... on JiraIssueTypeField {\n          issueType {\n            name\n            avatar {\n              small\n            }\n            id\n          }\n        }\n        ... on JiraStatusField {\n          id\n          status {\n            name\n            id\n          }\n        }\n        ... on JiraRichTextField {\n          richText {\n            adfValue {\n              convertedPlainText {\n                plainText\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n'
        }
    };
}();
$5e9a839f245cce70$var$node.hash = "abc321844d9c6870060a3b7ab9c39131";
var $5e9a839f245cce70$export$2e2bcd8739ae039 = $5e9a839f245cce70$var$node;

});

parcelRegister("WuwQM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b71fe4da82599b34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66438b6d6ac543f869203c04984c63da>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b71fe4da82599b34$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "card_fragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "issuetype",
                            "status",
                            "description"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraIssueFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fieldId",
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "small",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "JiraIssueTypeField",
                                        "abstractKey": null
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "JiraStatusField",
                                        "abstractKey": null
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "JiraRichText",
                                                "kind": "LinkedField",
                                                "name": "richText",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "JiraADF",
                                                        "kind": "LinkedField",
                                                        "name": "adfValue",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "JiraAdfToConvertedPlainText",
                                                                "kind": "LinkedField",
                                                                "name": "convertedPlainText",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "plainText",
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "JiraRichTextField",
                                        "abstractKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": 'fieldsById(ids:["issuetype","status","description"])'
            }
        ],
        "type": "JiraIssue",
        "abstractKey": null
    };
}();
$b71fe4da82599b34$var$node.hash = "322eefb2447626d447467304ee0e2a9b";
var $b71fe4da82599b34$export$2e2bcd8739ae039 = $b71fe4da82599b34$var$node;

});

parcelRegister("5FCTo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a026656028c05157ac730015f665601>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $420ef354d0ff2044$var$_react = $420ef354d0ff2044$var$_interopRequireDefault((parcelRequire("acw62")));

var $420ef354d0ff2044$var$_baseNew = $420ef354d0ff2044$var$_interopRequireDefault((parcelRequire("fqFky")));
function $420ef354d0ff2044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $420ef354d0ff2044$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $420ef354d0ff2044$var$_react.default.createElement($420ef354d0ff2044$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.03 3.97 6 7.94l3.97-3.97 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$420ef354d0ff2044$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $420ef354d0ff2044$var$_default = module.exports.default = $420ef354d0ff2044$var$ChevronDownIcon;

});

parcelRegister("glAld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afcaa915720f5b4d9e69ee6ef0943c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be6acc1b52267527$var$_react = $be6acc1b52267527$var$_interopRequireDefault((parcelRequire("acw62")));

var $be6acc1b52267527$var$_baseNew = $be6acc1b52267527$var$_interopRequireDefault((parcelRequire("fqFky")));
function $be6acc1b52267527$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be6acc1b52267527$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $be6acc1b52267527$var$_react.default.createElement($be6acc1b52267527$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 4.06 2.03 8.03.97 6.97l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5-1.06 1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$be6acc1b52267527$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $be6acc1b52267527$var$_default = module.exports.default = $be6acc1b52267527$var$ChevronUpIcon;

});

parcelRegister("7pIF7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $565d832dde178685$var$_react = $565d832dde178685$var$_interopRequireDefault((parcelRequire("acw62")));

var $565d832dde178685$var$_baseNew = $565d832dde178685$var$_interopRequireDefault((parcelRequire("fqFky")));
function $565d832dde178685$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $565d832dde178685$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $565d832dde178685$var$_react.default.createElement($565d832dde178685$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$565d832dde178685$var$ArrowUpRightIcon.displayName = "ArrowUpRightIcon";
var $565d832dde178685$var$_default = module.exports.default = $565d832dde178685$var$ArrowUpRightIcon;

});

parcelRegister("atfwD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fa6a1ec12e5ccb05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d6cd7c2cb0afdcfa7f6d01183d0df0e3>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fa6a1ec12e5ccb05$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "capabilities_IntegrationsConfigStates",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": null,
                "args": null,
                "concreteType": "JiraAppConfigState",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        "action": "THROW",
                        "path": "node.id"
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "appDisplayName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "appIconLink",
                        "storageKey": null
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraConfigStateConnection",
                            "kind": "LinkedField",
                            "name": "config",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "JiraConfigStateEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "JiraConfigState",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "status",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "configureLink",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    "action": "THROW",
                                    "path": "node.config.edges"
                                }
                            ],
                            "storageKey": null
                        },
                        "action": "THROW",
                        "path": "node.config"
                    }
                ],
                "storageKey": null
            },
            "action": "THROW",
            "path": "node"
        }
    ],
    "type": "JiraAppConfigStateEdge",
    "abstractKey": null
};
$fa6a1ec12e5ccb05$var$node.hash = "e1424ee322826b62f0a4d28af29ded49";
var $fa6a1ec12e5ccb05$export$2e2bcd8739ae039 = $fa6a1ec12e5ccb05$var$node;

});

parcelRegister("1fqzs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6346acb1f89fc3ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0a85e5a04b8658e35893c8db05c6a21>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6346acb1f89fc3ca$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "manage_IntegrationsConfigStates",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": null,
                "args": null,
                "concreteType": "JiraAppConfigState",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        "action": "THROW",
                        "path": "node.id"
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "appDisplayName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "appIconLink",
                        "storageKey": null
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraConfigStateConnection",
                            "kind": "LinkedField",
                            "name": "config",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "JiraConfigStateEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "JiraConfigState",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "status",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "configureLink",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    "action": "THROW",
                                    "path": "node.config.edges"
                                }
                            ],
                            "storageKey": null
                        },
                        "action": "THROW",
                        "path": "node.config"
                    }
                ],
                "storageKey": null
            },
            "action": "THROW",
            "path": "node"
        }
    ],
    "type": "JiraAppConfigStateEdge",
    "abstractKey": null
};
$6346acb1f89fc3ca$var$node.hash = "7cb1e047b6ee7509035df408cbe31ce3";
var $6346acb1f89fc3ca$export$2e2bcd8739ae039 = $6346acb1f89fc3ca$var$node;

});

parcelRegister("kS6rz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $561381eb649b1875$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c5c467aeba3736e272ed83d641336eb>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $561381eb649b1875$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudID"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudID"
        },
        {
            "kind": "Literal",
            "name": "providerTypeFilter",
            "value": [
                "DEVELOPMENT_INFO"
            ]
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "homePageMainQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraAppConfigStateConnection",
                                    "kind": "LinkedField",
                                    "name": "configStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "JiraAppConfigStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "manage_IntegrationsConfigStates"
                                                },
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "capabilities_IntegrationsConfigStates"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "JiraConfigStateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "config",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "JiraConfigStateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "JiraConfigState",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ 
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "homePageMainQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraAppConfigStateConnection",
                                    "kind": "LinkedField",
                                    "name": "configStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "JiraAppConfigStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "appDisplayName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "appIconLink",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "JiraConfigStateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "config",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "JiraConfigStateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "JiraConfigState",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "configureLink",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "4c79b1884b63e49c46537468e7718118",
            "id": null,
            "metadata": {},
            "name": "homePageMainQuery",
            "operationKind": "query",
            "text": 'query homePageMainQuery(\n  $cloudID: ID!\n) {\n  jira {\n    devOps {\n      configStates(cloudId: $cloudID, providerTypeFilter: [DEVELOPMENT_INFO]) @optIn(to: "Jira-config-states-by-provider") {\n        edges {\n          ...manage_IntegrationsConfigStates\n          ...capabilities_IntegrationsConfigStates\n          node {\n            id\n            config {\n              edges {\n                node {\n                  status\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment capabilities_IntegrationsConfigStates on JiraAppConfigStateEdge {\n  node {\n    id\n    appDisplayName\n    appIconLink\n    config {\n      edges {\n        node {\n          status\n          configureLink\n        }\n      }\n    }\n  }\n}\n\nfragment manage_IntegrationsConfigStates on JiraAppConfigStateEdge {\n  node {\n    id\n    appDisplayName\n    appIconLink\n    config {\n      edges {\n        node {\n          status\n          configureLink\n        }\n      }\n    }\n  }\n}\n'
        }
    };
}();
$561381eb649b1875$var$node.hash = "52d58e18a7195a30a2d154faa42a11a8";
var $561381eb649b1875$export$2e2bcd8739ae039 = $561381eb649b1875$var$node;

});

parcelRegister("8bfEX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7bf56ee6167f5baa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb96e74be1ca518527c01ba9cbc73018>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7bf56ee6167f5baa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }
    ], v1 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        }
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "jiraProjectsByJql",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalCount",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "startCursor",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "key",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "name",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "webUrl",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "codePlannerConfigurationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "codePlannerConfigurationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5d5fa5e5a7543259cf82ed59ee2bd7e0",
            "id": null,
            "metadata": {},
            "name": "codePlannerConfigurationQuery",
            "operationKind": "query",
            "text": "query codePlannerConfigurationQuery(\n  $cloudId: ID!\n  $query: String!\n) {\n  jira {\n    jiraProjectsByJql(cloudId: $cloudId, query: $query) {\n      totalCount\n      pageInfo {\n        startCursor\n        endCursor\n      }\n      edges {\n        node {\n          id\n          key\n          name\n          webUrl\n        }\n        cursor\n      }\n    }\n  }\n}\n"
        }
    };
}();
$7bf56ee6167f5baa$var$node.hash = "9bbe903cd497952194cc2c9a9d002222";
var $7bf56ee6167f5baa$export$2e2bcd8739ae039 = $7bf56ee6167f5baa$var$node;

});

parcelRegister("3V3p2", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $2da955b69f632732$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $2da955b69f632732$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $2da955b69f632732$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $2da955b69f632732$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $2da955b69f632732$export$c476bbe5da59992d);

var $02Ztr = parcelRequire("02Ztr");
var $2da955b69f632732$export$3987dc24b734dcab = function getPageRows(allRows, pageNumber, rowsPerPage) {
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
var $2da955b69f632732$export$5eb35a4771ec4090 = function assertIsSortable(head) {
    if (!head || !head.cells) return;
    head.cells.forEach(function(cell) {
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
var $2da955b69f632732$export$9133f5a8bfe8a200 = function validateSortKey(sortKey, head) {
    if (!sortKey) return;
    var headHasKey = head && head.cells.map(function(cell) {
        return cell.key;
    }).includes(sortKey);
    if (!headHasKey) try {
        throw Error("Cell with ".concat(sortKey, " key not found in head."));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
var $2da955b69f632732$export$a601f1775e10043f = function inlineStylesIfRanking(isRanking, width, height) {
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
var $2da955b69f632732$export$92bcb1ed38b134a1 = function computeIndex(index, page, rowsPerPage) {
    var itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
var $2da955b69f632732$export$c476bbe5da59992d = function reorderRows(rankEnd, rows) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var rowsPerPage = arguments.length > 3 ? arguments[3] : undefined;
    var destination = rankEnd.destination, sourceIndex = rankEnd.sourceIndex;
    if (!destination) return rows;
    var fromIndex = $2da955b69f632732$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    var toIndex = $2da955b69f632732$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    var reordered = rows.slice();
    var _reordered$splice = reordered.splice(fromIndex, 1), _reordered$splice2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_reordered$splice, 1), removed = _reordered$splice2[0];
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("alt3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $788267952c0dc246$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $7Dr7Z = parcelRequire("7Dr7Z");

var $3V3p2 = parcelRequire("3V3p2");
var $788267952c0dc246$var$_excluded = [
    "rows",
    "head",
    "sortKey",
    "sortOrder",
    "rowsPerPage",
    "page",
    "forwardedRef"
];
function $788267952c0dc246$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $788267952c0dc246$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $788267952c0dc246$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $788267952c0dc246$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $788267952c0dc246$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $788267952c0dc246$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $788267952c0dc246$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($788267952c0dc246$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $788267952c0dc246$var$getSortingCellValue = function getSortingCellValue(cells, head, sortKey) {
    for(var i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
var $788267952c0dc246$var$getSortedRows = function getSortedRows(head, rows, sortKey, sortOrder) {
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    var modifier = sortOrder === (0, $7Dr7Z.ASC) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    var collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "accent"
    });
    // Get copy of rows to avoid sorting prop in place
    var sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort(function(a, b) {
        var valA = $788267952c0dc246$var$getSortingCellValue(a.cells, head, sortKey);
        var valB = $788267952c0dc246$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(valA) !== (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(valB)) {
            // numbers are always grouped higher in the sort
            if (typeof valA === "number") return -1;
            if (typeof valB === "number") return 1;
            // strings are grouped next
            if (typeof valA === "string") return -1;
            if (typeof valB === "string") return 1;
        }
        if (typeof valA === "string" && typeof valB === "string") return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $788267952c0dc246$export$2e2bcd8739ae039(WrappedComponent) {
    var WithSortedPageRows = /*#__PURE__*/ function(_React$Component) {
        function WithSortedPageRows() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, WithSortedPageRows);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $788267952c0dc246$var$_callSuper(this, WithSortedPageRows, [].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "state", {
                pageRows: []
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(WithSortedPageRows, _React$Component);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(WithSortedPageRows, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(_prevProps, prevState) {
                    if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, rows = _this$props.rows, head = _this$props.head, sortKey = _this$props.sortKey, sortOrder = _this$props.sortOrder, rowsPerPage = _this$props.rowsPerPage, page = _this$props.page, forwardedRef = _this$props.forwardedRef, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$props, $788267952c0dc246$var$_excluded);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                        pageRows: this.state.pageRows,
                        head: head
                    }, restProps, {
                        ref: forwardedRef
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(props, state) {
                    var rows = props.rows, head = props.head, sortKey = props.sortKey, sortOrder = props.sortOrder, page = props.page, rowsPerPage = props.rowsPerPage, isTotalPagesControlledExternally = props.isTotalPagesControlledExternally;
                    (0, $3V3p2.validateSortKey)(sortKey, head);
                    var sortedRows;
                    var pageRows;
                    if (isTotalPagesControlledExternally) {
                        sortedRows = rows;
                        pageRows = rows;
                    } else {
                        sortedRows = $788267952c0dc246$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                        pageRows = (0, $3V3p2.getPageRows)(sortedRows, page, rowsPerPage);
                    }
                    return $788267952c0dc246$var$_objectSpread($788267952c0dc246$var$_objectSpread({}, state), {}, {
                        pageRows: pageRows
                    });
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WithSortedPageRows, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
            forwardedRef: ref
        }));
    });
}

});
parcelRegister("7Dr7Z", function(module, exports) {

$parcel$export(module.exports, "ASC", () => $58f137f15a3648f0$export$1dee026a19752d6b);
$parcel$export(module.exports, "DESC", () => $58f137f15a3648f0$export$b6abcf7fa1d94f65);
$parcel$export(module.exports, "SMALL", () => $58f137f15a3648f0$export$71dd4c8ecd45e95f);
$parcel$export(module.exports, "LARGE", () => $58f137f15a3648f0$export$7b93a10c0fefe3e3);
$parcel$export(module.exports, "LOADING_CONTENTS_OPACITY", () => $58f137f15a3648f0$export$3843c586a90b9cbf);
var $58f137f15a3648f0$export$1dee026a19752d6b = "ASC";
var $58f137f15a3648f0$export$b6abcf7fa1d94f65 = "DESC";
var $58f137f15a3648f0$export$71dd4c8ecd45e95f = "small";
var $58f137f15a3648f0$export$7b93a10c0fefe3e3 = "large";
var $58f137f15a3648f0$export$3843c586a90b9cbf = 0.22;

});


parcelRegister("74cUM", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $5252ecbc588124b3$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $2phQv = parcelRequire("2phQv");
var $5252ecbc588124b3$var$_excluded = [
    "width",
    "isFixedSize",
    "shouldTruncate",
    "innerRef"
];
var $5252ecbc588124b3$var$fixedSizeTruncateStyles = null;
var $5252ecbc588124b3$var$overflowTruncateStyles = null;
var $5252ecbc588124b3$var$truncationWidthStyles = null;
var $5252ecbc588124b3$var$cellStyles = null;
var $5252ecbc588124b3$export$948e91fcef170792 = function TableBodyCell(_ref) {
    var width = _ref.width, isFixedSize = _ref.isFixedSize, shouldTruncate = _ref.shouldTruncate, innerRef = _ref.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $5252ecbc588124b3$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement("td", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $2phQv.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        className: (0, $5zphJ.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ])
    }, props));
};

});
parcelRegister("2phQv", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $1c0bc265ffb1f4e3$export$5e6497a652ae30b5);

var $g5Zhu = parcelRequire("g5Zhu");
var $1c0bc265ffb1f4e3$var$CSS_VAR_WIDTH = "--local-dynamic-table-width";
var $1c0bc265ffb1f4e3$export$5e6497a652ae30b5 = function getTruncationStyleVars(_ref) {
    var width = _ref.width;
    return typeof width !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $1c0bc265ffb1f4e3$var$CSS_VAR_WIDTH, "".concat(width, "%")) : undefined;
};

});


parcelRegister("bs857", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $8568940d77e9b3f7$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");
var $8568940d77e9b3f7$var$_excluded = [
    "isHighlighted",
    "children",
    "style",
    "testId",
    "className"
];
function $8568940d77e9b3f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8568940d77e9b3f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8568940d77e9b3f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8568940d77e9b3f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8568940d77e9b3f7$var$rowStyles = null;
var $8568940d77e9b3f7$var$rowBackgroundStyles = null;
var $8568940d77e9b3f7$var$rowHighlightedBackgroundStyles = null;
var $8568940d77e9b3f7$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var isHighlighted = _ref.isHighlighted, children = _ref.children, style = _ref.style, testId = _ref.testId, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $8568940d77e9b3f7$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement("tr", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        /**
     * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
     * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $5zphJ.default)([
            "_bfhkqtfy _1ygb1852 _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ])
    }, rest, {
        ref: ref,
        "data-testid": testId,
        style: $8568940d77e9b3f7$var$_objectSpread($8568940d77e9b3f7$var$_objectSpread({}, style), {}, {
            "--_akp1ox": (0, $cZGu3.default)("2px solid ".concat("var(--ds-border-focused, var(--local-dynamic-table-hover-bg))"))
        })
    }), children);
});

});

parcelRegister("b12kL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80519925abf707e0$var$_react = $80519925abf707e0$var$_interopRequireDefault((parcelRequire("acw62")));

var $80519925abf707e0$var$_baseNew = $80519925abf707e0$var$_interopRequireDefault((parcelRequire("fqFky")));
function $80519925abf707e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80519925abf707e0$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $80519925abf707e0$var$_react.default.createElement($80519925abf707e0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$80519925abf707e0$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $80519925abf707e0$var$_default = module.exports.default = $80519925abf707e0$var$ChevronLeftIcon;

});

parcelRegister("d9q0V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99304b792f26d553$var$_react = $99304b792f26d553$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $99304b792f26d553$var$_chevronLeft = $99304b792f26d553$var$_interopRequireDefault((parcelRequire("b12kL")));
function $99304b792f26d553$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $99304b792f26d553$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $99304b792f26d553$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $99304b792f26d553$var$_chevronLeft.default,
        iconType: "utility"
    }));
$99304b792f26d553$var$ChevronLeftLargeIcon.displayName = "ChevronLeftLargeIcon";
var $99304b792f26d553$var$_default = module.exports.default = $99304b792f26d553$var$ChevronLeftLargeIcon;

});

parcelRegister("aPL5Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281ba53efaa7c88b789646091262f5f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e3332f9ea76538b$var$_react = $7e3332f9ea76538b$var$_interopRequireDefault((parcelRequire("acw62")));

var $7e3332f9ea76538b$var$_baseNew = $7e3332f9ea76538b$var$_interopRequireDefault((parcelRequire("fqFky")));
function $7e3332f9ea76538b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e3332f9ea76538b$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $7e3332f9ea76538b$var$_react.default.createElement($7e3332f9ea76538b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.94 6 3.97 2.03 5.03.97l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$7e3332f9ea76538b$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $7e3332f9ea76538b$var$_default = module.exports.default = $7e3332f9ea76538b$var$ChevronRightIcon;

});

parcelRegister("7gGhC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54aad3967c6c9221$var$_react = $54aad3967c6c9221$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $54aad3967c6c9221$var$_chevronRight = $54aad3967c6c9221$var$_interopRequireDefault((parcelRequire("aPL5Y")));
function $54aad3967c6c9221$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54aad3967c6c9221$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $54aad3967c6c9221$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $54aad3967c6c9221$var$_chevronRight.default,
        iconType: "utility"
    }));
$54aad3967c6c9221$var$ChevronRightLargeIcon.displayName = "ChevronRightLargeIcon";
var $54aad3967c6c9221$var$_default = module.exports.default = $54aad3967c6c9221$var$ChevronRightLargeIcon;

});

parcelRegister("aukfC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a2c6a1d36163a8b$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
function $7a2c6a1d36163a8b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $7a2c6a1d36163a8b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $7a2c6a1d36163a8b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7a2c6a1d36163a8b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7a2c6a1d36163a8b$export$2e2bcd8739ae039(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        function WithDimensions() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, WithDimensions);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $7a2c6a1d36163a8b$var$_callSuper(this, WithDimensions, [].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "state", {
                refWidth: 0,
                refHeight: 0
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "innerRef", function(ref) {
                if (ref && !_this.props.isRanking) _this.ref = ref;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "updateDimensions", function() {
                if (!_this.ref) return;
                var clientRect = _this.ref.getBoundingClientRect();
                var width = clientRect.width;
                var height = clientRect.height;
                if (width !== _this.state.refWidth || height !== _this.state.refHeight) _this.setState({
                    refWidth: width,
                    refHeight: height
                });
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(WithDimensions, _React$Component);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(WithDimensions, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    var wasRanking = this.props.isRanking;
                    var willRanking = nextProps.isRanking;
                    if (willRanking && !wasRanking) this.updateDimensions();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$state = this.state, refWidth = _this$state.refWidth, refHeight = _this$state.refHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                        refWidth: refWidth,
                        refHeight: refHeight,
                        innerRef: this.innerRef
                    }, this.props));
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
}

});

parcelRegister("hwM0X", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dJdHG").then(()=>parcelRequire("1vX2U"));

});

parcelRegister("9FrBT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01d0fd5b96ca9718$var$_react = $01d0fd5b96ca9718$var$_interopRequireDefault((parcelRequire("acw62")));

var $01d0fd5b96ca9718$var$_baseNew = $01d0fd5b96ca9718$var$_interopRequireDefault((parcelRequire("fqFky")));
function $01d0fd5b96ca9718$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $01d0fd5b96ca9718$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $01d0fd5b96ca9718$var$_react.default.createElement($01d0fd5b96ca9718$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$01d0fd5b96ca9718$var$CheckMarkIcon.displayName = "CheckMarkIcon";
var $01d0fd5b96ca9718$var$_default = module.exports.default = $01d0fd5b96ca9718$var$CheckMarkIcon;

});

parcelRegister("gm5D7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be83116dc16c7889$var$_react = $be83116dc16c7889$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $be83116dc16c7889$var$_checkMark = $be83116dc16c7889$var$_interopRequireDefault((parcelRequire("7CgVR")));
function $be83116dc16c7889$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be83116dc16c7889$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $be83116dc16c7889$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $be83116dc16c7889$var$_checkMark.default
    }));
$be83116dc16c7889$var$EditorDoneIcon.displayName = "EditorDoneIcon";
var $be83116dc16c7889$var$_default = module.exports.default = $be83116dc16c7889$var$EditorDoneIcon;

});
parcelRegister("7CgVR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58b93765bad037bc$var$_react = $58b93765bad037bc$var$_interopRequireDefault((parcelRequire("acw62")));

var $58b93765bad037bc$var$_baseNew = $58b93765bad037bc$var$_interopRequireDefault((parcelRequire("fqFky")));
function $58b93765bad037bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58b93765bad037bc$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $58b93765bad037bc$var$_react.default.createElement($58b93765bad037bc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$58b93765bad037bc$var$CheckMarkIcon.displayName = "CheckMarkIcon";
var $58b93765bad037bc$var$_default = module.exports.default = $58b93765bad037bc$var$CheckMarkIcon;

});


parcelRegister("aqtvs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56f9c413d8fbf4deb11215ad83bf4b70>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7973387782f99578$var$_react = $7973387782f99578$var$_interopRequireDefault((parcelRequire("acw62")));

var $7973387782f99578$var$_baseNew = $7973387782f99578$var$_interopRequireDefault((parcelRequire("fqFky")));
function $7973387782f99578$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7973387782f99578$var$CrossIcon = (props)=>/*#__PURE__*/ $7973387782f99578$var$_react.default.createElement($7973387782f99578$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.06 6 3.47-3.47-1.06-1.06L6 4.94 2.53 1.47 1.47 2.53 4.94 6 1.47 9.47l1.06 1.06L6 7.06l3.47 3.47 1.06-1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$7973387782f99578$var$CrossIcon.displayName = "CrossIcon";
var $7973387782f99578$var$_default = module.exports.default = $7973387782f99578$var$CrossIcon;

});

parcelRegister("1EH4T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $134af145e62a8b88$var$_react = $134af145e62a8b88$var$_interopRequireDefault((parcelRequire("acw62")));

var $134af145e62a8b88$var$_baseNew = $134af145e62a8b88$var$_interopRequireDefault((parcelRequire("fqFky")));
function $134af145e62a8b88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $134af145e62a8b88$var$PersonIcon = (props)=>/*#__PURE__*/ $134af145e62a8b88$var$_react.default.createElement($134af145e62a8b88$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$134af145e62a8b88$var$PersonIcon.displayName = "PersonIcon";
var $134af145e62a8b88$var$_default = module.exports.default = $134af145e62a8b88$var$PersonIcon;

});

parcelRegister("h910A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7b40f2ec5b5c30e$var$_react = $c7b40f2ec5b5c30e$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $c7b40f2ec5b5c30e$var$_person = $c7b40f2ec5b5c30e$var$_interopRequireDefault((parcelRequire("1EH4T")));
function $c7b40f2ec5b5c30e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c7b40f2ec5b5c30e$var$PersonIcon = (props)=>/*#__PURE__*/ $c7b40f2ec5b5c30e$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $c7b40f2ec5b5c30e$var$_person.default
    }));
$c7b40f2ec5b5c30e$var$PersonIcon.displayName = "PersonIcon";
var $c7b40f2ec5b5c30e$var$_default = module.exports.default = $c7b40f2ec5b5c30e$var$PersonIcon;

});

parcelRegister("47BVL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1a26e96d639121c034f7ae4d8530108>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30053d2078544edc$var$_react = $30053d2078544edc$var$_interopRequireDefault((parcelRequire("acw62")));

var $30053d2078544edc$var$_baseNew = $30053d2078544edc$var$_interopRequireDefault((parcelRequire("fqFky")));
function $30053d2078544edc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30053d2078544edc$var$ReleaseIcon = (props)=>/*#__PURE__*/ $30053d2078544edc$var$_react.default.createElement($30053d2078544edc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$30053d2078544edc$var$ReleaseIcon.displayName = "ReleaseIcon";
var $30053d2078544edc$var$_default = module.exports.default = $30053d2078544edc$var$ReleaseIcon;

});

parcelRegister("lPpiW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe41fd54ecdb4fd6$var$_react = $fe41fd54ecdb4fd6$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $fe41fd54ecdb4fd6$var$_release = $fe41fd54ecdb4fd6$var$_interopRequireDefault((parcelRequire("47BVL")));
function $fe41fd54ecdb4fd6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fe41fd54ecdb4fd6$var$ShipIcon = (props)=>/*#__PURE__*/ $fe41fd54ecdb4fd6$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $fe41fd54ecdb4fd6$var$_release.default
    }));
$fe41fd54ecdb4fd6$var$ShipIcon.displayName = "ShipIcon";
var $fe41fd54ecdb4fd6$var$_default = module.exports.default = $fe41fd54ecdb4fd6$var$ShipIcon;

});

parcelRegister("35SCa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $240c340d18938fc1$var$_react = $240c340d18938fc1$var$_interopRequireDefault((parcelRequire("acw62")));

var $240c340d18938fc1$var$_baseNew = $240c340d18938fc1$var$_interopRequireDefault((parcelRequire("fqFky")));
function $240c340d18938fc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $240c340d18938fc1$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $240c340d18938fc1$var$_react.default.createElement($240c340d18938fc1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$240c340d18938fc1$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $240c340d18938fc1$var$_default = module.exports.default = $240c340d18938fc1$var$ArrowRightIcon;

});

parcelRegister("1CwJo", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", () => $12e2bac26b5840ae$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $12e2bac26b5840ae$export$b46cecdf698e4bb5);

var $dAOin = parcelRequire("dAOin");

var $4QlPs = parcelRequire("4QlPs");

var $d33Zd = parcelRequire("d33Zd");

var $9Y7Ij = parcelRequire("9Y7Ij");

var $8lZnk = parcelRequire("8lZnk");
function $12e2bac26b5840ae$export$5ecf2aafafee3e0() {
    (0, $8lZnk.startLSObserver)();
    (0, $8lZnk.startLTObserver)();
}
var $12e2bac26b5840ae$export$b46cecdf698e4bb5 = function getLighthouseMetrics(_ref) {
    var start = _ref.start, stop = _ref.stop;
    var tbt = (0, $d33Zd.getTBT)(start, stop, (0, $9Y7Ij.EntriesBuffer)[(0, $4QlPs.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    var cls = (0, $dAOin.getCLS)(start, stop, (0, $9Y7Ij.EntriesBuffer)[(0, $4QlPs.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        "metric:tbt": Math.round(tbt.total),
        "metric:tbt:observed": Math.round(tbt.observed),
        "metric:cls": cls
    };
};

});
parcelRegister("dAOin", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $9e55a6cc9f353d77$export$fc6227831ee7c7);
function $9e55a6cc9f353d77$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9e55a6cc9f353d77$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9e55a6cc9f353d77$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9e55a6cc9f353d77$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9e55a6cc9f353d77$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9e55a6cc9f353d77$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $9e55a6cc9f353d77$export$fc6227831ee7c7 = function getCLS(start, stop, buffer) {
    var layoutShifts = buffer.getAll().filter(function(entry) {
        return entry.startTime >= start && entry.startTime <= stop;
    });
    var sessionWindows = [];
    var currentWindow = null;
    // Group layout shifts into session windows
    var _iterator = $9e55a6cc9f353d77$var$_createForOfIteratorHelper(layoutShifts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var shift = _step.value;
            var startTime = shift.startTime;
            var endTime = shift.startTime + shift.duration;
            var score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                // Start a new session window
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                // Add layout shift to current session window
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
    // Find session window with highest cumulative score
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var maxScore = sessionWindows.reduce(function(max, sessionWindow) {
        return sessionWindow.score > max ? sessionWindow.score : max;
    }, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("4QlPs", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $386cf38233e8ea39$export$a4def92db6fc8e17);
var $386cf38233e8ea39$export$a4def92db6fc8e17 = {
    LayoutShift: "layout-shift",
    LongTask: "longtask"
};

});

parcelRegister("d33Zd", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $97fea5c76ffbd6a8$export$2d6e933b35bd3407);
var $97fea5c76ffbd6a8$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
var $97fea5c76ffbd6a8$export$2d6e933b35bd3407 = function getTBT(start, stop, buffer) {
    return buffer.getAll().filter(function(entry) {
        return entry.startTime <= stop && entry.duration > $97fea5c76ffbd6a8$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop);
    }).reduce(function(tbt, entry) {
        var longTaskStop = entry.startTime + entry.duration;
        var intersectStart = Math.max(entry.startTime + $97fea5c76ffbd6a8$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        var intersectStop = Math.min(longTaskStop, stop);
        var longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $97fea5c76ffbd6a8$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
};

});

parcelRegister("9Y7Ij", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $741fb36946066f96$export$f7dc16cbd16f7bbe);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $4QlPs = parcelRequire("4QlPs");
var $741fb36946066f96$export$2c6e86519c9e8188 = /*#__PURE__*/ function() {
    function BufferWithMaxLength() {
        var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, BufferWithMaxLength);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "buffer", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "full", false);
        this.maxLength = maxLength;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(BufferWithMaxLength, [
        {
            key: "push",
            value: function push(item) {
                if (this.full || this.maxLength === this.buffer.length) {
                    this.full = true;
                    this.buffer.shift();
                }
                this.buffer.push(item);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return this.buffer;
            }
        }
    ]);
}();
var $741fb36946066f96$export$f7dc16cbd16f7bbe = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $4QlPs.PerformanceObserverEntryTypes).LongTask, new $741fb36946066f96$export$2c6e86519c9e8188()), (0, $4QlPs.PerformanceObserverEntryTypes).LayoutShift, new $741fb36946066f96$export$2c6e86519c9e8188());

});

parcelRegister("8lZnk", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $614fe4bd1116e2e6$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $614fe4bd1116e2e6$export$54fb8b6aaf70ec9c);

var $4QlPs = parcelRequire("4QlPs");

var $9Y7Ij = parcelRequire("9Y7Ij");
var $614fe4bd1116e2e6$var$pe = null;
var $614fe4bd1116e2e6$var$getObserver = function getObserver() {
    if (typeof PerformanceObserver !== "function") // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($614fe4bd1116e2e6$var$pe !== null) return $614fe4bd1116e2e6$var$pe;
    $614fe4bd1116e2e6$var$pe = new PerformanceObserver(function(list) {
        list.getEntries().forEach(function(entry) {
            if (entry.entryType === (0, $4QlPs.PerformanceObserverEntryTypes).LayoutShift) (0, $9Y7Ij.EntriesBuffer)[(0, $4QlPs.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $4QlPs.PerformanceObserverEntryTypes).LongTask) (0, $9Y7Ij.EntriesBuffer)[(0, $4QlPs.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $614fe4bd1116e2e6$var$pe;
};
var $614fe4bd1116e2e6$export$768ccc3ab7bac3ea = function startLSObserver() {
    var _getObserver;
    (_getObserver = $614fe4bd1116e2e6$var$getObserver()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $4QlPs.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
var $614fe4bd1116e2e6$export$54fb8b6aaf70ec9c = function startLTObserver() {
    var _getObserver2;
    (_getObserver2 = $614fe4bd1116e2e6$var$getObserver()) === null || _getObserver2 === void 0 || _getObserver2.observe({
        type: (0, $4QlPs.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("7qw2L", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9wu5l").then(()=>parcelRequire("bnSv7"));

});

parcelRegister("bmeQ7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7QZvr").then(()=>parcelRequire("4iPND"));

});

parcelRegister("6yIWp", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $7uWVM = parcelRequire("7uWVM");

var $dGCyA = parcelRequire("dGCyA");

var $ils74 = parcelRequire("ils74");

var $5wpCP = parcelRequire("5wpCP");

var $8CB0r = parcelRequire("8CB0r");

var $aq9ZM = parcelRequire("aq9ZM");

var $io2Di = parcelRequire("io2Di");

var $f8nQK = parcelRequire("f8nQK");

var $cuefK = parcelRequire("cuefK");

var $hIn3L = parcelRequire("hIn3L");

var $l6QXA = parcelRequire("l6QXA");

var $lmXME = parcelRequire("lmXME");

var $f0RKF = parcelRequire("f0RKF");

var $1PcQ6 = parcelRequire("1PcQ6");

var $aW0zg = parcelRequire("aW0zg");

var $gucor = parcelRequire("gucor");

var $i2E13 = parcelRequire("i2E13");
var $4c68c76f4451a21f$var$generateClientID = $i2E13.generateClientID, $4c68c76f4451a21f$var$generateUniqueClientID = $i2E13.generateUniqueClientID, $4c68c76f4451a21f$var$isClientID = $i2E13.isClientID;

var $lWuAe = parcelRequire("lWuAe");

var $ftuXr = parcelRequire("ftuXr");

var $i7dei = parcelRequire("i7dei");

var $2MLqe = parcelRequire("2MLqe");

var $fkd0X = parcelRequire("fkd0X");

var $7V8U5 = parcelRequire("7V8U5");

var $40tQb = parcelRequire("40tQb");

var $iEVza = parcelRequire("iEVza");

var $idJ2w = parcelRequire("idJ2w");

var $6rSHS = parcelRequire("6rSHS");

var $cGYI4 = parcelRequire("cGYI4");

var $L6WFS = parcelRequire("L6WFS");

var $5DrBw = parcelRequire("5DrBw");

var $5o6zS = parcelRequire("5o6zS");

var $2DcyS = parcelRequire("2DcyS");

var $c18RI = parcelRequire("c18RI");

var $9fUzq = parcelRequire("9fUzq");

var $7sl3K = parcelRequire("7sl3K");

var $k9Ckr = parcelRequire("k9Ckr");

var $leZHb = parcelRequire("leZHb");

var $5UXry = parcelRequire("5UXry");

var $k0hcd = parcelRequire("k0hcd");

var $7U4ur = parcelRequire("7U4ur");

var $2i5iW = parcelRequire("2i5iW");

var $8tEVh = parcelRequire("8tEVh");

var $402wI = parcelRequire("402wI");

var $47Vax = parcelRequire("47Vax");

var $1Q5mH = parcelRequire("1Q5mH");

var $iyRh8 = parcelRequire("iyRh8");

var $9DGaB = parcelRequire("9DGaB");

var $84X73 = parcelRequire("84X73");

var $7gvgi = parcelRequire("7gvgi");

var $ii2WU = parcelRequire("ii2WU");

var $dsOUI = parcelRequire("dsOUI");

var $9JzHH = parcelRequire("9JzHH");

var $aLywI = parcelRequire("aLywI");

var $8Q6tr = parcelRequire("8Q6tr");

var $hpvi1 = parcelRequire("hpvi1");
var $4c68c76f4451a21f$var$mapStr, $4c68c76f4451a21f$var$setStr, $4c68c76f4451a21f$var$promiseStr, $4c68c76f4451a21f$var$objStr;
/**
 * The public interface to Relay Runtime.
 */ module.exports = {
    // Core API
    Environment: $7V8U5,
    Network: $cuefK,
    Observable: $hIn3L,
    QueryResponseCache: $l6QXA,
    RecordSource: $L6WFS,
    Record: $iEVza,
    ReplaySubject: $aLywI,
    Store: $6rSHS,
    areEqualSelectors: $idJ2w.areEqualSelectors,
    createFragmentSpecResolver: $lWuAe,
    createNormalizationSelector: $idJ2w.createNormalizationSelector,
    createOperationDescriptor: $40tQb.createOperationDescriptor,
    createReaderSelector: $idJ2w.createReaderSelector,
    createRequestDescriptor: $40tQb.createRequestDescriptor,
    getArgumentValues: $5DrBw.getArgumentValues,
    getDataIDsFromFragment: $idJ2w.getDataIDsFromFragment,
    getDataIDsFromObject: $idJ2w.getDataIDsFromObject,
    getNode: $aW0zg.getNode,
    getFragment: $aW0zg.getFragment,
    getInlineDataFragment: $aW0zg.getInlineDataFragment,
    getModuleComponentKey: $5DrBw.getModuleComponentKey,
    getModuleOperationKey: $5DrBw.getModuleOperationKey,
    getPaginationFragment: $aW0zg.getPaginationFragment,
    getPluralSelector: $idJ2w.getPluralSelector,
    getRefetchableFragment: $aW0zg.getRefetchableFragment,
    getRequest: $aW0zg.getRequest,
    getRequestIdentifier: $8tEVh,
    getSelector: $idJ2w.getSelector,
    getSelectorsFromObject: $idJ2w.getSelectorsFromObject,
    getSingularSelector: $idJ2w.getSingularSelector,
    getStorageKey: $5DrBw.getStorageKey,
    getVariablesFromFragment: $idJ2w.getVariablesFromFragment,
    getVariablesFromObject: $idJ2w.getVariablesFromObject,
    getVariablesFromPluralFragment: $idJ2w.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $idJ2w.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $47Vax,
    graphql: $aW0zg.graphql,
    isFragment: $aW0zg.isFragment,
    isInlineDataFragment: $aW0zg.isInlineDataFragment,
    isRequest: $aW0zg.isRequest,
    readInlineData: $2MLqe,
    // Declarative mutation API
    MutationTypes: $f8nQK.MutationTypes,
    RangeOperations: $f8nQK.RangeOperations,
    // Extensions
    DefaultHandlerProvider: $5wpCP,
    ConnectionHandler: $7uWVM,
    MutationHandlers: $ils74,
    VIEWER_ID: $2DcyS.VIEWER_ID,
    VIEWER_TYPE: $2DcyS.VIEWER_TYPE,
    // Helpers (can be implemented via the above API)
    applyOptimisticMutation: $8CB0r,
    commitLocalUpdate: $aq9ZM,
    commitMutation: $io2Di,
    fetchQuery: $lmXME,
    fetchQuery_DEPRECATED: $f0RKF,
    isRelayModernEnvironment: $i7dei,
    requestSubscription: $c18RI,
    // Configuration interface for legacy or special uses
    ConnectionInterface: $dGCyA,
    // Utilities
    PreloadableQueryRegistry: $gucor,
    RelayProfiler: $9JzHH,
    createPayloadFor3DField: $9fUzq,
    // INTERNAL-ONLY: These exports might be removed at any point.
    RelayConcreteNode: $84X73,
    RelayError: $ii2WU,
    RelayFeatureFlags: $dsOUI,
    DEFAULT_HANDLE_KEY: $7gvgi.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $5DrBw.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $5DrBw.FRAGMENT_OWNER_KEY,
    ID_KEY: $5DrBw.ID_KEY,
    REF_KEY: $5DrBw.REF_KEY,
    REFS_KEY: $5DrBw.REFS_KEY,
    ROOT_ID: $5DrBw.ROOT_ID,
    ROOT_TYPE: $5DrBw.ROOT_TYPE,
    TYPENAME_KEY: $5DrBw.TYPENAME_KEY,
    deepFreeze: $7sl3K,
    generateClientID: $4c68c76f4451a21f$var$generateClientID,
    generateUniqueClientID: $4c68c76f4451a21f$var$generateUniqueClientID,
    getRelayHandleKey: $2i5iW,
    isClientID: $4c68c76f4451a21f$var$isClientID,
    isPromise: $1Q5mH,
    isScalarAndEqual: $iyRh8,
    recycleNodesInto: $9DGaB,
    stableCopy: $8Q6tr,
    getFragmentIdentifier: $k9Ckr,
    getRefetchMetadata: $7U4ur,
    getPaginationMetadata: $leZHb,
    getPaginationVariables: $5UXry,
    getPendingOperationsForFragment: $k0hcd,
    getValueAtPath: $402wI,
    __internal: {
        ResolverFragments: $5o6zS,
        OperationTracker: $cGYI4,
        createRelayContext: $ftuXr,
        getOperationVariables: $fkd0X.getOperationVariables,
        fetchQuery: $1PcQ6.fetchQuery,
        fetchQueryDeduped: $1PcQ6.fetchQueryDeduped,
        getPromiseForActiveRequest: $1PcQ6.getPromiseForActiveRequest,
        getObservableForActiveRequest: $1PcQ6.getObservableForActiveRequest,
        withProvidedVariables: $hpvi1
    }
};

});
parcelRegister("7uWVM", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $i2E13 = parcelRequire("i2E13");
var $57590c391e395ad0$var$generateClientID = $i2E13.generateClientID;

var $5DrBw = parcelRequire("5DrBw");
var $57590c391e395ad0$var$getStableStorageKey = $5DrBw.getStableStorageKey;

var $2i5iW = parcelRequire("2i5iW");

var $dGCyA = parcelRequire("dGCyA");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $57590c391e395ad0$var$CONNECTION = "connection";
// Per-instance incrementing index used to generate unique edge IDs
var $57590c391e395ad0$var$NEXT_EDGE_INDEX = "__connection_next_edge_index";
/**
 * @public
 *
 * A default runtime handler for connection fields that appends newly fetched
 * edges onto the end of a connection, regardless of the arguments used to fetch
 * those edges.
 */ function $57590c391e395ad0$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $dGCyA.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey);
        return;
    }
    // In rare cases the handleKey field may be unset even though the client
    // connection record exists, in this case new edges should still be merged
    // into the existing client connection record (and the field reset to point
    // to that record).
    var clientConnectionID = $57590c391e395ad0$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        // Initial fetch with data: copy fields from the server record
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $57590c391e395ad0$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $57590c391e395ad0$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($57590c391e395ad0$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) // If the handleKey field was unset but the client connection record
        // existed, update the field to point to the record
        record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        // Subsequent fetches:
        // - updated fields on the connection
        // - merge prev/next edges, de-duplicating by node id
        // - synthesize page info fields
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $57590c391e395ad0$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        // Reset EDGES and PAGE_INFO fields
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                // Forward pagination from the end of the connection: append edges
                if (clientPageInfo && args.after === clientPageInfo.getValue(END_CURSOR)) {
                    var nodeIDs = new Set();
                    $57590c391e395ad0$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $57590c391e395ad0$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                // Backward pagination from the start of the connection: prepend edges
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $57590c391e395ad0$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $57590c391e395ad0$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else // The connection was refetched from the beginning/end: replace edges
            nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else // $FlowFixMe[incompatible-type]
        nextEdges = prevEdges;
        // Update edges only if they were updated, the null check is
        // for Flow (prevEdges could be null).
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        // Page info should be updated even if no new edge were returned.
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) // The connection was refetched from the beginning/end: replace
            // page_info
            clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === "string") clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === "string") clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
/**
 * @public
 *
 * Given a record and the name of the schema field for which a connection was
 * fetched, returns the linked connection record.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *    edges {
 *      node {
 *        id
 *        }
 *      }
 *   }
 * }
 * ```
 *
 * The `friends` connection record can be accessed with:
 *
 * ```
 * store => {
 *   const user = store.get('<id>');
 *   const friends = ConnectionHandler.getConnection(user, 'FriendsFragment_friends');
 *   // Access fields on the connection:
 *   const edges = friends.getLinkedRecords('edges');
 * }
 * ```
 *
 * TODO: t15733312
 * Currently we haven't run into this case yet, but we need to add a `getConnections`
 * that returns an array of the connections under the same `key` regardless of the variables.
 */ function $57590c391e395ad0$var$getConnection(record, key, filters) {
    var handleKey = $2i5iW($57590c391e395ad0$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
/**
 * @public
 *
 * Given a record ID, the key of a connection field, and optional filters used
 * to identify the connection, returns the connection ID.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<user-id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *     edges {
 *       node {
 *         id
 *       }
 *     }
 *   }
 * }
 * ```
 *
 * The ID of the `friends` connection record can be accessed with:
 *
 * ```
 * store => {
 *   const connectionID = ConnectionHandler.getConnectionID('<user-id>', 'FriendsFragment_friends');
 * }
 * ```
 */ function $57590c391e395ad0$var$getConnectionID(recordID, key, filters) {
    var handleKey = $2i5iW($57590c391e395ad0$var$CONNECTION, key, null);
    var storageKey = $57590c391e395ad0$var$getStableStorageKey(handleKey, filters);
    return $57590c391e395ad0$var$generateClientID(recordID, storageKey);
}
/**
 * @public
 *
 * Inserts an edge after the given cursor, or at the end of the list if no
 * cursor is provided.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *    edges {
 *      node {
 *        id
 *        }
 *      }
 *   }
 * }
 * ```
 *
 * An edge can be appended with:
 *
 * ```
 * store => {
 *   const user = store.get('<id>');
 *   const friends = ConnectionHandler.getConnection(user, 'FriendsFragment_friends');
 *   const edge = store.create('<edge-id>', 'FriendsEdge');
 *   ConnectionHandler.insertEdgeAfter(friends, edge);
 * }
 * ```
 */ function $57590c391e395ad0$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $dGCyA.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
/**
 * @public
 *
 * Creates an edge for a connection record, given a node and edge type.
 */ function $57590c391e395ad0$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $dGCyA.get(), NODE = _ConnectionInterface$3.NODE;
    // An index-based client ID could easily conflict (unless it was
    // auto-incrementing, but there is nowhere to the store the id)
    // Instead, construct a client ID based on the connection ID and node ID,
    // which will only conflict if the same node is added to the same connection
    // twice. This is acceptable since the `insertEdge*` functions ignore
    // duplicates.
    var edgeID = $57590c391e395ad0$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue("cursor") == null) // Always use null instead of undefined value for cursor
    // to avoid considering it as missing data
    edge.setValue(null, "cursor");
    return edge;
}
/**
 * @public
 *
 * Inserts an edge before the given cursor, or at the beginning of the list if
 * no cursor is provided.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *    edges {
 *      node {
 *        id
 *        }
 *      }
 *   }
 * }
 * ```
 *
 * An edge can be prepended with:
 *
 * ```
 * store => {
 *   const user = store.get('<id>');
 *   const friends = ConnectionHandler.getConnection(user, 'FriendsFragment_friends');
 *   const edge = store.create('<edge-id>', 'FriendsEdge');
 *   ConnectionHandler.insertEdgeBefore(friends, edge);
 * }
 * ```
 */ function $57590c391e395ad0$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $dGCyA.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
/**
 * @public
 *
 * Remove any edges whose `node.id` matches the given id.
 */ function $57590c391e395ad0$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $dGCyA.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
/**
 * @internal
 *
 * Creates a copy of an edge with a unique ID based on per-connection-instance
 * incrementing edge index. This is necessary to avoid collisions between edges,
 * which can occur because (edge) client IDs are assigned deterministically
 * based on the path from the nearest node with an id.
 *
 * Example: if the first N edges of the same connection are refetched, the edges
 * from the second fetch will be assigned the same IDs as the first fetch, even
 * though the nodes they point to may be different (or the same and in different
 * order).
 */ function $57590c391e395ad0$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $dGCyA.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($57590c391e395ad0$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === "number") && $aaXwj(false);
    var edgeID = $57590c391e395ad0$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue("cursor") == null) // Always use null instead of undefined value for cursor
    // to avoid considering it as missing data
    connectionEdge.setValue(null, "cursor");
    connection.setValue(edgeIndex + 1, $57590c391e395ad0$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
/**
 * @internal
 *
 * Adds the source edges to the target edges, skipping edges with
 * duplicate node ids.
 */ function $57590c391e395ad0$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $dGCyA.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $57590c391e395ad0$var$buildConnectionEdge,
    createEdge: $57590c391e395ad0$var$createEdge,
    deleteNode: $57590c391e395ad0$var$deleteNode,
    getConnection: $57590c391e395ad0$var$getConnection,
    getConnectionID: $57590c391e395ad0$var$getConnectionID,
    insertEdgeAfter: $57590c391e395ad0$var$insertEdgeAfter,
    insertEdgeBefore: $57590c391e395ad0$var$insertEdgeBefore,
    update: $57590c391e395ad0$var$update
};

});
parcelRegister("i2E13", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $dsOUI = parcelRequire("dsOUI");

var $1pW7i = parcelRequire("1pW7i");
var $d227743bd67f9787$var$intern = $1pW7i.intern;
var $d227743bd67f9787$var$PREFIX = "client:";
function $d227743bd67f9787$var$generateClientID(id, storageKey, index) {
    var internedId = $dsOUI.STRING_INTERN_LEVEL <= 0 ? id : $d227743bd67f9787$var$intern(id, $dsOUI.MAX_DATA_ID_LENGTH);
    var key = internedId + ":" + storageKey;
    if (index != null) key += ":" + index;
    if (key.indexOf($d227743bd67f9787$var$PREFIX) !== 0) key = $d227743bd67f9787$var$PREFIX + key;
    return key;
}
function $d227743bd67f9787$var$isClientID(id) {
    return id.indexOf($d227743bd67f9787$var$PREFIX) === 0;
}
var $d227743bd67f9787$var$localID = 0;
function $d227743bd67f9787$var$generateUniqueClientID() {
    return "".concat($d227743bd67f9787$var$PREFIX, "local:").concat($d227743bd67f9787$var$localID++);
}
// Client objects backed by Relay Resolvers may not be able to provide a
// globally unique ID, so we provide a namespace.
function $d227743bd67f9787$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($d227743bd67f9787$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ":" + index;
    return key;
}
module.exports = {
    generateClientID: $d227743bd67f9787$var$generateClientID,
    generateClientObjectClientID: $d227743bd67f9787$var$generateClientObjectClientID,
    generateUniqueClientID: $d227743bd67f9787$var$generateUniqueClientID,
    isClientID: $d227743bd67f9787$var$isClientID
};

});
parcelRegister("dsOUI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $9cd562468f31220f$var$RelayFeatureFlags = {
    ENABLE_CLIENT_EDGES: false,
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_PARTIAL_RENDERING_DEFAULT: true,
    ENABLE_REACT_FLIGHT_COMPONENT_FIELD: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_LOAD_QUERY_REQUEST_DEDUPING: true,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    USE_REACT_CACHE: false,
    USE_REACT_CACHE_LEGACY_TIMEOUTS: true,
    ENABLE_QUERY_RENDERER_SET_STATE_PREVENTION: false
};
module.exports = $9cd562468f31220f$var$RelayFeatureFlags;

});

parcelRegister("1pW7i", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $108534fc88e2163a$var$internTable = new Map();
var $108534fc88e2163a$var$nextIndex = 1;
var $108534fc88e2163a$var$digits = $108534fc88e2163a$var$initDigitTable();
// Character used as the prefix for interned strings. The specific character is
// chosen to reduce the likelihood that non-interned input strings need to be
// escaped (choosing eg a-Z would increase the likelihood we need to escape)
var $108534fc88e2163a$var$INTERN_PREFIX = "	";
// Character used as the prefix of escaped strings. As above, this is also
// chosen to be unlikely in normal input strings.
var $108534fc88e2163a$var$ESCAPE_PREFIX = "\v";
function $108534fc88e2163a$var$initDigitTable() {
    // disable lint because digits isn't defined when this function is called
    // eslint-disable-next-line no-shadow
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
// Escape a string so that it cannot conflict with an interned string
function $108534fc88e2163a$var$escape(str) {
    if (// "\t<digit>..." -> "\v\t<digit>..."
    str[0] === $108534fc88e2163a$var$INTERN_PREFIX && $108534fc88e2163a$var$digits.has(str[1]) || // "\v..." -> "\v\v..."
    str[0] === $108534fc88e2163a$var$ESCAPE_PREFIX) return $108534fc88e2163a$var$ESCAPE_PREFIX + str;
    return str;
}
// Interns the input string if its length equals or exceeds the given `limit`,
// returning a shorter replacement string that is uniquely associated with the
// input: multiple calls to intern() for the equivalent input strings (and limit)
// will always return the exact same string.
// Strings shorter than the limit are not interned but are escaped if they
// could conflict with interned strings.
function $108534fc88e2163a$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $108534fc88e2163a$var$escape(str);
    var internedString = $108534fc88e2163a$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $108534fc88e2163a$var$INTERN_PREFIX + $108534fc88e2163a$var$nextIndex++;
    $108534fc88e2163a$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $108534fc88e2163a$var$intern
};

});


parcelRegister("5DrBw", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $41a601e2d7f3969a$var$_interopRequireDefault = $1jnue.default;

var $41a601e2d7f3969a$var$_toConsumableArray2 = $41a601e2d7f3969a$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $2i5iW = parcelRequire("2i5iW");

var $84X73 = parcelRequire("84X73");

var $8Q6tr = parcelRequire("8Q6tr");

var $aaXwj = parcelRequire("aaXwj");
var $41a601e2d7f3969a$var$VARIABLE = $84X73.VARIABLE, $41a601e2d7f3969a$var$LITERAL = $84X73.LITERAL, $41a601e2d7f3969a$var$OBJECT_VALUE = $84X73.OBJECT_VALUE, $41a601e2d7f3969a$var$LIST_VALUE = $84X73.LIST_VALUE;
var $41a601e2d7f3969a$var$MODULE_COMPONENT_KEY_PREFIX = "__module_component_";
var $41a601e2d7f3969a$var$MODULE_OPERATION_KEY_PREFIX = "__module_operation_";
function $41a601e2d7f3969a$var$getArgumentValue(arg, variables) {
    if (arg.kind === $41a601e2d7f3969a$var$VARIABLE) // Variables are provided at runtime and are not guaranteed to be stable.
    return $41a601e2d7f3969a$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $41a601e2d7f3969a$var$LITERAL) // The Relay compiler generates stable ConcreteArgument values.
    return arg.value;
    else if (arg.kind === $41a601e2d7f3969a$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $41a601e2d7f3969a$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $41a601e2d7f3969a$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($41a601e2d7f3969a$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
/**
 * Returns the values of field/fragment arguments as an object keyed by argument
 * names. Guaranteed to return a result with stable ordered nested values.
 */ function $41a601e2d7f3969a$var$getArgumentValues(args, variables) {
    var values = {};
    args.forEach(function(arg) {
        values[arg.name] = $41a601e2d7f3969a$var$getArgumentValue(arg, variables);
    });
    return values;
}
/**
 * Given a handle field and variable values, returns a key that can be used to
 * uniquely identify the combination of the handle name and argument values.
 *
 * Note: the word "storage" here refers to the fact this key is primarily used
 * when writing the results of a key in a normalized graph or "store". This
 * name was used in previous implementations of Relay internals and is also
 * used here for consistency.
 */ function $41a601e2d7f3969a$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $2i5iW(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) // "Sort" the arguments by argument name: this is done by the compiler for
    // user-supplied arguments but the dynamic argument must also be in sorted
    // order.  Note that dynamic key argument name is double-underscore-
    // -prefixed, and a double-underscore prefix is disallowed for user-supplied
    // argument names, so there's no need to actually sort.
    filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $41a601e2d7f3969a$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $41a601e2d7f3969a$var$formatStorageKey(handleName, $41a601e2d7f3969a$var$getArgumentValues(filterArgs, variables));
}
/**
 * Given a field and variable values, returns a key that can be used to
 * uniquely identify the combination of the field name and argument values.
 *
 * Note: the word "storage" here refers to the fact this key is primarily used
 * when writing the results of a key in a normalized graph or "store". This
 * name was used in previous implementations of Relay internals and is also
 * used here for consistency.
 */ function $41a601e2d7f3969a$var$getStorageKey(field, variables) {
    if (field.storageKey) // TODO T23663664: Handle nodes do not yet define a static storageKey.
    return field.storageKey;
    var args = $41a601e2d7f3969a$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $41a601e2d7f3969a$var$formatStorageKey(name, $41a601e2d7f3969a$var$getArgumentValues(args, variables)) : name;
}
/**
 * Given a field the method returns an array of arguments.
 * For Relay resolver fields, we store arguments on the field and fragment
 * and this method return combined list of arguments.
 */ function $41a601e2d7f3969a$var$getArguments(field) {
    if (field.kind === "RelayResolver" || field.kind === "RelayLiveResolver") {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === "undefined" ? undefined : field.args;
    return args;
}
/**
 * Given a `name` (eg. "foo") and an object representing argument values
 * (eg. `{orberBy: "name", first: 10}`) returns a unique storage key
 * (ie. `foo{"first":10,"orderBy":"name"}`).
 *
 * This differs from getStorageKey which requires a ConcreteNode where arguments
 * are assumed to already be sorted into a stable order.
 */ function $41a601e2d7f3969a$var$getStableStorageKey(name, args) {
    return $41a601e2d7f3969a$var$formatStorageKey(name, $8Q6tr(args));
}
/**
 * Given a name and argument values, format a storage key.
 *
 * Arguments and the values within them are expected to be ordered in a stable
 * alphabetical ordering.
 */ function $41a601e2d7f3969a$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ":" + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "undefined"));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(","), ")");
}
/**
 * Given Variables and a variable name, return a variable value with
 * all values in a stable order.
 */ function $41a601e2d7f3969a$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $aaXwj(false);
    return $8Q6tr(variables[name]);
}
function $41a601e2d7f3969a$var$getModuleComponentKey(documentName) {
    return "".concat($41a601e2d7f3969a$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $41a601e2d7f3969a$var$getModuleOperationKey(documentName) {
    return "".concat($41a601e2d7f3969a$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
/**
 * Constants shared by all implementations of RecordSource/MutableRecordSource/etc.
 */ var $41a601e2d7f3969a$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: "__actorIdentifier",
    CLIENT_EDGE_TRAVERSAL_PATH: "__clientEdgeTraversalPath",
    FRAGMENTS_KEY: "__fragments",
    FRAGMENT_OWNER_KEY: "__fragmentOwner",
    FRAGMENT_PROP_NAME_KEY: "__fragmentPropName",
    MODULE_COMPONENT_KEY: "__module_component",
    // alias returned by Reader
    ID_KEY: "__id",
    REF_KEY: "__ref",
    REFS_KEY: "__refs",
    ROOT_ID: "client:root",
    ROOT_TYPE: "__Root",
    TYPENAME_KEY: "__typename",
    INVALIDATED_AT_KEY: "__invalidated_at",
    IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: "__isWithinUnmatchedTypeRefinement",
    RELAY_RESOLVER_VALUE_KEY: "__resolverValue",
    RELAY_RESOLVER_INVALIDATION_KEY: "__resolverValueMayBeInvalid",
    RELAY_RESOLVER_SNAPSHOT_KEY: "__resolverSnapshot",
    RELAY_RESOLVER_ERROR_KEY: "__resolverError",
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: "__resolverOutputTypeRecordIDs",
    formatStorageKey: $41a601e2d7f3969a$var$formatStorageKey,
    getArgumentValue: $41a601e2d7f3969a$var$getArgumentValue,
    getArgumentValues: $41a601e2d7f3969a$var$getArgumentValues,
    getHandleStorageKey: $41a601e2d7f3969a$var$getHandleStorageKey,
    getStorageKey: $41a601e2d7f3969a$var$getStorageKey,
    getStableStorageKey: $41a601e2d7f3969a$var$getStableStorageKey,
    getModuleComponentKey: $41a601e2d7f3969a$var$getModuleComponentKey,
    getModuleOperationKey: $41a601e2d7f3969a$var$getModuleOperationKey
};
module.exports = $41a601e2d7f3969a$var$RelayStoreUtils;

});
parcelRegister("2i5iW", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $7gvgi = parcelRequire("7gvgi");
var $1ab160947d145632$var$DEFAULT_HANDLE_KEY = $7gvgi.DEFAULT_HANDLE_KEY;

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * Helper to create a unique name for a handle field based on the handle name, handle key and
 * source field.
 */ function $1ab160947d145632$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $1ab160947d145632$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $aaXwj(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $1ab160947d145632$var$getRelayHandleKey;

});
parcelRegister("7gvgi", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
module.exports = {
    DEFAULT_HANDLE_KEY: ""
};

});


parcelRegister("84X73", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * Represents a common GraphQL request that can be executed, an `operation`
 * containing information to normalize the results, and a `fragment` derived
 * from that operation to read the response data (masking data from child
 * fragments).
 */ /**
 * Contains the parameters required for executing a GraphQL request.
 * The operation can either be provided as a persisted `id` or `text`. If given
 * in `text` format, a `cacheID` as a hash of the text should be set to be used
 * for local caching.
 */ var $5e1c8d0443ff7a9c$var$RelayConcreteNode = {
    ACTOR_CHANGE: "ActorChange",
    CONDITION: "Condition",
    CLIENT_COMPONENT: "ClientComponent",
    CLIENT_EDGE_TO_SERVER_OBJECT: "ClientEdgeToServerObject",
    CLIENT_EDGE_TO_CLIENT_OBJECT: "ClientEdgeToClientObject",
    CLIENT_EXTENSION: "ClientExtension",
    DEFER: "Defer",
    CONNECTION: "Connection",
    FLIGHT_FIELD: "FlightField",
    FRAGMENT: "Fragment",
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_DATA_FRAGMENT_SPREAD: "InlineDataFragmentSpread",
    INLINE_DATA_FRAGMENT: "InlineDataFragment",
    INLINE_FRAGMENT: "InlineFragment",
    LINKED_FIELD: "LinkedField",
    LINKED_HANDLE: "LinkedHandle",
    LITERAL: "Literal",
    LIST_VALUE: "ListValue",
    LOCAL_ARGUMENT: "LocalArgument",
    MODULE_IMPORT: "ModuleImport",
    ALIASED_FRAGMENT_SPREAD: "AliasedFragmentSpread",
    ALIASED_INLINE_FRAGMENT_SPREAD: "AliasedInlineFragmentSpread",
    RELAY_RESOLVER: "RelayResolver",
    RELAY_LIVE_RESOLVER: "RelayLiveResolver",
    REQUIRED_FIELD: "RequiredField",
    OBJECT_VALUE: "ObjectValue",
    OPERATION: "Operation",
    REQUEST: "Request",
    ROOT_ARGUMENT: "RootArgument",
    SCALAR_FIELD: "ScalarField",
    SCALAR_HANDLE: "ScalarHandle",
    SPLIT_OPERATION: "SplitOperation",
    STREAM: "Stream",
    TYPE_DISCRIMINATOR: "TypeDiscriminator",
    UPDATABLE_QUERY: "UpdatableQuery",
    VARIABLE: "Variable"
};
module.exports = $5e1c8d0443ff7a9c$var$RelayConcreteNode;

});

parcelRegister("8Q6tr", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * Creates a copy of the provided value, ensuring any nested objects have their
 * keys sorted such that equivalent values would have identical JSON.stringify
 * results.
 */ function $66f833a5f98ccb7b$var$stableCopy(value) {
    if (!value || typeof value !== "object") return value;
    if (Array.isArray(value)) return value.map($66f833a5f98ccb7b$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $66f833a5f98ccb7b$var$stableCopy(value[keys[i]]);
    return stable;
}
module.exports = $66f833a5f98ccb7b$var$stableCopy;

});


parcelRegister("dGCyA", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $9f6d1b37ea106d00$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $9f6d1b37ea106d00$var$config = {
    CURSOR: "cursor",
    EDGES: "edges",
    END_CURSOR: "endCursor",
    HAS_NEXT_PAGE: "hasNextPage",
    HAS_PREV_PAGE: "hasPreviousPage",
    NODE: "node",
    PAGE_INFO_TYPE: "PageInfo",
    PAGE_INFO: "pageInfo",
    START_CURSOR: "startCursor"
};
/**
 * @internal
 *
 * Defines logic relevant to the informal "Connection" GraphQL interface.
 */ var $9f6d1b37ea106d00$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $9f6d1b37ea106d00$var$config = newConfig;
    },
    get: function get() {
        return $9f6d1b37ea106d00$var$config;
    },
    /**
   * Checks whether a call exists strictly to encode which parts of a connection
   * to fetch. Fields that only differ by connection call values should have the
   * same identity.
   */ isConnectionCall: function isConnectionCall(call) {
        return $9f6d1b37ea106d00$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $9f6d1b37ea106d00$var$ConnectionInterface;

});


parcelRegister("ils74", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $d5affed47439a513$var$_interopRequireDefault = $1jnue.default;

var $d5affed47439a513$var$_createForOfIteratorHelper2 = $d5affed47439a513$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $7uWVM = parcelRequire("7uWVM");

var $dGCyA = parcelRequire("dGCyA");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $d5affed47439a513$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === "string") store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === "string") store["delete"](id);
            });
        }
    }
};
var $d5affed47439a513$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $aaXwj(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === "string") {
                var _iterator = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $7uWVM.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $d5affed47439a513$var$AppendEdgeHandler = {
    update: $d5affed47439a513$var$edgeUpdater($7uWVM.insertEdgeAfter)
};
var $d5affed47439a513$var$PrependEdgeHandler = {
    update: $d5affed47439a513$var$edgeUpdater($7uWVM.insertEdgeBefore)
};
var $d5affed47439a513$var$AppendNodeHandler = {
    update: $d5affed47439a513$var$nodeUpdater($7uWVM.insertEdgeAfter)
};
var $d5affed47439a513$var$PrependNodeHandler = {
    update: $d5affed47439a513$var$nodeUpdater($7uWVM.insertEdgeBefore)
};
function $d5affed47439a513$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $aaXwj(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $dGCyA.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord("node");
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $7uWVM.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $aaXwj(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $d5affed47439a513$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $aaXwj(false);
        !(edgeTypeName != null) && $aaXwj(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $dGCyA.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $d5affed47439a513$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $7uWVM.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $aaXwj(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $d5affed47439a513$var$AppendEdgeHandler,
    DeleteRecordHandler: $d5affed47439a513$var$DeleteRecordHandler,
    PrependEdgeHandler: $d5affed47439a513$var$PrependEdgeHandler,
    AppendNodeHandler: $d5affed47439a513$var$AppendNodeHandler,
    PrependNodeHandler: $d5affed47439a513$var$PrependNodeHandler,
    DeleteEdgeHandler: $d5affed47439a513$var$DeleteEdgeHandler
};

});

parcelRegister("5wpCP", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $7uWVM = parcelRequire("7uWVM");

var $ils74 = parcelRequire("ils74");

var $aaXwj = parcelRequire("aaXwj");
function $4053d1890bfd378c$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case "connection":
            return $7uWVM;
        case "deleteRecord":
            return $ils74.DeleteRecordHandler;
        case "deleteEdge":
            return $ils74.DeleteEdgeHandler;
        case "appendEdge":
            return $ils74.AppendEdgeHandler;
        case "prependEdge":
            return $ils74.PrependEdgeHandler;
        case "appendNode":
            return $ils74.AppendNodeHandler;
        case "prependNode":
            return $ils74.PrependNodeHandler;
    }
    $aaXwj(false);
}
module.exports = $4053d1890bfd378c$var$RelayDefaultHandlerProvider;

});

parcelRegister("8CB0r", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $646e93f9dde74190$var$getRequest = $aW0zg.getRequest;

var $i7dei = parcelRequire("i7dei");

var $40tQb = parcelRequire("40tQb");
var $646e93f9dde74190$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $f8nQK = parcelRequire("f8nQK");

var $aaXwj = parcelRequire("aaXwj");
/**
 * Higher-level helper function to execute a mutation against a specific
 * environment.
 */ function $646e93f9dde74190$var$applyOptimisticMutation(environment, config) {
    !$i7dei(environment) && $aaXwj(false);
    var mutation = $646e93f9dde74190$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== "mutation") throw new Error("commitMutation: Expected mutation operation");
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $646e93f9dde74190$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $f8nQK.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $646e93f9dde74190$var$applyOptimisticMutation;

});
parcelRegister("aW0zg", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $84X73 = parcelRequire("84X73");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
// The type of a graphql`...` tagged template expression.
/**
 * Runtime function to correspond to the `graphql` tagged template function.
 * All calls to this function should be transformed by the plugin.
 */ function $7f5fc2e5a5fd33cd$var$graphql(strings) {
    $aaXwj(false);
}
function $7f5fc2e5a5fd33cd$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === "function") node = node();
    else if (node["default"]) // Support for languages that work (best) with ES6 modules, such as TypeScript.
    node = node["default"];
    return node;
}
function $7f5fc2e5a5fd33cd$var$isFragment(node) {
    var fragment = $7f5fc2e5a5fd33cd$var$getNode(node);
    return typeof fragment === "object" && fragment !== null && fragment.kind === $84X73.FRAGMENT;
}
function $7f5fc2e5a5fd33cd$var$isRequest(node) {
    var request = $7f5fc2e5a5fd33cd$var$getNode(node);
    return typeof request === "object" && request !== null && request.kind === $84X73.REQUEST;
}
function $7f5fc2e5a5fd33cd$var$isUpdatableQuery(node) {
    var updatableQuery = $7f5fc2e5a5fd33cd$var$getNode(node);
    return typeof updatableQuery === "object" && updatableQuery !== null && updatableQuery.kind === $84X73.UPDATABLE_QUERY;
}
function $7f5fc2e5a5fd33cd$var$isInlineDataFragment(node) {
    var fragment = $7f5fc2e5a5fd33cd$var$getNode(node);
    return typeof fragment === "object" && fragment !== null && fragment.kind === $84X73.INLINE_DATA_FRAGMENT;
}
function $7f5fc2e5a5fd33cd$var$getFragment(taggedNode) {
    var fragment = $7f5fc2e5a5fd33cd$var$getNode(taggedNode);
    !$7f5fc2e5a5fd33cd$var$isFragment(fragment) && $aaXwj(false);
    return fragment;
}
function $7f5fc2e5a5fd33cd$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $7f5fc2e5a5fd33cd$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== "object" || connection === null || typeof connection !== "object") return null;
    return fragment;
}
function $7f5fc2e5a5fd33cd$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $7f5fc2e5a5fd33cd$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== "object") return null;
    return fragment;
}
function $7f5fc2e5a5fd33cd$var$getRequest(taggedNode) {
    var request = $7f5fc2e5a5fd33cd$var$getNode(taggedNode);
    !$7f5fc2e5a5fd33cd$var$isRequest(request) && $aaXwj(false);
    return request;
}
function $7f5fc2e5a5fd33cd$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $7f5fc2e5a5fd33cd$var$getNode(taggedNode);
    !$7f5fc2e5a5fd33cd$var$isUpdatableQuery(updatableQuery) && $aaXwj(false);
    return updatableQuery;
}
function $7f5fc2e5a5fd33cd$var$getInlineDataFragment(taggedNode) {
    var fragment = $7f5fc2e5a5fd33cd$var$getNode(taggedNode);
    !$7f5fc2e5a5fd33cd$var$isInlineDataFragment(fragment) && $aaXwj(false);
    return fragment;
}
module.exports = {
    getFragment: $7f5fc2e5a5fd33cd$var$getFragment,
    getNode: $7f5fc2e5a5fd33cd$var$getNode,
    getPaginationFragment: $7f5fc2e5a5fd33cd$var$getPaginationFragment,
    getRefetchableFragment: $7f5fc2e5a5fd33cd$var$getRefetchableFragment,
    getRequest: $7f5fc2e5a5fd33cd$var$getRequest,
    getUpdatableQuery: $7f5fc2e5a5fd33cd$var$getUpdatableQuery,
    getInlineDataFragment: $7f5fc2e5a5fd33cd$var$getInlineDataFragment,
    graphql: $7f5fc2e5a5fd33cd$var$graphql,
    isFragment: $7f5fc2e5a5fd33cd$var$isFragment,
    isRequest: $7f5fc2e5a5fd33cd$var$isRequest,
    isUpdatableQuery: $7f5fc2e5a5fd33cd$var$isUpdatableQuery,
    isInlineDataFragment: $7f5fc2e5a5fd33cd$var$isInlineDataFragment
};

});

parcelRegister("i7dei", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * Determine if a given value is an object that implements the `Environment`
 * interface defined in `RelayStoreTypes`.
 *
 * Use a sigil for detection to avoid a realm-specific instanceof check, and to
 * aid in module tree-shaking to avoid requiring all of RelayRuntime just to
 * detect its environment.
 */ function $d3032490695fa8db$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment["@@RelayModernEnvironment"]);
}
module.exports = $d3032490695fa8db$var$isRelayModernEnvironment;

});

parcelRegister("40tQb", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
parcelRequire("7sl3K");

var $8tEVh = parcelRequire("8tEVh");

var $fkd0X = parcelRequire("fkd0X");
var $2eae4f3dd2b213dd$var$getOperationVariables = $fkd0X.getOperationVariables;

var $idJ2w = parcelRequire("idJ2w");
var $2eae4f3dd2b213dd$var$createNormalizationSelector = $idJ2w.createNormalizationSelector, $2eae4f3dd2b213dd$var$createReaderSelector = $idJ2w.createReaderSelector;

var $5DrBw = parcelRequire("5DrBw");
var $2eae4f3dd2b213dd$var$ROOT_ID = $5DrBw.ROOT_ID;
/**
 * Creates an instance of the `OperationDescriptor` type defined in
 * `RelayStoreTypes` given an operation and some variables. The input variables
 * are filtered to exclude variables that do not match defined arguments on the
 * operation, and default values are populated for null values.
 */ function $2eae4f3dd2b213dd$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $2eae4f3dd2b213dd$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $2eae4f3dd2b213dd$var$getOperationVariables(operation, request.params.providedVariables, variables);
    var requestDescriptor = $2eae4f3dd2b213dd$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $2eae4f3dd2b213dd$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $2eae4f3dd2b213dd$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $2eae4f3dd2b213dd$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $8tEVh(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $2eae4f3dd2b213dd$var$createOperationDescriptor,
    createRequestDescriptor: $2eae4f3dd2b213dd$var$createRequestDescriptor
};

});
parcelRegister("7sl3K", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * Recursively "deep" freezes the supplied object.
 *
 * For convenience, and for consistency with the behavior of `Object.freeze`,
 * returns the now-frozen original object.
 */ function $56db7beab1ad986a$var$deepFreeze(object) {
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === "object" && !Object.isFrozen(property)) $56db7beab1ad986a$var$deepFreeze(property);
    });
    return object;
}
module.exports = $56db7beab1ad986a$var$deepFreeze;

});

parcelRegister("8tEVh", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $8Q6tr = parcelRequire("8Q6tr");

var $aaXwj = parcelRequire("aaXwj");
/**
 * Returns a stable identifier for the given pair of `RequestParameters` +
 * variables.
 */ function $62c0c69921390dde$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $aaXwj(false);
    return requestID + JSON.stringify($8Q6tr(variables));
}
module.exports = $62c0c69921390dde$var$getRequestIdentifier;

});

parcelRegister("fkd0X", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $b282d1b1083e0ac3$var$_interopRequireDefault = $1jnue.default;

var $b282d1b1083e0ac3$var$_objectSpread2 = $b282d1b1083e0ac3$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $5DrBw = parcelRequire("5DrBw");
var $b282d1b1083e0ac3$var$getArgumentValues = $5DrBw.getArgumentValues;

var $aaXwj = parcelRequire("aaXwj");
/**
 * Determines the variables that are in scope for a fragment given the variables
 * in scope at the root query as well as any arguments applied at the fragment
 * spread via `@arguments`.
 *
 * Note that this is analagous to determining function arguments given a function call.
 */ function $b282d1b1083e0ac3$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    // TODO: Support for legacy ReaderInlineDataFragmentSpread nodes.
    // Remove this once all we've updated the ReaderInlineDataFragmentSpread
    // type to indicate that all compiled artifacts have been updated.
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $b282d1b1083e0ac3$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case "LocalArgument":
                variables[definition.name] = definition.defaultValue;
                break;
            case "RootArgument":
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    /*
           * Global variables passed as values of @arguments are not required to
           * be declared unless they are used by the callee fragment or a
           * descendant. In this case, the root variable may not be defined when
           * resolving the callee's variables. The value is explicitly set to
           * undefined to conform to the check in
           * RelayStoreUtils.getStableVariableValue() that variable keys are all
           * present.
           */ variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $aaXwj(false);
        }
    });
    return variables || argumentVariables;
}
/**
 * Determines the variables that are in scope for a given operation given values
 * for some/all of its arguments.
 * - extraneous input variables are filtered from the output
 * - missing variables are set to default values (if given in the
 * operation's definition).
 * - variables with provider modules are added
 */ function $b282d1b1083e0ac3$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $b282d1b1083e0ac3$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $b282d1b1083e0ac3$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $b282d1b1083e0ac3$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $b282d1b1083e0ac3$var$getLocalVariables,
    getFragmentVariables: $b282d1b1083e0ac3$var$getFragmentVariables,
    getOperationVariables: $b282d1b1083e0ac3$var$getOperationVariables
};

});

parcelRegister("idJ2w", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $fkd0X = parcelRequire("fkd0X");
var $d43c60d633c5fc6f$var$getFragmentVariables = $fkd0X.getFragmentVariables;

var $5DrBw = parcelRequire("5DrBw");
var $d43c60d633c5fc6f$var$CLIENT_EDGE_TRAVERSAL_PATH = $5DrBw.CLIENT_EDGE_TRAVERSAL_PATH, $d43c60d633c5fc6f$var$FRAGMENT_OWNER_KEY = $5DrBw.FRAGMENT_OWNER_KEY, $d43c60d633c5fc6f$var$FRAGMENTS_KEY = $5DrBw.FRAGMENTS_KEY, $d43c60d633c5fc6f$var$ID_KEY = $5DrBw.ID_KEY, $d43c60d633c5fc6f$var$IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $5DrBw.IS_WITHIN_UNMATCHED_TYPE_REFINEMENT;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * @public
 *
 * Given the result `item` from a parent that fetched `fragment`, creates a
 * selector that can be used to read the results of that fragment for that item.
 *
 * Example:
 *
 * Given two fragments as follows:
 *
 * ```
 * fragment Parent on User {
 *   id
 *   ...Child
 * }
 * fragment Child on User {
 *   name
 * }
 * ```
 *
 * And given some object `parent` that is the results of `Parent` for id "4",
 * the results of `Child` can be accessed by first getting a selector and then
 * using that selector to `lookup()` the results against the environment:
 *
 * ```
 * const childSelector = getSingularSelector(queryVariables, Child, parent);
 * const childData = environment.lookup(childSelector).data;
 * ```
 */ function $d43c60d633c5fc6f$var$getSingularSelector(fragment, item) {
    !(typeof item === "object" && item !== null && !Array.isArray(item)) && $aaXwj(false);
    var dataID = item[$d43c60d633c5fc6f$var$ID_KEY];
    var fragments = item[$d43c60d633c5fc6f$var$FRAGMENTS_KEY];
    var mixedOwner = item[$d43c60d633c5fc6f$var$FRAGMENT_OWNER_KEY];
    var isWithinUnmatchedTypeRefinement = item[$d43c60d633c5fc6f$var$IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
    var mixedClientEdgeTraversalPath = item[$d43c60d633c5fc6f$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === "string" && typeof fragments === "object" && fragments !== null && typeof fragments[fragment.name] === "object" && fragments[fragment.name] !== null && typeof mixedOwner === "object" && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $d43c60d633c5fc6f$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        return $d43c60d633c5fc6f$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
/**
 * @public
 *
 * Given the result `items` from a parent that fetched `fragment`, creates a
 * selector that can be used to read the results of that fragment on those
 * items. This is similar to `getSingularSelector` but for "plural" fragments that
 * expect an array of results and therefore return an array of selectors.
 */ function $d43c60d633c5fc6f$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $d43c60d633c5fc6f$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: "PluralReaderSelector",
        selectors: selectors
    };
}
function $d43c60d633c5fc6f$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getSingularSelector(fragment, item);
    }
}
/**
 * @public
 *
 * Given a mapping of keys -> results and a mapping of keys -> fragments,
 * extracts the selectors for those fragments from the results.
 *
 * The canonical use-case for this function is ReactRelayFragmentContainer, which
 * uses this function to convert (props, fragments) into selectors so that it
 * can read the results to pass to the inner component.
 */ function $d43c60d633c5fc6f$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $d43c60d633c5fc6f$var$getSelector(fragment, item);
    }
    return selectors;
}
/**
 * @public
 *
 * Given a mapping of keys -> results and a mapping of keys -> fragments,
 * extracts a mapping of keys -> id(s) of the results.
 *
 * Similar to `getSelectorsFromObject()`, this function can be useful in
 * determining the "identity" of the props passed to a component.
 */ function $d43c60d633c5fc6f$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $d43c60d633c5fc6f$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $d43c60d633c5fc6f$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getDataID(fragment, item);
    }
}
/**
 * @internal
 */ function $d43c60d633c5fc6f$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $d43c60d633c5fc6f$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
/**
 * @internal
 */ function $d43c60d633c5fc6f$var$getDataID(fragment, item) {
    !(typeof item === "object" && item !== null && !Array.isArray(item)) && $aaXwj(false);
    var dataID = item[$d43c60d633c5fc6f$var$ID_KEY];
    if (typeof dataID === "string") return dataID;
    return null;
}
/**
 * @public
 *
 * Given a mapping of keys -> results and a mapping of keys -> fragments,
 * extracts the merged variables that would be in scope for those
 * fragments/results.
 *
 * This can be useful in determing what varaibles were used to fetch the data
 * for a Relay container, for example.
 */ function $d43c60d633c5fc6f$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $d43c60d633c5fc6f$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $d43c60d633c5fc6f$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $aaXwj(false);
        return $d43c60d633c5fc6f$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $d43c60d633c5fc6f$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $d43c60d633c5fc6f$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $d43c60d633c5fc6f$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $d43c60d633c5fc6f$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $d43c60d633c5fc6f$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.owner === thatSelector.owner && thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $ewhZB(thisSelector.variables, thatSelector.variables);
}
/**
 * @public
 *
 * Determine if two selectors are equal (represent the same selection). Note
 * that this function returns `false` when the two queries/fragments are
 * different objects, even if they select the same fields.
 */ function $d43c60d633c5fc6f$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === "SingularReaderSelector" && b.kind === "SingularReaderSelector") return $d43c60d633c5fc6f$var$areEqualSingularSelectors(a, b);
    else if (a.kind === "PluralReaderSelector" && b.kind === "PluralReaderSelector") return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $d43c60d633c5fc6f$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $d43c60d633c5fc6f$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: "SingularReaderSelector",
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $d43c60d633c5fc6f$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $d43c60d633c5fc6f$var$areEqualSelectors,
    createReaderSelector: $d43c60d633c5fc6f$var$createReaderSelector,
    createNormalizationSelector: $d43c60d633c5fc6f$var$createNormalizationSelector,
    getDataIDsFromFragment: $d43c60d633c5fc6f$var$getDataIDsFromFragment,
    getDataIDsFromObject: $d43c60d633c5fc6f$var$getDataIDsFromObject,
    getSingularSelector: $d43c60d633c5fc6f$var$getSingularSelector,
    getPluralSelector: $d43c60d633c5fc6f$var$getPluralSelector,
    getSelector: $d43c60d633c5fc6f$var$getSelector,
    getSelectorsFromObject: $d43c60d633c5fc6f$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $d43c60d633c5fc6f$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $d43c60d633c5fc6f$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $d43c60d633c5fc6f$var$getVariablesFromFragment,
    getVariablesFromObject: $d43c60d633c5fc6f$var$getVariablesFromObject
};

});


parcelRegister("f8nQK", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $b04a1a720cd8549f$var$_interopRequireDefault = $1jnue.default;

var $b04a1a720cd8549f$var$_createForOfIteratorHelper2 = $b04a1a720cd8549f$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $7uWVM = parcelRequire("7uWVM");
parcelRequire("8Fbfi");
var $b04a1a720cd8549f$var$MutationTypes = Object.freeze({
    RANGE_ADD: "RANGE_ADD",
    RANGE_DELETE: "RANGE_DELETE",
    NODE_DELETE: "NODE_DELETE"
});
var $b04a1a720cd8549f$var$RangeOperations = Object.freeze({
    APPEND: "append",
    PREPEND: "prepend"
});
function $b04a1a720cd8549f$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case "NODE_DELETE":
                var nodeDeleteResult = $b04a1a720cd8549f$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case "RANGE_ADD":
                var rangeAddResult = $b04a1a720cd8549f$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case "RANGE_DELETE":
                var rangeDeleteResult = $b04a1a720cd8549f$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $b04a1a720cd8549f$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $b04a1a720cd8549f$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === "string") store["delete"](id);
        });
    };
}
function $b04a1a720cd8549f$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $b04a1a720cd8549f$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $b04a1a720cd8549f$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $7uWVM.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $7uWVM.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case "append":
                        $7uWVM.insertEdgeAfter(connection, clientEdge);
                        break;
                    case "prepend":
                        $7uWVM.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $b04a1a720cd8549f$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $b04a1a720cd8549f$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        // the type of data should come from a type parameter associated with ConcreteRequest,
        // but ConcreteRequest does not contain a type parameter. Hence, we use a FlowFixMe.
        // $FlowFixMe[incompatible-use] see above
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $b04a1a720cd8549f$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === "object") deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === "object" && typeof idObject.id === "string") deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === "string") deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === "string" && typeof deletedIDField === "object") {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === "string") deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === "string") deleteIDs.push(id);
            });
        }
        $b04a1a720cd8549f$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $b04a1a720cd8549f$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    // Should never enter loop except edge cases
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $b04a1a720cd8549f$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $7uWVM.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $7uWVM.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $b04a1a720cd8549f$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === "LinkedField") return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $b04a1a720cd8549f$var$MutationTypes,
    RangeOperations: $b04a1a720cd8549f$var$RangeOperations,
    convert: $b04a1a720cd8549f$var$convert
};

});


parcelRegister("aq9ZM", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
function $796415fa72badc05$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $796415fa72badc05$var$commitLocalUpdate;

});

parcelRegister("io2Di", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $d62c82af7e9aad49$var$_interopRequireDefault = $1jnue.default;

var $d62c82af7e9aad49$var$_toConsumableArray2 = $d62c82af7e9aad49$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $aW0zg = parcelRequire("aW0zg");
var $d62c82af7e9aad49$var$getRequest = $aW0zg.getRequest;

var $i2E13 = parcelRequire("i2E13");
var $d62c82af7e9aad49$var$generateUniqueClientID = $i2E13.generateUniqueClientID;

var $i7dei = parcelRequire("i7dei");

var $40tQb = parcelRequire("40tQb");
var $d62c82af7e9aad49$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $f8nQK = parcelRequire("f8nQK");
parcelRequire("eJlOZ");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * Higher-level helper function to execute a mutation against a specific
 * environment.
 */ function $d62c82af7e9aad49$var$commitMutation(environment, config) {
    !$i7dei(environment) && $aaXwj(false);
    var mutation = $d62c82af7e9aad49$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== "mutation") throw new Error("commitMutation: Expected mutation operation");
    if (mutation.kind !== "Request") throw new Error("commitMutation: Expected mutation to be of type request");
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $d62c82af7e9aad49$var$createOperationDescriptor(mutation, variables, cacheConfig, $d62c82af7e9aad49$var$generateUniqueClientID());
    // TODO: remove this check after we fix flow.
    if (typeof optimisticResponse === "function") optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $f8nQK.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $d62c82af7e9aad49$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $d62c82af7e9aad49$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $d62c82af7e9aad49$var$commitMutation;

});
parcelRegister("eJlOZ", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $ab9631f3b88eb2a3$var$_interopRequireDefault = $1jnue.default;

var $ab9631f3b88eb2a3$var$_objectSpread2 = $ab9631f3b88eb2a3$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $84X73 = parcelRequire("84X73");
var $ab9631f3b88eb2a3$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $ab9631f3b88eb2a3$var$CLIENT_COMPONENT = $84X73.CLIENT_COMPONENT, $ab9631f3b88eb2a3$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $ab9631f3b88eb2a3$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $ab9631f3b88eb2a3$var$CONDITION = $84X73.CONDITION, $ab9631f3b88eb2a3$var$DEFER = $84X73.DEFER, $ab9631f3b88eb2a3$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $ab9631f3b88eb2a3$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $ab9631f3b88eb2a3$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $ab9631f3b88eb2a3$var$LINKED_FIELD = $84X73.LINKED_FIELD, $ab9631f3b88eb2a3$var$LINKED_HANDLE = $84X73.LINKED_HANDLE, $ab9631f3b88eb2a3$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $ab9631f3b88eb2a3$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $ab9631f3b88eb2a3$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $ab9631f3b88eb2a3$var$SCALAR_HANDLE = $84X73.SCALAR_HANDLE, $ab9631f3b88eb2a3$var$STREAM = $84X73.STREAM, $ab9631f3b88eb2a3$var$TYPE_DISCRIMINATOR = $84X73.TYPE_DISCRIMINATOR;
parcelRequire("8Fbfi");
// $FlowFixMe[method-unbinding] added when improving typing for this parameters
var $ab9631f3b88eb2a3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ab9631f3b88eb2a3$var$validateMutation = function validateMutation() {};
var $ab9631f3b88eb2a3$var$addFieldToDiff, $ab9631f3b88eb2a3$var$validateSelections, $ab9631f3b88eb2a3$var$validateSelection, $ab9631f3b88eb2a3$var$validateModuleImport, $ab9631f3b88eb2a3$var$validateAbstractKey, $ab9631f3b88eb2a3$var$validateField, $ab9631f3b88eb2a3$var$validateOptimisticResponse;
module.exports = $ab9631f3b88eb2a3$var$validateMutation;

});


parcelRegister("cuefK", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $hpvi1 = parcelRequire("hpvi1");

var $5naHI = parcelRequire("5naHI");
var $917357bfb6bdf8e6$var$convertFetch = $5naHI.convertFetch;

var $aaXwj = parcelRequire("aaXwj");
/**
 * Creates an implementation of the `Network` interface defined in
 * `RelayNetworkTypes` given `fetch` and `subscribe` functions.
 */ function $917357bfb6bdf8e6$var$create(fetchFn, subscribe) {
    // Convert to functions that returns RelayObservable.
    var observeFetch = $917357bfb6bdf8e6$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $hpvi1(variables, request.providedVariables);
        if (request.operationKind === "subscription") {
            !subscribe && $aaXwj(false);
            !!uploadables && $aaXwj(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $aaXwj(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $917357bfb6bdf8e6$var$create
};

});
parcelRegister("hpvi1", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
parcelRequire("ewhZB");
parcelRequire("8Fbfi");
var $cacd0af5e6b60d25$var$WEAKMAP_SUPPORTED = typeof WeakMap === "function";
var $cacd0af5e6b60d25$var$debugCache = $cacd0af5e6b60d25$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $cacd0af5e6b60d25$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            // people like to ignore these warnings, so use the cache to
            // enforce that we only compute the value the first time
            if (!$cacd0af5e6b60d25$var$debugCache.has(providerFunction)) {
                $cacd0af5e6b60d25$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $cacd0af5e6b60d25$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$cacd0af5e6b60d25$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $cacd0af5e6b60d25$var$withProvidedVariables;

});

parcelRegister("5naHI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $hIn3L = parcelRequire("hIn3L");
/**
 * Converts a FetchFunction into an ExecuteFunction for use by RelayNetwork.
 */ function $3e97675b302b9d4f$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        // Note: We allow FetchFunction to directly return Error to indicate
        // a failure to fetch. To avoid handling this special case throughout the
        // Relay codebase, it is explicitly handled here.
        if (result instanceof Error) return $hIn3L.create(function(sink) {
            return sink.error(result);
        });
        return $hIn3L.from(result);
    };
}
module.exports = {
    convertFetch: $3e97675b302b9d4f$var$convertFetch
};

});
parcelRegister("hIn3L", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1Q5mH = parcelRequire("1Q5mH");
/**
 * A Subscription object is returned from .subscribe(), which can be
 * unsubscribed or checked to see if the resulting subscription has closed.
 */ var $ce586ee2e2d76b42$var$hostReportError = $ce586ee2e2d76b42$var$swallowError;
/**
 * Limited implementation of ESObservable, providing the limited set of behavior
 * Relay networking requires.
 *
 * Observables retain the benefit of callbacks which can be called
 * synchronously, avoiding any UI jitter, while providing a compositional API,
 * which simplifies logic and prevents mishandling of errors compared to
 * the direct use of callback functions.
 *
 * ESObservable: https://github.com/tc39/proposal-observable
 */ var $ce586ee2e2d76b42$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    /**
   * When an emitted error event is not handled by an Observer, it is reported
   * to the host environment (what the ESObservable spec refers to as
   * "HostReportErrors()").
   *
   * The default implementation in development rethrows thrown errors, and
   * logs emitted error events to the console, while in production does nothing
   * (swallowing unhandled errors).
   *
   * Called during application initialization, this method allows
   * application-specific handling of unhandled errors. Allowing, for example,
   * integration with error logging or developer tools.
   *
   * A second parameter `isUncaughtThrownError` is true when the unhandled error
   * was thrown within an Observer handler, and false when the unhandled error
   * was an unhandled emitted event.
   *
   *  - Uncaught thrown errors typically represent avoidable errors thrown from
   *    application code, which should be handled with a try/catch block, and
   *    usually have useful stack traces.
   *
   *  - Unhandled emitted event errors typically represent unavoidable events in
   *    application flow such as network failure, and may not have useful
   *    stack traces.
   */ RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $ce586ee2e2d76b42$var$hostReportError = callback;
    } /**
   * Accepts various kinds of data sources, and always returns a RelayObservable
   * useful for accepting the result of a user-provided FetchFunction.
   */ ;
    RelayObservable.from = function from(obj) {
        return $ce586ee2e2d76b42$var$isObservable(obj) ? $ce586ee2e2d76b42$var$fromObservable(obj) : $1Q5mH(obj) ? $ce586ee2e2d76b42$var$fromPromise(obj) : $ce586ee2e2d76b42$var$fromValue(obj);
    } /**
   * Similar to promise.catch(), observable.catch() handles error events, and
   * provides an alternative observable to use in it's place.
   *
   * If the catch handler throws a new error, it will appear as an error event
   * on the resulting Observable.
   */ ;
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    } /**
   * Returns a new Observable which first yields values from this Observable,
   * then yields values from the next Observable. This is useful for chaining
   * together Observables of finite length.
   */ ;
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    } /**
   * Returns a new Observable which returns the same values as this one, but
   * modified so that the provided Observer is called to perform a side-effects
   * for all events emitted by the source.
   *
   * Any errors that are thrown in the side-effect Observer are unhandled, and
   * do not affect the source Observable or its Observer.
   *
   * This is useful for when debugging your Observables or performing other
   * side-effects such as logging or performance monitoring.
   */ ;
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $ce586ee2e2d76b42$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both("start"),
                next: both("next"),
                error: both("error"),
                complete: both("complete"),
                unsubscribe: both("unsubscribe")
            });
        });
    } /**
   * Returns a new Observable which returns the same values as this one, but
   * modified so that the finally callback is performed after completion,
   * whether normal or due to error or unsubscription.
   *
   * This is useful for cleanup such as resource finalization.
   */ ;
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    } /**
   * Returns a new Observable which is identical to this one, unless this
   * Observable completes before yielding any values, in which case the new
   * Observable will yield the values from the alternate Observable.
   *
   * If this Observable does yield values, the alternate is never subscribed to.
   *
   * This is useful for scenarios where values may come from multiple sources
   * which should be tried in order, i.e. from a cache before a network.
   */ ;
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current.unsubscribe();
            };
        });
    } /**
   * Observable's primary API: returns an unsubscribable Subscription to the
   * source of this Observable.
   *
   * Note: A sink may be passed directly to .subscribe() as its observer,
   * allowing for easily composing Observables.
   */ ;
    _proto.subscribe = function subscribe(observer) {
        return $ce586ee2e2d76b42$var$_subscribe(this._source, observer);
    } /**
   * Returns a new Observerable where each value has been transformed by
   * the mapping function.
   */ ;
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    } /**
   * Returns a new Observable where each value is replaced with a new Observable
   * by the mapping function, the results of which returned as a single
   * merged Observable.
   */ ;
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    } /**
   * Returns a new Observable which first mirrors this Observable, then when it
   * completes, waits for `pollInterval` milliseconds before re-subscribing to
   * this Observable again, looping in this manner until unsubscribed.
   *
   * The returned Observable never completes.
   */ ;
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    } /**
   * Returns a Promise which resolves when this Observable yields a first value
   * or when it completes with no value.
   *
   * NOTE: The source Observable is *NOT* canceled when the returned Promise
   * resolves. The Observable is always run to completion.
   */ ;
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}(); // Use declarations to teach Flow how to check isObservable.
function $ce586ee2e2d76b42$var$isObservable(obj) {
    return typeof obj === "object" && obj !== null && typeof obj.subscribe === "function";
}
function $ce586ee2e2d76b42$var$fromObservable(obj) {
    return obj instanceof $ce586ee2e2d76b42$var$RelayObservable ? obj : $ce586ee2e2d76b42$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $ce586ee2e2d76b42$var$fromPromise(promise) {
    return $ce586ee2e2d76b42$var$RelayObservable.create(function(sink) {
        // Since sink methods do not throw, the resulting Promise can be ignored.
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $ce586ee2e2d76b42$var$fromValue(value) {
    return $ce586ee2e2d76b42$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $ce586ee2e2d76b42$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    // Ideally we would simply describe a `get closed()` method on the Sink and
    // Subscription objects below, however not all flow environments we expect
    // Relay to be used within will support property getters, and many minifier
    // tools still do not support ES5 syntax. Instead, we can use defineProperty.
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, "closed", {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $ce586ee2e2d76b42$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    // Create a Subscription.
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                // Tell Observer that unsubscribe was called.
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $ce586ee2e2d76b42$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    // Tell Observer that observation is about to begin.
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $ce586ee2e2d76b42$var$hostReportError(error, true);
    }
    // If closed already, don't bother creating a Sink.
    if (closed) return subscription;
    // Create a Sink respecting subscription state and cleanup.
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $ce586ee2e2d76b42$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $ce586ee2e2d76b42$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $ce586ee2e2d76b42$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $ce586ee2e2d76b42$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    // If anything goes wrong during observing the source, handle the error.
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    // If closed before the source function existed, cleanup now.
    if (closed) doCleanup();
    return subscription;
}
function $ce586ee2e2d76b42$var$swallowError(_error, _isUncaughtThrownError) {
// do nothing.
}
module.exports = $ce586ee2e2d76b42$var$RelayObservable;

});
parcelRegister("1Q5mH", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
function $156ecf273d8def1c$var$isPromise(p) {
    return !!p && typeof p.then === "function";
}
module.exports = $156ecf273d8def1c$var$isPromise;

});




parcelRegister("l6QXA", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $f5e33d43325eef4a$var$_interopRequireDefault = $1jnue.default;

var $f5e33d43325eef4a$var$_objectSpread2 = $f5e33d43325eef4a$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $8Q6tr = parcelRequire("8Q6tr");

var $aaXwj = parcelRequire("aaXwj");
/**
 * A cache for storing query responses, featuring:
 * - `get` with TTL
 * - cache size limiting, with least-recently *updated* entries purged first
 */ var $f5e33d43325eef4a$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $aaXwj(false);
        !(ttl > 0) && $aaXwj(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $f5e33d43325eef4a$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$f5e33d43325eef4a$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $f5e33d43325eef4a$var$_objectSpread2["default"])((0, $f5e33d43325eef4a$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $f5e33d43325eef4a$var$_objectSpread2["default"])((0, $f5e33d43325eef4a$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $f5e33d43325eef4a$var$_objectSpread2["default"])((0, $f5e33d43325eef4a$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $f5e33d43325eef4a$var$_objectSpread2["default"])((0, $f5e33d43325eef4a$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $f5e33d43325eef4a$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey); // deletion resets key ordering
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        // Purge least-recently updated key when max size reached
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $f5e33d43325eef4a$var$getCacheKey(queryID, variables) {
    return JSON.stringify($8Q6tr({
        queryID: queryID,
        variables: variables
    }));
}
/**
 * Determine whether a response fetched at `fetchTime` is still valid given
 * some `ttl`.
 */ function $f5e33d43325eef4a$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $f5e33d43325eef4a$var$RelayQueryResponseCache;

});

parcelRegister("lmXME", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $f8ea06d4c222f58c$var$_interopRequireDefault = $1jnue.default;

var $f8ea06d4c222f58c$var$_objectSpread2 = $f8ea06d4c222f58c$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $hIn3L = parcelRequire("hIn3L");

var $40tQb = parcelRequire("40tQb");
var $f8ea06d4c222f58c$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $47Vax = parcelRequire("47Vax");

var $1PcQ6 = parcelRequire("1PcQ6");

var $aW0zg = parcelRequire("aW0zg");
var $f8ea06d4c222f58c$var$getRequest = $aW0zg.getRequest;

var $aaXwj = parcelRequire("aaXwj");
/**
 * Fetches the given query and variables on the provided environment,
 * and de-dupes identical in-flight requests.
 *
 * Observing a request:
 * ====================
 * fetchQuery returns an Observable which you can call .subscribe()
 * on. Subscribe optionally takes an Observer, which you can provide to
 * observe network events:
 *
 * ```
 * fetchQuery(environment, query, variables).subscribe({
 *   // Called when network requests starts
 *   start: (subsctiption) => {},
 *
 *   // Called after a payload is received and written to the local store
 *   next: (payload) => {},
 *
 *   // Called when network requests errors
 *   error: (error) => {},
 *
 *   // Called when network requests fully completes
 *   complete: () => {},
 *
 *   // Called when network request is unsubscribed
 *   unsubscribe: (subscription) => {},
 * });
 * ```
 *
 * Request Promise:
 * ================
 * The obervable can be converted to a Promise with .toPromise(), which will
 * resolve to a snapshot of the query data when the first response is received
 * from the server.
 *
 * ```
 * fetchQuery(environment, query, variables).toPromise().then((data) => {
 *   // ...
 * });
 * ```
 *
 * In-flight request de-duping:
 * ============================
 * By default, calling fetchQuery multiple times with the same
 * environment, query and variables will not initiate a new request if a request
 * for those same parameters is already in flight.
 *
 * A request is marked in-flight from the moment it starts until the moment it
 * fully completes, regardless of error or successful completion.
 *
 * NOTE: If the request completes _synchronously_, calling fetchQuery
 * a second time with the same arguments in the same tick will _NOT_ de-dupe
 * the request given that it will no longer be in-flight.
 *
 *
 * Data Retention:
 * ===============
 * This function will NOT retain query data, meaning that it is not guaranteed
 * that the fetched data will remain in the Relay store after the request has
 * completed.
 * If you need to retain the query data outside of the network request,
 * you need to use `environment.retain()`.
 *
 *
 * Cancelling requests:
 * ====================
 * If the disposable returned by subscribe is called while the
 * request is in-flight, the request will be cancelled.
 *
 * ```
 * const disposable = fetchQuery(...).subscribe(...);
 *
 * // This will cancel the request if it is in-flight.
 * disposable.dispose();
 * ```
 * NOTE: When using .toPromise(), the request cannot be cancelled.
 */ function $f8ea06d4c222f58c$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $f8ea06d4c222f58c$var$getRequest(query);
    !(queryNode.params.operationKind === "query") && $aaXwj(false);
    var networkCacheConfig = (0, $f8ea06d4c222f58c$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $f8ea06d4c222f58c$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : "network-only";
    function readData(snapshot) {
        $47Vax(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors);
        /* $FlowFixMe[incompatible-return] we assume readData returns the right
     * data just having written it from network or checked availability. */ return snapshot.data;
    }
    switch(fetchPolicy){
        case "network-only":
            return $f8ea06d4c222f58c$var$getNetworkObservable(environment, operation).map(readData);
        case "store-or-network":
            if (environment.check(operation).status === "available") return $hIn3L.from(environment.lookup(operation.fragment)).map(readData);
            return $f8ea06d4c222f58c$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error("fetchQuery: Invalid fetchPolicy " + fetchPolicy);
    }
}
function $f8ea06d4c222f58c$var$getNetworkObservable(environment, operation) {
    return $1PcQ6.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $f8ea06d4c222f58c$var$fetchQuery;

});
parcelRegister("47Vax", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $301429753d16228d$var$_interopRequireDefault = $1jnue.default;

var $301429753d16228d$var$_createForOfIteratorHelper2 = $301429753d16228d$var$_interopRequireDefault((parcelRequire("8QL5z")));
function $301429753d16228d$var$handlePotentialSnapshotErrors(environment, missingRequiredFields, relayResolverErrors) {
    var _iterator = (0, $301429753d16228d$var$_createForOfIteratorHelper2["default"])(relayResolverErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var resolverError = _step.value;
            environment.requiredFieldLogger({
                kind: "relay_resolver.error",
                owner: resolverError.field.owner,
                fieldPath: resolverError.field.path,
                error: resolverError.error
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (missingRequiredFields != null) switch(missingRequiredFields.action){
        case "THROW":
            var _missingRequiredField = missingRequiredFields.field, path = _missingRequiredField.path, owner = _missingRequiredField.owner;
            // This gives the consumer the chance to throw their own error if they so wish.
            environment.requiredFieldLogger({
                kind: "missing_field.throw",
                owner: owner,
                fieldPath: path
            });
            throw new Error("Relay: Missing @required value at path '".concat(path, "' in '").concat(owner, "'."));
        case "LOG":
            missingRequiredFields.fields.forEach(function(_ref) {
                var path = _ref.path, owner = _ref.owner;
                environment.requiredFieldLogger({
                    kind: "missing_field.log",
                    owner: owner,
                    fieldPath: path
                });
            });
            break;
        default:
            missingRequiredFields.action;
    }
}
module.exports = $301429753d16228d$var$handlePotentialSnapshotErrors;

});

parcelRegister("1PcQ6", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $hIn3L = parcelRequire("hIn3L");

var $dsOUI = parcelRequire("dsOUI");

var $aLywI = parcelRequire("aLywI");

var $aaXwj = parcelRequire("aaXwj");
var $1544837bc9a02b7e$var$WEAKMAP_SUPPORTED = typeof WeakMap === "function";
var $1544837bc9a02b7e$var$requestCachesByEnvironment = $1544837bc9a02b7e$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
/**
 * Fetches the given query and variables on the provided environment,
 * and de-dupes identical in-flight requests.
 *
 * Observing a request:
 * ====================
 * fetchQuery returns an Observable which you can call .subscribe()
 * on. subscribe() takes an Observer, which you can provide to
 * observe network events:
 *
 * ```
 * fetchQuery(environment, query, variables).subscribe({
 *   // Called when network requests starts
 *   start: (subscription) => {},
 *
 *   // Called after a payload is received and written to the local store
 *   next: (payload) => {},
 *
 *   // Called when network requests errors
 *   error: (error) => {},
 *
 *   // Called when network requests fully completes
 *   complete: () => {},
 *
 *   // Called when network request is unsubscribed
 *   unsubscribe: (subscription) => {},
 * });
 * ```
 *
 * In-flight request de-duping:
 * ============================
 * By default, calling fetchQuery multiple times with the same
 * environment, query and variables will not initiate a new request if a request
 * for those same parameters is already in flight.
 *
 * A request is marked in-flight from the moment it starts until the moment it
 * fully completes, regardless of error or successful completion.
 *
 * NOTE: If the request completes _synchronously_, calling fetchQuery
 * a second time with the same arguments in the same tick will _NOT_ de-dupe
 * the request given that it will no longer be in-flight.
 *
 *
 * Data Retention:
 * ===============
 * This function will not retain any query data outside the scope of the
 * request, which means it is not guaranteed that it won't be garbage
 * collected after the request completes.
 * If you need to retain data, you can do so manually with environment.retain().
 *
 * Cancelling requests:
 * ====================
 * If the subscription returned by subscribe is called while the
 * request is in-flight, the request will be cancelled.
 *
 * ```
 * const subscription = fetchQuery(...).subscribe(...);
 *
 * // This will cancel the request if it is in-flight.
 * subscription.unsubscribe();
 * ```
 */ function $1544837bc9a02b7e$var$fetchQuery(environment, operation) {
    return $1544837bc9a02b7e$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
/**
 * Low-level implementation details of `fetchQuery`.
 *
 * `fetchQueryDeduped` can also be used to share a single cache for
 * requests that aren't using `fetchQuery` directly (e.g. because they don't
 * have an `OperationDescriptor` when they are called).
 */ function $1544837bc9a02b7e$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $hIn3L.create(function(sink) {
        var requestCache = $1544837bc9a02b7e$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $aLywI(),
                    subjectForInFlightStatus: new $aLywI(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $aaXwj(false);
        return $1544837bc9a02b7e$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
/**
 * @private
 */ function $1544837bc9a02b7e$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $hIn3L.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
/**
 * @private
 */ function $1544837bc9a02b7e$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $hIn3L.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
/**
 * If a request is active for the given query, variables and environment,
 * this function will return a Promise that will resolve when that request
 * stops being active (receives a final payload), and the data has been saved
 * to the store.
 * If no request is active, null will be returned
 */ function $1544837bc9a02b7e$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $1544837bc9a02b7e$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    if ($dsOUI.USE_REACT_CACHE) {
        var existing = cachedRequest.promise;
        if (existing) return existing;
    }
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $1544837bc9a02b7e$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                /*
         * The underlying `RelayReplaySubject` will synchronously replay events
         * as soon as we subscribe, but since we want the *next* asynchronous
         * one, we'll ignore them until the replay finishes.
         */ if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    if ($dsOUI.USE_REACT_CACHE) {
        // React Suspense should get thrown the same promise each time, so we cache it.
        // However, the promise gets resolved on each payload, so subsequently we need
        // to provide a new fresh promise that isn't already resolved. (When the feature
        // flag is off we do this in QueryResource.)
        cachedRequest.promise = promise;
        var cleanup = function cleanup() {
            cachedRequest.promise = null;
        };
        promise.then(cleanup, cleanup);
    }
    return promise;
}
/**
 * If there is a pending request for the given query, returns an Observable of
 * *all* its responses. Existing responses are published synchronously and
 * subsequent responses are published asynchronously. Returns null if there is
 * no pending request. This is similar to fetchQuery() except that it will not
 * issue a fetch if there isn't already one pending.
 */ function $1544837bc9a02b7e$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $1544837bc9a02b7e$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $1544837bc9a02b7e$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
/**
 * @private
 */ function $1544837bc9a02b7e$var$getRequestCache(environment) {
    var cached = $1544837bc9a02b7e$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $1544837bc9a02b7e$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
/**
 * @private
 */ function $1544837bc9a02b7e$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $aaXwj(false);
    return cached;
}
module.exports = {
    fetchQuery: $1544837bc9a02b7e$var$fetchQuery,
    fetchQueryDeduped: $1544837bc9a02b7e$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $1544837bc9a02b7e$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $1544837bc9a02b7e$var$getObservableForActiveRequest
};

});
parcelRegister("aLywI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $7d69136d8cd658ab$var$_interopRequireDefault = $1jnue.default;

var $7d69136d8cd658ab$var$_createForOfIteratorHelper2 = $7d69136d8cd658ab$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $7d69136d8cd658ab$var$_defineProperty2 = $7d69136d8cd658ab$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $hIn3L = parcelRequire("hIn3L");

var $aaXwj = parcelRequire("aaXwj");
/**
 * An implementation of a `ReplaySubject` for Relay Observables.
 *
 * Records events provided and synchronously plays them back to new subscribers,
 * as well as forwarding new asynchronous events.
 */ var $7d69136d8cd658ab$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $7d69136d8cd658ab$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $7d69136d8cd658ab$var$_defineProperty2["default"])(this, "_events", []);
        (0, $7d69136d8cd658ab$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $7d69136d8cd658ab$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $hIn3L.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case "complete":
                        sink.complete();
                        break;
                    case "error":
                        sink.error(event.error);
                        break;
                    case "next":
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $aaXwj(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: "complete"
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: "error",
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: "next",
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $7d69136d8cd658ab$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $7d69136d8cd658ab$var$RelayReplaySubject;

});



parcelRegister("f0RKF", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $40tQb = parcelRequire("40tQb");
var $aee08d16fabb6df7$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $aW0zg = parcelRequire("aW0zg");
var $aee08d16fabb6df7$var$getRequest = $aW0zg.getRequest;
/**
 * A helper function to fetch the results of a query. Note that results for
 * fragment spreads are masked: fields must be explicitly listed in the query in
 * order to be accessible in the result object.
 */ function $aee08d16fabb6df7$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $aee08d16fabb6df7$var$getRequest(taggedNode);
    if (query.params.operationKind !== "query") throw new Error("fetchQuery: Expected query operation");
    var operation = $aee08d16fabb6df7$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $aee08d16fabb6df7$var$fetchQuery_DEPRECATED;

});

parcelRegister("gucor", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $c0090fb264c4455a$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                // We do *not* want to throw in this tick, as this callback is executed
                // while a query is required for the very first time.
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $c0090fb264c4455a$var$preloadableQueryRegistry = new $c0090fb264c4455a$var$PreloadableQueryRegistry();
module.exports = $c0090fb264c4455a$var$preloadableQueryRegistry;

});

parcelRegister("lWuAe", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $eXtFn = parcelRequire("eXtFn");
parcelRequire("8Fbfi");
function $ff96bcfe11da0932$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $eXtFn(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $ff96bcfe11da0932$var$createFragmentSpecResolver;

});
parcelRegister("eXtFn", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $ae3d968518c600f2$var$_interopRequireDefault = $1jnue.default;

var $ae3d968518c600f2$var$_objectSpread2 = $ae3d968518c600f2$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $ae3d968518c600f2$var$_defineProperty2 = $ae3d968518c600f2$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $k0hcd = parcelRequire("k0hcd");

var $47Vax = parcelRequire("47Vax");

var $iyRh8 = parcelRequire("iyRh8");

var $9DGaB = parcelRequire("9DGaB");

var $dsOUI = parcelRequire("dsOUI");

var $40tQb = parcelRequire("40tQb");
var $ae3d968518c600f2$var$createRequestDescriptor = $40tQb.createRequestDescriptor;

var $idJ2w = parcelRequire("idJ2w");
var $ae3d968518c600f2$var$areEqualSelectors = $idJ2w.areEqualSelectors, $ae3d968518c600f2$var$createReaderSelector = $idJ2w.createReaderSelector, $ae3d968518c600f2$var$getSelectorsFromObject = $idJ2w.getSelectorsFromObject;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * A utility for resolving and subscribing to the results of a fragment spec
 * (key -> fragment mapping) given some "props" that determine the root ID
 * and variables to use when reading each fragment. When props are changed via
 * `setProps()`, the resolver will update its results and subscriptions
 * accordingly. Internally, the resolver:
 * - Converts the fragment map & props map into a map of `Selector`s.
 * - Removes any resolvers for any props that became null.
 * - Creates resolvers for any props that became non-null.
 * - Updates resolvers with the latest props.
 *
 * This utility is implemented as an imperative, stateful API for performance
 * reasons: reusing previous resolvers, callback functions, and subscriptions
 * all helps to reduce object allocation and thereby decrease GC time.
 *
 * The `resolve()` function is also lazy and memoized: changes in the store mark
 * the resolver as stale and notify the caller, and the actual results are
 * recomputed the first time `resolve()` is called.
 */ var $ae3d968518c600f2$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $ae3d968518c600f2$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === "function") _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $ae3d968518c600f2$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            // Avoid mapping the object multiple times, which could occur if data for
            // multiple keys changes in the same event loop.
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $ae3d968518c600f2$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$iyRh8(_nextItem, prevItem)) {
                        nextData = nextData || (0, $ae3d968518c600f2$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($dsOUI.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $ae3d968518c600f2$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === "PluralReaderSelector") {
                if (resolver == null) resolver = new $ae3d968518c600f2$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $ae3d968518c600f2$var$SelectorListResolver) && $aaXwj(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $ae3d968518c600f2$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $ae3d968518c600f2$var$SelectorResolver) && $aaXwj(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
/**
 * A resolver for a single Selector.
 */ var $ae3d968518c600f2$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $ae3d968518c600f2$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._missingRequiredFields = snapshot.missingRequiredFields;
            _this2._relayResolverErrors = snapshot.relayResolverErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._missingRequiredFields = _snapshot.missingRequiredFields;
        this._relayResolverErrors = _snapshot.relayResolverErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($dsOUI.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            // NOTE: This branch exists to handle the case in which:
            // - A RelayModern container is rendered as a descendant of a Relay Hook
            //   root using a "partial" renderPolicy (this means that eargerly
            //   reading any cached data that is available instead of blocking
            //   at the root until the whole query is fetched).
            // - A parent Relay Hook didnt' suspend earlier on data being fetched,
            //   either because the fragment data for the parent was available, or
            //   the parent fragment didn't have any data dependencies.
            // Even though our Flow types reflect the possiblity of null data, there
            // might still be cases where it's not handled at runtime becuase the
            // Flow types are being ignored, or simply not being used (for example,
            // the case reported here: https://fburl.com/srnbucf8, was due to
            // misuse of Flow types here: https://fburl.com/g3m0mqqh).
            // Additionally, even though the null data might be handled without a
            // runtime error, we might not suspend when we intended to if a parent
            // Relay Hook (e.g. that is using @defer) decided not to suspend becuase
            // it's immediate data was already available (even if it was deferred),
            // or it didn't actually need any data (was just spreading other fragments).
            // This should eventually go away with something like @optional, where we only
            // suspend at specific boundaries depending on whether the boundary
            // can be fulfilled or not.
            var pendingOperationsResult = $k0hcd(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: "suspense.fragment",
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $47Vax(this._environment, this._missingRequiredFields, this._relayResolverErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $ae3d968518c600f2$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $9DGaB(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._missingRequiredFields = snapshot.missingRequiredFields;
        this._relayResolverErrors = snapshot.relayResolverErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($ewhZB(variables, this._selector.variables)) // If we're not actually setting new variables, we don't actually want
        // to create a new fragment owner, since areEqualSelectors relies on
        // owner identity.
        // In fact, we don't even need to try to attempt to set a new selector.
        // When fragment ownership is not enabled, setSelector will also bail
        // out since the selector doesn't really change, so we're doing it here
        // earlier.
        return;
        // NOTE: We manually create the request descriptor here instead of
        // calling createOperationDescriptor() because we want to set a
        // descriptor with *unaltered* variables as the fragment owner.
        // This is a hack that allows us to preserve existing (broken)
        // behavior of RelayModern containers while using fragment ownership
        // to propagate variables instead of Context.
        // For more details, see the summary of D13999308
        var requestDescriptor = $ae3d968518c600f2$var$createRequestDescriptor(request, variables);
        var selector = $ae3d968518c600f2$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
/**
 * A resolver for an array of Selectors.
 */ var $ae3d968518c600f2$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $ae3d968518c600f2$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($ae3d968518c600f2$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            // Avoid mapping the array multiple times, which could occur if data for
            // multiple indices changes in the same event loop.
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $ae3d968518c600f2$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $ae3d968518c600f2$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $ae3d968518c600f2$var$RelayModernFragmentSpecResolver;

});
parcelRegister("k0hcd", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1PcQ6 = parcelRequire("1PcQ6");
var $e901258517dd2062$var$getPromiseForActiveRequest = $1PcQ6.getPromiseForActiveRequest;
function $e901258517dd2062$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $e901258517dd2062$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var result = environment.getOperationTracker().getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(",")) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = "Unknown pending operation";
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    // $FlowExpectedError[prop-missing] Expando to annotate Promises.
    promise.displayName = promiseDisplayName;
    // In order to monitor the efficacy of RelayOperationTracker, we log
    // enough information to track whether we are suspending on the fragment
    // owner's operation, or some other operation.
    environment.__log({
        name: "pendingoperation.found",
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $e901258517dd2062$var$getPendingOperationsForFragment;

});

parcelRegister("iyRh8", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * A fast test to determine if two values are equal scalars:
 * - compares scalars such as booleans, strings, numbers by value
 * - compares functions by identity
 * - returns false for complex values, since these cannot be cheaply tested for
 *   equality (use `areEquals` instead)
 */ function $d834ba5add34a187$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== "object");
}
module.exports = $d834ba5add34a187$var$isScalarAndEqual;

});

parcelRegister("9DGaB", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $704877a5fa33902c$var$hasWeakSetDefined = typeof WeakSet !== "undefined";
var $704877a5fa33902c$var$hasWeakMapDefined = typeof WeakMap !== "undefined";
/**
 * Recycles subtrees from `prevData` by replacing equal subtrees in `nextData`.
 */ function $704877a5fa33902c$var$recycleNodesInto(prevData, nextData) {
    if (prevData === nextData || typeof prevData !== "object" || prevData instanceof Set || prevData instanceof Map || $704877a5fa33902c$var$hasWeakSetDefined && prevData instanceof WeakSet || $704877a5fa33902c$var$hasWeakMapDefined && prevData instanceof WeakMap || !prevData || typeof nextData !== "object" || nextData instanceof Set || nextData instanceof Map || $704877a5fa33902c$var$hasWeakSetDefined && nextData instanceof WeakSet || $704877a5fa33902c$var$hasWeakMapDefined && nextData instanceof WeakMap || !nextData) return nextData;
    var canRecycle = false;
    // Assign local variables to preserve Flow type refinement.
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
        var prevValue = prevArray[ii];
        var nextValue = $704877a5fa33902c$var$recycleNodesInto(prevValue, nextItem);
        if (nextValue !== nextArray[ii]) nextArray[ii] = nextValue;
        return wasEqual && nextValue === prevArray[ii];
    }, true) && prevArray.length === nextArray.length;
    else if (!prevArray && !nextArray) {
        // Assign local variables to preserve Flow type refinement.
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $704877a5fa33902c$var$recycleNodesInto(prevValue, nextObject[key]);
            if (nextValue !== nextObject[key]) // $FlowFixMe[cannot-write]
            nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $704877a5fa33902c$var$recycleNodesInto;

});



parcelRegister("ftuXr", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aaXwj = parcelRequire("aaXwj");
// Ideally, we'd just import the type of the react module, but this causes Flow
// problems.
var $b4419401ed64c419$var$relayContext;
var $b4419401ed64c419$var$firstReact;
function $b4419401ed64c419$var$createRelayContext(react) {
    if (!$b4419401ed64c419$var$relayContext) {
        $b4419401ed64c419$var$relayContext = react.createContext(null);
        $b4419401ed64c419$var$firstReact = react;
    }
    !(react === $b4419401ed64c419$var$firstReact) && $aaXwj(false);
    return $b4419401ed64c419$var$relayContext;
}
module.exports = $b4419401ed64c419$var$createRelayContext;

});

parcelRegister("2MLqe", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $2074d97b262ae00c$var$getInlineDataFragment = $aW0zg.getInlineDataFragment;

var $5DrBw = parcelRequire("5DrBw");
var $2074d97b262ae00c$var$FRAGMENTS_KEY = $5DrBw.FRAGMENTS_KEY;

var $aaXwj = parcelRequire("aaXwj");
function $2074d97b262ae00c$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $2074d97b262ae00c$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === "object") && $aaXwj(false);
    // $FlowFixMe[incompatible-use]
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$2074d97b262ae00c$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $aaXwj(false);
    return inlineData;
}
module.exports = $2074d97b262ae00c$var$readInlineData;

});

parcelRegister("7V8U5", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $5c44c35fa5be72ec$var$_interopRequireDefault = $1jnue.default;

var $5c44c35fa5be72ec$var$_objectSpread2 = $5c44c35fa5be72ec$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $5wpCP = parcelRequire("5wpCP");

var $lbx0y = parcelRequire("lbx0y");
var $5c44c35fa5be72ec$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $lbx0y.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $5c44c35fa5be72ec$var$assertInternalActorIdentifier = $lbx0y.assertInternalActorIdentifier;

var $hIn3L = parcelRequire("hIn3L");

var $hRVdm = parcelRequire("hRVdm");

var $cGYI4 = parcelRequire("cGYI4");

var $frXF3 = parcelRequire("frXF3");

var $dsOUI = parcelRequire("dsOUI");

var $aNE7V = parcelRequire("aNE7V");

var $9YoSM = parcelRequire("9YoSM");

var $fziBd = parcelRequire("fziBd");

var $kkibE = parcelRequire("kkibE");

var $L6WFS = parcelRequire("L6WFS");
parcelRequire("aaXwj");
var $5c44c35fa5be72ec$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$requiredField, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        var reactFlightPayloadDeserializer = config.reactFlightPayloadDeserializer;
        var reactFlightServerErrorHandler = config.reactFlightServerErrorHandler;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $5c44c35fa5be72ec$var$emptyFunction;
        this.requiredFieldLogger = (_config$requiredField = config.requiredFieldLogger) !== null && _config$requiredField !== void 0 ? _config$requiredField : $9YoSM;
        this._defaultRenderPolicy = ((_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : $dsOUI.ENABLE_PARTIAL_RENDERING_DEFAULT === true) ? "partial" : "full";
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $hRVdm(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $aNE7V;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $kkibE(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $5wpCP, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this.__setNet = function(newNet) {
            return _this._network = $hRVdm(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $cGYI4();
        this._reactFlightPayloadDeserializer = reactFlightPayloadDeserializer;
        this._reactFlightServerErrorHandler = reactFlightServerErrorHandler;
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        // Register this Relay Environment with Relay DevTools if it exists.
        // Note: this must always be the last step in the constructor.
        $frXF3(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === "active";
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $hIn3L.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$5c44c35fa5be72ec$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $hIn3L.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $L6WFS.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $5c44c35fa5be72ec$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $5c44c35fa5be72ec$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $5c44c35fa5be72ec$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    } /**
   * Returns an Observable of GraphQLResponse resulting from executing the
   * provided Query operation, each result of which is then
   * normalized and committed to the publish queue.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to: environment.execute({...}).subscribe({...}).
   */ ;
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    } /**
   * Returns an Observable of GraphQLResponse resulting from executing the
   * provided Subscription operation, each result of which is then
   * normalized and committed to the publish queue.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to: environment.execute({...}).subscribe({...}).
   */ ;
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    } /**
   * Returns an Observable of GraphQLResponse resulting from executing the
   * provided Mutation operation, the result of which is then normalized and
   * committed to the publish queue along with an optional optimistic response
   * or updater.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to:
   * environment.executeMutation({...}).subscribe({...}).
   */ ;
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $5c44c35fa5be72ec$var$_objectSpread2["default"])((0, $5c44c35fa5be72ec$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    } /**
   * Returns an Observable of GraphQLResponse resulting from executing the
   * provided Query or Subscription operation responses, the result of which is
   * then normalized and committed to the publish queue.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to:
   * environment.executeWithSource({...}).subscribe({...}).
   */ ;
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : "", ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $hIn3L.create(function(sink) {
            var executor = $fziBd.execute({
                actorIdentifier: $5c44c35fa5be72ec$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $5c44c35fa5be72ec$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                reactFlightPayloadDeserializer: _this10._reactFlightPayloadDeserializer,
                reactFlightServerErrorHandler: _this10._reactFlightServerErrorHandler,
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                // NOTE: Some product tests expect `Network.execute` to be called only
                //       when the Observable is executed.
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $5c44c35fa5be72ec$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $5c44c35fa5be72ec$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === "Operation" && operation.root.node.clientAbstractTypes != null;
}
// Add a sigil for detection by `isRelayModernEnvironment()` to avoid a
// realm-specific instanceof check, and to aid in module tree-shaking to
// avoid requiring all of RelayRuntime just to detect its environment.
$5c44c35fa5be72ec$var$RelayModernEnvironment.prototype["@@RelayModernEnvironment"] = true;
function $5c44c35fa5be72ec$var$emptyFunction() {}
module.exports = $5c44c35fa5be72ec$var$RelayModernEnvironment;

});
parcelRegister("lbx0y", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aaXwj = parcelRequire("aaXwj");
var $f6c43abf5dba782e$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = "INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE";
function $f6c43abf5dba782e$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $f6c43abf5dba782e$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $aaXwj(false);
}
module.exports = {
    assertInternalActorIdentifier: $f6c43abf5dba782e$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error("Not Implemented");
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $f6c43abf5dba782e$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});

parcelRegister("hRVdm", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $8d9GR = parcelRequire("8d9GR");
/**
 * Wraps the network with logging to ensure that network requests are
 * always logged. Relying on each network callsite to be wrapped is
 * untenable and will eventually lead to holes in the logging.
 * NOTE: This function takes an environment instance, because Relay
 * devtools will mutate the `env.__log` method, and the devtools rely
 * on it to receive network events.
 */ function $d023c481fc97ad8a$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = $8d9GR();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: "network.start",
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: "network.next",
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: "network.error",
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: "network.complete",
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: "network.unsubscribe",
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: "network.info",
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
module.exports = $d023c481fc97ad8a$var$wrapNetworkWithLogObserver;

});
parcelRegister("8d9GR", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $5fa70df10d32675b$var$id = 100000;
function $5fa70df10d32675b$var$generateID() {
    return $5fa70df10d32675b$var$id++;
}
module.exports = $5fa70df10d32675b$var$generateID;

});


parcelRegister("cGYI4", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $93d87ff7f5810dab$var$_interopRequireDefault = $1jnue.default;

var $93d87ff7f5810dab$var$_createForOfIteratorHelper2 = $93d87ff7f5810dab$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $aaXwj = parcelRequire("aaXwj");
var $93d87ff7f5810dab$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    /**
   * Update the map of current processing operations with the set of
   * affected owners and notify subscribers
   */ var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) // In this case the `ownerIdentifier` already affected by some operations
                // We just need to detect, is it the same operation that we already
                // have in the list, or it's a new operation
                {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    // This is a new `ownerIdentifier` that is affected by the operation
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        // No new owners were affected by this operation, we may stop here
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        // But, if some owners were affected we need to add them to
        // the `_pendingOperationsToOwners` set
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    } /**
   * Once pending operation is completed we need to remove it
   * from all tracking maps
   */ ;
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        // These were the owners affected only by `pendingOperationIdentifier`
        var completedOwnersIdentifier = new Set();
        // These were the owners affected by `pendingOperationIdentifier`
        // and some other operations
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        // Complete subscriptions for all owners, affected by `pendingOperationIdentifier`
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        // Update all ownerIdentifier that were updated by `pendingOperationIdentifier` but still
        // are affected by other operations
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $93d87ff7f5810dab$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        // Finally, remove pending operation identifier
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $aaXwj(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $93d87ff7f5810dab$var$RelayOperationTracker;

});

parcelRegister("frXF3", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
function $b3f7a81de500bc6e$var$registerEnvironmentWithDevTools(environment) {
    // Register this Relay Environment with Relay DevTools if it exists.
    // Note: this must always be the last step in the constructor.
    var _global = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $b3f7a81de500bc6e$var$registerEnvironmentWithDevTools;

});

parcelRegister("aNE7V", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $2DcyS = parcelRequire("2DcyS");
var $7dcd9b58ce562edd$var$VIEWER_ID = $2DcyS.VIEWER_ID, $7dcd9b58ce562edd$var$VIEWER_TYPE = $2DcyS.VIEWER_TYPE;
function $7dcd9b58ce562edd$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $7dcd9b58ce562edd$var$VIEWER_TYPE) return fieldValue.id == null ? $7dcd9b58ce562edd$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $7dcd9b58ce562edd$var$defaultGetDataID;

});
parcelRegister("2DcyS", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $i2E13 = parcelRequire("i2E13");
var $1ea8f7bea0f67876$var$generateClientID = $i2E13.generateClientID;

var $5DrBw = parcelRequire("5DrBw");
var $1ea8f7bea0f67876$var$ROOT_ID = $5DrBw.ROOT_ID;
var $1ea8f7bea0f67876$var$VIEWER_ID = $1ea8f7bea0f67876$var$generateClientID($1ea8f7bea0f67876$var$ROOT_ID, "viewer");
var $1ea8f7bea0f67876$var$VIEWER_TYPE = "Viewer";
module.exports = {
    VIEWER_ID: $1ea8f7bea0f67876$var$VIEWER_ID,
    VIEWER_TYPE: $1ea8f7bea0f67876$var$VIEWER_TYPE
};

});


parcelRegister("9YoSM", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $742d04d35d97ad69$var$defaultRequiredFieldLogger = function defaultRequiredFieldLogger(event) {};
module.exports = $742d04d35d97ad69$var$defaultRequiredFieldLogger;

});

parcelRegister("fziBd", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $b5588d4de8532a6d$var$_interopRequireDefault = $1jnue.default;

var $b5588d4de8532a6d$var$_objectSpread2 = $b5588d4de8532a6d$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $b5588d4de8532a6d$var$_createForOfIteratorHelper2 = $b5588d4de8532a6d$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $b5588d4de8532a6d$var$_defineProperty2 = $b5588d4de8532a6d$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $b5588d4de8532a6d$var$_toConsumableArray2 = $b5588d4de8532a6d$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $hIn3L = parcelRequire("hIn3L");

var $8d9GR = parcelRequire("8d9GR");

var $dLcej = parcelRequire("dLcej");

var $ii2WU = parcelRequire("ii2WU");

var $dsOUI = parcelRequire("dsOUI");

var $8Q6tr = parcelRequire("8Q6tr");

var $8gN8q = parcelRequire("8gN8q");

var $i2E13 = parcelRequire("i2E13");
var $b5588d4de8532a6d$var$generateClientID = $i2E13.generateClientID, $b5588d4de8532a6d$var$generateUniqueClientID = $i2E13.generateUniqueClientID;

var $fkd0X = parcelRequire("fkd0X");
var $b5588d4de8532a6d$var$getLocalVariables = $fkd0X.getLocalVariables;

var $iEVza = parcelRequire("iEVza");

var $idJ2w = parcelRequire("idJ2w");
var $b5588d4de8532a6d$var$createNormalizationSelector = $idJ2w.createNormalizationSelector, $b5588d4de8532a6d$var$createReaderSelector = $idJ2w.createReaderSelector;

var $L6WFS = parcelRequire("L6WFS");

var $gDmh2 = parcelRequire("gDmh2");

var $5DrBw = parcelRequire("5DrBw");
var $b5588d4de8532a6d$var$ROOT_TYPE = $5DrBw.ROOT_TYPE, $b5588d4de8532a6d$var$TYPENAME_KEY = $5DrBw.TYPENAME_KEY, $b5588d4de8532a6d$var$getStorageKey = $5DrBw.getStorageKey;

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $b5588d4de8532a6d$var$execute(config) {
    return new $b5588d4de8532a6d$var$Executor(config);
}
/**
 * Coordinates the execution of a query, handling network callbacks
 * including optimistic payloads, standard payloads, resolution of match
 * dependencies, etc.
 */ var $b5588d4de8532a6d$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, _reactFlightPayloadDeserializer = _ref2.reactFlightPayloadDeserializer, reactFlightServerErrorHandler = _ref2.reactFlightServerErrorHandler, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log;
        (0, $b5588d4de8532a6d$var$_defineProperty2["default"])(this, "_deserializeReactFlightPayloadWithLogging", function(tree) {
            var reactFlightPayloadDeserializer = _this._reactFlightPayloadDeserializer;
            !(typeof reactFlightPayloadDeserializer === "function") && $aaXwj(false);
            var _withDuration = $8gN8q(function() {
                return reactFlightPayloadDeserializer(tree);
            }), duration = _withDuration[0], result = _withDuration[1];
            _this._log({
                name: "execute.flight.payload_deserialize",
                executeId: _this._executeId,
                operationName: _this._operation.request.node.params.name,
                duration: duration
            });
            return result;
        });
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $8d9GR();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = "started";
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._reactFlightPayloadDeserializer = _reactFlightPayloadDeserializer;
        this._reactFlightServerErrorHandler = reactFlightServerErrorHandler;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === "subscription";
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        var id = this._nextSubscriptionId++;
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: "execute.start",
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    // Cancel any pending execution tasks and mark the executor as completed.
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === "completed") return;
        this._state = "completed";
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            // OK: run revert on cancel
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case "started":
                activeState = "active";
                break;
            case "loading_incremental":
                activeState = "active";
                break;
            case "completed":
                activeState = "inactive";
                break;
            case "loading_final":
                activeState = this._pendingModulePayloadsCount > 0 ? "active" : "inactive";
                break;
            default:
                this._state;
                $aaXwj(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $hIn3L.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                });
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: "execute.complete",
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: "execute.error",
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        this._schedule(function() {
            var _withDuration2 = $8gN8q(function() {
                _this4._handleNext(response);
                _this4._maybeCompleteSubscriptionOperationTracking();
            }), duration = _withDuration2[0];
            _this4._log({
                name: "execute.next",
                executeId: _this4._executeId,
                response: response,
                duration: duration
            });
        });
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty("errors")) // Skip extensions-only payloads
            return;
            else if (response.data == null) {
                // Error if any other payload in the batch is missing data, regardless of whether
                // it had `errors` or not.
                var errors = response.hasOwnProperty("errors") && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join("\n") : "(No errors)";
                var error = $ii2WU.create("RelayNetwork", "No data returned for operation `" + _this5._operation.request.node.params.name + "`, got error(s):\n" + messages + "\n\nSee the error `source` property for more information.");
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                // In V8, Error objects keep the closure scope chain alive until the
                // err.stack property is accessed.
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    } /**
   * This method return boolean to indicate if the optimistic
   * response has been handled
   */ ;
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $aaXwj(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== "started") $aaXwj(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === "completed") return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            // no results with data, nothing to process
            // this can occur with extensions-only payloads
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = "loading_final";
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        // Next, handle optimistic responses
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $b5588d4de8532a6d$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        // In theory this doesn't preserve the ordering of the batch.
        // The idea is that a batch is always:
        //  * at most one non-incremental payload
        //  * followed by zero or more incremental payloads
        // The non-incremental payload can appear if the server sends a batch
        // with the initial payload followed by some early-to-resolve incremental
        // payloads (although, can that even happen?)
        if (hasNonIncrementalResponses) {
            // For subscriptions, to avoid every new payload from overwriting existing
            // data from previous payloads, assign a unique rootID for every new
            // non-incremental payload.
            if (this._isSubscriptionOperation) {
                var nextID = $b5588d4de8532a6d$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $b5588d4de8532a6d$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $b5588d4de8532a6d$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            // We attach the id to allow the `requestSubscription` to read from the store using
            // the current id in its `onNext` callback
            if (responsesWithData[0].extensions == null) // $FlowFixMe[cannot-write]
            responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        // OK: run once after each new payload
        // If we have non-incremental responses, we passing `this._operation` to
        // the publish queue here, which will later be passed to the store (via
        // notify) to indicate that this operation caused the store to update
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $aaXwj(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = $b5588d4de8532a6d$var$normalizeResponse(response, this._operation.root, $b5588d4de8532a6d$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                reactFlightPayloadDeserializer: this._reactFlightPayloadDeserializer != null ? this._deserializeReactFlightPayloadWithLogging : null,
                reactFlightServerErrorHandler: this._reactFlightServerErrorHandler,
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            $b5588d4de8532a6d$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $L6WFS.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        // OK: only called on construction and when receiving an optimistic payload from network,
        // which doesn't fall-through to the regular next() handling
        this._runPublishQueue();
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case "ModuleImportPayload":
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case "ActorPayload":
                            break;
                        default:
                            followupPayload;
                            $aaXwj(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    } /**
   * Normalize Data for @module payload, and actor-specific payload
   */ ;
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === "SplitOperation" && followupPayload.kind === "ModuleImportPayload") variables = $b5588d4de8532a6d$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $b5588d4de8532a6d$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return $b5588d4de8532a6d$var$normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            reactFlightPayloadDeserializer: this._reactFlightPayloadDeserializer != null ? this._deserializeReactFlightPayloadWithLogging : null,
            reactFlightServerErrorHandler: this._reactFlightServerErrorHandler,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $dLcej(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $b5588d4de8532a6d$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        // $FlowFixMe[unused-promise]
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== "started") return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                // OK: always have to run() after an module import resolves async
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = $b5588d4de8532a6d$var$normalizeResponse(payloadPart, _this8._operation.root, $b5588d4de8532a6d$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                reactFlightPayloadDeserializer: _this8._reactFlightPayloadDeserializer != null ? _this8._deserializeReactFlightPayloadWithLogging : null,
                reactFlightServerErrorHandler: _this8._reactFlightServerErrorHandler,
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            return relayPayload;
        });
    } /**
   * Handles any follow-up actions for a Relay payload for @match, @defer,
   * and @stream directives.
   */ ;
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === "completed") return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? "loading_final" : "loading_incremental";
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== "loading_final";
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === "loading_final") {
                    // But eagerly process any deferred payloads
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === "defer") relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    } /**
   * Processes a ModuleImportPayload, asynchronously resolving the normalization
   * AST and using it to normalize the field data into a RelayResponsePayload.
   * The resulting payload may contain other incremental payloads (match,
   * defer, stream, etc); these are handled by calling
   * `_processPayloadFollowups()`.
   */ ;
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case "ModuleImportPayload":
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) // If the operation module is available synchronously, normalize the
                // data synchronously.
                this._processFollowupPayloadWithNormalizationNode(followupPayload, $dLcej(node));
                else {
                    // Otherwise load the operation module and schedule a task to normalize
                    // the data when the module is available.
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    // Observable.from(operationLoader.load()) wouldn't catch synchronous
                    // errors thrown by the load function, which is user-defined. Guard
                    // against that with Observable.from(new Promise(<work>)).
                    var networkObservable = $hIn3L.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $hIn3L.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $dLcej(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $dsOUI.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withDuration3 = $8gN8q(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                // OK: always have to run after an async module import resolves
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(// $FlowFixMe[incompatible-call] `shouldScheduleAsyncStoreUpdate` check should cover `null` case
                                                batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), duration = _withDuration3[0];
                                            _this10._log({
                                                name: "execute.async.module",
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case "ActorPayload":
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $aaXwj(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    } /**
   * The executor now knows that GraphQL responses are expected for a given
   * label/path:
   * - Store the placeholder in order to process any future responses that may
   *   arrive.
   * - Then process any responses that had already arrived.
   *
   * The placeholder contains the normalization selector, path (for nested
   * defer/stream), and other metadata used to normalize the incremental
   * response(s).
   */ ;
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        // Update the label => path => placeholder map
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join(".");
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === "response" ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: "placeholder",
            placeholder: placeholder
        });
        // Store references to the parent node to allow detecting concurrent
        // modifications to the parent before items arrive and to replay
        // handle field payloads to account for new information on source records.
        var parentID;
        if (placeholder.kind === "stream") parentID = placeholder.parentID;
        else if (placeholder.kind === "defer") parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $aaXwj(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $b5588d4de8532a6d$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return(// handlers applied to the streamed field itself
            fieldPayload.dataID === parentID || // handlers applied to a field on an ancestor object, where
            // ancestor.field links to the parent record (example: connections)
            fieldID === parentID);
        });
        // If an incremental payload exists for some id that record should also
        // exist.
        !(parentRecord != null) && $aaXwj(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            // If a previous entry exists, merge the previous/next records and
            // payloads together.
            nextParentRecord = $iEVza.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $b5588d4de8532a6d$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        // If there were any queued responses, process them now that placeholders
        // are in place
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    } /**
   * Lookup the placeholder the describes how to process an incremental
   * response, normalize/publish it, and process any nested defer/match/stream
   * metadata.
   */ ;
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf("$defer$") !== -1) {
                var pathKey = path.map(String).join(".");
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: "response",
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === "response") {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === "defer") && $aaXwj(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                // @stream payload path values end in the field name and item index,
                // but Relay records paths relative to the parent of the stream node:
                // therefore we strip the last two elements just to lookup the path
                // (the item index is used later to insert the element in the list)
                var _pathKey = path.slice(0, -2).map(String).join(".");
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: "response",
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === "response") {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === "stream") && $aaXwj(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = $b5588d4de8532a6d$var$normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            reactFlightPayloadDeserializer: this._reactFlightPayloadDeserializer != null ? this._deserializeReactFlightPayloadWithLogging : null,
            reactFlightServerErrorHandler: this._reactFlightServerErrorHandler,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        // Load the version of the parent record from which this incremental data
        // was derived
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $aaXwj(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $L6WFS.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    } /**
   * Process the data for one item in a @stream field.
   */ ;
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        // Find the LinkedField where @stream was applied
        var field = node.selections[0];
        !(field != null && field.kind === "LinkedField" && field.plural === true) && $aaXwj(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        // Publish the new item and update the parent record to set
        // field[index] = item *if* the parent record hasn't been concurrently
        // modified.
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) // parent has since been deleted, stream data is stale
            return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) // field has since been deleted, stream data is stale
            return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) // field has been modified by something other than this query,
            // stream data is stale
            return;
            // parent.field has not been concurrently modified:
            // update `parent.field[index] = item`
            var nextItems = (0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        // Now that the parent record has been updated to include the new item,
        // also update any handle fields that are derived from the parent record.
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $L6WFS.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !(typeof data === "object") && $aaXwj(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $b5588d4de8532a6d$var$getStorageKey(field, variables);
        // Load the version of the parent record from which this incremental data
        // was derived
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $aaXwj(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        // Load the field value (items) that were created by *this* query executor
        // in order to check if there has been any concurrent modifications by some
        // other operation.
        var prevIDs = $iEVza.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $aaXwj(false);
        // Determine the index in the field of the new item
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $aaXwj(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$b5588d4de8532a6d$var$TYPENAME_KEY];
        !(typeof typeName === "string") && $aaXwj(false);
        // Determine the __id of the new item: this must equal the value that would
        // be assigned had the item not been streamed
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : // Reuse previously generated client IDs
        $b5588d4de8532a6d$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === "string") && $aaXwj(false);
        // Build a selector to normalize the item data with
        var selector = $b5588d4de8532a6d$var$createNormalizationSelector(field, itemID, variables);
        // Update the cached version of the parent record to reflect the new item:
        // this is used when subsequent stream payloads arrive to see if there
        // have been concurrent modifications to the list
        var nextParentRecord = $iEVza.clone(parentRecord);
        var nextIDs = (0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $iEVza.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = $b5588d4de8532a6d$var$normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, $b5588d4de8532a6d$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            reactFlightPayloadDeserializer: this._reactFlightPayloadDeserializer != null ? this._deserializeReactFlightPayloadWithLogging : null,
            reactFlightServerErrorHandler: this._reactFlightServerErrorHandler,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $b5588d4de8532a6d$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $aaXwj(false);
        return operationLoader;
    };
    return Executor;
}();
function $b5588d4de8532a6d$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $aaXwj(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function $b5588d4de8532a6d$var$normalizeResponse(response, selector, typeName, options) {
    var _response$extensions3;
    var data = response.data, errors = response.errors;
    var source = $L6WFS.create();
    var record = $iEVza.create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $gDmh2.normalize(source, selector, data, options);
    return (0, $b5588d4de8532a6d$var$_objectSpread2["default"])((0, $b5588d4de8532a6d$var$_objectSpread2["default"])({}, relayPayload), {}, {
        errors: errors,
        isFinal: ((_response$extensions3 = response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_final) === true
    });
}
function $b5588d4de8532a6d$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($8Q6tr(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : ""; // null-check for flow
}
function $b5588d4de8532a6d$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $aaXwj(false);
}
module.exports = {
    execute: $b5588d4de8532a6d$var$execute
};

});
parcelRegister("dLcej", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $84X73 = parcelRequire("84X73");
var $a04926bca1273feb$var$REQUEST = $84X73.REQUEST, $a04926bca1273feb$var$SPLIT_OPERATION = $84X73.SPLIT_OPERATION;
/**
 * OperationLoaders can return either a NormalizationSplitOperation or
 * ConcreteRequest.
 */ function $a04926bca1273feb$var$getOperation(node) {
    switch(node.kind){
        case $a04926bca1273feb$var$REQUEST:
            return node.operation;
        case $a04926bca1273feb$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $a04926bca1273feb$var$getOperation;

});

parcelRegister("ii2WU", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
/**
 * @private
 */ function $d50c3210f90a2db7$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ] // skip frame (code=2) twice
    });
    // In V8, Error objects keep the closure scope chain alive until the
    // err.stack property is accessed.
    if (error.stack === undefined) // IE sets the stack only if error is thrown
    try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $d50c3210f90a2db7$var$createError.apply(void 0, [
            "error",
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $d50c3210f90a2db7$var$createError.apply(void 0, [
            "warn",
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("8gN8q", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $6055ee83fd5ed8c7$var$_window, $6055ee83fd5ed8c7$var$_window$performance;
var $6055ee83fd5ed8c7$var$isPerformanceNowAvailable = typeof window !== "undefined" && typeof (($6055ee83fd5ed8c7$var$_window = window) === null || $6055ee83fd5ed8c7$var$_window === void 0 ? void 0 : ($6055ee83fd5ed8c7$var$_window$performance = $6055ee83fd5ed8c7$var$_window.performance) === null || $6055ee83fd5ed8c7$var$_window$performance === void 0 ? void 0 : $6055ee83fd5ed8c7$var$_window$performance.now) === "function";
function $6055ee83fd5ed8c7$var$currentTimestamp() {
    if ($6055ee83fd5ed8c7$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $6055ee83fd5ed8c7$var$withDuration(cb) {
    var startTime = $6055ee83fd5ed8c7$var$currentTimestamp();
    var result = cb();
    return [
        $6055ee83fd5ed8c7$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $6055ee83fd5ed8c7$var$withDuration;

});

parcelRegister("iEVza", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $d9589ddf5ce64fbc$var$_interopRequireDefault = $1jnue.default;

var $d9589ddf5ce64fbc$var$_objectSpread2 = $d9589ddf5ce64fbc$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $7sl3K = parcelRequire("7sl3K");

var $i2E13 = parcelRequire("i2E13");
var $d9589ddf5ce64fbc$var$generateClientObjectClientID = $i2E13.generateClientObjectClientID, $d9589ddf5ce64fbc$var$isClientID = $i2E13.isClientID;

var $l1FnP = parcelRequire("l1FnP");
var $d9589ddf5ce64fbc$var$isSuspenseSentinel = $l1FnP.isSuspenseSentinel;

var $5DrBw = parcelRequire("5DrBw");
var $d9589ddf5ce64fbc$var$ACTOR_IDENTIFIER_KEY = $5DrBw.ACTOR_IDENTIFIER_KEY, $d9589ddf5ce64fbc$var$ID_KEY = $5DrBw.ID_KEY, $d9589ddf5ce64fbc$var$INVALIDATED_AT_KEY = $5DrBw.INVALIDATED_AT_KEY, $d9589ddf5ce64fbc$var$REF_KEY = $5DrBw.REF_KEY, $d9589ddf5ce64fbc$var$REFS_KEY = $5DrBw.REFS_KEY, $d9589ddf5ce64fbc$var$RELAY_RESOLVER_VALUE_KEY = $5DrBw.RELAY_RESOLVER_VALUE_KEY, $d9589ddf5ce64fbc$var$ROOT_ID = $5DrBw.ROOT_ID, $d9589ddf5ce64fbc$var$TYPENAME_KEY = $5DrBw.TYPENAME_KEY;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * @public
 *
 * Low-level record manipulation methods.
 *
 * A note about perf: we use long-hand property access rather than computed
 * properties in this file for speed ie.
 *
 *    const object = {};
 *    object[KEY] = value;
 *    record[storageKey] = object;
 *
 * instead of:
 *
 *    record[storageKey] = {
 *      [KEY]: value,
 *    };
 *
 * The latter gets transformed by Babel into something like:
 *
 *    function _defineProperty(obj, key, value) {
 *      if (key in obj) {
 *        Object.defineProperty(obj, key, {
 *          value: value,
 *          enumerable: true,
 *          configurable: true,
 *          writable: true,
 *        });
 *      } else {
 *        obj[key] = value;
 *      }
 *      return obj;
 *    }
 *
 *    record[storageKey] = _defineProperty({}, KEY, value);
 *
 * A quick benchmark shows that computed property access is an order of
 * magnitude slower (times in seconds for 100,000 iterations):
 *
 *               best     avg     sd
 *    computed 0.02175 0.02292 0.00113
 *      manual 0.00110 0.00123 0.00008
 */ /**
 * @public
 *
 * Clone a record.
 */ function $d9589ddf5ce64fbc$var$clone(record) {
    return (0, $d9589ddf5ce64fbc$var$_objectSpread2["default"])({}, record);
}
/**
 * @public
 *
 * Copies all fields from `source` to `sink`, excluding `__id` and `__typename`.
 *
 * NOTE: This function does not treat `id` specially. To preserve the id,
 * manually reset it after calling this function. Also note that values are
 * copied by reference and not value; callers should ensure that values are
 * copied on write.
 */ function $d9589ddf5ce64fbc$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $d9589ddf5ce64fbc$var$ID_KEY && key !== $d9589ddf5ce64fbc$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
/**
 * @public
 *
 * Create a new record.
 */ function $d9589ddf5ce64fbc$var$create(dataID, typeName) {
    // See perf note above for why we aren't using computed property access.
    var record = {};
    record[$d9589ddf5ce64fbc$var$ID_KEY] = dataID;
    record[$d9589ddf5ce64fbc$var$TYPENAME_KEY] = typeName;
    return record;
}
/**
 * @public
 *
 * Get the record's `id` if available or the client-generated identifier.
 */ function $d9589ddf5ce64fbc$var$getDataID(record) {
    return record[$d9589ddf5ce64fbc$var$ID_KEY];
}
/**
 * @public
 *
 * Get the concrete type of the record.
 */ function $d9589ddf5ce64fbc$var$getType(record) {
    return record[$d9589ddf5ce64fbc$var$TYPENAME_KEY];
}
/**
 * @public
 *
 * Get a scalar (non-link) field value.
 */ function $d9589ddf5ce64fbc$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === "object") !(!value.hasOwnProperty($d9589ddf5ce64fbc$var$REF_KEY) && !value.hasOwnProperty($d9589ddf5ce64fbc$var$REFS_KEY)) && $aaXwj(false);
    return value;
}
/**
 * @public
 *
 * Get the value of a field as a reference to another record. Throws if the
 * field has a different type.
 */ function $d9589ddf5ce64fbc$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    // We reassign here so that the JSON.stringify call in invariant does not invalidate the
    // non-maybe refinement from above.
    var link = maybeLink;
    !(typeof link === "object" && link && typeof link[$d9589ddf5ce64fbc$var$REF_KEY] === "string") && $aaXwj(false);
    // $FlowFixMe[incompatible-return]
    return link[$d9589ddf5ce64fbc$var$REF_KEY];
}
/**
 * @public
 *
 * Get the value of a field as a list of references to other records. Throws if
 * the field has a different type.
 */ function $d9589ddf5ce64fbc$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === "object" && Array.isArray(links[$d9589ddf5ce64fbc$var$REFS_KEY])) && $aaXwj(false);
    // assume items of the array are ids
    return links[$d9589ddf5ce64fbc$var$REFS_KEY];
}
/**
 * @public
 *
 * Returns the epoch at which the record was invalidated, if it
 * ever was; otherwise returns null;
 */ function $d9589ddf5ce64fbc$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$d9589ddf5ce64fbc$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== "number") // If the record has never been invalidated, it isn't stale.
    return null;
    return invalidatedAt;
}
/**
 * @public
 *
 * Compares the fields of a previous and new record, returning either the
 * previous record if all fields are equal or a new record (with merged fields)
 * if any fields have changed.
 */ function $d9589ddf5ce64fbc$var$update(prevRecord, nextRecord) {
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var updated = null;
    var keys = Object.keys(nextRecord);
    for(var ii = 0; ii < keys.length; ii++){
        var key = keys[ii];
        if (updated || !$ewhZB(prevRecord[key], nextRecord[key])) {
            updated = updated !== null ? updated : (0, $d9589ddf5ce64fbc$var$_objectSpread2["default"])({}, prevRecord);
            updated[key] = nextRecord[key];
        }
    }
    return updated !== null ? updated : prevRecord;
}
/**
 * @public
 *
 * Returns a new record with the contents of the given records. Fields in the
 * second record will overwrite identical fields in the first record.
 */ function $d9589ddf5ce64fbc$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    return (0, $d9589ddf5ce64fbc$var$_objectSpread2["default"])((0, $d9589ddf5ce64fbc$var$_objectSpread2["default"])({}, record1), record2);
}
/**
 * @public
 *
 * Prevent modifications to the record. Attempts to call `set*` functions on a
 * frozen record will fatal at runtime.
 */ function $d9589ddf5ce64fbc$var$freeze(record) {
    $7sl3K(record);
}
/**
 * @public
 *
 * Set the value of a storageKey to a scalar.
 */ function $d9589ddf5ce64fbc$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
/**
 * @public
 *
 * Set the value of a field to a reference to another record.
 */ function $d9589ddf5ce64fbc$var$setLinkedRecordID(record, storageKey, linkedID) {
    // See perf note above for why we aren't using computed property access.
    var link = {};
    link[$d9589ddf5ce64fbc$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
/**
 * @public
 *
 * Set the value of a field to a list of references other records.
 */ function $d9589ddf5ce64fbc$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    // See perf note above for why we aren't using computed property access.
    var links = {};
    links[$d9589ddf5ce64fbc$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
/**
 * @public
 *
 * Set the value of a field to a reference to another record in the actor specific store.
 */ function $d9589ddf5ce64fbc$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    // See perf note above for why we aren't using computed property access.
    var link = {};
    link[$d9589ddf5ce64fbc$var$REF_KEY] = linkedID;
    link[$d9589ddf5ce64fbc$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
/**
 * @public
 *
 * Get link to a record and the actor identifier for the store.
 */ function $d9589ddf5ce64fbc$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === "object" && typeof link[$d9589ddf5ce64fbc$var$REF_KEY] === "string" && link[$d9589ddf5ce64fbc$var$ACTOR_IDENTIFIER_KEY] != null) && $aaXwj(false);
    return [
        link[$d9589ddf5ce64fbc$var$ACTOR_IDENTIFIER_KEY],
        link[$d9589ddf5ce64fbc$var$REF_KEY]
    ];
}
function $d9589ddf5ce64fbc$var$getResolverLinkedRecordID(record, typeName) {
    var id = $d9589ddf5ce64fbc$var$getValue(record, $d9589ddf5ce64fbc$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $d9589ddf5ce64fbc$var$isSuspenseSentinel(id)) return null;
    // TODD: Deprecate client edges that return just id.
    if (typeof id === "object") id = id.id;
    !(typeof id === "string") && $aaXwj(false);
    return $d9589ddf5ce64fbc$var$generateClientObjectClientID(typeName, id);
}
function $d9589ddf5ce64fbc$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $d9589ddf5ce64fbc$var$getValue(record, $d9589ddf5ce64fbc$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $d9589ddf5ce64fbc$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $aaXwj(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        // TODD: Deprecate client edges that return just id.
        if (typeof id === "object") id = id.id;
        !(typeof id === "string") && $aaXwj(false);
        return $d9589ddf5ce64fbc$var$generateClientObjectClientID(typeName, id);
    });
}
module.exports = {
    clone: $d9589ddf5ce64fbc$var$clone,
    copyFields: $d9589ddf5ce64fbc$var$copyFields,
    create: $d9589ddf5ce64fbc$var$create,
    freeze: $d9589ddf5ce64fbc$var$freeze,
    getDataID: $d9589ddf5ce64fbc$var$getDataID,
    getInvalidationEpoch: $d9589ddf5ce64fbc$var$getInvalidationEpoch,
    getLinkedRecordID: $d9589ddf5ce64fbc$var$getLinkedRecordID,
    getLinkedRecordIDs: $d9589ddf5ce64fbc$var$getLinkedRecordIDs,
    getType: $d9589ddf5ce64fbc$var$getType,
    getValue: $d9589ddf5ce64fbc$var$getValue,
    merge: $d9589ddf5ce64fbc$var$merge,
    setValue: $d9589ddf5ce64fbc$var$setValue,
    setLinkedRecordID: $d9589ddf5ce64fbc$var$setLinkedRecordID,
    setLinkedRecordIDs: $d9589ddf5ce64fbc$var$setLinkedRecordIDs,
    update: $d9589ddf5ce64fbc$var$update,
    getActorLinkedRecordID: $d9589ddf5ce64fbc$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $d9589ddf5ce64fbc$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $d9589ddf5ce64fbc$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $d9589ddf5ce64fbc$var$getResolverLinkedRecordIDs
};

});
parcelRegister("l1FnP", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $f4e9cad1aec721eb$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $f4e9cad1aec721eb$var$suspenseSentinel() {
    // $FlowFixMe[incompatible-return]
    return $f4e9cad1aec721eb$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $f4e9cad1aec721eb$var$isSuspenseSentinel(value) {
    return value === $f4e9cad1aec721eb$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $f4e9cad1aec721eb$var$isSuspenseSentinel,
    suspenseSentinel: $f4e9cad1aec721eb$var$suspenseSentinel
};

});


parcelRegister("L6WFS", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $08d9c71b03d8ee3d$var$_interopRequireDefault = $1jnue.default;

var $08d9c71b03d8ee3d$var$_createForOfIteratorHelper2 = $08d9c71b03d8ee3d$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $bZtyP = parcelRequire("bZtyP");
var $08d9c71b03d8ee3d$var$EXISTENT = $bZtyP.EXISTENT, $08d9c71b03d8ee3d$var$NONEXISTENT = $bZtyP.NONEXISTENT, $08d9c71b03d8ee3d$var$UNKNOWN = $bZtyP.UNKNOWN;
/**
 * An implementation of the `MutableRecordSource` interface (defined in
 * `RelayStoreTypes`) that holds all records in memory (JS Map).
 */ var $08d9c71b03d8ee3d$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            _this._records.set(key, records[key]);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $08d9c71b03d8ee3d$var$UNKNOWN;
        return this._records.get(dataID) == null ? $08d9c71b03d8ee3d$var$NONEXISTENT : $08d9c71b03d8ee3d$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $08d9c71b03d8ee3d$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
                obj[key] = value;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $08d9c71b03d8ee3d$var$RelayRecordSource;

});
parcelRegister("bZtyP", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $8bac5257a9f264bc$var$RelayRecordState = {
    /**
   * Record exists (either fetched from the server or produced by a local,
   * optimistic update).
   */ EXISTENT: "EXISTENT",
    /**
   * Record is known not to exist (either as the result of a mutation, or
   * because the server returned `null` when queried for the record).
   */ NONEXISTENT: "NONEXISTENT",
    /**
   * Record State is unknown because it has not yet been fetched from the
   * server.
   */ UNKNOWN: "UNKNOWN"
};
module.exports = $8bac5257a9f264bc$var$RelayRecordState;

});


parcelRegister("gDmh2", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $c1c190f56a797e52$var$_interopRequireDefault = $1jnue.default;

var $c1c190f56a797e52$var$_createForOfIteratorHelper2 = $c1c190f56a797e52$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $c1c190f56a797e52$var$_toConsumableArray2 = $c1c190f56a797e52$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $5hGP9 = parcelRequire("5hGP9");
var $c1c190f56a797e52$var$ACTOR_IDENTIFIER_FIELD_NAME = $5hGP9.ACTOR_IDENTIFIER_FIELD_NAME, $c1c190f56a797e52$var$getActorIdentifierFromPayload = $5hGP9.getActorIdentifierFromPayload;

var $84X73 = parcelRequire("84X73");
var $c1c190f56a797e52$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $c1c190f56a797e52$var$CLIENT_COMPONENT = $84X73.CLIENT_COMPONENT, $c1c190f56a797e52$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $c1c190f56a797e52$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $c1c190f56a797e52$var$CONDITION = $84X73.CONDITION, $c1c190f56a797e52$var$DEFER = $84X73.DEFER, $c1c190f56a797e52$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $c1c190f56a797e52$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $c1c190f56a797e52$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $c1c190f56a797e52$var$LINKED_FIELD = $84X73.LINKED_FIELD, $c1c190f56a797e52$var$LINKED_HANDLE = $84X73.LINKED_HANDLE, $c1c190f56a797e52$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $c1c190f56a797e52$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $c1c190f56a797e52$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $c1c190f56a797e52$var$SCALAR_HANDLE = $84X73.SCALAR_HANDLE, $c1c190f56a797e52$var$STREAM = $84X73.STREAM, $c1c190f56a797e52$var$TYPE_DISCRIMINATOR = $84X73.TYPE_DISCRIMINATOR;

var $dsOUI = parcelRequire("dsOUI");

var $i2E13 = parcelRequire("i2E13");
var $c1c190f56a797e52$var$generateClientID = $i2E13.generateClientID, $c1c190f56a797e52$var$isClientID = $i2E13.isClientID;

var $fkd0X = parcelRequire("fkd0X");
var $c1c190f56a797e52$var$getLocalVariables = $fkd0X.getLocalVariables;

var $iEVza = parcelRequire("iEVza");

var $idJ2w = parcelRequire("idJ2w");
var $c1c190f56a797e52$var$createNormalizationSelector = $idJ2w.createNormalizationSelector;

var $53GBi = parcelRequire("53GBi");
var $c1c190f56a797e52$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY = $53GBi.REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY, $c1c190f56a797e52$var$REACT_FLIGHT_TREE_STORAGE_KEY = $53GBi.REACT_FLIGHT_TREE_STORAGE_KEY, $c1c190f56a797e52$var$REACT_FLIGHT_TYPE_NAME = $53GBi.REACT_FLIGHT_TYPE_NAME, $c1c190f56a797e52$var$refineToReactFlightPayloadData = $53GBi.refineToReactFlightPayloadData;

var $5DrBw = parcelRequire("5DrBw");
var $c1c190f56a797e52$var$ROOT_ID = $5DrBw.ROOT_ID, $c1c190f56a797e52$var$ROOT_TYPE = $5DrBw.ROOT_TYPE, $c1c190f56a797e52$var$TYPENAME_KEY = $5DrBw.TYPENAME_KEY, $c1c190f56a797e52$var$getArgumentValues = $5DrBw.getArgumentValues, $c1c190f56a797e52$var$getHandleStorageKey = $5DrBw.getHandleStorageKey, $c1c190f56a797e52$var$getModuleComponentKey = $5DrBw.getModuleComponentKey, $c1c190f56a797e52$var$getModuleOperationKey = $5DrBw.getModuleOperationKey, $c1c190f56a797e52$var$getStorageKey = $5DrBw.getStorageKey;

var $kRPAW = parcelRequire("kRPAW");
var $c1c190f56a797e52$var$TYPE_SCHEMA_TYPE = $kRPAW.TYPE_SCHEMA_TYPE, $c1c190f56a797e52$var$generateTypeID = $kRPAW.generateTypeID;
parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
/**
 * Normalizes the results of a query and standard GraphQL response, writing the
 * normalized records/fields into the given MutableRecordSource.
 */ function $c1c190f56a797e52$var$normalize(recordSource, selector, response, options) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $c1c190f56a797e52$var$RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response);
}
/**
 * @private
 *
 * Helper for handling payloads.
 */ var $c1c190f56a797e52$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._reactFlightPayloadDeserializer = options.reactFlightPayloadDeserializer;
        this._reactFlightServerErrorHandler = options.reactFlightServerErrorHandler;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data) {
        var record = this._recordSource.get(dataID);
        !record && $aaXwj(false);
        this._assignClientAbstractTypes(node);
        this._traverseSelections(node, record, data);
        return {
            errors: null,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $c1c190f56a797e52$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $c1c190f56a797e52$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $iEVza.create(typeID, $c1c190f56a797e52$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $iEVza.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$c1c190f56a797e52$var$TYPENAME_KEY];
        !(typeName != null) && $aaXwj(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case $c1c190f56a797e52$var$SCALAR_FIELD:
                case $c1c190f56a797e52$var$LINKED_FIELD:
                    this._normalizeField(node, selection, record, data);
                    break;
                case $c1c190f56a797e52$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case $c1c190f56a797e52$var$FRAGMENT_SPREAD:
                    var prevVariables = this._variables;
                    this._variables = $c1c190f56a797e52$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case $c1c190f56a797e52$var$INLINE_FRAGMENT:
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $iEVza.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = $iEVza.getType(record);
                        var typeID = $c1c190f56a797e52$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $iEVza.create(typeID, $c1c190f56a797e52$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $iEVza.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case $c1c190f56a797e52$var$TYPE_DISCRIMINATOR:
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = $iEVza.getType(record);
                    var _typeID = $c1c190f56a797e52$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $iEVza.create(_typeID, $c1c190f56a797e52$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $iEVza.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case $c1c190f56a797e52$var$LINKED_HANDLE:
                case $c1c190f56a797e52$var$SCALAR_HANDLE:
                    var args = selection.args ? $c1c190f56a797e52$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $c1c190f56a797e52$var$getStorageKey(selection, this._variables);
                    var handleKey = $c1c190f56a797e52$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $iEVza.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $c1c190f56a797e52$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case $c1c190f56a797e52$var$MODULE_IMPORT:
                    this._normalizeModuleImport(node, selection, record, data);
                    break;
                case $c1c190f56a797e52$var$DEFER:
                    this._normalizeDefer(selection, record, data);
                    break;
                case $c1c190f56a797e52$var$STREAM:
                    this._normalizeStream(selection, record, data);
                    break;
                case $c1c190f56a797e52$var$CLIENT_EXTENSION:
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case $c1c190f56a797e52$var$CLIENT_COMPONENT:
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case $c1c190f56a797e52$var$FLIGHT_FIELD:
                    if ($dsOUI.ENABLE_REACT_FLIGHT_COMPONENT_FIELD) this._normalizeFlightField(node, selection, record, data);
                    else throw new Error("Flight fields are not yet supported.");
                    break;
                case $c1c190f56a797e52$var$ACTOR_CHANGE:
                    this._normalizeActorChange(node, selection, record, data);
                    break;
                case $c1c190f56a797e52$var$RELAY_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $c1c190f56a797e52$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) // If defer is disabled there will be no additional response chunk:
        // normalize the data already present.
        this._traverseSelections(defer, record, data);
        else // Otherwise data *for this selection* should not be present: enqueue
        // metadata to process the subsequent response chunk.
        this._incrementalPlaceholders.push({
            kind: "defer",
            data: data,
            label: defer.label,
            path: (0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(this._path),
            selector: $c1c190f56a797e52$var$createNormalizationSelector(defer, $iEVza.getDataID(record), this._variables),
            typeName: $iEVza.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        // Always normalize regardless of whether streaming is enabled or not,
        // this populates the initial array value (including any items when
        // initial_count > 0).
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) // If streaming is enabled, *also* emit metadata to process any
        // response chunks that may be delivered.
        this._incrementalPlaceholders.push({
            kind: "stream",
            label: stream.label,
            path: (0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(this._path),
            parentID: $iEVza.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(parent, moduleImport, record, data) {
        !(typeof data === "object" && data) && $aaXwj(false);
        var typeName = $iEVza.getType(record);
        var componentKey = $c1c190f56a797e52$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $iEVza.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $c1c190f56a797e52$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $iEVza.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: "ModuleImportPayload",
            args: moduleImport.args,
            data: data,
            dataID: $iEVza.getDataID(record),
            operationReference: operationReference,
            path: (0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(parent, selection, record, data) {
        !(typeof data === "object" && data) && $aaXwj(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $c1c190f56a797e52$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                // Fields may be missing in the response in two main cases:
                // - Inside a client extension: the server will not generally return
                //   values for these fields, but a local update may provide them.
                // - Inside an abstract type refinement where the concrete type does
                //   not conform to the interface/union.
                // However an otherwise-required field may also be missing if the server
                // is configured to skip fields with `null` values, in which case the
                // client is assumed to be correctly configured with
                // treatMissingFieldsAsNull=true.
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) // Field not expected to exist regardless of whether the server is pruning null
                // fields or not.
                return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $iEVza.setValue(record, storageKey, null);
            return;
        }
        if (selection.kind === $c1c190f56a797e52$var$SCALAR_FIELD) $iEVza.setValue(record, storageKey, fieldValue);
        else if (selection.kind === $c1c190f56a797e52$var$LINKED_FIELD) {
            this._path.push(responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._path.pop();
        } else {
            selection;
            $aaXwj(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(parent, selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === "object" && data) && $aaXwj(false);
        var responseKey = field.alias || field.name;
        var storageKey = $c1c190f56a797e52$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $iEVza.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $c1c190f56a797e52$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $iEVza.setValue(record, storageKey, null);
            return;
        }
        // $FlowFixMe[incompatible-call]
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(// $FlowFixMe[incompatible-call]
        fieldValue, typeName) || $iEVza.getLinkedRecordID(record, storageKey) || $c1c190f56a797e52$var$generateClientID($iEVza.getDataID(record), storageKey);
        !(typeof nextID === "string") && $aaXwj(false);
        $iEVza.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: "ActorPayload",
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $c1c190f56a797e52$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeFlightField = function _normalizeFlightField(parent, selection, record, data) {
        var responseKey = selection.alias || selection.name;
        var storageKey = $c1c190f56a797e52$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                // Flight field may be missing in the response if:
                // - It is inside an abstract type refinement where the concrete type does
                //   not conform to the interface/union.
                // However an otherwise-required field may also be missing if the server
                // is configured to skip fields with `null` values, in which case the
                // client is assumed to be correctly configured with
                // treatMissingFieldsAsNull=true.
                if (this._isUnmatchedAbstractType) // Field not expected to exist regardless of whether the server is pruning null
                // fields or not.
                return;
                else // Not optional and the server is not pruning null fields: field is expected
                // to be present
                !this._treatMissingFieldsAsNull && $aaXwj(false);
            }
            $iEVza.setValue(record, storageKey, null);
            return;
        }
        var reactFlightPayload = $c1c190f56a797e52$var$refineToReactFlightPayloadData(fieldValue);
        var reactFlightPayloadDeserializer = this._reactFlightPayloadDeserializer;
        !(reactFlightPayload != null) && $aaXwj(false);
        !(typeof reactFlightPayloadDeserializer === "function") && $aaXwj(false);
        if (reactFlightPayload.errors.length > 0) {
            if (typeof this._reactFlightServerErrorHandler === "function") this._reactFlightServerErrorHandler(reactFlightPayload.status, reactFlightPayload.errors);
        }
        var reactFlightID = $c1c190f56a797e52$var$generateClientID($iEVza.getDataID(record), $c1c190f56a797e52$var$getStorageKey(selection, this._variables));
        var reactFlightClientResponseRecord = this._recordSource.get(reactFlightID);
        if (reactFlightClientResponseRecord == null) {
            reactFlightClientResponseRecord = $iEVza.create(reactFlightID, $c1c190f56a797e52$var$REACT_FLIGHT_TYPE_NAME);
            this._recordSource.set(reactFlightID, reactFlightClientResponseRecord);
        }
        if (reactFlightPayload.tree == null) {
            // We create the flight record with a null value for the tree
            // and empty reachable definitions
            $iEVza.setValue(reactFlightClientResponseRecord, $c1c190f56a797e52$var$REACT_FLIGHT_TREE_STORAGE_KEY, null);
            $iEVza.setValue(reactFlightClientResponseRecord, $c1c190f56a797e52$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY, []);
            $iEVza.setLinkedRecordID(record, storageKey, reactFlightID);
            return;
        }
        // We store the deserialized reactFlightClientResponse in a separate
        // record and link it to the parent record. This is so we can GC the Flight
        // tree later even if the parent record is still reachable.
        var reactFlightClientResponse = reactFlightPayloadDeserializer(reactFlightPayload.tree);
        $iEVza.setValue(reactFlightClientResponseRecord, $c1c190f56a797e52$var$REACT_FLIGHT_TREE_STORAGE_KEY, reactFlightClientResponse);
        var reachableExecutableDefinitions = [];
        var _iterator2 = (0, $c1c190f56a797e52$var$_createForOfIteratorHelper2["default"])(reactFlightPayload.queries), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var query = _step2.value;
                if (query.response.data != null) this._followupPayloads.push({
                    kind: "ModuleImportPayload",
                    args: null,
                    data: query.response.data,
                    dataID: $c1c190f56a797e52$var$ROOT_ID,
                    operationReference: query.module,
                    path: [],
                    typeName: $c1c190f56a797e52$var$ROOT_TYPE,
                    variables: query.variables,
                    actorIdentifier: this._actorIdentifier
                });
                reachableExecutableDefinitions.push({
                    module: query.module,
                    variables: query.variables
                });
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        var _iterator3 = (0, $c1c190f56a797e52$var$_createForOfIteratorHelper2["default"])(reactFlightPayload.fragments), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var fragment = _step3.value;
                if (fragment.response.data != null) this._followupPayloads.push({
                    kind: "ModuleImportPayload",
                    args: null,
                    data: fragment.response.data,
                    dataID: fragment.__id,
                    operationReference: fragment.module,
                    path: [],
                    typeName: fragment.__typename,
                    variables: fragment.variables,
                    actorIdentifier: this._actorIdentifier
                });
                reachableExecutableDefinitions.push({
                    module: fragment.module,
                    variables: fragment.variables
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        $iEVza.setValue(reactFlightClientResponseRecord, $c1c190f56a797e52$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY, reachableExecutableDefinitions);
        $iEVza.setLinkedRecordID(record, storageKey, reactFlightID);
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === "object" && fieldValue) && $aaXwj(false);
        var nextID = this._getDataId(// $FlowFixMe[incompatible-variance]
        fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || // Reuse previously generated client IDs
        $iEVza.getLinkedRecordID(record, storageKey) || $c1c190f56a797e52$var$generateClientID($iEVza.getDataID(record), storageKey);
        !(typeof nextID === "string") && $aaXwj(false);
        $iEVza.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            // $FlowFixMe[incompatible-variance]
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $iEVza.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        // $FlowFixMe[incompatible-variance]
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $aaXwj(false);
        var prevIDs = $iEVza.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            // validate response data
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            !(typeof item === "object") && $aaXwj(false);
            var nextID = _this._getDataId(// $FlowFixMe[incompatible-variance]
            item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || // Reuse previously generated client IDs:
            $c1c190f56a797e52$var$generateClientID($iEVza.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === "string") && $aaXwj(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                // $FlowFixMe[incompatible-variance]
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $iEVza.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            // $FlowFixMe[incompatible-variance]
            _this._traverseSelections(field, nextRecord, item);
            _this._path.pop();
        });
        $iEVza.setLinkedRecordIDs(record, storageKey, nextIDs);
    } /**
   * Warns if the type of the record does not match the type of the field/payload.
   */ ;
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = $iEVza.getDataID(record);
    } /**
   * Warns if a single response contains conflicting fields with the same id
   */ ;
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    } /**
   * Warns if a single response contains conflicting fields with the same id
   */ ;
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(record, prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $c1c190f56a797e52$var$normalize
};

});
parcelRegister("5hGP9", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $3d8fc23a57d7fcd6$var$ACTOR_IDENTIFIER_FIELD_NAME = "actor_key";

var $lbx0y = parcelRequire("lbx0y");
var $3d8fc23a57d7fcd6$var$getActorIdentifier = $lbx0y.getActorIdentifier;
function $3d8fc23a57d7fcd6$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === "object" && typeof payload[$3d8fc23a57d7fcd6$var$ACTOR_IDENTIFIER_FIELD_NAME] === "string") return $3d8fc23a57d7fcd6$var$getActorIdentifier(payload[$3d8fc23a57d7fcd6$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $3d8fc23a57d7fcd6$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $3d8fc23a57d7fcd6$var$getActorIdentifierFromPayload
};

});

parcelRegister("53GBi", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $iEVza = parcelRequire("iEVza");
var $3aee472679212327$var$getType = $iEVza.getType;

var $aaXwj = parcelRequire("aaXwj");
// Reachable (client) executable definitions encountered while server component
// rendering
var $3aee472679212327$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY = "executableDefinitions";
var $3aee472679212327$var$REACT_FLIGHT_TREE_STORAGE_KEY = "tree";
var $3aee472679212327$var$REACT_FLIGHT_TYPE_NAME = "ReactFlightComponent";
function $3aee472679212327$var$refineToReactFlightPayloadData(payload) {
    if (payload == null || typeof payload !== "object" || typeof payload.status !== "string" || !Array.isArray(payload.tree) && payload.tree !== null || !Array.isArray(payload.queries) || !Array.isArray(payload.fragments) || !Array.isArray(payload.errors)) return null;
    return payload;
}
function $3aee472679212327$var$getReactFlightClientResponse(record) {
    !($3aee472679212327$var$getType(record) === $3aee472679212327$var$REACT_FLIGHT_TYPE_NAME) && $aaXwj(false);
    return record[$3aee472679212327$var$REACT_FLIGHT_TREE_STORAGE_KEY];
}
module.exports = {
    REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY: $3aee472679212327$var$REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY,
    REACT_FLIGHT_TREE_STORAGE_KEY: $3aee472679212327$var$REACT_FLIGHT_TREE_STORAGE_KEY,
    REACT_FLIGHT_TYPE_NAME: $3aee472679212327$var$REACT_FLIGHT_TYPE_NAME,
    getReactFlightClientResponse: $3aee472679212327$var$getReactFlightClientResponse,
    refineToReactFlightPayloadData: $3aee472679212327$var$refineToReactFlightPayloadData
};

});

parcelRegister("kRPAW", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $f310c78a7436bcf6$var$PREFIX = "client:__type:";
var $f310c78a7436bcf6$var$TYPE_SCHEMA_TYPE = "__TypeSchema";
function $f310c78a7436bcf6$var$generateTypeID(typeName) {
    return $f310c78a7436bcf6$var$PREFIX + typeName;
}
function $f310c78a7436bcf6$var$isTypeID(id) {
    return id.indexOf($f310c78a7436bcf6$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $f310c78a7436bcf6$var$generateTypeID,
    isTypeID: $f310c78a7436bcf6$var$isTypeID,
    TYPE_SCHEMA_TYPE: $f310c78a7436bcf6$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("kkibE", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $ecc3c86f01f852a8$var$_global$ErrorUtils$ap, $ecc3c86f01f852a8$var$_global$ErrorUtils;

var $2Zzcm = parcelRequire("2Zzcm");

var $RmER8 = parcelRequire("RmER8");

var $h9Hf6 = parcelRequire("h9Hf6");

var $5WA3P = parcelRequire("5WA3P");

var $L6WFS = parcelRequire("L6WFS");

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
var $ecc3c86f01f852a8$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : undefined;
var $ecc3c86f01f852a8$var$applyWithGuard = ($ecc3c86f01f852a8$var$_global$ErrorUtils$ap = $ecc3c86f01f852a8$var$_global === null || $ecc3c86f01f852a8$var$_global === void 0 ? void 0 : ($ecc3c86f01f852a8$var$_global$ErrorUtils = $ecc3c86f01f852a8$var$_global.ErrorUtils) === null || $ecc3c86f01f852a8$var$_global$ErrorUtils === void 0 ? void 0 : $ecc3c86f01f852a8$var$_global$ErrorUtils.applyWithGuard) !== null && $ecc3c86f01f852a8$var$_global$ErrorUtils$ap !== void 0 ? $ecc3c86f01f852a8$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
/**
 * Coordinates the concurrent modification of a `Store` due to optimistic and
 * non-revertable client updates and server payloads:
 * - Applies optimistic updates.
 * - Reverts optimistic updates, rebasing any subsequent updates.
 * - Commits client updates (typically for client schema extensions).
 * - Commits server updates:
 *   - Normalizes query/mutation/subscription responses.
 *   - Executes handlers for "handle" fields.
 *   - Reverts and reapplies pending optimistic updates.
 */ var $ecc3c86f01f852a8$var$RelayPublishQueue = /*#__PURE__*/ function() {
    // True if the next `run()` should apply the backup and rerun all optimistic
    // updates performing a rebase.
    // Payloads to apply or Sources to publish to the store with the next `run()`.
    // $FlowFixMe[unclear-type] See explanation below.
    // Optimistic updaters to add with the next `run()`.
    // $FlowFixMe[unclear-type] See explanation below.
    // Optimistic updaters that are already added and might be rerun in order to
    // rebase them.
    // $FlowFixMe[unclear-type] See explanation below.
    // For _pendingOptimisticUpdates, _appliedOptimisticUpdates, and _pendingData,
    // we want to parametrize by "any" since the type is effectively
    // "the union of all T's that PublishQueue's methods were called with".
    // Garbage collection hold, should rerun gc on dispose
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    /**
   * Schedule applying an optimistic updates on the next `run()`.
   */ var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $aaXwj(false);
        this._pendingOptimisticUpdates.add(updater);
    } /**
   * Schedule reverting an optimistic updates on the next `run()`.
   */ ;
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) // Reverted before it was applied
        this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    } /**
   * Schedule a revert of all optimistic updates on the next `run()`.
   */ ;
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    } /**
   * Schedule applying a payload to the store on the next `run()`.
   */ ;
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: "payload",
            operation: operation,
            payload: payload,
            updater: updater
        });
    } /**
   * Schedule an updater to mutate the store on the next `run()` typically to
   * update client schema fields.
   */ ;
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: "updater",
            updater: updater
        });
    } /**
   * Schedule a publish to the store from the provided source on the next
   * `run()`. As an example, to update the store with substituted fields that
   * are missing in the store.
   */ ;
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: "source",
            source: source
        });
    } /**
   * Execute all queued up operations from the other public methods.
   */ ;
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = // this._pendingBackupRebase is true if an applied optimistic
        // update has potentially been reverted or if this._pendingData is not empty.
        !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    } /**
   * _publishSourceFromPayload will return a boolean indicating if the
   * publish caused the store to be globally invalidated.
   */ ;
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $2Zzcm(this._store.getSource(), source);
        var recordSourceProxy = new $RmER8(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $aaXwj(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $aaXwj(false);
            var recordSourceSelectorProxy = new $h9Hf6(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $ecc3c86f01f852a8$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    } /**
   * _commitData will return a boolean indicating if any of
   * the pending commits caused the store to be globally invalidated.
   */ ;
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === "payload") {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === "source") {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $L6WFS.create();
                var mutator = new $2Zzcm(_this2._store.getSource(), sink);
                var recordSourceProxy = new $RmER8(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                $ecc3c86f01f852a8$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, "RelayPublishQueue:commitData");
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    } /**
   * Note that unlike _commitData, _applyUpdates will NOT return a boolean
   * indicating if the store was globally invalidated, since invalidating the
   * store during an optimistic update is a no-op.
   */ ;
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $L6WFS.create();
        var mutator = new $2Zzcm(this._store.getSource(), sink);
        var recordSourceProxy = new $RmER8(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        // $FlowFixMe[unclear-type] see explanation above.
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $ecc3c86f01f852a8$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, "RelayPublishQueue:applyUpdates");
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $ecc3c86f01f852a8$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $h9Hf6(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $ecc3c86f01f852a8$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, "RelayPublishQueue:applyUpdates");
                }
            }
        };
        // rerun all updaters in case we are running a rebase
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        // apply any new updaters
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $ecc3c86f01f852a8$var$lookupSelector(source, selector) {
    var selectorData = $5WA3P.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $ecc3c86f01f852a8$var$RelayPublishQueue;

});
parcelRegister("2Zzcm", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $iEVza = parcelRequire("iEVza");

var $bZtyP = parcelRequire("bZtyP");
var $22dc94f00d1a854e$var$EXISTENT = $bZtyP.EXISTENT;

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * Wrapper API that is an amalgam of the `RelayModernRecord` API and
 * `MutableRecordSource` interface, implementing copy-on-write semantics for records
 * in a record source.
 *
 * Modifications are applied to fresh copies of records:
 * - Records in `base` are never modified.
 * - Modifications cause a fresh version of a record to be created in `sink`.
 *   These sink records contain only modified fields.
 */ var $22dc94f00d1a854e$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    /**
   * **UNSTABLE**
   * This method is likely to be removed in an upcoming release
   * and should not be relied upon.
   * TODO T41593196: Remove unstable_getRawRecordWithChanges
   */ var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $iEVza.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $iEVza.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $iEVza.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $aaXwj(false);
            sinkRecord = $iEVza.create(dataID, $iEVza.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $aaXwj(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $iEVza.copyFields(baseSource, sink);
        if (sinkSource) $iEVza.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $iEVza.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $22dc94f00d1a854e$var$EXISTENT && this._sink.getStatus(dataID) !== $22dc94f00d1a854e$var$EXISTENT) && $aaXwj(false);
        var record = $iEVza.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $iEVza.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $iEVza.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iEVza.setValue(sinkRecord, storageKey, value);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iEVza.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $iEVza.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iEVza.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $22dc94f00d1a854e$var$RelayRecordSourceMutator;

});

parcelRegister("RmER8", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $iEVza = parcelRequire("iEVza");

var $bZtyP = parcelRequire("bZtyP");
var $0a0686c092d9048b$var$EXISTENT = $bZtyP.EXISTENT, $0a0686c092d9048b$var$NONEXISTENT = $bZtyP.NONEXISTENT;

var $5DrBw = parcelRequire("5DrBw");
var $0a0686c092d9048b$var$ROOT_ID = $5DrBw.ROOT_ID, $0a0686c092d9048b$var$ROOT_TYPE = $5DrBw.ROOT_TYPE;

var $drJF0 = parcelRequire("drJF0");
var $0a0686c092d9048b$var$_readUpdatableFragment = $drJF0.readUpdatableFragment;

var $ah1KR = parcelRequire("ah1KR");
var $0a0686c092d9048b$var$_readUpdatableQuery = $ah1KR.readUpdatableQuery;

var $1ZqjF = parcelRequire("1ZqjF");

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * A helper for manipulating a `RecordSource` via an imperative/OO-style API.
 */ var $0a0686c092d9048b$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $0a0686c092d9048b$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $0a0686c092d9048b$var$EXISTENT) _this.create(dataID, $iEVza.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $0a0686c092d9048b$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $aaXwj(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        // For flow
        !record && $aaXwj(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $0a0686c092d9048b$var$ROOT_ID) && $aaXwj(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $0a0686c092d9048b$var$EXISTENT) this._proxies[dataID] = new $1ZqjF(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $0a0686c092d9048b$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($0a0686c092d9048b$var$ROOT_ID);
        if (!root) root = this.create($0a0686c092d9048b$var$ROOT_ID, $0a0686c092d9048b$var$ROOT_TYPE);
        !(root && root.getType() === $0a0686c092d9048b$var$ROOT_TYPE) && $aaXwj(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $0a0686c092d9048b$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $0a0686c092d9048b$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $0a0686c092d9048b$var$RelayRecordSourceProxy;

});
parcelRegister("drJF0", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $9ca1372eb2f8e38b$var$getFragment = $aW0zg.getFragment;

var $idJ2w = parcelRequire("idJ2w");
var $9ca1372eb2f8e38b$var$getVariablesFromFragment = $idJ2w.getVariablesFromFragment;

var $5DrBw = parcelRequire("5DrBw");
var $9ca1372eb2f8e38b$var$ID_KEY = $5DrBw.ID_KEY;

var $9hh34 = parcelRequire("9hh34");
var $9ca1372eb2f8e38b$var$createUpdatableProxy = $9hh34.createUpdatableProxy;

var $aaXwj = parcelRequire("aaXwj");
// Note: plural fragment references are currently not supported
function $9ca1372eb2f8e38b$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $9ca1372eb2f8e38b$var$getFragment(fragment);
    var fragmentVariables = $9ca1372eb2f8e38b$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    // $FlowFixMe[prop-missing] it's there, we just don't include it in the type
    var id = fragmentReference[$9ca1372eb2f8e38b$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $aaXwj(false);
    return {
        // $FlowFixMe[incompatible-call]
        updatableData: $9ca1372eb2f8e38b$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $9ca1372eb2f8e38b$var$readUpdatableFragment
};

});
parcelRegister("9hh34", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $6c12ed122216a4ab$var$_interopRequireDefault = $1jnue.default;

var $6c12ed122216a4ab$var$_createForOfIteratorHelper2 = $6c12ed122216a4ab$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $5DrBw = parcelRequire("5DrBw");
var $6c12ed122216a4ab$var$getArgumentValues = $5DrBw.getArgumentValues;

var $84X73 = parcelRequire("84X73");
var $6c12ed122216a4ab$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $6c12ed122216a4ab$var$ALIASED_FRAGMENT_SPREAD = $84X73.ALIASED_FRAGMENT_SPREAD, $6c12ed122216a4ab$var$ALIASED_INLINE_FRAGMENT_SPREAD = $84X73.ALIASED_INLINE_FRAGMENT_SPREAD, $6c12ed122216a4ab$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $6c12ed122216a4ab$var$CLIENT_EDGE_TO_SERVER_OBJECT = $84X73.CLIENT_EDGE_TO_SERVER_OBJECT, $6c12ed122216a4ab$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $6c12ed122216a4ab$var$CONDITION = $84X73.CONDITION, $6c12ed122216a4ab$var$DEFER = $84X73.DEFER, $6c12ed122216a4ab$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $6c12ed122216a4ab$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $6c12ed122216a4ab$var$INLINE_DATA_FRAGMENT_SPREAD = $84X73.INLINE_DATA_FRAGMENT_SPREAD, $6c12ed122216a4ab$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $6c12ed122216a4ab$var$LINKED_FIELD = $84X73.LINKED_FIELD, $6c12ed122216a4ab$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $6c12ed122216a4ab$var$RELAY_LIVE_RESOLVER = $84X73.RELAY_LIVE_RESOLVER, $6c12ed122216a4ab$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $6c12ed122216a4ab$var$REQUIRED_FIELD = $84X73.REQUIRED_FIELD, $6c12ed122216a4ab$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $6c12ed122216a4ab$var$STREAM = $84X73.STREAM;
var $6c12ed122216a4ab$var$nonUpdatableKeys = [
    "id",
    "__id",
    "__typename",
    "js"
];
function $6c12ed122216a4ab$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $6c12ed122216a4ab$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    // unless ReaderSelection carries more type information, we will never be able
    // to flowtype mutableUpdatableProxy without a type assertion.
    // $FlowFixMe[unclear-type]
    return mutableUpdatableProxy;
}
function $6c12ed122216a4ab$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $6c12ed122216a4ab$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case $6c12ed122216a4ab$var$LINKED_FIELD:
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $6c12ed122216a4ab$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $6c12ed122216a4ab$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $6c12ed122216a4ab$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $6c12ed122216a4ab$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case $6c12ed122216a4ab$var$SCALAR_FIELD:
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            // Flow incorrect assumes that the return value for the get method must match
                            // the set parameter.
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $6c12ed122216a4ab$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $6c12ed122216a4ab$var$nonUpdatableKeys.includes(selection.name) ? undefined : // $FlowFixMe[unclear-type] Typed by the generated updatable query flow type
                        function(newValue) {
                            var _selection$args2;
                            var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            // $FlowFixMe[prop-missing] Typesafe updaters should prevent people from using untyped values
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case $6c12ed122216a4ab$var$INLINE_FRAGMENT:
                    if (updatableProxyRootRecord.getType() === selection.type) $6c12ed122216a4ab$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $6c12ed122216a4ab$var$CLIENT_EXTENSION:
                    $6c12ed122216a4ab$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $6c12ed122216a4ab$var$FRAGMENT_SPREAD:
                    break;
                case $6c12ed122216a4ab$var$CONDITION:
                case $6c12ed122216a4ab$var$ACTOR_CHANGE:
                case $6c12ed122216a4ab$var$ALIASED_FRAGMENT_SPREAD:
                case $6c12ed122216a4ab$var$INLINE_DATA_FRAGMENT_SPREAD:
                case $6c12ed122216a4ab$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                case $6c12ed122216a4ab$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $6c12ed122216a4ab$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                case $6c12ed122216a4ab$var$DEFER:
                case $6c12ed122216a4ab$var$FLIGHT_FIELD:
                case $6c12ed122216a4ab$var$MODULE_IMPORT:
                case $6c12ed122216a4ab$var$RELAY_LIVE_RESOLVER:
                case $6c12ed122216a4ab$var$REQUIRED_FIELD:
                case $6c12ed122216a4ab$var$STREAM:
                case $6c12ed122216a4ab$var$RELAY_RESOLVER:
                    // These types of reader nodes are not currently handled.
                    throw new Error("Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.");
                default:
                    selection.kind;
                    throw new Error("Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.");
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $6c12ed122216a4ab$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error("Do not assign null to plural linked fields; assign an empty array instead.");
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error("When assigning an array of items, none of the items should be null or undefined.");
                var __id = item.__id;
                if (__id == null) throw new Error("The __id field must be present on each item passed to the setter. This indicates a bug in Relay.");
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $6c12ed122216a4ab$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error("The __id field must be present on the argument. This indicates a bug in Relay.");
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $6c12ed122216a4ab$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $6c12ed122216a4ab$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $6c12ed122216a4ab$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                // Flow incorrect assumes that the return value for the get method must match
                // the set parameter.
                // $FlowFixMe[unclear-type] Typed by the generated updatable query flow type
                return updatableProxy;
            } else return linkedRecord;
        // $FlowFixMe[unclear-type] Typed by the generated updatable query flow type
        });
        else return linkedRecords;
    };
}
function $6c12ed122216a4ab$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $6c12ed122216a4ab$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $6c12ed122216a4ab$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $6c12ed122216a4ab$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            // Flow incorrect assumes that the return value for the get method must match
            // the set parameter.
            // $FlowFixMe[unclear-type] Typed by the generated updatable query flow type
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $6c12ed122216a4ab$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $6c12ed122216a4ab$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === "linked") {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $6c12ed122216a4ab$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $6c12ed122216a4ab$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === "pluralLinked") {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $6c12ed122216a4ab$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $6c12ed122216a4ab$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === "scalar") {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $6c12ed122216a4ab$var$createUpdatableProxy
};

});


parcelRegister("ah1KR", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $77acda5d157b1b63$var$getUpdatableQuery = $aW0zg.getUpdatableQuery;

var $9hh34 = parcelRequire("9hh34");
var $77acda5d157b1b63$var$createUpdatableProxy = $9hh34.createUpdatableProxy;
function $77acda5d157b1b63$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $77acda5d157b1b63$var$getUpdatableQuery(query);
    return {
        // $FlowFixMe[incompatible-call]
        updatableData: $77acda5d157b1b63$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $77acda5d157b1b63$var$readUpdatableQuery
};

});

parcelRegister("1ZqjF", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $i2E13 = parcelRequire("i2E13");
var $172fe6c8479de1a6$var$generateClientID = $i2E13.generateClientID;

var $5DrBw = parcelRequire("5DrBw");
var $172fe6c8479de1a6$var$getStableStorageKey = $5DrBw.getStableStorageKey;

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * A helper class for manipulating a given record from a record source via an
 * imperative/OO-style API.
 */ var $172fe6c8479de1a6$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $aaXwj(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args) {
        !$172fe6c8479de1a6$var$isValidLeafValue(value) && $aaXwj(false);
        return this.setValue__UNSAFE(value, name, args);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args) {
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $aaXwj(false);
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
            var clientID = $172fe6c8479de1a6$var$generateClientID(this.getDataID(), storageKey);
            // NOTE: it's possible that a client record for this field exists
            // but the field itself was unset.
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $aaXwj(false);
        var storageKey = $172fe6c8479de1a6$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $172fe6c8479de1a6$var$isValidLeafValue(value) {
    return value == null || typeof value !== "object" || Array.isArray(value) && value.every($172fe6c8479de1a6$var$isValidLeafValue);
}
module.exports = $172fe6c8479de1a6$var$RelayRecordProxy;

});


parcelRegister("h9Hf6", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $5DrBw = parcelRequire("5DrBw");
var $c7d4d200cf928b69$var$ROOT_TYPE = $5DrBw.ROOT_TYPE, $c7d4d200cf928b69$var$getStorageKey = $5DrBw.getStorageKey;

var $drJF0 = parcelRequire("drJF0");
var $c7d4d200cf928b69$var$_readUpdatableFragment = $drJF0.readUpdatableFragment;

var $ah1KR = parcelRequire("ah1KR");
var $c7d4d200cf928b69$var$_readUpdatableQuery = $ah1KR.readUpdatableQuery;

var $aaXwj = parcelRequire("aaXwj");
/**
 * @internal
 *
 * A subclass of RecordSourceProxy that provides convenience methods for
 * accessing the root fields of a given query/mutation. These fields accept
 * complex arguments and it can be tedious to re-construct the correct sets of
 * arguments to pass to e.g. `getRoot().getLinkedRecord()`.
 */ var $c7d4d200cf928b69$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $c7d4d200cf928b69$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === "LinkedField" && selection.name === fieldName || selection.kind === "RequiredField" && selection.field.name === fieldName;
        });
        if (field && field.kind === "RequiredField") field = field.field;
        !(field && field.kind === "LinkedField") && $aaXwj(false);
        !(field.plural === plural) && $aaXwj(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $c7d4d200cf928b69$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $c7d4d200cf928b69$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $c7d4d200cf928b69$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $c7d4d200cf928b69$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $c7d4d200cf928b69$var$RelayRecordSourceSelectorProxy;

});

parcelRegister("5WA3P", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $453e576ecc8ee4b3$var$_interopRequireDefault = $1jnue.default;

var $453e576ecc8ee4b3$var$_createForOfIteratorHelper2 = $453e576ecc8ee4b3$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $453e576ecc8ee4b3$var$_defineProperty2 = $453e576ecc8ee4b3$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $453e576ecc8ee4b3$var$_toConsumableArray2 = $453e576ecc8ee4b3$var$_interopRequireDefault((parcelRequire("fUHKi")));

var $84X73 = parcelRequire("84X73");
var $453e576ecc8ee4b3$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $453e576ecc8ee4b3$var$ALIASED_FRAGMENT_SPREAD = $84X73.ALIASED_FRAGMENT_SPREAD, $453e576ecc8ee4b3$var$ALIASED_INLINE_FRAGMENT_SPREAD = $84X73.ALIASED_INLINE_FRAGMENT_SPREAD, $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_SERVER_OBJECT = $84X73.CLIENT_EDGE_TO_SERVER_OBJECT, $453e576ecc8ee4b3$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $453e576ecc8ee4b3$var$CONDITION = $84X73.CONDITION, $453e576ecc8ee4b3$var$DEFER = $84X73.DEFER, $453e576ecc8ee4b3$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $453e576ecc8ee4b3$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $453e576ecc8ee4b3$var$INLINE_DATA_FRAGMENT_SPREAD = $84X73.INLINE_DATA_FRAGMENT_SPREAD, $453e576ecc8ee4b3$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $453e576ecc8ee4b3$var$LINKED_FIELD = $84X73.LINKED_FIELD, $453e576ecc8ee4b3$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $453e576ecc8ee4b3$var$RELAY_LIVE_RESOLVER = $84X73.RELAY_LIVE_RESOLVER, $453e576ecc8ee4b3$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $453e576ecc8ee4b3$var$REQUIRED_FIELD = $84X73.REQUIRED_FIELD, $453e576ecc8ee4b3$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $453e576ecc8ee4b3$var$STREAM = $84X73.STREAM;

var $dsOUI = parcelRequire("dsOUI");

var $l1FnP = parcelRequire("l1FnP");
var $453e576ecc8ee4b3$var$isSuspenseSentinel = $l1FnP.isSuspenseSentinel;

var $fkd0X = parcelRequire("fkd0X");

var $iEVza = parcelRequire("iEVza");

var $53GBi = parcelRequire("53GBi");
var $453e576ecc8ee4b3$var$getReactFlightClientResponse = $53GBi.getReactFlightClientResponse;

var $5DrBw = parcelRequire("5DrBw");
var $453e576ecc8ee4b3$var$CLIENT_EDGE_TRAVERSAL_PATH = $5DrBw.CLIENT_EDGE_TRAVERSAL_PATH, $453e576ecc8ee4b3$var$FRAGMENT_OWNER_KEY = $5DrBw.FRAGMENT_OWNER_KEY, $453e576ecc8ee4b3$var$FRAGMENT_PROP_NAME_KEY = $5DrBw.FRAGMENT_PROP_NAME_KEY, $453e576ecc8ee4b3$var$FRAGMENTS_KEY = $5DrBw.FRAGMENTS_KEY, $453e576ecc8ee4b3$var$ID_KEY = $5DrBw.ID_KEY, $453e576ecc8ee4b3$var$IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $5DrBw.IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $453e576ecc8ee4b3$var$MODULE_COMPONENT_KEY = $5DrBw.MODULE_COMPONENT_KEY, $453e576ecc8ee4b3$var$ROOT_ID = $5DrBw.ROOT_ID, $453e576ecc8ee4b3$var$getArgumentValues = $5DrBw.getArgumentValues, $453e576ecc8ee4b3$var$getModuleComponentKey = $5DrBw.getModuleComponentKey, $453e576ecc8ee4b3$var$getStorageKey = $5DrBw.getStorageKey;

var $5wZNL = parcelRequire("5wZNL");
var $453e576ecc8ee4b3$var$NoopResolverCache = $5wZNL.NoopResolverCache;

var $5o6zS = parcelRequire("5o6zS");
var $453e576ecc8ee4b3$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = $5o6zS.RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL, $453e576ecc8ee4b3$var$withResolverContext = $5o6zS.withResolverContext;

var $kRPAW = parcelRequire("kRPAW");
var $453e576ecc8ee4b3$var$generateTypeID = $kRPAW.generateTypeID;

var $aaXwj = parcelRequire("aaXwj");
function $453e576ecc8ee4b3$var$read(recordSource, selector, resolverCache) {
    var reader = new $453e576ecc8ee4b3$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $453e576ecc8ee4b3$var$NoopResolverCache());
    return reader.read();
}
/**
 * @private
 */ var $453e576ecc8ee4b3$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache) {
        var _selector$clientEdgeT;
        this._clientEdgeTraversalPath = $dsOUI.ENABLE_CLIENT_EDGES && (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._missingRequiredFields = null;
        this._owner = selector.owner;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._resolverErrors = [];
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        // Relay historically allowed child fragments to be read even if the root object
        // did not match the type of the fragment: either the root object has a different
        // concrete type than the fragment (for concrete fragments) or the root object does
        // not conform to the interface/union for abstract fragments.
        // For suspense purposes, however, we want to accurately compute whether any data
        // is missing: but if the fragment type doesn't match (or a parent type didn't
        // match), then no data is expected to be present.
        // By default data is expected to be present unless this selector was read out
        // from within a non-matching type refinement in a parent fragment:
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        // If this is a concrete fragment and the concrete type of the record does not
        // match, then no data is expected to be present.
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            var recordType = $iEVza.getType(record);
            if (recordType !== node.type && // The root record type is a special `__Root` type and may not match the
            // type on the ast, so ignore type mismatches at the root.
            // We currently detect whether we're at the root by checking against ROOT_ID,
            // but this does not work for mutations/subscriptions which generate unique
            // root ids. This is acceptable in practice as we don't read data for mutations/
            // subscriptions in a situation where we would use isMissingData to decide whether
            // to suspend or not.
            // TODO T96653810: Correctly detect reading from root of mutation/subscription
            dataID !== $453e576ecc8ee4b3$var$ROOT_ID) isDataExpectedToBePresent = false;
        }
        // If this is an abstract fragment (and the precise refinement GK is enabled)
        // then data is only expected to be present if the record type is known to
        // implement the interface. If we aren't sure whether the record implements
        // the interface, that itself constitutes "expected" data being missing.
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) // Type known to not implement the interface
            isDataExpectedToBePresent = false;
            else if (implementsInterface == null) // Don't know if the type implements the interface or not
            this._isMissingData = true;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: $dsOUI.ENABLE_CLIENT_EDGES && this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            missingRequiredFields: this._missingRequiredFields,
            relayResolverErrors: this._resolverErrors
        };
    };
    _proto._markDataAsMissing = function _markDataAsMissing() {
        this._isMissingData = true;
        if ($dsOUI.ENABLE_CLIENT_EDGES && this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            // Top can be null if we've traversed past a client edge into an ordinary
            // client extension field; we never want to fetch in response to missing
            // data off of a client extension field.
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing();
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(fieldPath, action, _record) {
        var _this$_missingRequire;
        if (((_this$_missingRequire = this._missingRequiredFields) === null || _this$_missingRequire === void 0 ? void 0 : _this$_missingRequire.action) === "THROW") // Chained @required directives may cause a parent `@required(action:
        // THROW)` field to become null, so the first missing field we
        // encounter is likely to be the root cause of the error.
        return;
        var owner = this._fragmentName;
        switch(action){
            case "THROW":
                this._missingRequiredFields = {
                    action: action,
                    field: {
                        path: fieldPath,
                        owner: owner
                    }
                };
                return;
            case "LOG":
                if (this._missingRequiredFields == null) this._missingRequiredFields = {
                    action: action,
                    fields: [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ]
                };
                else this._missingRequiredFields = {
                    action: action,
                    fields: [].concat((0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ])
                };
                return;
            default:
                action;
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) /* had all expected data */ {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case $453e576ecc8ee4b3$var$REQUIRED_FIELD:
                    var fieldValue = this._readRequiredField(selection, record, data);
                    if (fieldValue == null) {
                        var action = selection.action;
                        if (action !== "NONE") this._maybeReportUnexpectedNull(selection.path, action, record);
                        // We are going to throw, or our parent is going to get nulled out.
                        // Either way, sibling values are going to be ignored, so we can
                        // bail early here as an optimization.
                        return false;
                    }
                    break;
                case $453e576ecc8ee4b3$var$SCALAR_FIELD:
                    this._readScalar(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$LINKED_FIELD:
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case $453e576ecc8ee4b3$var$INLINE_FRAGMENT:
                    if (this._readInlineFragment(selection, record, data) === false) return false;
                    break;
                case $453e576ecc8ee4b3$var$RELAY_LIVE_RESOLVER:
                case $453e576ecc8ee4b3$var$RELAY_RESOLVER:
                    if (!$dsOUI.ENABLE_RELAY_RESOLVERS) throw new Error("Relay Resolver fields are not yet supported.");
                    this._readResolverField(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$FRAGMENT_SPREAD:
                    this._createFragmentPointer(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$ALIASED_FRAGMENT_SPREAD:
                    data[selection.name] = this._createAliasedFragmentSpread(selection, record);
                    break;
                case $453e576ecc8ee4b3$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                    var _fieldValue = this._readInlineFragment(selection.fragment, record, {});
                    if (_fieldValue === false) _fieldValue = null;
                    data[selection.name] = _fieldValue;
                    break;
                case $453e576ecc8ee4b3$var$MODULE_IMPORT:
                    this._readModuleImport(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$INLINE_DATA_FRAGMENT_SPREAD:
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$DEFER:
                case $453e576ecc8ee4b3$var$CLIENT_EXTENSION:
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    if ($dsOUI.ENABLE_CLIENT_EDGES) this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData = this._traverseSelections(selection.selections, record, data);
                    // The only case where we want to suspend due to missing data off of
                    // a client extension is if we reached a client edge that we might be
                    // able to fetch, or there is a missing data in one of the live resolvers.
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    if ($dsOUI.ENABLE_CLIENT_EDGES) this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData) return false;
                    break;
                case $453e576ecc8ee4b3$var$STREAM:
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData2) return false;
                    break;
                case $453e576ecc8ee4b3$var$FLIGHT_FIELD:
                    if ($dsOUI.ENABLE_REACT_FLIGHT_COMPONENT_FIELD) this._readFlightField(selection, record, data);
                    else throw new Error("Flight fields are not yet supported.");
                    break;
                case $453e576ecc8ee4b3$var$ACTOR_CHANGE:
                    this._readActorChange(selection, record, data);
                    break;
                case $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                    if ($dsOUI.ENABLE_CLIENT_EDGES) this._readClientEdge(selection, record, data);
                    else throw new Error("Client edges are not yet supported.");
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        }
        return true;
    };
    _proto._readRequiredField = function _readRequiredField(selection, record, data) {
        switch(selection.field.kind){
            case $453e576ecc8ee4b3$var$SCALAR_FIELD:
                return this._readScalar(selection.field, record, data);
            case $453e576ecc8ee4b3$var$LINKED_FIELD:
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case $453e576ecc8ee4b3$var$RELAY_RESOLVER:
                if (!$dsOUI.ENABLE_RELAY_RESOLVERS) throw new Error("Relay Resolver fields are not yet supported.");
                return this._readResolverField(selection.field, record, data);
            case $453e576ecc8ee4b3$var$RELAY_LIVE_RESOLVER:
                if (!$dsOUI.ENABLE_RELAY_RESOLVERS) throw new Error("Relay Resolver fields are not yet supported.");
                return this._readResolverField(selection.field, record, data);
            case $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
            case $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                if (!$dsOUI.ENABLE_RELAY_RESOLVERS) throw new Error("Relay Resolver fields are not yet supported.");
                return this._readClientEdge(selection.field, record, data);
            default:
                selection.field.kind;
                $aaXwj(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _this = this;
        var _field$alias;
        var fragment = field.fragment;
        var parentRecordID = $iEVza.getDataID(record);
        // Found when reading the resolver fragment, which can happen either when
        // evaluating the resolver and it calls readFragment, or when checking if the
        // inputs have changed since a previous evaluation:
        var snapshot;
        // The function `getDataForResolverFragment` serves two purposes:
        // 1. To memoize reads of the resolver's root fragment. This is important
        //    because we may read it twice. Once to check if the results have changed
        //    since last read, and once when we actually evaluate.
        // 2. To intercept the snapshot so that it can be cached by the resolver
        //    cache. This is what enables the change detection described in #1.
        //
        // Note: In the future this can be moved into the ResolverCache.
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) // It was already read when checking for input staleness; no need to read it again.
            // Note that the variables like fragmentSeenRecordIDs in the outer closure will have
            // already been set and will still be used in this case.
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
            snapshot = $453e576ecc8ee4b3$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
        };
        // This function `evaluate` tells the resolver cache how to read this
        // resolver. It returns an `EvaluationResult` which gives the resolver cache:
        // * `resolverResult` The value returned by the resolver function
        // * `snapshot` The snapshot returned when reading the resolver's root fragment (if it has one)
        // * `error` If the resolver throws, its error is caught (inside
        //   `getResolverValue`) and converted into an error object.
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $453e576ecc8ee4b3$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $453e576ecc8ee4b3$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $453e576ecc8ee4b3$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $453e576ecc8ee4b3$var$getResolverValue(field, _this._variables, key, _this._fragmentName), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $453e576ecc8ee4b3$var$getResolverValue(field, _this._variables, null, _this._fragmentName), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        // The resolver's root fragment (if there is one) may be missing data, have
        // errors, or be in a suspended state. Here we propagate those cases
        // upwards to mimic the behavior of having traversed into that fragment directly.
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingRequiredFields != null) this._addMissingRequiredFields(cachedSnapshot.missingRequiredFields);
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator = (0, $453e576ecc8ee4b3$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var missing = _step.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator2 = (0, $453e576ecc8ee4b3$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missingResolverField = _step2.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            var _iterator3 = (0, $453e576ecc8ee4b3$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.relayResolverErrors), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var error = _step3.value;
                    this._resolverErrors.push(error);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        // If the resolver errored, we track that as part of our traversal so that
        // the errors can be attached to this read's snapshot. This allows the error
        // to be logged.
        if (resolverError) this._resolverErrors.push(resolverError);
        // The resolver itself creates a record in the store. We record that we've
        // read this record so that subscribers to this snapshot also subscribe to
        // this resolver.
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        // If this resolver, or a dependency of this resolver, has suspended, we
        // need to report that in our snapshot. The `suspenseID` is the key in to
        // store where the suspended LiveState value lives. This ID allows readers
        // of the snapshot to subscribe to updates on that live resolver so that
        // they know when to unsuspend.
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push({
                path: "".concat(this._fragmentName, ".").concat(field.path),
                liveStateID: suspenseID
            });
        }
        if (updatedDataIDs != null) {
            var _iterator4 = (0, $453e576ecc8ee4b3$var$_createForOfIteratorHelper2["default"])(updatedDataIDs), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var recordID = _step4.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
        var applicationName = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        data[applicationName] = result;
        return result;
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _backingField$alias;
        var backingField = field.backingField;
        // Because ReaderClientExtension doesn't have `alias` or `name` and so I don't know
        // how to get its applicationName or storageKey yet:
        !(backingField.kind !== "ClientExtension") && $aaXwj(false);
        var applicationName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        // At this point, backingFieldData is an object with a single key (applicationName)
        // whose value is the value returned from the resolver, or a suspense sentinel.
        var clientEdgeResolverResponse = backingFieldData[applicationName];
        if (clientEdgeResolverResponse == null || $453e576ecc8ee4b3$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[applicationName] = clientEdgeResolverResponse;
            return;
        }
        var validClientEdgeResolverResponse = $453e576ecc8ee4b3$var$assertValidClientEdgeResolverResponse(field, clientEdgeResolverResponse);
        switch(validClientEdgeResolverResponse.kind){
            case "PluralConcrete":
                var storeIDs = $453e576ecc8ee4b3$var$getStoreIDsForPluralClientEdgeResolver(field, validClientEdgeResolverResponse.ids, this._resolverCache);
                this._clientEdgeTraversalPath.push(null);
                data[applicationName] = this._readLinkedIds(field.linkedField, storeIDs, record, data);
                this._clientEdgeTraversalPath.pop();
                break;
            case "SingularConcrete":
                var _getStoreIDAndTravers = $453e576ecc8ee4b3$var$getStoreIDAndTraversalPathSegmentForSingularClientEdgeResolver(field, validClientEdgeResolverResponse.id, this._resolverCache), storeID = _getStoreIDAndTravers[0], traversalPathSegment = _getStoreIDAndTravers[1];
                this._clientEdgeTraversalPath.push(traversalPathSegment);
                var prevData = data[applicationName];
                !(prevData == null || typeof prevData === "object") && $aaXwj(false);
                data[applicationName] = this._traverse(field.linkedField, storeID, // $FlowFixMe[incompatible-variance]
                prevData);
                this._clientEdgeTraversalPath.pop();
                break;
            default:
                validClientEdgeResolverResponse.kind;
        }
    };
    _proto._readFlightField = function _readFlightField(field, record, data) {
        var _field$alias2;
        var applicationName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var reactFlightClientResponseRecordID = $iEVza.getLinkedRecordID(record, storageKey);
        if (reactFlightClientResponseRecordID == null) {
            data[applicationName] = reactFlightClientResponseRecordID;
            if (reactFlightClientResponseRecordID === undefined) this._markDataAsMissing();
            return reactFlightClientResponseRecordID;
        }
        var reactFlightClientResponseRecord = this._recordSource.get(reactFlightClientResponseRecordID);
        this._seenRecords.add(reactFlightClientResponseRecordID);
        if (reactFlightClientResponseRecord == null) {
            data[applicationName] = reactFlightClientResponseRecord;
            if (reactFlightClientResponseRecord === undefined) this._markDataAsMissing();
            return reactFlightClientResponseRecord;
        }
        var clientResponse = $453e576ecc8ee4b3$var$getReactFlightClientResponse(reactFlightClientResponseRecord);
        data[applicationName] = clientResponse;
        return clientResponse;
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var applicationName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var value = $iEVza.getValue(record, storageKey);
        if (value === undefined) this._markDataAsMissing();
        data[applicationName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var applicationName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[applicationName] = linkedID;
            if (linkedID === undefined) this._markDataAsMissing();
            return linkedID;
        }
        var prevData = data[applicationName];
        !(prevData == null || typeof prevData === "object") && $aaXwj(false);
        // $FlowFixMe[incompatible-variance]
        var value = this._traverse(field, linkedID, prevData);
        data[applicationName] = value;
        return value;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var applicationName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var externalRef = $iEVza.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[applicationName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing();
            return data[applicationName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, {
            __id: dataID
        }, fragmentRef);
        data[applicationName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[applicationName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $453e576ecc8ee4b3$var$getStorageKey(field, this._variables);
        var linkedIDs = $iEVza.getLinkedRecordIDs(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this2 = this;
        var _field$alias6;
        var applicationName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[applicationName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing();
            return linkedIDs;
        }
        var prevData = data[applicationName];
        !(prevData == null || Array.isArray(prevData)) && $aaXwj(false);
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this2._markDataAsMissing();
                // $FlowFixMe[cannot-write]
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === "object") && $aaXwj(false);
            // $FlowFixMe[cannot-write]
            // $FlowFixMe[incompatible-variance]
            linkedArray[nextIndex] = _this2._traverse(field, linkedID, prevItem);
        });
        data[applicationName] = linkedArray;
        return linkedArray;
    } /**
   * Reads a ReaderModuleImport, which was generated from using the @module
   * directive.
   */ ;
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        // Determine the component module from the store: if the field is missing
        // it means we don't know what component to render the match with.
        var componentKey = $453e576ecc8ee4b3$var$getModuleComponentKey(moduleImport.documentName);
        var component = $iEVza.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing();
            return;
        }
        // Otherwise, read the fragment and module associated to the concrete
        // type, and put that data with the result:
        // - For the matched fragment, create the relevant fragment pointer and add
        //   the expected fragmentPropName
        // - For the matched module, create a reference to the module
        this._createFragmentPointer({
            kind: "FragmentSpread",
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$453e576ecc8ee4b3$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$453e576ecc8ee4b3$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._createAliasedFragmentSpread = function _createAliasedFragmentSpread(namedFragmentSpread, record) {
        var abstractKey = namedFragmentSpread.abstractKey;
        if (abstractKey == null) {
            // concrete type refinement: only read data if the type exactly matches
            var typeName = $iEVza.getType(record);
            if (typeName == null || typeName !== namedFragmentSpread.type) // This selection does not match the fragment spread. Do nothing.
            return null;
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) // Type known to not implement the interface, no data expected
            return null;
            else if (implementsInterface == null) {
                // Don't know if the type implements the interface or not
                this._markDataAsMissing();
                // Judgement call here. In some cases this will cause us to hide data that is actually valid.
                return undefined;
            }
        }
        var fieldData = {};
        this._createFragmentPointer(namedFragmentSpread.fragment, record, fieldData);
        return fieldData;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data) {
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            // concrete type refinement: only read data if the type exactly matches
            var typeName = $iEVza.getType(record);
            if (typeName == null || typeName !== inlineFragment.type) // This selection does not match the fragment spread. Do nothing.
            return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) // Bubble up null due to a missing @required field
                return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            // store flags to reset after reading
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            // @required is not allowed within inline fragments on abstract types, so
            // we can ignore the `hasMissingData` result of `_traverseSelections`.
            this._traverseSelections(inlineFragment.selections, record, data);
            // Reset
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                // Type known to not implement the interface, no data expected
                this._isMissingData = parentIsMissingData;
                return undefined;
            } else if (implementsInterface == null) {
                // Don't know if the type implements the interface or not
                this._markDataAsMissing();
                return null;
            }
        }
        return data;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$453e576ecc8ee4b3$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$453e576ecc8ee4b3$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === "object" && fragmentPointers != null) && $aaXwj(false);
        if (data[$453e576ecc8ee4b3$var$ID_KEY] == null) data[$453e576ecc8ee4b3$var$ID_KEY] = $iEVza.getDataID(record);
        // $FlowFixMe[cannot-write] - writing into read-only field
        fragmentPointers[fragmentSpread.name] = fragmentSpread.args ? $453e576ecc8ee4b3$var$getArgumentValues(fragmentSpread.args, this._variables) : {};
        data[$453e576ecc8ee4b3$var$FRAGMENT_OWNER_KEY] = this._owner;
        data[$453e576ecc8ee4b3$var$IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = this._isWithinUnmatchedTypeRefinement;
        if ($dsOUI.ENABLE_CLIENT_EDGES) {
            if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$453e576ecc8ee4b3$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
        }
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$453e576ecc8ee4b3$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$453e576ecc8ee4b3$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === "object" && fragmentPointers != null) && $aaXwj(false);
        if (data[$453e576ecc8ee4b3$var$ID_KEY] == null) data[$453e576ecc8ee4b3$var$ID_KEY] = $iEVza.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        // If the inline fragment spread has arguments, we need to temporarily
        // switch this._variables to include the fragment spread's arguments
        // for the duration of its traversal.
        var argumentVariables = fragmentSpreadOrFragment.args ? $453e576ecc8ee4b3$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $fkd0X.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        // Put the parent variables back
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        // $FlowFixMe[cannot-write] - writing into read-only field
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._addMissingRequiredFields = function _addMissingRequiredFields(additional) {
        if (this._missingRequiredFields == null) {
            this._missingRequiredFields = additional;
            return;
        }
        if (this._missingRequiredFields.action === "THROW") return;
        if (additional.action === "THROW") {
            this._missingRequiredFields = additional;
            return;
        }
        this._missingRequiredFields = {
            action: "LOG",
            fields: [].concat((0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), (0, $453e576ecc8ee4b3$var$_toConsumableArray2["default"])(additional.fields))
        };
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $iEVza.getType(record);
        var typeRecord = this._recordSource.get($453e576ecc8ee4b3$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $iEVza.getValue(typeRecord, abstractKey) : null;
        // $FlowFixMe Casting record value
        return implementsInterface;
    };
    return RelayReader;
}(); // Constructs the arguments for a resolver function and then evaluates it.
//
// If the resolver's fragment is missing data (query is in-flight, a dependency
// field is suspending, or is missing required fields) then `readFragment` will
// throw `RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL`. This function ensures that
// we catch that error and instead create an error object which can be
// propagated to the reader snapshot.
function $453e576ecc8ee4b3$var$getResolverValue(field, variables, fragmentKey, ownerName) {
    // Support for languages that work (best) with ES6 modules, such as TypeScript.
    var resolverFunction = typeof field.resolverModule === "function" ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $453e576ecc8ee4b3$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        if (e === $453e576ecc8ee4b3$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL) resolverResult = undefined;
        else {
            var _field$path;
            // `field.path` is typed as nullable while we rollout compiler changes.
            var path = (_field$path = field.path) !== null && _field$path !== void 0 ? _field$path : "[UNKNOWN]";
            resolverError = {
                field: {
                    path: path,
                    owner: ownerName
                },
                error: e
            };
        }
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $453e576ecc8ee4b3$var$assertValidClientEdgeResolverResponse(field, clientEdgeResolverResponse) {
    if (field.linkedField.plural) {
        !Array.isArray(clientEdgeResolverResponse) && $aaXwj(false);
        return {
            kind: "PluralConcrete",
            ids: clientEdgeResolverResponse.map(function(response) {
                return $453e576ecc8ee4b3$var$extractIdFromResponse(response, "Expected this plural Client Edge Relay Resolver to return an array containing IDs or objects with shape {id}.");
            })
        };
    } else return {
        kind: "SingularConcrete",
        id: $453e576ecc8ee4b3$var$extractIdFromResponse(clientEdgeResolverResponse, "Expected this Client Edge Relay Resolver to return an ID of type `string` or an object with shape {id}.")
    };
}
// For weak objects:
// The return value of a client edge resolver is the entire object (though,
// strong objects become DataIDs or arrays thereof). However, when being read
// out, these raw objects are turned into DataIDs or arrays thereof.
//
// For strong objects:
// For a singular field, the return value of a client edge resolver is a DataID
// (i.e. a string). If the edge points to a client type, we namespace the
// ID with the typename by calling resolverCache.ensureClientRecord.
function $453e576ecc8ee4b3$var$getStoreIDAndTraversalPathSegmentForSingularClientEdgeResolver(field, clientEdgeResolverResponse, resolverCache) {
    if (field.kind === $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT) {
        if (field.backingField.normalizationInfo == null) {
            var concreteType = field.concreteType;
            !(concreteType != null) && $aaXwj(false);
            // @edgeTo case where we need to ensure that the record has `id` field
            return [
                resolverCache.ensureClientRecord(clientEdgeResolverResponse, concreteType),
                null
            ];
        } else // The normalization process in LiveResolverCache should take care of generating the correct ID.
        return [
            clientEdgeResolverResponse,
            null
        ];
    } else return [
        clientEdgeResolverResponse,
        {
            readerClientEdge: field,
            clientEdgeDestinationID: clientEdgeResolverResponse
        }
    ];
}
// For weak objects:
// The return value of a client edge resolver is the entire object (though,
// strong objects become DataIDs or arrays thereof). However, when being read
// out, these raw objects are turned into DataIDs or arrays thereof.
//
// For strong objects:
// For a plural field, the return value of a client edge resolver is an
// array of DataID's. If the edge points to a client type, we namespace the
// IDs with the typename by calling resolverCache.ensureClientRecord.
function $453e576ecc8ee4b3$var$getStoreIDsForPluralClientEdgeResolver(field, clientEdgeResolverResponse, resolverCache) {
    if (field.kind === $453e576ecc8ee4b3$var$CLIENT_EDGE_TO_CLIENT_OBJECT) {
        if (field.backingField.normalizationInfo == null) {
            var concreteType = field.concreteType;
            !(concreteType != null) && $aaXwj(false);
            // @edgeTo case where we need to ensure that the record has `id` field
            return clientEdgeResolverResponse.map(function(id) {
                return resolverCache.ensureClientRecord(id, concreteType);
            });
        } else // The normalization process in LiveResolverCache should take care of generating the correct ID.
        return clientEdgeResolverResponse;
    } else $aaXwj(false);
}
function $453e576ecc8ee4b3$var$extractIdFromResponse(individualResponse, errorMessage) {
    if (typeof individualResponse === "string") return individualResponse;
    else if (typeof individualResponse === "object" && individualResponse != null && typeof individualResponse.id === "string") return individualResponse.id;
    $aaXwj(false);
}
module.exports = {
    read: $453e576ecc8ee4b3$var$read
};

});
parcelRegister("5wZNL", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $406fe16a9d65f6ff$var$_interopRequireDefault = $1jnue.default;

var $406fe16a9d65f6ff$var$_createForOfIteratorHelper2 = $406fe16a9d65f6ff$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $9DGaB = parcelRequire("9DGaB");

var $84X73 = parcelRequire("84X73");
var $406fe16a9d65f6ff$var$RELAY_LIVE_RESOLVER = $84X73.RELAY_LIVE_RESOLVER;

var $i2E13 = parcelRequire("i2E13");
var $406fe16a9d65f6ff$var$generateClientID = $i2E13.generateClientID;

var $iEVza = parcelRequire("iEVza");

var $5DrBw = parcelRequire("5DrBw");
var $406fe16a9d65f6ff$var$RELAY_RESOLVER_ERROR_KEY = $5DrBw.RELAY_RESOLVER_ERROR_KEY, $406fe16a9d65f6ff$var$RELAY_RESOLVER_INVALIDATION_KEY = $5DrBw.RELAY_RESOLVER_INVALIDATION_KEY, $406fe16a9d65f6ff$var$RELAY_RESOLVER_SNAPSHOT_KEY = $5DrBw.RELAY_RESOLVER_SNAPSHOT_KEY, $406fe16a9d65f6ff$var$RELAY_RESOLVER_VALUE_KEY = $5DrBw.RELAY_RESOLVER_VALUE_KEY, $406fe16a9d65f6ff$var$getStorageKey = $5DrBw.getStorageKey;

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
// $FlowFixMe[unclear-type] - will always be empty
var $406fe16a9d65f6ff$var$emptySet = new Set();
var $406fe16a9d65f6ff$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $406fe16a9d65f6ff$var$RELAY_LIVE_RESOLVER) && $aaXwj(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $aaXwj(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
function $406fe16a9d65f6ff$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $406fe16a9d65f6ff$var$RecordResolverCache = /*#__PURE__*/ function() {
    function RecordResolverCache(getRecordSource) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
    }
    var _proto2 = RecordResolverCache.prototype;
    _proto2.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        // NOTE: Be very careful with `record` in this scope. After `evaluate` has
        // been called, the `record` we have here may have been replaced in the
        // Relay store with a new record containing new information about nested
        // resolvers on this parent record.
        var record = recordSource.get(recordID);
        !(record != null) && $aaXwj(false);
        var storageKey = $406fe16a9d65f6ff$var$getStorageKey(field, variables);
        var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            // Cache miss; evaluate the selector and store the result in a new record:
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $406fe16a9d65f6ff$var$generateClientID(recordID, storageKey);
            linkedRecord = $iEVza.create(linkedID, "__RELAY_RESOLVER__");
            var evaluationResult = evaluate();
            $iEVza.setValue(linkedRecord, $406fe16a9d65f6ff$var$RELAY_RESOLVER_VALUE_KEY, evaluationResult.resolverResult);
            $iEVza.setValue(linkedRecord, $406fe16a9d65f6ff$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $iEVza.setValue(linkedRecord, $406fe16a9d65f6ff$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            recordSource.set(linkedID, linkedRecord);
            // Link the resolver value record to the resolver field of the record being read:
            // Note: We get a fresh instance of the parent record from the record
            // source, because it may have been updated when we traversed into child
            // resolvers.
            var currentRecord = recordSource.get(recordID);
            !(currentRecord != null) && $aaXwj(false);
            var nextRecord = $iEVza.clone(currentRecord);
            $iEVza.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna;
                // Put records observed by the resolver into the dependency graph:
                var fragmentStorageKey = $406fe16a9d65f6ff$var$getStorageKey(field.fragment, variables);
                var resolverID = $406fe16a9d65f6ff$var$generateClientID(recordID, fragmentStorageKey);
                $406fe16a9d65f6ff$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $406fe16a9d65f6ff$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna = evaluationResult.snapshot) === null || _evaluationResult$sna === void 0 ? void 0 : _evaluationResult$sna.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $406fe16a9d65f6ff$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $406fe16a9d65f6ff$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        }
        // $FlowFixMe[incompatible-type] - will always be empty
        var answer = linkedRecord[$406fe16a9d65f6ff$var$RELAY_RESOLVER_VALUE_KEY];
        // $FlowFixMe[incompatible-type] - casting mixed
        var snapshot = linkedRecord[$406fe16a9d65f6ff$var$RELAY_RESOLVER_SNAPSHOT_KEY];
        // $FlowFixMe[incompatible-type] - casting mixed
        var error = linkedRecord[$406fe16a9d65f6ff$var$RELAY_RESOLVER_ERROR_KEY];
        return [
            answer,
            linkedID,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto2.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs // Mutated in place
    ) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var _iterator2 = (0, $406fe16a9d65f6ff$var$_createForOfIteratorHelper2["default"])((_this$_recordIDToReso = this._recordIDToResolverIDs.get(recordID)) !== null && _this$_recordIDToReso !== void 0 ? _this$_recordIDToReso : $406fe16a9d65f6ff$var$emptySet), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _this$_recordIDToReso;
                    var fragment = _step2.value;
                    if (!visited.has(fragment)) {
                        var _iterator3 = (0, $406fe16a9d65f6ff$var$_createForOfIteratorHelper2["default"])((_this$_resolverIDToRe = this._resolverIDToRecordIDs.get(fragment)) !== null && _this$_resolverIDToRe !== void 0 ? _this$_resolverIDToRe : $406fe16a9d65f6ff$var$emptySet), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var _this$_resolverIDToRe;
                                var anotherRecordID = _step3.value;
                                this._markInvalidatedResolverRecord(anotherRecordID, recordSource, updatedDataIDs);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    };
    _proto2._markInvalidatedResolverRecord = function _markInvalidatedResolverRecord(dataID, recordSource, // Written to
    updatedDataIDs // Mutated in place
    ) {
        var record = recordSource.get(dataID);
        if (!record) return;
        var nextRecord = $iEVza.clone(record);
        $iEVza.setValue(nextRecord, $406fe16a9d65f6ff$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
        recordSource.set(dataID, nextRecord);
    };
    _proto2._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$iEVza.getValue(record, $406fe16a9d65f6ff$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        // $FlowFixMe[incompatible-type] - storing values in records is not typed
        var snapshot = $iEVza.getValue(record, $406fe16a9d65f6ff$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $9DGaB(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        return false;
    };
    _proto2.ensureClientRecord = function ensureClientRecord(id, typename) {
        $aaXwj(false);
    };
    _proto2.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        $aaXwj(false);
    };
    return RecordResolverCache;
}();
module.exports = {
    NoopResolverCache: $406fe16a9d65f6ff$var$NoopResolverCache,
    RecordResolverCache: $406fe16a9d65f6ff$var$RecordResolverCache
};

});

parcelRegister("5o6zS", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aW0zg = parcelRequire("aW0zg");
var $3ec44bd552cc4ea2$var$getFragment = $aW0zg.getFragment;

var $idJ2w = parcelRequire("idJ2w");
var $3ec44bd552cc4ea2$var$getSelector = $idJ2w.getSelector;

var $aaXwj = parcelRequire("aaXwj");
// When we call the user-supplied resolver function, it will in turn call
// `readFragment`, but that's a global function -- it needs information
// about what resolver is being executed, which is supplied by putting the
// info on this stack before we call the resolver function.
var $3ec44bd552cc4ea2$var$contextStack = [];
function $3ec44bd552cc4ea2$var$withResolverContext(context, cb) {
    $3ec44bd552cc4ea2$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $3ec44bd552cc4ea2$var$contextStack.pop();
    }
}
// NOTE: these declarations are copied from 'useFragment'; it would be good
// to figure out how to share the same type signature between the two functions.
// The declarations ensure that the type of the returned data is:
//   - non-nullable if the provided ref type is non-nullable
//   - nullable if the provided ref type is nullable
//   - array of non-nullable if the provided ref type is an array of
//     non-nullable refs
//   - array of nullable if the provided ref type is an array of nullable refs
function $3ec44bd552cc4ea2$var$readFragment(fragmentInput, fragmentKey) {
    if (!$3ec44bd552cc4ea2$var$contextStack.length) throw new Error("readFragment should be called only from within a Relay Resolver function.");
    var context = $3ec44bd552cc4ea2$var$contextStack[$3ec44bd552cc4ea2$var$contextStack.length - 1];
    var fragmentNode = $3ec44bd552cc4ea2$var$getFragment(fragmentInput);
    var fragmentSelector = $3ec44bd552cc4ea2$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $aaXwj(false);
    !(fragmentSelector.kind === "SingularReaderSelector") && $aaXwj(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData;
    if (isMissingData) throw $3ec44bd552cc4ea2$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL;
    return data;
}
var $3ec44bd552cc4ea2$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = {};
module.exports = {
    readFragment: $3ec44bd552cc4ea2$var$readFragment,
    withResolverContext: $3ec44bd552cc4ea2$var$withResolverContext,
    RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL: $3ec44bd552cc4ea2$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL
};

});




parcelRegister("6rSHS", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $4b1fb34eb9714cd2$var$_interopRequireDefault = $1jnue.default;

var $4b1fb34eb9714cd2$var$_createForOfIteratorHelper2 = $4b1fb34eb9714cd2$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $4b1fb34eb9714cd2$var$_defineProperty2 = $4b1fb34eb9714cd2$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $lbx0y = parcelRequire("lbx0y");
var $4b1fb34eb9714cd2$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $lbx0y.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $4b1fb34eb9714cd2$var$assertInternalActorIdentifier = $lbx0y.assertInternalActorIdentifier;
parcelRequire("7sl3K");

var $dsOUI = parcelRequire("dsOUI");

var $bUD3L = parcelRequire("bUD3L");

var $g2tqF = parcelRequire("g2tqF");

var $aNE7V = parcelRequire("aNE7V");

var $iEVza = parcelRequire("iEVza");

var $3J7dZ = parcelRequire("3J7dZ");

var $5WA3P = parcelRequire("5WA3P");

var $6vcfy = parcelRequire("6vcfy");

var $53GBi = parcelRequire("53GBi");

var $kTplQ = parcelRequire("kTplQ");

var $5DrBw = parcelRequire("5DrBw");

var $5DrBw = parcelRequire("5DrBw");
var $4b1fb34eb9714cd2$var$ROOT_ID = $5DrBw.ROOT_ID, $4b1fb34eb9714cd2$var$ROOT_TYPE = $5DrBw.ROOT_TYPE;

var $5wZNL = parcelRequire("5wZNL");
var $4b1fb34eb9714cd2$var$RecordResolverCache = $5wZNL.RecordResolverCache;

var $aaXwj = parcelRequire("aaXwj");
var $4b1fb34eb9714cd2$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
/**
 * @public
 *
 * An implementation of the `Store` interface defined in `RelayStoreTypes`.
 *
 * Note that a Store takes ownership of all records provided to it: other
 * objects may continue to hold a reference to such records but may not mutate
 * them. The static Relay core is architected to avoid mutating records that may have been
 * passed to a store: operations that mutate records will either create fresh
 * records or clone existing records and modify the clones. Record immutability
 * is also enforced in development mode by freezing all records passed to a store.
 */ var $4b1fb34eb9714cd2$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa;
        (0, $4b1fb34eb9714cd2$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $4b1fb34eb9714cd2$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $bUD3L;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $aNE7V;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $4b1fb34eb9714cd2$var$RecordResolverCache(function() {
            return _this._getMutableRecordSource();
        });
        this._storeSubscriptions = new $kTplQ(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents;
        $4b1fb34eb9714cd2$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        // Check if store has been globally invalidated
        if (globalInvalidationEpoch != null) {
            // If so, check if the operation we're checking was last written
            // before or after invalidation occurred.
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) // If the operation was written /before/ global invalidation occurred,
            // or if this operation has never been written to the store before,
            // we will consider the data for this operation to be stale
            // (i.e. not resolvable from the store).
            return {
                status: "stale"
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $4b1fb34eb9714cd2$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $4b1fb34eb9714cd2$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $g2tqF.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $4b1fb34eb9714cd2$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $4b1fb34eb9714cd2$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            // Ensure each retain can only dispose once
            if (disposed) return;
            disposed = true;
            // For Flow: guard against the entry somehow not existing
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            // Decrement the ref count: if it becomes zero it is eligible
            // for release.
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    // If the release buffer is now over-full, remove the least-recently
                    // added entry and schedule a GC. Note that all items in the release
                    // buffer have a refCount of 0.
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) // This entry should be in the release buffer, but it no longer belongs
            // there since it's retained. Remove it to maintain the invariant that
            // all release buffer entries have a refCount of 0.
            this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            // If we've previously retained this operation, increment the refCount
            rootEntry.refCount += 1;
        } else // Otherwise create a new entry for the operation
        this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $5WA3P.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: "store.notify.start",
            sourceOperation: sourceOperation
        });
        // Increment the current write when notifying after executing
        // a set of changes to the store.
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        if ($dsOUI.ENABLE_RELAY_RESOLVERS) // When a record is updated, we need to also handle records that depend on it,
        // specifically Relay Resolver result records containing results based on the
        // updated records. This both adds to updatedRecordIDs and invalidates any
        // cached data as needed.
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: "store.notify.complete",
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        // If a source operation was provided (indicating the operation
        // that produced this update to the store), record the current epoch
        // at which this operation was written.
        if (sourceOperation != null) {
            // We only track the epoch at which the operation was written if
            // it was previously retained, to keep the size of our operation
            // epoch map bounded. If a query wasn't retained, we assume it can
            // may be deleted at any moment and thus is not relevant for us to track
            // for the purposes of invalidation.
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === "query" && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                // The operation isn't retained but there is space in the release buffer:
                // temporarily track this operation in case the data can be reused soon.
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $4b1fb34eb9714cd2$var$updateTargetFromSource(target, source, // We increment the current epoch at the end of the set of updates,
        // in notify(). Here, we pass what will be the incremented value of
        // the epoch to use to write to invalidated records.
        this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        // NOTE: log *after* processing the source so that even if a bad log function
        // mutates the source, it doesn't affect Relay processing of it.
        var log = this.__log;
        if (log != null) log({
            name: "store.publish",
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return "RelayModernStore()";
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $iEVza.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set("global", this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        // Check if global invalidation has changed
        if (currentInvalidations.get("global") !== prevInvalidations.get("global")) return true;
        // Check if the invalidation state for any of the ids has changed.
        var _iterator = (0, $4b1fb34eb9714cd2$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $aaXwj(false);
        var log = this.__log;
        if (log != null) log({
            name: "store.snapshot"
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $3J7dZ.create(this.getSource());
    };
    _proto.restore = function restore() {
        !(this._optimisticSource != null) && $aaXwj(false);
        var log = this.__log;
        if (log != null) log({
            name: "store.restore"
        });
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    } /**
   * Run a full GC synchronously.
   */ ;
    _proto.__gc = function __gc() {
        // Don't run GC while there are optimistic updates applied
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        /* eslint-disable no-labels */ top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            // Mark all records that are traversable from a root
            var _iterator2 = (0, $4b1fb34eb9714cd2$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $6vcfy.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    // Yield for other work after each operation
                    yield;
                    // If the store was updated, restart
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: "store.gc",
                references: references
            });
            // Sweep records without references
            if (references.size === 0) // Short-circuit if *nothing* is referenced
            this._recordSource.clear();
            else {
                // Evict any unreferenced nodes
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) this._recordSource.remove(dataID);
                }
            }
            return;
        }
    };
    return RelayModernStore;
}();
function $4b1fb34eb9714cd2$var$initializeRecordSource(target) {
    if (!target.has($4b1fb34eb9714cd2$var$ROOT_ID)) {
        var rootRecord = $iEVza.create($4b1fb34eb9714cd2$var$ROOT_ID, $4b1fb34eb9714cd2$var$ROOT_TYPE);
        target.set($4b1fb34eb9714cd2$var$ROOT_ID, rootRecord);
    }
}
/**
 * Updates the target with information from source, also updating a mapping of
 * which records in the target were changed as a result.
 * Additionally, will mark records as invalidated at the current write epoch
 * given the set of record ids marked as stale in this update.
 */ function $4b1fb34eb9714cd2$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    // First, update any records that were marked for invalidation.
    // For each provided dataID that was invalidated, we write the
    // INVALIDATED_AT_KEY on the record, indicating
    // the epoch at which the record was invalidated.
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        // If record was deleted during the update (and also invalidated),
        // we don't need to count it as an invalidated id
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) // If the target record exists, use it to set the epoch
        // at which it was invalidated. This record will be updated with
        // any changes from source in the section below
        // where we update the target records based on the source.
        nextRecord = $iEVza.clone(targetRecord);
        else // If the target record doesn't exist, it means that a new record
        // in the source was created (and also invalidated), so we use that
        // record to set the epoch at which it was invalidated. This record
        // will be updated with any changes from source in the section below
        // where we update the target records based on the source.
        nextRecord = sourceRecord != null ? $iEVza.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $iEVza.setValue(nextRecord, $5DrBw.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    // Update the target based on the changes present in source
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            // ReactFlightClientResponses are lazy and only materialize when readRoot
            // is called when we read the field, so if the record is a Flight field
            // we always use the new record's data regardless of whether
            // it actually changed. Let React take care of reconciliation instead.
            var nextRecord = $iEVza.getType(targetRecord) === $53GBi.REACT_FLIGHT_TYPE_NAME ? sourceRecord : $iEVza.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        } // don't add explicit undefined
    }
}
/**
 * Returns an OperationAvailability given the Availability returned
 * by checking an operation, and when that operation was last written to the store.
 * Specifically, the provided Availability of an operation will contain the
 * value of when a record referenced by the operation was most recently
 * invalidated; given that value, and given when this operation was last
 * written to the store, this function will return the overall
 * OperationAvailability for the operation.
 */ function $4b1fb34eb9714cd2$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === "number") {
        // If some record referenced by this operation is stale, then the operation itself is stale
        // if either the operation itself was never written *or* the operation was last written
        // before the most recent invalidation of its reachable records.
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: "stale"
        };
    }
    if (status === "missing") return {
        status: "missing"
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: "stale"
        };
    }
    // There were no invalidations of any reachable records *or* the operation is known to have
    // been fetched after the most recent record invalidation.
    return {
        status: "available",
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $4b1fb34eb9714cd2$var$RelayModernStore;

});
parcelRegister("bUD3L", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $8ac3391c71be934a$var$resolvedPromise = Promise.resolve();
/**
 * An alternative to setImmediate based on Promise.
 */ function $8ac3391c71be934a$var$resolveImmediate(callback) {
    $8ac3391c71be934a$var$resolvedPromise.then(callback)["catch"]($8ac3391c71be934a$var$throwNext);
}
function $8ac3391c71be934a$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $8ac3391c71be934a$var$resolveImmediate;

});

parcelRegister("g2tqF", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $bad3a9440255aed3$var$_interopRequireDefault = $1jnue.default;

var $bad3a9440255aed3$var$_createForOfIteratorHelper2 = $bad3a9440255aed3$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $2Zzcm = parcelRequire("2Zzcm");

var $RmER8 = parcelRequire("RmER8");

var $dLcej = parcelRequire("dLcej");

var $84X73 = parcelRequire("84X73");

var $dsOUI = parcelRequire("dsOUI");

var $i2E13 = parcelRequire("i2E13");
var $bad3a9440255aed3$var$isClientID = $i2E13.isClientID;

var $ihZWi = parcelRequire("ihZWi");

var $fqaM4 = parcelRequire("fqaM4");

var $fkd0X = parcelRequire("fkd0X");
var $bad3a9440255aed3$var$getLocalVariables = $fkd0X.getLocalVariables;

var $iEVza = parcelRequire("iEVza");

var $bZtyP = parcelRequire("bZtyP");
var $bad3a9440255aed3$var$EXISTENT = $bZtyP.EXISTENT, $bad3a9440255aed3$var$UNKNOWN = $bZtyP.UNKNOWN;

var $53GBi = parcelRequire("53GBi");

var $5DrBw = parcelRequire("5DrBw");

var $kRPAW = parcelRequire("kRPAW");
var $bad3a9440255aed3$var$TYPE_SCHEMA_TYPE = $kRPAW.TYPE_SCHEMA_TYPE, $bad3a9440255aed3$var$generateTypeID = $kRPAW.generateTypeID;

var $aaXwj = parcelRequire("aaXwj");
var $bad3a9440255aed3$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $bad3a9440255aed3$var$CONDITION = $84X73.CONDITION, $bad3a9440255aed3$var$CLIENT_COMPONENT = $84X73.CLIENT_COMPONENT, $bad3a9440255aed3$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $bad3a9440255aed3$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT, $bad3a9440255aed3$var$DEFER = $84X73.DEFER, $bad3a9440255aed3$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $bad3a9440255aed3$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $bad3a9440255aed3$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $bad3a9440255aed3$var$LINKED_FIELD = $84X73.LINKED_FIELD, $bad3a9440255aed3$var$LINKED_HANDLE = $84X73.LINKED_HANDLE, $bad3a9440255aed3$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $bad3a9440255aed3$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $bad3a9440255aed3$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $bad3a9440255aed3$var$SCALAR_HANDLE = $84X73.SCALAR_HANDLE, $bad3a9440255aed3$var$STREAM = $84X73.STREAM, $bad3a9440255aed3$var$TYPE_DISCRIMINATOR = $84X73.TYPE_DISCRIMINATOR;
var $bad3a9440255aed3$var$ROOT_ID = $5DrBw.ROOT_ID, $bad3a9440255aed3$var$getModuleOperationKey = $5DrBw.getModuleOperationKey, $bad3a9440255aed3$var$getStorageKey = $5DrBw.getStorageKey, $bad3a9440255aed3$var$getArgumentValues = $5DrBw.getArgumentValues;
/**
 * Synchronously check whether the records required to fulfill the given
 * `selector` are present in `source`.
 *
 * If a field is missing, it uses the provided handlers to attempt to substitute
 * data. The `target` will store all records that are modified because of a
 * successful substitution.
 *
 * If all records are present, returns `true`, otherwise `false`.
 */ function $bad3a9440255aed3$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $bad3a9440255aed3$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    return checker.check(node, dataID);
}
/**
 * @private
 */ var $bad3a9440255aed3$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $2Zzcm(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $RmER8(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: "missing",
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: "available",
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === "id" && field.alias == null && $bad3a9440255aed3$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $bad3a9440255aed3$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === "scalar") {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $bad3a9440255aed3$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === "linked") {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $bad3a9440255aed3$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $bad3a9440255aed3$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === "pluralLinked") {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $bad3a9440255aed3$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $bad3a9440255aed3$var$UNKNOWN) this._handleMissing();
        if (status === $bad3a9440255aed3$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $iEVza.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $bad3a9440255aed3$var$SCALAR_FIELD:
                    _this2._checkScalar(selection, dataID);
                    break;
                case $bad3a9440255aed3$var$LINKED_FIELD:
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case $bad3a9440255aed3$var$ACTOR_CHANGE:
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case $bad3a9440255aed3$var$CONDITION:
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $bad3a9440255aed3$var$INLINE_FRAGMENT:
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        // concrete type refinement: only check data if the type exactly matches
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        // Abstract refinement: check data depending on whether the type
                        // conforms to the interface/union or not:
                        // - Type known to _not_ implement the interface: don't check the selections.
                        // - Type is known _to_ implement the interface: check selections.
                        // - Unknown whether the type implements the interface: don't check the selections
                        //   and treat the data as missing; we do this because the Relay Compiler
                        //   guarantees that the type discriminator will always be fetched.
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $aaXwj(false);
                        var _typeID = $bad3a9440255aed3$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) // unsure if the type implements the interface: data is
                        // missing so don't bother reading the fragment
                        _this2._handleMissing();
                         // else false: known to not implement the interface
                    }
                    break;
                case $bad3a9440255aed3$var$LINKED_HANDLE:
                    // Handles have no selections themselves; traverse the original field
                    // where the handle was set-up instead.
                    var handleField = $ihZWi(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case $bad3a9440255aed3$var$SCALAR_HANDLE:
                    var _handleField = $fqaM4(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case $bad3a9440255aed3$var$MODULE_IMPORT:
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case $bad3a9440255aed3$var$DEFER:
                case $bad3a9440255aed3$var$STREAM:
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $bad3a9440255aed3$var$FRAGMENT_SPREAD:
                    var prevVariables = _this2._variables;
                    _this2._variables = $bad3a9440255aed3$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case $bad3a9440255aed3$var$CLIENT_EXTENSION:
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case $bad3a9440255aed3$var$TYPE_DISCRIMINATOR:
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $aaXwj(false);
                    var typeID = $bad3a9440255aed3$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) // unsure if the type implements the interface: data is
                    // missing
                    _this2._handleMissing();
                     // else: if it does or doesn't implement, we don't need to check or skip anything else
                    break;
                case $bad3a9440255aed3$var$FLIGHT_FIELD:
                    if ($dsOUI.ENABLE_REACT_FLIGHT_COMPONENT_FIELD) _this2._checkFlightField(selection, dataID);
                    else throw new Error("Flight fields are not yet supported.");
                    break;
                case $bad3a9440255aed3$var$CLIENT_COMPONENT:
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case $bad3a9440255aed3$var$RELAY_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $bad3a9440255aed3$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        var operationKey = $bad3a9440255aed3$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $dLcej(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $bad3a9440255aed3$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else // If the fragment is not available, we assume that the data cannot have been
        // processed yet and must therefore be missing.
        this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $iEVza.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._checkFlightField = function _checkFlightField(field, dataID) {
        var storageKey = $bad3a9440255aed3$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID == null) {
            if (linkedID === undefined) {
                this._handleMissing();
                return;
            }
            return;
        }
        var tree = this._mutator.getValue(linkedID, $53GBi.REACT_FLIGHT_TREE_STORAGE_KEY);
        var reachableExecutableDefinitions = this._mutator.getValue(linkedID, $53GBi.REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY);
        if (tree == null || !Array.isArray(reachableExecutableDefinitions)) {
            this._handleMissing();
            return;
        }
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        // In Flight, the variables that are in scope for reachable executable
        // definitions aren't the same as what's in scope for the outer query.
        var prevVariables = this._variables;
        // $FlowFixMe[incompatible-cast]
        var _iterator4 = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(reachableExecutableDefinitions), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var definition = _step4.value;
                this._variables = definition.variables;
                var normalizationRootNode = operationLoader.get(definition.module);
                if (normalizationRootNode != null) {
                    var operation = $dLcej(normalizationRootNode);
                    this._traverseSelections(operation.selections, $bad3a9440255aed3$var$ROOT_ID);
                } else // If the fragment is not available, we assume that the data cannot have
                // been processed yet and must therefore be missing.
                this._handleMissing();
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        this._variables = prevVariables;
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator5 = (0, $bad3a9440255aed3$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var concreteType = _step5.value;
                    var typeID = $bad3a9440255aed3$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $bad3a9440255aed3$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $bad3a9440255aed3$var$check
};

});
parcelRegister("ihZWi", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $84X73 = parcelRequire("84X73");
var $d509dc638a4294ee$var$LINKED_FIELD = $84X73.LINKED_FIELD;

var $5DrBw = parcelRequire("5DrBw");
var $d509dc638a4294ee$var$getHandleStorageKey = $5DrBw.getHandleStorageKey;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
/**
 * @private
 *
 * Creates a clone of the supplied `handleField` by finding the original linked
 * field (on which the handle was declared) among the sibling `selections`, and
 * copying its selections into the clone.
 */ function $d509dc638a4294ee$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $d509dc638a4294ee$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $ewhZB(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $d509dc638a4294ee$var$LINKED_FIELD) && $aaXwj(false);
    var handleKey = $d509dc638a4294ee$var$getHandleStorageKey(handleField, variables);
    return {
        kind: "LinkedField",
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $d509dc638a4294ee$var$cloneRelayHandleSourceField;

});

parcelRegister("fqaM4", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $84X73 = parcelRequire("84X73");
var $b3a1a442480bc680$var$SCALAR_FIELD = $84X73.SCALAR_FIELD;

var $5DrBw = parcelRequire("5DrBw");
var $b3a1a442480bc680$var$getHandleStorageKey = $5DrBw.getHandleStorageKey;

var $ewhZB = parcelRequire("ewhZB");

var $aaXwj = parcelRequire("aaXwj");
/**
 * @private
 *
 * Creates a clone of the supplied `handleField` by finding the original scalar
 * field (on which the handle was declared) among the sibling `selections`.
 */ function $b3a1a442480bc680$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $b3a1a442480bc680$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $ewhZB(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $b3a1a442480bc680$var$SCALAR_FIELD) && $aaXwj(false);
    var handleKey = $b3a1a442480bc680$var$getHandleStorageKey(handleField, variables);
    return {
        kind: "ScalarField",
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $b3a1a442480bc680$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("3J7dZ", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $2b6b2dc144c245e7$var$_interopRequireDefault = $1jnue.default;

var $2b6b2dc144c245e7$var$_objectSpread2 = $2b6b2dc144c245e7$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $L6WFS = parcelRequire("L6WFS");

var $aaXwj = parcelRequire("aaXwj");
var $2b6b2dc144c245e7$var$UNPUBLISH_RECORD_SENTINEL = Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
});
/**
 * An implementation of MutableRecordSource that represents a base RecordSource
 * with optimistic updates stacked on top: records with optimistic updates
 * shadow the base version of the record rather than updating/replacing them.
 */ var $2b6b2dc144c245e7$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $L6WFS.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $2b6b2dc144c245e7$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $2b6b2dc144c245e7$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return "UNKNOWN";
        else if (record === null) return "NONEXISTENT";
        else return "EXISTENT";
    };
    _proto.clear = function clear() {
        this._base = $L6WFS.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $2b6b2dc144c245e7$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $2b6b2dc144c245e7$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = record;
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $2b6b2dc144c245e7$var$create(base) {
    return new $2b6b2dc144c245e7$var$RelayOptimisticRecordSource(base);
}
function $2b6b2dc144c245e7$var$getOptimisticRecordIDs(source) {
    !(source instanceof $2b6b2dc144c245e7$var$RelayOptimisticRecordSource) && $aaXwj(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $2b6b2dc144c245e7$var$create,
    getOptimisticRecordIDs: $2b6b2dc144c245e7$var$getOptimisticRecordIDs
};

});

parcelRegister("6vcfy", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $4bbf23ea7c0204c5$var$_interopRequireDefault = $1jnue.default;

var $4bbf23ea7c0204c5$var$_createForOfIteratorHelper2 = $4bbf23ea7c0204c5$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $dLcej = parcelRequire("dLcej");

var $84X73 = parcelRequire("84X73");

var $dsOUI = parcelRequire("dsOUI");

var $ihZWi = parcelRequire("ihZWi");

var $9VD3P = parcelRequire("9VD3P");

var $fkd0X = parcelRequire("fkd0X");
var $4bbf23ea7c0204c5$var$getLocalVariables = $fkd0X.getLocalVariables;

var $iEVza = parcelRequire("iEVza");

var $53GBi = parcelRequire("53GBi");

var $5DrBw = parcelRequire("5DrBw");

var $kRPAW = parcelRequire("kRPAW");
var $4bbf23ea7c0204c5$var$generateTypeID = $kRPAW.generateTypeID;

var $aaXwj = parcelRequire("aaXwj");
var $4bbf23ea7c0204c5$var$ACTOR_CHANGE = $84X73.ACTOR_CHANGE, $4bbf23ea7c0204c5$var$CONDITION = $84X73.CONDITION, $4bbf23ea7c0204c5$var$CLIENT_COMPONENT = $84X73.CLIENT_COMPONENT, $4bbf23ea7c0204c5$var$CLIENT_EXTENSION = $84X73.CLIENT_EXTENSION, $4bbf23ea7c0204c5$var$DEFER = $84X73.DEFER, $4bbf23ea7c0204c5$var$FLIGHT_FIELD = $84X73.FLIGHT_FIELD, $4bbf23ea7c0204c5$var$FRAGMENT_SPREAD = $84X73.FRAGMENT_SPREAD, $4bbf23ea7c0204c5$var$INLINE_FRAGMENT = $84X73.INLINE_FRAGMENT, $4bbf23ea7c0204c5$var$LINKED_FIELD = $84X73.LINKED_FIELD, $4bbf23ea7c0204c5$var$MODULE_IMPORT = $84X73.MODULE_IMPORT, $4bbf23ea7c0204c5$var$LINKED_HANDLE = $84X73.LINKED_HANDLE, $4bbf23ea7c0204c5$var$SCALAR_FIELD = $84X73.SCALAR_FIELD, $4bbf23ea7c0204c5$var$SCALAR_HANDLE = $84X73.SCALAR_HANDLE, $4bbf23ea7c0204c5$var$STREAM = $84X73.STREAM, $4bbf23ea7c0204c5$var$TYPE_DISCRIMINATOR = $84X73.TYPE_DISCRIMINATOR, $4bbf23ea7c0204c5$var$RELAY_RESOLVER = $84X73.RELAY_RESOLVER, $4bbf23ea7c0204c5$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $84X73.CLIENT_EDGE_TO_CLIENT_OBJECT;
var $4bbf23ea7c0204c5$var$ROOT_ID = $5DrBw.ROOT_ID, $4bbf23ea7c0204c5$var$getStorageKey = $5DrBw.getStorageKey, $4bbf23ea7c0204c5$var$getModuleOperationKey = $5DrBw.getModuleOperationKey;
function $4bbf23ea7c0204c5$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $4bbf23ea7c0204c5$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
/**
 * @private
 */ var $4bbf23ea7c0204c5$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === "Operation" || node.kind === "SplitOperation") this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aaXwj(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            /* eslint-disable no-fallthrough */ switch(selection.kind){
                case $4bbf23ea7c0204c5$var$ACTOR_CHANGE:
                    // TODO: T89695151 Support multi-actor record sources in RelayReferenceMarker.js
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case $4bbf23ea7c0204c5$var$LINKED_FIELD:
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case $4bbf23ea7c0204c5$var$CONDITION:
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case $4bbf23ea7c0204c5$var$INLINE_FRAGMENT:
                    if (selection.abstractKey == null) {
                        var typeName = $iEVza.getType(record);
                        if (typeName != null && typeName === selection.type || // Our root record has a special type of `__Root` which may not
                        // match the schema type of Query/Mutation or whatever the schema
                        // specifies.
                        //
                        // If we have an inline fragment on a concrete type within an
                        // operation root, and our query has been validated, we know that
                        // concrete type must match, since the operation selection must be
                        // on a concrete type.
                        typeName === $5DrBw.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $iEVza.getType(record);
                        var typeID = $4bbf23ea7c0204c5$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case $4bbf23ea7c0204c5$var$FRAGMENT_SPREAD:
                    var prevVariables = _this._variables;
                    _this._variables = $4bbf23ea7c0204c5$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case $4bbf23ea7c0204c5$var$LINKED_HANDLE:
                    // The selections for a "handle" field are the same as those of the
                    // original linked field where the handle was applied. Reference marking
                    // therefore requires traversing the original field selections against
                    // the synthesized client field.
                    //
                    // TODO: Instead of finding the source field in `selections`, change
                    // the concrete structure to allow shared subtrees, and have the linked
                    // handle directly refer to the same selections as the LinkedField that
                    // it was split from.
                    var handleField = $ihZWi(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case $4bbf23ea7c0204c5$var$DEFER:
                case $4bbf23ea7c0204c5$var$STREAM:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $4bbf23ea7c0204c5$var$SCALAR_FIELD:
                case $4bbf23ea7c0204c5$var$SCALAR_HANDLE:
                    break;
                case $4bbf23ea7c0204c5$var$TYPE_DISCRIMINATOR:
                    var _typeName2 = $iEVza.getType(record);
                    var _typeID = $4bbf23ea7c0204c5$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case $4bbf23ea7c0204c5$var$MODULE_IMPORT:
                    _this._traverseModuleImport(selection, record);
                    break;
                case $4bbf23ea7c0204c5$var$CLIENT_EXTENSION:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $4bbf23ea7c0204c5$var$FLIGHT_FIELD:
                    if ($dsOUI.ENABLE_REACT_FLIGHT_COMPONENT_FIELD) _this._traverseFlightField(selection, record);
                    else throw new Error("Flight fields are not yet supported.");
                    break;
                case $4bbf23ea7c0204c5$var$CLIENT_COMPONENT:
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case $4bbf23ea7c0204c5$var$RELAY_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $4bbf23ea7c0204c5$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $aaXwj(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            // Mark all @outputType record IDs
            var outputTypeRecordIDs = $9VD3P(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $4bbf23ea7c0204c5$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) // TODO: Handle retaining abstract client edges to client types.
            return;
            if (linkedField.plural) {
                var dataIDs = $iEVza.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $4bbf23ea7c0204c5$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $iEVza.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = $4bbf23ea7c0204c5$var$getStorageKey(field, this._variables);
        var dataID = $iEVza.getLinkedRecordID(record, storageKey);
        // If the resolver value has been created, we should retain it.
        // This record contains our cached resolver value, and potential Live
        // Resolver subscription.
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) // Mark the contents of the resolver's data dependencies.
        this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        var operationKey = $4bbf23ea7c0204c5$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $iEVza.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $dLcej(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $4bbf23ea7c0204c5$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    // Otherwise, if the operation is not available, we assume that the data
    // cannot have been processed yet and therefore isn't in the store to
    // begin with.
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $4bbf23ea7c0204c5$var$getStorageKey(field, this._variables);
        var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $4bbf23ea7c0204c5$var$getStorageKey(field, this._variables);
        var linkedIDs = $iEVza.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    _proto._traverseFlightField = function _traverseFlightField(field, record) {
        var storageKey = $4bbf23ea7c0204c5$var$getStorageKey(field, this._variables);
        var linkedID = $iEVza.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._references.add(linkedID);
        var reactFlightClientResponseRecord = this._recordSource.get(linkedID);
        if (reactFlightClientResponseRecord == null) return;
        var reachableExecutableDefinitions = $iEVza.getValue(reactFlightClientResponseRecord, $53GBi.REACT_FLIGHT_EXECUTABLE_DEFINITIONS_STORAGE_KEY);
        if (!Array.isArray(reachableExecutableDefinitions)) return;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aaXwj(false);
        // In Flight, the variables that are in scope for reachable executable
        // definitions aren't the same as what's in scope for the outer query.
        var prevVariables = this._variables;
        // $FlowFixMe[incompatible-cast]
        var _iterator3 = (0, $4bbf23ea7c0204c5$var$_createForOfIteratorHelper2["default"])(reachableExecutableDefinitions), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var definition = _step3.value;
                this._variables = definition.variables;
                var operationReference = definition.module;
                var normalizationRootNode = operationLoader.get(operationReference);
                if (normalizationRootNode != null) {
                    var operation = $dLcej(normalizationRootNode);
                    this._traverse(operation, $4bbf23ea7c0204c5$var$ROOT_ID);
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._variables = prevVariables;
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $4bbf23ea7c0204c5$var$mark
};

});
parcelRegister("9VD3P", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $iEVza = parcelRequire("iEVza");

var $5DrBw = parcelRequire("5DrBw");
var $73a7bc93037d64ca$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $5DrBw.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $aaXwj = parcelRequire("aaXwj");
function $73a7bc93037d64ca$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $iEVza.getValue(record, $73a7bc93037d64ca$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $aaXwj(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $73a7bc93037d64ca$var$getOutputTypeRecordIDs;

});


parcelRegister("kTplQ", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
parcelRequire("7sl3K");

var $9DGaB = parcelRequire("9DGaB");

var $dsOUI = parcelRequire("dsOUI");

var $5Fpm6 = parcelRequire("5Fpm6");

var $5WA3P = parcelRequire("5WA3P");
var $f35c9bedd581f4a1$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            // Backup occurs after writing a new "final" payload(s) and before (re)applying
            // optimistic changes. Each subscription's `snapshot` represents what was *last
            // published to the subscriber*, which notably may include previous optimistic
            // updates. Therefore a subscription can be in any of the following states:
            // - stale=true: This subscription was restored to a different value than
            //   `snapshot`. That means this subscription has changes relative to its base,
            //   but its base has changed (we just applied a final payload): recompute
            //   a backup so that we can later restore to the state the subscription
            //   should be in.
            // - stale=false: This subscription was restored to the same value as
            //   `snapshot`. That means this subscription does *not* have changes relative
            //   to its base, so the current `snapshot` is valid to use as a backup.
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $5WA3P.read(source, snapshot.selector, _this2._resolverCache);
            var nextData = $9DGaB(snapshot.data, backup.data);
            backup.data = nextData; // backup owns the snapshot and can safely mutate
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    missingRequiredFields: backup.missingRequiredFields,
                    relayResolverErrors: backup.relayResolverErrors
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    } /**
   * Notifies the callback for the subscription if the data for the associated
   * snapshot has changed.
   * Additionally, updates the subscription snapshot with the latest snapshot,
   * and marks it as not stale.
   * Returns the owner (RequestDescriptor) if the subscription was affected by the
   * latest update, or null if it was not affected.
   */ ;
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $5Fpm6(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $5WA3P.read(source, snapshot.selector, this._resolverCache) : backup;
        var nextData = $9DGaB(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            missingRequiredFields: nextSnapshot.missingRequiredFields,
            relayResolverErrors: nextSnapshot.relayResolverErrors
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $dsOUI.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: "store.notify.subscription",
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
    };
    return RelayStoreSubscriptions;
}();
module.exports = $f35c9bedd581f4a1$var$RelayStoreSubscriptions;

});
parcelRegister("5Fpm6", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $4204732eb29cddc5$var$ITERATOR_KEY = Symbol.iterator;
function $4204732eb29cddc5$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    // $FlowFixMe[incompatible-use]: Set is an iterable type, accessing its iterator is allowed.
    var iterator = seenRecords[$4204732eb29cddc5$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $4204732eb29cddc5$var$hasOverlappingIDs;

});



parcelRegister("c18RI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $f8nQK = parcelRequire("f8nQK");

var $aW0zg = parcelRequire("aW0zg");
var $8bfc74816abb9335$var$getRequest = $aW0zg.getRequest;

var $40tQb = parcelRequire("40tQb");
var $8bfc74816abb9335$var$createOperationDescriptor = $40tQb.createOperationDescriptor;

var $idJ2w = parcelRequire("idJ2w");
var $8bfc74816abb9335$var$createReaderSelector = $idJ2w.createReaderSelector;
parcelRequire("8Fbfi");
function $8bfc74816abb9335$var$requestSubscription(environment, config) {
    var subscription = $8bfc74816abb9335$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== "subscription") throw new Error("requestSubscription: Must use Subscription operation");
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $8bfc74816abb9335$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $f8nQK.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === "string") selector = $8bfc74816abb9335$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                // $FlowFixMe[incompatible-cast]
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $8bfc74816abb9335$var$requestSubscription;

});

parcelRegister("9fUzq", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $6bd1657ac6a11654$var$_interopRequireDefault = $1jnue.default;

var $6bd1657ac6a11654$var$_objectSpread2 = $6bd1657ac6a11654$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $5DrBw = parcelRequire("5DrBw");
var $6bd1657ac6a11654$var$getModuleComponentKey = $5DrBw.getModuleComponentKey, $6bd1657ac6a11654$var$getModuleOperationKey = $5DrBw.getModuleOperationKey;
function $6bd1657ac6a11654$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $6bd1657ac6a11654$var$_objectSpread2["default"])({}, response);
    // $FlowFixMe[prop-missing]
    data[$6bd1657ac6a11654$var$getModuleComponentKey(name)] = component;
    // $FlowFixMe[prop-missing]
    data[$6bd1657ac6a11654$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $6bd1657ac6a11654$var$createPayloadFor3DField;

});

parcelRegister("k9Ckr", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $idJ2w = parcelRequire("idJ2w");
var $eac26137970f79c4$var$getDataIDsFromFragment = $idJ2w.getDataIDsFromFragment, $eac26137970f79c4$var$getSelector = $idJ2w.getSelector, $eac26137970f79c4$var$getVariablesFromFragment = $idJ2w.getVariablesFromFragment;

var $hXXaI = parcelRequire("hXXaI");

var $dsOUI = parcelRequire("dsOUI");

var $8Q6tr = parcelRequire("8Q6tr");

var $1pW7i = parcelRequire("1pW7i");
var $eac26137970f79c4$var$intern = $1pW7i.intern;
function $eac26137970f79c4$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $eac26137970f79c4$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? "null" : selector.kind === "SingularReaderSelector" ? selector.owner.identifier : "[" + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(",") + "]";
    var fragmentVariables = $eac26137970f79c4$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $eac26137970f79c4$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($dsOUI.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === "undefined" ? "missing" : dataIDs == null ? "null" : Array.isArray(dataIDs) ? "[" + dataIDs.join(",") + "]" : dataIDs;
        ids = $dsOUI.STRING_INTERN_LEVEL <= 1 ? ids : $eac26137970f79c4$var$intern(ids, $dsOUI.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + "/" + fragmentNode.name + "/" + (fragmentVariables == null || $hXXaI(fragmentVariables) ? "{}" : JSON.stringify($8Q6tr(fragmentVariables))) + "/" + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "missing";
        _ids = $dsOUI.STRING_INTERN_LEVEL <= 1 ? _ids : $eac26137970f79c4$var$intern(_ids, $dsOUI.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + "/" + fragmentNode.name + "/" + JSON.stringify($8Q6tr(fragmentVariables)) + "/" + _ids;
    }
}
module.exports = $eac26137970f79c4$var$getFragmentIdentifier;

});
parcelRegister("hXXaI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
// $FlowFixMe[method-unbinding] added when improving typing for this parameters
var $d145d8a2e4f68eb2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $d145d8a2e4f68eb2$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($d145d8a2e4f68eb2$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $d145d8a2e4f68eb2$var$isEmptyObject;

});


parcelRegister("leZHb", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $7U4ur = parcelRequire("7U4ur");

var $aaXwj = parcelRequire("aaXwj");
function $f76ac337ef5e9221$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $7U4ur(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $aaXwj(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $aaXwj(false);
    var identifierField = refetchMetadata.identifierField;
    !(identifierField == null || typeof identifierField === "string") && $aaXwj(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $f76ac337ef5e9221$var$getPaginationMetadata;

});
parcelRegister("7U4ur", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $aaXwj = parcelRequire("aaXwj");
function $5c113ef78376fb1e$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $aaXwj(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $aaXwj(false);
    // handle both commonjs and es modules
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== "string") && $aaXwj(false);
    var identifierField = refetchMetadata.identifierField;
    !(identifierField == null || typeof identifierField === "string") && $aaXwj(false);
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierField: identifierField,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $5c113ef78376fb1e$var$getRefetchMetadata;

});


parcelRegister("5UXry", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $44f04aea96fbae50$var$_interopRequireDefault = $1jnue.default;

var $44f04aea96fbae50$var$_defineProperty2 = $44f04aea96fbae50$var$_interopRequireDefault((parcelRequire("g5Zhu")));

var $44f04aea96fbae50$var$_objectSpread4 = $44f04aea96fbae50$var$_interopRequireDefault((parcelRequire("cbdLd")));

var $aaXwj = parcelRequire("aaXwj");
parcelRequire("8Fbfi");
function $44f04aea96fbae50$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === "backward") {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $aaXwj(false);
        var _paginationVariables = (0, $44f04aea96fbae50$var$_objectSpread4["default"])((0, $44f04aea96fbae50$var$_objectSpread4["default"])((0, $44f04aea96fbae50$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $44f04aea96fbae50$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $44f04aea96fbae50$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $aaXwj(false);
    var paginationVariables = (0, $44f04aea96fbae50$var$_objectSpread4["default"])((0, $44f04aea96fbae50$var$_objectSpread4["default"])((0, $44f04aea96fbae50$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $44f04aea96fbae50$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $44f04aea96fbae50$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $44f04aea96fbae50$var$getPaginationVariables;

});

parcelRegister("402wI", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $2e991f3c1da01eee$var$_interopRequireDefault = $1jnue.default;

var $2e991f3c1da01eee$var$_createForOfIteratorHelper2 = $2e991f3c1da01eee$var$_interopRequireDefault((parcelRequire("8QL5z")));

var $aaXwj = parcelRequire("aaXwj");
function $2e991f3c1da01eee$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $2e991f3c1da01eee$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === "number") {
                !Array.isArray(result) && $aaXwj(false);
                result = result[key];
            } else {
                !(typeof result === "object" && !Array.isArray(result)) && $aaXwj(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $2e991f3c1da01eee$var$getValueAtPath;

});

parcelRegister("9JzHH", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */ "use strict";
var $7164030bf567370b$var$profileHandlersByName = {};
var $7164030bf567370b$var$defaultProfiler = {
    stop: function stop() {}
};
/**
 * @public
 *
 * Instruments methods to allow profiling various parts of Relay. Profiling code
 * in Relay consists of three steps:
 *
 *  - Instrument the function to be profiled.
 *  - Attach handlers to the instrumented function.
 *  - Run the code which triggers the handlers.
 *
 * Handlers attached to instrumented methods are called with an instrumentation
 * name and a callback that must be synchronously executed:
 *
 *   instrumentedMethod.attachHandler(function(name, callback) {
 *     const start = performance.now();
 *     callback();
 *     console.log('Duration', performance.now() - start);
 *   });
 *
 * Handlers for profiles are callbacks that return a stop method:
 *
 *   RelayProfiler.attachProfileHandler('profileName', (name, state) => {
 *     const start = performance.now();
 *     return function stop(name, state) {
 *       console.log(`Duration (${name})`, performance.now() - start);
 *     }
 *   });
 */ var $7164030bf567370b$var$RelayProfiler = {
    /**
   * Instruments profiling for arbitrarily asynchronous code by a name.
   *
   *   const timerProfiler = RelayProfiler.profile('timeout');
   *   setTimeout(function() {
   *     timerProfiler.stop();
   *   }, 1000);
   *
   *   RelayProfiler.attachProfileHandler('timeout', ...);
   *
   * Arbitrary state can also be passed into `profile` as a second argument. The
   * attached profile handlers will receive this as the second argument.
   */ profile: function profile(name, state) {
        var handlers = $7164030bf567370b$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $7164030bf567370b$var$defaultProfiler;
    },
    /**
   * Attaches a handler to profiles with the supplied name.
   */ attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$7164030bf567370b$var$profileHandlersByName.hasOwnProperty(name)) $7164030bf567370b$var$profileHandlersByName[name] = [];
        $7164030bf567370b$var$profileHandlersByName[name].push(handler);
    },
    /**
   * Detaches a handler attached via `attachProfileHandler`.
   */ detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($7164030bf567370b$var$profileHandlersByName.hasOwnProperty(name)) $7164030bf567370b$var$removeFromArray($7164030bf567370b$var$profileHandlersByName[name], handler);
    }
};
function $7164030bf567370b$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $7164030bf567370b$var$RelayProfiler;

});


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $25165aaf01761cfd$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $25165aaf01761cfd$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $25165aaf01761cfd$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $25165aaf01761cfd$var$isGlobalObj(window) || typeof self == "object" && $25165aaf01761cfd$var$isGlobalObj(self) || typeof $parcel$global == "object" && $25165aaf01761cfd$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $25165aaf01761cfd$export$256479dc0cea61c4() {
    return $25165aaf01761cfd$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $25165aaf01761cfd$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $25165aaf01761cfd$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $1e0be767ffa822d8$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$e6127cc7fe7395c3(wat) {
    switch($1e0be767ffa822d8$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $1e0be767ffa822d8$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$var$isBuiltin(wat, className) {
    return $1e0be767ffa822d8$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9f9636d330b71954(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$ef9e2056653f0c8e(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$12e869b2a583f783(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$844ec244b1367d54(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c3825b437cbdea5c(wat) {
    return wat === null || $1e0be767ffa822d8$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49841c62b9eff15(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $1e0be767ffa822d8$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$bc2894c7158efbac(wat) {
    return $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $abe5418a531ee1d6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/** Prefix for logging strings */ const $3199231328e69de5$var$PREFIX = "Sentry Logger ";
const $3199231328e69de5$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $3199231328e69de5$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $3199231328e69de5$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($3199231328e69de5$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $3199231328e69de5$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $3199231328e69de5$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $abe5418a531ee1d6$export$16a28057038b10ef) $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $3199231328e69de5$export$cda52e2a8927a2ca(()=>{
                (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console[name](`${$3199231328e69de5$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $3199231328e69de5$export$af88d00dbe7f521 = $3199231328e69de5$var$makeLogger();


const $91c304fc757d5e0f$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $91c304fc757d5e0f$export$7740643b9eeaf0c4() {
    return Date.now() / $91c304fc757d5e0f$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $91c304fc757d5e0f$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $91c304fc757d5e0f$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $91c304fc757d5e0f$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $91c304fc757d5e0f$export$ee52dced521e3e18 = $91c304fc757d5e0f$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $91c304fc757d5e0f$export$c5907b5a8838db13 = $91c304fc757d5e0f$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $91c304fc757d5e0f$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $91c304fc757d5e0f$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $91c304fc757d5e0f$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $91c304fc757d5e0f$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $91c304fc757d5e0f$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $91c304fc757d5e0f$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



// eslint-disable-next-line deprecation/deprecation
const $d3dd25a69ce66c78$var$WINDOW = (0, $25165aaf01761cfd$export$256479dc0cea61c4)();
const $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d3dd25a69ce66c78$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($d3dd25a69ce66c78$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $1e0be767ffa822d8$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $d3dd25a69ce66c78$export$1cfafeee2987818b() {
    try {
        return $d3dd25a69ce66c78$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d3dd25a69ce66c78$export$c660c1f3ab49225c(selector) {
    if ($d3dd25a69ce66c78$var$WINDOW.document && $d3dd25a69ce66c78$var$WINDOW.document.querySelector) return $d3dd25a69ce66c78$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $d3dd25a69ce66c78$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$d3dd25a69ce66c78$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $692fb1c9fae23fc3$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $1e0be767ffa822d8$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $692fb1c9fae23fc3$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $1e0be767ffa822d8$export$844ec244b1367d54)(value)) return false;
    if ((0, $1e0be767ffa822d8$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $1e0be767ffa822d8$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $692fb1c9fae23fc3$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$692fb1c9fae23fc3$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $e628e125e878fd27$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $e628e125e878fd27$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $abe5418a531ee1d6$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $e628e125e878fd27$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $e628e125e878fd27$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $e628e125e878fd27$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $e628e125e878fd27$export$62ff257738bf57f5(value) {
    if ((0, $1e0be767ffa822d8$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$e628e125e878fd27$var$getOwnProperties(value)
    };
    else if ((0, $1e0be767ffa822d8$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $e628e125e878fd27$var$serializeEventTarget(value.target),
            currentTarget: $e628e125e878fd27$var$serializeEventTarget(value.currentTarget),
            ...$e628e125e878fd27$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $1e0be767ffa822d8$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $e628e125e878fd27$var$serializeEventTarget(target) {
    try {
        return (0, $1e0be767ffa822d8$export$45a5e7f76e0caa8d)(target) ? (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $e628e125e878fd27$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $e628e125e878fd27$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($e628e125e878fd27$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $e628e125e878fd27$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($e628e125e878fd27$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $e628e125e878fd27$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($e628e125e878fd27$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $e628e125e878fd27$var$isPojo(input) {
    if (!(0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $e628e125e878fd27$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $1e0be767ffa822d8$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $806ed7b2edb8ea09$export$19f53698e68b2496() {
    const gbl = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $806ed7b2edb8ea09$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $806ed7b2edb8ea09$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $806ed7b2edb8ea09$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $806ed7b2edb8ea09$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $806ed7b2edb8ea09$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $806ed7b2edb8ea09$export$d364f2020ab30578(input) {
    const match = input.match($806ed7b2edb8ea09$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $806ed7b2edb8ea09$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $692fb1c9fae23fc3$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $692fb1c9fae23fc3$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $692fb1c9fae23fc3$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $806ed7b2edb8ea09$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $e628e125e878fd27$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $806ed7b2edb8ea09$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $ebf395d8a45b5e48$export$849dbeeeda01ae98 = "production";


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6593ea065203555e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;







/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $dde6191ffa17294f$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($dde6191ffa17294f$var$States || ($dde6191ffa17294f$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $dde6191ffa17294f$export$1fda8aa4d135f8aa(value) {
    return new $dde6191ffa17294f$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $dde6191ffa17294f$export$78e43115b553f358(reason) {
    return new $dde6191ffa17294f$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $dde6191ffa17294f$export$6f292d4960313241 {
    constructor(executor){
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init2.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init3.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $dde6191ffa17294f$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($dde6191ffa17294f$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($dde6191ffa17294f$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $dde6191ffa17294f$var$States.PENDING) return;
            if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $dde6191ffa17294f$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $dde6191ffa17294f$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $dde6191ffa17294f$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$3c4238858b85e8ac() {
    return (0, $25165aaf01761cfd$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $503ba8c00efa1d46$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $dde6191ffa17294f$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $6593ea065203555e$export$16a28057038b10ef) && processor.id && result === null && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(result)) result.then((final)=>$503ba8c00efa1d46$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $049d01d3a3164ac2$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$049d01d3a3164ac2$var$sessionToJSON(session)
    };
    if (context) $049d01d3a3164ac2$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $049d01d3a3164ac2$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $049d01d3a3164ac2$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $049d01d3a3164ac2$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $049d01d3a3164ac2$var$sessionToJSON(session) {
    return (0, $e628e125e878fd27$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $bc446a546b963a28$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}





const $9e1a8f302f19c673$export$9ca9946bd449ac06 = "baggage";
const $9e1a8f302f19c673$export$6e69537d67fa20f = "sentry-";
const $9e1a8f302f19c673$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $9e1a8f302f19c673$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $9e1a8f302f19c673$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $1e0be767ffa822d8$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($9e1a8f302f19c673$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($9e1a8f302f19c673$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $9e1a8f302f19c673$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$9e1a8f302f19c673$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $9e1a8f302f19c673$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $9e1a8f302f19c673$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $9e1a8f302f19c673$export$bdd844ddb2def819) {
            (0, $abe5418a531ee1d6$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $46f5220cb64aa700$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $46f5220cb64aa700$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($46f5220cb64aa700$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $46f5220cb64aa700$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $46f5220cb64aa700$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9e1a8f302f19c673$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
            spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16),
            spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $46f5220cb64aa700$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $46f5220cb64aa700$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9e1a8f302f19c673$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16),
        spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $46f5220cb64aa700$export$f35d907436da45cf(traceId = (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(), spanId = (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $e047a3e652f57c75$export$208d5b368507fb8b = 0x0;
const $e047a3e652f57c75$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $e047a3e652f57c75$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $e047a3e652f57c75$export$92d8c23565496537(span);
    return (0, $e628e125e878fd27$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $e047a3e652f57c75$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $e047a3e652f57c75$export$5caecac1caaf3a71(span);
    return (0, $46f5220cb64aa700$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $e047a3e652f57c75$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $e047a3e652f57c75$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $e047a3e652f57c75$var$ensureTimestampInSeconds(input.getTime());
    return (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $e047a3e652f57c75$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $e047a3e652f57c75$export$92d8c23565496537(span) {
    if ($e047a3e652f57c75$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $e047a3e652f57c75$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $e047a3e652f57c75$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $e047a3e652f57c75$export$eb571cd9b5d98de8);
}


/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $89d6805454b84092$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $e628e125e878fd27$export$d25f2688db1bb433)({
        environment: options.environment || (0, $ebf395d8a45b5e48$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $89d6805454b84092$export$a117f995597e25df(span) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $89d6805454b84092$export$366bad00d6815eed((0, $e047a3e652f57c75$export$92d8c23565496537)(span).trace_id || "", client, (0, $81a395368bb6f380$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $bc446a546b963a28$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $e047a3e652f57c75$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $e047a3e652f57c75$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $613716288721a3ee$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $613716288721a3ee$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $613716288721a3ee$var$applySpanToEvent(event, span);
    $613716288721a3ee$var$applyFingerprintToEvent(event, fingerprint);
    $613716288721a3ee$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $613716288721a3ee$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $613716288721a3ee$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $613716288721a3ee$export$b1a120a2871faa46(data, "extra", extra);
    $613716288721a3ee$export$b1a120a2871faa46(data, "tags", tags);
    $613716288721a3ee$export$b1a120a2871faa46(data, "user", user);
    $613716288721a3ee$export$b1a120a2871faa46(data, "contexts", contexts);
    $613716288721a3ee$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $613716288721a3ee$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $613716288721a3ee$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $e628e125e878fd27$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $e628e125e878fd27$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $e628e125e878fd27$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $e628e125e878fd27$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $613716288721a3ee$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $613716288721a3ee$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $613716288721a3ee$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $e047a3e652f57c75$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $bc446a546b963a28$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $89d6805454b84092$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $e047a3e652f57c75$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $613716288721a3ee$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $806ed7b2edb8ea09$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $90705fab783f17f9$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $90705fab783f17f9$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $90705fab783f17f9$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $90705fab783f17f9$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $049d01d3a3164ac2$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $90705fab783f17f9$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $91c304fc757d5e0f$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $613716288721a3ee$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $503ba8c00efa1d46$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $503ba8c00efa1d46$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3199231328e69de5$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3199231328e69de5$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3199231328e69de5$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $90705fab783f17f9$export$aa55d5ab8e05984f() {
    if (!$90705fab783f17f9$var$globalScope) $90705fab783f17f9$var$globalScope = new $90705fab783f17f9$export$775b6bb06e53a214();
    return $90705fab783f17f9$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $90705fab783f17f9$export$c83048efd17527d6(scope) {
    $90705fab783f17f9$var$globalScope = scope;
}
function $90705fab783f17f9$var$generatePropagationContext() {
    return {
        traceId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16)
    };
}



const $725570364ca356d5$export$31499a9cd224b78c = "7.120.3";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9007972943bbf579$export$24a86ef7798177e4 = parseFloat((0, $725570364ca356d5$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9007972943bbf579$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $9007972943bbf579$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $9007972943bbf579$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $90705fab783f17f9$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $90705fab783f17f9$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9007972943bbf579$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $91c304fc757d5e0f$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $3199231328e69de5$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $9007972943bbf579$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $9007972943bbf579$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $6593ea065203555e$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $049d01d3a3164ac2$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $ebf395d8a45b5e48$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $049d01d3a3164ac2$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $049d01d3a3164ac2$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9007972943bbf579$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9007972943bbf579$export$19eade501500c6c1() {
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $25165aaf01761cfd$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$4188a14ad302d1bc(hub) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    const oldHub = $9007972943bbf579$export$bfa8a924a84a76b7(registry);
    $9007972943bbf579$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $9007972943bbf579$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $9007972943bbf579$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $9007972943bbf579$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$var$getGlobalHub(registry = $9007972943bbf579$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$bfa8a924a84a76b7(registry).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$849f05434e95d2f2(registry, new $9007972943bbf579$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $9007972943bbf579$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$236689a79f5aa020(carrier, parent = $9007972943bbf579$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$bfa8a924a84a76b7(carrier).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $9007972943bbf579$export$849f05434e95d2f2(carrier, new $9007972943bbf579$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $9007972943bbf579$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $9007972943bbf579$export$70d775fb1f267027(callback, options = {}) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9007972943bbf579$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $25165aaf01761cfd$export$7e223ec222791509)("hub", ()=>new $9007972943bbf579$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $2a06788518a26cc6$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $93473cbc517fed7c$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $0cd1337813906a62$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $0cd1337813906a62$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($0cd1337813906a62$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $0cd1337813906a62$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $0cd1337813906a62$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $0cd1337813906a62$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $0cd1337813906a62$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $0cd1337813906a62$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $0cd1337813906a62$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $0cd1337813906a62$var$defaultFunctionName;
        return fn.name || $0cd1337813906a62$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $0cd1337813906a62$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $0cd1337813906a62$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $93473cbc517fed7c$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $9ca32e18a091d955$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $9ca32e18a091d955$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $9ca32e18a091d955$export$a3295358bff77e(object, depth);
    if ($9ca32e18a091d955$var$jsonSize(normalized) > maxSize) return $9ca32e18a091d955$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $9ca32e18a091d955$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $2a06788518a26cc6$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $1e0be767ffa822d8$export$c9f5652083b8129d)(value)) return value;
    const stringified = $9ca32e18a091d955$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $9ca32e18a091d955$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $e628e125e878fd27$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $9ca32e18a091d955$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $9ca32e18a091d955$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $1e0be767ffa822d8$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $1e0be767ffa822d8$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $0cd1337813906a62$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $9ca32e18a091d955$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $9ca32e18a091d955$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $9ca32e18a091d955$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$var$jsonSize(value) {
    return $9ca32e18a091d955$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $9ca32e18a091d955$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $7b0dad5cf366cc16$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $91c304fc757d5e0f$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $7b0dad5cf366cc16$var$applyClientOptions(prepared, options);
    $7b0dad5cf366cc16$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $7b0dad5cf366cc16$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $7b0dad5cf366cc16$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $90705fab783f17f9$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $613716288721a3ee$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $613716288721a3ee$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $613716288721a3ee$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $503ba8c00efa1d46$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $503ba8c00efa1d46$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $7b0dad5cf366cc16$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $7b0dad5cf366cc16$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $7b0dad5cf366cc16$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $ebf395d8a45b5e48$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $7b0dad5cf366cc16$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $7b0dad5cf366cc16$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $7b0dad5cf366cc16$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $7b0dad5cf366cc16$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $7b0dad5cf366cc16$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $7b0dad5cf366cc16$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $7b0dad5cf366cc16$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $9ca32e18a091d955$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $9ca32e18a091d955$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $9ca32e18a091d955$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $9ca32e18a091d955$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $9ca32e18a091d955$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $e047a3e652f57c75$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $9ca32e18a091d955$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $7b0dad5cf366cc16$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $90705fab783f17f9$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $7b0dad5cf366cc16$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($7b0dad5cf366cc16$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $90705fab783f17f9$export$775b6bb06e53a214) || typeof hint === "function";
}
const $7b0dad5cf366cc16$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $7b0dad5cf366cc16$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$7b0dad5cf366cc16$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $81a395368bb6f380$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().captureException(exception, (0, $7b0dad5cf366cc16$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $81a395368bb6f380$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $81a395368bb6f380$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $81a395368bb6f380$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $81a395368bb6f380$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $81a395368bb6f380$export$9a4fed82c350c2bd(callback) {
    return (0, $9007972943bbf579$export$70d775fb1f267027)(()=>{
        return callback((0, $9007972943bbf579$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $81a395368bb6f380$export$e57ac09b143d92a2(span, callback) {
    return $81a395368bb6f380$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $81a395368bb6f380$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (!client) (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $81a395368bb6f380$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $81a395368bb6f380$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $91c304fc757d5e0f$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$4909b86c8034bf73(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$8360e631d277ea4d(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $81a395368bb6f380$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $81a395368bb6f380$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $81a395368bb6f380$export$3f95c6f800b78024() {
    return !!$81a395368bb6f380$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $81a395368bb6f380$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $81a395368bb6f380$export$c0d84948cecf78d8(context) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    const isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $ebf395d8a45b5e48$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $049d01d3a3164ac2$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $049d01d3a3164ac2$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $81a395368bb6f380$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $81a395368bb6f380$export$17a5be43989a0bc1() {
    const isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $049d01d3a3164ac2$export$56521d9ba90f62ee)(session);
    $81a395368bb6f380$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $81a395368bb6f380$var$_sendSessionUpdate() {
    const isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $81a395368bb6f380$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $81a395368bb6f380$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $81a395368bb6f380$var$_sendSessionUpdate();
}








const $51cfcbefde61ff20$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $51cfcbefde61ff20$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $51cfcbefde61ff20$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $806ed7b2edb8ea09$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $51cfcbefde61ff20$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $51cfcbefde61ff20$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $51cfcbefde61ff20$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $51cfcbefde61ff20$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($51cfcbefde61ff20$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $503ba8c00efa1d46$export$8e4e25f54d456511), (0, $9007972943bbf579$export$a07cdf6544bbd7c));
        $51cfcbefde61ff20$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $51cfcbefde61ff20$export$2d8f5188773bcddd(integration) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $51cfcbefde61ff20$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $51cfcbefde61ff20$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $51cfcbefde61ff20$export$2323046b9414659f(fn) {
    return fn;
}


let $ceb328f2f449885f$var$originalFunctionToString;
const $ceb328f2f449885f$var$INTEGRATION_NAME = "FunctionToString";
const $ceb328f2f449885f$var$SETUP_CLIENTS = new WeakMap();
const $ceb328f2f449885f$var$_functionToStringIntegration = ()=>{
    return {
        name: $ceb328f2f449885f$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $ceb328f2f449885f$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $e628e125e878fd27$export$e6cc1e135e2092e5)(this);
                    const context = $ceb328f2f449885f$var$SETUP_CLIENTS.has((0, $81a395368bb6f380$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $ceb328f2f449885f$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $ceb328f2f449885f$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $ceb328f2f449885f$export$7918117e9202e4fb = (0, $51cfcbefde61ff20$export$2323046b9414659f)($ceb328f2f449885f$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ceb328f2f449885f$export$da4704525c20ae79 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($ceb328f2f449885f$var$INTEGRATION_NAME, $ceb328f2f449885f$export$7918117e9202e4fb);



/** Regular expression used to parse a Dsn. */ const $f7133678d936cd5e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f7133678d936cd5e$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f7133678d936cd5e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $f7133678d936cd5e$export$b892860177f70a30(str) {
    const match = $f7133678d936cd5e$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $3199231328e69de5$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f7133678d936cd5e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f7133678d936cd5e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $f7133678d936cd5e$var$validateDsn(dsn) {
    if (!(0, $abe5418a531ee1d6$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$f7133678d936cd5e$var$isValidProtocol(protocol)) {
        (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $f7133678d936cd5e$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $f7133678d936cd5e$export$b892860177f70a30(from) : $f7133678d936cd5e$var$dsnFromComponents(from);
    if (!components || !$f7133678d936cd5e$var$validateDsn(components)) return undefined;
    return components;
}


const $d91612272370ed71$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $d91612272370ed71$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $d91612272370ed71$var$_getIngestEndpoint(dsn) {
    return `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $d91612272370ed71$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $e628e125e878fd27$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $d91612272370ed71$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $d91612272370ed71$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$d91612272370ed71$var$_getIngestEndpoint(dsn)}?${$d91612272370ed71$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $d91612272370ed71$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $499a1b6c2e7bd9e9$var$INTEGRATION_NAME = "InboundFilters";
const $499a1b6c2e7bd9e9$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $499a1b6c2e7bd9e9$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $499a1b6c2e7bd9e9$var$_mergeOptions(options, clientOptions);
            return $499a1b6c2e7bd9e9$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba = (0, $51cfcbefde61ff20$export$2323046b9414659f)($499a1b6c2e7bd9e9$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($499a1b6c2e7bd9e9$var$INTEGRATION_NAME, $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba);
function $499a1b6c2e7bd9e9$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $499a1b6c2e7bd9e9$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $499a1b6c2e7bd9e9$var$_isSentryError(event)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$499a1b6c2e7bd9e9$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event).some((message)=>(0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $499a1b6c2e7bd9e9$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? false : (0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $499a1b6c2e7bd9e9$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? true : (0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $6593ea065203555e$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $499a1b6c2e7bd9e9$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $93002778f3923c52$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $6593ea065203555e$export$16a28057038b10ef) (0, $3199231328e69de5$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $3199231328e69de5$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $93002778f3923c52$export$ecb76f41d43c0e43(client);
    $93002778f3923c52$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $93002778f3923c52$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $93002778f3923c52$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $a7f24c22762d2906$var$WINDOW = (0, $25165aaf01761cfd$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a7f24c22762d2906$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $a7f24c22762d2906$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $a7f24c22762d2906$var$WINDOW && !!$a7f24c22762d2906$var$WINDOW.history.pushState && !!$a7f24c22762d2906$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}





// We keep the handlers globally
const $9995ab194a6bc98e$var$handlers = {};
const $9995ab194a6bc98e$var$instrumented = {};
/** Add a handler function. */ function $9995ab194a6bc98e$export$a4e09611e30da72e(type, handler) {
    $9995ab194a6bc98e$var$handlers[type] = $9995ab194a6bc98e$var$handlers[type] || [];
    $9995ab194a6bc98e$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $9995ab194a6bc98e$export$b17eab759a1cb5fe() {
    Object.keys($9995ab194a6bc98e$var$handlers).forEach((key)=>{
        $9995ab194a6bc98e$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $9995ab194a6bc98e$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$9995ab194a6bc98e$var$instrumented[type]) {
        instrumentFn();
        $9995ab194a6bc98e$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $9995ab194a6bc98e$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $9995ab194a6bc98e$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $abe5418a531ee1d6$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $0cd1337813906a62$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


const $2579aac1b9dfd189$var$WINDOW = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
let $2579aac1b9dfd189$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2579aac1b9dfd189$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $2579aac1b9dfd189$var$instrumentHistory);
}
function $2579aac1b9dfd189$var$instrumentHistory() {
    if (!(0, $a7f24c22762d2906$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $2579aac1b9dfd189$var$WINDOW.onpopstate;
    $2579aac1b9dfd189$var$WINDOW.onpopstate = function(...args) {
        const to = $2579aac1b9dfd189$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $2579aac1b9dfd189$var$lastHref;
        $2579aac1b9dfd189$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $9995ab194a6bc98e$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $2579aac1b9dfd189$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $2579aac1b9dfd189$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $9995ab194a6bc98e$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $e628e125e878fd27$export$9563e054e6f787fb)($2579aac1b9dfd189$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $e628e125e878fd27$export$9563e054e6f787fb)($2579aac1b9dfd189$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




// eslint-disable-next-line deprecation/deprecation
const $a87a94b8e4ff7f26$var$WINDOW = (0, $25165aaf01761cfd$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $a87a94b8e4ff7f26$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a87a94b8e4ff7f26$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a87a94b8e4ff7f26$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a87a94b8e4ff7f26$export$18cf36ed71d733e7($a87a94b8e4ff7f26$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a87a94b8e4ff7f26$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a87a94b8e4ff7f26$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $abe5418a531ee1d6$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$531055a6c684a70a() {
    return "ReportingObserver" in $a87a94b8e4ff7f26$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $cb951e05ebb58c43$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $725570364ca356d5$export$31499a9cd224b78c)
            })),
        version: (0, $725570364ca356d5$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $2cae643f899492f0$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $2cae643f899492f0$export$604a45d95a155e2b(envelope, types) {
    return $2cae643f899492f0$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $2cae643f899492f0$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $2cae643f899492f0$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $2cae643f899492f0$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $2cae643f899492f0$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $9ca32e18a091d955$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $2cae643f899492f0$var$concatBuffers(parts);
}
function $2cae643f899492f0$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $2cae643f899492f0$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $2cae643f899492f0$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $2cae643f899492f0$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $e628e125e878fd27$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $2cae643f899492f0$export$b11169581eeaf237(type) {
    return $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $2cae643f899492f0$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $2cae643f899492f0$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $e628e125e878fd27$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $890c53ca2f6b4a7a$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $9b6c4c62dbf66cae$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2cae643f899492f0$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $9b6c4c62dbf66cae$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2cae643f899492f0$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $2cae643f899492f0$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $2915496cd851a181$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $e628e125e878fd27$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $2915496cd851a181$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $2915496cd851a181$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $2915496cd851a181$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $2915496cd851a181$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $2915496cd851a181$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $2915496cd851a181$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $2915496cd851a181$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $2915496cd851a181$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $2915496cd851a181$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $2915496cd851a181$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $2915496cd851a181$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $2915496cd851a181$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $2915496cd851a181$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $b86d5e61843389b9$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn);
    const item = $b86d5e61843389b9$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $b86d5e61843389b9$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $2915496cd851a181$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $5d4a5f71b683f78e$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(options.dsn);
        else (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $d91612272370ed71$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $806ed7b2edb8ea09$export$6de4ffac6a2f1098)(exception)) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $1e0be767ffa822d8$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $1e0be767ffa822d8$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $806ed7b2edb8ea09$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $049d01d3a3164ac2$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $51cfcbefde61ff20$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $51cfcbefde61ff20$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $9b6c4c62dbf66cae$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $2cae643f899492f0$export$d650323442802f6f)(env, (0, $2cae643f899492f0$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $9b6c4c62dbf66cae$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $b86d5e61843389b9$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $51cfcbefde61ff20$export$51abed9797baa598)(this, integrations);
        (0, $51cfcbefde61ff20$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $049d01d3a3164ac2$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $dde6191ffa17294f$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $7b0dad5cf366cc16$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $89d6805454b84092$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $6593ea065203555e$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $3199231328e69de5$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $3199231328e69de5$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $5d4a5f71b683f78e$var$isTransactionEvent(event);
        const isError = $5d4a5f71b683f78e$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $dde6191ffa17294f$export$78e43115b553f358)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $5d4a5f71b683f78e$var$processBeforeSend(options, prepared, hint);
            return $5d4a5f71b683f78e$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $5d4a5f71b683f78e$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $5d4a5f71b683f78e$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($5d4a5f71b683f78e$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($5d4a5f71b683f78e$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $5d4a5f71b683f78e$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $5d4a5f71b683f78e$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $5d4a5f71b683f78e$export$9aac0b9f77928fbf(callback) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $d90c5d9ac5d72442$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $91c304fc757d5e0f$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0af207894032bdf2$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0af207894032bdf2$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $817d897c5dc6d664$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $230372ac01587541$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $230372ac01587541$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $230372ac01587541$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $1e0be767ffa822d8$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $9ca32e18a091d955$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $230372ac01587541$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $230372ac01587541$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $230372ac01587541$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $230372ac01587541$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($230372ac01587541$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $230372ac01587541$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $230372ac01587541$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $230372ac01587541$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $1e0be767ffa822d8$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $230372ac01587541$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $1e0be767ffa822d8$export$ef9e2056653f0c8e)(exception) || (0, $1e0be767ffa822d8$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $1e0be767ffa822d8$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $806ed7b2edb8ea09$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $1e0be767ffa822d8$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(exception) || (0, $1e0be767ffa822d8$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $230372ac01587541$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $806ed7b2edb8ea09$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $1e0be767ffa822d8$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $e628e125e878fd27$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $1e0be767ffa822d8$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $1e0be767ffa822d8$export$9671ea99bd126ace)(exception)) {
        const className = $230372ac01587541$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $230372ac01587541$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $4e817323ced6d78c$export$56d8a8a25bd48b81 = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
let $4e817323ced6d78c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $4e817323ced6d78c$export$b79738ab10c590b2() {
    return $4e817323ced6d78c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $4e817323ced6d78c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $4e817323ced6d78c$var$ignoreOnError++;
    setTimeout(()=>{
        $4e817323ced6d78c$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $4e817323ced6d78c$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $e628e125e878fd27$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$4e817323ced6d78c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $4e817323ced6d78c$export$1265a142ff5ba165();
            (0, $81a395368bb6f380$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $806ed7b2edb8ea09$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $81a395368bb6f380$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $e628e125e878fd27$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $e628e125e878fd27$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $b03dbb36f8019264$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $c55795097f9daeb0$export$1df9218a526d318d extends (0, $5d4a5f71b683f78e$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $0af207894032bdf2$export$8ad33f488b1ab046)();
        (0, $cb951e05ebb58c43$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $230372ac01587541$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $230372ac01587541$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $b03dbb36f8019264$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $d90c5d9ac5d72442$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $f7133678d936cd5e$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $6dad95eb90f2d36c$var$WINDOW = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
const $6dad95eb90f2d36c$var$DEBOUNCE_DURATION = 1000;
let $6dad95eb90f2d36c$var$debounceTimerID;
let $6dad95eb90f2d36c$var$lastCapturedEventType;
let $6dad95eb90f2d36c$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6dad95eb90f2d36c$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $6dad95eb90f2d36c$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $6dad95eb90f2d36c$export$3014bbf0af0e1d4a() {
    if (!$6dad95eb90f2d36c$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $9995ab194a6bc98e$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler, true);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $6dad95eb90f2d36c$var$WINDOW[target] && $6dad95eb90f2d36c$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $e628e125e878fd27$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $e628e125e878fd27$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $6dad95eb90f2d36c$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $6dad95eb90f2d36c$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $6dad95eb90f2d36c$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $6dad95eb90f2d36c$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $6dad95eb90f2d36c$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($6dad95eb90f2d36c$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $e628e125e878fd27$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $e628e125e878fd27$export$e73679ffaf56810e)(target, "_sentryId", (0, $806ed7b2edb8ea09$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $6dad95eb90f2d36c$var$lastCapturedEventType = event.type;
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($6dad95eb90f2d36c$var$debounceTimerID);
        $6dad95eb90f2d36c$var$debounceTimerID = $6dad95eb90f2d36c$var$WINDOW.setTimeout(()=>{
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = undefined;
            $6dad95eb90f2d36c$var$lastCapturedEventType = undefined;
        }, $6dad95eb90f2d36c$var$DEBOUNCE_DURATION);
    };
}
function $6dad95eb90f2d36c$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d81ce3377b27def9$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $d81ce3377b27def9$var$instrumentConsole);
}
function $d81ce3377b27def9$var$instrumentConsole() {
    if (!("console" in (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1))) return;
    (0, $3199231328e69de5$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console)) return;
        (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $3199231328e69de5$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $9995ab194a6bc98e$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $3199231328e69de5$export$77c4ce905194557b)[level];
                log && log.apply((0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $deebfb2c2f3e82fb$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $deebfb2c2f3e82fb$var$instrumentFetch);
}
function $deebfb2c2f3e82fb$var$instrumentFetch() {
    if (!(0, $a87a94b8e4ff7f26$export$c82d238e23c40b21)()) return;
    (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $25165aaf01761cfd$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $deebfb2c2f3e82fb$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $9995ab194a6bc98e$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $25165aaf01761cfd$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $9995ab194a6bc98e$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $9995ab194a6bc98e$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $deebfb2c2f3e82fb$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $deebfb2c2f3e82fb$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($deebfb2c2f3e82fb$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $deebfb2c2f3e82fb$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $deebfb2c2f3e82fb$var$getUrlFromResource(url),
            method: $deebfb2c2f3e82fb$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $deebfb2c2f3e82fb$var$getUrlFromResource(arg),
        method: $deebfb2c2f3e82fb$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $ae6dc6125d1c3217$var$WINDOW = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
const $ae6dc6125d1c3217$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ae6dc6125d1c3217$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $ae6dc6125d1c3217$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $ae6dc6125d1c3217$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$ae6dc6125d1c3217$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $e628e125e878fd27$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $1e0be767ffa822d8$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $ae6dc6125d1c3217$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $9995ab194a6bc98e$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $e628e125e878fd27$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $e628e125e878fd27$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $1e0be767ffa822d8$export$844ec244b1367d54)(header) && (0, $1e0be767ffa822d8$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $e628e125e878fd27$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $9995ab194a6bc98e$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $ae6dc6125d1c3217$var$parseUrl(url) {
    if ((0, $1e0be767ffa822d8$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $25257edadcf16f49$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $25257edadcf16f49$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $25257edadcf16f49$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $25257edadcf16f49$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $7f06244a5e0d22e8$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $7f06244a5e0d22e8$export$e01cef29b4327697(level) {
    return $7f06244a5e0d22e8$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $7f06244a5e0d22e8$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $7f06244a5e0d22e8$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $b50dad0732e7f682$var$INTEGRATION_NAME = "Breadcrumbs";
const $b50dad0732e7f682$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $b50dad0732e7f682$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $d81ce3377b27def9$export$1d6e0d073f9e6723)($b50dad0732e7f682$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $6dad95eb90f2d36c$export$5aeffd3db2cf9df7)($b50dad0732e7f682$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $ae6dc6125d1c3217$export$26ace48dd54c9aea)($b50dad0732e7f682$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $deebfb2c2f3e82fb$export$f75d3c772c923df0)($b50dad0732e7f682$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $2579aac1b9dfd189$export$3f18c56c58114e75)($b50dad0732e7f682$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $b50dad0732e7f682$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $b50dad0732e7f682$export$c079d904b326663a = (0, $51cfcbefde61ff20$export$2323046b9414659f)($b50dad0732e7f682$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b50dad0732e7f682$export$2dc68d50d56fbbd = (0, $51cfcbefde61ff20$export$afa219bf23651160)($b50dad0732e7f682$var$INTEGRATION_NAME, $b50dad0732e7f682$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $b50dad0732e7f682$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        (0, $81a395368bb6f380$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $b50dad0732e7f682$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $b50dad0732e7f682$var$_isEvent(event) ? event.target : event;
            target = (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $d3dd25a69ce66c78$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $81a395368bb6f380$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $b50dad0732e7f682$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $7f06244a5e0d22e8$export$d771ef054122c30a)(handlerData.level),
            message: (0, $692fb1c9fae23fc3$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $692fb1c9fae23fc3$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $81a395368bb6f380$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $b50dad0732e7f682$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $81a395368bb6f380$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $b50dad0732e7f682$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $81a395368bb6f380$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $81a395368bb6f380$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $b50dad0732e7f682$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $25257edadcf16f49$export$7a5253c0f62e0150)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $25257edadcf16f49$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $81a395368bb6f380$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $b50dad0732e7f682$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $893f0ce260470ef7$var$INTEGRATION_NAME = "Dedupe";
const $893f0ce260470ef7$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $893f0ce260470ef7$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $893f0ce260470ef7$export$6d39aa44cd0c7567 = (0, $51cfcbefde61ff20$export$2323046b9414659f)($893f0ce260470ef7$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $893f0ce260470ef7$export$688d98c249d31ad3 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($893f0ce260470ef7$var$INTEGRATION_NAME, $893f0ce260470ef7$export$6d39aa44cd0c7567);
function $893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $893f0ce260470ef7$var$_getExceptionFromEvent(previousEvent);
    const currentException = $893f0ce260470ef7$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $893f0ce260470ef7$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $893f0ce260470ef7$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $893f0ce260470ef7$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $893f0ce260470ef7$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}





let $d70977d9b36915fd$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d70977d9b36915fd$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $d70977d9b36915fd$var$instrumentError);
}
function $d70977d9b36915fd$var$instrumentError() {
    $d70977d9b36915fd$var$_oldOnErrorHandler = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onerror;
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $9995ab194a6bc98e$export$b18c893e424d3127)("error", handlerData);
        if ($d70977d9b36915fd$var$_oldOnErrorHandler && !$d70977d9b36915fd$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d70977d9b36915fd$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a4223cccebdcb864$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $a4223cccebdcb864$var$instrumentUnhandledRejection);
}
function $a4223cccebdcb864$var$instrumentUnhandledRejection() {
    $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $9995ab194a6bc98e$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler && !$a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $9d72a78ef45a7c39$var$INTEGRATION_NAME = "GlobalHandlers";
const $9d72a78ef45a7c39$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $9d72a78ef45a7c39$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler(client);
                $9d72a78ef45a7c39$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler(client);
                $9d72a78ef45a7c39$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $9d72a78ef45a7c39$export$66acc70e8cf2b71a = (0, $51cfcbefde61ff20$export$2323046b9414659f)($9d72a78ef45a7c39$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9d72a78ef45a7c39$export$204155decbc90e5a = (0, $51cfcbefde61ff20$export$afa219bf23651160)($9d72a78ef45a7c39$var$INTEGRATION_NAME, $9d72a78ef45a7c39$export$66acc70e8cf2b71a);
function $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler(client) {
    (0, $d70977d9b36915fd$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9d72a78ef45a7c39$var$getOptions();
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client || (0, $4e817323ced6d78c$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $1e0be767ffa822d8$export$844ec244b1367d54)(msg) ? $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) : $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame((0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $81a395368bb6f380$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $a4223cccebdcb864$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9d72a78ef45a7c39$var$getOptions();
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client || (0, $4e817323ced6d78c$export$b79738ab10c590b2)()) return;
        const error = $9d72a78ef45a7c39$var$_getUnhandledRejectionError(e);
        const event = (0, $1e0be767ffa822d8$export$c3825b437cbdea5c)(error) ? $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(error) : (0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $81a395368bb6f380$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $9d72a78ef45a7c39$var$_getUnhandledRejectionError(error) {
    if ((0, $1e0be767ffa822d8$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $1e0be767ffa822d8$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $1e0be767ffa822d8$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $d3dd25a69ce66c78$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9d72a78ef45a7c39$var$globalHandlerLog(type) {
    (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $9d72a78ef45a7c39$var$getOptions() {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $a609b75c449d57c1$var$INTEGRATION_NAME = "HttpContext";
const $a609b75c449d57c1$var$_httpContextIntegration = ()=>{
    return {
        name: $a609b75c449d57c1$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).navigator && !(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location && !(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $a609b75c449d57c1$export$1378794447170364 = (0, $51cfcbefde61ff20$export$2323046b9414659f)($a609b75c449d57c1$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a609b75c449d57c1$export$5d2ee9a544b09a94 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($a609b75c449d57c1$var$INTEGRATION_NAME, $a609b75c449d57c1$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $021240852b914991$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $1e0be767ffa822d8$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $021240852b914991$var$truncateAggregateExceptions($021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $1e0be767ffa822d8$export$49034edbe6b62415)(error[key], Error)) {
        $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $1e0be767ffa822d8$export$49034edbe6b62415)(childError, Error)) {
            $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $021240852b914991$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $021240852b914991$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $732232d08e00e18c$var$DEFAULT_KEY = "cause";
const $732232d08e00e18c$var$DEFAULT_LIMIT = 5;
const $732232d08e00e18c$var$INTEGRATION_NAME = "LinkedErrors";
const $732232d08e00e18c$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $732232d08e00e18c$var$DEFAULT_LIMIT;
    const key = options.key || $732232d08e00e18c$var$DEFAULT_KEY;
    return {
        name: $732232d08e00e18c$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $021240852b914991$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $230372ac01587541$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $732232d08e00e18c$export$ebabb00eb7f3a395 = (0, $51cfcbefde61ff20$export$2323046b9414659f)($732232d08e00e18c$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $732232d08e00e18c$export$8d1e60aaf616fb4f = (0, $51cfcbefde61ff20$export$afa219bf23651160)($732232d08e00e18c$var$INTEGRATION_NAME, $732232d08e00e18c$export$ebabb00eb7f3a395);





const $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $f8ac3caec1ed9186$var$INTEGRATION_NAME = "TryCatch";
const $f8ac3caec1ed9186$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $f8ac3caec1ed9186$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), "setTimeout", $f8ac3caec1ed9186$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), "setInterval", $f8ac3caec1ed9186$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), "requestAnimationFrame", $f8ac3caec1ed9186$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $4e817323ced6d78c$export$56d8a8a25bd48b81)) (0, $e628e125e878fd27$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $f8ac3caec1ed9186$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($f8ac3caec1ed9186$var$_wrapEventTarget);
            }
        }
    };
};
const $f8ac3caec1ed9186$export$59bfe9f1c76150e = (0, $51cfcbefde61ff20$export$2323046b9414659f)($f8ac3caec1ed9186$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f8ac3caec1ed9186$export$f1a018517668e6d3 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($f8ac3caec1ed9186$var$INTEGRATION_NAME, $f8ac3caec1ed9186$export$59bfe9f1c76150e);
function $f8ac3caec1ed9186$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $0cd1337813906a62$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f8ac3caec1ed9186$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $4e817323ced6d78c$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $0cd1337813906a62$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $f8ac3caec1ed9186$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $e628e125e878fd27$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $0cd1337813906a62$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $e628e125e878fd27$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $0cd1337813906a62$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $f8ac3caec1ed9186$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $e628e125e878fd27$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $0cd1337813906a62$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $0cd1337813906a62$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $e628e125e878fd27$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $6fa852429033a8df$var$UNKNOWN_FUNCTION = "?";
const $6fa852429033a8df$var$OPERA10_PRIORITY = 10;
const $6fa852429033a8df$var$OPERA11_PRIORITY = 20;
const $6fa852429033a8df$var$CHROME_PRIORITY = 30;
const $6fa852429033a8df$var$WINJS_PRIORITY = 40;
const $6fa852429033a8df$var$GECKO_PRIORITY = 50;
function $6fa852429033a8df$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $6fa852429033a8df$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $6fa852429033a8df$var$chromeStackParserFn = (line)=>{
    const parts = $6fa852429033a8df$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, parts[2]);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$263a749fff749872 = [
    $6fa852429033a8df$var$CHROME_PRIORITY,
    $6fa852429033a8df$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $6fa852429033a8df$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $6fa852429033a8df$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $6fa852429033a8df$var$gecko = (line)=>{
    const parts = $6fa852429033a8df$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION;
        [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(func, filename);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$cdba47a5dd2804d = [
    $6fa852429033a8df$var$GECKO_PRIORITY,
    $6fa852429033a8df$var$gecko
];
const $6fa852429033a8df$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$winjs = (line)=>{
    const parts = $6fa852429033a8df$var$winjsRegex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $6fa852429033a8df$export$179460296da408e8 = [
    $6fa852429033a8df$var$WINJS_PRIORITY,
    $6fa852429033a8df$var$winjs
];
const $6fa852429033a8df$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $6fa852429033a8df$var$opera10 = (line)=>{
    const parts = $6fa852429033a8df$var$opera10Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[3] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $6fa852429033a8df$export$f892b52c880ffc7a = [
    $6fa852429033a8df$var$OPERA10_PRIORITY,
    $6fa852429033a8df$var$opera10
];
const $6fa852429033a8df$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $6fa852429033a8df$var$opera11 = (line)=>{
    const parts = $6fa852429033a8df$var$opera11Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[5], parts[3] || parts[4] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $6fa852429033a8df$export$af11af13f09fb0dc = [
    $6fa852429033a8df$var$OPERA11_PRIORITY,
    $6fa852429033a8df$var$opera11
];
const $6fa852429033a8df$export$7197c0fe6554c079 = [
    $6fa852429033a8df$export$263a749fff749872,
    $6fa852429033a8df$export$cdba47a5dd2804d,
    $6fa852429033a8df$export$179460296da408e8
];
const $6fa852429033a8df$export$2b2b997d81bf3907 = (0, $0cd1337813906a62$export$a5739666fb2d03d4)(...$6fa852429033a8df$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $6fa852429033a8df$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $6fa852429033a8df$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $e02662e4aa308398$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $e02662e4aa308398$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $e02662e4aa308398$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $e02662e4aa308398$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $e02662e4aa308398$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $e02662e4aa308398$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $e21a1e6dd57da767$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $dde6191ffa17294f$export$78e43115b553f358)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $dde6191ffa17294f$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $551fd97e865f07d3$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $551fd97e865f07d3$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $e21a1e6dd57da767$export$85a4f67f852183e6)(options.bufferSize || $551fd97e865f07d3$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $2cae643f899492f0$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $2cae643f899492f0$export$b11169581eeaf237)(type);
            if ((0, $e02662e4aa308398$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $2cae643f899492f0$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $2cae643f899492f0$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $2cae643f899492f0$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $e02662e4aa308398$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) {
                (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $7d25350de9c66b8e$export$8be2119ce08e3379() {
    if ($7d25350de9c66b8e$var$cachedFetchImpl) return $7d25350de9c66b8e$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $a87a94b8e4ff7f26$export$18cf36ed71d733e7)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch)) return $7d25350de9c66b8e$var$cachedFetchImpl = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch.bind((0, $4e817323ced6d78c$export$56d8a8a25bd48b81));
    const document = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $7d25350de9c66b8e$var$cachedFetchImpl = fetchImpl.bind((0, $4e817323ced6d78c$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $7d25350de9c66b8e$export$d499686d2dd738c6() {
    $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9237c8bb75383bbf$export$b2311068c46d7cc8(options, nativeFetch = (0, $7d25350de9c66b8e$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $7d25350de9c66b8e$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $dde6191ffa17294f$export$78e43115b553f358)(e);
        }
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $8be23756f879b8e4$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $8be23756f879b8e4$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $dde6191ffa17294f$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $8be23756f879b8e4$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $4c87801c815e53f1$export$5ef831fccfce35e5 = [
    (0, $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba)(),
    (0, $ceb328f2f449885f$export$7918117e9202e4fb)(),
    (0, $f8ac3caec1ed9186$export$59bfe9f1c76150e)(),
    (0, $b50dad0732e7f682$export$c079d904b326663a)(),
    (0, $9d72a78ef45a7c39$export$66acc70e8cf2b71a)(),
    (0, $732232d08e00e18c$export$ebabb00eb7f3a395)(),
    (0, $893f0ce260470ef7$export$6d39aa44cd0c7567)(),
    (0, $a609b75c449d57c1$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $4c87801c815e53f1$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$4c87801c815e53f1$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $4c87801c815e53f1$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4c87801c815e53f1$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $0cd1337813906a62$export$1d5cf88b347146d4)(options.stackParser || (0, $6fa852429033a8df$export$2b2b997d81bf3907)),
        integrations: (0, $51cfcbefde61ff20$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e)() ? (0, $9237c8bb75383bbf$export$b2311068c46d7cc8) : (0, $8be23756f879b8e4$export$5e1441cee30d5a39))
    };
    (0, $93002778f3923c52$export$5333c3f1c58d9bc1)((0, $c55795097f9daeb0$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $4c87801c815e53f1$var$startSessionTracking();
}
const $4c87801c815e53f1$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $d91612272370ed71$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.head || (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4c87801c815e53f1$export$4997ffc0176396a6(fn) {
    return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4c87801c815e53f1$var$startSessionTracking() {
    if (typeof (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $81a395368bb6f380$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $81a395368bb6f380$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $2579aac1b9dfd189$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $81a395368bb6f380$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $81a395368bb6f380$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $4c87801c815e53f1$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $795a7664e1a3c052$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $cb951e05ebb58c43$export$b9f95b027256052c)(opts, "react");
    (0, $4c87801c815e53f1$export$2cd8252107eb640b)(opts);
}


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $aS1Zy = parcelRequire("aS1Zy");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $aS1Zy.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $aS1Zy.hydrateRoot;


var $2d93712440e0508b$exports = {};
/**
 * Relay v18.2.0
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
$2d93712440e0508b$exports = (parcelRequire("bNos8"));


var $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9;
(function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
})($9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9 || ($9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9 = {}));




var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $acw62 = parcelRequire("acw62");
var $cbc5b5bd3160fa7c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $acw62.createContext)("elevation.surface");
var $cbc5b5bd3160fa7c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $acw62.useContext)($cbc5b5bd3160fa7c$export$1ca2a26fecb070ae);
};
$cbc5b5bd3160fa7c$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");

var $cfuBi = parcelRequire("cfuBi");
function $bcbfa6eabcc99f23$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bcbfa6eabcc99f23$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bcbfa6eabcc99f23$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bcbfa6eabcc99f23$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bcbfa6eabcc99f23$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $bcbfa6eabcc99f23$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $bcbfa6eabcc99f23$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $bcbfa6eabcc99f23$export$632685d741f3dbbf = $bcbfa6eabcc99f23$var$_objectSpread($bcbfa6eabcc99f23$var$_objectSpread({}, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4), $bcbfa6eabcc99f23$export$d2dc61f58390201c);
var $bcbfa6eabcc99f23$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $bcbfa6eabcc99f23$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $bcbfa6eabcc99f23$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $bcbfa6eabcc99f23$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $bcbfa6eabcc99f23$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $bcbfa6eabcc99f23$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $bcbfa6eabcc99f23$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $bcbfa6eabcc99f23$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $bcbfa6eabcc99f23$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $bcbfa6eabcc99f23$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $bcbfa6eabcc99f23$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $bcbfa6eabcc99f23$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $bcbfa6eabcc99f23$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $bcbfa6eabcc99f23$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $bcbfa6eabcc99f23$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $bcbfa6eabcc99f23$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $bcbfa6eabcc99f23$export$e615f061ca585a6c = $bcbfa6eabcc99f23$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7(spacingProperty, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $bcbfa6eabcc99f23$export$bf46c3f9eeafc71f = $bcbfa6eabcc99f23$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7(spacingProperty, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $bcbfa6eabcc99f23$export$e7af83bafe7f9e63 = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7("backgroundColor", $bcbfa6eabcc99f23$export$d1d79bf68ac056bd);
var $bcbfa6eabcc99f23$export$3a1bcba60b23d7f0 = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7("color", $bcbfa6eabcc99f23$export$8473307aa00d6ea1);
var $bcbfa6eabcc99f23$export$45f3f4fe16f9f7d5 = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7("fontWeight", $bcbfa6eabcc99f23$export$303e322c6b1ed114);
var $bcbfa6eabcc99f23$export$68cc305da27dbaa4 = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7("fontFamily", $bcbfa6eabcc99f23$export$3c7e9587132614b4);
var $bcbfa6eabcc99f23$export$128f10c238242f83 = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7("font", $bcbfa6eabcc99f23$export$6ffa317d5e70375);
var $bcbfa6eabcc99f23$export$219d364c0da35ae4 = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7("font", $bcbfa6eabcc99f23$export$236bfe3a33ef1292);
var $bcbfa6eabcc99f23$export$38845ca010b93505 = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7("fontWeight", $bcbfa6eabcc99f23$export$855cfd311192d666);
var $bcbfa6eabcc99f23$export$ff257d957d48c421 = $bcbfa6eabcc99f23$export$ca0f9c2de39ffed7((0, $cfuBi.CURRENT_SURFACE_CSS_VAR), $bcbfa6eabcc99f23$export$41a358c9c2356760);
var $bcbfa6eabcc99f23$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $bcbfa6eabcc99f23$export$41a358c9c2356760[color] !== undefined;
};



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $jjlaj = parcelRequire("jjlaj");


var $hPtJY = parcelRequire("hPtJY");
function $d8fb25f1eb78afec$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d8fb25f1eb78afec$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d8fb25f1eb78afec$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d8fb25f1eb78afec$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d8fb25f1eb78afec$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d8fb25f1eb78afec$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $d8fb25f1eb78afec$export$9a199fbafee0014e = {
    backgroundColor: (0, $bcbfa6eabcc99f23$export$d1d79bf68ac056bd),
    blockSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderBottomColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderLeftColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $bcbfa6eabcc99f23$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    borderWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    bottom: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    boxShadow: (0, $bcbfa6eabcc99f23$export$7aff6e7ba39bb774),
    color: (0, $bcbfa6eabcc99f23$export$8473307aa00d6ea1),
    columnGap: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    font: (0, $bcbfa6eabcc99f23$export$6ffa317d5e70375),
    fontFamily: (0, $bcbfa6eabcc99f23$export$3c7e9587132614b4),
    fontWeight: (0, $bcbfa6eabcc99f23$export$303e322c6b1ed114),
    gap: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    height: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    inlineSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    inset: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetBlock: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetBlockEnd: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetBlockStart: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetInline: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetInlineEnd: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    insetInlineStart: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    left: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    margin: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginBlock: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginBlockEnd: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginBlockStart: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginBottom: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginInline: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginInlineEnd: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginInlineStart: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginLeft: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginRight: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    marginTop: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    maxBlockSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    maxHeight: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    maxWidth: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    minBlockSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    minHeight: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    minInlineSize: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    minWidth: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    opacity: (0, $bcbfa6eabcc99f23$export$daf94a976c798b4f),
    outlineColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac),
    outlineOffset: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    outlineWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8),
    padding: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingBlock: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingBottom: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingInline: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingLeft: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingRight: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    paddingTop: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    right: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    rowGap: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4),
    top: (0, $bcbfa6eabcc99f23$export$632685d741f3dbbf),
    width: (0, $bcbfa6eabcc99f23$export$6ccdbebca2ee545f),
    zIndex: (0, $bcbfa6eabcc99f23$export$b5f31a7e431d2eab)
};
var $d8fb25f1eb78afec$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $d8fb25f1eb78afec$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $hPtJY === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))($hPtJY.env) === "object" && false;
};
var $d8fb25f1eb78afec$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $d8fb25f1eb78afec$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $d8fb25f1eb78afec$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($d8fb25f1eb78afec$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value) === "object" && $d8fb25f1eb78afec$var$safeSelectors.test(key)) {
            styleObj[key] = $d8fb25f1eb78afec$var$_transformStyles(value);
            return;
        }
        if ($d8fb25f1eb78afec$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($d8fb25f1eb78afec$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $d8fb25f1eb78afec$export$9a199fbafee0014e)) return;
        var tokenValue = $d8fb25f1eb78afec$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $d8fb25f1eb78afec$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $d8fb25f1eb78afec$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $d8fb25f1eb78afec$var$uniqueSymbol, (0, $jjlaj.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $d8fb25f1eb78afec$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $d8fb25f1eb78afec$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $d8fb25f1eb78afec$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$d8fb25f1eb78afec$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $d8fb25f1eb78afec$export$f6c783d06584602c(style) {
    return $d8fb25f1eb78afec$var$baseXcss(style);
}


var $9c14666919da07a2$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $9c14666919da07a2$var$_excluded2 = [
    "className"
];
var $9c14666919da07a2$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $9c14666919da07a2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $9c14666919da07a2$var$_excluded2);
    var resolvedStyles = (0, $d8fb25f1eb78afec$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $9c14666919da07a2$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $bcbfa6eabcc99f23$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bcbfa6eabcc99f23$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $bcbfa6eabcc99f23$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jjlaj.jsx)((0, $cbc5b5bd3160fa7c$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $9c14666919da07a2$export$2e2bcd8739ae039 = $9c14666919da07a2$export$e71c4d32a2263218;
var $9c14666919da07a2$var$baseStyles = (0, $jjlaj.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $a21fdd6b3432b612$var$justifyContentMap = {
    start: (0, $jjlaj.css)({
        justifyContent: "start"
    }),
    center: (0, $jjlaj.css)({
        justifyContent: "center"
    }),
    end: (0, $jjlaj.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jjlaj.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jjlaj.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jjlaj.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jjlaj.css)({
        justifyContent: "stretch"
    })
};
var $a21fdd6b3432b612$var$flexDirectionMap = {
    column: (0, $jjlaj.css)({
        flexDirection: "column"
    }),
    row: (0, $jjlaj.css)({
        flexDirection: "row"
    })
};
var $a21fdd6b3432b612$var$flexWrapMap = {
    wrap: (0, $jjlaj.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $jjlaj.css)({
        flexWrap: "nowrap"
    })
};
var $a21fdd6b3432b612$var$alignItemsMap = {
    start: (0, $jjlaj.css)({
        alignItems: "start"
    }),
    center: (0, $jjlaj.css)({
        alignItems: "center"
    }),
    baseline: (0, $jjlaj.css)({
        alignItems: "baseline"
    }),
    end: (0, $jjlaj.css)({
        alignItems: "end"
    }),
    stretch: (0, $jjlaj.css)({
        alignItems: "stretch"
    })
};
var $a21fdd6b3432b612$var$baseStyles = (0, $jjlaj.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $a21fdd6b3432b612$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $d8fb25f1eb78afec$export$a9c84988c8f81f2d)(xcss);
    return (0, $jjlaj.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $a21fdd6b3432b612$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $bcbfa6eabcc99f23$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $bcbfa6eabcc99f23$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $bcbfa6eabcc99f23$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $a21fdd6b3432b612$var$alignItemsMap[alignItems],
            direction && $a21fdd6b3432b612$var$flexDirectionMap[direction],
            justifyContent && $a21fdd6b3432b612$var$justifyContentMap[justifyContent],
            wrap && $a21fdd6b3432b612$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$a21fdd6b3432b612$var$Flex.displayName = "Flex";
var $a21fdd6b3432b612$export$2e2bcd8739ae039 = $a21fdd6b3432b612$var$Flex;


var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $e4508b4e9680dfdd$var$gridTemplateAreasVar = "--ds-grid--grid-template-areas";
var $e4508b4e9680dfdd$var$gridTemplateColumnsVar = "--ds-grid--grid-template-columns";
var $e4508b4e9680dfdd$var$gridTemplateRowsVar = "--ds-grid--grid-template-rows";
var $e4508b4e9680dfdd$var$justifyContentMap = {
    start: (0, $jjlaj.css)({
        justifyContent: "start"
    }),
    center: (0, $jjlaj.css)({
        justifyContent: "center"
    }),
    end: (0, $jjlaj.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jjlaj.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jjlaj.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jjlaj.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jjlaj.css)({
        justifyContent: "stretch"
    })
};
var $e4508b4e9680dfdd$var$justifyItemsMap = {
    start: (0, $jjlaj.css)({
        justifyItems: "start"
    }),
    center: (0, $jjlaj.css)({
        justifyItems: "center"
    }),
    end: (0, $jjlaj.css)({
        justifyItems: "end"
    }),
    stretch: (0, $jjlaj.css)({
        justifyItems: "stretch"
    })
};
var $e4508b4e9680dfdd$var$alignContentMap = {
    start: (0, $jjlaj.css)({
        alignContent: "start"
    }),
    center: (0, $jjlaj.css)({
        alignContent: "center"
    }),
    end: (0, $jjlaj.css)({
        alignContent: "end"
    }),
    "space-between": (0, $jjlaj.css)({
        alignContent: "space-between"
    }),
    "space-around": (0, $jjlaj.css)({
        alignContent: "space-around"
    }),
    "space-evenly": (0, $jjlaj.css)({
        alignContent: "space-evenly"
    }),
    stretch: (0, $jjlaj.css)({
        alignContent: "stretch"
    })
};
var $e4508b4e9680dfdd$var$alignItemsMap = {
    start: (0, $jjlaj.css)({
        alignItems: "start"
    }),
    center: (0, $jjlaj.css)({
        alignItems: "center"
    }),
    baseline: (0, $jjlaj.css)({
        alignItems: "baseline"
    }),
    end: (0, $jjlaj.css)({
        alignItems: "end"
    })
};
var $e4508b4e9680dfdd$var$baseStyles = (0, $jjlaj.css)({
    display: "grid",
    boxSizing: "border-box",
    gridTemplateAreas: "var(".concat($e4508b4e9680dfdd$var$gridTemplateAreasVar, ")"),
    gridTemplateColumns: "var(".concat($e4508b4e9680dfdd$var$gridTemplateColumnsVar, ")"),
    gridTemplateRows: "var(".concat($e4508b4e9680dfdd$var$gridTemplateRowsVar, ")")
});
var $e4508b4e9680dfdd$var$gridAutoFlowMap = {
    row: (0, $jjlaj.css)({
        gridAutoFlow: "row"
    }),
    column: (0, $jjlaj.css)({
        gridAutoFlow: "column"
    }),
    dense: (0, $jjlaj.css)({
        gridAutoFlow: "dense"
    }),
    "row dense": (0, $jjlaj.css)({
        gridAutoFlow: "row dense"
    }),
    "column dense": (0, $jjlaj.css)({
        gridAutoFlow: "column dense"
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $e4508b4e9680dfdd$var$Grid = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || "div";
    var resolvedStyles = (0, $d8fb25f1eb78afec$export$a9c84988c8f81f2d)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ var style = (0, $acw62.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $e4508b4e9680dfdd$var$gridTemplateAreasVar, gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return '"'.concat(str, '"');
        }).join("\n") || "initial" : "initial"), $e4508b4e9680dfdd$var$gridTemplateColumnsVar, gridTemplateColumns || "initial"), $e4508b4e9680dfdd$var$gridTemplateRowsVar, gridTemplateRows || "initial");
    }, [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $jjlaj.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $e4508b4e9680dfdd$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $bcbfa6eabcc99f23$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $bcbfa6eabcc99f23$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $bcbfa6eabcc99f23$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $e4508b4e9680dfdd$var$alignItemsMap[alignItems],
            alignContent && $e4508b4e9680dfdd$var$alignContentMap[alignContent],
            justifyContent && $e4508b4e9680dfdd$var$justifyContentMap[justifyContent],
            autoFlow && $e4508b4e9680dfdd$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$e4508b4e9680dfdd$var$Grid.displayName = "Grid";
var $e4508b4e9680dfdd$export$2e2bcd8739ae039 = $e4508b4e9680dfdd$var$Grid;


var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $7e9cd1185a5decf2$var$flexGrowMap = {
    hug: (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $7e9cd1185a5decf2$var$Stack = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $7e9cd1185a5decf2$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jjlaj.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$7e9cd1185a5decf2$var$Stack.displayName = "Stack";
var $7e9cd1185a5decf2$export$2e2bcd8739ae039 = $7e9cd1185a5decf2$var$Stack;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");
function $e3ed46ff97b993f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3ed46ff97b993f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3ed46ff97b993f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3ed46ff97b993f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e3ed46ff97b993f0$var$shimmerKeyframes = null;
var $e3ed46ff97b993f0$var$skeletonStyles = null;
var $e3ed46ff97b993f0$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ var $e3ed46ff97b993f0$var$Skeleton = function Skeleton(_ref) {
    var width = _ref.width, height = _ref.height, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? "100px" : _ref$borderRadius, color = _ref.color, ShimmeringEndColor = _ref.ShimmeringEndColor, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, groupName = _ref.groupName, testId = _ref.testId;
    var groupDataAttribute = groupName && "data-".concat(groupName);
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId
    }, groupDataAttribute && (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, groupDataAttribute, "true"), {
        className: (0, $5zphJ.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq586c"
        ]),
        style: $e3ed46ff97b993f0$var$_objectSpread($e3ed46ff97b993f0$var$_objectSpread({}, {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            "--ds-skeleton-from-color": color && ShimmeringEndColor ? color : undefined,
            "--ds-skeleton-to-color": color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        }), {}, {
            "--_wenvhl": (0, $cZGu3.default)("var(--ds-skeleton-from-color, ".concat("var(--ds-skeleton, #091E420F)", ")")),
            "--_1soe2er": (0, $cZGu3.default)("var(--ds-skeleton-to-color, ".concat("var(--ds-skeleton-subtle, #091E4208)", ")"))
        })
    }));
};
var $e3ed46ff97b993f0$export$2e2bcd8739ae039 = $e3ed46ff97b993f0$var$Skeleton;


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


const $bb6557fb29c1ef20$export$44c18d210d5de37b = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
        alignItems: "center",
        templateColumns: "1fr 3fr 1fr",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {}),
            (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                alignItems: "center",
                justifyContent: "center",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                    xcss: $bb6557fb29c1ef20$var$skeletonItemsContainer,
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                        space: "space.500",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $e3ed46ff97b993f0$export$2e2bcd8739ae039), {
                                width: "100%",
                                height: "300px",
                                isShimmering: true,
                                borderRadius: "6px"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $e3ed46ff97b993f0$export$2e2bcd8739ae039), {
                                width: "100%",
                                height: "150px",
                                isShimmering: true,
                                borderRadius: "6px"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $e3ed46ff97b993f0$export$2e2bcd8739ae039), {
                                width: "100%",
                                height: "150px",
                                isShimmering: true,
                                borderRadius: "6px"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $e3ed46ff97b993f0$export$2e2bcd8739ae039), {
                                width: "100%",
                                height: "200px",
                                isShimmering: true,
                                borderRadius: "6px"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $e3ed46ff97b993f0$export$2e2bcd8739ae039), {
                                width: "100%",
                                height: "200px",
                                isShimmering: true,
                                borderRadius: "6px"
                            })
                        ]
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {})
        ]
    });
};
const $bb6557fb29c1ef20$var$skeletonItemsContainer = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.500",
    paddingBottom: "space.300",
    paddingLeft: "space.300",
    paddingRight: "space.300",
    width: "100%"
});






var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $480634a75d8ae79a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $da278c11bbb20b21$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function $da278c11bbb20b21$export$a87138b73900f5b(version) {
    const major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
const $da278c11bbb20b21$export$6ef4c0367e27f2d5 = "unknown";
const $da278c11bbb20b21$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function $da278c11bbb20b21$var$setCause(error, cause) {
    const seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $da278c11bbb20b21$export$e926676385687eaf extends $acw62.Component {
    constructor(props){
        super(props);
        $da278c11bbb20b21$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $da278c11bbb20b21$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
        if (client && client.on && props.showDialog) {
            this._openFallbackReportDialog = false;
            client.on("afterSendEvent", (event)=>{
                if (!event.type && event.event_id === this._lastEventId) // eslint-disable-next-line deprecation/deprecation
                (0, $4c87801c815e53f1$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, { componentStack: componentStack }) {
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $81a395368bb6f380$export$ec58d9285c204497)((scope)=>{
            // If on React version >= 17, create stack trace from componentStack param and links
            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
            // Linking errors requires the `LinkedErrors` integration be enabled.
            // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
            //
            // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
            // with non-error objects. This is why we need to check if the error is an error-like object.
            // See: https://github.com/getsentry/sentry-javascript/issues/6167
            if ($da278c11bbb20b21$export$a87138b73900f5b($acw62.version) && (0, $1e0be767ffa822d8$export$e6127cc7fe7395c3)(error)) {
                const errorBoundaryError = new Error(error.message);
                errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
                errorBoundaryError.stack = componentStack;
                // Using the `LinkedErrors` integration to link the errors together.
                $da278c11bbb20b21$var$setCause(error, errorBoundaryError);
            }
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const eventId = (0, $81a395368bb6f380$export$f5282963edea4a68)(error, {
                captureContext: {
                    contexts: {
                        react: {
                            componentStack: componentStack
                        }
                    }
                },
                // If users provide a fallback component we can assume they are handling the error.
                // Therefore, we set the mechanism depending on the presence of the fallback prop.
                mechanism: {
                    handled: !!this.props.fallback
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $4c87801c815e53f1$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($da278c11bbb20b21$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === "function") element = fallback({
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($acw62.isValidElement(element)) return element;
            if (fallback) (0, $480634a75d8ae79a$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("fallback did not produce a valid ReactElement");
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === "function") return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $da278c11bbb20b21$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $da278c11bbb20b21$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$acw62.createElement($da278c11bbb20b21$export$e926676385687eaf, {
            ...errorBoundaryOptions,
            __self: this,
            __source: {
                fileName: $da278c11bbb20b21$var$_jsxFileName,
                lineNumber: 240
            }
        }, $acw62.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: $da278c11bbb20b21$var$_jsxFileName,
                lineNumber: 241
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Wrapped, WrappedComponent);
    return Wrapped;
}


parcelRequire("acw62");

const $273a2ae2279c22d2$var$defaultFallback = (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
    children: "Something went wrong"
});
const $273a2ae2279c22d2$export$e926676385687eaf = ({ children: children, fallback: fallback, onError: onError })=>{
    return (0, $7b02d682eb115277$exports.jsx)($da278c11bbb20b21$export$e926676385687eaf, {
        fallback: fallback ?? $273a2ae2279c22d2$var$defaultFallback,
        onError: onError,
        children: children
    });
};




var $5l6ld = parcelRequire("5l6ld");


var $acw62 = parcelRequire("acw62");
const $690d3d7c4f641feb$export$8d72aed7d7257c6a = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $690d3d7c4f641feb$export$69bbac602c81ca6e = ()=>{
    const context = (0, $acw62.useContext)($690d3d7c4f641feb$export$8d72aed7d7257c6a);
    if (!context) throw new Error("useAuthData must be used within a AuthDataProvider");
    return context;
};



var $665198666197c108$var$_authContextProviderQuery;

const $665198666197c108$export$b2316657917319d2 = ({ children: children, queryRef: queryRef })=>{
    const data = (0, $2d93712440e0508b$exports.usePreloadedQuery)($665198666197c108$var$_authContextProviderQuery !== void 0 ? $665198666197c108$var$_authContextProviderQuery : $665198666197c108$var$_authContextProviderQuery = (parcelRequire("5l6ld")), queryRef);
    const userData = {
        user: {
            accountId: data.me.user.accountId,
            picture: data.me.user.picture ?? undefined,
            email: data.me.user.email ?? undefined,
            name: data.me.user.name ?? undefined
        }
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $690d3d7c4f641feb$export$8d72aed7d7257c6a).Provider, {
        value: userData,
        children: children
    });
};



const $b46b2bb54fe4f432$export$cf681dc9f7811050 = "https://dev-agents.stg-east.frontend.public.atl-paas.net/assets/";
const $b46b2bb54fe4f432$export$792ab0c5da0fd7c5 = "https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/";
const $b46b2bb54fe4f432$export$37e363941a7d06d9 = "integration.bb-inf.net";
const $b46b2bb54fe4f432$export$25eb080fef99f257 = "bitbucket.org";
const $b46b2bb54fe4f432$export$cc0ce9deeea0cdfa = "https://support.atlassian.com/jira-cloud-administration/docs/integrate-bitbucket-with-jira/";
const $b46b2bb54fe4f432$export$ad9d2623b45ad758 = "https://marketplace.atlassian.com/apps/1219592/github-for-jira?tab=overview&hosting=cloud";
const $b46b2bb54fe4f432$export$6a5f3b89af31068a = "https://support.atlassian.com/jira-cloud-administration/docs/integrate-with-github/";
const $b46b2bb54fe4f432$export$595fbe9beb48a7a7 = "/secure/admin/ConfigureDvcsOrganizations!default.jspa";
const $b46b2bb54fe4f432$export$c39cfd122465c04e = "https://rovodevagents-beta.atlassian.net/wiki/external/ZmEwZmU2MTYwMGM3NDE3NjhlOTA2MDZhNGY5ZmU0OTU";
const $b46b2bb54fe4f432$export$e4425ce4e2c57457 = "https://rovodevagents-beta.atlassian.net/wiki/external/NmYzMTZiZjhkOGQ1NGY5NTgzZDlkYjhlNjdhZjFjYWM";
const $b46b2bb54fe4f432$export$3255dadb03b35a28 = "https://rovodevagents-beta.atlassian.net/wiki/external/YWJmZmRiNTFhYTUxNDBhOTg5ZjY5ZmQ0Yzg5MTlkNzA";
const $b46b2bb54fe4f432$export$f7cf5dee5734594c = "https://rovodevagents-beta.atlassian.net/wiki/external/OWYyYTFhNGEyNGUwNGY3YjgwMzkxMDhhMTAzM2EwYzc";
const $b46b2bb54fe4f432$export$4c0bd3485d463fe = "https://bitbucket.org/account/workspaces/";
const $b46b2bb54fe4f432$export$4a98fc7b279f08ef = "https://integration.bb-inf.net/account/workspaces/";
const $b46b2bb54fe4f432$export$7b0f8fec4b919ab3 = "https://rovodevagents-beta.atlassian.net/wiki/external/ZjBjMmQ3YmQzOThhNDY1MGEzZjRiMjM1NzA5YmNkZTU";
const $b46b2bb54fe4f432$export$da4fecf2d95db63b = "https://rovodevagents-beta.atlassian.net/wiki/external/NzJlM2JlYjRmZTc1NGQ1NTk5NjUwNDFkYmE3NTZiODY";
const $b46b2bb54fe4f432$export$627321b82c429923 = "https://admin.atlassian.com";
const $b46b2bb54fe4f432$export$944e1ecf8da9f253 = "https://admin.stg.atlassian.com";
const $b46b2bb54fe4f432$export$d76ba9bdae389e5f = "/plugins/servlet/ac/com.github.integration.production/gh-addon-admin?s=com.github.integration.production__gh-addon-admin";
const $b46b2bb54fe4f432$export$deed3f587f71617d = "/plugins/servlet/ac/com.github.integration.staging/gh-addon-admin?s=com.github.integration.staging__gh-addon-admin";
const $b46b2bb54fe4f432$export$67efc9ea144c1797 = "https://rovodevagents-beta.atlassian.net/wiki/external/ZTk0Y2QzMmFmMDVlNDNjNzlkYjg5YjUyOWJhOTIyZTQ";
const $b46b2bb54fe4f432$export$b48ea3f417d3c529 = "https://rovodevagents-beta.atlassian.net/wiki/external/NTgwMGQ3Yzg1ZThjNDQ5ZDhmZWYyNWVjN2ZjODExNmM";
const $b46b2bb54fe4f432$export$f646aec6c096a2df = "https://rovodevagents.atlassian.net/servicedesk/customer/portal/1";


const $a2299f428347f042$export$696cc1fcfc4c83c6 = "Not an Atlassian user";
const $a2299f428347f042$var$isStaging = "https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/" === (0, $b46b2bb54fe4f432$export$cf681dc9f7811050);
const $a2299f428347f042$var$isProd = "https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/" === (0, $b46b2bb54fe4f432$export$792ab0c5da0fd7c5);
const $a2299f428347f042$export$1038046b28a1d92e = ()=>{
    if ($a2299f428347f042$var$isStaging) return (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).STAGING;
    if ($a2299f428347f042$var$isProd) return (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD;
    return (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).LOCAL;
};
const $a2299f428347f042$export$e61aef4ae55da883 = ()=>{
    return $a2299f428347f042$export$1038046b28a1d92e() === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).LOCAL ? "" : window.location.hostname;
};



var $acw62 = parcelRequire("acw62");





var $2pciS = parcelRequire("2pciS");


var $acw62 = parcelRequire("acw62");
const $01b04da237978a44$export$7adae10110d5e04c = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $01b04da237978a44$export$c00a80cbbdafd66b = ()=>{
    const context = (0, $acw62.useContext)($01b04da237978a44$export$7adae10110d5e04c);
    if (!context) throw new Error("useTenantData must be used within a TenantDataProvider");
    return context;
};



var $f815a3b12138ccb2$var$_tenantContextProviderQuery;

const $f815a3b12138ccb2$export$e32355e80a92030c = ({ children: children, queryRef: queryRef })=>{
    const data = (0, $2d93712440e0508b$exports.usePreloadedQuery)($f815a3b12138ccb2$var$_tenantContextProviderQuery !== void 0 ? $f815a3b12138ccb2$var$_tenantContextProviderQuery : $f815a3b12138ccb2$var$_tenantContextProviderQuery = (parcelRequire("2pciS")), queryRef);
    const tenantData = {
        tenantContexts: data.tenantContexts.filter((context)=>context !== null).map((context)=>({
                cloudId: context.cloudId,
                orgId: context.orgId,
                devaiEntitlementId: context.entitlementInfo?.entitlementId ?? null,
                hasActiveDevAiEntitlement: context.entitlementInfo?.entitlement?.status === "ACTIVE"
            }))
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $01b04da237978a44$export$7adae10110d5e04c).Provider, {
        value: tenantData,
        children: children
    });
};




var $g5Zhu = parcelRequire("g5Zhu");

var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");

var $8MSmw = parcelRequire("8MSmw");

var $ltooA = parcelRequire("ltooA");

var $hxCZS = parcelRequire("hxCZS");

var $b4vGv = parcelRequire("b4vGv");

var $9z7qU = parcelRequire("9z7qU");

var $ayrpn = parcelRequire("ayrpn");

var $9Gm6H = parcelRequire("9Gm6H");

var $7QErp = parcelRequire("7QErp");
// The UFORouteName object is a global singleton
var $81d0e14c6e36c59b$var$UFORouteName = {
    current: null
};
var $81d0e14c6e36c59b$export$2e2bcd8739ae039 = $81d0e14c6e36c59b$var$UFORouteName;


function $be2bac6f5bd8ac61$export$2e2bcd8739ae039() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var result = "";
    for(var i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}


function $c82b3e8bd684c411$export$2e2bcd8739ae039(callback) {
    var _document;
    if (((_document = document) === null || _document === void 0 ? void 0 : _document.visibilityState) !== "visible") {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== "undefined" && typeof window.scheduler.postTask === "function") // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(function() {
        window.scheduler.postTask(callback, {
            priority: "user-visible"
        });
    });
    else if (typeof requestAnimationFrame !== "undefined") // Fallback to using double requestAnimationFrame
    requestAnimationFrame(function() {
        requestAnimationFrame(function() {
            callback();
        });
    });
}


function $a5eb6fa517319005$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5eb6fa517319005$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5eb6fa517319005$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5eb6fa517319005$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a5eb6fa517319005$var$tryCompleteHandle;

var $a5eb6fa517319005$var$AsyncSegmentHighlight = /*#__PURE__*/ (0, $acw62.lazy)(function() {
    return (parcelRequire("dVxap")).then(function(module) {
        return {
            default: module.SegmentHighlight
        };
    });
});
var $a5eb6fa517319005$var$noopIdMap = new Map();
function $a5eb6fa517319005$export$2e2bcd8739ae039(_ref) {
    var _getConfig2;
    var segmentName = _ref.name, children = _ref.children, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "single" : _ref$mode;
    var parentContext = (0, $acw62.useContext)((0, $ayrpn.default));
    var segmentIdMap = (0, $acw62.useMemo)(function() {
        if (!(0, $ltooA.fg)("platform_ufo_segment_list_mode")) // just in case we cause rerender issues, use noop map
        return $a5eb6fa517319005$var$noopIdMap;
        if (!(parentContext !== null && parentContext !== void 0 && parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    var segmentId = (0, $acw62.useMemo)(function() {
        if (!(0, $ltooA.fg)("platform_ufo_segment_list_mode")) return (0, $be2bac6f5bd8ac61$export$2e2bcd8739ae039)();
        if (mode === "single") return (0, $be2bac6f5bd8ac61$export$2e2bcd8739ae039)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        var newSegmentId = (0, $be2bac6f5bd8ac61$export$2e2bcd8739ae039)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    var labelStack = (0, $acw62.useMemo)(function() {
        return parentContext !== null && parentContext !== void 0 && parentContext.labelStack ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(parentContext.labelStack), [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ]) : [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ];
    }, [
        parentContext,
        segmentName,
        segmentId
    ]);
    var interactionId = (0, $acw62.useContext)((0, $9Gm6H.default));
    var interactionContext = (0, $acw62.useMemo)(function() {
        if (!(0, $ltooA.fg)("platform-ufo-add-segment-use-effect")) (0, $7QErp.addSegment)(labelStack);
        var lastCompleteEndTime = 0;
        function complete() {
            var endTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    var capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($a5eb6fa517319005$var$tryCompleteHandle) {
                        var _cancelAnimationFrame;
                        (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 || _cancelAnimationFrame($a5eb6fa517319005$var$tryCompleteHandle);
                    }
                    (0, $fO90s.unstable_scheduleCallback)((0, $fO90s.unstable_NormalPriority), function() {
                        if (capturedInteractionId === interactionId.current) {
                            var _document;
                            var isPageVisible = ((_document = document) === null || _document === void 0 ? void 0 : _document.visibilityState) === "visible";
                            var canDoRAF = typeof requestAnimationFrame !== "undefined";
                            if (isPageVisible && canDoRAF) $a5eb6fa517319005$var$tryCompleteHandle = requestAnimationFrame(function() {
                                $a5eb6fa517319005$var$tryCompleteHandle = requestAnimationFrame(function() {
                                    if (capturedInteractionId === interactionId.current) (0, $7QErp.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $7QErp.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    });
                }
            }
        }
        function _internalHold(labelStack, name) {
            var experimental = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, experimental);
                else {
                    var capturedInteractionId = interactionId.current;
                    var disposeHold = (0, $7QErp.addHold)(interactionId.current, labelStack, name, experimental);
                    return function() {
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $7QErp.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $7QErp.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return $a5eb6fa517319005$var$_objectSpread($a5eb6fa517319005$var$_objectSpread({}, parentContext), {}, {
            labelStack: labelStack,
            complete: complete
        });
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold: function hold() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "unknown";
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental: function holdExperimental() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "unknown";
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID: function addHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "unknown";
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID: function removeHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "unknown";
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress: function tracePress() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "unknown";
                var timestamp = arguments.length > 1 ? arguments[1] : undefined;
                if (interactionId.current != null) (0, $7QErp.abortByNewInteraction)(interactionId.current, name);
                var rate = (0, $b4vGv.getInteractionRate)(name, "press");
                if ((0, $hxCZS.default)(rate)) {
                    var startTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    var newId = (0, $8MSmw.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $9z7qU.setInteractionActiveTrace)(newId, "press");
                    (0, $7QErp.addNewInteraction)(newId, name, "press", startTimestamp, rate, this.labelStack, (0, $81d0e14c6e36c59b$export$2e2bcd8739ae039).current, (0, $9z7qU.getActiveTrace)());
                }
            },
            retainQuery: function retainQuery(info) {
                if (interactionId.current != null) (0, $7QErp.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload: function addPreload(moduleId, timestamp) {
                if (interactionId.current != null) (0, $7QErp.addMark)(interactionId.current, "bundle_preload", moduleId, this.labelStack, timestamp);
            },
            addLoad: function addLoad(identifier, start, end) {
                if (interactionId.current != null) {
                    var _this$labelStack = this.labelStack, _labelStack = _this$labelStack === void 0 ? [] : _this$labelStack;
                    (0, $7QErp.addSpan)(interactionId.current, "bundle_load", identifier, _labelStack, start, end);
                }
            },
            addMark: function addMark(name, timestamp) {
                if (interactionId.current != null) {
                    var time = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    (0, $7QErp.addMark)(interactionId.current, "custom", name, this.labelStack, time);
                }
            },
            addCustomData: function addCustomData(customData) {
                if (interactionId.current != null) (0, $7QErp.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings: function addCustomTimings(customTimings) {
                if (interactionId.current != null) (0, $7QErp.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex: function addApdex(apdexInfo) {
                if (interactionId.current != null) {
                    var key = apdexInfo.key, stopTime = apdexInfo.stopTime, startTime = apdexInfo.startTime;
                    (0, $7QErp.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender: function onRender(phase, actualDuration, baseDuration, startTime, commitTime) {
                var _this = this;
                if (interactionId.current !== null) {
                    (0, $7QErp.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    if ((0, $ltooA.fg)("platform_ufo_vc_ttai_on_paint")) (0, $c82b3e8bd684c411$export$2e2bcd8739ae039)(function() {
                        var paintedTime = performance.now();
                        _this.complete(paintedTime);
                    });
                    else this.complete(commitTime);
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    var hasMounted = (0, $acw62.useRef)(false);
    var onRender = (0, $acw62.useCallback)(function(_id, phase, actualDuration, baseDuration, startTime, commitTime) {
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((_getConfig = (0, $b4vGv.getConfig)()) !== null && _getConfig !== void 0 && _getConfig.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender("mount", actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $acw62.useEffect)(function() {
        if ((0, $ltooA.fg)("platform-ufo-add-segment-use-effect")) (0, $7QErp.addSegment)(labelStack);
        return function() {
            (0, $7QErp.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    var reactProfilerId = (0, $acw62.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join("/");
    }, [
        labelStack
    ]);
    var enableSegmentHighlighting = (_getConfig2 = (0, $b4vGv.getConfig)()) === null || _getConfig2 === void 0 ? void 0 : _getConfig2.enableSegmentHighlighting;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ayrpn.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children, enableSegmentHighlighting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a5eb6fa517319005$var$AsyncSegmentHighlight, {
        segmentName: segmentName
    }))));
}


var $25bb30d690a27033$export$2e2bcd8739ae039 = (0, $a5eb6fa517319005$export$2e2bcd8739ae039);


// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $d6ce1402442d8264$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $d6ce1402442d8264$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $d6ce1402442d8264$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $d6ce1402442d8264$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $d6ce1402442d8264$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $d6ce1402442d8264$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["HALP"] = "halp";
    return userType;
}({});
let $d6ce1402442d8264$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $d6ce1402442d8264$export$809831be6c4c6227 = Object.freeze([
    $d6ce1402442d8264$export$6b4f396210e539f3.DESKTOP,
    $d6ce1402442d8264$export$6b4f396210e539f3.MAC,
    $d6ce1402442d8264$export$6b4f396210e539f3.LINUX,
    $d6ce1402442d8264$export$6b4f396210e539f3.WINDOWS
]);
const $d6ce1402442d8264$export$19c579398ad213e7 = Object.freeze([
    $d6ce1402442d8264$export$6b4f396210e539f3.WEB,
    $d6ce1402442d8264$export$6b4f396210e539f3.MOBILE_WEB
]);
let $d6ce1402442d8264$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $d6ce1402442d8264$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $d6ce1402442d8264$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $d6ce1402442d8264$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});



var $acw62 = parcelRequire("acw62");



var $g5Zhu = parcelRequire("g5Zhu");

var $GtgEQ = parcelRequire("GtgEQ");


var $g5Zhu = parcelRequire("g5Zhu");


var $g5Zhu = parcelRequire("g5Zhu");
class $b09d1a9975733eb7$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document.hidden !== "undefined") {
            // Opera 12.10 and Firefox 18 and later support
            this._isHidden = document.hidden;
            this._hidden = "hidden";
            this._visibilityChange = "visibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            this._isHidden = document.msHidden;
            this._hidden = "msHidden";
            this._visibilityChange = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            this._isHidden = document.webkitHidden;
            this._hidden = "webkitHidden";
            this._visibilityChange = "webkitvisibilitychange";
        }
        if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
    }
    addCallback(name, fn) {
        if (typeof name !== "string") throw new Error("Invalid name, must be string");
        if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}


class $dc5e3d9089ebb27b$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}


function $72465ab69bc3af9a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $72465ab69bc3af9a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $72465ab69bc3af9a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $72465ab69bc3af9a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $72465ab69bc3af9a$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $72465ab69bc3af9a$var$_objectSpread($72465ab69bc3af9a$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $d6ce1402442d8264$export$99b37380a464d794).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $d6ce1402442d8264$export$99b37380a464d794).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $d6ce1402442d8264$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $d6ce1402442d8264$export$26b9f946b448f23e)((0, $d6ce1402442d8264$export$99b37380a464d794), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $d6ce1402442d8264$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $72465ab69bc3af9a$var$_objectSpread($72465ab69bc3af9a$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $b09d1a9975733eb7$export$2e2bcd8739ae039))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $dc5e3d9089ebb27b$export$2e2bcd8739ae039)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($72465ab69bc3af9a$var$_objectSpread($72465ab69bc3af9a$var$_objectSpread($72465ab69bc3af9a$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}


/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $6aaee5584813c382$var$isFunction = (possibleFn)=>typeof possibleFn === "function";
var $6aaee5584813c382$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($6aaee5584813c382$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};



var $g5Zhu = parcelRequire("g5Zhu");

// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $51c3ce80838ab75d$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $51c3ce80838ab75d$var$isObjectObject(o) {
    return $51c3ce80838ab75d$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $51c3ce80838ab75d$export$53b83ca8eaab0383(o) {
    if ($51c3ce80838ab75d$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($51c3ce80838ab75d$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}


function $1e144fb3742c9947$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e144fb3742c9947$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e144fb3742c9947$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e144fb3742c9947$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1e144fb3742c9947$var$libraryVersion = "4.19.0";
function $1e144fb3742c9947$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $1e144fb3742c9947$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $1e144fb3742c9947$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $1e144fb3742c9947$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $1e144fb3742c9947$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $1e144fb3742c9947$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $1e144fb3742c9947$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $1e144fb3742c9947$var$getProductField(productInfo.env, overrides.env);
    const product = $1e144fb3742c9947$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $1e144fb3742c9947$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $1e144fb3742c9947$var$getProductField(productInfo.version, overrides.version);
    const origin = $1e144fb3742c9947$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $1e144fb3742c9947$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $1e144fb3742c9947$var$isNotEmptyObject(obj) {
    return (0, $51c3ce80838ab75d$export$53b83ca8eaab0383)(obj) && Object.keys(obj).length > 0;
}
function $1e144fb3742c9947$var$buildAttributesWithName(name, attrObject) {
    return $1e144fb3742c9947$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $1e144fb3742c9947$var$buildAttributes(attributes) {
    return $1e144fb3742c9947$var$buildAttributesWithName("attributes", attributes);
}
function $1e144fb3742c9947$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $1e144fb3742c9947$export$f045f238d77c002a(containers) {
    if ($1e144fb3742c9947$var$isNotEmptyObject(containers)) {
        const validContainers = $1e144fb3742c9947$export$3f5115a568819c1a(containers);
        return $1e144fb3742c9947$var$buildAttributesWithName("containers", validContainers);
    }
    return undefined;
}
function $1e144fb3742c9947$export$655ecf7241feac42(event, actionEventType) {
    return $1e144fb3742c9947$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $1e144fb3742c9947$export$f045f238d77c002a(event.containers));
}
function $1e144fb3742c9947$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $1e144fb3742c9947$var$buildAttributesWithName("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $1e144fb3742c9947$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers) {
    const productFields = $1e144fb3742c9947$var$buildProductFields(productInfo);
    const tenantFields = $1e144fb3742c9947$var$buildTenantFields(tenantInfo);
    const userFields = $1e144fb3742c9947$var$buildUserFields(userInfo);
    const orgFields = $1e144fb3742c9947$var$buildOrgFields(orgInfo);
    const workspaceFields = $1e144fb3742c9947$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $d6ce1402442d8264$export$4c045e605d532c98).SCREEN
    };
    return $1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $1e144fb3742c9947$var$buildAttributes(attributes)), $1e144fb3742c9947$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $1e144fb3742c9947$export$f045f238d77c002a(containers)), $1e144fb3742c9947$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields);
}
function $1e144fb3742c9947$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
function $1e144fb3742c9947$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $1e144fb3742c9947$var$libraryVersion
            }
        }
    };
}
function $1e144fb3742c9947$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $1e144fb3742c9947$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo) {
    const productFields = $1e144fb3742c9947$var$buildProductFields(productInfo, $1e144fb3742c9947$export$e3d99b4bfec06f6e(event));
    const tenantFields = $1e144fb3742c9947$var$buildTenantFields(tenantInfo);
    const orgFields = $1e144fb3742c9947$var$buildOrgFields(orgInfo);
    const workspaceFields = $1e144fb3742c9947$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $1e144fb3742c9947$var$buildUserFields(userInfo);
    const actionFields = $1e144fb3742c9947$export$655ecf7241feac42(event, actionEventType);
    return $1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread($1e144fb3742c9947$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $1e144fb3742c9947$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields);
}



var $g5Zhu = parcelRequire("g5Zhu");
const $46a4b6494ace7a2f$export$cf090d5281b5ae06 = 10000;
const $46a4b6494ace7a2f$export$8575e30be0feb909 = 30000;



var $g5Zhu = parcelRequire("g5Zhu");

/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $8a4ab4de05c8ab64$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $8a4ab4de05c8ab64$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $8a4ab4de05c8ab64$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $8a4ab4de05c8ab64$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $8a4ab4de05c8ab64$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $8a4ab4de05c8ab64$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$8a4ab4de05c8ab64$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $8a4ab4de05c8ab64$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);



var $g5Zhu = parcelRequire("g5Zhu");



var $g5Zhu = parcelRequire("g5Zhu");


const $a4d00bd888f23c01$var$actionEventTypes = Object.freeze([
    (0, $d6ce1402442d8264$export$4c045e605d532c98).OPERATIONAL,
    (0, $d6ce1402442d8264$export$4c045e605d532c98).TRACK,
    (0, $d6ce1402442d8264$export$4c045e605d532c98).UI
]);
function $a4d00bd888f23c01$export$df8ff30e3c960006(container) {
    if (!(0, $51c3ce80838ab75d$export$53b83ca8eaab0383)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}
function $a4d00bd888f23c01$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach((container)=>$a4d00bd888f23c01$export$df8ff30e3c960006(container));
}
function $a4d00bd888f23c01$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $d6ce1402442d8264$export$4c045e605d532c98).OPERATIONAL:
        case (0, $d6ce1402442d8264$export$4c045e605d532c98).TRACK:
        case (0, $d6ce1402442d8264$export$4c045e605d532c98).UI:
            return true;
        default:
            return false;
    }
}
function $a4d00bd888f23c01$export$4a8d7476662aebcc(type) {
    if (!$a4d00bd888f23c01$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$a4d00bd888f23c01$var$actionEventTypes}]`);
    return true;
}
function $a4d00bd888f23c01$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    $a4d00bd888f23c01$export$e63ea5d8477971d3(event.containers);
}
function $a4d00bd888f23c01$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}
function $a4d00bd888f23c01$export$8c014fd74b0c8b99(event) {
    $a4d00bd888f23c01$export$e0c121325c66ed4c(event);
}
function $a4d00bd888f23c01$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}
function $a4d00bd888f23c01$export$e5bac0930c812e90(event) {
    $a4d00bd888f23c01$export$e0c121325c66ed4c(event);
}
function $a4d00bd888f23c01$export$1e561554275607ef(event) {
    $a4d00bd888f23c01$export$e0c121325c66ed4c(event);
}
function $a4d00bd888f23c01$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $d6ce1402442d8264$export$26b9f946b448f23e)((0, $d6ce1402442d8264$export$1827adfd178b4870), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $d6ce1402442d8264$export$ad1854f4a08c15f8)((0, $d6ce1402442d8264$export$1827adfd178b4870))}]`);
}
function $a4d00bd888f23c01$export$801b46c35394d316(productInfo) {
    if (!(0, $d6ce1402442d8264$export$26b9f946b448f23e)((0, $d6ce1402442d8264$export$6b4f396210e539f3), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $d6ce1402442d8264$export$ad1854f4a08c15f8)((0, $d6ce1402442d8264$export$6b4f396210e539f3))}]`);
    if (productInfo.origin === (0, $d6ce1402442d8264$export$f73e9fcd368bb695).DESKTOP && !(0, $d6ce1402442d8264$export$26b9f946b448f23e)((0, $d6ce1402442d8264$export$809831be6c4c6227), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $d6ce1402442d8264$export$f73e9fcd368bb695).WEB && !(0, $d6ce1402442d8264$export$26b9f946b448f23e)((0, $d6ce1402442d8264$export$19c579398ad213e7), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}



class $b8ac8db10a7a2ea9$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $a4d00bd888f23c01$export$d19cebda16f7579a)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $8a4ab4de05c8ab64$export$b29f828819edca8d)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error("No events were returned from the compression function");
            compressedEvents.forEach((event)=>{
                (0, $a4d00bd888f23c01$export$4a8d7476662aebcc)(event.eventType);
                (0, $a4d00bd888f23c01$export$e0c121325c66ed4c)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
        if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}


function $ac4be8923b4facfa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ac4be8923b4facfa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ac4be8923b4facfa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ac4be8923b4facfa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $ac4be8923b4facfa$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $1e144fb3742c9947$export$655ecf7241feac42)(event, event.eventType);
                    contextFields = (0, $8a4ab4de05c8ab64$export$30a06c8d3562193f)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $8a4ab4de05c8ab64$export$e9bab7fafb253603)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$ac4be8923b4facfa$var$_objectSpread($ac4be8923b4facfa$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
        if (!compressionRules.every((rule)=>rule instanceof (0, $b8ac8db10a7a2ea9$export$89b3253ddfd2e6e8))) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
        this.compressionRules = compressionRules;
    }
}


// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $b43a0fdbf1726484$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $b43a0fdbf1726484$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $b43a0fdbf1726484$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Failed to perform compression on the delayed analytics events. " + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $b43a0fdbf1726484$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $b43a0fdbf1726484$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $8a4ab4de05c8ab64$export$b29f828819edca8d)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $8a4ab4de05c8ab64$export$e9bab7fafb253603)(group.userInfo, args.userInfo) && (0, $8a4ab4de05c8ab64$export$e9bab7fafb253603)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $1e144fb3742c9947$export$9c5623a792efc9b0)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $ac4be8923b4facfa$export$2e2bcd8739ae039)(compressionRules);
    }
}


let $74bdc57f6c5d2284$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});


class $4bfa36a99675327b$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startLowPriorityEventDelay", (timeout = (0, $46a4b6494ace7a2f$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $46a4b6494ace7a2f$export$8575e30be0feb909)) : (0, $46a4b6494ace7a2f$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $74bdc57f6c5d2284$export$fa6e3729c21cb8f).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopLowPriorityEventDelay", (reason = (0, $74bdc57f6c5d2284$export$fa6e3729c21cb8f).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $b43a0fdbf1726484$export$2e2bcd8739ae039)(fireDelayedEvent, compressors);
    }
}




var $g5Zhu = parcelRequire("g5Zhu");

var $GtgEQ = parcelRequire("GtgEQ");

var $g5Zhu = parcelRequire("g5Zhu");
let $34db9a8626937f62$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $34db9a8626937f62$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});



const $243f8154b1f46070$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $34db9a8626937f62$export$ecfa71cbc9b28241).ACK]: `${queuePrefix}.${queueId}.${(0, $34db9a8626937f62$export$ecfa71cbc9b28241).ACK}`,
        [(0, $34db9a8626937f62$export$ecfa71cbc9b28241).QUEUE]: `${queuePrefix}.${queueId}.${(0, $34db9a8626937f62$export$ecfa71cbc9b28241).QUEUE}`,
        [(0, $34db9a8626937f62$export$ecfa71cbc9b28241).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $34db9a8626937f62$export$ecfa71cbc9b28241).IN_PROGRESS}`,
        [(0, $34db9a8626937f62$export$ecfa71cbc9b28241).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $34db9a8626937f62$export$ecfa71cbc9b28241).RECLAIM_START}`,
        [(0, $34db9a8626937f62$export$ecfa71cbc9b28241).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $34db9a8626937f62$export$ecfa71cbc9b28241).RECLAIM_END}`
    });


// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $32c3e15d6938acbd$var$validSuffixs = Object.values((0, $34db9a8626937f62$export$ecfa71cbc9b28241));
var $32c3e15d6938acbd$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split(".")).filter((splitKeys)=>splitKeys.length === 3 && $32c3e15d6938acbd$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $34db9a8626937f62$export$ecfa71cbc9b28241).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $243f8154b1f46070$export$8433d54f767cbec5)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};


var $g5Zhu = parcelRequire("g5Zhu");

var $GtgEQ = parcelRequire("GtgEQ");


function $562f527bc061b2a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $562f527bc061b2a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $562f527bc061b2a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $562f527bc061b2a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $562f527bc061b2a2$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $562f527bc061b2a2$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split(".")).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $34db9a8626937f62$export$ecfa71cbc9b28241).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $34db9a8626937f62$export$8bb2c1fb2b1765a9).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $562f527bc061b2a2$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $562f527bc061b2a2$var$promisedSetTimeout((0, $34db9a8626937f62$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $34db9a8626937f62$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $562f527bc061b2a2$var$promisedSetTimeout((0, $34db9a8626937f62$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $34db9a8626937f62$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
    return $562f527bc061b2a2$var$reclaim(options, callback);
};
const $562f527bc061b2a2$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || "{}");
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $562f527bc061b2a2$var$_objectSpread($562f527bc061b2a2$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === "successful") $562f527bc061b2a2$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === "partial") {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $562f527bc061b2a2$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $562f527bc061b2a2$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $562f527bc061b2a2$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))();
    const queuesToReclaim = $562f527bc061b2a2$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$562f527bc061b2a2$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $243f8154b1f46070$export$8433d54f767cbec5)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === "rejected");
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === "fulfilled").map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};


const $26f8ccfaf9e091ee$export$a409c8de90e11e14 = "CallbackProcessingError";
class $26f8ccfaf9e091ee$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        const messageFromString = typeof error === "string" && error;
        const message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $26f8ccfaf9e091ee$export$2e2bcd8739ae039.prototype);
        this.name = $26f8ccfaf9e091ee$export$a409c8de90e11e14;
    }
}

const $f1a8afbc4574a199$export$d21fbb25eb37b5bf = "namespace-timeAdded";
const $f1a8afbc4574a199$export$8cad224051643259 = "analytics-web-client";
const $f1a8afbc4574a199$export$3d8420be07b276ab = "analytics-resilience";
const $f1a8afbc4574a199$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
const $f1a8afbc4574a199$export$89d9c1ff8ac91862 = "timeAdded";
const $f1a8afbc4574a199$export$a37d385bcd713809 = "retryAttempts";
const $f1a8afbc4574a199$export$6d8635fed0e4b14d = 15000;
let $f1a8afbc4574a199$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $f1a8afbc4574a199$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});


const $56713b75b685db03$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
class $56713b75b685db03$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super("window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $56713b75b685db03$export$2e2bcd8739ae039.prototype);
        this.name = $56713b75b685db03$export$fc14cf6dcea0f8ed;
    }
}

const $c41fefb7cbe633e9$export$ba95206613c96b28 = "AbandonWriteError";
class $c41fefb7cbe633e9$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c41fefb7cbe633e9$export$2e2bcd8739ae039.prototype);
        this.name = $c41fefb7cbe633e9$export$ba95206613c96b28;
    }
}



const $6be07a4405c4cb7d$export$7e7aee9a953465ec = "InvalidPolicyError";
class $6be07a4405c4cb7d$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $6be07a4405c4cb7d$export$7e7aee9a953465ec;
    }
}


const $3923a3cdd2bfea73$export$74101021e0969375 = (error)=>{
    if (error && typeof error === "object" && "name" in error) {
        const errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $c41fefb7cbe633e9$export$ba95206613c96b28) || errorWithName.name === (0, $26f8ccfaf9e091ee$export$a409c8de90e11e14) || errorWithName.name === (0, $6be07a4405c4cb7d$export$7e7aee9a953465ec));
    }
    return false;
};



var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");

const $9e2c357f10f43e4a$export$b6df3d334cec060f = 7;
const $9e2c357f10f43e4a$export$14ef152a03a4b6ee = 60000;
const $9e2c357f10f43e4a$export$da9ab7b2fd5998e8 = 10;
const $9e2c357f10f43e4a$export$1188664dfff364c8 = 5000;




var $g5Zhu = parcelRequire("g5Zhu");



var $GtgEQ = parcelRequire("GtgEQ");

const $7237735343673798$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $7237735343673798$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $9e2c357f10f43e4a$export$da9ab7b2fd5998e8),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $9e2c357f10f43e4a$export$1188664dfff364c8)
    });
const $7237735343673798$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $7237735343673798$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $7237735343673798$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return $7237735343673798$export$2a5213bce1720b42(transaction);
};
const $7237735343673798$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn("Error thrown from request:", event);
    };
};


class $6aba668a434d9e4c$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $f1a8afbc4574a199$export$d21fbb25eb37b5bf));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $7237735343673798$export$85ceed0783e42041)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $f1a8afbc4574a199$export$7710d69e6f450f20).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $f1a8afbc4574a199$export$7710d69e6f450f20).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $7237735343673798$export$85ceed0783e42041)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $7237735343673798$export$feab8418f018df89)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $c41fefb7cbe633e9$export$2e2bcd8739ae039)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $f1a8afbc4574a199$export$d21fbb25eb37b5bf));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $7237735343673798$export$85ceed0783e42041)(request);
        return event.target.result;
    }
}



const $1511bddba78f2cf9$var$_excluded = [
    "item"
], $1511bddba78f2cf9$var$_excluded2 = [
    "items"
];
function $1511bddba78f2cf9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1511bddba78f2cf9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1511bddba78f2cf9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1511bddba78f2cf9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $1511bddba78f2cf9$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                window.setTimeout(()=>{
                    this.logger.warn("IndexedDB timed out.");
                    reject(new (0, $56713b75b685db03$export$2e2bcd8739ae039)());
                }, (0, $f1a8afbc4574a199$export$6d8635fed0e4b14d));
                /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $f1a8afbc4574a199$export$8cad224051643259), 1);
                request.onupgradeneeded = (event)=>{
                    if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                    const db = request.result;
                    const store = db.createObjectStore((0, $f1a8afbc4574a199$export$3d8420be07b276ab), {
                        keyPath: "id"
                    });
                    store.createIndex((0, $f1a8afbc4574a199$export$a512a65455fce2a6), (0, $f1a8afbc4574a199$export$a512a65455fce2a6), {
                        unique: false
                    });
                    store.createIndex((0, $f1a8afbc4574a199$export$a37d385bcd713809), (0, $f1a8afbc4574a199$export$a37d385bcd713809), {
                        unique: false
                    });
                    store.createIndex((0, $f1a8afbc4574a199$export$89d9c1ff8ac91862), (0, $f1a8afbc4574a199$export$89d9c1ff8ac91862), {
                        unique: false
                    });
                    // Compound key index of product - timeAdded.
                    store.createIndex((0, $f1a8afbc4574a199$export$d21fbb25eb37b5bf), [
                        "namespace",
                        "timeAdded"
                    ], {
                        unique: false
                    });
                };
                try {
                    await (0, $7237735343673798$export$85ceed0783e42041)(request);
                    return resolve(request.result);
                } catch (error) {
                    this.logger.warn("IndexedDB failed to initialise.", error);
                    reject(new (0, $56713b75b685db03$export$2e2bcd8739ae039)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "addItem", async (item, options = {}, policy = (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $7237735343673798$export$aec476f33d77be11)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            if (policy === (0, $f1a8afbc4574a199$export$7710d69e6f450f20).IGNORE) throw new (0, $6be07a4405c4cb7d$export$2e2bcd8739ae039)(policy, "IndexedDbConnector#addItem");
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $3923a3cdd2bfea73$export$74101021e0969375)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "bulkAddItem", async (itemOptions, policy = (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $1511bddba78f2cf9$var$_excluded);
                return (0, $7237735343673798$export$aec476f33d77be11)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $3923a3cdd2bfea73$export$74101021e0969375)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItems", async (count = (0, $9e2c357f10f43e4a$export$b6df3d334cec060f))=>{
            const fixedCount = count > 0 ? count : (0, $9e2c357f10f43e4a$export$b6df3d334cec060f);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            const timeIndex = objectStore.index((0, $f1a8afbc4574a199$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error("Failed to open cursor:", error);
                    reject("Failed to open cursor");
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $1511bddba78f2cf9$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $9e2c357f10f43e4a$export$14ef152a03a4b6ee);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $7237735343673798$export$342d941b6f724995)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $7237735343673798$export$342d941b6f724995)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $7237735343673798$export$feab8418f018df89)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $7237735343673798$export$feab8418f018df89)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readonly");
            const timeIndex = objectStore.index((0, $f1a8afbc4574a199$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $7237735343673798$export$85ceed0783e42041)(request);
            await (0, $7237735343673798$export$feab8418f018df89)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "processItems", async (processFn, count = (0, $9e2c357f10f43e4a$export$b6df3d334cec060f))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_await$this$getItems, $1511bddba78f2cf9$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $26f8ccfaf9e091ee$export$2e2bcd8739ae039)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $7237735343673798$export$85ceed0783e42041)(objectStore.delete(id));
            } catch (error) {
                logger.error("Failed to delete item:", id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $f1a8afbc4574a199$export$3d8420be07b276ab), mode);
            const objectStore = transaction.objectStore((0, $f1a8afbc4574a199$export$3d8420be07b276ab));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $7237735343673798$export$ddc6718318090f71)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $56713b75b685db03$export$2e2bcd8739ae039)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $6aba668a434d9e4c$export$2e2bcd8739ae039)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $f1a8afbc4574a199$export$39337ab5872e9457).INDEXEDDB;
    }
}



var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");




var $g5Zhu = parcelRequire("g5Zhu");


class $01a28ea9a773a0c3$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $f1a8afbc4574a199$export$7710d69e6f450f20).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $f1a8afbc4574a199$export$7710d69e6f450f20).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $c41fefb7cbe633e9$export$2e2bcd8739ae039)((0, $f1a8afbc4574a199$export$39337ab5872e9457).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}



const $4c603e9b4aa433ee$var$_excluded = [
    "item"
], $4c603e9b4aa433ee$var$_excluded2 = [
    "items"
];
function $4c603e9b4aa433ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c603e9b4aa433ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c603e9b4aa433ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c603e9b4aa433ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $4c603e9b4aa433ee$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $7237735343673798$export$ddc6718318090f71)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $01a28ea9a773a0c3$export$2e2bcd8739ae039)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON) {
        if (policy === (0, $f1a8afbc4574a199$export$7710d69e6f450f20).IGNORE) throw new (0, $6be07a4405c4cb7d$export$2e2bcd8739ae039)(policy, "IndexedDbConnector#addItem");
        const storedValue = (0, $7237735343673798$export$aec476f33d77be11)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $4c603e9b4aa433ee$var$_excluded);
            return (0, $7237735343673798$export$aec476f33d77be11)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $9e2c357f10f43e4a$export$b6df3d334cec060f)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $9e2c357f10f43e4a$export$b6df3d334cec060f)) {
        const fixedCount = count > 0 ? count : (0, $9e2c357f10f43e4a$export$b6df3d334cec060f);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($4c603e9b4aa433ee$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $9e2c357f10f43e4a$export$14ef152a03a4b6ee);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$synchronousGetI, $4c603e9b4aa433ee$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $26f8ccfaf9e091ee$export$2e2bcd8739ae039)(error);
        }
    }
    storeType() {
        return (0, $f1a8afbc4574a199$export$39337ab5872e9457).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}



class $4110d75440824020$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $7237735343673798$export$ddc6718318090f71)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $1511bddba78f2cf9$export$2e2bcd8739ae039)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $56713b75b685db03$export$2e2bcd8739ae039))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
            }
        }
        return new (0, $4c603e9b4aa433ee$export$2e2bcd8739ae039)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $f1a8afbc4574a199$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $3923a3cdd2bfea73$export$74101021e0969375)(error)) throw error;
            else if (this.resilience.storeType() === (0, $f1a8afbc4574a199$export$39337ab5872e9457).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $4c603e9b4aa433ee$export$2e2bcd8739ae039)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $f1a8afbc4574a199$export$7710d69e6f450f20).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
        // Dont need to catch. We are just getting events if we can
        }
    }
}




var $2d18c9aad6cb64fe$export$2e2bcd8739ae039 = (0, $4110d75440824020$export$2e2bcd8739ae039);



var $g5Zhu = parcelRequire("g5Zhu");
let $ec2bbf2d836fefb8$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $ec2bbf2d836fefb8$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});


class $0619d49876a02fde$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "resilienceMechanism", (0, $ec2bbf2d836fefb8$export$c75161629e3ec34e).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $0619d49876a02fde$var$cachedMetricsClient = null;
var $0619d49876a02fde$export$2e2bcd8739ae039 = ()=>{
    if (!$0619d49876a02fde$var$cachedMetricsClient) $0619d49876a02fde$var$cachedMetricsClient = new $0619d49876a02fde$export$4b62ee5120ab50a8();
    return $0619d49876a02fde$var$cachedMetricsClient;
};



class $fc400720adfd96ae$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        window.addEventListener("offline", ()=>networkChangeCallback((0, $ec2bbf2d836fefb8$export$ee138fa712d11b84).OFFLINE));
        window.addEventListener("online", ()=>networkChangeCallback((0, $ec2bbf2d836fefb8$export$ee138fa712d11b84).ONLINE));
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $ec2bbf2d836fefb8$export$ee138fa712d11b84).ONLINE;
        return (0, $ec2bbf2d836fefb8$export$ee138fa712d11b84).OFFLINE;
    }
}



var $g5Zhu = parcelRequire("g5Zhu");

var $g5Zhu = parcelRequire("g5Zhu");
let $0e07d0d48d380985$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $0e07d0d48d380985$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $0e07d0d48d380985$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "callbackStatus", $0e07d0d48d380985$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $0e07d0d48d380985$export$ef3353088fca369c.IDLE:
            case $0e07d0d48d380985$export$ef3353088fca369c.TIMED_OUT:
            case $0e07d0d48d380985$export$ef3353088fca369c.COMPLETED:
                if (event === $0e07d0d48d380985$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $0e07d0d48d380985$export$ef3353088fca369c.RUNNING;
                break;
            case $0e07d0d48d380985$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $0e07d0d48d380985$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $0e07d0d48d380985$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $0e07d0d48d380985$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $0e07d0d48d380985$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        this.transitionCallbackStatus(this.callbackStatus, $0e07d0d48d380985$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $0e07d0d48d380985$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $0e07d0d48d380985$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $0e07d0d48d380985$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}


// Clients can optionally provide the callbackTimeoutPeriod parameter
let $ed27570a688ef2d6$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});


const $aed8a24ea5955233$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $aed8a24ea5955233$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $aed8a24ea5955233$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $aed8a24ea5955233$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $aed8a24ea5955233$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $aed8a24ea5955233$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $aed8a24ea5955233$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearTimeout", ()=>{
            if (this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $ed27570a688ef2d6$export$f93c40fda808dd0c).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $ed27570a688ef2d6$export$f93c40fda808dd0c).ERROR || this.callbackTimer.getCallbackStatus() === (0, $0e07d0d48d380985$export$ef3353088fca369c).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $ed27570a688ef2d6$export$f93c40fda808dd0c).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $aed8a24ea5955233$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $aed8a24ea5955233$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $aed8a24ea5955233$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $aed8a24ea5955233$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $aed8a24ea5955233$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $aed8a24ea5955233$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $aed8a24ea5955233$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $aed8a24ea5955233$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $aed8a24ea5955233$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $aed8a24ea5955233$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $0e07d0d48d380985$export$590a718599f8f8b3)(this.options.callbackTimeoutPeriod);
    }
}



function $68ee01c3d32244bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68ee01c3d32244bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68ee01c3d32244bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68ee01c3d32244bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $68ee01c3d32244bd$var$ONE_MINUTE = 60000;
const $68ee01c3d32244bd$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $68ee01c3d32244bd$var$ONE_MINUTE,
    minRetryDelay: $68ee01c3d32244bd$var$ONE_MINUTE,
    maxRetryDelay: $68ee01c3d32244bd$var$ONE_MINUTE
};
const $68ee01c3d32244bd$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $68ee01c3d32244bd$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $2d18c9aad6cb64fe$export$2e2bcd8739ae039)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $aed8a24ea5955233$export$2e2bcd8739ae039)($68ee01c3d32244bd$var$_objectSpread($68ee01c3d32244bd$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $aed8a24ea5955233$export$2e2bcd8739ae039)($68ee01c3d32244bd$var$_objectSpread($68ee01c3d32244bd$var$_objectSpread({}, $68ee01c3d32244bd$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $68ee01c3d32244bd$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $0619d49876a02fde$export$2e2bcd8739ae039)();
        this.networkStatus = new (0, $fc400720adfd96ae$export$2e2bcd8739ae039)((status)=>{
            if (status === (0, $ec2bbf2d836fefb8$export$ee138fa712d11b84).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $f1a8afbc4574a199$export$7710d69e6f450f20).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $ec2bbf2d836fefb8$export$ee138fa712d11b84).OFFLINE) {
            done((0, $ed27570a688ef2d6$export$f93c40fda808dd0c).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $26f8ccfaf9e091ee$export$a409c8de90e11e14)) {
                done((0, $ed27570a688ef2d6$export$f93c40fda808dd0c).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $32c3e15d6938acbd$export$2e2bcd8739ae039)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $562f527bc061b2a2$export$2e2bcd8739ae039)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $f1a8afbc4574a199$export$7710d69e6f450f20).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: "successful"
            };
            else return {
                status: "partial",
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $ed27570a688ef2d6$export$f93c40fda808dd0c).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $ed27570a688ef2d6$export$f93c40fda808dd0c).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $ed27570a688ef2d6$export$f93c40fda808dd0c).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $68ee01c3d32244bd$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $68ee01c3d32244bd$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $68ee01c3d32244bd$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $68ee01c3d32244bd$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $68ee01c3d32244bd$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $68ee01c3d32244bd$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $68ee01c3d32244bd$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $68ee01c3d32244bd$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $68ee01c3d32244bd$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}



var $10e628758231d4cb$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $68ee01c3d32244bd$export$2e2bcd8739ae039)(retryQueuePrefix, product, options || {}, logger);
};




var $g5Zhu = parcelRequire("g5Zhu");
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $1260132250289437$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $1260132250289437$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $1260132250289437$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});


function $e59b72f152103bf0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e59b72f152103bf0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e59b72f152103bf0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e59b72f152103bf0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e59b72f152103bf0$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $1260132250289437$export$ddf929981dc6feb3).PAGE || item.msg.type === (0, $1260132250289437$export$ddf929981dc6feb3).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $e59b72f152103bf0$var$_objectSpread($e59b72f152103bf0$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $1260132250289437$export$ddf929981dc6feb3).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $e59b72f152103bf0$var$_objectSpread($e59b72f152103bf0$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $e59b72f152103bf0$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$e59b72f152103bf0$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}


const $ad0bcca32dd32f14$export$9175ce0e1c95daf2 = 10000; // 10 seconds



var $g5Zhu = parcelRequire("g5Zhu");
var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}


function $d4c959ed3758b620$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d4c959ed3758b620$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d4c959ed3758b620$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d4c959ed3758b620$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d4c959ed3758b620$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $d4c959ed3758b620$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $d4c959ed3758b620$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $d4c959ed3758b620$var$_objectSpread({
        method: "POST",
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            "Content-Type": "text/plain"
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $d4c959ed3758b620$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $d4c959ed3758b620$var$getCorsForUrl = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});



function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}


function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY = 86400000;
function $f8bd67cac91ee19b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $5e650688c0910592$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $f8bd67cac91ee19b$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}



var $GtgEQ = parcelRequire("GtgEQ");
let $51a0d6d4e4b527a1$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $51a0d6d4e4b527a1$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $51a0d6d4e4b527a1$export$d4cb17942ea57c95 = {
    [$51a0d6d4e4b527a1$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $51a0d6d4e4b527a1$var$CookieSchema("__awc_tld_test__", {
        expires: 365,
        secure: window.location.protocol === "https:",
        path: "/"
    }),
    [$51a0d6d4e4b527a1$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $51a0d6d4e4b527a1$var$CookieSchema("atlassian_analytics_debug", {
        expires: 365,
        secure: window.location.protocol === "https:",
        path: "/"
    }),
    [$51a0d6d4e4b527a1$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $51a0d6d4e4b527a1$var$CookieSchema("ajs_anonymous_id", {
        expires: 365,
        secure: window.location.protocol === "https:",
        path: "/"
    })
};


var $g5Zhu = parcelRequire("g5Zhu");
var $a97786e851d72f87$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $a97786e851d72f87$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});




var $g5Zhu = parcelRequire("g5Zhu");
class $d5def0ae3ce1fc27$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$d5def0ae3ce1fc27$export$2e2bcd8739ae039 = new $d5def0ae3ce1fc27$export$90e3e001bcac59c7();



var $g5Zhu = parcelRequire("g5Zhu");


const $9927f0047e35c0d6$export$41c06fdd37b7e9a5 = "awc";
const $9927f0047e35c0d6$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
function $9927f0047e35c0d6$export$48c17662a6902497(store) {
    const TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        const key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $9927f0047e35c0d6$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $9927f0047e35c0d6$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($9927f0047e35c0d6$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $d5def0ae3ce1fc27$export$2e2bcd8739ae039)) return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($9927f0047e35c0d6$export$48c17662a6902497(window[$9927f0047e35c0d6$export$770aa8bc07b3de03])) inMemoryStorage = window[$9927f0047e35c0d6$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $d5def0ae3ce1fc27$export$2e2bcd8739ae039);
                if (!window[$9927f0047e35c0d6$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$9927f0047e35c0d6$export$770aa8bc07b3de03] = (0, $d5def0ae3ce1fc27$export$2e2bcd8739ae039);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($9927f0047e35c0d6$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $d6ce1402442d8264$export$56ac8ebc9870b1b9).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join("-");
        if ($9927f0047e35c0d6$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}


class $56fafc0b2ee013c7$export$2e2bcd8739ae039 extends (0, $9927f0047e35c0d6$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $d5def0ae3ce1fc27$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $d5def0ae3ce1fc27$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}


class $cecbb8372483c3a9$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $56fafc0b2ee013c7$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}





const $8484d123036887d3$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
const $8484d123036887d3$export$eb80e1beaa8dacf8 = (0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95).AWC_TLD_TEST.getKey();
const $8484d123036887d3$export$19164982d36535d8 = "tld_test";
const $8484d123036887d3$export$de6821eed3d5f32d = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(()=>{
    const { hostname: hostname } = location;
    const splitHostname = hostname.split(".");
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join(".")}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($a97786e851d72f87$exports))).set($8484d123036887d3$export$eb80e1beaa8dacf8, $8484d123036887d3$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a97786e851d72f87$exports))).get($8484d123036887d3$export$eb80e1beaa8dacf8) === $8484d123036887d3$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($a97786e851d72f87$exports))).remove($8484d123036887d3$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});


function $9fd054f8422cc9ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fd054f8422cc9ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fd054f8422cc9ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fd054f8422cc9ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $9fd054f8422cc9ec$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $8484d123036887d3$export$a9330601ee8f4d95)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($a97786e851d72f87$exports))) : new (0, $cecbb8372483c3a9$export$2e2bcd8739ae039)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95)[name].getKey(), value, $9fd054f8422cc9ec$var$_objectSpread($9fd054f8422cc9ec$var$_objectSpread({}, (0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $8484d123036887d3$export$de6821eed3d5f32d)()
        }, options));
    }
    get(name) {
        if (!(0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95)[name].getKey(), $9fd054f8422cc9ec$var$_objectSpread({}, options));
    }
}



// Cookie is stale, if anonymousId was generated 7 days ago.
const $e2354013c53bb450$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $e2354013c53bb450$var$SAFE = "SAFE";
const $e2354013c53bb450$var$UNSAFE = "UNSAFE";
const $e2354013c53bb450$var$NOT_FOUND = "NOT_FOUND";
const $e2354013c53bb450$var$COOKIE = "COOKIE";
const $e2354013c53bb450$var$LOCAL_STORAGE = "LOCAL_STORAGE";
class $e2354013c53bb450$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $56fafc0b2ee013c7$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $9fd054f8422cc9ec$export$2e2bcd8739ae039)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $51a0d6d4e4b527a1$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $e2354013c53bb450$var$LOCAL_STORAGE ? this.store.getItem((0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $51a0d6d4e4b527a1$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $e2354013c53bb450$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === "string") return {
                    type: $e2354013c53bb450$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $e2354013c53bb450$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($e2354013c53bb450$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $5e650688c0910592$export$2e2bcd8739ae039)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $e2354013c53bb450$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $e2354013c53bb450$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $e2354013c53bb450$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $e2354013c53bb450$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($e2354013c53bb450$var$COOKIE);
        switch(cookieValue.type){
            case $e2354013c53bb450$var$SAFE:
            case $e2354013c53bb450$var$UNSAFE:
                this.store.setItem((0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $e2354013c53bb450$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}



var $g5Zhu = parcelRequire("g5Zhu");
var $c168b02aa2d0b720$exports = {};
"use strict";
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $3ffda4e754dfe2c2$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $3ffda4e754dfe2c2$export$226b3eccf92c9ed9;
"use strict";
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $3ffda4e754dfe2c2$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$3ffda4e754dfe2c2$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $3ffda4e754dfe2c2$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + "00").substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === " ") offset = new Date().getTimezoneOffset();
    else if (arr[9] !== "Z" && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === "+") offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$3ffda4e754dfe2c2$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== "string") return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $3ffda4e754dfe2c2$var$matcher.test(string);
};


/**
 * Expose `traverse`.
 */ $c168b02aa2d0b720$exports = $c168b02aa2d0b720$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $c168b02aa2d0b720$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === "object") return $c168b02aa2d0b720$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $c168b02aa2d0b720$var$traverseArray(input, strict);
    else if ($3ffda4e754dfe2c2$export$226b3eccf92c9ed9(input, strict)) return $3ffda4e754dfe2c2$export$98e6a39c04603d36(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $c168b02aa2d0b720$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $c168b02aa2d0b720$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $c168b02aa2d0b720$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $c168b02aa2d0b720$var$traverse(value, strict);
    });
    return arr;
}


function $c2bee34d3beb373d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2bee34d3beb373d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2bee34d3beb373d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2bee34d3beb373d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c2bee34d3beb373d$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $c2bee34d3beb373d$var$_objectSpread($c2bee34d3beb373d$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $c2bee34d3beb373d$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $c2bee34d3beb373d$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c168b02aa2d0b720$exports)))(propertiesWithoutUndefined);
};
const $c2bee34d3beb373d$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== "object") return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $c2bee34d3beb373d$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$c2bee34d3beb373d$export$2250ccecd1e040fd(i));
            else if (typeof value === "object" && value !== null) clone[key] = $c2bee34d3beb373d$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $c2bee34d3beb373d$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};


function $ce4c4fcc94632f23$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce4c4fcc94632f23$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce4c4fcc94632f23$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce4c4fcc94632f23$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $ce4c4fcc94632f23$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $ce4c4fcc94632f23$var$_objectSpread($ce4c4fcc94632f23$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $d4c959ed3758b620$export$8e8f0180c1b41fad)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
            } catch (error) {
                callback(error, null);
            }
        });
        this.options = $ce4c4fcc94632f23$var$_objectSpread($ce4c4fcc94632f23$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $ad0bcca32dd32f14$export$9175ce0e1c95daf2),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $e2354013c53bb450$export$2e2bcd8739ae039)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $0619d49876a02fde$export$2e2bcd8739ae039)();
        this.resilienceQueue = (0, $10e628758231d4cb$export$2e2bcd8739ae039)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $1260132250289437$export$ddf929981dc6feb3).TRACK, builtEvent);
        const eventWithoutMessageId = $ce4c4fcc94632f23$var$_objectSpread($ce4c4fcc94632f23$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $1260132250289437$export$ddf929981dc6feb3).TRACK,
            properties: (0, $c2bee34d3beb373d$export$44d22e5fb02cc68e)(builtEvent),
            event: eventName
        });
        const event = $ce4c4fcc94632f23$var$_objectSpread($ce4c4fcc94632f23$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $1260132250289437$export$ddf929981dc6feb3).PAGE, builtEvent);
        const eventWithoutMessageId = $ce4c4fcc94632f23$var$_objectSpread($ce4c4fcc94632f23$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $1260132250289437$export$ddf929981dc6feb3).PAGE,
            properties: (0, $c2bee34d3beb373d$export$44d22e5fb02cc68e)(builtEvent),
            name: eventName
        });
        const event = $ce4c4fcc94632f23$var$_objectSpread($ce4c4fcc94632f23$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $1260132250289437$export$ddf929981dc6feb3).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $ce4c4fcc94632f23$var$_objectSpread($ce4c4fcc94632f23$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $1260132250289437$export$ddf929981dc6feb3).IDENTIFY,
            traits: (0, $c2bee34d3beb373d$export$44d22e5fb02cc68e)(builtEvent)
        });
        const event = $ce4c4fcc94632f23$var$_objectSpread($ce4c4fcc94632f23$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $c2bee34d3beb373d$export$44d22e5fb02cc68e)(context);
        const segmentContext = (0, $c2bee34d3beb373d$export$3a7fe28f9bf4f3d9)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                "Content-Type": "text/plain"
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $e59b72f152103bf0$export$c21270cab66ab290)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
}



var $g5Zhu = parcelRequire("g5Zhu");

var $3ecb7368762fc268$export$f9380c9a627682d3;
var $3ecb7368762fc268$export$98e6a39c04603d36;
var $3ecb7368762fc268$export$fac44ee5b035f737;
var $3ecb7368762fc268$export$7a5253c0f62e0150;
var $3ecb7368762fc268$export$a8c1621ea79325d3;
var $3ecb7368762fc268$export$357523c63a2253b9;
var $3ecb7368762fc268$export$44c361b8ec72ef7f;
"use strict";
var $2854ab6fe5249e91$exports = {};
"use strict";
$2854ab6fe5249e91$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $40bbc24beab9f9b8$exports = {};
"use strict";
var $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")|([^%]+?)", "gi");
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$40bbc24beab9f9b8$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};


var $08bd16383ca1ef3d$exports = {};
"use strict";
$08bd16383ca1ef3d$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $36fe9d1ef26e3f64$exports = {};
"use strict";
$36fe9d1ef26e3f64$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $3ecb7368762fc268$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $3ecb7368762fc268$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $3ecb7368762fc268$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            $3ecb7368762fc268$var$encode(index, options),
                            "]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $3ecb7368762fc268$var$encode(key, options),
                                keyValueSep,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $3ecb7368762fc268$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $3ecb7368762fc268$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $3ecb7368762fc268$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3ecb7368762fc268$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options)) : value === null ? value : $3ecb7368762fc268$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $3ecb7368762fc268$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3ecb7368762fc268$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $3ecb7368762fc268$var$encode(value, options) {
    if (options.encode) return options.strict ? $2854ab6fe5249e91$exports(value) : encodeURIComponent(value);
    return value;
}
function $3ecb7368762fc268$var$decode(value, options) {
    if (options.decode) return $40bbc24beab9f9b8$exports(value);
    return value;
}
function $3ecb7368762fc268$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $3ecb7368762fc268$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3ecb7368762fc268$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3ecb7368762fc268$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3ecb7368762fc268$var$extract(input) {
    input = $3ecb7368762fc268$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $3ecb7368762fc268$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $3ecb7368762fc268$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3ecb7368762fc268$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $08bd16383ca1ef3d$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $3ecb7368762fc268$var$decode(value, options);
        formatter($3ecb7368762fc268$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $3ecb7368762fc268$var$parseValue(value[k], options);
        else ret[key] = $3ecb7368762fc268$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3ecb7368762fc268$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3ecb7368762fc268$export$f9380c9a627682d3 = $3ecb7368762fc268$var$extract;
$3ecb7368762fc268$export$98e6a39c04603d36 = $3ecb7368762fc268$var$parse;
$3ecb7368762fc268$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3ecb7368762fc268$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $3ecb7368762fc268$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $3ecb7368762fc268$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $3ecb7368762fc268$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $3ecb7368762fc268$var$encode(key, options) + "=" + $3ecb7368762fc268$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$3ecb7368762fc268$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $08bd16383ca1ef3d$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $3ecb7368762fc268$var$parse($3ecb7368762fc268$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3ecb7368762fc268$var$decode(hash, options)
    } : {});
};
$3ecb7368762fc268$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $3ecb7368762fc268$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $3ecb7368762fc268$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3ecb7368762fc268$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3ecb7368762fc268$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3ecb7368762fc268$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$3ecb7368762fc268$var$encodeFragmentIdentifier] ? $3ecb7368762fc268$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$3ecb7368762fc268$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $3ecb7368762fc268$export$7a5253c0f62e0150(input, options);
    return $3ecb7368762fc268$export$a8c1621ea79325d3({
        url: url,
        query: $36fe9d1ef26e3f64$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3ecb7368762fc268$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3ecb7368762fc268$export$357523c63a2253b9(input, exclusionFilter, options);
};



const $c8e2bc57403e581e$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, "", newUrl);
const $c8e2bc57403e581e$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $c8e2bc57403e581e$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    const { url: url, query: query } = (0, $3ecb7368762fc268$export$7a5253c0f62e0150)(removedFragmentURL);
    const captureParams = (0, $8a4ab4de05c8ab64$export$b460b275d6c6aa0)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $8a4ab4de05c8ab64$export$d7a617dda645b4e3)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $3ecb7368762fc268$export$fac44ee5b035f737)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $c8e2bc57403e581e$export$2e2bcd8739ae039 = $c8e2bc57403e581e$var$urlParamExtractor;


class $74aa46e1117c7818$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $d6ce1402442d8264$export$62a500c02dc63ee)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $c8e2bc57403e581e$export$2e2bcd8739ae039)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}




var $g5Zhu = parcelRequire("g5Zhu");

const $c9a21e8f70354245$var$SESSION_ID_STORAGE_KEY = "session.id";
const $c9a21e8f70354245$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
const $c9a21e8f70354245$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $c9a21e8f70354245$export$285f6bddd927a06d = 1800000; // 30 minutes
const $c9a21e8f70354245$export$a92e915d70316eb2 = 5000; // 5 seconds
const $c9a21e8f70354245$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $c9a21e8f70354245$export$5702a91a6f42969f = ()=>{};
class $c9a21e8f70354245$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($c9a21e8f70354245$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($c9a21e8f70354245$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $c9a21e8f70354245$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $c9a21e8f70354245$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $c9a21e8f70354245$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $c9a21e8f70354245$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $56fafc0b2ee013c7$export$2e2bcd8739ae039)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($c9a21e8f70354245$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($c9a21e8f70354245$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$c9a21e8f70354245$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}




class $f7c4c7ac8da290e0$export$2e2bcd8739ae039 extends (0, $9927f0047e35c0d6$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $d5def0ae3ce1fc27$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $d5def0ae3ce1fc27$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}



var $g5Zhu = parcelRequire("g5Zhu");

var $GtgEQ = parcelRequire("GtgEQ");

const $e216c7fb8db2c3ce$var$STORAGE_KEY = "tab.id";
class $e216c7fb8db2c3ce$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))();
            this._safeSessionStorage.setItem($e216c7fb8db2c3ce$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $f7c4c7ac8da290e0$export$2e2bcd8739ae039)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($e216c7fb8db2c3ce$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}



var $g5Zhu = parcelRequire("g5Zhu");


var $GtgEQ = parcelRequire("GtgEQ");




function $da88fcff82a2ba8b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da88fcff82a2ba8b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da88fcff82a2ba8b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da88fcff82a2ba8b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $da88fcff82a2ba8b$var$STORAGE_KEY = "taskSessions";
const $da88fcff82a2ba8b$var$INIT_KEY = "taskSessionsInit";
const $da88fcff82a2ba8b$var$AWC_PARAM_PREFIX = "awc.";
const $da88fcff82a2ba8b$var$TASK_SESSION_RELOAD_TIME = 3000;
class $da88fcff82a2ba8b$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($da88fcff82a2ba8b$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($da88fcff82a2ba8b$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($da88fcff82a2ba8b$var$INIT_KEY) || "0", 10) < currentTimestamp - $da88fcff82a2ba8b$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($da88fcff82a2ba8b$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($da88fcff82a2ba8b$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($da88fcff82a2ba8b$var$STORAGE_KEY) || "");
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($da88fcff82a2ba8b$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $3ecb7368762fc268$export$7a5253c0f62e0150)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $8a4ab4de05c8ab64$export$357523c63a2253b9)(currentState, includedTaskSessions) : (0, $8a4ab4de05c8ab64$export$30a06c8d3562193f)(currentState, Object.values((0, $d6ce1402442d8264$export$62a500c02dc63ee)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $da88fcff82a2ba8b$var$_objectSpread($da88fcff82a2ba8b$var$_objectSpread({}, (0, $8a4ab4de05c8ab64$export$781522908e4e76a1)(filteredTaskSessions, (_, taskSessionName)=>$da88fcff82a2ba8b$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $3ecb7368762fc268$export$fac44ee5b035f737)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $8a4ab4de05c8ab64$export$781522908e4e76a1)((0, $c8e2bc57403e581e$export$2e2bcd8739ae039)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $f7c4c7ac8da290e0$export$2e2bcd8739ae039)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($da88fcff82a2ba8b$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}



var $g5Zhu = parcelRequire("g5Zhu");


const $2d14e27be707b776$var$MAX_CACHE_SIZE = 100;
const $2d14e27be707b776$var$COOKIE_NAME = (0, $51a0d6d4e4b527a1$export$d4cb17942ea57c95).AWC_ANALYTICS_DEBUG.getKey();
const $2d14e27be707b776$var$DEBUG_TAG = "synthetic";
const $2d14e27be707b776$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($a97786e851d72f87$exports))).get($2d14e27be707b776$var$COOKIE_NAME) || "false");
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($a97786e851d72f87$exports))).remove($2d14e27be707b776$var$COOKIE_NAME);
    }
    return false;
};
class $2d14e27be707b776$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_bind", ()=>{
            if (window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem("awc.ui.viewed.last.sent");
                        localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                        localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                        localStorage.removeItem("awc-local.ui.viewed.last.sent");
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_cache", (event)=>{
            if (window.testAnalytics.eventCache.length >= $2d14e27be707b776$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($2d14e27be707b776$var$DEBUG_TAG);
                else event.tags = [
                    $2d14e27be707b776$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $2d14e27be707b776$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $2d14e27be707b776$export$2e2bcd8739ae039 = $2d14e27be707b776$var$TestingCache;



var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");


const $2075b04ae0a428e0$var$_excluded = [
    "embeddedProduct"
];
function $2075b04ae0a428e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2075b04ae0a428e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2075b04ae0a428e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2075b04ae0a428e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2075b04ae0a428e0$var$DEFAULT_DELAY = 2000; // 2 seconds
const $2075b04ae0a428e0$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $2075b04ae0a428e0$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
class $2075b04ae0a428e0$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_bindEventListeners", ()=>{
            window.addEventListener("focus", this._focusListener);
            window.addEventListener("blur", this._blurListener);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_unbindEventListeners", ()=>{
            window.removeEventListener("focus", this._focusListener);
            window.removeEventListener("blur", this._blurListener);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || "");
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $d6ce1402442d8264$export$496f06ac2a964da2).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$_getContext, $2075b04ae0a428e0$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: "ui",
                action: "viewed",
                actionSubject: "ui",
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $2075b04ae0a428e0$var$_objectSpread($2075b04ae0a428e0$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $2075b04ae0a428e0$var$_objectSpread($2075b04ae0a428e0$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!getContext) throw new Error("Missing getContext callback");
        if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $2075b04ae0a428e0$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $2075b04ae0a428e0$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $2075b04ae0a428e0$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $56fafc0b2ee013c7$export$2e2bcd8739ae039)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}



function $10d754cfff418a6e$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return ()=>{
        callback(event);
    };
}


let $d6dbe294affbde29$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $d6dbe294affbde29$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});


const $15ed08ee17e5aa63$export$545bcbd53afabfa3 = 5000;
const $15ed08ee17e5aa63$export$af4087e36d63846 = ()=>[
        {
            type: (0, $d6dbe294affbde29$export$92ca0438bcb0d396).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $d6dbe294affbde29$export$92ca0438bcb0d396).UID,
            state: "TIMEOUT"
        }
    ];
const $15ed08ee17e5aa63$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $d6dbe294affbde29$export$92ca0438bcb0d396).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $d6dbe294affbde29$export$92ca0438bcb0d396).UID,
            state: "UNKNOWN"
        }
    ];


const $d252773de3de395e$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $15ed08ee17e5aa63$export$af4087e36d63846)()), (0, $15ed08ee17e5aa63$export$545bcbd53afabfa3));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $15ed08ee17e5aa63$export$fa341d0c750d705b)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};


function $520bfd73c957e8cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $520bfd73c957e8cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $520bfd73c957e8cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $520bfd73c957e8cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $520bfd73c957e8cd$var$PROD_HOST = "as.atlassian.com/api/v1";
const $520bfd73c957e8cd$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
const $520bfd73c957e8cd$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
const $520bfd73c957e8cd$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
const $520bfd73c957e8cd$var$FEDRAMP_SANDBOX_HOST = "as.atlassian-fex.com/api/v1";
const $520bfd73c957e8cd$var$STARGATE_FEDRAMP_SANDBOX_HOST = "api-private.atlassian-fex.com/gasv3/api/v1";
const $520bfd73c957e8cd$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
const $520bfd73c957e8cd$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
class $520bfd73c957e8cd$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_selectHost", ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter })=>{
            if (!useStargate) {
                if (perimeter === (0, $d6ce1402442d8264$export$bdd41749d2096e4b).FEDRAMP_MODERATE && env === (0, $d6ce1402442d8264$export$56ac8ebc9870b1b9).STAGING) return $520bfd73c957e8cd$var$FEDRAMP_SANDBOX_HOST;
                return env === (0, $d6ce1402442d8264$export$56ac8ebc9870b1b9).PROD ? $520bfd73c957e8cd$var$PROD_HOST : $520bfd73c957e8cd$var$STAGING_HOST;
            }
            if (useLegacyUrl) {
                if (perimeter === (0, $d6ce1402442d8264$export$bdd41749d2096e4b).FEDRAMP_MODERATE && env === (0, $d6ce1402442d8264$export$56ac8ebc9870b1b9).STAGING) return $520bfd73c957e8cd$var$STARGATE_FEDRAMP_SANDBOX_HOST;
                return env === (0, $d6ce1402442d8264$export$56ac8ebc9870b1b9).PROD ? $520bfd73c957e8cd$var$STARGATE_PROD_HOST : $520bfd73c957e8cd$var$STARGATE_STAGING_HOST;
            }
            /**
       * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
       * For more details, see:
       *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
       *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
       */ return window.location.host + $520bfd73c957e8cd$export$5df9262e102d0c32;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_createSubproductGetter", (subproduct)=>(0, $6aaee5584813c382$export$2e2bcd8739ae039)(subproduct, "Cannot get subproduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $6aaee5584813c382$export$2e2bcd8739ae039)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($520bfd73c957e8cd$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
            } catch (err) {
                this._safeSessionStorage.removeItem($520bfd73c957e8cd$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($520bfd73c957e8cd$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $d6ce1402442d8264$export$4c045e605d532c98).UI:
                case (0, $d6ce1402442d8264$export$4c045e605d532c98).OPERATIONAL:
                case (0, $d6ce1402442d8264$export$4c045e605d532c98).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $d6ce1402442d8264$export$4c045e605d532c98).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $d6ce1402442d8264$export$4c045e605d532c98).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    "sentWithDelay"
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
     * Calling this function in the intialisation of the client in product
     * captures specified 'origin tracing' URL params and fires a single origin landed event
     * <p>
     * This function expects a mapping between the keys for any URL parameters
     *  that should be captured and removed for origin tracing
     * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
     * Each handler function should return an object with two items
     * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
     * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
     *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
     * </p>
     * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
     * e.g. from a share or email
     *
     * An example calling this function using an external decoding library, with taskSessionId specified to persist
     * analyticsWebClient.setOriginTracingHandlers({
          atlOrigin: encodedOrigin => {
              const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
              return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
          },
      });
     *
     * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
     * @this {AnalyticsWebClient}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: "landed",
                actionSubject: "origin",
                source: "webClient",
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error("Missing tenantIdType");
            if (tenantIdType !== (0, $d6ce1402442d8264$export$496f06ac2a964da2).NONE && !tenantId) throw new Error("Missing tenantId");
            if (!(0, $d6ce1402442d8264$export$26b9f946b448f23e)((0, $d6ce1402442d8264$export$496f06ac2a964da2), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $d6ce1402442d8264$export$ad1854f4a08c15f8)((0, $d6ce1402442d8264$export$496f06ac2a964da2))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error("Missing orgId");
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error("Missing workspaceId");
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $a4d00bd888f23c01$export$c16a4e16aa4026c0)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
            if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
            this._uiViewedAttributes = $520bfd73c957e8cd$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $d6ce1402442d8264$export$4c045e605d532c98).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === "object") {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $a4d00bd888f23c01$export$dc993432a592dc27)(screenName);
            (0, $a4d00bd888f23c01$export$e63ea5d8477971d3)(screenContainers);
            const builtEvent = (0, $1e144fb3742c9947$export$c7d9a5f56acc4b19)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers);
            const builtEventWithName = $520bfd73c957e8cd$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $10d754cfff418a6e$export$2e2bcd8739ae039)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $a4d00bd888f23c01$export$8c014fd74b0c8b99)(event);
            const builtEvent = (0, $1e144fb3742c9947$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $d6ce1402442d8264$export$4c045e605d532c98).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo);
            return this._processEvent((0, $1e144fb3742c9947$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $10d754cfff418a6e$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendUIEvent", (event, callback)=>{
            (0, $a4d00bd888f23c01$export$e5bac0930c812e90)(event);
            const builtEvent = (0, $1e144fb3742c9947$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $d6ce1402442d8264$export$4c045e605d532c98).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo);
            return this._processEvent((0, $1e144fb3742c9947$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $10d754cfff418a6e$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $a4d00bd888f23c01$export$1e561554275607ef)(event);
            const builtEvent = (0, $1e144fb3742c9947$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $d6ce1402442d8264$export$4c045e605d532c98).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo);
            return this._processEvent((0, $1e144fb3742c9947$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $10d754cfff418a6e$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $2075b04ae0a428e0$export$2e2bcd8739ae039)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error("Missing analyticsData");
            if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
            if (analyticsData.eventType === (0, $d6ce1402442d8264$export$4c045e605d532c98).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $d6ce1402442d8264$export$4c045e605d532c98).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $d6ce1402442d8264$export$4c045e605d532c98).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $d6ce1402442d8264$export$4c045e605d532c98).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $d6ce1402442d8264$export$4c045e605d532c98).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $d6ce1402442d8264$export$ad1854f4a08c15f8)((0, $d6ce1402442d8264$export$4c045e605d532c98))}]`);
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.env) throw new Error("Missing productInfo.env");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!(0, $d6ce1402442d8264$export$26b9f946b448f23e)((0, $d6ce1402442d8264$export$56ac8ebc9870b1b9), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $d6ce1402442d8264$export$ad1854f4a08c15f8)((0, $d6ce1402442d8264$export$56ac8ebc9870b1b9))}]`);
        if (productInfo.perimeter && !(0, $d6ce1402442d8264$export$26b9f946b448f23e)((0, $d6ce1402442d8264$export$bdd41749d2096e4b), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $d6ce1402442d8264$export$ad1854f4a08c15f8)((0, $d6ce1402442d8264$export$bdd41749d2096e4b))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $d6ce1402442d8264$export$f73e9fcd368bb695).WEB;
        else if (!(0, $d6ce1402442d8264$export$26b9f946b448f23e)((0, $d6ce1402442d8264$export$f73e9fcd368bb695), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $d6ce1402442d8264$export$ad1854f4a08c15f8)((0, $d6ce1402442d8264$export$f73e9fcd368bb695))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $d6ce1402442d8264$export$f73e9fcd368bb695).WEB ? (0, $d6ce1402442d8264$export$6b4f396210e539f3).WEB : (0, $d6ce1402442d8264$export$6b4f396210e539f3).DESKTOP;
        else (0, $a4d00bd888f23c01$export$801b46c35394d316)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $520bfd73c957e8cd$var$_objectSpread($520bfd73c957e8cd$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $1e144fb3742c9947$export$3a7fe28f9bf4f3d9)(this._productInfo);
        this._safeSessionStorage = new (0, $f7c4c7ac8da290e0$export$2e2bcd8739ae039)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || this._selectHost({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter
        });
        const apiHostProtocol = settings.apiHostProtocol || "https";
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $d252773de3de395e$export$fbe53bbbe682bcdd)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $ce4c4fcc94632f23$export$2e2bcd8739ae039)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $b09d1a9975733eb7$export$2e2bcd8739ae039)();
        this._tabTracking = new (0, $e216c7fb8db2c3ce$export$2e2bcd8739ae039)();
        this._sessionTracking = new (0, $c9a21e8f70354245$export$2e2bcd8739ae039)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $da88fcff82a2ba8b$export$2e2bcd8739ae039)();
        this.originTracing = new (0, $74aa46e1117c7818$export$2e2bcd8739ae039)();
        // Init Apdex
        this._apdexEvent = new (0, $72465ab69bc3af9a$export$2e2bcd8739ae039)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $c8e2bc57403e581e$export$600dd5bf1b049f11);
        this.eventDelayQueue = new (0, $4bfa36a99675327b$export$2e2bcd8739ae039)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $2d14e27be707b776$export$2e2bcd8739ae039)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))();
        this._workspaceInfo = {};
    }
}




const $816be88acf151818$var$isLocal = (0, $a2299f428347f042$export$1038046b28a1d92e)() === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).LOCAL;
const $816be88acf151818$var$getApiHost = ()=>{
    const host = "";
    return `${host}/gateway/api/gasv3/api/v1/`;
};
const $816be88acf151818$export$b2e5abba3e61d1a4 = new (0, $520bfd73c957e8cd$export$2e2bcd8739ae039)({
    env: (0, $a2299f428347f042$export$1038046b28a1d92e)(),
    locale: "en",
    product: "devAgents",
    version: "1.0.0",
    origin: (0, $d6ce1402442d8264$export$f73e9fcd368bb695).WEB
}, $816be88acf151818$var$isLocal ? {
    apiHost: $816be88acf151818$var$getApiHost()
} : undefined);



const $8335f2c2f41b5065$var$AnalyticsWebClientContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $8335f2c2f41b5065$export$457db49ce252eed8 = ({ children: children })=>{
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { user: user } = (0, $690d3d7c4f641feb$export$69bbac602c81ca6e)();
    const analyticsWebClient = (0, $acw62.useMemo)(()=>{
        if (user?.accountId && tenantContexts[0].cloudId) {
            (0, $816be88acf151818$export$b2e5abba3e61d1a4).setTenantInfo((0, $d6ce1402442d8264$export$496f06ac2a964da2).CLOUD_ID, tenantContexts[0].cloudId);
            (0, $816be88acf151818$export$b2e5abba3e61d1a4).setUserInfo((0, $d6ce1402442d8264$export$1827adfd178b4870).ATLASSIAN_ACCOUNT, user.accountId);
            (0, $816be88acf151818$export$b2e5abba3e61d1a4).startUIViewedEvent();
        }
        return 0, $816be88acf151818$export$b2e5abba3e61d1a4;
    }, [
        user,
        tenantContexts
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($8335f2c2f41b5065$var$AnalyticsWebClientContext.Provider, {
        value: analyticsWebClient,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $25bb30d690a27033$export$2e2bcd8739ae039), {
            name: "devAgents.root",
            children: children
        })
    });
};
const $8335f2c2f41b5065$export$ab46754111902b52 = ()=>{
    const analyticsWebClient = (0, $acw62.useContext)($8335f2c2f41b5065$var$AnalyticsWebClientContext);
    if (!analyticsWebClient) throw new Error("Must be used inside AnalyticsWebClientProvider");
    return analyticsWebClient;
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $a10120e44fa360e9$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $acw62.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $a10120e44fa360e9$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a10120e44fa360e9$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a10120e44fa360e9$export$2e2bcd8739ae039 = $a10120e44fa360e9$var$RouterLinkProvider;



var $fOd0O = parcelRequire("fOd0O");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $h1Oiy = parcelRequire("h1Oiy");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $ltooA = parcelRequire("ltooA");

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");

var $ltooA = parcelRequire("ltooA");

var $5NceL = parcelRequire("5NceL");

var $hM7vC = parcelRequire("hM7vC");

var $02Ztr = parcelRequire("02Ztr");

var $ltooA = parcelRequire("ltooA");

var $g5Zhu = parcelRequire("g5Zhu");

var $ltooA = parcelRequire("ltooA");

var $cfuBi = parcelRequire("cfuBi");

var $5NceL = parcelRequire("5NceL");

var $41YNz = parcelRequire("41YNz");

var $02Ztr = parcelRequire("02Ztr");

var $5NceL = parcelRequire("5NceL");
var $162ad34f339133e7$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $162ad34f339133e7$var$customThemeOptions = "UNSAFE_themeOptions";
var $162ad34f339133e7$var$isThemeKind = function isThemeKind(themeKind) {
    return $162ad34f339133e7$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $162ad34f339133e7$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $5NceL.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $162ad34f339133e7$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $162ad34f339133e7$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $162ad34f339133e7$var$isColorMode(id)) themeObject[kind] = id;
        if ($162ad34f339133e7$var$isThemeKind(kind) && $162ad34f339133e7$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $162ad34f339133e7$var$customThemeOptions) try {
            themeObject[$162ad34f339133e7$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $162ad34f339133e7$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $162ad34f339133e7$var$isColorMode(id) || // custom theme state
        kind === $162ad34f339133e7$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" || // other theme states
        $162ad34f339133e7$var$isThemeKind(kind) && typeof id === "string" && $162ad34f339133e7$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};



var $hM7vC = parcelRequire("hM7vC");

var $klQHf = parcelRequire("klQHf");
function $cc5e48d73cadaad1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc5e48d73cadaad1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc5e48d73cadaad1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc5e48d73cadaad1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cc5e48d73cadaad1$var$defaultColorMode = "light";
var $cc5e48d73cadaad1$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $cc5e48d73cadaad1$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $5NceL.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $5NceL.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $5NceL.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $5NceL.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $5NceL.themeStateDefaults)["shape"] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $5NceL.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $5NceL.themeStateDefaults)["typography"]() : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $5NceL.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $162ad34f339133e7$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $cfuBi.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $cfuBi.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $cc5e48d73cadaad1$var$defaultColorMode : colorMode);
    if ((0, $ltooA.fg)("platform_increased-contrast-themes")) result = $cc5e48d73cadaad1$var$_objectSpread($cc5e48d73cadaad1$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $cfuBi.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $cc5e48d73cadaad1$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $hM7vC.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $klQHf.hash)(optionString);
        result[0, $cfuBi.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $cc5e48d73cadaad1$export$2e2bcd8739ae039 = $cc5e48d73cadaad1$var$getThemeHtmlAttrs;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $cfuBi = parcelRequire("cfuBi");

var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");

var $ltooA = parcelRequire("ltooA");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














var $6ce83c425fa21faf$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("8Ex6V"));
    },
    "light-future": function lightFuture() {
        return (parcelRequire("lH96A"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("1Lc0l"));
    },
    "dark": function dark() {
        return (parcelRequire("9Bi5g"));
    },
    "dark-future": function darkFuture() {
        return (parcelRequire("3J0Ly"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("b7Xwx"));
    },
    "legacy-light": function legacyLight() {
        return (parcelRequire("hR0TH"));
    },
    "legacy-dark": function legacyDark() {
        return (parcelRequire("n9MS2"));
    },
    "spacing": function spacing() {
        return (parcelRequire("k92Of"));
    },
    "typography-adg3": function typographyAdg3() {
        return (parcelRequire("kBQNP"));
    },
    "shape": function shape() {
        return (parcelRequire("g5OPz"));
    },
    "typography-modernized": function typographyModernized() {
        return (parcelRequire("8Rge0"));
    },
    "typography-refreshed": function typographyRefreshed() {
        return (parcelRequire("lDv3h"));
    },
    "light-brand-refresh": function lightBrandRefresh() {
        return (parcelRequire("iO3vf"));
    },
    "dark-brand-refresh": function darkBrandRefresh() {
        return (parcelRequire("73N7s"));
    }
};
var $6ce83c425fa21faf$export$2e2bcd8739ae039 = $6ce83c425fa21faf$var$themeImportsMap;



var $cfuBi = parcelRequire("cfuBi");
var $110c0ce7e3838fd9$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $cfuBi.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $cfuBi.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $110c0ce7e3838fd9$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $110c0ce7e3838fd9$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((themeId === "light" || themeId === "dark") && (0, $ltooA.fg)("platform-component-visual-refresh")) themeId += "-brand-refresh";
                    _context2.next = 3;
                    return (0, $6ce83c425fa21faf$export$2e2bcd8739ae039)[themeId]();
                case 3:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $110c0ce7e3838fd9$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $110c0ce7e3838fd9$export$8662df6937d86fcb = "(prefers-contrast: more)";


var $fe260825269bd5b0$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $fe260825269bd5b0$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $cfuBi.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $fe260825269bd5b0$var$darkModeMql = $fe260825269bd5b0$var$isMatchMediaAvailable && window.matchMedia((0, $110c0ce7e3838fd9$export$bb1e815119d30f8b));
var $fe260825269bd5b0$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$fe260825269bd5b0$var$darkModeMql) return "light";
                return $fe260825269bd5b0$var$darkModeMql !== null && $fe260825269bd5b0$var$darkModeMql !== void 0 && $fe260825269bd5b0$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($fe260825269bd5b0$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $8fY35.bind)($fe260825269bd5b0$var$darkModeMql, {
                    type: "change",
                    listener: $fe260825269bd5b0$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $fe260825269bd5b0$var$SingletonColorModeObserver = new $fe260825269bd5b0$var$ColorModeObserver();
var $fe260825269bd5b0$export$2e2bcd8739ae039 = $fe260825269bd5b0$var$SingletonColorModeObserver;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $8fY35 = parcelRequire("8fY35");

var $cfuBi = parcelRequire("cfuBi");

var $cc5d31fdc3f20457$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $cc5d31fdc3f20457$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $cfuBi.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $cc5d31fdc3f20457$var$contrastModeMql = $cc5d31fdc3f20457$var$isMatchMediaAvailable && window.matchMedia((0, $110c0ce7e3838fd9$export$8662df6937d86fcb));
var $cc5d31fdc3f20457$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$cc5d31fdc3f20457$var$contrastModeMql) return "no-preference";
                return $cc5d31fdc3f20457$var$contrastModeMql !== null && $cc5d31fdc3f20457$var$contrastModeMql !== void 0 && $cc5d31fdc3f20457$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($cc5d31fdc3f20457$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $8fY35.bind)($cc5d31fdc3f20457$var$contrastModeMql, {
                    type: "change",
                    listener: $cc5d31fdc3f20457$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $cc5d31fdc3f20457$var$SingletonContrastModeObserver = new $cc5d31fdc3f20457$var$ContrastModeObserver();
var $cc5d31fdc3f20457$export$2e2bcd8739ae039 = $cc5d31fdc3f20457$var$SingletonContrastModeObserver;


function $fed0594986187182$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $fe260825269bd5b0$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $fe260825269bd5b0$export$2e2bcd8739ae039).bind();
    } else (0, $fe260825269bd5b0$export$2e2bcd8739ae039).unbind();
    if ((0, $ltooA.fg)("platform_increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $cc5d31fdc3f20457$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $cc5d31fdc3f20457$export$2e2bcd8739ae039).bind();
        } else (0, $cc5d31fdc3f20457$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $cc5e48d73cadaad1$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $fe260825269bd5b0$export$2e2bcd8739ae039).unbind();
        if ((0, $ltooA.fg)("platform_increased-contrast-themes")) (0, $cc5d31fdc3f20457$export$2e2bcd8739ae039).unbind();
    };
}



var $lXhZa = parcelRequire("lXhZa");

var $fUHKi = parcelRequire("fUHKi");

var $ltooA = parcelRequire("ltooA");

var $02Ztr = parcelRequire("02Ztr");

var $5NceL = parcelRequire("5NceL");
function $c2acf3889ed29d53$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $5NceL.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $51f20e30bcac41e5$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $ltooA.fg)("platform_increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $c2acf3889ed29d53$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $ltooA.fg)("platform_increased-contrast-themes")) {
            var increasedContrastTheme = (0, $c2acf3889ed29d53$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set(themePreferences));
};
var $51f20e30bcac41e5$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set(themeOverridePreferences));
};



function $5a654a09224e2d18$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5a654a09224e2d18$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5a654a09224e2d18$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5a654a09224e2d18$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5a654a09224e2d18$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5a654a09224e2d18$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $5a654a09224e2d18$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $5NceL.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $5NceL.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $5NceL.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $5NceL.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $5NceL.themeStateDefaults)["shape"] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $5NceL.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $5NceL.themeStateDefaults)["typography"]() : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $5NceL.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $ltooA.fg)("platform_increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $51f20e30bcac41e5$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $110c0ce7e3838fd9$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $hM7vC.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $5NceL.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $lXhZa.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("ifbJw"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $51f20e30bcac41e5$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $5a654a09224e2d18$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $fed0594986187182$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $5a654a09224e2d18$export$2e2bcd8739ae039 = $5a654a09224e2d18$var$setGlobalTheme;


function $fa26c3c32090668f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa26c3c32090668f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa26c3c32090668f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa26c3c32090668f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fa26c3c32090668f$var$defaultThemeSettings = function defaultThemeSettings() {
    return {
        dark: "dark",
        light: "light",
        spacing: "spacing",
        typography: (0, $ltooA.fg)("platform-default-typography-modernized") ? "typography-modernized" : undefined
    };
};
var $fa26c3c32090668f$var$ColorModeContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $fa26c3c32090668f$var$SetColorModeContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $fa26c3c32090668f$var$ThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $fa26c3c32090668f$var$SetThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
function $fa26c3c32090668f$export$ce91654eb9fea460() {
    var value = (0, $acw62.useContext)($fa26c3c32090668f$var$ColorModeContext);
    return value;
}
function $fa26c3c32090668f$export$20f3076712c8dfa() {
    var value = (0, $acw62.useContext)($fa26c3c32090668f$var$ColorModeContext);
    if (!value) throw new Error("useColorMode must be used within AppProvider.");
    return value;
}
function $fa26c3c32090668f$export$e2afe7397c3d11c7() {
    var value = (0, $acw62.useContext)($fa26c3c32090668f$var$SetColorModeContext);
    if (!value) throw new Error("useSetColorMode must be used within AppProvider.");
    return value;
}
function $fa26c3c32090668f$export$93d4e7f90805808f() {
    var value = (0, $acw62.useContext)($fa26c3c32090668f$var$ThemeContext);
    if (!value) throw new Error("useTheme must be used within AppProvider.");
    return value;
}
function $fa26c3c32090668f$export$501aa0dcd5527a48() {
    var value = (0, $acw62.useContext)($fa26c3c32090668f$var$SetThemeContext);
    if (!value) throw new Error("useSetTheme must be used within AppProvider.");
    return value;
}
var $fa26c3c32090668f$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
var $fa26c3c32090668f$var$prefersDarkModeMql = $fa26c3c32090668f$var$isMatchMediaAvailable ? window.matchMedia("(prefers-color-scheme: dark)") : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $fa26c3c32090668f$var$getReconciledColorMode(colorMode) {
    if (colorMode === "auto") return $fa26c3c32090668f$var$prefersDarkModeMql !== null && $fa26c3c32090668f$var$prefersDarkModeMql !== void 0 && $fa26c3c32090668f$var$prefersDarkModeMql.matches ? "dark" : "light";
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $fa26c3c32090668f$var$ThemeProvider(_ref) {
    var children = _ref.children, defaultColorMode = _ref.defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $acw62.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $acw62.useState)($fa26c3c32090668f$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return $fa26c3c32090668f$var$_objectSpread($fa26c3c32090668f$var$_objectSpread({}, $fa26c3c32090668f$var$defaultThemeSettings()), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $acw62.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($fa26c3c32090668f$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $acw62.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $fa26c3c32090668f$var$_objectSpread($fa26c3c32090668f$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ var cleanupLastFnCall = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee() {
                var unbindFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!lastSetGlobalThemePromiseRef.current) {
                                _context.next = 6;
                                break;
                            }
                            _context.next = 3;
                            return lastSetGlobalThemePromiseRef.current;
                        case 3:
                            unbindFn = _context.sent;
                            unbindFn();
                            lastSetGlobalThemePromiseRef.current = null;
                        case 6:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function cleanupLastFnCall() {
                return _ref2.apply(this, arguments);
            };
        }();
        var safelySetGlobalTheme = /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2() {
                var promise;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _context2.next = 2;
                            return cleanupLastFnCall();
                        case 2:
                            promise = (0, $5a654a09224e2d18$export$2e2bcd8739ae039)($fa26c3c32090668f$var$_objectSpread($fa26c3c32090668f$var$_objectSpread({}, theme), {}, {
                                colorMode: reconciledColorMode
                            }));
                            lastSetGlobalThemePromiseRef.current = promise;
                        case 4:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function safelySetGlobalTheme() {
                return _ref3.apply(this, arguments);
            };
        }();
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $acw62.useEffect)(function() {
        if (!$fa26c3c32090668f$var$prefersDarkModeMql) return;
        var unbindListener = (0, $8fY35.bind)($fa26c3c32090668f$var$prefersDarkModeMql, {
            type: "change",
            listener: function listener(event) {
                if (chosenColorMode === "auto") setReconciledColorMode(event.matches ? "dark" : "light");
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fa26c3c32090668f$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fa26c3c32090668f$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fa26c3c32090668f$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fa26c3c32090668f$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $fa26c3c32090668f$export$2e2bcd8739ae039 = $fa26c3c32090668f$var$ThemeProvider;


var $46c32320cb273742$var$InsideAppProviderContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $46c32320cb273742$var$AppProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? "light" : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme, routerLinkComponent = _ref.routerLinkComponent, UNSAFE_isThemingDisabled = _ref.UNSAFE_isThemingDisabled;
    var isInsideAppProvider = (0, $acw62.useContext)($46c32320cb273742$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error("App provider should not be nested within another app provider.");
    var routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a10120e44fa360e9$export$2e2bcd8739ae039), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($46c32320cb273742$var$InsideAppProviderContext.Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fa26c3c32090668f$export$2e2bcd8739ae039), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $46c32320cb273742$export$2e2bcd8739ae039 = $46c32320cb273742$var$AppProvider;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $d29f5b3d0d51225a$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $d29f5b3d0d51225a$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $acw62.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $acw62.useRef)(true);
    var committed = (0, $acw62.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $d29f5b3d0d51225a$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $acw62.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $d29f5b3d0d51225a$export$33752cf3ee811995(callback, inputs) {
    return $d29f5b3d0d51225a$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $d29f5b3d0d51225a$export$1538c33de8887b59 = $d29f5b3d0d51225a$export$b6feb8998cd9b342;
var $d29f5b3d0d51225a$export$35808ee640e87ca7 = $d29f5b3d0d51225a$export$33752cf3ee811995;



var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $dpL0o = parcelRequire("dpL0o");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
function $fe9adb20c41a65ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe9adb20c41a65ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe9adb20c41a65ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe9adb20c41a65ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fe9adb20c41a65ad$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $fe9adb20c41a65ad$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $fe9adb20c41a65ad$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $fe9adb20c41a65ad$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(updater) === "object") this.payload = $fe9adb20c41a65ad$var$_objectSpread($fe9adb20c41a65ad$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $94aff9b9173eee4d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $94aff9b9173eee4d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $94aff9b9173eee4d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($94aff9b9173eee4d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $94aff9b9173eee4d$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($dpL0o)))((0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $94aff9b9173eee4d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $94aff9b9173eee4d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $94aff9b9173eee4d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UIAnalyticsEvent);
        _this = $94aff9b9173eee4d$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $94aff9b9173eee4d$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $fe9adb20c41a65ad$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $a43742e34dd4eabd$var$AnalyticsNextContext = (0, $acw62.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $a43742e34dd4eabd$export$2e2bcd8739ae039 = $a43742e34dd4eabd$var$AnalyticsNextContext;


var $025517dbaab8c128$export$2e2bcd8739ae039 = (0, $a43742e34dd4eabd$export$2e2bcd8739ae039);


var $d0165f47f9d720fb$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $acw62.useContext)((0, $025517dbaab8c128$export$2e2bcd8739ae039));
};


function $644f5cd0da7c3c67$export$5bf35293e545f20c() {
    var analyticsContext = (0, $d0165f47f9d720fb$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $d29f5b3d0d51225a$export$33752cf3ee811995)(function(payload) {
        return new (0, $94aff9b9173eee4d$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $acw62 = parcelRequire("acw62");
var $a25ba612a14d7f71$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};


function $ee8f8175665f2347$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ee8f8175665f2347$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ee8f8175665f2347$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ee8f8175665f2347$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ee8f8175665f2347$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $644f5cd0da7c3c67$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $a25ba612a14d7f71$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $a25ba612a14d7f71$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $ee8f8175665f2347$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $d3997b4aab843580$export$2e2bcd8739ae039() {}


/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");


/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $ltooA = parcelRequire("ltooA");



var $acw62 = parcelRequire("acw62");
// Allows support for heading levels 1-9 via aria-level
var $4166e07202f48cb9$var$HeadingLevelContext = /*#__PURE__*/ (0, $acw62.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $4166e07202f48cb9$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $acw62.useContext)($4166e07202f48cb9$var$HeadingLevelContext);
};
var $4166e07202f48cb9$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $4166e07202f48cb9$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $4166e07202f48cb9$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $4166e07202f48cb9$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4166e07202f48cb9$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $4166e07202f48cb9$export$2e2bcd8739ae039 = $4166e07202f48cb9$var$HeadingLevelContextProvider;



var $hPtJY = parcelRequire("hPtJY");
var $6dade6aab478882f$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $6dade6aab478882f$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $6dade6aab478882f$var$headingColorStylesMap = {
    "color.text": "_syaz1fxt",
    "color.text.inverse": "_syaz15cr",
    "color.text.warning.inverse": "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $6dade6aab478882f$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $6dade6aab478882f$var$useColor = function useColor(colorProp) {
    var surface = (0, $cbc5b5bd3160fa7c$export$1aeb4f6b93c4540d)();
    if ((0, $ltooA.fg)("platform-typography-improved-color-control")) {
        if (colorProp) return colorProp;
        if ((0, $bcbfa6eabcc99f23$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $bcbfa6eabcc99f23$export$2185ce37f9bdd963)[surface];
        return "color.text";
    }
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $bcbfa6eabcc99f23$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $bcbfa6eabcc99f23$export$2185ce37f9bdd963)[surface];
    return colorProp || "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $6dade6aab478882f$var$Heading = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $hPtJY;
    var _useHeading = (0, $4166e07202f48cb9$export$97a37b1befbbf9b1)($6dade6aab478882f$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $6dade6aab478882f$var$useColor(colorProp);
    return /*#__PURE__*/ $acw62.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $5zphJ.default)([
            $6dade6aab478882f$var$styles.reset,
            size && $6dade6aab478882f$var$headingSizeStylesMap[size],
            $6dade6aab478882f$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $6dade6aab478882f$export$2e2bcd8739ae039 = $6dade6aab478882f$var$Heading;



var $ltooA = parcelRequire("ltooA");
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $55175eaa0fdd994e$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $55175eaa0fdd994e$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $55175eaa0fdd994e$var$baseStyles = null;
var $55175eaa0fdd994e$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $55175eaa0fdd994e$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $55175eaa0fdd994e$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $55175eaa0fdd994e$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $55175eaa0fdd994e$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $55175eaa0fdd994e$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $55175eaa0fdd994e$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $55175eaa0fdd994e$var$Box = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $55175eaa0fdd994e$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $55175eaa0fdd994e$var$_excluded2);
    var node = /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: (0, $5zphJ.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $55175eaa0fdd994e$var$backgroundColorMap[backgroundColor],
            backgroundColor && $55175eaa0fdd994e$var$isSurfaceToken(backgroundColor) && $55175eaa0fdd994e$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $55175eaa0fdd994e$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $55175eaa0fdd994e$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $55175eaa0fdd994e$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $55175eaa0fdd994e$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $acw62.createElement((0, $cbc5b5bd3160fa7c$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $55175eaa0fdd994e$export$2e2bcd8739ae039 = $55175eaa0fdd994e$var$Box;
function $55175eaa0fdd994e$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $55175eaa0fdd994e$var$setSurfaceTokenMap;
}

/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("acw62");

const $55fb0f1d71af52d2$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $55fb0f1d71af52d2$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};



var $5zphJ = parcelRequire("5zphJ");
const $9b698034c8c53dd8$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $5zphJ.default)(actualStyles);
};


function $ef1213577ac20f88$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $55fb0f1d71af52d2$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $55fb0f1d71af52d2$export$c4df1cb0c2b4d77c)();
        },
        cx: $9b698034c8c53dd8$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $55fb0f1d71af52d2$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $32a33265390ae51f$var$_createStrictAPI = (0, $ef1213577ac20f88$export$39716b4af53f4ad)(), $32a33265390ae51f$var$XCSSProp = $32a33265390ae51f$var$_createStrictAPI.XCSSProp, $32a33265390ae51f$export$dbf350e5966cf602 = $32a33265390ae51f$var$_createStrictAPI.css, $32a33265390ae51f$export$eb1ecd84a24ee424 = $32a33265390ae51f$var$_createStrictAPI.cssMap, $32a33265390ae51f$export$a274e22fb40f762e = $32a33265390ae51f$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $fc6b3ef262d2d718$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $fc6b3ef262d2d718$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $fc6b3ef262d2d718$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $fc6b3ef262d2d718$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $fc6b3ef262d2d718$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $fc6b3ef262d2d718$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $fc6b3ef262d2d718$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $fc6b3ef262d2d718$var$Flex = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement(Component, {
        role: role,
        className: (0, $5zphJ.default)([
            $fc6b3ef262d2d718$var$styles.root,
            gap && $fc6b3ef262d2d718$var$columnGapMap[gap],
            columnGap && $fc6b3ef262d2d718$var$columnGapMap[columnGap],
            gap && $fc6b3ef262d2d718$var$rowGapMap[gap],
            rowGap && $fc6b3ef262d2d718$var$rowGapMap[rowGap],
            alignItems && $fc6b3ef262d2d718$var$alignItemsMap[alignItems],
            direction && $fc6b3ef262d2d718$var$flexDirectionMap[direction],
            justifyContent && $fc6b3ef262d2d718$var$justifyContentMap[justifyContent],
            wrap && $fc6b3ef262d2d718$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$fc6b3ef262d2d718$var$Flex.displayName = "Flex";
var $fc6b3ef262d2d718$export$2e2bcd8739ae039 = $fc6b3ef262d2d718$var$Flex;


var $f2901d7c083b4af1$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $f2901d7c083b4af1$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $5zphJ.default)([
            $f2901d7c083b4af1$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $f2901d7c083b4af1$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $acw62.createElement($f2901d7c083b4af1$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $acw62.createElement((0, $fc6b3ef262d2d718$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $32a33265390ae51f$export$a274e22fb40f762e)(grow === "hug" && $f2901d7c083b4af1$var$styles.hug, grow === "fill" && $f2901d7c083b4af1$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$f2901d7c083b4af1$var$Inline.displayName = "Inline";
var $f2901d7c083b4af1$export$2e2bcd8739ae039 = $f2901d7c083b4af1$var$Inline;

/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");



var $4bdd1b756b729740$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $4bdd1b756b729740$var$Stack = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    return /*#__PURE__*/ $acw62.createElement((0, $fc6b3ef262d2d718$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $32a33265390ae51f$export$a274e22fb40f762e)(grow === "hug" && $4bdd1b756b729740$var$styles.hug, grow === "fill" && $4bdd1b756b729740$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$4bdd1b756b729740$var$Stack.displayName = "Stack";
var $4bdd1b756b729740$export$2e2bcd8739ae039 = $4bdd1b756b729740$var$Stack;


/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $8568069ac023c6f7$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $8568069ac023c6f7$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $5zphJ.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $8568069ac023c6f7$export$2e2bcd8739ae039 = $8568069ac023c6f7$var$VisuallyHidden;


var $a8cf11ad922cb067$export$d6830277b06edd6 = "normal";


/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
var $6577dddfc3fa8cbd$var$_excluded = [
    "children"
];
function $6577dddfc3fa8cbd$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $acw62.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $6577dddfc3fa8cbd$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $acw62.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $acw62.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $bc4c50142919d5e5$var$_createTheme = (0, $6577dddfc3fa8cbd$export$25d302a5b900a763)(function() {
    return {
        mode: "light"
    };
}), $bc4c50142919d5e5$var$Provider = $bc4c50142919d5e5$var$_createTheme.Provider, $bc4c50142919d5e5$var$Consumer = $bc4c50142919d5e5$var$_createTheme.Consumer, $bc4c50142919d5e5$export$7692396083754928 = $bc4c50142919d5e5$var$_createTheme.useTheme;
var $bc4c50142919d5e5$var$Theme = {
    Provider: $bc4c50142919d5e5$var$Provider,
    Consumer: $bc4c50142919d5e5$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bc4c50142919d5e5$export$2e2bcd8739ae039 = $bc4c50142919d5e5$var$Theme;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");



var $acw62 = parcelRequire("acw62");
function $3f80dbe144e57bfc$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $6f72ff8788d34fb2$var$BORDER_WIDTH = 2;
var $6f72ff8788d34fb2$var$baseFocusOutsideStyles = (0, $jjlaj.css)({
    outline: "".concat($6f72ff8788d34fb2$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $6f72ff8788d34fb2$var$BORDER_WIDTH
});
var $6f72ff8788d34fb2$var$baseInsetStyles = (0, $jjlaj.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$6f72ff8788d34fb2$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $6f72ff8788d34fb2$var$focusRingStyles = (0, $jjlaj.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $6f72ff8788d34fb2$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $6f72ff8788d34fb2$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $6f72ff8788d34fb2$var$insetFocusRingStyles = (0, $jjlaj.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $6f72ff8788d34fb2$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $6f72ff8788d34fb2$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $6f72ff8788d34fb2$var$FocusRing = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $6f72ff8788d34fb2$var$baseInsetStyles : $6f72ff8788d34fb2$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $6f72ff8788d34fb2$var$insetFocusRingStyles : $6f72ff8788d34fb2$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $jjlaj.jsx)((0, $jjlaj.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $acw62.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $acw62.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$6f72ff8788d34fb2$var$FocusRing.displayName = "FocusRing";
var $6f72ff8788d34fb2$export$2e2bcd8739ae039 = $6f72ff8788d34fb2$var$FocusRing;



var $12HqF = parcelRequire("12HqF");

var $dnCk4 = parcelRequire("dnCk4");
function $5e302c3b7a82c90a$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5e302c3b7a82c90a$var$tabKeyCode = 9;
function $5e302c3b7a82c90a$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5e302c3b7a82c90a$var$tabKeyCode) return;
    $5e302c3b7a82c90a$var$abort(event);
}
var $5e302c3b7a82c90a$var$block = {
    onMouseDownCapture: $5e302c3b7a82c90a$var$abort,
    onMouseUpCapture: $5e302c3b7a82c90a$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $5e302c3b7a82c90a$var$onKey,
    onKeyUpCapture: $5e302c3b7a82c90a$var$onKey,
    onTouchStartCapture: $5e302c3b7a82c90a$var$abort,
    onTouchEndCapture: $5e302c3b7a82c90a$var$abort,
    onPointerDownCapture: $5e302c3b7a82c90a$var$abort,
    onPointerUpCapture: $5e302c3b7a82c90a$var$abort,
    onClickCapture: $5e302c3b7a82c90a$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $5e302c3b7a82c90a$var$abort
};
var $5e302c3b7a82c90a$var$doNotBlock = {};
function $5e302c3b7a82c90a$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $5e302c3b7a82c90a$var$doNotBlock : $5e302c3b7a82c90a$var$block;
}



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");

var $ltooA = parcelRequire("ltooA");
/* eslint-disable no-console */ var $a0f5ef3b0d821339$var$printed = {};
function $a0f5ef3b0d821339$export$2e2bcd8739ae039(message) {
    if ($a0f5ef3b0d821339$var$printed[message]) return;
    $a0f5ef3b0d821339$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}



var $hPtJY = parcelRequire("hPtJY");
function $f44ba4bc0607081e$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $a0f5ef3b0d821339$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $f44ba4bc0607081e$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $hPtJY;
}



var $dnCk4 = parcelRequire("dnCk4");
var $b7d36d3be7da66cd$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $b7d36d3be7da66cd$export$c93026a968943f95 = "light";
var $b7d36d3be7da66cd$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $b7d36d3be7da66cd$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $b7d36d3be7da66cd$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $b7d36d3be7da66cd$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $dnCk4.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b7d36d3be7da66cd$export$6d8204c2cb2e06b8() / 4;
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $b7d36d3be7da66cd$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $b7d36d3be7da66cd$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $b7d36d3be7da66cd$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $f44ba4bc0607081e$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $b7d36d3be7da66cd$export$ba1d834b86d72a09 = $b7d36d3be7da66cd$export$a1b3edb637fb4f35;
var $b7d36d3be7da66cd$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $dnCk4.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $dnCk4.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $dnCk4.N30A), ")")
            }
        }
    };
};



var $dnCk4 = parcelRequire("dnCk4");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $233d68a3e8882097$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $233d68a3e8882097$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($dnCk4.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($dnCk4.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($dnCk4.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($233d68a3e8882097$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($dnCk4.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dnCk4.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($dnCk4.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($dnCk4.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($dnCk4.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($dnCk4.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($dnCk4.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($dnCk4.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dnCk4.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($dnCk4.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($dnCk4.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($dnCk4.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($dnCk4.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($dnCk4.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($dnCk4.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dnCk4.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($dnCk4.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($dnCk4.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($dnCk4.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($dnCk4.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($dnCk4.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($dnCk4.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dnCk4.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($dnCk4.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($dnCk4.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($233d68a3e8882097$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($dnCk4.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($dnCk4.N500, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($dnCk4.B400, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($dnCk4.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($dnCk4.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($dnCk4.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($dnCk4.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($dnCk4.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($dnCk4.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($dnCk4.B400, ")"),
                dark: "var(--ds-link, ".concat($dnCk4.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($dnCk4.B300, ")"),
                dark: "var(--ds-link, ".concat($dnCk4.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($dnCk4.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($dnCk4.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($dnCk4.N500, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($dnCk4.B400, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($dnCk4.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($dnCk4.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($dnCk4.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($dnCk4.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($dnCk4.N400, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            }
        }
    }
};
var $233d68a3e8882097$export$2e2bcd8739ae039 = $233d68a3e8882097$var$values;


function $124693bd0740e550$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $124693bd0740e550$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $124693bd0740e550$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $124693bd0740e550$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $124693bd0740e550$var$gridSize = (0, $b7d36d3be7da66cd$export$6d8204c2cb2e06b8)();
var $124693bd0740e550$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $124693bd0740e550$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $124693bd0740e550$var$lineHeights = {
    default: $124693bd0740e550$var$heights.default,
    compact: $124693bd0740e550$var$heights.compact,
    none: "inherit"
};
var $124693bd0740e550$var$padding = {
    // 10px gutter
    default: "0 ".concat($124693bd0740e550$var$gridSize + $124693bd0740e550$var$gridSize / 4, "px"),
    compact: "0 ".concat($124693bd0740e550$var$gridSize + $124693bd0740e550$var$gridSize / 4, "px"),
    none: "0"
};
var $124693bd0740e550$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($124693bd0740e550$var$gridSize / 4, "px"),
    default: "0 ".concat($124693bd0740e550$var$gridSize / 4, "px"),
    none: "0"
};
var $124693bd0740e550$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $124693bd0740e550$var$innerMargin = {
    content: "0 ".concat($124693bd0740e550$var$gridSize / 4, "px"),
    icon: "0 ".concat($124693bd0740e550$var$gridSize / 4, "px")
};
var $124693bd0740e550$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $124693bd0740e550$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $124693bd0740e550$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $124693bd0740e550$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $124693bd0740e550$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $124693bd0740e550$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $124693bd0740e550$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $124693bd0740e550$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $124693bd0740e550$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $124693bd0740e550$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $124693bd0740e550$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $124693bd0740e550$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $124693bd0740e550$var$getColor({
            group: (0, $233d68a3e8882097$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($124693bd0740e550$var$getColor({
            group: (0, $233d68a3e8882097$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $124693bd0740e550$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $124693bd0740e550$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $ltooA.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $124693bd0740e550$var$heights[spacing],
        lineHeight: $124693bd0740e550$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $124693bd0740e550$var$singleIconPadding[spacing] : $124693bd0740e550$var$padding[spacing],
        verticalAlign: $124693bd0740e550$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $ltooA.fg)("platform-component-visual-refresh") && $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $124693bd0740e550$var$_objectSpread({}, baseColors),
        "&:hover": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $124693bd0740e550$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $124693bd0740e550$var$_objectSpread({}, $124693bd0740e550$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $ltooA.fg)("platform-component-visual-refresh") && (isSelected ? $124693bd0740e550$var$selectedStyles : $124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread($124693bd0740e550$var$_objectSpread({}, appearance === "default" && $124693bd0740e550$var$defaultStyles), appearance === "primary" && $124693bd0740e550$var$primaryStyles), appearance === "link" && $124693bd0740e550$var$linkStyles), appearance === "subtle" && $124693bd0740e550$var$subtleStyles), appearance === "subtle-link" && $124693bd0740e550$var$subtleLinkStyles), appearance === "warning" && $124693bd0740e550$var$warningStyles), appearance === "danger" && $124693bd0740e550$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $124693bd0740e550$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $124693bd0740e550$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $124693bd0740e550$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $124693bd0740e550$var$hasOverlayStyles))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $124693bd0740e550$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $jjlaj.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $124693bd0740e550$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $124693bd0740e550$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $jjlaj.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $124693bd0740e550$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $124693bd0740e550$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $jjlaj.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $124693bd0740e550$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $acw62 = parcelRequire("acw62");

var $c3573038e77d8f9e$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $acw62.isValidElement)(children) && children.type === (0, $8568069ac023c6f7$export$2e2bcd8739ae039);
};


var $d701453916ab4688$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $d701453916ab4688$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $d701453916ab4688$var$iconBeforeSpacingFixStyle = (0, $jjlaj.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $d701453916ab4688$var$iconAfterSpacingFixStyle = (0, $jjlaj.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $d701453916ab4688$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $c3573038e77d8f9e$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $d701453916ab4688$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $c3573038e77d8f9e$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $jjlaj.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $d701453916ab4688$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $d701453916ab4688$var$_excluded);
    var ourRef = (0, $acw62.useRef)();
    var setRef = (0, $acw62.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $3f80dbe144e57bfc$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $acw62.useContext)((0, $12HqF.default));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "23.0.3",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $acw62.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $jjlaj.css)((0, $124693bd0740e550$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $dnCk4.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $dnCk4.N500), ")"), " !important")
        }
    };
    return (0, $jjlaj.jsx)((0, $6f72ff8788d34fb2$export$2e2bcd8739ae039), null, (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $d701453916ab4688$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $5e302c3b7a82c90a$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $jjlaj.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $124693bd0740e550$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $d701453916ab4688$var$getSpacingFix(children, $d701453916ab4688$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $d701453916ab4688$var$getChildren(children, [
        fadeStyles,
        (0, $124693bd0740e550$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $jjlaj.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $124693bd0740e550$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $d701453916ab4688$var$getSpacingFix(children, $d701453916ab4688$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $jjlaj.jsx)("span", {
        css: [
            (0, $124693bd0740e550$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d701453916ab4688$export$2e2bcd8739ae039 = $d701453916ab4688$var$ButtonBase;



function $37ca384b6aa4d0c1$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $c3573038e77d8f9e$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");

var $12HqF = parcelRequire("12HqF");

var $dnCk4 = parcelRequire("dnCk4");
var $3ab5ab3d43a68898$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $d847f661580efa86$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $dnCk4.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $dnCk4.N0), ")");
}
var $d847f661580efa86$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $d847f661580efa86$var$loadIn = null;
var $d847f661580efa86$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $d847f661580efa86$var$useLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $d847f661580efa86$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $3ab5ab3d43a68898$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $d847f661580efa86$var$getStrokeColor(appearance);
    var context = (0, $acw62.useContext)((0, $12HqF.default));
    $d847f661580efa86$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $5zphJ.default)([
            $d847f661580efa86$var$styles.wrapperStyles,
            $d847f661580efa86$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $5zphJ.default)([
            $d847f661580efa86$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $5zphJ.default)([
            $d847f661580efa86$var$styles.circleStyles
        ])
    })));
}));
var $d847f661580efa86$export$2e2bcd8739ae039 = $d847f661580efa86$var$Spinner;


function $fa4f28c9a3efa92e$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $fa4f28c9a3efa92e$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d847f661580efa86$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $fa4f28c9a3efa92e$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}



var $g5Zhu = parcelRequire("g5Zhu");


function $7b0d721e607ac8a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b0d721e607ac8a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b0d721e607ac8a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b0d721e607ac8a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7b0d721e607ac8a2$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $7b0d721e607ac8a2$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $124693bd0740e550$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $7b0d721e607ac8a2$var$stateToSelectorMap[state];
    if (selector) result = $7b0d721e607ac8a2$var$_objectSpread($7b0d721e607ac8a2$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $7b0d721e607ac8a2$var$_objectSpread($7b0d721e607ac8a2$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $7b0d721e607ac8a2$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $7b0d721e607ac8a2$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $7b0d721e607ac8a2$var$Theme = (0, $6577dddfc3fa8cbd$export$25d302a5b900a763)(function(themeProps) {
    return {
        buttonStyles: $7b0d721e607ac8a2$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7b0d721e607ac8a2$export$2e2bcd8739ae039 = $7b0d721e607ac8a2$var$Theme;


var $0ac08233ee80a5c4$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $0ac08233ee80a5c4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ac08233ee80a5c4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ac08233ee80a5c4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ac08233ee80a5c4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0ac08233ee80a5c4$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $0ac08233ee80a5c4$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $0ac08233ee80a5c4$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $7b0d721e607ac8a2$export$437a7f77d13d7916) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $0ac08233ee80a5c4$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $0ac08233ee80a5c4$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $acw62.useState)($0ac08233ee80a5c4$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $acw62.useCallback)(function(event) {
        setState(function(current) {
            return $0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b0d721e607ac8a2$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bc4c50142919d5e5$export$2e2bcd8739ae039).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b0d721e607ac8a2$export$2e2bcd8739ae039).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            mode: mode,
            state: $0ac08233ee80a5c4$var$getInteractionState($0ac08233ee80a5c4$var$_objectSpread($0ac08233ee80a5c4$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $37ca384b6aa4d0c1$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d701453916ab4688$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fa4f28c9a3efa92e$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $7b0d721e607ac8a2$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$0ac08233ee80a5c4$var$CustomThemeButton.displayName = "CustomThemeButton";
var $0ac08233ee80a5c4$export$2e2bcd8739ae039 = $0ac08233ee80a5c4$var$CustomThemeButton;



var $ltooA = parcelRequire("ltooA");



var $acw62 = parcelRequire("acw62");
var $a0581f59513b2b8d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a36a65999ae3c13d3a1917b5e2b052e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($a0581f59513b2b8d$exports, "__esModule", {
    value: true
});
$a0581f59513b2b8d$exports.default = void 0;

var $a0581f59513b2b8d$var$_react = $a0581f59513b2b8d$var$_interopRequireDefault((parcelRequire("acw62")));

var $a0581f59513b2b8d$var$_error = $a0581f59513b2b8d$var$_interopRequireDefault((parcelRequire("ib4Hv")));

var $a0581f59513b2b8d$var$_error2 = $a0581f59513b2b8d$var$_interopRequireDefault((parcelRequire("eh3Ll")));
function $a0581f59513b2b8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0581f59513b2b8d$var$ErrorIcon = (props)=>/*#__PURE__*/ $a0581f59513b2b8d$var$_react.default.createElement($a0581f59513b2b8d$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $a0581f59513b2b8d$var$_error2.default
    }, props));
$a0581f59513b2b8d$var$ErrorIcon.Name = "ErrorIconMigration";
var $a0581f59513b2b8d$var$_default = $a0581f59513b2b8d$exports.default = $a0581f59513b2b8d$var$ErrorIcon;


var $729bb86269004fba$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a62cd542d4ba6c4ac33816bbd6056646>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($729bb86269004fba$exports, "__esModule", {
    value: true
});
$729bb86269004fba$exports.default = void 0;

var $729bb86269004fba$var$_react = $729bb86269004fba$var$_interopRequireDefault((parcelRequire("acw62")));

var $729bb86269004fba$var$_information = $729bb86269004fba$var$_interopRequireDefault((parcelRequire("kztcQ")));

var $729bb86269004fba$var$_info = $729bb86269004fba$var$_interopRequireDefault((parcelRequire("jqqD2")));
function $729bb86269004fba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $729bb86269004fba$var$InformationIcon = (props)=>/*#__PURE__*/ $729bb86269004fba$var$_react.default.createElement($729bb86269004fba$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $729bb86269004fba$var$_info.default
    }, props));
$729bb86269004fba$var$InformationIcon.Name = "InformationIconMigration";
var $729bb86269004fba$var$_default = $729bb86269004fba$exports.default = $729bb86269004fba$var$InformationIcon;


var $9e1cfd026d1894ea$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::934663f3d49f13f5eb4d23bc2f11a666>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($9e1cfd026d1894ea$exports, "__esModule", {
    value: true
});
$9e1cfd026d1894ea$exports.default = void 0;

var $9e1cfd026d1894ea$var$_react = $9e1cfd026d1894ea$var$_interopRequireDefault((parcelRequire("acw62")));

var $9e1cfd026d1894ea$var$_success = $9e1cfd026d1894ea$var$_interopRequireDefault((parcelRequire("9hXFR")));

var $9e1cfd026d1894ea$var$_checkCircle = $9e1cfd026d1894ea$var$_interopRequireDefault((parcelRequire("9yvRw")));
function $9e1cfd026d1894ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e1cfd026d1894ea$var$SuccessIcon = (props)=>/*#__PURE__*/ $9e1cfd026d1894ea$var$_react.default.createElement($9e1cfd026d1894ea$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $9e1cfd026d1894ea$var$_checkCircle.default
    }, props));
$9e1cfd026d1894ea$var$SuccessIcon.Name = "SuccessIconMigration";
var $9e1cfd026d1894ea$var$_default = $9e1cfd026d1894ea$exports.default = $9e1cfd026d1894ea$var$SuccessIcon;


var $1ed34559f671dc66$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::783ce92761ea23bbb39745cb99e4a6be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1ed34559f671dc66$exports, "__esModule", {
    value: true
});
$1ed34559f671dc66$exports.default = void 0;

var $1ed34559f671dc66$var$_react = $1ed34559f671dc66$var$_interopRequireDefault((parcelRequire("acw62")));

var $1ed34559f671dc66$var$_warning = $1ed34559f671dc66$var$_interopRequireDefault((parcelRequire("6nmbG")));

var $1ed34559f671dc66$var$_warning2 = $1ed34559f671dc66$var$_interopRequireDefault((parcelRequire("1I0Gl")));
function $1ed34559f671dc66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ed34559f671dc66$var$WarningIcon = (props)=>/*#__PURE__*/ $1ed34559f671dc66$var$_react.default.createElement($1ed34559f671dc66$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $1ed34559f671dc66$var$_warning2.default
    }, props));
$1ed34559f671dc66$var$WarningIcon.Name = "WarningIconMigration";
var $1ed34559f671dc66$var$_default = $1ed34559f671dc66$exports.default = $1ed34559f671dc66$var$WarningIcon;



var $dnCk4 = parcelRequire("dnCk4");
var $82786787318b191b$export$59e42969c95d314 = {
    error: "color.background.danger.bold",
    info: "color.background.neutral.bold",
    normal: "elevation.surface.overlay",
    success: "color.background.success.bold",
    warning: "color.background.warning.bold"
};
var $82786787318b191b$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
var $82786787318b191b$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a0581f59513b2b8d$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $dnCk4.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($729bb86269004fba$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $dnCk4.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($729bb86269004fba$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-subtle, ".concat((0, $dnCk4.N500), ")"),
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9e1cfd026d1894ea$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $dnCk4.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ed34559f671dc66$exports))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-warning-inverse, ".concat((0, $dnCk4.N700), ")"),
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
var $82786787318b191b$export$f50075b2584087f = {
    error: "color.text.inverse",
    info: "color.text.inverse",
    normal: "color.text",
    success: "color.text.inverse",
    warning: "color.text.warning.inverse"
};
var $82786787318b191b$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $dnCk4.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $dnCk4.N0), ")"),
    normal: "var(--ds-text, ".concat((0, $dnCk4.N800), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $dnCk4.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $dnCk4.N700), ")")
};
var $82786787318b191b$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $dnCk4.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $dnCk4.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $dnCk4.N30A), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $dnCk4.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $dnCk4.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $dnCk4.N30A), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $dnCk4.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $dnCk4.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $dnCk4.N30A), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $dnCk4.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $dnCk4.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $dnCk4.N30A), ")")
    },
    normal: {
        default: "none",
        active: "none",
        pressed: "none"
    }
};
var $82786787318b191b$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $dnCk4.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $dnCk4.N0), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $dnCk4.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $dnCk4.N700), ")"),
    normal: "var(--ds-link, ".concat((0, $dnCk4.B400), ")")
};


function $346810cc4b2b017b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $346810cc4b2b017b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $346810cc4b2b017b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $346810cc4b2b017b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $346810cc4b2b017b$var$buttonStyles = null;
var $346810cc4b2b017b$var$fontStyles = null;
var $346810cc4b2b017b$var$appearanceNormalButtonStyles = null;
var $346810cc4b2b017b$var$appearanceNormalActionsContainerStyles = null;
var $346810cc4b2b017b$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $a8cf11ad922cb067$export$d6830277b06edd6) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $a8cf11ad922cb067$export$d6830277b06edd6);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $5zphJ.default)([
            !isBold && "_1g4l107e _y8dn107e",
            (0, $ltooA.fg)("platform_ads_explicit_font_styles") && "_11c82smr"
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $f2901d7c083b4af1$export$2e2bcd8739ae039), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return /*#__PURE__*/ $acw62.createElement((0, $0ac08233ee80a5c4$export$2e2bcd8739ae039), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? "default" : "link",
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            className: (0, $5zphJ.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk69tn6 _1wy69tn6 _b3g39tn6 _eqps9tn6 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, $a8cf11ad922cb067$export$d6830277b06edd6) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ]),
            style: $346810cc4b2b017b$var$_objectSpread($346810cc4b2b017b$var$_objectSpread({}, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                "--color": (0, $82786787318b191b$export$7bcfe3cca4dd78b6)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--bg-color": (0, $82786787318b191b$export$81ba6b63eedb299f)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--bg-color-hover": (0, $82786787318b191b$export$81ba6b63eedb299f)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--bg-color-active": (0, $82786787318b191b$export$81ba6b63eedb299f)[appearance].active
            }), {}, {
                "--_zkfc5e": (0, $cZGu3.default)("var(--ds-space-100, 8px)".concat(" !important"))
            })
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$346810cc4b2b017b$export$2e2bcd8739ae039 = $346810cc4b2b017b$var$FlagActions;


/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");


var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
var $465494c09bea9747$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $465494c09bea9747$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$465494c09bea9747$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $465494c09bea9747$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $acw62.useState)($465494c09bea9747$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!$465494c09bea9747$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $465494c09bea9747$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $465494c09bea9747$export$ff7706047246b98b = function prefersReducedMotion() {
    return $465494c09bea9747$export$f0f789643ba5a83c;
};


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $183a833228617892$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $183a833228617892$var$ExitingContext = /*#__PURE__*/ (0, $acw62.createContext)($183a833228617892$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $183a833228617892$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $183a833228617892$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($183a833228617892$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $183a833228617892$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $acw62.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $183a833228617892$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $183a833228617892$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $183a833228617892$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $183a833228617892$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $183a833228617892$var$ExitingPersistence = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $acw62.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $acw62.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $acw62.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $465494c09bea9747$export$b7baf7667a68d87c)() && !(0, $ltooA.fg)("platform_design_system_motion_on_finish_fix")) /**
     * We still want to use the `ExitingPersistence` with reduced motion,
     * otherwise the exiting `onFinish` is not called.
     */ return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $183a833228617892$var$childrenToArray(previousChildren);
    var current = $183a833228617892$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $183a833228617892$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $183a833228617892$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $183a833228617892$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $183a833228617892$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $183a833228617892$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $acw62.useContext)($183a833228617892$var$ExitingContext);
};
$183a833228617892$var$ExitingPersistence.displayName = "ExitingPersistence";
var $183a833228617892$export$2e2bcd8739ae039 = $183a833228617892$var$ExitingPersistence;


var $acw62 = parcelRequire("acw62");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $ltooA = parcelRequire("ltooA");

/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $d145bd79772829f1$export$368bacef0dacbe05 = 25;
var $d145bd79772829f1$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $d145bd79772829f1$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $d145bd79772829f1$export$30fa1a2e62ae150c = {
    none: $d145bd79772829f1$export$38b928a7167ce124.none,
    small: $d145bd79772829f1$export$38b928a7167ce124.small * $d145bd79772829f1$var$EXITING_MOTION_MULTIPLIER,
    medium: $d145bd79772829f1$export$38b928a7167ce124.medium * $d145bd79772829f1$var$EXITING_MOTION_MULTIPLIER,
    large: $d145bd79772829f1$export$38b928a7167ce124.large * $d145bd79772829f1$var$EXITING_MOTION_MULTIPLIER
};



var $acw62 = parcelRequire("acw62");
var $33b808b0547937cc$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $33b808b0547937cc$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $33b808b0547937cc$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $33b808b0547937cc$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $33b808b0547937cc$var$getHookDeps(opts));
    return (0, $acw62.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $e8e989d9395983cb$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $acw62 = parcelRequire("acw62");
function $a0a7320c3aacf366$export$c485849f2e393253() {
    var identifier = (0, $acw62.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $cbd330df05180142$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $acw62.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $d3997b4aab843580$export$2e2bcd8739ae039)
    };
});
var $cbd330df05180142$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $a0a7320c3aacf366$export$c485849f2e393253)();
    var context = (0, $acw62.useContext)($cbd330df05180142$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $cbd330df05180142$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $acw62.useRef)([]);
    var indexes = [];
    var _useState = (0, $acw62.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $e8e989d9395983cb$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cbd330df05180142$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $cbd330df05180142$export$2e2bcd8739ae039 = $cbd330df05180142$var$StaggeredEntrance;


var $290b44577c627b97$var$zoomIn = null;
var $290b44577c627b97$var$zoomOut = null;
var $290b44577c627b97$var$fadeIn = null;
var $290b44577c627b97$var$fadeOut = null;
var $290b44577c627b97$var$fadeInFromTop = null;
var $290b44577c627b97$var$fadeOutFromTop = null;
var $290b44577c627b97$var$fadeInFromLeft = null;
var $290b44577c627b97$var$fadeOutFromLeft = null;
var $290b44577c627b97$var$fadeInFromBottom = null;
var $290b44577c627b97$var$fadeOutFromBottom = null;
var $290b44577c627b97$var$fadeInFromRight = null;
var $290b44577c627b97$var$fadeOutFromRight = null;
var $290b44577c627b97$var$fadeInFromTopConstant = null;
var $290b44577c627b97$var$fadeOutFromTopConstant = null;
var $290b44577c627b97$var$fadeInFromLeftConstant = null;
var $290b44577c627b97$var$fadeOutFromLeftConstant = null;
var $290b44577c627b97$var$fadeInFromBottomConstant = null;
var $290b44577c627b97$var$fadeOutFromBottomConstant = null;
var $290b44577c627b97$var$fadeInFromRightConstant = null;
var $290b44577c627b97$var$fadeOutFromRightConstant = null;
var $290b44577c627b97$var$slideInFromTop = null;
var $290b44577c627b97$var$slideOutFromTop = null;
var $290b44577c627b97$var$slideInFromRight = null;
var $290b44577c627b97$var$slideOutFromRight = null;
var $290b44577c627b97$var$slideInFromBottom = null;
var $290b44577c627b97$var$slideOutFromBottom = null;
var $290b44577c627b97$var$slideInFromLeft = null;
var $290b44577c627b97$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $290b44577c627b97$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $cbd330df05180142$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $183a833228617892$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $33b808b0547937cc$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $acw62.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === "exiting") // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $465494c09bea9747$export$b7baf7667a68d87c)() && (0, $ltooA.fg)("platform_design_system_motion_on_finish_fix")) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $d145bd79772829f1$export$30fa1a2e62ae150c)[duration] : (0, $d145bd79772829f1$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $5zphJ.default)([
            (0, $5zphJ.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $5zphJ.default)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $5zphJ.default)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $5zphJ.default)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $5zphJ.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $5zphJ.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $5zphJ.default)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $5zphJ.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $5zphJ.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $5zphJ.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $5zphJ.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $5zphJ.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $5zphJ.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $5zphJ.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $5zphJ.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $5zphJ.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $5zphJ.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $5zphJ.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $5zphJ.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $5zphJ.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $5zphJ.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $5zphJ.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $5zphJ.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $5zphJ.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $5zphJ.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $5zphJ.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $5zphJ.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $5zphJ.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $5zphJ.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $5zphJ.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $5zphJ.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $5zphJ.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $5zphJ.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $5zphJ.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $5zphJ.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $5zphJ.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $5zphJ.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $5zphJ.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $5zphJ.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $5zphJ.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $5zphJ.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $5zphJ.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $5zphJ.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $5zphJ.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $5zphJ.default)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $290b44577c627b97$export$2e2bcd8739ae039 = $290b44577c627b97$var$EnteringMotion;


/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $20529c9476e6df43$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$fade = _ref.fade, fade = _ref$fade === void 0 ? "none" : _ref$fade, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "medium" : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? "ease-out" : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? "ease-in" : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $290b44577c627b97$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $20529c9476e6df43$export$2e2bcd8739ae039 = $20529c9476e6df43$var$SlideIn;



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $aS1Zy = parcelRequire("aS1Zy");
var $048a9a7f2cfa709c$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $048a9a7f2cfa709c$export$72f415121273627e = "body > .atlaskit-portal-container";
var $048a9a7f2cfa709c$export$13f57c02915787b3 = "atlaskit-portal";


var $3dcce44f23fef19f$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $048a9a7f2cfa709c$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $3dcce44f23fef19f$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $3dcce44f23fef19f$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $048a9a7f2cfa709c$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $048a9a7f2cfa709c$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $3dcce44f23fef19f$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $3dcce44f23fef19f$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $3dcce44f23fef19f$var$getPortalParent().removeChild(container);
};
var $3dcce44f23fef19f$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $3dcce44f23fef19f$var$getPortalParent().appendChild(container);
};
var $3dcce44f23fef19f$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $3dcce44f23fef19f$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($3dcce44f23fef19f$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $048a9a7f2cfa709c$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $3dcce44f23fef19f$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($3dcce44f23fef19f$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $048a9a7f2cfa709c$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $048a9a7f2cfa709c$export$e4c79eb95c23a0da);
            parent.style.display = "flex";
            (_getBody2 = $3dcce44f23fef19f$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $45a07dae92ce14fd$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $acw62.useMemo)(function() {
        return (0, $3dcce44f23fef19f$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $3dcce44f23fef19f$export$c582005add11e141)(container);
    (0, $acw62.useEffect)(function() {
        return function() {
            (0, $3dcce44f23fef19f$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aS1Zy.createPortal)(children, container);
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $aS1Zy = parcelRequire("aS1Zy");

var $acw62 = parcelRequire("acw62");
var $958efa86467d55bc$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



function $e816b1eb28955d95$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $958efa86467d55bc$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $3dcce44f23fef19f$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $3dcce44f23fef19f$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aS1Zy.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $d890abd04375baa4$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $958efa86467d55bc$export$700979bc83e7db82) : (0, $acw62.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $d890abd04375baa4$export$2e2bcd8739ae039 = $d890abd04375baa4$var$useIsSubsequentRender;



var $acw62 = parcelRequire("acw62");
var $e9560e07bb6dad2c$export$ed5835cc67e87f72 = "akPortalMount";
var $e9560e07bb6dad2c$export$80816bd900e5bd00 = "akPortalUnmount";


var $704714955971ec93$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $704714955971ec93$var$getLayerName = function getLayerName(zIndex) {
    return $704714955971ec93$var$zIndexToName.hasOwnProperty(zIndex) ? $704714955971ec93$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $704714955971ec93$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $704714955971ec93$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $704714955971ec93$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $704714955971ec93$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $80f682bbfec0ea79$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $acw62.useEffect)(function() {
        (0, $704714955971ec93$export$2e2bcd8739ae039)((0, $e9560e07bb6dad2c$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $704714955971ec93$export$2e2bcd8739ae039)((0, $e9560e07bb6dad2c$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $80f682bbfec0ea79$export$2e2bcd8739ae039 = $80f682bbfec0ea79$var$useFirePortalEvent;


function $2167cf9ee39b2459$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $d890abd04375baa4$export$2e2bcd8739ae039)(mountStrategy);
    (0, $80f682bbfec0ea79$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $ltooA.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $45a07dae92ce14fd$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e816b1eb28955d95$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}




var $38132a618d93e205$export$1eee5ddc4f6d41c5 = 400;
var $38132a618d93e205$var$defaultFlagGroupContext = {
    onDismissed: (0, $d3997b4aab843580$export$2e2bcd8739ae039),
    isDismissAllowed: false
};
var $38132a618d93e205$export$c57ba665aaa722be = /*#__PURE__*/ (0, $acw62.createContext)($38132a618d93e205$var$defaultFlagGroupContext);
function $38132a618d93e205$export$e91ea202abb66350() {
    return (0, $acw62.useContext)($38132a618d93e205$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $38132a618d93e205$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $38132a618d93e205$var$dismissAllowedStyles = null;
var $38132a618d93e205$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $38132a618d93e205$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? "Flag notifications" : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? "h2" : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $acw62.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(children) === "object" ? (0, $acw62.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return /*#__PURE__*/ $acw62.createElement((0, $20529c9476e6df43$export$2e2bcd8739ae039), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $acw62.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $5zphJ.default)([
                        $38132a618d93e205$var$groupStyles.root,
                        index === 0 && $38132a618d93e205$var$groupStyles.first,
                        index === 1 && $38132a618d93e205$var$groupStyles.second,
                        index >= 1 && $38132a618d93e205$var$groupStyles.nth,
                        index >= 2 && $38132a618d93e205$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref
                }, /*#__PURE__*/ $acw62.createElement($38132a618d93e205$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $38132a618d93e205$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = /*#__PURE__*/ $acw62.createElement("div", {
        id: id,
        className: (0, $5zphJ.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $acw62.createElement((0, $8568069ac023c6f7$export$2e2bcd8739ae039), null, /*#__PURE__*/ $acw62.createElement(LabelTag, null, label)) : null, /*#__PURE__*/ $acw62.createElement((0, $183a833228617892$export$2e2bcd8739ae039), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : /*#__PURE__*/ $acw62.createElement((0, $2167cf9ee39b2459$export$2e2bcd8739ae039), {
        zIndex: (0, $b7d36d3be7da66cd$export$7be255094ccdc533).flag()
    }, flags);
};
var $38132a618d93e205$export$2e2bcd8739ae039 = $38132a618d93e205$var$FlagGroup;


/* dismiss-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $6890e2c18514c7bc$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e25fa526c0658720d6f2766d6bdbde06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6890e2c18514c7bc$exports, "__esModule", {
    value: true
});
$6890e2c18514c7bc$exports.default = void 0;

var $6890e2c18514c7bc$var$_react = $6890e2c18514c7bc$var$_interopRequireDefault((parcelRequire("acw62")));

var $6890e2c18514c7bc$var$_close = $6890e2c18514c7bc$var$_interopRequireDefault((parcelRequire("eVxRg")));

var $6890e2c18514c7bc$var$_cross = $6890e2c18514c7bc$var$_interopRequireDefault((parcelRequire("bsgYL")));
function $6890e2c18514c7bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6890e2c18514c7bc$var$CloseIcon = (props)=>/*#__PURE__*/ $6890e2c18514c7bc$var$_react.default.createElement($6890e2c18514c7bc$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $6890e2c18514c7bc$var$_cross.default
    }, props));
$6890e2c18514c7bc$var$CloseIcon.Name = "CloseIconMigration";
var $6890e2c18514c7bc$var$_default = $6890e2c18514c7bc$exports.default = $6890e2c18514c7bc$var$CloseIcon;


var $010df3279115e84a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03c6653983b99c648f0774c0bc3810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($010df3279115e84a$exports, "__esModule", {
    value: true
});
$010df3279115e84a$exports.default = void 0;

var $010df3279115e84a$var$_react = $010df3279115e84a$var$_interopRequireDefault((parcelRequire("acw62")));

var $010df3279115e84a$var$_chevronDown = $010df3279115e84a$var$_interopRequireDefault((parcelRequire("sg1HA")));

var $010df3279115e84a$var$_chevronDown2 = $010df3279115e84a$var$_interopRequireDefault((parcelRequire("hUoEk")));
function $010df3279115e84a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $010df3279115e84a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $010df3279115e84a$var$_react.default.createElement($010df3279115e84a$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $010df3279115e84a$var$_chevronDown2.default
    }, props));
$010df3279115e84a$var$ChevronDownIcon.Name = "ChevronDownIconMigration";
var $010df3279115e84a$var$_default = $010df3279115e84a$exports.default = $010df3279115e84a$var$ChevronDownIcon;


var $16810892fd4d52db$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c9bd6be3e7327013ae0b836bac300b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($16810892fd4d52db$exports, "__esModule", {
    value: true
});
$16810892fd4d52db$exports.default = void 0;

var $16810892fd4d52db$var$_react = $16810892fd4d52db$var$_interopRequireDefault((parcelRequire("acw62")));

var $16810892fd4d52db$var$_chevronUp = $16810892fd4d52db$var$_interopRequireDefault((parcelRequire("fqvUX")));

var $16810892fd4d52db$var$_chevronUp2 = $16810892fd4d52db$var$_interopRequireDefault((parcelRequire("ihoUn")));
function $16810892fd4d52db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16810892fd4d52db$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $16810892fd4d52db$var$_react.default.createElement($16810892fd4d52db$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $16810892fd4d52db$var$_chevronUp2.default
    }, props));
$16810892fd4d52db$var$ChevronUpIcon.Name = "ChevronUpIconMigration";
var $16810892fd4d52db$var$_default = $16810892fd4d52db$exports.default = $16810892fd4d52db$var$ChevronUpIcon;


/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");





var $12HqF = parcelRequire("12HqF");
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");
var $551de9b6eb78de0b$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $551de9b6eb78de0b$var$_excluded2 = [
    "className"
];
function $551de9b6eb78de0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $551de9b6eb78de0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $551de9b6eb78de0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $551de9b6eb78de0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $551de9b6eb78de0b$var$focusRingStyles = null;
var $551de9b6eb78de0b$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $551de9b6eb78de0b$var$Focusable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $551de9b6eb78de0b$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $551de9b6eb78de0b$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $5zphJ.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $551de9b6eb78de0b$var$_objectSpread($551de9b6eb78de0b$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $cZGu3.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $551de9b6eb78de0b$export$2e2bcd8739ae039 = $551de9b6eb78de0b$var$Focusable;


var $c5f2789211abe33c$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $c5f2789211abe33c$var$_excluded2 = [
    "className"
];
var $c5f2789211abe33c$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $c5f2789211abe33c$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $c5f2789211abe33c$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $12HqF.default));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.2.2",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $c5f2789211abe33c$var$_excluded2);
    return /*#__PURE__*/ $acw62.createElement((0, $551de9b6eb78de0b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: "button",
        style: style
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $9b698034c8c53dd8$export$a274e22fb40f762e)($c5f2789211abe33c$var$styles.root, isDisabled && $c5f2789211abe33c$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $c5f2789211abe33c$export$2e2bcd8739ae039 = $c5f2789211abe33c$var$Pressable;



var $2ca5792a09d1f5f6$var$styles = {
    button: "_16jlidpf _1o9zidpf _i0dl1wug _1dqoglyw _1e0c1txw _1bsb1tcg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1h6o _1bah1h6o _80omtlke _o5721q9c"
};
var $2ca5792a09d1f5f6$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($6890e2c18514c7bc$exports)));
    var buttonLabel = "Dismiss";
    var size = "small";
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($16810892fd4d52db$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($010df3279115e84a$exports)));
        buttonLabel = isExpanded ? "Collapse" : "Expand";
        size = "medium";
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ $acw62.createElement((0, $c5f2789211abe33c$export$2e2bcd8739ae039), {
        xcss: $2ca5792a09d1f5f6$var$styles.button,
        onClick: onClick,
        style: {
            background: "none"
        },
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId,
        "aria-label": buttonLabel
    }, /*#__PURE__*/ $acw62.createElement(ButtonIcon, {
        label: "",
        LEGACY_size: size,
        LEGACY_primaryColor: (0, $82786787318b191b$export$13b42cd9d596bfe0)[appearance],
        color: (0, $82786787318b191b$export$13b42cd9d596bfe0)[appearance]
    }));
};
var $2ca5792a09d1f5f6$var$DismissButton = /*#__PURE__*/ (0, $acw62.memo)($2ca5792a09d1f5f6$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2ca5792a09d1f5f6$export$2e2bcd8739ae039 = $2ca5792a09d1f5f6$var$DismissButton;

/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $c1a7c75e4c42bc2c$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $c1a7c75e4c42bc2c$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $c1a7c75e4c42bc2c$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $290b44577c627b97$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $c1a7c75e4c42bc2c$export$2e2bcd8739ae039 = $c1a7c75e4c42bc2c$var$FadeIn;



var $9444eed9bcadd173$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var $9444eed9bcadd173$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $acw62.createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        xcss: $9444eed9bcadd173$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: "1 1 100%",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $acw62.createElement((0, $183a833228617892$export$2e2bcd8739ae039), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $acw62.createElement((0, $c1a7c75e4c42bc2c$export$2e2bcd8739ae039), null, function(props) {
        return /*#__PURE__*/ $acw62.createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            xcss: $9444eed9bcadd173$var$styles.container
        }, props), /*#__PURE__*/ $acw62.createElement((0, $4bdd1b756b729740$export$2e2bcd8739ae039), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9444eed9bcadd173$export$2e2bcd8739ae039 = $9444eed9bcadd173$var$Expander;



function $2d77e1c2d32ffd41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d77e1c2d32ffd41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d77e1c2d32ffd41$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d77e1c2d32ffd41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d77e1c2d32ffd41$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkosqtm _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
var $2d77e1c2d32ffd41$var$CSS_VAR_ICON_COLOR = "--flag-icon-color";
var $2d77e1c2d32ffd41$var$oldDescriptionStyles = null;
var $2d77e1c2d32ffd41$var$descriptionStyles = null;
var $2d77e1c2d32ffd41$var$oldIconWrapperStyles = null;
var $2d77e1c2d32ffd41$var$iconWrapperStyles = null;
var $2d77e1c2d32ffd41$var$flagWrapperStyles = null;
var $2d77e1c2d32ffd41$var$analyticsAttributes = {
    componentName: "flag",
    packageName: "@atlaskit/flag",
    packageVersion: "17.1.3"
};
var $2d77e1c2d32ffd41$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $2d77e1c2d32ffd41$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $a8cf11ad922cb067$export$d6830277b06edd6) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $38132a618d93e205$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $acw62.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($2d77e1c2d32ffd41$var$_objectSpread({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext
    }, $2d77e1c2d32ffd41$var$analyticsAttributes));
    var isBold = appearance !== (0, $a8cf11ad922cb067$export$d6830277b06edd6);
    var toggleExpand = (0, $acw62.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $acw62.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $acw62.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $acw62.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($2d77e1c2d32ffd41$var$_objectSpread({
        fn: onFocus,
        action: "focused",
        analyticsData: analyticsContext
    }, $2d77e1c2d32ffd41$var$analyticsAttributes));
    var onBlurAnalytics = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($2d77e1c2d32ffd41$var$_objectSpread({
        fn: onBlur,
        action: "blurred",
        analyticsData: analyticsContext
    }, $2d77e1c2d32ffd41$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $82786787318b191b$export$f50075b2584087f)[appearance];
    var iconColor = (0, $82786787318b191b$export$7f70afe2167f8235)[appearance];
    var iconGlyph = (0, $82786787318b191b$export$73f08aee70487cd4)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $acw62.createElement((0, $8568069ac023c6f7$export$2e2bcd8739ae039), null, title, description) : undefined;
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $5zphJ.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $acw62.createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        padding: "space.200",
        backgroundColor: (0, $82786787318b191b$export$59e42969c95d314)[appearance],
        xcss: $2d77e1c2d32ffd41$var$styles.flag
    }, /*#__PURE__*/ $acw62.createElement((0, $f2901d7c083b4af1$export$2e2bcd8739ae039), {
        alignBlock: (0, $ltooA.fg)("platform_ads_component_no_icon_spacing_support") ? "start" : "stretch",
        space: "space.200"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $5zphJ.default)([
            (0, $ltooA.fg)("platform_ads_component_no_icon_spacing_support") ? "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9" : "_1e0c1txw _4cvrv2br _1o9zidpf _syaz16r9"
        ]),
        style: $2d77e1c2d32ffd41$var$_objectSpread($2d77e1c2d32ffd41$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $2d77e1c2d32ffd41$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $cZGu3.default)("var(".concat($2d77e1c2d32ffd41$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || (iconGlyph && (0, $ltooA.fg)("platform_ads_component_no_icon_spacing_support") ? iconGlyph : null)), /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $5zphJ.default)([
            "_v5641hdc _16jlkb7n"
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $4bdd1b756b729740$export$2e2bcd8739ae039), {
        space: shouldRenderGap ? "space.100" : "space.0" // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $acw62.createElement((0, $f2901d7c083b4af1$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $acw62.createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $2d77e1c2d32ffd41$var$styles.overflowWrap
    }, /*#__PURE__*/ $acw62.createElement((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $acw62.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $acw62.createElement((0, $2ca5792a09d1f5f6$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $acw62.createElement((0, $9444eed9bcadd173$export$2e2bcd8739ae039), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $acw62.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $82786787318b191b$export$13b42cd9d596bfe0)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $5zphJ.default)([
            (0, $ltooA.fg)("platform_ads_explicit_font_styles") ? "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65" : "_1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $acw62.createElement((0, $346810cc4b2b017b$export$2e2bcd8739ae039), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $2d77e1c2d32ffd41$export$2e2bcd8739ae039 = $2d77e1c2d32ffd41$var$Flag;



var $9f175d156b67ed04$var$packageName = "@atlaskit/flag";
var $9f175d156b67ed04$var$packageVersion = "17.1.3";
var $9f175d156b67ed04$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $9f175d156b67ed04$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onDismissed;
    var autoDismissTimer = (0, $acw62.useRef)(null);
    var _useFlagGroup = (0, $38132a618d93e205$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $acw62.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext,
        componentName: "flag",
        packageName: $9f175d156b67ed04$var$packageName,
        packageVersion: $9f175d156b67ed04$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $acw62.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $acw62.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $acw62.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $9f175d156b67ed04$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $acw62.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $9f175d156b67ed04$export$2e2bcd8739ae039 = $9f175d156b67ed04$var$AutoDismissFlag;




var $eb77deb211f1d0a4$var$_excluded = [
    "isAutoDismiss"
];
function $eb77deb211f1d0a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb77deb211f1d0a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb77deb211f1d0a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb77deb211f1d0a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eb77deb211f1d0a4$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $eb77deb211f1d0a4$export$2879604e6aec4ab() {
    var api = (0, $acw62.useContext)($eb77deb211f1d0a4$var$FlagContext);
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
}
var $eb77deb211f1d0a4$var$getUniqueId = function() {
    var count = 0;
    return function() {
        return "flag-provider-unique-id:".concat(count++);
    };
}();
function $eb77deb211f1d0a4$export$a4270ab432ac8a58(_ref) {
    var children = _ref.children, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useState = (0, $acw62.useState)([]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), flags = _useState2[0], setFlags = _useState2[1];
    var removeFlag = (0, $acw62.useCallback)(function(id) {
        setFlags(function(current) {
            return current.slice(0).filter(function(flag) {
                return flag.id !== id;
            });
        });
    }, []);
    var api = (0, $acw62.useMemo)(function() {
        return {
            showFlag: function show(value) {
                var flag = $eb77deb211f1d0a4$var$_objectSpread($eb77deb211f1d0a4$var$_objectSpread({}, value), {}, {
                    id: value.id || $eb77deb211f1d0a4$var$getUniqueId()
                });
                setFlags(function(current) {
                    var index = current.findIndex(function(value) {
                        return value.id === flag.id;
                    });
                    // If flag is not found add it
                    if (index === -1) return [
                        flag
                    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(current));
                    // If flag already exists with the same id, then replace it
                    var shallow = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(current);
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        };
    }, [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eb77deb211f1d0a4$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $38132a618d93e205$export$2e2bcd8739ae039), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map(function(flag) {
        var isAutoDismiss = flag.isAutoDismiss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(flag, $eb77deb211f1d0a4$var$_excluded);
        var FlagType = isAutoDismiss ? (0, $9f175d156b67ed04$export$2e2bcd8739ae039) : (0, $2d77e1c2d32ffd41$export$2e2bcd8739ae039);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FlagType, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, restProps, {
            key: flag.id
        }));
    })));
}
var $eb77deb211f1d0a4$export$7b676815c264eaf3 = function withFlagsProvider(fn) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eb77deb211f1d0a4$export$a4270ab432ac8a58, null, fn());
};




var $8MSmw = parcelRequire("8MSmw");

var $hxCZS = parcelRequire("hxCZS");

var $b4vGv = parcelRequire("b4vGv");

var $9z7qU = parcelRequire("9z7qU");

var $9Gm6H = parcelRequire("9Gm6H");

var $7QErp = parcelRequire("7QErp");

var $3c27fd8e5f64c965$var$AWAITING_PAGELOAD_NAME = "awaiting_pageload_name";
function $3c27fd8e5f64c965$export$2e2bcd8739ae039(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var activeInteraction = (0, $7QErp.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $81d0e14c6e36c59b$export$2e2bcd8739ae039).current = routeName || null;
    var rate = ufoName ? (0, $b4vGv.getInteractionRate)(ufoName, "page_load") : 1;
    var enabledBySamplingRate = (0, $hxCZS.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        var newId = (0, $8MSmw.v4)();
        (0, $9Gm6H.DefaultInteractionID).current = newId;
        (0, $7QErp.addNewInteraction)(newId, ufoName || "", "page_load", 0, rate, null, routeName, (0, $9z7qU.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $7QErp.addHoldByID)(newId, [], $3c27fd8e5f64c965$var$AWAITING_PAGELOAD_NAME, $3c27fd8e5f64c965$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === "page_load") // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $7QErp.abort)(activeInteraction.id, "excluded_by_sampling");
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === "page_load") {
        (0, $7QErp.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $7QErp.removeHoldByID)(activeInteraction.id, $3c27fd8e5f64c965$var$AWAITING_PAGELOAD_NAME);
    }
}
function $3c27fd8e5f64c965$export$d0f99433cd4f4028(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = (0, $7QErp.getActiveInteraction)();
    if (!interaction || interaction.type !== "page_load" && interaction.type !== "transition") return;
    if (ufoName) {
        var rate = (0, $b4vGv.getInteractionRate)(ufoName, "page_load");
        (0, $7QErp.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $hxCZS.default)(rate)) (0, $81d0e14c6e36c59b$export$2e2bcd8739ae039).current = ufoName;
        else (0, $7QErp.abort)(interaction.id, "excluded_by_sampling");
    }
    (0, $7QErp.removeHoldByID)(interaction.id, $3c27fd8e5f64c965$var$AWAITING_PAGELOAD_NAME);
}


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");

var $03015978bbe1a3c1$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $acw62.createContext)({
    registerSkipLink: (0, $d3997b4aab843580$export$2e2bcd8739ae039),
    unregisterSkipLink: (0, $d3997b4aab843580$export$2e2bcd8739ae039)
});
var $03015978bbe1a3c1$var$useSkipLinks = function useSkipLinks() {
    return (0, $acw62.useContext)($03015978bbe1a3c1$export$4c5cc3b14c7678a);
};
var $03015978bbe1a3c1$export$707b94c26b8b75aa = function useSkipLinkInternal(_ref) {
    var id = _ref.id, label = _ref.label, listIndex = _ref.listIndex, onBeforeNavigate = _ref.onBeforeNavigate, isHidden = _ref.isHidden;
    var _useSkipLinks = $03015978bbe1a3c1$var$useSkipLinks(), registerSkipLink = _useSkipLinks.registerSkipLink, unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
    (0, $acw62.useEffect)(function() {
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
var $03015978bbe1a3c1$export$89d9323301efc7d6 = function useSkipLink(id, label, listIndex) {
    $03015978bbe1a3c1$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};




var $41YNz = parcelRequire("41YNz");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $fd05be839c660684$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $fd05be839c660684$export$e2a22331486dcca0 = $fd05be839c660684$export$bdbb4cbb3078e58d();


var $4d266bc9c8f3d314$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $fd05be839c660684$export$bdbb4cbb3078e58d)()
    };
};
var $4d266bc9c8f3d314$export$e575061ef2a070eb = $4d266bc9c8f3d314$export$1921362e86c73c88();
var $4d266bc9c8f3d314$export$b4d5da5f34fb77ad = $acw62.createContext($4d266bc9c8f3d314$export$1921362e86c73c88());
var $4d266bc9c8f3d314$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $4d266bc9c8f3d314$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};


var $82d9d5049c8c7ec2$var$generateUID = function(context) {
    var quartz = context || (0, $4d266bc9c8f3d314$export$e575061ef2a070eb);
    var prefix = (0, $4d266bc9c8f3d314$export$36e24695f02d4503)(quartz);
    var id = (0, $4d266bc9c8f3d314$export$218c8c3169c024d2)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $82d9d5049c8c7ec2$var$useUIDState = function() {
    var context = (0, $acw62.useContext)((0, $4d266bc9c8f3d314$export$b4d5da5f34fb77ad));
    var uid = (0, $acw62.useState)(function() {
        return $82d9d5049c8c7ec2$var$generateUID(context);
    })[0];
    return uid;
};
var $82d9d5049c8c7ec2$export$87d05f07e65211f1 = function() {
    var uid = $82d9d5049c8c7ec2$var$useUIDState().uid;
    return uid;
};
var $82d9d5049c8c7ec2$export$bb5ca5fba6fb4f1f = function() {
    var gen = $82d9d5049c8c7ec2$var$useUIDState().gen;
    return gen;
};



var $ltooA = parcelRequire("ltooA");
var $6d39885ac77caaba$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $6d39885ac77caaba$var$react18UseId = ($6d39885ac77caaba$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $6d39885ac77caaba$var$_React$useId !== void 0 ? $6d39885ac77caaba$var$_React$useId : undefined;
function $6d39885ac77caaba$export$f680877a34711e37() {
    if ($6d39885ac77caaba$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $6d39885ac77caaba$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $82d9d5049c8c7ec2$export$87d05f07e65211f1)());
}
var $6d39885ac77caaba$export$6be90bcb437e928f = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($6d39885ac77caaba$export$f680877a34711e37()).concat(postfix);
    (0, $acw62.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $6d39885ac77caaba$export$6ee17796e3d70de2() {
    if ($6d39885ac77caaba$var$react18UseId && (0, $ltooA.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $6d39885ac77caaba$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $82d9d5049c8c7ec2$export$bb5ca5fba6fb4f1f)();
}


var $666273d20d8c70ce$export$86433d4fd18455f4 = function usePrefixedUID() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "element";
    return "".concat(prefix, "-").concat((0, $6d39885ac77caaba$export$f680877a34711e37)());
};



var $acw62 = parcelRequire("acw62");
var $a267a1cc69806d6b$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $acw62.createContext)(false);


var $08f005305414827f$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152t1l7u _165t1run _13wn1if8"
};
function $08f005305414827f$export$861edd1ccea2f746(_ref) {
    var children = _ref.children, isFixed = _ref.isFixed, xcss = _ref.xcss, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? "Main Content" : _ref$skipLinkLabel, testId = _ref.testId, id = _ref.id;
    var UID = (0, $666273d20d8c70ce$export$86433d4fd18455f4)();
    var CID = id ? id : UID;
    (0, $03015978bbe1a3c1$export$89d9323301efc7d6)(CID, skipLinkLabel);
    return /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, /*#__PURE__*/ $acw62.createElement("div", {
        id: CID,
        "data-layout-slot": true,
        className: (0, $5zphJ.default)([
            $08f005305414827f$var$mainElementStyles.root,
            isFixed && $08f005305414827f$var$mainElementStyles.fixedContentArea,
            xcss
        ]),
        role: "main",
        "data-testid": testId
    }, /*#__PURE__*/ $acw62.createElement((0, $a267a1cc69806d6b$export$3b369e2c6c1ec840).Provider, {
        value: Boolean(isFixed)
    }, children)));
}

/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $bv4qN = parcelRequire("bv4qN");

var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
var $43cfa707e17c4f64$var$HasTextAncestorContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $43cfa707e17c4f64$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $acw62.useContext)($43cfa707e17c4f64$var$HasTextAncestorContext);
};
var $43cfa707e17c4f64$export$ae933c6cbe5643ad = $43cfa707e17c4f64$var$HasTextAncestorContext.Provider;




var $35f2f57ed84fe783$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $35f2f57ed84fe783$var$resetStyles = (0, $jjlaj.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $35f2f57ed84fe783$var$strongStyles = (0, $jjlaj.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $35f2f57ed84fe783$var$emStyles = (0, $jjlaj.css)({
    fontStyle: "italic"
});
var $35f2f57ed84fe783$var$textAlignMap = {
    center: (0, $jjlaj.css)({
        textAlign: "center"
    }),
    end: (0, $jjlaj.css)({
        textAlign: "end"
    }),
    start: (0, $jjlaj.css)({
        textAlign: "start"
    })
};
var $35f2f57ed84fe783$var$truncationStyles = (0, $jjlaj.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $35f2f57ed84fe783$var$wordBreakMap = {
    breakAll: (0, $jjlaj.css)({
        wordBreak: "break-all"
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $35f2f57ed84fe783$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $cbc5b5bd3160fa7c$export$1aeb4f6b93c4540d)();
    if ((0, $ltooA.fg)("platform-typography-improved-color-control")) {
        if (colorProp === "inherit") return undefined;
        if (colorProp) return colorProp;
        if (hasTextAncestor) return undefined;
        if ((0, $bcbfa6eabcc99f23$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $bcbfa6eabcc99f23$export$2185ce37f9bdd963)[surface];
        return "color.text";
    }
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $bcbfa6eabcc99f23$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $bcbfa6eabcc99f23$export$2185ce37f9bdd963)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $35f2f57ed84fe783$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $bv4qN.default)($35f2f57ed84fe783$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $43cfa707e17c4f64$export$9322276ec105d055)();
    var color = $35f2f57ed84fe783$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = (0, $jjlaj.jsx)(Component, {
        ref: ref,
        css: [
            $35f2f57ed84fe783$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $bcbfa6eabcc99f23$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $bcbfa6eabcc99f23$export$3a1bcba60b23d7f0)[color],
            maxLines && $35f2f57ed84fe783$var$truncationStyles,
            maxLines === 1 && $35f2f57ed84fe783$var$wordBreakMap.breakAll,
            align && $35f2f57ed84fe783$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $bcbfa6eabcc99f23$export$38845ca010b93505)[weight],
            Component === "em" && $35f2f57ed84fe783$var$emStyles,
            Component === "strong" && $35f2f57ed84fe783$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $jjlaj.jsx)((0, $43cfa707e17c4f64$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $35f2f57ed84fe783$export$2e2bcd8739ae039 = $35f2f57ed84fe783$var$Text;



var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
function $867aafe9eaa1c42d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $867aafe9eaa1c42d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $867aafe9eaa1c42d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $867aafe9eaa1c42d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $867aafe9eaa1c42d$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $acw62.createContext)([]);
var $867aafe9eaa1c42d$var$_assignIndex = function assignIndex(num, arr) {
    if (!arr.includes(num)) return num;
    return $867aafe9eaa1c42d$var$_assignIndex(num + 1, arr);
};
var $867aafe9eaa1c42d$var$sortSkipLinks = function sortSkipLinks(arr) {
    var customLinks = arr.filter(function(link) {
        return Number.isInteger(link.listIndex);
    });
    if (customLinks.length === 0) return arr;
    var usedIndexes = customLinks.map(function(a) {
        return a.listIndex;
    });
    var regularLinksWithIdx = arr.filter(function(link) {
        return link.listIndex === undefined;
    }).map(function(link, idx) {
        var listIndex = $867aafe9eaa1c42d$var$_assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return $867aafe9eaa1c42d$var$_objectSpread($867aafe9eaa1c42d$var$_objectSpread({}, link), {}, {
            listIndex: listIndex
        });
    });
    return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(customLinks), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(regularLinksWithIdx)).sort(function(a, b) {
        return a.listIndex - b.listIndex;
    });
};
var $867aafe9eaa1c42d$export$b0b0d4fc1b356759 = function useSortedSkipLinks() {
    var skipLinksData = (0, $acw62.useContext)($867aafe9eaa1c42d$export$e9ab38ce6147d3d2);
    return (0, $acw62.useMemo)(function() {
        return $867aafe9eaa1c42d$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};


/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $3p9rK = parcelRequire("3p9rK");

var $41YNz = parcelRequire("41YNz");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $bv4qN = parcelRequire("bv4qN");


var $acw62 = parcelRequire("acw62");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $5318d277c24f693e$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $acw62.useContext)((0, $a10120e44fa360e9$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $5318d277c24f693e$export$2e2bcd8739ae039 = $5318d277c24f693e$var$useRouterLink;





var $12HqF = parcelRequire("12HqF");



var $11cad149381bd130$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $11cad149381bd130$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $11cad149381bd130$var$focusRingStyles = (0, $jjlaj.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $11cad149381bd130$var$baseStyles = (0, $jjlaj.css)({
    boxSizing: "border-box",
    textDecoration: "underline"
});
var $11cad149381bd130$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $11cad149381bd130$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $11cad149381bd130$var$OPENS_NEW_WINDOW_LABEL = "(opens new window)";
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $11cad149381bd130$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $11cad149381bd130$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $12HqF.default));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    var onClick = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.2.2",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $11cad149381bd130$var$_excluded2);
    var resolvedStyles = (0, $d8fb25f1eb78afec$export$a9c84988c8f81f2d)(xcss);
    var RouterLink = (0, $5318d277c24f693e$export$2e2bcd8739ae039)();
    var isExternal = typeof href === "string" && $11cad149381bd130$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $11cad149381bd130$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(href) === "object";
    (0, $bv4qN.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $11cad149381bd130$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $11cad149381bd130$var$baseStyles,
            $11cad149381bd130$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $bcbfa6eabcc99f23$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $jjlaj.jsx)((0, $8568069ac023c6f7$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $11cad149381bd130$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $11cad149381bd130$var$Anchor = /*#__PURE__*/ (0, $acw62.forwardRef)($11cad149381bd130$var$AnchorNoRef);
var $11cad149381bd130$export$2e2bcd8739ae039 = $11cad149381bd130$var$Anchor;


var $fb1d8b9624afc78e$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $fb1d8b9624afc78e$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute("tabindex", "-1");
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   */ (0, $8fY35.bind)(element, {
        type: "blur",
        listener: function listener() {
            element.removeAttribute("tabindex");
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
var $fb1d8b9624afc78e$export$ef95c37428582a65 = function SkipLink(_ref) {
    var id = _ref.id, children = _ref.children, onBeforeNavigate = _ref.onBeforeNavigate;
    var href = "#".concat(id);
    var onClick = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        var target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate === null || onBeforeNavigate === void 0 || onBeforeNavigate();
        $fb1d8b9624afc78e$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $5zphJ.default)([
            $fb1d8b9624afc78e$var$styles.skipLinkListItem
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11cad149381bd130$export$2e2bcd8739ae039), {
        tabIndex: 0,
        href: href,
        onClick: onClick
    }, children));
};


var $19533b1b7da653ac$var$styles = {
    root: "_2rkoglpi _1rjcu2gc _18zr12x7 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ var $19533b1b7da653ac$var$closeOnEscape = function closeOnEscape(event) {
    if (event.key !== "Escape") return;
    var activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
var $19533b1b7da653ac$var$isOnlyWhitespaceRegex = /^\s*$/;
var $19533b1b7da653ac$export$fce25a0c32fbc1e1 = function SkipLinksContainer(_ref) {
    var label = _ref.label, testId = _ref.testId;
    var sortedSkipLinks = (0, $867aafe9eaa1c42d$export$b0b0d4fc1b356759)();
    if (sortedSkipLinks.length === 0) return null;
    var isEmptyLabel = $19533b1b7da653ac$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ $acw62.createElement("div", {
        onKeyDown: $19533b1b7da653ac$var$closeOnEscape,
        "data-testid": testId ? "".concat(testId, "--skip-links-container") : undefined,
        className: (0, $5zphJ.default)([
            $19533b1b7da653ac$var$styles.root
        ])
    }, !isEmptyLabel && /*#__PURE__*/ $acw62.createElement((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
        weight: "medium",
        testId: testId ? "".concat(testId, "--skip-links-container--label") : undefined
    }, label), /*#__PURE__*/ $acw62.createElement("ol", {
        className: (0, $5zphJ.default)([
            $19533b1b7da653ac$var$styles.skipLinkList
        ])
    }, sortedSkipLinks.map(function(_ref2) {
        var id = _ref2.id, label = _ref2.label, onBeforeNavigate = _ref2.onBeforeNavigate;
        return /*#__PURE__*/ $acw62.createElement((0, $fb1d8b9624afc78e$export$ef95c37428582a65), {
            key: id,
            id: id,
            onBeforeNavigate: onBeforeNavigate
        }, label);
    })));
};



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $c4c2b52618a33b5e$export$4128169e0878a41d = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $c4c2b52618a33b5e$export$762fcfeaa67873eb = /*#__PURE__*/ (0, $acw62.createContext)((0, $d3997b4aab843580$export$2e2bcd8739ae039));


var $1c0700809345b9ba$export$8b9089606266983e = function HomeActionsProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4c2b52618a33b5e$export$4128169e0878a41d).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4c2b52618a33b5e$export$762fcfeaa67873eb).Provider, {
        value: setElement
    }, children));
};



var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");


var $a9d0cfabb21739bb$var$getByDomOrderSortFunction = function getByDomOrderSortFunction() {
    var layoutSlots = Array.from(document.querySelectorAll("[data-layout-slot]"));
    return function(a, b) {
        var _a$listIndex, _b$listIndex;
        var indexA = (_a$listIndex = a.listIndex) !== null && _a$listIndex !== void 0 ? _a$listIndex : layoutSlots.indexOf(document.getElementById(a.id));
        var indexB = (_b$listIndex = b.listIndex) !== null && _b$listIndex !== void 0 ? _b$listIndex : layoutSlots.indexOf(document.getElementById(b.id));
        /**
     * If they are tied it is because one (or both) is
     * a custom skiplink with a set index.
     *
     * Give the custom skiplink priority.
     */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
var $a9d0cfabb21739bb$export$fe514f9f7b03d46f = function SkipLinksProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $acw62.useState)([]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), links = _useState2[0], setLinks = _useState2[1];
    var registerSkipLink = (0, $acw62.useCallback)(function(skipLinkData) {
        // Don't add duplicate skip links
        setLinks(function(oldLinks) {
            if (oldLinks.some(function(_ref2) {
                var id = _ref2.id;
                return id === skipLinkData.id;
            })) return oldLinks;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(oldLinks), [
                skipLinkData
            ]).sort($a9d0cfabb21739bb$var$getByDomOrderSortFunction());
        });
    }, []);
    var unregisterSkipLink = (0, $acw62.useCallback)(function(id) {
        setLinks(function(links) {
            return links.filter(function(link) {
                return link.id !== id;
            });
        });
    }, []);
    var contextValue = (0, $acw62.useMemo)(function() {
        var data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $03015978bbe1a3c1$export$4c5cc3b14c7678a).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $867aafe9eaa1c42d$export$e9ab38ce6147d3d2).Provider, {
        value: links
    }, children));
};



var $acw62 = parcelRequire("acw62");
var $8895f9558135593b$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $acw62.createContext)(false);



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $5cf9c20981129cc0$export$9c1768094bef896 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $5cf9c20981129cc0$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $acw62.createContext)((0, $d3997b4aab843580$export$2e2bcd8739ae039));


var $4050a5056664e76f$export$ceb8e60e9790fc0f = function SideNavToggleButtonProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5cf9c20981129cc0$export$9c1768094bef896).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5cf9c20981129cc0$export$fb8fa9a80240785e).Provider, {
        value: setElement
    }, children));
};



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $f534cd49ac072614$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $f534cd49ac072614$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $acw62.createContext)((0, $d3997b4aab843580$export$2e2bcd8739ae039));


var $cdd27efbaa545901$export$aac8e996360f6ad9 = function SideNavVisibilityProvider(_ref) {
    var children = _ref.children;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), sideNavState = _useState2[0], setSideNavState = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f534cd49ac072614$export$eb04201bb6dd1e4e).Provider, {
        value: sideNavState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f534cd49ac072614$export$f6b496b07d1ea493).Provider, {
        value: setSideNavState
    }, children));
};


var $f5e5b2246da9d7d3$export$a6d827031bcb31d1 = "unsafe-design-system-page-layout-root";
var $f5e5b2246da9d7d3$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $f5e5b2246da9d7d3$export$be92b6f5f03c0fe9(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$UNSAFE_dangerous = _ref.UNSAFE_dangerouslyHoistSlotSizes, UNSAFE_dangerouslyHoistSlotSizes = _ref$UNSAFE_dangerous === void 0 ? false : _ref$UNSAFE_dangerous, _ref$skipLinksLabel = _ref.skipLinksLabel, skipLinksLabel = _ref$skipLinksLabel === void 0 ? "Skip to:" : _ref$skipLinksLabel, testId = _ref.testId;
    var ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        var IGNORED_ELEMENTS;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cdd27efbaa545901$export$aac8e996360f6ad9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4050a5056664e76f$export$ceb8e60e9790fc0f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1c0700809345b9ba$export$8b9089606266983e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8895f9558135593b$export$66e2c1a0115af861).Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a9d0cfabb21739bb$export$fe514f9f7b03d46f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19533b1b7da653ac$export$fce25a0c32fbc1e1), {
        label: skipLinksLabel,
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $5zphJ.default)([
            $f5e5b2246da9d7d3$var$styles.root,
            xcss
        ]),
        id: $f5e5b2246da9d7d3$export$a6d827031bcb31d1,
        "data-testid": testId
    }, children))))));
}

/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $8fY35 = parcelRequire("8fY35");

var $aS1Zy = parcelRequire("aS1Zy");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $731880a3c24b37f3$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $acw62.createContext)(null);


/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $5bff032364a29355$var$createInternalAPI() {
    var count = 0;
    var registry = new Set();
    function onChange(listener) {
        /**
     * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
     * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
     * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
     */ function wrapped() {
            listener.apply(void 0, arguments);
        }
        registry.add(wrapped);
        return function unsubscribe() {
            registry.delete(wrapped);
        };
    }
    function increment() {
        count += 1;
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(registry).forEach(function(listener) {
            return listener({
                count: count
            });
        });
    }
    function decrement() {
        count -= 1;
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(registry).forEach(function(listener) {
            return listener({
                count: count
            });
        });
    }
    return {
        getCount: function getCount() {
            return count;
        },
        onChange: onChange,
        increment: increment,
        decrement: decrement
    };
}
function $5bff032364a29355$export$97afddda23bcd287(_ref) {
    var children = _ref.children;
    // Using state to ensure a stable reference to a single instance.
    var _useState = (0, $acw62.useState)(function() {
        return $5bff032364a29355$var$createInternalAPI();
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), internalAPI = _useState2[0];
    var parentContext = (0, $acw62.useContext)((0, $731880a3c24b37f3$export$5fbf4d7fae6cdc00));
    var increment = (0, $acw62.useCallback)(function() {
        internalAPI.increment();
        // If the `OpenLayerObserver` is nested, increment the layer count in the parent context as well.
        if (parentContext !== null) parentContext.increment();
    }, [
        internalAPI,
        parentContext
    ]);
    var decrement = (0, $acw62.useCallback)(function() {
        internalAPI.decrement();
        // If the `OpenLayerObserver` is nested, decrement the layer count in the parent context as well.
        if (parentContext !== null) parentContext.decrement();
    }, [
        internalAPI,
        parentContext
    ]);
    var contextValue = (0, $acw62.useMemo)(function() {
        return {
            getCount: internalAPI.getCount,
            onChange: internalAPI.onChange,
            increment: increment,
            decrement: decrement
        };
    }, [
        decrement,
        increment,
        internalAPI.getCount,
        internalAPI.onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $731880a3c24b37f3$export$5fbf4d7fae6cdc00).Provider, {
        value: contextValue
    }, children);
}


var $acw62 = parcelRequire("acw62");

var $bv4qN = parcelRequire("bv4qN");

function $9bd6fa1891e87a3f$export$750f5b0d6c51617e() {
    var context = (0, $acw62.useContext)((0, $731880a3c24b37f3$export$5fbf4d7fae6cdc00));
    (0, $bv4qN.default)(context, "useOpenLayerObserver must be used within an OpenLayerObserver");
    var publicAPI = (0, $acw62.useMemo)(function() {
        return {
            getCount: context.getCount,
            onChange: context.onChange
        };
    }, [
        context.getCount,
        context.onChange
    ]);
    return publicAPI;
}


parcelRequire("lLUpG");
var $9eYWs = parcelRequire("9eYWs");
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $4d1cc07665f9c15d$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $4d1cc07665f9c15d$export$c881183ca713c214 = $4d1cc07665f9c15d$export$987d49ffe1b0900f;




/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
var $ba31aa5af7994f57$export$951bf5156e86d974 = "--n_sNvw";
var $ba31aa5af7994f57$export$594e6a30db7c057e = "--n_asDw";
var $ba31aa5af7994f57$export$db0c2e1d744fb281 = "--n_pnlW";
var $ba31aa5af7994f57$export$515a0b1baafe906c = "--n_bnrM";
var $ba31aa5af7994f57$export$a96e934b2a1eeee = "--n_tbrM";
var $ba31aa5af7994f57$export$2874e68531ce3163 = "calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))";
var $ba31aa5af7994f57$export$bfabd8c2c572ad29 = "calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))";
var $ba31aa5af7994f57$export$f4afb213f937404c = "--topNavigationHeight";
var $ba31aa5af7994f57$export$26354f9814213292 = "--bannerHeight";
var $ba31aa5af7994f57$export$6bfc931a04ec5741 = "--leftSidebarWidth";
var $ba31aa5af7994f57$export$bbbace2ff0c7ae1b = "--rightSidebarWidth";
var $ba31aa5af7994f57$export$753bf7651b25db91 = "--rightPanelWidth";
var $ba31aa5af7994f57$export$6460bd6a2446260 = "calc(var(".concat($ba31aa5af7994f57$export$26354f9814213292, ", 0px) + var(").concat($ba31aa5af7994f57$export$f4afb213f937404c, ", 0px))");
var $ba31aa5af7994f57$export$3055529fab2b4edf = "var(".concat($ba31aa5af7994f57$export$6bfc931a04ec5741, ", 0px)");
var $ba31aa5af7994f57$export$166d8fd766c3eb92 = "calc(var(".concat($ba31aa5af7994f57$export$bbbace2ff0c7ae1b, ", 0px) + var(").concat($ba31aa5af7994f57$export$753bf7651b25db91, ", 0px))");
var $ba31aa5af7994f57$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    topBarBorder: 3,
    sideNav: 2,
    contentBlockBorder: 2,
    contentInlineBorder: 1,
    panelSmallViewports: 1
};




var $acw62 = parcelRequire("acw62");

var $daa2a2a305813e84$export$cfa3cd08d675e56e = function HoistCssVarToLocalGrid(_ref) {
    var variableName = _ref.variableName, value = _ref.value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, "#".concat((0, $f5e5b2246da9d7d3$export$a6d827031bcb31d1), " { ").concat(variableName, ": ").concat(value, "px }"));
};
var $daa2a2a305813e84$var$getCssStringValue = function getCssStringValue(value) {
    return typeof value === "number" ? "".concat(value, "px") : value;
};
var $daa2a2a305813e84$export$9f45a1325e3cdfb8 = function DangerouslyHoistCssVarToDocumentRoot(_ref2) {
    var variableName = _ref2.variableName, value = _ref2.value, mediaQuery = _ref2.mediaQuery, responsiveValue = _ref2.responsiveValue;
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ var style = ":root { ".concat(variableName, ": ").concat($daa2a2a305813e84$var$getCssStringValue(value), " }");
    if (mediaQuery && responsiveValue) style += " ".concat(mediaQuery, " { :root { ").concat(variableName, ": ").concat($daa2a2a305813e84$var$getCssStringValue(responsiveValue), " } }");
    return(/*#__PURE__*/ // Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, style));
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $c93d67c1e69c78db$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $acw62.createContext)(null);


var $09f14703f48499ca$export$f662bfb764348932 = function PanelSplitterProvider(_ref) {
    var panelWidth = _ref.panelWidth, onCompleteResize = _ref.onCompleteResize, resizeBounds = _ref.resizeBounds, resizingCssVar = _ref.resizingCssVar, panelRef = _ref.panelRef, _ref$position = _ref.position, position = _ref$position === void 0 ? "end" : _ref$position, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, children = _ref.children;
    var portalRef = (0, $acw62.useRef)(null);
    var context = (0, $acw62.useMemo)(function() {
        return {
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            resizeBounds: resizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        };
    }, [
        isEnabled,
        onCompleteResize,
        panelRef,
        panelWidth,
        position,
        resizeBounds,
        resizingCssVar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c93d67c1e69c78db$export$7a4054f2c546f2cd).Provider, {
        value: context
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: portalRef
    }));
};



// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ var $5f3d2ae04a81a741$export$a7801e29f563faad = 400;




var $acw62 = parcelRequire("acw62");

var $bv4qN = parcelRequire("bv4qN");

function $5f21fc8971148bbe$export$e44b4744d8ff971a() {
    var setSideNavState = (0, $acw62.useContext)((0, $f534cd49ac072614$export$f6b496b07d1ea493));
    var expandSideNav = (0, $acw62.useCallback)(function() {
        var _window$matchMedia = window.matchMedia("(min-width: 64rem)"), matches = _window$matchMedia.matches;
        if (matches) setSideNavState(function(currentState) {
            (0, $bv4qN.default)(currentState, "Side nav state should not be null");
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === "expanded" && currentState.flyout === "closed") return currentState;
            return {
                mobile: currentState.mobile,
                desktop: "expanded",
                flyout: "closed"
            };
        });
        else setSideNavState(function(currentState) {
            (0, $bv4qN.default)(currentState, "Side nav state should not be null");
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === "expanded" && currentState.flyout === "closed") return currentState;
            return {
                desktop: currentState.desktop,
                mobile: "expanded",
                flyout: "closed"
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}



var $acw62 = parcelRequire("acw62");

var $4e479c9241965de2$export$4a602ad7e09bdb2c = function useSideNavVisibility() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$defaultCollapsed = _ref.defaultCollapsed, defaultCollapsed = _ref$defaultCollapsed === void 0 ? false : _ref$defaultCollapsed;
    var sideNavState = (0, $acw62.useContext)((0, $f534cd49ac072614$export$eb04201bb6dd1e4e));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === "expanded",
        isExpandedOnMobile: sideNavState.mobile === "expanded"
    };
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $8b1ca3977f5313f5$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}


function $4364742e75e8e668$export$1904b8f2577aba9a(_ref) {
    var onExpand = _ref.onExpand, onCollapse = _ref.onCollapse, isExpandedOnDesktop = _ref.isExpandedOnDesktop, isExpandedOnMobile = _ref.isExpandedOnMobile;
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    var onExpandRef = (0, $acw62.useRef)(onExpand);
    var onCollapseRef = (0, $acw62.useRef)(onCollapse);
    (0, $acw62.useEffect)(function() {
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    var previousIsExpandedOnDesktop = (0, $8b1ca3977f5313f5$export$2e2bcd8739ae039)(isExpandedOnDesktop);
    (0, $acw62.useEffect)(function() {
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnDesktop) {
            var _onExpandRef$current;
            (_onExpandRef$current = onExpandRef.current) === null || _onExpandRef$current === void 0 || _onExpandRef$current.call(onExpandRef, {
                screen: "desktop"
            });
        } else {
            var _onCollapseRef$curren;
            (_onCollapseRef$curren = onCollapseRef.current) === null || _onCollapseRef$curren === void 0 || _onCollapseRef$curren.call(onCollapseRef, {
                screen: "desktop"
            });
        }
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    var previousIsExpandedOnMobile = (0, $8b1ca3977f5313f5$export$2e2bcd8739ae039)(isExpandedOnMobile);
    (0, $acw62.useEffect)(function() {
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnMobile) {
            var _onExpandRef$current2;
            (_onExpandRef$current2 = onExpandRef.current) === null || _onExpandRef$current2 === void 0 || _onExpandRef$current2.call(onExpandRef, {
                screen: "mobile"
            });
        } else {
            var _onCollapseRef$curren2;
            (_onCollapseRef$curren2 = onCollapseRef.current) === null || _onCollapseRef$curren2 === void 0 || _onCollapseRef$curren2.call(onCollapseRef, {
                screen: "mobile"
            });
        }
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}



var $acw62 = parcelRequire("acw62");

var $bv4qN = parcelRequire("bv4qN");

function $4802f153fd426531$export$477ee35601a0a8ce() {
    var setSideNavState = (0, $acw62.useContext)((0, $f534cd49ac072614$export$f6b496b07d1ea493));
    var toggleSideNav = (0, $acw62.useCallback)(function() {
        var _window$matchMedia = window.matchMedia("(min-width: 64rem)"), matches = _window$matchMedia.matches;
        if (matches) setSideNavState(function(currentState) {
            (0, $bv4qN.default)(currentState, "Side nav state should not be null");
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === "expanded" ? "collapsed" : "expanded",
                flyout: "closed"
            };
        });
        else setSideNavState(function(currentState) {
            (0, $bv4qN.default)(currentState, "Side nav state should not be null");
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === "expanded" ? "collapsed" : "expanded",
                flyout: "closed"
            };
        });
    }, [
        setSideNavState
    ]);
    return toggleSideNav;
}



var $c5a8151421d30146$var$panelSplitterResizingVar = "--n_snvRsz";
var $c5a8151421d30146$var$widthResizeBounds = {
    min: "240px",
    max: "50vw"
};
var $c5a8151421d30146$var$styles = {
    root: "_nd5l1b6c _t51zzgxb _bfhk1bhr _16qs1cd0 _vchhusvi _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $c5a8151421d30146$var$SideNavInternal(_ref) {
    var children = _ref.children, defaultCollapsed = _ref.defaultCollapsed, _ref$defaultWidth = _ref.defaultWidth, defaultWidth = _ref$defaultWidth === void 0 ? 320 : _ref$defaultWidth, testId = _ref.testId, _ref$label = _ref.label, label = _ref$label === void 0 ? "Sidebar" : _ref$label, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? label : _ref$skipLinkLabel, onExpand = _ref.onExpand, onCollapse = _ref.onCollapse, id = _ref.id;
    var UID = (0, $666273d20d8c70ce$export$86433d4fd18455f4)();
    var CID = id ? id : UID;
    var expandSideNav = (0, $5f21fc8971148bbe$export$e44b4744d8ff971a)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ var synchronouslyExpandSideNav = (0, $acw62.useCallback)(function() {
        (0, $aS1Zy.flushSync)(function() {
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $03015978bbe1a3c1$export$707b94c26b8b75aa)({
        id: CID,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    var sideNavState = (0, $acw62.useContext)((0, $f534cd49ac072614$export$eb04201bb6dd1e4e));
    var setSideNavState = (0, $acw62.useContext)((0, $f534cd49ac072614$export$f6b496b07d1ea493));
    var _useSideNavVisibility = (0, $4e479c9241965de2$export$4a602ad7e09bdb2c)({
        defaultCollapsed: defaultCollapsed
    }), isExpandedOnDesktop = _useSideNavVisibility.isExpandedOnDesktop, isExpandedOnMobile = _useSideNavVisibility.isExpandedOnMobile;
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    var _useState = (0, $acw62.useState)(defaultCollapsed), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), initialDefaultCollapsed = _useState2[0];
    var _useState3 = (0, $acw62.useState)(defaultWidth), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), width = _useState4[0], setWidth = _useState4[1];
    var clampedWidth = "clamp(".concat($c5a8151421d30146$var$widthResizeBounds.min, ", ").concat(width, "px, ").concat($c5a8151421d30146$var$widthResizeBounds.max, ")");
    var dangerouslyHoistSlotSizes = (0, $acw62.useContext)((0, $8895f9558135593b$export$66e2c1a0115af861));
    var navRef = (0, $acw62.useRef)(null);
    var toggleButtonElement = (0, $acw62.useContext)((0, $5cf9c20981129cc0$export$9c1768094bef896));
    var homeActionsElement = (0, $acw62.useContext)((0, $c4c2b52618a33b5e$export$4128169e0878a41d));
    var devTimeOnlyAttributes = {};
    var openLayerObserver = (0, $9bd6fa1891e87a3f$export$750f5b0d6c51617e)();
    var flyoutStateRef = (0, $acw62.useRef)({
        type: "not-active"
    });
    var isFlyoutVisible = (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === "open";
    var updateFlyoutState = (0, $acw62.useMemo)(function() {
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === "waiting-for-close") flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: "open"
            };
            setSideNavState(function(currentState) {
                if ((currentState === null || currentState === void 0 ? void 0 : currentState.desktop) === "collapsed" && (currentState === null || currentState === void 0 ? void 0 : currentState.flyout) !== "open") return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: "open"
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: "not-active"
            };
            setSideNavState(function(currentState) {
                if ((currentState === null || currentState === void 0 ? void 0 : currentState.desktop) === "collapsed" && (currentState === null || currentState === void 0 ? void 0 : currentState.flyout) === "open") return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: "triggered-animate-close"
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === "drag-from-flyout-started") {
                open();
                flyoutStateRef.current = {
                    type: "is-dragging-from-flyout"
                };
                return;
            }
            if (action === "drag-from-flyout-finished") {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === "is-dragging-from-flyout") return;
            if (action === "open") {
                open();
                return;
            }
            if (action === "waiting-for-close") {
                if (flyoutStateRef.current.type === "waiting-for-close") return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                var timeout = setTimeout(function() {
                    updateFlyoutState("ready-to-close");
                }, (0, $5f3d2ae04a81a741$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: "waiting-for-close",
                    abort: function abort() {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === "ready-to-close") {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount() === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: "ready-to-close"
                };
                return;
            }
            if (action === "force-close") {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    var toggleVisibility = (0, $4802f153fd426531$export$477ee35601a0a8ce)();
    (0, $acw62.useEffect)(function() {
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? "collapsed" : "expanded",
            mobile: "collapsed",
            flyout: "closed"
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    var handleExpand = (0, $acw62.useCallback)(function(_ref2) {
        var screen = _ref2.screen;
        onExpand === null || onExpand === void 0 || onExpand({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState("force-close");
    }, [
        onExpand,
        updateFlyoutState
    ]);
    var handleCollapse = (0, $acw62.useCallback)(function(_ref3) {
        var screen = _ref3.screen;
        onCollapse === null || onCollapse === void 0 || onCollapse({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState("force-close");
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $4364742e75e8e668$export$1904b8f2577aba9a)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $acw62.useEffect)(function() {
        var mediaQueryList = window.matchMedia("(min-width: 64rem)");
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: function listener() {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    (0, $acw62.useEffect)(function() {
        if (!toggleButtonElement) return;
        return (0, $8fY35.bind)(toggleButtonElement, {
            type: "mouseenter",
            listener: function listener() {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                var _window$matchMedia = window.matchMedia("(min-width: 64rem)"), matches = _window$matchMedia.matches;
                if (matches) updateFlyoutState("open");
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $acw62.useEffect)(function() {
        if (!toggleButtonElement) return;
        return (0, $8fY35.bind)(toggleButtonElement, {
            type: "mouseleave",
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $acw62.useEffect)(function() {
        if (!navRef.current) return;
        return (0, $8fY35.bind)(navRef.current, {
            type: "mouseenter",
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState("open");
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $acw62.useEffect)(function() {
        if (!navRef.current) return;
        return (0, $8fY35.bind)(navRef.current, {
            type: "mouseleave",
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $acw62.useEffect)(function() {
        var nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $9eYWs.monitorForElements)({
            canMonitor: function canMonitor(_ref4) {
                var source = _ref4.source;
                return nav.contains(source.element);
            },
            onGenerateDragPreview: function onGenerateDragPreview() {
                updateFlyoutState("drag-from-flyout-started");
            },
            onDrop: function onDrop(_ref5) {
                var location = _ref5.location;
                // Always marking the drag and done
                updateFlyoutState("drag-from-flyout-finished");
                // If the user dropped outside of the flyout, we will close the flyout
                var underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $acw62.useEffect)(function() {
        if (!homeActionsElement || !toggleButtonElement) return;
        return (0, $8fY35.bind)(homeActionsElement, {
            type: "mouseover",
            listener: function listener(event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === homeActionsElement) {
                    // The mouse is directly over the home actions container, so cancel any pending flyout closes.
                    updateFlyoutState("open");
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the home actions container that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $acw62.useEffect)(function() {
        if (!homeActionsElement) return;
        return (0, $8fY35.bind)(homeActionsElement, {
            type: "mouseleave",
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the home actions container, so we should close the flyout with a delay.
                updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $acw62.useEffect)(function() {
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, top bar home actions element)
        return openLayerObserver.onChange(function onChange(_ref6) {
            var count = _ref6.count;
            if (flyoutStateRef.current.type === "ready-to-close" && count === 0) updateFlyoutState("force-close");
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $acw62.useEffect)(function() {
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === "waiting-for-close") flyoutStateRef.current.abort();
        };
    }, []);
    var visible;
    return /*#__PURE__*/ $acw62.createElement("nav", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        id: CID
    }, devTimeOnlyAttributes, {
        "data-layout-slot": true,
        "aria-label": label,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $ba31aa5af7994f57$export$951bf5156e86d974), clampedWidth),
        ref: navRef,
        "data-testid": testId,
        className: (0, $5zphJ.default)([
            $c5a8151421d30146$var$styles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $c5a8151421d30146$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $c5a8151421d30146$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $c5a8151421d30146$var$styles.hiddenMobileAndDesktop,
            (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === "open" && $c5a8151421d30146$var$styles.flyoutOpen,
            (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === "triggered-animate-close" && $c5a8151421d30146$var$styles.flyoutAnimateClosed
        ])
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $acw62.createElement((0, $daa2a2a305813e84$export$9f45a1325e3cdfb8), {
        variableName: (0, $ba31aa5af7994f57$export$6bfc931a04ec5741),
        value: "0px",
        mediaQuery: (0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.md,
        responsiveValue: isExpandedOnDesktop ? clampedWidth : 0
    }), /*#__PURE__*/ $acw62.createElement((0, $09f14703f48499ca$export$f662bfb764348932), {
        panelRef: navRef,
        panelWidth: width,
        onCompleteResize: setWidth,
        resizeBounds: $c5a8151421d30146$var$widthResizeBounds,
        resizingCssVar: $c5a8151421d30146$var$panelSplitterResizingVar,
        isEnabled: isExpandedOnDesktop && !isFlyoutVisible
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $5zphJ.default)([
            $c5a8151421d30146$var$styles.flexContainer
        ])
    }, children)));
}
function $c5a8151421d30146$export$1a35787d6353cf6a(_ref8) {
    var children = _ref8.children, defaultCollapsed = _ref8.defaultCollapsed, _ref8$defaultWidth = _ref8.defaultWidth, defaultWidth = _ref8$defaultWidth === void 0 ? 320 : _ref8$defaultWidth, testId = _ref8.testId, label = _ref8.label, _ref8$skipLinkLabel = _ref8.skipLinkLabel, skipLinkLabel = _ref8$skipLinkLabel === void 0 ? label : _ref8$skipLinkLabel, onExpand = _ref8.onExpand, onCollapse = _ref8.onCollapse, id = _ref8.id;
    return /*#__PURE__*/ $acw62.createElement((0, $5bff032364a29355$export$97afddda23bcd287), null, /*#__PURE__*/ $acw62.createElement($c5a8151421d30146$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        skipLinkLabel: skipLinkLabel,
        onExpand: onExpand,
        onCollapse: onCollapse,
        id: id
    }, children));
}

/* toggle-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
var $e451edc7bf29d1ff$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::abc8b5d03c24733db4f330a1621745d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e451edc7bf29d1ff$exports, "__esModule", {
    value: true
});
$e451edc7bf29d1ff$exports.default = void 0;

var $e451edc7bf29d1ff$var$_react = $e451edc7bf29d1ff$var$_interopRequireDefault((parcelRequire("acw62")));

var $e451edc7bf29d1ff$var$_baseNew = $e451edc7bf29d1ff$var$_interopRequireDefault((parcelRequire("fqFky")));
function $e451edc7bf29d1ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e451edc7bf29d1ff$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $e451edc7bf29d1ff$var$_react.default.createElement($e451edc7bf29d1ff$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$e451edc7bf29d1ff$var$SidebarCollapseIcon.displayName = "SidebarCollapseIcon";
var $e451edc7bf29d1ff$var$_default = $e451edc7bf29d1ff$exports.default = $e451edc7bf29d1ff$var$SidebarCollapseIcon;


var $97e1822274bbe635$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f4e0f9a7acbecae432a6a2607234087>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($97e1822274bbe635$exports, "__esModule", {
    value: true
});
$97e1822274bbe635$exports.default = void 0;

var $97e1822274bbe635$var$_react = $97e1822274bbe635$var$_interopRequireDefault((parcelRequire("acw62")));

var $97e1822274bbe635$var$_baseNew = $97e1822274bbe635$var$_interopRequireDefault((parcelRequire("fqFky")));
function $97e1822274bbe635$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97e1822274bbe635$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $97e1822274bbe635$var$_react.default.createElement($97e1822274bbe635$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$97e1822274bbe635$var$SidebarExpandIcon.displayName = "SidebarExpandIcon";
var $97e1822274bbe635$var$_default = $97e1822274bbe635$exports.default = $97e1822274bbe635$var$SidebarExpandIcon;



var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");



var $12HqF = parcelRequire("12HqF");


var $4a92da350b7429b4$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $4a92da350b7429b4$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $4a92da350b7429b4$var$focusRingStyles = (0, $jjlaj.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $bcbfa6eabcc99f23$export$1531ad5bb3fbedac)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $bcbfa6eabcc99f23$export$958d0ae7f2977ae4)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $bcbfa6eabcc99f23$export$e1b83c5210c471b8)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $4a92da350b7429b4$var$baseStyles = (0, $jjlaj.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $4a92da350b7429b4$var$enabledStyles = (0, $jjlaj.css)({
    cursor: "pointer"
});
var $4a92da350b7429b4$var$disabledStyles = (0, $jjlaj.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $4a92da350b7429b4$var$Pressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $4a92da350b7429b4$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $12HqF.default));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.2.2",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $4a92da350b7429b4$var$_excluded2);
    var resolvedStyles = (0, $d8fb25f1eb78afec$export$a9c84988c8f81f2d)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $jjlaj.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $4a92da350b7429b4$var$baseStyles,
            $4a92da350b7429b4$var$focusRingStyles,
            isDisabled ? $4a92da350b7429b4$var$disabledStyles : $4a92da350b7429b4$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $bcbfa6eabcc99f23$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $bcbfa6eabcc99f23$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $4a92da350b7429b4$export$2e2bcd8739ae039 = $4a92da350b7429b4$var$Pressable;



var $acw62 = parcelRequire("acw62");

var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $dfc470d833fdb959$var$textStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $dfc470d833fdb959$var$iconStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: "none"
});
var $dfc470d833fdb959$var$commonStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    transition: "opacity 0.3s"
});
var $dfc470d833fdb959$var$fadeStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $dfc470d833fdb959$var$beforeIconStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)"
});
var $dfc470d833fdb959$var$afterIconStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $dfc470d833fdb959$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        as: "span",
        xcss: [
            $dfc470d833fdb959$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(type === "text" ? [
            $dfc470d833fdb959$var$textStyles
        ] : [
            $dfc470d833fdb959$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(isLoading ? [
            $dfc470d833fdb959$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(position === "before" ? [
            $dfc470d833fdb959$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(position === "after" ? [
            $dfc470d833fdb959$var$afterIconStyles
        ] : []))
    }, children);
};
var $dfc470d833fdb959$export$2e2bcd8739ae039 = $dfc470d833fdb959$var$Content;



var $acw62 = parcelRequire("acw62");
function $e81b74584a4f1554$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $e81b74584a4f1554$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $e81b74584a4f1554$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        label: "",
        color: "currentColor"
    }));
};
var $e81b74584a4f1554$export$2e2bcd8739ae039 = $e81b74584a4f1554$var$IconRenderer;



var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $270747da43296caf$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}





var $ltooA = parcelRequire("ltooA");


var $dnCk4 = parcelRequire("dnCk4");


var $acw62 = parcelRequire("acw62");
var $607799b9d68c2448$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $607799b9d68c2448$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $acw62.useContext)($607799b9d68c2448$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $b7550bc4160ac1dd$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $b7550bc4160ac1dd$var$tabKeyCode = 9;
function $b7550bc4160ac1dd$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $b7550bc4160ac1dd$var$tabKeyCode) return;
    $b7550bc4160ac1dd$var$abort(event);
}
function $b7550bc4160ac1dd$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $b7550bc4160ac1dd$var$abort,
        onMouseUpCapture: $b7550bc4160ac1dd$var$abort,
        onKeyDownCapture: $b7550bc4160ac1dd$var$onKey,
        onKeyUpCapture: $b7550bc4160ac1dd$var$onKey,
        onTouchStartCapture: $b7550bc4160ac1dd$var$abort,
        onTouchEndCapture: $b7550bc4160ac1dd$var$abort,
        onPointerDownCapture: $b7550bc4160ac1dd$var$abort,
        onPointerUpCapture: $b7550bc4160ac1dd$var$abort,
        onClickCapture: $b7550bc4160ac1dd$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $b7550bc4160ac1dd$var$abort
    } : events;
}


var $b67192b4311b4214$export$d4c5499dc806c969 = ", Loading";



var $acw62 = parcelRequire("acw62");

function $791be1887d8efae6$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $791be1887d8efae6$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $791be1887d8efae6$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d847f661580efa86$export$2e2bcd8739ae039), {
        size: $791be1887d8efae6$var$getIconSpacing(spacing),
        appearance: $791be1887d8efae6$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


function $e5748c90ecffda4b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5748c90ecffda4b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5748c90ecffda4b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5748c90ecffda4b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e5748c90ecffda4b$var$buttonStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    flexShrink: 0,
    height: "2rem",
    font: "font.body",
    fontWeight: "font.weight.medium",
    paddingBlock: "space.075",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out",
    verticalAlign: "middle",
    "::after": {
        borderRadius: "inherit",
        inset: "space.0",
        borderStyle: "solid",
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: "none",
        position: "absolute"
    }
});
var $e5748c90ecffda4b$var$defaultInteractiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($dnCk4.N500, ")")
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($dnCk4.B75, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($dnCk4.B400, ")")
    }
});
var $e5748c90ecffda4b$var$defaultInteractiveRefreshedStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: "color.text.subtle"
    }
});
var $e5748c90ecffda4b$var$defaultStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($dnCk4.N20A, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($dnCk4.N500, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($dnCk4.N500, ")")
    },
    ":hover": {
        // @ts-expect-error — using tokens for explicit fallback usage.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($dnCk4.N500, ")")
    },
    ":active": {
        // @ts-expect-error — using tokens for explicit fallback usage.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($dnCk4.N500, ")")
    },
    ":focus": {
        // @ts-expect-error — using tokens for explicit fallback usage.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($dnCk4.N500, ")")
    }
});
var $e5748c90ecffda4b$var$defaultRefreshedStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "color.text.subtle",
    "::after": {
        content: '""',
        borderColor: "color.border"
    },
    ":visited": {
        color: "color.text.subtle"
    },
    ":hover": {
        color: "color.text.subtle"
    },
    ":active": {
        color: "color.text.subtle"
    },
    ":focus": {
        color: "color.text.subtle"
    }
});
var $e5748c90ecffda4b$var$primaryStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    },
    ":hover": {
        color: "color.text.inverse"
    },
    ":active": {
        color: "color.text.inverse"
    },
    ":focus": {
        color: "color.text.inverse"
    }
});
var $e5748c90ecffda4b$var$primaryInteractiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $e5748c90ecffda4b$var$warningStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    },
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    },
    ":focus": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $e5748c90ecffda4b$var$warningInteractiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $e5748c90ecffda4b$var$dangerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    },
    ":hover": {
        color: "color.text.inverse"
    },
    ":active": {
        color: "color.text.inverse"
    },
    ":focus": {
        color: "color.text.inverse"
    }
});
var $e5748c90ecffda4b$var$dangerInteractiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $e5748c90ecffda4b$var$discoveryStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    },
    ":hover": {
        color: "color.text.inverse"
    },
    ":active": {
        color: "color.text.inverse"
    },
    ":focus": {
        color: "color.text.inverse"
    }
});
var $e5748c90ecffda4b$var$discoveryInteractiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $e5748c90ecffda4b$var$subtleStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":focus": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $e5748c90ecffda4b$var$subtleRefreshedStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: "color.text.subtle",
    ":visited": {
        color: "color.text.subtle"
    },
    ":hover": {
        color: "color.text.subtle"
    },
    ":active": {
        color: "color.text.subtle"
    },
    ":focus": {
        color: "color.text.subtle"
    }
});
var $e5748c90ecffda4b$var$subtleInteractiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $e5748c90ecffda4b$var$subtleInteractiveRefreshedStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: "color.text.subtle"
    }
});
// Reinforce existing styles with higher specificity
// to defend against global anchor styles from products,
// preventing issues in Jira and Confluence.
var $e5748c90ecffda4b$var$linkDefensiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":active": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    },
    ":visited": {
        textDecoration: "none"
    }
});
var $e5748c90ecffda4b$var$disabledStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
    color: "color.text.disabled",
    "::after": {
        content: "none"
    },
    ":visited": {
        color: "color.text.disabled"
    },
    ":hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
        color: "color.text.disabled"
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
        color: "color.text.disabled"
    },
    ":focus": {
        color: "color.text.disabled"
    }
});
var $e5748c90ecffda4b$var$selectedStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")")
    },
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")")
    },
    ":focus": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")")
    }
});
var $e5748c90ecffda4b$var$selectedRefreshedStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "color.text.selected",
    "::after": {
        content: '""',
        borderColor: "color.border.selected"
    },
    ":visited": {
        color: "color.text.selected"
    },
    ":hover": {
        color: "color.text.selected"
    },
    ":active": {
        color: "color.text.selected"
    },
    ":focus": {
        color: "color.text.selected"
    }
});
var $e5748c90ecffda4b$var$selectedInsideSplitButtonStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $e5748c90ecffda4b$var$selectedInteractiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($dnCk4.N700, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($dnCk4.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $e5748c90ecffda4b$var$selectedWarningStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($dnCk4.N800, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $e5748c90ecffda4b$var$selectedDangerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($dnCk4.R500, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($dnCk4.R500, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($dnCk4.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $e5748c90ecffda4b$var$selectedDiscoveryStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
var $e5748c90ecffda4b$var$spacingCompactStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    columnGap: "space.050",
    height: "1.5rem",
    paddingBlock: "space.025",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $e5748c90ecffda4b$var$circleStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    borderRadius: "border.radius.circle"
});
var $e5748c90ecffda4b$var$fullWidthStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "100%"
});
var $e5748c90ecffda4b$var$loadingStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    cursor: "progress"
});
var $e5748c90ecffda4b$var$iconButtonStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    height: "2rem",
    width: "2rem",
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
var $e5748c90ecffda4b$var$iconButtonCompactStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "1.5rem",
    height: "1.5rem"
});
var $e5748c90ecffda4b$var$buttonIconBeforeStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingInlineStart: "space.100"
});
var $e5748c90ecffda4b$var$buttonIconAfterStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingInlineEnd: "space.100"
});
var $e5748c90ecffda4b$var$splitButtonStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    ":focus-visible": {
        zIndex: "card"
    }
});
var $e5748c90ecffda4b$var$navigationSplitButtonStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "24px",
    backgroundColor: "color.background.neutral.subtle",
    paddingInlineEnd: "space.075",
    paddingInlineStart: "space.075"
});
var $e5748c90ecffda4b$var$loadingOverlayStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    insetBlockEnd: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetInlineStart: "space.0"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $e5748c90ecffda4b$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, buttonType = _ref.buttonType, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $acw62.useRef)(null);
    var splitButtonContext = (0, $607799b9d68c2448$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $ltooA.fg)("platform-component-visual-refresh") ? "subtle" : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $3f80dbe144e57bfc$export$2e2bcd8739ae039)(localRef, autoFocus);
    return $e5748c90ecffda4b$var$_objectSpread({
        ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: [
            $e5748c90ecffda4b$var$buttonStyles,
            appearance === "default" && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $e5748c90ecffda4b$var$defaultRefreshedStyles : $e5748c90ecffda4b$var$defaultStyles),
            appearance === "default" && isInteractive && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $e5748c90ecffda4b$var$defaultInteractiveRefreshedStyles : $e5748c90ecffda4b$var$defaultInteractiveStyles),
            appearance === "primary" && $e5748c90ecffda4b$var$primaryStyles,
            appearance === "primary" && isInteractive && $e5748c90ecffda4b$var$primaryInteractiveStyles,
            appearance === "warning" && $e5748c90ecffda4b$var$warningStyles,
            appearance === "warning" && isInteractive && $e5748c90ecffda4b$var$warningInteractiveStyles,
            appearance === "danger" && $e5748c90ecffda4b$var$dangerStyles,
            appearance === "danger" && isInteractive && $e5748c90ecffda4b$var$dangerInteractiveStyles,
            appearance === "discovery" && $e5748c90ecffda4b$var$discoveryStyles,
            appearance === "discovery" && isInteractive && $e5748c90ecffda4b$var$discoveryInteractiveStyles,
            appearance === "subtle" && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $e5748c90ecffda4b$var$subtleRefreshedStyles : $e5748c90ecffda4b$var$subtleStyles),
            appearance === "subtle" && isInteractive && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $e5748c90ecffda4b$var$subtleInteractiveRefreshedStyles : $e5748c90ecffda4b$var$subtleInteractiveStyles),
            buttonType === "link" && $e5748c90ecffda4b$var$linkDefensiveStyles,
            isSelected && ((0, $ltooA.fg)("platform-component-visual-refresh") ? $e5748c90ecffda4b$var$selectedRefreshedStyles : $e5748c90ecffda4b$var$selectedStyles),
            isSelected && isSplitButton && $e5748c90ecffda4b$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $e5748c90ecffda4b$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "danger" && $e5748c90ecffda4b$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "warning" && $e5748c90ecffda4b$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "discovery" && $e5748c90ecffda4b$var$selectedDiscoveryStyles,
            isDisabled && $e5748c90ecffda4b$var$disabledStyles,
            isCircle && !isSplitButton && $e5748c90ecffda4b$var$circleStyles,
            spacing === "compact" && $e5748c90ecffda4b$var$spacingCompactStyles,
            hasIconBefore && $e5748c90ecffda4b$var$buttonIconBeforeStyles,
            hasIconAfter && $e5748c90ecffda4b$var$buttonIconAfterStyles,
            isIconButton && $e5748c90ecffda4b$var$iconButtonStyles,
            isIconButton && spacing === "compact" && $e5748c90ecffda4b$var$iconButtonCompactStyles,
            shouldFitContainer && $e5748c90ecffda4b$var$fullWidthStyles,
            isLoading && $e5748c90ecffda4b$var$loadingStyles,
            isSplitButton && $e5748c90ecffda4b$var$splitButtonStyles,
            isNavigationSplitButton && $e5748c90ecffda4b$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $607799b9d68c2448$export$4b86304b2c0d7e71).Provider, {
            value: undefined
        }, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
            as: "span",
            xcss: $e5748c90ecffda4b$var$loadingOverlayStyles
        }, (0, $791be1887d8efae6$export$2e2bcd8739ae039)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8568069ac023c6f7$export$2e2bcd8739ae039), {
            id: loadingLabelId
        }, (0, $b67192b4311b4214$export$d4c5499dc806c969))),
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $b67192b4311b4214$export$d4c5499dc806c969)) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $b7550bc4160ac1dd$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $e5748c90ecffda4b$export$2e2bcd8739ae039 = $e5748c90ecffda4b$var$useButtonBase;


/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $035cfa34802adc5a$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var baseProps = (0, $e5748c90ecffda4b$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfc470d833fdb959$export$2e2bcd8739ae039), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e81b74584a4f1554$export$2e2bcd8739ae039), {
            icon: iconBefore
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfc470d833fdb959$export$2e2bcd8739ae039), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfc470d833fdb959$export$2e2bcd8739ae039), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e81b74584a4f1554$export$2e2bcd8739ae039), {
            icon: iconAfter
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $035cfa34802adc5a$export$2e2bcd8739ae039 = $035cfa34802adc5a$var$useDefaultButton;


var $596fd22a12a3457e$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $596fd22a12a3457e$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $596fd22a12a3457e$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $596fd22a12a3457e$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $596fd22a12a3457e$var$_excluded2);
    var baseProps = (0, $035cfa34802adc5a$export$2e2bcd8739ae039)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a92da350b7429b4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        "aria-label": baseProps["aria-label"],
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$596fd22a12a3457e$var$Button.displayName = "Button";
var $596fd22a12a3457e$export$2e2bcd8739ae039 = $596fd22a12a3457e$var$Button;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


function $c5f50cf82d6ea085$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5f50cf82d6ea085$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5f50cf82d6ea085$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5f50cf82d6ea085$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c5f50cf82d6ea085$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $644f5cd0da7c3c67$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $a25ba612a14d7f71$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $a25ba612a14d7f71$export$1d27a74659855e44)(fn);
    var handler = (0, $acw62.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c5f50cf82d6ea085$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
/**
 * Character key codes which can be used in keyboard events.
 */ var $ee870615aeb9f56d$export$390330c10ff2b9a1 = "ArrowUp";
var $ee870615aeb9f56d$export$a80636c6f41931fe = "ArrowDown";
var $ee870615aeb9f56d$export$4af703091671bc = "Home";
var $ee870615aeb9f56d$export$e2bc30913faa5db7 = "End";
var $ee870615aeb9f56d$export$10f6869ed0a7d75b = "Tab";
var $ee870615aeb9f56d$export$8152f929a25a0ff4 = "Enter";
var $ee870615aeb9f56d$export$e51a3576c045c8d5 = "Space";
var $ee870615aeb9f56d$export$2bb790b9008907b4 = "Escape";


function $46d0f187c75ff716$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $ee870615aeb9f56d$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}



var $acw62 = parcelRequire("acw62");
function $28de818087a08ac5$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $acw62 = parcelRequire("acw62");

function $894603c2f42046e0$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $acw62.useContext)((0, $731880a3c24b37f3$export$5fbf4d7fae6cdc00));
    (0, $acw62.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}




var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $60c0a9468407f91d$export$3dbd3405086fec7b = $acw62.createContext();
var $60c0a9468407f91d$export$cbabb21c2529b130 = $acw62.createContext();
function $60c0a9468407f91d$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $acw62.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $acw62.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $acw62.createElement($60c0a9468407f91d$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $acw62.createElement($60c0a9468407f91d$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}



var $acw62 = parcelRequire("acw62");
var $85f0adf197ea687e$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $85f0adf197ea687e$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $85f0adf197ea687e$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $85f0adf197ea687e$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $85f0adf197ea687e$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $85f0adf197ea687e$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;



var $acw62 = parcelRequire("acw62");

var $aS1Zy = parcelRequire("aS1Zy");
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $77ddc6be16b1d7de$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
var $77ddc6be16b1d7de$var$hasMap = typeof Map === "function";
var $77ddc6be16b1d7de$var$hasSet = typeof Set === "function";
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$77ddc6be16b1d7de$exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $08cb017687258e89$var$EMPTY_MODIFIERS = [];
var $08cb017687258e89$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $08cb017687258e89$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aS1Zy.flushSync(function() {
                    setState({
                        styles: (0, $85f0adf197ea687e$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $85f0adf197ea687e$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($77ddc6be16b1d7de$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $85f0adf197ea687e$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $85f0adf197ea687e$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $288fbeb449f53487$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $253b3f1d15d57500$var$NOOP = function NOOP() {
    return void 0;
};
var $253b3f1d15d57500$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $253b3f1d15d57500$var$EMPTY_MODIFIERS = [];
function $253b3f1d15d57500$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $253b3f1d15d57500$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $acw62.useContext((0, $60c0a9468407f91d$export$3dbd3405086fec7b));
    var _React$useState = $acw62.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $acw62.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $acw62.useEffect(function() {
        (0, $85f0adf197ea687e$export$4bb192c7cacf928f)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $acw62.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $08cb017687258e89$export$f4d5bf230a36dd6e)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $acw62.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $253b3f1d15d57500$var$NOOP,
            update: update || $253b3f1d15d57500$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $85f0adf197ea687e$export$f52c55943429c8b6)(children)(childrenProps);
}



var $02Ztr = parcelRequire("02Ztr");
function $a983b1d5d4ece1eb$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $504e801fc3041bf3$var$viewportPadding = 5;
var $504e801fc3041bf3$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $504e801fc3041bf3$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $504e801fc3041bf3$var$defaultChildrenFn() {
    return null;
}
var $504e801fc3041bf3$var$defaultOffset = [
    0,
    8
];
function $504e801fc3041bf3$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $504e801fc3041bf3$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $504e801fc3041bf3$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $acw62.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $504e801fc3041bf3$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $a983b1d5d4ece1eb$export$6d8c2b45c99d6e3f)({
            viewportPadding: $504e801fc3041bf3$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($504e801fc3041bf3$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $253b3f1d15d57500$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}




/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $8fY35 = parcelRequire("8fY35");
var $cc7f79f757f95fd1$var$registrations = new Set();
var $cc7f79f757f95fd1$var$cleanupEndEventListeners = null;
function $cc7f79f757f95fd1$var$onDragStart() {
    if ($cc7f79f757f95fd1$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $cc7f79f757f95fd1$var$cleanupEndEventListeners = (0, $8fY35.bindAll)(window, [
        {
            type: "dragend",
            listener: $cc7f79f757f95fd1$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $cc7f79f757f95fd1$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $cc7f79f757f95fd1$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($cc7f79f757f95fd1$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $cc7f79f757f95fd1$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $cc7f79f757f95fd1$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $cc7f79f757f95fd1$var$cleanupEndEventListeners = null;
    var clone = Array.from($cc7f79f757f95fd1$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $cc7f79f757f95fd1$var$bindStartEvents() {
    return (0, $8fY35.bindAll)(window, [
        {
            type: "dragstart",
            listener: $cc7f79f757f95fd1$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $cc7f79f757f95fd1$var$onDragStart
        }
    ]);
}
var $cc7f79f757f95fd1$var$cleanupStartEventListeners = null;
function $cc7f79f757f95fd1$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$cc7f79f757f95fd1$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $cc7f79f757f95fd1$var$cleanupStartEventListeners = $cc7f79f757f95fd1$var$bindStartEvents();
    $cc7f79f757f95fd1$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $cc7f79f757f95fd1$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $cc7f79f757f95fd1$var$registrations.delete(registration);
        if ($cc7f79f757f95fd1$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $cc7f79f757f95fd1$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $cc7f79f757f95fd1$var$cleanupStartEventListeners = null;
        }
    };
}


var $27a36c6205a53923$var$delayId = null;
function $27a36c6205a53923$export$eaf678f6f93f5250() {
    if ($27a36c6205a53923$var$delayId != null) {
        window.clearTimeout($27a36c6205a53923$var$delayId);
        $27a36c6205a53923$var$delayId = null;
    }
}
function $27a36c6205a53923$export$5f4d6617421d489b(fn, delay) {
    $27a36c6205a53923$export$eaf678f6f93f5250();
    $27a36c6205a53923$var$delayId = window.setTimeout(function() {
        $27a36c6205a53923$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $a2aa532d7a4ab08a$var$active = null;
function $a2aa532d7a4ab08a$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($a2aa532d7a4ab08a$var$active && $a2aa532d7a4ab08a$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $27a36c6205a53923$export$eaf678f6f93f5250)();
            $a2aa532d7a4ab08a$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $27a36c6205a53923$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $27a36c6205a53923$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $27a36c6205a53923$export$5f4d6617421d489b)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($a2aa532d7a4ab08a$var$active && $a2aa532d7a4ab08a$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($a2aa532d7a4ab08a$var$active) {
            (0, $27a36c6205a53923$export$eaf678f6f93f5250)();
            $a2aa532d7a4ab08a$var$active.entry.hide({
                isImmediate: true
            });
            $a2aa532d7a4ab08a$var$active.entry.done();
            $a2aa532d7a4ab08a$var$active = null;
        }
        // this tooltip is now the active tooltip
        $a2aa532d7a4ab08a$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $27a36c6205a53923$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



function $dc296135ac3cf521$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $6d39885ac77caaba$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");

var $dnCk4 = parcelRequire("dnCk4");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

function $992814645ec028bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $992814645ec028bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $992814645ec028bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $992814645ec028bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $992814645ec028bf$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $992814645ec028bf$var$primitiveStyles = (0, $jjlaj.css)({
    zindex: "var(".concat($992814645ec028bf$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $992814645ec028bf$var$TooltipPrimitive = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $992814645ec028bf$var$_objectSpread($992814645ec028bf$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $992814645ec028bf$var$VAR_PRIMITIVE_ZINDEX, (0, $b7d36d3be7da66cd$export$7be255094ccdc533).tooltip()));
    return (0, $jjlaj.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $jjlaj.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $992814645ec028bf$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$992814645ec028bf$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $992814645ec028bf$export$2e2bcd8739ae039 = $992814645ec028bf$var$TooltipPrimitive;


function $5baad8c54c033fe2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5baad8c54c033fe2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5baad8c54c033fe2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5baad8c54c033fe2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5baad8c54c033fe2$var$baseStyles = null;
var $5baad8c54c033fe2$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $5baad8c54c033fe2$var$TooltipContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $acw62.createElement((0, $992814645ec028bf$export$2e2bcd8739ae039), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5zphJ.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $5baad8c54c033fe2$var$_objectSpread($5baad8c54c033fe2$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $cZGu3.default)("var(--ds-background-neutral-bold, ".concat((0, $dnCk4.N800), ")")),
            "--_ywovvi": (0, $cZGu3.default)("var(--ds-text-inverse, ".concat((0, $dnCk4.N0), ")"))
        })
    }, children);
});
$5baad8c54c033fe2$var$TooltipContainer.displayName = "TooltipContainer";
var $5baad8c54c033fe2$export$2e2bcd8739ae039 = $5baad8c54c033fe2$var$TooltipContainer;


function $d1f31c26db1ef639$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $6fa9833ed171567b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6fa9833ed171567b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6fa9833ed171567b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6fa9833ed171567b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6fa9833ed171567b$var$tooltipZIndex = (0, $b7d36d3be7da66cd$export$7be255094ccdc533).tooltip();
var $6fa9833ed171567b$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.0.4"
};
// Inverts motion direction
var $6fa9833ed171567b$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $6fa9833ed171567b$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $6fa9833ed171567b$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $5baad8c54c033fe2$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $c5f50cf82d6ea085$export$1a04351537078b55)($6fa9833ed171567b$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $6fa9833ed171567b$var$analyticsAttributes));
    var onHideHandler = (0, $c5f50cf82d6ea085$export$1a04351537078b55)($6fa9833ed171567b$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $6fa9833ed171567b$var$analyticsAttributes));
    var apiRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $acw62.useRef)(null);
    var containerRef = (0, $acw62.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $acw62.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $28de818087a08ac5$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $28de818087a08ac5$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $28de818087a08ac5$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $28de818087a08ac5$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $28de818087a08ac5$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $acw62.useRef)(false);
    var start = (0, $acw62.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $acw62.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $acw62.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        return (0, $cc7f79f757f95fd1$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $acw62.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $a2aa532d7a4ab08a$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $acw62.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $46d0f187c75ff716$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $acw62.useEffect)(function() {
        if (state === "hide") return 0, $d3997b4aab843580$export$2e2bcd8739ae039;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $acw62.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $d1f31c26db1ef639$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $acw62.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $d1f31c26db1ef639$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $acw62.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $acw62.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $acw62.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $acw62.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    (0, $894603c2f42046e0$export$469bb693f11edc7f)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $dc296135ac3cf521$export$2e2bcd8739ae039)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $acw62.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children($6fa9833ed171567b$var$_objectSpread($6fa9833ed171567b$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2167cf9ee39b2459$export$2e2bcd8739ae039), {
        zIndex: $6fa9833ed171567b$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $504e801fc3041bf3$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $6fa9833ed171567b$var$invertedDirection[$6fa9833ed171567b$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $183a833228617892$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c1a7c75e4c42bc2c$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $6fa9833ed171567b$var$_objectSpread($6fa9833ed171567b$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$6fa9833ed171567b$var$Tooltip.displayName = "Tooltip";
var $6fa9833ed171567b$export$2e2bcd8739ae039 = $6fa9833ed171567b$var$Tooltip;



var $acw62 = parcelRequire("acw62");




/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $03a01d289075afad$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var isCircle = shape === "circle";
    var baseProps = (0, $e5748c90ecffda4b$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfc470d833fdb959$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e81b74584a4f1554$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8568069ac023c6f7$export$2e2bcd8739ae039), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return baseProps;
};
var $03a01d289075afad$export$2e2bcd8739ae039 = $03a01d289075afad$var$useIconButton;


var $53997ce7dd1542b7$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $53997ce7dd1542b7$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $53997ce7dd1542b7$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $53997ce7dd1542b7$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $53997ce7dd1542b7$var$_excluded2);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $03a01d289075afad$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: "button",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fa9833ed171567b$export$2e2bcd8739ae039), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a92da350b7429b4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
                // Top level props
                "aria-labelledby": baseProps["aria-labelledby"],
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a92da350b7429b4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$53997ce7dd1542b7$var$IconButton.displayName = "IconButton";
var $53997ce7dd1542b7$export$2e2bcd8739ae039 = $53997ce7dd1542b7$var$IconButton;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $23756fdd73e76c31$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $23756fdd73e76c31$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $23756fdd73e76c31$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $23756fdd73e76c31$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $23756fdd73e76c31$var$_excluded2);
    var baseProps = (0, $035cfa34802adc5a$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: "link",
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11cad149381bd130$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        "aria-label": baseProps["aria-label"],
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? "link" : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
var $23756fdd73e76c31$var$WithRef = /*#__PURE__*/ (0, $acw62.forwardRef)($23756fdd73e76c31$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $23756fdd73e76c31$var$LinkButton = /*#__PURE__*/ (0, $acw62.memo)($23756fdd73e76c31$var$WithRef);
var $23756fdd73e76c31$export$2e2bcd8739ae039 = $23756fdd73e76c31$var$LinkButton;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");



var $6a586ba0f770e10c$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "href",
    "icon",
    "interactionName",
    "isDisabled",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip"
], $6a586ba0f770e10c$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $6a586ba0f770e10c$var$LinkIconButtonBase = function LinkIconButtonBase(_ref, ref) {
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, href = _ref.href, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $6a586ba0f770e10c$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(unsafeRest, $6a586ba0f770e10c$var$_excluded2);
    var baseProps = (0, $03a01d289075afad$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: "link",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fa9833ed171567b$export$2e2bcd8739ae039), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11cad149381bd130$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
                "aria-labelledby": baseProps["aria-labelledby"],
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture,
                href: baseProps.isDisabled ? undefined : href,
                role: baseProps.isDisabled ? "link" : undefined,
                "aria-disabled": baseProps.isDisabled === true ? true : undefined
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11cad149381bd130$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, saferRest, {
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? "link" : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
var $6a586ba0f770e10c$var$WithRef = /*#__PURE__*/ (0, $acw62.forwardRef)($6a586ba0f770e10c$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ var $6a586ba0f770e10c$var$LinkIconButton = /*#__PURE__*/ (0, $acw62.memo)($6a586ba0f770e10c$var$WithRef);
var $6a586ba0f770e10c$export$2e2bcd8739ae039 = $6a586ba0f770e10c$var$LinkIconButton;


/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");


/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $41YNz = parcelRequire("41YNz");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");



var $bv4qN = parcelRequire("bv4qN");





var $12HqF = parcelRequire("12HqF");


var $9c107440434aefdd$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $9c107440434aefdd$var$_excluded2 = [
    "className"
];
var $9c107440434aefdd$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi"
};
var $9c107440434aefdd$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $9c107440434aefdd$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $9c107440434aefdd$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? "(opens new window)" : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $9c107440434aefdd$var$_excluded);
    var interactionContext = (0, $acw62.useContext)((0, $12HqF.default));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    var onClick = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.2.2",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(htmlAttributes, $9c107440434aefdd$var$_excluded2);
    var RouterLink = (0, $5318d277c24f693e$export$2e2bcd8739ae039)();
    var isExternal = typeof href === "string" && $9c107440434aefdd$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $9c107440434aefdd$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(href) === "object";
    (0, $bv4qN.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $acw62.createElement((0, $551de9b6eb78de0b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $9b698034c8c53dd8$export$a274e22fb40f762e)($9c107440434aefdd$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $acw62.createElement((0, $8568069ac023c6f7$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $9c107440434aefdd$var$Anchor = /*#__PURE__*/ (0, $acw62.forwardRef)($9c107440434aefdd$var$AnchorNoRef);
var $9c107440434aefdd$export$2e2bcd8739ae039 = $9c107440434aefdd$var$Anchor;





var $acw62 = parcelRequire("acw62");
var $96640c64143ff394$export$8ab756e06c5d9001 = (0, $acw62.forwardRef);


var $782ccf10f797bd40$var$_excluded = [
    "style",
    "xcss",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd"
], $782ccf10f797bd40$var$_excluded2 = [
    "appearance",
    "shape",
    "isSelected",
    "isDisabled"
], $782ccf10f797bd40$var$_excluded3 = [
    "appearance",
    "shape",
    "isSelected",
    "isDisabled"
], $782ccf10f797bd40$var$_excluded4 = [
    "iconBefore",
    "children"
], $782ccf10f797bd40$var$_excluded5 = [
    "iconBefore",
    "children"
], $782ccf10f797bd40$var$_excluded6 = [
    "icon",
    "label",
    "tooltip"
], $782ccf10f797bd40$var$_excluded7 = [
    "icon",
    "label",
    "tooltip"
];
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ /**
 * Returns the spread props to pass through to underlying primitive components.
 *
 * It removes the props which apply styles.
 */ function $782ccf10f797bd40$var$getPrimitiveSpreadProps(_ref) {
    var style = _ref.style, xcss = _ref.xcss, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $782ccf10f797bd40$var$_excluded);
    return props;
}
var $782ccf10f797bd40$export$b93b81aa41a8061a = "--ds-top-bar-button-background";
var $782ccf10f797bd40$export$96a2312c81489aa1 = "--ds-top-bar-button-background-hovered";
var $782ccf10f797bd40$export$9db7a918ddfed23e = "--ds-top-bar-button-background-pressed";
var $782ccf10f797bd40$export$2b00bded80635cbb = "--ds-top-bar-button-border";
var $782ccf10f797bd40$export$eca746d7c1a9cd6e = "--ds-top-bar-button-primary-text";
var $782ccf10f797bd40$export$2c2bc298cddb8aca = "--ds-top-bar-button-primary-background";
var $782ccf10f797bd40$export$6b28e650669cd3c7 = "--ds-top-bar-button-primary-background-hovered";
var $782ccf10f797bd40$export$1656be06aad539b9 = "--ds-top-bar-button-primary-background-pressed";
var $782ccf10f797bd40$export$c26a897d419ef487 = "--ds-top-bar-button-selected-text";
var $782ccf10f797bd40$export$4e50e625ccffdb13 = "--ds-top-bar-button-selected-background";
var $782ccf10f797bd40$export$55c84c90f36bda4d = "--ds-top-bar-button-selected-background-hovered";
var $782ccf10f797bd40$export$c5c0213472126c08 = "--ds-top-bar-button-selected-background-pressed";
var $782ccf10f797bd40$export$22928007ff541429 = "--ds-top-bar-button-selected-border";
var $782ccf10f797bd40$export$787ad93d0f2276af = "--ds-top-bar-button-disabled-text";
var $782ccf10f797bd40$export$5e774f44b77335d6 = "--ds-top-bar-button-disabled-background";
var $782ccf10f797bd40$var$styles = {
    root: "_zulp12x7 _11c82smr _2rkosqtm _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
var $782ccf10f797bd40$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
var $782ccf10f797bd40$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
/**
 * Props shared by `ThemedPressable` and `ThemedAnchor`
 */ /**
 * Intentionally an almost-duplicate of `ThemedAnchor` - make sure to update both.
 *
 * See `ThemedAnchor` for more context.
 */ var $782ccf10f797bd40$var$ThemedPressable = /*#__PURE__*/ (0, $acw62.forwardRef)(function ThemedPressable(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? "default" : _ref2$shape, isSelected = _ref2.isSelected, isDisabled = _ref2.isDisabled, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $782ccf10f797bd40$var$_excluded2);
    var hasBorder = appearance === "default" || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c5f2789211abe33c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, $782ccf10f797bd40$var$getPrimitiveSpreadProps(props), {
        ref: ref,
        type: "button",
        xcss: (0, $9b698034c8c53dd8$export$a274e22fb40f762e)($782ccf10f797bd40$var$styles.root, $782ccf10f797bd40$var$shapeStyles[shape], hasBorder && $782ccf10f797bd40$var$styles.border, $782ccf10f797bd40$var$appearanceStyles[appearance], isSelected && $782ccf10f797bd40$var$styles.selected, isDisabled && $782ccf10f797bd40$var$styles.disabled),
        isDisabled: isDisabled
    }));
});
/**
 * Intentionally an almost-duplicate of `ThemedPressable` - make sure to update both.
 *
 * More 'clever' solutions were tried but I couldn't get them working in an acceptable state.
 *
 * Polymorphism had many typing issues and required sacrificing type safety.
 *
 * Render props had problems passing down styles through `xcss` to the `children` function.
 */ var $782ccf10f797bd40$var$ThemedAnchor = (0, $96640c64143ff394$export$8ab756e06c5d9001)(function ThemedAnchor(_ref3, ref) {
    var _ref3$appearance = _ref3.appearance, appearance = _ref3$appearance === void 0 ? "default" : _ref3$appearance, _ref3$shape = _ref3.shape, shape = _ref3$shape === void 0 ? "default" : _ref3$shape, isSelected = _ref3.isSelected, isDisabled = _ref3.isDisabled, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref3, $782ccf10f797bd40$var$_excluded3);
    var hasBorder = appearance === "default" || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c107440434aefdd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, $782ccf10f797bd40$var$getPrimitiveSpreadProps(props), {
        ref: ref,
        xcss: (0, $9b698034c8c53dd8$export$a274e22fb40f762e)($782ccf10f797bd40$var$styles.root, $782ccf10f797bd40$var$shapeStyles[shape], hasBorder && $782ccf10f797bd40$var$styles.border, $782ccf10f797bd40$var$appearanceStyles[appearance], isSelected && $782ccf10f797bd40$var$styles.selected, isDisabled && $782ccf10f797bd40$var$styles.disabled)
    }));
});
var $782ccf10f797bd40$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
var $782ccf10f797bd40$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $acw62.forwardRef)(function ThemedButton(_ref4, ref) {
    var IconBefore = _ref4.iconBefore, children = _ref4.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref4, $782ccf10f797bd40$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($782ccf10f797bd40$var$ThemedPressable, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        ref: ref
    }), IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $5zphJ.default)([
            $782ccf10f797bd40$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IconBefore, {
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $5zphJ.default)([
            $782ccf10f797bd40$var$textButtonStyles.text
        ])
    }, children));
});
var $782ccf10f797bd40$export$b0b5aeed52623827 = (0, $96640c64143ff394$export$8ab756e06c5d9001)(function ThemedLinkButton(_ref5, ref) {
    var IconBefore = _ref5.iconBefore, children = _ref5.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref5, $782ccf10f797bd40$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($782ccf10f797bd40$var$ThemedAnchor, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        ref: ref
    }), IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $5zphJ.default)([
            $782ccf10f797bd40$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IconBefore, {
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $5zphJ.default)([
            $782ccf10f797bd40$var$textButtonStyles.text
        ])
    }, children));
});
var $782ccf10f797bd40$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $acw62.forwardRef)(function ThemedIconButton(_ref6, ref) {
    var _tooltip$content;
    var Icon = _ref6.icon, label = _ref6.label, tooltip = _ref6.tooltip, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref6, $782ccf10f797bd40$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fa9833ed171567b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, tooltip, {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label
    }), function(triggerProps) {
        return(/*#__PURE__*/ /**
       * The `aria-describedby` from `triggerProps` is intentionally not passed down,
       * because it would cause double announcements with the `VisuallyHidden` label.
       *
       * The `@atlaskit/button` IconButton uses the same approach.
       */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($782ccf10f797bd40$var$ThemedPressable, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
            shape: "square",
            ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
                ref,
                triggerProps.ref
            ]),
            onClick: function onClick(event, analyticsEvent) {
                var _props$onClick, _triggerProps$onClick;
                (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _props$onMouseOver;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_props$onMouseOver = props.onMouseOver) === null || _props$onMouseOver === void 0 || _props$onMouseOver.call(props, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _props$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_props$onMouseOut = props.onMouseOut) === null || _props$onMouseOut === void 0 || _props$onMouseOut.call(props, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _props$onMouseMove;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_props$onMouseMove = props.onMouseMove) === null || _props$onMouseMove === void 0 || _props$onMouseMove.call(props, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _props$onMouseDown;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_props$onMouseDown = props.onMouseDown) === null || _props$onMouseDown === void 0 || _props$onMouseDown.call(props, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _props$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _props$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, e);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8568069ac023c6f7$export$2e2bcd8739ae039), null, label)));
    });
});
var $782ccf10f797bd40$export$a1ab08e79d264ec8 = (0, $96640c64143ff394$export$8ab756e06c5d9001)(function ThemedLinkIconButton(_ref7, ref) {
    var _tooltip$content2;
    var Icon = _ref7.icon, label = _ref7.label, tooltip = _ref7.tooltip, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref7, $782ccf10f797bd40$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fa9833ed171567b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, tooltip, {
        content: (_tooltip$content2 = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content2 !== void 0 ? _tooltip$content2 : label
    }), function(triggerProps) {
        return(/*#__PURE__*/ /**
       * The `aria-describedby` from `triggerProps` is intentionally not passed down,
       * because it would cause double announcements with the `VisuallyHidden` label.
       *
       * The `@atlaskit/button` IconButton uses the same approach.
       */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($782ccf10f797bd40$var$ThemedAnchor, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
            shape: "square",
            ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
                ref,
                triggerProps.ref
            ]),
            onClick: function onClick(event, analyticsEvent) {
                var _props$onClick2, _triggerProps$onClick2;
                (_props$onClick2 = props.onClick) === null || _props$onClick2 === void 0 || _props$onClick2.call(props, event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick2 = triggerProps.onClick) === null || _triggerProps$onClick2 === void 0 || _triggerProps$onClick2.call(triggerProps, event);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse5, _props$onMouseOver2;
                (_triggerProps$onMouse5 = triggerProps.onMouseOver) === null || _triggerProps$onMouse5 === void 0 || _triggerProps$onMouse5.call(triggerProps, e);
                (_props$onMouseOver2 = props.onMouseOver) === null || _props$onMouseOver2 === void 0 || _props$onMouseOver2.call(props, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse6, _props$onMouseOut2;
                (_triggerProps$onMouse6 = triggerProps.onMouseOut) === null || _triggerProps$onMouse6 === void 0 || _triggerProps$onMouse6.call(triggerProps, e);
                (_props$onMouseOut2 = props.onMouseOut) === null || _props$onMouseOut2 === void 0 || _props$onMouseOut2.call(props, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse7, _props$onMouseMove2;
                (_triggerProps$onMouse7 = triggerProps.onMouseMove) === null || _triggerProps$onMouse7 === void 0 || _triggerProps$onMouse7.call(triggerProps, e);
                (_props$onMouseMove2 = props.onMouseMove) === null || _props$onMouseMove2 === void 0 || _props$onMouseMove2.call(props, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse8, _props$onMouseDown2;
                (_triggerProps$onMouse8 = triggerProps.onMouseDown) === null || _triggerProps$onMouse8 === void 0 || _triggerProps$onMouse8.call(triggerProps, e);
                (_props$onMouseDown2 = props.onMouseDown) === null || _props$onMouseDown2 === void 0 || _props$onMouseDown2.call(props, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus2, _props$onFocus2;
                (_triggerProps$onFocus2 = triggerProps.onFocus) === null || _triggerProps$onFocus2 === void 0 || _triggerProps$onFocus2.call(triggerProps, e);
                (_props$onFocus2 = props.onFocus) === null || _props$onFocus2 === void 0 || _props$onFocus2.call(props, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur2, _props$onBlur2;
                (_triggerProps$onBlur2 = triggerProps.onBlur) === null || _triggerProps$onBlur2 === void 0 || _triggerProps$onBlur2.call(triggerProps, e);
                (_props$onBlur2 = props.onBlur) === null || _props$onBlur2 === void 0 || _props$onBlur2.call(props, e);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8568069ac023c6f7$export$2e2bcd8739ae039), null, label)));
    });
});



var $acw62 = parcelRequire("acw62");
var $2900aa2180cfcb6e$export$d158fa15757a1890 = /*#__PURE__*/ (0, $acw62.createContext)(false);
function $2900aa2180cfcb6e$export$abfcaeeca4ae7a55() {
    return (0, $acw62.useContext)($2900aa2180cfcb6e$export$d158fa15757a1890);
}


// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $1b95d5cf1ea992c9$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $2900aa2180cfcb6e$export$abfcaeeca4ae7a55)();
    var Component = hasCustomTheme ? (0, $782ccf10f797bd40$export$d9c2d067feb61447) : (0, $53997ce7dd1542b7$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $1b95d5cf1ea992c9$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $2900aa2180cfcb6e$export$abfcaeeca4ae7a55)();
    var Component = hasCustomTheme ? (0, $782ccf10f797bd40$export$a1ab08e79d264ec8) : (0, $6a586ba0f770e10c$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $1b95d5cf1ea992c9$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $2900aa2180cfcb6e$export$abfcaeeca4ae7a55)();
    var Component = hasCustomTheme ? (0, $782ccf10f797bd40$export$f67fb575035cc7d0) : (0, $596fd22a12a3457e$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $1b95d5cf1ea992c9$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $2900aa2180cfcb6e$export$abfcaeeca4ae7a55)();
    var Component = hasCustomTheme ? (0, $782ccf10f797bd40$export$b0b5aeed52623827) : (0, $23756fdd73e76c31$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, props));
});





var $ec5d9fb83dd33f59$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
var $ec5d9fb83dd33f59$var$silentIconStyles = null;
var $ec5d9fb83dd33f59$export$8bd77667631fec25 = function SideNavToggleButton(_ref) {
    var _ref$defaultCollapsed = _ref.defaultCollapsed, defaultCollapsed = _ref$defaultCollapsed === void 0 ? false : _ref$defaultCollapsed, expandLabel = _ref.expandLabel, collapseLabel = _ref.collapseLabel, testId = _ref.testId, interactionName = _ref.interactionName, onClick = _ref.onClick;
    var _useSideNavVisibility = (0, $4e479c9241965de2$export$4a602ad7e09bdb2c)({
        defaultCollapsed: defaultCollapsed
    }), isSideNavExpandedOnDesktop = _useSideNavVisibility.isExpandedOnDesktop, isSideNavExpandedOnMobile = _useSideNavVisibility.isExpandedOnMobile;
    var _useState = (0, $acw62.useState)(!defaultCollapsed), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSideNavExpanded = _useState2[0], setIsSideNavExpanded = _useState2[1];
    var ref = (0, $acw62.useContext)((0, $5cf9c20981129cc0$export$fb8fa9a80240785e));
    (0, $acw62.useEffect)(function() {
        var _window$matchMedia = window.matchMedia("(min-width: 64rem)"), matches = _window$matchMedia.matches;
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $acw62.useEffect)(function() {
        // When screen size changes, ensure we use the correct visibility state
        var mediaQueryList = window.matchMedia("(min-width: 64rem)");
        return (0, $8fY35.bind)(mediaQueryList, {
            type: "change",
            listener: function listener() {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    var toggleVisibility = (0, $4802f153fd426531$export$477ee35601a0a8ce)();
    var handleClick = (0, $acw62.useCallback)(function(event, analyticsEvent) {
        onClick === null || onClick === void 0 || onClick(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
    }, [
        onClick,
        toggleVisibility,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ var icon = function icon(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $5zphJ.default)([
                "_1e0c1bgi _lcxvglyw"
            ])
        }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e451edc7bf29d1ff$exports))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($97e1822274bbe635$exports))), props));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b95d5cf1ea992c9$export$c25acd513dcc8062), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: ref,
        tooltip: $ec5d9fb83dd33f59$var$toggleButtonTooltipOptions
    });
};

/* top-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $ltooA = parcelRequire("ltooA");



var $acw62 = parcelRequire("acw62");

var $g5Zhu = parcelRequire("g5Zhu");
/* nav-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");


var $943a9081db4aa8b0$export$24328117f1132113 = "--ds-top-bar-logo-icon";
var $943a9081db4aa8b0$export$91b0830f8f4ab279 = "--ds-top-bar-logo-text";
var $943a9081db4aa8b0$var$navLogoStyles = {
    root: "_2rkoiti9 _1e0c1txw _4cvr1h6o _4t3izwfg",
    icon: "_18zr1b66 _1e0c1txw _p12f1tcg _vchh1ntv _10y4glyw",
    logo: "_18zru2gc _1e0cglyw _p12fnklw _vchh1ntv _10y41txw",
    imageContainer: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51"
};
var $943a9081db4aa8b0$export$b6394419753329e = function NavLogo(_ref) {
    var href = _ref.href, logo = _ref.logo, icon = _ref.icon, onClick = _ref.onClick, label = _ref.label;
    var ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        var _img$parentElement, _img$parentElement2;
        var img, hasExpectedStructure, isOnlyChild;
        return;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11cad149381bd130$export$2e2bcd8739ae039), {
        ref: ref,
        "aria-label": label,
        href: href,
        xcss: $943a9081db4aa8b0$var$navLogoStyles.root,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            $943a9081db4aa8b0$var$navLogoStyles.imageContainer,
            $943a9081db4aa8b0$var$navLogoStyles.icon
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($943a9081db4aa8b0$var$NavLogoRenderer, {
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            $943a9081db4aa8b0$var$navLogoStyles.imageContainer,
            $943a9081db4aa8b0$var$navLogoStyles.logo
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($943a9081db4aa8b0$var$NavLogoRenderer, {
        logoOrIcon: logo
    })));
};
function $943a9081db4aa8b0$var$NavLogoRenderer(_ref2) {
    var LogoOrIcon = _ref2.logoOrIcon;
    var hasCustomTheme = (0, $2900aa2180cfcb6e$export$abfcaeeca4ae7a55)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LogoOrIcon, {
        size: "small",
        label: "",
        iconColor: "var(".concat($943a9081db4aa8b0$export$24328117f1132113, ")"),
        textColor: "var(".concat($943a9081db4aa8b0$export$91b0830f8f4ab279, ")")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}



/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $792e1eda59c80cbc$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $792e1eda59c80cbc$var$relativeLuminanceW3C(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    /**
   * Normalized sRGB - each channel is between 0 and 1
   */ var normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
   * linear RGB - the gamma correction of sRGB is removed and
   * the channels correspond directly to subpixel intensity
   */ var linear = {
        r: $792e1eda59c80cbc$var$linearizeRGBChannel(normal.r),
        g: $792e1eda59c80cbc$var$linearizeRGBChannel(normal.g),
        b: $792e1eda59c80cbc$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    var L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ var $792e1eda59c80cbc$var$flipLuminance = 0.179129;
function $792e1eda59c80cbc$export$44af652f4cca9039(color) {
    return $792e1eda59c80cbc$var$relativeLuminanceW3C(color) >= $792e1eda59c80cbc$var$flipLuminance;
}
function $792e1eda59c80cbc$export$5573a5bab3e074b5(backgroundColor) {
    if ($792e1eda59c80cbc$var$relativeLuminanceW3C(backgroundColor) >= $792e1eda59c80cbc$var$flipLuminance) return "light";
    return "dark";
}
var $792e1eda59c80cbc$var$textColor = {
    light: {
        hex: "#000",
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: "#FFF",
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $792e1eda59c80cbc$export$5357fe757c335c0d(backgroundColor) {
    var colorMode = $792e1eda59c80cbc$export$5573a5bab3e074b5(backgroundColor);
    return $792e1eda59c80cbc$var$textColor[colorMode];
}
function $792e1eda59c80cbc$export$e5e64c30bee1469b(_ref2) {
    var background = _ref2.background, foreground = _ref2.foreground;
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}


// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
var $55cfd2419315e3a2$var$isValidHex = function isValidHex(hex) {
    return(// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex));
};
function $55cfd2419315e3a2$export$103711ef09c6edec(color) {
    if (!$55cfd2419315e3a2$var$isValidHex(color)) return null;
    var channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}


/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ var $6de152d0983fec14$export$eaad8caa32d2521d = {
    "DarkNeutral-100": "#111213",
    "DarkNeutral-100A": "#01040475",
    DarkNeutral0: "#18191A",
    DarkNeutral100: "#1F1F21",
    DarkNeutral100A: "#BDBDBD0A",
    DarkNeutral200: "#242528",
    DarkNeutral200A: "#CECED912",
    DarkNeutral250: "#2B2C2F",
    DarkNeutral250A: "#D9DAE71A",
    DarkNeutral300: "#303134",
    DarkNeutral300A: "#E3E4F21F",
    DarkNeutral350: "#3D3F43",
    DarkNeutral350A: "#E8EDFD2E",
    DarkNeutral400: "#4B4D51",
    DarkNeutral400A: "#E5E9F640",
    DarkNeutral500: "#63666B",
    DarkNeutral500A: "#E9F0FB5C",
    DarkNeutral600: "#7E8188",
    DarkNeutral700: "#96999E",
    DarkNeutral800: "#A9ABAF",
    DarkNeutral900: "#BFC1C4",
    DarkNeutral1000: "#CECFD2",
    DarkNeutral1100: "#E2E3E4",
    Neutral0: "#FFFFFF",
    Neutral100: "#F8F8F8",
    Neutral100A: "#17171708",
    Neutral200: "#F0F1F2",
    Neutral200A: "#0515240F",
    Neutral300: "#DDDEE1",
    Neutral300A: "#0B120E24",
    Neutral400: "#B7B9BE",
    Neutral400A: "#080F214A",
    Neutral500: "#8C8F97",
    Neutral500A: "#050C1F75",
    Neutral600: "#7D818A",
    Neutral700: "#6B6E76",
    Neutral800: "#505258",
    Neutral900: "#3B3D42",
    Neutral1000: "#292A2E",
    Neutral1100: "#1E1F21"
};
var $6de152d0983fec14$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};




var $6afc0b54cb9cb1f9$export$ae6fbf5ba3a7a784 = "--ds-top-bar-search-border";
var $6afc0b54cb9cb1f9$export$ee42b8430f4c19bd = "--ds-top-bar-search-border-focused";
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ var $6afc0b54cb9cb1f9$var$legacySearchTheme = {
    default: {
        backgroundColor: "transparent",
        color: "currentColor",
        borderColor: "var(".concat($6afc0b54cb9cb1f9$export$ae6fbf5ba3a7a784, ")")
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: "var(".concat($6afc0b54cb9cb1f9$export$ee42b8430f4c19bd, ")"),
        boxShadow: "inset 0px 0px 0px 1px var(".concat($6afc0b54cb9cb1f9$export$ee42b8430f4c19bd, ")")
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: "var(".concat((0, $782ccf10f797bd40$export$96a2312c81489aa1), ")")
    }
};
function $6afc0b54cb9cb1f9$export$18a29b1ed2212823() {
    var hasCustomTheme = (0, $2900aa2180cfcb6e$export$abfcaeeca4ae7a55)();
    if (hasCustomTheme) return $6afc0b54cb9cb1f9$var$legacySearchTheme;
    return undefined;
}


function $ebe61f9ef3a387c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ebe61f9ef3a387c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ebe61f9ef3a387c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ebe61f9ef3a387c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Expects colors to be passed as `RGB` objects.
 *
 * Allows `string` for hex strings only, for backwards compatibility.
 * This will likely be removed in the future.
 *
 * Allows `null` for ergonomic reasons, because our color parsing utilities can return
 * `null` if they cannot parse a color string.
 */ function $ebe61f9ef3a387c2$var$toRGBString(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}
function $ebe61f9ef3a387c2$var$toRGBAString(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b, a = _ref2.a;
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
var $ebe61f9ef3a387c2$var$buttonStyles = {
    light: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $782ccf10f797bd40$export$b93b81aa41a8061a), "transparent"), (0, $782ccf10f797bd40$export$96a2312c81489aa1), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral200A), (0, $782ccf10f797bd40$export$9db7a918ddfed23e), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral300A), (0, $782ccf10f797bd40$export$2b00bded80635cbb), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral300A), (0, $782ccf10f797bd40$export$4e50e625ccffdb13), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral300A), (0, $782ccf10f797bd40$export$55c84c90f36bda4d), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral400A), (0, $782ccf10f797bd40$export$c5c0213472126c08), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral500A), (0, $782ccf10f797bd40$export$787ad93d0f2276af), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral400A), (0, $782ccf10f797bd40$export$5e774f44b77335d6), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral100A),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $782ccf10f797bd40$export$b93b81aa41a8061a), "transparent"), (0, $782ccf10f797bd40$export$96a2312c81489aa1), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral200A), (0, $782ccf10f797bd40$export$9db7a918ddfed23e), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral300A), (0, $782ccf10f797bd40$export$2b00bded80635cbb), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral300A), (0, $782ccf10f797bd40$export$4e50e625ccffdb13), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral300A), (0, $782ccf10f797bd40$export$55c84c90f36bda4d), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral400A), (0, $782ccf10f797bd40$export$c5c0213472126c08), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral500A), (0, $782ccf10f797bd40$export$787ad93d0f2276af), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral400A), (0, $782ccf10f797bd40$export$5e774f44b77335d6), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral100A)
};
var $ebe61f9ef3a387c2$var$logoStyles = {
    light: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $943a9081db4aa8b0$export$24328117f1132113), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral0), (0, $943a9081db4aa8b0$export$91b0830f8f4ab279), (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral0),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $943a9081db4aa8b0$export$24328117f1132113), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral0), (0, $943a9081db4aa8b0$export$91b0830f8f4ab279), (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral0)
};
function $ebe61f9ef3a387c2$export$3986d75fe2da3239(_ref3) {
    var backgroundColor = _ref3.backgroundColor, highlightColor = _ref3.highlightColor;
    var backgroundRgb = typeof backgroundColor === "string" ? (0, $55cfd2419315e3a2$export$103711ef09c6edec)(backgroundColor) : backgroundColor;
    var highlightRgb = typeof highlightColor === "string" ? (0, $55cfd2419315e3a2$export$103711ef09c6edec)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    var textColor = (0, $792e1eda59c80cbc$export$5357fe757c335c0d)(backgroundRgb);
    var colorMode = (0, $792e1eda59c80cbc$export$5573a5bab3e074b5)(backgroundRgb);
    var highlightTextColor = (0, $792e1eda59c80cbc$export$5357fe757c335c0d)(highlightRgb);
    return $ebe61f9ef3a387c2$var$_objectSpread($ebe61f9ef3a387c2$var$_objectSpread($ebe61f9ef3a387c2$var$_objectSpread($ebe61f9ef3a387c2$var$_objectSpread({
        backgroundColor: $ebe61f9ef3a387c2$var$toRGBString(backgroundRgb),
        color: textColor.hex
    }, $ebe61f9ef3a387c2$var$buttonStyles[colorMode]), $ebe61f9ef3a387c2$var$logoStyles[colorMode]), $ebe61f9ef3a387c2$var$getSelectedStyles({
        backgroundColor: backgroundRgb,
        colorMode: colorMode
    })), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $6afc0b54cb9cb1f9$export$ae6fbf5ba3a7a784), $ebe61f9ef3a387c2$var$toRGBAString($ebe61f9ef3a387c2$var$_objectSpread($ebe61f9ef3a387c2$var$_objectSpread({}, textColor.rgb), {}, {
        a: 0.5
    }))), (0, $6afc0b54cb9cb1f9$export$ee42b8430f4c19bd), $ebe61f9ef3a387c2$var$toRGBAString($ebe61f9ef3a387c2$var$_objectSpread($ebe61f9ef3a387c2$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $782ccf10f797bd40$export$2c2bc298cddb8aca), $ebe61f9ef3a387c2$var$toRGBString(highlightRgb)), (0, $782ccf10f797bd40$export$6b28e650669cd3c7), $ebe61f9ef3a387c2$var$toRGBAString($ebe61f9ef3a387c2$var$_objectSpread($ebe61f9ef3a387c2$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $782ccf10f797bd40$export$1656be06aad539b9), $ebe61f9ef3a387c2$var$toRGBAString($ebe61f9ef3a387c2$var$_objectSpread($ebe61f9ef3a387c2$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.65
    }))), (0, $782ccf10f797bd40$export$eca746d7c1a9cd6e), highlightTextColor.hex));
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ var $ebe61f9ef3a387c2$var$selectedBackgroundRGBA = {
    light: (0, $6de152d0983fec14$export$c9b84419dae66a82).Neutral300A,
    dark: (0, $6de152d0983fec14$export$c9b84419dae66a82).DarkNeutral300A
};
function $ebe61f9ef3a387c2$var$getSelectedStyles(_ref4) {
    var backgroundColor = _ref4.backgroundColor, colorMode = _ref4.colorMode;
    /**
   * The background color of the selected button in its default state.
   *
   * We are referring to this as a foreground color because it is semi-transparent,
   * so is not the actual color displayed when the button is on top of a background color.
   */ var foregroundColor = $ebe61f9ef3a387c2$var$selectedBackgroundRGBA[colorMode];
    /**
   * The blended color seen when the selected background is over the top bar.
   */ var blendedBackground = (0, $792e1eda59c80cbc$export$e5e64c30bee1469b)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $782ccf10f797bd40$export$c26a897d419ef487), (0, $792e1eda59c80cbc$export$5357fe757c335c0d)(blendedBackground).hex), (0, $782ccf10f797bd40$export$22928007ff541429), (0, $792e1eda59c80cbc$export$44af652f4cca9039)(blendedBackground) ? (0, $6de152d0983fec14$export$eaad8caa32d2521d).Neutral1100 : (0, $6de152d0983fec14$export$eaad8caa32d2521d).DarkNeutral1100);
}


function $a5c73e10b8941286$export$c0c5f5b297b77726(theme) {
    var value = (0, $acw62.useMemo)(function() {
        if (!(theme !== null && theme !== void 0 && theme.backgroundColor) || !(theme !== null && theme !== void 0 && theme.highlightColor)) return {
            isEnabled: false
        };
        /**
     * Re-creating the `theme` object from it's pieces.
     *
     * _Technically_ we could just use `theme`, but that would involve an eslint opt out
     * as we would be leveraging a value (`theme`) not in the dependency array.
     *
     * The current approach is the most correct™️ and avoids foot guns.
     * We are only using values in the effect that are defined in the dependency array 🙌
     */ var value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        var style = (0, $ebe61f9ef3a387c2$export$3986d75fe2da3239)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme === null || theme === void 0 ? void 0 : theme.backgroundColor,
        theme === null || theme === void 0 ? void 0 : theme.highlightColor
    ]);
    return value;
}






var $1450e52c0cd780da$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
};
function $1450e52c0cd780da$export$c4e96258f3b6511(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$UNSAFE_height = _ref.UNSAFE_height, UNSAFE_height = _ref$UNSAFE_height === void 0 ? 48 : _ref$UNSAFE_height, _ref$label = _ref.label, label = _ref$label === void 0 ? "Top Bar" : _ref$label, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? label : _ref$skipLinkLabel, testId = _ref.testId, id = _ref.id, UNSAFE_theme = _ref.UNSAFE_theme;
    var dangerouslyHoistSlotSizes = (0, $acw62.useContext)((0, $8895f9558135593b$export$66e2c1a0115af861));
    var UID = (0, $666273d20d8c70ce$export$86433d4fd18455f4)();
    var CID = id ? id : UID;
    (0, $03015978bbe1a3c1$export$89d9323301efc7d6)(CID, skipLinkLabel);
    var customTheme = (0, $a5c73e10b8941286$export$c0c5f5b297b77726)(UNSAFE_theme);
    return /*#__PURE__*/ $acw62.createElement((0, $2900aa2180cfcb6e$export$d158fa15757a1890).Provider, {
        value: customTheme.isEnabled
    }, /*#__PURE__*/ $acw62.createElement("header", {
        id: CID,
        "data-layout-slot": true,
        className: (0, $5zphJ.default)([
            $1450e52c0cd780da$var$styles.root,
            (0, $ltooA.fg)("platform_design_system_nav4_top_nav_columns") ? $1450e52c0cd780da$var$styles.newLayoutStyles : $1450e52c0cd780da$var$styles.oldLayoutStyles,
            xcss
        ]),
        "data-testid": testId,
        style: customTheme.isEnabled ? customTheme.style : undefined
    }, /*#__PURE__*/ $acw62.createElement((0, $daa2a2a305813e84$export$cfa3cd08d675e56e), {
        variableName: (0, $ba31aa5af7994f57$export$a96e934b2a1eeee),
        value: UNSAFE_height
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $acw62.createElement((0, $daa2a2a305813e84$export$9f45a1325e3cdfb8), {
        variableName: (0, $ba31aa5af7994f57$export$f4afb213f937404c),
        value: UNSAFE_height
    }), children));
}

/* user-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $5fc7b62a530a88f6$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);


var $bb892e43b35db19d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb6bef909769872b46b1e0328cacf596>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($bb892e43b35db19d$exports, "__esModule", {
    value: true
});
$bb892e43b35db19d$exports.default = void 0;

var $bb892e43b35db19d$var$_react = $bb892e43b35db19d$var$_interopRequireDefault((parcelRequire("acw62")));

var $bb892e43b35db19d$var$_baseNew = $bb892e43b35db19d$var$_interopRequireDefault((parcelRequire("fqFky")));
function $bb892e43b35db19d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb892e43b35db19d$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $bb892e43b35db19d$var$_react.default.createElement($bb892e43b35db19d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$bb892e43b35db19d$var$ShowMoreHorizontalIcon.displayName = "ShowMoreHorizontalIcon";
var $bb892e43b35db19d$var$_default = $bb892e43b35db19d$exports.default = $bb892e43b35db19d$var$ShowMoreHorizontalIcon;



var $ltooA = parcelRequire("ltooA");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");
var $8fe0ce44053a7d1f$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $8fe0ce44053a7d1f$export$48b383b280e20440 = /*#__PURE__*/ (0, $acw62.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $d3997b4aab843580$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $8fe0ce44053a7d1f$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $acw62.useContext)($8fe0ce44053a7d1f$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (!(0, $ltooA.fg)("plan_timeline_layering_wrapper")) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    (0, $acw62.useEffect)(function() {
        if ((0, $ltooA.fg)("plan_timeline_layering_wrapper")) {
            if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
        }
        return function() {
            if ((0, $ltooA.fg)("plan_timeline_layering_wrapper")) setTopLevel(currentLevel - 1);
            else // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8fe0ce44053a7d1f$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $8fe0ce44053a7d1f$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $acw62.useRef)(0);
    var value = (0, $acw62.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8fe0ce44053a7d1f$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $8fe0ce44053a7d1f$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $acw62.useContext)($8fe0ce44053a7d1f$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8fe0ce44053a7d1f$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8fe0ce44053a7d1f$var$LayeringProvider, null, content);
};




var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");
var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;




function $4e93effa1fe7e7cd$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $acw62.useContext((0, $60c0a9468407f91d$export$cbabb21c2529b130));
    var refHandler = $acw62.useCallback(function(node) {
        (0, $85f0adf197ea687e$export$4bb192c7cacf928f)(innerRef, node);
        (0, $85f0adf197ea687e$export$3dfa7c28635fe028)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $acw62.useEffect(function() {
        return function() {
            return (0, $85f0adf197ea687e$export$4bb192c7cacf928f)(innerRef, null);
        };
    }, []);
    $acw62.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $85f0adf197ea687e$export$f52c55943429c8b6)(children)({
        ref: refHandler
    });
}






var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");

var $39ea3782c8eee010$var$ESCAPE = "Escape";
function $39ea3782c8eee010$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $acw62.useRef)(false);
    var _useLayering = $39ea3782c8eee010$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $acw62.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $39ea3782c8eee010$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $acw62.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $39ea3782c8eee010$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $acw62.useContext)((0, $8fe0ce44053a7d1f$export$650d12d3c2ddb8fc));
    var _useContext = (0, $acw62.useContext)((0, $8fe0ce44053a7d1f$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $acw62.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}



var $ltooA = parcelRequire("ltooA");


var $dnCk4 = parcelRequire("dnCk4");


var $cfuBi = parcelRequire("cfuBi");

var $acw62 = parcelRequire("acw62");
var $51665465d7f5025c$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $acw62.useRef)(true);
    (0, $acw62.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children);
};


// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");



var $ltooA = parcelRequire("ltooA");
var $f0a2c7d5f11b6699$var$interactiveTags = [
    "button",
    "a",
    "input",
    "select",
    "textarea"
];
var $f0a2c7d5f11b6699$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($f0a2c7d5f11b6699$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute("tabindex") !== null || element.hasAttribute("contenteditable")) return true;
    return false;
};



var $acw62 = parcelRequire("acw62");
var $8ed46d56122fe515$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $acw62.useRef)([]);
    var requestFrame = (0, $acw62.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $acw62.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $acw62.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $4e470db8c083b813$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $39ea3782c8eee010$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $8ed46d56122fe515$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $acw62.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $d3997b4aab843580$export$2e2bcd8739ae039;
        var inIframe = window && window.self !== window.top && (0, $ltooA.fg)("fix-dropdown-close-outside-iframe");
        var closePopup = function closePopup(event) {
            if (onClose) {
                if ((0, $ltooA.fg)("sibling-dropdown-close-issue")) {
                    var _currentLevel = null;
                    if (event.target instanceof HTMLElement) {
                        var _event$target$closest;
                        _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute("data-ds--level");
                    }
                    _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "0");
                if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "0");
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $ltooA.fg)("design-system-closed-all-when-click-outside")) {
                    if (target instanceof HTMLElement) {
                        var _target$closest;
                        var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                        if (layeredElement) {
                            var closeType = layeredElement.getAttribute("[data-ds--close--type]");
                            if (closeType === "single") // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            var levelOfClickedLayer = layeredElement.getAttribute("data-ds--level");
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $f0a2c7d5f11b6699$export$3dee5e4542c672d9)(document.activeElement) && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === "Tab" && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === "Tab") {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest("[aria-modal]")) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === "Escape" || key === "Esc") {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === "Escape" || _key === "Esc" || shouldCloseOnTab && _key === "Tab") closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $8fY35.bind)(window.parent.window, {
            type: "click",
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $d3997b4aab843580$export$2e2bcd8739ae039);
        if ((0, $ltooA.fg)("popup-onclose-fix")) setTimeout(function() {
            unbind = (0, $8fY35.bindAll)(window, [
                {
                    type: "click",
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: "keydown",
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $8fY35.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $d3997b4aab843580$export$2e2bcd8739ae039);
        unbindBlur = (0, $8fY35.bind)(window, {
            type: "blur",
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            if ((0, $ltooA.fg)("popup-onclose-fix")) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $acw62 = parcelRequire("acw62");
var $539e1bc5b4077faf$exports = {};
var $234353d92c14c737$exports = {};
$234353d92c14c737$exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $234353d92c14c737$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        "input",
        "select",
        "a[href]",
        "textarea",
        "button",
        "[tabindex]"
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(","));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute("tabindex"), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === "INPUT" && candidate.type === "hidden" || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $234353d92c14c737$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === "none") result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === "hidden";
    };
}


var $539e1bc5b4077faf$var$listeningFocusTrap = null;
function $539e1bc5b4077faf$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === "string" ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $539e1bc5b4077faf$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($539e1bc5b4077faf$var$listeningFocusTrap) $539e1bc5b4077faf$var$listeningFocusTrap.pause();
        $539e1bc5b4077faf$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $539e1bc5b4077faf$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener("focus", checkFocus, true);
        document.addEventListener("click", checkClick, true);
        document.addEventListener("mousedown", checkPointerDown, true);
        document.addEventListener("touchstart", checkPointerDown, true);
        document.addEventListener("keydown", checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $539e1bc5b4077faf$var$listeningFocusTrap !== trap) return;
        document.removeEventListener("focus", checkFocus, true);
        document.removeEventListener("click", checkClick, true);
        document.removeEventListener("mousedown", checkPointerDown, true);
        document.removeEventListener("touchstart", checkPointerDown, true);
        document.removeEventListener("keydown", checkKey, true);
        $539e1bc5b4077faf$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === "string") {
            node = document.querySelector(optionValue);
            if (!node) throw new Error("`" + optionName + "` refers to no known node");
        }
        if (typeof optionValue === "function") {
            node = optionValue();
            if (!node) throw new Error("`" + optionName + "` did not return a node");
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption("initialFocus") !== null) node = getNodeForOption("initialFocus");
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption("fallbackFocus");
        if (!node) throw new Error("You can't have a focus-trap without at least one focusable element");
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === "function") e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === "Tab" || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $539e1bc5b4077faf$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute("tabindex") && Number(e.target.getAttribute("tabindex")) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $539e1bc5b4077faf$var$tryFocus(lastTabbableNode);
            return $539e1bc5b4077faf$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $539e1bc5b4077faf$var$tryFocus(firstTabbableNode);
        $539e1bc5b4077faf$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $234353d92c14c737$exports(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $539e1bc5b4077faf$var$tryFocus(lastTabbableNode);
        $539e1bc5b4077faf$var$tryFocus(firstTabbableNode);
    }
}
function $539e1bc5b4077faf$var$isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}
function $539e1bc5b4077faf$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === "input") node.select();
}
$539e1bc5b4077faf$exports = $539e1bc5b4077faf$var$focusTrap;





var $ltooA = parcelRequire("ltooA");

var $39f70b818aa49886$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $8ed46d56122fe515$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $39ea3782c8eee010$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $acw62.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $d3997b4aab843580$export$2e2bcd8739ae039;
        if (shouldDisableFocusTrap && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) {
            var isDropdown = popupRef.matches("[id^=ds--dropdown--]");
            var popups = document.querySelectorAll('[data-ds--level="'.concat(currentLevel - 1, '"]'));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "-1");
                    if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "-1");
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $d3997b4aab843580$export$2e2bcd8739ae039;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($539e1bc5b4077faf$exports)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $9f16de00f36940ec$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "xcss"
];
var $9f16de00f36940ec$var$fullWidthStyles = (0, $jjlaj.css)({
    width: "100%"
});
var $9f16de00f36940ec$var$rootStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "block",
    boxSizing: "border-box",
    zIndex: (0, $b7d36d3be7da66cd$export$7be255094ccdc533).layer(),
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $dnCk4.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $dnCk4.N50A), ", 0 0 1px ").concat((0, $dnCk4.N60A)), ")"),
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)"
}, (0, $cfuBi.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $dnCk4.N0), ")")), "&:focus", {
    outline: "none"
}));
var $9f16de00f36940ec$var$scrollableStyles = (0, $jjlaj.css)({
    overflow: "auto"
});
var $9f16de00f36940ec$var$blanketStyles = (0, $jjlaj.css)({
    position: "fixed",
    inset: 0,
    backgroundColor: "var(--ds-blanket, #091E427D)"
});
var $9f16de00f36940ec$var$modalStyles = (0, $jjlaj.css)({
    maxHeight: "50vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-050, 4px)",
    insetInline: "var(--ds-space-050, 4px)"
});
var $9f16de00f36940ec$var$DefaultPopupComponent = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, xcss = props.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $9f16de00f36940ec$var$_excluded);
    return (0, $jjlaj.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- This rule still fails because of the TS assertion
        className: xcss,
        css: [
            $9f16de00f36940ec$var$rootStyles,
            appearance === "UNSAFE_modal-below-sm" && $9f16de00f36940ec$var$modalStyles,
            !shouldRenderToParent && $9f16de00f36940ec$var$scrollableStyles,
            shouldFitContainer && $9f16de00f36940ec$var$fullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $9f16de00f36940ec$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $9f16de00f36940ec$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== "dialog";
    (0, $39f70b818aa49886$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $4e470db8c083b813$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $39ea3782c8eee010$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $acw62.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return (0, $jjlaj.jsx)((0, $504e801fc3041bf3$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        var popupContainer = (0, $jjlaj.jsx)(PopupContainer, {
            xcss: xcss,
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === "UNSAFE_modal-below-sm" ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $jjlaj.jsx)((0, $51665465d7f5025c$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return !initialFocusRef && (0, $ltooA.fg)("platform-design-system-apply-popup-wrapper-focus") ? (0, $jjlaj.jsx)((0, $acw62.Fragment), null, (0, $jjlaj.jsx)((0, $6f72ff8788d34fb2$export$2e2bcd8739ae039), null, popupContainer), appearance === "UNSAFE_modal-below-sm" && (0, $jjlaj.jsx)("div", {
            css: $9f16de00f36940ec$var$blanketStyles
        })) : (0, $jjlaj.jsx)((0, $acw62.Fragment), null, popupContainer, appearance === "UNSAFE_modal-below-sm" && (0, $jjlaj.jsx)("div", {
            css: $9f16de00f36940ec$var$blanketStyles
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9f16de00f36940ec$export$2e2bcd8739ae039 = $9f16de00f36940ec$var$PopperWrapper;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");


var $f7ecb33df6523b26$var$_window, $f7ecb33df6523b26$var$_window$matchMedia, $f7ecb33df6523b26$var$_window2, $f7ecb33df6523b26$var$_window2$matchMedia, $f7ecb33df6523b26$var$_window3, $f7ecb33df6523b26$var$_window3$matchMedia, $f7ecb33df6523b26$var$_window4, $f7ecb33df6523b26$var$_window4$matchMedia, $f7ecb33df6523b26$var$_window5, $f7ecb33df6523b26$var$_window5$matchMedia, $f7ecb33df6523b26$var$_window6, $f7ecb33df6523b26$var$_window6$matchMedia, $f7ecb33df6523b26$var$_window7, $f7ecb33df6523b26$var$_window7$matchMedia, $f7ecb33df6523b26$var$_window8, $f7ecb33df6523b26$var$_window8$matchMedia, $f7ecb33df6523b26$var$_window9, $f7ecb33df6523b26$var$_window9$matchMedia, $f7ecb33df6523b26$var$_window10, $f7ecb33df6523b26$var$_window10$matchMedia, $f7ecb33df6523b26$var$_window11, $f7ecb33df6523b26$var$_window11$matchMedia;
var $f7ecb33df6523b26$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window = window) === null || $f7ecb33df6523b26$var$_window === void 0 || ($f7ecb33df6523b26$var$_window$matchMedia = $f7ecb33df6523b26$var$_window.matchMedia) === null || $f7ecb33df6523b26$var$_window$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window$matchMedia.call($f7ecb33df6523b26$var$_window, (0, $4d1cc07665f9c15d$export$c881183ca713c214).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window2 = window) === null || $f7ecb33df6523b26$var$_window2 === void 0 || ($f7ecb33df6523b26$var$_window2$matchMedia = $f7ecb33df6523b26$var$_window2.matchMedia) === null || $f7ecb33df6523b26$var$_window2$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window2$matchMedia.call($f7ecb33df6523b26$var$_window2, (0, $4d1cc07665f9c15d$export$c881183ca713c214).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window3 = window) === null || $f7ecb33df6523b26$var$_window3 === void 0 || ($f7ecb33df6523b26$var$_window3$matchMedia = $f7ecb33df6523b26$var$_window3.matchMedia) === null || $f7ecb33df6523b26$var$_window3$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window3$matchMedia.call($f7ecb33df6523b26$var$_window3, (0, $4d1cc07665f9c15d$export$c881183ca713c214).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window4 = window) === null || $f7ecb33df6523b26$var$_window4 === void 0 || ($f7ecb33df6523b26$var$_window4$matchMedia = $f7ecb33df6523b26$var$_window4.matchMedia) === null || $f7ecb33df6523b26$var$_window4$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window4$matchMedia.call($f7ecb33df6523b26$var$_window4, (0, $4d1cc07665f9c15d$export$c881183ca713c214).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window5 = window) === null || $f7ecb33df6523b26$var$_window5 === void 0 || ($f7ecb33df6523b26$var$_window5$matchMedia = $f7ecb33df6523b26$var$_window5.matchMedia) === null || $f7ecb33df6523b26$var$_window5$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window5$matchMedia.call($f7ecb33df6523b26$var$_window5, (0, $4d1cc07665f9c15d$export$c881183ca713c214).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window6 = window) === null || $f7ecb33df6523b26$var$_window6 === void 0 || ($f7ecb33df6523b26$var$_window6$matchMedia = $f7ecb33df6523b26$var$_window6.matchMedia) === null || $f7ecb33df6523b26$var$_window6$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window6$matchMedia.call($f7ecb33df6523b26$var$_window6, (0, $4d1cc07665f9c15d$export$c881183ca713c214).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window7 = window) === null || $f7ecb33df6523b26$var$_window7 === void 0 || ($f7ecb33df6523b26$var$_window7$matchMedia = $f7ecb33df6523b26$var$_window7.matchMedia) === null || $f7ecb33df6523b26$var$_window7$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window7$matchMedia.call($f7ecb33df6523b26$var$_window7, (0, $4d1cc07665f9c15d$export$c881183ca713c214).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window8 = window) === null || $f7ecb33df6523b26$var$_window8 === void 0 || ($f7ecb33df6523b26$var$_window8$matchMedia = $f7ecb33df6523b26$var$_window8.matchMedia) === null || $f7ecb33df6523b26$var$_window8$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window8$matchMedia.call($f7ecb33df6523b26$var$_window8, (0, $4d1cc07665f9c15d$export$c881183ca713c214).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window9 = window) === null || $f7ecb33df6523b26$var$_window9 === void 0 || ($f7ecb33df6523b26$var$_window9$matchMedia = $f7ecb33df6523b26$var$_window9.matchMedia) === null || $f7ecb33df6523b26$var$_window9$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window9$matchMedia.call($f7ecb33df6523b26$var$_window9, (0, $4d1cc07665f9c15d$export$c881183ca713c214).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window10 = window) === null || $f7ecb33df6523b26$var$_window10 === void 0 || ($f7ecb33df6523b26$var$_window10$matchMedia = $f7ecb33df6523b26$var$_window10.matchMedia) === null || $f7ecb33df6523b26$var$_window10$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window10$matchMedia.call($f7ecb33df6523b26$var$_window10, (0, $4d1cc07665f9c15d$export$c881183ca713c214).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($f7ecb33df6523b26$var$_window11 = window) === null || $f7ecb33df6523b26$var$_window11 === void 0 || ($f7ecb33df6523b26$var$_window11$matchMedia = $f7ecb33df6523b26$var$_window11.matchMedia) === null || $f7ecb33df6523b26$var$_window11$matchMedia === void 0 ? void 0 : $f7ecb33df6523b26$var$_window11$matchMedia.call($f7ecb33df6523b26$var$_window11, (0, $4d1cc07665f9c15d$export$c881183ca713c214).below.xl.replace("@media ", "").trim())
};
var $f7ecb33df6523b26$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $acw62.useRef)(listener);
    (0, $acw62.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $f7ecb33df6523b26$var$queries[queryString];
    (0, $5fc7b62a530a88f6$export$e5c5a5f917a5871c)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $8fY35.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $105fb3f8500a6369$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $f7ecb33df6523b26$export$49e55ae2c03d6045)("below.sm", function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $acw62.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === "UNSAFE_modal-below-sm" && isSmallViewport ? "UNSAFE_modal-below-sm" : "default";
    var shouldRenderToParent = _shouldRenderToParent && appearance === "default";
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $861bf76cc2d1fb06$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $acw62.useState)(function() {
        return (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $d889a1652758f271$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $acw62.useState)(function() {
        return (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $cea3ad096574884c$var$defaultLayer = (0, $b7d36d3be7da66cd$export$7be255094ccdc533).layer();
var $cea3ad096574884c$var$wrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    position: "relative"
});
var $cea3ad096574884c$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $cea3ad096574884c$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $861bf76cc2d1fb06$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $d889a1652758f271$export$5d3a2de79e07b376)();
    var generatedId = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    var _usePopupAppearance = (0, $105fb3f8500a6369$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    (0, $894603c2f42046e0$export$469bb693f11edc7f)({
        isOpen: isOpen
    });
    var renderPopperWrapper = (0, $jjlaj.jsx)((0, $8fe0ce44053a7d1f$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $jjlaj.jsx)((0, $9f16de00f36940ec$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? "absolute" : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = (0, $jjlaj.jsx)((0, $60c0a9468407f91d$export$d0d38e7dec7a1a61), null, (0, $jjlaj.jsx)((0, $4e93effa1fe7e7cd$export$e0be378c32fb70a7), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $ltooA.fg)("platform-design-system-popup-ref") ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            "aria-controls": isOpen ? id : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": role === "dialog" && (0, $ltooA.fg)("platform_dst_popup-disable-focuslock") ? "dialog" : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $jjlaj.jsx)((0, $2167cf9ee39b2459$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $jjlaj.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        xcss: $cea3ad096574884c$var$wrapperStyles
    }, popupContent);
    return popupContent;
});


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9394c3c3f1484d88$export$2e2bcd8739ae039 = (0, $cea3ad096574884c$export$129a32eedafa97c5);



var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $a587c07a4f667978$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};


var $33d8ba37b098d2eb$var$_window, $33d8ba37b098d2eb$var$_window$matchMedia, $33d8ba37b098d2eb$var$_window2, $33d8ba37b098d2eb$var$_window2$matchMedia, $33d8ba37b098d2eb$var$_window3, $33d8ba37b098d2eb$var$_window3$matchMedia, $33d8ba37b098d2eb$var$_window4, $33d8ba37b098d2eb$var$_window4$matchMedia, $33d8ba37b098d2eb$var$_window5, $33d8ba37b098d2eb$var$_window5$matchMedia, $33d8ba37b098d2eb$var$_window6, $33d8ba37b098d2eb$var$_window6$matchMedia, $33d8ba37b098d2eb$var$_window7, $33d8ba37b098d2eb$var$_window7$matchMedia, $33d8ba37b098d2eb$var$_window8, $33d8ba37b098d2eb$var$_window8$matchMedia, $33d8ba37b098d2eb$var$_window9, $33d8ba37b098d2eb$var$_window9$matchMedia, $33d8ba37b098d2eb$var$_window10, $33d8ba37b098d2eb$var$_window10$matchMedia, $33d8ba37b098d2eb$var$_window11, $33d8ba37b098d2eb$var$_window11$matchMedia;
var $33d8ba37b098d2eb$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window = window) === null || $33d8ba37b098d2eb$var$_window === void 0 || ($33d8ba37b098d2eb$var$_window$matchMedia = $33d8ba37b098d2eb$var$_window.matchMedia) === null || $33d8ba37b098d2eb$var$_window$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window$matchMedia.call($33d8ba37b098d2eb$var$_window, (0, $a587c07a4f667978$export$987d49ffe1b0900f).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window2 = window) === null || $33d8ba37b098d2eb$var$_window2 === void 0 || ($33d8ba37b098d2eb$var$_window2$matchMedia = $33d8ba37b098d2eb$var$_window2.matchMedia) === null || $33d8ba37b098d2eb$var$_window2$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window2$matchMedia.call($33d8ba37b098d2eb$var$_window2, (0, $a587c07a4f667978$export$987d49ffe1b0900f).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window3 = window) === null || $33d8ba37b098d2eb$var$_window3 === void 0 || ($33d8ba37b098d2eb$var$_window3$matchMedia = $33d8ba37b098d2eb$var$_window3.matchMedia) === null || $33d8ba37b098d2eb$var$_window3$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window3$matchMedia.call($33d8ba37b098d2eb$var$_window3, (0, $a587c07a4f667978$export$987d49ffe1b0900f).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window4 = window) === null || $33d8ba37b098d2eb$var$_window4 === void 0 || ($33d8ba37b098d2eb$var$_window4$matchMedia = $33d8ba37b098d2eb$var$_window4.matchMedia) === null || $33d8ba37b098d2eb$var$_window4$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window4$matchMedia.call($33d8ba37b098d2eb$var$_window4, (0, $a587c07a4f667978$export$987d49ffe1b0900f).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window5 = window) === null || $33d8ba37b098d2eb$var$_window5 === void 0 || ($33d8ba37b098d2eb$var$_window5$matchMedia = $33d8ba37b098d2eb$var$_window5.matchMedia) === null || $33d8ba37b098d2eb$var$_window5$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window5$matchMedia.call($33d8ba37b098d2eb$var$_window5, (0, $a587c07a4f667978$export$987d49ffe1b0900f).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window6 = window) === null || $33d8ba37b098d2eb$var$_window6 === void 0 || ($33d8ba37b098d2eb$var$_window6$matchMedia = $33d8ba37b098d2eb$var$_window6.matchMedia) === null || $33d8ba37b098d2eb$var$_window6$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window6$matchMedia.call($33d8ba37b098d2eb$var$_window6, (0, $a587c07a4f667978$export$987d49ffe1b0900f).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window7 = window) === null || $33d8ba37b098d2eb$var$_window7 === void 0 || ($33d8ba37b098d2eb$var$_window7$matchMedia = $33d8ba37b098d2eb$var$_window7.matchMedia) === null || $33d8ba37b098d2eb$var$_window7$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window7$matchMedia.call($33d8ba37b098d2eb$var$_window7, (0, $a587c07a4f667978$export$987d49ffe1b0900f).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window8 = window) === null || $33d8ba37b098d2eb$var$_window8 === void 0 || ($33d8ba37b098d2eb$var$_window8$matchMedia = $33d8ba37b098d2eb$var$_window8.matchMedia) === null || $33d8ba37b098d2eb$var$_window8$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window8$matchMedia.call($33d8ba37b098d2eb$var$_window8, (0, $a587c07a4f667978$export$987d49ffe1b0900f).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window9 = window) === null || $33d8ba37b098d2eb$var$_window9 === void 0 || ($33d8ba37b098d2eb$var$_window9$matchMedia = $33d8ba37b098d2eb$var$_window9.matchMedia) === null || $33d8ba37b098d2eb$var$_window9$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window9$matchMedia.call($33d8ba37b098d2eb$var$_window9, (0, $a587c07a4f667978$export$987d49ffe1b0900f).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window10 = window) === null || $33d8ba37b098d2eb$var$_window10 === void 0 || ($33d8ba37b098d2eb$var$_window10$matchMedia = $33d8ba37b098d2eb$var$_window10.matchMedia) === null || $33d8ba37b098d2eb$var$_window10$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window10$matchMedia.call($33d8ba37b098d2eb$var$_window10, (0, $a587c07a4f667978$export$987d49ffe1b0900f).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($33d8ba37b098d2eb$var$_window11 = window) === null || $33d8ba37b098d2eb$var$_window11 === void 0 || ($33d8ba37b098d2eb$var$_window11$matchMedia = $33d8ba37b098d2eb$var$_window11.matchMedia) === null || $33d8ba37b098d2eb$var$_window11$matchMedia === void 0 ? void 0 : $33d8ba37b098d2eb$var$_window11$matchMedia.call($33d8ba37b098d2eb$var$_window11, (0, $a587c07a4f667978$export$987d49ffe1b0900f).below.xl.replace("@media ", "").trim())
};
var $33d8ba37b098d2eb$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $acw62.useRef)(listener);
    (0, $acw62.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $33d8ba37b098d2eb$var$queries[queryString];
    (0, $acw62.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $8fY35.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

function $8baf40fa10b11784$var$_List(_ref, forwardedRef) {
    var children = _ref.children, xcss = _ref.xcss;
    return(/*#__PURE__*/ /**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ $acw62.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss
    }, children));
}
var $8baf40fa10b11784$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $acw62.forwardRef)($8baf40fa10b11784$var$_List);




var $af41a5c5629fbf6e$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg",
    newLayoutStyles: "_1d2y1ris",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi _ndwch9n0"
};
var $af41a5c5629fbf6e$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
};
var $af41a5c5629fbf6e$export$2fb70d5e506c6bc2 = function UserActions(_ref) {
    var children = _ref.children, _ref$label = _ref.label, label = _ref$label === void 0 ? "Actions" : _ref$label, _ref$showMoreButtonLa = _ref.showMoreButtonLabel, showMoreButtonLabel = _ref$showMoreButtonLa === void 0 ? "Show more" : _ref$showMoreButtonLa;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isMobile = _useState4[0], setIsMobile = _useState4[1];
    // Note: `query` is a stable value between renders
    var query = (0, $33d8ba37b098d2eb$export$49e55ae2c03d6045)("below.sm", function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $5fc7b62a530a88f6$export$e5c5a5f917a5871c)(function() {
        var _query$matches;
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile((_query$matches = query === null || query === void 0 ? void 0 : query.matches) !== null && _query$matches !== void 0 ? _query$matches : false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "aria-label": label,
        className: (0, $5zphJ.default)([
            $af41a5c5629fbf6e$var$containerStyles.root,
            (0, $ltooA.fg)("platform_design_system_nav4_top_nav_columns") && $af41a5c5629fbf6e$var$containerStyles.newLayoutStyles,
            (0, $ltooA.fg)("platform_design_system_nav4_top_nav_min_widths") && $af41a5c5629fbf6e$var$containerStyles.contentMinWidthStyles
        ])
    }, isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9394c3c3f1484d88$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: function onClose() {
            return setIsOpen(false);
        },
        placement: "bottom-start",
        shouldRenderToParent: true,
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2900aa2180cfcb6e$export$d158fa15757a1890).Provider, {
                value: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8baf40fa10b11784$export$54c2e3dc7acea9f5), {
                xcss: (0, $9b698034c8c53dd8$export$a274e22fb40f762e)($af41a5c5629fbf6e$var$listStyles.root, $af41a5c5629fbf6e$var$listStyles.popupContainer)
            }, children));
        },
        trigger: function trigger(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b95d5cf1ea992c9$export$c25acd513dcc8062), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, triggerProps, {
                label: showMoreButtonLabel,
                isSelected: isOpen,
                onClick: function onClick() {
                    return setIsOpen(!isOpen);
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bb892e43b35db19d$exports))),
                isTooltipDisabled: false
            }));
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8baf40fa10b11784$export$54c2e3dc7acea9f5), {
        xcss: (0, $9b698034c8c53dd8$export$a274e22fb40f762e)($af41a5c5629fbf6e$var$listStyles.root, $af41a5c5629fbf6e$var$listStyles.hideOnSmallViewport)
    }, children));
};


/* home-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $387974f8a0e71add$var$styles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw",
    logoPaddingStyles: "_pwyo12x7",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi"
};
var $387974f8a0e71add$export$ae2177c1f0d2b72c = function HomeActions(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var ref = (0, $acw62.useContext)((0, $c4c2b52618a33b5e$export$762fcfeaa67873eb));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $5zphJ.default)([
            $387974f8a0e71add$var$styles.root,
            (0, $ltooA.fg)("platform_design_system_nav4_top_nav_min_widths") ? $387974f8a0e71add$var$styles.contentMinWidthStyles : // Removing the extra logo padding when applying the content min width
            $387974f8a0e71add$var$styles.logoPaddingStyles
        ])
    }, children);
};




var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $6d23e34a443a4a03$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6d23e34a443a4a03$export$e19cd5f9376f8cee || ($6d23e34a443a4a03$export$e19cd5f9376f8cee = {}));
var $6d23e34a443a4a03$var$readOnly = function(obj) {
    return obj;
};
function $6d23e34a443a4a03$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $6d23e34a443a4a03$var$BeforeUnloadEventType = "beforeunload";
var $6d23e34a443a4a03$var$HashChangeEventType = "hashchange";
var $6d23e34a443a4a03$var$PopStateEventType = "popstate";
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6d23e34a443a4a03$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $6d23e34a443a4a03$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($6d23e34a443a4a03$var$PopStateEventType, handlePop);
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $8nd05.default)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $8nd05.default)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6d23e34a443a4a03$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $6d23e34a443a4a03$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? "" : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? "" : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $6d23e34a443a4a03$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($6d23e34a443a4a03$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($6d23e34a443a4a03$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($6d23e34a443a4a03$export$fe53371bee54353d(nextLocation) !== $6d23e34a443a4a03$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $8nd05.default)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $8nd05.default)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $6d23e34a443a4a03$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        "/"
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $6d23e34a443a4a03$var$readOnly((0, $8nd05.default)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $6d23e34a443a4a03$var$createKey()
        }, typeof entry === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $6d23e34a443a4a03$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $8nd05.default)({
            pathname: location.pathname,
            search: "",
            hash: ""
        }, typeof to === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $6d23e34a443a4a03$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $6d23e34a443a4a03$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $6d23e34a443a4a03$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = "";
}
function $6d23e34a443a4a03$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $6d23e34a443a4a03$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $6d23e34a443a4a03$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $6d23e34a443a4a03$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}



var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");


var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $faa88de4f0afd1d0$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == "symbol" || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, "");
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
$faa88de4f0afd1d0$exports = $faa88de4f0afd1d0$var$debounce;


var $ffc02c93f21d2d39$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $ffc02c93f21d2d39$var$noop() {
// No operation performed.
}
$ffc02c93f21d2d39$exports = $ffc02c93f21d2d39$var$noop;


const $71bcd808d0e94c1b$var$hasWindow = ()=>typeof window !== "undefined";
const $71bcd808d0e94c1b$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports)))
};
const $71bcd808d0e94c1b$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = "", search: search = "", hash: hash = "" } = $71bcd808d0e94c1b$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $71bcd808d0e94c1b$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector("#content");
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return "POP";
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return "POP";
            }
            historyStack[historyStack.length - 1] = currentHref;
            return "REPLACE";
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return "PUSH";
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $71bcd808d0e94c1b$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $71bcd808d0e94c1b$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $71bcd808d0e94c1b$var$getLocation();
    let currentAction = "PUSH";
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        get location () {
            return currentLocation;
        },
        get length () {
            return $71bcd808d0e94c1b$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $71bcd808d0e94c1b$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === "string" ? path : (0, $6d23e34a443a4a03$export$fe53371bee54353d)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === "string" ? path : (0, $6d23e34a443a4a03$export$fe53371bee54353d)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $71bcd808d0e94c1b$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
        createHref: (location)=>(0, $6d23e34a443a4a03$export$fe53371bee54353d)(location)
    } : $71bcd808d0e94c1b$var$methodsPlaceholders);
};


/**
 * Tokenize input string.
 */ function $9b2606e870840c90$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError('Pattern cannot start with "?" at '.concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $9b2606e870840c90$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $9b2606e870840c90$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError('Must have text between two parameters, missing text after "'.concat(prev.name, '"'));
        if (!prevText || isSafe(prevText)) return "[^".concat($9b2606e870840c90$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($9b2606e870840c90$var$escapeString(prevText), ")[^").concat($9b2606e870840c90$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $9b2606e870840c90$export$ef7acd7185315e22(str, options) {
    return $9b2606e870840c90$export$5b9bad9e403cf3d9($9b2606e870840c90$export$98e6a39c04603d36(str, options), options);
}
function $9b2606e870840c90$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $9b2606e870840c90$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError('Expected "'.concat(token.name, '" to not repeat, but got an array'));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError('Expected "'.concat(token.name, '" to not be empty'));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError('Expected "'.concat(token.name, '" to be ').concat(typeOfMessage));
        }
        return path;
    };
}
function $9b2606e870840c90$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $9b2606e870840c90$export$71304158c7e35877(str, keys, options);
    return $9b2606e870840c90$export$968e97c88708237a(re, keys, options);
}
function $9b2606e870840c90$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $9b2606e870840c90$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $9b2606e870840c90$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $9b2606e870840c90$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $9b2606e870840c90$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $9b2606e870840c90$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $9b2606e870840c90$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $9b2606e870840c90$var$stringToRegexp(path, keys, options) {
    return $9b2606e870840c90$export$9a9303716def6456($9b2606e870840c90$export$98e6a39c04603d36(path, options), keys, options);
}
function $9b2606e870840c90$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($9b2606e870840c90$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($9b2606e870840c90$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $9b2606e870840c90$var$escapeString(encode(token));
        else {
            var prefix = $9b2606e870840c90$var$escapeString(encode(token.prefix));
            var suffix = $9b2606e870840c90$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError('Can not repeat "'.concat(token.name, '" without a prefix and suffix'));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $9b2606e870840c90$var$flags(options));
}
function $9b2606e870840c90$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $9b2606e870840c90$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $9b2606e870840c90$var$arrayToRegexp(path, keys, options);
    return $9b2606e870840c90$var$stringToRegexp(path, keys, options);
}


var $5682d9ca04ade704$exports = {};
"use strict";
var $e72213fefeee6595$exports = {};
"use strict";
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ $e72213fefeee6595$exports = function required(port, protocol) {
    protocol = protocol.split(":")[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case "http":
        case "ws":
            return port !== 80;
        case "https":
        case "wss":
            return port !== 443;
        case "ftp":
            return port !== 21;
        case "gopher":
            return port !== 70;
        case "file":
            return false;
    }
    return port !== 0;
};


var $c7ed1ca4ef6b4f89$exports = {};

$parcel$export($c7ed1ca4ef6b4f89$exports, "stringify", () => $c7ed1ca4ef6b4f89$export$fac44ee5b035f737, (v) => $c7ed1ca4ef6b4f89$export$fac44ee5b035f737 = v);
$parcel$export($c7ed1ca4ef6b4f89$exports, "parse", () => $c7ed1ca4ef6b4f89$export$98e6a39c04603d36, (v) => $c7ed1ca4ef6b4f89$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $c7ed1ca4ef6b4f89$export$fac44ee5b035f737;
var $c7ed1ca4ef6b4f89$export$98e6a39c04603d36;
"use strict";
var $c7ed1ca4ef6b4f89$var$has = Object.prototype.hasOwnProperty, $c7ed1ca4ef6b4f89$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $c7ed1ca4ef6b4f89$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, " "));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $c7ed1ca4ef6b4f89$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $c7ed1ca4ef6b4f89$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $c7ed1ca4ef6b4f89$var$decode(part[1]), value = $c7ed1ca4ef6b4f89$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $c7ed1ca4ef6b4f89$var$querystringify(obj, prefix) {
    prefix = prefix || "";
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ("string" !== typeof prefix) prefix = "?";
    for(key in obj)if ($c7ed1ca4ef6b4f89$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $c7ed1ca4ef6b4f89$var$undef || isNaN(value))) value = "";
        key = $c7ed1ca4ef6b4f89$var$encode(key);
        value = $c7ed1ca4ef6b4f89$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + "=" + value);
    }
    return pairs.length ? prefix + pairs.join("&") : "";
}
$c7ed1ca4ef6b4f89$export$fac44ee5b035f737 = $c7ed1ca4ef6b4f89$var$querystringify;
$c7ed1ca4ef6b4f89$export$98e6a39c04603d36 = $c7ed1ca4ef6b4f89$var$querystring;


var $5682d9ca04ade704$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $5682d9ca04ade704$var$CRHTLF = /[\n\r\t]/g, $5682d9ca04ade704$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $5682d9ca04ade704$var$port = /:\d+$/, $5682d9ca04ade704$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $5682d9ca04ade704$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $5682d9ca04ade704$var$trimLeft(str) {
    return (str ? str : "").toString().replace($5682d9ca04ade704$var$controlOrWhitespace, "");
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $5682d9ca04ade704$var$rules = [
    [
        "#",
        "hash"
    ],
    [
        "?",
        "query"
    ],
    function sanitize(address, url) {
        return $5682d9ca04ade704$var$isSpecial(url.protocol) ? address.replace(/\\/g, "/") : address;
    },
    [
        "/",
        "pathname"
    ],
    [
        "@",
        "auth",
        1
    ],
    [
        NaN,
        "host",
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        "port",
        undefined,
        1
    ],
    [
        NaN,
        "hostname",
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $5682d9ca04ade704$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $5682d9ca04ade704$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== "undefined") globalVar = window;
    else if (typeof $parcel$global !== "undefined") globalVar = $parcel$global;
    else if (typeof self !== "undefined") globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ("blob:" === loc.protocol) finaldestination = new $5682d9ca04ade704$var$Url(unescape(loc.pathname), {});
    else if ("string" === type) {
        finaldestination = new $5682d9ca04ade704$var$Url(loc, {});
        for(key in $5682d9ca04ade704$var$ignore)delete finaldestination[key];
    } else if ("object" === type) {
        for(key in loc){
            if (key in $5682d9ca04ade704$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $5682d9ca04ade704$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $5682d9ca04ade704$var$isSpecial(scheme) {
    return scheme === "file:" || scheme === "ftp:" || scheme === "http:" || scheme === "https:" || scheme === "ws:" || scheme === "wss:";
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $5682d9ca04ade704$var$extractProtocol(address, location) {
    address = $5682d9ca04ade704$var$trimLeft(address);
    address = address.replace($5682d9ca04ade704$var$CRHTLF, "");
    location = location || {};
    var match = $5682d9ca04ade704$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : "";
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === "file:") {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($5682d9ca04ade704$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $5682d9ca04ade704$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $5682d9ca04ade704$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $5682d9ca04ade704$var$resolve(relative, base) {
    if (relative === "") return base;
    var path = (base || "/").split("/").slice(0, -1).concat(relative.split("/")), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === ".") path.splice(i, 1);
        else if (path[i] === "..") {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift("");
    if (last === "." || last === "..") path.push("");
    return path.join("/");
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $5682d9ca04ade704$var$Url(address, location, parser) {
    address = $5682d9ca04ade704$var$trimLeft(address);
    address = address.replace($5682d9ca04ade704$var$CRHTLF, "");
    if (!(this instanceof $5682d9ca04ade704$var$Url)) return new $5682d9ca04ade704$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $5682d9ca04ade704$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ("object" !== type && "string" !== type) {
        parser = location;
        location = null;
    }
    if (parser && "function" !== typeof parser) parser = $c7ed1ca4ef6b4f89$exports.parse;
    location = $5682d9ca04ade704$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $5682d9ca04ade704$var$extractProtocol(address || "", location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || "";
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === "file:" && (extracted.slashesCount !== 2 || $5682d9ca04ade704$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$5682d9ca04ade704$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        "pathname"
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === "function") {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ("string" === typeof parse) {
            index = parse === "@" ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ("number" === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || "" : "");
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== "/" && (url.pathname !== "" || location.pathname !== "")) url.pathname = $5682d9ca04ade704$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== "/" && $5682d9ca04ade704$var$isSpecial(url.protocol)) url.pathname = "/" + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$e72213fefeee6595$exports(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = "";
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = "";
    if (url.auth) {
        index = url.auth.indexOf(":");
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ":" + url.password : url.username;
    }
    url.origin = url.protocol !== "file:" && $5682d9ca04ade704$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $5682d9ca04ade704$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case "query":
            if ("string" === typeof value && value.length) value = (fn || $c7ed1ca4ef6b4f89$exports.parse)(value);
            url[part] = value;
            break;
        case "port":
            url[part] = value;
            if (!$e72213fefeee6595$exports(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = "";
            } else if (value) url.host = url.hostname + ":" + value;
            break;
        case "hostname":
            url[part] = value;
            if (url.port) value += ":" + url.port;
            url.host = value;
            break;
        case "host":
            url[part] = value;
            if ($5682d9ca04ade704$var$port.test(value)) {
                value = value.split(":");
                url.port = value.pop();
                url.hostname = value.join(":");
            } else {
                url.hostname = value;
                url.port = "";
            }
            break;
        case "protocol":
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case "pathname":
        case "hash":
            if (value) {
                var char = part === "pathname" ? "/" : "#";
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case "username":
        case "password":
            url[part] = encodeURIComponent(value);
            break;
        case "auth":
            var index = value.indexOf(":");
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $5682d9ca04ade704$var$rules.length; i++){
        var ins = $5682d9ca04ade704$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ":" + url.password : url.username;
    url.origin = url.protocol !== "file:" && $5682d9ca04ade704$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $5682d9ca04ade704$var$toString(stringify) {
    if (!stringify || "function" !== typeof stringify) stringify = $c7ed1ca4ef6b4f89$exports.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ":") protocol += ":";
    var result = protocol + (url.protocol && url.slashes || $5682d9ca04ade704$var$isSpecial(url.protocol) ? "//" : "");
    if (url.username) {
        result += url.username;
        if (url.password) result += ":" + url.password;
        result += "@";
    } else if (url.password) {
        result += ":" + url.password;
        result += "@";
    } else if (url.protocol !== "file:" && $5682d9ca04ade704$var$isSpecial(url.protocol) && !host && url.pathname !== "/") //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += "@";
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ":" || $5682d9ca04ade704$var$port.test(url.hostname) && !url.port) host += ":";
    result += host + url.pathname;
    query = "object" === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += "?" !== query.charAt(0) ? "?" + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$5682d9ca04ade704$var$Url.prototype = {
    set: $5682d9ca04ade704$var$set,
    toString: $5682d9ca04ade704$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$5682d9ca04ade704$var$Url.extractProtocol = $5682d9ca04ade704$var$extractProtocol;
$5682d9ca04ade704$var$Url.location = $5682d9ca04ade704$var$lolcation;
$5682d9ca04ade704$var$Url.trimLeft = $5682d9ca04ade704$var$trimLeft;
$5682d9ca04ade704$var$Url.qs = $c7ed1ca4ef6b4f89$exports;
$5682d9ca04ade704$exports = $5682d9ca04ade704$var$Url;


function $b3b09a7589a73470$export$37e0729cc751960b(pattern = "/", options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = "" } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $5682d9ca04ade704$exports.qs).stringify(query, true);
    const pathname = pattern === "/" ? pattern : (0, $9b2606e870840c90$export$ef7acd7185315e22)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ""
    };
}



const $3b1df627ec2bc28b$export$82476f982757e71e = (pattern = "/", params)=>pattern === "/" ? pattern : (0, $9b2606e870840c90$export$ef7acd7185315e22)(pattern)(params);


/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $hPtJY = parcelRequire("hPtJY");
const $40dc7ae0aadcfdfd$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === "nodejs" || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes("Node.js")) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes("jsdom"));
};
const $40dc7ae0aadcfdfd$export$455cc18296abe008 = ()=>{
    if (typeof window === "undefined" || typeof $hPtJY !== "undefined" && $hPtJY.versions != null && $hPtJY.versions.node != null) return true;
    if ($40dc7ae0aadcfdfd$var$isJsDomEnvironment()) return true;
    return false;
};




var $3p9rK = parcelRequire("3p9rK");
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

const $3772e0d80d77cbb5$var$cache = {};
const $3772e0d80d77cbb5$var$cacheLimit = 10000;
let $3772e0d80d77cbb5$var$cacheCount = 0;
function $3772e0d80d77cbb5$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $3772e0d80d77cbb5$var$cache[cacheKey] || ($3772e0d80d77cbb5$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $9b2606e870840c90$export$71304158c7e35877)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($3772e0d80d77cbb5$var$cacheCount < $3772e0d80d77cbb5$var$cacheLimit) {
        pathCache[path] = result;
        $3772e0d80d77cbb5$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $3772e0d80d77cbb5$var$matchPath(pathname, options = {}) {
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = "" } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== "") return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $3772e0d80d77cbb5$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $3772e0d80d77cbb5$export$2e2bcd8739ae039 = $3772e0d80d77cbb5$var$matchPath;



var $3p9rK = parcelRequire("3p9rK");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $87df97816e40d486$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split("=");
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes("!=")) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split("|").map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes("?")) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || "";
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith("(")) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || "");
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $87df97816e40d486$export$2e2bcd8739ae039 = $87df97816e40d486$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $c866d9187f6d354d$var$computeRootMatch = (pathname)=>({
        path: "/",
        url: "/",
        params: {},
        isExact: pathname === "/",
        query: {}
    });
function $c866d9187f6d354d$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $3772e0d80d77cbb5$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $c866d9187f6d354d$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $87df97816e40d486$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $c866d9187f6d354d$export$2e2bcd8739ae039 = $c866d9187f6d354d$var$execRouteMatching;


const $91b1717ffc0107b6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $91b1717ffc0107b6$var$MAX_CACHE_SIZE = 1000;
function $91b1717ffc0107b6$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$91b1717ffc0107b6$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $91b1717ffc0107b6$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($91b1717ffc0107b6$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $91b1717ffc0107b6$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $91b1717ffc0107b6$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $4366c52d36621328$var$matchRoute = (routes, pathname, queryParams = {}, basePath = "")=>{
    // if navigating to to `/` or just basePath, then do not append basePath
    const updatedBasePath = [
        "/",
        basePath
    ].includes(pathname) ? "" : basePath;
    const queryParamObject = typeof queryParams === "string" ? (0, $5682d9ca04ade704$exports.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $91b1717ffc0107b6$export$f594abf16a5ad948).get(pathname, queryParamObject, updatedBasePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $c866d9187f6d354d$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, updatedBasePath);
        if (matchedRoute) {
            (0, $91b1717ffc0107b6$export$f594abf16a5ad948).set(pathname, queryParamObject, updatedBasePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $4366c52d36621328$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = "")=>$4366c52d36621328$var$matchRoute(routes, pathname, queryParams, basePath);
const $4366c52d36621328$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = "")=>{
    $4366c52d36621328$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $4366c52d36621328$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = "")=>$4366c52d36621328$var$matchRoute(routes, pathname, queryParams, basePath);





const $f89e874adec4a5d6$export$7c22f8f9552f689e = {
    pathname: "",
    search: "",
    hash: ""
};
const $f89e874adec4a5d6$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: "",
    url: "",
    query: {}
};
const $f89e874adec4a5d6$export$4eadc79233226325 = {
    path: "",
    component: ()=>null,
    name: ""
};
const $f89e874adec4a5d6$export$39607c9878cf5148 = (0, $71bcd808d0e94c1b$export$883c3f3b6c000133)();
const $f89e874adec4a5d6$export$1515254c8c90bebb = {
    location: $f89e874adec4a5d6$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($ffc02c93f21d2d39$exports)))
};
const $f89e874adec4a5d6$export$fa440ddf675c8a93 = "POP";




const $7040b2dec5a7dddb$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = "" } = options;
    const pathname = (0, $3b1df627ec2bc28b$export$82476f982757e71e)(route.path, params);
    const matchedRoute = (0, $4366c52d36621328$export$2e2bcd8739ae039)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $f89e874adec4a5d6$export$2de13e891a662beb),
        query: query
    };
};
const $7040b2dec5a7dddb$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = "" } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $5682d9ca04ade704$exports.qs).parse(search);
    const matchedRoute = (0, $4366c52d36621328$export$2e2bcd8739ae039)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $f89e874adec4a5d6$export$4eadc79233226325),
        match: matchedRoute ? matchedRoute.match : (0, $f89e874adec4a5d6$export$2de13e891a662beb)
    };
};


const $1b8104a3d5821b84$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $1b8104a3d5821b84$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $1b8104a3d5821b84$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $1b8104a3d5821b84$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);





var $3p9rK = parcelRequire("3p9rK");

/* eslint-disable import/no-unresolved */ 
var $aS1Zy = parcelRequire("aS1Zy");

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");
const $16a7bafc81a7e985$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $16a7bafc81a7e985$var$defaults = {
    batchUpdates: "useSyncExternalStore" in (0, (/*@__PURE__*/$parcel$interopDefault($acw62))),
    devtools: false,
    middlewares: new Set(),
    mutator: $16a7bafc81a7e985$var$defaultMutator
};
var $16a7bafc81a7e985$export$2e2bcd8739ae039 = $16a7bafc81a7e985$var$defaults;


const $123976b5fa440531$var$supports = {
    scheduling () {
        return typeof window !== "undefined" && typeof MessageChannel === "function";
    }
};
var $123976b5fa440531$export$2e2bcd8739ae039 = $123976b5fa440531$var$supports;


let $670af8fa19d94fbd$var$isInsideBatchedSchedule = false;
function $670af8fa19d94fbd$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $16a7bafc81a7e985$export$2e2bcd8739ae039).batchUpdates || !(0, $123976b5fa440531$export$2e2bcd8739ae039).scheduling() || $670af8fa19d94fbd$var$isInsideBatchedSchedule) return (0, $aS1Zy.unstable_batchedUpdates)(fn);
    $670af8fa19d94fbd$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $fO90s.unstable_scheduleCallback)((0, $fO90s.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $aS1Zy.unstable_batchedUpdates)(fn);
        $670af8fa19d94fbd$var$isInsideBatchedSchedule = false;
    });
}


var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
"use strict";

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));



var $acw62 = parcelRequire("acw62");


const $13e1b1165581c9b3$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $13e1b1165581c9b3$var$warnings = new WeakMap();
const $13e1b1165581c9b3$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).devtools ? $13e1b1165581c9b3$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$13e1b1165581c9b3$var$warnings.has(actionFn)) $13e1b1165581c9b3$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $13e1b1165581c9b3$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $13e1b1165581c9b3$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};



// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $005aee7619e5fa52$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $005aee7619e5fa52$var$CACHE = new WeakMap();
function $005aee7619e5fa52$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = "" + objA;
        const strB = "" + objB;
        if (strA !== strB || strA[0] === "[" && strA !== "[object Object]") return false;
         // do object comparison
        let keysA;
        if ($005aee7619e5fa52$var$CACHE.has(objA)) keysA = $005aee7619e5fa52$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $005aee7619e5fa52$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($005aee7619e5fa52$var$CACHE.has(objB)) keysB = $005aee7619e5fa52$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $005aee7619e5fa52$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$005aee7619e5fa52$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}


const $987ee9d36fade5fb$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $005aee7619e5fa52$export$2e2bcd8739ae039)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $987ee9d36fade5fb$export$2e2bcd8739ae039 = $987ee9d36fade5fb$var$updateMiddleware;


const $1aee96b21602f71e$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $987ee9d36fade5fb$export$2e2bcd8739ae039)).reduceRight((next, mw)=>mw(storeState)(next), (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).mutator);
var $1aee96b21602f71e$export$2e2bcd8739ae039 = $1aee96b21602f71e$var$applyMiddleware;



const $dc346cd81aa1a5b4$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === "DISPATCH") switch(message.payload.type){
            case "RESET":
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case "COMMIT":
                devTools.init(storeState.getState());
                return;
            case "ROLLBACK":
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case "JUMP_TO_STATE":
            case "JUMP_TO_ACTION":
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === "ACTION") {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $dc346cd81aa1a5b4$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $16a7bafc81a7e985$export$2e2bcd8739ae039).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).devtools === "function" ? (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).devtools(storeState) : {};
                        devTools = $dc346cd81aa1a5b4$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $dc346cd81aa1a5b4$export$2e2bcd8739ae039 = $dc346cd81aa1a5b4$var$withDevtools;






const $f8bfb2cc6be056d4$var$QUEUE = [];
let $f8bfb2cc6be056d4$var$scheduled;
function $f8bfb2cc6be056d4$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $16a7bafc81a7e985$export$2e2bcd8739ae039).batchUpdates || !(0, $123976b5fa440531$export$2e2bcd8739ae039).scheduling()) return (0, $670af8fa19d94fbd$export$712ea50be43a7858)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$f8bfb2cc6be056d4$var$QUEUE.includes(fn)) $f8bfb2cc6be056d4$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($f8bfb2cc6be056d4$var$scheduled) return;
    $f8bfb2cc6be056d4$var$scheduled = (0, $670af8fa19d94fbd$export$712ea50be43a7858)(()=>{
        let queueFn;
        while(queueFn = $f8bfb2cc6be056d4$var$QUEUE.shift())queueFn();
        $f8bfb2cc6be056d4$var$scheduled = null;
    });
}


function $90172912008b49e0$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $f8bfb2cc6be056d4$export$2e2bcd8739ae039)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $1aee96b21602f71e$export$2e2bcd8739ae039)(storeState, (0, $16a7bafc81a7e985$export$2e2bcd8739ae039).middlewares);
    return storeState;
}
var $90172912008b49e0$export$2e2bcd8739ae039 = (0, $dc346cd81aa1a5b4$export$2e2bcd8739ae039)($90172912008b49e0$var$createStoreState);


const $61bf82a671dbe4e0$export$e4d628ba0054221b = "__global__";
class $61bf82a671dbe4e0$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $61bf82a671dbe4e0$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $123976b5fa440531$export$2e2bcd8739ae039).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $90172912008b49e0$export$2e2bcd8739ae039)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $13e1b1165581c9b3$export$5ee1d46cd0883a22)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $61bf82a671dbe4e0$export$9d726ae4880b1060 = new $61bf82a671dbe4e0$export$acb47f32da33501e();


const $18357e59c27a6d53$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    globalRegistry: (0, $61bf82a671dbe4e0$export$9d726ae4880b1060),
    retrieveStore: (Store)=>(0, $61bf82a671dbe4e0$export$9d726ae4880b1060).getStore(Store)
}, ()=>0);



function $0af7b28a1088eb67$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $0af7b28a1088eb67$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $005aee7619e5fa52$export$2e2bcd8739ae039)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$0af7b28a1088eb67$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $0af7b28a1088eb67$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $0af7b28a1088eb67$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $005aee7619e5fa52$export$2e2bcd8739ae039)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}


function $486088c4f937815c$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $0af7b28a1088eb67$export$2e2bcd8739ae039)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $0af7b28a1088eb67$export$2e2bcd8739ae039)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $486088c4f937815c$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === "function" && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $486088c4f937815c$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $486088c4f937815c$var$cache = new WeakMap();
function $486088c4f937815c$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$486088c4f937815c$var$cache.has(storeState)) $486088c4f937815c$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $486088c4f937815c$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $486088c4f937815c$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $486088c4f937815c$export$d2c200d79fc82f8c(selector);
}


const $b11c197a6f748a78$var$EMPTY_SELECTOR = ()=>undefined;
const $b11c197a6f748a78$var$DEFAULT_SELECTOR = (state)=>state;
function $b11c197a6f748a78$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $acw62.useContext)((0, $18357e59c27a6d53$export$841858b892ce1f4c));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $acw62.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $acw62.useMemo)(()=>selector ? (0, $486088c4f937815c$export$38d24f3c60944dd5)(selector, storeState, hasPropsArg) : selector === null ? $b11c197a6f748a78$var$EMPTY_SELECTOR : $b11c197a6f748a78$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $acw62.useState)({})[1];
        const getSnapshot = (0, $acw62.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $b11c197a6f748a78$export$7c643e1d6648e418(Store) {
    const useHook = $b11c197a6f748a78$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $b11c197a6f748a78$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $b11c197a6f748a78$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}


var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();





const $8506a449c87a280c$var$_excluded = [
    "children"
], $8506a449c87a280c$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $8506a449c87a280c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8506a449c87a280c$var$noop = ()=>()=>{};
function $8506a449c87a280c$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $8506a449c87a280c$var$noop, onUpdate: onUpdate = $8506a449c87a280c$var$noop, onCleanup: onCleanup = $8506a449c87a280c$var$noop, displayName: displayName = "" } = _temp === void 0 ? {} : _temp;
    if ("key" in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split("__")[0]})`;
        return $8506a449c87a280c$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $8506a449c87a280c$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $8506a449c87a280c$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $8506a449c87a280c$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $8506a449c87a280c$var$createFunctionContainer(StoreOrOptions);
}
function $8506a449c87a280c$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $acw62.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $61bf82a671dbe4e0$export$acb47f32da33501e)("__local__") : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $8506a449c87a280c$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $acw62.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $acw62.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $13e1b1165581c9b3$export$5ee1d46cd0883a22)(Store.actions, storeState, config);
            const handlers = (0, $13e1b1165581c9b3$export$5ee1d46cd0883a22)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $8506a449c87a280c$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $acw62.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $acw62.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $8506a449c87a280c$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $8506a449c87a280c$var$_objectWithoutPropertiesLoose(props, $8506a449c87a280c$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $8506a449c87a280c$var$_objectWithoutPropertiesLoose(restProps, $8506a449c87a280c$var$_excluded2);
        const ctx = (0, $acw62.useContext)((0, $18357e59c27a6d53$export$841858b892ce1f4c));
        const registry = $8506a449c87a280c$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $acw62.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $8506a449c87a280c$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $8506a449c87a280c$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $005aee7619e5fa52$export$2e2bcd8739ae039)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $acw62.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18357e59c27a6d53$export$841858b892ce1f4c).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
    };
    return FunctionContainer;
}

/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $f99d8d574f57736c$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}


function $abf782f06879c350$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), "") : "";
    return [
        name,
        (0, $f99d8d574f57736c$export$2e2bcd8739ae039)(src + JSON.stringify(initialState))
    ].filter(Boolean).join("__");
}
function $abf782f06879c350$export$f51a9068ac82ea43(_ref) {
    let { name: name = "", initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $abf782f06879c350$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}






const $7bf0d9fdaa35eb7b$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
const $7bf0d9fdaa35eb7b$var$addLeadingSlash = (path)=>path.charAt(0) === "/" ? path : "/" + path;
const $7bf0d9fdaa35eb7b$export$b8ce2e8154d1dff1 = (path, prefix = "")=>{
    if (prefix) {
        prefix = $7bf0d9fdaa35eb7b$var$stripTrailingSlash(prefix);
        prefix = $7bf0d9fdaa35eb7b$var$addLeadingSlash(prefix);
        path = $7bf0d9fdaa35eb7b$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $7bf0d9fdaa35eb7b$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp("^([a-z]+://|//)", "i");
    return regex.test(path);
};
const $7bf0d9fdaa35eb7b$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== "string" || !$7bf0d9fdaa35eb7b$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($5682d9ca04ade704$exports)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($5682d9ca04ade704$exports)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $7bf0d9fdaa35eb7b$export$ae9fda833d91ed65 = (path, prefix = "")=>{
    if (typeof path !== "string") return path;
    if (!$7bf0d9fdaa35eb7b$export$e83e3719fc818ee5(path)) {
        path = $7bf0d9fdaa35eb7b$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($5682d9ca04ade704$exports)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $7bf0d9fdaa35eb7b$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $5682d9ca04ade704$exports.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $7bf0d9fdaa35eb7b$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $7bf0d9fdaa35eb7b$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $1b8104a3d5821b84$export$5997e70fc4543270)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === "resources-plugin" || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return defaultShouldReload;
};


const $d7dd1b3b8cc777cb$export$36d128238e6b60f5 = {
    action: (0, $f89e874adec4a5d6$export$fa440ddf675c8a93),
    basePath: "",
    location: (0, $f89e874adec4a5d6$export$39607c9878cf5148).location,
    history: (0, $f89e874adec4a5d6$export$39607c9878cf5148),
    match: (0, $f89e874adec4a5d6$export$2de13e891a662beb),
    onPrefetch: undefined,
    query: {},
    route: (0, $f89e874adec4a5d6$export$4eadc79233226325),
    routes: [],
    unlisten: null,
    plugins: []
};
const $d7dd1b3b8cc777cb$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = "", history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $7040b2dec5a7dddb$export$a0bd0313cbeabd49)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $40dc7ae0aadcfdfd$export$455cc18296abe008)()) dispatch($d7dd1b3b8cc777cb$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $7040b2dec5a7dddb$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $7bf0d9fdaa35eb7b$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $670af8fa19d94fbd$export$712ea50be43a7858)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $7bf0d9fdaa35eb7b$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $7bf0d9fdaa35eb7b$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $b3b09a7589a73470$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, attributes, {
                basePath: basePath
            }));
            (0, $4366c52d36621328$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $7bf0d9fdaa35eb7b$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $7bf0d9fdaa35eb7b$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $b3b09a7589a73470$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, attributes, {
                basePath: basePath
            }));
            (0, $4366c52d36621328$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ("goBack" in history) history.goBack();
            else if ("back" in history) history.back();
            else throw new Error("History does not support goBack");
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ("goForward" in history) history.goForward();
            else if ("forward" in history) history.forward();
            else throw new Error("History does not support goForward");
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = "push")=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $7bf0d9fdaa35eb7b$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $7bf0d9fdaa35eb7b$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = "push")=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, existingPathParams, params);
            const updatedPath = (0, $3b1df627ec2bc28b$export$82476f982757e71e)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $7bf0d9fdaa35eb7b$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $7bf0d9fdaa35eb7b$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $d7dd1b3b8cc777cb$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $7bf0d9fdaa35eb7b$export$2fa6dede99f181e5)(path)) {
                const location = (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)((0, $7bf0d9fdaa35eb7b$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $7040b2dec5a7dddb$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $670af8fa19d94fbd$export$712ea50be43a7858)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $d7dd1b3b8cc777cb$export$1cf0ecab63b1963c = (0, $abf782f06879c350$export$f51a9068ac82ea43)({
    initialState: $d7dd1b3b8cc777cb$export$36d128238e6b60f5,
    actions: $d7dd1b3b8cc777cb$var$actions,
    name: "router"
});
const $d7dd1b3b8cc777cb$export$d6b817abe7a77ea5 = (0, $8506a449c87a280c$export$26ae5ca175b4ec5a)($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c, {
    displayName: "RouterContainer",
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($d7dd1b3b8cc777cb$var$actions.bootstrapStore(props));
            !(0, $40dc7ae0aadcfdfd$export$455cc18296abe008)() && dispatch($d7dd1b3b8cc777cb$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $40dc7ae0aadcfdfd$export$455cc18296abe008)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $d7dd1b3b8cc777cb$export$9569010eab09ae9e = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c);
const $d7dd1b3b8cc777cb$export$ada49399abf7a3a1 = (0, $b11c197a6f748a78$export$7c643e1d6648e418)($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c);
function $d7dd1b3b8cc777cb$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $d7dd1b3b8cc777cb$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $61bf82a671dbe4e0$export$9d726ae4880b1060).getStore($d7dd1b3b8cc777cb$export$1cf0ecab63b1963c);
const $d7dd1b3b8cc777cb$export$ebf37f7e180b13a9 = ()=>$d7dd1b3b8cc777cb$export$5ccad187366c8494().storeState.getState();


const $ea45ac0bebb723d5$export$9a302a45f65d0572 = (0, $d7dd1b3b8cc777cb$export$9569010eab09ae9e);


class $872831f5c7989038$var$Redirector extends (0, $acw62.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === "object" ? "path" in to ? (0, $6d23e34a443a4a03$export$fe53371bee54353d)((0, $b3b09a7589a73470$export$37e0729cc751960b)(to.path, routeAttributes)) : (0, $6d23e34a443a4a03$export$fe53371bee54353d)(to) : to;
        const currentPath = (0, $6d23e34a443a4a03$export$fe53371bee54353d)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($872831f5c7989038$var$Redirector, "defaultProps", {
    push: false
});
const $872831f5c7989038$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($872831f5c7989038$var$Redirector, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        actions: actions,
        location: location
    }, props));
};



var $3p9rK = parcelRequire("3p9rK");


var $acw62 = parcelRequire("acw62");

const $54d5bb126d55fb0e$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d7dd1b3b8cc777cb$export$d6b817abe7a77ea5), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $54d5bb126d55fb0e$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $acw62.useMemo)(()=>(0, $6d23e34a443a4a03$export$2b76ad033c6e6d08)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($54d5bb126d55fb0e$export$55185c17a0fcbe46, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}



var $acw62 = parcelRequire("acw62");

const $9a1d980dc90c7cfe$export$402e82ff1b20594b = (0, $d7dd1b3b8cc777cb$export$ada49399abf7a3a1);


const $c5192386069651b8$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $9a1d980dc90c7cfe$export$402e82ff1b20594b)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(actions));
};
$c5192386069651b8$export$b371fa9cf762ad06.displayName = "RouterActions";



var $c05no = parcelRequire("c05no");

var $acw62 = parcelRequire("acw62");


const $aa3a0e8e98413b22$var$_excluded = [
    "listen"
];
const $aa3a0e8e98413b22$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $d7dd1b3b8cc777cb$export$9569010eab09ae9e)();
    const { listen: listen } = _ref, actions = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(_ref, $aa3a0e8e98413b22$var$_excluded);
    if (!state.unlisten && !(0, $40dc7ae0aadcfdfd$export$455cc18296abe008)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(state, actions));
};




var $acw62 = parcelRequire("acw62");


const $2b48cf5702e8d29d$var$createPathParamHook = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)((0, $d7dd1b3b8cc777cb$export$1cf0ecab63b1963c), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $2b48cf5702e8d29d$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $2b48cf5702e8d29d$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $acw62.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};



var $acw62 = parcelRequire("acw62");


const $1f125c4828fc1621$var$createQueryParamHook = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)((0, $d7dd1b3b8cc777cb$export$1cf0ecab63b1963c), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $1f125c4828fc1621$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $1f125c4828fc1621$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $acw62.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};





var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

const $1d0b9d2c09db05d6$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = "UNDEFINED";
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $1d0b9d2c09db05d6$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $1d0b9d2c09db05d6$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $d7dd1b3b8cc777cb$export$9569010eab09ae9e)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};





var $3p9rK = parcelRequire("3p9rK");

var $c05no = parcelRequire("c05no");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $af0f173a51e2a07e$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $acw62.useRef)();
    const schedule = (0, $acw62.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $acw62.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};


const $ae3337f73846c030$var$VALID_LINK_TYPES = [
    "a",
    "button"
];
const $ae3337f73846c030$export$855ece989b15eb57 = (type)=>$ae3337f73846c030$var$VALID_LINK_TYPES.includes(type) ? type : "a";


const $23982ddbe477671f$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $23982ddbe477671f$export$130b789831072f4c = (event)=>[
        "keypress",
        "keydown",
        "keyup"
    ].includes(event.type);


const $86967f23a8bebdcb$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $23982ddbe477671f$export$130b789831072f4c)(event) && event.key !== "Enter") return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $23982ddbe477671f$export$130b789831072f4c)(event) && event.key === "Enter" || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === "_self") && // let browser handle "target=_blank" etc.
    !(0, $23982ddbe477671f$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};




const $e14fbd57cc703bea$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $e14fbd57cc703bea$var$PREFETCH_DELAY = 225;
const $e14fbd57cc703bea$var$Link = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = "_self", replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = "a", params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(_ref, $e14fbd57cc703bea$var$_excluded);
    const routerActions = (0, $d7dd1b3b8cc777cb$export$ada49399abf7a3a1)();
    const { schedule: schedule, cancel: cancel } = (0, $af0f173a51e2a07e$export$d8e6abf214c9ec0f)($e14fbd57cc703bea$var$PREFETCH_DELAY);
    const validLinkType = (0, $ae3337f73846c030$export$855ece989b15eb57)(linkType);
    const [route, setRoute] = (0, $acw62.useState)(()=>{
        if (to && typeof to !== "string") {
            if ("then" in to) to.then((r)=>setRoute("default" in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== "string" ? route && (0, $6d23e34a443a4a03$export$fe53371bee54353d)((0, $b3b09a7589a73470$export$37e0729cc751960b)(route.path, routeAttributes)) || "" : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === "string" ? routeAttributes.basePath : "";
    const triggerPrefetch = (0, $acw62.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== "string" && !route) return;
        const context = typeof to !== "string" && route ? (0, $7040b2dec5a7dddb$export$faed15f35ddc6f99)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $acw62.useEffect)(()=>{
        if (prefetch === "mount") schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $86967f23a8bebdcb$export$706ad1af8096e280)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === "hover") schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === "hover") cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === "hover") schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === "hover") cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === "hover") {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $acw62.createElement)(validLinkType, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$e14fbd57cc703bea$var$Link.displayName = "Link";
var $e14fbd57cc703bea$export$2e2bcd8739ae039 = $e14fbd57cc703bea$var$Link;



var $acw62 = parcelRequire("acw62");

const $9c1d9ab94a99f286$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};






const $5c5fc49f89228450$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $7040b2dec5a7dddb$export$a0bd0313cbeabd49)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};





var $3p9rK = parcelRequire("3p9rK");

var $c05no = parcelRequire("c05no");

const $5fd4d2e98591a497$var$_excluded = [
    "children"
];
function $5fd4d2e98591a497$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5fd4d2e98591a497$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $5fd4d2e98591a497$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = "" } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $5fd4d2e98591a497$var$_objectWithoutPropertiesLoose(_ref, $5fd4d2e98591a497$var$_excluded);
        const api = useStore($5fd4d2e98591a497$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split("__")[0]})`;
    return Subscriber;
}




var $3p9rK = parcelRequire("3p9rK");
const $80a44afb3352f8a7$export$9ccb639b7a119f61 = ()=>Date.now();



var $3p9rK = parcelRequire("3p9rK");
const $0daa80f21dc00bb9$export$881d135f98d8d7d0 = 100;
const $0daa80f21dc00bb9$export$9ab5bdcb8a1d6c34 = false;
const $0daa80f21dc00bb9$export$12c1dc38ea1692da = 0;



var $3p9rK = parcelRequire("3p9rK");
const $09224ee6e0f14bb2$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $09224ee6e0f14bb2$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice, {
        expiresAt: $09224ee6e0f14bb2$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;


const $ac5914e1b54c512a$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};


class $1764d5cdabf9b060$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super("Resource timed out: " + message);
        this.name = "TimeoutError";
    }
}


const $0ed746462ed56ab8$export$37d3126be6549b13 = 10000;


function $722f2912d3f13ed9$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $ac5914e1b54c512a$export$58634b3a58ae66b7)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === "function" ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $1764d5cdabf9b060$export$66d311bf29d5c89c)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $0daa80f21dc00bb9$export$12c1dc38ea1692da));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)((0, $0ed746462ed56ab8$export$37d3126be6549b13))) : resourceMaxAge
    };
}



/**
 * Utility method to created async versions of getData functions
 */ const $9887148533011f1c$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $9887148533011f1c$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $9887148533011f1c$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === "number" ? arg.maxAge : (0, $0daa80f21dc00bb9$export$12c1dc38ea1692da),
        maxCache: typeof arg.maxCache === "number" ? arg.maxCache : (0, $0daa80f21dc00bb9$export$881d135f98d8d7d0),
        isBrowserOnly: typeof arg.isBrowserOnly === "boolean" ? arg.isBrowserOnly : (0, $0daa80f21dc00bb9$export$9ab5bdcb8a1d6c34),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};



var $3p9rK = parcelRequire("3p9rK");

var $3p9rK = parcelRequire("3p9rK");



/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $056ce9d2617b7d15$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $7072c7b2c523c18c$export$fa8e33c3301e2e94 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, (0, $056ce9d2617b7d15$export$2df85a734ff5ed27), {
        expiresAt: (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)((0, $0daa80f21dc00bb9$export$12c1dc38ea1692da)),
        accessedAt: (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)()
    });



var $c05no = parcelRequire("c05no");

var $3p9rK = parcelRequire("3p9rK");
function $36e20b00616847b7$var$_toPropertyKey(t) {
    var i = $36e20b00616847b7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $36e20b00616847b7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $36e20b00616847b7$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $36e20b00616847b7$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, prefetching, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $36e20b00616847b7$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($36e20b00616847b7$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, data, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $36e20b00616847b7$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $36e20b00616847b7$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(data, [
            type
        ].map($36e20b00616847b7$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(resourceForType, [
                key
            ].map($36e20b00616847b7$var$_toPropertyKey));
            setState({
                data: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };


var $2aa0415f4fbaaef9$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $2aa0415f4fbaaef9$var$fromEntries = ($2aa0415f4fbaaef9$var$_Object$fromEntries = Object.fromEntries) != null ? $2aa0415f4fbaaef9$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $2aa0415f4fbaaef9$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $2aa0415f4fbaaef9$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = "ResourceDependencyError";
    }
}
const $2aa0415f4fbaaef9$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error("execution is already in progress");
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($2aa0415f4fbaaef9$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($2aa0415f4fbaaef9$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error("execution reached an inconsistent state");
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($2aa0415f4fbaaef9$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $2aa0415f4fbaaef9$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($2aa0415f4fbaaef9$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $2aa0415f4fbaaef9$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$2aa0415f4fbaaef9$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $2aa0415f4fbaaef9$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($2aa0415f4fbaaef9$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $2aa0415f4fbaaef9$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($2aa0415f4fbaaef9$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $2aa0415f4fbaaef9$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($2aa0415f4fbaaef9$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $2aa0415f4fbaaef9$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $2aa0415f4fbaaef9$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $2aa0415f4fbaaef9$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(dependencyType, key)) || (0, $7072c7b2c523c18c$export$fa8e33c3301e2e94)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $36e20b00616847b7$export$11374758be89e40)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };





const $95b99fbe63b579ee$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $95b99fbe63b579ee$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$95b99fbe63b579ee$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));



const $2219ae4670107b19$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $2219ae4670107b19$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;


const $ac03685282beddca$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $2219ae4670107b19$export$740886389191c640)(nextRoute)) return [];
    if ((0, $2219ae4670107b19$export$221027ff1aa38f82)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $95b99fbe63b579ee$export$cd7fbe7e979df558)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $95b99fbe63b579ee$export$c616b176adf9ad4a)(resource, nextRouterStoreContext, resourceStoreContext)));
};



const $de5c3ff2ee0cf07c$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $de5c3ff2ee0cf07c$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $de5c3ff2ee0cf07c$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $de5c3ff2ee0cf07c$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $de5c3ff2ee0cf07c$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $36e20b00616847b7$export$d40f35dc5952864b)(type, keyTobeDeleted));
    };




// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $549026d620c8a374$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = "NonError";
        if (Error.captureStackTrace) Error.captureStackTrace(this, $549026d620c8a374$var$NonError);
    }
}
const $549026d620c8a374$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
const $549026d620c8a374$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $549026d620c8a374$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = "[Circular]";
    }
    for (const property of $549026d620c8a374$var$commonProperties)if (typeof from[property] === "string") to[property] = from[property];
    return to;
};
const $549026d620c8a374$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === "object" && value !== null) return $549026d620c8a374$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === "function") // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
const $549026d620c8a374$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $549026d620c8a374$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $549026d620c8a374$var$NonError(value);
};


const $9ded5038a8fc11a1$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $9ded5038a8fc11a1$var$isFresh = (resource)=>{
    if ($9ded5038a8fc11a1$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $9ded5038a8fc11a1$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === "TimeoutError") return false;
    if (resource.loading) return true;
    if ($9ded5038a8fc11a1$var$isFresh(resource)) return true;
    return false;
};



var $3p9rK = parcelRequire("3p9rK");
const $b194ee12835f929c$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;



const $b3237e0ad7d80117$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});




const $5d07b75cfb5fbe3b$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice) : (0, $7072c7b2c523c18c$export$fa8e33c3301e2e94)();
};
const $5d07b75cfb5fbe3b$export$6a0b1779210de0ee = (state)=>state.context;



const $cb32642adcae8951$var$_excluded = [
    "context"
], $cb32642adcae8951$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $cb32642adcae8951$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $36e20b00616847b7$export$d40f35dc5952864b)(type, key));
                dispatch((0, $2aa0415f4fbaaef9$export$7d1ffac63c68405d)(resource, (dependentResource)=>$cb32642adcae8951$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $36e20b00616847b7$export$d40f35dc5952864b)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(_getState, $cb32642adcae8951$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $5d07b75cfb5fbe3b$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, prevSlice, changes, {
                expiresAt: (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)(maxAge),
                accessedAt: (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)()
            });
            dispatch((0, $36e20b00616847b7$export$704f800f263b050e)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $2aa0415f4fbaaef9$export$7d1ffac63c68405d)(resource, (dependentResource)=>$cb32642adcae8951$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(type, key));
            if (cached && (0, $9ded5038a8fc11a1$export$399de8c43d0ece3c)(cached)) {
                if ((0, $9ded5038a8fc11a1$export$b25d2963b8a3488a)(cached)) {
                    const withResolvedPromise = (0, $b194ee12835f929c$export$2e4da1b414980956)(cached);
                    cached = (0, $09224ee6e0f14bb2$export$18d1d420fd588368)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)();
                dispatch((0, $36e20b00616847b7$export$704f800f263b050e)(type, key, cached));
                return cached;
            }
            return dispatch($cb32642adcae8951$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(type, key)) || (0, $7072c7b2c523c18c$export$fa8e33c3301e2e94)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $de5c3ff2ee0cf07c$export$89440b7623c2c75c)(resource, key));
            const loadingSlice = dispatch((0, $36e20b00616847b7$export$11374758be89e40)(type, key)) || (0, $722f2912d3f13ed9$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $2aa0415f4fbaaef9$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $36e20b00616847b7$export$704f800f263b050e)(type, key, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $2aa0415f4fbaaef9$export$7d1ffac63c68405d)(resource, (dependentResource)=>$cb32642adcae8951$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $1764d5cdabf9b060$export$66d311bf29d5c89c)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(type, key));
            const finalSlice = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $80a44afb3352f8a7$export$9ccb639b7a119f61)(),
                expiresAt: (0, $09224ee6e0f14bb2$export$b65d7ba7fbf150f1)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $36e20b00616847b7$export$704f800f263b050e)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $36e20b00616847b7$export$11374758be89e40)(type, key)) || (0, $722f2912d3f13ed9$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $2aa0415f4fbaaef9$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $36e20b00616847b7$export$1e32615dc8354436)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $2aa0415f4fbaaef9$export$7d1ffac63c68405d)(resource, (dependentResource)=>$cb32642adcae8951$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $cb32642adcae8951$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $2aa0415f4fbaaef9$export$5f7e1fd85734e71e)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $cb32642adcae8951$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $2aa0415f4fbaaef9$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $cb32642adcae8951$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $2aa0415f4fbaaef9$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $cb32642adcae8951$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $2aa0415f4fbaaef9$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $cb32642adcae8951$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($cb32642adcae8951$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $36e20b00616847b7$export$5fc90c33b03fffb)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $36e20b00616847b7$export$d40f35dc5952864b)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $40dc7ae0aadcfdfd$export$455cc18296abe008)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $2aa0415f4fbaaef9$export$f71a65c89c987a02)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$cb32642adcae8951$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $2aa0415f4fbaaef9$export$f71a65c89c987a02)(routerStoreContext.route.resources, resources, (resource)=>$cb32642adcae8951$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $b3237e0ad7d80117$export$3ceb62baab058c6b)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(_ref, $cb32642adcae8951$var$_excluded2);
                const deserializedError = !error ? null : (0, $549026d620c8a374$export$64cddc1e268e9046)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === "TimeoutError";
                return (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $b3237e0ad7d80117$export$3ceb62baab058c6b)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $549026d620c8a374$export$46ff38bc6bdea8fb)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $1764d5cdabf9b060$export$66d311bf29d5c89c) ? loading : false
                }))
};
const $cb32642adcae8951$export$94f50dade551bd01 = (0, $abf782f06879c350$export$f51a9068ac82ea43)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $cb32642adcae8951$export$e324594224ef24da,
    name: "router-resources"
});
const $cb32642adcae8951$export$cc90fb9c37c5589d = (0, $8506a449c87a280c$export$26ae5ca175b4ec5a)($cb32642adcae8951$export$94f50dade551bd01, {
    displayName: "ResourceContainer"
});
const $cb32642adcae8951$export$fee1a6213543bd78 = (0, $5fd4d2e98591a497$export$48f338a7e080595c)($cb32642adcae8951$export$94f50dade551bd01, {
    displayName: "ResourceSelectorSubscriber",
    selector: (state, props)=>(0, $5d07b75cfb5fbe3b$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $cb32642adcae8951$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $61bf82a671dbe4e0$export$9d726ae4880b1060).getStore($cb32642adcae8951$export$94f50dade551bd01);
const $cb32642adcae8951$export$ac3608e0bb357c7 = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)($cb32642adcae8951$export$94f50dade551bd01, {
    selector: (0, $5d07b75cfb5fbe3b$export$c9ed509724feb827)
});
const $cb32642adcae8951$export$98e41a62c9bef75e = (0, $b11c197a6f748a78$export$7c643e1d6648e418)($cb32642adcae8951$export$94f50dade551bd01);
const $cb32642adcae8951$export$e59f52df235ac7b3 = (0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)($cb32642adcae8951$export$94f50dade551bd01, {
    selector: (0, $5d07b75cfb5fbe3b$export$6a0b1779210de0ee)
});



const $5ee70daed3bb0fac$export$a9bc0bb87abc2c4c = "resources-plugin";
const $5ee70daed3bb0fac$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $cb32642adcae8951$export$6f6057d42352becb)().actions;
    const nextResources = (0, $ac03685282beddca$export$7cbbc763e2f3d65d)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $5ee70daed3bb0fac$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $cb32642adcae8951$export$6f6057d42352becb)().actions;
    const nextResources = (0, $ac03685282beddca$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $5ee70daed3bb0fac$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $cb32642adcae8951$export$6f6057d42352becb)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $5ee70daed3bb0fac$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $5ee70daed3bb0fac$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $5ee70daed3bb0fac$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $cb32642adcae8951$export$6f6057d42352becb)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $cb32642adcae8951$export$6f6057d42352becb)().actions;
            const nextResources = (0, $ac03685282beddca$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $cb32642adcae8951$export$6f6057d42352becb)().actions.getSafeData();
        }
    };
};



var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");



const $ed08430a367fa2fa$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $cb32642adcae8951$export$98e41a62c9bef75e)();
    const { getContext: getRouterContext } = (0, $d7dd1b3b8cc777cb$export$ada49399abf7a3a1)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $acw62.useMemo)(()=>(0, $b11c197a6f748a78$export$e7f733c8fc2b8a24)((0, $d7dd1b3b8cc777cb$export$1cf0ecab63b1963c), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $cb32642adcae8951$export$ac3608e0bb357c7)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $acw62.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $acw62.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $acw62.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $acw62.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $acw62.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};


const $6cb34cba151f3b47$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $ed08430a367fa2fa$export$9f6abfd74295843b)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children(result));
};




const $ccfe686fa15f1dbd$export$dee7bf9fc0ff48c3 = (fn)=>(0, $cb32642adcae8951$export$6f6057d42352becb)().storeState.subscribe(fn);




const $38e2e54fc73eaafe$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: "bar"
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ""
};







/**
 * Provided to the APP provider to use as the default router link component.
 *
 * This is necessary so Anchor components can perform SPA transitions.
 *
 * @see https://staging.atlassian.design/components/primitives/anchor/examples#router-links
 */ 
var $acw62 = parcelRequire("acw62");


const $3c939fdb4f38b8df$export$c62c1bf7572a3c0c = /*#__PURE__*/ (0, $acw62.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    // A basic link by passing a string as the component's `href` prop.
    if (typeof href === "string") return (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
        ref: ref,
        href: href,
        ...rest,
        children: children
    });
    // Advanced link configuration by passing an object as the
    // component's `href` prop
    return (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        ...rest,
        children: children
    });
});
$3c939fdb4f38b8df$export$c62c1bf7572a3c0c.displayName = "CustomRouterLink";




var $kYoXd = parcelRequire("kYoXd");

var $5Lqbi = parcelRequire("5Lqbi");
var $a9hho = parcelRequire("a9hho");
var $99ab2b0d4f97b94a$exports = {};
"use strict";
var $99ab2b0d4f97b94a$var$__createBinding = $99ab2b0d4f97b94a$exports && $99ab2b0d4f97b94a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $99ab2b0d4f97b94a$var$__exportStar = $99ab2b0d4f97b94a$exports && $99ab2b0d4f97b94a$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $99ab2b0d4f97b94a$var$__createBinding(exports1, m, p);
};
Object.defineProperty($99ab2b0d4f97b94a$exports, "__esModule", {
    value: true
});

$99ab2b0d4f97b94a$var$__exportStar((parcelRequire("2yjMv")), $99ab2b0d4f97b94a$exports);

$99ab2b0d4f97b94a$var$__exportStar((parcelRequire("5vuWi")), $99ab2b0d4f97b94a$exports);

$99ab2b0d4f97b94a$var$__exportStar((parcelRequire("6AwzT")), $99ab2b0d4f97b94a$exports);

$99ab2b0d4f97b94a$var$__exportStar((parcelRequire("1FExB")), $99ab2b0d4f97b94a$exports);

$99ab2b0d4f97b94a$var$__exportStar((parcelRequire("eWJCq")), $99ab2b0d4f97b94a$exports);


parcelRequire("acw62");



const $c8951a72a3bf9b47$export$271f9f08425019c7 = ()=>{
    const [routeState] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    if (routeState.match.path === "/") return (0, $7b02d682eb115277$exports.jsx)((0, $872831f5c7989038$export$2d8d895a0a0f636e), {
        to: "/"
    });
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Not Found"
    });
};





const $098873af10a85f8f$var$STATSIG_CLIENT_KEY = {
    staging: "00f6830e-2abf-458f-b2ad-10c1a238d343",
    production: "bf14aab7-117d-45e0-98ea-1e2e5efc2c39"
};
const $098873af10a85f8f$var$getEnvironment = ()=>{
    if (window.location.hostname.includes("atlassian.net")) return "production";
    return "staging";
};
const $098873af10a85f8f$export$b40ec24ac8275656 = (gateName)=>{
    (0, $5Lqbi.default).initializeCompleted();
    return (0, $5Lqbi.default).checkGate(gateName);
};
const $098873af10a85f8f$export$6084ad8a2ad35ad4 = ({ children: children })=>{
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { user: user } = (0, $690d3d7c4f641feb$export$69bbac602c81ca6e)();
    const onError = (err)=>{
        if (err) {
            console.error("STATSIG_CLIENT_ERROR", err);
            throw err;
        }
    };
    // If tenantContexts is empty, the user does not have access to the site.
    if (!tenantContexts?.length) return (0, $7b02d682eb115277$exports.jsx)((0, $c8951a72a3bf9b47$export$271f9f08425019c7), {});
    if (!user?.accountId || !tenantContexts[0].cloudId) throw new Error("User/Tenant Context is not set");
    const apiKey = $098873af10a85f8f$var$STATSIG_CLIENT_KEY[$098873af10a85f8f$var$getEnvironment()];
    if (!apiKey) throw new Error("STATSIG_CLIENT_API_KEY is not set");
    const atlassianAccountId = user.accountId;
    const { cloudId: cloudId } = tenantContexts[0];
    return (0, $7b02d682eb115277$exports.jsx)((0, $99ab2b0d4f97b94a$exports.FeatureGatesInitialization), {
        options: {
            apiKey: apiKey,
            environment: $098873af10a85f8f$var$getEnvironment() === "staging" ? (0, $a9hho.FeatureGateEnvironment).Staging : (0, $a9hho.FeatureGateEnvironment).Production,
            targetApp: "dev-agents_web",
            fetchTimeoutMs: 1000,
            useGatewayURL: true
        },
        identifiers: {
            atlassianAccountId: atlassianAccountId,
            tenantId: cloudId
        },
        initializingComponent: (0, $7b02d682eb115277$exports.jsx)((0, $bb6557fb29c1ef20$export$44c18d210d5de37b), {}),
        onReady: onError,
        children: children
    });
};




var $acw62 = parcelRequire("acw62");
const $927556e5474cebfb$export$bba6f4c37972feaa = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $927556e5474cebfb$export$a0210e79452e8007 = ()=>{
    const context = (0, $acw62.useContext)($927556e5474cebfb$export$bba6f4c37972feaa);
    if (!context) throw new Error("useUserPermData must be used within a UseUserPermContext");
    return context;
};



var $0ad252b79ab48383$var$_userPermContextProviderQuery;

const $0ad252b79ab48383$export$5677d1adf0a1908a = ({ children: children, queryRef: queryRef })=>{
    const data = (0, $2d93712440e0508b$exports.usePreloadedQuery)($0ad252b79ab48383$var$_userPermContextProviderQuery !== void 0 ? $0ad252b79ab48383$var$_userPermContextProviderQuery : $0ad252b79ab48383$var$_userPermContextProviderQuery = (parcelRequire("kYoXd")), queryRef);
    const userPerms = {
        rovoDevAgentsUser: {
            hasProductAccess: data.devai_rovoDevAgentsUser?.hasProductAccess || false,
            isAdmin: data.devai_rovoDevAgentsUser?.isAdmin || false
        }
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $927556e5474cebfb$export$bba6f4c37972feaa).Provider, {
        value: userPerms,
        children: children
    });
};





var $fUHKi = parcelRequire("fUHKi");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $f9d9fd34a2dcabbd$var$flexGrowMap = {
    hug: (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $f9d9fd34a2dcabbd$var$separatorStyles = (0, $jjlaj.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $f9d9fd34a2dcabbd$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $jjlaj.jsx)("span", {
        css: $f9d9fd34a2dcabbd$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $f9d9fd34a2dcabbd$var$Inline = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $jjlaj.jsx)($f9d9fd34a2dcabbd$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $acw62.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $jjlaj.jsx)((0, $acw62.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $f9d9fd34a2dcabbd$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jjlaj.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$f9d9fd34a2dcabbd$var$Inline.displayName = "Inline";
var $f9d9fd34a2dcabbd$export$2e2bcd8739ae039 = $f9d9fd34a2dcabbd$var$Inline;


const $b3c27da72be923c3$export$5d5930b97498321d = "/";
const $b3c27da72be923c3$export$d278c9a4e4cdafa2 = "/code-reviewer";
const $b3c27da72be923c3$export$122dbbe6a3dd8f50 = "/code-planner";
const $b3c27da72be923c3$export$87368091a36693a3 = "/flow";
const $b3c27da72be923c3$export$f3344f66f55069d1 = "/flow/create/embed";
const $b3c27da72be923c3$export$aba8de7a7c35cfeb = "/flow/s/:flowId";
const $b3c27da72be923c3$export$8c7edd817b46b0f5 = "/flow/s/:flowId/code";



const $f7f0296dce984358$export$f855a9abeb935dca = "data:image/png;base64,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";
const $f7f0296dce984358$var$logoStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "32px",
    height: "32px",
    background: `url(${$f7f0296dce984358$export$f855a9abeb935dca}) no-repeat center center`,
    backgroundSize: "contain"
});
const $f7f0296dce984358$var$linkStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    },
    ":visited": {
        textDecoration: "none"
    }
});
const $f7f0296dce984358$export$e6ff31bff12b7ff4 = ()=>(0, $7b02d682eb115277$exports.jsx)((0, $11cad149381bd130$export$2e2bcd8739ae039), {
        href: (0, $b3c27da72be923c3$export$87368091a36693a3),
        xcss: $f7f0296dce984358$var$linkStyles,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
            space: "space.200",
            alignBlock: "center",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                    xcss: $f7f0296dce984358$var$logoStyles
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                        size: "small",
                        children: "Boysenberry"
                    })
                })
            ]
        })
    });


/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $efc76caa3f4e1993$export$babe3c784778f3ba = /*#__PURE__*/ (0, $acw62.forwardRef)($efc76caa3f4e1993$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
var $efc76caa3f4e1993$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
function $efc76caa3f4e1993$var$_SideNavContent(_ref, ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $5zphJ.default)([
            $efc76caa3f4e1993$var$styles.scrollContainer
        ])
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $5zphJ.default)([
            $efc76caa3f4e1993$var$styles.paddingContainer
        ])
    }, children));
}



var $ee32a0ae812c612c$export$d4c4e98c5044dc8 = (0, $8baf40fa10b11784$export$54c2e3dc7acea9f5);



var $acw62 = parcelRequire("acw62");





var $4q3AQ = parcelRequire("4q3AQ");

var $b9569ae36860c8eb$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b9569ae36860c8eb$exports, "__esModule", {
    value: true
});
$b9569ae36860c8eb$exports.default = void 0;

var $b9569ae36860c8eb$var$_react = $b9569ae36860c8eb$var$_interopRequireDefault((parcelRequire("acw62")));

var $b9569ae36860c8eb$var$_baseNew = $b9569ae36860c8eb$var$_interopRequireDefault((parcelRequire("fqFky")));
function $b9569ae36860c8eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9569ae36860c8eb$var$AddIcon = (props)=>/*#__PURE__*/ $b9569ae36860c8eb$var$_react.default.createElement($b9569ae36860c8eb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$b9569ae36860c8eb$var$AddIcon.displayName = "AddIcon";
var $b9569ae36860c8eb$var$_default = $b9569ae36860c8eb$exports.default = $b9569ae36860c8eb$var$AddIcon;


var $5c97e6b36a7bc9b8$exports = {};
"use strict";
Object.defineProperty($5c97e6b36a7bc9b8$exports, "__esModule", {
    value: true
});
$5c97e6b36a7bc9b8$exports.default = void 0;

var $5c97e6b36a7bc9b8$var$_react = $5c97e6b36a7bc9b8$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $5c97e6b36a7bc9b8$var$_file = $5c97e6b36a7bc9b8$var$_interopRequireDefault((parcelRequire("aFWKD")));
function $5c97e6b36a7bc9b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5c97e6b36a7bc9b8$var$FileIcon = (props)=>/*#__PURE__*/ $5c97e6b36a7bc9b8$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/><rect width="8" height="2" x="8" y="12" rx="1"/><rect width="4" height="2" x="8" y="15" rx="1"/></g></svg>`
    }, props, {
        newIcon: $5c97e6b36a7bc9b8$var$_file.default
    }));
$5c97e6b36a7bc9b8$var$FileIcon.displayName = "FileIcon";
var $5c97e6b36a7bc9b8$var$_default = $5c97e6b36a7bc9b8$exports.default = $5c97e6b36a7bc9b8$var$FileIcon;




var $acw62 = parcelRequire("acw62");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

function $1a92f85ba0e22d9c$var$_ListItem(_ref, ref) {
    var children = _ref.children, xcss = _ref.xcss;
    return /*#__PURE__*/ $acw62.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss
    }, children);
}
var $1a92f85ba0e22d9c$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $acw62.forwardRef)($1a92f85ba0e22d9c$var$_ListItem);


var $114d0e1ed852f5d8$export$6c2f3257abc4825b = (0, $1a92f85ba0e22d9c$export$a7b06bfba60a8a78);



var $acw62 = parcelRequire("acw62");

var $bv4qN = parcelRequire("bv4qN");
var $f39ecb7fd4cc9bc0$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $f39ecb7fd4cc9bc0$export$8100cda602411810 = function useMenuSectionContext() {
    var context = (0, $acw62.useContext)($f39ecb7fd4cc9bc0$export$728ac99b9c7eea8a);
    (0, $bv4qN.default)(context, "useMenuSectionContext must be used within a MenuSection");
    return context;
};


var $983ce119fc15eacb$export$4b1545b4f2016d26 = function MenuSection(_ref) {
    var children = _ref.children, _ref$isMenuListItem = _ref.isMenuListItem, isMenuListItem = _ref$isMenuListItem === void 0 ? false : _ref$isMenuListItem;
    var id = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    var Wrapper = isMenuListItem ? (0, $114d0e1ed852f5d8$export$6c2f3257abc4825b) : (0, $acw62.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f39ecb7fd4cc9bc0$export$728ac99b9c7eea8a).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-labelledby": "".concat(id, "-heading")
    }, children)));
};

/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $d5a1d224e04d4791$var$styles = {
    root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
};
var $d5a1d224e04d4791$export$5d3acdbf9237a364 = function MenuSectionHeading(_ref) {
    var children = _ref.children;
    var id = (0, $f39ecb7fd4cc9bc0$export$8100cda602411810)();
    return /*#__PURE__*/ $acw62.createElement("h2", {
        id: "".concat(id, "-heading"),
        className: (0, $5zphJ.default)([
            $d5a1d224e04d4791$var$styles.root
        ])
    }, children);
};



var $acw62 = parcelRequire("acw62");



const $2cf4acc76693ef07$export$6510e166e79b4e5c = ()=>{
    return (0, $3b1df627ec2bc28b$export$82476f982757e71e)((0, $b3c27da72be923c3$export$87368091a36693a3));
};
const $2cf4acc76693ef07$export$ba128a57e6df3736 = (flowId)=>{
    return (0, $3b1df627ec2bc28b$export$82476f982757e71e)((0, $b3c27da72be923c3$export$aba8de7a7c35cfeb), {
        flowId: flowId
    });
};
const $2cf4acc76693ef07$export$f9c9ceb569f226b1 = (flowId)=>{
    return (0, $3b1df627ec2bc28b$export$82476f982757e71e)((0, $b3c27da72be923c3$export$8c7edd817b46b0f5), {
        flowId: flowId
    });
};




var $kHyiL = parcelRequire("kHyiL");

var $acw62 = parcelRequire("acw62");
const $34c4c68c6fb9a758$export$4203fb010fad9bf0 = new WeakMap();
const $34c4c68c6fb9a758$export$b8b9d90f9e5bd72b = "react-magnetic-di";



const $0528f92d33aa6023$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $0528f92d33aa6023$export$7804429c45dff272 = {
    state: $0528f92d33aa6023$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $0528f92d33aa6023$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};


let $3c708412a153aa8d$var$hasWarned = false;
function $3c708412a153aa8d$export$5b28268982f175ba(message) {
    if (!$3c708412a153aa8d$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn("Warning:", message);
        $3c708412a153aa8d$var$hasWarned = true;
    }
}
function $3c708412a153aa8d$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $34c4c68c6fb9a758$export$4203fb010fad9bf0).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $0528f92d33aa6023$export$7804429c45dff272).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $3c708412a153aa8d$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $34c4c68c6fb9a758$export$4203fb010fad9bf0).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $3c708412a153aa8d$export$be63e0664592e141(Comp, wrapper = "") {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $3c708412a153aa8d$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $3c708412a153aa8d$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $0528f92d33aa6023$export$7804429c45dff272).track(candidate);
    return candidate;
}


const $bf371cfad43a56b7$var$replacementMap = new Map();
const $bf371cfad43a56b7$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($bf371cfad43a56b7$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $3c708412a153aa8d$export$7c436e151c3ee289)($bf371cfad43a56b7$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($bf371cfad43a56b7$var$replacementMap.size) throw new Error(`${(0, $34c4c68c6fb9a758$export$b8b9d90f9e5bd72b)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $3c708412a153aa8d$export$7a7134bdd2f9ae2e)($bf371cfad43a56b7$var$replacementMap, inj));
    },
    clear () {
        $bf371cfad43a56b7$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $34c4c68c6fb9a758$export$4203fb010fad9bf0).get(inj).global) (0, $3c708412a153aa8d$export$7a7134bdd2f9ae2e)($bf371cfad43a56b7$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $3c708412a153aa8d$export$8057a2244a849b7b)($bf371cfad43a56b7$var$replacementMap, inj));
    }
};
function $bf371cfad43a56b7$export$b887ce09d70113f9(thunk, deps) {
    $bf371cfad43a56b7$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === "object" && typeof result.then === "function" && typeof result.finally === "function") result.finally($bf371cfad43a56b7$export$a775919ebd7dd28a.clear);
        else $bf371cfad43a56b7$export$a775919ebd7dd28a.clear();
    }
}


const $8823ba9f1c641715$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    getDependencies: (0, $bf371cfad43a56b7$export$a775919ebd7dd28a).getDependencies
});



function $868ad208b5b0fa15$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $8823ba9f1c641715$export$841858b892ce1f4c)._currentRenderer2 && (0, $8823ba9f1c641715$export$841858b892ce1f4c)._currentValue2 || // grab value from default renderer
    (0, $8823ba9f1c641715$export$841858b892ce1f4c)._currentValue || (0, $bf371cfad43a56b7$export$a775919ebd7dd28a);
    return getDependencies(deps, target);
}










var $4q3AQ = parcelRequire("4q3AQ");
function $a9fa3d0bb0d11e02$export$7ad44063fdf1b9d(serializedAdditionalInfo) {
    try {
        return JSON.parse(serializedAdditionalInfo);
    } catch (error) {
        return {
            gitUserName: "",
            gitUserEmail: "",
            branchName: "",
            prompt: ""
        };
    }
}
const $a9fa3d0bb0d11e02$export$8dc403c19fc3ad11 = (additionalInfo)=>{
    try {
        return JSON.stringify(additionalInfo);
    } catch (error) {
        console.error("Error serializing additional info:", error);
        return "";
    }
};


function $bc5fb7cfd344e236$export$e3fb9aaa7acd7fc1(serializedIssue) {
    try {
        return JSON.parse(serializedIssue);
    } catch (error) {
        return {
            key: "",
            summary: "",
            description: "",
            icon: ""
        };
    }
}
const $bc5fb7cfd344e236$export$ec791a71e388933b = (issue)=>{
    try {
        return JSON.stringify(issue);
    } catch (error) {
        console.error("Error serializing issue:", error);
        return "";
    }
};



var $b827bd2eb59618e8$var$_useCreateFlowMutation;

const $b827bd2eb59618e8$export$bfb165159aabd81d = ()=>{
    (0, $868ad208b5b0fa15$export$479d1ccc5f2ab701)();
    const [, routerActions] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { cloudId: cloudId } = tenantContexts[0];
    const { user: user } = (0, $690d3d7c4f641feb$export$69bbac602c81ca6e)();
    const [, loadQuery] = (0, $2d93712440e0508b$exports.useQueryLoader)((0, $4q3AQ.default));
    const { showFlag: showFlag } = (0, $eb77deb211f1d0a4$export$2879604e6aec4ab)();
    const refreshSidebarQuery = ()=>{
        if (user?.accountId) loadQuery({
            creator: user.accountId,
            cloudId: cloudId
        }, {
            fetchPolicy: "store-and-network"
        });
    };
    const [commit, isPending] = (0, $2d93712440e0508b$exports.useMutation)($b827bd2eb59618e8$var$_useCreateFlowMutation !== void 0 ? $b827bd2eb59618e8$var$_useCreateFlowMutation : $b827bd2eb59618e8$var$_useCreateFlowMutation = (parcelRequire("i4oav")));
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    const createSession = ({ issueARI: issueARI, repoUrl: repoUrl, issue: issue, branchName: branchName, prompt: prompt, onSuccess: onSuccess })=>{
        const additionalInfo = {
            gitUserName: user?.name ?? "",
            gitUserEmail: user?.email ?? "",
            branchName: branchName,
            prompt: prompt ?? ""
        };
        commit({
            variables: {
                issueARI: issueARI ?? null,
                cloudId: cloudId,
                createdBy: user?.accountId ?? "",
                repoUrl: repoUrl,
                jiraHost: (0, $a2299f428347f042$export$e61aef4ae55da883)(),
                jiraIssueJSON: issue ? (0, $bc5fb7cfd344e236$export$ec791a71e388933b)(issue) : null,
                additionalInfoJSON: (0, $a9fa3d0bb0d11e02$export$8dc403c19fc3ad11)(additionalInfo)
            },
            onCompleted: (response)=>{
                const sessionId = response.devai_flowCreate?.id;
                if (sessionId) {
                    refreshSidebarQuery();
                    const flowRoute = (0, $2cf4acc76693ef07$export$ba128a57e6df3736)(sessionId);
                    routerActions.push(flowRoute);
                    analyticsWebClient.sendTrackEvent({
                        action: "create",
                        actionSubject: "session",
                        source: "use-create-flow"
                    });
                    onSuccess?.();
                }
            },
            onError: (error)=>{
                const dismiss = showFlag({
                    id: "create-flow-error",
                    title: "Couldn't create a flow",
                    description: error.message,
                    icon: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHyiL))), {
                        label: "Warning",
                        primaryColor: "var(--ds-icon-warning, #E56910)"
                    }),
                    actions: [
                        {
                            content: "Dismiss",
                            onClick: ()=>dismiss()
                        }
                    ]
                });
            }
        });
    };
    return [
        createSession,
        isPending
    ];
};



var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $34f6623b57e1a1c8$exports = {};

$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_GROUP", () => $34f6623b57e1a1c8$export$4f9a06cb7441a087);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_DISABLED", () => $34f6623b57e1a1c8$export$aeda8252e54b50f7);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_ALLOW", () => $34f6623b57e1a1c8$export$54ecf528c58f9ef6);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_AUTO", () => $34f6623b57e1a1c8$export$70e9b4a1820af101);
$parcel$export($34f6623b57e1a1c8$exports, "FOCUS_NO_AUTOFOCUS", () => $34f6623b57e1a1c8$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $34f6623b57e1a1c8$export$4f9a06cb7441a087 = "data-focus-lock";
var $34f6623b57e1a1c8$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $34f6623b57e1a1c8$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $34f6623b57e1a1c8$export$70e9b4a1820af101 = "data-autofocus-inside";
var $34f6623b57e1a1c8$export$134ebef29fd94853 = "data-no-autofocus";



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $acw62 = parcelRequire("acw62");

var $119d56c93ccd46db$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $119d56c93ccd46db$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }));
};
$119d56c93ccd46db$var$InFocusGuard.propTypes = {};
var $119d56c93ccd46db$export$2e2bcd8739ae039 = $119d56c93ccd46db$var$InFocusGuard;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $292937b69072d1e6$export$5733e022b1d538cb = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $292937b69072d1e6$export$b3e9a9312f73723c = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$3a1d52767cbc07b8 = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$892cbf28e5518020 = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)({
    async: true,
    ssr: typeof document !== "undefined"
});



var $acw62 = parcelRequire("acw62");
var $8e648ed3a7dabece$export$f5272e9b1168239c = /*#__PURE__*/ (0, $acw62.createContext)(undefined);


var $e86725766b4cde33$var$emptyArray = [];
var $e86725766b4cde33$var$FocusLock = /*#__PURE__*/ (0, $acw62.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $acw62.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $acw62.useRef)();
    var isActive = (0, $acw62.useRef)(false);
    var originalFocusedElement = (0, $acw62.useRef)(null);
    var _useState2 = (0, $acw62.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $e86725766b4cde33$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $acw62.useState)({}), id = _useState3[0];
    var onActivation = (0, $acw62.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $acw62.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $acw62.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === "function" ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $acw62.useCallback)(function(event) {
        if (isActive.current) (0, $292937b69072d1e6$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $292937b69072d1e6$export$b3e9a9312f73723c).useMedium;
    var setObserveNode = (0, $acw62.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $8nd05.default)((_extends2 = {}, _extends2[0, $34f6623b57e1a1c8$export$aeda8252e54b50f7] = disabled && "disabled", _extends2[0, $34f6623b57e1a1c8$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $acw62.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SideCar, {
        id: id,
        sideCar: (0, $292937b69072d1e6$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, (0, $8nd05.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8e648ed3a7dabece$export$f5272e9b1168239c).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
    }));
});
$e86725766b4cde33$var$FocusLock.propTypes = {};
var $e86725766b4cde33$export$2e2bcd8739ae039 = $e86725766b4cde33$var$FocusLock;



var $acw62 = parcelRequire("acw62");

function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $acw62 = parcelRequire("acw62");
function $bec73a156e960f78$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $acw62.PureComponent));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $bec73a156e960f78$export$2e2bcd8739ae039 = $bec73a156e960f78$var$withSideEffect;


/*
IE11 support
 */ var $c2cb5aa387a37a50$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $c2cb5aa387a37a50$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $c2cb5aa387a37a50$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};



var $2cff22612808ae96$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $2cff22612808ae96$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $2cff22612808ae96$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $2cff22612808ae96$var$isInert = function(node) {
    return node.hasAttribute("inert");
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $2cff22612808ae96$var$isVisibleUncached = function(node, checkParent) {
    return !node || $2cff22612808ae96$var$isTopNode(node) || !$2cff22612808ae96$var$isElementHidden(node) && !$2cff22612808ae96$var$isInert(node) && checkParent($2cff22612808ae96$var$getParentNode(node));
};
var $2cff22612808ae96$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isVisibleUncached(node, $2cff22612808ae96$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $2cff22612808ae96$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$2cff22612808ae96$var$isTopNode(node) ? $2cff22612808ae96$export$b8550e27de209d85(node) ? checkParent($2cff22612808ae96$var$getParentNode(node)) : false : true;
};
var $2cff22612808ae96$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isAutoFocusAllowedUncached(node, $2cff22612808ae96$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $2cff22612808ae96$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $2cff22612808ae96$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $2cff22612808ae96$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $2cff22612808ae96$export$9d74f6fbc6f469d0 = function(node) {
    return $2cff22612808ae96$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $2cff22612808ae96$export$8197b0ea56b3b055 = function(node) {
    return !(($2cff22612808ae96$export$88a6ceeed5737ba3(node) || $2cff22612808ae96$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $2cff22612808ae96$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $34f6623b57e1a1c8$export$134ebef29fd94853));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $2cff22612808ae96$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $2cff22612808ae96$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $2cff22612808ae96$export$602e5a0d338d7750 = function(node) {
    return !$2cff22612808ae96$export$d94b8b58ec2f30eb(node);
};
var $2cff22612808ae96$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $e6301f5798625d25$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $e6301f5798625d25$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute("tabindex")) return 0;
    }
    return node.tabIndex;
};
var $e6301f5798625d25$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).map(function(node, index) {
        var tabIndex = $e6301f5798625d25$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($e6301f5798625d25$export$350ee6c095d98996);
};




/**
 * list of the object to be considered as focusable
 */ var $9fc4580037f02fd3$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];


var $c85a3cad3fc06f20$var$queryTabbables = (0, $9fc4580037f02fd3$export$8555f4622e95784).join(",");
var $c85a3cad3fc06f20$var$queryGuardTabbables = "".concat($c85a3cad3fc06f20$var$queryTabbables, ", [data-focus-guard]");
var $c85a3cad3fc06f20$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $c85a3cad3fc06f20$var$queryGuardTabbables : $c85a3cad3fc06f20$var$queryTabbables) ? [
            child
        ] : [], $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $c85a3cad3fc06f20$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $c85a3cad3fc06f20$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $c85a3cad3fc06f20$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $c85a3cad3fc06f20$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parent.parentNode.querySelectorAll($c85a3cad3fc06f20$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $c85a3cad3fc06f20$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$70e9b4a1820af101), "]"));
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $c85a3cad3fc06f20$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $9b74641517b143d6$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $2cff22612808ae96$export$8197b0ea56b3b055)(node);
    });
};
var $9b74641517b143d6$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$bcaa50628f6a736e)(cache, node);
    });
};
var $9b74641517b143d6$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $9b74641517b143d6$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $9b74641517b143d6$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$853fa94d922e78b9)(topNode), visibilityCache);
};
var $9b74641517b143d6$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $9b74641517b143d6$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $9b74641517b143d6$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $9b74641517b143d6$export$2344b14b097df817(child, element);
        });
    }
};


function $e8393b55a6e31e11$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === "undefined") return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $e8393b55a6e31e11$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $e8393b55a6e31e11$var$weakRef(currentElement),
            parent: $e8393b55a6e31e11$var$weakRef(currentElement.parentElement),
            left: $e8393b55a6e31e11$var$weakRef(currentElement.previousElementSibling),
            right: $e8393b55a6e31e11$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $e8393b55a6e31e11$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $e8393b55a6e31e11$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $9b74641517b143d6$export$3738e313571e2ad2)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $e8393b55a6e31e11$export$d357db6e554ff59a = function(targetElement) {
    var location = $e8393b55a6e31e11$export$5061a7725be48ff9(targetElement);
    return function() {
        return $e8393b55a6e31e11$var$restoreFocusTo(location);
    };
};



/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $7bf194f892d90e1b$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $7bf194f892d90e1b$var$getTopParent = function(node) {
    return node.parentNode ? $7bf194f892d90e1b$var$getTopParent(node.parentNode) : node;
};
var $7bf194f892d90e1b$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $7bf194f892d90e1b$var$filterNested((0, $c2cb5aa387a37a50$export$45b10814cc054894)($7bf194f892d90e1b$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087), '="').concat(group, '"]:not([').concat((0, $34f6623b57e1a1c8$export$aeda8252e54b50f7), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};





var $51d90458d728fe34$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $51d90458d728fe34$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $51d90458d728fe34$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $51d90458d728fe34$var$getParents(nodeA);
    var parentsB = $51d90458d728fe34$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $51d90458d728fe34$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $51d90458d728fe34$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $51d90458d728fe34$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $9b74641517b143d6$export$2344b14b097df817)(common, topCommon)) topCommon = common;
                else topCommon = $51d90458d728fe34$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $51d90458d728fe34$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $9b74641517b143d6$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};




var $3f73a80c2e676402$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var outerNodes = (0, $e6301f5798625d25$export$cb40ee071f0d5226)((0, $c85a3cad3fc06f20$export$f6768025e418420e)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $c85a3cad3fc06f20$export$f6768025e418420e)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(node)
        };
    });
};

var $2bf5fb6846f8e2c5$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};




var $b394242c3b6cfaf1$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error("no element or scope given");
        return {};
    }
    var shards = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(scope);
    if (shards.every(function(shard) {
        return !(0, $9b74641517b143d6$export$2344b14b097df817)(shard, element);
    })) {
        console.error("Active element is not contained in the scope");
        return {};
    }
    var focusables = useTabbables ? (0, $9b74641517b143d6$export$3738e313571e2ad2)(shards, new Map()) : (0, $9b74641517b143d6$export$493d05a3a8e6532d)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $b394242c3b6cfaf1$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $9b74641517b143d6$export$3738e313571e2ad2)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(shards), new Map()) : (0, $9b74641517b143d6$export$493d05a3a8e6532d)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $b394242c3b6cfaf1$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $b394242c3b6cfaf1$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $b394242c3b6cfaf1$var$defaultOptions(options);
    var solution = $b394242c3b6cfaf1$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $2bf5fb6846f8e2c5$export$c12b3da842c43a8)(target.node, newOptions.focusOptions);
};
var $b394242c3b6cfaf1$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $b394242c3b6cfaf1$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $b394242c3b6cfaf1$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $b394242c3b6cfaf1$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $2bf5fb6846f8e2c5$export$c12b3da842c43a8)(node.node, options.focusOptions);
};
var $b394242c3b6cfaf1$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$pickBoundary(scope, options, "first");
};
var $b394242c3b6cfaf1$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $b394242c3b6cfaf1$var$pickBoundary(scope, options, "last");
};




/**
 * returns active element from document or from nested shadowdoms
 */ var $f296cb52f860ecc3$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};


var $b5783d59678393a3$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $f296cb52f860ecc3$export$78d20aae35adef88)(function() {
        return activeElement.contentWindow.document;
    }) ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};


var $eec3e0cab722c011$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $eec3e0cab722c011$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $c2cb5aa387a37a50$export$45b10814cc054894)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $eec3e0cab722c011$var$focusInFrame(node, activeElement);
    }));
};
var $eec3e0cab722c011$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement) || $eec3e0cab722c011$var$focusInsideIframe(node, activeElement);
    });
};





var $4a4957b2dfe49f02$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(inDocument.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$54ecf528c58f9ef6), "]"))).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement);
    });
};








var $3315685220e94b72$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $3315685220e94b72$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)(node) && node.name) return $3315685220e94b72$var$findSelectedRadio(node, nodes);
    return node;
};
var $3315685220e94b72$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($3315685220e94b72$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $550b7510239b204f$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $3315685220e94b72$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $550b7510239b204f$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $3315685220e94b72$export$5261662167ad7ced)(node, nodes));
};



var $5f30961e5fc5285a$export$85710b12cf912438 = "NEW_FOCUS";
var $5f30961e5fc5285a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $5f30961e5fc5285a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $5f30961e5fc5285a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $3315685220e94b72$export$4a5a72a7124e45f9)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};








var $0a6fd98cd390fe5b$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $2cff22612808ae96$export$698b339b0c8edae3)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $0a6fd98cd390fe5b$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $9b74641517b143d6$export$2f70373d403a5d2b)(nodes.filter($0a6fd98cd390fe5b$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)(autoFocusable);
    return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)((0, $9b74641517b143d6$export$2f70373d403a5d2b)(orderedNodes));
};





var $d862fa039a3b3c25$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $2cff22612808ae96$export$4e62c701997796c1));
};
var $d862fa039a3b3c25$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(topNode).length > 0 ? document : (0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $9b74641517b143d6$export$493d05a3a8e6532d)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $2cff22612808ae96$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $9b74641517b143d6$export$493d05a3a8e6532d)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $d862fa039a3b3c25$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $5f30961e5fc5285a$export$65842178e9bb4205)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $5f30961e5fc5285a$export$85710b12cf912438)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $0a6fd98cd390fe5b$export$cfb742983e257555)(anyFocusable, innerTabbable, (0, $51d90458d728fe34$export$8f99714c70a37db1)(entries, visibilityCache)) || (0, $0a6fd98cd390fe5b$export$cfb742983e257555)(anyFocusable, innerFocusables, (0, $51d90458d728fe34$export$8f99714c70a37db1)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $7698a7d35ed86651$var$guardCount = 0;
var $7698a7d35ed86651$var$lockDisabled = false;
var $7698a7d35ed86651$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $d862fa039a3b3c25$export$305758c744b57f6f)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($7698a7d35ed86651$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($7698a7d35ed86651$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $7698a7d35ed86651$var$lockDisabled = true;
            setTimeout(function() {
                $7698a7d35ed86651$var$lockDisabled = false;
            }, 1);
            return;
        }
        $7698a7d35ed86651$var$guardCount++;
        (0, $2bf5fb6846f8e2c5$export$c12b3da842c43a8)(focusable.node, options.focusOptions);
        $7698a7d35ed86651$var$guardCount--;
    }
};





/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $db815af593127be9$export$1a988e7317c65621 = $34f6623b57e1a1c8$exports;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $db815af593127be9$var$deprecated_default_moveFocusInside = (0, $7698a7d35ed86651$export$cd599851e879a025);
var $db815af593127be9$export$2e2bcd8739ae039 //
 = $db815af593127be9$var$deprecated_default_moveFocusInside;


function $de7ba2c6b170eb4f$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $de7ba2c6b170eb4f$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $de7ba2c6b170eb4f$export$c613fed06e332533 = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};



var $00df5dbe84bcea91$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $00df5dbe84bcea91$var$isFreeFocus = function isFreeFocus() {
    return $00df5dbe84bcea91$var$focusOnBody() || (0, $4a4957b2dfe49f02$export$be6b21806d3fd485)();
};
var $00df5dbe84bcea91$var$lastActiveTrap = null;
var $00df5dbe84bcea91$var$lastActiveFocus = null;
var $00df5dbe84bcea91$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $00df5dbe84bcea91$var$lastPortaledElement = null;
var $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
var $00df5dbe84bcea91$var$windowFocused = false;
var $00df5dbe84bcea91$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $00df5dbe84bcea91$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($00df5dbe84bcea91$var$lastActiveTrap.whiteList || $00df5dbe84bcea91$var$defaultWhitelist)(activeElement);
};
var $00df5dbe84bcea91$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $00df5dbe84bcea91$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $00df5dbe84bcea91$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement === element;
};
function $00df5dbe84bcea91$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $00df5dbe84bcea91$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($00df5dbe84bcea91$var$focusWasOutsideWindow);
    return $00df5dbe84bcea91$var$focusWasOutsideWindow === "meanwhile";
};
var $00df5dbe84bcea91$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $00df5dbe84bcea91$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $00df5dbe84bcea91$var$checkInHost(activeElement, area, area);
    });
};
var $00df5dbe84bcea91$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $9b74641517b143d6$export$493d05a3a8e6532d)(nodes, new Map());
};
var $00df5dbe84bcea91$var$isNotFocusable = function isNotFocusable(node) {
    return !$00df5dbe84bcea91$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $00df5dbe84bcea91$var$activateTrap = function activateTrap() {
    var result = false;
    if ($00df5dbe84bcea91$var$lastActiveTrap) {
        var _lastActiveTrap = $00df5dbe84bcea91$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement;
        if ($00df5dbe84bcea91$var$focusOnBody() && $00df5dbe84bcea91$var$lastActiveFocus && $00df5dbe84bcea91$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($00df5dbe84bcea91$var$lastActiveFocus) || $00df5dbe84bcea91$var$isNotFocusable($00df5dbe84bcea91$var$lastActiveFocus)) {
                var newTarget = $00df5dbe84bcea91$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $de7ba2c6b170eb4f$export$c613fed06e332533)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$00df5dbe84bcea91$var$focusWasOutside(crossFrame) || !noFocusGuards || !$00df5dbe84bcea91$var$lastActiveFocus || $00df5dbe84bcea91$var$windowFocused) return false;
                var nodes = $00df5dbe84bcea91$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $00df5dbe84bcea91$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $00df5dbe84bcea91$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$00df5dbe84bcea91$var$isFreeFocus() || !$00df5dbe84bcea91$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $eec3e0cab722c011$export$20115f8da7baa6fa)(workingArea) || activeElement && $00df5dbe84bcea91$var$withinHost(activeElement, workingArea) || $00df5dbe84bcea91$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$00df5dbe84bcea91$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $7698a7d35ed86651$export$cd599851e879a025)(workingArea, $00df5dbe84bcea91$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $00df5dbe84bcea91$var$lastPortaledElement = {};
                        }
                    }
                    $00df5dbe84bcea91$var$lastActiveFocus = document && document.activeElement;
                    if ($00df5dbe84bcea91$var$lastActiveFocus !== document.body) $00df5dbe84bcea91$var$tryRestoreFocus = (0, $e8393b55a6e31e11$export$d357db6e554ff59a)($00df5dbe84bcea91$var$lastActiveFocus);
                    $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $3f73a80c2e676402$export$f89ac71e91767111)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $00df5dbe84bcea91$var$onTrap = function onTrap(event) {
    if ($00df5dbe84bcea91$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $00df5dbe84bcea91$var$onBlur = function onBlur() {
    return (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
};
var $00df5dbe84bcea91$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $00df5dbe84bcea91$var$recordPortal(currentNode, source);
};
var $00df5dbe84bcea91$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $00df5dbe84bcea91$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onBlur: $00df5dbe84bcea91$var$onBlur,
        onFocus: $00df5dbe84bcea91$var$onFocus
    }, children);
};
$00df5dbe84bcea91$var$FocusTrap.propTypes = {};
var $00df5dbe84bcea91$var$onWindowFocus = function onWindowFocus() {
    $00df5dbe84bcea91$var$windowFocused = true;
};
var $00df5dbe84bcea91$var$onWindowBlur = function onWindowBlur() {
    $00df5dbe84bcea91$var$windowFocused = false;
    $00df5dbe84bcea91$var$focusWasOutsideWindow = "just";
    (0, $de7ba2c6b170eb4f$export$6523025722806278)(function() {
        $00df5dbe84bcea91$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $00df5dbe84bcea91$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.addEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.addEventListener("focus", $00df5dbe84bcea91$var$onWindowFocus);
    window.addEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
var $00df5dbe84bcea91$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.removeEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.removeEventListener("focus", $00df5dbe84bcea91$var$onWindowFocus);
    window.removeEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
function $00df5dbe84bcea91$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $00df5dbe84bcea91$var$focusLockAPI = {
    moveFocusInside: (0, $7698a7d35ed86651$export$cd599851e879a025),
    focusInside: (0, $eec3e0cab722c011$export$20115f8da7baa6fa),
    focusNextElement: (0, $b394242c3b6cfaf1$export$3b0237e8566c8d65),
    focusPrevElement: (0, $b394242c3b6cfaf1$export$33b47db07a82b2fb),
    focusFirstElement: (0, $b394242c3b6cfaf1$export$2a791d8097a66406),
    focusLastElement: (0, $b394242c3b6cfaf1$export$6a79073ddabfd6c3),
    captureFocusRestore: (0, $e8393b55a6e31e11$export$d357db6e554ff59a)
};
function $00df5dbe84bcea91$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$00df5dbe84bcea91$var$lastActiveTrap) $00df5dbe84bcea91$var$attachHandler();
    var lastTrap = $00df5dbe84bcea91$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $00df5dbe84bcea91$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $00df5dbe84bcea91$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($00df5dbe84bcea91$var$focusLockAPI);
        $00df5dbe84bcea91$var$activateTrap(true);
        (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
    } else {
        $00df5dbe84bcea91$var$detachHandler();
        $00df5dbe84bcea91$var$lastActiveFocus = null;
    }
}
(0, $292937b69072d1e6$export$5733e022b1d538cb).assignSyncMedium($00df5dbe84bcea91$var$onFocus);
(0, $292937b69072d1e6$export$b3e9a9312f73723c).assignMedium($00df5dbe84bcea91$var$onBlur);
(0, $292937b69072d1e6$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb($00df5dbe84bcea91$var$focusLockAPI);
});
var $00df5dbe84bcea91$export$2e2bcd8739ae039 = (0, $bec73a156e960f78$export$2e2bcd8739ae039)($00df5dbe84bcea91$var$reducePropsToState, $00df5dbe84bcea91$var$handleStateChangeOnClient)($00df5dbe84bcea91$var$FocusWatcher);


var $afd3cd9c4d0274d7$var$FocusLockCombination = /*#__PURE__*/ (0, $acw62.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e86725766b4cde33$export$2e2bcd8739ae039), (0, $8nd05.default)({
        sideCar: (0, $00df5dbe84bcea91$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $afd3cd9c4d0274d7$var$_ref = (0, $e86725766b4cde33$export$2e2bcd8739ae039).propTypes || {}, $afd3cd9c4d0274d7$var$sideCar = $afd3cd9c4d0274d7$var$_ref.sideCar, $afd3cd9c4d0274d7$var$propTypes = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)($afd3cd9c4d0274d7$var$_ref, [
    "sideCar"
]);
$afd3cd9c4d0274d7$var$FocusLockCombination.propTypes = {};
var $afd3cd9c4d0274d7$export$2e2bcd8739ae039 = $afd3cd9c4d0274d7$var$FocusLockCombination;



var $9962412629625ccb$export$2e2bcd8739ae039 = (0, $afd3cd9c4d0274d7$export$2e2bcd8739ae039);


var $cf2505162f62ed75$exports = {};
"use strict";
Object.defineProperty($cf2505162f62ed75$exports, "__esModule", {
    value: true
});
var $9ce482b93321ce99$exports = {};
"use strict";
Object.defineProperty($9ce482b93321ce99$exports, "__esModule", {
    value: true
});
var $9ce482b93321ce99$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $9ce482b93321ce99$var$_react2 = $9ce482b93321ce99$var$_interopRequireDefault($acw62);
var $9b1af1a6f2632174$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, $9b1af1a6f2632174$exports) $9b1af1a6f2632174$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $1129dd3c6936dec9$exports = {};
"use strict";
Object.defineProperty($1129dd3c6936dec9$exports, "__esModule", {
    value: true
});
$1129dd3c6936dec9$exports.TouchScrollable = undefined;
var $1129dd3c6936dec9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $1129dd3c6936dec9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");

var $76f11057e191f2b2$exports = {};
"use strict";
Object.defineProperty($76f11057e191f2b2$exports, "__esModule", {
    value: true
});
$76f11057e191f2b2$exports.pipe = $76f11057e191f2b2$exports.listenerOptions = undefined;
$76f11057e191f2b2$exports.preventTouchMove = $76f11057e191f2b2$var$preventTouchMove;
$76f11057e191f2b2$exports.allowTouchMove = $76f11057e191f2b2$var$allowTouchMove;
$76f11057e191f2b2$exports.preventInertiaScroll = $76f11057e191f2b2$var$preventInertiaScroll;
$76f11057e191f2b2$exports.isTouchDevice = $76f11057e191f2b2$var$isTouchDevice;
$76f11057e191f2b2$exports.camelToKebab = $76f11057e191f2b2$var$camelToKebab;
$76f11057e191f2b2$exports.parse = $76f11057e191f2b2$var$parse;
$76f11057e191f2b2$exports.getPadding = $76f11057e191f2b2$var$getPadding;
$76f11057e191f2b2$exports.getWindowHeight = $76f11057e191f2b2$var$getWindowHeight;
$76f11057e191f2b2$exports.getDocumentHeight = $76f11057e191f2b2$var$getDocumentHeight;
$76f11057e191f2b2$exports.makeStyleTag = $76f11057e191f2b2$var$makeStyleTag;
$76f11057e191f2b2$exports.injectStyles = $76f11057e191f2b2$var$injectStyles;
$76f11057e191f2b2$exports.insertStyleTag = $76f11057e191f2b2$var$insertStyleTag;

var $76f11057e191f2b2$var$listenerOptions = $76f11057e191f2b2$exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $76f11057e191f2b2$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $76f11057e191f2b2$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $76f11057e191f2b2$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $76f11057e191f2b2$var$isTouchDevice() {
    if (!$9b1af1a6f2632174$exports.canUseDOM) return false;
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $76f11057e191f2b2$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $76f11057e191f2b2$var$parse(val) {
    return isNaN(val) ? val : val + "px";
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $76f11057e191f2b2$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $76f11057e191f2b2$var$pipe = $76f11057e191f2b2$exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($76f11057e191f2b2$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $76f11057e191f2b2$var$getPadding() {
    if (!$9b1af1a6f2632174$exports.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $76f11057e191f2b2$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($9b1af1a6f2632174$exports.canUseDOM) return window.innerHeight * multiplier;
}
function $76f11057e191f2b2$var$getDocumentHeight() {
    if ($9b1af1a6f2632174$exports.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $76f11057e191f2b2$var$makeStyleTag() {
    if (!$9b1af1a6f2632174$exports.canUseDOM) return;
    var tag = document.createElement("style");
    tag.type = "text/css";
    tag.setAttribute("data-react-scrolllock", "");
    return tag;
}
function $76f11057e191f2b2$var$injectStyles(tag, css) {
    if (!$9b1af1a6f2632174$exports.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $76f11057e191f2b2$var$insertStyleTag(tag) {
    if (!$9b1af1a6f2632174$exports.canUseDOM) return;
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}


function $1129dd3c6936dec9$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $1129dd3c6936dec9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1129dd3c6936dec9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1129dd3c6936dec9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1129dd3c6936dec9$var$TouchScrollable = $1129dd3c6936dec9$exports.TouchScrollable = function(_PureComponent) {
    $1129dd3c6936dec9$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $1129dd3c6936dec9$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1129dd3c6936dec9$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $1129dd3c6936dec9$var$_possibleConstructorReturn(_this, _ret);
    }
    $1129dd3c6936dec9$var$_createClass(TouchScrollable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$9b1af1a6f2632174$exports.canUseEventListeners) return;
                this.scrollableArea.addEventListener("touchstart", $76f11057e191f2b2$exports.preventInertiaScroll, $76f11057e191f2b2$exports.listenerOptions);
                this.scrollableArea.addEventListener("touchmove", $76f11057e191f2b2$exports.allowTouchMove, $76f11057e191f2b2$exports.listenerOptions);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$9b1af1a6f2632174$exports.canUseEventListeners) return;
                this.scrollableArea.removeEventListener("touchstart", $76f11057e191f2b2$exports.preventInertiaScroll, $76f11057e191f2b2$exports.listenerOptions);
                this.scrollableArea.removeEventListener("touchmove", $76f11057e191f2b2$exports.allowTouchMove, $76f11057e191f2b2$exports.listenerOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, rest = $1129dd3c6936dec9$var$_objectWithoutProperties(_props, [
                    "children"
                ]);
                return typeof children === "function" ? children(this.getScrollableArea) : (0, $acw62.cloneElement)(children, $1129dd3c6936dec9$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($acw62.PureComponent);


var $43807214af823376$exports = {};
"use strict";
Object.defineProperty($43807214af823376$exports, "__esModule", {
    value: true
});
var $43807214af823376$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$43807214af823376$exports.default = $43807214af823376$var$withLockSheet;

var $acw62 = parcelRequire("acw62");
var $43807214af823376$var$_react2 = $43807214af823376$var$_interopRequireDefault($acw62);

function $43807214af823376$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $43807214af823376$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $43807214af823376$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $43807214af823376$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $43807214af823376$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $43807214af823376$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $43807214af823376$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $43807214af823376$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $76f11057e191f2b2$exports.makeStyleTag)();
                if (!sheet) return;
                (0, $76f11057e191f2b2$exports.injectStyles)(sheet, styles);
                (0, $76f11057e191f2b2$exports.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $76f11057e191f2b2$exports.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $76f11057e191f2b2$exports.getPadding)() : null;
                var styles = "body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        " + (height ? "height: " + height + "px !important;" : "") + "\n        " + (paddingRight ? "padding-right: " + paddingRight + "px !important;" : "") + "\n      }";
                return styles;
            }, _temp), $43807214af823376$var$_possibleConstructorReturn(_this, _ret);
        }
        $43807214af823376$var$_createClass(SheetProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: "removeSheet",
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: "render",
                value: function render() {
                    return $43807214af823376$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($acw62.PureComponent);
}


var $9ce482b93321ce99$var$_withLockSheet2 = $9ce482b93321ce99$var$_interopRequireDefault($43807214af823376$exports);
var $b2bceace3becf4c9$exports = {};
"use strict";
Object.defineProperty($b2bceace3becf4c9$exports, "__esModule", {
    value: true
});
var $b2bceace3becf4c9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$b2bceace3becf4c9$exports.default = $b2bceace3becf4c9$var$withTouchListeners;

var $acw62 = parcelRequire("acw62");
var $b2bceace3becf4c9$var$_react2 = $b2bceace3becf4c9$var$_interopRequireDefault($acw62);


function $b2bceace3becf4c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2bceace3becf4c9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b2bceace3becf4c9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b2bceace3becf4c9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $b2bceace3becf4c9$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $b2bceace3becf4c9$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $b2bceace3becf4c9$var$_classCallCheck(this, TouchProvider);
            return $b2bceace3becf4c9$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $b2bceace3becf4c9$var$_createClass(TouchProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!$9b1af1a6f2632174$exports.canUseDOM || !(0, $76f11057e191f2b2$exports.isTouchDevice)()) return;
                    document.addEventListener("touchmove", $76f11057e191f2b2$exports.preventTouchMove, $76f11057e191f2b2$exports.listenerOptions);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (!$9b1af1a6f2632174$exports.canUseDOM || !(0, $76f11057e191f2b2$exports.isTouchDevice)()) return;
                    document.removeEventListener("touchmove", $76f11057e191f2b2$exports.preventTouchMove, $76f11057e191f2b2$exports.listenerOptions);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $b2bceace3becf4c9$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($acw62.PureComponent);
}


var $9ce482b93321ce99$var$_withTouchListeners2 = $9ce482b93321ce99$var$_interopRequireDefault($b2bceace3becf4c9$exports);

function $9ce482b93321ce99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ce482b93321ce99$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9ce482b93321ce99$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9ce482b93321ce99$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9ce482b93321ce99$var$ScrollLock = function(_PureComponent) {
    $9ce482b93321ce99$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $9ce482b93321ce99$var$_classCallCheck(this, ScrollLock);
        return $9ce482b93321ce99$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $9ce482b93321ce99$var$_createClass(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$9b1af1a6f2632174$exports.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children ? $9ce482b93321ce99$var$_react2.default.createElement($1129dd3c6936dec9$exports.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($acw62.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $9ce482b93321ce99$var$compose = (0, $76f11057e191f2b2$exports.pipe)($9ce482b93321ce99$var$_withTouchListeners2.default, $9ce482b93321ce99$var$_withLockSheet2.default);
var $9ce482b93321ce99$var$SheetLock = $9ce482b93321ce99$var$compose($9ce482b93321ce99$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $9ce482b93321ce99$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $9ce482b93321ce99$var$_react2.default.createElement($9ce482b93321ce99$var$SheetLock, props) : props.children;
};
$9ce482b93321ce99$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
$9ce482b93321ce99$exports.default = $9ce482b93321ce99$var$LockToggle;


Object.defineProperty($cf2505162f62ed75$exports, "default", {
    enumerable: true,
    get: function get() {
        return $cf2505162f62ed75$var$_interopRequireDefault($9ce482b93321ce99$exports).default;
    }
});

Object.defineProperty($cf2505162f62ed75$exports, "TouchScrollable", {
    enumerable: true,
    get: function get() {
        return $1129dd3c6936dec9$exports.TouchScrollable;
    }
});
function $cf2505162f62ed75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}



/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");



var $dnCk4 = parcelRequire("dnCk4");

function $aac7c3d609a8c84e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aac7c3d609a8c84e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aac7c3d609a8c84e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aac7c3d609a8c84e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aac7c3d609a8c84e$var$packageName = "@atlaskit/blanket";
var $aac7c3d609a8c84e$var$packageVersion = "15.0.3";
var $aac7c3d609a8c84e$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $aac7c3d609a8c84e$var$packageName,
    packageVersion: $aac7c3d609a8c84e$var$packageVersion
};
var $aac7c3d609a8c84e$var$baseStyles = null;
var $aac7c3d609a8c84e$var$shouldAllowClickThroughStyles = null;
var $aac7c3d609a8c84e$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $aac7c3d609a8c84e$var$Blanket = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $acw62.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($aac7c3d609a8c84e$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $aac7c3d609a8c84e$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $acw62.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $acw62.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $acw62.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $5zphJ.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $cZGu3.default)("var(--ds-blanket, ".concat((0, $dnCk4.N100A), ")"))
        }
    }, children);
}));
$aac7c3d609a8c84e$var$Blanket.displayName = "Blanket";
var $aac7c3d609a8c84e$export$2e2bcd8739ae039 = $aac7c3d609a8c84e$var$Blanket;








var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");






parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");


var $dnCk4 = parcelRequire("dnCk4");

var $cfuBi = parcelRequire("cfuBi");

var $acw62 = parcelRequire("acw62");
var $c409c6850144d199$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $c409c6850144d199$export$dece24112a937f92 = /*#__PURE__*/ (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");
function $c2c5fe2a4523ebc1$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $acw62.useRef)(null);
    var onMotionFinish = (0, $acw62.useCallback)(function(state) {
        if (state === "entering" && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === "exiting" && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}



var $8fY35 = parcelRequire("8fY35");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
parcelRequire("lLUpG");
var $9eYWs = parcelRequire("9eYWs");

var $fUHKi = parcelRequire("fUHKi");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $9a728e936ea814a6$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? "" : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $9a728e936ea814a6$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $9a728e936ea814a6$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith("data:")) return false;
    return !$9a728e936ea814a6$var$hasSameOrigin(window.location.href, iframe.src);
}
var $9a728e936ea814a6$var$registry = new Map();
function $9a728e936ea814a6$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll("iframe")).filter($9a728e936ea814a6$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $9a728e936ea814a6$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $9a728e936ea814a6$var$setStyle(iframe, {
                    property: "pointer-events",
                    rule: "none",
                    priority: "important"
                }),
                count: 1
            };
            $9a728e936ea814a6$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $9a728e936ea814a6$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $iedos.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $9a728e936ea814a6$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $9a728e936ea814a6$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}


function $43e887ba0560d3db$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: "pointerdown",
            listener: stop
        },
        {
            // The user did not start a drag
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: "dragstart",
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $9eYWs.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $iedos.combine)(unbindEvents, unbindMonitor);
}
function $43e887ba0560d3db$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $8fY35.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $43e887ba0560d3db$var$api = (0, $9a728e936ea814a6$export$a74bff2507e6126b)({
    watchForInteractionStart: $43e887ba0560d3db$var$watchForInteractionStart,
    watchForInteractionEnd: $43e887ba0560d3db$var$watchForInteractionEnd
});
function $43e887ba0560d3db$export$ec28e97c7d8b1b35() {
    return $43e887ba0560d3db$var$api.registerUsage();
}



var $fUHKi = parcelRequire("fUHKi");

var $8fY35 = parcelRequire("8fY35");

var $6WHuD = parcelRequire("6WHuD");

var $6AMEG = parcelRequire("6AMEG");

var $6enBj = parcelRequire("6enBj");

var $iXb9E = parcelRequire("iXb9E");

var $fCUWk = parcelRequire("fCUWk");

var $kVTd4 = parcelRequire("kVTd4");
function $24379c7d8f4fe1c5$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== "dragenter") return false;
    if ((0, $iXb9E.isSafari)()) return (0, $fCUWk.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $6enBj.isFirefox)()) return (0, $kVTd4.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}



var $guUqI = parcelRequire("guUqI");

var $sJ9rD = parcelRequire("sJ9rD");

var $kBeST = parcelRequire("kBeST");
function $1facfb95e9b24d1e$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $kBeST.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $sJ9rD.textMediaType) && value === (0, $6AMEG.androidFallbackText)) return false;
    return true;
}
function $1facfb95e9b24d1e$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $1facfb95e9b24d1e$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $1facfb95e9b24d1e$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === "file" || $1facfb95e9b24d1e$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $1facfb95e9b24d1e$var$didDragStartLocally = false;
var $1facfb95e9b24d1e$var$adapter = (0, $6WHuD.makeAdapter)({
    typeKey: "external",
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: "copy",
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $8fY35.bind)(window, {
            type: "dragenter",
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($1facfb95e9b24d1e$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $24379c7d8f4fe1c5$export$d1c6f249e893cdf4)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $1facfb95e9b24d1e$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: "external",
                        startedFrom: "external",
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $1facfb95e9b24d1e$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$1facfb95e9b24d1e$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $1facfb95e9b24d1e$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $1facfb95e9b24d1e$var$adapter.dropTarget(args);
}
function $1facfb95e9b24d1e$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $1facfb95e9b24d1e$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === "undefined") return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $1facfb95e9b24d1e$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: "idle"
    };
    var state = idle;
    function clear() {
        if (state.type !== "dragging") return;
        $1facfb95e9b24d1e$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $8fY35.bindAll)(window, [
            {
                type: "dragend",
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((0, $guUqI.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $8fY35.bind)(window, {
        type: "dragstart",
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== "idle") return;
            // set our global flag
            $1facfb95e9b24d1e$var$didDragStartLocally = true;
            state = {
                type: "dragging",
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 


 // The data that is being dragged



function $039a45a81f75228a$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $1facfb95e9b24d1e$export$bb1740f3194979c1)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $039a45a81f75228a$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $1facfb95e9b24d1e$export$bb1740f3194979c1)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $039a45a81f75228a$var$api = (0, $9a728e936ea814a6$export$a74bff2507e6126b)({
    watchForInteractionStart: $039a45a81f75228a$var$watchForInteractionStart,
    watchForInteractionEnd: $039a45a81f75228a$var$watchForInteractionEnd
});
function $039a45a81f75228a$export$27d79116d3a4e7d5() {
    return $039a45a81f75228a$var$api.registerUsage();
}



var $8fY35 = parcelRequire("8fY35");
parcelRequire("cXz1d");
var $iedos = parcelRequire("iedos");

var $8fY35 = parcelRequire("8fY35");

var $6QCyH = parcelRequire("6QCyH");

var $6WHuD = parcelRequire("6WHuD");

var $iedos = parcelRequire("iedos");

var $iXb9E = parcelRequire("iXb9E");
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $b6d7fe08f1b93598$export$338a9f6c7a1f02b0 = "text/html";



var $sJ9rD = parcelRequire("sJ9rD");

var $kBeST = parcelRequire("kBeST");
function $c1076dc7700d1760$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $iXb9E.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $sJ9rD.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $c1076dc7700d1760$var$honeyPotFix = (0, $6QCyH.makeHoneyPotFix)();
var $c1076dc7700d1760$var$adapter = (0, $6WHuD.makeAdapter)({
    typeKey: "text-selection",
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: "copy",
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $iedos.combine)($c1076dc7700d1760$var$honeyPotFix.bindEvents(), (0, $8fY35.bind)(window, {
            type: "dragstart",
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $kBeST.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $sJ9rD.textMediaType))) return;
                var target = $c1076dc7700d1760$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $sJ9rD.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $b6d7fe08f1b93598$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: "text-selection",
                        startedFrom: "internal",
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $c1076dc7700d1760$var$honeyPotFix.getOnPostDispatch()
});
function $c1076dc7700d1760$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $c1076dc7700d1760$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === "undefined") return;
    $c1076dc7700d1760$var$adapter.registerUsage();
})();
function $c1076dc7700d1760$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $c1076dc7700d1760$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 


 // Payload for the text selection being dragged



function $8f54e017dd248c21$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $8fY35.bindAll)(window, [
        {
            // User is starting another interaction
            type: "pointerdown",
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            type: "dragstart",
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $c1076dc7700d1760$export$2e178e3647f5e6e9)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $iedos.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $8f54e017dd248c21$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $8fY35.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $8f54e017dd248c21$var$api = (0, $9a728e936ea814a6$export$a74bff2507e6126b)({
    watchForInteractionStart: $8f54e017dd248c21$var$watchForInteractionStart,
    watchForInteractionEnd: $8f54e017dd248c21$var$watchForInteractionEnd
});
function $8f54e017dd248c21$export$9c0606fcefb5d1e2() {
    return $8f54e017dd248c21$var$api.registerUsage();
}


var $8e0a7c9e1635d9ed$export$7e3df82ee760448c = {
    values: [
        "small",
        "medium",
        "large",
        "x-large"
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        "x-large": 968
    },
    defaultValue: "medium"
};
var $8e0a7c9e1635d9ed$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return "auto";
    var isWidthName = $8e0a7c9e1635d9ed$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($8e0a7c9e1635d9ed$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === "number" ? "".concat(input, "px") : input;
};
var $8e0a7c9e1635d9ed$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return "auto";
    return typeof input === "number" ? "".concat(input, "px") : input;
};



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");
var $e9ca40ca2325ac8e$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $e9ca40ca2325ac8e$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $e9ca40ca2325ac8e$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";
var $e9ca40ca2325ac8e$export$45db2fc2f15997e7 = "cubic-bezier(0,0,1,1)";





var $7e8436e9e798d30d$var$gutter = 60;
var $7e8436e9e798d30d$var$maxWidthDimensions = "calc(100vw - ".concat($7e8436e9e798d30d$var$gutter * 2, "px)");
var $7e8436e9e798d30d$var$maxHeightDimensions = "calc(100vh - ".concat($7e8436e9e798d30d$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $7e8436e9e798d30d$var$positionerStyles = (0, $jjlaj.css)({
    display: "flex",
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    position: "fixed",
    zIndex: (0, $b7d36d3be7da66cd$export$7be255094ccdc533).modal(),
    flexDirection: "column",
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $7e8436e9e798d30d$var$viewportScrollStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    height: "auto",
    position: "relative"
}, (0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xs, {
    margin: "".concat($7e8436e9e798d30d$var$gutter, "px auto"),
    pointerEvents: "none"
}));
var $7e8436e9e798d30d$var$bodyScrollStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xs, {
    maxWidth: $7e8436e9e798d30d$var$maxWidthDimensions,
    maxHeight: $7e8436e9e798d30d$var$maxHeightDimensions,
    position: "absolute",
    insetBlockStart: "".concat($7e8436e9e798d30d$var$gutter, "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    pointerEvents: "none"
}));
var $7e8436e9e798d30d$var$stackTransitionStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transitionDuration: "".concat((0, $d145bd79772829f1$export$38b928a7167ce124).medium, "ms"),
    transitionProperty: "transform",
    transitionTimingFunction: (0, $e9ca40ca2325ac8e$export$c07234257a03d5e9),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
});
var $7e8436e9e798d30d$var$stackTransformStyles = (0, $jjlaj.css)({
    transform: "translateY(var(--modal-dialog-translate-y))"
});
var $7e8436e9e798d30d$var$stackIdleStyles = (0, $jjlaj.css)({
    transform: "none"
});
var $7e8436e9e798d30d$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $jjlaj.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--modal-dialog-translate-y": "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")")
        },
        css: [
            $7e8436e9e798d30d$var$positionerStyles,
            $7e8436e9e798d30d$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $7e8436e9e798d30d$var$stackTransformStyles : $7e8436e9e798d30d$var$stackIdleStyles,
            shouldScrollInViewport ? $7e8436e9e798d30d$var$viewportScrollStyles : $7e8436e9e798d30d$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e8436e9e798d30d$export$2e2bcd8739ae039 = $7e8436e9e798d30d$var$Positioner;


var $173f315784d5fdf0$var$dialogStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "flex",
    width: "100%",
    maxWidth: "100vw",
    height: "100%",
    minHeight: 0,
    maxHeight: "100vh",
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: "0 1 auto",
    flexDirection: "column",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $dnCk4.N0), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat((0, $dnCk4.N900), ")")
}, (0, $cfuBi.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $dnCk4.N0), ")")), "pointerEvents", "auto"), (0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xs, {
    width: "var(--modal-dialog-width)",
    maxWidth: "inherit",
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $dnCk4.N30A), ", 0 2px 1px ").concat((0, $dnCk4.N30A), ", 0 0 20px -6px ").concat((0, $dnCk4.N60A)), ")"),
    marginInlineEnd: "inherit",
    marginInlineStart: "inherit"
}), "& > form:only-child", {
    display: "inherit",
    maxHeight: "inherit",
    flexDirection: "inherit"
}));
var $173f315784d5fdf0$var$viewportScrollStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: "100vh",
    maxHeight: "none"
}, (0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xs, {
    minHeight: "var(--modal-dialog-height)"
}));
var $173f315784d5fdf0$var$bodyScrollStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xs, {
    height: "var(--modal-dialog-height)",
    maxHeight: "inherit"
}));
var $173f315784d5fdf0$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? "medium" : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $acw62.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $iedos.combine)((0, $43e887ba0560d3db$export$ec28e97c7d8b1b35)(), (0, $8f54e017dd248c21$export$9c0606fcefb5d1e2)(), (0, $039a45a81f75228a$export$27d79116d3a4e7d5)());
    }, []);
    (0, $3f80dbe144e57bfc$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object" ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(autoFocus) === "object");
    var _useOnMotionFinish = (0, $c2c5fe2a4523ebc1$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $acw62.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose
        };
    }, [
        testId,
        titleId,
        onClose,
        hasProvidedOnClose
    ]);
    (0, $39ea3782c8eee010$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $39ea3782c8eee010$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    return (0, $jjlaj.jsx)((0, $7e8436e9e798d30d$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $jjlaj.jsx)((0, $c409c6850144d199$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, (0, $jjlaj.jsx)((0, $c409c6850144d199$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, (0, $jjlaj.jsx)((0, $c1a7c75e4c42bc2c$export$2e2bcd8739ae039), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $jjlaj.jsx)((0, $6f72ff8788d34fb2$export$2e2bcd8739ae039), null, (0, $jjlaj.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-width": (0, $8e0a7c9e1635d9ed$export$a3da89b899389ed8)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-height": (0, $8e0a7c9e1635d9ed$export$ceba93bf0bdd16f2)(height)
            },
            css: [
                $173f315784d5fdf0$var$dialogStyles,
                shouldScrollInViewport ? $173f315784d5fdf0$var$viewportScrollStyles : $173f315784d5fdf0$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$173f315784d5fdf0$export$2e2bcd8739ae039 = $173f315784d5fdf0$var$ModalDialog;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $32da3ab8d78b92fd$var$uniqueReferencedValue = {};
function $32da3ab8d78b92fd$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $acw62.useRef)($32da3ab8d78b92fd$var$uniqueReferencedValue);
    if (ref.current === $32da3ab8d78b92fd$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $94e127bdad6c95fb$export$2e2bcd8739ae039(callback) {
    var ref = (0, $32da3ab8d78b92fd$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}




var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $ae6659c5d7ef547e$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $acw62.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $266f54f749ed0c14$var$modalStackRegister = [];
function $266f54f749ed0c14$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $183a833228617892$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $ae6659c5d7ef547e$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $8b1ca3977f5313f5$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $94e127bdad6c95fb$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $266f54f749ed0c14$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $acw62.useEffect)(function() {
        var currentStackIndex = $266f54f749ed0c14$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $266f54f749ed0c14$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $266f54f749ed0c14$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $266f54f749ed0c14$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $266f54f749ed0c14$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $266f54f749ed0c14$var$modalStackRegister.splice(currentStackIndex, 1);
                $266f54f749ed0c14$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $acw62.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $f1146797d708fab8$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $f1146797d708fab8$export$2e2bcd8739ae039() {
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $acw62.useLayoutEffect)(function() {
        setScrollTopOffset($f1146797d708fab8$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $acw62.useCallback)(function() {
        if ($f1146797d708fab8$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


var $49f7c216070fc3db$var$fillScreenStyles = (0, $jjlaj.css)({
    width: "100vw",
    height: "100vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
});
var $49f7c216070fc3db$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector(".aui-blanket:not([hidden])")) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === "function") return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $49f7c216070fc3db$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $266f54f749ed0c14$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === "boolean" ? autoFocus : false;
    var onCloseHandler = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: providedOnClose || (0, $d3997b4aab843580$export$2e2bcd8739ae039),
        action: "closed",
        componentName: "modalDialog",
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "13.4.0"
    });
    var onBlanketClicked = (0, $acw62.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $acw62.useCallback)(function(element) {
        return $49f7c216070fc3db$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $f1146797d708fab8$export$2e2bcd8739ae039)();
    var modalDialogWithBlanket = (0, $jjlaj.jsx)((0, $aac7c3d609a8c84e$export$2e2bcd8739ae039), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $jjlaj.jsx)((0, $173f315784d5fdf0$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose)
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ("boolean" === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $jjlaj.jsx)((0, $8fe0ce44053a7d1f$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $jjlaj.jsx)((0, $2167cf9ee39b2459$export$2e2bcd8739ae039), {
        zIndex: (0, $b7d36d3be7da66cd$export$7be255094ccdc533).modal()
    }, (0, $jjlaj.jsx)((0, $c1a7c75e4c42bc2c$export$2e2bcd8739ae039), null, function(fadeInProps) {
        return (0, $jjlaj.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, fadeInProps, {
            css: $49f7c216070fc3db$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $jjlaj.jsx)((0, $9962412629625ccb$export$2e2bcd8739ae039), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $jjlaj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf2505162f62ed75$exports))), null), shouldScrollInViewport ? (0, $jjlaj.jsx)((0, $cf2505162f62ed75$exports.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $49f7c216070fc3db$export$2e2bcd8739ae039 = $49f7c216070fc3db$var$ModalWrapper;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $ede1f1939e49e4d2$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $acw62.useContext)((0, $c409c6850144d199$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};



var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $8fY35 = parcelRequire("8fY35");

var $ciU3d = parcelRequire("ciU3d");






var $dnCk4 = parcelRequire("dnCk4");
var $2c7c9e4a57fa5ffc$var$keylineColor = "var(--ds-border, ".concat((0, $dnCk4.N30), ")");
var $2c7c9e4a57fa5ffc$var$baseStyles = (0, $jjlaj.css)((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
    display: "inherit",
    margin: "var(--ds-space-0, 0px)",
    flex: "inherit",
    flexDirection: "inherit",
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto"
}, (0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xs, {
    height: "unset",
    overflowY: "auto"
}));
var $2c7c9e4a57fa5ffc$var$keylineHeight = 2;
var $2c7c9e4a57fa5ffc$var$topKeylineStyles = (0, $jjlaj.css)({
    borderBlockStart: "var(--ds-border-width-outline, 2px)".concat(" solid ", $2c7c9e4a57fa5ffc$var$keylineColor)
});
var $2c7c9e4a57fa5ffc$var$bottomKeylineStyles = (0, $jjlaj.css)({
    borderBlockEnd: "var(--ds-border-width-outline, 2px)".concat(" solid ", $2c7c9e4a57fa5ffc$var$keylineColor)
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $2c7c9e4a57fa5ffc$var$ScrollContainer = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $acw62.useEffect)(function() {
        var schedule = (0, $ciU3d.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $94e127bdad6c95fb$export$2e2bcd8739ae039)((0, $ciU3d.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $2c7c9e4a57fa5ffc$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $2c7c9e4a57fa5ffc$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $acw62.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $8fY35.bind)(window, {
            type: "resize",
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $8fY35.bind)(target, {
            type: "scroll",
            listener: setLazyKeylines
        }) : (0, $d3997b4aab843580$export$2e2bcd8739ae039);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $jjlaj.jsx)((0, $6f72ff8788d34fb2$export$2e2bcd8739ae039), {
        isInset: true
    }, (0, $jjlaj.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? "region" : undefined,
        "aria-label": showContentFocus ? "Scrollable content" : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
            ref,
            scrollableRef
        ]),
        css: [
            $2c7c9e4a57fa5ffc$var$baseStyles,
            showTopKeyline && $2c7c9e4a57fa5ffc$var$topKeylineStyles,
            showBottomKeyline && $2c7c9e4a57fa5ffc$var$bottomKeylineStyles
        ]
    }, children));
});
$2c7c9e4a57fa5ffc$var$ScrollContainer.displayName = "ScrollContainer";
var $2c7c9e4a57fa5ffc$export$2e2bcd8739ae039 = $2c7c9e4a57fa5ffc$var$ScrollContainer;



var $acw62 = parcelRequire("acw62");

function $53aacbda375cec68$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $acw62.useContext)((0, $c409c6850144d199$export$dece24112a937f92));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


var $f7609201e9bc2976$var$bodyStyles = (0, $jjlaj.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: "1 1 auto"
});
var $f7609201e9bc2976$var$fontStyles = (0, $jjlaj.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $f7609201e9bc2976$var$bodyScrollStyles = (0, $jjlaj.css)({
    paddingBlock: "var(--ds-border-width-outline, 2px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $f7609201e9bc2976$var$viewportScrollStyles = (0, $jjlaj.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $f7609201e9bc2976$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $ede1f1939e49e4d2$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $53aacbda375cec68$export$2e2bcd8739ae039)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $jjlaj.jsx)("div", {
        css: [
            $f7609201e9bc2976$var$bodyStyles,
            $f7609201e9bc2976$var$viewportScrollStyles,
            (0, $ltooA.fg)("platform_ads_explicit_font_styles") && $f7609201e9bc2976$var$fontStyles
        ],
        "data-testid": testId
    }, children) : (0, $jjlaj.jsx)((0, $cf2505162f62ed75$exports.TouchScrollable), null, (0, $jjlaj.jsx)((0, $2c7c9e4a57fa5ffc$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, (0, $jjlaj.jsx)("div", {
        css: [
            $f7609201e9bc2976$var$bodyStyles,
            $f7609201e9bc2976$var$bodyScrollStyles,
            (0, $ltooA.fg)("platform_ads_explicit_font_styles") && $f7609201e9bc2976$var$fontStyles
        ],
        "data-testid": testId
    }, children)));
};
var $f7609201e9bc2976$export$2e2bcd8739ae039 = $f7609201e9bc2976$var$ModalBody;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $acw62 = parcelRequire("acw62");

var $b33ac5a568096776$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e25fa526c0658720d6f2766d6bdbde06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b33ac5a568096776$exports, "__esModule", {
    value: true
});
$b33ac5a568096776$exports.default = void 0;

var $b33ac5a568096776$var$_react = $b33ac5a568096776$var$_interopRequireDefault((parcelRequire("acw62")));

var $b33ac5a568096776$var$_close = $b33ac5a568096776$var$_interopRequireDefault((parcelRequire("3BIVW")));

var $b33ac5a568096776$var$_cross = $b33ac5a568096776$var$_interopRequireDefault((parcelRequire("at3iV")));
function $b33ac5a568096776$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b33ac5a568096776$var$CloseIcon = (props)=>/*#__PURE__*/ $b33ac5a568096776$var$_react.default.createElement($b33ac5a568096776$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $b33ac5a568096776$var$_cross.default
    }, props));
$b33ac5a568096776$var$CloseIcon.Name = "CloseIconMigration";
var $b33ac5a568096776$var$_default = $b33ac5a568096776$exports.default = $b33ac5a568096776$var$CloseIcon;


var $4ed1fb099eddf491$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $53997ce7dd1542b7$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b33ac5a568096776$exports))),
        label: label || "Close Modal",
        onClick: onClick
    });
};



var $185e137d176d1262$var$headerStyles = (0, $jjlaj.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    marginBlockEnd: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
var $185e137d176d1262$var$gridStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "100%"
});
var $185e137d176d1262$var$closeContainerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    gridArea: "close"
});
var $185e137d176d1262$var$titleContainerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    gridArea: "title"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $185e137d176d1262$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $ede1f1939e49e4d2$export$33ffd74ebf07f060)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return (0, $jjlaj.jsx)("div", {
        css: $185e137d176d1262$var$headerStyles,
        "data-testid": testId
    }, shouldShowCloseButton ? (0, $jjlaj.jsx)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
        gap: "space.200",
        templateAreas: [
            "title close"
        ],
        xcss: $185e137d176d1262$var$gridStyles
    }, (0, $jjlaj.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
        xcss: $185e137d176d1262$var$titleContainerStyles,
        justifyContent: "start",
        alignItems: "center"
    }, children), (0, $jjlaj.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
        xcss: $185e137d176d1262$var$closeContainerStyles,
        justifyContent: "end"
    }, (0, $jjlaj.jsx)((0, $4ed1fb099eddf491$export$de65de8213222d10), {
        onClick: onClose,
        testId: modalTestId
    }))) : children);
};
var $185e137d176d1262$export$2e2bcd8739ae039 = $185e137d176d1262$var$ModalHeader;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jjlaj = parcelRequire("jjlaj");
var $10a28323f2aa4e03$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a36a65999ae3c13d3a1917b5e2b052e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($10a28323f2aa4e03$exports, "__esModule", {
    value: true
});
$10a28323f2aa4e03$exports.default = void 0;

var $10a28323f2aa4e03$var$_react = $10a28323f2aa4e03$var$_interopRequireDefault((parcelRequire("acw62")));

var $10a28323f2aa4e03$var$_error = $10a28323f2aa4e03$var$_interopRequireDefault((parcelRequire("71Yyg")));

var $10a28323f2aa4e03$var$_error2 = $10a28323f2aa4e03$var$_interopRequireDefault((parcelRequire("29iCp")));
function $10a28323f2aa4e03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10a28323f2aa4e03$var$ErrorIcon = (props)=>/*#__PURE__*/ $10a28323f2aa4e03$var$_react.default.createElement($10a28323f2aa4e03$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $10a28323f2aa4e03$var$_error2.default
    }, props));
$10a28323f2aa4e03$var$ErrorIcon.Name = "ErrorIconMigration";
var $10a28323f2aa4e03$var$_default = $10a28323f2aa4e03$exports.default = $10a28323f2aa4e03$var$ErrorIcon;


var $8331970a6514bd13$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::783ce92761ea23bbb39745cb99e4a6be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($8331970a6514bd13$exports, "__esModule", {
    value: true
});
$8331970a6514bd13$exports.default = void 0;

var $8331970a6514bd13$var$_react = $8331970a6514bd13$var$_interopRequireDefault((parcelRequire("acw62")));

var $8331970a6514bd13$var$_warning = $8331970a6514bd13$var$_interopRequireDefault((parcelRequire("keOiG")));

var $8331970a6514bd13$var$_warning2 = $8331970a6514bd13$var$_interopRequireDefault((parcelRequire("kHyiL")));
function $8331970a6514bd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8331970a6514bd13$var$WarningIcon = (props)=>/*#__PURE__*/ $8331970a6514bd13$var$_react.default.createElement($8331970a6514bd13$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $8331970a6514bd13$var$_warning2.default
    }, props));
$8331970a6514bd13$var$WarningIcon.Name = "WarningIconMigration";
var $8331970a6514bd13$var$_default = $8331970a6514bd13$exports.default = $8331970a6514bd13$var$WarningIcon;



var $dnCk4 = parcelRequire("dnCk4");

var $dc702393df320999$var$iconColor = {
    danger: "var(--ds-icon-danger, ".concat((0, $dnCk4.R400), ")"),
    warning: "var(--ds-icon-warning, #D97008)"
};
var $dc702393df320999$var$iconStyles = (0, $jjlaj.css)({
    flex: "0 0 auto",
    // The following properties have been added purely to avoid a global style override in Jira breaking alignment between the icon and title text.
    // https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-legacy-frontend/jira-atlaskit-module/src/main/resources/jira-atlaskit-module/css/adg3-general-overrides.less?at=master#24
    // When the override is removed, these can be removed.
    color: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "inherit",
    fontStyle: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontWeight: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "inherit"
});
var $dc702393df320999$var$titleStyles = (0, $jjlaj.css)({
    display: "flex",
    minWidth: 0,
    margin: "var(--ds-space-0, 0px)",
    gap: "var(--ds-space-100, 8px)",
    font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
});
var $dc702393df320999$var$textStyles = (0, $jjlaj.css)({
    minWidth: 0,
    /**
   * This ensures that the element fills the whole header space
   * and its content does not overflow (since flex items don't
   * shrink past its content size by default).
   */ flex: "1 1 auto",
    wordWrap: "break-word"
});
var $dc702393df320999$var$truncatedTextStyles = (0, $jjlaj.css)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $dc702393df320999$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === "danger" ? (0, (/*@__PURE__*/$parcel$interopDefault($10a28323f2aa4e03$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8331970a6514bd13$exports)));
    return (0, $jjlaj.jsx)("span", {
        css: $dc702393df320999$var$iconStyles
    }, (0, $jjlaj.jsx)(Icon, {
        label: appearance,
        color: $dc702393df320999$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $dc702393df320999$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $ede1f1939e49e4d2$export$33ffd74ebf07f060)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return(// eslint-disable-next-line @atlaskit/design-system/use-heading
    (0, $jjlaj.jsx)("h1", {
        css: $dc702393df320999$var$titleStyles,
        "data-testid": testId
    }, appearance && (0, $jjlaj.jsx)($dc702393df320999$var$TitleIcon, {
        appearance: appearance
    }), (0, $jjlaj.jsx)("span", {
        id: titleId,
        css: [
            $dc702393df320999$var$textStyles,
            !isMultiline && $dc702393df320999$var$truncatedTextStyles
        ],
        "data-testid": testId && "".concat(testId, "-text")
    }, children)));
};
var $dc702393df320999$export$2e2bcd8739ae039 = $dc702393df320999$var$ModalTitle;


var $acw62 = parcelRequire("acw62");

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $d935d45ecc0a58cd$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $183a833228617892$export$2e2bcd8739ae039), {
        appear: true
    }, props.children);
};
var $d935d45ecc0a58cd$export$2e2bcd8739ae039 = $d935d45ecc0a58cd$var$ModalTransition;




var $acw62 = parcelRequire("acw62");



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $dnCk4 = parcelRequire("dnCk4");

var $7113889b49598eb1$var$decoration = (0, $jjlaj.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: "relative",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":before": {
        display: "inline-flex",
        padding: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)"),
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        background: "var(--ds-background-warning, ".concat((0, $dnCk4.Y75), ")"),
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
        fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
        fontStyle: "normal",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "18px",
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: "auto"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":hover:before": {
        background: "var(--ds-background-warning-hovered, ".concat((0, $dnCk4.Y75), ")"),
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $7113889b49598eb1$export$a592b67c93d52467(_ref) {
    var bidiCharacter = _ref.bidiCharacter, children = _ref.children, testId = _ref.testId;
    var bidiCharacterCode = $7113889b49598eb1$var$getBidiCharacterCode(bidiCharacter);
    return (0, $jjlaj.jsx)((0, $acw62.Fragment), null, (0, $jjlaj.jsx)("span", {
        css: $7113889b49598eb1$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        "aria-hidden": "true"
    }, children), (0, $jjlaj.jsx)((0, $8568069ac023c6f7$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--visually-hidden")
    }, (0, $jjlaj.jsx)("mark", null, bidiCharacterCode)));
}
function $7113889b49598eb1$var$getBidiCharacterCode(bidiCharacter) {
    var _bidiCharacter$codePo;
    var bidiCharacterCode = (_bidiCharacter$codePo = bidiCharacter.codePointAt(0)) === null || _bidiCharacter$codePo === void 0 ? void 0 : _bidiCharacter$codePo.toString(16);
    return "U+".concat(bidiCharacterCode);
}


var $273a7741ebb4127e$var$_excluded = [
    "children"
];
function $273a7741ebb4127e$export$2e2bcd8739ae039(_ref) {
    var testId = _ref.testId, bidiCharacter = _ref.bidiCharacter, skipChildren = _ref.skipChildren, tooltipEnabled = _ref.tooltipEnabled, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code." : _ref$label;
    if (tooltipEnabled) return(/*#__PURE__*/ // Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fa9833ed171567b$export$2e2bcd8739ae039), {
        content: label,
        tag: $273a7741ebb4127e$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7113889b49598eb1$export$a592b67c93d52467), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7113889b49598eb1$export$a592b67c93d52467), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
var $273a7741ebb4127e$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var children = props.children, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $273a7741ebb4127e$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: ref
    }), children);
});



var $fUHKi = parcelRequire("fUHKi");
function $933c4817526de54e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $933c4817526de54e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $933c4817526de54e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $933c4817526de54e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $933c4817526de54e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $933c4817526de54e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $933c4817526de54e$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $933c4817526de54e$export$2e2bcd8739ae039(originalText, decorate) {
    var matches = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(originalText.matchAll($933c4817526de54e$export$ecb256e6a1f5ee7e));
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    var children = [];
    var mappedTo = 0;
    var _iterator = $933c4817526de54e$var$_createForOfIteratorHelper(matches), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var match = _step.value;
            if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
            // mapped to the children.
            // Add them as plain text.
            children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            // While index is guaranteed to be present, it needs to be asserted due
            // to a limitation of typescripts regex handling
            //
            // https://github.com/microsoft/TypeScript/issues/36788
            // Decorate bidi character
            mappedTo = match.index + match[0].length;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}


// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $35fb791af3d27096$export$431ac46d758d98c8 = 12;
var $35fb791af3d27096$export$8e3c04032121c606 = "20px";
var $35fb791af3d27096$export$c8b5dc30e9f2b86e = "4px";
var $35fb791af3d27096$export$82ea42e772d49e5b = (0, $b7d36d3be7da66cd$export$6d8204c2cb2e06b8)();
var $35fb791af3d27096$export$eeeea0ff98e06fff = $35fb791af3d27096$export$82ea42e772d49e5b * 2;
var $35fb791af3d27096$export$254015fe817dcb9e = "--ds--code--line-number-bg-color";
var $35fb791af3d27096$export$1758fda69688282e = "--ds--code--bg-color";
var $35fb791af3d27096$export$2cd00c745c539a1 = "data-ds--code--code-block";



var $d97b45edccfeae68$var$_excluded = [
    "testId"
], $d97b45edccfeae68$var$_excluded2 = [
    "children",
    "codeBidiWarnings",
    "codeBidiWarningLabel",
    "codeBidiWarningTooltipEnabled"
];
var $d97b45edccfeae68$var$styles = (0, $jjlaj.css)({
    display: "inline",
    padding: "2px 0.5ch",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: "var(".concat((0, $35fb791af3d27096$export$1758fda69688282e), ", ", "var(--ds-background-neutral, #091E420F)", ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    borderStyle: "none",
    boxDecorationBreak: "clone",
    color: "var(--ds-text, #172B4D)",
    font: 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "inherit",
    overflow: "auto",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap"
});
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ var $d97b45edccfeae68$var$Code = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function Code(_ref, ref) {
    var testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $d97b45edccfeae68$var$_excluded);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    var children = props.children, _props$codeBidiWarnin = props.codeBidiWarnings, codeBidiWarnings = _props$codeBidiWarnin === void 0 ? true : _props$codeBidiWarnin, codeBidiWarningLabel = props.codeBidiWarningLabel, _props$codeBidiWarnin2 = props.codeBidiWarningTooltipEnabled, codeBidiWarningTooltipEnabled = _props$codeBidiWarnin2 === void 0 ? true : _props$codeBidiWarnin2, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $d97b45edccfeae68$var$_excluded2);
    var decoratedChildren = codeBidiWarnings ? (0, $jjlaj.jsx)($d97b45edccfeae68$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    }, children) : children;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    (0, $jjlaj.jsx)("code", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref,
        "data-testid": testId,
        css: $d97b45edccfeae68$var$styles
    }, otherProps), decoratedChildren));
}));
function $d97b45edccfeae68$var$RenderCodeChildrenWithBidiWarnings(_ref2) {
    var children = _ref2.children, codeBidiWarningLabel = _ref2.codeBidiWarningLabel, codeBidiWarningTooltipEnabled = _ref2.codeBidiWarningTooltipEnabled;
    var replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, function(childNode) {
        if (typeof childNode === "string") {
            var decorated = (0, $933c4817526de54e$export$2e2bcd8739ae039)(childNode, function(_ref3) {
                var bidiCharacter = _ref3.bidiCharacter, index = _ref3.index;
                return (0, $jjlaj.jsx)((0, $273a7741ebb4127e$export$2e2bcd8739ae039), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                });
            });
            return decorated;
        }
        if ($d97b45edccfeae68$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            var newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(childNode, {
                children: (0, $jjlaj.jsx)($d97b45edccfeae68$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return (0, $jjlaj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, replacedChildren);
}
function $d97b45edccfeae68$var$isReactElement(child) {
    return !!child.type;
}
$d97b45edccfeae68$var$Code.displayName = "Code";
var $d97b45edccfeae68$export$2e2bcd8739ae039 = $d97b45edccfeae68$var$Code;


/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $b4cf4dbd977701b6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b4cf4dbd977701b6$exports, "__esModule", {
    value: true
});
$b4cf4dbd977701b6$exports.default = void 0;

var $b4cf4dbd977701b6$var$_react = $b4cf4dbd977701b6$var$_interopRequireDefault((parcelRequire("acw62")));

var $b4cf4dbd977701b6$var$_error = $b4cf4dbd977701b6$var$_interopRequireDefault((parcelRequire("1yyV4")));

var $b4cf4dbd977701b6$var$_error2 = $b4cf4dbd977701b6$var$_interopRequireDefault((parcelRequire("29iCp")));
function $b4cf4dbd977701b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4cf4dbd977701b6$var$ErrorIcon = (props)=>/*#__PURE__*/ $b4cf4dbd977701b6$var$_react.default.createElement($b4cf4dbd977701b6$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $b4cf4dbd977701b6$var$_error2.default
    }, props));
$b4cf4dbd977701b6$var$ErrorIcon.Name = "ErrorIconMigration";
var $b4cf4dbd977701b6$var$_default = $b4cf4dbd977701b6$exports.default = $b4cf4dbd977701b6$var$ErrorIcon;


var $ba3f601c2bb870a3$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d345d1980a5e7ce7680063890c36f7e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($ba3f601c2bb870a3$exports, "__esModule", {
    value: true
});
$ba3f601c2bb870a3$exports.default = void 0;

var $ba3f601c2bb870a3$var$_react = $ba3f601c2bb870a3$var$_interopRequireDefault((parcelRequire("acw62")));

var $ba3f601c2bb870a3$var$_success = $ba3f601c2bb870a3$var$_interopRequireDefault((parcelRequire("kOdz9")));

var $ba3f601c2bb870a3$var$_success2 = $ba3f601c2bb870a3$var$_interopRequireDefault((parcelRequire("7GNzJ")));
function $ba3f601c2bb870a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba3f601c2bb870a3$var$SuccessIcon = (props)=>/*#__PURE__*/ $ba3f601c2bb870a3$var$_react.default.createElement($ba3f601c2bb870a3$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $ba3f601c2bb870a3$var$_success2.default
    }, props));
$ba3f601c2bb870a3$var$SuccessIcon.Name = "SuccessIconMigration";
var $ba3f601c2bb870a3$var$_default = $ba3f601c2bb870a3$exports.default = $ba3f601c2bb870a3$var$SuccessIcon;



var $acw62 = parcelRequire("acw62");
var $6aef6ef376234231$export$3c4232819458a302 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);


/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $cb16a61bc9021082$var$messageStyles = null;
var $cb16a61bc9021082$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $cb16a61bc9021082$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $cb16a61bc9021082$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $5zphJ.default)([
            $cb16a61bc9021082$var$iconWrapperStyles.root
        ])
    }, children);
};
var $cb16a61bc9021082$var$messageIcons = {
    error: /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b4cf4dbd977701b6$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ba3f601c2bb870a3$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
var $cb16a61bc9021082$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $cb16a61bc9021082$var$messageIcons[appearance];
    var messageRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasMessageWrapper = _useState2[0], setHasMessageWrapper = _useState2[1];
    var _useContext = (0, $acw62.useContext)($cb16a61bc9021082$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    (0, $acw62.useEffect)(function() {
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : /*#__PURE__*/ $acw62.createElement("span", null, children);
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        "aria-live": !hasMessageWrapper ? "polite" : undefined,
        className: (0, $5zphJ.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $cb16a61bc9021082$var$messageAppearanceStyles[appearance]
        ])
    }, icon && /*#__PURE__*/ $acw62.createElement($cb16a61bc9021082$var$IconWrapper, null, icon), content);
};
var $cb16a61bc9021082$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $acw62.createElement((0, $6aef6ef376234231$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $acw62.createElement($cb16a61bc9021082$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $cb16a61bc9021082$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $acw62.createElement((0, $6aef6ef376234231$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $acw62.createElement($cb16a61bc9021082$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $cb16a61bc9021082$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $acw62.createElement((0, $6aef6ef376234231$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $acw62.createElement($cb16a61bc9021082$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $cb16a61bc9021082$var$MessageWrapperContext = /*#__PURE__*/ (0, $acw62.createContext)({
    isWrapper: false
});
var $cb16a61bc9021082$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $acw62.createElement($cb16a61bc9021082$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $fca5071e52876da9$var$fieldsetLabelStyles = null;
var $fca5071e52876da9$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $5zphJ.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $fca5071e52876da9$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $acw62.createElement("legend", {
        className: (0, $5zphJ.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};



/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");

var $dnCk4 = parcelRequire("dnCk4");
var $0958b1383b57e4f7$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "value",
    "style"
];
function $0958b1383b57e4f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0958b1383b57e4f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0958b1383b57e4f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0958b1383b57e4f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0958b1383b57e4f7$var$packageName = "@atlaskit/textarea";
var $0958b1383b57e4f7$var$packageVersion = "8.0.3";
var $0958b1383b57e4f7$var$analyticsParams = {
    componentName: "textArea",
    packageName: $0958b1383b57e4f7$var$packageName,
    packageVersion: $0958b1383b57e4f7$var$packageVersion
};
var $0958b1383b57e4f7$var$lineHeightBase = 20;
var $0958b1383b57e4f7$var$lineHeightCompact = 16;
var $0958b1383b57e4f7$var$compactVerticalPadding = 2;
var $0958b1383b57e4f7$var$verticalPadding = 6;
var $0958b1383b57e4f7$var$transitionDuration = "0.2s";
var $0958b1383b57e4f7$var$borderWidth = 2;
var $0958b1383b57e4f7$var$baseStyles = null;
var $0958b1383b57e4f7$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
var $0958b1383b57e4f7$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
var $0958b1383b57e4f7$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
var $0958b1383b57e4f7$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = "auto";
    var borderHeight = $0958b1383b57e4f7$var$borderWidth;
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $0958b1383b57e4f7$var$InnerTextArea = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var ourRef = (0, $acw62.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? "smart" : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? "50vh" : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, value = props.value, style = props.style, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $0958b1383b57e4f7$var$_excluded);
    var borderHeight = (0, $acw62.useMemo)(function() {
        return appearance === "none" ? 2 : 1;
    }, [
        appearance
    ]);
    (0, $acw62.useEffect)(function() {
        var el = ourRef.current;
        if (resize === "smart" && el) $0958b1383b57e4f7$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($0958b1383b57e4f7$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $0958b1383b57e4f7$var$analyticsParams));
    var onFocusWithAnalytics = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($0958b1383b57e4f7$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $0958b1383b57e4f7$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref) === "object") // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === "function") ref(elementRef);
    };
    var handleOnChange = (0, $acw62.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === "smart" && el) $0958b1383b57e4f7$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-testid": testId ? testId : undefined
    };
    var compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows
    }, rest, {
        className: (0, $5zphJ.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v5641gs0 _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazovqm _slp31hna _153gksl0 _usy41kd8 _1a2sh9qi _vbqbhxcb _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fraksl0 _ibjd12ci _6zpvh9qi _19k01ouc _1idrpsu8 _1lephxcb _nmhq1fiz _1n388sxn _1luh3zdg _ndzbkwt5 _1vj0119y",
            $0958b1383b57e4f7$var$appearanceStyles[appearance],
            (0, $ltooA.fg)("platform_design_system_team_safari_input_fix") && $0958b1383b57e4f7$var$fontStyles["large"],
            $0958b1383b57e4f7$var$fontStyles[isMonospaced ? "monospace" : "default"],
            $0958b1383b57e4f7$var$resizeStyles[resize],
            "_uzq71d1b _16lw1cn1"
        ]),
        style: $0958b1383b57e4f7$var$_objectSpread($0958b1383b57e4f7$var$_objectSpread({}, style), {}, {
            maxHeight: maxHeight,
            "--_5xk3r4": (0, $cZGu3.default)("var(--ds-text, ".concat((0, $dnCk4.N900), ")")),
            "--_19uzta9": (0, $cZGu3.default)("background-color ".concat($0958b1383b57e4f7$var$transitionDuration, " ease-in-out,\n               border-color ").concat($0958b1383b57e4f7$var$transitionDuration, " ease-in-out")),
            "--_dnrmjm": (0, $cZGu3.default)("var(--ds-text-disabled, ".concat((0, $dnCk4.N70), ")")),
            "--_t0vtv2": (0, $cZGu3.default)("var(--ds-background-input-pressed, ".concat((0, $dnCk4.N0), ")")),
            "--_xjqa3d": (0, $cZGu3.default)("var(--ds-border-focused, ".concat((0, $dnCk4.B200), ")")),
            "--_1n75f5r": (0, $cZGu3.default)("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-focused, ".concat((0, $dnCk4.B200), ")"))),
            "--_4mkb4g": (0, $cZGu3.default)("var(--ds-background-input, ".concat((0, $dnCk4.N10), ")")),
            "--_1u9fbts": (0, $cZGu3.default)("var(--ds-border-danger, ".concat((0, $dnCk4.R400), ")")),
            "--_1l1juom": (0, $cZGu3.default)("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, ".concat((0, $dnCk4.R400), ")"))),
            "--_r5pknd": (0, $cZGu3.default)("var(--ds-background-disabled, ".concat((0, $dnCk4.N20), ")")),
            "--_1z08gfx": (0, $cZGu3.default)("var(--ds-background-input-hovered, ".concat((0, $dnCk4.N30), ")")),
            "--_vrm7dk": (0, $cZGu3.default)("var(--ds-text-subtlest, ".concat((0, $dnCk4.N200), ")")),
            "--_dqsusn": (0, $cZGu3.default)("".concat($0958b1383b57e4f7$var$lineHeightCompact * minimumRows + $0958b1383b57e4f7$var$compactVerticalPadding * 2 + borderHeight * 2, "px")),
            "--_n9nqvh": (0, $cZGu3.default)("".concat($0958b1383b57e4f7$var$lineHeightBase * minimumRows + $0958b1383b57e4f7$var$verticalPadding * 2 + borderHeight * 2, "px"))
        })
    }));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $0958b1383b57e4f7$var$TextArea = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0958b1383b57e4f7$var$InnerTextArea, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, props));
}));
$0958b1383b57e4f7$var$TextArea.displayName = "TextArea";
var $0958b1383b57e4f7$export$2e2bcd8739ae039 = $0958b1383b57e4f7$var$TextArea;


/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");
var $59fee00d0d1a69dc$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $59fee00d0d1a69dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59fee00d0d1a69dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59fee00d0d1a69dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59fee00d0d1a69dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $59fee00d0d1a69dc$var$containerMedia = {
    invalid: "_srjtgir2",
    disabled: "_6up518qt"
};
var $59fee00d0d1a69dc$var$inputMediaDisabled = null;
var $59fee00d0d1a69dc$var$analyticsParams = {
    componentName: "textField",
    packageName: "@atlaskit/textfield",
    packageVersion: "8.0.4"
};
var $59fee00d0d1a69dc$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1lh4 _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1lh4 _80om13gf"
};
var $59fee00d0d1a69dc$var$invalidStyle = null;
var $59fee00d0d1a69dc$var$focusWithinStyle = {
    standard: "_ochr1p6i _195er01l _bqhtq049",
    subtle: "_ochr1p6i _195er01l _bqhtq049",
    none: "_ochr1j28 _195e1j28 _bqht3sij"
};
var $59fee00d0d1a69dc$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx1j28 _irr31j28"
};
var $59fee00d0d1a69dc$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _srjtgir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syaz1fxt _80om1kdv _16hg1j28 _srjtgir2",
    none: "_1h6d1j28 _1dqoglyw _syaz1fxt _80om1kdv _16hg1j28 _srjtgir2"
};
var $59fee00d0d1a69dc$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $59fee00d0d1a69dc$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $59fee00d0d1a69dc$var$widthMap ? "".concat($59fee00d0d1a69dc$var$widthMap[width], "px") : "".concat(+width, "px");
};
var $59fee00d0d1a69dc$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
var $59fee00d0d1a69dc$var$containerStyles = null;
var $59fee00d0d1a69dc$var$inputDisabledStyle = null;
var $59fee00d0d1a69dc$var$inputCompactStyleWithFg = null;
var $59fee00d0d1a69dc$var$inputCompactStyle = null;
var $59fee00d0d1a69dc$var$inputMonospacedStyle = null;
var $59fee00d0d1a69dc$var$inputFontStyleWithFG = null;
var $59fee00d0d1a69dc$var$inputStyleMonospacedWithFg = null;
var $59fee00d0d1a69dc$var$inputStyleNotDataCompactWithFG = null;
var $59fee00d0d1a69dc$var$inputStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $59fee00d0d1a69dc$var$Textfield = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $59fee00d0d1a69dc$var$_excluded);
    var inputRef = (0, $acw62.useRef)(null);
    var handleOnFocus = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($59fee00d0d1a69dc$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $59fee00d0d1a69dc$var$analyticsParams));
    var handleOnBlur = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($59fee00d0d1a69dc$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $59fee00d0d1a69dc$var$analyticsParams));
    var handleOnMouseDown = (0, $acw62.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== "INPUT") event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $acw62.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ref) === "object") ref.current = inputElement;
        if (typeof ref === "function") ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5zphJ.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $59fee00d0d1a69dc$var$getContainerTextBgAndBorderColor[appearance],
            $59fee00d0d1a69dc$var$containerStyleAppearance[appearance],
            !isDisabled && $59fee00d0d1a69dc$var$focusWithinStyle[appearance],
            !isDisabled && $59fee00d0d1a69dc$var$hoverStyle[appearance],
            isDisabled && $59fee00d0d1a69dc$var$containerMedia.disabled,
            isDisabled && $59fee00d0d1a69dc$var$disabledStyle[appearance],
            isInvalid && $59fee00d0d1a69dc$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qs13x5 _1dbz13x5 _10j7r01l",
            className
        ]),
        style: {
            maxWidth: "".concat($59fee00d0d1a69dc$var$getMaxWidth(width)),
            "--_x5k4n9": (0, $cZGu3.default)("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, #E2483D)"))
        }
    }, elemBeforeInput, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired,
        className: (0, $5zphJ.default)([
            "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
            isMonospaced && "_ect41odn",
            isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
            isDisabled && "_syaz1lh4 _1idr1lh4",
            isDisabled && "_1fnx18qt",
            !isCompact && (0, $ltooA.fg)("platform_design_system_team_safari_input_fix") && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            (0, $ltooA.fg)("platform_design_system_team_safari_input_fix") && "_11c81ixg _1tn22smr",
            isCompact && (0, $ltooA.fg)("platform_design_system_team_safari_input_fix") && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
            isMonospaced && (0, $ltooA.fg)("platform_design_system_team_safari_input_fix") && "_ect41odn _14md1odn"
        ])
    })), elemAfterInput);
});
var $59fee00d0d1a69dc$export$2e2bcd8739ae039 = $59fee00d0d1a69dc$var$Textfield;



var $acw62 = parcelRequire("acw62");
// Basic wrapper for local storage api, which safely handles the case where the local storage is full or have an error when setting an item
// Later we should add more capabilities like user context, expiration,etc.
const $d10d50fcd1dfe105$export$697e65b1658f821b = (namespace)=>{
    const getLocalStorage = ()=>{
        try {
            return window.localStorage;
        } catch (e) {
            console.error("Local storage is not available", e);
            return null;
        }
    };
    const getKey = (key)=>{
        return `${namespace}-${key}`;
    };
    const setItem = (key, value)=>{
        try {
            getLocalStorage()?.setItem(getKey(key), value);
        } catch (e) {
            console.error("Failed to set item", e);
        }
    };
    const removeItem = (key)=>{
        getLocalStorage()?.removeItem(getKey(key));
    };
    const clear = ()=>{
        getLocalStorage()?.clear();
    };
    const getItem = (key)=>{
        return getLocalStorage()?.getItem(getKey(key));
    };
    return {
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        getItem: getItem
    };
};


const $8a9ba3a276775f31$export$e4648128777cf15d = (lines)=>{
    return lines.join("\n");
};
const $8a9ba3a276775f31$export$af5d89918f1e18c4 = (input)=>{
    if (input.issue) return $8a9ba3a276775f31$export$e4648128777cf15d([
        "Please generate code to help me solve the following Jira issue:",
        "",
        `Summary: ${input.issue.summary}`,
        `Description: ${input.issue.description}`
    ]);
    return "";
};


const $682d87f459d73dfb$export$6eea4b23e6e0e7fc = (url)=>{
    return /^https:\/\/[^\s/$.?#].[^\s]*$/i.test(url);
};



const $bf9470823e7dbf36$var$validateRepositoryUrl = (url)=>{
    return (0, $682d87f459d73dfb$export$6eea4b23e6e0e7fc)(url);
};
const $bf9470823e7dbf36$var$validateBranchName = (name)=>{
    return name?.trim() !== "";
};
const $bf9470823e7dbf36$export$a7fed597f4b8afd8 = ({ initialBranchName: initialBranchName, initialRepositoryUrl: initialRepositoryUrl, isCreatingFlow: isCreatingFlow, selectedIssue: selectedIssue, onCancel: onCancel, onSubmit: onSubmit })=>{
    const localStorage = (0, $d10d50fcd1dfe105$export$697e65b1658f821b)("boysenberryRepository");
    const [prompt, setPrompt] = (0, $acw62.useState)(()=>selectedIssue ? (0, $8a9ba3a276775f31$export$af5d89918f1e18c4)({
            issue: selectedIssue
        }) : "");
    const [repositoryUrl, setRepositoryUrl] = (0, $acw62.useState)(()=>initialRepositoryUrl || localStorage.getItem("cloneUrl") || "");
    const [branchName, setBranchName] = (0, $acw62.useState)(initialBranchName);
    const [isInvalidRepositoryUrl, setIsInvalidRepositoryUrl] = (0, $acw62.useState)(!$bf9470823e7dbf36$var$validateRepositoryUrl(repositoryUrl));
    const [isInvalidBranchName, setIsInvalidBranchName] = (0, $acw62.useState)(!$bf9470823e7dbf36$var$validateBranchName(branchName));
    const handleOnChangeField = (0, $acw62.useCallback)((e)=>{
        setRepositoryUrl(e.target.value);
        setIsInvalidRepositoryUrl(!$bf9470823e7dbf36$var$validateRepositoryUrl(e.target.value));
    }, []);
    const handleBranchNameChange = (0, $acw62.useCallback)((e)=>{
        setBranchName(e.target.value);
        setIsInvalidBranchName(!$bf9470823e7dbf36$var$validateBranchName(e.target.value));
    }, []);
    const handleOnChangePrompt = (0, $acw62.useCallback)((e)=>{
        setPrompt(e.target.value);
    }, []);
    const handleSubmit = ()=>{
        if ($bf9470823e7dbf36$var$validateRepositoryUrl(repositoryUrl) && $bf9470823e7dbf36$var$validateBranchName(branchName)) {
            localStorage.setItem("cloneUrl", repositoryUrl);
            onSubmit(repositoryUrl, branchName, prompt);
        }
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
        space: "space.300",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                space: "space.100",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $fca5071e52876da9$export$b04be29aa201d4f5), {
                        htmlFor: "repository-url-input",
                        children: "What's the repository url used in this flow:"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $59fee00d0d1a69dc$export$2e2bcd8739ae039), {
                            id: "repository-url-input",
                            testId: "repository-url-input",
                            value: repositoryUrl,
                            onChange: handleOnChangeField,
                            placeholder: "https://bitbucket.org/atlassian/my-repo",
                            autoFocus: true,
                            isInvalid: isInvalidRepositoryUrl
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $cb16a61bc9021082$export$8fbe3c7d0ed2c683), {
                        children: [
                            "Example: ",
                            (0, $7b02d682eb115277$exports.jsx)((0, $d97b45edccfeae68$export$2e2bcd8739ae039), {
                                children: "https://bitbucket.org/atlassian/my-repo"
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                space: "space.100",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $fca5071e52876da9$export$b04be29aa201d4f5), {
                        htmlFor: "branch-name-input",
                        children: "Branch name:"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $59fee00d0d1a69dc$export$2e2bcd8739ae039), {
                        id: "branch-name-input",
                        testId: "branch-name-input",
                        value: branchName,
                        defaultValue: initialBranchName,
                        onChange: handleBranchNameChange,
                        isInvalid: isInvalidBranchName
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                space: "space.100",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $fca5071e52876da9$export$b04be29aa201d4f5), {
                        htmlFor: "prompt",
                        children: "Tell what you would like this flow to do:"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $0958b1383b57e4f7$export$2e2bcd8739ae039), {
                            id: "prompt",
                            testId: "prompt",
                            rows: 7,
                            value: prompt,
                            onChange: handleOnChangePrompt,
                            placeholder: "Create a landing page for my new product"
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
                space: "space.100",
                alignInline: "end",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        onClick: onCancel,
                        children: "Cancel"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                        appearance: "primary",
                        testId: "confirm-repository",
                        onClick: handleSubmit,
                        isDisabled: isInvalidRepositoryUrl || isInvalidBranchName,
                        isLoading: isCreatingFlow,
                        children: "Confirm"
                    })
                ]
            })
        ]
    });
};



const $1d5c0065d0f65928$var$RepositoryModalWrapper = ({ isOpen: isOpen, isSubmitPending: isSubmitPending, onClose: onClose, onSubmit: onSubmit, initialBranchName: initialBranchName, selectedIssue: selectedIssue })=>{
    return (0, $7b02d682eb115277$exports.jsx)((0, $d935d45ecc0a58cd$export$2e2bcd8739ae039), {
        children: isOpen && (0, $7b02d682eb115277$exports.jsx)($1d5c0065d0f65928$var$RepositoryModalDialog, {
            initialBranchName: initialBranchName,
            isSubmitPending: isSubmitPending,
            onClose: onClose,
            onSubmit: onSubmit,
            selectedIssue: selectedIssue
        })
    });
};
const $1d5c0065d0f65928$var$RepositoryModalDialog = ({ isSubmitPending: isSubmitPending, onClose: onClose, onSubmit: onSubmit, initialBranchName: initialBranchName, selectedIssue: selectedIssue })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $49f7c216070fc3db$export$2e2bcd8739ae039), {
        onClose: onClose,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $185e137d176d1262$export$2e2bcd8739ae039), {
                hasCloseButton: true,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $dc702393df320999$export$2e2bcd8739ae039), {
                    children: "Create a new flow"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $f7609201e9bc2976$export$2e2bcd8739ae039), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                    paddingBlockEnd: "space.300",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $bf9470823e7dbf36$export$a7fed597f4b8afd8), {
                        initialBranchName: initialBranchName,
                        isCreatingFlow: isSubmitPending,
                        onCancel: onClose,
                        onSubmit: onSubmit,
                        selectedIssue: selectedIssue
                    })
                })
            })
        ]
    });
};
const $1d5c0065d0f65928$export$69e0a26a343ce256 = ({ branchName: branchName, onConfirm: onConfirm, isSubmitPending: isSubmitPending, selectedIssue: selectedIssue })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    const openModal = ()=>{
        setIsOpen(true);
        analyticsWebClient.sendUIEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "start-session",
            source: "boysenberry-home"
        });
    };
    const closeModal = ()=>{
        setIsOpen(false);
    };
    const handleConfirm = (repositoryUrl, branchName, prompt)=>{
        onConfirm(repositoryUrl, branchName, prompt);
        analyticsWebClient.sendUIEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "confirm-repository",
            source: "boysenberry-home"
        });
    };
    return {
        openModal: openModal,
        closeModal: closeModal,
        RepositoryModal: (0, $7b02d682eb115277$exports.jsx)($1d5c0065d0f65928$var$RepositoryModalWrapper, {
            initialBranchName: branchName,
            selectedIssue: selectedIssue,
            isOpen: isOpen,
            onClose: closeModal,
            onSubmit: handleConfirm,
            isSubmitPending: isSubmitPending
        })
    };
};





var $127MC = parcelRequire("127MC");
var $ed7a54b61160bbae$exports = {};
"use strict";
Object.defineProperty($ed7a54b61160bbae$exports, "__esModule", {
    value: true
});
$ed7a54b61160bbae$exports.default = void 0;

var $ed7a54b61160bbae$var$_react = $ed7a54b61160bbae$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");
function $ed7a54b61160bbae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ed7a54b61160bbae$var$PresenceActiveIcon = (props)=>/*#__PURE__*/ $ed7a54b61160bbae$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="6" fill="currentcolor" fill-rule="evenodd"/></svg>`
    }, props));
$ed7a54b61160bbae$var$PresenceActiveIcon.displayName = "PresenceActiveIcon";
var $ed7a54b61160bbae$var$_default = $ed7a54b61160bbae$exports.default = $ed7a54b61160bbae$var$PresenceActiveIcon;




/* menu-link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");




/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $fcf8dc8ded2923a0$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $fcf8dc8ded2923a0$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $acw62.useContext)($fcf8dc8ded2923a0$export$a20dad690e1279e2);
};
var $fcf8dc8ded2923a0$var$defaultAvatarContentProps = {
    as: "span",
    appearance: "circle",
    avatarImage: null,
    ref: null,
    size: "medium"
};
var $fcf8dc8ded2923a0$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $acw62.createContext)($fcf8dc8ded2923a0$var$defaultAvatarContentProps);
var $fcf8dc8ded2923a0$export$79d078b69b7e4842 = function useAvatarContent() {
    return (0, $acw62.useContext)($fcf8dc8ded2923a0$export$b983474ddd0b6d28);
};
var $fcf8dc8ded2923a0$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $fcf8dc8ded2923a0$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $acw62.useContext)($fcf8dc8ded2923a0$export$6b4cbd90d24955ad);
    if (!context) throw new Error("Avatar sub-components must be used within a Avatar component.");
};






/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ var $5a89adf5f55214c0$export$d492445a79a49b48 = "12px";



var $acw62 = parcelRequire("acw62");

var $bv4qN = parcelRequire("bv4qN");
var $0eb198661eb5e9c3$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $0eb198661eb5e9c3$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $0eb198661eb5e9c3$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $0eb198661eb5e9c3$export$572ce188c913ceba = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $0eb198661eb5e9c3$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $0eb198661eb5e9c3$export$37e565a09598825e = function useIsExpanded() {
    var context = (0, $acw62.useContext)($0eb198661eb5e9c3$export$c856e5885cc34d81);
    (0, $bv4qN.default)(context !== null, "useIsExpanded must be used within an ExpandableMenuItem");
    return context;
};
var $0eb198661eb5e9c3$export$c9a171ea8de5861b = function useSetIsExpanded() {
    var context = (0, $acw62.useContext)($0eb198661eb5e9c3$export$48cb11cb8691f597);
    (0, $bv4qN.default)(context !== null, "useSetIsExpanded must be used within an ExpandableMenuItem");
    return context;
};
var $0eb198661eb5e9c3$export$56c8438498b72c7a = function useOnExpansionToggle() {
    return (0, $acw62.useContext)($0eb198661eb5e9c3$export$572ce188c913ceba);
};
var $0eb198661eb5e9c3$export$fdfe9e5e8183d4f2 = function useLevel() {
    return (0, $acw62.useContext)($0eb198661eb5e9c3$export$650d12d3c2ddb8fc);
};
var $0eb198661eb5e9c3$export$57108b5f08ae5194 = function useAreAllAncestorsExpanded() {
    var _useContext;
    return (_useContext = (0, $acw62.useContext)($0eb198661eb5e9c3$export$9c01e0e6a504d553)) !== null && _useContext !== void 0 ? _useContext : true;
};



var $acw62 = parcelRequire("acw62");

var $ba8332364ef07b5e$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $acw62.createContext)(false);
var $ba8332364ef07b5e$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $acw62.createContext)((0, $d3997b4aab843580$export$2e2bcd8739ae039));
var $ba8332364ef07b5e$export$6927118f874a49aa = function useFlyoutMenuOpen() {
    return (0, $acw62.useContext)($ba8332364ef07b5e$export$efa4d9670e96ac31);
};
var $ba8332364ef07b5e$export$538ac1aa421adb94 = function useSetFlyoutMenuOpen() {
    return (0, $acw62.useContext)($ba8332364ef07b5e$export$4c55b1c61a116b42);
};


var $12593ed091de44f1$export$f4b8e24fae579c6f = Symbol("collapse-elem-before");


var $a5ab0d53dc469e4b$var$_excluded = [
    "children",
    "className"
];
function $a5ab0d53dc469e4b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5ab0d53dc469e4b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5ab0d53dc469e4b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5ab0d53dc469e4b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a5ab0d53dc469e4b$var$tooltipStyles = {
    root: "_2rkoglpi _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
var $a5ab0d53dc469e4b$var$MenuItemTooltip = /*#__PURE__*/ (0, $acw62.forwardRef)(function MenuItemTooltip(_ref, ref) {
    var children = _ref.children, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a5ab0d53dc469e4b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $992814645ec028bf$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $5zphJ.default)([
            $a5ab0d53dc469e4b$var$tooltipStyles.root,
            className
        ]),
        ref: ref
    }), children);
});
function $a5ab0d53dc469e4b$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
var $a5ab0d53dc469e4b$var$defaultAvatarValues = {
    size: "small"
};
var $a5ab0d53dc469e4b$var$elemAfterDisplayVar = "--elem-after-display";
var $a5ab0d53dc469e4b$var$actionsOnHoverDisplayVar = "--actions-on-hover-display";
var $a5ab0d53dc469e4b$var$notchColorVar = "--notch-color";
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ var $a5ab0d53dc469e4b$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ var $a5ab0d53dc469e4b$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
var $a5ab0d53dc469e4b$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
var $a5ab0d53dc469e4b$var$containerStyles = {
    root: "_2rkoglpi _vchhusvi _1e0c11p5 _yv0eaa4y _1ul9t9kd _4t3izwfg _4cvr1h6o _uiztglyw _syaz1gjq _ek6gglyw _1yyu1j28 _91ju1txw _1swv108i _1ojv1txw _irr3108i _1brr1txw _109x1txw",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_ek6g1txw",
    removeElemAfterOnHover: "_1mfcglyw _1sjuglyw",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _irr3n7od",
    hasDescription: "_4t3ickbl"
};
var $a5ab0d53dc469e4b$var$buttonOrAnchorStyles = {
    root: "_2rkoglpi _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _4t3i1osq _1q511b66 _y4ti1b66 _85i51b66 _bozg1b66 _bfhk1j28 _syaz1gjq _4cvr1h6o _y3gnv2br",
    active: "_14iu1ji5",
    selected: "_syazaqb7 _1di619ru"
};
var $a5ab0d53dc469e4b$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
var $a5ab0d53dc469e4b$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
var $a5ab0d53dc469e4b$var$actionStyles = {
    root: "_zulp1b66 _1reo15vq _18m915vq _1ii7kb7n _yyhyqfx8 _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
var $a5ab0d53dc469e4b$var$actionsOnHoverStyles = {
    root: "_zulp1b66 _1reo15vq _18m915vq _1ii7kb7n _yyhy11wp _1e0c1c3z _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
var $a5ab0d53dc469e4b$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _yyhycs5v _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
var $a5ab0d53dc469e4b$var$elemBeforeStyles = {
    root: "_1reo15vq _18m915vq _yyhykb7n _1ii7kb7n _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh1ntv _1guo18uv _12s918uv"
};
var $a5ab0d53dc469e4b$var$elemAfterStyles = {
    root: "_1reo15vq _18m915vq _yyhyegat _1ii7kb7n _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
function $a5ab0d53dc469e4b$var$getTextColor(_ref2) {
    var isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected;
    if (isDisabled) return "color.text.disabled";
    if (isSelected) return "color.text.selected";
    return "color.text.subtle";
}
/**
 * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
 *
 * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
 * expanded content for ExpandableMenuItem.
 */ /**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ var $a5ab0d53dc469e4b$var$MenuItemBaseNoRef = function MenuItemBaseNoRef(_ref3, forwardedRef) {
    var testId = _ref3.testId, actions = _ref3.actions, actionsOnHover = _ref3.actionsOnHover, children = _ref3.children, description = _ref3.description, elemAfter = _ref3.elemAfter, elemBefore = _ref3.elemBefore, href = _ref3.href, target = _ref3.target, isDisabled = _ref3.isDisabled, isSelected = _ref3.isSelected, onClick = _ref3.onClick, ariaControls = _ref3.ariaControls, ariaExpanded = _ref3.ariaExpanded, ariaHasPopup = _ref3.ariaHasPopup, interactionName = _ref3.interactionName, isContentTooltipDisabled = _ref3.isContentTooltipDisabled, visualContentRef = _ref3.visualContentRef;
    var level = (0, $0eb198661eb5e9c3$export$fdfe9e5e8183d4f2)();
    var setFlyoutMenuOpen = (0, $ba8332364ef07b5e$export$538ac1aa421adb94)();
    var isFlyoutMenuOpen = (0, $ba8332364ef07b5e$export$6927118f874a49aa)();
    var isLink = typeof href !== "undefined";
    var labelRef = (0, $acw62.useRef)(null);
    var descriptionRef = (0, $acw62.useRef)(null);
    var tooltipOnClick = (0, $acw62.useRef)(null);
    var handleClick = (0, $acw62.useCallback)(function(event, analyticsEvent) {
        var _tooltipOnClick$curre;
        onClick === null || onClick === void 0 || onClick(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        (_tooltipOnClick$curre = tooltipOnClick.current) === null || _tooltipOnClick$curre === void 0 || _tooltipOnClick$curre.call(tooltipOnClick, event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ var canTooltipAppear = (0, $acw62.useCallback)(function() {
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        var label = labelRef.current;
        var description = descriptionRef.current;
        if (label && $a5ab0d53dc469e4b$var$isTextClamped(label)) return true;
        return Boolean(description && $a5ab0d53dc469e4b$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    var showElemBefore = elemBefore !== (0, $12593ed091de44f1$export$f4b8e24fae579c6f);
    var interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        // This extends the clickable area of nested menu items to the width
        // of the root level menu items, while being visually indented.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            insetInlineStart: "calc(-1 * ".concat(level, " * ").concat((0, $5a89adf5f55214c0$export$d492445a79a49b48), ")")
        },
        "aria-hidden": "true",
        className: (0, $5zphJ.default)([
            $a5ab0d53dc469e4b$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            $a5ab0d53dc469e4b$var$textStyles.root,
            !showElemBefore && $a5ab0d53dc469e4b$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
        weight: "medium",
        maxLines: 1,
        color: $a5ab0d53dc469e4b$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        ref: labelRef
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
        color: isDisabled ? "color.text.disabled" : "color.text.subtle",
        size: "small",
        maxLines: 1,
        ref: descriptionRef
    }, description)));
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ var showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fcf8dc8ded2923a0$export$a20dad690e1279e2).Provider, {
        value: $a5ab0d53dc469e4b$var$defaultAvatarValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: visualContentRef,
        "data-testid": testId ? "".concat(testId, "-container") : undefined,
        "data-selected": isSelected,
        className: (0, $5zphJ.default)([
            $a5ab0d53dc469e4b$var$containerStyles.root,
            isSelected && $a5ab0d53dc469e4b$var$containerStyles.selected,
            description && $a5ab0d53dc469e4b$var$containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && $a5ab0d53dc469e4b$var$containerStyles.showHoverActions,
            showHoverActionsWhenNotHovered && elemAfter && $a5ab0d53dc469e4b$var$containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && $a5ab0d53dc469e4b$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && $a5ab0d53dc469e4b$var$containerStyles.disabled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fa9833ed171567b$export$2e2bcd8739ae039), {
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, description) : null);
        },
        position: "right",
        component: $a5ab0d53dc469e4b$var$MenuItemTooltip,
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true,
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, function(tooltipProps) {
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        var sharedProps = $a5ab0d53dc469e4b$var$_objectSpread($a5ab0d53dc469e4b$var$_objectSpread({}, tooltipProps), {}, {
            "aria-controls": ariaControls,
            "aria-haspopup": ariaHasPopup,
            ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
                forwardedRef,
                tooltipProps.ref
            ]),
            testId: testId,
            interactionName: interactionName
        });
        return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11cad149381bd130$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, sharedProps, {
            onClick: handleClick,
            xcss: (0, $9b698034c8c53dd8$export$a274e22fb40f762e)($a5ab0d53dc469e4b$var$buttonOrAnchorStyles.root, $a5ab0d53dc469e4b$var$topLevelSiblingStyles.root, isSelected && $a5ab0d53dc469e4b$var$buttonOrAnchorStyles.selected),
            style: {
                textDecoration: "none"
            },
            "aria-current": isSelected ? "page" : undefined,
            href: href,
            target: target
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-hidden": "true",
            className: (0, $5zphJ.default)([
                $a5ab0d53dc469e4b$var$notchStyles.root
            ])
        }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a92da350b7429b4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, sharedProps, {
            onClick: handleClick,
            xcss: (0, $9b698034c8c53dd8$export$a274e22fb40f762e)($a5ab0d53dc469e4b$var$buttonOrAnchorStyles.root, $a5ab0d53dc469e4b$var$buttonOrAnchorStyles.active, $a5ab0d53dc469e4b$var$topLevelSiblingStyles.root, isSelected && $a5ab0d53dc469e4b$var$buttonOrAnchorStyles.selected),
            "aria-expanded": ariaExpanded,
            isDisabled: isDisabled
        }), interactiveElemContent);
    }), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            $a5ab0d53dc469e4b$var$elemBeforeStyles.root,
            $a5ab0d53dc469e4b$var$topLevelSiblingStyles.root,
            $a5ab0d53dc469e4b$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            $a5ab0d53dc469e4b$var$actionsOnHoverStyles.root
        ])
    }, actionsOnHover), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            $a5ab0d53dc469e4b$var$elemAfterStyles.root,
            $a5ab0d53dc469e4b$var$topLevelSiblingStyles.root,
            $a5ab0d53dc469e4b$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            $a5ab0d53dc469e4b$var$actionStyles.root,
            $a5ab0d53dc469e4b$var$topLevelSiblingStyles.root,
            $a5ab0d53dc469e4b$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions)));
};
var $a5ab0d53dc469e4b$export$859b390bf71e044e = (0, $96640c64143ff394$export$8ab756e06c5d9001)($a5ab0d53dc469e4b$var$MenuItemBaseNoRef);



var $acw62 = parcelRequire("acw62");

var $bv4qN = parcelRequire("bv4qN");

function $c928ee238de953b6$var$scrollMenuItemIntoView(element) {
    var _element$scrollIntoVi;
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ if (typeof element.scrollIntoViewIfNeeded === "function") {
        element.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    (_element$scrollIntoVi = element.scrollIntoView) === null || _element$scrollIntoVi === void 0 || _element$scrollIntoVi.call(element, {
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: "nearest"
    });
}
function $c928ee238de953b6$export$2c52ec851fcc6058(_ref) {
    var elementRef = _ref.elementRef, isSelected = _ref.isSelected;
    var areAllAncestorsExpanded = (0, $0eb198661eb5e9c3$export$57108b5f08ae5194)();
    var waitingStateRef = (0, $acw62.useRef)({
        type: "waiting-to-be-selected-and-all-ancestors-expanded"
    });
    (0, $acw62.useEffect)(function() {
        if (waitingStateRef.current.type === "waiting-to-be-selected-and-all-ancestors-expanded") {
            var shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            var element = elementRef.current;
            (0, $bv4qN.default)(element, "Element ref must be set");
            $c928ee238de953b6$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = "waiting-to-be-unselected";
            return;
        }
        if (waitingStateRef.current.type === "waiting-to-be-unselected") {
            if (!isSelected) waitingStateRef.current.type = "waiting-to-be-selected-and-all-ancestors-expanded";
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}


var $84eeeb22b70a3bef$var$listItemStyles = {
    root: "_10m98stt"
};
var $84eeeb22b70a3bef$var$MenuLinkItemNoRef = function MenuLinkItemNoRef(_ref, forwardedRef) {
    var testId = _ref.testId, actions = _ref.actions, children = _ref.children, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, target = _ref.target, actionsOnHover = _ref.actionsOnHover, isSelected = _ref.isSelected, onClick = _ref.onClick, interactionName = _ref.interactionName, isContentTooltipDisabled = _ref.isContentTooltipDisabled, visualContentRef = _ref.visualContentRef, listItemRef = _ref.listItemRef;
    var itemRef = (0, $acw62.useRef)(null);
    (0, $c928ee238de953b6$export$2c52ec851fcc6058)({
        elementRef: itemRef,
        isSelected: isSelected !== null && isSelected !== void 0 ? isSelected : false
    });
    var ref = (0, $acw62.useMemo)(function() {
        return (0, $270747da43296caf$export$2e2bcd8739ae039)([
            itemRef,
            listItemRef !== null && listItemRef !== void 0 ? listItemRef : null
        ]);
    }, [
        listItemRef,
        itemRef
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $1a92f85ba0e22d9c$export$a7b06bfba60a8a78), {
        ref: ref,
        xcss: $84eeeb22b70a3bef$var$listItemStyles.root
    }, /*#__PURE__*/ $acw62.createElement((0, $a5ab0d53dc469e4b$export$859b390bf71e044e), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled
    }, children));
};
var $84eeeb22b70a3bef$export$68ef190193a37bc2 = (0, $96640c64143ff394$export$8ab756e06c5d9001)($84eeeb22b70a3bef$var$MenuLinkItemNoRef);





/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jjlaj = parcelRequire("jjlaj");

var $246b20cce3342d64$var$footerStyles = (0, $jjlaj.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--ds-space-100, 8px)",
    marginBlockStart: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $246b20cce3342d64$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $ede1f1939e49e4d2$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $jjlaj.jsx)("div", {
        css: $246b20cce3342d64$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $246b20cce3342d64$export$2e2bcd8739ae039 = $246b20cce3342d64$var$ModalFooter;



var $acw62 = parcelRequire("acw62");

const $3baebe2d33227ee4$var$ConfirmationModalWrapper = ({ title: title, confirmBody: confirmBody, isOpen: isOpen, onConfirm: onConfirm, onClose: onClose })=>{
    return (0, $7b02d682eb115277$exports.jsx)((0, $d935d45ecc0a58cd$export$2e2bcd8739ae039), {
        children: isOpen && (0, $7b02d682eb115277$exports.jsx)($3baebe2d33227ee4$var$ConfirmationModal, {
            title: title,
            confirmBody: confirmBody,
            onConfirm: onConfirm,
            onClose: onClose
        })
    });
};
const $3baebe2d33227ee4$var$ConfirmationModal = ({ title: title, confirmBody: confirmBody, onConfirm: onConfirm, onClose: onClose })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $49f7c216070fc3db$export$2e2bcd8739ae039), {
        onClose: onClose,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $185e137d176d1262$export$2e2bcd8739ae039), {
                hasCloseButton: true,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $dc702393df320999$export$2e2bcd8739ae039), {
                    appearance: "danger",
                    children: title
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $f7609201e9bc2976$export$2e2bcd8739ae039), {
                children: confirmBody
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $246b20cce3342d64$export$2e2bcd8739ae039), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        onClick: onClose,
                        testId: "confirmation-modal-cancel",
                        children: "Cancel"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                        appearance: "danger",
                        onClick: onConfirm,
                        testId: "confirmation-modal-confirm",
                        children: "Confirm"
                    })
                ]
            })
        ]
    });
};
const $3baebe2d33227ee4$export$6e641f8ac1760e91 = ({ onConfirm: onConfirm, title: title, confirmBody: confirmBody })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const openConfirmationModal = (0, $acw62.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const closeConfirmationModal = (0, $acw62.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const handleConfirm = (0, $acw62.useCallback)(()=>{
        onConfirm();
        closeConfirmationModal();
    }, [
        onConfirm,
        closeConfirmationModal
    ]);
    return {
        openConfirmationModal: openConfirmationModal,
        closeConfirmationModal: closeConfirmationModal,
        ConfirmationModal: (0, $7b02d682eb115277$exports.jsx)($3baebe2d33227ee4$var$ConfirmationModalWrapper, {
            title: title,
            confirmBody: confirmBody,
            isOpen: isOpen,
            onConfirm: handleConfirm,
            onClose: closeConfirmationModal
        })
    };
};






var $e3ac7a3fb3c33c11$var$_useCompleteFlowMutation;

const $e3ac7a3fb3c33c11$export$a4d687327b185037 = ()=>{
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    const { user: user } = (0, $690d3d7c4f641feb$export$69bbac602c81ca6e)();
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { cloudId: cloudId } = tenantContexts[0];
    const [commit, isPending] = (0, $2d93712440e0508b$exports.useMutation)($e3ac7a3fb3c33c11$var$_useCompleteFlowMutation !== void 0 ? $e3ac7a3fb3c33c11$var$_useCompleteFlowMutation : $e3ac7a3fb3c33c11$var$_useCompleteFlowMutation = (parcelRequire("9qHPW")));
    const completeSession = (id, flowARI)=>{
        const updater = (store, response)=>{
            if (response?.devai_flowSessionComplete?.status !== "COMPLETED") return;
            const root = store.getRoot();
            const sessions = root.getLinkedRecords("devai_flowSessionsByCreatorAndCloudId", {
                creator: user?.accountId,
                cloudId: cloudId
            });
            if (sessions) {
                // Filter out the completed session
                const updatedSessions = sessions.filter((session)=>session?.getValue("id") !== id);
                // Update the connection with the filtered list
                root.setLinkedRecords(updatedSessions, "devai_flowSessionsByCreatorAndCloudId", {
                    creator: user?.accountId,
                    cloudId: cloudId
                });
            }
        };
        const trackSuccessEvent = ()=>{
            analyticsWebClient.sendOperationalEvent({
                action: "success",
                actionSubject: "complete-flow",
                source: "use-complete-flow",
                attributes: {
                    flowARI: flowARI
                }
            });
        };
        const trackFailedEvent = (error)=>{
            analyticsWebClient.sendOperationalEvent({
                action: "failed",
                actionSubject: "complete-flow",
                source: "use-complete-flow",
                attributes: {
                    flowARI: flowARI,
                    error: error.message
                }
            });
        };
        commit({
            variables: {
                id: flowARI
            },
            optimisticResponse: {
                devai_flowSessionComplete: {
                    id: id,
                    sessionARI: flowARI,
                    status: "COMPLETED"
                }
            },
            optimisticUpdater: updater,
            updater: updater,
            onCompleted: (response)=>{
                if (response?.devai_flowSessionComplete?.status === "COMPLETED") trackSuccessEvent();
                else trackFailedEvent(new Error("Couldn't complete flow"));
            },
            onError: (error)=>{
                trackFailedEvent(error);
            }
        });
    };
    return [
        completeSession,
        isPending
    ];
};



const $625587502b80ca40$var$getColor = (status)=>{
    if (status === "IN_PROGRESS") return "var(--ds-icon-accent-lime, #6A9A23)";
    return "var(--ds-icon-accent-yellow, #B38600)";
};
const $625587502b80ca40$var$StatusIcon = ({ status: status })=>{
    const color = $625587502b80ca40$var$getColor(status);
    return (0, $7b02d682eb115277$exports.jsx)((0, $6fa9833ed171567b$export$2e2bcd8739ae039), {
        content: `Status: ${status}`,
        children: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ed7a54b61160bbae$exports))), {
            primaryColor: color,
            label: status
        })
    });
};
const $625587502b80ca40$var$TerminateFlowButton = ({ onClick: onClick, isDisabled: isDisabled })=>{
    return (0, $7b02d682eb115277$exports.jsx)((0, $6fa9833ed171567b$export$2e2bcd8739ae039), {
        content: "Terminate this flow",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $53997ce7dd1542b7$export$2e2bcd8739ae039), {
            testId: "terminate-flow-button",
            appearance: "subtle",
            onClick: onClick,
            isDisabled: isDisabled,
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($127MC))),
            label: "Terminate this flow"
        })
    });
};
const $625587502b80ca40$export$805d95ba9e806026 = ({ icon: icon, children: children, href: href, status: status, id: id, flowARI: flowARI })=>{
    const [routeState, routerActions] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    const [completeSession, isCompletePending] = (0, $e3ac7a3fb3c33c11$export$a4d687327b185037)();
    const { openConfirmationModal: openConfirmationModal, ConfirmationModal: ConfirmationModal } = (0, $3baebe2d33227ee4$export$6e641f8ac1760e91)({
        title: "Are you sure you want to terminate this flow?",
        confirmBody: (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "This operation is irreversible, please ensure you have saved all your work. "
        }),
        onConfirm: ()=>{
            if (id && flowARI) completeSession(id, flowARI);
        }
    });
    const handleComplete = (e)=>{
        e.stopPropagation();
        if (id && flowARI) openConfirmationModal();
    };
    if (!id || !flowARI) return null;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $84eeeb22b70a3bef$export$68ef190193a37bc2), {
        href: href,
        elemBefore: icon,
        elemAfter: (0, $7b02d682eb115277$exports.jsxs)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)($625587502b80ca40$var$StatusIcon, {
                    status: status
                }),
                (0, $7b02d682eb115277$exports.jsx)($625587502b80ca40$var$TerminateFlowButton, {
                    onClick: handleComplete,
                    isDisabled: isCompletePending
                })
            ]
        }),
        isSelected: routeState.match.url === `${routeState.basePath}${href}`,
        onClick: (e)=>{
            if (href) {
                e.preventDefault();
                routerActions.push(href);
                analyticsWebClient.sendUIEvent({
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "boysenberry-navigation-item",
                    source: "boysenberry-sidebar"
                });
            }
        },
        children: [
            children,
            ConfirmationModal
        ]
    });
};



var $f352784c9ce781b8$var$_flowsQuery;

const $f352784c9ce781b8$var$FlowItems = ({ queryRef: queryRef })=>{
    const data = (0, $2d93712440e0508b$exports.usePreloadedQuery)($f352784c9ce781b8$var$_flowsQuery !== void 0 ? $f352784c9ce781b8$var$_flowsQuery : $f352784c9ce781b8$var$_flowsQuery = (parcelRequire("4q3AQ")), queryRef);
    const inProgressFlows = (0, $acw62.useMemo)(()=>{
        return data.devai_flowSessionsByCreatorAndCloudId?.filter(// TODO: replace this with a filter through the query
        (flow)=>flow?.status === "IN_PROGRESS") ?? [];
    }, [
        data.devai_flowSessionsByCreatorAndCloudId
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: inProgressFlows.map((flow)=>{
            const { branchName: branchName } = (0, $a9fa3d0bb0d11e02$export$7ad44063fdf1b9d)(flow?.additionalInfoJSON ?? "{}");
            return (0, $7b02d682eb115277$exports.jsx)((0, $625587502b80ca40$export$805d95ba9e806026), {
                id: flow?.id,
                flowARI: flow?.sessionARI,
                icon: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5c97e6b36a7bc9b8$exports))), {
                    label: "Flow",
                    size: "medium"
                }),
                status: flow?.status ?? "",
                href: (0, $2cf4acc76693ef07$export$ba128a57e6df3736)(flow?.id ?? ""),
                children: branchName ?? `New flow - ${flow?.id}`
            }, flow?.id);
        })
    });
};
const $f352784c9ce781b8$export$a1ef158a6380b092 = ({ queryRef: queryRef })=>{
    const [createFlow, isPending] = (0, $b827bd2eb59618e8$export$bfb165159aabd81d)();
    const { openModal: openModal, closeModal: closeModal, RepositoryModal: RepositoryModal } = (0, $1d5c0065d0f65928$export$69e0a26a343ce256)({
        branchName: `NO-ISSUE-${Date.now()}`,
        onConfirm: (repositoryUrl, branchName, prompt)=>{
            createFlow({
                repoUrl: repositoryUrl,
                branchName: branchName,
                prompt: prompt,
                onSuccess: ()=>{
                    closeModal();
                }
            });
        },
        isSubmitPending: isPending
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $983ce119fc15eacb$export$4b1545b4f2016d26), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $d5a1d224e04d4791$export$5d3acdbf9237a364), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
                    space: "space.100",
                    spread: "space-between",
                    alignBlock: "center",
                    children: [
                        "Flows",
                        (0, $7b02d682eb115277$exports.jsx)((0, $53997ce7dd1542b7$export$2e2bcd8739ae039), {
                            onClick: openModal,
                            label: "New flow",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($b9569ae36860c8eb$exports))),
                            appearance: "subtle",
                            spacing: "compact"
                        })
                    ]
                })
            }),
            queryRef && (0, $7b02d682eb115277$exports.jsx)($f352784c9ce781b8$var$FlowItems, {
                queryRef: queryRef
            }),
            RepositoryModal
        ]
    });
};



const $b091e1a4de596bb7$export$6b9e9e78a8c6019f = ()=>{
    const { user: user } = (0, $690d3d7c4f641feb$export$69bbac602c81ca6e)();
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { cloudId: cloudId } = tenantContexts[0];
    const [queryRef, loadQuery] = (0, $2d93712440e0508b$exports.useQueryLoader)((0, $4q3AQ.default));
    (0, $acw62.useEffect)(()=>{
        if (user?.accountId && cloudId) loadQuery({
            creator: user.accountId,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        user?.accountId,
        cloudId
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $273a2ae2279c22d2$export$e926676385687eaf), {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $efc76caa3f4e1993$export$babe3c784778f3ba), {
            children: (0, $7b02d682eb115277$exports.jsx)((0, $ee32a0ae812c612c$export$d4c4e98c5044dc8), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $f352784c9ce781b8$export$a1ef158a6380b092), {
                    queryRef: queryRef
                })
            })
        })
    });
};



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $bb97553b5b099267$export$4673cbff94e146e2 = ()=>{
    const colorMode = (0, $fa26c3c32090668f$export$20f3076712c8dfa)();
    const setColorMode = (0, $fa26c3c32090668f$export$e2afe7397c3d11c7)();
    (0, $acw62.useEffect)(()=>{
        if (colorMode !== "dark") setColorMode("dark");
    }, [
        colorMode,
        setColorMode
    ]);
};



var $acw62 = parcelRequire("acw62");
const $61a4c70bdf4ee986$export$1252d0179ae6292b = (initialFavicon)=>{
    const [favicon, setFavicon] = (0, $acw62.useState)(initialFavicon);
    (0, $acw62.useEffect)(()=>{
        const link = document.querySelector('link[rel="icon"][type="image/svg+xml"]');
        if (link) link.href = favicon;
        else {
            const link = document.createElement("link");
            link.rel = "icon";
            link.type = "image/svg+xml";
            link.href = favicon;
            document.head.appendChild(link);
        }
    }, [
        favicon
    ]);
    return setFavicon;
};



const $22c6e38358bb9501$export$bc1fe2419086c7e0 = ({ children: children, isFullscreen: isFullscreen })=>{
    (0, $bb97553b5b099267$export$4673cbff94e146e2)();
    (0, $61a4c70bdf4ee986$export$1252d0179ae6292b)((0, $f7f0296dce984358$export$f855a9abeb935dca));
    const suspendedChildren = (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
        children: children
    });
    if (isFullscreen) return suspendedChildren;
    return (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        padding: "space.400",
        children: suspendedChildren
    });
};



var $6Yjvt = parcelRequire("6Yjvt");
parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");


var $407da411a640d42c$var$_codeFrame_loadFlowQuery;

const $407da411a640d42c$export$6310d407093f41e5 = ({ queryRef: queryRef })=>{
    const data = (0, $2d93712440e0508b$exports.usePreloadedQuery)($407da411a640d42c$var$_codeFrame_loadFlowQuery !== void 0 ? $407da411a640d42c$var$_codeFrame_loadFlowQuery : $407da411a640d42c$var$_codeFrame_loadFlowQuery = (parcelRequire("6Yjvt")), queryRef);
    if (!data?.devai_flowSessionGetByIDAndCloudID?.pipelines?.[0]?.url) return null;
    return (0, $7b02d682eb115277$exports.jsx)("iframe", {
        title: "Flow",
        allow: "clipboard-read; clipboard-write",
        src: data?.devai_flowSessionGetByIDAndCloudID?.pipelines?.[0]?.url,
        width: "100%",
        height: "100%",
        className: (0, $5zphJ.default)([
            "_19itglyw"
        ])
    });
};
const $407da411a640d42c$var$iframeStyles = null;



const $0b8dfee0887dc2a8$export$bb654e07daaf8c3a = "/boysenberry/flow/:flowId";
const $0b8dfee0887dc2a8$export$8c1df0002295a597 = ()=>{
    const [queryRef, loadQuery] = (0, $2d93712440e0508b$exports.useQueryLoader)((0, $6Yjvt.default));
    const [routeState] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { cloudId: cloudId } = tenantContexts[0];
    const { flowId: flowId } = routeState.match.params;
    (0, $acw62.useEffect)(()=>{
        if (flowId) loadQuery({
            sessionId: flowId,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        flowId,
        cloudId
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $22c6e38358bb9501$export$bc1fe2419086c7e0), {
        isFullscreen: true,
        children: queryRef && (0, $7b02d682eb115277$exports.jsx)((0, $407da411a640d42c$export$6310d407093f41e5), {
            queryRef: queryRef
        })
    });
};









var $acw62 = parcelRequire("acw62");
const $3de4a9813b2cc810$export$4882d379d640c470 = (initialTitle)=>{
    const [title, setTitle] = (0, $acw62.useState)(initialTitle);
    (0, $acw62.useEffect)(()=>{
        document.title = title;
    }, [
        title
    ]);
    return setTitle;
};



const $a53f6bd3b6237b8e$export$9fa526446500d498 = ()=>{
    (0, $bb97553b5b099267$export$4673cbff94e146e2)();
    (0, $3de4a9813b2cc810$export$4882d379d640c470)("Create new flow");
    const [createFlowSession, isCreatingFlow] = (0, $b827bd2eb59618e8$export$bfb165159aabd81d)();
    const handleSubmit = (repositoryUrl, branchName, prompt)=>{
        createFlowSession({
            repoUrl: repositoryUrl,
            branchName: branchName,
            prompt: prompt,
            onSuccess: ()=>{
                window.parent.postMessage("boysenberryCreateSuccess", "*");
            }
        });
    };
    const currentUrl = decodeURIComponent(document.location.search.split("currentUrl=")[1]);
    const initialRepositoryUrl = currentUrl.includes("bitbucket.org") ? `${currentUrl}`.split("/").slice(0, 5).join("/") : null;
    return (0, $7b02d682eb115277$exports.jsx)((0, $22c6e38358bb9501$export$bc1fe2419086c7e0), {
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
            space: "space.300",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
                    alignBlock: "center",
                    spread: "space-between",
                    grow: "fill",
                    shouldWrap: true,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                        size: "small",
                        children: "Create new flow"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $bf9470823e7dbf36$export$a7fed597f4b8afd8), {
                    initialBranchName: "issue-123-my-feature",
                    initialRepositoryUrl: initialRepositoryUrl,
                    isCreatingFlow: isCreatingFlow,
                    onCancel: ()=>{
                        window.parent.postMessage("boysenberryCreateCancel", "*");
                    },
                    onSubmit: handleSubmit
                })
            ]
        })
    });
};



var $acw62 = parcelRequire("acw62");





var $2SfCO = parcelRequire("2SfCO");
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");


var $ltooA = parcelRequire("ltooA");

var $211777b1e6e6df36$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $211777b1e6e6df36$var$styles = {
    visitedLink: "_1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz14q2 _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj14q2 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1gjq _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1gjq _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n4jp4b _kqswh2mm _152ttb3r"
};
var $211777b1e6e6df36$var$iconStyles = null;
var $211777b1e6e6df36$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, preventedClassName = _ref.className, preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $211777b1e6e6df36$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement((0, $9c107440434aefdd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $32a33265390ae51f$export$a274e22fb40f762e)(appearance === "default" && $211777b1e6e6df36$var$styles.defaultAppearance, appearance === "subtle" && $211777b1e6e6df36$var$styles.subtleAppearance, appearance === "inverse" && $211777b1e6e6df36$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== "inverse" && $211777b1e6e6df36$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === "_blank" && /*#__PURE__*/ $acw62.createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $211777b1e6e6df36$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", (0, $ltooA.fg)("platform-visual-refresh-icons") ? /*#__PURE__*/ $acw62.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $5zphJ.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ $acw62.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $5zphJ.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $211777b1e6e6df36$var$Link = /*#__PURE__*/ (0, $acw62.forwardRef)($211777b1e6e6df36$var$LinkWithoutRef);
var $211777b1e6e6df36$export$2e2bcd8739ae039 = $211777b1e6e6df36$var$Link;



var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $ltooA = parcelRequire("ltooA");

var $fa5f67cdd8102876$var$stylesOld = {
    container: "_2rkoglpi _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    "text.bold.default": "_syaz15cr",
    "text.bold.inprogress": "_syaz15cr",
    "text.bold.moved": "_syazal3n",
    "text.bold.new": "_syaz15cr",
    "text.bold.removed": "_syaz15cr",
    "text.bold.success": "_syaz15cr",
    "text.subtle.default": "_syazjjyb",
    "text.subtle.inprogress": "_syaz1lpn",
    "text.subtle.moved": "_syaz1tm6",
    "text.subtle.new": "_syaz1mvf",
    "text.subtle.removed": "_syaz1ick",
    "text.subtle.success": "_syaz17fi"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
var $fa5f67cdd8102876$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
var $fa5f67cdd8102876$var$backgroundColorsOld = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $fa5f67cdd8102876$var$stylesNew = {
    container: "_2rko1l7b _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    "bg.bold.default": "_bfhk1fkg",
    "bg.bold.inprogress": "_bfhk1ymo",
    "bg.bold.moved": "_bfhkxmjf",
    "bg.bold.new": "_bfhkshej",
    "bg.bold.removed": "_bfhk1366",
    "bg.bold.success": "_bfhk3uhp",
    "bg.subtle.default": "_bfhksm61",
    "bg.subtle.inprogress": "_bfhksm61",
    "bg.subtle.moved": "_bfhksm61",
    "bg.subtle.new": "_bfhksm61",
    "bg.subtle.removed": "_bfhksm61",
    "bg.subtle.success": "_bfhksm61",
    "border.subtle.default": "_19it14mp",
    "border.subtle.inprogress": "_19it1cy7",
    "border.subtle.moved": "_19itzi1n",
    "border.subtle.new": "_19it1apr",
    "border.subtle.removed": "_19itoa5t",
    "border.subtle.success": "_19it1am1",
    "outline.subtle.default": "_12ji14je _1qu2nqa1 _12y3t94y",
    "outline.subtle.inprogress": "_12jiuisw _1qu2nqa1 _12y3t94y",
    "outline.subtle.moved": "_12jih727 _1qu2nqa1 _12y3t94y",
    "outline.subtle.new": "_12ji157s _1qu2nqa1 _12y3t94y",
    "outline.subtle.removed": "_12jia2c0 _1qu2nqa1 _12y3t94y",
    "outline.subtle.success": "_12jin0nx _1qu2nqa1 _12y3t94y",
    "text.subtle": "_syaz1fxt",
    "text.bold": "_syazwwip"
};
var $fa5f67cdd8102876$var$appearanceTypes = [
    "default",
    "inprogress",
    "moved",
    "new",
    "removed",
    "success"
];
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $fa5f67cdd8102876$var$Lozenge = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = (0, $acw62.useMemo)(function() {
        return $fa5f67cdd8102876$var$appearanceTypes.includes(appearance) ? appearance : "default";
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    if ((0, $ltooA.fg)("platform-component-visual-refresh")) return /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        "data-testid": testId,
        className: (0, $5zphJ.default)([
            $fa5f67cdd8102876$var$stylesNew.container,
            $fa5f67cdd8102876$var$stylesNew["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === "subtle" && !(0, $ltooA.fg)("visual-refresh_drop_5") && $fa5f67cdd8102876$var$stylesNew["border.subtle.".concat(appearanceType)],
            appearanceStyle === "subtle" && (0, $ltooA.fg)("visual-refresh_drop_5") && $fa5f67cdd8102876$var$stylesNew["outline.subtle.".concat(appearanceType)],
            appearanceStyle === "subtle" && (0, $ltooA.fg)("visual-refresh_drop_5") && $fa5f67cdd8102876$var$stylesNew.containerSubtle
        ])
    }, /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $5zphJ.default)([
            $fa5f67cdd8102876$var$stylesNew.text,
            (0, $ltooA.fg)("platform-lozenge-custom-letterspacing") && $fa5f67cdd8102876$var$stylesNew.customLetterspacing,
            $fa5f67cdd8102876$var$stylesNew["text.".concat(appearanceStyle)]
        ])
    }, children));
    return /*#__PURE__*/ $acw62.createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        as: "span",
        backgroundColor: $fa5f67cdd8102876$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $fa5f67cdd8102876$var$stylesOld.container,
        testId: testId
    }, /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $5zphJ.default)([
            $fa5f67cdd8102876$var$stylesOldUnbounded.text,
            (0, $ltooA.fg)("platform-lozenge-custom-letterspacing") && $fa5f67cdd8102876$var$stylesOldUnbounded.customLetterspacing,
            $fa5f67cdd8102876$var$stylesOld["text.".concat(appearanceStyle, ".").concat(appearanceType)]
        ])
    }, children));
});
$fa5f67cdd8102876$var$Lozenge.displayName = "Lozenge";
var $fa5f67cdd8102876$export$2e2bcd8739ae039 = $fa5f67cdd8102876$var$Lozenge;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $ltooA = parcelRequire("ltooA");

var $f9fb6075c8e14ace$var$baseStylesOld = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    display: "inline-flex",
    borderRadius: "border.radius",
    blockSize: "min-content",
    position: "static",
    overflow: "hidden"
});
var $f9fb6075c8e14ace$var$styles = {
    container: (0, $jjlaj.css)({
        display: "inline-flex",
        boxSizing: "border-box",
        position: "static",
        blockSize: "min-content",
        borderRadius: "3px",
        overflow: "hidden",
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    containerSubtle: (0, $jjlaj.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: (0, $jjlaj.css)({
                backgroundColor: "#DDDEE1"
            }),
            inprogress: (0, $jjlaj.css)({
                backgroundColor: "#8FB8F6"
            }),
            moved: (0, $jjlaj.css)({
                backgroundColor: "#F9C84E"
            }),
            new: (0, $jjlaj.css)({
                backgroundColor: "#D8A0F7"
            }),
            removed: (0, $jjlaj.css)({
                backgroundColor: "#FD9891"
            }),
            success: (0, $jjlaj.css)({
                backgroundColor: "#B3DF72"
            })
        },
        subtle: {
            default: (0, $jjlaj.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $jjlaj.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $jjlaj.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $jjlaj.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $jjlaj.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $jjlaj.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $jjlaj.css)({
                border: "1px solid #B7B9BE"
            }),
            inprogress: (0, $jjlaj.css)({
                border: "1px solid #669DF1"
            }),
            moved: (0, $jjlaj.css)({
                border: "1px solid #FCA700"
            }),
            new: (0, $jjlaj.css)({
                border: "1px solid #C97CF4"
            }),
            removed: (0, $jjlaj.css)({
                border: "1px solid #F87168"
            }),
            success: (0, $jjlaj.css)({
                border: "1px solid #94C748"
            })
        }
    },
    outline: {
        subtle: {
            default: (0, $jjlaj.css)({
                outline: "1px solid #B7B9BE"
            }),
            inprogress: (0, $jjlaj.css)({
                outline: "1px solid #669DF1"
            }),
            moved: (0, $jjlaj.css)({
                outline: "1px solid #FCA700"
            }),
            new: (0, $jjlaj.css)({
                outline: "1px solid #C97CF4"
            }),
            removed: (0, $jjlaj.css)({
                outline: "1px solid #F87168"
            }),
            success: (0, $jjlaj.css)({
                outline: "1px solid #94C748"
            })
        }
    },
    text: {
        subtle: (0, $jjlaj.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $jjlaj.css)({
            color: "#292A2E"
        })
    }
};
var $f9fb6075c8e14ace$var$textStyles = (0, $jjlaj.css)({
    fontFamily: 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "16px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: "uppercase",
    whiteSpace: "nowrap"
});
var $f9fb6075c8e14ace$var$customLetterspacingStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: 0.165
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $f9fb6075c8e14ace$var$Lozenge = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = appearance in $f9fb6075c8e14ace$var$styles.background[appearanceStyle] ? appearance : "default";
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    if ((0, $ltooA.fg)("platform-component-visual-refresh")) return (0, $jjlaj.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        css: [
            $f9fb6075c8e14ace$var$styles.container,
            $f9fb6075c8e14ace$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === "subtle" && !(0, $ltooA.fg)("visual-refresh_drop_5") && $f9fb6075c8e14ace$var$styles.border.subtle[appearanceType],
            appearanceStyle === "subtle" && (0, $ltooA.fg)("visual-refresh_drop_5") && $f9fb6075c8e14ace$var$styles.outline.subtle[appearanceType],
            appearanceStyle === "subtle" && (0, $ltooA.fg)("visual-refresh_drop_5") && $f9fb6075c8e14ace$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, (0, $jjlaj.jsx)("span", {
        css: [
            $f9fb6075c8e14ace$var$textStyles,
            (0, $ltooA.fg)("platform-lozenge-custom-letterspacing") && $f9fb6075c8e14ace$var$customLetterspacingStyles,
            $f9fb6075c8e14ace$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
    var appearanceTypeOld = appearance in $f9fb6075c8e14ace$var$backgroundColorsOld[appearanceStyle] ? appearance : "default";
    return (0, $jjlaj.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        as: "span",
        backgroundColor: $f9fb6075c8e14ace$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $f9fb6075c8e14ace$var$baseStylesOld,
        testId: testId
    }, (0, $jjlaj.jsx)("span", {
        css: [
            $f9fb6075c8e14ace$var$textStyles,
            (0, $ltooA.fg)("platform-lozenge-custom-letterspacing") && $f9fb6075c8e14ace$var$customLetterspacingStyles,
            $f9fb6075c8e14ace$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
});
$f9fb6075c8e14ace$var$Lozenge.displayName = "Lozenge";
var $f9fb6075c8e14ace$export$2e2bcd8739ae039 = $f9fb6075c8e14ace$var$Lozenge;
var $f9fb6075c8e14ace$var$backgroundColorsOld = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
var $f9fb6075c8e14ace$var$textColorsOld = {
    bold: {
        default: (0, $jjlaj.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $jjlaj.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $jjlaj.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $jjlaj.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $jjlaj.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $jjlaj.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $jjlaj.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $jjlaj.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $jjlaj.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $jjlaj.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $jjlaj.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $jjlaj.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $2112685ebd1785a2$var$Lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $ltooA.fg)("platform_dst_lozenge_fg") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fa5f67cdd8102876$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9fb6075c8e14ace$export$2e2bcd8739ae039), props));
});
// NOTE: Remove this and just directly `export { default } from '…';` when tidying `platform_dst_lozenge_fg`
$2112685ebd1785a2$var$Lozenge.displayName = "Lozenge";
var $2112685ebd1785a2$export$2e2bcd8739ae039 = $2112685ebd1785a2$var$Lozenge;



/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $acw62 = parcelRequire("acw62");


var $ltooA = parcelRequire("ltooA");


var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $948a3502aa397edf$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a62cd542d4ba6c4ac33816bbd6056646>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($948a3502aa397edf$exports, "__esModule", {
    value: true
});
$948a3502aa397edf$exports.default = void 0;

var $948a3502aa397edf$var$_react = $948a3502aa397edf$var$_interopRequireDefault((parcelRequire("acw62")));

var $948a3502aa397edf$var$_information = $948a3502aa397edf$var$_interopRequireDefault((parcelRequire("7rmpO")));

var $948a3502aa397edf$var$_info = $948a3502aa397edf$var$_interopRequireDefault((parcelRequire("kyY1Q")));
function $948a3502aa397edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $948a3502aa397edf$var$InformationIcon = (props)=>/*#__PURE__*/ $948a3502aa397edf$var$_react.default.createElement($948a3502aa397edf$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $948a3502aa397edf$var$_info.default
    }, props));
$948a3502aa397edf$var$InformationIcon.Name = "InformationIconMigration";
var $948a3502aa397edf$var$_default = $948a3502aa397edf$exports.default = $948a3502aa397edf$var$InformationIcon;


var $e8373758edd9478d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b4f7ab8b5658b8ac17876b86421aa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e8373758edd9478d$exports, "__esModule", {
    value: true
});
$e8373758edd9478d$exports.default = void 0;

var $e8373758edd9478d$var$_react = $e8373758edd9478d$var$_interopRequireDefault((parcelRequire("acw62")));

var $e8373758edd9478d$var$_questionCircle = $e8373758edd9478d$var$_interopRequireDefault((parcelRequire("ftOEy")));

var $e8373758edd9478d$var$_questionCircle2 = $e8373758edd9478d$var$_interopRequireDefault((parcelRequire("c8PsL")));
function $e8373758edd9478d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e8373758edd9478d$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $e8373758edd9478d$var$_react.default.createElement($e8373758edd9478d$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $e8373758edd9478d$var$_questionCircle2.default
    }, props));
$e8373758edd9478d$var$QuestionCircleIcon.Name = "QuestionCircleIconMigration";
var $e8373758edd9478d$var$_default = $e8373758edd9478d$exports.default = $e8373758edd9478d$var$QuestionCircleIcon;


var $058a3c562ddbf8e9$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::934663f3d49f13f5eb4d23bc2f11a666>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($058a3c562ddbf8e9$exports, "__esModule", {
    value: true
});
$058a3c562ddbf8e9$exports.default = void 0;

var $058a3c562ddbf8e9$var$_react = $058a3c562ddbf8e9$var$_interopRequireDefault((parcelRequire("acw62")));

var $058a3c562ddbf8e9$var$_success = $058a3c562ddbf8e9$var$_interopRequireDefault((parcelRequire("jTmfM")));

var $058a3c562ddbf8e9$var$_checkCircle = $058a3c562ddbf8e9$var$_interopRequireDefault((parcelRequire("4rk35")));
function $058a3c562ddbf8e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $058a3c562ddbf8e9$var$SuccessIcon = (props)=>/*#__PURE__*/ $058a3c562ddbf8e9$var$_react.default.createElement($058a3c562ddbf8e9$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $058a3c562ddbf8e9$var$_checkCircle.default
    }, props));
$058a3c562ddbf8e9$var$SuccessIcon.Name = "SuccessIconMigration";
var $058a3c562ddbf8e9$var$_default = $058a3c562ddbf8e9$exports.default = $058a3c562ddbf8e9$var$SuccessIcon;




var $dnCk4 = parcelRequire("dnCk4");
function $ed17b649aca0e172$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed17b649aca0e172$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed17b649aca0e172$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed17b649aca0e172$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ed17b649aca0e172$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $dnCk4.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($948a3502aa397edf$exports))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $dnCk4.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $dnCk4.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8331970a6514bd13$exports))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $dnCk4.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $dnCk4.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($10a28323f2aa4e03$exports))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $dnCk4.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $dnCk4.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($058a3c562ddbf8e9$exports))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $dnCk4.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $dnCk4.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($e8373758edd9478d$exports))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $dnCk4.P500), ")")
    }
};
function $ed17b649aca0e172$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $ed17b649aca0e172$var$appearanceIconSchema[appearance] || $ed17b649aca0e172$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $ed17b649aca0e172$var$_objectSpread($ed17b649aca0e172$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}


var $2154909317384aee$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $2154909317384aee$var$SectionMessage = /*#__PURE__*/ (0, $acw62.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "information" : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, testId = _ref.testId;
    var _getAppearanceIconSty = (0, $ed17b649aca0e172$export$e9b82d2e21ac0c1f)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment ? actions.props.children : actions;
    var actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        as: "section",
        backgroundColor: $2154909317384aee$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $2154909317384aee$var$sectionMessageStyles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f2901d7c083b4af1$export$2e2bcd8739ae039), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        xcss: $2154909317384aee$var$sectionMessageStyles.bleed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4bdd1b756b729740$export$2e2bcd8739ae039), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content")
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        xcss: $2154909317384aee$var$sectionMessageStyles.content
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f2901d7c083b4af1$export$2e2bcd8739ae039), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list",
        xcss: (0, $ltooA.fg)("platform_ads_explicit_font_styles") && $2154909317384aee$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f2901d7c083b4af1$export$2e2bcd8739ae039), {
            role: "listitem",
            key: id
        }, action);
    })))));
});
var $2154909317384aee$var$appearanceMap = {
    information: "color.background.information",
    warning: "color.background.warning",
    error: "color.background.danger",
    success: "color.background.success",
    discovery: "color.background.discovery"
};
$2154909317384aee$var$SectionMessage.displayName = "SectionMessage";
var $2154909317384aee$export$2e2bcd8739ae039 = $2154909317384aee$var$SectionMessage;

/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");





var $12HqF = parcelRequire("12HqF");

var $dnCk4 = parcelRequire("dnCk4");
function $78777a3643a439ce$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $78777a3643a439ce$var$tabKeyCode = 9;
function $78777a3643a439ce$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $78777a3643a439ce$var$tabKeyCode) return;
    $78777a3643a439ce$var$abort(event);
}
var $78777a3643a439ce$var$block = {
    onMouseDownCapture: $78777a3643a439ce$var$abort,
    onMouseUpCapture: $78777a3643a439ce$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $78777a3643a439ce$var$onKey,
    onKeyUpCapture: $78777a3643a439ce$var$onKey,
    onTouchStartCapture: $78777a3643a439ce$var$abort,
    onTouchEndCapture: $78777a3643a439ce$var$abort,
    onPointerDownCapture: $78777a3643a439ce$var$abort,
    onPointerUpCapture: $78777a3643a439ce$var$abort,
    onClickCapture: $78777a3643a439ce$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $78777a3643a439ce$var$abort
};
var $78777a3643a439ce$var$doNotBlock = {};
function $78777a3643a439ce$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $78777a3643a439ce$var$doNotBlock : $78777a3643a439ce$var$block;
}



var $g5Zhu = parcelRequire("g5Zhu");

var $jjlaj = parcelRequire("jjlaj");

var $ltooA = parcelRequire("ltooA");


var $dnCk4 = parcelRequire("dnCk4");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $93899cb209aae547$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $93899cb209aae547$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($dnCk4.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($dnCk4.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($dnCk4.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($93899cb209aae547$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($dnCk4.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dnCk4.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($dnCk4.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($dnCk4.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($dnCk4.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($dnCk4.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($dnCk4.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($dnCk4.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dnCk4.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($dnCk4.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($dnCk4.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($dnCk4.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($dnCk4.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($dnCk4.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($dnCk4.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dnCk4.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($dnCk4.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($dnCk4.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($dnCk4.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($dnCk4.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($dnCk4.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($dnCk4.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dnCk4.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dnCk4.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($dnCk4.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($dnCk4.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($93899cb209aae547$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($dnCk4.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dnCk4.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dnCk4.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($dnCk4.N500, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($dnCk4.B400, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($dnCk4.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($dnCk4.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($dnCk4.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($dnCk4.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($dnCk4.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($dnCk4.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($dnCk4.B400, ")"),
                dark: "var(--ds-link, ".concat($dnCk4.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($dnCk4.B300, ")"),
                dark: "var(--ds-link, ".concat($dnCk4.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($dnCk4.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($dnCk4.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($dnCk4.N500, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($dnCk4.B400, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($dnCk4.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($dnCk4.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($dnCk4.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($dnCk4.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($dnCk4.N400, ")"),
                dark: "var(--ds-text, ".concat($dnCk4.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dnCk4.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dnCk4.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dnCk4.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dnCk4.DN400, ")")
            }
        }
    }
};
var $93899cb209aae547$export$2e2bcd8739ae039 = $93899cb209aae547$var$values;


function $6f444228c2c7eea6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f444228c2c7eea6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f444228c2c7eea6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f444228c2c7eea6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6f444228c2c7eea6$var$gridSize = (0, $b7d36d3be7da66cd$export$6d8204c2cb2e06b8)();
var $6f444228c2c7eea6$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $6f444228c2c7eea6$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $6f444228c2c7eea6$var$lineHeights = {
    default: $6f444228c2c7eea6$var$heights.default,
    compact: $6f444228c2c7eea6$var$heights.compact,
    none: "inherit"
};
var $6f444228c2c7eea6$var$padding = {
    // 10px gutter
    default: "0 ".concat($6f444228c2c7eea6$var$gridSize + $6f444228c2c7eea6$var$gridSize / 4, "px"),
    compact: "0 ".concat($6f444228c2c7eea6$var$gridSize + $6f444228c2c7eea6$var$gridSize / 4, "px"),
    none: "0"
};
var $6f444228c2c7eea6$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($6f444228c2c7eea6$var$gridSize / 4, "px"),
    default: "0 ".concat($6f444228c2c7eea6$var$gridSize / 4, "px"),
    none: "0"
};
var $6f444228c2c7eea6$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $6f444228c2c7eea6$var$innerMargin = {
    content: "0 ".concat($6f444228c2c7eea6$var$gridSize / 4, "px"),
    icon: "0 ".concat($6f444228c2c7eea6$var$gridSize / 4, "px")
};
var $6f444228c2c7eea6$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $6f444228c2c7eea6$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $6f444228c2c7eea6$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $6f444228c2c7eea6$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $6f444228c2c7eea6$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $6f444228c2c7eea6$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $6f444228c2c7eea6$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $6f444228c2c7eea6$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $6f444228c2c7eea6$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $6f444228c2c7eea6$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $6f444228c2c7eea6$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $6f444228c2c7eea6$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $6f444228c2c7eea6$var$getColor({
            group: (0, $93899cb209aae547$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($6f444228c2c7eea6$var$getColor({
            group: (0, $93899cb209aae547$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $6f444228c2c7eea6$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $6f444228c2c7eea6$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $ltooA.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $6f444228c2c7eea6$var$heights[spacing],
        lineHeight: $6f444228c2c7eea6$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $6f444228c2c7eea6$var$singleIconPadding[spacing] : $6f444228c2c7eea6$var$padding[spacing],
        verticalAlign: $6f444228c2c7eea6$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $ltooA.fg)("platform-component-visual-refresh") && $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $6f444228c2c7eea6$var$_objectSpread({}, baseColors),
        "&:hover": $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $6f444228c2c7eea6$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $6f444228c2c7eea6$var$_objectSpread({}, $6f444228c2c7eea6$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $ltooA.fg)("platform-component-visual-refresh") && (isSelected ? $6f444228c2c7eea6$var$selectedStyles : $6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread($6f444228c2c7eea6$var$_objectSpread({}, appearance === "default" && $6f444228c2c7eea6$var$defaultStyles), appearance === "primary" && $6f444228c2c7eea6$var$primaryStyles), appearance === "link" && $6f444228c2c7eea6$var$linkStyles), appearance === "subtle" && $6f444228c2c7eea6$var$subtleStyles), appearance === "subtle-link" && $6f444228c2c7eea6$var$subtleLinkStyles), appearance === "warning" && $6f444228c2c7eea6$var$warningStyles), appearance === "danger" && $6f444228c2c7eea6$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $6f444228c2c7eea6$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $6f444228c2c7eea6$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $6f444228c2c7eea6$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $6f444228c2c7eea6$var$hasOverlayStyles))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $6f444228c2c7eea6$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $jjlaj.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $6f444228c2c7eea6$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $6f444228c2c7eea6$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $jjlaj.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $6f444228c2c7eea6$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $6f444228c2c7eea6$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $jjlaj.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $6f444228c2c7eea6$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $acw62 = parcelRequire("acw62");

var $6f5a0a3b8f3c11db$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $acw62.isValidElement)(children) && children.type === (0, $8568069ac023c6f7$export$2e2bcd8739ae039);
};


var $18e2b6fea76e317b$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $18e2b6fea76e317b$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $18e2b6fea76e317b$var$iconBeforeSpacingFixStyle = (0, $jjlaj.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $18e2b6fea76e317b$var$iconAfterSpacingFixStyle = (0, $jjlaj.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $18e2b6fea76e317b$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $6f5a0a3b8f3c11db$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $18e2b6fea76e317b$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $6f5a0a3b8f3c11db$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $jjlaj.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $18e2b6fea76e317b$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $18e2b6fea76e317b$var$_excluded);
    var ourRef = (0, $acw62.useRef)();
    var setRef = (0, $acw62.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $3f80dbe144e57bfc$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $acw62.useContext)((0, $12HqF.default));
    var handleClick = (0, $acw62.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "21.1.5",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $acw62.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $jjlaj.css)((0, $6f444228c2c7eea6$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $dnCk4.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $dnCk4.N500), ")"), " !important")
        }
    };
    return (0, $jjlaj.jsx)((0, $6f72ff8788d34fb2$export$2e2bcd8739ae039), null, (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $18e2b6fea76e317b$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $78777a3643a439ce$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $jjlaj.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $6f444228c2c7eea6$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $18e2b6fea76e317b$var$getSpacingFix(children, $18e2b6fea76e317b$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $18e2b6fea76e317b$var$getChildren(children, [
        fadeStyles,
        (0, $6f444228c2c7eea6$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $jjlaj.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $6f444228c2c7eea6$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $18e2b6fea76e317b$var$getSpacingFix(children, $18e2b6fea76e317b$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $jjlaj.jsx)("span", {
        css: [
            (0, $6f444228c2c7eea6$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$18e2b6fea76e317b$export$2e2bcd8739ae039 = $18e2b6fea76e317b$var$ButtonBase;




function $e5b38769158951a0$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $6f5a0a3b8f3c11db$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $b68af4c645c75ad0$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $b68af4c645c75ad0$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $b68af4c645c75ad0$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b68af4c645c75ad0$var$_excluded);
    var _useGlobalTheme = (0, $bc4c50142919d5e5$export$7692396083754928)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $e5b38769158951a0$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $acw62.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($b68af4c645c75ad0$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $acw62.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($b68af4c645c75ad0$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $acw62.useMemo)(function() {
        return (0, $6f444228c2c7eea6$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18e2b6fea76e317b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$b68af4c645c75ad0$var$Button.displayName = "Button";
var $b68af4c645c75ad0$export$2e2bcd8739ae039 = $b68af4c645c75ad0$var$Button;




var $ltooA = parcelRequire("ltooA");

var $6e6d37597ca9a744$var$styles = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik1r31 _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ var $6e6d37597ca9a744$var$SectionMessageAction = /*#__PURE__*/ (0, $acw62.memo)(function SectionMessageAction(_ref) {
    var children = _ref.children, onClick = _ref.onClick, href = _ref.href, testId = _ref.testId, linkComponent = _ref.linkComponent;
    if (!linkComponent && (0, $ltooA.fg)("platform_section_message_action_migration")) {
        if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c107440434aefdd$export$2e2bcd8739ae039), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $32a33265390ae51f$export$a274e22fb40f762e)($6e6d37597ca9a744$var$styles.common, $6e6d37597ca9a744$var$styles.anchor)
        }, children);
        if (onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c5f2789211abe33c$export$2e2bcd8739ae039), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $32a33265390ae51f$export$a274e22fb40f762e)($6e6d37597ca9a744$var$styles.common, $6e6d37597ca9a744$var$styles.pressable)
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
            as: "span",
            testId: testId
        }, children);
    }
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b68af4c645c75ad0$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
});
var $6e6d37597ca9a744$export$2e2bcd8739ae039 = $6e6d37597ca9a744$var$SectionMessageAction;



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $f9996f5aa3058036$export$724d89106c22b769 = (fn, timeMS, maxRequests)=>{
    const [hasExceededMaxRequests, setHasExceededMaxRequests] = (0, $acw62.useState)(false);
    const [isDone, setIsDone] = (0, $acw62.useState)(false);
    const [requestCount, setRequestCount] = (0, $acw62.useState)(0);
    const stopRetry = (0, $acw62.useCallback)(()=>setIsDone(true), [
        setIsDone
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isDone || hasExceededMaxRequests) return;
        if (requestCount >= maxRequests) setHasExceededMaxRequests(true);
    }, [
        hasExceededMaxRequests,
        isDone,
        maxRequests,
        requestCount
    ]);
    (0, $acw62.useEffect)(()=>{
        let timeout;
        if (!hasExceededMaxRequests && !isDone) timeout = setTimeout(()=>{
            fn();
            setRequestCount(requestCount + 1);
        }, timeMS);
        return ()=>timeout && clearTimeout(timeout);
    }, [
        fn,
        hasExceededMaxRequests,
        isDone,
        timeMS,
        requestCount
    ]);
    return {
        hasExceededMaxRequests: hasExceededMaxRequests,
        stopRetry: stopRetry,
        count: requestCount
    };
};




const $bd9957ab26776374$export$c7828da8e326ef41 = ()=>{
    return (0, $7b02d682eb115277$exports.jsx)((0, $d847f661580efa86$export$2e2bcd8739ae039), {});
};


/* pipeline-frame.tsx generated by @compiled/babel-plugin v0.37.1 */ parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

const $611597a91a5965b0$export$a27ccc4d1d364b3 = ({ url: url, isFullScreen: isFullScreen })=>{
    return (0, $7b02d682eb115277$exports.jsx)("iframe", {
        title: "Flow",
        allow: "clipboard-read; clipboard-write",
        src: url,
        width: "100%",
        height: "100%",
        className: (0, $5zphJ.default)([
            "_19itglyw",
            !isFullScreen && "_kqswstnw _1bsb107j _4t3ijoat _1vfx17dr _3um015vq _lcxvglyw"
        ])
    });
};
const $611597a91a5965b0$var$iframeStyles = null;
const $611597a91a5965b0$var$iframeLoadingStyles = null;



var $c0c1c1d658fee1f0$var$_flowScreen_loadFlowQuery;
const $c0c1c1d658fee1f0$var$MAX_REQUEST_COUNT = 600;
const $c0c1c1d658fee1f0$var$getScreenState = (flow)=>{
    switch(flow?.status ?? null){
        case null:
        case "PENDING":
            return "INITIALIZING";
        case "COMPLETED":
            return "COMPLETED";
        case "FAILED":
            return "FAILED";
        default:
            break;
    }
    switch(flow?.pipelines?.[0]?.status ?? null){
        default:
        case null:
        case "PROVISIONED":
            return "INITIALIZING";
        case "STARTING":
            return "IFRAME_STARTING";
        case "IN_PROGRESS":
            return "IN_PROGRESS";
        case "STOPPED":
            return "COMPLETED";
        case "FAILED":
            return "FAILED";
    }
};

const $c0c1c1d658fee1f0$export$da5f8e3803da4892 = ({ flowId: flowId, queryRef: queryRef, refreshQuery: refreshQuery })=>{
    const data = (0, $2d93712440e0508b$exports.usePreloadedQuery)($c0c1c1d658fee1f0$var$_flowScreen_loadFlowQuery !== void 0 ? $c0c1c1d658fee1f0$var$_flowScreen_loadFlowQuery : $c0c1c1d658fee1f0$var$_flowScreen_loadFlowQuery = (parcelRequire("2SfCO")), queryRef);
    const flow = data?.devai_flowSessionGetByIDAndCloudID;
    const url = flow?.pipelines?.[0]?.url;
    const screenState = $c0c1c1d658fee1f0$var$getScreenState(flow);
    const { branchName: branchName } = (0, $a9fa3d0bb0d11e02$export$7ad44063fdf1b9d)(flow?.additionalInfoJSON ?? "{}");
    (0, $3de4a9813b2cc810$export$4882d379d640c470)(`${branchName} - Flow`);
    const refreshFlowData = (0, $acw62.useCallback)(()=>{
        if (flowId && (screenState === "INITIALIZING" || screenState === "IFRAME_STARTING")) refreshQuery();
    }, [
        flowId,
        refreshQuery,
        screenState
    ]);
    const { stopRetry: stopRetry, hasExceededMaxRequests: hasExceededMaxRequests } = (0, $f9996f5aa3058036$export$724d89106c22b769)(refreshFlowData, 1000, $c0c1c1d658fee1f0$var$MAX_REQUEST_COUNT);
    (0, $acw62.useEffect)(()=>{
        if (screenState === "IN_PROGRESS") stopRetry();
    }, [
        stopRetry,
        screenState
    ]);
    const showIntroText = ()=>{
        if (hasExceededMaxRequests) return (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
            size: "small",
            color: "color.text.danger",
            children: "Flow took longer than usual to start... Please refresh the page to try again."
        });
        return (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
            size: "medium",
            children: "Preparing your flow... This can take a few minutes."
        });
    };
    const showLoadingScreen = ()=>{
        return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                showIntroText(),
                (0, $7b02d682eb115277$exports.jsx)((0, $bd9957ab26776374$export$c7828da8e326ef41), {})
            ]
        });
    };
    const showEndScreen = ()=>{
        return (0, $7b02d682eb115277$exports.jsx)((0, $2154909317384aee$export$2e2bcd8739ae039), {
            appearance: "information",
            actions: (0, $7b02d682eb115277$exports.jsx)((0, $6e6d37597ca9a744$export$2e2bcd8739ae039), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $211777b1e6e6df36$export$2e2bcd8739ae039), {
                    href: (0, $2cf4acc76693ef07$export$6510e166e79b4e5c)(),
                    children: "Return to home"
                })
            }),
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                children: [
                    "This flow has",
                    " ",
                    (0, $7b02d682eb115277$exports.jsx)((0, $2112685ebd1785a2$export$2e2bcd8739ae039), {
                        appearance: screenState === "FAILED" ? "removed" : "success",
                        children: screenState
                    }),
                    " ",
                    "and it's not available anymore."
                ]
            })
        });
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        xcss: screenState === "IN_PROGRESS" ? $c0c1c1d658fee1f0$var$fullHeightStyles : $c0c1c1d658fee1f0$var$flexContainerStyles,
        children: [
            (screenState === "INITIALIZING" || screenState === "IFRAME_STARTING") && showLoadingScreen(),
            (screenState === "COMPLETED" || screenState === "FAILED") && showEndScreen(),
            (screenState === "IFRAME_STARTING" || screenState === "IN_PROGRESS") && (0, $7b02d682eb115277$exports.jsx)((0, $611597a91a5965b0$export$a27ccc4d1d364b3), {
                url: url ?? "",
                isFullScreen: screenState === "IN_PROGRESS"
            })
        ]
    });
};
const $c0c1c1d658fee1f0$var$fullHeightStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    display: "grid",
    width: "100%",
    height: "100%"
});
const $c0c1c1d658fee1f0$var$flexContainerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: "space.400",
    justifyContent: "center",
    alignItems: "center"
});



const $f3d98130205b45b3$export$bb654e07daaf8c3a = "/boysenberry/flow/:flowId";
const $f3d98130205b45b3$export$cac4e69ddf1cf4a5 = ()=>{
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { cloudId: cloudId } = tenantContexts[0];
    const [queryRef, loadQuery] = (0, $2d93712440e0508b$exports.useQueryLoader)((0, $2SfCO.default));
    const [routeState] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    const flowId = (0, $acw62.useMemo)(()=>{
        if (routeState.match.params.flowId) return routeState.match.params.flowId;
        return null;
    }, [
        routeState.match.params.flowId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (flowId) loadQuery({
            sessionId: flowId,
            cloudId: cloudId
        });
    }, [
        cloudId,
        loadQuery,
        flowId
    ]);
    const refreshQuery = (0, $acw62.useCallback)(()=>{
        if (flowId) loadQuery({
            sessionId: flowId,
            cloudId: cloudId
        }, {
            fetchPolicy: "store-and-network"
        });
    }, [
        cloudId,
        flowId,
        loadQuery
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $22c6e38358bb9501$export$bc1fe2419086c7e0), {
        isFullscreen: true,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            children: queryRef && (0, $7b02d682eb115277$exports.jsx)((0, $c0c1c1d658fee1f0$export$da5f8e3803da4892), {
                flowId: flowId,
                queryRef: queryRef,
                refreshQuery: refreshQuery
            }, flowId)
        })
    });
};



var $acw62 = parcelRequire("acw62");





var $31QgG = parcelRequire("31QgG");











var $496b19f93736673f$var$_card_fragment;

const $496b19f93736673f$export$60332b2344f7fe41 = ({ issue: issue })=>{
    const data = (0, $2d93712440e0508b$exports.useFragment)($496b19f93736673f$var$_card_fragment !== void 0 ? $496b19f93736673f$var$_card_fragment : $496b19f93736673f$var$_card_fragment = (parcelRequire("WuwQM")), issue);
    const { id: id, key: key, summary: summary, fieldsById: fieldsById } = data;
    const getFieldByFieldId = (fieldId)=>fieldsById?.edges?.find((edge)=>edge?.node?.fieldId === fieldId);
    const issueType = getFieldByFieldId("issuetype")?.node?.issueType;
    const description = getFieldByFieldId("description")?.node?.richText?.adfValue?.convertedPlainText?.plainText;
    const [createFlow, isPending] = (0, $b827bd2eb59618e8$export$bfb165159aabd81d)();
    const issueForSession = {
        icon: issueType?.avatar?.small ?? "",
        key: key,
        summary: summary ?? "",
        description: description ?? ""
    };
    const { openModal: openModal, RepositoryModal: RepositoryModal } = (0, $1d5c0065d0f65928$export$69e0a26a343ce256)({
        branchName: `${key}-feature`,
        onConfirm: (repositoryUrl, branchName, prompt)=>{
            createFlow({
                issueARI: id,
                repoUrl: repositoryUrl,
                issue: issueForSession,
                branchName: branchName,
                prompt: prompt
            });
        },
        isSubmitPending: isPending,
        selectedIssue: issueForSession
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
        xcss: $496b19f93736673f$var$containerStyles,
        spread: "space-between",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                as: "span",
                weight: "bold",
                maxLines: 1,
                children: summary
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                as: "span",
                maxLines: 1,
                children: description
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                as: "span",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $2112685ebd1785a2$export$2e2bcd8739ae039), {
                    appearance: "new",
                    children: getFieldByFieldId("status")?.node?.status?.name
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
                spread: "space-between",
                alignBlock: "center",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
                        space: "space.100",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("img", {
                                alt: issueType?.name ?? "",
                                src: issueType?.avatar?.small ?? "",
                                width: 16,
                                height: 16
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                                size: "xxsmall",
                                children: key
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                            onClick: openModal,
                            children: "Start flow"
                        })
                    })
                ]
            }),
            RepositoryModal
        ]
    });
};
const $496b19f93736673f$var$containerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    padding: "space.150",
    minWidth: "260px",
    minHeight: "148px",
    backgroundColor: "elevation.surface.raised",
    borderRadius: "border.radius.100",
    boxShadow: "elevation.shadow.raised",
    ":hover": {
        backgroundColor: "elevation.surface.hovered"
    }
});



var $8c6b4cd0d6428a50$var$_assignedToMeQuery;

const $8c6b4cd0d6428a50$export$e3d31746137e02e9 = ({ queryRef: queryRef })=>{
    const data = (0, $2d93712440e0508b$exports.usePreloadedQuery)($8c6b4cd0d6428a50$var$_assignedToMeQuery !== void 0 ? $8c6b4cd0d6428a50$var$_assignedToMeQuery : $8c6b4cd0d6428a50$var$_assignedToMeQuery = (parcelRequire("31QgG")), queryRef);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
        space: "space.200",
        alignInline: "start",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
                alignBlock: "center",
                spread: "space-between",
                grow: "fill",
                shouldWrap: true,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                    size: "small",
                    children: "Assigned to me"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
                xcss: $8c6b4cd0d6428a50$var$responsiveStyles,
                columnGap: "space.200",
                rowGap: "space.200",
                alignItems: "center",
                children: data?.jira?.issueSearch?.edges?.map((edge)=>edge?.node && (0, $7b02d682eb115277$exports.jsx)((0, $496b19f93736673f$export$60332b2344f7fe41), {
                        issue: edge?.node
                    }, edge?.node.key))
            })
        ]
    });
};
const $8c6b4cd0d6428a50$var$responsiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xxs]: {
        gridTemplateColumns: "repeat(1, 1fr)"
    },
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.sm]: {
        gridTemplateColumns: "repeat(2, 1fr)"
    },
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.md]: {
        gridTemplateColumns: "repeat(3, 1fr)"
    },
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.lg]: {
        gridTemplateColumns: "repeat(4, 1fr)"
    },
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xl]: {
        gridTemplateColumns: "repeat(5, 1fr)"
    }
});



const $3f4b1c4e8d7d9171$export$4c5a7631b37fb7af = ()=>{
    (0, $3de4a9813b2cc810$export$4882d379d640c470)("Flow");
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { cloudId: cloudId } = tenantContexts[0];
    const [queryRef, loadQuery] = (0, $2d93712440e0508b$exports.useQueryLoader)((0, $31QgG.default));
    (0, $acw62.useEffect)(()=>{
        loadQuery({
            cloudId: cloudId,
            jql: 'assignee = currentUser() AND statusCategory = "To Do" AND updated > "-4w" order by updated DESC'
        });
    }, [
        cloudId,
        loadQuery
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $22c6e38358bb9501$export$bc1fe2419086c7e0), {
        children: queryRef && (0, $7b02d682eb115277$exports.jsx)((0, $8c6b4cd0d6428a50$export$e3d31746137e02e9), {
            queryRef: queryRef
        })
    });
};




var $a360cf1e6956c59e$exports = {};
"use strict";
Object.defineProperty($a360cf1e6956c59e$exports, "__esModule", {
    value: true
});
$a360cf1e6956c59e$exports.default = void 0;

var $a360cf1e6956c59e$var$_react = $a360cf1e6956c59e$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $a360cf1e6956c59e$var$_chevronDown = $a360cf1e6956c59e$var$_interopRequireDefault((parcelRequire("5FCTo")));
function $a360cf1e6956c59e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a360cf1e6956c59e$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $a360cf1e6956c59e$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $a360cf1e6956c59e$var$_chevronDown.default,
        iconType: "utility"
    }));
$a360cf1e6956c59e$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $a360cf1e6956c59e$var$_default = $a360cf1e6956c59e$exports.default = $a360cf1e6956c59e$var$HipchatChevronDownIcon;


var $19986f13e317935c$exports = {};
"use strict";
Object.defineProperty($19986f13e317935c$exports, "__esModule", {
    value: true
});
$19986f13e317935c$exports.default = void 0;

var $19986f13e317935c$var$_react = $19986f13e317935c$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $19986f13e317935c$var$_chevronUp = $19986f13e317935c$var$_interopRequireDefault((parcelRequire("glAld")));
function $19986f13e317935c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $19986f13e317935c$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $19986f13e317935c$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $19986f13e317935c$var$_chevronUp.default,
        iconType: "utility"
    }));
$19986f13e317935c$var$HipchatChevronUpIcon.displayName = "HipchatChevronUpIcon";
var $19986f13e317935c$var$_default = $19986f13e317935c$exports.default = $19986f13e317935c$var$HipchatChevronUpIcon;






var $acw62 = parcelRequire("acw62");

var $8cf1fe534ba272f8$exports = {};
$8cf1fe534ba272f8$exports = new URL("rocket.5b83577f.svg", import.meta.url).toString();


var $81429ba5cb21c54b$exports = {};
$81429ba5cb21c54b$exports = new URL("settings.b1da4df8.svg", import.meta.url).toString();










var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");



const $fc9f5ef74b2a0e66$export$a32df719f7bcd2c = ({ act: act })=>{
    const { label: label, icon: icon, action: action, analyticEvent: analyticEvent } = act;
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    const handleClick = ()=>{
        if (analyticEvent) analyticsWebClient.sendUIEvent(analyticEvent);
        if (action) action();
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
        appearance: "subtle",
        iconAfter: icon,
        onClick: handleClick,
        spacing: "compact",
        testId: act.testId ? act.testId : undefined,
        children: label
    });
};





const $7b4203b69ca61aaf$export$59e50acbc404277 = ({ action: action })=>{
    const { link: link, target: target } = action?.href || {};
    const { label: label, analyticEvent: analyticEvent } = action;
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    const handleClick = ()=>{
        if (analyticEvent) analyticsWebClient.sendUIEvent(analyticEvent);
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $23756fdd73e76c31$export$2e2bcd8739ae039), {
        href: link || "",
        appearance: "subtle",
        spacing: "compact",
        target: target || "_blank",
        onClick: handleClick,
        testId: action.testId ? action.testId : undefined,
        children: label
    });
};



const $d34d09f118d159f8$var$iconContainerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    width: "32px",
    height: "32px"
});
const $d34d09f118d159f8$var$contentContainerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    flex: 1
});
const $d34d09f118d159f8$var$cardSizeStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    padding: "space.150",
    borderRadius: "border.radius.100",
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: "elevation.surface.overlay",
    ":hover": {
        backgroundColor: "elevation.surface.overlay.hovered"
    }
});
const $d34d09f118d159f8$var$actionsContainerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    gap: "space.050"
});
const $d34d09f118d159f8$var$suggestionActionsContainerStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    gap: "space.050"
});
const $d34d09f118d159f8$var$primaryActionStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: "border.radius.200"
});
const $d34d09f118d159f8$export$60332b2344f7fe41 = ({ title: title, description: description, icon: icon, primaryAction: primaryAction, secondaryAction: secondaryAction, type: type = "regular", uniformActions: uniformActions = false, lozenge: lozenge, testId: testId })=>{
    return (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        xcss: $d34d09f118d159f8$var$cardSizeStyles,
        testId: testId ? `${testId}-card` : undefined,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
            gap: "space.100",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                    xcss: $d34d09f118d159f8$var$iconContainerStyles,
                    children: icon
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                    xcss: $d34d09f118d159f8$var$contentContainerStyles,
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                        space: type === "suggestion" ? "space.050" : "space.100",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                                space: type === "suggestion" ? "space.050" : "space.100",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsxs)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                                        gap: "space.100",
                                        alignItems: "center",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                                size: "medium",
                                                weight: type === "suggestion" ? "regular" : "bold",
                                                testId: testId ? `${testId}-card-title` : undefined,
                                                children: title
                                            }),
                                            lozenge && (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $2112685ebd1785a2$export$2e2bcd8739ae039), {
                                                    appearance: lozenge.appearance,
                                                    isBold: lozenge.isBold,
                                                    children: lozenge.text
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                        size: "medium",
                                        color: "color.text.subtlest",
                                        children: description
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                xcss: type === "suggestion" ? $d34d09f118d159f8$var$suggestionActionsContainerStyles : $d34d09f118d159f8$var$actionsContainerStyles,
                                children: [
                                    primaryAction && (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                        xcss: $d34d09f118d159f8$var$primaryActionStyles,
                                        children: [
                                            primaryAction.action && (0, $7b02d682eb115277$exports.jsx)((0, $fc9f5ef74b2a0e66$export$a32df719f7bcd2c), {
                                                act: primaryAction
                                            }),
                                            primaryAction && primaryAction.children && primaryAction.children,
                                            primaryAction && primaryAction.href && primaryAction.href.link && (0, $7b02d682eb115277$exports.jsx)((0, $7b4203b69ca61aaf$export$59e50acbc404277), {
                                                action: primaryAction
                                            })
                                        ]
                                    }),
                                    secondaryAction && (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                        xcss: uniformActions ? $d34d09f118d159f8$var$primaryActionStyles : undefined,
                                        children: [
                                            secondaryAction.action && (0, $7b02d682eb115277$exports.jsx)((0, $fc9f5ef74b2a0e66$export$a32df719f7bcd2c), {
                                                act: secondaryAction
                                            }),
                                            secondaryAction.children && secondaryAction.children,
                                            secondaryAction.href && secondaryAction.href.link && (0, $7b02d682eb115277$exports.jsx)((0, $7b4203b69ca61aaf$export$59e50acbc404277), {
                                                action: secondaryAction
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};


parcelRequire("acw62");





var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");



var $12HqF = parcelRequire("12HqF");

var $ltooA = parcelRequire("ltooA");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");



var $ltooA = parcelRequire("ltooA");


var $dnCk4 = parcelRequire("dnCk4");

var $acw62 = parcelRequire("acw62");
var $5aff9f9707de081d$export$443076ec7ebce042 = /*#__PURE__*/ (0, $acw62.createContext)("cozy");
var $5aff9f9707de081d$export$9ca534b70725964d = /*#__PURE__*/ (0, $acw62.createContext)("border");


var $6abbde01b35a36b1$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $jjlaj.jsx)(Component, props));
};
var $6abbde01b35a36b1$var$beforeAfterElementStylesOld = (0, $jjlaj.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $6abbde01b35a36b1$var$beforeAfterElementStyles = (0, $jjlaj.css)({
    display: "flex",
    minWidth: 24,
    minHeight: 24,
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $6abbde01b35a36b1$var$contentStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    outline: "none",
    overflow: "hidden",
    textAlign: "left"
});
var $6abbde01b35a36b1$var$truncateStyles = (0, $jjlaj.css)({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $6abbde01b35a36b1$var$titleStyles = (0, $jjlaj.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
});
var $6abbde01b35a36b1$var$wordBreakStyles = (0, $jjlaj.css)({
    wordBreak: "break-word"
});
var $6abbde01b35a36b1$var$descriptionStyles = (0, $jjlaj.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $dnCk4.N200), ")"),
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
});
var $6abbde01b35a36b1$var$disabledDescriptionStyles = (0, $jjlaj.css)({
    color: "var(--ds-text-disabled, ".concat((0, $dnCk4.N200), ")")
});
var $6abbde01b35a36b1$var$positionRelativeStyles = (0, $jjlaj.css)({
    position: "relative"
});
var $6abbde01b35a36b1$var$primitiveStyles = (0, $jjlaj.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    border: 0,
    outline: 0,
    textDecoration: "none",
    userSelect: "none",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-moz-focus-inner": {
        border: 0
    },
    "&:hover": {
        textDecoration: "none"
    }
});
var $6abbde01b35a36b1$var$spacingMapStyles = {
    cozy: (0, $jjlaj.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $jjlaj.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $6abbde01b35a36b1$var$interactiveStyles = (0, $jjlaj.css)({
    cursor: "pointer"
});
var $6abbde01b35a36b1$var$unselectedStyles = (0, $jjlaj.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: "currentColor",
    "&:visited": {
        color: "currentColor"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $dnCk4.N20), ")"),
        color: "currentColor"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $dnCk4.N30), ")"),
        boxShadow: "none",
        color: "currentColor"
    }
});
var $6abbde01b35a36b1$var$disabledStyles = (0, $jjlaj.css)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&, :hover, :active": {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $dnCk4.N200), ")")
    }
});
var $6abbde01b35a36b1$var$selectedBorderStyles = (0, $jjlaj.css)({
    "&::before": {
        width: 2,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $6abbde01b35a36b1$var$selectedNotchStyles = (0, $jjlaj.css)({
    "&::before": {
        width: 4,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $6abbde01b35a36b1$var$selectedStyles = (0, $jjlaj.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $dnCk4.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    "&:visited": {
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $dnCk4.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $dnCk4.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $6abbde01b35a36b1$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $6abbde01b35a36b1$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $f44ba4bc0607081e$export$eb1decd851a5ae56)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $acw62.useContext)((0, $5aff9f9707de081d$export$443076ec7ebce042));
    var selectionStyle = (0, $acw62.useContext)((0, $5aff9f9707de081d$export$9ca534b70725964d));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $6abbde01b35a36b1$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $jjlaj.jsx)((0, $jjlaj.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $jjlaj.jsx)((0, $6f72ff8788d34fb2$export$2e2bcd8739ae039), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $6abbde01b35a36b1$var$positionRelativeStyles,
                    $6abbde01b35a36b1$var$primitiveStyles,
                    $6abbde01b35a36b1$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $6abbde01b35a36b1$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $6abbde01b35a36b1$var$selectedStyles,
                        [
                            selectionStyle === "border" && $6abbde01b35a36b1$var$selectedBorderStyles,
                            selectionStyle === "notch" && $6abbde01b35a36b1$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $6abbde01b35a36b1$var$disabledStyles : $6abbde01b35a36b1$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $jjlaj.jsx)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $6abbde01b35a36b1$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $jjlaj.jsx)("span", {
                "data-item-elem-before": true,
                css: (0, $ltooA.fg)("platform_ads_component_no_icon_spacing_support") ? $6abbde01b35a36b1$var$beforeAfterElementStyles : $6abbde01b35a36b1$var$beforeAfterElementStylesOld,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $jjlaj.jsx)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                alignBlock: "center",
                grow: "fill",
                xcss: $6abbde01b35a36b1$var$contentStyles
            }, renderTitle("span", {
                children: title,
                className: cn($6abbde01b35a36b1$var$titleStyles, shouldTitleWrap ? $6abbde01b35a36b1$var$wordBreakStyles : $6abbde01b35a36b1$var$truncateStyles),
                "data-item-title": true
            }), description && (0, $jjlaj.jsx)("span", {
                "data-item-description": true,
                css: [
                    $6abbde01b35a36b1$var$descriptionStyles,
                    isDisabled && $6abbde01b35a36b1$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $6abbde01b35a36b1$var$wordBreakStyles : $6abbde01b35a36b1$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $jjlaj.jsx)("span", {
                "data-item-elem-after": true,
                css: (0, $ltooA.fg)("platform_ads_component_no_icon_spacing_support") ? $6abbde01b35a36b1$var$beforeAfterElementStyles : $6abbde01b35a36b1$var$beforeAfterElementStylesOld,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $6abbde01b35a36b1$export$2e2bcd8739ae039 = $6abbde01b35a36b1$var$MenuItemPrimitive;


var $c641af5ec2d65691$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $c641af5ec2d65691$var$ButtonItem = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $c641af5ec2d65691$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $acw62.useContext)((0, $12HqF.default));
    var handleClick = (0, $acw62.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $f44ba4bc0607081e$export$eb1decd851a5ae56)("@atlaskit/menu", "cssFn", cssFn !== (0, $d3997b4aab843580$export$2e2bcd8739ae039), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $jjlaj.jsx)((0, $6abbde01b35a36b1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $jjlaj.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $c641af5ec2d65691$export$2e2bcd8739ae039 = $c641af5ec2d65691$var$ButtonItem;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");



var $12HqF = parcelRequire("12HqF");

var $ltooA = parcelRequire("ltooA");

var $0c0451e80ae3b3e9$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $0c0451e80ae3b3e9$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $0c0451e80ae3b3e9$var$CustomItem = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $0c0451e80ae3b3e9$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $acw62.useContext)((0, $12HqF.default));
    var handleClick = (0, $acw62.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $f44ba4bc0607081e$export$eb1decd851a5ae56)("@atlaskit/menu", "cssFn", cssFn !== (0, $d3997b4aab843580$export$2e2bcd8739ae039), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $jjlaj.jsx)((0, $6abbde01b35a36b1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $jjlaj.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $0c0451e80ae3b3e9$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $0c0451e80ae3b3e9$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $0c0451e80ae3b3e9$var$preventEvent : (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $0c0451e80ae3b3e9$export$2e2bcd8739ae039 = $0c0451e80ae3b3e9$var$CustomItem;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");




var $12HqF = parcelRequire("12HqF");

var $ltooA = parcelRequire("ltooA");

var $b065f2b82e3e7bee$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $b065f2b82e3e7bee$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $b065f2b82e3e7bee$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $b065f2b82e3e7bee$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $b065f2b82e3e7bee$var$LinkItem = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $b065f2b82e3e7bee$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $5318d277c24f693e$export$2e2bcd8739ae039)();
    var interactionContext = (0, $acw62.useContext)((0, $12HqF.default));
    var handleClick = (0, $acw62.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === "string" && $b065f2b82e3e7bee$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $b065f2b82e3e7bee$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === "";
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : "a";
    (0, $f44ba4bc0607081e$export$eb1decd851a5ae56)("@atlaskit/menu", "cssFn", cssFn !== (0, $d3997b4aab843580$export$2e2bcd8739ae039), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $jjlaj.jsx)((0, $6abbde01b35a36b1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $jjlaj.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $b065f2b82e3e7bee$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $b065f2b82e3e7bee$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $b065f2b82e3e7bee$var$preventEvent : (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $b065f2b82e3e7bee$export$2e2bcd8739ae039 = $b065f2b82e3e7bee$var$LinkItem;



var $ltooA = parcelRequire("ltooA");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");



var $g5Zhu = parcelRequire("g5Zhu");


var $ltooA = parcelRequire("ltooA");

var $53d7d7dd8d0c75e1$export$8a682ae47622dbb9 = "ds--dropdown--";
function $53d7d7dd8d0c75e1$export$2e2bcd8739ae039() {
    var id = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    return "".concat($53d7d7dd8d0c75e1$export$8a682ae47622dbb9).concat(id);
}


var $35652f3e34571c60$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $ee870615aeb9f56d$export$a80636c6f41931fe), "next"), (0, $ee870615aeb9f56d$export$390330c10ff2b9a1), "prev"), (0, $ee870615aeb9f56d$export$4af703091671bc), "first"), (0, $ee870615aeb9f56d$export$e2bc30913faa5db7), "last");
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $35652f3e34571c60$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    if ((0, $ltooA.fg)("dropdown-menu-disabled-navigation-fix")) for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute("disabled");
        if (isValid) return element;
    }
    else while(currentFocusedIdx + 1 < refs.length){
        var _element = refs[++currentFocusedIdx].current;
        var _isValid = !!_element && !_element.hasAttribute("disabled");
        if (_isValid) return _element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $35652f3e34571c60$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    if ((0, $ltooA.fg)("dropdown-menu-disabled-navigation-fix")) for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute("disabled");
        if (isValid) return element;
    }
    else while(currentFocusedIdx > 0){
        var _element2 = refs[--currentFocusedIdx].current;
        var _isValid2 = !!_element2 && !_element2.hasAttribute("disabled");
        if (_isValid2) return _element2;
    }
};
function $35652f3e34571c60$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $ltooA.fg)("platform_dst_popup-disable-focuslock")) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $53d7d7dd8d0c75e1$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $ee870615aeb9f56d$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $ee870615aeb9f56d$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $35652f3e34571c60$var$actionMap[e.key];
        switch(action){
            case "next":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if ((0, $ltooA.fg)("dropdown-menu-disabled-navigation-fix")) {
                    var _nextFocusableElement = $35652f3e34571c60$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                    break;
                }
                // Remove on FG cleanup dropdown-menu-disabled-navigation-fix
                if (currentFocusedIdx < currentRefs.length - 1) {
                    var _nextFocusableElement2 = $35652f3e34571c60$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    _nextFocusableElement2 === null || _nextFocusableElement2 === void 0 || _nextFocusableElement2.focus();
                } else {
                    var firstFocusableElement = $35652f3e34571c60$var$getNextFocusableElement(currentRefs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case "prev":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if ((0, $ltooA.fg)("dropdown-menu-disabled-navigation-fix")) {
                    var _prevFocusableElement = $35652f3e34571c60$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                    break;
                }
                // Remove on FG cleanup dropdown-menu-disabled-navigation-fix
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement2 = $35652f3e34571c60$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    _prevFocusableElement2 === null || _prevFocusableElement2 === void 0 || _prevFocusableElement2.focus();
                } else {
                    var lastFocusableElement = $35652f3e34571c60$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case "first":
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $35652f3e34571c60$var$getNextFocusableElement(currentRefs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case "last":
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $35652f3e34571c60$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $372d7ef692401e8e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $acw62.createContext)({
    menuItemRefs: [],
    registerRef: (0, $d3997b4aab843580$export$2e2bcd8739ae039)
});
/**
 * Focus manager logic.
 */ var $372d7ef692401e8e$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $acw62.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $acw62.useRef)("ordered");
    registerMode.current = "ordered";
    var registerRef = (0, $acw62.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case "ordered":
                menuItemRefs.current.push(ref);
                break;
            case "unordered":
                // Reset and force a rerender
                registerMode.current = "regenerate";
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case "regenerate":
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $39ea3782c8eee010$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $acw62.useEffect)(function() {
        if (registerMode.current === "ordered") // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = "unordered";
    });
    (0, $acw62.useEffect)(function() {
        return (0, $8fY35.bind)(window, {
            type: "keydown",
            listener: (0, $35652f3e34571c60$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($372d7ef692401e8e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $372d7ef692401e8e$export$2e2bcd8739ae039 = $372d7ef692401e8e$var$FocusManager;


// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $4923b4573ae6c70f$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $acw62.useContext)((0, $372d7ef692401e8e$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (hasPopup && (0, $ltooA.fg)("select-avoid-duplicated-registered-ref")) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $4923b4573ae6c70f$export$2e2bcd8739ae039 = $4923b4573ae6c70f$var$useRegisterItemWithFocusManager;


var $aa7456d8790c6386$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $aa7456d8790c6386$var$DropdownMenuItem = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $aa7456d8790c6386$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $4923b4573ae6c70f$export$2e2bcd8739ae039)(!!rest["aria-haspopup"]);
    var handleItemClick = (0, $acw62.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0c0451e80ae3b3e9$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b065f2b82e3e7bee$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c641af5ec2d65691$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, (0, $ltooA.fg)("platform_button_item-add-ufo-metrics") && {
        interactionName: interactionName
    }, rest), children);
});
var $aa7456d8790c6386$export$2e2bcd8739ae039 = $aa7456d8790c6386$var$DropdownMenuItem;


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $dnCk4 = parcelRequire("dnCk4");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");



var $dnCk4 = parcelRequire("dnCk4");
var $1b0546910de6dd37$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $1b0546910de6dd37$var$headingStyles = (0, $jjlaj.css)({
    color: "var(--ds-text-subtle, ".concat((0, $dnCk4.N300), ")"),
    font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $1b0546910de6dd37$var$HeadingItem = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $1b0546910de6dd37$var$_excluded);
    (0, $f44ba4bc0607081e$export$eb1decd851a5ae56)("@atlaskit/menu", "cssFn", cssFn !== (0, $d3997b4aab843580$export$2e2bcd8739ae039), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var UNSAFE_overrides = (0, $jjlaj.css)(cssFn(undefined));
    return (0, $jjlaj.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        css: [
            $1b0546910de6dd37$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: UNSAFE_className
    }, rest), children);
});
var $1b0546910de6dd37$export$2e2bcd8739ae039 = $1b0546910de6dd37$var$HeadingItem;


var $792950128a817a1c$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $792950128a817a1c$var$gridSize = 8;
var $792950128a817a1c$var$itemHeadingTopMargin = $792950128a817a1c$var$gridSize * 2.5;
var $792950128a817a1c$var$itemHeadingBottomMargin = $792950128a817a1c$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $792950128a817a1c$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $792950128a817a1c$var$skeletonHeadingHeight = $792950128a817a1c$var$gridSize;
var $792950128a817a1c$var$skeletonHeadingMarginOffset = 3;
var $792950128a817a1c$var$skeletonHeadingTopMargin = $792950128a817a1c$var$itemHeadingTopMargin + ($792950128a817a1c$var$itemHeadingContentHeight - $792950128a817a1c$var$skeletonHeadingHeight) - $792950128a817a1c$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $792950128a817a1c$var$skeletonHeadingBottomMargin = $792950128a817a1c$var$itemHeadingBottomMargin + $792950128a817a1c$var$skeletonHeadingMarginOffset;
var $792950128a817a1c$var$sectionPaddingTopBottom = $792950128a817a1c$var$gridSize * 0.75;
var $792950128a817a1c$var$VAR_SEPARATOR_COLOR = "--ds-menu-seperator-color";
var $792950128a817a1c$var$sectionStyles = (0, $jjlaj.css)({
    "&::before, &::after": {
        display: "block",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $792950128a817a1c$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $792950128a817a1c$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $792950128a817a1c$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $792950128a817a1c$var$itemHeadingTopMargin - $792950128a817a1c$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--skeleton-heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $792950128a817a1c$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $792950128a817a1c$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $792950128a817a1c$var$skeletonHeadingTopMargin - $792950128a817a1c$var$sectionPaddingTopBottom
        }
    },
    "&:focus": {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $792950128a817a1c$var$scrollableStyles = (0, $jjlaj.css)({
    flexShrink: 1,
    overflow: "auto"
});
var $792950128a817a1c$var$unscrollableStyles = (0, $jjlaj.css)({
    flexShrink: 0
});
var $792950128a817a1c$var$thinSeparatorStyles = (0, $jjlaj.css)({
    borderBlockStart: "1px solid var(".concat($792950128a817a1c$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $dnCk4.N30A), ")"), ")")
});
var $792950128a817a1c$var$noSeparatorStyles = (0, $jjlaj.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "[data-section] + &": {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $792950128a817a1c$var$Section = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $792950128a817a1c$var$_excluded);
    (0, $f44ba4bc0607081e$export$eb1decd851a5ae56)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $jjlaj.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $acw62.Children).map((0, $acw62.Children).toArray(children), function(child, index) {
        return (0, $jjlaj.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: "none",
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $jjlaj.jsx)((0, $acw62.Fragment), null, (0, $jjlaj.jsx)((0, $1b0546910de6dd37$export$2e2bcd8739ae039), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $jjlaj.jsx)((0, $acw62.Fragment), null, content);
    return (0, $jjlaj.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        css: [
            $792950128a817a1c$var$sectionStyles,
            isScrollable ? $792950128a817a1c$var$scrollableStyles : $792950128a817a1c$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $792950128a817a1c$var$thinSeparatorStyles : $792950128a817a1c$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $792950128a817a1c$export$2e2bcd8739ae039 = $792950128a817a1c$var$Section;



var $acw62 = parcelRequire("acw62");

var $a449f5aeccbeb8bd$var$headingStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    color: "color.text.subtle",
    font: "font.heading.xxsmall",
    paddingBlock: "space.0",
    paddingInline: "space.200"
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $a449f5aeccbeb8bd$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $a449f5aeccbeb8bd$var$headingStyles
    }, title);
};
var $a449f5aeccbeb8bd$export$2e2bcd8739ae039 = $a449f5aeccbeb8bd$var$GroupTitle;


var $da28a647dcd0fc3c$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator",
    "overrides"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $da28a647dcd0fc3c$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, overrides = _ref.overrides, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $da28a647dcd0fc3c$var$_excluded);
    var uid = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $792950128a817a1c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        overrides: overrides
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a449f5aeccbeb8bd$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $da28a647dcd0fc3c$export$2e2bcd8739ae039 = $da28a647dcd0fc3c$var$DropdownMenuItemGroup;


var $8550fae2a8eb6759$exports = {};
"use strict";
Object.defineProperty($8550fae2a8eb6759$exports, "__esModule", {
    value: true
});
$8550fae2a8eb6759$exports.default = void 0;

var $8550fae2a8eb6759$var$_react = $8550fae2a8eb6759$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $8550fae2a8eb6759$var$_chevronDown = $8550fae2a8eb6759$var$_interopRequireDefault((parcelRequire("5FCTo")));
function $8550fae2a8eb6759$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8550fae2a8eb6759$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $8550fae2a8eb6759$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $8550fae2a8eb6759$var$_chevronDown.default,
        iconType: "utility"
    }));
$8550fae2a8eb6759$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $8550fae2a8eb6759$var$_default = $8550fae2a8eb6759$exports.default = $8550fae2a8eb6759$var$ChevronDownIcon;


var $01f2c5ba34969e08$exports = {};
"use strict";
Object.defineProperty($01f2c5ba34969e08$exports, "__esModule", {
    value: true
});
$01f2c5ba34969e08$exports.default = void 0;

var $01f2c5ba34969e08$var$_react = $01f2c5ba34969e08$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $01f2c5ba34969e08$var$_arrowUpRight = $01f2c5ba34969e08$var$_interopRequireDefault((parcelRequire("7pIF7")));
function $01f2c5ba34969e08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01f2c5ba34969e08$var$OpenIcon = (props)=>/*#__PURE__*/ $01f2c5ba34969e08$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $01f2c5ba34969e08$var$_arrowUpRight.default
    }));
$01f2c5ba34969e08$var$OpenIcon.displayName = "OpenIcon";
var $01f2c5ba34969e08$var$_default = $01f2c5ba34969e08$exports.default = $01f2c5ba34969e08$var$OpenIcon;





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $1a835d1e20c64ab3$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $1a835d1e20c64ab3$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});



var $ltooA = parcelRequire("ltooA");

var $g5Zhu = parcelRequire("g5Zhu");

var $g5Zhu = parcelRequire("g5Zhu");

var $GtgEQ = parcelRequire("GtgEQ");
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $93f5d16c7f116a6e$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $93f5d16c7f116a6e$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $93f5d16c7f116a6e$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $93f5d16c7f116a6e$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $93f5d16c7f116a6e$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $93f5d16c7f116a6e$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
let $93f5d16c7f116a6e$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $93f5d16c7f116a6e$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $93f5d16c7f116a6e$export$809831be6c4c6227 = Object.freeze([
    $93f5d16c7f116a6e$export$6b4f396210e539f3.DESKTOP,
    $93f5d16c7f116a6e$export$6b4f396210e539f3.MAC,
    $93f5d16c7f116a6e$export$6b4f396210e539f3.LINUX,
    $93f5d16c7f116a6e$export$6b4f396210e539f3.WINDOWS
]);
const $93f5d16c7f116a6e$export$19c579398ad213e7 = Object.freeze([
    $93f5d16c7f116a6e$export$6b4f396210e539f3.WEB,
    $93f5d16c7f116a6e$export$6b4f396210e539f3.MOBILE_WEB
]);
let $93f5d16c7f116a6e$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $93f5d16c7f116a6e$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $93f5d16c7f116a6e$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $93f5d16c7f116a6e$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $93f5d16c7f116a6e$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $93f5d16c7f116a6e$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $93f5d16c7f116a6e$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});



var $g5Zhu = parcelRequire("g5Zhu");


var $g5Zhu = parcelRequire("g5Zhu");
class $ddc9b6bbba94d5d4$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== "undefined") {
            if (typeof document.hidden !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = "hidden";
                this._visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                this._isHidden = document.msHidden;
                this._hidden = "msHidden";
                this._visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                this._isHidden = document.webkitHidden;
                this._hidden = "webkitHidden";
                this._visibilityChange = "webkitvisibilitychange";
            }
            if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== "string") throw new Error("Invalid name, must be string");
        if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}


class $d0b11aedd4cb2872$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}


function $b611e717ce85c573$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b611e717ce85c573$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b611e717ce85c573$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b611e717ce85c573$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $b611e717ce85c573$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $b611e717ce85c573$var$_objectSpread($b611e717ce85c573$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $93f5d16c7f116a6e$export$99b37380a464d794).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $93f5d16c7f116a6e$export$99b37380a464d794).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $93f5d16c7f116a6e$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$99b37380a464d794), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $93f5d16c7f116a6e$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $b611e717ce85c573$var$_objectSpread($b611e717ce85c573$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $ddc9b6bbba94d5d4$export$2e2bcd8739ae039))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $d0b11aedd4cb2872$export$2e2bcd8739ae039)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($b611e717ce85c573$var$_objectSpread($b611e717ce85c573$var$_objectSpread($b611e717ce85c573$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}


/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $b10ccdef2d007477$var$isFunction = (possibleFn)=>typeof possibleFn === "function";
var $b10ccdef2d007477$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($b10ccdef2d007477$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};



const $0a7986df04cf3b8c$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $93f5d16c7f116a6e$export$f49776dca27a2e7c).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $0a7986df04cf3b8c$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $93f5d16c7f116a6e$export$f49776dca27a2e7c).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};



var $g5Zhu = parcelRequire("g5Zhu");

// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $3255bdb7f2a44e26$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $3255bdb7f2a44e26$var$isObjectObject(o) {
    return $3255bdb7f2a44e26$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $3255bdb7f2a44e26$export$53b83ca8eaab0383(o) {
    if ($3255bdb7f2a44e26$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($3255bdb7f2a44e26$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}


function $df9e9ae13d4a866e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df9e9ae13d4a866e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df9e9ae13d4a866e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df9e9ae13d4a866e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $df9e9ae13d4a866e$var$libraryVersion = "5.1.0";
function $df9e9ae13d4a866e$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $df9e9ae13d4a866e$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $df9e9ae13d4a866e$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $df9e9ae13d4a866e$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $df9e9ae13d4a866e$var$buildAliases(aliases) {
    if ($df9e9ae13d4a866e$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $df9e9ae13d4a866e$var$buildGroups(groups) {
    if ($df9e9ae13d4a866e$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $df9e9ae13d4a866e$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $df9e9ae13d4a866e$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $df9e9ae13d4a866e$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $df9e9ae13d4a866e$var$getProductField(productInfo.env, overrides.env);
    const product = $df9e9ae13d4a866e$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $df9e9ae13d4a866e$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $df9e9ae13d4a866e$var$getProductField(productInfo.version, overrides.version);
    const origin = $df9e9ae13d4a866e$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $df9e9ae13d4a866e$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $df9e9ae13d4a866e$var$isNotEmptyObject(obj) {
    return (0, $3255bdb7f2a44e26$export$53b83ca8eaab0383)(obj) && Object.keys(obj).length > 0;
}
function $df9e9ae13d4a866e$var$buildAttributesWithName(name, attrObject) {
    return $df9e9ae13d4a866e$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $df9e9ae13d4a866e$var$buildAttributes(attributes) {
    return $df9e9ae13d4a866e$var$buildAttributesWithName("attributes", attributes);
}
function $df9e9ae13d4a866e$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $df9e9ae13d4a866e$export$f045f238d77c002a(containers) {
    if ($df9e9ae13d4a866e$var$isNotEmptyObject(containers)) {
        const validContainers = $df9e9ae13d4a866e$export$3f5115a568819c1a(containers);
        return $df9e9ae13d4a866e$var$buildAttributesWithName("containers", validContainers);
    }
    return undefined;
}
function $df9e9ae13d4a866e$export$655ecf7241feac42(event, actionEventType) {
    return $df9e9ae13d4a866e$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $df9e9ae13d4a866e$export$f045f238d77c002a(event.containers));
}
function $df9e9ae13d4a866e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $df9e9ae13d4a866e$var$buildAttributesWithName("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $df9e9ae13d4a866e$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $df9e9ae13d4a866e$var$buildProductFields(productInfo);
    const tenantFields = $df9e9ae13d4a866e$var$buildTenantFields(tenantInfo);
    const userFields = $df9e9ae13d4a866e$var$buildUserFields(userInfo);
    const orgFields = $df9e9ae13d4a866e$var$buildOrgFields(orgInfo);
    const workspaceFields = $df9e9ae13d4a866e$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $93f5d16c7f116a6e$export$4c045e605d532c98).SCREEN
    };
    return $df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $df9e9ae13d4a866e$var$buildAttributes(attributes)), $df9e9ae13d4a866e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $df9e9ae13d4a866e$export$f045f238d77c002a(containers)), $df9e9ae13d4a866e$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $df9e9ae13d4a866e$var$buildAliases(aliases)), $df9e9ae13d4a866e$var$buildGroups(groups));
}
function $df9e9ae13d4a866e$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
let $df9e9ae13d4a866e$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $df9e9ae13d4a866e$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return $df9e9ae13d4a866e$export$fbd92247fb4d6159.QUIET;
    if (environment.includes("prod")) return $df9e9ae13d4a866e$export$fbd92247fb4d6159.QUIET;
    return $df9e9ae13d4a866e$export$fbd92247fb4d6159.COMPLETE;
}
function $df9e9ae13d4a866e$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $df9e9ae13d4a866e$var$libraryVersion
            },
            validationMode: $df9e9ae13d4a866e$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $df9e9ae13d4a866e$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $df9e9ae13d4a866e$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $df9e9ae13d4a866e$var$buildProductFields(productInfo, $df9e9ae13d4a866e$export$e3d99b4bfec06f6e(event));
    const tenantFields = $df9e9ae13d4a866e$var$buildTenantFields(tenantInfo);
    const orgFields = $df9e9ae13d4a866e$var$buildOrgFields(orgInfo);
    const workspaceFields = $df9e9ae13d4a866e$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $df9e9ae13d4a866e$var$buildUserFields(userInfo);
    const actionFields = $df9e9ae13d4a866e$export$655ecf7241feac42(event, actionEventType);
    return $df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread($df9e9ae13d4a866e$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $df9e9ae13d4a866e$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $df9e9ae13d4a866e$var$buildAliases(aliases)), $df9e9ae13d4a866e$var$buildGroups(groups));
}



var $g5Zhu = parcelRequire("g5Zhu");
const $f3b4b359082dba5b$export$cf090d5281b5ae06 = 10000;
const $f3b4b359082dba5b$export$8575e30be0feb909 = 30000;



var $g5Zhu = parcelRequire("g5Zhu");

/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $eeeffb0732c0b2cc$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $eeeffb0732c0b2cc$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $eeeffb0732c0b2cc$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $eeeffb0732c0b2cc$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $eeeffb0732c0b2cc$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $eeeffb0732c0b2cc$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$eeeffb0732c0b2cc$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $eeeffb0732c0b2cc$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);



var $g5Zhu = parcelRequire("g5Zhu");



var $g5Zhu = parcelRequire("g5Zhu");


const $4f3c6709bd72259b$var$actionEventTypes = Object.freeze([
    (0, $93f5d16c7f116a6e$export$4c045e605d532c98).OPERATIONAL,
    (0, $93f5d16c7f116a6e$export$4c045e605d532c98).TRACK,
    (0, $93f5d16c7f116a6e$export$4c045e605d532c98).UI
]);
function $4f3c6709bd72259b$export$df8ff30e3c960006(container) {
    if (!(0, $3255bdb7f2a44e26$export$53b83ca8eaab0383)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}
function $4f3c6709bd72259b$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach((container)=>$4f3c6709bd72259b$export$df8ff30e3c960006(container));
}
function $4f3c6709bd72259b$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $93f5d16c7f116a6e$export$4c045e605d532c98).OPERATIONAL:
        case (0, $93f5d16c7f116a6e$export$4c045e605d532c98).TRACK:
        case (0, $93f5d16c7f116a6e$export$4c045e605d532c98).UI:
            return true;
        default:
            return false;
    }
}
function $4f3c6709bd72259b$export$4a8d7476662aebcc(type) {
    if (!$4f3c6709bd72259b$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$4f3c6709bd72259b$var$actionEventTypes}]`);
    return true;
}
function $4f3c6709bd72259b$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    $4f3c6709bd72259b$export$e63ea5d8477971d3(event.containers);
}
function $4f3c6709bd72259b$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}
function $4f3c6709bd72259b$export$8c014fd74b0c8b99(event) {
    $4f3c6709bd72259b$export$e0c121325c66ed4c(event);
}
function $4f3c6709bd72259b$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}
function $4f3c6709bd72259b$export$e5bac0930c812e90(event) {
    $4f3c6709bd72259b$export$e0c121325c66ed4c(event);
}
function $4f3c6709bd72259b$export$1e561554275607ef(event) {
    $4f3c6709bd72259b$export$e0c121325c66ed4c(event);
}
function $4f3c6709bd72259b$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$1827adfd178b4870), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $93f5d16c7f116a6e$export$ad1854f4a08c15f8)((0, $93f5d16c7f116a6e$export$1827adfd178b4870))}]`);
}
function $4f3c6709bd72259b$export$801b46c35394d316(productInfo) {
    if (!(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$6b4f396210e539f3), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $93f5d16c7f116a6e$export$ad1854f4a08c15f8)((0, $93f5d16c7f116a6e$export$6b4f396210e539f3))}]`);
    if (productInfo.origin === (0, $93f5d16c7f116a6e$export$f73e9fcd368bb695).DESKTOP && !(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$809831be6c4c6227), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $93f5d16c7f116a6e$export$f73e9fcd368bb695).WEB && !(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$19c579398ad213e7), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}



class $ad94af85e7ce3b67$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $4f3c6709bd72259b$export$d19cebda16f7579a)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $eeeffb0732c0b2cc$export$b29f828819edca8d)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error("No events were returned from the compression function");
            compressedEvents.forEach((event)=>{
                (0, $4f3c6709bd72259b$export$4a8d7476662aebcc)(event.eventType);
                (0, $4f3c6709bd72259b$export$e0c121325c66ed4c)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
        if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}


function $d5d687568e7961e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5d687568e7961e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5d687568e7961e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5d687568e7961e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $d5d687568e7961e6$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $df9e9ae13d4a866e$export$655ecf7241feac42)(event, event.eventType);
                    contextFields = (0, $eeeffb0732c0b2cc$export$30a06c8d3562193f)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $eeeffb0732c0b2cc$export$e9bab7fafb253603)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$d5d687568e7961e6$var$_objectSpread($d5d687568e7961e6$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
        if (!compressionRules.every((rule)=>rule instanceof (0, $ad94af85e7ce3b67$export$89b3253ddfd2e6e8))) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
        this.compressionRules = compressionRules;
    }
}


// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $51c780c4b051095f$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $51c780c4b051095f$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $51c780c4b051095f$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Failed to perform compression on the delayed analytics events. " + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $51c780c4b051095f$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $51c780c4b051095f$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $eeeffb0732c0b2cc$export$b29f828819edca8d)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $eeeffb0732c0b2cc$export$e9bab7fafb253603)(group.userInfo, args.userInfo) && (0, $eeeffb0732c0b2cc$export$e9bab7fafb253603)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $df9e9ae13d4a866e$export$9c5623a792efc9b0)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $d5d687568e7961e6$export$2e2bcd8739ae039)(compressionRules);
    }
}


let $08ee277bb07ec538$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});


class $0442973d0ddb8572$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startLowPriorityEventDelay", (timeout = (0, $f3b4b359082dba5b$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $f3b4b359082dba5b$export$8575e30be0feb909)) : (0, $f3b4b359082dba5b$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $08ee277bb07ec538$export$fa6e3729c21cb8f).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopLowPriorityEventDelay", (reason = (0, $08ee277bb07ec538$export$fa6e3729c21cb8f).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $51c780c4b051095f$export$2e2bcd8739ae039)(fireDelayedEvent, compressors);
    }
}




var $g5Zhu = parcelRequire("g5Zhu");

var $GtgEQ = parcelRequire("GtgEQ");

var $g5Zhu = parcelRequire("g5Zhu");
let $909a3a90d9a29cc5$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $909a3a90d9a29cc5$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});



const $53d14f69460c8300$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).ACK]: `${queuePrefix}.${queueId}.${(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).ACK}`,
        [(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).QUEUE]: `${queuePrefix}.${queueId}.${(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).QUEUE}`,
        [(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).IN_PROGRESS}`,
        [(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).RECLAIM_START}`,
        [(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).RECLAIM_END}`
    });


// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $6626548ccb34a5fc$var$validSuffixs = Object.values((0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241));
var $6626548ccb34a5fc$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split(".")).filter((splitKeys)=>splitKeys.length === 3 && $6626548ccb34a5fc$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $53d14f69460c8300$export$8433d54f767cbec5)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};


var $g5Zhu = parcelRequire("g5Zhu");

var $GtgEQ = parcelRequire("GtgEQ");


function $fc83ddc5b0e43bd5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc83ddc5b0e43bd5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc83ddc5b0e43bd5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc83ddc5b0e43bd5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $fc83ddc5b0e43bd5$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $fc83ddc5b0e43bd5$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split(".")).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $909a3a90d9a29cc5$export$ecfa71cbc9b28241).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $909a3a90d9a29cc5$export$8bb2c1fb2b1765a9).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $fc83ddc5b0e43bd5$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $fc83ddc5b0e43bd5$var$promisedSetTimeout((0, $909a3a90d9a29cc5$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $909a3a90d9a29cc5$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $fc83ddc5b0e43bd5$var$promisedSetTimeout((0, $909a3a90d9a29cc5$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $909a3a90d9a29cc5$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
    return $fc83ddc5b0e43bd5$var$reclaim(options, callback);
};
const $fc83ddc5b0e43bd5$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || "{}");
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $fc83ddc5b0e43bd5$var$_objectSpread($fc83ddc5b0e43bd5$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === "successful") $fc83ddc5b0e43bd5$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === "partial") {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $fc83ddc5b0e43bd5$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $fc83ddc5b0e43bd5$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $fc83ddc5b0e43bd5$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))();
    const queuesToReclaim = $fc83ddc5b0e43bd5$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$fc83ddc5b0e43bd5$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $53d14f69460c8300$export$8433d54f767cbec5)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === "rejected");
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === "fulfilled").map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};


const $1b13be32e45af283$export$a409c8de90e11e14 = "CallbackProcessingError";
class $1b13be32e45af283$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        const messageFromString = typeof error === "string" && error;
        const message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $1b13be32e45af283$export$2e2bcd8739ae039.prototype);
        this.name = $1b13be32e45af283$export$a409c8de90e11e14;
    }
}

const $b2df635b240d0e97$export$d21fbb25eb37b5bf = "namespace-timeAdded";
const $b2df635b240d0e97$export$8cad224051643259 = "analytics-web-client";
const $b2df635b240d0e97$export$3d8420be07b276ab = "analytics-resilience";
const $b2df635b240d0e97$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
const $b2df635b240d0e97$export$89d9c1ff8ac91862 = "timeAdded";
const $b2df635b240d0e97$export$a37d385bcd713809 = "retryAttempts";
const $b2df635b240d0e97$export$6d8635fed0e4b14d = 15000;
let $b2df635b240d0e97$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $b2df635b240d0e97$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});


const $bd50ed54f7df20b1$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
class $bd50ed54f7df20b1$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super("window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $bd50ed54f7df20b1$export$2e2bcd8739ae039.prototype);
        this.name = $bd50ed54f7df20b1$export$fc14cf6dcea0f8ed;
    }
}

const $ed43872603c5e676$export$ba95206613c96b28 = "AbandonWriteError";
class $ed43872603c5e676$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $ed43872603c5e676$export$2e2bcd8739ae039.prototype);
        this.name = $ed43872603c5e676$export$ba95206613c96b28;
    }
}



const $4cbdcfa6a466f5c5$export$7e7aee9a953465ec = "InvalidPolicyError";
class $4cbdcfa6a466f5c5$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $4cbdcfa6a466f5c5$export$7e7aee9a953465ec;
    }
}


const $d03f02314e3df154$export$74101021e0969375 = (error)=>{
    if (error && typeof error === "object" && "name" in error) {
        const errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $ed43872603c5e676$export$ba95206613c96b28) || errorWithName.name === (0, $1b13be32e45af283$export$a409c8de90e11e14) || errorWithName.name === (0, $4cbdcfa6a466f5c5$export$7e7aee9a953465ec));
    }
    return false;
};



var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");

const $47d8a751786c8e47$export$b6df3d334cec060f = 7;
const $47d8a751786c8e47$export$14ef152a03a4b6ee = 60000;
const $47d8a751786c8e47$export$da9ab7b2fd5998e8 = 10;
const $47d8a751786c8e47$export$1188664dfff364c8 = 5000;




var $g5Zhu = parcelRequire("g5Zhu");



var $GtgEQ = parcelRequire("GtgEQ");

const $ac6e3b2d39b98e1b$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $ac6e3b2d39b98e1b$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $47d8a751786c8e47$export$da9ab7b2fd5998e8),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $47d8a751786c8e47$export$1188664dfff364c8)
    });
const $ac6e3b2d39b98e1b$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $ac6e3b2d39b98e1b$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $ac6e3b2d39b98e1b$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return $ac6e3b2d39b98e1b$export$2a5213bce1720b42(transaction);
};
const $ac6e3b2d39b98e1b$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn("Error thrown from request:", event);
    };
};


class $507172ee7ac1c9b6$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $b2df635b240d0e97$export$d21fbb25eb37b5bf));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $ac6e3b2d39b98e1b$export$85ceed0783e42041)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $b2df635b240d0e97$export$7710d69e6f450f20).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $b2df635b240d0e97$export$7710d69e6f450f20).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $ac6e3b2d39b98e1b$export$85ceed0783e42041)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $ac6e3b2d39b98e1b$export$feab8418f018df89)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $ed43872603c5e676$export$2e2bcd8739ae039)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $b2df635b240d0e97$export$d21fbb25eb37b5bf));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $ac6e3b2d39b98e1b$export$85ceed0783e42041)(request);
        return event.target.result;
    }
}



const $a471ddb4f619e2d7$var$_excluded = [
    "item"
], $a471ddb4f619e2d7$var$_excluded2 = [
    "items"
];
function $a471ddb4f619e2d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a471ddb4f619e2d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a471ddb4f619e2d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a471ddb4f619e2d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $a471ddb4f619e2d7$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== "undefined") {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn("IndexedDB timed out.");
                        reject(new (0, $bd50ed54f7df20b1$export$2e2bcd8739ae039)());
                    }, (0, $b2df635b240d0e97$export$6d8635fed0e4b14d));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $b2df635b240d0e97$export$8cad224051643259), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                        const db = request.result;
                        const store = db.createObjectStore((0, $b2df635b240d0e97$export$3d8420be07b276ab), {
                            keyPath: "id"
                        });
                        store.createIndex((0, $b2df635b240d0e97$export$a512a65455fce2a6), (0, $b2df635b240d0e97$export$a512a65455fce2a6), {
                            unique: false
                        });
                        store.createIndex((0, $b2df635b240d0e97$export$a37d385bcd713809), (0, $b2df635b240d0e97$export$a37d385bcd713809), {
                            unique: false
                        });
                        store.createIndex((0, $b2df635b240d0e97$export$89d9c1ff8ac91862), (0, $b2df635b240d0e97$export$89d9c1ff8ac91862), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $b2df635b240d0e97$export$d21fbb25eb37b5bf), [
                            "namespace",
                            "timeAdded"
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $bd50ed54f7df20b1$export$2e2bcd8739ae039)());
                    };
                    try {
                        await (0, $ac6e3b2d39b98e1b$export$85ceed0783e42041)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn("IndexedDB failed to initialise.", error);
                        reject(new (0, $bd50ed54f7df20b1$export$2e2bcd8739ae039)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $bd50ed54f7df20b1$export$2e2bcd8739ae039)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "addItem", async (item, options = {}, policy = (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $ac6e3b2d39b98e1b$export$aec476f33d77be11)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            if (policy === (0, $b2df635b240d0e97$export$7710d69e6f450f20).IGNORE) throw new (0, $4cbdcfa6a466f5c5$export$2e2bcd8739ae039)(policy, "IndexedDbConnector#addItem");
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $d03f02314e3df154$export$74101021e0969375)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "bulkAddItem", async (itemOptions, policy = (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a471ddb4f619e2d7$var$_excluded);
                return (0, $ac6e3b2d39b98e1b$export$aec476f33d77be11)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $d03f02314e3df154$export$74101021e0969375)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItems", async (count = (0, $47d8a751786c8e47$export$b6df3d334cec060f))=>{
            const fixedCount = count > 0 ? count : (0, $47d8a751786c8e47$export$b6df3d334cec060f);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            const timeIndex = objectStore.index((0, $b2df635b240d0e97$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error("Failed to open cursor:", error);
                    reject("Failed to open cursor");
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $a471ddb4f619e2d7$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $47d8a751786c8e47$export$14ef152a03a4b6ee);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $ac6e3b2d39b98e1b$export$342d941b6f724995)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $ac6e3b2d39b98e1b$export$342d941b6f724995)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $ac6e3b2d39b98e1b$export$feab8418f018df89)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $ac6e3b2d39b98e1b$export$feab8418f018df89)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readonly");
            const timeIndex = objectStore.index((0, $b2df635b240d0e97$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $ac6e3b2d39b98e1b$export$85ceed0783e42041)(request);
            await (0, $ac6e3b2d39b98e1b$export$feab8418f018df89)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "processItems", async (processFn, count = (0, $47d8a751786c8e47$export$b6df3d334cec060f))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_await$this$getItems, $a471ddb4f619e2d7$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $1b13be32e45af283$export$2e2bcd8739ae039)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $ac6e3b2d39b98e1b$export$85ceed0783e42041)(objectStore.delete(id));
            } catch (error) {
                logger.error("Failed to delete item:", id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $b2df635b240d0e97$export$3d8420be07b276ab), mode);
            const objectStore = transaction.objectStore((0, $b2df635b240d0e97$export$3d8420be07b276ab));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $ac6e3b2d39b98e1b$export$ddc6718318090f71)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $bd50ed54f7df20b1$export$2e2bcd8739ae039)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $507172ee7ac1c9b6$export$2e2bcd8739ae039)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $b2df635b240d0e97$export$39337ab5872e9457).INDEXEDDB;
    }
}



var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");




var $g5Zhu = parcelRequire("g5Zhu");


class $a85c418a0fa69ca7$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $b2df635b240d0e97$export$7710d69e6f450f20).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $b2df635b240d0e97$export$7710d69e6f450f20).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $ed43872603c5e676$export$2e2bcd8739ae039)((0, $b2df635b240d0e97$export$39337ab5872e9457).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}



const $17634c485105556b$var$_excluded = [
    "item"
], $17634c485105556b$var$_excluded2 = [
    "items"
];
function $17634c485105556b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $17634c485105556b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $17634c485105556b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $17634c485105556b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $17634c485105556b$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $ac6e3b2d39b98e1b$export$ddc6718318090f71)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $a85c418a0fa69ca7$export$2e2bcd8739ae039)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON) {
        if (policy === (0, $b2df635b240d0e97$export$7710d69e6f450f20).IGNORE) throw new (0, $4cbdcfa6a466f5c5$export$2e2bcd8739ae039)(policy, "IndexedDbConnector#addItem");
        const storedValue = (0, $ac6e3b2d39b98e1b$export$aec476f33d77be11)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $17634c485105556b$var$_excluded);
            return (0, $ac6e3b2d39b98e1b$export$aec476f33d77be11)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $47d8a751786c8e47$export$b6df3d334cec060f)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $47d8a751786c8e47$export$b6df3d334cec060f)) {
        const fixedCount = count > 0 ? count : (0, $47d8a751786c8e47$export$b6df3d334cec060f);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($17634c485105556b$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $47d8a751786c8e47$export$14ef152a03a4b6ee);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$synchronousGetI, $17634c485105556b$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $1b13be32e45af283$export$2e2bcd8739ae039)(error);
        }
    }
    storeType() {
        return (0, $b2df635b240d0e97$export$39337ab5872e9457).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}



class $d9c99715eb675ab3$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $ac6e3b2d39b98e1b$export$ddc6718318090f71)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $a471ddb4f619e2d7$export$2e2bcd8739ae039)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $bd50ed54f7df20b1$export$2e2bcd8739ae039))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
            }
        }
        return new (0, $17634c485105556b$export$2e2bcd8739ae039)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $b2df635b240d0e97$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $d03f02314e3df154$export$74101021e0969375)(error)) throw error;
            else if (this.resilience.storeType() === (0, $b2df635b240d0e97$export$39337ab5872e9457).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $17634c485105556b$export$2e2bcd8739ae039)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $b2df635b240d0e97$export$7710d69e6f450f20).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
        // Dont need to catch. We are just getting events if we can
        }
    }
}




var $203ee50ae979938d$export$2e2bcd8739ae039 = (0, $d9c99715eb675ab3$export$2e2bcd8739ae039);



var $g5Zhu = parcelRequire("g5Zhu");
let $613ace8bef471e04$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $613ace8bef471e04$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});


class $f828bb60d1dd5079$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "resilienceMechanism", (0, $613ace8bef471e04$export$c75161629e3ec34e).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $f828bb60d1dd5079$var$cachedMetricsClient = null;
var $f828bb60d1dd5079$export$2e2bcd8739ae039 = ()=>{
    if (!$f828bb60d1dd5079$var$cachedMetricsClient) $f828bb60d1dd5079$var$cachedMetricsClient = new $f828bb60d1dd5079$export$4b62ee5120ab50a8();
    return $f828bb60d1dd5079$var$cachedMetricsClient;
};



class $443e8cea14124f63$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        if (typeof window !== "undefined") {
            window.addEventListener("offline", ()=>networkChangeCallback((0, $613ace8bef471e04$export$ee138fa712d11b84).OFFLINE));
            window.addEventListener("online", ()=>networkChangeCallback((0, $613ace8bef471e04$export$ee138fa712d11b84).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $613ace8bef471e04$export$ee138fa712d11b84).ONLINE;
        return (0, $613ace8bef471e04$export$ee138fa712d11b84).OFFLINE;
    }
}



var $g5Zhu = parcelRequire("g5Zhu");

var $g5Zhu = parcelRequire("g5Zhu");
let $8961832a53ef94f1$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $8961832a53ef94f1$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $8961832a53ef94f1$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "callbackStatus", $8961832a53ef94f1$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $8961832a53ef94f1$export$ef3353088fca369c.IDLE:
            case $8961832a53ef94f1$export$ef3353088fca369c.TIMED_OUT:
            case $8961832a53ef94f1$export$ef3353088fca369c.COMPLETED:
                if (event === $8961832a53ef94f1$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $8961832a53ef94f1$export$ef3353088fca369c.RUNNING;
                break;
            case $8961832a53ef94f1$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $8961832a53ef94f1$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $8961832a53ef94f1$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $8961832a53ef94f1$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $8961832a53ef94f1$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === "undefined") return;
        this.transitionCallbackStatus(this.callbackStatus, $8961832a53ef94f1$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $8961832a53ef94f1$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $8961832a53ef94f1$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $8961832a53ef94f1$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== "undefined" && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}


// Clients can optionally provide the callbackTimeoutPeriod parameter
let $e976323562e85ac7$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});


const $bc3f5abdbc5f904d$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $bc3f5abdbc5f904d$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $bc3f5abdbc5f904d$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === "undefined") return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $bc3f5abdbc5f904d$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $bc3f5abdbc5f904d$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $bc3f5abdbc5f904d$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $bc3f5abdbc5f904d$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearTimeout", ()=>{
            if (typeof window !== "undefined" && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $e976323562e85ac7$export$f93c40fda808dd0c).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $e976323562e85ac7$export$f93c40fda808dd0c).ERROR || this.callbackTimer.getCallbackStatus() === (0, $8961832a53ef94f1$export$ef3353088fca369c).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $e976323562e85ac7$export$f93c40fda808dd0c).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $bc3f5abdbc5f904d$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $bc3f5abdbc5f904d$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $bc3f5abdbc5f904d$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $bc3f5abdbc5f904d$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $bc3f5abdbc5f904d$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $bc3f5abdbc5f904d$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $bc3f5abdbc5f904d$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $bc3f5abdbc5f904d$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $bc3f5abdbc5f904d$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $bc3f5abdbc5f904d$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $8961832a53ef94f1$export$590a718599f8f8b3)(this.options.callbackTimeoutPeriod);
    }
}



function $3d100611d56bdbe0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d100611d56bdbe0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d100611d56bdbe0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d100611d56bdbe0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3d100611d56bdbe0$var$ONE_MINUTE = 60000;
const $3d100611d56bdbe0$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $3d100611d56bdbe0$var$ONE_MINUTE,
    minRetryDelay: $3d100611d56bdbe0$var$ONE_MINUTE,
    maxRetryDelay: $3d100611d56bdbe0$var$ONE_MINUTE
};
const $3d100611d56bdbe0$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $3d100611d56bdbe0$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $203ee50ae979938d$export$2e2bcd8739ae039)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $bc3f5abdbc5f904d$export$2e2bcd8739ae039)($3d100611d56bdbe0$var$_objectSpread($3d100611d56bdbe0$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $bc3f5abdbc5f904d$export$2e2bcd8739ae039)($3d100611d56bdbe0$var$_objectSpread($3d100611d56bdbe0$var$_objectSpread({}, $3d100611d56bdbe0$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $3d100611d56bdbe0$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $f828bb60d1dd5079$export$2e2bcd8739ae039)();
        this.networkStatus = new (0, $443e8cea14124f63$export$2e2bcd8739ae039)((status)=>{
            if (status === (0, $613ace8bef471e04$export$ee138fa712d11b84).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $b2df635b240d0e97$export$7710d69e6f450f20).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $613ace8bef471e04$export$ee138fa712d11b84).OFFLINE) {
            done((0, $e976323562e85ac7$export$f93c40fda808dd0c).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $1b13be32e45af283$export$a409c8de90e11e14)) {
                done((0, $e976323562e85ac7$export$f93c40fda808dd0c).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $6626548ccb34a5fc$export$2e2bcd8739ae039)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $fc83ddc5b0e43bd5$export$2e2bcd8739ae039)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $b2df635b240d0e97$export$7710d69e6f450f20).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: "successful"
            };
            else return {
                status: "partial",
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $e976323562e85ac7$export$f93c40fda808dd0c).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $e976323562e85ac7$export$f93c40fda808dd0c).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $e976323562e85ac7$export$f93c40fda808dd0c).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $3d100611d56bdbe0$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $3d100611d56bdbe0$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $3d100611d56bdbe0$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $3d100611d56bdbe0$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $3d100611d56bdbe0$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $3d100611d56bdbe0$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $3d100611d56bdbe0$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $3d100611d56bdbe0$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $3d100611d56bdbe0$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}



var $4730c7d5973c7c48$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $3d100611d56bdbe0$export$2e2bcd8739ae039)(retryQueuePrefix, product, options || {}, logger);
};




var $g5Zhu = parcelRequire("g5Zhu");
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $3e6544d6c45ea475$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $3e6544d6c45ea475$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $3e6544d6c45ea475$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});


function $5d76724be5d06767$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d76724be5d06767$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d76724be5d06767$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d76724be5d06767$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5d76724be5d06767$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $3e6544d6c45ea475$export$ddf929981dc6feb3).PAGE || item.msg.type === (0, $3e6544d6c45ea475$export$ddf929981dc6feb3).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $5d76724be5d06767$var$_objectSpread($5d76724be5d06767$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $3e6544d6c45ea475$export$ddf929981dc6feb3).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $5d76724be5d06767$var$_objectSpread($5d76724be5d06767$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $5d76724be5d06767$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$5d76724be5d06767$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}


const $dc32e8e9c572d6bf$export$9175ce0e1c95daf2 = 10000; // 10 seconds


const $bd4c4b9d0892ef41$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        "OK"
    ],
    [
        400,
        "Bad Request"
    ],
    [
        401,
        "Unauthorized"
    ],
    [
        402,
        "Payment Required"
    ],
    [
        403,
        "Forbidden"
    ],
    [
        404,
        "Not Found"
    ],
    [
        405,
        "Method Not Allowed"
    ],
    [
        406,
        "Not Acceptable"
    ],
    [
        407,
        "Proxy Authentication Required"
    ],
    [
        408,
        "Request Timeout"
    ],
    [
        409,
        "Conflict"
    ],
    [
        410,
        "Gone"
    ],
    [
        411,
        "Length Required"
    ],
    [
        412,
        "Precondition Failed"
    ],
    [
        413,
        "Payload Too Large"
    ],
    [
        414,
        "URI Too Long"
    ],
    [
        415,
        "Unsupported Media Type"
    ],
    [
        416,
        "Requested range not satisfiable"
    ],
    [
        417,
        "Expectation Failed"
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        "Unprocessable Entity"
    ],
    [
        423,
        "Locked"
    ],
    [
        424,
        "Failed Dependency"
    ],
    [
        425,
        "Too Early"
    ],
    [
        426,
        "Upgrade Required"
    ],
    [
        428,
        "Precondition Required"
    ],
    [
        429,
        "Too Many Requests"
    ],
    [
        431,
        "Request Header Fields Too Large"
    ],
    [
        451,
        "Unavailable For Legal Reasons"
    ],
    [
        500,
        "Internal Server Error"
    ],
    [
        501,
        "Not Implemented"
    ],
    [
        502,
        "Bad Gateway"
    ],
    [
        503,
        "Service Unavailable"
    ],
    [
        504,
        "Gateway Timeout"
    ],
    [
        505,
        "HTTP Version not supported"
    ],
    [
        506,
        "Variant Also Negotiates"
    ],
    [
        507,
        "Insufficient Storage"
    ],
    [
        508,
        "Loop Detected"
    ],
    [
        509,
        "Bandwidth Limit Exceeded"
    ],
    [
        510,
        "Not Extended"
    ],
    [
        511,
        "Network Authentication Required"
    ],
    [
        -1,
        "Unknown Status"
    ]
]);



var $g5Zhu = parcelRequire("g5Zhu");

function $021006432f28d29c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $021006432f28d29c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $021006432f28d29c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $021006432f28d29c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $021006432f28d29c$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $021006432f28d29c$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $021006432f28d29c$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $021006432f28d29c$var$_objectSpread({
        method: "POST",
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            "Content-Type": "text/plain"
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $021006432f28d29c$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $021006432f28d29c$var$getCorsForUrl = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});





var $GtgEQ = parcelRequire("GtgEQ");
let $3df1809383e5ee70$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $3df1809383e5ee70$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $3df1809383e5ee70$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === "https:";
    } catch (err) {
        return false;
    }
};
const $3df1809383e5ee70$export$d4cb17942ea57c95 = {
    [$3df1809383e5ee70$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $3df1809383e5ee70$var$CookieSchema("__awc_tld_test__", {
        expires: 365,
        secure: $3df1809383e5ee70$var$isSecure(),
        path: "/"
    }),
    [$3df1809383e5ee70$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $3df1809383e5ee70$var$CookieSchema("atlassian_analytics_debug", {
        expires: 365,
        secure: $3df1809383e5ee70$var$isSecure(),
        path: "/"
    }),
    [$3df1809383e5ee70$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $3df1809383e5ee70$var$CookieSchema("ajs_anonymous_id", {
        expires: 365,
        secure: $3df1809383e5ee70$var$isSecure(),
        path: "/"
    })
};


var $g5Zhu = parcelRequire("g5Zhu");



var $g5Zhu = parcelRequire("g5Zhu");
class $383151df190ac505$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$383151df190ac505$export$2e2bcd8739ae039 = new $383151df190ac505$export$90e3e001bcac59c7();



var $g5Zhu = parcelRequire("g5Zhu");


const $4074d312a405a485$export$41c06fdd37b7e9a5 = "awc";
const $4074d312a405a485$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
function $4074d312a405a485$export$48c17662a6902497(store) {
    const TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        const key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $4074d312a405a485$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $4074d312a405a485$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($4074d312a405a485$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $383151df190ac505$export$2e2bcd8739ae039) || typeof window === "undefined") return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($4074d312a405a485$export$48c17662a6902497(window[$4074d312a405a485$export$770aa8bc07b3de03])) inMemoryStorage = window[$4074d312a405a485$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $383151df190ac505$export$2e2bcd8739ae039);
                if (!window[$4074d312a405a485$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$4074d312a405a485$export$770aa8bc07b3de03] = (0, $383151df190ac505$export$2e2bcd8739ae039);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($4074d312a405a485$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join("-");
        if ($4074d312a405a485$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}


class $65222c5d1768af9b$export$2e2bcd8739ae039 extends (0, $4074d312a405a485$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $383151df190ac505$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $383151df190ac505$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}


class $cebe652a6d772f96$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $65222c5d1768af9b$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}





const $fe7b3b393a32285a$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
const $fe7b3b393a32285a$export$eb80e1beaa8dacf8 = (0, $3df1809383e5ee70$export$d4cb17942ea57c95).AWC_TLD_TEST.getKey();
const $fe7b3b393a32285a$export$19164982d36535d8 = "tld_test";
const $fe7b3b393a32285a$export$de6821eed3d5f32d = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(()=>{
    if (typeof location === "undefined") return "";
    const { hostname: hostname } = location;
    const splitHostname = hostname.split(".");
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join(".")}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).set($fe7b3b393a32285a$export$eb80e1beaa8dacf8, $fe7b3b393a32285a$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).get($fe7b3b393a32285a$export$eb80e1beaa8dacf8) === $fe7b3b393a32285a$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).remove($fe7b3b393a32285a$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});


function $57832590e025d13a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $57832590e025d13a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $57832590e025d13a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $57832590e025d13a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $57832590e025d13a$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $fe7b3b393a32285a$export$a9330601ee8f4d95)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))) : new (0, $cebe652a6d772f96$export$2e2bcd8739ae039)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $3df1809383e5ee70$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $3df1809383e5ee70$export$d4cb17942ea57c95)[name].getKey(), value, $57832590e025d13a$var$_objectSpread($57832590e025d13a$var$_objectSpread({}, (0, $3df1809383e5ee70$export$d4cb17942ea57c95)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $fe7b3b393a32285a$export$de6821eed3d5f32d)()
        }, options));
    }
    get(name) {
        if (!(0, $3df1809383e5ee70$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $3df1809383e5ee70$export$d4cb17942ea57c95)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $3df1809383e5ee70$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $3df1809383e5ee70$export$d4cb17942ea57c95)[name].getKey(), $57832590e025d13a$var$_objectSpread({}, options));
    }
}



// Cookie is stale, if anonymousId was generated 7 days ago.
const $2a378cf6f594961c$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $2a378cf6f594961c$var$SAFE = "SAFE";
const $2a378cf6f594961c$var$UNSAFE = "UNSAFE";
const $2a378cf6f594961c$var$NOT_FOUND = "NOT_FOUND";
const $2a378cf6f594961c$var$COOKIE = "COOKIE";
const $2a378cf6f594961c$var$LOCAL_STORAGE = "LOCAL_STORAGE";
class $2a378cf6f594961c$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $65222c5d1768af9b$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $57832590e025d13a$export$2e2bcd8739ae039)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $3df1809383e5ee70$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $3df1809383e5ee70$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $2a378cf6f594961c$var$LOCAL_STORAGE ? this.store.getItem((0, $3df1809383e5ee70$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $3df1809383e5ee70$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $2a378cf6f594961c$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === "string") return {
                    type: $2a378cf6f594961c$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $2a378cf6f594961c$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($2a378cf6f594961c$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $5e650688c0910592$export$2e2bcd8739ae039)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $2a378cf6f594961c$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $2a378cf6f594961c$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $2a378cf6f594961c$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $2a378cf6f594961c$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($2a378cf6f594961c$var$COOKIE);
        switch(cookieValue.type){
            case $2a378cf6f594961c$var$SAFE:
            case $2a378cf6f594961c$var$UNSAFE:
                this.store.setItem((0, $3df1809383e5ee70$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $2a378cf6f594961c$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}



var $g5Zhu = parcelRequire("g5Zhu");

function $a312149463902085$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a312149463902085$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a312149463902085$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a312149463902085$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a312149463902085$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $a312149463902085$var$_objectSpread($a312149463902085$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $a312149463902085$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $a312149463902085$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c168b02aa2d0b720$exports)))(propertiesWithoutUndefined);
};
const $a312149463902085$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== "object") return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $a312149463902085$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$a312149463902085$export$2250ccecd1e040fd(i));
            else if (typeof value === "object" && value !== null) clone[key] = $a312149463902085$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $a312149463902085$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};


function $a6af15877d886508$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a6af15877d886508$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a6af15877d886508$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a6af15877d886508$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $a6af15877d886508$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports;
    }
}
class $a6af15877d886508$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $a6af15877d886508$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $a6af15877d886508$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $a6af15877d886508$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $a6af15877d886508$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $a6af15877d886508$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $a6af15877d886508$var$_objectSpread($a6af15877d886508$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            const localResponseCallback = this.responseCallback;
            try {
                const response = await (0, $021006432f28d29c$export$8e8f0180c1b41fad)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                if (localResponseCallback !== null && response !== null) {
                    const analyticsAPIResponse = await response.clone().json();
                    const analyticsResponse = $a6af15877d886508$var$BatchInterceptor.toAnalyticsResponse(items, null, analyticsAPIResponse);
                    localResponseCallback(analyticsResponse);
                }
            } catch (error) {
                callback(error, null);
                if (localResponseCallback !== null && error !== null) {
                    const analyticsResponse = $a6af15877d886508$var$BatchInterceptor.toAnalyticsResponse(items, error, null);
                    localResponseCallback(analyticsResponse);
                }
            }
        });
        this.options = $a6af15877d886508$var$_objectSpread($a6af15877d886508$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $dc32e8e9c572d6bf$export$9175ce0e1c95daf2),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $2a378cf6f594961c$export$2e2bcd8739ae039)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $f828bb60d1dd5079$export$2e2bcd8739ae039)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $4730c7d5973c7c48$export$2e2bcd8739ae039)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $3e6544d6c45ea475$export$ddf929981dc6feb3).TRACK, builtEvent);
        const eventWithoutMessageId = $a6af15877d886508$var$_objectSpread($a6af15877d886508$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $3e6544d6c45ea475$export$ddf929981dc6feb3).TRACK,
            properties: (0, $a312149463902085$export$44d22e5fb02cc68e)(builtEvent),
            event: eventName
        });
        const event = $a6af15877d886508$var$_objectSpread($a6af15877d886508$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $3e6544d6c45ea475$export$ddf929981dc6feb3).PAGE, builtEvent);
        const eventWithoutMessageId = $a6af15877d886508$var$_objectSpread($a6af15877d886508$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $3e6544d6c45ea475$export$ddf929981dc6feb3).PAGE,
            properties: (0, $a312149463902085$export$44d22e5fb02cc68e)(builtEvent),
            name: eventName
        });
        const event = $a6af15877d886508$var$_objectSpread($a6af15877d886508$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $3e6544d6c45ea475$export$ddf929981dc6feb3).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $a6af15877d886508$var$_objectSpread($a6af15877d886508$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $3e6544d6c45ea475$export$ddf929981dc6feb3).IDENTIFY,
            traits: (0, $a312149463902085$export$44d22e5fb02cc68e)(builtEvent)
        });
        const event = $a6af15877d886508$var$_objectSpread($a6af15877d886508$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $a312149463902085$export$44d22e5fb02cc68e)(context);
        const segmentContext = (0, $a312149463902085$export$3a7fe28f9bf4f3d9)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                "Content-Type": "text/plain"
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $5d76724be5d06767$export$c21270cab66ab290)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
}
class $a6af15877d886508$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $a6af15877d886508$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $a6af15877d886508$export$133650fcdde1b226(success, statusCode, (0, $bd4c4b9d0892ef41$export$ba118f9de1e5ac63).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $bd4c4b9d0892ef41$export$ba118f9de1e5ac63).has(statusCode) ? (0, $bd4c4b9d0892ef41$export$ba118f9de1e5ac63).get(statusCode) : (0, $bd4c4b9d0892ef41$export$ba118f9de1e5ac63).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $a6af15877d886508$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $a6af15877d886508$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error.message !== null) {
            const match = error.message.match($a6af15877d886508$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $a6af15877d886508$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $a6af15877d886508$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $a6af15877d886508$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $a6af15877d886508$export$133650fcdde1b226(false, -1, (0, $bd4c4b9d0892ef41$export$ba118f9de1e5ac63).get(-1), eventResponseList);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($a6af15877d886508$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);



var $g5Zhu = parcelRequire("g5Zhu");



const $69781af6494e202b$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, "", newUrl);
const $69781af6494e202b$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $69781af6494e202b$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    const { url: url, query: query } = (0, $3ecb7368762fc268$export$7a5253c0f62e0150)(removedFragmentURL);
    const captureParams = (0, $eeeffb0732c0b2cc$export$b460b275d6c6aa0)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $eeeffb0732c0b2cc$export$d7a617dda645b4e3)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $3ecb7368762fc268$export$fac44ee5b035f737)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $69781af6494e202b$export$2e2bcd8739ae039 = $69781af6494e202b$var$urlParamExtractor;


class $9e4ec09c337ed506$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $93f5d16c7f116a6e$export$62a500c02dc63ee)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $69781af6494e202b$export$2e2bcd8739ae039)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}




const $0a2735b96043898c$var$PROD_HOST = "as.atlassian.com/api/v1";
const $0a2735b96043898c$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
const $0a2735b96043898c$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
const $0a2735b96043898c$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
const $0a2735b96043898c$var$FEDRAMP_STAGING_HOST = "as.staging.atl-paas-us-gov-mod.net/api/v1";
const $0a2735b96043898c$var$FEDRAMP_PROD_HOST = "as.atlassian-us-gov-mod.com/api/v1";
const $0a2735b96043898c$var$STARGATE_FEDRAMP_STAGING_HOST = "api.stg.atlassian-us-gov-mod.com/gasv3/api/v1";
const $0a2735b96043898c$var$STARGATE_FEDRAMP_PROD_HOST = "api.atlassian-us-gov-mod.com/gasv3/api/v1";
const $0a2735b96043898c$var$STARGATE_PROXY_PATH = "/gateway/api/gasv3/api/v1";
const $0a2735b96043898c$var$handleFedRampStagingDirect = ()=>{
    return $0a2735b96043898c$var$FEDRAMP_STAGING_HOST;
};
const $0a2735b96043898c$var$handleFedRampStagingStargate = ()=>{
    return $0a2735b96043898c$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $0a2735b96043898c$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).LOCAL || env === (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).DEV) throw Error("No LOCAL or DEV environments for FedRAMP.");
    if (env === (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).PROD && envOverride) throw Error("Cannot override to FedRAMP Sandbox for Prod.");
    if (!useStargate) return env === (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).PROD ? $0a2735b96043898c$var$FEDRAMP_PROD_HOST : $0a2735b96043898c$var$handleFedRampStagingDirect();
    if (useLegacyUrl) return env === (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).PROD ? $0a2735b96043898c$var$STARGATE_FEDRAMP_PROD_HOST : $0a2735b96043898c$var$handleFedRampStagingStargate();
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $0a2735b96043898c$var$STARGATE_PROXY_PATH;
};
const $0a2735b96043898c$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).PROD ? $0a2735b96043898c$var$PROD_HOST : $0a2735b96043898c$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).PROD ? $0a2735b96043898c$var$STARGATE_PROD_HOST : $0a2735b96043898c$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $0a2735b96043898c$var$STARGATE_PROXY_PATH;
};
function $0a2735b96043898c$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $93f5d16c7f116a6e$export$bdd41749d2096e4b).FEDRAMP_MODERATE) return $0a2735b96043898c$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $0a2735b96043898c$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}



var $g5Zhu = parcelRequire("g5Zhu");

const $0361be74d9e52b5c$var$SESSION_ID_STORAGE_KEY = "session.id";
const $0361be74d9e52b5c$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
const $0361be74d9e52b5c$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $0361be74d9e52b5c$export$285f6bddd927a06d = 1800000; // 30 minutes
const $0361be74d9e52b5c$export$a92e915d70316eb2 = 5000; // 5 seconds
const $0361be74d9e52b5c$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $0361be74d9e52b5c$export$5702a91a6f42969f = ()=>{};
class $0361be74d9e52b5c$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($0361be74d9e52b5c$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($0361be74d9e52b5c$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $0361be74d9e52b5c$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $0361be74d9e52b5c$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $0361be74d9e52b5c$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $0361be74d9e52b5c$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $65222c5d1768af9b$export$2e2bcd8739ae039)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($0361be74d9e52b5c$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($0361be74d9e52b5c$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$0361be74d9e52b5c$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}




class $a3fa09f12030bc7e$export$2e2bcd8739ae039 extends (0, $4074d312a405a485$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $383151df190ac505$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $383151df190ac505$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}



var $g5Zhu = parcelRequire("g5Zhu");

var $GtgEQ = parcelRequire("GtgEQ");

const $7144de85f1bec12e$var$STORAGE_KEY = "tab.id";
class $7144de85f1bec12e$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))();
            this._safeSessionStorage.setItem($7144de85f1bec12e$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $a3fa09f12030bc7e$export$2e2bcd8739ae039)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($7144de85f1bec12e$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}



var $g5Zhu = parcelRequire("g5Zhu");


var $GtgEQ = parcelRequire("GtgEQ");




function $d6d62ee05f372628$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6d62ee05f372628$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6d62ee05f372628$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6d62ee05f372628$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d6d62ee05f372628$var$STORAGE_KEY = "taskSessions";
const $d6d62ee05f372628$var$INIT_KEY = "taskSessionsInit";
const $d6d62ee05f372628$var$AWC_PARAM_PREFIX = "awc.";
const $d6d62ee05f372628$var$TASK_SESSION_RELOAD_TIME = 3000;
class $d6d62ee05f372628$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($d6d62ee05f372628$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($d6d62ee05f372628$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($d6d62ee05f372628$var$INIT_KEY) || "0", 10) < currentTimestamp - $d6d62ee05f372628$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($d6d62ee05f372628$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($d6d62ee05f372628$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($d6d62ee05f372628$var$STORAGE_KEY) || "");
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($d6d62ee05f372628$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $3ecb7368762fc268$export$7a5253c0f62e0150)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $eeeffb0732c0b2cc$export$357523c63a2253b9)(currentState, includedTaskSessions) : (0, $eeeffb0732c0b2cc$export$30a06c8d3562193f)(currentState, Object.values((0, $93f5d16c7f116a6e$export$62a500c02dc63ee)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $d6d62ee05f372628$var$_objectSpread($d6d62ee05f372628$var$_objectSpread({}, (0, $eeeffb0732c0b2cc$export$781522908e4e76a1)(filteredTaskSessions, (_, taskSessionName)=>$d6d62ee05f372628$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $3ecb7368762fc268$export$fac44ee5b035f737)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $eeeffb0732c0b2cc$export$781522908e4e76a1)((0, $69781af6494e202b$export$2e2bcd8739ae039)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $a3fa09f12030bc7e$export$2e2bcd8739ae039)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($d6d62ee05f372628$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}



var $g5Zhu = parcelRequire("g5Zhu");


const $9e182246405b9a95$var$MAX_CACHE_SIZE = 100;
const $9e182246405b9a95$var$COOKIE_NAME = (0, $3df1809383e5ee70$export$d4cb17942ea57c95).AWC_ANALYTICS_DEBUG.getKey();
const $9e182246405b9a95$var$DEBUG_TAG = "synthetic";
const $9e182246405b9a95$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).get($9e182246405b9a95$var$COOKIE_NAME) || "false");
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).remove($9e182246405b9a95$var$COOKIE_NAME);
    }
    return false;
};
class $9e182246405b9a95$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_bind", ()=>{
            if (typeof window === "undefined" || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem("awc.ui.viewed.last.sent");
                        localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                        localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                        localStorage.removeItem("awc-local.ui.viewed.last.sent");
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_cache", (event)=>{
            if (typeof window === "undefined") return;
            if (window.testAnalytics.eventCache.length >= $9e182246405b9a95$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($9e182246405b9a95$var$DEBUG_TAG);
                else event.tags = [
                    $9e182246405b9a95$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $9e182246405b9a95$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $9e182246405b9a95$export$2e2bcd8739ae039 = $9e182246405b9a95$var$TestingCache;



var $gZU1N = parcelRequire("gZU1N");

var $g5Zhu = parcelRequire("g5Zhu");


const $c40c9189ef0a8969$var$_excluded = [
    "embeddedProduct"
];
function $c40c9189ef0a8969$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c40c9189ef0a8969$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c40c9189ef0a8969$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c40c9189ef0a8969$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c40c9189ef0a8969$var$DEFAULT_DELAY = 2000; // 2 seconds
const $c40c9189ef0a8969$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $c40c9189ef0a8969$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
class $c40c9189ef0a8969$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.addEventListener("focus", this._focusListener);
                window.addEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.removeEventListener("focus", this._focusListener);
                window.removeEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || "");
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $93f5d16c7f116a6e$export$496f06ac2a964da2).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$_getContext, $c40c9189ef0a8969$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: "ui",
                action: "viewed",
                actionSubject: "ui",
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $c40c9189ef0a8969$var$_objectSpread($c40c9189ef0a8969$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $c40c9189ef0a8969$var$_objectSpread($c40c9189ef0a8969$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!getContext) throw new Error("Missing getContext callback");
        if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $c40c9189ef0a8969$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $c40c9189ef0a8969$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $c40c9189ef0a8969$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $65222c5d1768af9b$export$2e2bcd8739ae039)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}



function $9c6b76a93de05f64$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return ()=>{
        callback(event);
    };
}


let $105be42185c2675e$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $105be42185c2675e$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});


const $29f9018694def459$export$545bcbd53afabfa3 = 5000;
const $29f9018694def459$export$af4087e36d63846 = ()=>[
        {
            type: (0, $105be42185c2675e$export$92ca0438bcb0d396).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $105be42185c2675e$export$92ca0438bcb0d396).UID,
            state: "TIMEOUT"
        }
    ];
const $29f9018694def459$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $105be42185c2675e$export$92ca0438bcb0d396).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $105be42185c2675e$export$92ca0438bcb0d396).UID,
            state: "UNKNOWN"
        }
    ];


const $331c5818a5efd702$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $29f9018694def459$export$af4087e36d63846)()), (0, $29f9018694def459$export$545bcbd53afabfa3));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $29f9018694def459$export$fa341d0c750d705b)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};


function $f6b375407f598b9c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f6b375407f598b9c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f6b375407f598b9c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f6b375407f598b9c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f6b375407f598b9c$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
const $f6b375407f598b9c$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
class $f6b375407f598b9c$export$48361b6ed38f1b0 {
    static callback(response) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) {
            if (response.getEventResponseList().length === 0) // eslint-disable-next-line no-console
            console.debug("Event(s) submitted to GASv3");
            else response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn("Validation report for event with message ID %s:\n", eventResponse.getMessageId(), eventResponse);
            });
        } else if (statusCode === 400 || statusCode === 404) {
            // eslint-disable-next-line no-console
            console.warn("GASv3 submission failed with HTTP Status Code %d: %s", response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn("Event with message ID %s:\n", eventResponse.getMessageId(), eventResponse);
            });
        } else {
            // eslint-disable-next-line no-console
            console.info("GASv3 submission failed with HTTP Status Code %d: %s", response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.debug("Event with message ID %s:\n", eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $f6b375407f598b9c$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_createSubproductGetter", (subproduct)=>(0, $b10ccdef2d007477$export$2e2bcd8739ae039)(subproduct, "Cannot get subproduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $b10ccdef2d007477$export$2e2bcd8739ae039)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($f6b375407f598b9c$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
            } catch (err) {
                this._safeSessionStorage.removeItem($f6b375407f598b9c$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($f6b375407f598b9c$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $93f5d16c7f116a6e$export$4c045e605d532c98).UI:
                case (0, $93f5d16c7f116a6e$export$4c045e605d532c98).OPERATIONAL:
                case (0, $93f5d16c7f116a6e$export$4c045e605d532c98).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $93f5d16c7f116a6e$export$4c045e605d532c98).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $93f5d16c7f116a6e$export$4c045e605d532c98).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    "sentWithDelay"
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: "landed",
                actionSubject: "origin",
                source: "webClient",
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error("Missing tenantIdType");
            if (tenantIdType !== (0, $93f5d16c7f116a6e$export$496f06ac2a964da2).NONE && !tenantId) throw new Error("Missing tenantId");
            if (!(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$496f06ac2a964da2), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $93f5d16c7f116a6e$export$ad1854f4a08c15f8)((0, $93f5d16c7f116a6e$export$496f06ac2a964da2))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error("Missing orgId");
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error("Missing workspaceId");
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $4f3c6709bd72259b$export$c16a4e16aa4026c0)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error("Missing aliasType");
            if (!(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$a8c99e46b781d936), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $93f5d16c7f116a6e$export$ad1854f4a08c15f8)((0, $93f5d16c7f116a6e$export$a8c99e46b781d936))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error("Missing groupType");
            if (!(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$e73680b18d9b7c6e), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $93f5d16c7f116a6e$export$ad1854f4a08c15f8)((0, $93f5d16c7f116a6e$export$e73680b18d9b7c6e))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
            if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
            this._uiViewedAttributes = $f6b375407f598b9c$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $93f5d16c7f116a6e$export$4c045e605d532c98).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === "object") {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $4f3c6709bd72259b$export$dc993432a592dc27)(screenName);
            (0, $4f3c6709bd72259b$export$e63ea5d8477971d3)(screenContainers);
            const builtEvent = (0, $df9e9ae13d4a866e$export$c7d9a5f56acc4b19)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $f6b375407f598b9c$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $9c6b76a93de05f64$export$2e2bcd8739ae039)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $4f3c6709bd72259b$export$8c014fd74b0c8b99)(event);
            const builtEvent = (0, $df9e9ae13d4a866e$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $93f5d16c7f116a6e$export$4c045e605d532c98).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $df9e9ae13d4a866e$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $9c6b76a93de05f64$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendUIEvent", (event, callback)=>{
            (0, $4f3c6709bd72259b$export$e5bac0930c812e90)(event);
            const builtEvent = (0, $df9e9ae13d4a866e$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $93f5d16c7f116a6e$export$4c045e605d532c98).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $df9e9ae13d4a866e$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $9c6b76a93de05f64$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $4f3c6709bd72259b$export$1e561554275607ef)(event);
            const builtEvent = (0, $df9e9ae13d4a866e$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $93f5d16c7f116a6e$export$4c045e605d532c98).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $df9e9ae13d4a866e$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $9c6b76a93de05f64$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $c40c9189ef0a8969$export$2e2bcd8739ae039)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error("Missing analyticsData");
            if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
            if (analyticsData.eventType === (0, $93f5d16c7f116a6e$export$4c045e605d532c98).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $93f5d16c7f116a6e$export$4c045e605d532c98).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $93f5d16c7f116a6e$export$4c045e605d532c98).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $93f5d16c7f116a6e$export$4c045e605d532c98).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $93f5d16c7f116a6e$export$4c045e605d532c98).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $93f5d16c7f116a6e$export$ad1854f4a08c15f8)((0, $93f5d16c7f116a6e$export$4c045e605d532c98))}]`);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "setResponseCallback", (responseCallback)=>{
            this.eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.env) throw new Error("Missing productInfo.env");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $93f5d16c7f116a6e$export$ad1854f4a08c15f8)((0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9))}]`);
        if (productInfo.perimeter && !(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$bdd41749d2096e4b), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $93f5d16c7f116a6e$export$ad1854f4a08c15f8)((0, $93f5d16c7f116a6e$export$bdd41749d2096e4b))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $93f5d16c7f116a6e$export$f73e9fcd368bb695).WEB;
        else if (!(0, $93f5d16c7f116a6e$export$26b9f946b448f23e)((0, $93f5d16c7f116a6e$export$f73e9fcd368bb695), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $93f5d16c7f116a6e$export$ad1854f4a08c15f8)((0, $93f5d16c7f116a6e$export$f73e9fcd368bb695))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $93f5d16c7f116a6e$export$f73e9fcd368bb695).WEB ? (0, $93f5d16c7f116a6e$export$6b4f396210e539f3).WEB : (0, $93f5d16c7f116a6e$export$6b4f396210e539f3).DESKTOP;
        else (0, $4f3c6709bd72259b$export$801b46c35394d316)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $f6b375407f598b9c$var$_objectSpread($f6b375407f598b9c$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $0a7986df04cf3b8c$export$f56713ced121eb91)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext["embeddedType"],
                embeddedFromProduct: this._embeddedContext["embeddedFromProduct"],
                embeddedFromSubproduct: this._embeddedContext["embeddedFromSubproduct"],
                embeddedFromTopLevelDomain: this._embeddedContext["embeddedFromTopLevelDomain"]
            });
            if ((0, $0a7986df04cf3b8c$export$ab34f90cc32c8960)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext["embeddedType"],
                embeddedFromTopLevelDomain: this._embeddedContext["embeddedFromTopLevelDomain"]
            });
        }
        this._context = (0, $df9e9ae13d4a866e$export$3a7fe28f9bf4f3d9)(this._productInfo);
        this._safeSessionStorage = new (0, $a3fa09f12030bc7e$export$2e2bcd8739ae039)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $0a2735b96043898c$export$18c0b81944902eae)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || "https";
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $331c5818a5efd702$export$fbe53bbbe682bcdd)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $a6af15877d886508$export$2e2bcd8739ae039)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $f6b375407f598b9c$export$48361b6ed38f1b0.callback
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $ddc9b6bbba94d5d4$export$2e2bcd8739ae039)();
        this._tabTracking = new (0, $7144de85f1bec12e$export$2e2bcd8739ae039)();
        this._sessionTracking = new (0, $0361be74d9e52b5c$export$2e2bcd8739ae039)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $d6d62ee05f372628$export$2e2bcd8739ae039)();
        this.originTracing = new (0, $9e4ec09c337ed506$export$2e2bcd8739ae039)();
        // Init Apdex
        this._apdexEvent = new (0, $b611e717ce85c573$export$2e2bcd8739ae039)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $69781af6494e202b$export$600dd5bf1b049f11);
        this.eventDelayQueue = new (0, $0442973d0ddb8572$export$2e2bcd8739ae039)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $9e182246405b9a95$export$2e2bcd8739ae039)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($GtgEQ)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
}



var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");


var $ltooA = parcelRequire("ltooA");
var $1406f121bd15a78d$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $1406f121bd15a78d$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $1406f121bd15a78d$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $1406f121bd15a78d$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $1406f121bd15a78d$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $1406f121bd15a78d$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    return CategoryStorageType;
}({});
var $1406f121bd15a78d$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $1406f121bd15a78d$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({}); /**
 * Common fields that are shared between the ConsentBanner and initializeControls
 */ 



var $fOd0O = parcelRequire("fOd0O");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $h1Oiy = parcelRequire("h1Oiy");


var $g5Zhu = parcelRequire("g5Zhu");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $ltooA = parcelRequire("ltooA");


function $ff5d4c9f4d091b21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff5d4c9f4d091b21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff5d4c9f4d091b21$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff5d4c9f4d091b21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ff5d4c9f4d091b21$var$LOG_PREFIX = "[browser-storage-controls]";
var $ff5d4c9f4d091b21$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    function Logger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Logger);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Logger, null, [
        {
            key: "info",
            value: function info(message, metadata) {
                console.log("".concat($ff5d4c9f4d091b21$var$LOG_PREFIX, ": ").concat(message), metadata ? JSON.stringify(metadata) : "");
            }
        },
        {
            key: "error",
            value: function error(message, metadata) {
                console.error("".concat($ff5d4c9f4d091b21$var$LOG_PREFIX, ": ").concat(message), metadata ? JSON.stringify(metadata) : "");
            }
        },
        {
            key: "errorWithOperationalEvent",
            value: function errorWithOperationalEvent(_ref) {
                var action = _ref.action, _ref$attributes = _ref.attributes, attributes = _ref$attributes === void 0 ? {} : _ref$attributes, message = _ref.message, metadata = _ref.metadata;
                try {
                    (0, $b6e163f711a9bb81$export$5bfe55348e7aebc1)({
                        action: action,
                        attributes: $ff5d4c9f4d091b21$var$_objectSpread({
                            error: message
                        }, attributes)
                    });
                } catch (e) {
                    this.error("Failed to send operational event on error: ".concat(action, ". ").concat(e.message || ""));
                }
                this.error(message, metadata ? JSON.stringify(metadata) : "");
            }
        },
        {
            key: "warn",
            value: function warn(message, metadata) {
                console.warn("".concat($ff5d4c9f4d091b21$var$LOG_PREFIX, ": ").concat(message), metadata ? JSON.stringify(metadata) : "");
            }
        },
        {
            key: "debug",
            value: function debug(message, metadata) {
                if ((0, $4f1116441453b565$export$3b78a1ea01f5ec28)().packageDebugMode && (0, $ltooA.fg)("platform_moonjelly_bsc_debug_mode")) console.debug("".concat($ff5d4c9f4d091b21$var$LOG_PREFIX, ": DEBUG ").concat(message), metadata ? JSON.stringify(metadata) : "");
            }
        }
    ]);
}();


var $7a3ad9d8b42780e8$export$194c34963e6f0bc6 = "https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json";
var $7a3ad9d8b42780e8$export$ab0619f627170401 = "https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json";
var $7a3ad9d8b42780e8$export$38bed9fd9923fef3 = "https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json";
var $7a3ad9d8b42780e8$export$4f73a4b5fdb7ed6c = "https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json";


var $d343dc0fd031e3dc$export$e479342c697b82a9 = /*#__PURE__*/ function() {
    /**
   * Cache variable for storing categorized cookies cache
   */ /**
   * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
   *
   * Allows for many invocations to happen simultaneously, and for only one fetch to go out
   */ /**
   * Cache variable for storing the promise returned from the response object's json method
   *
   * Ensures we don't invoke response.json multiple times
   */ function CacheLoader(storageType) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CacheLoader);
        switch(storageType){
            case (0, $1406f121bd15a78d$export$2506b012eb637f61).Cookies:
                this.cacheUrl = (0, $7a3ad9d8b42780e8$export$ab0619f627170401);
                break;
            case (0, $1406f121bd15a78d$export$2506b012eb637f61).LocalStorage:
                this.cacheUrl = (0, $7a3ad9d8b42780e8$export$38bed9fd9923fef3);
                break;
            case (0, $1406f121bd15a78d$export$2506b012eb637f61).SessionStorage:
                this.cacheUrl = (0, $7a3ad9d8b42780e8$export$4f73a4b5fdb7ed6c);
                break;
            default:
                this.cacheUrl = (0, $7a3ad9d8b42780e8$export$194c34963e6f0bc6);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CacheLoader, [
        {
            key: "clearStorageControlsDataCache",
            value: function clearStorageControlsDataCache() {
                this.localResponseCache = undefined;
                this.localResponsePromiseCache = undefined;
                this.localResponseJsonPromiseCache = undefined;
            }
        },
        {
            key: "handleCategoriesResponse",
            value: function() {
                var _handleCategoriesResponse = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(responsePromise) {
                    var response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (responsePromise) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new Error("Failed to fetch Cookies Cache! Cached promise was undefined");
                            case 2:
                                _context.next = 4;
                                return responsePromise;
                            case 4:
                                response = _context.sent;
                                if (response.ok) {
                                    _context.next = 7;
                                    break;
                                }
                                throw new Error("Failed to fetch Cookies Cache! status: ".concat(response.status));
                            case 7:
                                // Checks if we've already fired the response.json() promise
                                this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
                                return _context.abrupt("return", this.localResponseJsonPromiseCache);
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function handleCategoriesResponse(_x) {
                    return _handleCategoriesResponse.apply(this, arguments);
                }
                return handleCategoriesResponse;
            }()
        },
        {
            key: "loadStorageControlsData",
            value: function() {
                var _loadStorageControlsData = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!this.localResponseCache) {
                                    _context2.next = 4;
                                    break;
                                }
                                return _context2.abrupt("return", this.localResponseCache);
                            case 4:
                                _context2.prev = 4;
                                if (!this.localResponsePromiseCache) {
                                    (0, $ff5d4c9f4d091b21$export$efa9a398d6368992).debug("Loading cache ".concat(this.cacheUrl));
                                    // invoke CDN and cache the promise
                                    this.localResponsePromiseCache = fetch(this.cacheUrl);
                                }
                                // unpack response
                                _context2.next = 8;
                                return this.handleCategoriesResponse(this.localResponsePromiseCache);
                            case 8:
                                this.localResponseCache = _context2.sent;
                                return _context2.abrupt("return", this.localResponseCache);
                            case 12:
                                _context2.prev = 12;
                                _context2.t0 = _context2["catch"](4);
                                (0, $ff5d4c9f4d091b21$export$efa9a398d6368992).errorWithOperationalEvent({
                                    action: "loadStorageControlsError",
                                    message: _context2.t0.message || ""
                                });
                                this.clearStorageControlsDataCache();
                            case 16:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            4,
                            12
                        ]
                    ]);
                }));
                function loadStorageControlsData() {
                    return _loadStorageControlsData.apply(this, arguments);
                }
                return loadStorageControlsData;
            }()
        }
    ]);
}();



var $4f1116441453b565$var$analyticsEnabledGlobalState;
var $4f1116441453b565$var$productGlobalState;
var $4f1116441453b565$var$webStorageControlsEnabledGlobalState;
var $4f1116441453b565$var$localConsentModeGlobalState;
var $4f1116441453b565$var$packageDebugModeEnabledGlobalState;
var $4f1116441453b565$var$allowUncategorizedCookiesInOverridesGlobalState;
var $4f1116441453b565$var$hasInitialized = false;
var $4f1116441453b565$var$cookiesCacheLoader;
var $4f1116441453b565$var$localStorageCacheLoader;
var $4f1116441453b565$var$sessionStorageCacheLoader;
var $4f1116441453b565$var$loadCache = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee(storageType) {
        var _cookiesCacheLoader, _localStorageCacheLoa, _sessionStorageCacheL;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.t0 = storageType;
                    _context.next = _context.t0 === (0, $1406f121bd15a78d$export$2506b012eb637f61).Cookies ? 3 : _context.t0 === (0, $1406f121bd15a78d$export$2506b012eb637f61).LocalStorage ? 6 : _context.t0 === (0, $1406f121bd15a78d$export$2506b012eb637f61).SessionStorage ? 9 : 12;
                    break;
                case 3:
                    _context.next = 5;
                    return (_cookiesCacheLoader = $4f1116441453b565$var$cookiesCacheLoader) === null || _cookiesCacheLoader === void 0 ? void 0 : _cookiesCacheLoader.loadStorageControlsData();
                case 5:
                    return _context.abrupt("return", _context.sent);
                case 6:
                    _context.next = 8;
                    return (_localStorageCacheLoa = $4f1116441453b565$var$localStorageCacheLoader) === null || _localStorageCacheLoa === void 0 ? void 0 : _localStorageCacheLoa.loadStorageControlsData();
                case 8:
                    return _context.abrupt("return", _context.sent);
                case 9:
                    _context.next = 11;
                    return (_sessionStorageCacheL = $4f1116441453b565$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL === void 0 ? void 0 : _sessionStorageCacheL.loadStorageControlsData();
                case 11:
                    return _context.abrupt("return", _context.sent);
                case 12:
                    return _context.abrupt("return", undefined);
                case 13:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadCache(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $4f1116441453b565$export$3b78a1ea01f5ec28 = function getBscGlobalState() {
    var _analyticsEnabledGlob, _webStorageControlsEn, _localConsentModeGlob, _allowUncategorizedCo;
    return {
        analyticsEnabled: (_analyticsEnabledGlob = $4f1116441453b565$var$analyticsEnabledGlobalState) !== null && _analyticsEnabledGlob !== void 0 ? _analyticsEnabledGlob : true,
        product: $4f1116441453b565$var$productGlobalState,
        webStorageEnabled: (_webStorageControlsEn = $4f1116441453b565$var$webStorageControlsEnabledGlobalState) !== null && _webStorageControlsEn !== void 0 ? _webStorageControlsEn : false,
        localConsentMode: (_localConsentModeGlob = $4f1116441453b565$var$localConsentModeGlobalState) !== null && _localConsentModeGlob !== void 0 ? _localConsentModeGlob : false,
        packageDebugMode: $4f1116441453b565$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: (_allowUncategorizedCo = $4f1116441453b565$var$allowUncategorizedCookiesInOverridesGlobalState) !== null && _allowUncategorizedCo !== void 0 ? _allowUncategorizedCo : false,
        cookiesCacheLoader: $4f1116441453b565$var$cookiesCacheLoader,
        localStorageCacheLoader: $4f1116441453b565$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $4f1116441453b565$var$sessionStorageCacheLoader,
        loadCache: $4f1116441453b565$var$loadCache,
        hasInitialized: $4f1116441453b565$var$hasInitialized
    };
};
var $4f1116441453b565$export$882c4530c58781d8 = function initializeGlobalState() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, webStorageEnabled = _ref2.webStorageEnabled, allowUncategorizedCookiesInOverrides = _ref2.allowUncategorizedCookiesInOverrides, _ref2$localConsentMod = _ref2.localConsentMode, localConsentMode = _ref2$localConsentMod === void 0 ? false : _ref2$localConsentMod, _ref2$product = _ref2.product, product = _ref2$product === void 0 ? "all" : _ref2$product, _ref2$analyticsEnable = _ref2.analyticsEnabled, analyticsEnabled = _ref2$analyticsEnable === void 0 ? true : _ref2$analyticsEnable;
    (0, $ff5d4c9f4d091b21$export$efa9a398d6368992).debug("Initialize global state invoked");
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!$4f1116441453b565$var$productGlobalState || $4f1116441453b565$var$productGlobalState == null || $4f1116441453b565$var$productGlobalState === "all") && product) $4f1116441453b565$var$productGlobalState = product;
    // Treating webStorageEnabled and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    if (webStorageEnabled !== undefined && $4f1116441453b565$var$webStorageControlsEnabledGlobalState === undefined) $4f1116441453b565$var$webStorageControlsEnabledGlobalState = webStorageEnabled && !(0, $ltooA.fg)("platform_moonjelly_bsc_master_killswitch") && !(0, $ltooA.fg)("platform_moonjelly_bsc_web_storage_killswitch");
    if (allowUncategorizedCookiesInOverrides !== undefined && $4f1116441453b565$var$allowUncategorizedCookiesInOverridesGlobalState === undefined) $4f1116441453b565$var$allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
    // All other state can only be initialized once and is defaulted if not passed on the first initialization
    if ($4f1116441453b565$var$hasInitialized) return;
    $4f1116441453b565$var$localConsentModeGlobalState = localConsentMode;
    $4f1116441453b565$var$analyticsEnabledGlobalState = analyticsEnabled;
    $4f1116441453b565$var$cookiesCacheLoader = new (0, $d343dc0fd031e3dc$export$e479342c697b82a9)((0, $1406f121bd15a78d$export$2506b012eb637f61).Cookies);
    $4f1116441453b565$var$localStorageCacheLoader = new (0, $d343dc0fd031e3dc$export$e479342c697b82a9)((0, $1406f121bd15a78d$export$2506b012eb637f61).LocalStorage);
    $4f1116441453b565$var$sessionStorageCacheLoader = new (0, $d343dc0fd031e3dc$export$e479342c697b82a9)((0, $1406f121bd15a78d$export$2506b012eb637f61).SessionStorage);
    if ((0, $ltooA.fg)("platform_moonjelly_bsc_debug_mode")) $4f1116441453b565$var$packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).get("atl-bsc-debug-mode"));
    $4f1116441453b565$var$hasInitialized = true;
};
var $4f1116441453b565$export$f86e17381f699baf = function testing_overrideGlobalState(_ref3) {
    var overrideLoadCache = _ref3.loadCache, overrideProduct = _ref3.product;
    if (overrideLoadCache) $4f1116441453b565$var$loadCache = overrideLoadCache;
    if (overrideProduct) $4f1116441453b565$var$productGlobalState = overrideProduct;
};
var $4f1116441453b565$export$ac7c2edd09656c05 = function clearGlobalState() {
    $4f1116441453b565$var$analyticsEnabledGlobalState = undefined;
    $4f1116441453b565$var$productGlobalState = undefined;
    $4f1116441453b565$var$webStorageControlsEnabledGlobalState = undefined;
    $4f1116441453b565$var$localConsentModeGlobalState = undefined;
    $4f1116441453b565$var$packageDebugModeEnabledGlobalState = undefined;
    $4f1116441453b565$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $4f1116441453b565$var$cookiesCacheLoader = undefined;
    $4f1116441453b565$var$localStorageCacheLoader = undefined;
    $4f1116441453b565$var$sessionStorageCacheLoader = undefined;
    $4f1116441453b565$var$hasInitialized = false;
};




var $hPtJY = parcelRequire("hPtJY");
var $19cbbefc5a2b75ab$var$_ref, $19cbbefc5a2b75ab$var$_process, $19cbbefc5a2b75ab$var$_ref2, $19cbbefc5a2b75ab$var$_process2;
var $19cbbefc5a2b75ab$export$9345d7360ffe0722 = ($19cbbefc5a2b75ab$var$_ref = ($19cbbefc5a2b75ab$var$_process = $hPtJY) === null || $19cbbefc5a2b75ab$var$_process === void 0 ? void 0 : $19cbbefc5a2b75ab$var$_process.env._PACKAGE_NAME_) !== null && $19cbbefc5a2b75ab$var$_ref !== void 0 ? $19cbbefc5a2b75ab$var$_ref : "";
var $19cbbefc5a2b75ab$export$91546b032799aa40 = ($19cbbefc5a2b75ab$var$_ref2 = ($19cbbefc5a2b75ab$var$_process2 = $hPtJY) === null || $19cbbefc5a2b75ab$var$_process2 === void 0 ? void 0 : $19cbbefc5a2b75ab$var$_process2.env._PACKAGE_VERSION_) !== null && $19cbbefc5a2b75ab$var$_ref2 !== void 0 ? $19cbbefc5a2b75ab$var$_ref2 : "";



var $fOd0O = parcelRequire("fOd0O");

var $h1Oiy = parcelRequire("h1Oiy");



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");
var $a4cd0820ab02f2eb$export$b886edaf6623554a = /*#__PURE__*/ function() {
    function CachedSamplingConfig() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CachedSamplingConfig);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CachedSamplingConfig, [
        {
            key: "cachedSamplingConfig",
            get: function get() {
                return this.cache;
            },
            set: function set(value) {
                this.cache = value;
            }
        }
    ]);
}();


var $414edd8180672181$export$69a3209f1a06c04d = new (0, $a4cd0820ab02f2eb$export$b886edaf6623554a)();




var $ltooA = parcelRequire("ltooA");

var $f9e951ac267ae2fc$export$48d7c418edadb60c = function isSSR() {
    var isMissingNecessaryBrowserUtils = typeof document === "undefined" || typeof window === "undefined" || !Document || !Document.prototype || !Object || !Object.defineProperty;
    var isMissingBooleanFF = !(0, $ltooA.fg);
    var isMissingAnalyticsWebClient = !Boolean((0, $f6b375407f598b9c$export$2e2bcd8739ae039));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $ff5d4c9f4d091b21$export$efa9a398d6368992).warn("Browser context is not available.");
    if (isMissingBooleanFF) (0, $ff5d4c9f4d091b21$export$efa9a398d6368992).warn("Platform Feature Flag library is not available");
    if (!(0, $f6b375407f598b9c$export$2e2bcd8739ae039)) (0, $ff5d4c9f4d091b21$export$efa9a398d6368992).warn("analytics-web-client is not available");
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};


var $379a5517f5b374ae$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
var $379a5517f5b374ae$var$localOnlySamplingKeys = [
    "loadStorageControlsError"
];
function $379a5517f5b374ae$var$loadSamplingConfig() {
    return $379a5517f5b374ae$var$_loadSamplingConfig.apply(this, arguments);
}
function $379a5517f5b374ae$var$_loadSamplingConfig() {
    $379a5517f5b374ae$var$_loadSamplingConfig = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee() {
        var _getBscGlobalState, loadCache, controlsData, analyticsSamplingRatioConfigs;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $414edd8180672181$export$69a3209f1a06c04d).cachedSamplingConfig) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", (0, $414edd8180672181$export$69a3209f1a06c04d).cachedSamplingConfig);
                case 2:
                    if (!(0, $f9e951ac267ae2fc$export$48d7c418edadb60c)()) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return", undefined);
                case 4:
                    _getBscGlobalState = (0, $4f1116441453b565$export$3b78a1ea01f5ec28)(), loadCache = _getBscGlobalState.loadCache;
                    _context.next = 7;
                    return loadCache((0, $1406f121bd15a78d$export$2506b012eb637f61).Cookies);
                case 7:
                    controlsData = _context.sent;
                    analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
                    (0, $414edd8180672181$export$69a3209f1a06c04d).cachedSamplingConfig = analyticsSamplingRatioConfigs;
                    return _context.abrupt("return", analyticsSamplingRatioConfigs);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $379a5517f5b374ae$var$_loadSamplingConfig.apply(this, arguments);
}
function $379a5517f5b374ae$export$b286f5e8716d11ad(_x) {
    return $379a5517f5b374ae$var$_getAnalyticsSamplingRatio.apply(this, arguments);
}
function $379a5517f5b374ae$var$_getAnalyticsSamplingRatio() {
    $379a5517f5b374ae$var$_getAnalyticsSamplingRatio = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee2(analyticsEventKey) {
        var remoteSamplingConfig, samplingConfig, samplingRatio;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!$379a5517f5b374ae$var$localOnlySamplingKeys.includes(analyticsEventKey)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $379a5517f5b374ae$export$1138592b3c099377[analyticsEventKey]);
                case 2:
                    _context2.next = 4;
                    return $379a5517f5b374ae$var$loadSamplingConfig();
                case 4:
                    remoteSamplingConfig = _context2.sent;
                    samplingConfig = remoteSamplingConfig !== null && remoteSamplingConfig !== void 0 ? remoteSamplingConfig : $379a5517f5b374ae$export$1138592b3c099377;
                    samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : $379a5517f5b374ae$export$1138592b3c099377[analyticsEventKey];
                    return _context2.abrupt("return", samplingRatio);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $379a5517f5b374ae$var$_getAnalyticsSamplingRatio.apply(this, arguments);
}
function $379a5517f5b374ae$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ var shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
function $379a5517f5b374ae$export$67b6e87f323cb6ad(_x2, _x3) {
    return $379a5517f5b374ae$var$_withAnalyticsEventSampling.apply(this, arguments);
}
function $379a5517f5b374ae$var$_withAnalyticsEventSampling() {
    $379a5517f5b374ae$var$_withAnalyticsEventSampling = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).mark(function _callee3(analyticsEventKey, cb) {
        var ratio;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1Oiy))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $379a5517f5b374ae$export$b286f5e8716d11ad(analyticsEventKey);
                case 2:
                    ratio = _context3.sent;
                    $379a5517f5b374ae$export$dc2f0946255b3f89(ratio, cb);
                case 4:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $379a5517f5b374ae$var$_withAnalyticsEventSampling.apply(this, arguments);
}


function $b6e163f711a9bb81$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6e163f711a9bb81$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6e163f711a9bb81$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6e163f711a9bb81$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b6e163f711a9bb81$var$getEnvironment = function getEnvironment() {
    var hostname = window.location.hostname;
    if (hostname.includes(".dev.") || hostname.includes(".stg.")) return (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).STAGING;
    if (hostname.includes("localhost") || hostname.includes("ngrok") || hostname.includes("atlastunnel")) return (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).DEV;
    return (0, $93f5d16c7f116a6e$export$56ac8ebc9870b1b9).PROD;
};
var $b6e163f711a9bb81$export$78d7c0236b4fece9 = function getProductSubPath(path) {
    var subPath = "";
    if (!path) return subPath;
    var checkPath = function checkPath(match) {
        return new RegExp("^".concat(match, "(/|$)")).test(String(path));
    };
    if (checkPath("/wiki")) subPath = "/wiki";
    if (checkPath("/jira")) subPath = "/jira";
    if (checkPath("/compass")) subPath = "/compass";
    if (checkPath("/canvas")) subPath = "/canvas";
    if (checkPath("/servicedesk") || checkPath("/jira/servicedesk")) subPath = "/servicedesk";
    return subPath;
};
var $b6e163f711a9bb81$var$getProductFromDomain = function getProductFromDomain(domain) {
    if (domain === "https://trello.com") return "trello";
    return null;
};
var $b6e163f711a9bb81$export$fce3dd735e04d566 = function getContextualPageDetails() {
    var _window$location = window.location, origin = _window$location.origin, pathname = _window$location.pathname;
    var productPath = $b6e163f711a9bb81$export$78d7c0236b4fece9(pathname);
    var domain = "".concat(origin).concat(productPath);
    var product = $b6e163f711a9bb81$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
var $b6e163f711a9bb81$var$decorateEventAttributes = function decorateEventAttributes(attributes) {
    var _getBscGlobalState$pr, _getBscGlobalState$pr2;
    var _getContextualPageDet = $b6e163f711a9bb81$export$fce3dd735e04d566(), domain = _getContextualPageDet.domain, product = _getContextualPageDet.product;
    return $b6e163f711a9bb81$var$_objectSpread({
        packageName: (0, $19cbbefc5a2b75ab$export$9345d7360ffe0722),
        packageVersion: (0, $19cbbefc5a2b75ab$export$91546b032799aa40),
        domain: domain,
        product: (_getBscGlobalState$pr = (_getBscGlobalState$pr2 = (0, $4f1116441453b565$export$3b78a1ea01f5ec28)().product) === null || _getBscGlobalState$pr2 === void 0 ? void 0 : _getBscGlobalState$pr2.toLowerCase()) !== null && _getBscGlobalState$pr !== void 0 ? _getBscGlobalState$pr : product
    }, attributes && attributes);
};
var $b6e163f711a9bb81$export$fde53e78fd93a54d = function() {
    var instance;
    return function() {
        try {
            if (!instance && (0, $4f1116441453b565$export$3b78a1ea01f5ec28)().analyticsEnabled) instance = new (0, $f6b375407f598b9c$export$2e2bcd8739ae039)({
                env: $b6e163f711a9bb81$var$getEnvironment(),
                product: "atlassianCookies"
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $ff5d4c9f4d091b21$export$efa9a398d6368992).error("Failed to initialize AnalyticsWebClient. ".concat(e));
        }
        if (!(0, $4f1116441453b565$export$3b78a1ea01f5ec28)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
}();
function $b6e163f711a9bb81$export$5bfe55348e7aebc1(properties) {
    (0, $379a5517f5b374ae$export$67b6e87f323cb6ad)(properties.action, function() {
        var _getAnalyticsClient;
        return (_getAnalyticsClient = $b6e163f711a9bb81$export$fde53e78fd93a54d()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
            source: "package",
            actionSubject: "package",
            action: properties.action,
            attributes: $b6e163f711a9bb81$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $b6e163f711a9bb81$export$1aecf263098db667(properties) {
    var _getAnalyticsClient2;
    (_getAnalyticsClient2 = $b6e163f711a9bb81$export$fde53e78fd93a54d()) === null || _getAnalyticsClient2 === void 0 || _getAnalyticsClient2.sendUIEvent($b6e163f711a9bb81$var$_objectSpread($b6e163f711a9bb81$var$_objectSpread({}, properties), {}, {
        attributes: $b6e163f711a9bb81$var$decorateEventAttributes(properties.attributes)
    }));
}
function $b6e163f711a9bb81$export$22a3b1671f38a193(properties) {
    var _getAnalyticsClient3;
    (_getAnalyticsClient3 = $b6e163f711a9bb81$export$fde53e78fd93a54d()) === null || _getAnalyticsClient3 === void 0 || _getAnalyticsClient3.sendScreenEvent($b6e163f711a9bb81$var$_objectSpread($b6e163f711a9bb81$var$_objectSpread({}, properties), {}, {
        attributes: $b6e163f711a9bb81$var$decorateEventAttributes(properties.attributes)
    }));
}
function $b6e163f711a9bb81$export$1ba525b8a711eaac(properties) {
    var _getAnalyticsClient4;
    (_getAnalyticsClient4 = $b6e163f711a9bb81$export$fde53e78fd93a54d()) === null || _getAnalyticsClient4 === void 0 || _getAnalyticsClient4.sendTrackEvent($b6e163f711a9bb81$var$_objectSpread($b6e163f711a9bb81$var$_objectSpread({}, properties), {}, {
        attributes: $b6e163f711a9bb81$var$decorateEventAttributes(properties.attributes)
    }));
}



function $46f32ca09b5e6aaa$export$4be65e66cfa2648a(key) {
    if ((0, $ltooA.fg)("platform_moonjelly_bsc_master_killswitch")) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).get();
    try {
        (0, $b6e163f711a9bb81$export$5bfe55348e7aebc1)({
            action: "usedGetCookie",
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($1a835d1e20c64ab3$exports))).get();
    } catch (e) {
        (0, $ff5d4c9f4d091b21$export$efa9a398d6368992).errorWithOperationalEvent({
            action: "usedGetCookieError",
            attributes: {
                cookieKey: key
            },
            message: "Failed to use get cookie. ".concat(e.message || "")
        });
    }
}


const $7313551ab8168ced$export$f39f459ffe3b5b2 = "csrftoken";
const $7313551ab8168ced$export$7f697e417cb7a5a8 = "X-CSRFToken";
const $7313551ab8168ced$export$81350727a0ff4e2e = (url)=>/^(?!https?:)/.test(url) || url.indexOf(window.location.origin) === 0;
const $7313551ab8168ced$var$getRequestHeaders = (url, csrftoken)=>{
    const headers = {};
    // never send tokens cross-(sub)domain
    if ($7313551ab8168ced$export$81350727a0ff4e2e(url)) headers[$7313551ab8168ced$export$7f697e417cb7a5a8] = csrftoken;
    return headers;
};
function $7313551ab8168ced$export$2e2bcd8739ae039(url, options = {}, csrftoken = (0, $46f32ca09b5e6aaa$export$4be65e66cfa2648a)($7313551ab8168ced$export$f39f459ffe3b5b2) || "") {
    const headers = $7313551ab8168ced$var$getRequestHeaders(url, csrftoken);
    return new Request(url, {
        credentials: "same-origin",
        ...options,
        headers: {
            ...headers,
            ...options.headers || {}
        }
    });
}


var $c0c4b434f06c20d3$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3602017c9c0db571ac57dae4d1f426bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c0c4b434f06c20d3$exports, "__esModule", {
    value: true
});
$c0c4b434f06c20d3$exports.default = void 0;

var $c0c4b434f06c20d3$var$_react = $c0c4b434f06c20d3$var$_interopRequireDefault((parcelRequire("acw62")));

var $c0c4b434f06c20d3$var$_baseNew = $c0c4b434f06c20d3$var$_interopRequireDefault((parcelRequire("fqFky")));
function $c0c4b434f06c20d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0c4b434f06c20d3$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $c0c4b434f06c20d3$var$_react.default.createElement($c0c4b434f06c20d3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$c0c4b434f06c20d3$var$LinkExternalIcon.displayName = "LinkExternalIcon";
var $c0c4b434f06c20d3$var$_default = $c0c4b434f06c20d3$exports.default = $c0c4b434f06c20d3$var$LinkExternalIcon;


/* eslint-disable max-len */ 
var $acw62 = parcelRequire("acw62");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $g5Zhu = parcelRequire("g5Zhu");

var $cfuBi = parcelRequire("cfuBi");

var $5NceL = parcelRequire("5NceL");

function $36b73c8162883cdf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $36b73c8162883cdf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $36b73c8162883cdf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $36b73c8162883cdf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $36b73c8162883cdf$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $5NceL.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $36b73c8162883cdf$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $cfuBi.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $cfuBi.THEME_DATA_ATTRIBUTE)) || "";
    return $36b73c8162883cdf$var$_objectSpread($36b73c8162883cdf$var$_objectSpread({}, (0, $162ad34f339133e7$export$f19b488f7c0547ee)(theme)), $36b73c8162883cdf$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $36b73c8162883cdf$export$2e2bcd8739ae039 = $36b73c8162883cdf$var$getGlobalTheme;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $cfuBi = parcelRequire("cfuBi");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $f3671c88720a2a6f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $36b73c8162883cdf$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $cfuBi.THEME_DATA_ATTRIBUTE),
                            (0, $cfuBi.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($f3671c88720a2a6f$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($f3671c88720a2a6f$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $54e6b8023ffdb4d7$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $acw62.useState)((0, $36b73c8162883cdf$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $acw62.useEffect)(function() {
        var observer = new (0, $f3671c88720a2a6f$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $54e6b8023ffdb4d7$export$2e2bcd8739ae039 = $54e6b8023ffdb4d7$var$useThemeObserver;


/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $2aea3ad1109a7dfc$export$438460117ae6b7ee = {
    iconColor: "inherit",
    label: "",
    size: "medium",
    textColor: "currentColor"
};
var $2aea3ad1109a7dfc$export$793fba32aed8942a = {
    iconGradientStart: "inherit",
    iconGradientStop: "inherit"
};
var $2aea3ad1109a7dfc$export$31d7044b7540a6d8 = $2aea3ad1109a7dfc$export$438460117ae6b7ee;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $dnCk4 = parcelRequire("dnCk4");
var $5369016cc795bca6$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case "brand":
            iconGradientStart = (0, $dnCk4.B400);
            iconGradientStop = (0, $dnCk4.B200);
            iconColor = (0, $dnCk4.B200);
            textColor = "var(--ds-text, ".concat((0, $dnCk4.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $dnCk4.B400);
            break;
        case "neutral":
            iconGradientStart = (0, $dnCk4.N600);
            iconGradientStop = (0, $dnCk4.N100);
            iconColor = (0, $dnCk4.N100);
            textColor = (0, $dnCk4.N400);
            atlassianLogoTextColor = (0, $dnCk4.N400);
            break;
        case "inverse":
            iconGradientStart = "#FFFFFF66";
            iconGradientStop = "#FFFFFF";
            iconColor = "#FFFFFF";
            textColor = "#FFFFFF";
            atlassianLogoTextColor = "#FFFFFF";
            break;
    }
    if (colorMode === "dark" && appearance === "inverse") {
        iconGradientStart = "#161A1D66";
        iconGradientStop = "#161A1D";
        iconColor = "#161A1D";
        textColor = "#161A1D";
        atlassianLogoTextColor = "#161A1D";
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $5369016cc795bca6$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#357DE8";
            textColor = "#E2E3E4";
            atlassianLogoTextColor = "#357DE8";
            break;
        case "neutral":
            iconColor = "#96999E";
            textColor = "#BFC1C4";
            atlassianLogoTextColor = "#96999E";
            break;
        case "inverse":
            iconColor = "#101214";
            textColor = "#101214";
            atlassianLogoTextColor = "#101214";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#1868DB";
            textColor = "#101214";
            atlassianLogoTextColor = "#1868DB";
            break;
        case "neutral":
            iconColor = "#6C6F77";
            textColor = "#3B3D42";
            atlassianLogoTextColor = "#6C6F77";
            break;
        case "inverse":
            iconColor = (0, $dnCk4.N0);
            textColor = (0, $dnCk4.N0);
            atlassianLogoTextColor = (0, $dnCk4.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $5369016cc795bca6$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $5369016cc795bca6$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $5369016cc795bca6$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#EFF0FF";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#252434";
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};


/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $eb9e0e5fc14987df$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $eb9e0e5fc14987df$var$CSS_VAR_COLOR = "--logo-color";
var $eb9e0e5fc14987df$var$CSS_VAR_FILL = "--logo-fill";
var $eb9e0e5fc14987df$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xsmall: "_4t3i7vkz",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $eb9e0e5fc14987df$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $eb9e0e5fc14987df$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $acw62.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $eb9e0e5fc14987df$var$CSS_VAR_COLOR, iconColor), $eb9e0e5fc14987df$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $5zphJ.default)([
            $eb9e0e5fc14987df$var$styles.root,
            shouldApplyStopColor && $eb9e0e5fc14987df$var$styles.stop,
            size && $eb9e0e5fc14987df$var$styles[size]
        ])
    }));
};
var $eb9e0e5fc14987df$export$2e2bcd8739ae039 = $eb9e0e5fc14987df$var$Wrapper;


var $11e058f4355d4a2c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $5369016cc795bca6$export$bbacc3980e0f3029)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>\n    </svg>');
};
var $11e058f4355d4a2c$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2aea3ad1109a7dfc$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2aea3ad1109a7dfc$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2aea3ad1109a7dfc$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $54e6b8023ffdb4d7$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eb9e0e5fc14987df$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $11e058f4355d4a2c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};








const $80a046d009ef2432$var$overlayStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    mixBlendMode: "lighten",
    opacity: 0.6
});
const $80a046d009ef2432$export$cfb19d3a192c6fe2 = ()=>{
    const { colorMode: colorMode, light: light } = (0, $54e6b8023ffdb4d7$export$2e2bcd8739ae039)();
    const isLightMode = colorMode === light;
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "140",
        height: "24",
        viewBox: "0 0 140 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.0123 3.27288C12.3955 2.91395 11.6359 2.90911 11.0152 3.25836C11.0064 3.26485 10.9971 3.27094 10.9874 3.27658L10.9873 3.27663L10.986 3.27741C10.5867 3.51015 10.2848 3.8698 10.1189 4.28886C10.0268 4.52385 9.97754 4.77777 9.97754 5.03912V7.73475L13.3255 9.68348L13.3257 9.6836C14.1479 10.1605 14.6521 11.0421 14.6521 11.9981L14.6521 18.9571C14.6521 19.2693 14.5978 19.574 14.496 19.8594L18.9874 17.2439L18.9879 17.2436C19.6151 16.8799 19.9998 16.2078 19.9998 15.4776V8.51862C19.9998 7.79133 19.6128 7.11627 18.9875 6.75238L18.9874 6.75233L13.0123 3.27288Z",
                fill: isLightMode ? "#1868DB" : "#357DE8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0223 18.9609C14.0223 19.2226 13.9728 19.4768 13.8806 19.712C13.7144 20.1312 13.4121 20.4908 13.0125 20.7234L13.0124 20.7234C13.0027 20.7291 12.9934 20.7352 12.9846 20.7417C12.3639 21.0909 11.6044 21.0861 10.9876 20.7272L10.9875 20.7271L5.01241 17.2477L5.01232 17.2476C4.38699 16.8838 4 16.2087 4 15.4814L4 8.52239C4 7.79222 4.38472 7.12009 5.01191 6.75639L9.50381 4.14062C9.40202 4.426 9.34771 4.73069 9.34771 5.04289V12.0019C9.34771 12.9578 9.85176 13.8393 10.6739 14.3163L10.6743 14.3165L14.0223 16.2653V18.9609Z",
                fill: isLightMode ? "#1868DB" : "#357DE8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M139.367 15.4723C139.367 16.8003 138.503 17.8083 136.359 17.8083C135.159 17.8083 134.183 17.5363 133.575 17.2163V15.7603C134.263 16.1603 135.415 16.5443 136.423 16.5443C137.479 16.5443 138.023 16.1123 138.023 15.4883C138.023 14.8803 137.559 14.5283 136.039 14.1603C134.263 13.7283 133.511 13.0403 133.511 11.7283C133.511 10.3363 134.583 9.48828 136.407 9.48828C137.447 9.48828 138.391 9.74428 138.983 10.0643V11.4883C138.023 11.0083 137.239 10.7523 136.391 10.7523C135.383 10.7523 134.839 11.1043 134.839 11.7283C134.839 12.2883 135.223 12.6403 136.695 12.9923C138.471 13.4243 139.367 14.0803 139.367 15.4723Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M130.11 15.1681C130.11 15.8721 130.526 16.3521 131.374 16.3521C131.694 16.3521 131.998 16.2881 132.238 16.2401V17.5681C131.998 17.6321 131.726 17.6961 131.31 17.6961C129.598 17.6961 128.766 16.6881 128.766 15.2001V10.9281H127.47V9.64815H128.766V7.95215H130.11V9.64815H132.238V10.9281H130.11V15.1681Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M126.287 12.9603V17.6483H124.911V12.8163C124.911 11.3763 124.335 10.7363 123.023 10.7363C121.743 10.7363 120.863 11.5843 120.863 13.2003V17.6483H119.487V9.64828H120.863V10.9603C121.375 10.0163 122.319 9.48828 123.391 9.48828C125.231 9.48828 126.287 10.7523 126.287 12.9603Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M114.329 10.7363C112.873 10.7363 112.137 11.6803 111.993 13.0723H116.457C116.377 11.5843 115.705 10.7363 114.329 10.7363ZM117.401 17.3283C116.745 17.6803 115.737 17.8083 114.921 17.8083C111.929 17.8083 110.617 16.0803 110.617 13.6323C110.617 11.2163 111.961 9.48828 114.393 9.48828C116.857 9.48828 117.849 11.2003 117.849 13.6323V14.2563H112.009C112.201 15.6163 113.081 16.4963 114.969 16.4963C115.897 16.4963 116.681 16.3203 117.401 16.0643V17.3283Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M107.676 17.0083V16.2083C107.164 17.2643 106.204 17.8083 104.972 17.8083C102.86 17.8083 101.804 16.0003 101.804 13.6483C101.804 11.3923 102.908 9.48828 105.132 9.48828C106.3 9.48828 107.196 10.0163 107.676 11.0563V9.64828H109.02V16.9283C109.02 19.2803 107.916 20.8643 105.052 20.8643C103.708 20.8643 102.972 20.6883 102.204 20.4323V19.0883C103.084 19.3763 103.996 19.5683 104.988 19.5683C106.988 19.5683 107.676 18.4963 107.676 17.0083ZM103.148 13.6483C103.148 15.5683 103.916 16.5283 105.34 16.5283C106.572 16.5283 107.676 15.7443 107.676 13.9683V13.3283C107.676 11.5523 106.668 10.7683 105.5 10.7683C103.948 10.7683 103.148 11.7923 103.148 13.6483Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M96.2189 15.5522C95.4189 15.5522 94.6029 15.4562 93.7069 15.2802L92.8269 17.6482H91.2109L95.3549 7.13623H97.1789L101.323 17.6482H99.7069L98.8269 15.2642C97.8829 15.4562 97.0669 15.5522 96.2189 15.5522ZM96.2189 14.2722C96.8909 14.2722 97.5789 14.1922 98.3949 14.0642L96.2669 8.30423L94.1389 14.0802C94.9229 14.2082 95.5789 14.2722 96.2189 14.2722Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M85.3947 17.6484H83.5547L80.4507 9.64844H81.8907L84.4827 16.4804L87.0587 9.64844H88.4987L85.3947 17.6484Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M76.1881 10.7363C74.7321 10.7363 73.9961 11.6803 73.8521 13.0723H78.3161C78.2361 11.5843 77.5641 10.7363 76.1881 10.7363ZM79.2601 17.3283C78.6041 17.6803 77.5961 17.8083 76.7801 17.8083C73.7881 17.8083 72.4761 16.0803 72.4761 13.6323C72.4761 11.2163 73.8201 9.48828 76.2521 9.48828C78.7161 9.48828 79.7081 11.2003 79.7081 13.6323V14.2563H73.8681C74.0601 15.6163 74.9401 16.4963 76.8281 16.4963C77.7561 16.4963 78.5401 16.3203 79.2601 16.0643V17.3283Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M66.1498 8.51223H63.7818V16.2722H66.2298C68.6298 16.2722 69.8298 15.0082 69.8298 12.4642C69.8298 9.90423 68.6938 8.51223 66.1498 8.51223ZM62.3418 17.6482V7.13623H66.2138C69.6218 7.13623 71.2698 9.26423 71.2698 12.4162C71.2698 15.6002 69.6058 17.6482 66.2138 17.6482H62.3418Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M53.8622 17.8083C51.4622 17.8083 50.0542 16.0323 50.0542 13.6323C50.0542 11.2323 51.4622 9.48828 53.8622 9.48828C56.2462 9.48828 57.6382 11.2323 57.6382 13.6323C57.6382 16.0323 56.2462 17.8083 53.8622 17.8083ZM53.8622 10.7683C52.1502 10.7683 51.3982 12.1123 51.3982 13.6323C51.3982 15.1523 52.1502 16.5283 53.8622 16.5283C55.5582 16.5283 56.2942 15.1523 56.2942 13.6323C56.2942 12.1123 55.5582 10.7683 53.8622 10.7683Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M46.5509 17.6484H44.7109L41.6069 9.64844H43.0469L45.6389 16.4804L48.2149 9.64844H49.6549L46.5509 17.6484Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M37.4403 17.8083C35.0403 17.8083 33.6323 16.0323 33.6323 13.6323C33.6323 11.2323 35.0403 9.48828 37.4403 9.48828C39.8243 9.48828 41.2163 11.2323 41.2163 13.6323C41.2163 16.0323 39.8243 17.8083 37.4403 17.8083ZM37.4403 10.7683C35.7283 10.7683 34.9763 12.1123 34.9763 13.6323C34.9763 15.1523 35.7283 16.5283 37.4403 16.5283C39.1363 16.5283 39.8723 15.1523 39.8723 13.6323C39.8723 12.1123 39.1363 10.7683 37.4403 10.7683Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M28.552 8.51223H26.44V12.3522H28.552C30.424 12.3522 31 11.6322 31 10.4322C31 9.29623 30.408 8.51223 28.552 8.51223ZM32.44 10.4002C32.44 11.9842 31.768 13.0562 30.376 13.5042L32.952 17.6482H31.256L28.936 13.7282C28.872 13.7282 28.792 13.7282 28.712 13.7282H26.44V17.6482H25V7.13623H28.712C31.224 7.13623 32.44 8.38423 32.44 10.4002Z",
                fill: isLightMode ? "#101214" : "#E2E3E4"
            })
        ]
    });
};
const $80a046d009ef2432$export$2ba09f2b55b47be8 = ()=>{
    const { colorMode: colorMode, light: light } = (0, $54e6b8023ffdb4d7$export$2e2bcd8739ae039)();
    const isLightMode = colorMode === light;
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.0123 3.27288C12.3955 2.91395 11.6359 2.90911 11.0152 3.25836C11.0064 3.26485 10.9971 3.27094 10.9874 3.27658L10.9873 3.27663L10.986 3.27741C10.5867 3.51015 10.2848 3.8698 10.1189 4.28886C10.0268 4.52385 9.97754 4.77777 9.97754 5.03912V7.73475L13.3255 9.68348L13.3257 9.6836C14.1479 10.1605 14.6521 11.0421 14.6521 11.9981L14.6521 18.9571C14.6521 19.2693 14.5978 19.574 14.496 19.8594L18.9874 17.2439L18.9879 17.2436C19.6151 16.8799 19.9998 16.2078 19.9998 15.4776V8.51862C19.9998 7.79133 19.6128 7.11627 18.9875 6.75238L18.9874 6.75233L13.0123 3.27288Z",
                fill: isLightMode ? "#1868DB" : "#357DE8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0223 18.9609C14.0223 19.2226 13.9728 19.4768 13.8806 19.712C13.7144 20.1312 13.4121 20.4908 13.0125 20.7234L13.0124 20.7234C13.0027 20.7291 12.9934 20.7352 12.9846 20.7417C12.3639 21.0909 11.6044 21.0861 10.9876 20.7272L10.9875 20.7271L5.01241 17.2477L5.01232 17.2476C4.38699 16.8838 4 16.2087 4 15.4814L4 8.52239C4 7.79222 4.38472 7.12009 5.01191 6.75639L9.50381 4.14062C9.40202 4.426 9.34771 4.73069 9.34771 5.04289V12.0019C9.34771 12.9578 9.85176 13.8393 10.6739 14.3163L10.6743 14.3165L14.0223 16.2653V18.9609Z",
                fill: isLightMode ? "#1868DB" : "#357DE8"
            })
        ]
    });
};
const $80a046d009ef2432$export$5f000633c2c20481 = ({ width: width = "24", height: height = "24" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "2",
                y: "2",
                width: "24",
                height: "24",
                rx: "12",
                fill: "var(--ds-surface-sunken, #F7F8F9)",
                fillOpacity: "0.07"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "26",
                rx: "13",
                stroke: "var(--ds-border-accent-gray, #758195)",
                strokeOpacity: "0.4",
                strokeWidth: "1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 8.5C8.72386 8.5 8.5 8.72386 8.5 9V9.49994H19C20.1046 9.49994 21 10.3954 21 11.4999V18.9999C21 20.1045 20.1046 20.9999 19 20.9999H9C7.89543 20.9999 7 20.1045 7 18.9999V9C7 7.89543 7.89543 7 9 7H19.5V8.5H9ZM8.5 10.9999V18.9999C8.5 19.2761 8.72386 19.4999 9 19.4999H19C19.2761 19.4999 19.5 19.2761 19.5 18.9999V17.5H18C16.8954 17.5 16 16.6046 16 15.5V15C16 13.8954 16.8954 13 18 13H19.5V11.4999C19.5 11.2238 19.2761 10.9999 19 10.9999H8.5ZM19.5 14.5H18C17.7239 14.5 17.5 14.7239 17.5 15V15.5C17.5 15.7761 17.7239 16 18 16H19.5V14.5Z",
                fill: "var(--ds-icon-accent-gray, #758195)"
            })
        ]
    });
};
const $80a046d009ef2432$export$1fbfda8af1f68ad9 = ({ width: width = "23", height: height = "26" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 23 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.6228 6.52919L12.1228 1.0696C11.7372 0.847967 11.2628 0.847966 10.8772 1.0696L1.37716 6.52919C0.989192 6.75215 0.75 7.16549 0.75 7.61297V18.5242C0.75 18.9716 0.989192 19.385 1.37716 19.608L10.8772 25.0675C11.2628 25.2892 11.7372 25.2892 12.1228 25.0675L21.6228 19.608C22.0108 19.385 22.25 18.9716 22.25 18.5242V7.61297C22.25 7.16549 22.0108 6.75215 21.6228 6.52919Z",
                fill: "#82B536",
                stroke: "var(--ds-border, #091E4224)",
                strokeWidth: "0.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_1374_6696",
                maskUnits: "userSpaceOnUse",
                x: "1",
                y: "1",
                width: "21",
                height: "24",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M10.7526 1.42953C11.2154 1.16357 11.7846 1.16357 12.2474 1.42953L21.2474 6.60178C21.713 6.86933 22 7.36534 22 7.90231V18.2348C22 18.7718 21.713 19.2678 21.2474 19.5354L12.2474 24.7076C11.7846 24.9736 11.2154 24.9736 10.7526 24.7076L1.75259 19.5354C1.28703 19.2678 1 18.7718 1 18.2348V7.90231C1 7.36534 1.28703 6.86933 1.75259 6.60178L10.7526 1.42953Z",
                    fill: "#FFA900"
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                mask: "url(#mask0_1374_6696)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.8637 8.79376C16.2381 8.71142 15.3055 9.05378 14.8028 8.80243C14.9556 8.81688 15.0399 6.76563 14.5357 7.13543C14.3901 7.25822 14.3215 7.48645 14.5429 7.54567C14.1316 7.73924 14.7685 8.79232 13.8117 9.23146C13.7974 8.67531 11.3224 9.54058 12.7648 9.56658C12.7991 9.34557 12.8077 9.91761 13.2133 9.49725C14.67 9.64748 14.0987 10.3539 14.6029 11.4618C14.5315 12.9844 15.6112 11.7998 15.0542 11.0472C15.4426 10.0722 14.0559 9.31234 15.7168 9.73126C15.8839 9.3759 17.8005 9.35279 16.8622 8.79376H16.8637Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M22.3718 12.1338C21.9762 11.946 21.4792 12.2667 21.2436 11.8709C21.5449 11.9951 21.5049 10.3975 21.0079 10.7759C20.9479 11.0244 20.8037 10.994 21.0579 11.0793C20.6309 11.0822 21.0279 11.3566 21.0136 11.3956C20.7808 11.4014 21.085 11.5343 20.8637 11.4881C20.7351 11.5141 21.1108 11.8434 20.8565 11.7553C20.7751 12.1136 20.3781 12.1107 20.4667 12.3288C20.4624 12.18 19.1427 12.1453 19.5083 12.7145C19.7397 12.7029 19.7097 12.9658 19.744 12.6235C19.814 13.0482 19.9696 12.6235 20.0068 12.6336C20.0411 12.8719 20.1096 12.5426 20.0996 12.7752C20.1339 12.9008 20.3567 12.4993 20.3124 12.7622C21.0822 12.9658 20.4509 13.1854 20.8951 13.6274C20.9394 13.8326 20.8308 14.4985 21.3064 14.4364C21.932 14.2544 21.2022 13.1175 21.5735 12.9196C21.7392 12.7694 21.9748 12.5801 22.2876 12.7087C22.4418 12.7116 22.6403 12.0746 22.3733 12.1323L22.3718 12.1338Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M19.3705 5.31109C19.5147 5.4671 20.6958 5.47867 20.6958 5.47867C20.6958 5.47867 20.9429 5.74733 20.8529 5.95101C21.0714 6.09691 21.0786 6.45806 21.03 6.82786C21.0457 7.01709 21.7227 7.10954 21.607 6.81052C21.7512 6.53462 21.2914 5.67512 21.6341 5.74446C21.6313 5.3631 22.2754 5.52344 22.0797 5.00341C22.0226 4.66683 21.7598 4.86184 21.7341 4.78817C20.9258 5.48011 21.6741 2.93195 20.8301 3.34797C20.7901 3.60221 20.8472 4.14969 20.7572 4.34182C20.6073 4.52527 20.6158 4.74339 20.6573 4.97163C20.4002 4.90085 19.3162 4.96729 19.3691 5.30965L19.3705 5.31109Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12.2033 3.83045C11.7363 3.712 11.5978 4.2537 11.5249 3.33641C11.4564 2.91461 11.1479 3.03162 11.0422 3.17174C10.978 3.25552 11.1779 3.65422 11.0993 3.69178C11.0993 3.69178 11.1079 4.02112 11.1293 4.20025C11.1065 4.00957 10.3895 4.11357 10.0582 4.25514C10.0582 4.25514 9.82257 4.54549 10.1568 4.72317C10.1768 4.71739 10.8194 4.63505 11.0022 4.70583C11.3021 4.91962 11.0708 4.97453 11.1251 5.20566C11.1793 5.43534 11.1736 6.45085 11.8191 5.85859C11.8434 5.39634 11.8391 5.30676 11.7563 4.67117C11.8591 4.49638 12.0162 4.37071 12.2533 4.41116C12.379 4.3736 12.4033 3.72789 12.2048 3.83045H12.2033Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.6584 14.7191C14.1914 14.6007 14.0529 15.1424 13.98 14.2251C13.9115 13.8033 13.603 13.9203 13.4973 14.0604C13.433 14.1442 13.633 14.5429 13.5544 14.5805C13.5544 14.5805 13.563 14.9098 13.5844 15.0889C13.5616 14.8982 12.8446 15.0022 12.5133 15.1438C12.5133 15.1438 12.2776 15.4342 12.6118 15.6118C12.6318 15.6061 13.2745 15.5237 13.4573 15.5945C13.7572 15.8083 13.5259 15.8632 13.5801 16.0943C13.6344 16.324 13.6287 17.3395 14.2742 16.7473C14.2985 16.285 14.2942 16.1954 14.2114 15.5598C14.3142 15.385 14.4713 15.2594 14.7084 15.2998C14.8341 15.2623 14.8583 14.6166 14.6598 14.7191H14.6584Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.9126 1.27046C14.9298 1.27335 15.7653 1.10433 15.6753 1.34701C15.851 1.59692 15.6996 2.18053 15.9923 2.24842C16.7664 2.29175 16.2594 1.80638 16.3879 1.47558C16.6879 1.58392 17.0406 1.05811 16.7121 0.829873C16.6464 0.932435 16.4851 0.721531 16.5008 0.845761L16.4993 0.792314C16.3837 0.884764 16.3151 0.906431 16.1809 0.718641C16.0609 0.990214 16.4651 -0.163976 15.8281 0.0642609C15.7124 0.1596 15.9166 0.701315 15.6596 0.673869C15.4554 0.79521 15.1697 0.707084 14.9755 0.790868C14.8155 0.860205 14.7213 1.02634 14.9155 1.27046H14.9126Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.83355 9.77338C6.85069 9.77627 7.68616 9.60726 7.59619 9.84994C7.77185 10.0998 7.62047 10.6834 7.91324 10.7513C8.68731 10.7947 8.18031 10.3093 8.30885 9.97849C8.60876 10.0868 8.96152 9.56102 8.63304 9.33279C8.56734 9.43535 8.40596 9.22444 8.42167 9.34867L8.42024 9.29523C8.30456 9.38768 8.23601 9.40934 8.10176 9.22155C7.98179 9.49313 8.38597 8.33895 7.749 8.56719C7.63332 8.66253 7.83755 9.20423 7.58048 9.17678C7.37625 9.29812 7.09062 9.21 6.89639 9.29378C6.73643 9.36312 6.64217 9.52925 6.8364 9.77338H6.83355Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M19.8084 12.8643C20.204 13.0521 20.701 12.7314 20.9367 13.1272C20.6353 13.003 20.6753 14.6006 21.1723 14.2221C21.2323 13.9737 21.3766 14.004 21.1223 13.9188C21.5494 13.9159 21.1523 13.6415 21.1666 13.6024C21.3994 13.5967 21.0952 13.4638 21.3166 13.51C21.4451 13.484 21.0695 13.1546 21.3237 13.2428C21.4051 12.8845 21.8021 12.8874 21.7136 12.6693C21.7179 12.8181 23.0375 12.8527 22.6719 12.2836C22.4405 12.2951 22.4705 12.0322 22.4363 12.3746C22.3663 11.9499 22.2106 12.3746 22.1735 12.3645C22.1392 12.1261 22.0706 12.4555 22.0806 12.2229C22.0464 12.0972 21.8236 12.4988 21.8678 12.2359C21.0981 12.0322 21.7293 11.8127 21.2851 11.3706C21.2409 11.1655 21.3494 10.4996 20.8738 10.5617C20.2483 10.7437 20.9781 11.8806 20.6068 12.0785C20.4411 12.2287 20.2055 12.4179 19.8927 12.2894C19.7384 12.2865 19.5399 12.9235 19.807 12.8657L19.8084 12.8643Z",
                        fill: "#B3DF72"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.72852 7.68164V16.9304H15.9773V7.68164H6.72852ZM10.6923 9.66789H13.9954V10.6588H10.6923V9.66789ZM10.6923 11.8095H13.9954V12.8004H10.6923V11.8095ZM9.04289 9.49727C9.40602 9.49727 9.70352 9.79477 9.70352 10.1579C9.70352 10.521 9.40602 10.8185 9.04289 10.8185C8.67977 10.8185 8.38227 10.5232 8.38227 10.1579C8.38227 9.79258 8.67758 9.49727 9.04289 9.49727ZM9.04289 11.6454C9.40602 11.6454 9.70352 11.9407 9.70352 12.306C9.70352 12.6713 9.40602 12.9666 9.04289 12.9666C8.67977 12.9666 8.38227 12.6713 8.38227 12.306C8.38227 11.9407 8.67758 11.6454 9.04289 11.6454Z",
                fill: "white"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.232 13.3867V14.9202H10.6914V18.0373H17.232V19.8792L20.4761 16.6308L17.232 13.3867Z",
                fill: "#101214"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.6914 14.9199V16.9302H15.9764V14.9199H10.6914Z",
                fill: "#82B536"
            })
        ]
    });
};
const $80a046d009ef2432$export$a60fe8618e9cd1ae = ({ width: width = "23", height: height = "26" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 23 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.1228 1.0696C11.7372 0.847967 11.2628 0.847967 10.8772 1.0696L1.37716 6.52919C0.989192 6.75215 0.75 7.16549 0.75 7.61297V18.5242C0.75 18.9716 0.989191 19.385 1.37716 19.608L10.8772 25.0675C11.2628 25.2892 11.7372 25.2892 12.1228 25.0675L21.6228 19.608C22.0108 19.385 22.25 18.9716 22.25 18.5242V7.61297C22.25 7.16549 22.0108 6.75215 21.6228 6.52919L12.1228 1.0696Z",
                fill: "#82B536",
                stroke: "var(--ds-border, #091E4224)",
                strokeWidth: "0.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_1374_6858",
                maskUnits: "userSpaceOnUse",
                x: "1",
                y: "1",
                width: "21",
                height: "24",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M10.5035 1.57271C11.1205 1.2181 11.8795 1.2181 12.4965 1.57271L20.9965 6.45761C21.6173 6.81435 22 7.47569 22 8.19165V17.9455C22 18.6615 21.6173 19.3228 20.9965 19.6795L12.4965 24.5644C11.8795 24.919 11.1205 24.919 10.5035 24.5644L2.00346 19.6795C1.38271 19.3228 1 18.6615 1 17.9455V8.19165C1 7.47569 1.38271 6.81435 2.00346 6.45761L10.5035 1.57271Z",
                    fill: "#FFA900"
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                mask: "url(#mask0_1374_6858)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10.6751 7.0413C10.6302 6.18122 10.4491 5.03372 10.4202 4.62024C10.6527 5.11706 10.5616 3.82854 10.5113 3.61699C10.4898 3.83388 10.3934 3.66615 10.4138 3.5187C10.7587 3.72598 10.5241 0.210855 10.2221 2.01863C10.1439 2.87123 9.99603 4.73885 9.97461 6.09681C10.1546 6.76031 10.4909 9.54782 10.6751 7.04237V7.0413Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.29441 8.51073C7.07804 8.10259 6.8456 7.74893 6.39464 7.31622C6.43213 7.67414 6.2404 7.42842 6.22326 7.2596C6.54461 7.32691 6.11292 6.86214 5.96082 6.79804C6.00474 6.86321 5.92654 6.92197 5.8537 6.82261C6.1247 6.80124 5.15853 5.6623 5.a06641 6.17408C5.19066 6.35358 5.05569 6.43477 5.27849 6.35678C5.03534 6.56405 5.42632 6.56085 5.44238 6.5961C5.29242 6.82475 5.75194 6.86001 5.55913 6.91984C5.63304 7.35576 7.33512 9.4659 7.29441 8.5118V8.51073Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.6735 12.3385C5.17755 11.9432 4.62912 11.6793 3.83968 11.5404C4.16853 11.8438 3.78612 11.7199 3.61902 11.5949C4.35812 11.3246 0.316648 11.128 1.85054 11.7445C1.9191 11.4047 1.87197 11.846 2.0787 11.721C2.23723 11.6099 2.38826 11.6462 2.38505 11.7338C2.38398 11.831 2.80922 11.5735 2.69354 11.7573C3.04809 11.8107 6.48972 13.158 5.6735 12.3385Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.16804 15.8193C4.59604 16.0052 4.06797 16.299 3.55703 16.8653C3.98014 16.7531 3.66842 17.0117 3.48311 17.0694C3.66949 16.2852 1.35688 19.4648 2.67654 18.5663C2.41411 18.3248 2.7858 18.6015 2.7783 18.3718C2.88434 17.8814 3.38458 17.9145 3.78733 17.344C4.01549 16.969 6.0828 15.9337 5.16804 15.8204V15.8193Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M9.15363 19.6561C8.60627 16.4231 8.4306 19.0621 8.53129 20.56C8.73695 20.107 8.71874 20.5878 8.62662 20.7865C8.42631 20.2887 8.39525 21.8069 8.60841 21.4703C8.61055 21.5269 8.62876 21.5846 8.62769 21.6381C8.32991 21.4425 8.51201 24.2172 8.91262 22.8016C8.58806 22.7097 9.11935 22.7738 8.79693 22.2952C9.16755 21.825 8.88263 20.4019 9.15363 19.6572V19.6561Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.936 22.1817C15.5059 21.4872 14.0138 16.9838 14.1916 19.4465C14.258 19.7681 14.3437 20.4839 14.4711 20.9936C14.619 20.5363 14.665 20.9968 14.589 21.1987C14.3544 20.75 14.4347 22.1806 14.6179 21.8558C14.6168 22.0577 14.4615 22.2565 14.5065 22.9146C14.4401 23.7458 14.8621 23.5696 14.8643 23.1358C14.6275 23.0834 15.1031 23.0834 14.8128 22.6539C15.0549 22.6454 14.7711 22.0748 14.935 22.1817H14.936Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.1874 17.0919C19.6314 16.907 19.0883 16.7948 18.3439 16.7852C18.6974 17.0267 18.3043 16.9711 18.1457 16.86C18.4874 16.6837 17.683 16.6463 17.5148 16.6923C17.6262 16.7179 17.5694 16.8098 17.4409 16.782C17.7141 16.6121 15.8877 16.3386 16.1952 16.7265C16.1684 16.8194 16.374 16.8002 16.4405 16.9188C16.4779 16.9188 16.479 16.72 16.5272 16.7874C16.4683 17.1015 16.8357 16.8589 16.8775 16.875C16.7522 17.1656 21.1407 17.8804 20.1884 17.094L20.1874 17.0919Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M20.7892 11.8666C20.1872 11.8142 19.6569 11.8185 18.8868 11.8879C19.3302 12.0941 18.7465 12.1187 18.694 11.9413C19.0528 11.8452 18.1198 11.8056 18.0256 11.8986C18.1455 11.9114 18.0931 12.0097 17.9602 11.9958C18.0598 11.7458 15.7001 11.7544 16.9501 12.2544C16.9887 12.248 16.9619 12.0535 17.0208 12.1123C17.0037 12.4317 17.3454 12.1422 17.3915 12.154C17.4279 12.4018 17.9217 12.1112 17.806 12.2822C18.0545 12.576 21.9385 12.389 20.7881 11.8666H20.7892Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.3381 5.39052C16.2942 4.82319 16.8726 4.42787 16.9808 3.8584C16.7516 2.94062 14.9317 6.4707 15.5283 5.80828C15.7072 5.5978 13.6034 8.74217 14.3554 8.74431C14.3822 8.802 14.6425 8.44516 14.5932 8.41952C14.545 8.3725 14.4721 8.36181 14.5225 8.31801C14.8128 8.45049 14.7014 7.93338 14.7367 7.88102C15.2905 7.5199 15.6493 6.04975 16.3392 5.38839L16.3381 5.39052Z",
                        fill: "#B3DF72"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.2236 10.458C12.0449 10.458 10.3343 12.1511 9.68457 12.9955C10.1177 13.8421 12.0449 15.533 14.2236 15.533C16.4024 15.533 18.3296 13.8399 18.7627 12.9955C18.1152 12.1489 16.4024 10.458 14.2236 10.458ZM14.2236 11.158C15.2386 11.158 16.0611 11.9805 16.0611 12.9955C16.0611 14.0105 15.2386 14.833 14.2236 14.833C13.2086 14.833 12.3861 14.0105 12.3861 12.9955C12.3861 11.9805 13.2086 11.158 14.2236 11.158Z",
                fill: "#101214"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0965 13.0002L15.4112 14.5993L14.2562 16.603L12.2109 16.2618L11.4868 18.2021H9.17461L8.44617 16.2618L6.40086 16.603L5.24805 14.5993L6.56055 13.0002L5.24805 11.4012L6.40086 9.3974L8.44617 9.73647L9.17461 7.79834H11.4868L12.2109 9.73647L14.2562 9.3974L15.4134 11.4012L14.0965 13.0002Z",
                fill: "white"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.2234 14.8352C13.2084 14.8352 12.3859 14.0105 12.3859 12.9955C12.3859 11.9805 13.2084 11.158 14.2234 11.158C14.6325 11.158 15.0109 11.2914 15.3171 11.5189L15.4134 11.4008L14.9015 10.5127C14.6828 10.4777 14.4553 10.458 14.2234 10.458C12.0446 10.458 10.334 12.1489 9.68652 12.9955C10.1175 13.8421 12.0446 15.533 14.2234 15.533C14.4531 15.533 14.6806 15.5133 14.9037 15.4783L15.4112 14.5989L15.3128 14.4786C15.0065 14.7018 14.6303 14.8352 14.2234 14.8352Z",
                fill: "#82B536"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0964 13.0001L15.3126 14.4788C15.0064 14.702 14.6301 14.8354 14.2232 14.8354C13.2082 14.8354 12.3857 14.0107 12.3857 12.9957C12.3857 11.9807 13.2082 11.1582 14.2232 11.1582C14.6323 11.1582 15.0107 11.2916 15.317 11.5191L14.0964 13.0001Z",
                fill: "#101214"
            })
        ]
    });
};
const $80a046d009ef2432$export$6beb87409d36db16 = ({ width: width = "21", height: height = "24" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 21 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.25 3.01714C8.48948 1.15544 12.5105 1.15544 15.75 3.01714C18.9865 4.87713 21 8.3357 21 12.0686C21 15.8014 18.9865 19.26 15.75 21.12C12.5105 22.9817 8.48948 22.9817 5.25 21.12C2.01352 19.26 0 15.8014 0 12.0686C0 8.3357 2.01352 4.87713 5.25 3.01714Z",
                fill: "#82B536"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7206 7.4553C11.5734 7.40463 11.4121 7.41451 11.2722 7.48276C11.1323 7.55101 11.0252 7.67204 10.9745 7.81923L8.13942 16.0639C8.09241 16.2102 8.10462 16.3691 8.17343 16.5064C8.24223 16.6438 8.36215 16.7487 8.50744 16.7986C8.65273 16.8486 8.8118 16.8396 8.95052 16.7735C9.08924 16.7075 9.19654 16.5897 9.2494 16.4455L12.0845 8.20135C12.1352 8.05416 12.1253 7.89287 12.057 7.75296C11.9888 7.61305 11.8678 7.50598 11.7206 7.4553ZM8.1177 12.2744L6.60329 10.8064L8.24625 9.2133C8.35803 9.10495 8.42218 8.95664 8.4246 8.80098C8.42702 8.64533 8.36751 8.49509 8.25916 8.38332C8.15081 8.27154 8.0025 8.20738 7.84684 8.20496C7.69119 8.20254 7.54095 8.26205 7.42917 8.3704L5.35127 10.3849C5.29482 10.4396 5.24994 10.5051 5.21929 10.5775C5.18864 10.6499 5.17285 10.7277 5.17285 10.8064C5.17285 10.885 5.18864 10.9628 5.21929 11.0352C5.24994 11.1076 5.29482 11.1731 5.35127 11.2278L7.30004 13.1173C7.35538 13.171 7.42076 13.2133 7.49244 13.2417C7.56412 13.2701 7.64069 13.2841 7.71779 13.2829C7.79489 13.2818 7.87101 13.2654 7.94179 13.2348C8.01257 13.2043 8.07663 13.16 8.13032 13.1047C8.18401 13.0493 8.22627 12.984 8.25469 12.9123C8.28311 12.8406 8.29714 12.764 8.29597 12.6869C8.2948 12.6098 8.27845 12.5337 8.24786 12.4629C8.21728 12.3922 8.17305 12.3281 8.1177 12.2744ZM15.29 13.1948L13.3412 11.3047C13.2858 11.251 13.2204 11.2088 13.1487 11.1804C13.077 11.152 13.0004 11.138 12.9233 11.1391C12.7675 11.1416 12.6191 11.2058 12.5107 11.3176C12.4022 11.4295 12.3427 11.5798 12.3451 11.7356C12.3475 11.8913 12.4117 12.0398 12.5236 12.1482L14.038 13.6156L12.395 15.2093C12.2832 15.3176 12.2191 15.466 12.2167 15.6216C12.2142 15.7773 12.2738 15.9275 12.3821 16.0393C12.4905 16.1511 12.6388 16.2152 12.7944 16.2176C12.9501 16.2201 13.1003 16.1605 13.2121 16.0522L15.29 14.0377C15.3464 13.983 15.3913 13.9175 15.422 13.8451C15.4526 13.7727 15.4684 13.6949 15.4684 13.6162C15.4684 13.5376 15.4526 13.4598 15.422 13.3874C15.3913 13.315 15.3464 13.2495 15.29 13.1948Z",
                fill: "white"
            })
        ]
    });
};
const $80a046d009ef2432$export$29a768e77dec31dc = ({ width: width = "23", height: height = "26" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 23 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.6202 6.49502L12.1202 1.06645C11.7359 0.846852 11.2641 0.846853 10.8798 1.06645L1.37983 6.49502C0.990358 6.71757 0.75 7.13175 0.75 7.58032V18.4197C0.75 18.8682 0.990357 19.2824 1.37983 19.505L10.8798 24.9336C11.2641 25.1531 11.7359 25.1531 12.1202 24.9336L21.6202 19.505C22.0096 19.2824 22.25 18.8682 22.25 18.4197V7.58032C22.25 7.13175 22.0096 6.71757 21.6202 6.49502Z",
                fill: "#82B536",
                stroke: "var(--ds-border, #091E4224)",
                strokeWidth: "0.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_1518_7988",
                maskUnits: "userSpaceOnUse",
                x: "1",
                y: "1",
                width: "21",
                height: "24",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M11.0039 1.28351C11.3113 1.10783 11.6887 1.10783 11.9961 1.28351L21.4961 6.71208C21.8077 6.89012 22 7.22147 22 7.58032V18.4197C22 18.7785 21.8077 19.1099 21.4961 19.2879L11.9961 24.7165C11.6887 24.8922 11.3113 24.8922 11.0039 24.7165L1.50386 19.2879C1.19229 19.1099 1 18.7785 1 18.4197V7.58032C1 7.22147 1.19229 6.89012 1.50386 6.71208L11.0039 1.28351Z",
                    fill: "#FFA900"
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                mask: "url(#mask0_1518_7988)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("g", {
                        css: $80a046d009ef2432$var$overlayStyles,
                        children: (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M18.6 17.9768C18.8772 18.3001 19.1404 18.6328 19.392 18.9725C19.392 18.9725 19.4712 19.0873 19.583 19.2747C19.7018 19.4598 19.8533 19.7222 20.0024 20.0127C20.1515 20.3032 20.2936 20.6289 20.3611 20.9358C20.4007 21.0904 20.403 21.2357 20.3891 21.3622C20.3751 21.4911 20.3122 21.5824 20.2516 21.6574C20.0559 21.805 19.7741 21.8167 19.5108 21.791C19.2429 21.7652 18.9774 21.6902 18.7188 21.6082C18.1993 21.4348 17.6938 21.2052 17.2022 20.9569C17.2022 20.9569 17.123 20.9194 16.9996 20.8632C16.8761 20.8023 16.7107 20.7203 16.5313 20.6312C16.1749 20.4508 15.7742 20.24 15.5809 20.1556C15.3409 20.0502 15.1755 19.9963 15.1243 20.0104C15.0264 20.0291 15.3782 20.3595 16.5826 20.9827C16.5942 20.9944 16.6408 21.0248 16.6431 21.0319C17.2908 21.3388 17.9221 21.6527 18.6046 21.8894C18.9471 22.0042 19.3012 22.1073 19.6995 22.119C19.8952 22.1283 20.1188 22.0979 20.3332 21.9807C20.4403 21.9222 20.5405 21.8308 20.608 21.7207C20.6779 21.6082 20.7129 21.4887 20.7315 21.3716C20.7082 21.3903 20.6966 21.3294 20.7129 21.2779L20.7385 21.299C20.7432 20.9967 20.6709 20.7671 20.608 20.5539C20.5358 20.3454 20.4613 20.1556 20.3751 19.9776C20.205 19.6191 20.007 19.2911 19.7228 18.942C19.7228 18.942 19.809 19.0076 19.8113 19.01C18.1038 16.4539 15.1546 13.5511 12.6293 11.4566L12.6386 11.4706H12.6316C12.8553 11.6815 13.9082 12.6795 13.9082 12.6795C13.009 12.0517 12.1611 11.1379 11.2502 10.4163L11.2782 10.3929C11.6695 10.7092 12.0236 10.981 12.1704 11.084C11.4948 10.4866 10.4465 9.62444 9.35861 8.82786C8.27537 8.0266 7.14786 7.30031 6.39309 6.87625C6.41871 6.92311 6.90559 7.15271 6.97082 7.30266C6.59809 7.06603 6.21371 6.8458 5.85263 6.63728C5.88058 6.58574 6.08092 6.72397 6.12519 6.74037C5.97377 6.64431 5.09319 6.05625 3.77233 5.4799C3.43921 5.33933 3.07812 5.2011 2.67977 5.10504C2.4771 5.06287 2.2721 5.01601 2.04613 5.01367C1.82482 5.01367 1.5709 5.03007 1.33562 5.18939C1.21681 5.26202 1.11897 5.38619 1.06772 5.51739C1.02113 5.64859 0.997829 5.78448 1.00016 5.90865C1.00016 6.16168 1.06073 6.38425 1.13294 6.5998C1.27971 7.0262 1.48937 7.40809 1.70834 7.77123C2.14863 8.49518 2.6425 9.13009 3.08977 9.67598C3.53938 10.2195 3.95171 10.667 4.26154 10.9903C4.88819 11.6323 5.09785 11.7893 4.54575 11.1051L4.62728 11.1496C4.02625 10.4772 3.53938 9.90324 3.00591 9.12775C2.91971 9.02701 2.91739 9.01061 2.89176 9.02935C2.86613 9.00358 2.8242 8.96375 2.8242 8.98249C2.77528 9.03872 2.6192 8.78569 2.54233 8.68261C2.6821 8.67558 2.24181 8.09689 1.82715 7.41511C1.61982 7.0754 1.42414 6.70757 1.31698 6.38425C1.2634 6.22259 1.23079 6.07265 1.22147 5.95082C1.21681 5.82899 1.22613 5.73528 1.24476 5.68842C1.30067 5.66265 1.35891 5.48225 1.53829 5.37682C1.713 5.2667 1.96227 5.25264 2.07874 5.28076C2.06011 5.28076 1.95528 5.30419 1.94363 5.31356C1.99488 5.32293 2.2488 5.32527 2.58892 5.3979C2.92903 5.46585 3.34602 5.59939 3.71875 5.74465C4.46421 6.03751 5.03961 6.33974 4.55041 6.16168C6.40939 7.21363 8.90202 8.90284 11.2828 10.8146C13.6636 12.7241 15.9326 14.8561 17.3886 16.653L17.3746 16.6179C17.3956 16.6484 17.4748 16.728 17.4818 16.7608C17.6495 16.9155 17.9337 17.2153 18.1713 17.4824C18.4089 17.7495 18.6 17.9791 18.6 17.9791V17.9768ZM11.0988 10.4866C11.0988 10.4866 11.0918 10.4866 11.0918 10.4913C11.0965 10.4796 10.6282 10.1164 10.6096 10.1L10.6352 10.0743C11.1547 10.3882 12.0749 11.4613 11.1198 10.5475C11.0802 10.5264 11.0988 10.503 11.0988 10.4866ZM6.81241 7.38934C6.72621 7.33311 6.63303 7.26986 6.53053 7.20191C7.76054 7.82512 9.19787 9.01295 10.4139 9.89856C9.91305 9.70878 8.98588 8.90752 8.45707 8.53266C7.90497 8.18592 7.28764 7.71969 6.81241 7.39169V7.38934ZM2.12534 8.0102L2.14397 8.00317L2.1696 8.043C2.1696 8.043 2.15795 8.043 2.14863 8.03597C2.14164 8.03129 2.12999 8.01957 2.12534 8.0102ZM18.2086 17.3583C18.1224 17.2997 17.8895 16.9951 18.0945 17.1521C18.1294 17.2083 18.2715 17.3372 18.2086 17.3583ZM5.50552 6.55528C5.47757 6.60682 5.03262 6.37488 5.0699 6.30459C5.22365 6.38191 5.36575 6.47094 5.50552 6.55528ZM20.3169 20.4368C20.4217 20.5399 20.3425 20.5282 20.3192 20.582C20.3169 20.5492 20.2796 20.4344 20.3145 20.4485V20.4368H20.3169ZM19.3478 21.8777C19.3105 21.9011 19.173 21.8941 19.1101 21.8847C18.9564 21.8308 19.2825 21.8378 19.3478 21.8777ZM15.7975 20.3431C15.7742 20.3712 15.688 20.3337 15.6857 20.2915C15.7067 20.2751 15.8138 20.3126 15.8068 20.3571C15.8068 20.3571 15.8068 20.3501 15.7975 20.3454V20.3431ZM3.45551 5.42602C3.62324 5.37447 4.02393 5.63453 4.25921 5.71419C4.16836 5.78213 3.79097 5.53379 3.6046 5.4799C3.54404 5.45413 3.49279 5.43773 3.45551 5.42367V5.42602ZM15.7579 14.4273C15.8185 14.357 16.1353 14.7741 16.2681 14.8842L16.2401 14.9076C16.0538 14.7319 15.9303 14.6405 15.7649 14.4344L15.7579 14.4273ZM7.60679 7.6658C7.70929 7.68923 7.82576 7.80872 7.9073 7.86494C7.87701 7.90712 7.52292 7.67752 7.60679 7.6658ZM11.0685 10.2195C11.0499 10.2781 10.9031 10.1235 10.8519 10.0907C10.8938 10.1071 10.9753 10.1282 11.0149 10.161C11.0406 10.1844 11.0452 10.1938 11.0708 10.2195H11.0685ZM15.5972 14.3196C15.4551 14.1813 15.3013 14.0314 15.1546 13.8885L15.1848 13.8674C15.3339 14.0126 15.4807 14.1579 15.6275 14.2985L15.5995 14.3196H15.5972ZM14.1715 12.8927L14.1948 12.867C14.4347 13.038 14.3974 13.1294 14.1761 12.8974L14.1715 12.8927ZM17.4329 16.1634C17.4142 16.14 17.3816 16.1025 17.363 16.0814C17.0788 15.7768 17.5703 16.1189 17.4329 16.1634ZM18.8702 17.8057C18.9005 17.8362 18.9424 17.8713 18.968 17.9088C19.1451 18.1455 18.8772 17.9393 18.8702 17.8057Z",
                            fill: "white"
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("g", {
                        css: $80a046d009ef2432$var$overlayStyles,
                        children: (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M6.7829 20.0003C6.42415 20.2299 6.06074 20.4501 5.69267 20.661C5.69267 20.661 5.5692 20.7219 5.36886 20.8156C5.16852 20.9094 4.89363 21.0359 4.58846 21.16C3.98277 21.4178 3.2443 21.638 2.82265 21.631C2.56174 21.6146 2.31947 21.4716 2.27055 21.2233C2.21697 20.9796 2.28219 20.7055 2.36606 20.4501C2.55009 19.9371 2.8343 19.4568 3.1418 18.9952C3.1418 18.9952 3.32584 18.7 3.54947 18.3697C3.77311 18.037 4.03868 17.6692 4.14817 17.4864C4.28794 17.2615 4.36249 17.1045 4.35783 17.053C4.35084 16.9991 4.26232 17.053 4.06896 17.2568C3.87561 17.4583 3.57976 17.8121 3.19538 18.3767C3.1814 18.3884 3.14646 18.4306 3.13714 18.4306C2.94146 18.7352 2.7481 19.0374 2.56873 19.349C2.38702 19.6583 2.2193 19.9792 2.08884 20.3307C2.02361 20.5064 1.97236 20.6938 1.94674 20.8929C1.93276 21.0968 1.93742 21.3311 2.07253 21.556C2.21464 21.7786 2.46157 21.8934 2.67123 21.9285C2.88555 21.9683 3.09055 21.9613 3.2839 21.9308C3.26061 21.9121 3.30953 21.8863 3.35845 21.891L3.3468 21.9215C3.85232 21.8114 4.22737 21.6755 4.59544 21.5396C4.96119 21.399 5.30363 21.2397 5.68102 20.996C5.68102 20.996 5.60647 21.0734 5.60414 21.0757C8.33671 19.6934 11.661 17.2287 14.1047 15.0287L14.0884 15.0358V15.0287C13.8484 15.2185 12.7023 16.1158 12.7023 16.1158C13.4594 15.3193 14.4891 14.6117 15.3394 13.8151L15.358 13.8479C14.9876 14.1877 14.6638 14.4993 14.5403 14.6305C15.2322 14.0494 16.2432 13.138 17.1914 12.1751C18.1442 11.2169 19.0294 10.2001 19.5512 9.50426C19.5023 9.523 19.2041 9.97517 19.048 10.0197C19.3346 9.67997 19.6071 9.33088 19.8634 8.9982C19.91 9.03334 19.7446 9.21374 19.7236 9.25826C19.7842 9.19031 19.9845 8.95368 20.2687 8.58117C20.5483 8.20631 20.9163 7.69556 21.2564 7.04659C21.4218 6.71858 21.5896 6.35778 21.6548 5.91967C21.6781 5.70178 21.6781 5.43235 21.5104 5.19338C21.4218 5.08326 21.3124 4.9872 21.1889 4.93566C21.0678 4.88412 20.942 4.85366 20.8255 4.84663C20.3479 4.80915 19.9193 4.93332 19.5046 5.06218C19.09 5.19806 18.6939 5.36909 18.3165 5.54949C16.8023 6.27812 15.5304 7.14499 14.8012 7.6651C14.0767 8.19459 13.8904 8.37968 14.6452 7.92985L14.5892 8.00482C15.3417 7.50345 15.9777 7.10282 16.814 6.67641C16.9258 6.60613 16.9421 6.60378 16.9281 6.57567C16.9561 6.55458 17.0027 6.5171 16.984 6.51241C16.9351 6.45618 17.2053 6.33435 17.3195 6.2711C17.3078 6.40933 17.9415 6.05087 18.6567 5.70178C19.0154 5.52606 19.3951 5.35738 19.7189 5.24492C20.0404 5.13012 20.306 5.07389 20.4085 5.06686C20.4551 5.11606 20.6508 5.09029 20.8604 5.11138C20.9652 5.12543 21.0724 5.14886 21.1586 5.19806C21.2401 5.24726 21.296 5.31755 21.317 5.36909C21.31 5.35269 21.2215 5.30349 21.2145 5.29646C21.2215 5.32223 21.2728 5.36675 21.31 5.45812C21.3426 5.54949 21.3776 5.68538 21.3589 5.85172C21.3333 6.18675 21.1749 6.60378 21.0049 6.96224C20.6484 7.68385 20.2687 8.21568 20.5087 7.75179C19.246 9.48317 17.196 11.7042 14.948 13.7823C12.7046 15.8628 10.2516 17.791 8.26683 18.9788L8.3041 18.9695C8.27149 18.9859 8.18063 19.0538 8.14802 19.0561C7.97097 19.1991 7.63319 19.4404 7.33501 19.6395C7.03915 19.8387 6.78523 19.998 6.78523 19.998L6.7829 20.0003ZM15.2974 13.6535C15.2974 13.6535 15.2974 13.6465 15.2951 13.6465C15.2974 13.6465 15.3254 13.623 15.3673 13.5855C15.4093 13.5481 15.4652 13.4965 15.5211 13.445C15.6329 13.3395 15.7447 13.2341 15.754 13.2271L15.775 13.2552C15.386 13.7238 14.1886 14.4782 15.2345 13.6652C15.2602 13.6277 15.2811 13.6511 15.2974 13.6535ZM18.9921 9.84632C19.0597 9.769 19.1342 9.68466 19.2181 9.59094C18.4307 10.7296 17.0399 11.983 15.9847 13.0607C16.2479 12.5922 17.1774 11.7886 17.627 11.32C18.051 10.821 18.6007 10.2751 18.9921 9.84632ZM18.0347 5.94075L18.0393 5.95949L17.9974 5.98058C17.9974 5.98058 17.9974 5.96887 18.0044 5.96184C18.009 5.95481 18.023 5.94544 18.0347 5.94075ZM7.44915 19.6957C7.51904 19.6184 7.85217 19.4287 7.66813 19.6114C7.60756 19.6372 7.4608 19.7613 7.44915 19.6957ZM19.9962 8.65848C19.9519 8.62334 20.2361 8.21099 20.3013 8.25551C20.2035 8.39842 20.101 8.53197 19.9962 8.65848ZM4.14584 21.4482C4.03868 21.549 4.05266 21.4693 3.99908 21.4482C4.03402 21.4482 4.1505 21.4131 4.13419 21.4482H4.14584ZM2.14708 21.0898C2.11912 21.0593 2.09117 20.914 2.10515 20.8508C2.12844 20.7688 2.14242 20.8133 2.14475 20.8836C2.14475 20.9539 2.16106 21.0523 2.14475 21.0921L2.14708 21.0898ZM3.93385 17.6715C3.91055 17.6457 3.95715 17.5637 4.00141 17.5661C4.01538 17.5895 3.9618 17.6926 3.91987 17.6785C3.91987 17.6785 3.92686 17.6785 3.93385 17.6715ZM21.338 6.72093C21.3822 6.89664 21.0887 7.28556 20.9792 7.51047C20.921 7.41207 21.2099 7.05596 21.2728 6.87087C21.303 6.80996 21.3217 6.76076 21.338 6.72327V6.72093ZM10.7035 17.6879C10.7641 17.7582 10.3029 18.0112 10.1771 18.1284L10.1584 18.0979C10.3588 17.9386 10.4706 17.8308 10.6966 17.6949L10.7059 17.6879H10.7035ZM18.6031 10.5984C18.5658 10.6968 18.4284 10.7952 18.3631 10.8702C18.3259 10.835 18.6031 10.514 18.6054 10.5984H18.6031ZM15.5653 13.6629C15.5118 13.6347 15.6865 13.5129 15.7261 13.4661C15.7028 13.5035 15.6702 13.5832 15.6329 13.616C15.6073 13.6394 15.5956 13.6418 15.5677 13.6629H15.5653ZM10.834 17.545C10.9924 17.4255 11.1625 17.2943 11.3279 17.1701L11.3442 17.2029C11.1788 17.3294 11.0134 17.4536 10.8526 17.5778L10.8363 17.545H10.834ZM12.4554 16.3431L12.4787 16.3712C12.2713 16.5821 12.1898 16.5305 12.4507 16.3478L12.4554 16.3431ZM8.7374 19.096C8.76302 19.0796 8.80496 19.0538 8.82825 19.0397C9.1707 18.8008 8.76069 19.2412 8.7374 19.096ZM6.91103 20.2932C6.87841 20.3189 6.83415 20.3564 6.79455 20.3775C6.53597 20.5228 6.77591 20.2815 6.91103 20.2932Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.6401 12.0635H8.49219V17.0218H18.6401V12.0635Z",
                fill: "#101214"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.4868 8.98438H5.33887V13.9427H15.4868V8.98438Z",
                fill: "white"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.4859 12.0635H8.49219V13.9426H15.4859V12.0635Z",
                fill: "#82B536"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.0109 13.8561L15.8255 16.0415L14.6963 14.8811L15.1838 14.4082L15.8338 15.0749L17.5317 13.377L18.013 13.8582L18.0109 13.8561Z",
                fill: "white"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.099 7.48499C10.9843 7.46148 10.9212 7.3484 10.7831 7.41557C10.369 7.61821 9.83911 8.28099 9.67183 8.5564C9.2706 8.76127 8.5547 9.67705 8.26811 10.1506C8.09615 10.4562 7.61304 11.2489 7.61304 11.2489L7.55338 11.2444C7.55338 11.2444 6.62458 10.051 6.15199 9.80691C6.06776 9.78004 5.97535 9.80579 5.89464 9.92558C5.85136 9.96812 6.17071 10.3465 6.24557 10.351C6.3181 10.3129 6.65148 10.8011 6.85502 11.0474C7.49255 11.8221 7.61654 11.8892 7.91717 11.6407C8.41784 11.2265 10.5807 8.26979 11.099 7.48387V7.48499Z",
                fill: "#101214"
            })
        ]
    });
};
const $80a046d009ef2432$export$e8e65f186ccd8749 = ({ width: width = "28", height: height = "28" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#clip0_1109_48075)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.019 0.412109C5.13963 0.412109 0.37207 5.2589 0.37207 11.238C0.37207 16.0211 3.42274 20.0791 7.65308 21.5106C8.18518 21.6108 8.38053 21.2758 8.38053 20.9898C8.38053 20.7317 8.37066 19.8789 8.36608 18.9743C5.40409 19.6291 4.77908 17.697 4.77908 17.697C4.29476 16.4456 3.59693 16.1129 3.59693 16.1129C2.63093 15.441 3.66974 15.4548 3.66974 15.4548C4.73888 15.5312 5.30183 16.5704 5.30183 16.5704C6.25143 18.2254 7.79254 17.747 8.4001 17.4704C8.49566 16.7707 8.77158 16.2931 9.07607 16.0227C6.71124 15.749 4.22529 14.8207 4.22529 10.6725C4.22529 9.49061 4.6412 8.52487 5.32228 7.76673C5.21174 7.49406 4.84731 6.39297 5.42542 4.90179C5.42542 4.90179 6.31948 4.61083 8.35408 6.01148C9.20336 5.77162 10.1142 5.65133 11.019 5.6472C11.9238 5.65133 12.8353 5.77162 13.6862 6.01148C15.7183 4.61083 16.6111 4.90179 16.6111 4.90179C17.1907 6.39297 16.8261 7.49406 16.7155 7.76673C17.3982 8.52487 17.8113 9.49061 17.8113 10.6725C17.8113 14.8306 15.3206 15.7461 12.9497 16.0141C13.3316 16.3501 13.6719 17.0089 13.6719 18.0189C13.6719 19.4674 13.6596 20.6332 13.6596 20.9898C13.6596 21.2779 13.8512 21.6155 14.3909 21.5092C18.6189 20.0761 21.6657 16.0195 21.6657 11.238C21.6657 5.2589 16.8989 0.412109 11.019 0.412109Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_1109_48075",
                    children: (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "21.3333",
                        height: "21.3333",
                        fill: "var(--ds-icon-inverse, #FFFFFF)",
                        transform: "translate(0.333496 0.333008)"
                    })
                })
            })
        ]
    });
};
const $80a046d009ef2432$export$a2d9bd0613a7e60f = ({ width: width = "24", height: height = "24" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "2",
                y: "2",
                width: "24",
                height: "24",
                rx: "12",
                fill: "var(--ds-surface-sunken, #F7F8F9)",
                fillOpacity: "0.07"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "26",
                rx: "13",
                stroke: "var(--ds-border-accent-gray, #758195)",
                strokeOpacity: "0.4",
                strokeWidth: "1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1174 7.54723C16.6097 6.73303 18.5172 6.95696 19.7802 8.21997C21.3157 9.75551 21.3157 12.2451 19.7802 13.7806L17.5302 16.0306L16.4695 14.97L18.7195 12.72C19.6693 11.7702 19.6693 10.2304 18.7195 9.28063C18.0158 8.57693 16.9873 8.39444 16.1157 8.73386C16.2025 8.97317 16.2499 9.23136 16.2499 9.5003C16.2499 10.7429 15.2425 11.7503 13.9999 11.7503C12.7572 11.7503 11.7499 10.7429 11.7499 9.5003C11.7499 8.25766 12.7572 7.2503 13.9999 7.2503C14.4064 7.2503 14.7882 7.35854 15.1174 7.54723ZM13.9999 8.7503C13.5856 8.7503 13.2499 9.08609 13.2499 9.5003C13.2499 9.91452 13.5856 10.2503 13.9999 10.2503C14.4141 10.2503 14.7499 9.91452 14.7499 9.5003C14.7499 9.29829 14.671 9.11627 14.5408 8.98077C14.4034 8.83779 14.2125 8.7503 13.9999 8.7503ZM8.21952 14.22L10.4695 11.97L11.5302 13.0306L9.28018 15.2806C8.33043 16.2304 8.33043 17.7702 9.28018 18.72C9.98388 19.4237 11.0124 19.6062 11.884 19.2667C11.7972 19.0274 11.7499 18.7692 11.7499 18.5003C11.7499 17.2577 12.7572 16.2503 13.9999 16.2503C15.2425 16.2503 16.2499 17.2577 16.2499 18.5003C16.2499 19.7429 15.2425 20.7503 13.9999 20.7503C13.5933 20.7503 13.2115 20.6421 12.8823 20.4534C11.39 21.2676 9.48253 21.0436 8.21952 19.7806C6.68399 18.2451 6.68399 15.7555 8.21952 14.22ZM13.9999 17.7503C13.5856 17.7503 13.2499 18.0861 13.2499 18.5003C13.2499 18.7023 13.3287 18.8843 13.4589 19.0198C13.5963 19.1628 13.7872 19.2503 13.9999 19.2503C14.4141 19.2503 14.7499 18.9145 14.7499 18.5003C14.7499 18.0861 14.4141 17.7503 13.9999 17.7503Z",
                fill: "var(--ds-icon-accent-gray, #758195)"
            })
        ]
    });
};
const $80a046d009ef2432$export$fc1703dc7d632678 = ({ width: width = "23", height: height = "26" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 23 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.0872 1.18645C11.7236 0.977484 11.2764 0.977484 10.9128 1.18645L1.46037 6.61868C1.09457 6.8289 0.869048 7.21862 0.869048 7.64052V18.4966C0.869048 18.9185 1.09457 19.3082 1.46037 19.5185L10.9128 24.9507C11.2764 25.1597 11.7236 25.1597 12.0872 24.9507L21.5396 19.5185C21.9054 19.3082 22.131 18.9185 22.131 18.4966V7.64052C22.131 7.21862 21.9054 6.8289 21.5396 6.61868L12.0872 1.18645Z",
                fill: "#82B536",
                stroke: "var(--ds-border, #091E4224)",
                strokeWidth: "0.261905"
            }),
            (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_1374_5992",
                maskUnits: "userSpaceOnUse",
                x: "1",
                y: "1",
                width: "21",
                height: "24",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M10.978 1.29999C11.3012 1.11424 11.6988 1.11424 12.022 1.29999L21.4744 6.73221C21.7995 6.91908 22 7.2655 22 7.64052V18.4966C22 18.8716 21.7995 19.2181 21.4744 19.4049L12.022 24.8372C11.6988 25.0229 11.3012 25.0229 10.978 24.8372L1.52562 19.4049C1.20047 19.2181 1 18.8716 1 18.4966V7.64052C1 7.2655 1.20047 6.91908 1.52562 6.73222L10.978 1.29999Z",
                    fill: "#FFA900"
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                mask: "url(#mask0_1374_5992)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.513 6.19383C13.9794 6.41389 14.3759 6.70366 14.6568 7.01257L14.6608 6.9866C15.7415 7.47593 16.6098 8.42179 17.1259 9.51664C16.8948 9.49477 16.4015 9.14896 16.2052 9.23233C14.759 8.64869 16.8061 9.99777 17.4082 9.9513L17.4042 9.94719C17.4042 9.94719 17.5346 9.95813 17.5265 9.9718C18.0722 9.31707 18.0749 6.30317 17.4405 8.98357C17.2657 8.61862 16.9136 8.01037 16.7711 7.84771C16.4606 7.62902 16.4189 7.34062 16.0506 7.2094C16.0506 7.2094 16.1232 7.19163 16.1246 7.19026C15.259 6.32915 13.8826 5.41745 12.642 5.21379C12.6662 5.27804 13.2051 5.50494 13.2535 5.54458C12.8839 5.60882 11.3341 5.05797 12.4148 5.17962C12.0277 4.85841 9.19967 5.01561 9.947 5.27941C9.81797 5.31358 9.28436 5.52954 9.55319 5.31904C8.6244 5.13589 5.24526 8.06231 6.23991 8.32885C6.3891 8.01447 6.82191 7.81901 6.91466 7.56068C6.86761 7.45817 6.83805 7.39939 6.93886 7.33925C7.27892 7.57708 7.70366 6.57381 7.87436 6.5205C7.93619 6.7556 9.33541 5.57738 9.12035 5.9601C10.4954 5.66896 12.1809 5.5104 13.5157 6.18973L13.513 6.19383Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M19.9461 13.8634C19.9797 13.4916 18.9649 11.7516 18.9824 12.5129C18.9797 12.625 19.2338 13.2401 19.3292 13.3973C19.4381 13.4014 19.5026 13.4 19.5052 13.5148C19.1504 13.7171 19.7015 14.3937 19.6679 14.6971C19.4381 16.3442 17.8923 19.5522 15.4379 19.3923C15.3196 19.3813 14.9541 19.5399 14.8425 19.5207C13.8223 19.6397 11.3115 18.974 13.333 18.4204C14.0024 17.7356 11.7914 18.6719 11.5723 18.9275C11.79 20.0647 13.5293 21.5382 12.2591 19.4401C12.9446 19.8337 13.5051 20.17 14.278 20.0866C15.1476 20.4912 17.1302 19.9718 17.9286 19.1476C17.8762 19.1394 17.3721 19.3991 17.3197 19.4114C17.5428 19.0546 18.7498 18.2837 18.0993 18.9945C19.7136 17.5402 20.176 16.1241 19.9448 13.8606L19.9461 13.8634Z",
                        fill: "#B3DF72"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M9.22481 18.177C9.13475 18.1456 8.51781 18.1688 8.37533 18.2057C8.33904 18.3069 8.32426 18.3739 8.22479 18.337C8.03796 17.8886 7.17368 18.337 6.87663 17.9925C5.74085 17.5155 3.01095 15.6634 3.82818 13.6637C3.78382 12.6905 4.2892 11.6982 4.96395 10.9929C5.17095 10.6635 5.02981 11.7897 5.21665 11.8335C5.37929 13.4218 5.60644 10.9081 5.2852 10.4215C5.2852 10.4215 5.23412 10.2999 5.25025 10.2999C4.25694 10.1331 2.19103 11.4043 4.39405 10.8412C3.92629 11.3701 3.55128 11.7515 3.45451 12.4486C2.88729 13.0787 2.80663 15.0729 3.4666 15.9354C3.46929 15.8438 3.33354 15.3231 3.3416 15.3272C3.6279 15.5937 4.12792 16.8102 3.57952 16.1172C3.77173 17.5209 8.95464 19.7407 9.22481 18.1757V18.177Z",
                        fill: "#B3DF72"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.47953 7.75586H13.4597C15.1684 7.75586 16.5544 9.14194 16.5544 10.8506C16.5544 12.5592 15.1684 13.9453 13.4597 13.9453H9.74608C8.94988 13.9453 8.30188 14.5904 8.30188 15.3895C8.30188 16.1886 8.94697 16.8337 9.74608 16.8337H15.7263V18.4842H9.74608C8.03745 18.4842 6.65137 17.0981 6.65137 15.3895C6.65137 13.6808 8.03745 12.2948 9.74608 12.2948H13.4597C14.2559 12.2948 14.9039 11.6497 14.9039 10.8506C14.9039 10.0515 14.2588 9.40637 13.4597 9.40637H7.47953V7.75586Z",
                fill: "#101214"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.47967 11.0365C8.847 11.0365 9.95544 9.92806 9.95544 8.56073C9.95544 7.1934 8.847 6.08496 7.47967 6.08496C6.11235 6.08496 5.00391 7.1934 5.00391 8.56073C5.00391 9.92806 6.11235 11.0365 7.47967 11.0365Z",
                fill: "white"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.0018 15.3779H13.4629V19.9168H18.0018V15.3779Z",
                fill: "white"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.81771 7.75586C9.90488 8.00867 9.95138 8.276 9.95138 8.55787C9.95138 8.85717 9.89907 9.14194 9.80028 9.40637H7.47852V7.75586H9.81771Z",
                fill: "#82B536"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.95138 8.55787C9.95138 8.85717 9.89907 9.14194 9.80028 9.40637H7.47852V7.75586H9.81771C9.90488 8.00867 9.95138 8.276 9.95138 8.55787Z",
                fill: "#82B536"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.2916 19.5625V18.4815H13.4609V16.831H15.2916V15.75L17.1949 17.6562L15.2916 19.5625Z",
                fill: "#82B536"
            })
        ]
    });
};
const $80a046d009ef2432$export$4e04c809deb7a605 = ({ width: width = "24", height: height = "24" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "2",
                y: "2",
                width: "24",
                height: "24",
                rx: "12",
                fill: "var(--ds-surface-sunken, #F7F8F9)",
                fillOpacity: "0.07"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "26",
                rx: "13",
                stroke: "var(--ds-border-accent-gray, #758195)",
                strokeOpacity: "0.4",
                strokeWidth: "1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14 7.5C12.6193 7.5 11.5 8.61929 11.5 10C11.5 11.3807 12.6193 12.5 14 12.5C15.3807 12.5 16.5 11.3807 16.5 10C16.5 8.61929 15.3807 7.5 14 7.5ZM10 10C10 7.79086 11.7909 6 14 6C16.2091 6 18 7.79086 18 10C18 12.2091 16.2091 14 14 14C11.7909 14 10 12.2091 10 10ZM8 19C8 16.9289 9.67893 15.25 11.75 15.25H16.25C18.3211 15.25 20 16.9289 20 19V21H18.5V19C18.5 17.7574 17.4926 16.75 16.25 16.75H11.75C10.5074 16.75 9.5 17.7574 9.5 19V21H8V19Z",
                fill: "var(--ds-icon-accent-gray, #758195)"
            })
        ]
    });
};
const $80a046d009ef2432$export$10918ce732c13a50 = ({ width: width = "24", height: height = "24" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.0123 3.27288C12.3955 2.91395 11.6359 2.90911 11.0152 3.25836C11.0064 3.26485 10.9971 3.27094 10.9874 3.27658L10.9873 3.27663L10.986 3.27741C10.5867 3.51015 10.2848 3.8698 10.1189 4.28886C10.0268 4.52385 9.97754 4.77777 9.97754 5.03912V7.73475L13.3255 9.68348L13.3257 9.6836C14.1479 10.1605 14.6521 11.0421 14.6521 11.9981L14.6521 18.9571C14.6521 19.2693 14.5978 19.574 14.496 19.8594L18.9874 17.2439L18.9879 17.2436C19.6151 16.8799 19.9998 16.2078 19.9998 15.4776V8.51862C19.9998 7.79133 19.6128 7.11627 18.9875 6.75238L18.9874 6.75233L13.0123 3.27288Z",
                fill: "#579DFF"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0223 18.9609C14.0223 19.2226 13.9728 19.4768 13.8806 19.712C13.7144 20.1312 13.4121 20.4908 13.0125 20.7234L13.0124 20.7234C13.0027 20.7291 12.9934 20.7352 12.9846 20.7417C12.3639 21.0909 11.6044 21.0861 10.9876 20.7272L10.9875 20.7271L5.01241 17.2477L5.01232 17.2476C4.38699 16.8838 4 16.2087 4 15.4814L4 8.52239C4 7.79222 4.38472 7.12009 5.01191 6.75639L9.50381 4.14062C9.40202 4.426 9.34771 4.73069 9.34771 5.04289V12.0019C9.34771 12.9578 9.85176 13.8393 10.6739 14.3163L10.6743 14.3165L14.0223 16.2653V18.9609Z",
                fill: "#579DFF"
            })
        ]
    });
};



const $301b8558ed3f0a7a$export$43b7c33d6dda23ce = {
    GITHUB_STG: "com.github.integration.staging",
    GITHUB_PROD: "com.github.integration.production",
    BITBUCKET: "bitbucket"
};
const $301b8558ed3f0a7a$export$1f9b0361de4b5915 = ()=>{
    const currentEnv = (0, $a2299f428347f042$export$1038046b28a1d92e)();
    if (currentEnv === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).LOCAL) return undefined + (0, $b46b2bb54fe4f432$export$595fbe9beb48a7a7);
    return `${window.location.protocol}//${window.location.host}${0, $b46b2bb54fe4f432$export$595fbe9beb48a7a7}`;
};
const $301b8558ed3f0a7a$export$df7ddecd5c71c2ff = ()=>{
    const currentEnv = (0, $a2299f428347f042$export$1038046b28a1d92e)();
    const domain = currentEnv === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD ? (0, $b46b2bb54fe4f432$export$25eb080fef99f257) : (0, $b46b2bb54fe4f432$export$37e363941a7d06d9);
    return `https://${domain}`;
};
const $301b8558ed3f0a7a$export$d55f97af03376191 = [
    {
        id: $301b8558ed3f0a7a$export$43b7c33d6dda23ce.BITBUCKET,
        title: "Bitbucket for Jira",
        description: "Set up a DVCS connection between Bitbucket and Jira.",
        icon: (0, $7b02d682eb115277$exports.jsx)((0, $11e058f4355d4a2c$export$5fc1066e677788d4), {
            appearance: "brand",
            size: "small"
        }),
        primaryAction: {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))),
            label: "Connect Bitbucket",
            href: {
                link: $301b8558ed3f0a7a$export$1f9b0361de4b5915()
            },
            analyticEvent: {
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "connect-bbc",
                source: "home-page-setup"
            }
        },
        secondaryAction: {
            label: "How to connect Bitbucket to Jira",
            href: {
                link: (0, $b46b2bb54fe4f432$export$cc0ce9deeea0cdfa)
            },
            analyticEvent: {
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "connect-bbc-info-link",
                source: "home-page-setup"
            }
        },
        testId: "bitbucket-integration"
    },
    {
        id: $301b8558ed3f0a7a$export$43b7c33d6dda23ce.GITHUB_STG,
        title: "GitHub",
        description: "Use the GitHub for Jira app to connect.",
        icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$e8e65f186ccd8749), {}),
        primaryAction: {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))),
            label: "Install GitHub for Jira",
            href: {
                link: (0, $b46b2bb54fe4f432$export$ad9d2623b45ad758)
            },
            analyticEvent: {
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "install-gh4j-link",
                source: "home-page-setup"
            }
        },
        secondaryAction: {
            label: "How to connect GitHub for Jira",
            href: {
                link: (0, $b46b2bb54fe4f432$export$6a5f3b89af31068a)
            },
            analyticEvent: {
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "install-gh4j-info-link",
                source: "home-page-setup"
            }
        },
        testId: "github-integration"
    },
    {
        id: $301b8558ed3f0a7a$export$43b7c33d6dda23ce.GITHUB_PROD,
        title: "GitHub",
        description: "Setup a connection between GitHub and Jira",
        icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$e8e65f186ccd8749), {}),
        primaryAction: {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))),
            label: "Install GitHub for Jira",
            href: {
                link: (0, $b46b2bb54fe4f432$export$ad9d2623b45ad758)
            },
            analyticEvent: {
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "install-gh4j-link",
                source: "home-page-setup"
            }
        },
        secondaryAction: {
            label: "How to connect GitHub for Jira",
            href: {
                link: (0, $b46b2bb54fe4f432$export$6a5f3b89af31068a)
            },
            analyticEvent: {
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "install-gh4j-info-link",
                source: "home-page-setup"
            }
        },
        testId: "github-integration"
    }
];
const $301b8558ed3f0a7a$export$33e178c06d3d9c29 = ()=>{
    const currentEnv = (0, $a2299f428347f042$export$1038046b28a1d92e)();
    switch(currentEnv){
        case (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD:
            return [
                $301b8558ed3f0a7a$export$43b7c33d6dda23ce.GITHUB_PROD,
                $301b8558ed3f0a7a$export$43b7c33d6dda23ce.BITBUCKET
            ];
        case (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).DEV || (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).STAGING:
            return [
                $301b8558ed3f0a7a$export$43b7c33d6dda23ce.GITHUB_STG,
                $301b8558ed3f0a7a$export$43b7c33d6dda23ce.BITBUCKET
            ];
        default:
            return [
                $301b8558ed3f0a7a$export$43b7c33d6dda23ce.GITHUB_STG,
                $301b8558ed3f0a7a$export$43b7c33d6dda23ce.BITBUCKET
            ];
    }
};


const $b6d2d4a30bbd3a94$export$58b9d2cd8f6ce60 = "/gateway/api/devai-core/v1/dev-agents";
const $b6d2d4a30bbd3a94$var$BB_WORKSPACE_PATH = `${$b6d2d4a30bbd3a94$export$58b9d2cd8f6ce60}/bitbucket/getConnectedWorkspaces`;
const $b6d2d4a30bbd3a94$export$c24e3b99d7447d09 = (isBitbucketConnected)=>{
    const [error, setError] = (0, $acw62.useState)(null);
    const [workspacesList, setWorkspacesList] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const getWorkspacesList = async ()=>{
        setIsLoading(true);
        const request = (0, $7313551ab8168ced$export$2e2bcd8739ae039)($b6d2d4a30bbd3a94$var$BB_WORKSPACE_PATH, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        try {
            const res = await fetch(request);
            if (!res.ok) throw new Error(`http error status ${res.status} with text: ${res.statusText}`);
            const response = await res.json();
            setWorkspacesList(response.workspaces);
        } catch (e) {
            setError("An error has occured");
        }
        setIsLoading(false);
    };
    (0, $acw62.useEffect)(()=>{
        if (isBitbucketConnected) getWorkspacesList();
    }, [
        isBitbucketConnected
    ]);
    return {
        workspacesList: workspacesList,
        error: error,
        isLoading: isLoading
    };
};
const $b6d2d4a30bbd3a94$export$78d3cf5c6dc6dd13 = (uuid)=>{
    const baseUrl = (0, $301b8558ed3f0a7a$export$df7ddecd5c71c2ff)();
    return `${baseUrl}/${uuid}/workspace/settings/rovo-dev-agents`;
};
const $b6d2d4a30bbd3a94$export$5e21ab101f3fc83 = ()=>{
    const baseUrl = (0, $301b8558ed3f0a7a$export$df7ddecd5c71c2ff)();
    return `${baseUrl}/account/workspaces`;
};
const $b6d2d4a30bbd3a94$export$74e80d5b170ff6a1 = (workspacesList)=>{
    if (workspacesList === null) return [
        {
            redirectUrl: $b6d2d4a30bbd3a94$export$5e21ab101f3fc83()
        }
    ];
    const totalWorkspaces = workspacesList ? workspacesList.length : 0;
    if (totalWorkspaces === 0) return [
        {
            redirectUrl: (0, $301b8558ed3f0a7a$export$1f9b0361de4b5915)()
        }
    ];
    return workspacesList.length ? workspacesList.map((workspace)=>{
        return {
            redirectUrl: $b6d2d4a30bbd3a94$export$78d3cf5c6dc6dd13(workspace.uuid),
            name: workspace.name
        };
    }) : [];
};
const $b6d2d4a30bbd3a94$export$a930110fdb9ce1d3 = {
    title: "Choose a workspace to enable Code Reviewer",
    infoPanelDetails: {
        text: "To enable Code Reviewer on other workspaces, go to workspace settings in Bitbucket and select Rovo Dev Agents. ",
        redirectUrl: $b6d2d4a30bbd3a94$export$5e21ab101f3fc83(),
        linkText: "See all workspaces."
    }
};




var $fab5e6711ead5218$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($fab5e6711ead5218$exports, "__esModule", {
    value: true
});
$fab5e6711ead5218$exports.default = void 0;

var $fab5e6711ead5218$var$_react = $fab5e6711ead5218$var$_interopRequireDefault((parcelRequire("acw62")));

var $fab5e6711ead5218$var$_baseNew = $fab5e6711ead5218$var$_interopRequireDefault((parcelRequire("fqFky")));
function $fab5e6711ead5218$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab5e6711ead5218$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $fab5e6711ead5218$var$_react.default.createElement($fab5e6711ead5218$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$fab5e6711ead5218$var$InformationCircleIcon.displayName = "InformationCircleIcon";
var $fab5e6711ead5218$var$_default = $fab5e6711ead5218$exports.default = $fab5e6711ead5218$var$InformationCircleIcon;









const $4334c90a56947805$var$SmartCard = ({ bitbucketRedirectUrl: bitbucketRedirectUrl, workspaceName: workspaceName, analyticEvent: analyticEvent })=>{
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $11cad149381bd130$export$2e2bcd8739ae039), {
        interactionName: "link",
        href: bitbucketRedirectUrl,
        xcss: $4334c90a56947805$var$anchorStyles,
        target: "_blank",
        onClick: ()=>{
            if (analyticEvent) analyticsWebClient.sendUIEvent(analyticEvent);
        },
        children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
            xcss: $4334c90a56947805$var$smartCardStyles,
            children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                xcss: $4334c90a56947805$var$boxStyles,
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                    gap: "space.100",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
                            space: "space.100",
                            alignBlock: "center",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                xcss: $4334c90a56947805$var$workspaceTextStyles,
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                    weight: "regular",
                                    size: "medium",
                                    color: "color.link",
                                    children: workspaceName
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))), {
                            label: "Workspace Setting"
                        })
                    ]
                })
            })
        })
    });
};
const $4334c90a56947805$var$boxStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    backgroundColor: "elevation.surface.raised",
    borderRadius: "6px",
    border: "1px solid #E3E4F21F",
    borderColor: "color.border",
    paddingTop: "space.100",
    paddingRight: "space.150",
    paddingBottom: "space.100",
    paddingLeft: "space.150",
    gap: "space.050",
    ":hover": {
        backgroundColor: "elevation.surface.raised.hovered"
    }
});
const $4334c90a56947805$var$workspaceTextStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    font: "font.body",
    fontWeight: "font.weight.regular",
    color: "color.link"
});
const $4334c90a56947805$var$anchorStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    textDecoration: "none",
    color: "color.text",
    ":hover": {
        textDecoration: "none"
    }
});
const $4334c90a56947805$var$smartCardStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.100",
    paddingBottom: "space.100",
    gap: "space.050"
});
var $4334c90a56947805$export$2e2bcd8739ae039 = $4334c90a56947805$var$SmartCard;



const $306d50e9a638af0d$export$725c4181b2e34588 = ({ title: title, closeModalDialog: closeModalDialog, items: items, infoPanelDetails: infoPanelDetails })=>{
    const workspacesList = items.slice(0, 9); // we only want 10 workspaces.
    return (0, $7b02d682eb115277$exports.jsx)((0, $d935d45ecc0a58cd$export$2e2bcd8739ae039), {
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $49f7c216070fc3db$export$2e2bcd8739ae039), {
            onClose: closeModalDialog,
            testId: "workspaces-modal",
            width: "large",
            height: "auto",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $185e137d176d1262$export$2e2bcd8739ae039), {
                    hasCloseButton: true,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $dc702393df320999$export$2e2bcd8739ae039), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                            xcss: $306d50e9a638af0d$var$modalHeaderStyles,
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                                size: "large",
                                testId: "workspaces-modal-heading",
                                children: title
                            })
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $f7609201e9bc2976$export$2e2bcd8739ae039), {
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                        xcss: $306d50e9a638af0d$var$modalBodyStyles,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                xcss: $306d50e9a638af0d$var$modalListBoxStyles,
                                children: workspacesList.map((item, key)=>{
                                    return (0, $7b02d682eb115277$exports.jsx)((0, $4334c90a56947805$export$2e2bcd8739ae039), {
                                        bitbucketRedirectUrl: item.redirectUrl,
                                        workspaceName: item?.name || "" // if it gets here, then it must have workspace name
                                        ,
                                        analyticEvent: {
                                            action: "clicked",
                                            actionSubject: "link",
                                            actionSubjectId: "bbc-workspace-link",
                                            source: "home-page-agents"
                                        }
                                    }, key);
                                })
                            }),
                            items.length > 10 && (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                xcss: $306d50e9a638af0d$var$modalInfoPanelStyles,
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                                    gap: "space.100",
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $f9d9fd34a2dcabbd$export$2e2bcd8739ae039), {
                                        alignBlock: "start",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                                xcss: $306d50e9a638af0d$var$infoPanelIconStyles,
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fab5e6711ead5218$exports))), {
                                                    label: "Information",
                                                    color: "var(--ds-icon-accent-blue, #1D7AFC)"
                                                })
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                                xcss: $306d50e9a638af0d$var$modalInfoPanelTextBoxStyles,
                                                children: (0, $7b02d682eb115277$exports.jsxs)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                                    weight: "regular",
                                                    size: "medium",
                                                    children: [
                                                        infoPanelDetails.text,
                                                        (0, $7b02d682eb115277$exports.jsx)((0, $211777b1e6e6df36$export$2e2bcd8739ae039), {
                                                            href: infoPanelDetails.redirectUrl,
                                                            target: "_blank",
                                                            children: infoPanelDetails.linkText
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $246b20cce3342d64$export$2e2bcd8739ae039), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        onClick: closeModalDialog,
                        testId: "workspaces-modal-close-button",
                        children: "Close"
                    })
                })
            ]
        })
    });
};
const $306d50e9a638af0d$var$modalHeaderStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.300",
    paddingRight: "space.300",
    paddingBottom: "space.200",
    paddingLeft: "space.300",
    gap: "space.100"
});
const $306d50e9a638af0d$var$modalBodyStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingRight: "space.300",
    paddingLeft: "space.300"
});
const $306d50e9a638af0d$var$modalListBoxStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.200",
    paddingBottom: "space.200",
    gap: "space.100"
});
const $306d50e9a638af0d$var$modalInfoPanelStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "fill",
    backgroundColor: "color.background.information",
    borderRadius: "3px",
    padding: "space.100"
});
const $306d50e9a638af0d$var$modalInfoPanelTextBoxStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingRight: "space.050",
    paddingLeft: "space.050",
    gap: "space.100"
});
const $306d50e9a638af0d$var$infoPanelIconStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    padding: "space.050"
});



const $7c49d4bd62a94acc$var$primaryActionStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: "border.radius.200"
});
const $7c49d4bd62a94acc$export$7b71f667336697ee = ({ showBitbucket: showBitbucket, showGitHub: showGitHub })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const { workspacesList: workspacesList, isLoading: isLoading } = (0, $b6d2d4a30bbd3a94$export$c24e3b99d7447d09)(showBitbucket);
    const [isWorkspacesModalOpen, setIsWorkspacesModalOpen] = (0, $acw62.useState)(false);
    const bitbucketRedirectUrls = (0, $b6d2d4a30bbd3a94$export$74e80d5b170ff6a1)(workspacesList);
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    const getWorkspaceLink = ()=>{
        if (!isLoading) {
            if (bitbucketRedirectUrls.length === 1) return bitbucketRedirectUrls.at(0)?.redirectUrl;
            if (bitbucketRedirectUrls.length === 0) return (0, $b6d2d4a30bbd3a94$export$5e21ab101f3fc83)();
        }
        return undefined;
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            isWorkspacesModalOpen && (0, $7b02d682eb115277$exports.jsx)((0, $306d50e9a638af0d$export$725c4181b2e34588), {
                closeModalDialog: ()=>setIsWorkspacesModalOpen(!isWorkspacesModalOpen),
                title: (0, $b6d2d4a30bbd3a94$export$a930110fdb9ce1d3).title,
                infoPanelDetails: (0, $b6d2d4a30bbd3a94$export$a930110fdb9ce1d3).infoPanelDetails,
                items: bitbucketRedirectUrls // if a modal is being shown, it would have workspaces
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                    space: "space.100",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $9394c3c3f1484d88$export$2e2bcd8739ae039), {
                        isOpen: isOpen,
                        onClose: ()=>setIsOpen(false),
                        placement: "bottom-start",
                        content: ()=>(0, $7b02d682eb115277$exports.jsxs)((0, $da28a647dcd0fc3c$export$2e2bcd8739ae039), {
                                children: [
                                    showBitbucket && (0, $7b02d682eb115277$exports.jsx)((0, $aa7456d8790c6386$export$2e2bcd8739ae039), {
                                        isDisabled: isLoading,
                                        elemBefore: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($01f2c5ba34969e08$exports))), {
                                            label: ""
                                        }),
                                        description: "Configure Code Reviewer for Bitbucket",
                                        href: getWorkspaceLink(),
                                        onClick: ()=>{
                                            if (bitbucketRedirectUrls.length > 1) setIsWorkspacesModalOpen(!isWorkspacesModalOpen);
                                            analyticsWebClient.sendUIEvent({
                                                action: "clicked",
                                                actionSubject: "button",
                                                actionSubjectId: "code-reviewer-bbc-settings",
                                                source: "home-page-agents"
                                            });
                                        },
                                        target: "_blank",
                                        testId: "code-reviewer-bbc-settings-button",
                                        children: "Bitbucket"
                                    }),
                                    showGitHub && (0, $7b02d682eb115277$exports.jsx)((0, $aa7456d8790c6386$export$2e2bcd8739ae039), {
                                        elemBefore: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($01f2c5ba34969e08$exports))), {
                                            label: ""
                                        }),
                                        description: "Configure Code Reviewer for GitHub",
                                        href: (0, $b3c27da72be923c3$export$d278c9a4e4cdafa2),
                                        onClick: ()=>{
                                            analyticsWebClient.sendUIEvent({
                                                action: "clicked",
                                                actionSubject: "button",
                                                actionSubjectId: "code-reviewer-gh-settings",
                                                source: "home-page-agents"
                                            });
                                        },
                                        testId: "code-reviewer-github-settings-button",
                                        children: "GitHub"
                                    })
                                ]
                            }),
                        trigger: (triggerProps)=>(0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                xcss: $7c49d4bd62a94acc$var$primaryActionStyles,
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                                    ...triggerProps,
                                    appearance: "subtle",
                                    iconAfter: ()=>(0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8550fae2a8eb6759$exports))), {
                                            label: ""
                                        }),
                                    onClick: ()=>setIsOpen(!isOpen),
                                    spacing: "compact",
                                    testId: "enable-code-reviewer",
                                    children: "Enable Code Reviewer on repositories"
                                })
                            })
                    })
                })
            })
        ]
    });
};




const $26c5ad5f0032e1b2$var$getCodingAgentsLearnMoreAction = ()=>{
    return {
        label: "Read about coding agents",
        href: {
            link: (0, $b46b2bb54fe4f432$export$c39cfd122465c04e)
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "coding-agents-info-link",
            source: "home-page-agents"
        }
    };
};
const $26c5ad5f0032e1b2$var$getCodingAgentsPrimaryAction = ()=>{
    if ((0, $098873af10a85f8f$export$b40ec24ac8275656)("coding-agents-limited-beta")) return $26c5ad5f0032e1b2$var$getCodingAgentsLearnMoreAction(); // TODO: Explore agents link is not yet ready
    return {
        label: "Join waitlist",
        href: {
            link: (0, $b46b2bb54fe4f432$export$f646aec6c096a2df),
            target: "_blank"
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "coding-agents-waitlist",
            source: "home-page-agents"
        }
    };
};
// TODO: Explore agents link is not yet ready
const $26c5ad5f0032e1b2$var$getCodingAgentsSecondaryAction = ()=>{
    if ((0, $098873af10a85f8f$export$b40ec24ac8275656)("coding-agents-limited-beta")) return undefined;
    return $26c5ad5f0032e1b2$var$getCodingAgentsLearnMoreAction();
};
// TODO: Explore agents link is not yet ready
// const getCodingAgentsSettingsAction = (): Action => {
// 	return {
// 		label: 'Explore agents',
// 		href: {
// 			link: '',
// 		},
// 	};
// };
const $26c5ad5f0032e1b2$var$getCodePlannerLearnMoreAction = ()=>{
    return {
        label: "Read about Code Planner",
        href: {
            link: (0, $b46b2bb54fe4f432$export$e4425ce4e2c57457)
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "code-planner-info-link",
            source: "home-page-agents"
        }
    };
};
const $26c5ad5f0032e1b2$var$getCodePlannerPrimaryAction = ()=>{
    if ((0, $098873af10a85f8f$export$b40ec24ac8275656)("code-planner-agent-limited-beta")) return {
        label: "Enable Code Planner on projects",
        href: {
            link: (0, $b3c27da72be923c3$export$122dbbe6a3dd8f50),
            target: "_self"
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "code-planner-settings",
            source: "home-page-agents"
        }
    };
    return {
        label: "Join waitlist",
        href: {
            link: (0, $b46b2bb54fe4f432$export$f646aec6c096a2df),
            target: "_blank"
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "code-planner-settings-waitlist",
            source: "home-page-agents"
        },
        testId: "enable-code-planner"
    };
};
const $26c5ad5f0032e1b2$var$getCodeReviewerLearnMoreAction = ()=>{
    return {
        label: "Read about Code Reviewer",
        href: {
            link: (0, $b46b2bb54fe4f432$export$3255dadb03b35a28)
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "code-reviewer-info-link",
            source: "home-page-agents"
        }
    };
};
const $26c5ad5f0032e1b2$var$getCodeReviewerSettingsAction = (showBitbucket, showGitHub)=>{
    return {
        label: "Enable Code Reviewer on repositories",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $7c49d4bd62a94acc$export$7b71f667336697ee), {
            showBitbucket: showBitbucket,
            showGitHub: showGitHub
        })
    };
};
const $26c5ad5f0032e1b2$var$getDeploymentSummarizerLearnMoreAction = ()=>{
    return {
        label: "Read about Deployment Summarizer",
        href: {
            link: (0, $b46b2bb54fe4f432$export$f7cf5dee5734594c)
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "deployment-summarizer-info-link",
            source: "home-page-agents"
        }
    };
};
const $26c5ad5f0032e1b2$var$getDeploymentSummarizeSettingsAction = ()=>{
    return {
        label: "Set up Deployment Summarizer",
        href: {
            link: (0, $b46b2bb54fe4f432$export$67efc9ea144c1797)
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "deployment-summarizer-settings",
            source: "home-page-agents"
        }
    };
};
const $26c5ad5f0032e1b2$var$getPipelineTroubleshooterLearnMoreAction = ()=>{
    return {
        label: "Read about Pipeline Troubleshooter",
        href: {
            link: (0, $b46b2bb54fe4f432$export$7b0f8fec4b919ab3)
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "pipeline-troubleshooter-info-link",
            source: "home-page-agents"
        }
    };
};
const $26c5ad5f0032e1b2$var$getPipelineTroubleshooterSettingsAction = ()=>{
    return {
        label: "Set up Pipeline Troubleshooter",
        href: {
            link: (0, $b46b2bb54fe4f432$export$b48ea3f417d3c529)
        },
        analyticEvent: {
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "pipeline-troubleshooter-settings",
            source: "home-page-agents"
        }
    };
};
const $26c5ad5f0032e1b2$var$getCodeReviewerPrimaryAction = (isUserProductAdmin, hasScmIntegrations, isBitbucketConnected, isGitHubConnected)=>{
    if (!isUserProductAdmin) return $26c5ad5f0032e1b2$var$getCodeReviewerLearnMoreAction();
    return hasScmIntegrations ? $26c5ad5f0032e1b2$var$getCodeReviewerSettingsAction(isBitbucketConnected, isGitHubConnected) : $26c5ad5f0032e1b2$var$getCodeReviewerLearnMoreAction();
};
const $26c5ad5f0032e1b2$export$80a6dbd652bdbd9e = (isUserProductAdmin, hasScmIntegrations, isBitbucketConnected, isGitHubConnected)=>{
    return [
        {
            title: "Code Planner",
            description: "Writes a coding plan based on a work item.",
            icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$1fbfda8af1f68ad9), {}),
            primaryAction: isUserProductAdmin ? $26c5ad5f0032e1b2$var$getCodePlannerPrimaryAction() : $26c5ad5f0032e1b2$var$getCodePlannerLearnMoreAction(),
            secondaryAction: isUserProductAdmin ? $26c5ad5f0032e1b2$var$getCodePlannerLearnMoreAction() : undefined,
            testId: "code-planner",
            priority: 1,
            isAvailable: (0, $098873af10a85f8f$export$b40ec24ac8275656)("code-planner-agent-limited-beta")
        },
        {
            title: "Coding Agents",
            description: "Generate code to complete tasks.",
            icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$6beb87409d36db16), {}),
            primaryAction: isUserProductAdmin ? $26c5ad5f0032e1b2$var$getCodingAgentsPrimaryAction() : $26c5ad5f0032e1b2$var$getCodingAgentsLearnMoreAction(),
            secondaryAction: isUserProductAdmin ? $26c5ad5f0032e1b2$var$getCodingAgentsSecondaryAction() : undefined,
            testId: "coding-agents",
            priority: 2,
            isAvailable: (0, $098873af10a85f8f$export$b40ec24ac8275656)("coding-agents-limited-beta")
        },
        {
            title: "Code Reviewer",
            description: "Reads pull requests and adds feedback.",
            icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$a60fe8618e9cd1ae), {}),
            primaryAction: $26c5ad5f0032e1b2$var$getCodeReviewerPrimaryAction(isUserProductAdmin, hasScmIntegrations, isBitbucketConnected, isGitHubConnected),
            secondaryAction: isUserProductAdmin && hasScmIntegrations ? $26c5ad5f0032e1b2$var$getCodeReviewerLearnMoreAction() : undefined,
            testId: "code-reviewer",
            priority: 3,
            isAvailable: true
        },
        {
            title: "Pipeline Troubleshooter",
            lozenge: {
                text: "Bitbucket only",
                appearance: "default",
                isBold: true
            },
            description: "Helps identify and fix pipeline step failures.",
            icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$fc1703dc7d632678), {}),
            primaryAction: isUserProductAdmin && isBitbucketConnected ? $26c5ad5f0032e1b2$var$getPipelineTroubleshooterSettingsAction() : $26c5ad5f0032e1b2$var$getPipelineTroubleshooterLearnMoreAction(),
            secondaryAction: isUserProductAdmin && isBitbucketConnected ? $26c5ad5f0032e1b2$var$getPipelineTroubleshooterLearnMoreAction() : undefined,
            testId: "pipeline-troubleshooter",
            priority: 4,
            isAvailable: true
        },
        {
            title: "Deployment Summarizer",
            lozenge: {
                text: "Bitbucket only",
                appearance: "default",
                isBold: true
            },
            description: "Summarizes all changes in a deployment.",
            icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$29a768e77dec31dc), {}),
            primaryAction: isUserProductAdmin && isBitbucketConnected ? $26c5ad5f0032e1b2$var$getDeploymentSummarizeSettingsAction() : $26c5ad5f0032e1b2$var$getDeploymentSummarizerLearnMoreAction(),
            secondaryAction: isUserProductAdmin && isBitbucketConnected ? $26c5ad5f0032e1b2$var$getDeploymentSummarizerLearnMoreAction() : undefined,
            testId: "deployment-summarizer",
            priority: 5,
            isAvailable: true
        },
        {
            title: "Code search in Rovo chat",
            description: "Search your codebase using Rovo chat.",
            icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$10918ce732c13a50), {}),
            primaryAction: {
                label: "About code search in Rovo chat",
                href: {
                    link: (0, $b46b2bb54fe4f432$export$da4fecf2d95db63b)
                },
                analyticEvent: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "code-search-info-link",
                    source: "home-page-agents"
                }
            },
            testId: "code-search",
            priority: 6,
            isAvailable: false
        }
    ];
};




var $a76e4d761226cb3c$var$_capabilities_IntegrationsConfigStates;
const $a76e4d761226cb3c$var$suggestionsStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.200"
});
const $a76e4d761226cb3c$var$capabilitiesSectionWrapper = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.500"
});
const $a76e4d761226cb3c$var$responsiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xxs]: {
        gridTemplateColumns: "repeat(1, 1fr)"
    },
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.sm]: {
        gridTemplateColumns: "repeat(2, 1fr)"
    },
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.md]: {
        gridTemplateColumns: "repeat(3, 1fr)"
    }
});

const $a76e4d761226cb3c$export$991fe453de1a0a4c = ({ isUserProductAdmin: isUserProductAdmin = true, hasScmIntegrations: hasScmIntegrations = false, integrationsConfigStatesFragment: integrationsConfigStatesFragment })=>{
    const integrations = (0, $2d93712440e0508b$exports.useFragment)($a76e4d761226cb3c$var$_capabilities_IntegrationsConfigStates !== void 0 ? $a76e4d761226cb3c$var$_capabilities_IntegrationsConfigStates : $a76e4d761226cb3c$var$_capabilities_IntegrationsConfigStates = (parcelRequire("atfwD")), integrationsConfigStatesFragment);
    const configStates = Object.fromEntries((integrations || []).map((edge)=>[
            edge.node.id,
            edge.node.config.edges[0]?.node?.status || "NOT_CONFIGURED"
        ]));
    const requiredProviders = (0, $301b8558ed3f0a7a$export$33e178c06d3d9c29)();
    const configuredProviders = requiredProviders.filter((providerId)=>configStates[providerId] === "CONFIGURED");
    const isBitbucketConnected = configuredProviders.includes((0, $301b8558ed3f0a7a$export$43b7c33d6dda23ce).BITBUCKET);
    const isGitHubConnected = configuredProviders.includes((0, $301b8558ed3f0a7a$export$43b7c33d6dda23ce).GITHUB_PROD) || configuredProviders.includes((0, $301b8558ed3f0a7a$export$43b7c33d6dda23ce).GITHUB_STG);
    const capabilities = (0, $26c5ad5f0032e1b2$export$80a6dbd652bdbd9e)(isUserProductAdmin, hasScmIntegrations, isBitbucketConnected, isGitHubConnected);
    const availableCapabilities = (0, $acw62.useMemo)(()=>{
        return capabilities.filter((capability)=>capability.isAvailable).sort((a, b)=>a.priority - b.priority);
    }, [
        capabilities
    ]);
    const comingSoonCapabilities = (0, $acw62.useMemo)(()=>{
        return capabilities.filter((capability)=>!capability.isAvailable).sort((a, b)=>a.priority - b.priority);
    }, [
        capabilities
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        xcss: $a76e4d761226cb3c$var$capabilitiesSectionWrapper,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                space: "space.150",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                        size: "xlarge",
                        testId: "capabilities-section-heading",
                        children: "Agents"
                    }),
                    !isUserProductAdmin && (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                        as: "p",
                        children: "You must be a Rovo Dev Agents admin to enable, disable or manage agents on this site. For more information, talk to your site admin."
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                xcss: $a76e4d761226cb3c$var$suggestionsStyles,
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                    space: "space.200",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                            space: "space.200",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
                                xcss: $a76e4d761226cb3c$var$responsiveStyles,
                                gap: "space.200",
                                children: availableCapabilities.map((capability, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $d34d09f118d159f8$export$60332b2344f7fe41), {
                                        description: capability.description,
                                        icon: capability.icon,
                                        primaryAction: capability.primaryAction,
                                        secondaryAction: capability.secondaryAction,
                                        title: capability.title,
                                        lozenge: capability.lozenge
                                    }, `capability-${index}`))
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                            space: "space.200",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                    size: "large",
                                    weight: "medium",
                                    children: "Coming soon"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
                                    xcss: $a76e4d761226cb3c$var$responsiveStyles,
                                    gap: "space.200",
                                    children: comingSoonCapabilities.map((capability, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $d34d09f118d159f8$export$60332b2344f7fe41), {
                                            description: capability.description,
                                            icon: capability.icon,
                                            primaryAction: capability.primaryAction,
                                            secondaryAction: capability.secondaryAction,
                                            title: capability.title,
                                            lozenge: capability.lozenge
                                        }, `capability-${index}`))
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};






var $5edd8119dea8c7fd$exports = {};
$5edd8119dea8c7fd$exports = new URL("chat.ad58c92b.svg", import.meta.url).toString();




const $4cc664b792d3d446$export$175e500a48a60fd2 = ()=>{
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        xcss: $4cc664b792d3d446$var$feedbackSectionWrapper,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
            xcss: $4cc664b792d3d446$var$feedbackCardStyles,
            children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                xcss: $4cc664b792d3d446$var$textWrapperStyles,
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                    space: "space.150",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                            size: "medium",
                            testId: "feedback-section-heading",
                            children: "Talk to the community"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                            as: "p",
                            children: "Join our Rovo Dev Agents group to ask questions and get advice from product experts."
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $211777b1e6e6df36$export$2e2bcd8739ae039), {
                            href: "https://community.atlassian.com/forums/Rovo-Dev-AI-Agents-Beta/gh-p/rovo-dev-ai-agents",
                            appearance: "subtle",
                            target: "_blank",
                            onClick: ()=>{
                                analyticsWebClient.sendUIEvent({
                                    action: "clicked",
                                    actionSubject: "link",
                                    actionSubjectId: "community-link",
                                    source: "home-page-feedback"
                                });
                            },
                            children: "Visit the Rovo Dev Agents group"
                        })
                    ]
                })
            })
        })
    });
};
const $4cc664b792d3d446$var$feedbackCardStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    padding: "space.600",
    backgroundColor: "elevation.surface.overlay",
    "::after": {
        content: '""',
        position: "absolute",
        top: "-10px",
        right: "space.0",
        width: "198px",
        height: "198px",
        background: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($5edd8119dea8c7fd$exports)))}) no-repeat`
    },
    position: "relative",
    borderRadius: "border.radius.100",
    border: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $4cc664b792d3d446$var$feedbackSectionWrapper = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.500"
});
const $4cc664b792d3d446$var$textWrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "calc(100% - 150px)"
});

















const $e6141e7244aa70cb$var$getAdminHubLink = (orgId, siteId)=>{
    const currentEnv = (0, $a2299f428347f042$export$1038046b28a1d92e)();
    const baseUrl = currentEnv === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD ? (0, $b46b2bb54fe4f432$export$627321b82c429923) : (0, $b46b2bb54fe4f432$export$944e1ecf8da9f253);
    return `${baseUrl}/o/${orgId}/products/devai/${siteId}`;
};
const $e6141e7244aa70cb$var$getSubscriptionsLink = (orgId, siteId, devAiEntitlementID)=>{
    const currentEnv = (0, $a2299f428347f042$export$1038046b28a1d92e)();
    const baseUrl = currentEnv === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD ? (0, $b46b2bb54fe4f432$export$627321b82c429923) : (0, $b46b2bb54fe4f432$export$944e1ecf8da9f253);
    return `${baseUrl}/billing/o/${orgId}/${siteId}/entitlement/${devAiEntitlementID}`;
};
const $e6141e7244aa70cb$export$92cce82fc992f15 = ()=>{
    const currentEnv = (0, $a2299f428347f042$export$1038046b28a1d92e)();
    if (currentEnv === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).LOCAL) return undefined + (0, $b46b2bb54fe4f432$export$deed3f587f71617d);
    const baseGithubIntegrationUrl = `${window.location.protocol}//${window.location.host}`;
    return currentEnv === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD ? `${baseGithubIntegrationUrl}${0, $b46b2bb54fe4f432$export$d76ba9bdae389e5f}` : `${baseGithubIntegrationUrl}${0, $b46b2bb54fe4f432$export$deed3f587f71617d}`;
};
const $e6141e7244aa70cb$export$4927c3bfb9ef0d23 = (orgId, siteId, devAiEntitlementID)=>{
    return [
        {
            title: "Users",
            description: "Add or remove users and administrators for Rovo Dev Agents.",
            icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$4e04c809deb7a605), {}),
            primaryAction: {
                label: "Manage user access",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))),
                href: {
                    link: $e6141e7244aa70cb$var$getAdminHubLink(orgId, siteId)
                },
                analyticEvent: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "manage-users",
                    source: "home-page-manage"
                }
            },
            testId: "manage-users"
        },
        {
            title: "Billing",
            description: "View and manage your subscription status for Rovo Dev Agents.",
            icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$5f000633c2c20481), {}),
            primaryAction: {
                label: "Manage subscription",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))),
                href: {
                    link: devAiEntitlementID !== null ? $e6141e7244aa70cb$var$getSubscriptionsLink(orgId, siteId, devAiEntitlementID) : ""
                },
                analyticEvent: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "manage-subscription",
                    source: "home-page-manage"
                }
            },
            testId: "manage-subscription"
        }
    ];
};



var $3f714345c43d529e$var$_manage_IntegrationsConfigStates;
const $3f714345c43d529e$var$suggestionsStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.200"
});
const $3f714345c43d529e$var$manageSectionWrapper = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.500"
});
const $3f714345c43d529e$var$responsiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xxs]: {
        gridTemplateColumns: "repeat(1, 1fr)"
    },
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.sm]: {
        gridTemplateColumns: "repeat(2, 1fr)"
    },
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.md]: {
        gridTemplateColumns: "repeat(3, 1fr)"
    }
});

const $3f714345c43d529e$export$9313e7897c3e1812 = ({ integrationsConfigStatesFragment: integrationsConfigStatesFragment })=>{
    const integrations = (0, $2d93712440e0508b$exports.useFragment)($3f714345c43d529e$var$_manage_IntegrationsConfigStates !== void 0 ? $3f714345c43d529e$var$_manage_IntegrationsConfigStates : $3f714345c43d529e$var$_manage_IntegrationsConfigStates = (parcelRequire("1fqzs")), integrationsConfigStatesFragment);
    const configStates = Object.fromEntries((integrations || []).map((edge)=>[
            edge.node.id,
            edge.node.config.edges[0]?.node?.status || "NOT_CONFIGURED"
        ]));
    const requiredProviders = (0, $301b8558ed3f0a7a$export$33e178c06d3d9c29)();
    const configuredProviders = requiredProviders.filter((providerId)=>configStates[providerId] === "CONFIGURED");
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { cloudId: cloudId, orgId: orgId, devaiEntitlementId: devaiEntitlementId } = tenantContexts[0];
    const getSCMIntegrationsDescription = ()=>{
        if (configuredProviders.length === 0) return "No code management tools are connected";
        if (configuredProviders.length === 1) return "There is 1 code management tool connected";
        return `${configuredProviders.length} code management tools are connected`;
    };
    const isGithubConnected = configuredProviders.some((provider)=>provider === (0, $301b8558ed3f0a7a$export$43b7c33d6dda23ce).GITHUB_PROD || provider === (0, $301b8558ed3f0a7a$export$43b7c33d6dda23ce).GITHUB_STG);
    const isBitbucketConnected = configuredProviders.includes((0, $301b8558ed3f0a7a$export$43b7c33d6dda23ce).BITBUCKET);
    const managementTools = (0, $e6141e7244aa70cb$export$4927c3bfb9ef0d23)(orgId, cloudId, devaiEntitlementId);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        xcss: $3f714345c43d529e$var$manageSectionWrapper,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                space: "space.150",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                    size: "xlarge",
                    testId: "manage-section-heading",
                    children: "Manage Rovo Dev Agents"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                xcss: $3f714345c43d529e$var$suggestionsStyles,
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
                    xcss: $3f714345c43d529e$var$responsiveStyles,
                    gap: "space.200",
                    children: [
                        managementTools.map((tool, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $d34d09f118d159f8$export$60332b2344f7fe41), {
                                description: tool.description,
                                icon: tool.icon,
                                primaryAction: tool.primaryAction,
                                secondaryAction: tool.secondaryAction,
                                title: tool.title
                            }, `tool-${index}`)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $d34d09f118d159f8$export$60332b2344f7fe41), {
                            description: getSCMIntegrationsDescription(),
                            icon: (0, $7b02d682eb115277$exports.jsx)((0, $80a046d009ef2432$export$a2d9bd0613a7e60f), {}),
                            primaryAction: isGithubConnected ? {
                                label: "Manage GitHub",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))),
                                href: {
                                    link: (0, $e6141e7244aa70cb$export$92cce82fc992f15)()
                                },
                                analyticEvent: {
                                    action: "clicked",
                                    actionSubject: "link",
                                    actionSubjectId: "manage-gh-link",
                                    source: "home-page-manage"
                                }
                            } : {
                                label: "Install GitHub for Jira",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))),
                                href: {
                                    link: (0, $b46b2bb54fe4f432$export$ad9d2623b45ad758)
                                },
                                analyticEvent: {
                                    action: "clicked",
                                    actionSubject: "link",
                                    actionSubjectId: "install-gh4j-link",
                                    source: "home-page-manage"
                                }
                            },
                            secondaryAction: isBitbucketConnected ? {
                                label: "Manage Bitbucket",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))),
                                href: {
                                    link: (0, $301b8558ed3f0a7a$export$1f9b0361de4b5915)()
                                },
                                analyticEvent: {
                                    action: "clicked",
                                    actionSubject: "link",
                                    actionSubjectId: "manage-bbc",
                                    source: "home-page-manage"
                                }
                            } : {
                                label: "Connect Bitbucket",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0c4b434f06c20d3$exports))),
                                href: {
                                    link: (0, $301b8558ed3f0a7a$export$1f9b0361de4b5915)()
                                },
                                analyticEvent: {
                                    action: "clicked",
                                    actionSubject: "link",
                                    actionSubjectId: "connect-bbc",
                                    source: "home-page-manage"
                                }
                            },
                            title: "Code management tools",
                            uniformActions: true
                        })
                    ]
                })
            })
        ]
    });
};




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jjlaj = parcelRequire("jjlaj");
var $57580ffdfef15295$var$defaultGridSize = 8;
var $57580ffdfef15295$export$74797698e12f8baa = 12;
var $57580ffdfef15295$export$b8241a1616ab1b96 = $57580ffdfef15295$var$defaultGridSize * 10;
var $57580ffdfef15295$export$2a89a65a43bab52d = {
    comfortable: $57580ffdfef15295$var$defaultGridSize * 5,
    cosy: $57580ffdfef15295$var$defaultGridSize * 2,
    compact: $57580ffdfef15295$var$defaultGridSize * 0.5
};
var $57580ffdfef15295$export$8ec7372efd74b753 = "cosy";
var $57580ffdfef15295$export$d77f83c3d17a7b8a = 52;
var $57580ffdfef15295$export$f8725d21f81f3e01 = 0;
var $57580ffdfef15295$export$2303d2bd9eeff99a = "fixed";
var $57580ffdfef15295$export$9ddc3632bbfb8966 = "--ds-columns-num";
var $57580ffdfef15295$export$8b7e31f391e6e681 = "--ds-column-span";
var $57580ffdfef15295$export$936829b4511db3e4 = "--ds-grid-spacing";


var $51d023ef8ca0c717$var$bannerStyles = (0, $jjlaj.css)({
    width: "100%",
    position: "fixed"
});
var $51d023ef8ca0c717$var$bannerContainerStyles = (0, $jjlaj.css)({
    width: "100%",
    position: "relative",
    zIndex: 3,
    flex: "1 0 auto",
    transition: "height 0.25s ease-in-out"
});
var $51d023ef8ca0c717$var$pageContentStyles = (0, $jjlaj.css)({
    minWidth: 0,
    position: "relative",
    zIndex: 1,
    flex: "1 1 auto"
});
var $51d023ef8ca0c717$var$wrapperStyles = (0, $jjlaj.css)({
    display: "flex",
    width: "100%",
    minHeight: "100%",
    flexDirection: "column"
});
var $51d023ef8ca0c717$var$mainContainerStyles = (0, $jjlaj.css)({
    display: "flex",
    flex: "1 1 auto"
});
var $51d023ef8ca0c717$var$navigationStyles = (0, $jjlaj.css)({
    position: "relative",
    zIndex: 2
});
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $51d023ef8ca0c717$var$Page = function Page(_ref) {
    var _ref$isBannerOpen = _ref.isBannerOpen, isBannerOpen = _ref$isBannerOpen === void 0 ? false : _ref$isBannerOpen, _ref$bannerHeight = _ref.bannerHeight, bannerHeight = _ref$bannerHeight === void 0 ? (0, $57580ffdfef15295$export$d77f83c3d17a7b8a) : _ref$bannerHeight, banner = _ref.banner, navigation = _ref.navigation, children = _ref.children, testId = _ref.testId;
    return (0, $jjlaj.jsx)("div", {
        css: $51d023ef8ca0c717$var$wrapperStyles,
        "data-testid": testId
    }, banner ? (0, $jjlaj.jsx)("div", {
        css: $51d023ef8ca0c717$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? "".concat(bannerHeight, "px") : "0"
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? "".concat(testId, "--banner-container") : undefined
    }, (0, $jjlaj.jsx)("div", {
        css: $51d023ef8ca0c717$var$bannerStyles
    }, banner)) : null, (0, $jjlaj.jsx)("div", {
        css: $51d023ef8ca0c717$var$mainContainerStyles
    }, (0, $jjlaj.jsx)("div", {
        css: $51d023ef8ca0c717$var$navigationStyles
    }, navigation), (0, $jjlaj.jsx)("div", {
        css: $51d023ef8ca0c717$var$pageContentStyles
    }, children)));
};
var $51d023ef8ca0c717$export$2e2bcd8739ae039 = $51d023ef8ca0c717$var$Page;




var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");


var $acw62 = parcelRequire("acw62");

var $c8e1ff5e10432b88$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $acw62.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $57580ffdfef15295$export$8ec7372efd74b753),
    columns: (0, $57580ffdfef15295$export$74797698e12f8baa)
});


/**
 * Determines the method by which column width is calculated.
 */ var $ddcf36d926e8a699$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    ColumnVariant["Auto"] = "auto";
    ColumnVariant["Bounded"] = "bounded";
    ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($ddcf36d926e8a699$var$ColumnVariant || {});
var $ddcf36d926e8a699$var$getVariant = function getVariant(_ref) {
    var medium = _ref.medium, columns = _ref.columns;
    if (medium === (0, $57580ffdfef15295$export$f8725d21f81f3e01)) return $ddcf36d926e8a699$var$ColumnVariant.Auto;
    else if (medium < columns) return $ddcf36d926e8a699$var$ColumnVariant.Bounded;
    return $ddcf36d926e8a699$var$ColumnVariant.FullWidth;
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ var $ddcf36d926e8a699$var$availableWidth = "99.9999%";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $ddcf36d926e8a699$var$singleColumnWidth = "(".concat($ddcf36d926e8a699$var$availableWidth, " / var(").concat((0, $57580ffdfef15295$export$9ddc3632bbfb8966), "))");
var $ddcf36d926e8a699$var$gridColumnStyles = (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: "calc(".concat($ddcf36d926e8a699$var$singleColumnWidth, " - var(").concat((0, $57580ffdfef15295$export$936829b4511db3e4), "))"),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: "0 calc(var(".concat((0, $57580ffdfef15295$export$936829b4511db3e4), ") / 2)"),
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: "break-word"
});
var $ddcf36d926e8a699$var$gridColumnWidthStyles = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $ddcf36d926e8a699$var$ColumnVariant.Auto, (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "calc(100% - var(".concat((0, $57580ffdfef15295$export$936829b4511db3e4), "))"),
    flexBasis: "auto"
})), $ddcf36d926e8a699$var$ColumnVariant.Bounded, (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "calc(".concat($ddcf36d926e8a699$var$singleColumnWidth, " *  var(").concat((0, $57580ffdfef15295$export$8b7e31f391e6e681), ") - var(").concat((0, $57580ffdfef15295$export$936829b4511db3e4), "))"),
    flexBasis: "100%"
})), $ddcf36d926e8a699$var$ColumnVariant.FullWidth, (0, $jjlaj.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "calc(100% - var(".concat((0, $57580ffdfef15295$export$936829b4511db3e4), "))"),
    flexBasis: "100%"
}));
var $ddcf36d926e8a699$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $acw62.createContext)({
    medium: (0, $57580ffdfef15295$export$f8725d21f81f3e01)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $ddcf36d926e8a699$var$GridColumn = function GridColumn(_ref2) {
    var _ref2$medium = _ref2.medium, medium = _ref2$medium === void 0 ? (0, $57580ffdfef15295$export$f8725d21f81f3e01) : _ref2$medium, children = _ref2.children, testId = _ref2.testId;
    var _useContext = (0, $acw62.useContext)((0, $c8e1ff5e10432b88$export$11cae3e04ab99fae)), columns = _useContext.columns;
    var contextValue = (0, $acw62.useMemo)(function() {
        return {
            medium: medium
        };
    }, [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ var colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ var variant = $ddcf36d926e8a699$var$getVariant({
        medium: medium,
        columns: columns
    });
    return (0, $jjlaj.jsx)($ddcf36d926e8a699$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, (0, $jjlaj.jsx)("div", {
        css: [
            $ddcf36d926e8a699$var$gridColumnStyles,
            $ddcf36d926e8a699$var$gridColumnWidthStyles[variant]
        ],
        style: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, (0, $57580ffdfef15295$export$8b7e31f391e6e681), variant === $ddcf36d926e8a699$var$ColumnVariant.Auto ? "auto" : colSpan),
        "data-testid": testId
    }, children));
};
var $ddcf36d926e8a699$export$2e2bcd8739ae039 = $ddcf36d926e8a699$var$GridColumn;


var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$579ae95472f9b0ae$export$2e2bcd8739ae039 = (0, $51d023ef8ca0c717$export$2e2bcd8739ae039);





const $e584c191a84e017c$export$69a679459027c35e = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "172",
        height: "172",
        viewBox: "0 0 172 172",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M157.683 90.8097H151.222L148.114 82.979H130.607C130.882 66.786 132.534 51.7876 135.498 38.2715H50.5241C50.2739 40.7233 50.0487 43.2063 49.8361 45.7019H25.337L28.4455 53.5388H59.4118L62.5203 61.3758H48.7666C48.7666 61.4758 48.754 61.5759 48.7478 61.676L48.629 61.3758H11.208L14.3165 69.2127H25.3433L28.4518 77.0497H48.2287C48.1599 80.4271 48.1223 83.8233 48.1223 87.2571C48.1223 98.4965 48.4663 109.379 49.1231 119.912H34.3748L37.4834 127.749H28.1328L31.2413 135.586H135.286C133.828 128.819 132.709 121.682 131.921 114.202H118.311L115.202 106.365H126.073L122.964 98.5278L160.798 98.6404L157.689 90.8034L157.683 90.8097Z",
                fill: "#4B4D51"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.9157 76.9185C81.4838 76.9185 75.9798 80.6462 72.8213 86.0188C75.9798 91.3915 81.4901 95.1192 90.9157 95.1192V76.9247V76.9185Z",
                fill: "#101214"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.916 95.1192C100.348 95.1192 105.852 91.3915 109.01 86.0188C105.852 80.6462 100.342 76.9185 90.916 76.9185V95.1129V95.1192Z",
                fill: "#101214"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M97.4017 87.4699C97.483 87.0196 97.5268 86.538 97.5268 86.0314C97.5268 85.5247 97.483 85.0306 97.4017 84.5741C96.9139 81.8533 95.0187 80.1709 92.3668 79.7393C91.9165 79.6642 91.4411 79.6267 90.947 79.6267C90.4529 79.6267 89.94 79.6705 89.4647 79.7455C86.8128 80.1896 84.9239 81.8596 84.4298 84.5678C84.3485 85.0244 84.3047 85.5122 84.3047 86.0251C84.3047 86.538 84.3485 87.0133 84.4298 87.4637C84.9176 90.1656 86.8065 91.8418 89.4647 92.2859C89.9338 92.3672 90.4279 92.4048 90.947 92.4048C91.4661 92.4048 91.9165 92.3672 92.3668 92.2922C95.025 91.8606 96.9139 90.1781 97.4017 87.4574V87.4699Z",
                fill: "#4B4D51"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M104.951 71.9834L76.8809 100.054",
                stroke: "#101214",
                strokeWidth: "3.7152",
                strokeMiterlimit: "10"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M48.2227 77.0498H66.2483L63.1397 69.2129H48.2227V77.0498Z",
                fill: "#7E8188"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M50.6807 135.592H68.7063L65.5978 127.749H50.124L50.6807 135.592Z",
                fill: "#7E8188"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M130.15 90.7034H118.717L121.825 98.5466H124.69H130.15V90.7034Z",
                fill: "#7E8188"
            })
        ]
    });
};



const $296e8e33e77bc1fe$var$contentStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    textAlign: "center",
    maxWidth: "480px"
});
const $296e8e33e77bc1fe$export$36825b49355323ef = ()=>{
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $579ae95472f9b0ae$export$2e2bcd8739ae039), {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
            children: (0, $7b02d682eb115277$exports.jsx)((0, $ddcf36d926e8a699$export$2e2bcd8739ae039), {
                medium: 4,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                    alignItems: "center",
                    justifyContent: "center",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                        xcss: $296e8e33e77bc1fe$var$contentStyles,
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                            space: "space.300",
                            alignInline: "center",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $e584c191a84e017c$export$69a679459027c35e), {}),
                                (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                                    size: "medium",
                                    children: "Rovo Dev Agents is not installed on this site"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                                    space: "space.050",
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                        as: "p",
                                        testId: "no-access-page-description",
                                        children: [
                                            "Rovo Dev Agents may not be installed on this site, or you might still be waiting on us to activate the product. Try again later, or",
                                            " ",
                                            (0, $7b02d682eb115277$exports.jsx)((0, $211777b1e6e6df36$export$2e2bcd8739ae039), {
                                                href: "https://rovodevagents-beta.atlassian.net/wiki/external/YmQ4YTllN2EyZTJmNGNmMTkwYTllMTZkYjk2MGRiNDU",
                                                target: "_blank",
                                                onClick: ()=>{
                                                    analyticsWebClient.sendUIEvent({
                                                        action: "clicked",
                                                        actionSubject: "link",
                                                        actionSubjectId: "no-access-page-info-link",
                                                        source: "no-access-page"
                                                    });
                                                },
                                                children: "read how to install Rovo Dev Agents"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};









const $24253e83c091541f$export$b47ffaf95cbecdde = ()=>{
    return (0, $7b02d682eb115277$exports.jsx)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
        alignItems: "center",
        templateColumns: "1fr",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
            alignItems: "center",
            justifyContent: "center",
            children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                xcss: $24253e83c091541f$var$homeWrapperStyles,
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                    space: "space.300",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                            xcss: $24253e83c091541f$var$suggestionsWrapperStyles,
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                xcss: $24253e83c091541f$var$mainHeadingWrapperStyles,
                                children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                                    space: "space.150",
                                    xcss: $24253e83c091541f$var$mainHeadingStyles,
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsxs)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                                            gap: "space.100",
                                            alignItems: "center",
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                                                    size: "xxlarge",
                                                    children: "Rovo Dev Agents"
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $2112685ebd1785a2$export$2e2bcd8739ae039), {
                                                    appearance: "inprogress",
                                                    isBold: true,
                                                    children: "Beta"
                                                })
                                            ]
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                            as: "p",
                                            testId: "non-admin-page-description",
                                            children: "By tapping into your team\u2019s knowledge in Jira, Confluence, and your codebase, Rovo Dev Agents can speed up delivery of high-quality code and let developers focus on more meaningful work. Discover more about Rovo Dev Agents"
                                        })
                                    ]
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $a76e4d761226cb3c$export$991fe453de1a0a4c), {
                            integrationsConfigStatesFragment: null,
                            isUserProductAdmin: false
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $4cc664b792d3d446$export$175e500a48a60fd2), {})
                    ]
                })
            })
        })
    });
};
const $24253e83c091541f$var$suggestionsWrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.500",
    paddingBottom: "space.300"
});
const $24253e83c091541f$var$mainHeadingWrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    "::after": {
        content: '""',
        position: "absolute",
        top: "space.0",
        right: "space.0",
        width: "208px",
        height: "208px",
        background: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($8cf1fe534ba272f8$exports)))}) no-repeat`
    },
    position: "relative"
});
const $24253e83c091541f$var$mainHeadingStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "calc(100% - 250px)"
});
const $24253e83c091541f$var$homeWrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.500",
    paddingBottom: "space.300",
    paddingLeft: "space.300",
    paddingRight: "space.300"
});




var $ca57a5b1ea39cf09$var$_homePageMainQuery;
const $ca57a5b1ea39cf09$var$responsiveStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.lg]: {
        width: "1200px"
    },
    marginLeft: "auto",
    marginRight: "auto"
});

const $ca57a5b1ea39cf09$var$MainContentQuery = $ca57a5b1ea39cf09$var$_homePageMainQuery !== void 0 ? $ca57a5b1ea39cf09$var$_homePageMainQuery : $ca57a5b1ea39cf09$var$_homePageMainQuery = (parcelRequire("kS6rz"));
const $ca57a5b1ea39cf09$var$MainContent = ({ cloudID: cloudID })=>{
    const data = (0, $2d93712440e0508b$exports.useLazyLoadQuery)($ca57a5b1ea39cf09$var$MainContentQuery, {
        cloudID: cloudID
    });
    const [skipSetupSection, setSkipSetupSection] = (0, $acw62.useState)(false);
    const [hideSetupSection, setHideSetupSection] = (0, $acw62.useState)(false);
    const configStates = Object.fromEntries(data.jira?.devOps?.configStates?.edges?.map((edge)=>[
            edge?.node?.id,
            edge?.node?.config?.edges?.[0]?.node?.status || "NOT_CONFIGURED"
        ]) || []);
    const requiredProviders = (0, $301b8558ed3f0a7a$export$33e178c06d3d9c29)();
    const configuredProviders = requiredProviders.filter((providerId)=>configStates[providerId] === "CONFIGURED");
    const showIntegrationsIncompleteStatus = !configuredProviders.length && !skipSetupSection;
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
        alignItems: "center",
        xcss: $ca57a5b1ea39cf09$var$responsiveStyles,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
            alignItems: "center",
            justifyContent: "center",
            children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                xcss: $ca57a5b1ea39cf09$var$homeWrapperStyles,
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                    space: "space.300",
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                            xcss: $ca57a5b1ea39cf09$var$suggestionsWrapperStyles,
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                    xcss: showIntegrationsIncompleteStatus ? $ca57a5b1ea39cf09$var$setupHeadingWrapperStyles : $ca57a5b1ea39cf09$var$mainHeadingWrapperStyles,
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                                        space: "space.150",
                                        xcss: $ca57a5b1ea39cf09$var$mainHeadingStyles,
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsxs)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                                                gap: "space.100",
                                                alignItems: "center",
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                                                        size: "xxlarge",
                                                        children: showIntegrationsIncompleteStatus ? "Setup Rovo Dev Agents" : "Rovo Dev Agents"
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $2112685ebd1785a2$export$2e2bcd8739ae039), {
                                                        appearance: "inprogress",
                                                        isBold: true,
                                                        children: "Beta"
                                                    })
                                                ]
                                            }),
                                            (0, $7b02d682eb115277$exports.jsxs)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                                as: "p",
                                                testId: "home-page-description",
                                                children: [
                                                    "By tapping into your team's knowledge in Jira, Confluence, and your codebase, Rovo Dev Agents can speed up delivery of high-quality code and let developers focus on more meaningful work.",
                                                    " ",
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $211777b1e6e6df36$export$2e2bcd8739ae039), {
                                                        href: "https://rovodevagents-beta.atlassian.net/wiki/external/OWEyMmMwZjllYjgyNDQzNjgyNWNiN2VhYjQ3MGY4MzI",
                                                        target: "_blank",
                                                        onClick: ()=>{
                                                            analyticsWebClient.sendUIEvent({
                                                                action: "clicked",
                                                                actionSubject: "link",
                                                                actionSubjectId: "heading-info-link",
                                                                source: "home-page"
                                                            });
                                                        },
                                                        children: "Discover more about Rovo Dev Agents"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                showIntegrationsIncompleteStatus && (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                    xcss: $ca57a5b1ea39cf09$var$panelStyles,
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                                        space: "space.200",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                                                children: (0, $7b02d682eb115277$exports.jsxs)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                                                            size: "large",
                                                            children: "Connect a source code management tool"
                                                        }),
                                                        (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                                                            appearance: "default",
                                                            onClick: ()=>setHideSetupSection(!hideSetupSection),
                                                            iconBefore: hideSetupSection ? (0, (/*@__PURE__*/$parcel$interopDefault($a360cf1e6956c59e$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($19986f13e317935c$exports))),
                                                            children: hideSetupSection ? "Show" : "Hide"
                                                        })
                                                    ]
                                                })
                                            }),
                                            !hideSetupSection && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                                        as: "p",
                                                        children: "To use Code Reviewer, Code Planner, or a coding agent, you need to connect Bitbucket or GitHub to Jira."
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                                                        space: "space.200",
                                                        children: [
                                                            (0, $7b02d682eb115277$exports.jsx)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
                                                                xcss: $ca57a5b1ea39cf09$var$responsiveSCMToolsStyles,
                                                                gap: "space.200",
                                                                children: (0, $301b8558ed3f0a7a$export$d55f97af03376191).filter((integration)=>requiredProviders.includes(integration.id)).map((integration, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $d34d09f118d159f8$export$60332b2344f7fe41), {
                                                                        description: integration.description,
                                                                        icon: integration.icon,
                                                                        primaryAction: integration.primaryAction,
                                                                        secondaryAction: integration.secondaryAction,
                                                                        title: integration.title,
                                                                        type: "suggestion"
                                                                    }, `integration-${index}`))
                                                            }),
                                                            (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                                                                as: "p",
                                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                                                                    appearance: "subtle",
                                                                    onClick: ()=>setSkipSetupSection(true),
                                                                    children: "Skip connecting for now"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $a76e4d761226cb3c$export$991fe453de1a0a4c), {
                            hasScmIntegrations: !showIntegrationsIncompleteStatus,
                            integrationsConfigStatesFragment: data.jira?.devOps?.configStates?.edges
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $3f714345c43d529e$export$9313e7897c3e1812), {
                            integrationsConfigStatesFragment: data.jira?.devOps?.configStates?.edges
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $4cc664b792d3d446$export$175e500a48a60fd2), {})
                    ]
                })
            })
        })
    });
};
const $ca57a5b1ea39cf09$export$36d69433c4f81145 = ()=>{
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { user: user } = (0, $690d3d7c4f641feb$export$69bbac602c81ca6e)();
    const cloudID = tenantContexts[0].cloudId;
    const devaiEntitlementId = tenantContexts[0]?.devaiEntitlementId;
    const hasActiveDevAiEntitlement = tenantContexts[0]?.hasActiveDevAiEntitlement;
    const hasFiredScreenEvent = (0, $acw62.useRef)(false);
    const { rovoDevAgentsUser: rovoDevAgentsUser } = (0, $927556e5474cebfb$export$a0210e79452e8007)();
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    (0, $acw62.useEffect)(()=>{
        if (cloudID && user?.accountId && !hasFiredScreenEvent.current) {
            analyticsWebClient.sendScreenEvent({
                name: "devAgentsHomePage",
                attributes: {
                    productInstalled: devaiEntitlementId != null,
                    isAdmin: rovoDevAgentsUser.isAdmin
                }
            });
            hasFiredScreenEvent.current = true;
        }
    }, [
        analyticsWebClient,
        devaiEntitlementId,
        cloudID,
        user?.accountId,
        rovoDevAgentsUser.isAdmin
    ]);
    if (devaiEntitlementId === null || !(0, $098873af10a85f8f$export$b40ec24ac8275656)("enable-dev-agents-app-access") || !hasActiveDevAiEntitlement && (0, $098873af10a85f8f$export$b40ec24ac8275656)("enable-devai-entitlement-status-check")) return (0, $7b02d682eb115277$exports.jsx)((0, $296e8e33e77bc1fe$export$36825b49355323ef), {});
    if (!rovoDevAgentsUser.hasProductAccess || !rovoDevAgentsUser.isAdmin) return (0, $7b02d682eb115277$exports.jsx)((0, $24253e83c091541f$export$b47ffaf95cbecdde), {});
    return (0, $7b02d682eb115277$exports.jsx)($ca57a5b1ea39cf09$var$MainContent, {
        cloudID: cloudID
    });
};
const $ca57a5b1ea39cf09$var$panelStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "100%",
    backgroundColor: "elevation.surface.overlay",
    padding: "space.400",
    marginTop: "space.400",
    borderRadius: "border.radius.100",
    border: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $ca57a5b1ea39cf09$var$suggestionsWrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.500",
    paddingBottom: "space.300"
});
const $ca57a5b1ea39cf09$var$mainHeadingWrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    "::after": {
        content: '""',
        position: "absolute",
        top: "space.0",
        right: "-40px",
        width: "208px",
        height: "208px",
        background: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($8cf1fe534ba272f8$exports)))}) no-repeat`
    },
    position: "relative"
});
const $ca57a5b1ea39cf09$var$setupHeadingWrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    "::after": {
        content: '""',
        position: "absolute",
        top: "space.0",
        right: "-100px",
        width: "208px",
        height: "208px",
        background: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($81429ba5cb21c54b$exports)))}) no-repeat`
    },
    position: "relative"
});
const $ca57a5b1ea39cf09$var$mainHeadingStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "calc(100% - 250px)"
});
const $ca57a5b1ea39cf09$var$responsiveSCMToolsStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.xxs]: {
        gridTemplateColumns: "repeat(1, 1fr)"
    },
    [(0, $4d1cc07665f9c15d$export$987d49ffe1b0900f).above.md]: {
        gridTemplateColumns: "repeat(2, 1fr)"
    }
});
const $ca57a5b1ea39cf09$var$homeWrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.500",
    paddingBottom: "space.300",
    paddingLeft: "space.300",
    paddingRight: "space.300"
});



/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");


var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");



var $a346ab7aa571dadb$var$_excluded = [
    "analyticsContext",
    "component",
    "hasOverflow",
    "href",
    "iconAfter",
    "iconBefore",
    "onClick",
    "target",
    "testId"
];
function $a346ab7aa571dadb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a346ab7aa571dadb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a346ab7aa571dadb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a346ab7aa571dadb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a346ab7aa571dadb$var$analyticsAttributes = {
    componentName: "breadcrumbsItem",
    packageName: "@atlaskit/breadcrumbs",
    packageVersion: "15.0.3"
};
var $a346ab7aa571dadb$var$noop = (0, $d3997b4aab843580$export$2e2bcd8739ae039);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ var $a346ab7aa571dadb$var$Step = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, component = _ref.component, _ref$hasOverflow = _ref.hasOverflow, hasOverflow = _ref$hasOverflow === void 0 ? true : _ref$hasOverflow, _ref$href = _ref.href, href = _ref$href === void 0 ? "#" : _ref$href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, _ref$onClick = _ref.onClick, onClickProvided = _ref$onClick === void 0 ? $a346ab7aa571dadb$var$noop : _ref$onClick, target = _ref.target, testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a346ab7aa571dadb$var$_excluded);
    var handleClicked = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($a346ab7aa571dadb$var$_objectSpread({
        fn: onClickProvided,
        action: "clicked",
        analyticsData: analyticsContext
    }, $a346ab7aa571dadb$var$analyticsAttributes));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b68af4c645c75ad0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    }));
});
var $a346ab7aa571dadb$export$2e2bcd8739ae039 = $a346ab7aa571dadb$var$Step;



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");
function $d85bf960dc188a24$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    var shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    var _useState = (0, $acw62.useState)((0, $ltooA.fg)("platform_fix_unnessesary_re-renders_in_breadcrumbs") ? Boolean(shouldCheckWidth) : true), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasOverflow = _useState2[0], setOverflow = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), showTooltip = _useState4[0], setShowTooltip = _useState4[1];
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $acw62.useEffect)(function() {
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            var shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            var shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}


var $60fab9c8c1ebbeeb$var$_excluded = [
    "analyticsContext",
    "component",
    "href",
    "iconAfter",
    "iconBefore",
    "onClick",
    "onTooltipShown",
    "ref",
    "target",
    "testId",
    "text",
    "truncationWidth"
];
function $60fab9c8c1ebbeeb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $60fab9c8c1ebbeeb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $60fab9c8c1ebbeeb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $60fab9c8c1ebbeeb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $60fab9c8c1ebbeeb$var$itemWrapperStyles = null;
var $60fab9c8c1ebbeeb$var$VAR_STEP_TRUNCATION_WIDTH = "--max-width";
var $60fab9c8c1ebbeeb$var$ICON_WIDTH_ESTIMATE = 24;
var $60fab9c8c1ebbeeb$var$staticItemStyles = null;
var $60fab9c8c1ebbeeb$var$staticItemWithTruncationStyles = null;
var $60fab9c8c1ebbeeb$var$staticItemWithoutTruncationStyles = null;
var $60fab9c8c1ebbeeb$var$BreadcrumbsItem = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var analyticsContext = _ref.analyticsContext, component = _ref.component, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onClick = _ref.onClick, onTooltipShown = _ref.onTooltipShown, ref = _ref.ref, target = _ref.target, testId = _ref.testId, text = _ref.text, truncationWidth = _ref.truncationWidth, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $60fab9c8c1ebbeeb$var$_excluded);
    var buttonRef = (0, $acw62.useRef)(null);
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    var iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $60fab9c8c1ebbeeb$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $60fab9c8c1ebbeeb$var$ICON_WIDTH_ESTIMATE;
    var _useOverflowable = (0, $d85bf960dc188a24$export$2e2bcd8739ae039)(truncationWidth, buttonRef.current, iconWidthAllowance), _useOverflowable2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useOverflowable, 2), hasOverflow = _useOverflowable2[0], showTooltip = _useOverflowable2[1];
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    var dynamicItemStyles = (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $60fab9c8c1ebbeeb$var$VAR_STEP_TRUNCATION_WIDTH, typeof truncationWidth !== "undefined" && "".concat(truncationWidth, "px"));
    var step = /*#__PURE__*/ $acw62.createElement((0, $a346ab7aa571dadb$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: buttonRef,
        target: target,
        testId: testId,
        className: (0, $5zphJ.default)([
            "_1rjc1raa _k48p13dq _vwz41txs",
            truncationWidth ? "_p12f1pis" : "_1ul9grf3 _1o9zzg3v"
        ]),
        style: $60fab9c8c1ebbeeb$var$_objectSpread($60fab9c8c1ebbeeb$var$_objectSpread({}, truncationWidth ? dynamicItemStyles : undefined), {}, {
            "--_ymfj9u": (0, $cZGu3.default)("var(--ds-font-weight-regular, 400)".concat(" !important")),
            "--_lugd7d": (0, $cZGu3.default)("var(--ds-space-025, 2px)".concat(" !important")),
            "--_1fteikb": (0, $cZGu3.default)("var(".concat($60fab9c8c1ebbeeb$var$VAR_STEP_TRUNCATION_WIDTH, ") !important"))
        })
    }), text);
    return /*#__PURE__*/ $acw62.createElement("li", {
        className: (0, $5zphJ.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3i59ms _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        style: {
            "--_1fdrbou": (0, $cZGu3.default)("".concat(24 / 14, "em"))
        }
    }, showTooltip ? /*#__PURE__*/ $acw62.createElement((0, $6fa9833ed171567b$export$2e2bcd8739ae039), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$60fab9c8c1ebbeeb$export$2e2bcd8739ae039 = $60fab9c8c1ebbeeb$var$BreadcrumbsItem;





var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");

const $c3f640ad5ecdb761$var$pageStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    paddingTop: "space.300",
    paddingBottom: "space.300",
    width: "70%"
});
const $c3f640ad5ecdb761$export$9086365ce732c74c = ({ children: children })=>{
    return (0, $7b02d682eb115277$exports.jsx)((0, $e4508b4e9680dfdd$export$2e2bcd8739ae039), {
        alignItems: "center",
        templateColumns: "1fr",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
            alignItems: "center",
            justifyContent: "center",
            children: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                xcss: $c3f640ad5ecdb761$var$pageStyles,
                children: children
            })
        })
    });
};




/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $fUHKi = parcelRequire("fUHKi");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");

var $acw62 = parcelRequire("acw62");




var $dnCk4 = parcelRequire("dnCk4");
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");


var $cff187b83f016768$var$noop = (0, $d3997b4aab843580$export$2e2bcd8739ae039);
var $cff187b83f016768$var$itemWrapperStyles = null;
var $cff187b83f016768$var$staticItemStyles = null;
var $cff187b83f016768$var$EllipsisItem = /*#__PURE__*/ (0, $acw62.memo)(function(_ref) {
    var label = _ref.label, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? $cff187b83f016768$var$noop : _ref$onClick, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("li", {
        className: (0, $5zphJ.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3i59ms _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        style: {
            "--_1fdrbou": (0, $cZGu3.default)("".concat(24 / 14, "em"))
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $b68af4c645c75ad0$export$2e2bcd8739ae039), {
        appearance: "subtle-link",
        "aria-label": label,
        onClick: onClick,
        spacing: "none",
        testId: testId,
        className: (0, $5zphJ.default)([
            "_1rjc1raa _k48p13dq _vwz41txs"
        ]),
        style: {
            "--_ymfj9u": (0, $cZGu3.default)("var(--ds-font-weight-regular, 400)".concat(" !important")),
            "--_lugd7d": (0, $cZGu3.default)("var(--ds-space-025, 2px)".concat(" !important"))
        }
    }, "\u2026"));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cff187b83f016768$export$2e2bcd8739ae039 = $cff187b83f016768$var$EllipsisItem;



var $acw62 = parcelRequire("acw62");

function $439811e29049a575$export$e9c4922b2ecf808a(callback, _ref) {
    var isExpanded = _ref.isExpanded, isDisabled = _ref.isDisabled;
    var prevExtended = (0, $8b1ca3977f5313f5$export$2e2bcd8739ae039)(isExpanded);
    (0, $acw62.useEffect)(function() {
        var hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}


var $a9f422b2fba66670$var$_excluded = [
    "analyticsContext",
    "children",
    "createAnalyticsEvent",
    "defaultExpanded",
    "ellipsisLabel",
    "isExpanded",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "label",
    "maxItems",
    "onExpand",
    "testId"
];
function $a9f422b2fba66670$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a9f422b2fba66670$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a9f422b2fba66670$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a9f422b2fba66670$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a9f422b2fba66670$var$defaultMaxItems = 8;
var $a9f422b2fba66670$var$defaultBreadcrumbsLabel = "Breadcrumbs";
var $a9f422b2fba66670$var$defaultEllipsisLabel = "Show more breadcrumbs";
var $a9f422b2fba66670$var$toArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray;
var $a9f422b2fba66670$var$analyticsAttributes = {
    componentName: "breadcrumbs",
    packageName: "@atlaskit/breadcrumbs",
    packageVersion: "15.0.3"
};
var $a9f422b2fba66670$var$noop = (0, $d3997b4aab843580$export$2e2bcd8739ae039);
var $a9f422b2fba66670$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
var $a9f422b2fba66670$var$breadcrumbStyles = null;
var $a9f422b2fba66670$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var _props$defaultExpande = props.defaultExpanded, defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande, isExpanded = props.isExpanded, _props$maxItems = props.maxItems, maxItems = _props$maxItems === void 0 ? $a9f422b2fba66670$var$defaultMaxItems : _props$maxItems, _props$itemsBeforeCol = props.itemsBeforeCollapse, itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol, _props$itemsAfterColl = props.itemsAfterCollapse, itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl, _props$children = props.children, children = _props$children === void 0 ? [] : _props$children, testId = props.testId, _props$onExpand = props.onExpand, providedExpanse = _props$onExpand === void 0 ? $a9f422b2fba66670$var$noop : _props$onExpand, analyticsContext = props.analyticsContext, _props$label = props.label, label = _props$label === void 0 ? $a9f422b2fba66670$var$defaultBreadcrumbsLabel : _props$label, _props$ellipsisLabel = props.ellipsisLabel, ellipsisLabel = _props$ellipsisLabel === void 0 ? $a9f422b2fba66670$var$defaultEllipsisLabel : _props$ellipsisLabel;
    var _useState = (0, $acw62.useState)(defaultExpanded), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), expanded = _useState2[0], setExpanse = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isClickedBySpace = _useState4[0], setExpansionTrigger = _useState4[1];
    var wrapperRef = (0, $acw62.useRef)(null);
    var isControlled = typeof isExpanded !== "undefined";
    var isExpansionHandled = providedExpanse !== $a9f422b2fba66670$var$noop;
    var shouldExpand = isControlled ? isExpanded : expanded;
    var focusFirstRevealed = function focusFirstRevealed() {
        if (wrapperRef.current) {
            var listItems = Array.from(wrapperRef.current.querySelectorAll("li"));
            var interactiveElements = listItems.map(function(li) {
                return li.querySelector($a9f422b2fba66670$var$interactiveElementSelector);
            });
            var elementToFocus = interactiveElements[itemsBeforeCollapse];
            var firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $439811e29049a575$export$e9c4922b2ecf808a)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    var handleExpansion = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($a9f422b2fba66670$var$_objectSpread({
        fn: function fn(event, analyticsEvent) {
            if (!isControlled) setExpanse(function(expanded) {
                return !expanded;
            });
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: "expanded",
        analyticsData: analyticsContext
    }, $a9f422b2fba66670$var$analyticsAttributes));
    var childrenArray = $a9f422b2fba66670$var$toArray(children);
    var breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(childrenArray, function(child, index) {
        //To avoid error if child is a string
        if (typeof child === "string") return child;
        return childrenArray.length - 1 === index ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
            "aria-current": "page"
        }) : child;
    });
    var renderItemsWithEllipsis = function renderItemsWithEllipsis() {
        var allItems = breadcrumbsArray;
        // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        var beforeItems = allItems.slice(0, itemsBeforeCollapse);
        var afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(beforeItems), [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cff187b83f016768$export$2e2bcd8739ae039), {
                key: "ellipsis",
                testId: testId && "".concat(testId, "--breadcrumb-ellipsis"),
                onClick: handleExpansion,
                label: ellipsisLabel
            })
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(afterItems));
    };
    var shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    var breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "aria-label": label,
        ref: (0, $270747da43296caf$export$2e2bcd8739ae039)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        "data-testid": testId,
        className: (0, $5zphJ.default)([
            "_1e0c1txw _1n261g80 _syazpsu8 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        style: {
            "--_vrm7dk": (0, $cZGu3.default)("var(--ds-text-subtlest, ".concat((0, $dnCk4.N200), ")"))
        }
    }, breadcrumbsItems));
});
var $a9f422b2fba66670$var$Breadcrumbs = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, children = _ref.children, createAnalyticsEvent = _ref.createAnalyticsEvent, defaultExpanded = _ref.defaultExpanded, ellipsisLabel = _ref.ellipsisLabel, isExpanded = _ref.isExpanded, itemsAfterCollapse = _ref.itemsAfterCollapse, itemsBeforeCollapse = _ref.itemsBeforeCollapse, label = _ref.label, maxItems = _ref.maxItems, onExpand = _ref.onExpand, testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $a9f422b2fba66670$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a9f422b2fba66670$var$InnerBreadcrumbs, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }));
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a9f422b2fba66670$export$2e2bcd8739ae039 = $a9f422b2fba66670$var$Breadcrumbs;


// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $acw62 = parcelRequire("acw62");
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $5zphJ = parcelRequire("5zphJ");

var $acw62 = parcelRequire("acw62");

var $d59d2057162a25a7$var$styles = {
    bottomBar: "_1pfhpxbi"
};
var $d59d2057162a25a7$var$truncateStyles = null;
var $d59d2057162a25a7$var$outerStyles = null;
var $d59d2057162a25a7$var$titleStyles = null;
var $d59d2057162a25a7$var$titleWrapperStyles = null;
var $d59d2057162a25a7$var$titleWrapperTruncateStyles = null;
var $d59d2057162a25a7$var$titleContainerStyles = null;
var $d59d2057162a25a7$var$actionStyles = null;
var $d59d2057162a25a7$var$titleContainerTruncateStyles = null;
var $d59d2057162a25a7$export$edaaad985a878983 = function OuterWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ])
    }, children);
};
var $d59d2057162a25a7$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref2, ref) {
    var children = _ref2.children, id = _ref2.id, truncateTitle = _ref2.truncateTitle, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && "".concat(testId, "--title"),
        className: (0, $5zphJ.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children);
});
var $d59d2057162a25a7$export$585a3b23e887288b = function TitleWrapper(_ref3) {
    var children = _ref3.children, truncateTitle = _ref3.truncateTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            "_1e0c1txw _4cvr1y6m _1n261g80",
            truncateTitle && "_1n261q9c"
        ])
    }, children);
};
var $d59d2057162a25a7$export$35e09ba17cc51c69 = function TitleContainer(_ref4) {
    var children = _ref4.children, truncateTitle = _ref4.truncateTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc",
            truncateTitle && "_1o9zkb7n"
        ])
    }, children);
};
var $d59d2057162a25a7$export$c8223871eecc8f3a = function ActionsWrapper(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5zphJ.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ])
    }, children);
};
var $d59d2057162a25a7$export$6330225854c30dc = function BottomBarWrapper(_ref6) {
    var children = _ref6.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        xcss: $d59d2057162a25a7$var$styles.bottomBar
    }, children);
};


/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ var $92ae62b21d01c435$var$PageHeader = function PageHeader(_ref) {
    var innerRef = _ref.innerRef, breadcrumbs = _ref.breadcrumbs, actions = _ref.actions, bottomBar = _ref.bottomBar, children = _ref.children, id = _ref.id, _ref$disableTitleStyl = _ref.disableTitleStyles, disableTitleStyles = _ref$disableTitleStyl === void 0 ? false : _ref$disableTitleStyl, _ref$truncateTitle = _ref.truncateTitle, truncateTitle = _ref$truncateTitle === void 0 ? false : _ref$truncateTitle, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d59d2057162a25a7$export$edaaad985a878983), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d59d2057162a25a7$export$585a3b23e887288b), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d59d2057162a25a7$export$35e09ba17cc51c69), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d59d2057162a25a7$export$284be1ee64a3465c), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id,
        testId: testId
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d59d2057162a25a7$export$c8223871eecc8f3a), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d59d2057162a25a7$export$6330225854c30dc), null, " ", bottomBar, " "));
};
var $92ae62b21d01c435$export$2e2bcd8739ae039 = $92ae62b21d01c435$var$PageHeader;




const $bb8d9e52e7488bfb$var$wrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    marginBottom: "space.150"
});
const $bb8d9e52e7488bfb$export$7cc3c78152b2ca07 = ({ additionalBreadcrumbItems: additionalBreadcrumbItems, headingText: headingText, descriptionText: descriptionText })=>{
    const breadCrumbs = (0, $7b02d682eb115277$exports.jsxs)((0, $a9f422b2fba66670$export$2e2bcd8739ae039), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $60fab9c8c1ebbeeb$export$2e2bcd8739ae039), {
                href: "/dev-agents/",
                text: "Rovo Dev Agents"
            }, "rovo-dev-agents"),
            additionalBreadcrumbItems
        ]
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
        xcss: $bb8d9e52e7488bfb$var$wrapperStyles,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $92ae62b21d01c435$export$2e2bcd8739ae039), {
                breadcrumbs: breadCrumbs,
                testId: "page-header-heading",
                children: headingText
            }),
            descriptionText && (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                children: descriptionText
            })
        ]
    });
};



var $8bfEX = parcelRequire("8bfEX");

var $acw62 = parcelRequire("acw62");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $97dc047858cd229a$var$buttonGroupStyles = (0, $jjlaj.css)({
    display: "inline-flex",
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> *": {
        flex: "1 0 auto"
    }
});
function $97dc047858cd229a$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref.label, titleId = _ref.titleId;
    return (0, $jjlaj.jsx)("div", {
        css: $97dc047858cd229a$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $jjlaj.jsx)((0, $acw62.Fragment), {
            key: idx
        }, child);
    }));
}



/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $bv4qN = parcelRequire("bv4qN");

var $ltooA = parcelRequire("ltooA");


var $18c6b2a5dadc0a2b$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $18c6b2a5dadc0a2b$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $cbc5b5bd3160fa7c$export$1aeb4f6b93c4540d)();
    if ((0, $ltooA.fg)("platform-typography-improved-color-control")) {
        if (colorProp === "inherit") return undefined;
        if (colorProp) return colorProp;
        if (hasTextAncestor) return undefined;
        if ($18c6b2a5dadc0a2b$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $18c6b2a5dadc0a2b$export$2185ce37f9bdd963[surface];
        return "color.text";
    }
    /*
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if (surface in $18c6b2a5dadc0a2b$export$2185ce37f9bdd963) return $18c6b2a5dadc0a2b$export$2185ce37f9bdd963[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
var $18c6b2a5dadc0a2b$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    "as.strong": "_k48pmoej",
    "as.em": "_zg8l1m30",
    "textAlign.center": "_y3gn1h6o",
    "textAlign.end": "_y3gnh9n0",
    "textAlign.start": "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $18c6b2a5dadc0a2b$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $18c6b2a5dadc0a2b$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $18c6b2a5dadc0a2b$var$textColorMap = {
    "color.text": "_syaz1fxt",
    "color.text.accent.lime": "_syaz1tco",
    "color.text.accent.lime.bolder": "_syaz1ik3",
    "color.text.accent.red": "_syaz9lu1",
    "color.text.accent.red.bolder": "_syazhwvp",
    "color.text.accent.orange": "_syaz1q28",
    "color.text.accent.orange.bolder": "_syaz1vps",
    "color.text.accent.yellow": "_syazfb2s",
    "color.text.accent.yellow.bolder": "_syazekll",
    "color.text.accent.green": "_syazh55r",
    "color.text.accent.green.bolder": "_syaz1y78",
    "color.text.accent.teal": "_syaz17qg",
    "color.text.accent.teal.bolder": "_syaz12v7",
    "color.text.accent.blue": "_syazpnps",
    "color.text.accent.blue.bolder": "_syazsc1o",
    "color.text.accent.purple": "_syaz10m5",
    "color.text.accent.purple.bolder": "_syaz2ibx",
    "color.text.accent.magenta": "_syaz1s8m",
    "color.text.accent.magenta.bolder": "_syaz1qur",
    "color.text.accent.gray": "_syaz1dyx",
    "color.text.accent.gray.bolder": "_syaz1x9z",
    "color.text.disabled": "_syaz1lh4",
    "color.text.inverse": "_syaz15cr",
    "color.text.selected": "_syazaqb7",
    "color.text.brand": "_syaz1e6v",
    "color.text.danger": "_syaz1tmw",
    "color.text.warning": "_syazwx40",
    "color.text.warning.inverse": "_syazal3n",
    "color.text.success": "_syazy73q",
    "color.text.discovery": "_syazzjem",
    "color.text.information": "_syaze0os",
    "color.text.subtlest": "_syaz131l",
    "color.text.subtle": "_syaz1gjq",
    "color.link": "_syaz14q2",
    "color.link.pressed": "_syaz16c2",
    "color.link.visited": "_syazw7te",
    "color.link.visited.pressed": "_syazg3x0"
};
var $18c6b2a5dadc0a2b$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $18c6b2a5dadc0a2b$var$Text = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $bv4qN.default)($18c6b2a5dadc0a2b$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $43cfa707e17c4f64$export$9322276ec105d055)();
    var color = $18c6b2a5dadc0a2b$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = /*#__PURE__*/ $acw62.createElement(Component, {
        id: id,
        className: (0, $5zphJ.default)([
            $18c6b2a5dadc0a2b$var$styles.root,
            size && $18c6b2a5dadc0a2b$var$fontSizeMap[size],
            color && $18c6b2a5dadc0a2b$var$textColorMap[color],
            maxLines && $18c6b2a5dadc0a2b$var$styles.truncation,
            maxLines === 1 && $18c6b2a5dadc0a2b$var$styles.breakAll,
            align && $18c6b2a5dadc0a2b$var$styles["textAlign.".concat(align)],
            weight && $18c6b2a5dadc0a2b$var$fontWeightMap[weight],
            Component === "em" && $18c6b2a5dadc0a2b$var$styles["as.em"],
            Component === "strong" && $18c6b2a5dadc0a2b$var$styles["as.strong"],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $acw62.createElement((0, $43cfa707e17c4f64$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $18c6b2a5dadc0a2b$export$2e2bcd8739ae039 = $18c6b2a5dadc0a2b$var$Text;



/* actions-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $5ca16395bc7bc9f4$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ var $5ca16395bc7bc9f4$var$ActionsContainer = function ActionsContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $5zphJ.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ])
    }, children);
};
var $5ca16395bc7bc9f4$export$2e2bcd8739ae039 = $5ca16395bc7bc9f4$var$ActionsContainer;

/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $17b45c0bc740d568$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ var $17b45c0bc740d568$var$wideContainerStyles = null;
var $17b45c0bc740d568$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ var $17b45c0bc740d568$var$Container = function Container(_ref) {
    var children = _ref.children, width = _ref.width, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId,
        className: (0, $5zphJ.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === "narrow" ? "_p12fko4j" : "_p12f1pl1"
        ])
    }, children);
};
var $17b45c0bc740d568$export$2e2bcd8739ae039 = $17b45c0bc740d568$var$Container;

/* image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");
function $4766100e7b88bc3a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4766100e7b88bc3a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4766100e7b88bc3a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4766100e7b88bc3a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4766100e7b88bc3a$var$CSS_VAR_MAX_WIDTH = "--max-width";
var $4766100e7b88bc3a$var$CSS_VAR_MAX_HEIGHT = "--max-height";
var $4766100e7b88bc3a$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ var $4766100e7b88bc3a$var$Image = function Image(_ref) {
    var maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? "auto" : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? "auto" : _ref$width, src = _ref.src;
    return /*#__PURE__*/ $acw62.createElement("img", {
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $5zphJ.default)([
            "_1e0c1ule _p12f163m _c71l649k _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ]),
        style: $4766100e7b88bc3a$var$_objectSpread($4766100e7b88bc3a$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $4766100e7b88bc3a$var$CSS_VAR_MAX_WIDTH, "".concat(maxWidth, "px")), $4766100e7b88bc3a$var$CSS_VAR_MAX_HEIGHT, "".concat(maxHeight, "px"))), {}, {
            "--_11x3y0": (0, $cZGu3.default)("var(".concat($4766100e7b88bc3a$var$CSS_VAR_MAX_WIDTH, ")")),
            "--_zsxb2b": (0, $cZGu3.default)("var(".concat($4766100e7b88bc3a$var$CSS_VAR_MAX_HEIGHT, ")"))
        })
    });
};
var $4766100e7b88bc3a$export$2e2bcd8739ae039 = $4766100e7b88bc3a$var$Image;

/* spinner-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $1b3e8d1e81bf9d05$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ var $1b3e8d1e81bf9d05$var$SpinnerContainer = function SpinnerContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $5zphJ.default)([
            "_1bsb1ejb _ahbqpxbi"
        ])
    }, children);
};
var $1b3e8d1e81bf9d05$export$2e2bcd8739ae039 = $1b3e8d1e81bf9d05$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ var $c9f282bfce9aba21$var$EmptyState = function EmptyState(_ref) {
    var buttonGroupLabel = _ref.buttonGroupLabel, description = _ref.description, header = _ref.header, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 4 : _ref$headingLevel, imageHeight = _ref.imageHeight, imageUrl = _ref.imageUrl, imageWidth = _ref.imageWidth, isLoading = _ref.isLoading, _ref$maxImageHeight = _ref.maxImageHeight, maxImageHeight = _ref$maxImageHeight === void 0 ? 160 : _ref$maxImageHeight, _ref$maxImageWidth = _ref.maxImageWidth, maxImageWidth = _ref$maxImageWidth === void 0 ? 160 : _ref$maxImageWidth, primaryAction = _ref.primaryAction, renderImage = _ref.renderImage, secondaryAction = _ref.secondaryAction, width = _ref.width, size = _ref.size, tertiaryAction = _ref.tertiaryAction, testId = _ref.testId;
    var actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5ca16395bc7bc9f4$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97dc047858cd229a$export$2e2bcd8739ae039), {
        label: buttonGroupLabel || "Button group",
        testId: testId && "".concat(testId, "-button-group")
    }, secondaryAction, primaryAction), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b3e8d1e81bf9d05$export$2e2bcd8739ae039), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d847f661580efa86$export$2e2bcd8739ae039), {
        testId: "empty-state-spinner"
    }))) : null;
    var tag = "h".concat(headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $17b45c0bc740d568$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || size || "wide"
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4766100e7b88bc3a$export$2e2bcd8739ae039), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
        size: "medium",
        as: tag
    }, header)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18c6b2a5dadc0a2b$export$2e2bcd8739ae039), {
        as: "p"
    }, description)), actionsContainer, tertiaryAction);
};
var $c9f282bfce9aba21$export$2e2bcd8739ae039 = $c9f282bfce9aba21$var$EmptyState;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $2804e02a1fe45ad3$export$e3c470447822f816 = "ati:cloud:jira:project";
const $2804e02a1fe45ad3$export$5f46e680e0216089 = "code_planner_settings";


const $73696979d9e2fa35$export$cf05780ee047feb4 = "/gateway/api/devai-core/public/v2/settings/get";
const $73696979d9e2fa35$export$49b8d3ee29ca4a5 = "/gateway/api/devai-core/public/v2/settings/set";


const $5c69c67e55e6e81b$export$595f1b0445a2aee8 = ()=>{
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [codePlannerSettingsCache, setCodePlannerSettingsCache] = (0, $acw62.useState)(new Map());
    const getCodePlannerSettings = (0, $acw62.useCallback)(async (containerIdList)=>{
        setLoading(true);
        setError(null);
        const settingsRequestList = containerIdList.map((containerId)=>({
                containerType: (0, $2804e02a1fe45ad3$export$e3c470447822f816),
                containerId: containerId,
                key: (0, $2804e02a1fe45ad3$export$5f46e680e0216089)
            }));
        const settingsMap = new Map();
        try {
            const response = await fetch((0, $7313551ab8168ced$export$2e2bcd8739ae039)((0, $73696979d9e2fa35$export$cf05780ee047feb4), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    settings: settingsRequestList
                })
            }));
            if (!response.ok) throw new Error(`Error: ${response.statusText}`);
            const data = await response.json();
            if (!data.success) throw new Error("Failed to get agent settings");
            data.settings.forEach((item)=>{
                settingsMap.set(item.containerId, item);
            });
        } catch (e) {
            setError("An error has occurred");
        }
        setLoading(false);
        return settingsMap;
    }, []);
    return {
        getCodePlannerSettings: getCodePlannerSettings,
        codePlannerSettingsCache: codePlannerSettingsCache,
        setCodePlannerSettingsCache: setCodePlannerSettingsCache,
        loading: loading,
        error: error
    };
};





var $acw62 = parcelRequire("acw62");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $3V3p2 = parcelRequire("3V3p2");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");



var $ltooA = parcelRequire("ltooA");

var $7Dr7Z = parcelRequire("7Dr7Z");

var $3V3p2 = parcelRequire("3V3p2");
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");

var $dnCk4 = parcelRequire("dnCk4");
var $f94e7324e0698144$var$_excluded = [
    "isFixedSize",
    "hasDataRow",
    "children",
    "testId",
    "isLoading"
];
function $f94e7324e0698144$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f94e7324e0698144$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f94e7324e0698144$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f94e7324e0698144$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f94e7324e0698144$var$fixedSizeTableStyles = null;
var $f94e7324e0698144$var$tableStyles = null;
var $f94e7324e0698144$var$bodyBorder = null;
var $f94e7324e0698144$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var isFixedSize = _ref.isFixedSize, hasDataRow = _ref.hasDataRow, children = _ref.children, testId = _ref.testId, isLoading = _ref.isLoading, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $f94e7324e0698144$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement("table", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        inert: isLoading ? "" : undefined,
        ref: ref
    }, rest, {
        "data-testid": testId && "".concat(testId, "--table"),
        className: (0, $5zphJ.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179rralu"
        ]),
        style: $f94e7324e0698144$var$_objectSpread($f94e7324e0698144$var$_objectSpread({}, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            "--local-dynamic-table-hover-bg": "var(--ds-background-neutral-subtle-hovered, ".concat((0, $dnCk4.N10), ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            "--local-dynamic-table-highlighted-bg": "var(--ds-background-selected, ".concat((0, $dnCk4.B50), ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            "--local-dynamic-table-hover-highlighted-bg": "var(--ds-background-selected-hovered, ".concat((0, $dnCk4.B75), ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            "--local-dynamic-table-row-focus-outline": "var(--ds-border-focused, ".concat((0, $dnCk4.B100), ")")
        }), {}, {
            "--_k02y3n": (0, $cZGu3.default)("2px solid ".concat("var(--ds-border, ".concat((0, $dnCk4.N40), ")")))
        })
    }), children);
});
var $f94e7324e0698144$var$captionStyles = null;
var $f94e7324e0698144$export$32fbfacc5d962e0c = function Caption(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $acw62.createElement("caption", {
        className: (0, $5zphJ.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ])
    }, children);
};
var $f94e7324e0698144$var$paginationWrapperStyles = null;
var $f94e7324e0698144$export$3e5e12dc01f20a43 = function PaginationWrapper(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId && "".concat(testId, "--pagination--container"),
        className: (0, $5zphJ.default)([
            "_1e0c1txw _1bah1h6o"
        ])
    }, children);
};


/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $82fbc6429a5e1d5c$var$fixedHeightStyles = null;
var $82fbc6429a5e1d5c$export$8f45b9407d4090d7 = function EmptyViewWithFixedHeight(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId && "".concat(testId, "--empty-view-with-fixed-height"),
        className: (0, $5zphJ.default)([
            "_4t3i1jdh"
        ])
    }, children);
};
var $82fbc6429a5e1d5c$var$emptyViewContainerStyles = null;
var $82fbc6429a5e1d5c$export$381ea436de119582 = function EmptyViewContainer(props) {
    var children = props.children, testId = props.testId;
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId && "".concat(testId, "--empty-view-container"),
        className: (0, $5zphJ.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ])
    }, children);
};



var $3p9rK = parcelRequire("3p9rK");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $acw62 = parcelRequire("acw62");

var $alt3z = parcelRequire("alt3z");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $74cUM = parcelRequire("74cUM");

var $bs857 = parcelRequire("bs857");
var $80814191ad7b100c$var$_excluded = [
    "cells"
], $80814191ad7b100c$var$_excluded2 = [
    "content",
    "testId"
];
var $80814191ad7b100c$var$Row = function Row(_ref) {
    var row = _ref.row, head = _ref.head, testId = _ref.testId, isFixedSize = _ref.isFixedSize, isHighlighted = _ref.isHighlighted;
    var cells = row.cells, restRowProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(row, $80814191ad7b100c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bs857.TableBodyRow), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, restRowProps, {
        isHighlighted: isHighlighted
    }, isHighlighted ? {
        "data-ts--dynamic-table--table-row--highlighted": true
    } : null, {
        testId: row.testId || testId && "".concat(testId, "--row-").concat(restRowProps.key)
    }), cells.map(function(cell, cellIndex) {
        var content = cell.content, cellTestId = cell.testId, restCellProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(cell, $80814191ad7b100c$var$_excluded2);
        var _ref2 = (head || {
            cells: []
        }).cells[cellIndex] || {}, shouldTruncate = _ref2.shouldTruncate, width = _ref2.width;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74cUM.TableBodyCell), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            "data-testid": cellTestId || testId && "".concat(testId, "--cell-").concat(cellIndex)
        }, restCellProps, {
            isFixedSize: isFixedSize,
            key: cellIndex // eslint-disable-line react/no-array-index-key
            ,
            shouldTruncate: shouldTruncate,
            width: width
        }), content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80814191ad7b100c$export$2e2bcd8739ae039 = $80814191ad7b100c$var$Row;


function $1079e9f423df4cd0$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $1079e9f423df4cd0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $1079e9f423df4cd0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1079e9f423df4cd0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1079e9f423df4cd0$var$BodyComponent = /*#__PURE__*/ function(_React$Component) {
    function BodyComponent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, BodyComponent);
        return $1079e9f423df4cd0$var$_callSuper(this, BodyComponent, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(BodyComponent, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(BodyComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, pageRows = _this$props.pageRows, head = _this$props.head, isFixedSize = _this$props.isFixedSize, highlightedRowIndex = _this$props.highlightedRowIndex, testId = _this$props.testId, forwardedRef = _this$props.forwardedRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", {
                    "data-testid": testId && "".concat(testId, "--body"),
                    ref: forwardedRef
                }, pageRows.map(function(row, rowIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80814191ad7b100c$export$2e2bcd8739ae039), {
                        head: head,
                        isFixedSize: isFixedSize,
                        key: row.key || rowIndex,
                        row: row,
                        isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === "number" ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                        testId: testId
                    });
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $1079e9f423df4cd0$var$Body = (0, $alt3z.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1079e9f423df4cd0$var$BodyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        forwardedRef: ref
    }));
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1079e9f423df4cd0$export$2e2bcd8739ae039 = $1079e9f423df4cd0$var$Body;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $acw62 = parcelRequire("acw62");
function $3fef8293417eb387$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $3fef8293417eb387$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $3fef8293417eb387$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3fef8293417eb387$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $3fef8293417eb387$export$e926676385687eaf = /*#__PURE__*/ function(_React$Component) {
    function ErrorBoundary(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ErrorBoundary);
        _this = $3fef8293417eb387$var$_callSuper(this, ErrorBoundary, [
            props
        ]);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ErrorBoundary, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) // You can render any custom fallback UI
                return this.props.fallback;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                // Update state so the next render will show the fallback UI.
                return {
                    hasError: true
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $7Dr7Z = parcelRequire("7Dr7Z");
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");
function $817dd9ef41cfc4ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $817dd9ef41cfc4ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $817dd9ef41cfc4ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $817dd9ef41cfc4ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $817dd9ef41cfc4ab$export$c335a80381ec61f5 = "--contents-opacity";
var $817dd9ef41cfc4ab$var$containerStyles = null;
var $817dd9ef41cfc4ab$export$42a852a2b6b56249 = function Container(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId && "".concat(testId, "--container"),
        className: (0, $5zphJ.default)([
            "_kqswh2mm"
        ])
    }, children);
};
var $817dd9ef41cfc4ab$var$contentsContainerStyles = null;
var $817dd9ef41cfc4ab$export$67c29eae8ae2137a = function ContentsContainer(_ref2) {
    var children = _ref2.children, contentsOpacity = _ref2.contentsOpacity, testId = _ref2.testId;
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId && "".concat(testId, "--contents--container"),
        className: (0, $5zphJ.default)([
            "_tzy47hfw _lcxvglyw"
        ]),
        style: $817dd9ef41cfc4ab$var$_objectSpread($817dd9ef41cfc4ab$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $817dd9ef41cfc4ab$export$c335a80381ec61f5, contentsOpacity)), {}, {
            "--_cnddr8": (0, $cZGu3.default)("var(".concat($817dd9ef41cfc4ab$export$c335a80381ec61f5, ")"))
        })
    }, children);
};
var $817dd9ef41cfc4ab$var$spinnerContainerStyles = null;
var $817dd9ef41cfc4ab$export$a5e06607a5ac6158 = function SpinnerContainer(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId && "".concat(testId, "--spinner--container"),
        className: (0, $5zphJ.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ])
    }, children);
};


function $5afbfba05fa6580a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $5afbfba05fa6580a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $5afbfba05fa6580a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5afbfba05fa6580a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5afbfba05fa6580a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function LoadingContainer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, LoadingContainer);
        return $5afbfba05fa6580a$var$_callSuper(this, LoadingContainer, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(LoadingContainer, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(LoadingContainer, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, isLoading = _this$props.isLoading, spinnerSize = _this$props.spinnerSize, contentsOpacity = _this$props.contentsOpacity, testId = _this$props.testId, loadingLabel = _this$props.loadingLabel;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $817dd9ef41cfc4ab$export$42a852a2b6b56249), {
                    testId: testId
                }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $817dd9ef41cfc4ab$export$67c29eae8ae2137a), {
                    contentsOpacity: contentsOpacity,
                    testId: testId
                }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $817dd9ef41cfc4ab$export$a5e06607a5ac6158), {
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d847f661580efa86$export$2e2bcd8739ae039), {
                    size: spinnerSize,
                    testId: testId && "".concat(testId, "--loadingSpinner"),
                    label: loadingLabel
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($5afbfba05fa6580a$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $7Dr7Z.LARGE),
    contentsOpacity: (0, $7Dr7Z.LOADING_CONTENTS_OPACITY),
    loadingLabel: "Loading table"
});



var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");


var $7Dr7Z = parcelRequire("7Dr7Z");
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $09a984e0f9bcfa8d$var$_excluded = [
    "children",
    "testId"
];
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $09a984e0f9bcfa8d$var$containerStyles = null;
var $09a984e0f9bcfa8d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var children = props.children, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $09a984e0f9bcfa8d$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        "data-testid": testId,
        ref: ref,
        className: (0, $5zphJ.default)([
            "_kqswh2mm _6rth1ejb"
        ])
    }), children);
});
var $09a984e0f9bcfa8d$var$spinnerBackdropStyles = null;
var $09a984e0f9bcfa8d$export$aa207050321b0c53 = function SpinnerBackdrop(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $acw62.createElement("div", {
        "data-testid": testId && "".concat(testId, "--spinner-backdrop"),
        className: (0, $5zphJ.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ])
    }, children);
};
var $09a984e0f9bcfa8d$var$spinnerContainerStyles = null;
var $09a984e0f9bcfa8d$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: ref,
        className: (0, $5zphJ.default)([
            "_kqswh2mm _152tidpf"
        ])
    }, children);
});


function $c9ff243d213f17f1$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $c9ff243d213f17f1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $c9ff243d213f17f1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c9ff243d213f17f1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c9ff243d213f17f1$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function LoadingContainerAdvanced() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, LoadingContainerAdvanced);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $c9ff243d213f17f1$var$_callSuper(this, LoadingContainerAdvanced, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "spinnerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "containerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "componentDidMount", function() {
            if (_this.props.isLoading && _this.hasTargetNode()) {
                _this.attachListeners();
                _this.updateTargetAppearance();
                _this.updateSpinnerPosition();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "UNSAFE_componentWillReceiveProps", function(nextProps) {
            if (!nextProps.isLoading || !_this.hasTargetNode(nextProps)) _this.detachListeners();
            else if (!_this.props.isLoading) _this.attachListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "componentDidUpdate", function() {
            if (_this.hasTargetNode()) {
                _this.updateTargetAppearance();
                if (_this.props.isLoading) _this.updateSpinnerPosition();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "componentWillUnmount", function() {
            _this.detachListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "getTargetNode", function() {
            var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            var targetRef = nextProps.targetRef;
            var target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || _this.containerRef.current;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "hasTargetNode", function(nextProps) {
            return !!_this.getTargetNode(nextProps);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "isVerticallyVisible", function(elementRect, viewportHeight) {
            var top = elementRect.top, bottom = elementRect.bottom;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "isFullyVerticallyVisible", function(elementRect, viewportHeight) {
            var top = elementRect.top, bottom = elementRect.bottom;
            return top >= 0 && bottom <= viewportHeight;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "handleResize", function() {
            _this.updateSpinnerPosition();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "handleScroll", function() {
            _this.updateSpinnerPosition();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "translateSpinner", function(spinnerNode, transformY, isFixed) {
            spinnerNode.style.position = isFixed ? "fixed" : "";
            spinnerNode.style.transform = transformY !== 0 ? "translate3d(0, ".concat(transformY, "px, 0)") : "";
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "updateTargetAppearance", function() {
            var targetNode = _this.getTargetNode();
            var _this$props = _this.props, isLoading = _this$props.isLoading, contentsOpacity = _this$props.contentsOpacity;
            if (targetNode && targetNode.style && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(targetNode.style) === "object") {
                targetNode.style.pointerEvents = isLoading ? "none" : "";
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : "";
            }
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(LoadingContainerAdvanced, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(LoadingContainerAdvanced, [
        {
            key: "attachListeners",
            value: function attachListeners() {
                window.addEventListener("scroll", this.handleScroll);
                window.addEventListener("resize", this.handleResize);
            }
        },
        {
            key: "detachListeners",
            value: function detachListeners() {
                window.removeEventListener("scroll", this.handleScroll);
                window.removeEventListener("resize", this.handleResize);
            }
        },
        {
            key: "updateSpinnerPosition",
            value: function updateSpinnerPosition() {
                var _this$spinnerRef, _this$containerRef;
                var viewportHeight = window.innerHeight;
                var targetNode = this.getTargetNode();
                var spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
                if (!targetNode || typeof targetNode.getBoundingClientRect !== "function" || !spinnerNode) return;
                var targetRect = targetNode.getBoundingClientRect();
                var spinnerRect = spinnerNode.getBoundingClientRect();
                var spinnerHeight = spinnerRect.height;
                var isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
                var top = targetRect.top, bottom = targetRect.bottom, height = targetRect.height;
                if (isInViewport) {
                    // The spinner may follow the element only if there is enough space:
                    // Let's say the element can fit at least three spinners (vertically)
                    var canFollow = height >= spinnerHeight * 3;
                    if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                        if (top >= 0) {
                            // Only the head of the element is visible
                            var viewportSpaceTakenByElement = viewportHeight - top;
                            var diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                            var y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                            this.translateSpinner(spinnerNode, y, true);
                        } else if (top < 0 && bottom > viewportHeight) {
                            // The element takes all viewport, nor its head nor tail are visible
                            var _y = viewportHeight / 2 - spinnerHeight / 2;
                            this.translateSpinner(spinnerNode, _y, true);
                        } else {
                            // Only the tail of the element is visible
                            var _diff = bottom / 2 - spinnerHeight / 2;
                            var _y2 = _diff < spinnerHeight ? _diff - (spinnerHeight - _diff) : _diff;
                            this.translateSpinner(spinnerNode, _y2, true);
                        }
                        return;
                    }
                } else {
                    // If both the element and the spinner are off screen - quit
                    if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
                }
                // Three options here:
                // 1) the element is fully visible
                // 2) the element is too small for the spinner to follow
                // 3) the spinner might still be visible while the element isn't
                var containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
                if (containerNode && typeof containerNode.getBoundingClientRect === "function") {
                    var thisTop = containerNode.getBoundingClientRect().top;
                    var _y3 = (top - thisTop) / 2;
                    this.translateSpinner(spinnerNode, _y3, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, isLoading = _this$props2.isLoading, spinnerSize = _this$props2.spinnerSize, testId = _this$props2.testId, loadingLabel = _this$props2.loadingLabel;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $09a984e0f9bcfa8d$export$42a852a2b6b56249), {
                    testId: testId && "".concat(testId, "--loading--container--advanced"),
                    ref: this.containerRef
                }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $09a984e0f9bcfa8d$export$aa207050321b0c53), {
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $09a984e0f9bcfa8d$export$a5e06607a5ac6158), {
                    ref: this.spinnerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d847f661580efa86$export$2e2bcd8739ae039), {
                    size: spinnerSize,
                    testId: testId && "".concat(testId, "--loadingSpinner"),
                    label: loadingLabel
                }))));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($c9ff243d213f17f1$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $7Dr7Z.LARGE),
    contentsOpacity: "var(--ds-opacity-loading, ".concat("".concat((0, $7Dr7Z.LOADING_CONTENTS_OPACITY)), ")"),
    loadingLabel: "Loading table"
});



var $fUHKi = parcelRequire("fUHKi");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");


var $acw62 = parcelRequire("acw62");



var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");
function $91a58227bcfc77cc$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $acw62.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $acw62.useRef)(isControlled);
    (0, $acw62.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $acw62.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $82d3f244cd297d5a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($82d3f244cd297d5a$exports, "__esModule", {
    value: true
});
$82d3f244cd297d5a$exports.default = void 0;

var $82d3f244cd297d5a$var$_react = $82d3f244cd297d5a$var$_interopRequireDefault((parcelRequire("acw62")));

var $82d3f244cd297d5a$var$_chevronLeft = $82d3f244cd297d5a$var$_interopRequireDefault((parcelRequire("b12kL")));

var $82d3f244cd297d5a$var$_chevronLeftLarge = $82d3f244cd297d5a$var$_interopRequireDefault((parcelRequire("d9q0V")));
function $82d3f244cd297d5a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82d3f244cd297d5a$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $82d3f244cd297d5a$var$_react.default.createElement($82d3f244cd297d5a$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $82d3f244cd297d5a$var$_chevronLeftLarge.default
    }, props));
$82d3f244cd297d5a$var$ChevronLeftIcon.Name = "ChevronLeftIconMigration";
var $82d3f244cd297d5a$var$_default = $82d3f244cd297d5a$exports.default = $82d3f244cd297d5a$var$ChevronLeftIcon;


var $276d6254a6650c97$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($276d6254a6650c97$exports, "__esModule", {
    value: true
});
$276d6254a6650c97$exports.default = void 0;

var $276d6254a6650c97$var$_react = $276d6254a6650c97$var$_interopRequireDefault((parcelRequire("acw62")));

var $276d6254a6650c97$var$_chevronRight = $276d6254a6650c97$var$_interopRequireDefault((parcelRequire("aPL5Y")));

var $276d6254a6650c97$var$_chevronRightLarge = $276d6254a6650c97$var$_interopRequireDefault((parcelRequire("7gGhC")));
function $276d6254a6650c97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $276d6254a6650c97$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $276d6254a6650c97$var$_react.default.createElement($276d6254a6650c97$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $276d6254a6650c97$var$_chevronRightLarge.default
    }, props));
$276d6254a6650c97$var$ChevronRightIcon.Name = "ChevronRightIconMigration";
var $276d6254a6650c97$var$_default = $276d6254a6650c97$exports.default = $276d6254a6650c97$var$ChevronRightIcon;




var $acw62 = parcelRequire("acw62");

function $35978dafa76b5486$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b68af4c645c75ad0$export$2e2bcd8739ae039), {
        "aria-label": props["aria-label"],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}



var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

function $01d581d55a7dd5f1$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b68af4c645c75ad0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        appearance: "subtle"
    }));
}


/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $acw62 = parcelRequire("acw62");


var $b4cb222789309f61$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $b4cb222789309f61$export$2e2bcd8739ae039(_ref) {
    var key = _ref.key, testId = _ref.testId, from = _ref.from, to = _ref.to;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $b4cb222789309f61$var$styles.container,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18c6b2a5dadc0a2b$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "-text")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8568069ac023c6f7$export$2e2bcd8739ae039), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}


var $4d8d9dd05a1c85b3$export$3f860eba1218f8d3 = {};



var $fUHKi = parcelRequire("fUHKi");

// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
var $770df8a2ade37f3e$var$collapseRange = function collapseRange(pages, current, _ref, testId) {
    var max = _ref.max, ellipsis = _ref.ellipsis, transform = _ref.transform;
    var total = pages.length;
    // only need ellipsis if we have more pages than we can display
    var needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    var hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    var hasEndEllipsis = needEllipsis && current < total - max + 3;
    var getPageComponents = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function() {
        var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var lastIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : total;
        return pages.slice(startIndex, lastIndex).map(function(page, index) {
            return transform(page, startIndex + index, testId);
        });
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        var _pageCount = max - 2;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getPageComponents(0, 1)), [
            ellipsis({
                key: "ellipsis-1",
                testId: testId && "".concat(testId, "-ellipsis"),
                from: 2,
                to: total - _pageCount
            })
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getPageComponents(total - _pageCount)));
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        var _pageCount2 = max - 2;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getPageComponents(0, _pageCount2)), [
            ellipsis({
                key: "ellipsis-1",
                testId: testId && "".concat(testId, "-ellipsis"),
                from: _pageCount2 + 1,
                to: total - 1
            })
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getPageComponents(total - 1)));
    }
    // we have both start and end ellipsis
    var pageCount = max - 4;
    return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getPageComponents(0, 1)), [
        ellipsis({
            key: "ellipsis-1",
            testId: testId && "".concat(testId, "-ellipsis"),
            from: 2,
            to: current - Math.floor(pageCount / 2)
        })
    ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1)), [
        ellipsis({
            key: "ellipsis-2",
            testId: testId && "".concat(testId, "-ellipsis"),
            from: current + 3,
            to: total - 1
        })
    ], (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(getPageComponents(total - 1)));
};
var $770df8a2ade37f3e$export$2e2bcd8739ae039 = $770df8a2ade37f3e$var$collapseRange;


function $0ea9908cf529c1f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ea9908cf529c1f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ea9908cf529c1f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ea9908cf529c1f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0ea9908cf529c1f6$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t",
    navigatorIconWrapper: "_18zr12x7"
};
var $0ea9908cf529c1f6$var$analyticsAttributes = {
    componentName: "pagination",
    packageName: "@atlaskit/pagination",
    packageVersion: "16.0.3"
};
function $0ea9908cf529c1f6$var$NavigatorIcon(_ref) {
    var chevronDirection = _ref.chevronDirection;
    var Chevron = chevronDirection === "left" ? (0, (/*@__PURE__*/$parcel$interopDefault($82d3f244cd297d5a$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($276d6254a6650c97$exports)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $0ea9908cf529c1f6$var$styles.navigatorIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Chevron, {
        label: "",
        LEGACY_margin: "0 ".concat("var(--ds-space-negative-075, -6px)"),
        color: "currentColor"
    }));
}
function $0ea9908cf529c1f6$var$InnerPagination(_ref2, ref) {
    var _ref2$components = _ref2.components, components = _ref2$components === void 0 ? (0, $4d8d9dd05a1c85b3$export$3f860eba1218f8d3) : _ref2$components, _ref2$defaultSelected = _ref2.defaultSelectedIndex, defaultSelectedIndex = _ref2$defaultSelected === void 0 ? 0 : _ref2$defaultSelected, selectedIndex = _ref2.selectedIndex, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "pagination" : _ref2$label, _ref2$pageLabel = _ref2.pageLabel, pageLabel = _ref2$pageLabel === void 0 ? "page" : _ref2$pageLabel, _ref2$previousLabel = _ref2.previousLabel, previousLabel = _ref2$previousLabel === void 0 ? "previous" : _ref2$previousLabel, _ref2$nextLabel = _ref2.nextLabel, nextLabel = _ref2$nextLabel === void 0 ? "next" : _ref2$nextLabel, _ref2$style = _ref2.style, style = _ref2$style === void 0 ? (0, $4d8d9dd05a1c85b3$export$3f860eba1218f8d3) : _ref2$style, _ref2$max = _ref2.max, max = _ref2$max === void 0 ? 7 : _ref2$max, _ref2$onChange = _ref2.onChange, onChange = _ref2$onChange === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref2$onChange, pages = _ref2.pages, getPageLabel = _ref2.getPageLabel, _ref2$renderEllipsis = _ref2.renderEllipsis, renderEllipsis = _ref2$renderEllipsis === void 0 ? (0, $b4cb222789309f61$export$2e2bcd8739ae039) : _ref2$renderEllipsis, analyticsContext = _ref2.analyticsContext, testId = _ref2.testId, isDisabled = _ref2.isDisabled;
    var _useControlled = (0, $91a58227bcfc77cc$export$2e2bcd8739ae039)(selectedIndex, function() {
        return defaultSelectedIndex || 0;
    }), _useControlled2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useControlled, 2), selectedIndexValue = _useControlled2[0], setSelectedIndexValue = _useControlled2[1];
    var onChangeWithAnalytics = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($0ea9908cf529c1f6$var$_objectSpread({
        fn: function fn(value, analyticsEvent) {
            var event = value.event, selectedPageIndex = value.selectedPageIndex;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: "changed",
        actionSubject: "pageNumber",
        analyticsData: analyticsContext
    }, $0ea9908cf529c1f6$var$analyticsAttributes));
    var transform = function transform(page, currPageIndex, testId) {
        var selectedPage = pages[selectedIndexValue];
        var pageIndexLabel = "".concat(pageLabel, " ").concat(getPageLabel ? getPageLabel(page, currPageIndex) : page);
        var isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f2901d7c083b4af1$export$2e2bcd8739ae039), {
            as: "li",
            xcss: $0ea9908cf529c1f6$var$styles.paginationMenuItem,
            key: "page-".concat(getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01d581d55a7dd5f1$export$2e2bcd8739ae039), {
            component: components.Page,
            onClick: function onClick(event) {
                return onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                });
            },
            "aria-current": isCurrentPage ? "page" : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && "".concat(testId, "--").concat(isCurrentPage ? "current-" : "", "page-").concat(currPageIndex)
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f2901d7c083b4af1$export$2e2bcd8739ae039), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35978dafa76b5486$export$2e2bcd8739ae039), {
        key: "left-navigator",
        component: components.Previous,
        onClick: function onClick(event) {
            return onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            });
        },
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0ea9908cf529c1f6$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && "".concat(testId, "--left-navigator")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f2901d7c083b4af1$export$2e2bcd8739ae039), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $0ea9908cf529c1f6$var$styles.paginationMenu
    }, (0, $770df8a2ade37f3e$export$2e2bcd8739ae039)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35978dafa76b5486$export$2e2bcd8739ae039), {
        key: "right-navigator",
        component: components.Next,
        onClick: function onClick(event) {
            return onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            });
        },
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0ea9908cf529c1f6$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && "".concat(testId, "--right-navigator")
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ var $0ea9908cf529c1f6$var$Pagination = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)($0ea9908cf529c1f6$var$InnerPagination));
var $0ea9908cf529c1f6$export$2e2bcd8739ae039 = $0ea9908cf529c1f6$var$Pagination;


function $7a2ad14cacdb7a78$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $7a2ad14cacdb7a78$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $7a2ad14cacdb7a78$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7a2ad14cacdb7a78$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7a2ad14cacdb7a78$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function ManagedPagination() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ManagedPagination);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $7a2ad14cacdb7a78$var$_callSuper(this, ManagedPagination, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onChange", function(_event, newValue, analyticsEvent) {
            _this.props.onChange(newValue, analyticsEvent);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ManagedPagination, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ManagedPagination, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, total = _this$props.total, _this$props$value = _this$props.value, value = _this$props$value === void 0 ? 1 : _this$props$value, i18n = _this$props.i18n, testId = _this$props.testId, isDisabled = _this$props.isDisabled;
                var pages = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Array(total)).map(function(_, index) {
                    return index + 1;
                });
                // Pagination accepts array now thus selectedIndex starts with 0
                // So, we are substracting value by one thus not breaking dynamic table
                var selectedIndex = value - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0ea9908cf529c1f6$export$2e2bcd8739ae039), {
                    selectedIndex: selectedIndex,
                    isDisabled: isDisabled,
                    label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
                    nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
                    previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
                    pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
                    onChange: this.onChange,
                    pages: pages,
                    testId: testId && "".concat(testId, "--pagination")
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $acw62 = parcelRequire("acw62");

var $ltooA = parcelRequire("ltooA");

var $3V3p2 = parcelRequire("3V3p2");
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");

var $ltooA = parcelRequire("ltooA");

var $dnCk4 = parcelRequire("dnCk4");

var $7Dr7Z = parcelRequire("7Dr7Z");

var $2phQv = parcelRequire("2phQv");
var $d288ef7a0f5bd03d$var$_excluded = [
    "isRanking",
    "testId"
], $d288ef7a0f5bd03d$var$_excluded2 = [
    "width",
    "children",
    "isSortable",
    "sortOrder",
    "isFixedSize",
    "shouldTruncate",
    "onClick",
    "style",
    "testId"
];
function $d288ef7a0f5bd03d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d288ef7a0f5bd03d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d288ef7a0f5bd03d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d288ef7a0f5bd03d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d288ef7a0f5bd03d$var$CSS_VAR_TEXT_COLOR = "--local-dynamic-table-text-color";
var $d288ef7a0f5bd03d$var$rankingStyles = null;
var $d288ef7a0f5bd03d$var$headStyles = null;
var $d288ef7a0f5bd03d$var$overflowTruncateStyles = null;
var $d288ef7a0f5bd03d$var$truncationWidthStyles = null;
var $d288ef7a0f5bd03d$var$fixedSizeTruncateStyles = null;
var $d288ef7a0f5bd03d$var$cellStyles = null;
var $d288ef7a0f5bd03d$export$e93312b7773dfcac = function Head(_ref) {
    var isRanking = _ref.isRanking, testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $d288ef7a0f5bd03d$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement("thead", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "data-testid": testId
    }, props, {
        className: (0, $5zphJ.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    }));
};
var $d288ef7a0f5bd03d$var$headCellBaseStyles = null;
var $d288ef7a0f5bd03d$var$headCellBaseStylesOld = null;
var $d288ef7a0f5bd03d$var$onClickStyles = null;
var $d288ef7a0f5bd03d$var$baseStyles = null;
var $d288ef7a0f5bd03d$var$ascendingStyles = null;
var $d288ef7a0f5bd03d$var$descendingStyles = null;
var $d288ef7a0f5bd03d$export$4e8024263ace498b = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref2, ref) {
    var width = _ref2.width, children = _ref2.children, isSortable = _ref2.isSortable, sortOrder = _ref2.sortOrder, isFixedSize = _ref2.isFixedSize, shouldTruncate = _ref2.shouldTruncate, onClick = _ref2.onClick, style = _ref2.style, testId = _ref2.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $d288ef7a0f5bd03d$var$_excluded2);
    var mergedStyles = $d288ef7a0f5bd03d$var$_objectSpread($d288ef7a0f5bd03d$var$_objectSpread($d288ef7a0f5bd03d$var$_objectSpread({}, style), width && (0, $2phQv.getTruncationStyleVars)({
        width: width
    })), {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $d288ef7a0f5bd03d$var$CSS_VAR_TEXT_COLOR, "var(--ds-text-subtlest, ".concat((0, $dnCk4.N300), ")")));
    var isASC = sortOrder === (0, $7Dr7Z.ASC);
    var isDESC = sortOrder === (0, $7Dr7Z.DESC);
    var getFormattedSortOrder = function getFormattedSortOrder() {
        if (isASC) return "ascending";
        else if (isDESC) return "descending";
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    var Component = children ? "th" : "td";
    var isVisuallyRefreshed = (0, $ltooA.fg)("platform-component-visual-refresh");
    return /*#__PURE__*/ $acw62.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "aria-sort": getFormattedSortOrder(),
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId
    }, rest, {
        className: (0, $5zphJ.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179rralu _mqm2glyw _vchhusvi _kqswh2mm _syaz12fi _k48pmoej _y3gn1e5h _s7n4nkob _1ygbuwsq" : "_11c8dcr7 _179rralu _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz12fi _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbuwsq",
            !isVisuallyRefreshed && onClick && "_irr3bfnf _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk1j28 _1wfn1j28 _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77k1f6e _qzvtu2gc _f4731f6e _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k2wk4 _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4732wk4 _17x894yt"
        ]),
        style: $d288ef7a0f5bd03d$var$_objectSpread($d288ef7a0f5bd03d$var$_objectSpread({}, mergedStyles), {}, {
            "--_k02y3n": (0, $cZGu3.default)("2px solid ".concat("var(--ds-border, ".concat((0, $dnCk4.N40), ")"))),
            "--_17ckjys": (0, $cZGu3.default)("var(--ds-text-subtle, ".concat("var(".concat($d288ef7a0f5bd03d$var$CSS_VAR_TEXT_COLOR, ")"), ")")),
            "--_jz8ahf": (0, $cZGu3.default)("solid 2px ".concat("var(--ds-border-focused, ".concat((0, $dnCk4.B100), ")"))),
            "--_6j4ewu": (0, $cZGu3.default)("var(--ds-background-neutral-hovered, ".concat((0, $dnCk4.N30A), ")")),
            "--_1rdacuj": (0, $cZGu3.default)("3px solid ".concat("var(--ds-icon-disabled, ".concat((0, $dnCk4.N40), ")"))),
            "--_1qca9zt": (0, $cZGu3.default)("3px solid ".concat("var(--ds-icon-subtle, ".concat((0, $dnCk4.N300), ")")))
        })
    }), children);
});



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $acw62 = parcelRequire("acw62");

var $aukfC = parcelRequire("aukfC");

var $3V3p2 = parcelRequire("3V3p2");
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");


var $acw62 = parcelRequire("acw62");
var $986336a19535790a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($986336a19535790a$exports, "__esModule", {
    value: true
});
$986336a19535790a$exports.default = void 0;

var $986336a19535790a$var$_react = $986336a19535790a$var$_interopRequireDefault((parcelRequire("acw62")));

var $986336a19535790a$var$_baseNew = $986336a19535790a$var$_interopRequireDefault((parcelRequire("fqFky")));
function $986336a19535790a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $986336a19535790a$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $986336a19535790a$var$_react.default.createElement($986336a19535790a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$986336a19535790a$var$ArrowDownIcon.displayName = "ArrowDownIcon";
var $986336a19535790a$var$_default = $986336a19535790a$exports.default = $986336a19535790a$var$ArrowDownIcon;


var $89afd23d3594b8e8$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($89afd23d3594b8e8$exports, "__esModule", {
    value: true
});
$89afd23d3594b8e8$exports.default = void 0;

var $89afd23d3594b8e8$var$_react = $89afd23d3594b8e8$var$_interopRequireDefault((parcelRequire("acw62")));

var $89afd23d3594b8e8$var$_baseNew = $89afd23d3594b8e8$var$_interopRequireDefault((parcelRequire("fqFky")));
function $89afd23d3594b8e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89afd23d3594b8e8$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $89afd23d3594b8e8$var$_react.default.createElement($89afd23d3594b8e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$89afd23d3594b8e8$var$ArrowUpIcon.displayName = "ArrowUpIcon";
var $89afd23d3594b8e8$var$_default = $89afd23d3594b8e8$exports.default = $89afd23d3594b8e8$var$ArrowUpIcon;





var $7Dr7Z = parcelRequire("7Dr7Z");

var $50bd260335f9d1cd$var$_excluded = [
    "content",
    "inlineStyles",
    "testId",
    "isRanking",
    "innerRef",
    "isSortable",
    "sortOrder",
    "onClick",
    "headCellId",
    "activeSortButtonId",
    "ascendingSortTooltip",
    "descendingSortTooltip",
    "buttonAriaRoleDescription",
    "isIconOnlyHeader"
];
var $50bd260335f9d1cd$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
var $50bd260335f9d1cd$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
var $50bd260335f9d1cd$var$TableHeadCell = function TableHeadCell(_ref) {
    var content = _ref.content, inlineStyles = _ref.inlineStyles, testId = _ref.testId, isRanking = _ref.isRanking, innerRef = _ref.innerRef, isSortable = _ref.isSortable, sortOrder = _ref.sortOrder, onClick = _ref.onClick, headCellId = _ref.headCellId, activeSortButtonId = _ref.activeSortButtonId, _ref$ascendingSortToo = _ref.ascendingSortTooltip, ascendingSortTooltip = _ref$ascendingSortToo === void 0 ? "Sort ascending" : _ref$ascendingSortToo, _ref$descendingSortTo = _ref.descendingSortTooltip, descendingSortTooltip = _ref$descendingSortTo === void 0 ? "Sort descending" : _ref$descendingSortTo, _ref$buttonAriaRoleDe = _ref.buttonAriaRoleDescription, buttonAriaRoleDescription = _ref$buttonAriaRoleDe === void 0 ? "Sort button" : _ref$buttonAriaRoleDe, isIconOnlyHeader = _ref.isIconOnlyHeader, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $50bd260335f9d1cd$var$_excluded);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isHovered = _useState2[0], setIsHovered = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isFocused = _useState4[0], setIsFocused = _useState4[1];
    var isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    var isSortIconVisible = isHovered || isActive || isFocused;
    var isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    var shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    var handleFocus = (0, $acw62.useCallback)(function() {
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(true);
    }, [
        setIsFocused
    ]);
    var handleBlur = (0, $acw62.useCallback)(function() {
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(false);
    }, [
        setIsFocused
    ]);
    var handleMouseEnter = (0, $acw62.useCallback)(function() {
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    var handleMouseLeave = (0, $acw62.useCallback)(function() {
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    var visuallyRefreshedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        xcss: $50bd260335f9d1cd$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fa9833ed171567b$export$2e2bcd8739ae039), {
        content: sortOrder === (0, $7Dr7Z.ASC) ? ascendingSortTooltip : descendingSortTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c5f2789211abe33c$export$2e2bcd8739ae039), {
        onClick: onClick,
        xcss: $50bd260335f9d1cd$var$styles.buttonWrapper,
        "aria-roledescription": buttonAriaRoleDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc6b3ef262d2d718$export$2e2bcd8739ae039), {
        xcss: isVisibleIconOnlyHeader ? $50bd260335f9d1cd$var$styles.hideIconHeaderWrapper : $50bd260335f9d1cd$var$styles.visibleHeaderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18c6b2a5dadc0a2b$export$2e2bcd8739ae039), {
        size: "small",
        color: "color.text.subtle",
        weight: "bold",
        maxLines: 1
    }, content)), shouldRenderSortIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc6b3ef262d2d718$export$2e2bcd8739ae039), {
        xcss: isSortIconVisible ? $50bd260335f9d1cd$var$styles.sortIconVisibleWrapper : $50bd260335f9d1cd$var$styles.sortIconHiddenWrapper
    }, sortOrder === (0, $7Dr7Z.ASC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($89afd23d3594b8e8$exports))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && "".concat(testId, "--up--icon")
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($986336a19535790a$exports))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && "".concat(testId, "--down--icon")
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d288ef7a0f5bd03d$export$4e8024263ace498b), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: inlineStyles,
        testId: testId && "".concat(testId, "--head--cell"),
        ref: typeof innerRef !== "string" ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    }, rest, {
        isSortable: isSortable,
        sortOrder: sortOrder
    }), isSortable ? visuallyRefreshedButton : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$50bd260335f9d1cd$export$2e2bcd8739ae039 = $50bd260335f9d1cd$var$TableHeadCell;


var $18a66bab87c651a3$var$_excluded = [
    "isRanking",
    "refHeight",
    "refWidth"
];
function $18a66bab87c651a3$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $18a66bab87c651a3$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $18a66bab87c651a3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($18a66bab87c651a3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $18a66bab87c651a3$var$RankableTableHeadCellComponent = /*#__PURE__*/ function(_React$Component) {
    function RankableTableHeadCellComponent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RankableTableHeadCellComponent);
        return $18a66bab87c651a3$var$_callSuper(this, RankableTableHeadCellComponent, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(RankableTableHeadCellComponent, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RankableTableHeadCellComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, isRanking = _this$props.isRanking, refHeight = _this$props.refHeight, refWidth = _this$props.refWidth, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$props, $18a66bab87c651a3$var$_excluded);
                var inlineStyles = (0, $3V3p2.inlineStylesIfRanking)(isRanking, refWidth);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $50bd260335f9d1cd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    inlineStyles: inlineStyles
                }, restProps));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18a66bab87c651a3$var$RankableTableHeadCell = (0, $aukfC.default)($18a66bab87c651a3$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$18a66bab87c651a3$export$2e2bcd8739ae039 = $18a66bab87c651a3$var$RankableTableHeadCell;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $f8wIT = parcelRequire("f8wIT");

var $acw62 = parcelRequire("acw62");

var $aukfC = parcelRequire("aukfC");

var $3V3p2 = parcelRequire("3V3p2");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");

var $53c917e7881dc470$var$_excluded = [
    "content",
    "inlineStyles",
    "testId",
    "isRanking",
    "innerRef",
    "isSortable",
    "onClick"
];
var $53c917e7881dc470$var$TableHeadCellOld = function TableHeadCellOld(_ref) {
    var content = _ref.content, inlineStyles = _ref.inlineStyles, testId = _ref.testId, isRanking = _ref.isRanking, innerRef = _ref.innerRef, isSortable = _ref.isSortable, onClick = _ref.onClick, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $53c917e7881dc470$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d288ef7a0f5bd03d$export$4e8024263ace498b), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: inlineStyles,
        testId: testId && "".concat(testId, "--head--cell"),
        ref: typeof innerRef !== "string" ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    }, rest, {
        onClick: onClick,
        isSortable: isSortable
    }), isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$53c917e7881dc470$export$2e2bcd8739ae039 = $53c917e7881dc470$var$TableHeadCellOld;


var $42a44600d4b5fadf$var$_excluded = [
    "isRanking",
    "refHeight",
    "refWidth"
];
function $42a44600d4b5fadf$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $42a44600d4b5fadf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $42a44600d4b5fadf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($42a44600d4b5fadf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $42a44600d4b5fadf$var$RankableTableHeadCellComponentOld = /*#__PURE__*/ function(_React$Component) {
    function RankableTableHeadCellComponentOld() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RankableTableHeadCellComponentOld);
        return $42a44600d4b5fadf$var$_callSuper(this, RankableTableHeadCellComponentOld, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(RankableTableHeadCellComponentOld, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RankableTableHeadCellComponentOld, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, isRanking = _this$props.isRanking, refHeight = _this$props.refHeight, refWidth = _this$props.refWidth, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$props, $42a44600d4b5fadf$var$_excluded);
                var inlineStyles = (0, $3V3p2.inlineStylesIfRanking)(isRanking, refWidth);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $53c917e7881dc470$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    inlineStyles: inlineStyles
                }, restProps));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $42a44600d4b5fadf$var$RankableTableHeadCellOld = (0, $aukfC.default)($42a44600d4b5fadf$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$42a44600d4b5fadf$export$2e2bcd8739ae039 = $42a44600d4b5fadf$var$RankableTableHeadCellOld;




var $640744b0f74b9dc4$var$_excluded = [
    "cells"
], $640744b0f74b9dc4$var$_excluded2 = [
    "ascendingSortTooltip",
    "buttonAriaRoleDescription",
    "colSpan",
    "content",
    "descendingSortTooltip",
    "isIconOnlyHeader",
    "isSortable",
    "key",
    "shouldTruncate",
    "testId",
    "width"
];
function $640744b0f74b9dc4$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $640744b0f74b9dc4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $640744b0f74b9dc4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($640744b0f74b9dc4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $640744b0f74b9dc4$var$TableHead = /*#__PURE__*/ function(_React$Component) {
    function TableHead(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, TableHead);
        _this = $640744b0f74b9dc4$var$_callSuper(this, TableHead, [
            props
        ]);
        _this.state = {
            activeSortButtonId: null
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(TableHead, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(TableHead, [
        {
            key: "UNSAFE_componentWillMount",
            value: function UNSAFE_componentWillMount() {
                (0, $3V3p2.validateSortKey)(this.props.sortKey, this.props.head);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $3V3p2.validateSortKey)(nextProps.sortKey, nextProps.head);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, head = _this$props.head, sortKey = _this$props.sortKey, sortOrder = _this$props.sortOrder, isFixedSize = _this$props.isFixedSize, onSort = _this$props.onSort, isRanking = _this$props.isRanking, isRankable = _this$props.isRankable, testId = _this$props.testId;
                var activeSortButtonId = this.state.activeSortButtonId;
                if (!head) return null;
                var HeadCellComponentOld = isRankable ? (0, $42a44600d4b5fadf$export$2e2bcd8739ae039) : (0, $53c917e7881dc470$export$2e2bcd8739ae039);
                var HeadCellComponent = isRankable ? (0, $18a66bab87c651a3$export$2e2bcd8739ae039) : (0, $50bd260335f9d1cd$export$2e2bcd8739ae039);
                // TODO: Remove `rest` props and use only what is explicitly in the API.
                // Some tests use this to pass in onClick and other stuff within the `head`
                // variable here, but considering it's not in the API, it should probably
                // be removed.
                var cells = head.cells, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(head, $640744b0f74b9dc4$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d288ef7a0f5bd03d$export$e93312b7773dfcac), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
                    isRanking: isRanking,
                    testId: testId && "".concat(testId, "--head")
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, cells.map(function(cell, index) {
                    var ascendingSortTooltip = cell.ascendingSortTooltip, buttonAriaRoleDescription = cell.buttonAriaRoleDescription, colSpan = cell.colSpan, content = cell.content, descendingSortTooltip = cell.descendingSortTooltip, isIconOnlyHeader = cell.isIconOnlyHeader, isSortable = cell.isSortable, key = cell.key, shouldTruncate = cell.shouldTruncate, cellTestId = cell.testId, width = cell.width, restCellProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(cell, $640744b0f74b9dc4$var$_excluded2);
                    var headCellId = "head-cell-".concat(index);
                    var handleClick = function handleClick() {
                        _this2.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $ltooA.fg)("platform-component-visual-refresh") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(HeadCellComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        key: key || index,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription
                    }, restCellProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(HeadCellComponentOld, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        key: key || index,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width
                    }, restCellProps));
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $640744b0f74b9dc4$export$2e2bcd8739ae039 = $640744b0f74b9dc4$var$TableHead;


var $0d726897b07d67b1$var$_excluded = [
    "isRankable",
    "isRanking",
    "onRankStart",
    "onRankEnd",
    "isRankingDisabled"
];
function $0d726897b07d67b1$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $7Dr7Z.DESC:
            return 0, $7Dr7Z.ASC;
        case 0, $7Dr7Z.ASC:
            return 0, $7Dr7Z.DESC;
        default:
            return currentSortOrder;
    }
}
var $0d726897b07d67b1$var$DynamicTable = function DynamicTable(_ref) {
    var caption = _ref.caption, head = _ref.head, highlightedRowIndex = _ref.highlightedRowIndex, rows = _ref.rows, sortKey = _ref.sortKey, sortOrder = _ref.sortOrder, loadingLabel = _ref.loadingLabel, onPageRowsUpdate = _ref.onPageRowsUpdate, testId = _ref.testId, passedDownTotalRows = _ref.totalRows, label = _ref.label, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isFixedSize = _ref.isFixedSize, isFixedSize = _ref$isFixedSize === void 0 ? false : _ref$isFixedSize, _ref$rowsPerPage = _ref.rowsPerPage, rowsPerPage = _ref$rowsPerPage === void 0 ? Infinity : _ref$rowsPerPage, _ref$onSetPage = _ref.onSetPage, onSetPage = _ref$onSetPage === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onSetPage, _ref$onSort = _ref.onSort, providedOnSort = _ref$onSort === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onSort, _ref$page = _ref.page, page = _ref$page === void 0 ? 1 : _ref$page, emptyView = _ref.emptyView, _ref$isRankable = _ref.isRankable, isRankable = _ref$isRankable === void 0 ? false : _ref$isRankable, _ref$isRankingDisable = _ref.isRankingDisabled, isRankingDisabled = _ref$isRankingDisable === void 0 ? false : _ref$isRankingDisable, _ref$onRankStart = _ref.onRankStart, onRankStart = _ref$onRankStart === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onRankStart, _ref$onRankEnd = _ref.onRankEnd, providedOnRankEnd = _ref$onRankEnd === void 0 ? (0, $d3997b4aab843580$export$2e2bcd8739ae039) : _ref$onRankEnd, loadingSpinnerSize = _ref.loadingSpinnerSize, _ref$paginationi18n = _ref.paginationi18n, paginationi18n = _ref$paginationi18n === void 0 ? {
        prev: (0, $ltooA.fg)("eax-1131_fix_a11y_issues_global_issues_settings") ? "Previous Page" : "Previous",
        next: (0, $ltooA.fg)("eax-1131_fix_a11y_issues_global_issues_settings") ? "Next Page" : "Next",
        label: "Pagination",
        pageLabel: "Page"
    } : _ref$paginationi18n;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), isRanking = _useState2[0], setIsRanking = _useState2[1];
    var tableBodyRef = (0, $acw62.useRef)(null);
    var onSort = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: providedOnSort,
        action: "sorted",
        componentName: "dynamicTable",
        packageName: "@atlaskit/dynamic-table",
        packageVersion: "18.0.4"
    });
    var onRankEnd = (0, $ee8f8175665f2347$export$a4687b0234b40e28)({
        fn: providedOnRankEnd,
        action: "ranked",
        componentName: "dynamicTable",
        packageName: "@atlaskit/dynamic-table",
        packageVersion: "18.0.4"
    });
    (0, $acw62.useEffect)(function() {
        (0, $3V3p2.validateSortKey)(sortKey, head);
        (0, $3V3p2.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    var onSortHandler = function onSortHandler(item) {
        return function() {
            var key = item.key;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $7Dr7Z.DESC)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            var sortOrderFormatted = key !== sortKey ? (0, $7Dr7Z.ASC) : $0d726897b07d67b1$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    };
    var onSetPageHandler = function onSetPageHandler(page, event) {
        onSetPage(page, event);
    };
    var onRankStartHandler = function onRankStartHandler(params) {
        setIsRanking(true);
        onRankStart(params);
    };
    var onRankEndHandler = function onRankEndHandler(params) {
        setIsRanking(false);
        onRankEnd(params);
    };
    var getSpinnerSize = function getSpinnerSize() {
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $3V3p2.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $7Dr7Z.LARGE) : (0, $7Dr7Z.SMALL);
    };
    var renderEmptyBody = function renderEmptyBody() {
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82fbc6429a5e1d5c$export$8f45b9407d4090d7), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82fbc6429a5e1d5c$export$381ea436de119582), {
            testId: testId
        }, emptyView);
    };
    var rowsLength = rows && rows.length;
    var totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    var isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    var getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    var rowsExist = !!rowsLength;
    var spinnerSize = getSpinnerSize();
    var emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c9ff243d213f17f1$export$2e2bcd8739ae039), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: function targetRef() {
            return tableBodyRef.current;
        },
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f94e7324e0698144$export$54ec01a60f47d33d), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f94e7324e0698144$export$32fbfacc5d962e0c), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $640744b0f74b9dc4$export$2e2bcd8739ae039), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d726897b07d67b1$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : /*#__PURE__*/ // only show pagination if there's MORE than 1 page
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f94e7324e0698144$export$3e5e12dc01f20a43), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a2ad14cacdb7a78$export$2e2bcd8739ae039), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5afbfba05fa6580a$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        spinnerSize: (0, $7Dr7Z.LARGE),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

var $0d726897b07d67b1$var$RankableTableBody = /*#__PURE__*/ (0, $acw62.lazy)(function() {
    return (parcelRequire("hwM0X"));
});
var $0d726897b07d67b1$var$TableBody = /*#__PURE__*/ (0, $acw62.forwardRef)(function TableBody(_ref2, ref) {
    var _ref2$isRankable = _ref2.isRankable, isRankable = _ref2$isRankable === void 0 ? false : _ref2$isRankable, isRanking = _ref2.isRanking, onRankStart = _ref2.onRankStart, onRankEnd = _ref2.onRankEnd, isRankingDisabled = _ref2.isRankingDisabled, bodyProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref2, $0d726897b07d67b1$var$_excluded);
    var canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), canRenderRankable = _useState4[0], setCanRenderRankable = _useState4[1];
    (0, $acw62.useEffect)(function() {
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    var nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1079e9f423df4cd0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, bodyProps));
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fef8293417eb387$export$e926676385687eaf), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d726897b07d67b1$var$RankableTableBody, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        ref: ref
    }, bodyProps, {
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    })))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0d726897b07d67b1$export$2e2bcd8739ae039 = $0d726897b07d67b1$var$DynamicTable;


function $a54d86cb7351f254$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(t, $a54d86cb7351f254$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(t).constructor) : o.apply(t, e));
}
function $a54d86cb7351f254$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a54d86cb7351f254$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * __Dynamic Table__
 *
 * A table displays rows of data with built-in pagination, sorting, and re-ordering functionality.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/dynamic-table)
 * - [Code](https://bitbucket.org/atlassian/atlassian-frontend/packages/design-system/dynamic-table)
 *
 * @example
 * ```jsx
 * import DynamicTable from '@atlaskit/dynamic-table';
 *
 * export default function TableUncontrolled() {
 *  return (
 *   <DynamicTable
 *    head={head}
 *    rows={rows}
 *    rowsPerPage={10}
 *    defaultPage={1}
 *    loadingSpinnerSize="large"
 *    isLoading={false}
 *   />
 *  );
 * }
 * ```
 */ var $a54d86cb7351f254$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function DynamicTable() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DynamicTable);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $a54d86cb7351f254$var$_callSuper(this, DynamicTable, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "state", {
            page: _this.props.defaultPage,
            sortKey: _this.props.defaultSortKey,
            sortOrder: _this.props.defaultSortOrder,
            rows: _this.props.rows
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onSetPageHandler", function(page, analyticsEvent) {
            var onSetPage = _this.props.onSetPage;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                _this.setState({
                    page: page
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onSortHandler", function(_ref, analyticsEvent) {
            var key = _ref.key, item = _ref.item, sortOrder = _ref.sortOrder;
            var onSort = _this.props.onSort;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                _this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onRankEndIfExistsHandler", function(params) {
            if (_this.props.onRankEnd) _this.props.onRankEnd(params);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_this, "onRankEndHandler", function(params) {
            var destination = params.destination;
            var _this$state = _this.state, rows = _this$state.rows, page = _this$state.page;
            var rowsPerPage = _this.props.rowsPerPage;
            if (!destination || !rows) {
                _this.onRankEndIfExistsHandler(params);
                return;
            }
            var reordered = (0, $3V3p2.reorderRows)(params, rows, page, rowsPerPage);
            _this.setState({
                rows: reordered
            });
            _this.onRankEndIfExistsHandler(params);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(DynamicTable, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DynamicTable, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(newProps) {
                var sortKey = newProps.sortKey || this.state.sortKey;
                var sortOrder = newProps.sortOrder || this.state.sortOrder;
                var page = newProps.page || this.state.page;
                this.setState({
                    page: page,
                    sortKey: sortKey,
                    sortOrder: sortOrder,
                    rows: newProps.rows
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state2 = this.state, page = _this$state2.page, sortKey = _this$state2.sortKey, sortOrder = _this$state2.sortOrder, rows = _this$state2.rows;
                var _this$props = this.props, caption = _this$props.caption, emptyView = _this$props.emptyView, head = _this$props.head, highlightedRowIndex = _this$props.highlightedRowIndex, loadingSpinnerSize = _this$props.loadingSpinnerSize, isLoading = _this$props.isLoading, loadingLabel = _this$props.loadingLabel, isFixedSize = _this$props.isFixedSize, isRankable = _this$props.isRankable, isRankingDisabled = _this$props.isRankingDisabled, rowsPerPage = _this$props.rowsPerPage, paginationi18n = _this$props.paginationi18n, onRankStart = _this$props.onRankStart, onPageRowsUpdate = _this$props.onPageRowsUpdate, testId = _this$props.testId, label = _this$props.label;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d726897b07d67b1$export$2e2bcd8739ae039), {
                    paginationi18n: paginationi18n,
                    caption: caption,
                    emptyView: emptyView,
                    head: head,
                    highlightedRowIndex: highlightedRowIndex,
                    loadingSpinnerSize: loadingSpinnerSize,
                    isLoading: isLoading,
                    loadingLabel: loadingLabel,
                    isFixedSize: isFixedSize,
                    onSetPage: this.onSetPageHandler,
                    onSort: this.onSortHandler,
                    page: page,
                    rows: rows,
                    rowsPerPage: rowsPerPage,
                    sortKey: sortKey,
                    sortOrder: sortOrder,
                    isRankable: isRankable,
                    isRankingDisabled: isRankingDisabled,
                    onRankEnd: this.onRankEndHandler,
                    onRankStart: onRankStart,
                    onPageRowsUpdate: onPageRowsUpdate,
                    testId: testId,
                    label: label
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($a54d86cb7351f254$export$2e2bcd8739ae039, "defaultProps", {
    defaultPage: 1,
    isLoading: false,
    isFixedSize: false,
    isRankable: false,
    onSetPage: (0, $d3997b4aab843580$export$2e2bcd8739ae039),
    onSort: (0, $d3997b4aab843580$export$2e2bcd8739ae039),
    rowsPerPage: Infinity
});




var $7701b548f2a152b5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c2ea3862f75cebada30b1178c22cdb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($7701b548f2a152b5$exports, "__esModule", {
    value: true
});
$7701b548f2a152b5$exports.default = void 0;

var $7701b548f2a152b5$var$_react = $7701b548f2a152b5$var$_interopRequireDefault((parcelRequire("acw62")));

var $7701b548f2a152b5$var$_baseNew = $7701b548f2a152b5$var$_interopRequireDefault((parcelRequire("fqFky")));
function $7701b548f2a152b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7701b548f2a152b5$var$SearchIcon = (props)=>/*#__PURE__*/ $7701b548f2a152b5$var$_react.default.createElement($7701b548f2a152b5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$7701b548f2a152b5$var$SearchIcon.displayName = "SearchIcon";
var $7701b548f2a152b5$var$_default = $7701b548f2a152b5$exports.default = $7701b548f2a152b5$var$SearchIcon;





var $acw62 = parcelRequire("acw62");

const $f6420ab55d208491$export$83c6651d3fd522be = 500;
const $f6420ab55d208491$var$searchWrapperStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    width: "100%",
    marginBottom: "space.100"
});
const $f6420ab55d208491$export$55d7609a8f1eccd2 = ({ onSearch: onSearch, placeholder: placeholder, testId: testId })=>{
    const [search, setSearch] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        if (search === "") onSearch("");
        const searchHandler = setTimeout(()=>{
            if (search) onSearch(search);
        }, $f6420ab55d208491$export$83c6651d3fd522be);
        return ()=>{
            clearTimeout(searchHandler);
        };
    }, [
        search,
        onSearch
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        xcss: $f6420ab55d208491$var$searchWrapperStyles,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $59fee00d0d1a69dc$export$2e2bcd8739ae039), {
            testId: testId ? `${testId}-search-input` : undefined,
            id: "search-input",
            onChange: (e)=>{
                setSearch(e.currentTarget.value);
            },
            placeholder: placeholder ?? "Search",
            value: search,
            elemBeforeInput: (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
                as: "span",
                paddingInlineStart: "space.100",
                children: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7701b548f2a152b5$exports))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            }),
            autoComplete: "off"
        })
    });
};


const $23da3c291c0fddec$export$680c2e5e5eec1385 = 10;



const $622a69e27ffb1ba3$export$88904f849af903e6 = ({ headingText: headingText, error: error, tableHead: tableHead, tableRows: tableRows, loading: loading, rowsPerPage: rowsPerPage = (0, $23da3c291c0fddec$export$680c2e5e5eec1385), currentPage: currentPage, setCurrentPage: setCurrentPage, onSearch: onSearch, searchPlaceholder: searchPlaceholder })=>(0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
        space: "space.150",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                as: "h3",
                size: "small",
                children: headingText
            }),
            onSearch && (0, $7b02d682eb115277$exports.jsx)((0, $f6420ab55d208491$export$55d7609a8f1eccd2), {
                onSearch: onSearch,
                testId: "settings-list",
                placeholder: searchPlaceholder
            }),
            error ? (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                children: error
            }) : (0, $7b02d682eb115277$exports.jsx)((0, $a54d86cb7351f254$export$2e2bcd8739ae039), {
                isFixedSize: true,
                head: tableHead,
                rows: tableRows,
                rowsPerPage: rowsPerPage,
                page: currentPage,
                onSetPage: setCurrentPage,
                isLoading: loading ?? false,
                emptyView: (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                    children: "No results were found."
                })
            })
        ]
    });





var $acw62 = parcelRequire("acw62");



const $640541f0aa41bdd6$export$39b6bc45110e434e = ()=>{
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const setCodePlannerSettings = (0, $acw62.useCallback)(async (codePlannerSettings)=>{
        setLoading(true);
        const settingsRequestList = codePlannerSettings.map((setting)=>({
                containerType: (0, $2804e02a1fe45ad3$export$e3c470447822f816),
                containerId: setting.containerId,
                key: (0, $2804e02a1fe45ad3$export$5f46e680e0216089),
                value: {
                    code_planner_enabled: setting.value
                }
            }));
        const settingsMap = new Map();
        try {
            const response = await fetch((0, $7313551ab8168ced$export$2e2bcd8739ae039)((0, $73696979d9e2fa35$export$49b8d3ee29ca4a5), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    settings: settingsRequestList
                })
            }));
            if (!response.ok) throw new Error(`Error: ${response.statusText}`);
            const data = await response.json();
            if (!data.success) throw new Error("Failed to set agent settings");
            data.settings.forEach((item)=>{
                settingsMap.set(item.containerId, item);
            });
        } catch (e) {
            setError("An error has occurred");
        }
        setLoading(false);
        return settingsMap;
    }, []);
    return {
        setCodePlannerSettings: setCodePlannerSettings,
        loading: loading,
        error: error
    };
};



/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $5zphJ = parcelRequire("5zphJ");
var $cZGu3 = parcelRequire("cZGu3");

var $acw62 = parcelRequire("acw62");

var $8fY35 = parcelRequire("8fY35");



var $3c66783819981cd6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($3c66783819981cd6$exports, "__esModule", {
    value: true
});
$3c66783819981cd6$exports.default = void 0;

var $3c66783819981cd6$var$_react = $3c66783819981cd6$var$_interopRequireDefault((parcelRequire("acw62")));

var $3c66783819981cd6$var$_checkMark = $3c66783819981cd6$var$_interopRequireDefault((parcelRequire("9FrBT")));

var $3c66783819981cd6$var$_done = $3c66783819981cd6$var$_interopRequireDefault((parcelRequire("gm5D7")));
function $3c66783819981cd6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c66783819981cd6$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $3c66783819981cd6$var$_react.default.createElement($3c66783819981cd6$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $3c66783819981cd6$var$_done.default
    }, props));
$3c66783819981cd6$var$CheckMarkIcon.Name = "CheckMarkIconMigration";
var $3c66783819981cd6$var$_default = $3c66783819981cd6$exports.default = $3c66783819981cd6$var$CheckMarkIcon;


var $fa814907f4a3bc0a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c13696afcc546e8bf0fe91a6c236c8d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($fa814907f4a3bc0a$exports, "__esModule", {
    value: true
});
$fa814907f4a3bc0a$exports.default = void 0;

var $fa814907f4a3bc0a$var$_react = $fa814907f4a3bc0a$var$_interopRequireDefault((parcelRequire("acw62")));

var $fa814907f4a3bc0a$var$_cross = $fa814907f4a3bc0a$var$_interopRequireDefault((parcelRequire("aqtvs")));

var $fa814907f4a3bc0a$var$_close = $fa814907f4a3bc0a$var$_interopRequireDefault((parcelRequire("127MC")));
function $fa814907f4a3bc0a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa814907f4a3bc0a$var$CrossIcon = (props)=>/*#__PURE__*/ $fa814907f4a3bc0a$var$_react.default.createElement($fa814907f4a3bc0a$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $fa814907f4a3bc0a$var$_close.default
    }, props));
$fa814907f4a3bc0a$var$CrossIcon.Name = "CrossIconMigration";
var $fa814907f4a3bc0a$var$_default = $fa814907f4a3bc0a$exports.default = $fa814907f4a3bc0a$var$CrossIcon;



var $ltooA = parcelRequire("ltooA");

var $dnCk4 = parcelRequire("dnCk4");
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");



var $ltooA = parcelRequire("ltooA");

var $9a5b325ff2f03546$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ var $9a5b325ff2f03546$var$IconContainer = function IconContainer(_ref) {
    var children = _ref.children, size = _ref.size, isHidden = _ref.isHidden, position = _ref.position;
    return /*#__PURE__*/ $acw62.createElement((0, $55175eaa0fdd994e$export$2e2bcd8739ae039), {
        as: "span",
        xcss: (0, $32a33265390ae51f$export$a274e22fb40f762e)($9a5b325ff2f03546$var$styles.iconContainer, isHidden && (0, $ltooA.fg)("platform-visual-refresh-icons") && $9a5b325ff2f03546$var$styles.hidden, size === "regular" && $9a5b325ff2f03546$var$styles.iconContainerRegular, size === "large" && $9a5b325ff2f03546$var$styles.iconContainerLarge, position === "left" && $9a5b325ff2f03546$var$styles.left, position === "right" && $9a5b325ff2f03546$var$styles.right)
    }, children);
};
var $9a5b325ff2f03546$export$2e2bcd8739ae039 = $9a5b325ff2f03546$var$IconContainer;


function $58893187255622b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $58893187255622b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $58893187255622b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $58893187255622b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $58893187255622b0$var$basicStyles = null;
var $58893187255622b0$var$borderStyles = null;
var $58893187255622b0$var$iconStyles = null;
var $58893187255622b0$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
var $58893187255622b0$var$noop = (0, $d3997b4aab843580$export$2e2bcd8739ae039);
var $58893187255622b0$var$analyticsAttributes = {
    componentName: "toggle",
    packageName: "@atlaskit/toggle",
    packageVersion: "15.0.4"
};
var $58893187255622b0$var$iconSizeMap = {
    regular: "small",
    large: "medium"
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ var $58893187255622b0$var$Toggle = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$onBlur = props.onBlur, providedOnBlur = _props$onBlur === void 0 ? $58893187255622b0$var$noop : _props$onBlur, _props$onChange = props.onChange, providedChange = _props$onChange === void 0 ? $58893187255622b0$var$noop : _props$onChange, _props$onFocus = props.onFocus, providedFocus = _props$onFocus === void 0 ? $58893187255622b0$var$noop : _props$onFocus, _props$size = props.size, size = _props$size === void 0 ? "regular" : _props$size, _props$name = props.name, name = _props$name === void 0 ? "" : _props$name, _props$value = props.value, value = _props$value === void 0 ? "" : _props$value, isChecked = props.isChecked, analyticsContext = props.analyticsContext, id = props.id, testId = props.testId, label = props.label, descriptionId = props.descriptionId;
    var isControlled = typeof isChecked === "undefined";
    var _useState = (0, $acw62.useState)(defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), checked = _useState2[0], setChecked = _useState2[1];
    var _useState3 = (0, $acw62.useState)(true), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), isKeyboardUsed = _useState4[0], setIsKeyboardUsed = _useState4[1];
    var wrapperRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ var linkedLabel = wrapperRef.current.parentElement.querySelector('label[for="'.concat(id, '"]'));
            if (linkedLabel) {
                var unbind = (0, $8fY35.bindAll)(linkedLabel, [
                    {
                        type: "click",
                        listener: function listener(event) {
                            setIsKeyboardUsed(false);
                            if ((event === null || event === void 0 ? void 0 : event.detail) > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    var handleBlur = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($58893187255622b0$var$_objectSpread({
        fn: function fn(event, analyticsEvent) {
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: "blur",
        analyticsData: analyticsContext
    }, $58893187255622b0$var$analyticsAttributes));
    var handleFocus = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($58893187255622b0$var$_objectSpread({
        fn: providedFocus,
        action: "focus",
        analyticsData: analyticsContext
    }, $58893187255622b0$var$analyticsAttributes));
    var handleChange = (0, $ee8f8175665f2347$export$a4687b0234b40e28)($58893187255622b0$var$_objectSpread({
        fn: function fn(event, analyticsEvent) {
            if (isControlled) setChecked(function(checked) {
                return !checked;
            });
            return providedChange(event, analyticsEvent);
        },
        action: "change",
        analyticsData: analyticsContext
    }, $58893187255622b0$var$analyticsAttributes));
    var onLabelKeyDown = function onLabelKeyDown(event) {
        if ([
            " ",
            "Tab",
            "Space"
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    var shouldChecked = isControlled ? checked : isChecked;
    var controlProps = {
        "data-checked": shouldChecked ? shouldChecked : undefined,
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-size": size,
        "data-testid": testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: function onMouseDown() {
            setIsKeyboardUsed(false);
        }
    };
    var legacyIconSize = $58893187255622b0$var$iconSizeMap[size];
    var labelId = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, controlProps, {
        ref: wrapperRef,
        className: (0, $5zphJ.default)([
            "_v564kete _1h6d1j28 _1dqonqa1 _189eyh40 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1tkq _syazw5hi _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rusw5hi _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1ouc _1flt1ouc _3xv21ouc _94713286 _ucabw5hi _mqf8snw8 _3dj2snw8 _1dl9snw8 _1divw5hi _1il8kb7n _y54dw5hi _irr31mlc _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plu15bl _1uo81mlc _178c1ouc _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf3zdg _1r4mnqa1 _1t9pyh40",
            size === "large" && !(0, $ltooA.fg)("platform-visual-refresh-icons") && "_1n82gktf _19vpgktf",
            $58893187255622b0$var$sizeStyles[size]
        ]),
        style: {
            "--_1lrlov9": (0, $cZGu3.default)("var(--ds-background-neutral-bold, ".concat((0, $dnCk4.N200), ")")),
            "--_1qgzj18": (0, $cZGu3.default)("var(--ds-icon-inverse, ".concat((0, $dnCk4.N0), ")")),
            "--_r5pknd": (0, $cZGu3.default)("var(--ds-background-disabled, ".concat((0, $dnCk4.N20), ")")),
            "--_ouwnnt": (0, $cZGu3.default)("var(--ds-background-neutral-bold-hovered, ".concat((0, $dnCk4.N400), ")")),
            "--_16xemc6": (0, $cZGu3.default)("var(--ds-background-success-bold, ".concat((0, $dnCk4.G400), ")")),
            "--_2cuxaa": (0, $cZGu3.default)("var(--ds-background-success-bold-hovered, ".concat((0, $dnCk4.G500), ")")),
            "--_1xmcmw9": (0, $cZGu3.default)("var(--ds-icon-disabled, ".concat((0, $dnCk4.N70), ")")),
            "--_xjqa3d": (0, $cZGu3.default)("var(--ds-border-focused, ".concat((0, $dnCk4.B200), ")"))
        }
    }), label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && "".concat(testId, "--input"),
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a5b325ff2f03546$export$2e2bcd8739ae039), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3c66783819981cd6$exports))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && "".concat(testId, "--toggle-check-icon")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a5b325ff2f03546$export$2e2bcd8739ae039), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fa814907f4a3bc0a$exports))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && "".concat(testId, "--toggle-cross-icon")
    })));
}));
$58893187255622b0$var$Toggle.displayName = "Toggle";
var $58893187255622b0$export$2e2bcd8739ae039 = $58893187255622b0$var$Toggle;




const $b65fa00950b0b4ef$export$5e72cf9af3fcdc9d = ({ onChange: onChange, isChecked: isChecked, analyticsEvent: analyticsEvent, toggleType: toggleType, isDisabled: isDisabled })=>{
    const label = isChecked ? "Enabled" : "Disabled";
    const labelWithToggleType = toggleType ? `${label} for ${toggleType}` : label;
    const { sendUIEvent: sendUIEvent } = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    const handleToggle = ()=>{
        sendUIEvent(analyticsEvent);
        onChange();
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
        alignItems: "center",
        gap: "space.050",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $58893187255622b0$export$2e2bcd8739ae039), {
                testId: "list-toggle",
                size: "large",
                label: "",
                onChange: handleToggle,
                isChecked: isChecked,
                isDisabled: isDisabled ?? false
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                children: labelWithToggleType
            })
        ]
    });
};



const $de0d95f042c04a68$export$6bd8a2aba912b303 = ({ jiraProjectAri: jiraProjectAri, onChange: onChange, value: value, settingsError: settingsError })=>{
    const handleChange = ()=>{
        onChange(jiraProjectAri, !value);
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $b65fa00950b0b4ef$export$5e72cf9af3fcdc9d), {
        onChange: handleChange,
        isChecked: value,
        analyticsEvent: {
            action: "clicked",
            actionSubject: "code-planner-jira-project-toggle",
            actionSubjectId: "code-planner-jira-project-toggle",
            source: "code-planner-settings"
        },
        isDisabled: settingsError !== null
    });
};



const $52992ed57cd8d10e$var$styles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    height: "50px"
});
const $52992ed57cd8d10e$var$tableHead = {
    cells: [
        {
            key: "project-key-head-cell",
            content: "Key",
            isSortable: true
        },
        {
            key: "project-name-head-cell",
            content: "Name",
            isSortable: true
        },
        {
            key: "actions-head-cell",
            content: "Automatic coding plans",
            isSortable: false
        }
    ]
};
const $52992ed57cd8d10e$export$3de4cabdfbe15662 = ({ projects: projects, projectsLoaded: projectsLoaded, settingsCache: settingsCache, onSettingsCacheChange: onSettingsCacheChange })=>{
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const [tableDataLoaded, setTableDataLoaded] = (0, $acw62.useState)(false);
    const { getCodePlannerSettings: getCodePlannerSettings, loading: codePlannerSettingsLoading, error: codePlannerSettingsError } = (0, $5c69c67e55e6e81b$export$595f1b0445a2aee8)();
    const { setCodePlannerSettings: setCodePlannerSettings } = (0, $640541f0aa41bdd6$export$39b6bc45110e434e)();
    const filteredProjects = (0, $acw62.useMemo)(()=>{
        return projects.filter((project)=>project.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }, [
        projects,
        searchTerm
    ]);
    const currentProjects = (0, $acw62.useMemo)(()=>{
        const startIndex = (currentPage - 1) * (0, $23da3c291c0fddec$export$680c2e5e5eec1385);
        const endIndex = startIndex + (0, $23da3c291c0fddec$export$680c2e5e5eec1385);
        return filteredProjects.slice(startIndex, endIndex);
    }, [
        filteredProjects,
        currentPage
    ]);
    (0, $acw62.useEffect)(()=>{
        if (currentProjects.length > 0) {
            const jiraProjectIds = currentProjects.map((project)=>project.id);
            const cachedIds = Array.from(settingsCache.keys());
            const nonCachedProjects = jiraProjectIds.filter((id)=>!cachedIds.includes(id));
            if (nonCachedProjects.length > 0) getCodePlannerSettings(nonCachedProjects).then((settings)=>{
                const updatedSettings = new Map(settingsCache);
                settings.forEach((setting, id)=>{
                    updatedSettings.set(id, setting.value.value.code_planner_enabled);
                });
                nonCachedProjects.forEach((id)=>{
                    if (!settings.has(id)) updatedSettings.set(id, false);
                });
                onSettingsCacheChange(updatedSettings);
            });
            setTableDataLoaded(true);
        }
    }, [
        currentProjects,
        getCodePlannerSettings,
        onSettingsCacheChange,
        settingsCache
    ]);
    const handleProjectSearch = (0, $acw62.useCallback)((input)=>{
        setCurrentPage(1);
        setSearchTerm(input);
    }, []);
    const handleToggleChange = async (jiraProjectAri, value)=>{
        setCodePlannerSettings([
            {
                containerId: jiraProjectAri,
                value: value
            }
        ]);
        const updatedSettings = new Map(settingsCache);
        updatedSettings.set(jiraProjectAri, value);
        onSettingsCacheChange(updatedSettings);
    };
    const projectRows = filteredProjects.map((project)=>{
        const { id: id, key: key, name: name, webUrl: webUrl } = project;
        return {
            key: `row-${key}-${name}`,
            cells: [
                {
                    key: `key-${key}`,
                    content: (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                        xcss: $52992ed57cd8d10e$var$styles,
                        alignItems: "center",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $211777b1e6e6df36$export$2e2bcd8739ae039), {
                            href: webUrl,
                            appearance: "subtle",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: key
                        })
                    })
                },
                {
                    key: `name-${name}`,
                    content: (0, $7b02d682eb115277$exports.jsx)((0, $211777b1e6e6df36$export$2e2bcd8739ae039), {
                        href: webUrl,
                        appearance: "subtle",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: name
                    })
                },
                {
                    key: `actions-${key}`,
                    content: (0, $7b02d682eb115277$exports.jsx)((0, $de0d95f042c04a68$export$6bd8a2aba912b303), {
                        jiraProjectAri: id,
                        onChange: handleToggleChange,
                        value: settingsCache.get(id) ?? false,
                        settingsError: codePlannerSettingsError
                    })
                }
            ]
        };
    });
    return (0, $7b02d682eb115277$exports.jsx)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
        testId: "jira-projects-table",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $622a69e27ffb1ba3$export$88904f849af903e6), {
            headingText: "Jira projects",
            tableHead: $52992ed57cd8d10e$var$tableHead,
            tableRows: projectRows,
            currentPage: currentPage,
            setCurrentPage: setCurrentPage,
            loading: !projectsLoaded || !tableDataLoaded || codePlannerSettingsLoading,
            error: codePlannerSettingsError,
            onSearch: handleProjectSearch,
            searchPlaceholder: "Search project names"
        })
    });
};









const $0f73c100ad362ad5$export$7cf03eaf8fbb2827 = (0, $a2299f428347f042$export$1038046b28a1d92e)() === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).LOCAL ? "" : window.location.hostname;
const $0f73c100ad362ad5$export$d00bfc95c1960322 = $0f73c100ad362ad5$export$7cf03eaf8fbb2827.split(".")[0].replace("https://", "");
const $0f73c100ad362ad5$export$287a8255e7e3b923 = "code-planner-site-settings-enabled";



const $b8bae7b69626a9f5$export$83efb63ee22ecda9 = ({ projects: projects, onChange: onChange })=>{
    const { setCodePlannerSettings: setCodePlannerSettings } = (0, $640541f0aa41bdd6$export$39b6bc45110e434e)();
    const handleEnable = ()=>{
        onChange(new Map(projects.map((project)=>[
                project.id,
                true
            ])));
        setCodePlannerSettings(projects.map((project)=>({
                containerId: project.id,
                value: true
            })));
    };
    const handleDisable = ()=>{
        onChange(new Map(projects.map((project)=>[
                project.id,
                false
            ])));
        setCodePlannerSettings(projects.map((project)=>({
                containerId: project.id,
                value: false
            })));
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
        testId: "site-settings",
        space: "space.150",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $6dade6aab478882f$export$2e2bcd8739ae039), {
                as: "h3",
                size: "small",
                children: "Site settings"
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                children: [
                    "Enable or disable Code Planner for all Jira projects in ",
                    (0, $0f73c100ad362ad5$export$d00bfc95c1960322)
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $97dc047858cd229a$export$2e2bcd8739ae039), {
                    label: "Enable or disable Code Planner for all Jira projects in {hostName}",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                            onClick: handleEnable,
                            children: "Enable for all repositories"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                            onClick: handleDisable,
                            children: "Disable for all repositories"
                        })
                    ]
                })
            })
        ]
    });
};




var $62a7b61eea416e8f$var$_codePlannerConfigurationQuery;

const $62a7b61eea416e8f$export$2737ecc5d94e6a4d = ({ queryRef: queryRef })=>{
    const [jiraProjectsLoaded, setJiraProjectsLoaded] = (0, $acw62.useState)(false);
    const [jiraProjects, setJiraProjects] = (0, $acw62.useState)([]);
    const { codePlannerSettingsCache: codePlannerSettingsCache, setCodePlannerSettingsCache: setCodePlannerSettingsCache } = (0, $5c69c67e55e6e81b$export$595f1b0445a2aee8)();
    const isEnableAllRepositoriesButtonEnabled = (0, $098873af10a85f8f$export$b40ec24ac8275656)((0, $0f73c100ad362ad5$export$287a8255e7e3b923));
    const data = (0, $2d93712440e0508b$exports.usePreloadedQuery)($62a7b61eea416e8f$var$_codePlannerConfigurationQuery !== void 0 ? $62a7b61eea416e8f$var$_codePlannerConfigurationQuery : $62a7b61eea416e8f$var$_codePlannerConfigurationQuery = (parcelRequire("8bfEX")), queryRef);
    const projects = data?.jira?.jiraProjectsByJql?.edges;
    (0, $acw62.useEffect)(()=>{
        if (projects) {
            const projectNodes = projects.map((project)=>project?.node).filter((project)=>project !== null);
            setJiraProjects(projectNodes);
            setJiraProjectsLoaded(true);
        }
    }, [
        projects
    ]);
    if (jiraProjectsLoaded && jiraProjects.length === 0) return (0, $7b02d682eb115277$exports.jsx)((0, $c9f282bfce9aba21$export$2e2bcd8739ae039), {
        testId: "code-planner-no-projects-found",
        header: "No projects found",
        description: "Please check you have administrative privileges to Jira projects and try again."
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
        testId: "code-planner-configuration",
        children: [
            isEnableAllRepositoriesButtonEnabled && (0, $7b02d682eb115277$exports.jsx)((0, $b8bae7b69626a9f5$export$83efb63ee22ecda9), {
                projects: jiraProjects,
                onChange: setCodePlannerSettingsCache
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $52992ed57cd8d10e$export$3de4cabdfbe15662), {
                projects: jiraProjects,
                projectsLoaded: jiraProjectsLoaded,
                settingsCache: codePlannerSettingsCache,
                onSettingsCacheChange: setCodePlannerSettingsCache
            })
        ]
    });
};


const $23a8296fdef15c14$export$66a1ebf3b03d5434 = 'project IN projectsWhereUserHasPermission("Browse Projects")';



const $eeff9d89d462430b$export$51e2657f946d6dae = ()=>{
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { cloudId: cloudId } = tenantContexts[0];
    const [queryRef, loadQuery] = (0, $2d93712440e0508b$exports.useQueryLoader)((0, $8bfEX.default));
    (0, $acw62.useEffect)(()=>{
        if (!queryRef) loadQuery({
            cloudId: cloudId,
            query: (0, $23a8296fdef15c14$export$66a1ebf3b03d5434)
        });
    }, [
        queryRef,
        loadQuery,
        cloudId
    ]);
    const loadingState = ()=>{
        return (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
            alignInline: "center",
            space: "space.300",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $d847f661580efa86$export$2e2bcd8739ae039), {
                    size: "large"
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                    children: "Loading..."
                })
            ]
        });
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $c3f640ad5ecdb761$export$9086365ce732c74c), {
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
            space: "space.400",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $bb8d9e52e7488bfb$export$7cc3c78152b2ca07), {
                    additionalBreadcrumbItems: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $60fab9c8c1ebbeeb$export$2e2bcd8739ae039), {
                            href: `/dev-agents${(0, $b3c27da72be923c3$export$122dbbe6a3dd8f50)}`,
                            text: "Enable automatic coding plans"
                        }, "code-planner")
                    ],
                    headingText: "Enable automatic coding plans",
                    descriptionText: "Code Planner can automatically create coding plans for work items in a project. When this setting is enabled for a project, every new coding-related work item created will automatically have a coding plan created and added to the work item. Code Planner can still create coding plans manually, whether this setting is enabled or not. You must be a Rovo Dev Agents admin to enable automatic coding plans on a project."
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
                    fallback: loadingState(),
                    children: queryRef && (0, $7b02d682eb115277$exports.jsx)((0, $62a7b61eea416e8f$export$2737ecc5d94e6a4d), {
                        queryRef: queryRef
                    })
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $63acb35e5becc07c$export$61abde59b50deb8e = (suffix)=>`/gateway/api/devai-core/v1/dev-agents/autoreview-github/${suffix}`;


const $cca48e39ebf92bd7$export$b9744ed7bca15a12 = ({ subscriptionId: subscriptionId, page: page, rowsPerPage: rowsPerPage })=>{
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const rowCache = (0, $acw62.useRef)(new Map());
    const [repoList, setRepoList] = (0, $acw62.useState)([]);
    const createAuthRequest = (0, $acw62.useCallback)((pageNumber, searchString)=>{
        const body = {
            orgSubscriptionId: subscriptionId,
            page: pageNumber,
            pageLength: rowsPerPage
        };
        if (searchString) body.reposNameToSearch = searchString;
        return (0, $7313551ab8168ced$export$2e2bcd8739ae039)((0, $63acb35e5becc07c$export$61abde59b50deb8e)("getRepositories"), {
            method: "POST",
            body: JSON.stringify(body),
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            }
        });
    }, [
        rowsPerPage,
        subscriptionId
    ]);
    const tryRequest = (0, $acw62.useCallback)(async (request, cacheResult, pageNumber)=>{
        setLoading(true);
        try {
            const res = await fetch(request);
            if (!res.ok) throw new Error(`http error status ${res.status} with text: ${res.statusText}`);
            const response = await res.json();
            // Set the cache with the value
            if (cacheResult && pageNumber) rowCache.current.set(pageNumber, response.repositories);
            setRepoList(response.repositories);
        } catch (e) {
            setError("An error has occurred");
        }
        setLoading(false);
    }, []);
    const getRepoList = (0, $acw62.useCallback)(async (pageNumber)=>{
        const cachedValue = rowCache.current.get(pageNumber);
        // check if the current page is in the rowCache
        if (cachedValue) {
            setRepoList(cachedValue);
            return;
        }
        // Otherwise fetch this page
        const request = createAuthRequest(pageNumber);
        await tryRequest(request, true, pageNumber);
    }, [
        createAuthRequest,
        tryRequest
    ]);
    const searchRepos = (0, $acw62.useCallback)(async (searchString)=>{
        const request = createAuthRequest(1, searchString);
        await tryRequest(request, false);
    }, [
        createAuthRequest,
        tryRequest
    ]);
    (0, $acw62.useEffect)(()=>{
        getRepoList(page);
    }, [
        getRepoList,
        page
    ]);
    const updateRepoSettingInList = (repoId, newValue)=>{
        // Update the repo in the current list
        setRepoList((current)=>current.map((repo)=>{
                if (repo.repoId === repoId) return {
                    ...repo,
                    autoreviewSettings: {
                        ...repo.autoreviewSettings,
                        value: {
                            autoreview_enabled: newValue
                        }
                    }
                };
                return repo;
            }));
        // Update the repo in the cache
        rowCache.current.set(page, // is this confirmed that the current page will be on screen?
        rowCache.current.get(page)?.map((repo)=>{
            if (repo.repoId === repoId) return {
                ...repo,
                autoreviewSettings: {
                    ...repo.autoreviewSettings,
                    value: {
                        autoreview_enabled: newValue
                    }
                }
            };
            return repo;
        }) ?? []);
    };
    return {
        repoList: repoList,
        loading: loading,
        error: error,
        searchRepos: searchRepos,
        updateRepoSettingInList: updateRepoSettingInList
    };
};



var $acw62 = parcelRequire("acw62");


const $b2d7c56ca57568c9$export$6ec8cc906a88e6bf = ()=>{
    const [error, setError] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [orgList, setOrgList] = (0, $acw62.useState)([]);
    const getOrgList = async ()=>{
        const request = (0, $7313551ab8168ced$export$2e2bcd8739ae039)((0, $63acb35e5becc07c$export$61abde59b50deb8e)("getOrganizations"), {
            method: "POST",
            body: JSON.stringify({}),
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            }
        });
        try {
            const res = await fetch(request);
            if (!res.ok) throw new Error(`http error status ${res.status} with text: ${res.statusText}`);
            const response = await res.json();
            setOrgList(response.organizations);
        } catch (e) {
            setError("An error has occurred");
        }
        setLoading(false);
    };
    (0, $acw62.useEffect)(()=>{
        getOrgList();
    }, []);
    return {
        orgList: orgList,
        setOrgList: setOrgList,
        loading: loading,
        error: error
    };
};




const $47f6d8247064560f$export$e2280c1995141b13 = (input)=>{
    return input ? input.replace(/^(the|a|an)/, "").replace(/\s/g, "") : input;
};
const $47f6d8247064560f$export$e03c61ca66ec1497 = (value)=>{
    const newValue = value.autoreview_activated ?? value.autoreview_enabled;
    switch(typeof newValue){
        case "string":
            switch(newValue.toLowerCase()){
                case "true":
                    return true;
                case "false":
                    return false;
                default:
                    throw new Error("The value could not be interpreted as a boolean");
            }
        case "boolean":
            return newValue;
        default:
            throw new Error("The value could not be interpreted as a boolean");
    }
};




var $4rk35 = parcelRequire("4rk35");

const $54af5f40dc8ed7cb$export$665a60762b9e88ec = ({ flags: flags, setFlags: setFlags })=>{
    const handleDismissFlag = ()=>{
        setFlags(flags.slice(1));
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $38132a618d93e205$export$2e2bcd8739ae039), {
        onDismissed: handleDismissFlag,
        children: flags.map(({ id: id, title: title, description: description })=>(0, $7b02d682eb115277$exports.jsx)((0, $9f175d156b67ed04$export$2e2bcd8739ae039), {
                id: id,
                icon: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4rk35))), {
                    primaryColor: "var(--ds-icon-success, #22A06B)",
                    label: "Success"
                }),
                title: title,
                description: description
            }, id))
    });
};





var $acw62 = parcelRequire("acw62");



const $5b787d7a0f85c697$var$setUrl = "/gateway/api/devai-core/public/v2/settings/set";
const $5b787d7a0f85c697$export$ec65bea5eee9342e = ({ type: type, entityUrl: entityUrl, setting: setting, disableToggle: disableToggle, onToggle: onToggle })=>{
    const [isEnabled, setIsEnabled] = (0, $acw62.useState)(setting);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setIsEnabled(setting);
    }, [
        setting
    ]);
    const getSettingValue = (0, $acw62.useCallback)((newValue)=>{
        switch(type){
            case "repository":
                return {
                    autoreview_enabled: newValue
                };
            case "workspace":
                return {
                    autoreview_activated: newValue
                };
            default:
                throw new Error("An error has occured");
        }
    }, [
        type
    ]);
    const updateSetting = (0, $acw62.useCallback)(async ()=>{
        setError(null);
        // Optimistic Update
        const newValue = !isEnabled;
        setIsEnabled(newValue);
        if (onToggle) onToggle(newValue);
        try {
            const res = await fetch((0, $7313551ab8168ced$export$2e2bcd8739ae039)($5b787d7a0f85c697$var$setUrl, {
                method: "POST",
                body: JSON.stringify({
                    settings: [
                        {
                            containerType: type,
                            containerId: entityUrl,
                            key: "autoreview_settings",
                            value: getSettingValue(newValue)
                        }
                    ]
                }),
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                }
            }));
            if (!res.ok) throw new Error(`http error status ${res.status} with text: ${res.statusText}`);
        } catch (e) {
            setError("An error has occured");
            // reverse optimistic update
            setIsEnabled(!newValue);
        }
    }, [
        entityUrl,
        getSettingValue,
        isEnabled,
        onToggle,
        type
    ]);
    if (error) return (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
        children: error
    });
    return (0, $7b02d682eb115277$exports.jsx)((0, $b65fa00950b0b4ef$export$5e72cf9af3fcdc9d), {
        onChange: updateSetting,
        isChecked: isEnabled,
        analyticsEvent: {
            action: "clicked",
            actionSubject: "code-reviewer-setting-toggle",
            actionSubjectId: type === "repository" ? "repository-toggle" : "organisation-toggle",
            source: type === "repository" ? "code-reviewer-repository-settings" : "code-reviewer-organisation-settings"
        },
        isDisabled: disableToggle,
        toggleType: type === "repository" ? "repository" : "organization"
    });
};



const $63de165c0753417a$export$776ad53b86e0e347 = ({ repository: repository, orgSetting: orgSetting, superToggle: superToggle })=>{
    const isEnabledForOrg = orgSetting?.value ? (0, $47f6d8247064560f$export$e03c61ca66ec1497)(orgSetting?.value) : false;
    const onToggle = superToggle ? (newValue)=>{
        superToggle(repository.repoId, newValue);
    } : undefined;
    const setting = repository.autoreviewSettings ? (0, $47f6d8247064560f$export$e03c61ca66ec1497)(repository.autoreviewSettings?.value) : false;
    return (0, $7b02d682eb115277$exports.jsx)((0, $5b787d7a0f85c697$export$ec65bea5eee9342e), {
        type: "repository",
        entityUrl: repository.repoUrl,
        setting: setting,
        disableToggle: !isEnabledForOrg,
        onToggle: onToggle
    });
};





const $b594ffcac3648576$export$90c44738719d06eb = ({ org: org, onToggle: onToggle })=>{
    const setting = org.autoreviewSettings ? (0, $47f6d8247064560f$export$e03c61ca66ec1497)(org.autoreviewSettings?.value) : false;
    return (0, $7b02d682eb115277$exports.jsx)((0, $5b787d7a0f85c697$export$ec65bea5eee9342e), {
        type: "workspace",
        entityUrl: org.ownerUrl,
        setting: setting,
        disableToggle: false,
        onToggle: onToggle
    });
};





const $113409ef42ac40ce$var$styles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    height: "50px"
});
const $113409ef42ac40ce$var$orgHead = {
    cells: [
        {
            key: "name-head-cell",
            content: "Name",
            isSortable: true,
            width: 20
        },
        {
            key: "url-head-cell",
            content: "URL",
            isSortable: true,
            width: 35
        },
        {
            key: "status-head-cell",
            content: "Code Reviewer status",
            isSortable: false,
            width: 25
        },
        {
            key: "action-head-cell",
            content: "Repositories",
            isSortable: false,
            width: 20
        }
    ]
};
const $113409ef42ac40ce$export$dbb635bd9aa6b6d6 = ({ setSelectedOrg: setSelectedOrg })=>{
    const { error: error, loading: loading, orgList: orgList, setOrgList: setOrgList } = (0, $b2d7c56ca57568c9$export$6ec8cc906a88e6bf)();
    const [page, setPage] = (0, $acw62.useState)(0);
    const [flags, setFlags] = (0, $acw62.useState)([]);
    const orgRows = orgList?.map((org)=>{
        const { subscriptionId: subscriptionId, owner: owner, ownerUrl: ownerUrl } = org;
        const enableButton = org.autoreviewSettings ? (0, $47f6d8247064560f$export$e03c61ca66ec1497)(org.autoreviewSettings.value) : false;
        const handleUpdateOrgList = (newValue)=>{
            const newOrgList = orgList.map((newOrg)=>{
                if (newOrg.subscriptionId === org.subscriptionId) return {
                    ...newOrg,
                    autoreviewSettings: {
                        value: {
                            autoreview_activated: newValue
                        },
                        lastUpdatedTime: new Date(),
                        containerId: newOrg.ownerUrl
                    }
                };
                return newOrg;
            });
            const flagToAdd = {
                id: flags.length + 1,
                title: newValue ? "Enabled Code Reviewer" : "Disabled Code Reviewer",
                description: "This might take up to 15 minutes"
            };
            setFlags((current)=>[
                    ...current,
                    flagToAdd
                ]);
            setOrgList(newOrgList);
        };
        return {
            key: `row-${subscriptionId}-${owner} `,
            cells: [
                {
                    key: (0, $47f6d8247064560f$export$e2280c1995141b13)(owner),
                    content: (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                        xcss: $113409ef42ac40ce$var$styles,
                        alignItems: "center",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                            children: owner
                        })
                    })
                },
                {
                    key: (0, $47f6d8247064560f$export$e2280c1995141b13)(ownerUrl),
                    content: (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
                        href: ownerUrl,
                        children: ownerUrl
                    })
                },
                {
                    key: `${subscriptionId}-status-cell`,
                    content: (0, $7b02d682eb115277$exports.jsx)((0, $b594ffcac3648576$export$90c44738719d06eb), {
                        org: org,
                        onToggle: (newValue)=>handleUpdateOrgList(newValue)
                    })
                },
                {
                    key: `${subscriptionId}-action-cell`,
                    content: (0, $7b02d682eb115277$exports.jsx)((0, $6fa9833ed171567b$export$2e2bcd8739ae039), {
                        content: "Enable this organisation to gain access to repository settings",
                        canAppear: ()=>!enableButton,
                        children: (toolTipProps)=>(0, $7b02d682eb115277$exports.jsx)((0, $596fd22a12a3457e$export$2e2bcd8739ae039), {
                                ...toolTipProps,
                                onClick: ()=>setSelectedOrg(org),
                                isDisabled: !enableButton,
                                children: "Manage repositories"
                            })
                    })
                }
            ]
        };
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $622a69e27ffb1ba3$export$88904f849af903e6), {
                headingText: "Organizations",
                error: error,
                loading: loading,
                tableHead: $113409ef42ac40ce$var$orgHead,
                tableRows: orgRows ?? [],
                currentPage: page,
                setCurrentPage: setPage
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $54af5f40dc8ed7cb$export$665a60762b9e88ec), {
                flags: flags,
                setFlags: setFlags
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");








const $bde658452d5d4a22$var$styles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    height: "50px"
});
const $bde658452d5d4a22$var$LoadingCell = ({ width: width })=>(0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
        xcss: $bde658452d5d4a22$var$styles,
        alignItems: "center",
        justifyContent: "start",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $e3ed46ff97b993f0$export$2e2bcd8739ae039), {
            width: width,
            height: "25px",
            isShimmering: true,
            borderRadius: "25px"
        })
    });
const $bde658452d5d4a22$var$loadingRow = (selectedOrg, idx)=>({
        key: `${selectedOrg.owner}-repo-${idx}`,
        cells: [
            {
                key: `repo-loading-cell-1-${idx}`,
                content: (0, $7b02d682eb115277$exports.jsx)($bde658452d5d4a22$var$LoadingCell, {
                    width: `${Math.floor(Math.random() * 100)}%`
                })
            },
            {
                key: `repo-loading-cell-2-${idx}`,
                content: (0, $7b02d682eb115277$exports.jsx)($bde658452d5d4a22$var$LoadingCell, {
                    width: `${Math.floor(Math.random() * 100)}%`
                })
            },
            {
                key: `repo-loading-cell-3-${idx}`,
                content: (0, $7b02d682eb115277$exports.jsx)($bde658452d5d4a22$var$LoadingCell, {
                    width: "80%"
                })
            }
        ]
    });
const $bde658452d5d4a22$var$newRow = (owner, repo, idx, orgSetting, superToggle)=>({
        key: `${owner}-repo-${idx}`,
        cells: [
            {
                key: (0, $47f6d8247064560f$export$e2280c1995141b13)(repo.repoName),
                content: (0, $7b02d682eb115277$exports.jsx)((0, $a21fdd6b3432b612$export$2e2bcd8739ae039), {
                    xcss: $bde658452d5d4a22$var$styles,
                    alignItems: "center",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                        children: repo.repoName
                    })
                })
            },
            {
                key: (0, $47f6d8247064560f$export$e2280c1995141b13)(repo.repoUrl),
                content: (0, $7b02d682eb115277$exports.jsx)((0, $e14fbd57cc703bea$export$2e2bcd8739ae039), {
                    href: repo.repoUrl,
                    children: repo.repoUrl
                })
            },
            {
                key: `${repo.repoId}-action-cell`,
                content: (0, $7b02d682eb115277$exports.jsx)((0, $63de165c0753417a$export$776ad53b86e0e347), {
                    repository: repo,
                    orgSetting: orgSetting,
                    superToggle: superToggle
                })
            }
        ]
    });
const $bde658452d5d4a22$var$repoHead = {
    cells: [
        {
            key: "name-head-cell",
            content: "Name",
            isSortable: false,
            width: 20
        },
        {
            key: "url-head-cell",
            content: "URL",
            isSortable: false,
            width: 55
        },
        {
            key: "actions-head-cell",
            content: "Code Reviewer status",
            isSortable: false,
            width: 25
        }
    ]
};
const $bde658452d5d4a22$export$801eda18957f9257 = ({ selectedOrg: selectedOrg })=>{
    const [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)((0, $23da3c291c0fddec$export$680c2e5e5eec1385));
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const pageCache = (0, $acw62.useRef)(1);
    const { repoList: repoList, loading: loading, error: error, searchRepos: searchRepos, updateRepoSettingInList: updateRepoSettingInList } = (0, $cca48e39ebf92bd7$export$b9744ed7bca15a12)({
        subscriptionId: selectedOrg.subscriptionId,
        page: currentPage,
        rowsPerPage: rowsPerPage
    });
    const [flags, setFlags] = (0, $acw62.useState)([]);
    const superToggle = (0, $acw62.useCallback)((repoId, newValue)=>{
        const flagToAdd = {
            id: flags.length + 1,
            title: newValue ? "Enabled Code Reviewer" : "Disabled Code Reviewer",
            description: "This might take up to 15 minutes"
        };
        setFlags((current)=>[
                ...current,
                flagToAdd
            ]);
        updateRepoSettingInList(repoId, newValue);
    }, [
        flags.length,
        updateRepoSettingInList
    ]);
    const onSearch = (0, $acw62.useCallback)((input)=>{
        if (input === "") {
            setRowsPerPage((0, $23da3c291c0fddec$export$680c2e5e5eec1385));
            setCurrentPage(pageCache.current);
            return;
        }
        setRowsPerPage(selectedOrg.totalNumberOfRepos);
        setCurrentPage(1);
        searchRepos(input);
    }, [
        selectedOrg.totalNumberOfRepos,
        searchRepos
    ]);
    const handleSetCurrentPage = (n)=>{
        setCurrentPage(n);
        pageCache.current = n;
    };
    /**
  Explanation of logic:
   The DynamicTable component used by SettingsList requires the list of rows to be complete for
   pagination to work correctly. For this reason, we need to provide it with a list of the correct
   size, even though we don't have those repos loaded from the hook.
  	 This block will provide the table with a list of rows that is the correct size, with the current
   page offset into the correct location in that list to display that page correctly. The pages are
   cached in the useGithubRepositoryList hook for quick use next time.
  * */ const startingIndex = (currentPage - 1) * (0, $23da3c291c0fddec$export$680c2e5e5eec1385);
    const renderRows = (0, $acw62.useMemo)(()=>{
        if (rowsPerPage === selectedOrg.totalNumberOfRepos) return repoList.map((r, idx)=>$bde658452d5d4a22$var$newRow(selectedOrg.owner, r, idx, selectedOrg.autoreviewSettings, superToggle));
        return Array.from({
            length: selectedOrg.totalNumberOfRepos
        }, (_, idx)=>{
            const repo = repoList[idx - startingIndex];
            if (repo) return $bde658452d5d4a22$var$newRow(selectedOrg.owner, repo, idx, selectedOrg.autoreviewSettings, superToggle);
            return $bde658452d5d4a22$var$loadingRow(selectedOrg, idx);
        });
    }, [
        rowsPerPage,
        selectedOrg,
        repoList,
        superToggle,
        startingIndex
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $622a69e27ffb1ba3$export$88904f849af903e6), {
                headingText: "Repositories",
                error: error,
                loading: loading,
                tableHead: $bde658452d5d4a22$var$repoHead,
                tableRows: renderRows,
                currentPage: currentPage,
                setCurrentPage: handleSetCurrentPage,
                rowsPerPage: rowsPerPage,
                onSearch: onSearch
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $54af5f40dc8ed7cb$export$665a60762b9e88ec), {
                flags: flags,
                setFlags: setFlags
            })
        ]
    });
};



class $9b48720f394bae81$var$Organisations {
    viewKey;
    selectedOrg;
    constructor(){
        this.viewKey = "organisations";
        this.selectedOrg = null;
    }
}
class $9b48720f394bae81$var$Repositories {
    viewKey;
    selectedOrg;
    constructor(selectedOrg){
        this.viewKey = "repositories";
        this.selectedOrg = selectedOrg;
    }
}
const $9b48720f394bae81$export$2c8367f5c6c942e5 = ()=>{
    const [viewMode, setViewMode] = (0, $acw62.useState)(new $9b48720f394bae81$var$Organisations());
    const { sendScreenEvent: sendScreenEvent } = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    const setSelectedOrg = (org)=>{
        setViewMode(new $9b48720f394bae81$var$Repositories(org));
    };
    const clearSelectedOrg = ()=>setViewMode(new $9b48720f394bae81$var$Organisations());
    (0, $acw62.useEffect)(()=>{
        sendScreenEvent({
            name: viewMode.viewKey === "organisations" ? "view-github-organisations" : "view-github-repositories"
        });
    }, [
        sendScreenEvent,
        viewMode.viewKey
    ]);
    if (viewMode.viewKey === "organisations") return (0, $7b02d682eb115277$exports.jsx)((0, $c3f640ad5ecdb761$export$9086365ce732c74c), {
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
            space: "space.200",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $bb8d9e52e7488bfb$export$7cc3c78152b2ca07), {
                    additionalBreadcrumbItems: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $60fab9c8c1ebbeeb$export$2e2bcd8739ae039), {
                            href: `/dev-agents${(0, $b3c27da72be923c3$export$d278c9a4e4cdafa2)}`,
                            text: "Set up Code Reviewer for GitHub"
                        }, "set-up-code-reviewer-for-github")
                    ],
                    headingText: "Set up Code Reviewer for GitHub",
                    descriptionText: "Select the GitHub organizations and repositories you want to enable the Code Reviewer on. When the Code Reviewer is enabled, it automatically review new pull requests and leave feedbacks in pull request comments. You must be a Rovo Dev Agents admin to enable Code Reviewer on a GitHub organization."
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $113409ef42ac40ce$export$dbb635bd9aa6b6d6), {
                    setSelectedOrg: setSelectedOrg
                })
            ]
        })
    });
    if (viewMode.viewKey === "repositories" && viewMode.selectedOrg) return (0, $7b02d682eb115277$exports.jsx)((0, $c3f640ad5ecdb761$export$9086365ce732c74c), {
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
            space: "space.300",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $bb8d9e52e7488bfb$export$7cc3c78152b2ca07), {
                    additionalBreadcrumbItems: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $60fab9c8c1ebbeeb$export$2e2bcd8739ae039), {
                            onClick: ()=>clearSelectedOrg(),
                            href: `/dev-agents${(0, $b3c27da72be923c3$export$d278c9a4e4cdafa2)}`,
                            text: "Set up Code Reviewer for GitHub"
                        }, "set-up-code-reviewer-for-github"),
                        (0, $7b02d682eb115277$exports.jsx)((0, $60fab9c8c1ebbeeb$export$2e2bcd8739ae039), {
                            text: viewMode.selectedOrg.owner
                        }, viewMode.selectedOrg.owner)
                    ],
                    headingText: `${viewMode.selectedOrg.owner}`,
                    descriptionText: " Select the repositories in your organization you want to enable Code Reviewer on. When Code Reviewer is enabled on a repository, it automatically reviews new pull requests and leaves feedback in pull request comments. You must be a Rovo Dev Agents admin to enable Code Reviewer on a repository. "
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $bde658452d5d4a22$export$801eda18957f9257), {
                    selectedOrg: viewMode.selectedOrg
                })
            ]
        })
    });
    // TODO: Replace with empty state
    return (0, $7b02d682eb115277$exports.jsx)((0, $c3f640ad5ecdb761$export$9086365ce732c74c), {
        children: "Error"
    });
};





const $0c4ee6d4a2f72cd2$export$c344a3deb8f83e2f = {
    name: "home",
    path: (0, $b3c27da72be923c3$export$5d5930b97498321d),
    exact: true,
    component: (0, $ca57a5b1ea39cf09$export$36d69433c4f81145),
    analyticsName: "dev-agents-home-page"
};
const $0c4ee6d4a2f72cd2$export$9b882bf02e350685 = {
    name: "Code Reviewer settings",
    path: (0, $b3c27da72be923c3$export$d278c9a4e4cdafa2),
    exact: true,
    component: (0, $9b48720f394bae81$export$2c8367f5c6c942e5),
    analyticsName: "dev-agents-code-reviewer-settings-page"
};
const $0c4ee6d4a2f72cd2$export$6f07f58c47696ecf = {
    name: "Code Planner settings",
    path: (0, $b3c27da72be923c3$export$122dbbe6a3dd8f50),
    exact: true,
    component: (0, $eeff9d89d462430b$export$51e2657f946d6dae),
    analyticsName: "dev-agents-code-planner-settings-page"
};
const $0c4ee6d4a2f72cd2$export$ade873bc90ce0536 = {
    name: "Boysenberry",
    path: (0, $b3c27da72be923c3$export$87368091a36693a3),
    exact: true,
    component: (0, $3f4b1c4e8d7d9171$export$4c5a7631b37fb7af),
    navigation: (0, $b091e1a4de596bb7$export$6b9e9e78a8c6019f),
    logo: (0, $f7f0296dce984358$export$e6ff31bff12b7ff4),
    analyticsName: "dev-agents-boysenberry-page"
};
const $0c4ee6d4a2f72cd2$export$f7063e50d1285fec = {
    name: "Boysenberry flow",
    path: (0, $b3c27da72be923c3$export$aba8de7a7c35cfeb),
    exact: true,
    component: (0, $f3d98130205b45b3$export$cac4e69ddf1cf4a5),
    navigation: (0, $b091e1a4de596bb7$export$6b9e9e78a8c6019f),
    logo: (0, $f7f0296dce984358$export$e6ff31bff12b7ff4),
    analyticsName: "dev-agents-boysenberry-flow-page"
};
const $0c4ee6d4a2f72cd2$export$6fc9c51b3751f011 = {
    name: "Boysenberry code page",
    path: (0, $b3c27da72be923c3$export$8c7edd817b46b0f5),
    exact: true,
    component: (0, $0b8dfee0887dc2a8$export$8c1df0002295a597),
    navigation: (0, $b091e1a4de596bb7$export$6b9e9e78a8c6019f),
    logo: (0, $f7f0296dce984358$export$e6ff31bff12b7ff4),
    analyticsName: "dev-agents-boysenberry-code-page"
};
const $0c4ee6d4a2f72cd2$export$ea165ba17ad920f8 = {
    name: "Boysenberry create embed",
    path: (0, $b3c27da72be923c3$export$f3344f66f55069d1),
    exact: true,
    component: (0, $a53f6bd3b6237b8e$export$9fa526446500d498),
    logo: (0, $f7f0296dce984358$export$e6ff31bff12b7ff4),
    analyticsName: "dev-agents-boysenberry-create-embed-page"
};
const $0c4ee6d4a2f72cd2$export$4dc84672b833126 = {
    name: "404",
    path: "",
    component: (0, $c8951a72a3bf9b47$export$271f9f08425019c7),
    analyticsName: "dev-agents-404-page"
};


const $b3c1eeb19c22229f$export$2d723d99e5956467 = (usersHasAccessToAdminRoutes, userHasRovoEntitlement)=>{
    const appRoutes = [
        (0, $0c4ee6d4a2f72cd2$export$c344a3deb8f83e2f)
    ];
    if (usersHasAccessToAdminRoutes && userHasRovoEntitlement && (0, $098873af10a85f8f$export$b40ec24ac8275656)("code-planner-agent-limited-beta")) appRoutes.push((0, $0c4ee6d4a2f72cd2$export$6f07f58c47696ecf));
    if (usersHasAccessToAdminRoutes && userHasRovoEntitlement) appRoutes.push((0, $0c4ee6d4a2f72cd2$export$9b882bf02e350685));
    if ((0, $098873af10a85f8f$export$b40ec24ac8275656)("dev_agents_boysenberry_route")) {
        appRoutes.push((0, $0c4ee6d4a2f72cd2$export$ade873bc90ce0536));
        appRoutes.push((0, $0c4ee6d4a2f72cd2$export$f7063e50d1285fec));
        appRoutes.push((0, $0c4ee6d4a2f72cd2$export$6fc9c51b3751f011));
        appRoutes.push((0, $0c4ee6d4a2f72cd2$export$ea165ba17ad920f8));
    }
    // this is a catch all route and should always be the last route
    appRoutes.push((0, $0c4ee6d4a2f72cd2$export$4dc84672b833126));
    return appRoutes;
};





const $8dfb65dab4a54eab$export$2f7a12048d96237 = ()=>{
    const savedThemePreference = window.localStorage.getItem("themeColorMode");
    // legacy saved theme
    if (savedThemePreference === "light" || savedThemePreference === "dark" || savedThemePreference === "auto") return {
        colorMode: savedThemePreference
    };
    if (savedThemePreference != null) {
        const themeObject = (0, $162ad34f339133e7$export$f19b488f7c0547ee)(savedThemePreference);
        return Object.keys(themeObject).length > 0 ? themeObject : $8dfb65dab4a54eab$var$getOsThemePreference();
    }
    return $8dfb65dab4a54eab$var$getOsThemePreference();
};
const $8dfb65dab4a54eab$var$getOsThemePreference = ()=>{
    const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    if (darkModeMediaQuery.matches) return {
        colorMode: "dark"
    };
    return {
        colorMode: "light"
    };
};





/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");


/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $ltooA = parcelRequire("ltooA");

var $1b365a283dea1d8d$var$boxShadowCssVar = "--avatar-box-shadow";
var $1b365a283dea1d8d$var$bgColorCssVar = "--avatar-bg-color";
var $1b365a283dea1d8d$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128m1bk5 _4dave4h9",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
var $1b365a283dea1d8d$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1g4v _ez1ykb7n _gcm1182g _eeh8kb7n _jlxit94y"
};
var $1b365a283dea1d8d$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $1b365a283dea1d8d$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
var $1b365a283dea1d8d$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $fcf8dc8ded2923a0$export$7db5c57474082dd9)();
    var _useAvatarContent = (0, $fcf8dc8ded2923a0$export$79d078b69b7e4842)(), Container = _useAvatarContent.as, appearance = _useAvatarContent.appearance, avatarImage = _useAvatarContent.avatarImage, _useAvatarContent$bor = _useAvatarContent.borderColor, borderColor = _useAvatarContent$bor === void 0 ? (0, $ltooA.fg)("platform-component-visual-refresh") ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, #FFFFFF)" : _useAvatarContent$bor, href = _useAvatarContent.href, isDisabled = _useAvatarContent.isDisabled, label = _useAvatarContent.label, onClick = _useAvatarContent.onClick, contextRef = _useAvatarContent.ref, tabIndex = _useAvatarContent.tabIndex, target = _useAvatarContent.target, testId = _useAvatarContent.testId, size = _useAvatarContent.size, stackIndex = _useAvatarContent.stackIndex;
    var isInteractive = Boolean(onClick || href || isDisabled);
    return /*#__PURE__*/ $acw62.createElement(Container, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        style: (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, $1b365a283dea1d8d$var$bgColorCssVar, borderColor), $1b365a283dea1d8d$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === "button" ? "button" : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === "_blank" ? "noopener noreferrer" : undefined
    }, {
        className: (0, $5zphJ.default)([
            $1b365a283dea1d8d$var$unboundStyles.root,
            $1b365a283dea1d8d$var$styles.root,
            $1b365a283dea1d8d$var$borderRadiusMap[size],
            appearance === "circle" && $1b365a283dea1d8d$var$styles.circle,
            $1b365a283dea1d8d$var$widthHeightMap[size],
            stackIndex !== undefined && $1b365a283dea1d8d$var$styles.positionRelative,
            isInteractive && !isDisabled && $1b365a283dea1d8d$var$unboundStyles.interactive,
            isDisabled && $1b365a283dea1d8d$var$styles.disabled
        ])
    }), children || avatarImage);
});



/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $9ad511842b664a6d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::325d0bc066f2b42d61e7c5ff0e093014>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($9ad511842b664a6d$exports, "__esModule", {
    value: true
});
$9ad511842b664a6d$exports.default = void 0;

var $9ad511842b664a6d$var$_react = $9ad511842b664a6d$var$_interopRequireDefault((parcelRequire("acw62")));

var $9ad511842b664a6d$var$_person = $9ad511842b664a6d$var$_interopRequireDefault((parcelRequire("1EH4T")));

var $9ad511842b664a6d$var$_person2 = $9ad511842b664a6d$var$_interopRequireDefault((parcelRequire("h910A")));
function $9ad511842b664a6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ad511842b664a6d$var$PersonIcon = (props)=>/*#__PURE__*/ $9ad511842b664a6d$var$_react.default.createElement($9ad511842b664a6d$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $9ad511842b664a6d$var$_person2.default
    }, props));
$9ad511842b664a6d$var$PersonIcon.Name = "PersonIconMigration";
var $9ad511842b664a6d$var$_default = $9ad511842b664a6d$exports.default = $9ad511842b664a6d$var$PersonIcon;


var $e65f2ce665b46e76$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df09611fb9f343ce3ed015b37269b5a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e65f2ce665b46e76$exports, "__esModule", {
    value: true
});
$e65f2ce665b46e76$exports.default = void 0;

var $e65f2ce665b46e76$var$_react = $e65f2ce665b46e76$var$_interopRequireDefault((parcelRequire("acw62")));

var $e65f2ce665b46e76$var$_release = $e65f2ce665b46e76$var$_interopRequireDefault((parcelRequire("47BVL")));

var $e65f2ce665b46e76$var$_ship = $e65f2ce665b46e76$var$_interopRequireDefault((parcelRequire("lPpiW")));
function $e65f2ce665b46e76$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e65f2ce665b46e76$var$ReleaseIcon = (props)=>/*#__PURE__*/ $e65f2ce665b46e76$var$_react.default.createElement($e65f2ce665b46e76$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $e65f2ce665b46e76$var$_ship.default
    }, props));
$e65f2ce665b46e76$var$ReleaseIcon.Name = "ReleaseIconMigration";
var $e65f2ce665b46e76$var$_default = $e65f2ce665b46e76$exports.default = $e65f2ce665b46e76$var$ReleaseIcon;



var $1EH4T = parcelRequire("1EH4T");

var $47BVL = parcelRequire("47BVL");

var $ltooA = parcelRequire("ltooA");

var $dnCk4 = parcelRequire("dnCk4");
var $def0f4b7ac3f0178$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq",
    iconBg: "_bfhkr4aa",
    iconBGVisualRefresh: "_bfhk1v33",
    circle: "_2rko1q5u"
};
var $def0f4b7ac3f0178$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rko1l7b",
    large: "_2rko1l7b",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
var $def0f4b7ac3f0178$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $def0f4b7ac3f0178$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? "" : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $acw62.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $5zphJ.default)([
            $def0f4b7ac3f0178$var$styles.icon,
            (0, $ltooA.fg)("platform-component-visual-refresh") ? $def0f4b7ac3f0178$var$styles.iconBGVisualRefresh : $def0f4b7ac3f0178$var$styles.iconBg,
            $def0f4b7ac3f0178$var$nestedSvgStylesMap[size]
        ])
    }, appearance === "circle" ? (0, $ltooA.fg)("platform-component-visual-refresh") ? /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1EH4T))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ad511842b664a6d$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $dnCk4.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $dnCk4.N90), ")"),
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $ltooA.fg)("platform-component-visual-refresh") ? /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($47BVL))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }) : /*#__PURE__*/ $acw62.createElement((0, (/*@__PURE__*/$parcel$interopDefault($e65f2ce665b46e76$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $dnCk4.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $dnCk4.N90), ")"),
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }));
    return /*#__PURE__*/ $acw62.createElement("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : "avatar-image",
        "data-ssr-placeholder-ignored": true,
        className: (0, $5zphJ.default)([
            $def0f4b7ac3f0178$var$styles.image,
            $def0f4b7ac3f0178$var$borderRadiusMap[size],
            appearance === "circle" && $def0f4b7ac3f0178$var$styles.circle
        ])
    });
};
var $def0f4b7ac3f0178$export$2e2bcd8739ae039 = $def0f4b7ac3f0178$var$AvatarImage;


/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $dnCk4 = parcelRequire("dnCk4");
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");
var $4b14e1c90b59f048$var$styles = {
    root: "_2rko1q5u _1reo15vq _18m915vq _189e1bk5 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $4b14e1c90b59f048$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $4b14e1c90b59f048$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $5zphJ.default)([
            $4b14e1c90b59f048$var$styles.root,
            $4b14e1c90b59f048$var$unboundStyles.root
        ])
    }, children);
};
var $4b14e1c90b59f048$export$2e2bcd8739ae039 = $4b14e1c90b59f048$var$IconWrapper;


var $894bb78a4c559da9$var$BusyIndicator = /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, /*#__PURE__*/ $acw62.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $dnCk4.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $acw62.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $dnCk4.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $894bb78a4c559da9$var$FocusIndicator = /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, /*#__PURE__*/ $acw62.createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $dnCk4.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $894bb78a4c559da9$var$OfflineIndicator = /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, /*#__PURE__*/ $acw62.createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $dnCk4.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $acw62.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $dnCk4.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $894bb78a4c559da9$var$OnlineIndicator = /*#__PURE__*/ $acw62.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $dnCk4.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $894bb78a4c559da9$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $894bb78a4c559da9$var$BusyIndicator;
        case "focus":
            return $894bb78a4c559da9$var$FocusIndicator;
        case "offline":
            return $894bb78a4c559da9$var$OfflineIndicator;
        case "online":
            return $894bb78a4c559da9$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $894bb78a4c559da9$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $acw62.createElement((0, $4b14e1c90b59f048$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $acw62.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $894bb78a4c559da9$var$getPresence(presence)) : children);
};
var $894bb78a4c559da9$export$2e2bcd8739ae039 = $894bb78a4c559da9$var$AvatarPresence;
var $894bb78a4c559da9$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $894bb78a4c559da9$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $894bb78a4c559da9$var$iconOffsetMap = {
    square: "_94n5myb0 _1xi2myb0",
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $894bb78a4c559da9$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $5zphJ.default)([
            $894bb78a4c559da9$var$styles.root,
            $894bb78a4c559da9$var$iconSizeMap[size],
            $894bb78a4c559da9$var$iconOffsetMap[size],
            appearance === "square" && $894bb78a4c559da9$var$iconOffsetMap["square"]
        ])
    }, /*#__PURE__*/ $acw62.createElement($894bb78a4c559da9$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};


/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $acw62 = parcelRequire("acw62");

var $5zphJ = parcelRequire("5zphJ");

var $dnCk4 = parcelRequire("dnCk4");

var $a2701e88c0c6779d$var$styles = {
    root: "_kqswstnw"
};
var $a2701e88c0c6779d$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $a2701e88c0c6779d$var$iconOffsetMap = {
    square: "_1xi2idpf _154iidpf",
    small: "_1xi2idpf _154iidpf",
    medium: "_1xi2idpf _154iidpf",
    large: "_1xi2t94y _154it94y",
    xlarge: "_1xi21v6z _154i1v6z"
};
var $a2701e88c0c6779d$var$ApprovedIndicator = /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, /*#__PURE__*/ $acw62.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $dnCk4.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $acw62.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $dnCk4.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $a2701e88c0c6779d$var$DeclinedIndicator = /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, /*#__PURE__*/ $acw62.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $dnCk4.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $acw62.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $dnCk4.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $a2701e88c0c6779d$var$LockedIndicator = /*#__PURE__*/ $acw62.createElement((0, $acw62.Fragment), null, /*#__PURE__*/ $acw62.createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $dnCk4.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $acw62.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $dnCk4.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $a2701e88c0c6779d$var$getStatus(status) {
    switch(status){
        case "approved":
            return $a2701e88c0c6779d$var$ApprovedIndicator;
        case "declined":
            return $a2701e88c0c6779d$var$DeclinedIndicator;
        case "locked":
            return $a2701e88c0c6779d$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $a2701e88c0c6779d$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $acw62.createElement((0, $4b14e1c90b59f048$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $acw62.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $a2701e88c0c6779d$var$getStatus(status)) : children);
};
var $a2701e88c0c6779d$export$2e2bcd8739ae039 = $a2701e88c0c6779d$var$AvatarStatus;
var $a2701e88c0c6779d$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $5zphJ.default)([
            $a2701e88c0c6779d$var$styles.root,
            $a2701e88c0c6779d$var$iconSizeMap[size],
            $a2701e88c0c6779d$var$iconOffsetMap[size],
            appearance === "square" && $a2701e88c0c6779d$var$iconOffsetMap["square"]
        ])
    }, /*#__PURE__*/ $acw62.createElement($a2701e88c0c6779d$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};


var $5818345945150eb4$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};


function $531f656a7efeef0c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $531f656a7efeef0c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $531f656a7efeef0c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $531f656a7efeef0c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $531f656a7efeef0c$var$packageName = "@atlaskit/avatar";
var $531f656a7efeef0c$var$packageVersion = "25.0.2";
var $531f656a7efeef0c$var$containerStyles = null;
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $531f656a7efeef0c$var$Avatar = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "circle" : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? "div" : _ref$as;
    var _useAnalyticsEvents = (0, $644f5cd0da7c3c67$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $fcf8dc8ded2923a0$export$b50b87a1c4086b23)();
    var size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || "medium";
    var customPresenceNode = /*#__PURE__*/ (0, $acw62.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $acw62.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $acw62.useRef)(analyticsContext);
    var labelId = (0, $6d39885ac77caaba$export$f680877a34711e37)();
    (0, $acw62.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $acw62.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $531f656a7efeef0c$var$packageName,
                packageVersion: $531f656a7efeef0c$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $531f656a7efeef0c$var$_objectSpread({
            componentName: "avatar",
            packageName: $531f656a7efeef0c$var$packageName,
            packageVersion: $531f656a7efeef0c$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(" ");
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $acw62.createElement((0, $fcf8dc8ded2923a0$export$6b4cbd90d24955ad).Provider, {
        value: true
    }, /*#__PURE__*/ $acw62.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? "img" : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $5zphJ.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $acw62.createElement((0, $fcf8dc8ded2923a0$export$b983474ddd0b6d28).Provider, {
        value: {
            as: (0, $5818345945150eb4$export$83ee468102cdf04c)(isDisabled, href, onClick),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            avatarImage: /*#__PURE__*/ $acw62.createElement((0, $def0f4b7ac3f0178$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId
            })
        }
    }, children || /*#__PURE__*/ $acw62.createElement((0, $1b365a283dea1d8d$export$47fbc0b44cae5559), null)), isPresence && /*#__PURE__*/ $acw62.createElement((0, $894bb78a4c559da9$export$972c5e90200fa0ef), {
        appearance: appearance,
        size: size,
        presence: typeof presence === "string" ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $acw62.createElement((0, $a2701e88c0c6779d$export$8045894f255f9726), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === "string" ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $acw62.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$531f656a7efeef0c$var$Avatar.displayName = "Avatar";
var $531f656a7efeef0c$export$2e2bcd8739ae039 = $531f656a7efeef0c$var$Avatar;


var $541511ff3a786cd1$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b0ad8e82692fcbf05d6af098ca724db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($541511ff3a786cd1$exports, "__esModule", {
    value: true
});
$541511ff3a786cd1$exports.default = void 0;

var $541511ff3a786cd1$var$_react = $541511ff3a786cd1$var$_interopRequireDefault((parcelRequire("acw62")));

var $541511ff3a786cd1$var$_baseNew = $541511ff3a786cd1$var$_interopRequireDefault((parcelRequire("fqFky")));
function $541511ff3a786cd1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $541511ff3a786cd1$var$LogOutIcon = (props)=>/*#__PURE__*/ $541511ff3a786cd1$var$_react.default.createElement($541511ff3a786cd1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$541511ff3a786cd1$var$LogOutIcon.displayName = "LogOutIcon";
var $541511ff3a786cd1$var$_default = $541511ff3a786cd1$exports.default = $541511ff3a786cd1$var$LogOutIcon;


var $cb41f06f1b0a0f9c$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::654979ffcf55141d2c08f198a843721e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($cb41f06f1b0a0f9c$exports, "__esModule", {
    value: true
});
$cb41f06f1b0a0f9c$exports.default = void 0;

var $cb41f06f1b0a0f9c$var$_react = $cb41f06f1b0a0f9c$var$_interopRequireDefault((parcelRequire("acw62")));

var $cb41f06f1b0a0f9c$var$_baseNew = $cb41f06f1b0a0f9c$var$_interopRequireDefault((parcelRequire("fqFky")));
function $cb41f06f1b0a0f9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb41f06f1b0a0f9c$var$SettingsIcon = (props)=>/*#__PURE__*/ $cb41f06f1b0a0f9c$var$_react.default.createElement($cb41f06f1b0a0f9c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$cb41f06f1b0a0f9c$var$SettingsIcon.displayName = "SettingsIcon";
var $cb41f06f1b0a0f9c$var$_default = $cb41f06f1b0a0f9c$exports.default = $cb41f06f1b0a0f9c$var$SettingsIcon;


var $6682d8b382689391$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e16f3e8522976fe7001db436c90d9bf8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6682d8b382689391$exports, "__esModule", {
    value: true
});
$6682d8b382689391$exports.default = void 0;

var $6682d8b382689391$var$_react = $6682d8b382689391$var$_interopRequireDefault((parcelRequire("acw62")));

var $6682d8b382689391$var$_baseNew = $6682d8b382689391$var$_interopRequireDefault((parcelRequire("fqFky")));
function $6682d8b382689391$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6682d8b382689391$var$ThemeIcon = (props)=>/*#__PURE__*/ $6682d8b382689391$var$_react.default.createElement($6682d8b382689391$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$6682d8b382689391$var$ThemeIcon.displayName = "ThemeIcon";
var $6682d8b382689391$var$_default = $6682d8b382689391$exports.default = $6682d8b382689391$var$ThemeIcon;


var $44d08d1d7c6c2d3d$exports = {};
"use strict";
Object.defineProperty($44d08d1d7c6c2d3d$exports, "__esModule", {
    value: true
});
$44d08d1d7c6c2d3d$exports.default = void 0;

var $44d08d1d7c6c2d3d$var$_react = $44d08d1d7c6c2d3d$var$_interopRequireDefault((parcelRequire("acw62")));

var $kaGTc = parcelRequire("kaGTc");

var $44d08d1d7c6c2d3d$var$_arrowRight = $44d08d1d7c6c2d3d$var$_interopRequireDefault((parcelRequire("35SCa")));
function $44d08d1d7c6c2d3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $44d08d1d7c6c2d3d$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $44d08d1d7c6c2d3d$var$_react.default.createElement($kaGTc.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $44d08d1d7c6c2d3d$var$_arrowRight.default
    }));
$44d08d1d7c6c2d3d$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $44d08d1d7c6c2d3d$var$_default = $44d08d1d7c6c2d3d$exports.default = $44d08d1d7c6c2d3d$var$ArrowRightIcon;



var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $jjlaj = parcelRequire("jjlaj");

var $c81b625042d208d0$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $c81b625042d208d0$var$baseStyles = (0, $jjlaj.css)({
    display: "flex",
    position: "static",
    flexDirection: "column",
    overflow: "auto"
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $c81b625042d208d0$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "cozy" : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $c81b625042d208d0$var$_excluded);
    return (0, $jjlaj.jsx)((0, $5aff9f9707de081d$export$443076ec7ebce042).Provider, {
        value: spacing
    }, (0, $jjlaj.jsx)((0, $5aff9f9707de081d$export$9ca534b70725964d).Provider, {
        value: "border"
    }, (0, $jjlaj.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $c81b625042d208d0$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $c81b625042d208d0$export$2e2bcd8739ae039 = $c81b625042d208d0$var$MenuGroup;





var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $5be83c457dcd9e04$export$d344b04822cd68e8 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, forwardedRef) {
    var label = _ref.label, icon = _ref.icon, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, isSelected = _ref.isSelected, testId = _ref.testId, interactionName = _ref.interactionName, ariaControls = _ref["aria-controls"], ariaExpanded = _ref["aria-expanded"], ariaHasPopup = _ref["aria-haspopup"], _ref$isListItem = _ref.isListItem, isListItem = _ref$isListItem === void 0 ? true : _ref$isListItem;
    var Wrapper = isListItem ? (0, $1a92f85ba0e22d9c$export$a7b06bfba60a8a78) : (0, $acw62.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b95d5cf1ea992c9$export$c25acd513dcc8062), {
        ref: forwardedRef,
        icon: icon,
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        appearance: "subtle",
        isSelected: isSelected,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup
    }));
});


var $9092b22c1b5b3936$var$_excluded = [
    "src"
];
var $9092b22c1b5b3936$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var src = _ref.src, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $9092b22c1b5b3936$var$_excluded);
    var ProfileAvatar = (0, $acw62.useCallback)(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $531f656a7efeef0c$export$2e2bcd8739ae039), {
            appearance: "circle",
            src: src,
            size: "small"
        });
    }, [
        src
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5be83c457dcd9e04$export$d344b04822cd68e8), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        ref: ref,
        icon: ProfileAvatar
    }));
});



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

const $eb3caeb96f2e70a8$export$4caed8261f73d63a = ()=>{
    const setColorMode = (0, $fa26c3c32090668f$export$e2afe7397c3d11c7)();
    const currentColorMode = (0, $fa26c3c32090668f$export$20f3076712c8dfa)();
    const updateTheme = (0, $acw62.useCallback)((newColorMode)=>{
        if (newColorMode === currentColorMode) return;
        setColorMode(newColorMode);
        window.localStorage.setItem("themeColorMode", newColorMode);
    }, [
        setColorMode,
        currentColorMode
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $c641af5ec2d65691$export$2e2bcd8739ae039), {
                onClick: ()=>updateTheme("light"),
                children: "Light"
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $c641af5ec2d65691$export$2e2bcd8739ae039), {
                onClick: ()=>updateTheme("dark"),
                children: "Dark"
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $c641af5ec2d65691$export$2e2bcd8739ae039), {
                onClick: ()=>updateTheme("auto"),
                children: "System"
            })
        ]
    });
};




const $41dd6cc1080bc652$export$cede4c054426e41d = (email)=>{
    return (0, $a2299f428347f042$export$1038046b28a1d92e)() === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD ? `https://id.atlassian.com/login?application=dev-agents&continue=${encodeURIComponent("https://id.atlassian.com/manage-profile")}&prompt=none&login_hint=${encodeURIComponent(email)}` : `https://id.stg.internal.atlassian.com/login?application=dev-agents&continue=${encodeURIComponent("https://id.stg.internal.atlassian.com/manage-profile")}&prompt=none&login_hint=${encodeURIComponent(email)}`;
};



const $89f0935ebfdcc784$var$UserInfo = ({ user: user })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        xcss: $89f0935ebfdcc784$var$userInfoStyles,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $531f656a7efeef0c$export$2e2bcd8739ae039), {
                src: user.picture,
                size: "large"
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $7e9cd1185a5decf2$export$2e2bcd8739ae039), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                        maxLines: 1,
                        weight: "bold",
                        children: user.name
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $35f2f57ed84fe783$export$2e2bcd8739ae039), {
                        maxLines: 1,
                        color: "color.text.subtlest",
                        children: user.email
                    })
                ]
            })
        ]
    });
};
const $89f0935ebfdcc784$var$ProfilePopup = ({ user: user })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    return (0, $7b02d682eb115277$exports.jsx)((0, $9c14666919da07a2$export$2e2bcd8739ae039), {
        onClick: (e)=>e.stopPropagation(),
        xcss: $89f0935ebfdcc784$var$nestedPopupStyles,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $c81b625042d208d0$export$2e2bcd8739ae039), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $792950128a817a1c$export$2e2bcd8739ae039), {
                    titleId: "user-profile-section",
                    children: (0, $7b02d682eb115277$exports.jsx)($89f0935ebfdcc784$var$UserInfo, {
                        user: user
                    })
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $792950128a817a1c$export$2e2bcd8739ae039), {
                    titleId: "user-profile-settings",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $b065f2b82e3e7bee$export$2e2bcd8739ae039), {
                            href: (0, $41dd6cc1080bc652$export$cede4c054426e41d)(user?.email || ""),
                            target: "_blank",
                            iconBefore: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cb41f06f1b0a0f9c$exports))), {
                                label: ""
                            }),
                            children: "Account Settings"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $9394c3c3f1484d88$export$2e2bcd8739ae039), {
                            isOpen: isOpen,
                            placement: "left-start",
                            onClose: ()=>setIsOpen(false),
                            content: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $eb3caeb96f2e70a8$export$4caed8261f73d63a), {}),
                            trigger: (triggerProps)=>(0, $7b02d682eb115277$exports.jsx)((0, $c641af5ec2d65691$export$2e2bcd8739ae039), {
                                    ...triggerProps,
                                    isSelected: isOpen,
                                    onClick: ()=>setIsOpen(true),
                                    iconBefore: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6682d8b382689391$exports))), {
                                        label: ""
                                    }),
                                    iconAfter: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($44d08d1d7c6c2d3d$exports))), {
                                        label: ""
                                    }),
                                    children: "Theme"
                                })
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $792950128a817a1c$export$2e2bcd8739ae039), {
                    titleId: "user-profile-actions",
                    hasSeparator: true,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $b065f2b82e3e7bee$export$2e2bcd8739ae039), {
                        href: `${window.location.origin}/logout`,
                        iconBefore: (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($541511ff3a786cd1$exports))), {
                            label: ""
                        }),
                        children: "Log Out"
                    })
                })
            ]
        })
    });
};
const $89f0935ebfdcc784$export$b7b58f2e100445f7 = ({ user: user })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const close = ()=>setIsOpen(false);
    return (0, $7b02d682eb115277$exports.jsx)((0, $9394c3c3f1484d88$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        trigger: (triggerProps)=>(0, $7b02d682eb115277$exports.jsx)((0, $9092b22c1b5b3936$export$5120f2d0b8d4cab8), {
                ...triggerProps,
                label: "Profile",
                src: user.picture,
                isSelected: isOpen,
                onClick: ()=>setIsOpen((prevOpen)=>!prevOpen)
            }),
        content: ()=>(0, $7b02d682eb115277$exports.jsx)($89f0935ebfdcc784$var$ProfilePopup, {
                user: user
            })
    });
};
const $89f0935ebfdcc784$var$nestedPopupStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    boxSizing: "border-box",
    minWidth: "300px",
    maxWidth: "300px"
});
const $89f0935ebfdcc784$var$userInfoStyles = (0, $d8fb25f1eb78afec$export$f6c783d06584602c)({
    display: "flex",
    flexDirection: "row",
    backgroundColor: "elevation.surface.sunken",
    columnGap: "space.100",
    padding: "space.200",
    marginLeft: "space.100",
    marginRight: "space.100"
});



const $0ba681e45ca1bd8b$var$history = (0, $6d23e34a443a4a03$export$719fc203c4e16dee)();
const $0ba681e45ca1bd8b$var$resourcesPlugin = (0, $5ee70daed3bb0fac$export$23ed892c481a96fe)({
    resourceData: undefined
});
/*
 * Components for composing top and side navigation
 */ const $0ba681e45ca1bd8b$var$AtlassianProductHome = ()=>{
    const [routeState] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    const Logo = routeState.route?.logo;
    if (Logo) return (0, $7b02d682eb115277$exports.jsx)(Logo, {});
    return (0, $7b02d682eb115277$exports.jsx)((0, $943a9081db4aa8b0$export$b6394419753329e), {
        href: "/",
        logo: (0, $80a046d009ef2432$export$cfb19d3a192c6fe2),
        icon: (0, $80a046d009ef2432$export$2ba09f2b55b47be8),
        label: "Rovo Dev Agents"
    });
};
const $0ba681e45ca1bd8b$var$AppRouteComponent = ()=>{
    const [routerState] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    const SidebarComponent = routerState.route?.navigation;
    const { user: user } = (0, $690d3d7c4f641feb$export$69bbac602c81ca6e)();
    const ufoName = routerState.route?.analyticsName;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $f5e5b2246da9d7d3$export$be92b6f5f03c0fe9), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $1450e52c0cd780da$export$c4e96258f3b6511), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $387974f8a0e71add$export$ae2177c1f0d2b72c), {
                        children: [
                            SidebarComponent && (0, $7b02d682eb115277$exports.jsx)((0, $ec5d9fb83dd33f59$export$8bd77667631fec25), {
                                defaultCollapsed: true,
                                collapseLabel: "Collapse sidebar",
                                expandLabel: "Expand sidebar"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)($0ba681e45ca1bd8b$var$AtlassianProductHome, {})
                        ]
                    }),
                    user && (0, $7b02d682eb115277$exports.jsx)((0, $af41a5c5629fbf6e$export$2fb70d5e506c6bc2), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $89f0935ebfdcc784$export$b7b58f2e100445f7), {
                            user: user
                        })
                    })
                ]
            }),
            SidebarComponent && (0, $7b02d682eb115277$exports.jsx)((0, $c5a8151421d30146$export$1a35787d6353cf6a), {
                defaultWidth: 200,
                children: (0, $7b02d682eb115277$exports.jsx)(SidebarComponent, {})
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $08f005305414827f$export$861edd1ccea2f746), {
                isFixed: true,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $25bb30d690a27033$export$2e2bcd8739ae039), {
                    name: ufoName ?? "",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $9c1d9ab94a99f286$export$7903e4b73fc7d6c3), {})
                })
            })
        ]
    });
};
const $0ba681e45ca1bd8b$var$BlockingAtlassianProviders = ({ children: children })=>{
    return (0, $7b02d682eb115277$exports.jsx)((0, $46c32320cb273742$export$2e2bcd8739ae039), {
        routerLinkComponent: (0, $3c939fdb4f38b8df$export$c62c1bf7572a3c0c),
        defaultColorMode: (0, $8dfb65dab4a54eab$export$2f7a12048d96237)().colorMode,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $098873af10a85f8f$export$6084ad8a2ad35ad4), {
            children: children
        })
    });
};
const $0ba681e45ca1bd8b$var$LazyAppRouterWithUsersPermsContext = ({ children: children })=>{
    const [userPermsQueryRef, loadUserPermsQuery] = (0, $2d93712440e0508b$exports.useQueryLoader)((0, $kYoXd.default));
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const { user: user } = (0, $690d3d7c4f641feb$export$69bbac602c81ca6e)();
    const cloudID = tenantContexts[0]?.cloudId || "";
    const atlassianAccountId = user.accountId;
    (0, $acw62.useEffect)(()=>{
        loadUserPermsQuery({
            cloudID: cloudID,
            atlassianAccountId: atlassianAccountId
        });
    }, [
        loadUserPermsQuery,
        cloudID,
        atlassianAccountId
    ]);
    return userPermsQueryRef && (0, $7b02d682eb115277$exports.jsx)((0, $0ad252b79ab48383$export$5677d1adf0a1908a), {
        queryRef: userPermsQueryRef,
        children: (0, $7b02d682eb115277$exports.jsx)($0ba681e45ca1bd8b$var$LazyAppRouter, {
            children: children
        })
    });
};
const $0ba681e45ca1bd8b$var$LazyAppRouter = ({ children: children })=>{
    const { rovoDevAgentsUser: rovoDevAgentsUser } = (0, $927556e5474cebfb$export$a0210e79452e8007)();
    const { tenantContexts: tenantContexts } = (0, $01b04da237978a44$export$c00a80cbbdafd66b)();
    const devaiEntitlementId = tenantContexts[0]?.devaiEntitlementId;
    return (0, $7b02d682eb115277$exports.jsx)((0, $54d5bb126d55fb0e$export$55185c17a0fcbe46), {
        routes: (0, $b3c1eeb19c22229f$export$2d723d99e5956467)(rovoDevAgentsUser.isAdmin, devaiEntitlementId !== null),
        history: $0ba681e45ca1bd8b$var$history,
        plugins: [
            $0ba681e45ca1bd8b$var$resourcesPlugin
        ],
        basePath: "/dev-agents",
        children: children
    });
};
const $0ba681e45ca1bd8b$var$AppWithRoute = ({ children: children })=>{
    const [{ route: route }] = (0, $ea45ac0bebb723d5$export$9a302a45f65d0572)();
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    (0, $acw62.useEffect)(()=>{
        if (route?.analyticsName) {
            /*
       * Start instrumenting the page load event.
       * We invoke `traceUFOPageLoad` once more
       * when we have the route context.
       * It attaches the route name to the event.
       * */ (0, $3c27fd8e5f64c965$export$2e2bcd8739ae039)(route.analyticsName);
            analyticsWebClient.sendOperationalEvent({
                action: "rendered",
                actionSubject: `app.${route.analyticsName}`,
                source: "app"
            });
        }
    }, [
        route?.analyticsName
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $da278c11bbb20b21$export$e926676385687eaf), {
        onError: (err)=>{
            analyticsWebClient.sendOperationalEvent({
                action: "error",
                actionSubject: `app.${route.analyticsName}`,
                source: "app",
                attributes: {
                    message: err?.message
                }
            });
        },
        children: children
    });
};
const $0ba681e45ca1bd8b$export$86fbec116b87613f = ()=>{
    const analyticsWebClient = (0, $8335f2c2f41b5065$export$ab46754111902b52)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $da278c11bbb20b21$export$e926676385687eaf), {
        onError: (err)=>{
            analyticsWebClient.sendOperationalEvent({
                action: "error",
                actionSubject: "appComponent",
                source: "app",
                attributes: {
                    message: err.message
                }
            });
        },
        children: (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: (0, $7b02d682eb115277$exports.jsx)((0, $bb6557fb29c1ef20$export$44c18d210d5de37b), {}),
            children: (0, $7b02d682eb115277$exports.jsx)($0ba681e45ca1bd8b$var$BlockingAtlassianProviders, {
                children: (0, $7b02d682eb115277$exports.jsx)($0ba681e45ca1bd8b$var$LazyAppRouterWithUsersPermsContext, {
                    children: (0, $7b02d682eb115277$exports.jsx)($0ba681e45ca1bd8b$var$AppWithRoute, {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $eb77deb211f1d0a4$export$a4270ab432ac8a58), {
                            children: (0, $7b02d682eb115277$exports.jsx)($0ba681e45ca1bd8b$var$AppRouteComponent, {})
                        })
                    })
                })
            })
        })
    });
};



const $6596dc10e3319818$export$fd90f7e8fb65886c = ()=>{
    const [queryRef, loadQuery] = (0, $2d93712440e0508b$exports.useQueryLoader)((0, $2pciS.default));
    const hostName = (0, $a2299f428347f042$export$1038046b28a1d92e)() === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).LOCAL ? "" : window.location.hostname;
    (0, $acw62.useEffect)(()=>{
        loadQuery({
            hostNames: [
                hostName
            ]
        });
    }, [
        loadQuery,
        hostName
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $273a2ae2279c22d2$export$e926676385687eaf), {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: (0, $7b02d682eb115277$exports.jsx)((0, $bb6557fb29c1ef20$export$44c18d210d5de37b), {}),
            children: queryRef && (0, $7b02d682eb115277$exports.jsx)((0, $f815a3b12138ccb2$export$e32355e80a92030c), {
                queryRef: queryRef,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $8335f2c2f41b5065$export$457db49ce252eed8), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $0ba681e45ca1bd8b$export$86fbec116b87613f), {})
                })
            })
        })
    });
};



const $b7ede0491b8a7464$var$redirectUrl = (0, $a2299f428347f042$export$1038046b28a1d92e)() === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD ? `https://id.atlassian.com/login?continue=${encodeURIComponent(window.location.href)}` : `https://id.stg.internal.atlassian.com/login?continue=${encodeURIComponent(window.location.href)}`;
const $b7ede0491b8a7464$var$AuthErrorBoundary = ({ children: children })=>{
    return (0, $7b02d682eb115277$exports.jsx)((0, $273a2ae2279c22d2$export$e926676385687eaf), {
        fallback: ()=>{
            // Redirect on auth errors except for localhost
            if (window && window.location.hostname !== "localhost") window.location.replace($b7ede0491b8a7464$var$redirectUrl);
            return (0, $7b02d682eb115277$exports.jsx)((0, $bb6557fb29c1ef20$export$44c18d210d5de37b), {});
        },
        children: children
    });
};
const $b7ede0491b8a7464$export$f02ca4dee6bcbf60 = ()=>{
    const [queryRef, loadQuery] = (0, $2d93712440e0508b$exports.useQueryLoader)((0, $5l6ld.default));
    (0, $acw62.useEffect)(()=>{
        loadQuery({});
    }, [
        loadQuery
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($b7ede0491b8a7464$var$AuthErrorBoundary, {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: (0, $7b02d682eb115277$exports.jsx)((0, $bb6557fb29c1ef20$export$44c18d210d5de37b), {}),
            children: queryRef && (0, $7b02d682eb115277$exports.jsx)((0, $665198666197c108$export$b2316657917319d2), {
                queryRef: queryRef,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $6596dc10e3319818$export$fd90f7e8fb65886c), {})
            })
        })
    });
};





var $02Ztr = parcelRequire("02Ztr");

var $ltooA = parcelRequire("ltooA");

var $1CwJo = parcelRequire("1CwJo");

var $b4vGv = parcelRequire("b4vGv");

var $9NQTG = parcelRequire("9NQTG");

var $197ST = parcelRequire("197ST");

var $7QErp = parcelRequire("7QErp");

var $lllYc = parcelRequire("lllYc");

var $fO90s = parcelRequire("fO90s");

var $ltooA = parcelRequire("ltooA");
function $b358eeb341f4001b$export$2e2bcd8739ae039(work) {
    if (typeof window !== "undefined" && typeof window.requestIdleCallback === "function" && (0, $ltooA.fg)("ufo_payload_use_idle_callback")) window.requestIdleCallback(work);
    else (0, $fO90s.unstable_scheduleCallback)((0, $fO90s.unstable_IdlePriority), work);
}


var $9c8fb4e78810a10a$var$initialized = false;
function $9c8fb4e78810a10a$var$sinkInteraction(instance, payloadPackage) {
    (0, $7QErp.sinkInteractionHandler)(function(interactionId, interaction) {
        (0, $b358eeb341f4001b$export$2e2bcd8739ae039)(function() {
            payloadPackage.createPayloads(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                    if (typeof devToolObserver === "function") devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        });
    });
}
function $9c8fb4e78810a10a$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    (0, $9NQTG.sinkExperimentalHandler)(function(interactionId, interaction) {
        (0, $b358eeb341f4001b$export$2e2bcd8739ae039)(function() {
            var payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then(function(payload) {
                if (payload) {
                    if ((0, $ltooA.fg)("enable_ufo_devtools_api_for_extra_events")) {
                        // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                        var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                        if (typeof devToolObserver === "function") devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    }
                    instance.sendOperationalEvent(payload);
                }
            });
        });
    });
}
function $9c8fb4e78810a10a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $7QErp.sinkPostInteractionLogHandler)(function(logOutput) {
        (0, $b358eeb341f4001b$export$2e2bcd8739ae039)(function() {
            var payload = createPostInteractionLogPayload(logOutput);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                if ((0, $ltooA.fg)("enable_ufo_devtools_api_for_extra_events")) {
                    var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === "function") devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}


var $9c8fb4e78810a10a$export$2cd8252107eb640b = function init(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($9c8fb4e78810a10a$var$initialized) return;
    (0, $b4vGv.setUFOConfig)(config);
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
        var _config$experimentalI;
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig
        };
        (0, $lllYc.getVCObserver)(vcOptions).start({
            startTime: 0
        });
        (0, $7QErp.postInteractionLog).initializeVCObserver(vcOptions);
        (0, $7QErp.postInteractionLog).startVCObserver({
            startTime: 0
        });
        if (config !== null && config !== void 0 && (_config$experimentalI = config.experimentalInteractionMetrics) !== null && _config$experimentalI !== void 0 && _config$experimentalI.enabled) (0, $9NQTG.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
    }
    (0, $197ST.setupHiddenTimingCapture)();
    (0, $1CwJo.startLighthouseObserver)();
    $9c8fb4e78810a10a$var$initialized = true;
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("7qw2L")),
        (parcelRequire("bmeQ7"))
    ]).then(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 3), awc = _ref2[0], payloadPackage = _ref2[1], createPostInteractionLogPayloadPackage = _ref2[2];
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then(function(client) {
            var _config$experimentalI2, _config$postInteracti;
            var instance = client.getInstance();
            $9c8fb4e78810a10a$var$sinkInteraction(instance, payloadPackage);
            if (config !== null && config !== void 0 && (_config$experimentalI2 = config.experimentalInteractionMetrics) !== null && _config$experimentalI2 !== void 0 && _config$experimentalI2.enabled) $9c8fb4e78810a10a$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) $9c8fb4e78810a10a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
        });
        else if (awc.sendOperationalEvent) {
            var _config$experimentalI3, _config$postInteracti2;
            $9c8fb4e78810a10a$var$sinkInteraction(awc, payloadPackage);
            if (config !== null && config !== void 0 && (_config$experimentalI3 = config.experimentalInteractionMetrics) !== null && _config$experimentalI3 !== void 0 && _config$experimentalI3.enabled) $9c8fb4e78810a10a$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) $9c8fb4e78810a10a$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
        }
    });
};




const $47f8b7eddfb722ae$var$isProd = (0, $a2299f428347f042$export$1038046b28a1d92e)() === (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD;
const $47f8b7eddfb722ae$var$region = $47f8b7eddfb722ae$var$isProd ? "prod-east" : "stg-east";
const $47f8b7eddfb722ae$var$config = {
    product: "devAgents",
    namePrefix: "dev-agents-ufo-",
    region: $47f8b7eddfb722ae$var$region,
    capability: {
        /*
     * Enabling feature flag data to be captured in UFO.
     */ feature_flag_access: 1,
        /*
     * https://atlassian.slack.com/archives/C01AY8132S3/p1723030532244489?thread_ts=1722580624.223629&cid=C01AY8132S3
     * react_profiler is added since it is required by the type,
     * will be cleaned up in the future
     */ react_profiler: 0
    },
    vc: {
        /*
     * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/129126/diff#platform%2F.changeset%2Fred-lemons-mate.md
     */ stopVCAtInteractionFinish: true,
        enabled: true,
        ssr: false,
        devToolsEnabled: (0, $a2299f428347f042$export$1038046b28a1d92e)() !== (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).PROD,
        selectorConfig: {
            id: false,
            // in the example above, since ids may contain UGC, we want to set capturing `id` information for TTVC to `false`.
            role: true,
            className: true,
            testId: true
        }
    },
    kind: {
        /*
     * Sampling works in 1 in the rate specified.
     * If rate is 1, it captures all events - 1/1
     */ page_load: 1,
        transition: 1,
        press: 1,
        typing: 1,
        legacy: 0,
        // For some Jira events that will be cleaned up in UFO
        hover: 1
    },
    postInteractionLog: {
        enabled: true
    }
};
const $47f8b7eddfb722ae$export$c486014928b2a4c7 = (analyticsWebClient)=>{
    (0, $9c8fb4e78810a10a$export$2cd8252107eb640b)(Promise.resolve(analyticsWebClient), $47f8b7eddfb722ae$var$config);
};


var $aba06b8b6fe80494$exports = {};
/**
 * Relay v15.0.0
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
$aba06b8b6fe80494$exports = (parcelRequire("6yIWp"));


const $eeb185e700d83a9a$var$GATEWAY_URL = "/gateway/api/graphql";
function $eeb185e700d83a9a$var$createRelayEnvironment() {
    const network = (0, $aba06b8b6fe80494$exports.Network).create((params, variables)=>{
        const response = fetch($eeb185e700d83a9a$var$GATEWAY_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $aba06b8b6fe80494$exports.Observable).from(response.then((data)=>data.json()));
    });
    const store = new (0, $aba06b8b6fe80494$exports.Store)(new (0, $aba06b8b6fe80494$exports.RecordSource)());
    return new (0, $aba06b8b6fe80494$exports.Environment)({
        network: network,
        store: store
    });
}
var $eeb185e700d83a9a$export$2e2bcd8739ae039 = $eeb185e700d83a9a$var$createRelayEnvironment();



$795a7664e1a3c052$export$2cd8252107eb640b({
    environment: (0, $a2299f428347f042$export$1038046b28a1d92e)(),
    enabled: (0, $a2299f428347f042$export$1038046b28a1d92e)() !== (0, $9ccdaa0fe1434a2c$export$56ac8ebc9870b1b9).LOCAL,
    dsn: "https://aa7f49d6af9f98e93324071287d92bb8@o55978.ingest.us.sentry.io/4508946351521793",
    tracesSampleRate: 1.0 // Capture 100% of the transactions
});
(0, $47f8b7eddfb722ae$export$c486014928b2a4c7)((0, $816be88acf151818$export$b2e5abba3e61d1a4));
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("root"));
$70fc9a727fa662ae$var$root.render((0, $7b02d682eb115277$exports.jsx)((0, $2d93712440e0508b$exports.RelayEnvironmentProvider), {
    environment: (0, $eeb185e700d83a9a$export$2e2bcd8739ae039),
    children: (0, $7b02d682eb115277$exports.jsx)((0, $b7ede0491b8a7464$export$f02ca4dee6bcbf60), {})
}));


//# sourceMappingURL=index.54610a5d.js.map
